// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%2335434a%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27gray%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23249d79%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e00000%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e00000%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27black%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27white%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./images/pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./images/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./images/pattern-dark.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./images/logo-dark.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23000000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23000000%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23000000%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
   01. Color system 
   02. Options toggle setting (rtl, shadow, caret, negative margin, color mode)
   03. Variable prefix setting
   04. Body setting
   05. Spacer setting
   06. Font & headings settings
   07. Grid settings
   08. Container padding
   09. Component border settings
   10. Component border-radius settings
   11. Component box-shadow settings 
   12. Component color settings 
   13. Component caret settings 
   14. Component transition settings 
   15. Component ratio settings 
   16. Container padding settings
   17. App - Header settings
   18. App - Sidebar settings
   19. App - Content settings
   20. App - Pos system settings
   21. Link settings
   22. Alerts settings
   23. Breadcrumbs settings
   24. Progress bars settings
   25. Buttons + Forms settings
   26. Buttons settings
   27. Button close settings
   28. Forms settings
   29. Form placeholders settings
   30. Form check settings
   31. Form switch settings
   32. Form input group settings
   33. Form select settings
   34. Form range settings
   35. Form file settings
   36. Form Floating settings
   37. Form validation settings
   38. Cards settings
   39. Tooltips settings
   40. Popovers
   41. Modals settings
   42. Offcanvas
   43. Toasts settings
   44. Accordion settings
   45. Tables settings
   46. Dropdown settings
   47. List group settings
   48. Nav settings
   49. Navbar settings
   50. Pagination settings
   51. Z-index settings
   52. Badges settings
   53. Position settings
   54. Image thumbnails settings
   55. Figures settings
   56. Carousel settings
   57. Spinners settings
   58. Code settings
*/
/*
   Dark color mode variables

   01. Color system 
   02. Body setting
   03. Font & headings settings
   04. Border settings
   05. Component settings
   06. App - Header settings
   07. App - Sidebar settings
   08. App - Theme panel settings
   09. Form switch settings
   10. Form select settings
   11. Form check settings
   12. Accordion settings
   13. Modal settings
*/
/*!
 * Bootstrap  v5.3.2 (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0271ff;
  --bs-indigo: #5c25ff;
  --bs-purple: #b90dff;
  --bs-pink: #e61079;
  --bs-red: #e00000;
  --bs-orange: #ff9f0c;
  --bs-yellow: #f9e80d;
  --bs-green: #148922;
  --bs-teal: #249d79;
  --bs-cyan: #009be3;
  --bs-black: #000000;
  --bs-white: #ffffff;
  --bs-gray: #526872;
  --bs-gray-dark: #35434a;
  --bs-gray-100: #c0cacf;
  --bs-gray-200: #a8b6bc;
  --bs-gray-300: #90a2aa;
  --bs-gray-400: #798e98;
  --bs-gray-500: #617a86;
  --bs-gray-600: #526872;
  --bs-gray-700: #44555e;
  --bs-gray-800: #35434a;
  --bs-gray-900: #273136;
  --bs-default: #798e98;
  --bs-theme: #249d79;
  --bs-theme-color: #ffffff;
  --bs-primary: #0271ff;
  --bs-secondary: #798e98;
  --bs-warning: #ff9f0c;
  --bs-danger: #e00000;
  --bs-success: #249d79;
  --bs-inverse: #000000;
  --bs-info: #009be3;
  --bs-dark: #35434a;
  --bs-black: #000000;
  --bs-white: #ffffff;
  --bs-purple: #b90dff;
  --bs-indigo: #5c25ff;
  --bs-red: #e00000;
  --bs-pink: #e61079;
  --bs-green: #148922;
  --bs-yellow: #f9e80d;
  --bs-teal: #249d79;
  --bs-muted: #617a86;
  --bs-light: #c0cacf;
  --bs-lime: #50b00a;
  --bs-gray-100: #c0cacf;
  --bs-gray-200: #a8b6bc;
  --bs-gray-300: #90a2aa;
  --bs-gray-400: #798e98;
  --bs-gray-500: #617a86;
  --bs-gray-600: #526872;
  --bs-gray-700: #44555e;
  --bs-gray-800: #35434a;
  --bs-gray-900: #273136;
  --bs-default-rgb: 121, 142, 152;
  --bs-theme-rgb: 36, 157, 121;
  --bs-theme-color-rgb: 255, 255, 255;
  --bs-primary-rgb: 2, 113, 255;
  --bs-secondary-rgb: 121, 142, 152;
  --bs-warning-rgb: 255, 159, 12;
  --bs-danger-rgb: 224, 0, 0;
  --bs-success-rgb: 36, 157, 121;
  --bs-inverse-rgb: 0, 0, 0;
  --bs-info-rgb: 0, 155, 227;
  --bs-dark-rgb: 53, 67, 74;
  --bs-black-rgb: 0, 0, 0;
  --bs-white-rgb: 255, 255, 255;
  --bs-purple-rgb: 185, 13, 255;
  --bs-indigo-rgb: 92, 37, 255;
  --bs-red-rgb: 224, 0, 0;
  --bs-pink-rgb: 230, 16, 121;
  --bs-green-rgb: 20, 137, 34;
  --bs-yellow-rgb: 249, 232, 13;
  --bs-teal-rgb: 36, 157, 121;
  --bs-muted-rgb: 97, 122, 134;
  --bs-light-rgb: 192, 202, 207;
  --bs-lime-rgb: 80, 176, 10;
  --bs-gray-100-rgb: 192, 202, 207;
  --bs-gray-200-rgb: 168, 182, 188;
  --bs-gray-300-rgb: 144, 162, 170;
  --bs-gray-400-rgb: 121, 142, 152;
  --bs-gray-500-rgb: 97, 122, 134;
  --bs-gray-600-rgb: 82, 104, 114;
  --bs-gray-700-rgb: 68, 85, 94;
  --bs-gray-800-rgb: 53, 67, 74;
  --bs-gray-900-rgb: 39, 49, 54;
  --bs-primary-text-emphasis: #012d66;
  --bs-secondary-text-emphasis: #30393d;
  --bs-success-text-emphasis: #0e3f30;
  --bs-info-text-emphasis: #003e5b;
  --bs-warning-text-emphasis: #664005;
  --bs-danger-text-emphasis: #5a0000;
  --bs-light-text-emphasis: #44555e;
  --bs-dark-text-emphasis: #44555e;
  --bs-primary-bg-subtle: #cce3ff;
  --bs-secondary-bg-subtle: #c0cacf;
  --bs-success-bg-subtle: #d0e7d3;
  --bs-info-bg-subtle: #ccebf9;
  --bs-warning-bg-subtle: #fefacf;
  --bs-danger-bg-subtle: #f9cccc;
  --bs-light-bg-subtle: #e0e5e7;
  --bs-dark-bg-subtle: #798e98;
  --bs-primary-border-subtle: #9ac6ff;
  --bs-secondary-border-subtle: #a8b6bc;
  --bs-success-border-subtle: #a1d0a7;
  --bs-info-border-subtle: #99d7f4;
  --bs-warning-border-subtle: #fdf69e;
  --bs-danger-border-subtle: #f39999;
  --bs-light-border-subtle: #a8b6bc;
  --bs-dark-border-subtle: #617a86;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: "Chakra Petch", sans-serif;
  --bs-body-font-size: 0.875rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: black;
  --bs-body-color-rgb: 0, 0, 0;
  --bs-body-bg: #ffffff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(0, 0, 0, 0.75);
  --bs-secondary-color-rgb: 0, 0, 0;
  --bs-secondary-bg: #c0cacf;
  --bs-secondary-bg-rgb: 192, 202, 207;
  --bs-tertiary-color: rgba(0, 0, 0, 0.5);
  --bs-tertiary-color-rgb: 0, 0, 0;
  --bs-tertiary-bg: rgba(0, 0, 0, 0.1);
  --bs-tertiary-bg-rgb: 0, 0, 0;
  --bs-heading-color: #000000;
  --bs-link-color: #249d79;
  --bs-link-color-rgb: 36, 157, 121;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgba(36, 157, 121, 0.5);
  --bs-link-hover-color-rgb: 36, 157, 121;
  --bs-code-color: #e61079;
  --bs-highlight-color: black;
  --bs-highlight-bg: #fefacf;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: rgba(0, 0, 0, 0.2);
  --bs-border-color-translucent: rgba(0, 0, 0, 0.1);
  --bs-border-radius: 4px;
  --bs-border-radius-sm: 2px;
  --bs-border-radius-lg: 8px;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(var(--bs-inverse-rgb), 0.035);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(var(--bs-inverse-rgb), 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(var(--bs-inverse-rgb), 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(2, 113, 255, 0.25);
  --bs-form-valid-color: #249d79;
  --bs-form-valid-border-color: #249d79;
  --bs-form-invalid-color: #e00000;
  --bs-form-invalid-border-color: #e00000;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: white;
  --bs-body-color-rgb: 255, 255, 255;
  --bs-body-bg: #1d2835;
  --bs-body-bg-rgb: 29, 40, 53;
  --bs-emphasis-color: #c0cacf;
  --bs-emphasis-color-rgb: 192, 202, 207;
  --bs-secondary-color: rgba(255, 255, 255, 0.75);
  --bs-secondary-color-rgb: 255, 255, 255;
  --bs-secondary-bg: #35434a;
  --bs-secondary-bg-rgb: 53, 67, 74;
  --bs-tertiary-color: rgba(255, 255, 255, 0.5);
  --bs-tertiary-color-rgb: 255, 255, 255;
  --bs-tertiary-bg: rgba(0, 0, 0, 0.1);
  --bs-tertiary-bg-rgb: 0, 0, 0;
  --bs-primary-text-emphasis: #67aaff;
  --bs-secondary-text-emphasis: #afbbc1;
  --bs-success-text-emphasis: #7cc4af;
  --bs-info-text-emphasis: #66c3ee;
  --bs-warning-text-emphasis: #ffc56d;
  --bs-danger-text-emphasis: #ec6666;
  --bs-light-text-emphasis: #c0cacf;
  --bs-dark-text-emphasis: #90a2aa;
  --bs-primary-bg-subtle: #001733;
  --bs-secondary-bg-subtle: #273136;
  --bs-success-bg-subtle: #041b07;
  --bs-info-bg-subtle: #001f2d;
  --bs-warning-bg-subtle: #322e03;
  --bs-danger-bg-subtle: #2d0000;
  --bs-light-bg-subtle: #35434a;
  --bs-dark-bg-subtle: #1b2225;
  --bs-primary-border-subtle: #014499;
  --bs-secondary-border-subtle: #44555e;
  --bs-success-border-subtle: #0c5214;
  --bs-info-border-subtle: #003e5b;
  --bs-warning-border-subtle: #645d05;
  --bs-danger-border-subtle: #860000;
  --bs-light-border-subtle: #44555e;
  --bs-dark-border-subtle: #35434a;
  --bs-heading-color: #fff;
  --bs-link-color: #67aaff;
  --bs-link-hover-color: #9ac6ff;
  --bs-link-color-rgb: 103, 170, 255;
  --bs-link-hover-color-rgb: 154, 198, 255;
  --bs-code-color: #f070af;
  --bs-highlight-color: white;
  --bs-highlight-bg: #645d05;
  --bs-border-color: rgba(255, 255, 255, 0.25);
  --bs-border-color-translucent: rgba(255, 255, 255, 0.25);
  --bs-form-valid-color: #72b87a;
  --bs-form-valid-border-color: #72b87a;
  --bs-form-invalid-color: #ec6666;
  --bs-form-invalid-border-color: #ec6666;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.34375rem + 1.125vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.1875rem;
  }
}

h2, .h2 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.75rem;
  }
}

h3, .h3 {
  font-size: calc(1.278125rem + 0.3375vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.53125rem;
  }
}

h4, .h4 {
  font-size: calc(1.25625rem + 0.075vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.3125rem;
  }
}

h5, .h5 {
  font-size: 1.09375rem;
}

h6, .h6 {
  font-size: 0.875rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 2px;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #798e98;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.09375rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.09375rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #526872;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 20px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1660px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1660px;
  --bs-breakpoint-xxxl: 1921px;
}

.row {
  --bs-gutter-x: 20px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1660px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1921px) {
  .col-xxxl {
    flex: 1 0;
  }
  .row-cols-xxxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxxl-0 {
    margin-left: 0;
  }
  .offset-xxxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxxl-3 {
    margin-left: 25%;
  }
  .offset-xxxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxxl-6 {
    margin-left: 50%;
  }
  .offset-xxxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxxl-9 {
    margin-left: 75%;
  }
  .offset-xxxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxxl-0,
  .gx-xxxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxxl-0,
  .gy-xxxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxxl-1,
  .gx-xxxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxxl-1,
  .gy-xxxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxxl-2,
  .gx-xxxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxxl-2,
  .gy-xxxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxxl-3,
  .gx-xxxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxxl-3,
  .gy-xxxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxxl-4,
  .gx-xxxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxxl-4,
  .gy-xxxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxxl-5,
  .gx-xxxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxxl-5,
  .gy-xxxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: transparent;
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(var(--bs-inverse-rgb), 0.1);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: rgba(var(--bs-inverse-rgb), 0.1);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: rgba(var(--bs-inverse-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000000;
  --bs-table-bg: #cce3ff;
  --bs-table-border-color: #b8cce6;
  --bs-table-striped-bg: #b8cce6;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #b8cce6;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #bdd2ec;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000000;
  --bs-table-bg: #e4e8ea;
  --bs-table-border-color: #cdd1d3;
  --bs-table-striped-bg: #cdd1d3;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #cdd1d3;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #d3d7d8;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000000;
  --bs-table-bg: #d3ebe4;
  --bs-table-border-color: #bed4cd;
  --bs-table-striped-bg: #bed4cd;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #bed4cd;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #c3d9d3;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000000;
  --bs-table-bg: #ccebf9;
  --bs-table-border-color: #b8d4e0;
  --bs-table-striped-bg: #b8d4e0;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #b8d4e0;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #bdd9e6;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000000;
  --bs-table-bg: #ffecce;
  --bs-table-border-color: #e6d4b9;
  --bs-table-striped-bg: #e6d4b9;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e6d4b9;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #ecdabf;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000000;
  --bs-table-bg: #f9cccc;
  --bs-table-border-color: #e0b8b8;
  --bs-table-striped-bg: #e0b8b8;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e0b8b8;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e6bdbd;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000000;
  --bs-table-bg: #c0cacf;
  --bs-table-border-color: #adb6ba;
  --bs-table-striped-bg: #adb6ba;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #adb6ba;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #b2bbbf;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #ffffff;
  --bs-table-bg: #35434a;
  --bs-table-border-color: #49565c;
  --bs-table-striped-bg: #49565c;
  --bs-table-striped-color: #ffffff;
  --bs-table-active-bg: #49565c;
  --bs-table-active-color: #ffffff;
  --bs-table-hover-bg: #445158;
  --bs-table-hover-color: #ffffff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1659.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1920.98px) {
  .table-responsive-xxxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.8125rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #798e98;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: transparent;
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: transparent;
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: rgba(var(--bs-body-color-rgb), 0.5);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-form-control-disabled-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-border-color);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.8125rem;
  border-radius: 2px;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 8px;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 4px;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 4px;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: transparent;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-form-control-disabled-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.8125rem;
  border-radius: 2px;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1rem;
  border-radius: 8px;
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.3em;
  padding-left: 1.8em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.8em;
}

.form-check-reverse {
  padding-right: 1.8em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.8em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: transparent;
  flex-shrink: 0;
  width: 1.3em;
  height: 1.3em;
  margin-top: 0.1em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-check-input:checked {
  background-color: #249d79;
  border-color: #249d79;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #249d79;
  border-color: #249d79;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.8em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2.3em;
  margin-left: -2.8em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2.3em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.8em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.8em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px transparent, 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px transparent, 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: var(--bs-theme);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgba(var(--bs-theme-rgb), 0.75);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: rgba(var(--bs-inverse-rgb), 0.1);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: var(--bs-theme);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgba(var(--bs-theme-rgb), 0.75);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: rgba(var(--bs-inverse-rgb), 0.1);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.875em;
  content: "";
  background-color: transparent;
  border-radius: 4px;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #526872;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-form-control-disabled-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 4px;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 8px;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.8125rem;
  border-radius: 2px;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-success-text);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.8125rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-success);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-success);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-success);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-success);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-success);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-success-text);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-success-text);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-danger-text);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.8125rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-danger);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-danger);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-danger);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-danger);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-danger);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-danger-text);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-danger-text);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 4px;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-default {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #798e98;
  --bs-btn-border-color: #798e98;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #677981;
  --bs-btn-hover-border-color: #61727a;
  --bs-btn-focus-shadow-rgb: 141, 159, 167;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #61727a;
  --bs-btn-active-border-color: #5b6b72;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #798e98;
  --bs-btn-disabled-border-color: #798e98;
}

.btn-theme {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #1f8567;
  --bs-btn-hover-border-color: #1d7e61;
  --bs-btn-focus-shadow-rgb: 69, 172, 141;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #1d7e61;
  --bs-btn-active-border-color: #1b765b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #249d79;
  --bs-btn-disabled-border-color: #249d79;
}

.btn-theme-color {
  --bs-btn-color: #000000;
  --bs-btn-bg: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: white;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: white;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #ffffff;
  --bs-btn-disabled-border-color: #ffffff;
}

.btn-primary {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #0271ff;
  --bs-btn-border-color: #0271ff;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #0260d9;
  --bs-btn-hover-border-color: #025acc;
  --bs-btn-focus-shadow-rgb: 40, 134, 255;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #025acc;
  --bs-btn-active-border-color: #0255bf;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #0271ff;
  --bs-btn-disabled-border-color: #0271ff;
}

.btn-secondary {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #798e98;
  --bs-btn-border-color: #798e98;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #677981;
  --bs-btn-hover-border-color: #61727a;
  --bs-btn-focus-shadow-rgb: 141, 159, 167;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #61727a;
  --bs-btn-active-border-color: #5b6b72;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #798e98;
  --bs-btn-disabled-border-color: #798e98;
}

.btn-warning {
  --bs-btn-color: #000000;
  --bs-btn-bg: #ff9f0c;
  --bs-btn-border-color: #ff9f0c;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffad30;
  --bs-btn-hover-border-color: #ffa924;
  --bs-btn-focus-shadow-rgb: 217, 135, 10;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffb23d;
  --bs-btn-active-border-color: #ffa924;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #ff9f0c;
  --bs-btn-disabled-border-color: #ff9f0c;
}

.btn-danger {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #e00000;
  --bs-btn-border-color: #e00000;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #be0000;
  --bs-btn-hover-border-color: #b30000;
  --bs-btn-focus-shadow-rgb: 229, 38, 38;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #b30000;
  --bs-btn-active-border-color: #a80000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #e00000;
  --bs-btn-disabled-border-color: #e00000;
}

.btn-success {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #1f8567;
  --bs-btn-hover-border-color: #1d7e61;
  --bs-btn-focus-shadow-rgb: 69, 172, 141;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #1d7e61;
  --bs-btn-active-border-color: #1b765b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #249d79;
  --bs-btn-disabled-border-color: #249d79;
}

.btn-inverse {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: black;
  --bs-btn-hover-border-color: black;
  --bs-btn-focus-shadow-rgb: 38, 38, 38;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: black;
  --bs-btn-active-border-color: black;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #000000;
  --bs-btn-disabled-border-color: #000000;
}

.btn-info {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #009be3;
  --bs-btn-border-color: #009be3;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #0084c1;
  --bs-btn-hover-border-color: #007cb6;
  --bs-btn-focus-shadow-rgb: 38, 170, 231;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #007cb6;
  --bs-btn-active-border-color: #0074aa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #009be3;
  --bs-btn-disabled-border-color: #009be3;
}

.btn-dark {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #35434a;
  --bs-btn-border-color: #35434a;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #535f65;
  --bs-btn-hover-border-color: #49565c;
  --bs-btn-focus-shadow-rgb: 83, 95, 101;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #5d696e;
  --bs-btn-active-border-color: #49565c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #35434a;
  --bs-btn-disabled-border-color: #35434a;
}

.btn-black {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: black;
  --bs-btn-hover-border-color: black;
  --bs-btn-focus-shadow-rgb: 38, 38, 38;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: black;
  --bs-btn-active-border-color: black;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #000000;
  --bs-btn-disabled-border-color: #000000;
}

.btn-white {
  --bs-btn-color: #000000;
  --bs-btn-bg: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: white;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: white;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #ffffff;
  --bs-btn-disabled-border-color: #ffffff;
}

.btn-purple {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #b90dff;
  --bs-btn-border-color: #b90dff;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #9d0bd9;
  --bs-btn-hover-border-color: #940acc;
  --bs-btn-focus-shadow-rgb: 196, 49, 255;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #940acc;
  --bs-btn-active-border-color: #8b0abf;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #b90dff;
  --bs-btn-disabled-border-color: #b90dff;
}

.btn-indigo {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #5c25ff;
  --bs-btn-border-color: #5c25ff;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #4e1fd9;
  --bs-btn-hover-border-color: #4a1ecc;
  --bs-btn-focus-shadow-rgb: 116, 70, 255;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #4a1ecc;
  --bs-btn-active-border-color: #451cbf;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #5c25ff;
  --bs-btn-disabled-border-color: #5c25ff;
}

.btn-red {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #e00000;
  --bs-btn-border-color: #e00000;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #be0000;
  --bs-btn-hover-border-color: #b30000;
  --bs-btn-focus-shadow-rgb: 229, 38, 38;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #b30000;
  --bs-btn-active-border-color: #a80000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #e00000;
  --bs-btn-disabled-border-color: #e00000;
}

.btn-pink {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #e61079;
  --bs-btn-border-color: #e61079;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #c40e67;
  --bs-btn-hover-border-color: #b80d61;
  --bs-btn-focus-shadow-rgb: 234, 52, 141;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #b80d61;
  --bs-btn-active-border-color: #ad0c5b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #e61079;
  --bs-btn-disabled-border-color: #e61079;
}

.btn-green {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #148922;
  --bs-btn-border-color: #148922;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #11741d;
  --bs-btn-hover-border-color: #106e1b;
  --bs-btn-focus-shadow-rgb: 55, 155, 67;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #106e1b;
  --bs-btn-active-border-color: #0f671a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #148922;
  --bs-btn-disabled-border-color: #148922;
}

.btn-yellow {
  --bs-btn-color: #000000;
  --bs-btn-bg: #f9e80d;
  --bs-btn-border-color: #f9e80d;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #faeb31;
  --bs-btn-hover-border-color: #faea25;
  --bs-btn-focus-shadow-rgb: 212, 197, 11;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #faed3d;
  --bs-btn-active-border-color: #faea25;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #f9e80d;
  --bs-btn-disabled-border-color: #f9e80d;
}

.btn-teal {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #1f8567;
  --bs-btn-hover-border-color: #1d7e61;
  --bs-btn-focus-shadow-rgb: 69, 172, 141;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #1d7e61;
  --bs-btn-active-border-color: #1b765b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #249d79;
  --bs-btn-disabled-border-color: #249d79;
}

.btn-muted {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #617a86;
  --bs-btn-border-color: #617a86;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #526872;
  --bs-btn-hover-border-color: #4e626b;
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #4e626b;
  --bs-btn-active-border-color: #495c65;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #617a86;
  --bs-btn-disabled-border-color: #617a86;
}

.btn-light {
  --bs-btn-color: #000000;
  --bs-btn-bg: #c0cacf;
  --bs-btn-border-color: #c0cacf;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #a3acb0;
  --bs-btn-hover-border-color: #9aa2a6;
  --bs-btn-focus-shadow-rgb: 163, 172, 176;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #9aa2a6;
  --bs-btn-active-border-color: #90989b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #c0cacf;
  --bs-btn-disabled-border-color: #c0cacf;
}

.btn-lime {
  --bs-btn-color: #000000;
  --bs-btn-bg: #50b00a;
  --bs-btn-border-color: #50b00a;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #6abc2f;
  --bs-btn-hover-border-color: #62b823;
  --bs-btn-focus-shadow-rgb: 68, 150, 9;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #73c03b;
  --bs-btn-active-border-color: #62b823;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #50b00a;
  --bs-btn-disabled-border-color: #50b00a;
}

.btn-gray-100 {
  --bs-btn-color: #000000;
  --bs-btn-bg: #c0cacf;
  --bs-btn-border-color: #c0cacf;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #c9d2d6;
  --bs-btn-hover-border-color: #c6cfd4;
  --bs-btn-focus-shadow-rgb: 163, 172, 176;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #cdd5d9;
  --bs-btn-active-border-color: #c6cfd4;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #c0cacf;
  --bs-btn-disabled-border-color: #c0cacf;
}

.btn-gray-200 {
  --bs-btn-color: #000000;
  --bs-btn-bg: #a8b6bc;
  --bs-btn-border-color: #a8b6bc;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #b5c1c6;
  --bs-btn-hover-border-color: #b1bdc3;
  --bs-btn-focus-shadow-rgb: 143, 155, 160;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #b9c5c9;
  --bs-btn-active-border-color: #b1bdc3;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #a8b6bc;
  --bs-btn-disabled-border-color: #a8b6bc;
}

.btn-gray-300 {
  --bs-btn-color: #000000;
  --bs-btn-bg: #90a2aa;
  --bs-btn-border-color: #90a2aa;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #a1b0b7;
  --bs-btn-hover-border-color: #9babb3;
  --bs-btn-focus-shadow-rgb: 122, 138, 145;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #a6b5bb;
  --bs-btn-active-border-color: #9babb3;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #90a2aa;
  --bs-btn-disabled-border-color: #90a2aa;
}

.btn-gray-400 {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #798e98;
  --bs-btn-border-color: #798e98;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #677981;
  --bs-btn-hover-border-color: #61727a;
  --bs-btn-focus-shadow-rgb: 141, 159, 167;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #61727a;
  --bs-btn-active-border-color: #5b6b72;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #798e98;
  --bs-btn-disabled-border-color: #798e98;
}

.btn-gray-500 {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #617a86;
  --bs-btn-border-color: #617a86;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #526872;
  --bs-btn-hover-border-color: #4e626b;
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #4e626b;
  --bs-btn-active-border-color: #495c65;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #617a86;
  --bs-btn-disabled-border-color: #617a86;
}

.btn-gray-600 {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #526872;
  --bs-btn-border-color: #526872;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #465861;
  --bs-btn-hover-border-color: #42535b;
  --bs-btn-focus-shadow-rgb: 108, 127, 135;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #42535b;
  --bs-btn-active-border-color: #3e4e56;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #526872;
  --bs-btn-disabled-border-color: #526872;
}

.btn-gray-700 {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #44555e;
  --bs-btn-border-color: #44555e;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #3a4850;
  --bs-btn-hover-border-color: #36444b;
  --bs-btn-focus-shadow-rgb: 96, 111, 118;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #36444b;
  --bs-btn-active-border-color: #334047;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #44555e;
  --bs-btn-disabled-border-color: #44555e;
}

.btn-gray-800 {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #35434a;
  --bs-btn-border-color: #35434a;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #2d393f;
  --bs-btn-hover-border-color: #2a363b;
  --bs-btn-focus-shadow-rgb: 83, 95, 101;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #2a363b;
  --bs-btn-active-border-color: #283238;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #35434a;
  --bs-btn-disabled-border-color: #35434a;
}

.btn-gray-900 {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #273136;
  --bs-btn-border-color: #273136;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #212a2e;
  --bs-btn-hover-border-color: #1f272b;
  --bs-btn-focus-shadow-rgb: 71, 80, 84;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #1f272b;
  --bs-btn-active-border-color: #1d2529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #273136;
  --bs-btn-disabled-border-color: #273136;
}

.btn-outline-default {
  --bs-btn-color: #798e98;
  --bs-btn-border-color: #798e98;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #798e98;
  --bs-btn-hover-border-color: #798e98;
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #798e98;
  --bs-btn-active-border-color: #798e98;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #798e98;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #798e98;
  --bs-gradient: none;
}

.btn-outline-theme {
  --bs-btn-color: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #249d79;
  --bs-btn-hover-border-color: #249d79;
  --bs-btn-focus-shadow-rgb: 36, 157, 121;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #249d79;
  --bs-btn-active-border-color: #249d79;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #249d79;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #249d79;
  --bs-gradient: none;
}

.btn-outline-theme-color {
  --bs-btn-color: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffffff;
  --bs-btn-hover-border-color: #ffffff;
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffffff;
  --bs-btn-active-border-color: #ffffff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffffff;
  --bs-gradient: none;
}

.btn-outline-primary {
  --bs-btn-color: #0271ff;
  --bs-btn-border-color: #0271ff;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #0271ff;
  --bs-btn-hover-border-color: #0271ff;
  --bs-btn-focus-shadow-rgb: 2, 113, 255;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #0271ff;
  --bs-btn-active-border-color: #0271ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0271ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0271ff;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #798e98;
  --bs-btn-border-color: #798e98;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #798e98;
  --bs-btn-hover-border-color: #798e98;
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #798e98;
  --bs-btn-active-border-color: #798e98;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #798e98;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #798e98;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ff9f0c;
  --bs-btn-border-color: #ff9f0c;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ff9f0c;
  --bs-btn-hover-border-color: #ff9f0c;
  --bs-btn-focus-shadow-rgb: 255, 159, 12;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ff9f0c;
  --bs-btn-active-border-color: #ff9f0c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ff9f0c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff9f0c;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #e00000;
  --bs-btn-border-color: #e00000;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #e00000;
  --bs-btn-hover-border-color: #e00000;
  --bs-btn-focus-shadow-rgb: 224, 0, 0;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #e00000;
  --bs-btn-active-border-color: #e00000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e00000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e00000;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #249d79;
  --bs-btn-hover-border-color: #249d79;
  --bs-btn-focus-shadow-rgb: 36, 157, 121;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #249d79;
  --bs-btn-active-border-color: #249d79;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #249d79;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #249d79;
  --bs-gradient: none;
}

.btn-outline-inverse {
  --bs-btn-color: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #000000;
  --bs-btn-hover-border-color: #000000;
  --bs-btn-focus-shadow-rgb: 0, 0, 0;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #000000;
  --bs-btn-active-border-color: #000000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #000000;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #009be3;
  --bs-btn-border-color: #009be3;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #009be3;
  --bs-btn-hover-border-color: #009be3;
  --bs-btn-focus-shadow-rgb: 0, 155, 227;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #009be3;
  --bs-btn-active-border-color: #009be3;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #009be3;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #009be3;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #35434a;
  --bs-btn-border-color: #35434a;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #35434a;
  --bs-btn-hover-border-color: #35434a;
  --bs-btn-focus-shadow-rgb: 53, 67, 74;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #35434a;
  --bs-btn-active-border-color: #35434a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #35434a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #35434a;
  --bs-gradient: none;
}

.btn-outline-black {
  --bs-btn-color: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #000000;
  --bs-btn-hover-border-color: #000000;
  --bs-btn-focus-shadow-rgb: 0, 0, 0;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #000000;
  --bs-btn-active-border-color: #000000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #000000;
  --bs-gradient: none;
}

.btn-outline-white {
  --bs-btn-color: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffffff;
  --bs-btn-hover-border-color: #ffffff;
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffffff;
  --bs-btn-active-border-color: #ffffff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffffff;
  --bs-gradient: none;
}

.btn-outline-purple {
  --bs-btn-color: #b90dff;
  --bs-btn-border-color: #b90dff;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #b90dff;
  --bs-btn-hover-border-color: #b90dff;
  --bs-btn-focus-shadow-rgb: 185, 13, 255;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #b90dff;
  --bs-btn-active-border-color: #b90dff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #b90dff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #b90dff;
  --bs-gradient: none;
}

.btn-outline-indigo {
  --bs-btn-color: #5c25ff;
  --bs-btn-border-color: #5c25ff;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #5c25ff;
  --bs-btn-hover-border-color: #5c25ff;
  --bs-btn-focus-shadow-rgb: 92, 37, 255;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #5c25ff;
  --bs-btn-active-border-color: #5c25ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #5c25ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #5c25ff;
  --bs-gradient: none;
}

.btn-outline-red {
  --bs-btn-color: #e00000;
  --bs-btn-border-color: #e00000;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #e00000;
  --bs-btn-hover-border-color: #e00000;
  --bs-btn-focus-shadow-rgb: 224, 0, 0;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #e00000;
  --bs-btn-active-border-color: #e00000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e00000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e00000;
  --bs-gradient: none;
}

.btn-outline-pink {
  --bs-btn-color: #e61079;
  --bs-btn-border-color: #e61079;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #e61079;
  --bs-btn-hover-border-color: #e61079;
  --bs-btn-focus-shadow-rgb: 230, 16, 121;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #e61079;
  --bs-btn-active-border-color: #e61079;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e61079;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e61079;
  --bs-gradient: none;
}

.btn-outline-green {
  --bs-btn-color: #148922;
  --bs-btn-border-color: #148922;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #148922;
  --bs-btn-hover-border-color: #148922;
  --bs-btn-focus-shadow-rgb: 20, 137, 34;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #148922;
  --bs-btn-active-border-color: #148922;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #148922;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #148922;
  --bs-gradient: none;
}

.btn-outline-yellow {
  --bs-btn-color: #f9e80d;
  --bs-btn-border-color: #f9e80d;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f9e80d;
  --bs-btn-hover-border-color: #f9e80d;
  --bs-btn-focus-shadow-rgb: 249, 232, 13;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f9e80d;
  --bs-btn-active-border-color: #f9e80d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f9e80d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f9e80d;
  --bs-gradient: none;
}

.btn-outline-teal {
  --bs-btn-color: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #249d79;
  --bs-btn-hover-border-color: #249d79;
  --bs-btn-focus-shadow-rgb: 36, 157, 121;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #249d79;
  --bs-btn-active-border-color: #249d79;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #249d79;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #249d79;
  --bs-gradient: none;
}

.btn-outline-muted {
  --bs-btn-color: #617a86;
  --bs-btn-border-color: #617a86;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #617a86;
  --bs-btn-hover-border-color: #617a86;
  --bs-btn-focus-shadow-rgb: 97, 122, 134;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #617a86;
  --bs-btn-active-border-color: #617a86;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #617a86;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #617a86;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #c0cacf;
  --bs-btn-border-color: #c0cacf;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #c0cacf;
  --bs-btn-hover-border-color: #c0cacf;
  --bs-btn-focus-shadow-rgb: 192, 202, 207;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #c0cacf;
  --bs-btn-active-border-color: #c0cacf;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #c0cacf;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #c0cacf;
  --bs-gradient: none;
}

.btn-outline-lime {
  --bs-btn-color: #50b00a;
  --bs-btn-border-color: #50b00a;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #50b00a;
  --bs-btn-hover-border-color: #50b00a;
  --bs-btn-focus-shadow-rgb: 80, 176, 10;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #50b00a;
  --bs-btn-active-border-color: #50b00a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #50b00a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #50b00a;
  --bs-gradient: none;
}

.btn-outline-gray-100 {
  --bs-btn-color: #c0cacf;
  --bs-btn-border-color: #c0cacf;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #c0cacf;
  --bs-btn-hover-border-color: #c0cacf;
  --bs-btn-focus-shadow-rgb: 192, 202, 207;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #c0cacf;
  --bs-btn-active-border-color: #c0cacf;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #c0cacf;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #c0cacf;
  --bs-gradient: none;
}

.btn-outline-gray-200 {
  --bs-btn-color: #a8b6bc;
  --bs-btn-border-color: #a8b6bc;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #a8b6bc;
  --bs-btn-hover-border-color: #a8b6bc;
  --bs-btn-focus-shadow-rgb: 168, 182, 188;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #a8b6bc;
  --bs-btn-active-border-color: #a8b6bc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #a8b6bc;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #a8b6bc;
  --bs-gradient: none;
}

.btn-outline-gray-300 {
  --bs-btn-color: #90a2aa;
  --bs-btn-border-color: #90a2aa;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #90a2aa;
  --bs-btn-hover-border-color: #90a2aa;
  --bs-btn-focus-shadow-rgb: 144, 162, 170;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #90a2aa;
  --bs-btn-active-border-color: #90a2aa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #90a2aa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #90a2aa;
  --bs-gradient: none;
}

.btn-outline-gray-400 {
  --bs-btn-color: #798e98;
  --bs-btn-border-color: #798e98;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #798e98;
  --bs-btn-hover-border-color: #798e98;
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #798e98;
  --bs-btn-active-border-color: #798e98;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #798e98;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #798e98;
  --bs-gradient: none;
}

.btn-outline-gray-500 {
  --bs-btn-color: #617a86;
  --bs-btn-border-color: #617a86;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #617a86;
  --bs-btn-hover-border-color: #617a86;
  --bs-btn-focus-shadow-rgb: 97, 122, 134;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #617a86;
  --bs-btn-active-border-color: #617a86;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #617a86;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #617a86;
  --bs-gradient: none;
}

.btn-outline-gray-600 {
  --bs-btn-color: #526872;
  --bs-btn-border-color: #526872;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #526872;
  --bs-btn-hover-border-color: #526872;
  --bs-btn-focus-shadow-rgb: 82, 104, 114;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #526872;
  --bs-btn-active-border-color: #526872;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #526872;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #526872;
  --bs-gradient: none;
}

.btn-outline-gray-700 {
  --bs-btn-color: #44555e;
  --bs-btn-border-color: #44555e;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #44555e;
  --bs-btn-hover-border-color: #44555e;
  --bs-btn-focus-shadow-rgb: 68, 85, 94;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #44555e;
  --bs-btn-active-border-color: #44555e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #44555e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #44555e;
  --bs-gradient: none;
}

.btn-outline-gray-800 {
  --bs-btn-color: #35434a;
  --bs-btn-border-color: #35434a;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #35434a;
  --bs-btn-hover-border-color: #35434a;
  --bs-btn-focus-shadow-rgb: 53, 67, 74;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #35434a;
  --bs-btn-active-border-color: #35434a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #35434a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #35434a;
  --bs-gradient: none;
}

.btn-outline-gray-900 {
  --bs-btn-color: #273136;
  --bs-btn-border-color: #273136;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #273136;
  --bs-btn-hover-border-color: #273136;
  --bs-btn-focus-shadow-rgb: 39, 49, 54;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #273136;
  --bs-btn-active-border-color: #273136;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #273136;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #273136;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #526872;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 69, 172, 141;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1rem;
  --bs-btn-border-radius: 8px;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.8125rem;
  --bs-btn-border-radius: 2px;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.875rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: rgba(var(--bs-body-bg-rgb), 0.98);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0;
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(0 - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: rgba(var(--bs-body-color-rgb), 0.15);
  --bs-dropdown-link-active-color: #ffffff;
  --bs-dropdown-link-active-bg: #249d79;
  --bs-dropdown-link-disabled-color: #617a86;
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.375rem;
  --bs-dropdown-header-color: rgba(var(--bs-body-color-rgb), 0.5);
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1660px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1921px) {
  .dropdown-menu-xxxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.8125rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #90a2aa;
  --bs-dropdown-bg: #35434a;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #90a2aa;
  --bs-dropdown-link-hover-color: #ffffff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #ffffff;
  --bs-dropdown-link-active-bg: #249d79;
  --bs-dropdown-link-disabled-color: #617a86;
  --bs-dropdown-header-color: #617a86;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 4px;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(2, 113, 255, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-inverse);
  --bs-nav-tabs-link-active-bg: transparent;
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) transparent;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 4px;
  --bs-nav-pills-link-active-color: #ffffff;
  --bs-nav-pills-link-active-bg: #249d79;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 600;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-inverse-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-inverse-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-inverse-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-inverse-rgb), 1);
  --bs-navbar-brand-padding-y: 0.40625rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1rem;
  --bs-navbar-brand-color: rgba(var(--bs-inverse-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-inverse-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-inverse-rgb), 0.15);
  --bs-navbar-toggler-border-radius: 4px;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1660px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1921px) {
  .navbar-expand-xxxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #ffffff;
  --bs-navbar-brand-color: #ffffff;
  --bs-navbar-brand-hover-color: #ffffff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: transparent;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-focus-border-color: rgba(var(--bs-inverse-rgb), 0.5);
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-inverse);
  --bs-accordion-active-bg: rgba(var(--bs-theme-rgb), 0.15);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.875rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-font-size: 85%;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-color: var(--bs-inverse);
  --bs-pagination-bg: transparent;
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-inverse);
  --bs-pagination-hover-bg: rgba(var(--bs-inverse-rgb), 0.1);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
  --bs-pagination-active-color: var(--bs-theme-color);
  --bs-pagination-active-bg: var(--bs-theme);
  --bs-pagination-active-border-color: var(--bs-theme);
  --bs-pagination-disabled-color: rgba(var(--bs-inverse-rgb), 0.35);
  --bs-pagination-disabled-bg: rgba(var(--bs-inverse-rgb), 0.1);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-border-radius: 8px;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.8125rem;
  --bs-pagination-border-radius: 2px;
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #ffffff;
  --bs-badge-border-radius: 4px;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 4px;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-default {
  --bs-alert-color: var(--bs-default-text-emphasis);
  --bs-alert-bg: var(--bs-default-bg-subtle);
  --bs-alert-border-color: var(--bs-default-border-subtle);
  --bs-alert-link-color: var(--bs-default-text-emphasis);
}

.alert-theme {
  --bs-alert-color: var(--bs-theme-text-emphasis);
  --bs-alert-bg: var(--bs-theme-bg-subtle);
  --bs-alert-border-color: var(--bs-theme-border-subtle);
  --bs-alert-link-color: var(--bs-theme-text-emphasis);
}

.alert-theme-color {
  --bs-alert-color: var(--bs-theme-color-text-emphasis);
  --bs-alert-bg: var(--bs-theme-color-bg-subtle);
  --bs-alert-border-color: var(--bs-theme-color-border-subtle);
  --bs-alert-link-color: var(--bs-theme-color-text-emphasis);
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-inverse {
  --bs-alert-color: var(--bs-inverse-text-emphasis);
  --bs-alert-bg: var(--bs-inverse-bg-subtle);
  --bs-alert-border-color: var(--bs-inverse-border-subtle);
  --bs-alert-link-color: var(--bs-inverse-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

.alert-black {
  --bs-alert-color: var(--bs-black-text-emphasis);
  --bs-alert-bg: var(--bs-black-bg-subtle);
  --bs-alert-border-color: var(--bs-black-border-subtle);
  --bs-alert-link-color: var(--bs-black-text-emphasis);
}

.alert-white {
  --bs-alert-color: var(--bs-white-text-emphasis);
  --bs-alert-bg: var(--bs-white-bg-subtle);
  --bs-alert-border-color: var(--bs-white-border-subtle);
  --bs-alert-link-color: var(--bs-white-text-emphasis);
}

.alert-purple {
  --bs-alert-color: var(--bs-purple-text-emphasis);
  --bs-alert-bg: var(--bs-purple-bg-subtle);
  --bs-alert-border-color: var(--bs-purple-border-subtle);
  --bs-alert-link-color: var(--bs-purple-text-emphasis);
}

.alert-indigo {
  --bs-alert-color: var(--bs-indigo-text-emphasis);
  --bs-alert-bg: var(--bs-indigo-bg-subtle);
  --bs-alert-border-color: var(--bs-indigo-border-subtle);
  --bs-alert-link-color: var(--bs-indigo-text-emphasis);
}

.alert-red {
  --bs-alert-color: var(--bs-red-text-emphasis);
  --bs-alert-bg: var(--bs-red-bg-subtle);
  --bs-alert-border-color: var(--bs-red-border-subtle);
  --bs-alert-link-color: var(--bs-red-text-emphasis);
}

.alert-pink {
  --bs-alert-color: var(--bs-pink-text-emphasis);
  --bs-alert-bg: var(--bs-pink-bg-subtle);
  --bs-alert-border-color: var(--bs-pink-border-subtle);
  --bs-alert-link-color: var(--bs-pink-text-emphasis);
}

.alert-green {
  --bs-alert-color: var(--bs-green-text-emphasis);
  --bs-alert-bg: var(--bs-green-bg-subtle);
  --bs-alert-border-color: var(--bs-green-border-subtle);
  --bs-alert-link-color: var(--bs-green-text-emphasis);
}

.alert-yellow {
  --bs-alert-color: var(--bs-yellow-text-emphasis);
  --bs-alert-bg: var(--bs-yellow-bg-subtle);
  --bs-alert-border-color: var(--bs-yellow-border-subtle);
  --bs-alert-link-color: var(--bs-yellow-text-emphasis);
}

.alert-teal {
  --bs-alert-color: var(--bs-teal-text-emphasis);
  --bs-alert-bg: var(--bs-teal-bg-subtle);
  --bs-alert-border-color: var(--bs-teal-border-subtle);
  --bs-alert-link-color: var(--bs-teal-text-emphasis);
}

.alert-muted {
  --bs-alert-color: var(--bs-muted-text-emphasis);
  --bs-alert-bg: var(--bs-muted-bg-subtle);
  --bs-alert-border-color: var(--bs-muted-border-subtle);
  --bs-alert-link-color: var(--bs-muted-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-lime {
  --bs-alert-color: var(--bs-lime-text-emphasis);
  --bs-alert-bg: var(--bs-lime-bg-subtle);
  --bs-alert-border-color: var(--bs-lime-border-subtle);
  --bs-alert-link-color: var(--bs-lime-text-emphasis);
}

.alert-gray-100 {
  --bs-alert-color: var(--bs-gray-100-text-emphasis);
  --bs-alert-bg: var(--bs-gray-100-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-100-border-subtle);
  --bs-alert-link-color: var(--bs-gray-100-text-emphasis);
}

.alert-gray-200 {
  --bs-alert-color: var(--bs-gray-200-text-emphasis);
  --bs-alert-bg: var(--bs-gray-200-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-200-border-subtle);
  --bs-alert-link-color: var(--bs-gray-200-text-emphasis);
}

.alert-gray-300 {
  --bs-alert-color: var(--bs-gray-300-text-emphasis);
  --bs-alert-bg: var(--bs-gray-300-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-300-border-subtle);
  --bs-alert-link-color: var(--bs-gray-300-text-emphasis);
}

.alert-gray-400 {
  --bs-alert-color: var(--bs-gray-400-text-emphasis);
  --bs-alert-bg: var(--bs-gray-400-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-400-border-subtle);
  --bs-alert-link-color: var(--bs-gray-400-text-emphasis);
}

.alert-gray-500 {
  --bs-alert-color: var(--bs-gray-500-text-emphasis);
  --bs-alert-bg: var(--bs-gray-500-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-500-border-subtle);
  --bs-alert-link-color: var(--bs-gray-500-text-emphasis);
}

.alert-gray-600 {
  --bs-alert-color: var(--bs-gray-600-text-emphasis);
  --bs-alert-bg: var(--bs-gray-600-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-600-border-subtle);
  --bs-alert-link-color: var(--bs-gray-600-text-emphasis);
}

.alert-gray-700 {
  --bs-alert-color: var(--bs-gray-700-text-emphasis);
  --bs-alert-bg: var(--bs-gray-700-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-700-border-subtle);
  --bs-alert-link-color: var(--bs-gray-700-text-emphasis);
}

.alert-gray-800 {
  --bs-alert-color: var(--bs-gray-800-text-emphasis);
  --bs-alert-bg: var(--bs-gray-800-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-800-border-subtle);
  --bs-alert-link-color: var(--bs-gray-800-text-emphasis);
}

.alert-gray-900 {
  --bs-alert-color: var(--bs-gray-900-text-emphasis);
  --bs-alert-bg: var(--bs-gray-900-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-900-border-subtle);
  --bs-alert-link-color: var(--bs-gray-900-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.65625rem;
  --bs-progress-bg: rgba(var(--bs-inverse-rgb), 0.15);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #ffffff;
  --bs-progress-bar-bg: #0271ff;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: transparent;
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-inverse);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: transparent;
  --bs-list-group-active-color: #ffffff;
  --bs-list-group-active-bg: #249d79;
  --bs-list-group-active-border-color: #249d79;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1660px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1921px) {
  .list-group-horizontal-xxxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-default {
  --bs-list-group-color: var(--bs-default-text-emphasis);
  --bs-list-group-bg: var(--bs-default-bg-subtle);
  --bs-list-group-border-color: var(--bs-default-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-default-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-default-border-subtle);
  --bs-list-group-active-color: var(--bs-default-bg-subtle);
  --bs-list-group-active-bg: var(--bs-default-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-default-text-emphasis);
}

.list-group-item-theme {
  --bs-list-group-color: var(--bs-theme-text-emphasis);
  --bs-list-group-bg: var(--bs-theme-bg-subtle);
  --bs-list-group-border-color: var(--bs-theme-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-theme-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-theme-border-subtle);
  --bs-list-group-active-color: var(--bs-theme-bg-subtle);
  --bs-list-group-active-bg: var(--bs-theme-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-theme-text-emphasis);
}

.list-group-item-theme-color {
  --bs-list-group-color: var(--bs-theme-color-text-emphasis);
  --bs-list-group-bg: var(--bs-theme-color-bg-subtle);
  --bs-list-group-border-color: var(--bs-theme-color-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-theme-color-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-theme-color-border-subtle);
  --bs-list-group-active-color: var(--bs-theme-color-bg-subtle);
  --bs-list-group-active-bg: var(--bs-theme-color-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-theme-color-text-emphasis);
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-inverse {
  --bs-list-group-color: var(--bs-inverse-text-emphasis);
  --bs-list-group-bg: var(--bs-inverse-bg-subtle);
  --bs-list-group-border-color: var(--bs-inverse-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-inverse-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-inverse-border-subtle);
  --bs-list-group-active-color: var(--bs-inverse-bg-subtle);
  --bs-list-group-active-bg: var(--bs-inverse-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-inverse-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.list-group-item-black {
  --bs-list-group-color: var(--bs-black-text-emphasis);
  --bs-list-group-bg: var(--bs-black-bg-subtle);
  --bs-list-group-border-color: var(--bs-black-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-black-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-black-border-subtle);
  --bs-list-group-active-color: var(--bs-black-bg-subtle);
  --bs-list-group-active-bg: var(--bs-black-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-black-text-emphasis);
}

.list-group-item-white {
  --bs-list-group-color: var(--bs-white-text-emphasis);
  --bs-list-group-bg: var(--bs-white-bg-subtle);
  --bs-list-group-border-color: var(--bs-white-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-white-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-white-border-subtle);
  --bs-list-group-active-color: var(--bs-white-bg-subtle);
  --bs-list-group-active-bg: var(--bs-white-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-white-text-emphasis);
}

.list-group-item-purple {
  --bs-list-group-color: var(--bs-purple-text-emphasis);
  --bs-list-group-bg: var(--bs-purple-bg-subtle);
  --bs-list-group-border-color: var(--bs-purple-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-purple-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-purple-border-subtle);
  --bs-list-group-active-color: var(--bs-purple-bg-subtle);
  --bs-list-group-active-bg: var(--bs-purple-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-purple-text-emphasis);
}

.list-group-item-indigo {
  --bs-list-group-color: var(--bs-indigo-text-emphasis);
  --bs-list-group-bg: var(--bs-indigo-bg-subtle);
  --bs-list-group-border-color: var(--bs-indigo-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-indigo-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-indigo-border-subtle);
  --bs-list-group-active-color: var(--bs-indigo-bg-subtle);
  --bs-list-group-active-bg: var(--bs-indigo-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-indigo-text-emphasis);
}

.list-group-item-red {
  --bs-list-group-color: var(--bs-red-text-emphasis);
  --bs-list-group-bg: var(--bs-red-bg-subtle);
  --bs-list-group-border-color: var(--bs-red-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-red-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-red-border-subtle);
  --bs-list-group-active-color: var(--bs-red-bg-subtle);
  --bs-list-group-active-bg: var(--bs-red-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-red-text-emphasis);
}

.list-group-item-pink {
  --bs-list-group-color: var(--bs-pink-text-emphasis);
  --bs-list-group-bg: var(--bs-pink-bg-subtle);
  --bs-list-group-border-color: var(--bs-pink-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-pink-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-pink-border-subtle);
  --bs-list-group-active-color: var(--bs-pink-bg-subtle);
  --bs-list-group-active-bg: var(--bs-pink-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-pink-text-emphasis);
}

.list-group-item-green {
  --bs-list-group-color: var(--bs-green-text-emphasis);
  --bs-list-group-bg: var(--bs-green-bg-subtle);
  --bs-list-group-border-color: var(--bs-green-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-green-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-green-border-subtle);
  --bs-list-group-active-color: var(--bs-green-bg-subtle);
  --bs-list-group-active-bg: var(--bs-green-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-green-text-emphasis);
}

.list-group-item-yellow {
  --bs-list-group-color: var(--bs-yellow-text-emphasis);
  --bs-list-group-bg: var(--bs-yellow-bg-subtle);
  --bs-list-group-border-color: var(--bs-yellow-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-yellow-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-yellow-border-subtle);
  --bs-list-group-active-color: var(--bs-yellow-bg-subtle);
  --bs-list-group-active-bg: var(--bs-yellow-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-yellow-text-emphasis);
}

.list-group-item-teal {
  --bs-list-group-color: var(--bs-teal-text-emphasis);
  --bs-list-group-bg: var(--bs-teal-bg-subtle);
  --bs-list-group-border-color: var(--bs-teal-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-teal-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-teal-border-subtle);
  --bs-list-group-active-color: var(--bs-teal-bg-subtle);
  --bs-list-group-active-bg: var(--bs-teal-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-teal-text-emphasis);
}

.list-group-item-muted {
  --bs-list-group-color: var(--bs-muted-text-emphasis);
  --bs-list-group-bg: var(--bs-muted-bg-subtle);
  --bs-list-group-border-color: var(--bs-muted-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-muted-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-muted-border-subtle);
  --bs-list-group-active-color: var(--bs-muted-bg-subtle);
  --bs-list-group-active-bg: var(--bs-muted-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-muted-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-lime {
  --bs-list-group-color: var(--bs-lime-text-emphasis);
  --bs-list-group-bg: var(--bs-lime-bg-subtle);
  --bs-list-group-border-color: var(--bs-lime-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-lime-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-lime-border-subtle);
  --bs-list-group-active-color: var(--bs-lime-bg-subtle);
  --bs-list-group-active-bg: var(--bs-lime-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-lime-text-emphasis);
}

.list-group-item-gray-100 {
  --bs-list-group-color: var(--bs-gray-100-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-100-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-100-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-100-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-100-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-100-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-100-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-100-text-emphasis);
}

.list-group-item-gray-200 {
  --bs-list-group-color: var(--bs-gray-200-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-200-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-200-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-200-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-200-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-200-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-200-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-200-text-emphasis);
}

.list-group-item-gray-300 {
  --bs-list-group-color: var(--bs-gray-300-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-300-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-300-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-300-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-300-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-300-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-300-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-300-text-emphasis);
}

.list-group-item-gray-400 {
  --bs-list-group-color: var(--bs-gray-400-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-400-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-400-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-400-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-400-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-400-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-400-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-400-text-emphasis);
}

.list-group-item-gray-500 {
  --bs-list-group-color: var(--bs-gray-500-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-500-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-500-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-500-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-500-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-500-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-500-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-500-text-emphasis);
}

.list-group-item-gray-600 {
  --bs-list-group-color: var(--bs-gray-600-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-600-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-600-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-600-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-600-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-600-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-600-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-600-text-emphasis);
}

.list-group-item-gray-700 {
  --bs-list-group-color: var(--bs-gray-700-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-700-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-700-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-700-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-700-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-700-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-700-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-700-text-emphasis);
}

.list-group-item-gray-800 {
  --bs-list-group-color: var(--bs-gray-800-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-800-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-800-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-800-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-800-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-800-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-800-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-800-text-emphasis);
}

.list-group-item-gray-900 {
  --bs-list-group-color: var(--bs-gray-900-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-900-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-900-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-900-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-900-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-900-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-900-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-900-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 4px;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 20px;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-app-header-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: 0;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(var(--bs-inverse-rgb), 0.035);
  --bs-modal-inner-border-radius: 0;
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #e6e6e6;
  --bs-backdrop-opacity: 0.95;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1659.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1920.98px) {
  .modal-fullscreen-xxxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxxl-down .modal-header,
  .modal-fullscreen-xxxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1130;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.8125rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-inverse);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: "Chakra Petch", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.8125rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 0.875rem;
  --bs-popover-header-color: #000000;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: "Chakra Petch", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #ffffff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #ffffff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000000;
}
.carousel-dark .carousel-caption {
  color: #000000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxxl, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(var(--bs-inverse-rgb), 0.035);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1659.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1659.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1659.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1660px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1920.98px) {
  .offcanvas-xxxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1920.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxxl {
    transition: none;
  }
}
@media (max-width: 1920.98px) {
  .offcanvas-xxxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxxl.showing, .offcanvas-xxxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxxl.showing, .offcanvas-xxxl.hiding, .offcanvas-xxxl.show {
    visibility: visible;
  }
}
@media (min-width: 1921px) {
  .offcanvas-xxxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #e6e6e6;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.95;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-default {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-default-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-theme {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-theme-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-theme-color {
  color: #000000 !important;
  background-color: RGBA(var(--bs-theme-color-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-inverse {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-inverse-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-black {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-black-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-white {
  color: #000000 !important;
  background-color: RGBA(var(--bs-white-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-purple {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-purple-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-indigo {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-indigo-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-red {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-red-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-pink {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-pink-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-green {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-green-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-yellow {
  color: #000000 !important;
  background-color: RGBA(var(--bs-yellow-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-teal {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-teal-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-muted {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-muted-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-lime {
  color: #000000 !important;
  background-color: RGBA(var(--bs-lime-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-100 {
  color: #000000 !important;
  background-color: RGBA(var(--bs-gray-100-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-200 {
  color: #000000 !important;
  background-color: RGBA(var(--bs-gray-200-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-300 {
  color: #000000 !important;
  background-color: RGBA(var(--bs-gray-300-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-400 {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-gray-400-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-500 {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-gray-500-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-600 {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-gray-600-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-700 {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-gray-700-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-800 {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-gray-800-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-900 {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-gray-900-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-default {
  color: RGBA(var(--bs-default-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-default-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-default:hover, .link-default:focus {
  color: RGBA(97, 114, 122, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 114, 122, var(--bs-link-underline-opacity, 1)) !important;
}

.link-theme {
  color: RGBA(var(--bs-theme-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-theme-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-theme:hover, .link-theme:focus {
  color: RGBA(29, 126, 97, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(29, 126, 97, var(--bs-link-underline-opacity, 1)) !important;
}

.link-theme-color {
  color: RGBA(var(--bs-theme-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-theme-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-theme-color:hover, .link-theme-color:focus {
  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(2, 90, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(2, 90, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(97, 114, 122, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 114, 122, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 178, 61, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 178, 61, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(179, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(179, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(29, 126, 97, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(29, 126, 97, var(--bs-link-underline-opacity, 1)) !important;
}

.link-inverse {
  color: RGBA(var(--bs-inverse-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-inverse-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-inverse:hover, .link-inverse:focus {
  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(0, 124, 182, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 124, 182, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(42, 54, 59, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 54, 59, var(--bs-link-underline-opacity, 1)) !important;
}

.link-black {
  color: RGBA(var(--bs-black-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-black-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-black:hover, .link-black:focus {
  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-white {
  color: RGBA(var(--bs-white-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-white-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-white:hover, .link-white:focus {
  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-purple {
  color: RGBA(var(--bs-purple-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-purple-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-purple:hover, .link-purple:focus {
  color: RGBA(148, 10, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(148, 10, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-indigo {
  color: RGBA(var(--bs-indigo-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-indigo-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-indigo:hover, .link-indigo:focus {
  color: RGBA(74, 30, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(74, 30, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-red {
  color: RGBA(var(--bs-red-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-red-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-red:hover, .link-red:focus {
  color: RGBA(179, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(179, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-pink {
  color: RGBA(var(--bs-pink-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-pink-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-pink:hover, .link-pink:focus {
  color: RGBA(184, 13, 97, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(184, 13, 97, var(--bs-link-underline-opacity, 1)) !important;
}

.link-green {
  color: RGBA(var(--bs-green-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-green-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-green:hover, .link-green:focus {
  color: RGBA(16, 110, 27, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(16, 110, 27, var(--bs-link-underline-opacity, 1)) !important;
}

.link-yellow {
  color: RGBA(var(--bs-yellow-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-yellow-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-yellow:hover, .link-yellow:focus {
  color: RGBA(250, 237, 61, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(250, 237, 61, var(--bs-link-underline-opacity, 1)) !important;
}

.link-teal {
  color: RGBA(var(--bs-teal-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-teal-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-teal:hover, .link-teal:focus {
  color: RGBA(29, 126, 97, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(29, 126, 97, var(--bs-link-underline-opacity, 1)) !important;
}

.link-muted {
  color: RGBA(var(--bs-muted-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-muted-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-muted:hover, .link-muted:focus {
  color: RGBA(78, 98, 107, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(78, 98, 107, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(205, 213, 217, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(205, 213, 217, var(--bs-link-underline-opacity, 1)) !important;
}

.link-lime {
  color: RGBA(var(--bs-lime-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-lime-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-lime:hover, .link-lime:focus {
  color: RGBA(115, 192, 59, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(115, 192, 59, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-100 {
  color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-100:hover, .link-gray-100:focus {
  color: RGBA(205, 213, 217, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(205, 213, 217, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-200 {
  color: RGBA(var(--bs-gray-200-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-200-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-200:hover, .link-gray-200:focus {
  color: RGBA(185, 197, 201, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(185, 197, 201, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-300 {
  color: RGBA(var(--bs-gray-300-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-300-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-300:hover, .link-gray-300:focus {
  color: RGBA(166, 181, 187, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(166, 181, 187, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-400 {
  color: RGBA(var(--bs-gray-400-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-400-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-400:hover, .link-gray-400:focus {
  color: RGBA(97, 114, 122, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 114, 122, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-500 {
  color: RGBA(var(--bs-gray-500-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-500-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-500:hover, .link-gray-500:focus {
  color: RGBA(78, 98, 107, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(78, 98, 107, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-600 {
  color: RGBA(var(--bs-gray-600-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-600-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-600:hover, .link-gray-600:focus {
  color: RGBA(66, 83, 91, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(66, 83, 91, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-700 {
  color: RGBA(var(--bs-gray-700-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-700-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-700:hover, .link-gray-700:focus {
  color: RGBA(54, 68, 75, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(54, 68, 75, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-800 {
  color: RGBA(var(--bs-gray-800-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-800-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-800:hover, .link-gray-800:focus {
  color: RGBA(42, 54, 59, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 54, 59, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-900 {
  color: RGBA(var(--bs-gray-900-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-900-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-900:hover, .link-gray-900:focus {
  color: RGBA(31, 39, 43, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(31, 39, 43, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1660px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1921px) {
  .sticky-xxxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-default {
  --bs-focus-ring-color: rgba(var(--bs-default-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-theme {
  --bs-focus-ring-color: rgba(var(--bs-theme-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-theme-color {
  --bs-focus-ring-color: rgba(var(--bs-theme-color-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-inverse {
  --bs-focus-ring-color: rgba(var(--bs-inverse-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-black {
  --bs-focus-ring-color: rgba(var(--bs-black-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-white {
  --bs-focus-ring-color: rgba(var(--bs-white-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-purple {
  --bs-focus-ring-color: rgba(var(--bs-purple-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-indigo {
  --bs-focus-ring-color: rgba(var(--bs-indigo-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-red {
  --bs-focus-ring-color: rgba(var(--bs-red-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-pink {
  --bs-focus-ring-color: rgba(var(--bs-pink-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-green {
  --bs-focus-ring-color: rgba(var(--bs-green-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-yellow {
  --bs-focus-ring-color: rgba(var(--bs-yellow-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-teal {
  --bs-focus-ring-color: rgba(var(--bs-teal-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-muted {
  --bs-focus-ring-color: rgba(var(--bs-muted-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-lime {
  --bs-focus-ring-color: rgba(var(--bs-lime-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-100 {
  --bs-focus-ring-color: rgba(var(--bs-gray-100-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-200 {
  --bs-focus-ring-color: rgba(var(--bs-gray-200-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-300 {
  --bs-focus-ring-color: rgba(var(--bs-gray-300-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-400 {
  --bs-focus-ring-color: rgba(var(--bs-gray-400-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-500 {
  --bs-focus-ring-color: rgba(var(--bs-gray-500-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-600 {
  --bs-focus-ring-color: rgba(var(--bs-gray-600-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-700 {
  --bs-focus-ring-color: rgba(var(--bs-gray-700-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-800 {
  --bs-focus-ring-color: rgba(var(--bs-gray-800-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-900 {
  --bs-focus-ring-color: rgba(var(--bs-gray-900-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-default {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-default-rgb), var(--bs-border-opacity)) !important;
}

.border-theme {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-theme-rgb), var(--bs-border-opacity)) !important;
}

.border-theme-color {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-theme-color-rgb), var(--bs-border-opacity)) !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-inverse {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-inverse-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-purple {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-purple-rgb), var(--bs-border-opacity)) !important;
}

.border-indigo {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-indigo-rgb), var(--bs-border-opacity)) !important;
}

.border-red {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-red-rgb), var(--bs-border-opacity)) !important;
}

.border-pink {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-pink-rgb), var(--bs-border-opacity)) !important;
}

.border-green {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-green-rgb), var(--bs-border-opacity)) !important;
}

.border-yellow {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-yellow-rgb), var(--bs-border-opacity)) !important;
}

.border-teal {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-teal-rgb), var(--bs-border-opacity)) !important;
}

.border-muted {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-muted-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-lime {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-lime-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-100 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-100-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-200 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-200-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-300 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-300-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-400 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-400-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-500 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-500-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-600 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-600-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-700 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-700-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-800 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-800-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-900 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-900-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.34375rem + 1.125vw) !important;
}

.fs-2 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-3 {
  font-size: calc(1.278125rem + 0.3375vw) !important;
}

.fs-4 {
  font-size: calc(1.25625rem + 0.075vw) !important;
}

.fs-5 {
  font-size: 1.09375rem !important;
}

.fs-6 {
  font-size: 0.875rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 500 !important;
}

.fw-bold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-default {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-default-rgb), var(--bs-text-opacity)) !important;
}

.text-theme {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-theme-rgb), var(--bs-text-opacity)) !important;
}

.text-theme-color {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-theme-color-rgb), var(--bs-text-opacity)) !important;
}

.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-inverse {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-inverse-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-purple {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-purple-rgb), var(--bs-text-opacity)) !important;
}

.text-indigo {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-indigo-rgb), var(--bs-text-opacity)) !important;
}

.text-red {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-red-rgb), var(--bs-text-opacity)) !important;
}

.text-pink {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-pink-rgb), var(--bs-text-opacity)) !important;
}

.text-green {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-green-rgb), var(--bs-text-opacity)) !important;
}

.text-yellow {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-yellow-rgb), var(--bs-text-opacity)) !important;
}

.text-teal {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-teal-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-lime {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-lime-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-100 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-100-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-200 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-200-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-300 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-300-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-400 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-400-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-500 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-500-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-600 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-600-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-700 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-700-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-800 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-800-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-900 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-900-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-default {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-default-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-theme {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-theme-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-theme-color {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-theme-color-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-inverse {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-inverse-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-black {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-black-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-white {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-white-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-purple {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-purple-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-indigo {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-indigo-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-red {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-red-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-pink {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-pink-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-green {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-green-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-yellow {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-yellow-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-teal {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-teal-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-muted {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-muted-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-lime {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-lime-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-100 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-200 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-200-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-300 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-300-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-400 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-400-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-500 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-500-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-600 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-600-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-700 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-700-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-800 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-800-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-900 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-900-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-default {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-default-rgb), var(--bs-bg-opacity)) !important;
}

.bg-theme {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-theme-rgb), var(--bs-bg-opacity)) !important;
}

.bg-theme-color {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-theme-color-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-inverse {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-inverse-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-purple {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-purple-rgb), var(--bs-bg-opacity)) !important;
}

.bg-indigo {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-indigo-rgb), var(--bs-bg-opacity)) !important;
}

.bg-red {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-red-rgb), var(--bs-bg-opacity)) !important;
}

.bg-pink {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-pink-rgb), var(--bs-bg-opacity)) !important;
}

.bg-green {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-green-rgb), var(--bs-bg-opacity)) !important;
}

.bg-yellow {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-yellow-rgb), var(--bs-bg-opacity)) !important;
}

.bg-teal {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-teal-rgb), var(--bs-bg-opacity)) !important;
}

.bg-muted {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-muted-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-lime {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-lime-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-100-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-200-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-300-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-400-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-500 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-500-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-600-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-700-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-800-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-900-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1660px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1921px) {
  .float-xxxl-start {
    float: left !important;
  }
  .float-xxxl-end {
    float: right !important;
  }
  .float-xxxl-none {
    float: none !important;
  }
  .object-fit-xxxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxxl-none {
    object-fit: none !important;
  }
  .d-xxxl-inline {
    display: inline !important;
  }
  .d-xxxl-inline-block {
    display: inline-block !important;
  }
  .d-xxxl-block {
    display: block !important;
  }
  .d-xxxl-grid {
    display: grid !important;
  }
  .d-xxxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxxl-table {
    display: table !important;
  }
  .d-xxxl-table-row {
    display: table-row !important;
  }
  .d-xxxl-table-cell {
    display: table-cell !important;
  }
  .d-xxxl-flex {
    display: flex !important;
  }
  .d-xxxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxxl-none {
    display: none !important;
  }
  .flex-xxxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxxl-row {
    flex-direction: row !important;
  }
  .flex-xxxl-column {
    flex-direction: column !important;
  }
  .flex-xxxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxxl-center {
    justify-content: center !important;
  }
  .justify-content-xxxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxxl-center {
    align-items: center !important;
  }
  .align-items-xxxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxxl-center {
    align-content: center !important;
  }
  .align-content-xxxl-between {
    align-content: space-between !important;
  }
  .align-content-xxxl-around {
    align-content: space-around !important;
  }
  .align-content-xxxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxxl-auto {
    align-self: auto !important;
  }
  .align-self-xxxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxxl-center {
    align-self: center !important;
  }
  .align-self-xxxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxxl-stretch {
    align-self: stretch !important;
  }
  .order-xxxl-first {
    order: -1 !important;
  }
  .order-xxxl-0 {
    order: 0 !important;
  }
  .order-xxxl-1 {
    order: 1 !important;
  }
  .order-xxxl-2 {
    order: 2 !important;
  }
  .order-xxxl-3 {
    order: 3 !important;
  }
  .order-xxxl-4 {
    order: 4 !important;
  }
  .order-xxxl-5 {
    order: 5 !important;
  }
  .order-xxxl-last {
    order: 6 !important;
  }
  .m-xxxl-0 {
    margin: 0 !important;
  }
  .m-xxxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxxl-3 {
    margin: 1rem !important;
  }
  .m-xxxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxxl-5 {
    margin: 3rem !important;
  }
  .m-xxxl-auto {
    margin: auto !important;
  }
  .mx-xxxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxxl-auto {
    margin-top: auto !important;
  }
  .me-xxxl-0 {
    margin-right: 0 !important;
  }
  .me-xxxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxxl-auto {
    margin-right: auto !important;
  }
  .mb-xxxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxxl-auto {
    margin-left: auto !important;
  }
  .m-xxxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxxl-n3 {
    margin: -1rem !important;
  }
  .m-xxxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxxl-n5 {
    margin: -3rem !important;
  }
  .mx-xxxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xxxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xxxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxxl-n5 {
    margin-top: -3rem !important;
  }
  .me-xxxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxxl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xxxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxxl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xxxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxxl-n5 {
    margin-left: -3rem !important;
  }
  .p-xxxl-0 {
    padding: 0 !important;
  }
  .p-xxxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxxl-3 {
    padding: 1rem !important;
  }
  .p-xxxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxxl-5 {
    padding: 3rem !important;
  }
  .px-xxxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxxl-0 {
    gap: 0 !important;
  }
  .gap-xxxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxxl-3 {
    gap: 1rem !important;
  }
  .gap-xxxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxxl-start {
    text-align: left !important;
  }
  .text-xxxl-end {
    text-align: right !important;
  }
  .text-xxxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.1875rem !important;
  }
  .fs-2 {
    font-size: 1.75rem !important;
  }
  .fs-3 {
    font-size: 1.53125rem !important;
  }
  .fs-4 {
    font-size: 1.3125rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
[data-bs-theme=light] .border-white {
  border-color: #000 !important;
}
[data-bs-theme=light] .text-white {
  color: #000 !important;
}
[data-bs-theme=light] .border-black {
  border-color: #fff !important;
}
[data-bs-theme=light] .text-black {
  color: #fff !important;
}
[data-bs-theme=light] body .react-select__control,
[data-bs-theme=light] .form-control,
[data-bs-theme=light] .form-select {
  background-color: #fff;
}
[data-bs-theme=light] body .react-select__control .react-select__value-container .react-select__input-container {
  color: #000;
}
[data-bs-theme=light] .table {
  background: #fff;
}
[data-bs-theme=light] .tree {
  border-color: rgba(0, 0, 0, 0.3);
}
[data-bs-theme=light] .tree li a {
  color: black;
  border-color: rgba(0, 0, 0, 0.3);
}
[data-bs-theme=light] .disaster-page {
  background: linear-gradient(180deg, #ff8d8d -190%, rgb(255, 255, 255) 90%) !important;
}
[data-bs-theme=light] .breaking-news a {
  color: #000;
}
[data-bs-theme=light] .breaking-news a p {
  background: rgba(0, 0, 0, 0.02);
}
[data-bs-theme=light] .map-info-container {
  background: rgba(255, 255, 255, 0.9) !important;
}
[data-bs-theme=light] .graphic-events .graphic-events-dropdown {
  background: white;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
}
[data-bs-theme=light] .file-progress-card {
  background: white;
}
[data-bs-theme=light] .popover-content {
  background: white;
}

[data-bs-theme=dark] .ck-reset_all :not(.ck-reset_all-excluded *),
[data-bs-theme=dark] .ck.ck-reset_all {
  color: #fff !important;
}

:root,
[data-bs-theme=light] {
  --bs-body-bg-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.99) 100%);
  --bs-body-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --bs-body-bg-image-size: 4.6875rem;
  --bs-body-font-weight: 400;
  --bs-body-letter-spacing: 0.046875rem;
  --bs-component-bg: #ffffff;
  --bs-component-bg-rgb: 255, 255, 255;
  --bs-component-color: black;
  --bs-component-color-rgb: 0, 0, 0;
  --bs-app-header-bg: #ffffff;
  --bs-app-header-brand-img: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --bs-app-header-link-color: #000000;
  --bs-app-header-link-color-rgb: 0, 0, 0;
  --bs-app-header-link-hover-color: #000000;
  --bs-app-header-scroll-box-shadow: ;
  --bs-app-sidebar-menu-header-color: rgba(var(--bs-inverse-rgb), 0.3);
  --bs-app-sidebar-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);
  --bs-app-sidebar-menu-link-hover-color: #000000;
  --bs-app-sidebar-menu-link-active-color: #000000;
  --bs-app-sidebar-mobile-bg: rgba(255, 255, 255, 0.98);
  --bs-app-top-nav-bg: #ffffff;
  --bs-app-top-nav-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);
  --bs-app-top-nav-menu-link-hover-color: #000000;
  --bs-app-top-nav-menu-link-active-color: #000000;
  --bs-app-top-nav-menu-submenu-bg: #ffffff;
  --bs-app-theme-panel-bg: rgba(255, 255, 255, 0.95);
  --bs-theme-bg-subtle: #d3ebe4;
  --bs-dark2: #dadada;
  --bs-dark3: #f2f2f2;
  --bs-dark4: #fefefe;
  --bs-dark5: #65656596;
}

[data-bs-theme=dark] {
  --bs-body-bg-gradient: linear-gradient(180deg, rgba(9, 56, 45, 0.9) 0%, rgb(0, 7, 23) 100%);
  --bs-body-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --bs-body-bg-image-size: 4.6875rem;
  --bs-body-font-weight: 300;
  --bs-body-letter-spacing: 0.046875rem;
  --bs-component-bg: #28292b;
  --bs-component-bg-rgb: 40, 41, 43;
  --bs-component-color: white;
  --bs-component-color-rgb: 255, 255, 255;
  --bs-app-header-bg: rgba(29, 40, 53, 0.5);
  --bs-app-header-brand-img: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  --bs-app-header-link-color: #ffffff;
  --bs-app-header-link-color-rgb: 255, 255, 255;
  --bs-app-header-link-hover-color: rgba(255, 255, 255, 0.5);
  --bs-app-header-scroll-box-shadow: ;
  --bs-app-sidebar-menu-header-color: rgba(var(--bs-inverse-rgb), 0.5);
  --bs-app-sidebar-menu-link-color: rgba(var(--bs-inverse-rgb), 0.8);
  --bs-app-sidebar-menu-link-hover-color: #ffffff;
  --bs-app-sidebar-menu-link-active-color: #ffffff;
  --bs-app-sidebar-mobile-bg: rgba(44, 56, 70, 0.98);
  --bs-app-top-nav-bg: rgba(29, 40, 53, 0.95);
  --bs-app-top-nav-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);
  --bs-app-top-nav-menu-link-hover-color: #ffffff;
  --bs-app-top-nav-menu-link-active-color: #ffffff;
  --bs-app-top-nav-menu-submenu-bg: rgba(29, 40, 53, 0.95);
  --bs-app-theme-panel-bg: rgba(68, 85, 94, 0.95);
  --bs-theme-bg-subtle: #071f18;
  --bs-dark2: #0f131f;
  --bs-dark3: #1d2835;
  --bs-dark4: #141b24;
  --bs-dark5: #141b2496;
}

html {
  height: 100%;
}
[data-bs-theme=light] .app {
  background: #eee;
}

[data-bs-theme=dark] .app {
  background: linear-gradient(180deg, var(--bs-theme) -190%, rgb(0, 7, 23) 90%);
}

body {
  background: none;
  font-weight: var(--bs-body-font-weight);
  letter-spacing: var(--bs-body-letter-spacing);
  position: relative;
  min-height: 100vh;
  z-index: 9999;
  overflow-x: hidden;
}
body:before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background-attachment: initial;
  background-color: transparent;
  background-size: var(--bs-body-bg-image-size);
  background-repeat: repeat;
  background-attachment: initial;
  z-index: -5;
}
strong {
  font-weight: bold;
}

.ck.ck-editor__top .ck-sticky-panel .ck-toolbar {
  background: var(--bs-dark4) !important;
  border-color: rgba(255, 255, 255, 0.25) !important;
}

.ck.ck-editor__main > .ck-editor__editable {
  background: rgba(255, 255, 255, 0) !important;
  min-height: 200px !important;
}

.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  border-color: rgba(255, 255, 255, 0.25) !important;
}

.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {
  border-color: #fff !important;
}

.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  color: #fff !important;
  background: var(--bs-theme) !important;
}

.ck.ck-button.ck-on:not(.ck-disabled):hover,
a.ck.ck-button.ck-on:not(.ck-disabled):hover {
  background: var(--bs-theme) !important;
}

.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--bs-theme) !important;
}

.ck.ck-dropdown__panel,
.ck.ck-list {
  background: var(--bs-dark4) !important;
}

.ck.ck-list__item .ck-button:hover:not(.ck-disabled) {
  background: var(--bs-theme) !important;
}

.ck.ck-list__item .ck-button.ck-on {
  background: #1f9b76 !important;
}

.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled) {
  background: var(--bs-theme) !important;
}

/* Helper Margin */
.m-1px {
  margin: 1px !important;
}

.m-2px {
  margin: 2px !important;
}

.m-3px {
  margin: 3px !important;
}

.m-4px {
  margin: 4px !important;
}

.m-5px {
  margin: 5px !important;
}

.m-6px {
  margin: 6px !important;
}

.m-7px {
  margin: 7px !important;
}

.m-8px {
  margin: 8px !important;
}

.m-9px {
  margin: 9px !important;
}

.m-10px {
  margin: 10px !important;
}

.m-5px {
  margin: 5px !important;
}

.m-10px {
  margin: 10px !important;
}

.m-15px {
  margin: 15px !important;
}

.m-20px {
  margin: 20px !important;
}

.m-25px {
  margin: 25px !important;
}

.m-30px {
  margin: 30px !important;
}

.m-35px {
  margin: 35px !important;
}

.m-40px {
  margin: 40px !important;
}

.m-45px {
  margin: 45px !important;
}

.m-50px {
  margin: 50px !important;
}

.mt-1px {
  margin-top: 1px !important;
}

.mt-2px {
  margin-top: 2px !important;
}

.mt-3px {
  margin-top: 3px !important;
}

.mt-4px {
  margin-top: 4px !important;
}

.mt-5px {
  margin-top: 5px !important;
}

.mt-6px {
  margin-top: 6px !important;
}

.mt-7px {
  margin-top: 7px !important;
}

.mt-8px {
  margin-top: 8px !important;
}

.mt-9px {
  margin-top: 9px !important;
}

.mt-10px {
  margin-top: 10px !important;
}

.mt-5px {
  margin-top: 5px !important;
}

.mt-10px {
  margin-top: 10px !important;
}

.mt-15px {
  margin-top: 15px !important;
}

.mt-20px {
  margin-top: 20px !important;
}

.mt-25px {
  margin-top: 25px !important;
}

.mt-30px {
  margin-top: 30px !important;
}

.mt-35px {
  margin-top: 35px !important;
}

.mt-40px {
  margin-top: 40px !important;
}

.mt-45px {
  margin-top: 45px !important;
}

.mt-50px {
  margin-top: 50px !important;
}

.me-1px {
  margin-right: 1px !important;
}

.me-2px {
  margin-right: 2px !important;
}

.me-3px {
  margin-right: 3px !important;
}

.me-4px {
  margin-right: 4px !important;
}

.me-5px {
  margin-right: 5px !important;
}

.me-6px {
  margin-right: 6px !important;
}

.me-7px {
  margin-right: 7px !important;
}

.me-8px {
  margin-right: 8px !important;
}

.me-9px {
  margin-right: 9px !important;
}

.me-10px {
  margin-right: 10px !important;
}

.me-5px {
  margin-right: 5px !important;
}

.me-10px {
  margin-right: 10px !important;
}

.me-15px {
  margin-right: 15px !important;
}

.me-20px {
  margin-right: 20px !important;
}

.me-25px {
  margin-right: 25px !important;
}

.me-30px {
  margin-right: 30px !important;
}

.me-35px {
  margin-right: 35px !important;
}

.me-40px {
  margin-right: 40px !important;
}

.me-45px {
  margin-right: 45px !important;
}

.me-50px {
  margin-right: 50px !important;
}

.mb-1px {
  margin-bottom: 1px !important;
}

.mb-2px {
  margin-bottom: 2px !important;
}

.mb-3px {
  margin-bottom: 3px !important;
}

.mb-4px {
  margin-bottom: 4px !important;
}

.mb-5px {
  margin-bottom: 5px !important;
}

.mb-6px {
  margin-bottom: 6px !important;
}

.mb-7px {
  margin-bottom: 7px !important;
}

.mb-8px {
  margin-bottom: 8px !important;
}

.mb-9px {
  margin-bottom: 9px !important;
}

.mb-10px {
  margin-bottom: 10px !important;
}

.mb-5px {
  margin-bottom: 5px !important;
}

.mb-10px {
  margin-bottom: 10px !important;
}

.mb-15px {
  margin-bottom: 15px !important;
}

.mb-20px {
  margin-bottom: 20px !important;
}

.mb-25px {
  margin-bottom: 25px !important;
}

.mb-30px {
  margin-bottom: 30px !important;
}

.mb-35px {
  margin-bottom: 35px !important;
}

.mb-40px {
  margin-bottom: 40px !important;
}

.mb-45px {
  margin-bottom: 45px !important;
}

.mb-50px {
  margin-bottom: 50px !important;
}

.ms-1px {
  margin-left: 1px !important;
}

.ms-2px {
  margin-left: 2px !important;
}

.ms-3px {
  margin-left: 3px !important;
}

.ms-4px {
  margin-left: 4px !important;
}

.ms-5px {
  margin-left: 5px !important;
}

.ms-6px {
  margin-left: 6px !important;
}

.ms-7px {
  margin-left: 7px !important;
}

.ms-8px {
  margin-left: 8px !important;
}

.ms-9px {
  margin-left: 9px !important;
}

.ms-10px {
  margin-left: 10px !important;
}

.ms-5px {
  margin-left: 5px !important;
}

.ms-10px {
  margin-left: 10px !important;
}

.ms-15px {
  margin-left: 15px !important;
}

.ms-20px {
  margin-left: 20px !important;
}

.ms-25px {
  margin-left: 25px !important;
}

.ms-30px {
  margin-left: 30px !important;
}

.ms-35px {
  margin-left: 35px !important;
}

.ms-40px {
  margin-left: 40px !important;
}

.ms-45px {
  margin-left: 45px !important;
}

.ms-50px {
  margin-left: 50px !important;
}

.mx-1px {
  margin-left: 1px !important;
  margin-right: 1px !important;
}

.mx-2px {
  margin-left: 2px !important;
  margin-right: 2px !important;
}

.mx-3px {
  margin-left: 3px !important;
  margin-right: 3px !important;
}

.mx-4px {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.mx-5px {
  margin-left: 5px !important;
  margin-right: 5px !important;
}

.mx-6px {
  margin-left: 6px !important;
  margin-right: 6px !important;
}

.mx-7px {
  margin-left: 7px !important;
  margin-right: 7px !important;
}

.mx-8px {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.mx-9px {
  margin-left: 9px !important;
  margin-right: 9px !important;
}

.mx-10px {
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.mx-5px {
  margin-left: 5px !important;
  margin-right: 5px !important;
}

.mx-10px {
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.mx-15px {
  margin-left: 15px !important;
  margin-right: 15px !important;
}

.mx-20px {
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.mx-25px {
  margin-left: 25px !important;
  margin-right: 25px !important;
}

.mx-30px {
  margin-left: 30px !important;
  margin-right: 30px !important;
}

.mx-35px {
  margin-left: 35px !important;
  margin-right: 35px !important;
}

.mx-40px {
  margin-left: 40px !important;
  margin-right: 40px !important;
}

.mx-45px {
  margin-left: 45px !important;
  margin-right: 45px !important;
}

.mx-50px {
  margin-left: 50px !important;
  margin-right: 50px !important;
}

.my-1px {
  margin-top: 1px !important;
  margin-bottom: 1px !important;
}

.my-2px {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.my-3px {
  margin-top: 3px !important;
  margin-bottom: 3px !important;
}

.my-4px {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.my-5px {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.my-6px {
  margin-top: 6px !important;
  margin-bottom: 6px !important;
}

.my-7px {
  margin-top: 7px !important;
  margin-bottom: 7px !important;
}

.my-8px {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.my-9px {
  margin-top: 9px !important;
  margin-bottom: 9px !important;
}

.my-10px {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.my-5px {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.my-10px {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.my-15px {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}

.my-20px {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.my-25px {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}

.my-30px {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}

.my-35px {
  margin-top: 35px !important;
  margin-bottom: 35px !important;
}

.my-40px {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.my-45px {
  margin-top: 45px !important;
  margin-bottom: 45px !important;
}

.my-50px {
  margin-top: 50px !important;
  margin-bottom: 50px !important;
}

/* Helper Padding */
.p-1px {
  padding: 1px !important;
}

.p-2px {
  padding: 2px !important;
}

.p-3px {
  padding: 3px !important;
}

.p-4px {
  padding: 4px !important;
}

.p-5px {
  padding: 5px !important;
}

.p-6px {
  padding: 6px !important;
}

.p-7px {
  padding: 7px !important;
}

.p-8px {
  padding: 8px !important;
}

.p-9px {
  padding: 9px !important;
}

.p-10px {
  padding: 10px !important;
}

.p-5px {
  padding: 5px !important;
}

.p-10px {
  padding: 10px !important;
}

.p-15px {
  padding: 15px !important;
}

.p-20px {
  padding: 20px !important;
}

.p-25px {
  padding: 25px !important;
}

.p-30px {
  padding: 30px !important;
}

.p-35px {
  padding: 35px !important;
}

.p-40px {
  padding: 40px !important;
}

.p-45px {
  padding: 45px !important;
}

.p-50px {
  padding: 50px !important;
}

.pt-1px {
  padding-top: 1px !important;
}

.pt-2px {
  padding-top: 2px !important;
}

.pt-3px {
  padding-top: 3px !important;
}

.pt-4px {
  padding-top: 4px !important;
}

.pt-5px {
  padding-top: 5px !important;
}

.pt-6px {
  padding-top: 6px !important;
}

.pt-7px {
  padding-top: 7px !important;
}

.pt-8px {
  padding-top: 8px !important;
}

.pt-9px {
  padding-top: 9px !important;
}

.pt-10px {
  padding-top: 10px !important;
}

.pt-5px {
  padding-top: 5px !important;
}

.pt-10px {
  padding-top: 10px !important;
}

.pt-15px {
  padding-top: 15px !important;
}

.pt-20px {
  padding-top: 20px !important;
}

.pt-25px {
  padding-top: 25px !important;
}

.pt-30px {
  padding-top: 30px !important;
}

.pt-35px {
  padding-top: 35px !important;
}

.pt-40px {
  padding-top: 40px !important;
}

.pt-45px {
  padding-top: 45px !important;
}

.pt-50px {
  padding-top: 50px !important;
}

.pe-1px {
  padding-right: 1px !important;
}

.pe-2px {
  padding-right: 2px !important;
}

.pe-3px {
  padding-right: 3px !important;
}

.pe-4px {
  padding-right: 4px !important;
}

.pe-5px {
  padding-right: 5px !important;
}

.pe-6px {
  padding-right: 6px !important;
}

.pe-7px {
  padding-right: 7px !important;
}

.pe-8px {
  padding-right: 8px !important;
}

.pe-9px {
  padding-right: 9px !important;
}

.pe-10px {
  padding-right: 10px !important;
}

.pe-5px {
  padding-right: 5px !important;
}

.pe-10px {
  padding-right: 10px !important;
}

.pe-15px {
  padding-right: 15px !important;
}

.pe-20px {
  padding-right: 20px !important;
}

.pe-25px {
  padding-right: 25px !important;
}

.pe-30px {
  padding-right: 30px !important;
}

.pe-35px {
  padding-right: 35px !important;
}

.pe-40px {
  padding-right: 40px !important;
}

.pe-45px {
  padding-right: 45px !important;
}

.pe-50px {
  padding-right: 50px !important;
}

.pb-1px {
  padding-bottom: 1px !important;
}

.pb-2px {
  padding-bottom: 2px !important;
}

.pb-3px {
  padding-bottom: 3px !important;
}

.pb-4px {
  padding-bottom: 4px !important;
}

.pb-5px {
  padding-bottom: 5px !important;
}

.pb-6px {
  padding-bottom: 6px !important;
}

.pb-7px {
  padding-bottom: 7px !important;
}

.pb-8px {
  padding-bottom: 8px !important;
}

.pb-9px {
  padding-bottom: 9px !important;
}

.pb-10px {
  padding-bottom: 10px !important;
}

.pb-5px {
  padding-bottom: 5px !important;
}

.pb-10px {
  padding-bottom: 10px !important;
}

.pb-15px {
  padding-bottom: 15px !important;
}

.pb-20px {
  padding-bottom: 20px !important;
}

.pb-25px {
  padding-bottom: 25px !important;
}

.pb-30px {
  padding-bottom: 30px !important;
}

.pb-35px {
  padding-bottom: 35px !important;
}

.pb-40px {
  padding-bottom: 40px !important;
}

.pb-45px {
  padding-bottom: 45px !important;
}

.pb-50px {
  padding-bottom: 50px !important;
}

.ps-1px {
  padding-left: 1px !important;
}

.ps-2px {
  padding-left: 2px !important;
}

.ps-3px {
  padding-left: 3px !important;
}

.ps-4px {
  padding-left: 4px !important;
}

.ps-5px {
  padding-left: 5px !important;
}

.ps-6px {
  padding-left: 6px !important;
}

.ps-7px {
  padding-left: 7px !important;
}

.ps-8px {
  padding-left: 8px !important;
}

.ps-9px {
  padding-left: 9px !important;
}

.ps-10px {
  padding-left: 10px !important;
}

.ps-5px {
  padding-left: 5px !important;
}

.ps-10px {
  padding-left: 10px !important;
}

.ps-15px {
  padding-left: 15px !important;
}

.ps-20px {
  padding-left: 20px !important;
}

.ps-25px {
  padding-left: 25px !important;
}

.ps-30px {
  padding-left: 30px !important;
}

.ps-35px {
  padding-left: 35px !important;
}

.ps-40px {
  padding-left: 40px !important;
}

.ps-45px {
  padding-left: 45px !important;
}

.ps-50px {
  padding-left: 50px !important;
}

.px-1px {
  padding-left: 1px !important;
  padding-right: 1px !important;
}

.px-2px {
  padding-left: 2px !important;
  padding-right: 2px !important;
}

.px-3px {
  padding-left: 3px !important;
  padding-right: 3px !important;
}

.px-4px {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.px-5px {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.px-6px {
  padding-left: 6px !important;
  padding-right: 6px !important;
}

.px-7px {
  padding-left: 7px !important;
  padding-right: 7px !important;
}

.px-8px {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.px-9px {
  padding-left: 9px !important;
  padding-right: 9px !important;
}

.px-10px {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.px-5px {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.px-10px {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.px-15px {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.px-20px {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.px-25px {
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.px-30px {
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.px-35px {
  padding-left: 35px !important;
  padding-right: 35px !important;
}

.px-40px {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.px-45px {
  padding-left: 45px !important;
  padding-right: 45px !important;
}

.px-50px {
  padding-left: 50px !important;
  padding-right: 50px !important;
}

.py-1px {
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}

.py-2px {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.py-3px {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.py-4px {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.py-5px {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.py-6px {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.py-7px {
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}

.py-8px {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.py-9px {
  padding-top: 9px !important;
  padding-bottom: 9px !important;
}

.py-10px {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.py-5px {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.py-10px {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.py-15px {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

.py-20px {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.py-25px {
  padding-top: 25px !important;
  padding-bottom: 25px !important;
}

.py-30px {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}

.py-35px {
  padding-top: 35px !important;
  padding-bottom: 35px !important;
}

.py-40px {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.py-45px {
  padding-top: 45px !important;
  padding-bottom: 45px !important;
}

.py-50px {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}

/* Helper Font */
.fs-0px {
  font-size: 0px !important;
}

.fs-1px {
  font-size: 1px !important;
}

.fs-2px {
  font-size: 2px !important;
}

.fs-3px {
  font-size: 3px !important;
}

.fs-4px {
  font-size: 4px !important;
}

.fs-5px {
  font-size: 5px !important;
}

.fs-6px {
  font-size: 6px !important;
}

.fs-7px {
  font-size: 7px !important;
}

.fs-8px {
  font-size: 8px !important;
}

.fs-9px {
  font-size: 9px !important;
}

.fs-10px {
  font-size: 10px !important;
}

.fs-11px {
  font-size: 11px !important;
}

.fs-12px {
  font-size: 12px !important;
}

.fs-13px {
  font-size: 13px !important;
}

.fs-14px {
  font-size: 14px !important;
}

.fs-15px {
  font-size: 15px !important;
}

.fs-16px {
  font-size: 16px !important;
}

.fs-17px {
  font-size: 17px !important;
}

.fs-18px {
  font-size: 18px !important;
}

.fs-19px {
  font-size: 19px !important;
}

.fs-20px {
  font-size: 20px !important;
}

.fs-21px {
  font-size: 21px !important;
}

.fs-22px {
  font-size: 22px !important;
}

.fs-23px {
  font-size: 23px !important;
}

.fs-24px {
  font-size: 24px !important;
}

.fs-25px {
  font-size: 25px !important;
}

.fs-26px {
  font-size: 26px !important;
}

.fs-27px {
  font-size: 27px !important;
}

.fs-28px {
  font-size: 28px !important;
}

.fs-29px {
  font-size: 29px !important;
}

.fs-30px {
  font-size: 30px !important;
}

.fs-31px {
  font-size: 31px !important;
}

.fs-32px {
  font-size: 32px !important;
}

.fs-33px {
  font-size: 33px !important;
}

.fs-34px {
  font-size: 34px !important;
}

.fs-35px {
  font-size: 35px !important;
}

.fs-36px {
  font-size: 36px !important;
}

.fs-37px {
  font-size: 37px !important;
}

.fs-38px {
  font-size: 38px !important;
}

.fs-39px {
  font-size: 39px !important;
}

.fs-40px {
  font-size: 40px !important;
}

.fs-41px {
  font-size: 41px !important;
}

.fs-42px {
  font-size: 42px !important;
}

.fs-43px {
  font-size: 43px !important;
}

.fs-44px {
  font-size: 44px !important;
}

.fs-45px {
  font-size: 45px !important;
}

.fs-46px {
  font-size: 46px !important;
}

.fs-47px {
  font-size: 47px !important;
}

.fs-48px {
  font-size: 48px !important;
}

.fs-49px {
  font-size: 49px !important;
}

.fs-50px {
  font-size: 50px !important;
}

.fs-51px {
  font-size: 51px !important;
}

.fs-52px {
  font-size: 52px !important;
}

.fs-53px {
  font-size: 53px !important;
}

.fs-54px {
  font-size: 54px !important;
}

.fs-55px {
  font-size: 55px !important;
}

.fs-56px {
  font-size: 56px !important;
}

.fs-57px {
  font-size: 57px !important;
}

.fs-58px {
  font-size: 58px !important;
}

.fs-59px {
  font-size: 59px !important;
}

.fs-60px {
  font-size: 60px !important;
}

.fs-61px {
  font-size: 61px !important;
}

.fs-62px {
  font-size: 62px !important;
}

.fs-63px {
  font-size: 63px !important;
}

.fs-64px {
  font-size: 64px !important;
}

.fs-65px {
  font-size: 65px !important;
}

.fs-66px {
  font-size: 66px !important;
}

.fs-67px {
  font-size: 67px !important;
}

.fs-68px {
  font-size: 68px !important;
}

.fs-69px {
  font-size: 69px !important;
}

.fs-70px {
  font-size: 70px !important;
}

.fs-71px {
  font-size: 71px !important;
}

.fs-72px {
  font-size: 72px !important;
}

.fs-73px {
  font-size: 73px !important;
}

.fs-74px {
  font-size: 74px !important;
}

.fs-75px {
  font-size: 75px !important;
}

.fs-76px {
  font-size: 76px !important;
}

.fs-77px {
  font-size: 77px !important;
}

.fs-78px {
  font-size: 78px !important;
}

.fs-79px {
  font-size: 79px !important;
}

.fs-80px {
  font-size: 80px !important;
}

.fw-100 {
  font-weight: 100 !important;
}

.fw-200 {
  font-weight: 200 !important;
}

.fw-300 {
  font-weight: 300 !important;
}

.fw-400 {
  font-weight: 400 !important;
}

.fw-500 {
  font-weight: 500 !important;
}

.fw-600 {
  font-weight: 600 !important;
}

.fw-700 {
  font-weight: 700 !important;
}

.fw-800 {
  font-weight: 800 !important;
}

/* Helper Position Direction */
.top-0 {
  top: 0 !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.start-0 {
  left: 0 !important;
}

.end-0 {
  right: 0 !important;
}

.top-auto {
  top: auto !important;
}

.bottom-auto {
  bottom: auto !important;
}

.start-auto {
  left: auto !important;
}

.end-auto {
  right: auto !important;
}

/* Helper Text */
.text-underline {
  text-decoration: underline !important;
}

.text-gradient {
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.line-height-1 {
  line-height: 1 !important;
}

/* Helper Size */
.w-5px {
  width: 5px !important;
}

.w-1px {
  width: 1px !important;
}

.w-10px {
  width: 10px !important;
}

.w-2px {
  width: 2px !important;
}

.w-15px {
  width: 15px !important;
}

.w-3px {
  width: 3px !important;
}

.w-20px {
  width: 20px !important;
}

.w-4px {
  width: 4px !important;
}

.w-25px {
  width: 25px !important;
}

.w-5px {
  width: 5px !important;
}

.w-30px {
  width: 30px !important;
}

.w-6px {
  width: 6px !important;
}

.w-35px {
  width: 35px !important;
}

.w-7px {
  width: 7px !important;
}

.w-40px {
  width: 40px !important;
}

.w-8px {
  width: 8px !important;
}

.w-45px {
  width: 45px !important;
}

.w-9px {
  width: 9px !important;
}

.w-50px {
  width: 50px !important;
}

.w-10px {
  width: 10px !important;
}

.w-55px {
  width: 55px !important;
}

.w-11px {
  width: 11px !important;
}

.w-60px {
  width: 60px !important;
}

.w-12px {
  width: 12px !important;
}

.w-65px {
  width: 65px !important;
}

.w-13px {
  width: 13px !important;
}

.w-70px {
  width: 70px !important;
}

.w-14px {
  width: 14px !important;
}

.w-75px {
  width: 75px !important;
}

.w-15px {
  width: 15px !important;
}

.w-80px {
  width: 80px !important;
}

.w-16px {
  width: 16px !important;
}

.w-85px {
  width: 85px !important;
}

.w-17px {
  width: 17px !important;
}

.w-90px {
  width: 90px !important;
}

.w-18px {
  width: 18px !important;
}

.w-95px {
  width: 95px !important;
}

.w-19px {
  width: 19px !important;
}

.w-100px {
  width: 100px !important;
}

.w-20px {
  width: 20px !important;
}

.w-105px {
  width: 105px !important;
}

.w-21px {
  width: 21px !important;
}

.w-110px {
  width: 110px !important;
}

.w-22px {
  width: 22px !important;
}

.w-115px {
  width: 115px !important;
}

.w-23px {
  width: 23px !important;
}

.w-120px {
  width: 120px !important;
}

.w-24px {
  width: 24px !important;
}

.w-125px {
  width: 125px !important;
}

.w-25px {
  width: 25px !important;
}

.w-130px {
  width: 130px !important;
}

.w-26px {
  width: 26px !important;
}

.w-135px {
  width: 135px !important;
}

.w-27px {
  width: 27px !important;
}

.w-140px {
  width: 140px !important;
}

.w-28px {
  width: 28px !important;
}

.w-145px {
  width: 145px !important;
}

.w-29px {
  width: 29px !important;
}

.w-150px {
  width: 150px !important;
}

.w-30px {
  width: 30px !important;
}

.w-155px {
  width: 155px !important;
}

.w-31px {
  width: 31px !important;
}

.w-160px {
  width: 160px !important;
}

.w-32px {
  width: 32px !important;
}

.w-165px {
  width: 165px !important;
}

.w-33px {
  width: 33px !important;
}

.w-170px {
  width: 170px !important;
}

.w-34px {
  width: 34px !important;
}

.w-175px {
  width: 175px !important;
}

.w-35px {
  width: 35px !important;
}

.w-180px {
  width: 180px !important;
}

.w-36px {
  width: 36px !important;
}

.w-185px {
  width: 185px !important;
}

.w-37px {
  width: 37px !important;
}

.w-190px {
  width: 190px !important;
}

.w-38px {
  width: 38px !important;
}

.w-195px {
  width: 195px !important;
}

.w-39px {
  width: 39px !important;
}

.w-200px {
  width: 200px !important;
}

.w-40px {
  width: 40px !important;
}

.w-250px {
  width: 250px !important;
}

.w-300px {
  width: 300px !important;
}

.w-350px {
  width: 350px !important;
}

.w-400px {
  width: 400px !important;
}

.w-450px {
  width: 450px !important;
}

.w-500px {
  width: 500px !important;
}

.w-550px {
  width: 550px !important;
}

.w-600px {
  width: 600px !important;
}

.h-5px {
  height: 5px !important;
}

.h-1px {
  height: 1px !important;
}

.h-10px {
  height: 10px !important;
}

.h-2px {
  height: 2px !important;
}

.h-15px {
  height: 15px !important;
}

.h-3px {
  height: 3px !important;
}

.h-20px {
  height: 20px !important;
}

.h-4px {
  height: 4px !important;
}

.h-25px {
  height: 25px !important;
}

.h-5px {
  height: 5px !important;
}

.h-30px {
  height: 30px !important;
}

.h-6px {
  height: 6px !important;
}

.h-35px {
  height: 35px !important;
}

.h-7px {
  height: 7px !important;
}

.h-40px {
  height: 40px !important;
}

.h-8px {
  height: 8px !important;
}

.h-45px {
  height: 45px !important;
}

.h-9px {
  height: 9px !important;
}

.h-50px {
  height: 50px !important;
}

.h-10px {
  height: 10px !important;
}

.h-55px {
  height: 55px !important;
}

.h-11px {
  height: 11px !important;
}

.h-60px {
  height: 60px !important;
}

.h-12px {
  height: 12px !important;
}

.h-65px {
  height: 65px !important;
}

.h-13px {
  height: 13px !important;
}

.h-70px {
  height: 70px !important;
}

.h-14px {
  height: 14px !important;
}

.h-75px {
  height: 75px !important;
}

.h-15px {
  height: 15px !important;
}

.h-80px {
  height: 80px !important;
}

.h-16px {
  height: 16px !important;
}

.h-85px {
  height: 85px !important;
}

.h-17px {
  height: 17px !important;
}

.h-90px {
  height: 90px !important;
}

.h-18px {
  height: 18px !important;
}

.h-95px {
  height: 95px !important;
}

.h-19px {
  height: 19px !important;
}

.h-100px {
  height: 100px !important;
}

.h-20px {
  height: 20px !important;
}

.h-105px {
  height: 105px !important;
}

.h-21px {
  height: 21px !important;
}

.h-110px {
  height: 110px !important;
}

.h-22px {
  height: 22px !important;
}

.h-115px {
  height: 115px !important;
}

.h-23px {
  height: 23px !important;
}

.h-120px {
  height: 120px !important;
}

.h-24px {
  height: 24px !important;
}

.h-125px {
  height: 125px !important;
}

.h-25px {
  height: 25px !important;
}

.h-130px {
  height: 130px !important;
}

.h-26px {
  height: 26px !important;
}

.h-135px {
  height: 135px !important;
}

.h-27px {
  height: 27px !important;
}

.h-140px {
  height: 140px !important;
}

.h-28px {
  height: 28px !important;
}

.h-145px {
  height: 145px !important;
}

.h-29px {
  height: 29px !important;
}

.h-150px {
  height: 150px !important;
}

.h-30px {
  height: 30px !important;
}

.h-155px {
  height: 155px !important;
}

.h-31px {
  height: 31px !important;
}

.h-160px {
  height: 160px !important;
}

.h-32px {
  height: 32px !important;
}

.h-165px {
  height: 165px !important;
}

.h-33px {
  height: 33px !important;
}

.h-170px {
  height: 170px !important;
}

.h-34px {
  height: 34px !important;
}

.h-175px {
  height: 175px !important;
}

.h-35px {
  height: 35px !important;
}

.h-180px {
  height: 180px !important;
}

.h-36px {
  height: 36px !important;
}

.h-185px {
  height: 185px !important;
}

.h-37px {
  height: 37px !important;
}

.h-190px {
  height: 190px !important;
}

.h-38px {
  height: 38px !important;
}

.h-195px {
  height: 195px !important;
}

.h-39px {
  height: 39px !important;
}

.h-200px {
  height: 200px !important;
}

.h-40px {
  height: 40px !important;
}

.h-250px {
  height: 250px !important;
}

.h-300px {
  height: 300px !important;
}

.h-350px {
  height: 350px !important;
}

.h-400px {
  height: 400px !important;
}

.h-450px {
  height: 450px !important;
}

.h-500px {
  height: 500px !important;
}

.h-550px {
  height: 550px !important;
}

.h-600px {
  height: 600px !important;
}

/* Helper Color */
.bg-gradient-default {
  background-color: #798e98 !important;
  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-default {
  --bs-theme: #798e98 !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-default-100 {
  --bs-text-opacity: 1;
  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;
}

.bg-default-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;
}

.text-default-600 {
  --bs-text-opacity: 1;
  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;
}

.bg-default-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;
}

.text-default-200 {
  --bs-text-opacity: 1;
  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;
}

.bg-default-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;
}

.text-default-700 {
  --bs-text-opacity: 1;
  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;
}

.bg-default-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;
}

.text-default-300 {
  --bs-text-opacity: 1;
  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;
}

.bg-default-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;
}

.text-default-800 {
  --bs-text-opacity: 1;
  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;
}

.bg-default-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;
}

.text-default-400 {
  --bs-text-opacity: 1;
  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;
}

.bg-default-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;
}

.text-default-900 {
  --bs-text-opacity: 1;
  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;
}

.bg-default-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;
}

.bg-gradient-theme {
  background-color: #249d79 !important;
  background-image: linear-gradient(to bottom, #2ec699, #1f8869) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

.border-theme {
  border-color: var(--bs-theme) !important;
}

:root .theme-theme {
  --bs-theme: #249d79 !important;
  --bs-theme-rgb: 36, 157, 121 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-theme-100 {
  --bs-text-opacity: 1;
  color: rgba(211, 235, 228, var(--bs-text-opacity)) !important;
}

.bg-theme-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211, 235, 228, var(--bs-bg-opacity)) !important;
}

.text-theme-600 {
  --bs-text-opacity: 1;
  color: rgba(29, 126, 97, var(--bs-text-opacity)) !important;
}

.bg-theme-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(29, 126, 97, var(--bs-bg-opacity)) !important;
}

.text-theme-200 {
  --bs-text-opacity: 1;
  color: rgba(167, 216, 201, var(--bs-text-opacity)) !important;
}

.bg-theme-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(167, 216, 201, var(--bs-bg-opacity)) !important;
}

.text-theme-700 {
  --bs-text-opacity: 1;
  color: rgba(22, 94, 73, var(--bs-text-opacity)) !important;
}

.bg-theme-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(22, 94, 73, var(--bs-bg-opacity)) !important;
}

.text-theme-300 {
  --bs-text-opacity: 1;
  color: rgba(124, 196, 175, var(--bs-text-opacity)) !important;
}

.bg-theme-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(124, 196, 175, var(--bs-bg-opacity)) !important;
}

.text-theme-800 {
  --bs-text-opacity: 1;
  color: rgba(14, 63, 48, var(--bs-text-opacity)) !important;
}

.bg-theme-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(14, 63, 48, var(--bs-bg-opacity)) !important;
}

.text-theme-400 {
  --bs-text-opacity: 1;
  color: rgba(80, 177, 148, var(--bs-text-opacity)) !important;
}

.bg-theme-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(80, 177, 148, var(--bs-bg-opacity)) !important;
}

.text-theme-900 {
  --bs-text-opacity: 1;
  color: rgba(7, 31, 24, var(--bs-text-opacity)) !important;
}

.bg-theme-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7, 31, 24, var(--bs-bg-opacity)) !important;
}

.bg-gradient-theme-color {
  background-color: #ffffff !important;
  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-theme-color {
  --bs-theme: #ffffff !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-theme-color-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-theme-color-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-theme-color-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-theme-color-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-theme-color-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-theme-color-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-theme-color-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-theme-color-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-theme-color-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-theme-color-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-theme-color-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-theme-color-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-theme-color-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-theme-color-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-theme-color-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-theme-color-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-primary {
  background-color: #0271ff !important;
  background-image: linear-gradient(to bottom, #358eff, #0066e8) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-primary {
  --bs-theme: #0271ff !important;
  --bs-theme-rgb: 2, 113, 255 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-primary-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 227, 255, var(--bs-text-opacity)) !important;
}

.bg-primary-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 227, 255, var(--bs-bg-opacity)) !important;
}

.text-primary-600 {
  --bs-text-opacity: 1;
  color: rgba(2, 90, 204, var(--bs-text-opacity)) !important;
}

.bg-primary-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(2, 90, 204, var(--bs-bg-opacity)) !important;
}

.text-primary-200 {
  --bs-text-opacity: 1;
  color: rgba(154, 198, 255, var(--bs-text-opacity)) !important;
}

.bg-primary-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(154, 198, 255, var(--bs-bg-opacity)) !important;
}

.text-primary-700 {
  --bs-text-opacity: 1;
  color: rgba(1, 68, 153, var(--bs-text-opacity)) !important;
}

.bg-primary-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(1, 68, 153, var(--bs-bg-opacity)) !important;
}

.text-primary-300 {
  --bs-text-opacity: 1;
  color: rgba(103, 170, 255, var(--bs-text-opacity)) !important;
}

.bg-primary-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(103, 170, 255, var(--bs-bg-opacity)) !important;
}

.text-primary-800 {
  --bs-text-opacity: 1;
  color: rgba(1, 45, 102, var(--bs-text-opacity)) !important;
}

.bg-primary-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(1, 45, 102, var(--bs-bg-opacity)) !important;
}

.text-primary-400 {
  --bs-text-opacity: 1;
  color: rgba(53, 141, 255, var(--bs-text-opacity)) !important;
}

.bg-primary-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(53, 141, 255, var(--bs-bg-opacity)) !important;
}

.text-primary-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 23, 51, var(--bs-text-opacity)) !important;
}

.bg-primary-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 23, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-secondary {
  background-color: #798e98 !important;
  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-secondary {
  --bs-theme: #798e98 !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-secondary-100 {
  --bs-text-opacity: 1;
  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;
}

.bg-secondary-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;
}

.text-secondary-600 {
  --bs-text-opacity: 1;
  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;
}

.bg-secondary-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;
}

.text-secondary-200 {
  --bs-text-opacity: 1;
  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;
}

.bg-secondary-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;
}

.text-secondary-700 {
  --bs-text-opacity: 1;
  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;
}

.bg-secondary-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;
}

.text-secondary-300 {
  --bs-text-opacity: 1;
  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;
}

.bg-secondary-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;
}

.text-secondary-800 {
  --bs-text-opacity: 1;
  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;
}

.bg-secondary-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;
}

.text-secondary-400 {
  --bs-text-opacity: 1;
  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;
}

.bg-secondary-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;
}

.text-secondary-900 {
  --bs-text-opacity: 1;
  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;
}

.bg-secondary-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;
}

.bg-gradient-warning {
  background-color: #ff9f0c !important;
  background-image: linear-gradient(to bottom, #ffb33f, #f29200) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-warning {
  --bs-theme: #ff9f0c !important;
  --bs-theme-rgb: 255, 159, 12 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-warning-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 236, 206, var(--bs-text-opacity)) !important;
}

.bg-warning-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 236, 206, var(--bs-bg-opacity)) !important;
}

.text-warning-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 127, 10, var(--bs-text-opacity)) !important;
}

.bg-warning-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 127, 10, var(--bs-bg-opacity)) !important;
}

.text-warning-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 217, 158, var(--bs-text-opacity)) !important;
}

.bg-warning-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 217, 158, var(--bs-bg-opacity)) !important;
}

.text-warning-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 95, 7, var(--bs-text-opacity)) !important;
}

.bg-warning-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 95, 7, var(--bs-bg-opacity)) !important;
}

.text-warning-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 197, 109, var(--bs-text-opacity)) !important;
}

.bg-warning-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 197, 109, var(--bs-bg-opacity)) !important;
}

.text-warning-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 64, 5, var(--bs-text-opacity)) !important;
}

.bg-warning-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 64, 5, var(--bs-bg-opacity)) !important;
}

.text-warning-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 178, 61, var(--bs-text-opacity)) !important;
}

.bg-warning-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 178, 61, var(--bs-bg-opacity)) !important;
}

.text-warning-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 32, 2, var(--bs-text-opacity)) !important;
}

.bg-warning-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 32, 2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-danger {
  background-color: #e00000 !important;
  background-image: linear-gradient(to bottom, #ff1414, #c70000) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-danger {
  --bs-theme: #e00000 !important;
  --bs-theme-rgb: 224, 0, 0 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-danger-100 {
  --bs-text-opacity: 1;
  color: rgba(249, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-danger-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(249, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-danger-600 {
  --bs-text-opacity: 1;
  color: rgba(179, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-danger-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-danger-200 {
  --bs-text-opacity: 1;
  color: rgba(243, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-danger-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(243, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-danger-700 {
  --bs-text-opacity: 1;
  color: rgba(134, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-danger-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-danger-300 {
  --bs-text-opacity: 1;
  color: rgba(236, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-danger-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(236, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-danger-800 {
  --bs-text-opacity: 1;
  color: rgba(90, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-danger-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(90, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-danger-400 {
  --bs-text-opacity: 1;
  color: rgba(230, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-danger-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(230, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-danger-900 {
  --bs-text-opacity: 1;
  color: rgba(45, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-danger-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(45, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-success {
  background-color: #249d79 !important;
  background-image: linear-gradient(to bottom, #2ec699, #1f8869) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-success {
  --bs-theme: #249d79 !important;
  --bs-theme-rgb: 36, 157, 121 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-success-100 {
  --bs-text-opacity: 1;
  color: rgba(211, 235, 228, var(--bs-text-opacity)) !important;
}

.bg-success-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211, 235, 228, var(--bs-bg-opacity)) !important;
}

.text-success-600 {
  --bs-text-opacity: 1;
  color: rgba(29, 126, 97, var(--bs-text-opacity)) !important;
}

.bg-success-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(29, 126, 97, var(--bs-bg-opacity)) !important;
}

.text-success-200 {
  --bs-text-opacity: 1;
  color: rgba(167, 216, 201, var(--bs-text-opacity)) !important;
}

.bg-success-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(167, 216, 201, var(--bs-bg-opacity)) !important;
}

.text-success-700 {
  --bs-text-opacity: 1;
  color: rgba(22, 94, 73, var(--bs-text-opacity)) !important;
}

.bg-success-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(22, 94, 73, var(--bs-bg-opacity)) !important;
}

.text-success-300 {
  --bs-text-opacity: 1;
  color: rgba(124, 196, 175, var(--bs-text-opacity)) !important;
}

.bg-success-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(124, 196, 175, var(--bs-bg-opacity)) !important;
}

.text-success-800 {
  --bs-text-opacity: 1;
  color: rgba(14, 63, 48, var(--bs-text-opacity)) !important;
}

.bg-success-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(14, 63, 48, var(--bs-bg-opacity)) !important;
}

.text-success-400 {
  --bs-text-opacity: 1;
  color: rgba(80, 177, 148, var(--bs-text-opacity)) !important;
}

.bg-success-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(80, 177, 148, var(--bs-bg-opacity)) !important;
}

.text-success-900 {
  --bs-text-opacity: 1;
  color: rgba(7, 31, 24, var(--bs-text-opacity)) !important;
}

.bg-success-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7, 31, 24, var(--bs-bg-opacity)) !important;
}

.bg-gradient-inverse {
  background-color: #000000 !important;
  background-image: linear-gradient(to bottom, #1a1a1a, black) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-inverse {
  --bs-theme: #000000 !important;
  --bs-theme-rgb: 0, 0, 0 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-inverse-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-inverse-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-inverse-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-inverse-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-inverse-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-inverse-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-inverse-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-inverse-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-inverse-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-inverse-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-inverse-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-inverse-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-inverse-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-inverse-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-inverse-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-inverse-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-info {
  background-color: #009be3 !important;
  background-image: linear-gradient(to bottom, #17b5ff, #008aca) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-info {
  --bs-theme: #009be3 !important;
  --bs-theme-rgb: 0, 155, 227 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-info-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 235, 249, var(--bs-text-opacity)) !important;
}

.bg-info-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 235, 249, var(--bs-bg-opacity)) !important;
}

.text-info-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 124, 182, var(--bs-text-opacity)) !important;
}

.bg-info-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 124, 182, var(--bs-bg-opacity)) !important;
}

.text-info-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 215, 244, var(--bs-text-opacity)) !important;
}

.bg-info-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 215, 244, var(--bs-bg-opacity)) !important;
}

.text-info-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 93, 136, var(--bs-text-opacity)) !important;
}

.bg-info-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 93, 136, var(--bs-bg-opacity)) !important;
}

.text-info-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 195, 238, var(--bs-text-opacity)) !important;
}

.bg-info-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 195, 238, var(--bs-bg-opacity)) !important;
}

.text-info-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 62, 91, var(--bs-text-opacity)) !important;
}

.bg-info-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 62, 91, var(--bs-bg-opacity)) !important;
}

.text-info-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 175, 233, var(--bs-text-opacity)) !important;
}

.bg-info-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 175, 233, var(--bs-bg-opacity)) !important;
}

.text-info-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 31, 45, var(--bs-text-opacity)) !important;
}

.bg-info-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 31, 45, var(--bs-bg-opacity)) !important;
}

.bg-gradient-dark {
  background-color: #35434a !important;
  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-dark {
  --bs-theme: #35434a !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-dark-100 {
  --bs-text-opacity: 1;
  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;
}

.bg-dark-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;
}

.text-dark-600 {
  --bs-text-opacity: 1;
  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;
}

.bg-dark-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;
}

.text-dark-200 {
  --bs-text-opacity: 1;
  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;
}

.bg-dark-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;
}

.text-dark-700 {
  --bs-text-opacity: 1;
  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;
}

.bg-dark-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;
}

.text-dark-300 {
  --bs-text-opacity: 1;
  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;
}

.bg-dark-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;
}

.text-dark-800 {
  --bs-text-opacity: 1;
  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;
}

.bg-dark-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;
}

.text-dark-400 {
  --bs-text-opacity: 1;
  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;
}

.bg-dark-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;
}

.text-dark-900 {
  --bs-text-opacity: 1;
  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;
}

.bg-dark-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;
}

.bg-gradient-black {
  background-color: #000000 !important;
  background-image: linear-gradient(to bottom, #1a1a1a, black) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-black {
  --bs-theme: #000000 !important;
  --bs-theme-rgb: 0, 0, 0 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-black-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-black-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-black-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-black-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-black-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-black-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-black-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-black-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-black-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-white {
  background-color: #ffffff !important;
  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-white {
  --bs-theme: #ffffff !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-white-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-white-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-white-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-white-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-white-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-white-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-white-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-white-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-purple {
  background-color: #b90dff !important;
  background-image: linear-gradient(to bottom, #c840ff, #ac00f3) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-purple {
  --bs-theme: #b90dff !important;
  --bs-theme-rgb: 185, 13, 255 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-purple-100 {
  --bs-text-opacity: 1;
  color: rgba(241, 207, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(241, 207, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-600 {
  --bs-text-opacity: 1;
  color: rgba(148, 10, 204, var(--bs-text-opacity)) !important;
}

.bg-purple-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(148, 10, 204, var(--bs-bg-opacity)) !important;
}

.text-purple-200 {
  --bs-text-opacity: 1;
  color: rgba(227, 158, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(227, 158, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-700 {
  --bs-text-opacity: 1;
  color: rgba(111, 8, 153, var(--bs-text-opacity)) !important;
}

.bg-purple-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(111, 8, 153, var(--bs-bg-opacity)) !important;
}

.text-purple-300 {
  --bs-text-opacity: 1;
  color: rgba(213, 110, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(213, 110, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-800 {
  --bs-text-opacity: 1;
  color: rgba(74, 5, 102, var(--bs-text-opacity)) !important;
}

.bg-purple-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(74, 5, 102, var(--bs-bg-opacity)) !important;
}

.text-purple-400 {
  --bs-text-opacity: 1;
  color: rgba(199, 61, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(199, 61, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-900 {
  --bs-text-opacity: 1;
  color: rgba(37, 3, 51, var(--bs-text-opacity)) !important;
}

.bg-purple-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(37, 3, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-indigo {
  background-color: #5c25ff !important;
  background-image: linear-gradient(to bottom, #8258ff, #490cff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-indigo {
  --bs-theme: #5c25ff !important;
  --bs-theme-rgb: 92, 37, 255 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-indigo-100 {
  --bs-text-opacity: 1;
  color: rgba(222, 211, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(222, 211, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-600 {
  --bs-text-opacity: 1;
  color: rgba(74, 30, 204, var(--bs-text-opacity)) !important;
}

.bg-indigo-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(74, 30, 204, var(--bs-bg-opacity)) !important;
}

.text-indigo-200 {
  --bs-text-opacity: 1;
  color: rgba(190, 168, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(190, 168, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-700 {
  --bs-text-opacity: 1;
  color: rgba(55, 22, 153, var(--bs-text-opacity)) !important;
}

.bg-indigo-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(55, 22, 153, var(--bs-bg-opacity)) !important;
}

.text-indigo-300 {
  --bs-text-opacity: 1;
  color: rgba(157, 124, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(157, 124, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-800 {
  --bs-text-opacity: 1;
  color: rgba(37, 15, 102, var(--bs-text-opacity)) !important;
}

.bg-indigo-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(37, 15, 102, var(--bs-bg-opacity)) !important;
}

.text-indigo-400 {
  --bs-text-opacity: 1;
  color: rgba(125, 81, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(125, 81, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-900 {
  --bs-text-opacity: 1;
  color: rgba(18, 7, 51, var(--bs-text-opacity)) !important;
}

.bg-indigo-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(18, 7, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-red {
  background-color: #e00000 !important;
  background-image: linear-gradient(to bottom, #ff1414, #c70000) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-red {
  --bs-theme: #e00000 !important;
  --bs-theme-rgb: 224, 0, 0 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-red-100 {
  --bs-text-opacity: 1;
  color: rgba(249, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-red-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(249, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-red-600 {
  --bs-text-opacity: 1;
  color: rgba(179, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-200 {
  --bs-text-opacity: 1;
  color: rgba(243, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-red-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(243, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-red-700 {
  --bs-text-opacity: 1;
  color: rgba(134, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-300 {
  --bs-text-opacity: 1;
  color: rgba(236, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-red-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(236, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-red-800 {
  --bs-text-opacity: 1;
  color: rgba(90, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(90, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-400 {
  --bs-text-opacity: 1;
  color: rgba(230, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-red-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(230, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-red-900 {
  --bs-text-opacity: 1;
  color: rgba(45, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(45, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-pink {
  background-color: #e61079 !important;
  background-image: linear-gradient(to bottom, #f13893, #ce0e6c) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-pink {
  --bs-theme: #e61079 !important;
  --bs-theme-rgb: 230, 16, 121 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-pink-100 {
  --bs-text-opacity: 1;
  color: rgba(250, 207, 228, var(--bs-text-opacity)) !important;
}

.bg-pink-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 207, 228, var(--bs-bg-opacity)) !important;
}

.text-pink-600 {
  --bs-text-opacity: 1;
  color: rgba(184, 13, 97, var(--bs-text-opacity)) !important;
}

.bg-pink-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(184, 13, 97, var(--bs-bg-opacity)) !important;
}

.text-pink-200 {
  --bs-text-opacity: 1;
  color: rgba(245, 159, 201, var(--bs-text-opacity)) !important;
}

.bg-pink-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(245, 159, 201, var(--bs-bg-opacity)) !important;
}

.text-pink-700 {
  --bs-text-opacity: 1;
  color: rgba(138, 10, 73, var(--bs-text-opacity)) !important;
}

.bg-pink-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 10, 73, var(--bs-bg-opacity)) !important;
}

.text-pink-300 {
  --bs-text-opacity: 1;
  color: rgba(240, 112, 175, var(--bs-text-opacity)) !important;
}

.bg-pink-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(240, 112, 175, var(--bs-bg-opacity)) !important;
}

.text-pink-800 {
  --bs-text-opacity: 1;
  color: rgba(92, 6, 48, var(--bs-text-opacity)) !important;
}

.bg-pink-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(92, 6, 48, var(--bs-bg-opacity)) !important;
}

.text-pink-400 {
  --bs-text-opacity: 1;
  color: rgba(235, 64, 148, var(--bs-text-opacity)) !important;
}

.bg-pink-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(235, 64, 148, var(--bs-bg-opacity)) !important;
}

.text-pink-900 {
  --bs-text-opacity: 1;
  color: rgba(46, 3, 24, var(--bs-text-opacity)) !important;
}

.bg-pink-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(46, 3, 24, var(--bs-bg-opacity)) !important;
}

.bg-gradient-green {
  background-color: #148922 !important;
  background-image: linear-gradient(to bottom, #1ab62d, #11731c) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-green {
  --bs-theme: #148922 !important;
  --bs-theme-rgb: 20, 137, 34 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-green-100 {
  --bs-text-opacity: 1;
  color: rgba(208, 231, 211, var(--bs-text-opacity)) !important;
}

.bg-green-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(208, 231, 211, var(--bs-bg-opacity)) !important;
}

.text-green-600 {
  --bs-text-opacity: 1;
  color: rgba(16, 110, 27, var(--bs-text-opacity)) !important;
}

.bg-green-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 110, 27, var(--bs-bg-opacity)) !important;
}

.text-green-200 {
  --bs-text-opacity: 1;
  color: rgba(161, 208, 167, var(--bs-text-opacity)) !important;
}

.bg-green-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(161, 208, 167, var(--bs-bg-opacity)) !important;
}

.text-green-700 {
  --bs-text-opacity: 1;
  color: rgba(12, 82, 20, var(--bs-text-opacity)) !important;
}

.bg-green-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 82, 20, var(--bs-bg-opacity)) !important;
}

.text-green-300 {
  --bs-text-opacity: 1;
  color: rgba(114, 184, 122, var(--bs-text-opacity)) !important;
}

.bg-green-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(114, 184, 122, var(--bs-bg-opacity)) !important;
}

.text-green-800 {
  --bs-text-opacity: 1;
  color: rgba(8, 55, 14, var(--bs-text-opacity)) !important;
}

.bg-green-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(8, 55, 14, var(--bs-bg-opacity)) !important;
}

.text-green-400 {
  --bs-text-opacity: 1;
  color: rgba(67, 161, 78, var(--bs-text-opacity)) !important;
}

.bg-green-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(67, 161, 78, var(--bs-bg-opacity)) !important;
}

.text-green-900 {
  --bs-text-opacity: 1;
  color: rgba(4, 27, 7, var(--bs-text-opacity)) !important;
}

.bg-green-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(4, 27, 7, var(--bs-bg-opacity)) !important;
}

.bg-gradient-yellow {
  background-color: #f9e80d !important;
  background-image: linear-gradient(to bottom, #faed3f, #e7d706) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-yellow {
  --bs-theme: #f9e80d !important;
  --bs-theme-rgb: 249, 232, 13 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-yellow-100 {
  --bs-text-opacity: 1;
  color: rgba(254, 250, 207, var(--bs-text-opacity)) !important;
}

.bg-yellow-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(254, 250, 207, var(--bs-bg-opacity)) !important;
}

.text-yellow-600 {
  --bs-text-opacity: 1;
  color: rgba(199, 186, 10, var(--bs-text-opacity)) !important;
}

.bg-yellow-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(199, 186, 10, var(--bs-bg-opacity)) !important;
}

.text-yellow-200 {
  --bs-text-opacity: 1;
  color: rgba(253, 246, 158, var(--bs-text-opacity)) !important;
}

.bg-yellow-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(253, 246, 158, var(--bs-bg-opacity)) !important;
}

.text-yellow-700 {
  --bs-text-opacity: 1;
  color: rgba(149, 139, 8, var(--bs-text-opacity)) !important;
}

.bg-yellow-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(149, 139, 8, var(--bs-bg-opacity)) !important;
}

.text-yellow-300 {
  --bs-text-opacity: 1;
  color: rgba(251, 241, 110, var(--bs-text-opacity)) !important;
}

.bg-yellow-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(251, 241, 110, var(--bs-bg-opacity)) !important;
}

.text-yellow-800 {
  --bs-text-opacity: 1;
  color: rgba(100, 93, 5, var(--bs-text-opacity)) !important;
}

.bg-yellow-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(100, 93, 5, var(--bs-bg-opacity)) !important;
}

.text-yellow-400 {
  --bs-text-opacity: 1;
  color: rgba(250, 237, 61, var(--bs-text-opacity)) !important;
}

.bg-yellow-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 237, 61, var(--bs-bg-opacity)) !important;
}

.text-yellow-900 {
  --bs-text-opacity: 1;
  color: rgba(50, 46, 3, var(--bs-text-opacity)) !important;
}

.bg-yellow-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(50, 46, 3, var(--bs-bg-opacity)) !important;
}

.bg-gradient-teal {
  background-color: #249d79 !important;
  background-image: linear-gradient(to bottom, #2ec699, #1f8869) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-teal {
  --bs-theme: #249d79 !important;
  --bs-theme-rgb: 36, 157, 121 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-teal-100 {
  --bs-text-opacity: 1;
  color: rgba(211, 235, 228, var(--bs-text-opacity)) !important;
}

.bg-teal-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211, 235, 228, var(--bs-bg-opacity)) !important;
}

.text-teal-600 {
  --bs-text-opacity: 1;
  color: rgba(29, 126, 97, var(--bs-text-opacity)) !important;
}

.bg-teal-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(29, 126, 97, var(--bs-bg-opacity)) !important;
}

.text-teal-200 {
  --bs-text-opacity: 1;
  color: rgba(167, 216, 201, var(--bs-text-opacity)) !important;
}

.bg-teal-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(167, 216, 201, var(--bs-bg-opacity)) !important;
}

.text-teal-700 {
  --bs-text-opacity: 1;
  color: rgba(22, 94, 73, var(--bs-text-opacity)) !important;
}

.bg-teal-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(22, 94, 73, var(--bs-bg-opacity)) !important;
}

.text-teal-300 {
  --bs-text-opacity: 1;
  color: rgba(124, 196, 175, var(--bs-text-opacity)) !important;
}

.bg-teal-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(124, 196, 175, var(--bs-bg-opacity)) !important;
}

.text-teal-800 {
  --bs-text-opacity: 1;
  color: rgba(14, 63, 48, var(--bs-text-opacity)) !important;
}

.bg-teal-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(14, 63, 48, var(--bs-bg-opacity)) !important;
}

.text-teal-400 {
  --bs-text-opacity: 1;
  color: rgba(80, 177, 148, var(--bs-text-opacity)) !important;
}

.bg-teal-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(80, 177, 148, var(--bs-bg-opacity)) !important;
}

.text-teal-900 {
  --bs-text-opacity: 1;
  color: rgba(7, 31, 24, var(--bs-text-opacity)) !important;
}

.bg-teal-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7, 31, 24, var(--bs-bg-opacity)) !important;
}

.bg-gradient-muted {
  background-color: #617a86 !important;
  background-image: linear-gradient(to bottom, #7b939f, #566d77) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-muted {
  --bs-theme: #617a86 !important;
  --bs-theme-rgb: 97, 122, 134 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-muted-100 {
  --bs-text-opacity: 1;
  color: rgba(223, 228, 231, var(--bs-text-opacity)) !important;
}

.bg-muted-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(223, 228, 231, var(--bs-bg-opacity)) !important;
}

.text-muted-600 {
  --bs-text-opacity: 1;
  color: rgba(78, 98, 107, var(--bs-text-opacity)) !important;
}

.bg-muted-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(78, 98, 107, var(--bs-bg-opacity)) !important;
}

.text-muted-200 {
  --bs-text-opacity: 1;
  color: rgba(192, 202, 207, var(--bs-text-opacity)) !important;
}

.bg-muted-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(192, 202, 207, var(--bs-bg-opacity)) !important;
}

.text-muted-700 {
  --bs-text-opacity: 1;
  color: rgba(58, 73, 80, var(--bs-text-opacity)) !important;
}

.bg-muted-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(58, 73, 80, var(--bs-bg-opacity)) !important;
}

.text-muted-300 {
  --bs-text-opacity: 1;
  color: rgba(160, 175, 182, var(--bs-text-opacity)) !important;
}

.bg-muted-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(160, 175, 182, var(--bs-bg-opacity)) !important;
}

.text-muted-800 {
  --bs-text-opacity: 1;
  color: rgba(39, 49, 54, var(--bs-text-opacity)) !important;
}

.bg-muted-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(39, 49, 54, var(--bs-bg-opacity)) !important;
}

.text-muted-400 {
  --bs-text-opacity: 1;
  color: rgba(129, 149, 158, var(--bs-text-opacity)) !important;
}

.bg-muted-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(129, 149, 158, var(--bs-bg-opacity)) !important;
}

.text-muted-900 {
  --bs-text-opacity: 1;
  color: rgba(19, 24, 27, var(--bs-text-opacity)) !important;
}

.bg-muted-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(19, 24, 27, var(--bs-bg-opacity)) !important;
}

.bg-gradient-light {
  background-color: #c0cacf !important;
  background-image: linear-gradient(to bottom, #dde2e5, #b2bec4) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-light {
  --bs-theme: #c0cacf !important;
  --bs-theme-rgb: 192, 202, 207 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-light-100 {
  --bs-text-opacity: 1;
  color: rgba(242, 244, 245, var(--bs-text-opacity)) !important;
}

.bg-light-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(242, 244, 245, var(--bs-bg-opacity)) !important;
}

.text-light-600 {
  --bs-text-opacity: 1;
  color: rgba(154, 162, 166, var(--bs-text-opacity)) !important;
}

.bg-light-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(154, 162, 166, var(--bs-bg-opacity)) !important;
}

.text-light-200 {
  --bs-text-opacity: 1;
  color: rgba(230, 234, 236, var(--bs-text-opacity)) !important;
}

.bg-light-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(230, 234, 236, var(--bs-bg-opacity)) !important;
}

.text-light-700 {
  --bs-text-opacity: 1;
  color: rgba(115, 121, 124, var(--bs-text-opacity)) !important;
}

.bg-light-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(115, 121, 124, var(--bs-bg-opacity)) !important;
}

.text-light-300 {
  --bs-text-opacity: 1;
  color: rgba(217, 223, 226, var(--bs-text-opacity)) !important;
}

.bg-light-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(217, 223, 226, var(--bs-bg-opacity)) !important;
}

.text-light-800 {
  --bs-text-opacity: 1;
  color: rgba(77, 81, 83, var(--bs-text-opacity)) !important;
}

.bg-light-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(77, 81, 83, var(--bs-bg-opacity)) !important;
}

.text-light-400 {
  --bs-text-opacity: 1;
  color: rgba(205, 213, 217, var(--bs-text-opacity)) !important;
}

.bg-light-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(205, 213, 217, var(--bs-bg-opacity)) !important;
}

.text-light-900 {
  --bs-text-opacity: 1;
  color: rgba(38, 40, 41, var(--bs-text-opacity)) !important;
}

.bg-light-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(38, 40, 41, var(--bs-bg-opacity)) !important;
}

.bg-gradient-lime {
  background-color: #50b00a !important;
  background-image: linear-gradient(to bottom, #66e00d, #459809) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-lime {
  --bs-theme: #50b00a !important;
  --bs-theme-rgb: 80, 176, 10 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-lime-100 {
  --bs-text-opacity: 1;
  color: rgba(220, 239, 206, var(--bs-text-opacity)) !important;
}

.bg-lime-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 239, 206, var(--bs-bg-opacity)) !important;
}

.text-lime-600 {
  --bs-text-opacity: 1;
  color: rgba(64, 141, 8, var(--bs-text-opacity)) !important;
}

.bg-lime-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(64, 141, 8, var(--bs-bg-opacity)) !important;
}

.text-lime-200 {
  --bs-text-opacity: 1;
  color: rgba(185, 223, 157, var(--bs-text-opacity)) !important;
}

.bg-lime-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(185, 223, 157, var(--bs-bg-opacity)) !important;
}

.text-lime-700 {
  --bs-text-opacity: 1;
  color: rgba(48, 106, 6, var(--bs-text-opacity)) !important;
}

.bg-lime-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 106, 6, var(--bs-bg-opacity)) !important;
}

.text-lime-300 {
  --bs-text-opacity: 1;
  color: rgba(150, 208, 108, var(--bs-text-opacity)) !important;
}

.bg-lime-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(150, 208, 108, var(--bs-bg-opacity)) !important;
}

.text-lime-800 {
  --bs-text-opacity: 1;
  color: rgba(32, 70, 4, var(--bs-text-opacity)) !important;
}

.bg-lime-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(32, 70, 4, var(--bs-bg-opacity)) !important;
}

.text-lime-400 {
  --bs-text-opacity: 1;
  color: rgba(115, 192, 59, var(--bs-text-opacity)) !important;
}

.bg-lime-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(115, 192, 59, var(--bs-bg-opacity)) !important;
}

.text-lime-900 {
  --bs-text-opacity: 1;
  color: rgba(16, 35, 2, var(--bs-text-opacity)) !important;
}

.bg-lime-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 35, 2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-100 {
  background-color: #c0cacf !important;
  background-image: linear-gradient(to bottom, #dde2e5, #b2bec4) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-100 {
  --bs-theme: #c0cacf !important;
  --bs-theme-rgb: 192, 202, 207 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-gray-100-100 {
  --bs-text-opacity: 1;
  color: rgba(242, 244, 245, var(--bs-text-opacity)) !important;
}

.bg-gray-100-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(242, 244, 245, var(--bs-bg-opacity)) !important;
}

.text-gray-100-600 {
  --bs-text-opacity: 1;
  color: rgba(154, 162, 166, var(--bs-text-opacity)) !important;
}

.bg-gray-100-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(154, 162, 166, var(--bs-bg-opacity)) !important;
}

.text-gray-100-200 {
  --bs-text-opacity: 1;
  color: rgba(230, 234, 236, var(--bs-text-opacity)) !important;
}

.bg-gray-100-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(230, 234, 236, var(--bs-bg-opacity)) !important;
}

.text-gray-100-700 {
  --bs-text-opacity: 1;
  color: rgba(115, 121, 124, var(--bs-text-opacity)) !important;
}

.bg-gray-100-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(115, 121, 124, var(--bs-bg-opacity)) !important;
}

.text-gray-100-300 {
  --bs-text-opacity: 1;
  color: rgba(217, 223, 226, var(--bs-text-opacity)) !important;
}

.bg-gray-100-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(217, 223, 226, var(--bs-bg-opacity)) !important;
}

.text-gray-100-800 {
  --bs-text-opacity: 1;
  color: rgba(77, 81, 83, var(--bs-text-opacity)) !important;
}

.bg-gray-100-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(77, 81, 83, var(--bs-bg-opacity)) !important;
}

.text-gray-100-400 {
  --bs-text-opacity: 1;
  color: rgba(205, 213, 217, var(--bs-text-opacity)) !important;
}

.bg-gray-100-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(205, 213, 217, var(--bs-bg-opacity)) !important;
}

.text-gray-100-900 {
  --bs-text-opacity: 1;
  color: rgba(38, 40, 41, var(--bs-text-opacity)) !important;
}

.bg-gray-100-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(38, 40, 41, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-200 {
  background-color: #a8b6bc !important;
  background-image: linear-gradient(to bottom, #c5ced2, #9aaab1) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-200 {
  --bs-theme: #a8b6bc !important;
  --bs-theme-rgb: 168, 182, 188 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-gray-200-100 {
  --bs-text-opacity: 1;
  color: rgba(238, 240, 242, var(--bs-text-opacity)) !important;
}

.bg-gray-200-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(238, 240, 242, var(--bs-bg-opacity)) !important;
}

.text-gray-200-600 {
  --bs-text-opacity: 1;
  color: rgba(134, 146, 150, var(--bs-text-opacity)) !important;
}

.bg-gray-200-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 146, 150, var(--bs-bg-opacity)) !important;
}

.text-gray-200-200 {
  --bs-text-opacity: 1;
  color: rgba(220, 226, 228, var(--bs-text-opacity)) !important;
}

.bg-gray-200-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 226, 228, var(--bs-bg-opacity)) !important;
}

.text-gray-200-700 {
  --bs-text-opacity: 1;
  color: rgba(101, 109, 113, var(--bs-text-opacity)) !important;
}

.bg-gray-200-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(101, 109, 113, var(--bs-bg-opacity)) !important;
}

.text-gray-200-300 {
  --bs-text-opacity: 1;
  color: rgba(203, 211, 215, var(--bs-text-opacity)) !important;
}

.bg-gray-200-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(203, 211, 215, var(--bs-bg-opacity)) !important;
}

.text-gray-200-800 {
  --bs-text-opacity: 1;
  color: rgba(67, 73, 75, var(--bs-text-opacity)) !important;
}

.bg-gray-200-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(67, 73, 75, var(--bs-bg-opacity)) !important;
}

.text-gray-200-400 {
  --bs-text-opacity: 1;
  color: rgba(185, 197, 201, var(--bs-text-opacity)) !important;
}

.bg-gray-200-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(185, 197, 201, var(--bs-bg-opacity)) !important;
}

.text-gray-200-900 {
  --bs-text-opacity: 1;
  color: rgba(34, 36, 38, var(--bs-text-opacity)) !important;
}

.bg-gray-200-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(34, 36, 38, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-300 {
  background-color: #90a2aa !important;
  background-image: linear-gradient(to bottom, #adbac0, #82969f) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-300 {
  --bs-theme: #90a2aa !important;
  --bs-theme-rgb: 144, 162, 170 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-gray-300-100 {
  --bs-text-opacity: 1;
  color: rgba(233, 236, 238, var(--bs-text-opacity)) !important;
}

.bg-gray-300-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(233, 236, 238, var(--bs-bg-opacity)) !important;
}

.text-gray-300-600 {
  --bs-text-opacity: 1;
  color: rgba(115, 130, 136, var(--bs-text-opacity)) !important;
}

.bg-gray-300-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(115, 130, 136, var(--bs-bg-opacity)) !important;
}

.text-gray-300-200 {
  --bs-text-opacity: 1;
  color: rgba(211, 218, 221, var(--bs-text-opacity)) !important;
}

.bg-gray-300-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(211, 218, 221, var(--bs-bg-opacity)) !important;
}

.text-gray-300-700 {
  --bs-text-opacity: 1;
  color: rgba(86, 97, 102, var(--bs-text-opacity)) !important;
}

.bg-gray-300-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(86, 97, 102, var(--bs-bg-opacity)) !important;
}

.text-gray-300-300 {
  --bs-text-opacity: 1;
  color: rgba(188, 199, 204, var(--bs-text-opacity)) !important;
}

.bg-gray-300-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(188, 199, 204, var(--bs-bg-opacity)) !important;
}

.text-gray-300-800 {
  --bs-text-opacity: 1;
  color: rgba(58, 65, 68, var(--bs-text-opacity)) !important;
}

.bg-gray-300-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(58, 65, 68, var(--bs-bg-opacity)) !important;
}

.text-gray-300-400 {
  --bs-text-opacity: 1;
  color: rgba(166, 181, 187, var(--bs-text-opacity)) !important;
}

.bg-gray-300-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(166, 181, 187, var(--bs-bg-opacity)) !important;
}

.text-gray-300-900 {
  --bs-text-opacity: 1;
  color: rgba(29, 32, 34, var(--bs-text-opacity)) !important;
}

.bg-gray-300-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(29, 32, 34, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-400 {
  background-color: #798e98 !important;
  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-400 {
  --bs-theme: #798e98 !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-400-100 {
  --bs-text-opacity: 1;
  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;
}

.bg-gray-400-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;
}

.text-gray-400-600 {
  --bs-text-opacity: 1;
  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;
}

.bg-gray-400-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;
}

.text-gray-400-200 {
  --bs-text-opacity: 1;
  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;
}

.bg-gray-400-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;
}

.text-gray-400-700 {
  --bs-text-opacity: 1;
  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;
}

.bg-gray-400-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;
}

.text-gray-400-300 {
  --bs-text-opacity: 1;
  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;
}

.bg-gray-400-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;
}

.text-gray-400-800 {
  --bs-text-opacity: 1;
  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;
}

.bg-gray-400-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;
}

.text-gray-400-400 {
  --bs-text-opacity: 1;
  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;
}

.bg-gray-400-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;
}

.text-gray-400-900 {
  --bs-text-opacity: 1;
  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;
}

.bg-gray-400-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-500 {
  background-color: #617a86 !important;
  background-image: linear-gradient(to bottom, #7b939f, #566d77) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-500 {
  --bs-theme: #617a86 !important;
  --bs-theme-rgb: 97, 122, 134 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-500-100 {
  --bs-text-opacity: 1;
  color: rgba(223, 228, 231, var(--bs-text-opacity)) !important;
}

.bg-gray-500-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(223, 228, 231, var(--bs-bg-opacity)) !important;
}

.text-gray-500-600 {
  --bs-text-opacity: 1;
  color: rgba(78, 98, 107, var(--bs-text-opacity)) !important;
}

.bg-gray-500-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(78, 98, 107, var(--bs-bg-opacity)) !important;
}

.text-gray-500-200 {
  --bs-text-opacity: 1;
  color: rgba(192, 202, 207, var(--bs-text-opacity)) !important;
}

.bg-gray-500-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(192, 202, 207, var(--bs-bg-opacity)) !important;
}

.text-gray-500-700 {
  --bs-text-opacity: 1;
  color: rgba(58, 73, 80, var(--bs-text-opacity)) !important;
}

.bg-gray-500-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(58, 73, 80, var(--bs-bg-opacity)) !important;
}

.text-gray-500-300 {
  --bs-text-opacity: 1;
  color: rgba(160, 175, 182, var(--bs-text-opacity)) !important;
}

.bg-gray-500-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(160, 175, 182, var(--bs-bg-opacity)) !important;
}

.text-gray-500-800 {
  --bs-text-opacity: 1;
  color: rgba(39, 49, 54, var(--bs-text-opacity)) !important;
}

.bg-gray-500-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(39, 49, 54, var(--bs-bg-opacity)) !important;
}

.text-gray-500-400 {
  --bs-text-opacity: 1;
  color: rgba(129, 149, 158, var(--bs-text-opacity)) !important;
}

.bg-gray-500-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(129, 149, 158, var(--bs-bg-opacity)) !important;
}

.text-gray-500-900 {
  --bs-text-opacity: 1;
  color: rgba(19, 24, 27, var(--bs-text-opacity)) !important;
}

.bg-gray-500-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(19, 24, 27, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-600 {
  background-color: #526872 !important;
  background-image: linear-gradient(to bottom, #678390, #475a63) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-600 {
  --bs-theme: #526872 !important;
  --bs-theme-rgb: 82, 104, 114 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-600-100 {
  --bs-text-opacity: 1;
  color: rgba(220, 225, 227, var(--bs-text-opacity)) !important;
}

.bg-gray-600-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 225, 227, var(--bs-bg-opacity)) !important;
}

.text-gray-600-600 {
  --bs-text-opacity: 1;
  color: rgba(66, 83, 91, var(--bs-text-opacity)) !important;
}

.bg-gray-600-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(66, 83, 91, var(--bs-bg-opacity)) !important;
}

.text-gray-600-200 {
  --bs-text-opacity: 1;
  color: rgba(186, 195, 199, var(--bs-text-opacity)) !important;
}

.bg-gray-600-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(186, 195, 199, var(--bs-bg-opacity)) !important;
}

.text-gray-600-700 {
  --bs-text-opacity: 1;
  color: rgba(49, 62, 68, var(--bs-text-opacity)) !important;
}

.bg-gray-600-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(49, 62, 68, var(--bs-bg-opacity)) !important;
}

.text-gray-600-300 {
  --bs-text-opacity: 1;
  color: rgba(151, 164, 170, var(--bs-text-opacity)) !important;
}

.bg-gray-600-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(151, 164, 170, var(--bs-bg-opacity)) !important;
}

.text-gray-600-800 {
  --bs-text-opacity: 1;
  color: rgba(33, 42, 46, var(--bs-text-opacity)) !important;
}

.bg-gray-600-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(33, 42, 46, var(--bs-bg-opacity)) !important;
}

.text-gray-600-400 {
  --bs-text-opacity: 1;
  color: rgba(117, 134, 142, var(--bs-text-opacity)) !important;
}

.bg-gray-600-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(117, 134, 142, var(--bs-bg-opacity)) !important;
}

.text-gray-600-900 {
  --bs-text-opacity: 1;
  color: rgba(16, 21, 23, var(--bs-text-opacity)) !important;
}

.bg-gray-600-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 21, 23, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-700 {
  background-color: #44555e !important;
  background-image: linear-gradient(to bottom, #59707c, #39484f) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-700 {
  --bs-theme: #44555e !important;
  --bs-theme-rgb: 68, 85, 94 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-700-100 {
  --bs-text-opacity: 1;
  color: rgba(218, 221, 223, var(--bs-text-opacity)) !important;
}

.bg-gray-700-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(218, 221, 223, var(--bs-bg-opacity)) !important;
}

.text-gray-700-600 {
  --bs-text-opacity: 1;
  color: rgba(54, 68, 75, var(--bs-text-opacity)) !important;
}

.bg-gray-700-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(54, 68, 75, var(--bs-bg-opacity)) !important;
}

.text-gray-700-200 {
  --bs-text-opacity: 1;
  color: rgba(180, 187, 191, var(--bs-text-opacity)) !important;
}

.bg-gray-700-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(180, 187, 191, var(--bs-bg-opacity)) !important;
}

.text-gray-700-700 {
  --bs-text-opacity: 1;
  color: rgba(41, 51, 56, var(--bs-text-opacity)) !important;
}

.bg-gray-700-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(41, 51, 56, var(--bs-bg-opacity)) !important;
}

.text-gray-700-300 {
  --bs-text-opacity: 1;
  color: rgba(143, 153, 158, var(--bs-text-opacity)) !important;
}

.bg-gray-700-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(143, 153, 158, var(--bs-bg-opacity)) !important;
}

.text-gray-700-800 {
  --bs-text-opacity: 1;
  color: rgba(27, 34, 38, var(--bs-text-opacity)) !important;
}

.bg-gray-700-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(27, 34, 38, var(--bs-bg-opacity)) !important;
}

.text-gray-700-400 {
  --bs-text-opacity: 1;
  color: rgba(105, 119, 126, var(--bs-text-opacity)) !important;
}

.bg-gray-700-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(105, 119, 126, var(--bs-bg-opacity)) !important;
}

.text-gray-700-900 {
  --bs-text-opacity: 1;
  color: rgba(14, 17, 19, var(--bs-text-opacity)) !important;
}

.bg-gray-700-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(14, 17, 19, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-800 {
  background-color: #35434a !important;
  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-800 {
  --bs-theme: #35434a !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-800-100 {
  --bs-text-opacity: 1;
  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;
}

.bg-gray-800-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;
}

.text-gray-800-600 {
  --bs-text-opacity: 1;
  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;
}

.bg-gray-800-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;
}

.text-gray-800-200 {
  --bs-text-opacity: 1;
  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;
}

.bg-gray-800-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;
}

.text-gray-800-700 {
  --bs-text-opacity: 1;
  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;
}

.bg-gray-800-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;
}

.text-gray-800-300 {
  --bs-text-opacity: 1;
  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;
}

.bg-gray-800-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;
}

.text-gray-800-800 {
  --bs-text-opacity: 1;
  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;
}

.bg-gray-800-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;
}

.text-gray-800-400 {
  --bs-text-opacity: 1;
  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;
}

.bg-gray-800-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;
}

.text-gray-800-900 {
  --bs-text-opacity: 1;
  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;
}

.bg-gray-800-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-900 {
  background-color: #273136 !important;
  background-image: linear-gradient(to bottom, #3c4c54, #1c2427) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-900 {
  --bs-theme: #273136 !important;
  --bs-theme-rgb: 39, 49, 54 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-900-100 {
  --bs-text-opacity: 1;
  color: rgba(212, 214, 215, var(--bs-text-opacity)) !important;
}

.bg-gray-900-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(212, 214, 215, var(--bs-bg-opacity)) !important;
}

.text-gray-900-600 {
  --bs-text-opacity: 1;
  color: rgba(31, 39, 43, var(--bs-text-opacity)) !important;
}

.bg-gray-900-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(31, 39, 43, var(--bs-bg-opacity)) !important;
}

.text-gray-900-200 {
  --bs-text-opacity: 1;
  color: rgba(169, 173, 175, var(--bs-text-opacity)) !important;
}

.bg-gray-900-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(169, 173, 175, var(--bs-bg-opacity)) !important;
}

.text-gray-900-700 {
  --bs-text-opacity: 1;
  color: rgba(23, 29, 32, var(--bs-text-opacity)) !important;
}

.bg-gray-900-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(23, 29, 32, var(--bs-bg-opacity)) !important;
}

.text-gray-900-300 {
  --bs-text-opacity: 1;
  color: rgba(125, 131, 134, var(--bs-text-opacity)) !important;
}

.bg-gray-900-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(125, 131, 134, var(--bs-bg-opacity)) !important;
}

.text-gray-900-800 {
  --bs-text-opacity: 1;
  color: rgba(16, 20, 22, var(--bs-text-opacity)) !important;
}

.bg-gray-900-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 20, 22, var(--bs-bg-opacity)) !important;
}

.text-gray-900-400 {
  --bs-text-opacity: 1;
  color: rgba(82, 90, 94, var(--bs-text-opacity)) !important;
}

.bg-gray-900-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(82, 90, 94, var(--bs-bg-opacity)) !important;
}

.text-gray-900-900 {
  --bs-text-opacity: 1;
  color: rgba(8, 10, 11, var(--bs-text-opacity)) !important;
}

.bg-gray-900-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(8, 10, 11, var(--bs-bg-opacity)) !important;
}

.bg-gradient-blue {
  background-color: #0271ff !important;
  background-image: linear-gradient(to bottom, #358eff, #0066e8) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-blue {
  --bs-theme: #0271ff !important;
  --bs-theme-rgb: 2, 113, 255 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-blue-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 227, 255, var(--bs-text-opacity)) !important;
}

.bg-blue-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 227, 255, var(--bs-bg-opacity)) !important;
}

.text-blue-600 {
  --bs-text-opacity: 1;
  color: rgba(2, 90, 204, var(--bs-text-opacity)) !important;
}

.bg-blue-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(2, 90, 204, var(--bs-bg-opacity)) !important;
}

.text-blue-200 {
  --bs-text-opacity: 1;
  color: rgba(154, 198, 255, var(--bs-text-opacity)) !important;
}

.bg-blue-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(154, 198, 255, var(--bs-bg-opacity)) !important;
}

.text-blue-700 {
  --bs-text-opacity: 1;
  color: rgba(1, 68, 153, var(--bs-text-opacity)) !important;
}

.bg-blue-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(1, 68, 153, var(--bs-bg-opacity)) !important;
}

.text-blue-300 {
  --bs-text-opacity: 1;
  color: rgba(103, 170, 255, var(--bs-text-opacity)) !important;
}

.bg-blue-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(103, 170, 255, var(--bs-bg-opacity)) !important;
}

.text-blue-800 {
  --bs-text-opacity: 1;
  color: rgba(1, 45, 102, var(--bs-text-opacity)) !important;
}

.bg-blue-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(1, 45, 102, var(--bs-bg-opacity)) !important;
}

.text-blue-400 {
  --bs-text-opacity: 1;
  color: rgba(53, 141, 255, var(--bs-text-opacity)) !important;
}

.bg-blue-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(53, 141, 255, var(--bs-bg-opacity)) !important;
}

.text-blue-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 23, 51, var(--bs-text-opacity)) !important;
}

.bg-blue-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 23, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-indigo {
  background-color: #5c25ff !important;
  background-image: linear-gradient(to bottom, #8258ff, #490cff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-indigo {
  --bs-theme: #5c25ff !important;
  --bs-theme-rgb: 92, 37, 255 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-indigo-100 {
  --bs-text-opacity: 1;
  color: rgba(222, 211, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(222, 211, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-600 {
  --bs-text-opacity: 1;
  color: rgba(74, 30, 204, var(--bs-text-opacity)) !important;
}

.bg-indigo-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(74, 30, 204, var(--bs-bg-opacity)) !important;
}

.text-indigo-200 {
  --bs-text-opacity: 1;
  color: rgba(190, 168, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(190, 168, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-700 {
  --bs-text-opacity: 1;
  color: rgba(55, 22, 153, var(--bs-text-opacity)) !important;
}

.bg-indigo-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(55, 22, 153, var(--bs-bg-opacity)) !important;
}

.text-indigo-300 {
  --bs-text-opacity: 1;
  color: rgba(157, 124, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(157, 124, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-800 {
  --bs-text-opacity: 1;
  color: rgba(37, 15, 102, var(--bs-text-opacity)) !important;
}

.bg-indigo-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(37, 15, 102, var(--bs-bg-opacity)) !important;
}

.text-indigo-400 {
  --bs-text-opacity: 1;
  color: rgba(125, 81, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(125, 81, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-900 {
  --bs-text-opacity: 1;
  color: rgba(18, 7, 51, var(--bs-text-opacity)) !important;
}

.bg-indigo-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(18, 7, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-purple {
  background-color: #b90dff !important;
  background-image: linear-gradient(to bottom, #c840ff, #ac00f3) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-purple {
  --bs-theme: #b90dff !important;
  --bs-theme-rgb: 185, 13, 255 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-purple-100 {
  --bs-text-opacity: 1;
  color: rgba(241, 207, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(241, 207, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-600 {
  --bs-text-opacity: 1;
  color: rgba(148, 10, 204, var(--bs-text-opacity)) !important;
}

.bg-purple-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(148, 10, 204, var(--bs-bg-opacity)) !important;
}

.text-purple-200 {
  --bs-text-opacity: 1;
  color: rgba(227, 158, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(227, 158, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-700 {
  --bs-text-opacity: 1;
  color: rgba(111, 8, 153, var(--bs-text-opacity)) !important;
}

.bg-purple-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(111, 8, 153, var(--bs-bg-opacity)) !important;
}

.text-purple-300 {
  --bs-text-opacity: 1;
  color: rgba(213, 110, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(213, 110, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-800 {
  --bs-text-opacity: 1;
  color: rgba(74, 5, 102, var(--bs-text-opacity)) !important;
}

.bg-purple-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(74, 5, 102, var(--bs-bg-opacity)) !important;
}

.text-purple-400 {
  --bs-text-opacity: 1;
  color: rgba(199, 61, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(199, 61, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-900 {
  --bs-text-opacity: 1;
  color: rgba(37, 3, 51, var(--bs-text-opacity)) !important;
}

.bg-purple-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(37, 3, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-pink {
  background-color: #e61079 !important;
  background-image: linear-gradient(to bottom, #f13893, #ce0e6c) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-pink {
  --bs-theme: #e61079 !important;
  --bs-theme-rgb: 230, 16, 121 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-pink-100 {
  --bs-text-opacity: 1;
  color: rgba(250, 207, 228, var(--bs-text-opacity)) !important;
}

.bg-pink-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 207, 228, var(--bs-bg-opacity)) !important;
}

.text-pink-600 {
  --bs-text-opacity: 1;
  color: rgba(184, 13, 97, var(--bs-text-opacity)) !important;
}

.bg-pink-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(184, 13, 97, var(--bs-bg-opacity)) !important;
}

.text-pink-200 {
  --bs-text-opacity: 1;
  color: rgba(245, 159, 201, var(--bs-text-opacity)) !important;
}

.bg-pink-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(245, 159, 201, var(--bs-bg-opacity)) !important;
}

.text-pink-700 {
  --bs-text-opacity: 1;
  color: rgba(138, 10, 73, var(--bs-text-opacity)) !important;
}

.bg-pink-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 10, 73, var(--bs-bg-opacity)) !important;
}

.text-pink-300 {
  --bs-text-opacity: 1;
  color: rgba(240, 112, 175, var(--bs-text-opacity)) !important;
}

.bg-pink-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(240, 112, 175, var(--bs-bg-opacity)) !important;
}

.text-pink-800 {
  --bs-text-opacity: 1;
  color: rgba(92, 6, 48, var(--bs-text-opacity)) !important;
}

.bg-pink-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(92, 6, 48, var(--bs-bg-opacity)) !important;
}

.text-pink-400 {
  --bs-text-opacity: 1;
  color: rgba(235, 64, 148, var(--bs-text-opacity)) !important;
}

.bg-pink-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(235, 64, 148, var(--bs-bg-opacity)) !important;
}

.text-pink-900 {
  --bs-text-opacity: 1;
  color: rgba(46, 3, 24, var(--bs-text-opacity)) !important;
}

.bg-pink-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(46, 3, 24, var(--bs-bg-opacity)) !important;
}

.bg-gradient-red {
  background-color: #e00000 !important;
  background-image: linear-gradient(to bottom, #ff1414, #c70000) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-red {
  --bs-theme: #e00000 !important;
  --bs-theme-rgb: 224, 0, 0 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-red-100 {
  --bs-text-opacity: 1;
  color: rgba(249, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-red-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(249, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-red-600 {
  --bs-text-opacity: 1;
  color: rgba(179, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-200 {
  --bs-text-opacity: 1;
  color: rgba(243, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-red-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(243, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-red-700 {
  --bs-text-opacity: 1;
  color: rgba(134, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-300 {
  --bs-text-opacity: 1;
  color: rgba(236, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-red-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(236, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-red-800 {
  --bs-text-opacity: 1;
  color: rgba(90, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(90, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-400 {
  --bs-text-opacity: 1;
  color: rgba(230, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-red-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(230, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-red-900 {
  --bs-text-opacity: 1;
  color: rgba(45, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(45, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-orange {
  background-color: #ff9f0c !important;
  background-image: linear-gradient(to bottom, #ffb33f, #f29200) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-orange {
  --bs-theme: #ff9f0c !important;
  --bs-theme-rgb: 255, 159, 12 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-orange-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 236, 206, var(--bs-text-opacity)) !important;
}

.bg-orange-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 236, 206, var(--bs-bg-opacity)) !important;
}

.text-orange-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 127, 10, var(--bs-text-opacity)) !important;
}

.bg-orange-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 127, 10, var(--bs-bg-opacity)) !important;
}

.text-orange-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 217, 158, var(--bs-text-opacity)) !important;
}

.bg-orange-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 217, 158, var(--bs-bg-opacity)) !important;
}

.text-orange-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 95, 7, var(--bs-text-opacity)) !important;
}

.bg-orange-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 95, 7, var(--bs-bg-opacity)) !important;
}

.text-orange-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 197, 109, var(--bs-text-opacity)) !important;
}

.bg-orange-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 197, 109, var(--bs-bg-opacity)) !important;
}

.text-orange-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 64, 5, var(--bs-text-opacity)) !important;
}

.bg-orange-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 64, 5, var(--bs-bg-opacity)) !important;
}

.text-orange-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 178, 61, var(--bs-text-opacity)) !important;
}

.bg-orange-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 178, 61, var(--bs-bg-opacity)) !important;
}

.text-orange-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 32, 2, var(--bs-text-opacity)) !important;
}

.bg-orange-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 32, 2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-yellow {
  background-color: #f9e80d !important;
  background-image: linear-gradient(to bottom, #faed3f, #e7d706) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-yellow {
  --bs-theme: #f9e80d !important;
  --bs-theme-rgb: 249, 232, 13 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-yellow-100 {
  --bs-text-opacity: 1;
  color: rgba(254, 250, 207, var(--bs-text-opacity)) !important;
}

.bg-yellow-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(254, 250, 207, var(--bs-bg-opacity)) !important;
}

.text-yellow-600 {
  --bs-text-opacity: 1;
  color: rgba(199, 186, 10, var(--bs-text-opacity)) !important;
}

.bg-yellow-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(199, 186, 10, var(--bs-bg-opacity)) !important;
}

.text-yellow-200 {
  --bs-text-opacity: 1;
  color: rgba(253, 246, 158, var(--bs-text-opacity)) !important;
}

.bg-yellow-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(253, 246, 158, var(--bs-bg-opacity)) !important;
}

.text-yellow-700 {
  --bs-text-opacity: 1;
  color: rgba(149, 139, 8, var(--bs-text-opacity)) !important;
}

.bg-yellow-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(149, 139, 8, var(--bs-bg-opacity)) !important;
}

.text-yellow-300 {
  --bs-text-opacity: 1;
  color: rgba(251, 241, 110, var(--bs-text-opacity)) !important;
}

.bg-yellow-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(251, 241, 110, var(--bs-bg-opacity)) !important;
}

.text-yellow-800 {
  --bs-text-opacity: 1;
  color: rgba(100, 93, 5, var(--bs-text-opacity)) !important;
}

.bg-yellow-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(100, 93, 5, var(--bs-bg-opacity)) !important;
}

.text-yellow-400 {
  --bs-text-opacity: 1;
  color: rgba(250, 237, 61, var(--bs-text-opacity)) !important;
}

.bg-yellow-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 237, 61, var(--bs-bg-opacity)) !important;
}

.text-yellow-900 {
  --bs-text-opacity: 1;
  color: rgba(50, 46, 3, var(--bs-text-opacity)) !important;
}

.bg-yellow-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(50, 46, 3, var(--bs-bg-opacity)) !important;
}

.bg-gradient-green {
  background-color: #148922 !important;
  background-image: linear-gradient(to bottom, #1ab62d, #11731c) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-green {
  --bs-theme: #148922 !important;
  --bs-theme-rgb: 20, 137, 34 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-green-100 {
  --bs-text-opacity: 1;
  color: rgba(208, 231, 211, var(--bs-text-opacity)) !important;
}

.bg-green-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(208, 231, 211, var(--bs-bg-opacity)) !important;
}

.text-green-600 {
  --bs-text-opacity: 1;
  color: rgba(16, 110, 27, var(--bs-text-opacity)) !important;
}

.bg-green-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 110, 27, var(--bs-bg-opacity)) !important;
}

.text-green-200 {
  --bs-text-opacity: 1;
  color: rgba(161, 208, 167, var(--bs-text-opacity)) !important;
}

.bg-green-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(161, 208, 167, var(--bs-bg-opacity)) !important;
}

.text-green-700 {
  --bs-text-opacity: 1;
  color: rgba(12, 82, 20, var(--bs-text-opacity)) !important;
}

.bg-green-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 82, 20, var(--bs-bg-opacity)) !important;
}

.text-green-300 {
  --bs-text-opacity: 1;
  color: rgba(114, 184, 122, var(--bs-text-opacity)) !important;
}

.bg-green-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(114, 184, 122, var(--bs-bg-opacity)) !important;
}

.text-green-800 {
  --bs-text-opacity: 1;
  color: rgba(8, 55, 14, var(--bs-text-opacity)) !important;
}

.bg-green-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(8, 55, 14, var(--bs-bg-opacity)) !important;
}

.text-green-400 {
  --bs-text-opacity: 1;
  color: rgba(67, 161, 78, var(--bs-text-opacity)) !important;
}

.bg-green-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(67, 161, 78, var(--bs-bg-opacity)) !important;
}

.text-green-900 {
  --bs-text-opacity: 1;
  color: rgba(4, 27, 7, var(--bs-text-opacity)) !important;
}

.bg-green-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(4, 27, 7, var(--bs-bg-opacity)) !important;
}

.bg-gradient-teal {
  background-color: #249d79 !important;
  background-image: linear-gradient(to bottom, #2ec699, #1f8869) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-teal {
  --bs-theme: #249d79 !important;
  --bs-theme-rgb: 36, 157, 121 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-teal-100 {
  --bs-text-opacity: 1;
  color: rgba(211, 235, 228, var(--bs-text-opacity)) !important;
}

.bg-teal-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211, 235, 228, var(--bs-bg-opacity)) !important;
}

.text-teal-600 {
  --bs-text-opacity: 1;
  color: rgba(29, 126, 97, var(--bs-text-opacity)) !important;
}

.bg-teal-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(29, 126, 97, var(--bs-bg-opacity)) !important;
}

.text-teal-200 {
  --bs-text-opacity: 1;
  color: rgba(167, 216, 201, var(--bs-text-opacity)) !important;
}

.bg-teal-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(167, 216, 201, var(--bs-bg-opacity)) !important;
}

.text-teal-700 {
  --bs-text-opacity: 1;
  color: rgba(22, 94, 73, var(--bs-text-opacity)) !important;
}

.bg-teal-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(22, 94, 73, var(--bs-bg-opacity)) !important;
}

.text-teal-300 {
  --bs-text-opacity: 1;
  color: rgba(124, 196, 175, var(--bs-text-opacity)) !important;
}

.bg-teal-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(124, 196, 175, var(--bs-bg-opacity)) !important;
}

.text-teal-800 {
  --bs-text-opacity: 1;
  color: rgba(14, 63, 48, var(--bs-text-opacity)) !important;
}

.bg-teal-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(14, 63, 48, var(--bs-bg-opacity)) !important;
}

.text-teal-400 {
  --bs-text-opacity: 1;
  color: rgba(80, 177, 148, var(--bs-text-opacity)) !important;
}

.bg-teal-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(80, 177, 148, var(--bs-bg-opacity)) !important;
}

.text-teal-900 {
  --bs-text-opacity: 1;
  color: rgba(7, 31, 24, var(--bs-text-opacity)) !important;
}

.bg-teal-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7, 31, 24, var(--bs-bg-opacity)) !important;
}

.bg-gradient-cyan {
  background-color: #009be3 !important;
  background-image: linear-gradient(to bottom, #17b5ff, #008aca) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-cyan {
  --bs-theme: #009be3 !important;
  --bs-theme-rgb: 0, 155, 227 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-cyan-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 235, 249, var(--bs-text-opacity)) !important;
}

.bg-cyan-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 235, 249, var(--bs-bg-opacity)) !important;
}

.text-cyan-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 124, 182, var(--bs-text-opacity)) !important;
}

.bg-cyan-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 124, 182, var(--bs-bg-opacity)) !important;
}

.text-cyan-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 215, 244, var(--bs-text-opacity)) !important;
}

.bg-cyan-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 215, 244, var(--bs-bg-opacity)) !important;
}

.text-cyan-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 93, 136, var(--bs-text-opacity)) !important;
}

.bg-cyan-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 93, 136, var(--bs-bg-opacity)) !important;
}

.text-cyan-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 195, 238, var(--bs-text-opacity)) !important;
}

.bg-cyan-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 195, 238, var(--bs-bg-opacity)) !important;
}

.text-cyan-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 62, 91, var(--bs-text-opacity)) !important;
}

.bg-cyan-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 62, 91, var(--bs-bg-opacity)) !important;
}

.text-cyan-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 175, 233, var(--bs-text-opacity)) !important;
}

.bg-cyan-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 175, 233, var(--bs-bg-opacity)) !important;
}

.text-cyan-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 31, 45, var(--bs-text-opacity)) !important;
}

.bg-cyan-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 31, 45, var(--bs-bg-opacity)) !important;
}

.bg-gradient-black {
  background-color: #000000 !important;
  background-image: linear-gradient(to bottom, #1a1a1a, black) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-black {
  --bs-theme: #000000 !important;
  --bs-theme-rgb: 0, 0, 0 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-black-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-black-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-black-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-black-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-black-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-black-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-black-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-black-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-black-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-white {
  background-color: #ffffff !important;
  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-white {
  --bs-theme: #ffffff !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-white-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-white-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-white-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-white-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-white-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-white-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-white-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-white-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray {
  background-color: #526872 !important;
  background-image: linear-gradient(to bottom, #678390, #475a63) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray {
  --bs-theme: #526872 !important;
  --bs-theme-rgb: 82, 104, 114 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-100 {
  --bs-text-opacity: 1;
  color: rgba(220, 225, 227, var(--bs-text-opacity)) !important;
}

.bg-gray-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 225, 227, var(--bs-bg-opacity)) !important;
}

.text-gray-600 {
  --bs-text-opacity: 1;
  color: rgba(66, 83, 91, var(--bs-text-opacity)) !important;
}

.bg-gray-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(66, 83, 91, var(--bs-bg-opacity)) !important;
}

.text-gray-200 {
  --bs-text-opacity: 1;
  color: rgba(186, 195, 199, var(--bs-text-opacity)) !important;
}

.bg-gray-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(186, 195, 199, var(--bs-bg-opacity)) !important;
}

.text-gray-700 {
  --bs-text-opacity: 1;
  color: rgba(49, 62, 68, var(--bs-text-opacity)) !important;
}

.bg-gray-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(49, 62, 68, var(--bs-bg-opacity)) !important;
}

.text-gray-300 {
  --bs-text-opacity: 1;
  color: rgba(151, 164, 170, var(--bs-text-opacity)) !important;
}

.bg-gray-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(151, 164, 170, var(--bs-bg-opacity)) !important;
}

.text-gray-800 {
  --bs-text-opacity: 1;
  color: rgba(33, 42, 46, var(--bs-text-opacity)) !important;
}

.bg-gray-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(33, 42, 46, var(--bs-bg-opacity)) !important;
}

.text-gray-400 {
  --bs-text-opacity: 1;
  color: rgba(117, 134, 142, var(--bs-text-opacity)) !important;
}

.bg-gray-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(117, 134, 142, var(--bs-bg-opacity)) !important;
}

.text-gray-900 {
  --bs-text-opacity: 1;
  color: rgba(16, 21, 23, var(--bs-text-opacity)) !important;
}

.bg-gray-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 21, 23, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-dark {
  background-color: #35434a !important;
  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-dark {
  --bs-theme: #35434a !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-dark-100 {
  --bs-text-opacity: 1;
  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-600 {
  --bs-text-opacity: 1;
  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-200 {
  --bs-text-opacity: 1;
  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-700 {
  --bs-text-opacity: 1;
  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-300 {
  --bs-text-opacity: 1;
  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-800 {
  --bs-text-opacity: 1;
  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-400 {
  --bs-text-opacity: 1;
  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-900 {
  --bs-text-opacity: 1;
  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;
}

[data-bs-theme=dark] {
  --bs-default: #a8b6bc;
  --bs-default-rgb: 168, 182, 188;
  --bs-theme: #3cd2a5;
  --bs-theme-rgb: 60, 210, 165;
  --bs-primary: #4e9cff;
  --bs-primary-rgb: 78, 156, 255;
  --bs-secondary: #798e98;
  --bs-secondary-rgb: 121, 142, 152;
  --bs-warning: #ff9f0c;
  --bs-warning-rgb: 255, 159, 12;
  --bs-danger: #ff6060;
  --bs-danger-rgb: 255, 96, 96;
  --bs-success: #3cd2a5;
  --bs-success-rgb: 60, 210, 165;
  --bs-inverse: #ffffff;
  --bs-inverse-rgb: 255, 255, 255;
  --bs-info: #30beff;
  --bs-info-rgb: 48, 190, 255;
  --bs-dark: #35434a;
  --bs-dark-rgb: 53, 67, 74;
  --bs-black: #000000;
  --bs-black-rgb: 0, 0, 0;
  --bs-white: #ffffff;
  --bs-white-rgb: 255, 255, 255;
  --bs-purple: #de8cff;
  --bs-purple-rgb: 222, 140, 255;
  --bs-indigo: #bba4ff;
  --bs-indigo-rgb: 187, 164, 255;
  --bs-red: #ff6060;
  --bs-red-rgb: 255, 96, 96;
  --bs-pink: #f34fa0;
  --bs-pink-rgb: 243, 79, 160;
  --bs-green: #1ecc33;
  --bs-green-rgb: 30, 204, 51;
  --bs-yellow: #f9e80d;
  --bs-yellow-rgb: 249, 232, 13;
  --bs-teal: #3cd2a5;
  --bs-teal-rgb: 60, 210, 165;
  --bs-muted: #617a86;
  --bs-muted-rgb: 97, 122, 134;
  --bs-light: #c0cacf;
  --bs-light-rgb: 192, 202, 207;
  --bs-lime: #81f32d;
  --bs-lime-rgb: 129, 243, 45;
  --bs-gray-100: #c0cacf;
  --bs-gray-100-rgb: 192, 202, 207;
  --bs-gray-200: #a8b6bc;
  --bs-gray-200-rgb: 168, 182, 188;
  --bs-gray-300: #90a2aa;
  --bs-gray-300-rgb: 144, 162, 170;
  --bs-gray-400: #798e98;
  --bs-gray-400-rgb: 121, 142, 152;
  --bs-gray-500: #617a86;
  --bs-gray-500-rgb: 97, 122, 134;
  --bs-gray-600: #526872;
  --bs-gray-600-rgb: 82, 104, 114;
  --bs-gray-700: #44555e;
  --bs-gray-700-rgb: 68, 85, 94;
  --bs-gray-800: #35434a;
  --bs-gray-800-rgb: 53, 67, 74;
  --bs-gray-900: #273136;
  --bs-gray-900-rgb: 39, 49, 54;
  --bs-theme-color-1: #d23c3c;
  --bs-theme-color-1-rgb: 210, 60, 60;
  --bs-theme-color-2: #d23c5b;
  --bs-theme-color-2-rgb: 210, 60, 91;
  --bs-theme-color-3: #3ca7d2;
  --bs-theme-color-3-rgb: 60, 167, 210;
  --bs-theme-color-4: #3ccbd2;
  --bs-theme-color-4-rgb: 60, 203, 210;
  --bs-theme-color-5: #3cd2a5;
  --bs-theme-color-5-rgb: 60, 210, 165;
  --bs-theme-color-6: #3cd26a;
  --bs-theme-color-6-rgb: 60, 210, 106;
  --bs-theme-color-7: #a2d23c;
  --bs-theme-color-7-rgb: 162, 210, 60;
  --bs-theme-color-8: #d2bc3c;
  --bs-theme-color-8-rgb: 210, 188, 60;
  --bs-theme-color-9: #d2a83c;
  --bs-theme-color-9-rgb: 210, 168, 60;
  --bs-theme-color-10: #d26e3c;
  --bs-theme-color-10-rgb: 210, 110, 60;
}
[data-bs-theme=dark] .bg-gradient-default {
  background-color: #a8b6bc !important;
  background-image: linear-gradient(to bottom, #c5ced2, #9aaab1) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-default {
  --bs-theme: #a8b6bc !important;
  --bs-theme-rgb: 168, 182, 188 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-default-100 {
  --bs-text-opacity: 1;
  color: rgba(238, 240, 242, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(238, 240, 242, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-600 {
  --bs-text-opacity: 1;
  color: rgba(134, 146, 150, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 146, 150, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-200 {
  --bs-text-opacity: 1;
  color: rgba(220, 226, 228, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 226, 228, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-700 {
  --bs-text-opacity: 1;
  color: rgba(101, 109, 113, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(101, 109, 113, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-300 {
  --bs-text-opacity: 1;
  color: rgba(203, 211, 215, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(203, 211, 215, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-800 {
  --bs-text-opacity: 1;
  color: rgba(67, 73, 75, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(67, 73, 75, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-400 {
  --bs-text-opacity: 1;
  color: rgba(185, 197, 201, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(185, 197, 201, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-900 {
  --bs-text-opacity: 1;
  color: rgba(34, 36, 38, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(34, 36, 38, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme {
  background-color: #3cd2a5 !important;
  background-image: linear-gradient(to bottom, #65dcb8, #2ec799) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .border-theme {
  border-color: var(--bs-theme) !important;
}
[data-bs-theme=dark] .theme-theme {
  --bs-theme: #3cd2a5 !important;
  --bs-theme-rgb: 60, 210, 165 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-theme-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-primary {
  background-color: #4e9cff !important;
  background-image: linear-gradient(to bottom, #81b9ff, #358eff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-primary {
  --bs-theme: #4e9cff !important;
  --bs-theme-rgb: 78, 156, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-primary-100 {
  --bs-text-opacity: 1;
  color: rgba(220, 235, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 235, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-600 {
  --bs-text-opacity: 1;
  color: rgba(62, 125, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(62, 125, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-200 {
  --bs-text-opacity: 1;
  color: rgba(184, 215, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(184, 215, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-700 {
  --bs-text-opacity: 1;
  color: rgba(47, 94, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(47, 94, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-300 {
  --bs-text-opacity: 1;
  color: rgba(149, 196, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(149, 196, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-800 {
  --bs-text-opacity: 1;
  color: rgba(31, 62, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(31, 62, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-400 {
  --bs-text-opacity: 1;
  color: rgba(113, 176, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(113, 176, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-900 {
  --bs-text-opacity: 1;
  color: rgba(16, 31, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 31, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-secondary {
  background-color: #798e98 !important;
  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-secondary {
  --bs-theme: #798e98 !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-secondary-100 {
  --bs-text-opacity: 1;
  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-600 {
  --bs-text-opacity: 1;
  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-200 {
  --bs-text-opacity: 1;
  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-700 {
  --bs-text-opacity: 1;
  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-300 {
  --bs-text-opacity: 1;
  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-800 {
  --bs-text-opacity: 1;
  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-400 {
  --bs-text-opacity: 1;
  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-900 {
  --bs-text-opacity: 1;
  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-warning {
  background-color: #ff9f0c !important;
  background-image: linear-gradient(to bottom, #ffb33f, #f29200) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-warning {
  --bs-theme: #ff9f0c !important;
  --bs-theme-rgb: 255, 159, 12 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-warning-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 236, 206, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 236, 206, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 127, 10, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 127, 10, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 217, 158, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 217, 158, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 95, 7, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 95, 7, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 197, 109, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 197, 109, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 64, 5, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 64, 5, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 178, 61, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 178, 61, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 32, 2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 32, 2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-danger {
  background-color: #ff6060 !important;
  background-image: linear-gradient(to bottom, #ff9393, #ff4747) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-danger {
  --bs-theme: #ff6060 !important;
  --bs-theme-rgb: 255, 96, 96 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-danger-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 223, 223, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 223, 223, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 77, 77, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 77, 77, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 191, 191, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 191, 191, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 58, 58, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 58, 58, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 160, 160, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 160, 160, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 38, 38, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 38, 38, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 128, 128, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 128, 128, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 19, 19, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 19, 19, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-success {
  background-color: #3cd2a5 !important;
  background-image: linear-gradient(to bottom, #65dcb8, #2ec799) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-success {
  --bs-theme: #3cd2a5 !important;
  --bs-theme-rgb: 60, 210, 165 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-success-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-inverse {
  background-color: #ffffff !important;
  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-inverse {
  --bs-theme: #ffffff !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-inverse-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-info {
  background-color: #30beff !important;
  background-image: linear-gradient(to bottom, #63ceff, #17b6ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-info {
  --bs-theme: #30beff !important;
  --bs-theme-rgb: 48, 190, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-info-100 {
  --bs-text-opacity: 1;
  color: rgba(214, 242, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(214, 242, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-600 {
  --bs-text-opacity: 1;
  color: rgba(38, 152, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(38, 152, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-200 {
  --bs-text-opacity: 1;
  color: rgba(172, 229, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(172, 229, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-700 {
  --bs-text-opacity: 1;
  color: rgba(29, 114, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(29, 114, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-300 {
  --bs-text-opacity: 1;
  color: rgba(131, 216, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(131, 216, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-800 {
  --bs-text-opacity: 1;
  color: rgba(19, 76, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(19, 76, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-400 {
  --bs-text-opacity: 1;
  color: rgba(89, 203, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(89, 203, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-900 {
  --bs-text-opacity: 1;
  color: rgba(10, 38, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(10, 38, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-dark {
  background-color: #35434a !important;
  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-dark {
  --bs-theme: #35434a !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-dark-100 {
  --bs-text-opacity: 1;
  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-600 {
  --bs-text-opacity: 1;
  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-200 {
  --bs-text-opacity: 1;
  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-700 {
  --bs-text-opacity: 1;
  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-300 {
  --bs-text-opacity: 1;
  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-800 {
  --bs-text-opacity: 1;
  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-400 {
  --bs-text-opacity: 1;
  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-900 {
  --bs-text-opacity: 1;
  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-black {
  background-color: #000000 !important;
  background-image: linear-gradient(to bottom, #1a1a1a, black) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-black {
  --bs-theme: #000000 !important;
  --bs-theme-rgb: 0, 0, 0 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-black-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-white {
  background-color: #ffffff !important;
  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-white {
  --bs-theme: #ffffff !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-white-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-purple {
  background-color: #de8cff !important;
  background-image: linear-gradient(to bottom, #edbfff, #d773ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-purple {
  --bs-theme: #de8cff !important;
  --bs-theme-rgb: 222, 140, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-purple-100 {
  --bs-text-opacity: 1;
  color: rgba(248, 232, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(248, 232, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-600 {
  --bs-text-opacity: 1;
  color: rgba(178, 112, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(178, 112, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-200 {
  --bs-text-opacity: 1;
  color: rgba(242, 209, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(242, 209, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-700 {
  --bs-text-opacity: 1;
  color: rgba(133, 84, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(133, 84, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-300 {
  --bs-text-opacity: 1;
  color: rgba(235, 186, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(235, 186, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-800 {
  --bs-text-opacity: 1;
  color: rgba(89, 56, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(89, 56, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-400 {
  --bs-text-opacity: 1;
  color: rgba(229, 163, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(229, 163, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-900 {
  --bs-text-opacity: 1;
  color: rgba(44, 28, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(44, 28, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-indigo {
  background-color: #bba4ff !important;
  background-image: linear-gradient(to bottom, #e1d7ff, #a88bff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-indigo {
  --bs-theme: #bba4ff !important;
  --bs-theme-rgb: 187, 164, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-indigo-100 {
  --bs-text-opacity: 1;
  color: rgba(241, 237, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(241, 237, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-600 {
  --bs-text-opacity: 1;
  color: rgba(150, 131, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(150, 131, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-200 {
  --bs-text-opacity: 1;
  color: rgba(228, 219, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 219, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-700 {
  --bs-text-opacity: 1;
  color: rgba(112, 98, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(112, 98, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-300 {
  --bs-text-opacity: 1;
  color: rgba(214, 200, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(214, 200, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-800 {
  --bs-text-opacity: 1;
  color: rgba(75, 66, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(75, 66, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-400 {
  --bs-text-opacity: 1;
  color: rgba(201, 182, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(201, 182, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-900 {
  --bs-text-opacity: 1;
  color: rgba(37, 33, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(37, 33, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-red {
  background-color: #ff6060 !important;
  background-image: linear-gradient(to bottom, #ff9393, #ff4747) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-red {
  --bs-theme: #ff6060 !important;
  --bs-theme-rgb: 255, 96, 96 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-red-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 223, 223, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 223, 223, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 77, 77, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 77, 77, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 191, 191, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 191, 191, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 58, 58, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 58, 58, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 160, 160, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 160, 160, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 38, 38, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 38, 38, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 128, 128, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 128, 128, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 19, 19, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 19, 19, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-pink {
  background-color: #f34fa0 !important;
  background-image: linear-gradient(to bottom, #f67fba, #f13793) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-pink {
  --bs-theme: #f34fa0 !important;
  --bs-theme-rgb: 243, 79, 160 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-pink-100 {
  --bs-text-opacity: 1;
  color: rgba(253, 220, 236, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(253, 220, 236, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-600 {
  --bs-text-opacity: 1;
  color: rgba(194, 63, 128, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(194, 63, 128, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-200 {
  --bs-text-opacity: 1;
  color: rgba(250, 185, 217, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 185, 217, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-700 {
  --bs-text-opacity: 1;
  color: rgba(146, 47, 96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(146, 47, 96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-300 {
  --bs-text-opacity: 1;
  color: rgba(248, 149, 198, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(248, 149, 198, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-800 {
  --bs-text-opacity: 1;
  color: rgba(97, 32, 64, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(97, 32, 64, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-400 {
  --bs-text-opacity: 1;
  color: rgba(245, 114, 179, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(245, 114, 179, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-900 {
  --bs-text-opacity: 1;
  color: rgba(49, 16, 32, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(49, 16, 32, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-green {
  background-color: #1ecc33 !important;
  background-image: linear-gradient(to bottom, #3be24f, #1bb62d) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-green {
  --bs-theme: #1ecc33 !important;
  --bs-theme-rgb: 30, 204, 51 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-green-100 {
  --bs-text-opacity: 1;
  color: rgba(210, 245, 214, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(210, 245, 214, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-600 {
  --bs-text-opacity: 1;
  color: rgba(24, 163, 41, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 163, 41, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-200 {
  --bs-text-opacity: 1;
  color: rgba(165, 235, 173, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(165, 235, 173, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-700 {
  --bs-text-opacity: 1;
  color: rgba(18, 122, 31, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(18, 122, 31, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-300 {
  --bs-text-opacity: 1;
  color: rgba(120, 224, 133, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(120, 224, 133, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-800 {
  --bs-text-opacity: 1;
  color: rgba(12, 82, 20, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 82, 20, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-400 {
  --bs-text-opacity: 1;
  color: rgba(75, 214, 92, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(75, 214, 92, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-900 {
  --bs-text-opacity: 1;
  color: rgba(6, 41, 10, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(6, 41, 10, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-yellow {
  background-color: #f9e80d !important;
  background-image: linear-gradient(to bottom, #faed3f, #e7d706) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-yellow {
  --bs-theme: #f9e80d !important;
  --bs-theme-rgb: 249, 232, 13 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-yellow-100 {
  --bs-text-opacity: 1;
  color: rgba(254, 250, 207, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(254, 250, 207, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-600 {
  --bs-text-opacity: 1;
  color: rgba(199, 186, 10, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(199, 186, 10, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-200 {
  --bs-text-opacity: 1;
  color: rgba(253, 246, 158, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(253, 246, 158, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-700 {
  --bs-text-opacity: 1;
  color: rgba(149, 139, 8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(149, 139, 8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-300 {
  --bs-text-opacity: 1;
  color: rgba(251, 241, 110, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(251, 241, 110, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-800 {
  --bs-text-opacity: 1;
  color: rgba(100, 93, 5, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(100, 93, 5, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-400 {
  --bs-text-opacity: 1;
  color: rgba(250, 237, 61, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 237, 61, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-900 {
  --bs-text-opacity: 1;
  color: rgba(50, 46, 3, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(50, 46, 3, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-teal {
  background-color: #3cd2a5 !important;
  background-image: linear-gradient(to bottom, #65dcb8, #2ec799) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-teal {
  --bs-theme: #3cd2a5 !important;
  --bs-theme-rgb: 60, 210, 165 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-teal-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-muted {
  background-color: #617a86 !important;
  background-image: linear-gradient(to bottom, #7b939f, #566d77) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-muted {
  --bs-theme: #617a86 !important;
  --bs-theme-rgb: 97, 122, 134 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-muted-100 {
  --bs-text-opacity: 1;
  color: rgba(223, 228, 231, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(223, 228, 231, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-600 {
  --bs-text-opacity: 1;
  color: rgba(78, 98, 107, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(78, 98, 107, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-200 {
  --bs-text-opacity: 1;
  color: rgba(192, 202, 207, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(192, 202, 207, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-700 {
  --bs-text-opacity: 1;
  color: rgba(58, 73, 80, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(58, 73, 80, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-300 {
  --bs-text-opacity: 1;
  color: rgba(160, 175, 182, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(160, 175, 182, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-800 {
  --bs-text-opacity: 1;
  color: rgba(39, 49, 54, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(39, 49, 54, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-400 {
  --bs-text-opacity: 1;
  color: rgba(129, 149, 158, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(129, 149, 158, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-900 {
  --bs-text-opacity: 1;
  color: rgba(19, 24, 27, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(19, 24, 27, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-light {
  background-color: #c0cacf !important;
  background-image: linear-gradient(to bottom, #dde2e5, #b2bec4) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-light {
  --bs-theme: #c0cacf !important;
  --bs-theme-rgb: 192, 202, 207 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-light-100 {
  --bs-text-opacity: 1;
  color: rgba(242, 244, 245, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(242, 244, 245, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-600 {
  --bs-text-opacity: 1;
  color: rgba(154, 162, 166, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(154, 162, 166, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-200 {
  --bs-text-opacity: 1;
  color: rgba(230, 234, 236, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(230, 234, 236, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-700 {
  --bs-text-opacity: 1;
  color: rgba(115, 121, 124, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(115, 121, 124, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-300 {
  --bs-text-opacity: 1;
  color: rgba(217, 223, 226, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(217, 223, 226, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-800 {
  --bs-text-opacity: 1;
  color: rgba(77, 81, 83, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(77, 81, 83, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-400 {
  --bs-text-opacity: 1;
  color: rgba(205, 213, 217, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(205, 213, 217, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-900 {
  --bs-text-opacity: 1;
  color: rgba(38, 40, 41, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(38, 40, 41, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-lime {
  background-color: #81f32d !important;
  background-image: linear-gradient(to bottom, #9ef65d, #73f215) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-lime {
  --bs-theme: #81f32d !important;
  --bs-theme-rgb: 129, 243, 45 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-lime-100 {
  --bs-text-opacity: 1;
  color: rgba(230, 253, 213, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(230, 253, 213, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-600 {
  --bs-text-opacity: 1;
  color: rgba(103, 194, 36, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(103, 194, 36, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-200 {
  --bs-text-opacity: 1;
  color: rgba(205, 250, 171, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(205, 250, 171, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-700 {
  --bs-text-opacity: 1;
  color: rgba(77, 146, 27, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(77, 146, 27, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-300 {
  --bs-text-opacity: 1;
  color: rgba(179, 248, 129, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(179, 248, 129, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-800 {
  --bs-text-opacity: 1;
  color: rgba(52, 97, 18, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(52, 97, 18, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-400 {
  --bs-text-opacity: 1;
  color: rgba(154, 245, 87, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(154, 245, 87, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-900 {
  --bs-text-opacity: 1;
  color: rgba(26, 49, 9, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(26, 49, 9, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-100 {
  background-color: #c0cacf !important;
  background-image: linear-gradient(to bottom, #dde2e5, #b2bec4) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-100 {
  --bs-theme: #c0cacf !important;
  --bs-theme-rgb: 192, 202, 207 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-gray-100-100 {
  --bs-text-opacity: 1;
  color: rgba(242, 244, 245, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(242, 244, 245, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-600 {
  --bs-text-opacity: 1;
  color: rgba(154, 162, 166, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(154, 162, 166, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-200 {
  --bs-text-opacity: 1;
  color: rgba(230, 234, 236, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(230, 234, 236, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-700 {
  --bs-text-opacity: 1;
  color: rgba(115, 121, 124, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(115, 121, 124, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-300 {
  --bs-text-opacity: 1;
  color: rgba(217, 223, 226, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(217, 223, 226, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-800 {
  --bs-text-opacity: 1;
  color: rgba(77, 81, 83, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(77, 81, 83, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-400 {
  --bs-text-opacity: 1;
  color: rgba(205, 213, 217, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(205, 213, 217, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-900 {
  --bs-text-opacity: 1;
  color: rgba(38, 40, 41, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(38, 40, 41, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-200 {
  background-color: #a8b6bc !important;
  background-image: linear-gradient(to bottom, #c5ced2, #9aaab1) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-200 {
  --bs-theme: #a8b6bc !important;
  --bs-theme-rgb: 168, 182, 188 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-gray-200-100 {
  --bs-text-opacity: 1;
  color: rgba(238, 240, 242, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(238, 240, 242, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-600 {
  --bs-text-opacity: 1;
  color: rgba(134, 146, 150, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 146, 150, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-200 {
  --bs-text-opacity: 1;
  color: rgba(220, 226, 228, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 226, 228, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-700 {
  --bs-text-opacity: 1;
  color: rgba(101, 109, 113, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(101, 109, 113, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-300 {
  --bs-text-opacity: 1;
  color: rgba(203, 211, 215, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(203, 211, 215, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-800 {
  --bs-text-opacity: 1;
  color: rgba(67, 73, 75, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(67, 73, 75, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-400 {
  --bs-text-opacity: 1;
  color: rgba(185, 197, 201, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(185, 197, 201, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-900 {
  --bs-text-opacity: 1;
  color: rgba(34, 36, 38, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(34, 36, 38, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-300 {
  background-color: #90a2aa !important;
  background-image: linear-gradient(to bottom, #adbac0, #82969f) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-300 {
  --bs-theme: #90a2aa !important;
  --bs-theme-rgb: 144, 162, 170 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-gray-300-100 {
  --bs-text-opacity: 1;
  color: rgba(233, 236, 238, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(233, 236, 238, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-600 {
  --bs-text-opacity: 1;
  color: rgba(115, 130, 136, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(115, 130, 136, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-200 {
  --bs-text-opacity: 1;
  color: rgba(211, 218, 221, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(211, 218, 221, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-700 {
  --bs-text-opacity: 1;
  color: rgba(86, 97, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(86, 97, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-300 {
  --bs-text-opacity: 1;
  color: rgba(188, 199, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(188, 199, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-800 {
  --bs-text-opacity: 1;
  color: rgba(58, 65, 68, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(58, 65, 68, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-400 {
  --bs-text-opacity: 1;
  color: rgba(166, 181, 187, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(166, 181, 187, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-900 {
  --bs-text-opacity: 1;
  color: rgba(29, 32, 34, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(29, 32, 34, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-400 {
  background-color: #798e98 !important;
  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-400 {
  --bs-theme: #798e98 !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-400-100 {
  --bs-text-opacity: 1;
  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-600 {
  --bs-text-opacity: 1;
  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-200 {
  --bs-text-opacity: 1;
  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-700 {
  --bs-text-opacity: 1;
  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-300 {
  --bs-text-opacity: 1;
  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-800 {
  --bs-text-opacity: 1;
  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-400 {
  --bs-text-opacity: 1;
  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-900 {
  --bs-text-opacity: 1;
  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-500 {
  background-color: #617a86 !important;
  background-image: linear-gradient(to bottom, #7b939f, #566d77) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-500 {
  --bs-theme: #617a86 !important;
  --bs-theme-rgb: 97, 122, 134 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-500-100 {
  --bs-text-opacity: 1;
  color: rgba(223, 228, 231, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(223, 228, 231, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-600 {
  --bs-text-opacity: 1;
  color: rgba(78, 98, 107, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(78, 98, 107, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-200 {
  --bs-text-opacity: 1;
  color: rgba(192, 202, 207, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(192, 202, 207, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-700 {
  --bs-text-opacity: 1;
  color: rgba(58, 73, 80, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(58, 73, 80, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-300 {
  --bs-text-opacity: 1;
  color: rgba(160, 175, 182, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(160, 175, 182, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-800 {
  --bs-text-opacity: 1;
  color: rgba(39, 49, 54, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(39, 49, 54, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-400 {
  --bs-text-opacity: 1;
  color: rgba(129, 149, 158, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(129, 149, 158, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-900 {
  --bs-text-opacity: 1;
  color: rgba(19, 24, 27, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(19, 24, 27, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-600 {
  background-color: #526872 !important;
  background-image: linear-gradient(to bottom, #678390, #475a63) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-600 {
  --bs-theme: #526872 !important;
  --bs-theme-rgb: 82, 104, 114 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-600-100 {
  --bs-text-opacity: 1;
  color: rgba(220, 225, 227, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 225, 227, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-600 {
  --bs-text-opacity: 1;
  color: rgba(66, 83, 91, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(66, 83, 91, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-200 {
  --bs-text-opacity: 1;
  color: rgba(186, 195, 199, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(186, 195, 199, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-700 {
  --bs-text-opacity: 1;
  color: rgba(49, 62, 68, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(49, 62, 68, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-300 {
  --bs-text-opacity: 1;
  color: rgba(151, 164, 170, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(151, 164, 170, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-800 {
  --bs-text-opacity: 1;
  color: rgba(33, 42, 46, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(33, 42, 46, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-400 {
  --bs-text-opacity: 1;
  color: rgba(117, 134, 142, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(117, 134, 142, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-900 {
  --bs-text-opacity: 1;
  color: rgba(16, 21, 23, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 21, 23, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-700 {
  background-color: #44555e !important;
  background-image: linear-gradient(to bottom, #59707c, #39484f) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-700 {
  --bs-theme: #44555e !important;
  --bs-theme-rgb: 68, 85, 94 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-700-100 {
  --bs-text-opacity: 1;
  color: rgba(218, 221, 223, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(218, 221, 223, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-600 {
  --bs-text-opacity: 1;
  color: rgba(54, 68, 75, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(54, 68, 75, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-200 {
  --bs-text-opacity: 1;
  color: rgba(180, 187, 191, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(180, 187, 191, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-700 {
  --bs-text-opacity: 1;
  color: rgba(41, 51, 56, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(41, 51, 56, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-300 {
  --bs-text-opacity: 1;
  color: rgba(143, 153, 158, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(143, 153, 158, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-800 {
  --bs-text-opacity: 1;
  color: rgba(27, 34, 38, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(27, 34, 38, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-400 {
  --bs-text-opacity: 1;
  color: rgba(105, 119, 126, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(105, 119, 126, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-900 {
  --bs-text-opacity: 1;
  color: rgba(14, 17, 19, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(14, 17, 19, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-800 {
  background-color: #35434a !important;
  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-800 {
  --bs-theme: #35434a !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-800-100 {
  --bs-text-opacity: 1;
  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-600 {
  --bs-text-opacity: 1;
  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-200 {
  --bs-text-opacity: 1;
  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-700 {
  --bs-text-opacity: 1;
  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-300 {
  --bs-text-opacity: 1;
  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-800 {
  --bs-text-opacity: 1;
  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-400 {
  --bs-text-opacity: 1;
  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-900 {
  --bs-text-opacity: 1;
  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-900 {
  background-color: #273136 !important;
  background-image: linear-gradient(to bottom, #3c4c54, #1c2427) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-900 {
  --bs-theme: #273136 !important;
  --bs-theme-rgb: 39, 49, 54 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-900-100 {
  --bs-text-opacity: 1;
  color: rgba(212, 214, 215, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(212, 214, 215, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-600 {
  --bs-text-opacity: 1;
  color: rgba(31, 39, 43, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(31, 39, 43, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-200 {
  --bs-text-opacity: 1;
  color: rgba(169, 173, 175, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(169, 173, 175, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-700 {
  --bs-text-opacity: 1;
  color: rgba(23, 29, 32, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(23, 29, 32, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-300 {
  --bs-text-opacity: 1;
  color: rgba(125, 131, 134, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(125, 131, 134, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-800 {
  --bs-text-opacity: 1;
  color: rgba(16, 20, 22, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 20, 22, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-400 {
  --bs-text-opacity: 1;
  color: rgba(82, 90, 94, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(82, 90, 94, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-900 {
  --bs-text-opacity: 1;
  color: rgba(8, 10, 11, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(8, 10, 11, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-1 {
  background-color: #d23c3c !important;
  background-image: linear-gradient(to bottom, #dc6565, #c72e2e) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-1 {
  --bs-theme: #d23c3c !important;
  --bs-theme-rgb: 210, 60, 60 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-theme-color-1-100 {
  --bs-text-opacity: 1;
  color: rgba(246, 216, 216, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-1-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(246, 216, 216, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-1-600 {
  --bs-text-opacity: 1;
  color: rgba(168, 48, 48, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-1-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(168, 48, 48, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-1-200 {
  --bs-text-opacity: 1;
  color: rgba(237, 177, 177, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-1-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(237, 177, 177, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-1-700 {
  --bs-text-opacity: 1;
  color: rgba(126, 36, 36, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-1-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(126, 36, 36, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-1-300 {
  --bs-text-opacity: 1;
  color: rgba(228, 138, 138, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-1-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 138, 138, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-1-800 {
  --bs-text-opacity: 1;
  color: rgba(84, 24, 24, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-1-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(84, 24, 24, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-1-400 {
  --bs-text-opacity: 1;
  color: rgba(219, 99, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-1-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(219, 99, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-1-900 {
  --bs-text-opacity: 1;
  color: rgba(42, 12, 12, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-1-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 12, 12, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-2 {
  background-color: #d23c5b !important;
  background-image: linear-gradient(to bottom, #dc657e, #c72e4d) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-2 {
  --bs-theme: #d23c5b !important;
  --bs-theme-rgb: 210, 60, 91 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-theme-color-2-100 {
  --bs-text-opacity: 1;
  color: rgba(246, 216, 222, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-2-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(246, 216, 222, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-2-600 {
  --bs-text-opacity: 1;
  color: rgba(168, 48, 73, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-2-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(168, 48, 73, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-2-200 {
  --bs-text-opacity: 1;
  color: rgba(237, 177, 189, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-2-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(237, 177, 189, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-2-700 {
  --bs-text-opacity: 1;
  color: rgba(126, 36, 55, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-2-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(126, 36, 55, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-2-300 {
  --bs-text-opacity: 1;
  color: rgba(228, 138, 157, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-2-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 138, 157, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-2-800 {
  --bs-text-opacity: 1;
  color: rgba(84, 24, 36, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-2-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(84, 24, 36, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-2-400 {
  --bs-text-opacity: 1;
  color: rgba(219, 99, 124, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-2-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(219, 99, 124, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-2-900 {
  --bs-text-opacity: 1;
  color: rgba(42, 12, 18, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-2-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 12, 18, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-3 {
  background-color: #3ca7d2 !important;
  background-image: linear-gradient(to bottom, #65badc, #2e9bc7) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-3 {
  --bs-theme: #3ca7d2 !important;
  --bs-theme-rgb: 60, 167, 210 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-theme-color-3-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 237, 246, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-3-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 237, 246, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-3-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 134, 168, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-3-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 134, 168, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-3-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 220, 237, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-3-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 220, 237, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-3-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 100, 126, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-3-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 100, 126, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-3-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 202, 228, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-3-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 202, 228, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-3-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 67, 84, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-3-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 67, 84, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-3-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 185, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-3-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 185, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-3-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 33, 42, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-3-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 33, 42, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-4 {
  background-color: #3ccbd2 !important;
  background-image: linear-gradient(to bottom, #65d6dc, #2ec0c7) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-4 {
  --bs-theme: #3ccbd2 !important;
  --bs-theme-rgb: 60, 203, 210 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-theme-color-4-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 245, 246, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-4-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 245, 246, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-4-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 162, 168, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-4-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 162, 168, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-4-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 234, 237, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-4-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 234, 237, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-4-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 122, 126, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-4-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 122, 126, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-4-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 224, 228, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-4-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 224, 228, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-4-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 81, 84, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-4-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 81, 84, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-4-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 213, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-4-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 213, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-4-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 41, 42, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-4-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 41, 42, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-5 {
  background-color: #3cd2a5 !important;
  background-image: linear-gradient(to bottom, #65dcb8, #2ec799) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-5 {
  --bs-theme: #3cd2a5 !important;
  --bs-theme-rgb: 60, 210, 165 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-theme-color-5-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-5-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-5-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-5-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-5-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-5-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-5-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-5-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-5-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-5-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-5-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-5-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-5-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-5-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-5-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-5-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-6 {
  background-color: #3cd26a !important;
  background-image: linear-gradient(to bottom, #65dc8a, #2ec75d) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-6 {
  --bs-theme: #3cd26a !important;
  --bs-theme-rgb: 60, 210, 106 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-theme-color-6-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 246, 225, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-6-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 246, 225, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-6-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 168, 85, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-6-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 168, 85, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-6-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 237, 195, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-6-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 237, 195, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-6-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 126, 64, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-6-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 126, 64, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-6-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 228, 166, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-6-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 228, 166, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-6-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 84, 42, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-6-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 84, 42, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-6-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 219, 136, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-6-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 219, 136, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-6-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 42, 21, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-6-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 42, 21, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-7 {
  background-color: #a2d23c !important;
  background-image: linear-gradient(to bottom, #b6dc65, #96c72e) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-7 {
  --bs-theme: #a2d23c !important;
  --bs-theme-rgb: 162, 210, 60 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-theme-color-7-100 {
  --bs-text-opacity: 1;
  color: rgba(236, 246, 216, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-7-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(236, 246, 216, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-7-600 {
  --bs-text-opacity: 1;
  color: rgba(130, 168, 48, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-7-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(130, 168, 48, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-7-200 {
  --bs-text-opacity: 1;
  color: rgba(218, 237, 177, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-7-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(218, 237, 177, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-7-700 {
  --bs-text-opacity: 1;
  color: rgba(97, 126, 36, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-7-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(97, 126, 36, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-7-300 {
  --bs-text-opacity: 1;
  color: rgba(199, 228, 138, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-7-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(199, 228, 138, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-7-800 {
  --bs-text-opacity: 1;
  color: rgba(65, 84, 24, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-7-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(65, 84, 24, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-7-400 {
  --bs-text-opacity: 1;
  color: rgba(181, 219, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-7-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(181, 219, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-7-900 {
  --bs-text-opacity: 1;
  color: rgba(32, 42, 12, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-7-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(32, 42, 12, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-8 {
  background-color: #d2bc3c !important;
  background-image: linear-gradient(to bottom, #dcca65, #c7b02e) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-8 {
  --bs-theme: #d2bc3c !important;
  --bs-theme-rgb: 210, 188, 60 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-theme-color-8-100 {
  --bs-text-opacity: 1;
  color: rgba(246, 242, 216, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-8-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(246, 242, 216, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-8-600 {
  --bs-text-opacity: 1;
  color: rgba(168, 150, 48, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-8-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(168, 150, 48, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-8-200 {
  --bs-text-opacity: 1;
  color: rgba(237, 228, 177, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-8-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(237, 228, 177, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-8-700 {
  --bs-text-opacity: 1;
  color: rgba(126, 113, 36, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-8-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(126, 113, 36, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-8-300 {
  --bs-text-opacity: 1;
  color: rgba(228, 215, 138, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-8-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 215, 138, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-8-800 {
  --bs-text-opacity: 1;
  color: rgba(84, 75, 24, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-8-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(84, 75, 24, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-8-400 {
  --bs-text-opacity: 1;
  color: rgba(219, 201, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-8-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(219, 201, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-8-900 {
  --bs-text-opacity: 1;
  color: rgba(42, 38, 12, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-8-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 38, 12, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-9 {
  background-color: #d2a83c !important;
  background-image: linear-gradient(to bottom, #dcba65, #c79c2e) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-9 {
  --bs-theme: #d2a83c !important;
  --bs-theme-rgb: 210, 168, 60 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-theme-color-9-100 {
  --bs-text-opacity: 1;
  color: rgba(246, 238, 216, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-9-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(246, 238, 216, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-9-600 {
  --bs-text-opacity: 1;
  color: rgba(168, 134, 48, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-9-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(168, 134, 48, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-9-200 {
  --bs-text-opacity: 1;
  color: rgba(237, 220, 177, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-9-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(237, 220, 177, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-9-700 {
  --bs-text-opacity: 1;
  color: rgba(126, 101, 36, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-9-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(126, 101, 36, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-9-300 {
  --bs-text-opacity: 1;
  color: rgba(228, 203, 138, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-9-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 203, 138, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-9-800 {
  --bs-text-opacity: 1;
  color: rgba(84, 67, 24, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-9-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(84, 67, 24, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-9-400 {
  --bs-text-opacity: 1;
  color: rgba(219, 185, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-9-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(219, 185, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-9-900 {
  --bs-text-opacity: 1;
  color: rgba(42, 34, 12, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-9-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 34, 12, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme-color-10 {
  background-color: #d26e3c !important;
  background-image: linear-gradient(to bottom, #dc8d65, #c7612e) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-theme-color-10 {
  --bs-theme: #d26e3c !important;
  --bs-theme-rgb: 210, 110, 60 !important;
  --bs-theme-color: #ffffff !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-theme-color-10-100 {
  --bs-text-opacity: 1;
  color: rgba(246, 226, 216, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-10-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(246, 226, 216, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-10-600 {
  --bs-text-opacity: 1;
  color: rgba(168, 88, 48, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-10-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(168, 88, 48, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-10-200 {
  --bs-text-opacity: 1;
  color: rgba(237, 197, 177, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-10-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(237, 197, 177, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-10-700 {
  --bs-text-opacity: 1;
  color: rgba(126, 66, 36, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-10-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(126, 66, 36, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-10-300 {
  --bs-text-opacity: 1;
  color: rgba(228, 168, 138, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-10-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(228, 168, 138, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-10-800 {
  --bs-text-opacity: 1;
  color: rgba(84, 44, 24, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-10-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(84, 44, 24, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-10-400 {
  --bs-text-opacity: 1;
  color: rgba(219, 139, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-10-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(219, 139, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-color-10-900 {
  --bs-text-opacity: 1;
  color: rgba(42, 22, 12, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-color-10-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(42, 22, 12, var(--bs-bg-opacity)) !important;
}

.bg-none {
  background: none !important;
}

.bg-position-center {
  background-position: center !important;
}

.bg-size-cover {
  background-size: cover !important;
}

.bg-repeat-no-repeat {
  background-repeat: no-repeat !important;
}

.bg-gradient-orange-red {
  background: #ffb33f;
}

.bg-gradient-orange-red {
  background: linear-gradient(to top, #ffb33f, #ff1414) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-red-orange {
  background: #ff1414;
}

.bg-gradient-red-orange {
  background: linear-gradient(to top, #ff1414, #ffb33f) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-red-pink {
  background: #ff1414;
}

.bg-gradient-red-pink {
  background: linear-gradient(to top, #ff1414, #f13893) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-yellow-orange {
  background: #faed3f;
}

.bg-gradient-yellow-orange {
  background: linear-gradient(to top, #faed3f, #ffb33f) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-yellow-red {
  background: #faed3f;
}

.bg-gradient-yellow-red {
  background: linear-gradient(to top, #faed3f, #ff1414) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-yellow-green {
  background: #faed3f;
}

.bg-gradient-yellow-green {
  background: linear-gradient(to top, #faed3f, #1ab62d) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-blue-indigo {
  background: #0271ff;
}

.bg-gradient-blue-indigo {
  background: linear-gradient(to top, #0271ff, #5c25ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-blue-cyan {
  background: #0271ff;
}

.bg-gradient-blue-cyan {
  background: linear-gradient(to top, #0271ff, #009be3) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-cyan-blue {
  background: #009be3;
}

.bg-gradient-cyan-blue {
  background: linear-gradient(to top, #009be3, #0271ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-cyan-indigo {
  background: #009be3;
}

.bg-gradient-cyan-indigo {
  background: linear-gradient(to top, #009be3, #5c25ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-indigo-blue {
  background: #5c25ff;
}

.bg-gradient-indigo-blue {
  background: linear-gradient(to top, #5c25ff, #0271ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-orange {
  background: #f57260;
}

.bg-gradient-custom-orange {
  background: linear-gradient(to left, #f57260, #f78f81) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-pink {
  background: #ef1d84;
}

.bg-gradient-custom-pink {
  background: linear-gradient(to left, #ef1d84, #f13f96) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-teal {
  background: #1e8163;
}

.bg-gradient-custom-teal {
  background: linear-gradient(to left, #1e8163, #249d79) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-indigo {
  background: #8a66f6;
}

.bg-gradient-custom-indigo {
  background: linear-gradient(to left, #8a66f6, #b39bf9) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-blue {
  background: #0271ff;
}

.bg-gradient-custom-blue {
  background: linear-gradient(to left, #0271ff, #358eff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-indigo-teal {
  background-image: linear-gradient(to left, #5c25ff, #0271ff, #249d79) !important;
}

[data-bs-theme=dark] .invert-dark {
  filter: invert(1);
}

/* Helper Opacity */
.opacity-0 {
  opacity: 0 !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.text-opacity-0 {
  --bs-text-opacity: 0;
}

.text-opacity-5 {
  --bs-text-opacity: 0.05;
}

.bg-opacity-0 {
  --bs-bg-opacity: 0;
}

.bg-opacity-5 {
  --bs-bg-opacity: 0.05;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.text-opacity-10 {
  --bs-text-opacity: 0.1;
}

.text-opacity-15 {
  --bs-text-opacity: 0.15;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-15 {
  --bs-bg-opacity: 0.15;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-30 {
  opacity: 0.3 !important;
}

.text-opacity-20 {
  --bs-text-opacity: 0.2;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.bg-opacity-20 {
  --bs-bg-opacity: 0.2;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-45 {
  opacity: 0.45 !important;
}

.text-opacity-30 {
  --bs-text-opacity: 0.3;
}

.text-opacity-35 {
  --bs-text-opacity: 0.35;
}

.bg-opacity-30 {
  --bs-bg-opacity: 0.3;
}

.bg-opacity-35 {
  --bs-bg-opacity: 0.35;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-60 {
  opacity: 0.6 !important;
}

.text-opacity-40 {
  --bs-text-opacity: 0.4;
}

.text-opacity-45 {
  --bs-text-opacity: 0.45;
}

.bg-opacity-40 {
  --bs-bg-opacity: 0.4;
}

.bg-opacity-45 {
  --bs-bg-opacity: 0.45;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-55 {
  --bs-text-opacity: 0.55;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-55 {
  --bs-bg-opacity: 0.55;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-90 {
  opacity: 0.9 !important;
}

.text-opacity-60 {
  --bs-text-opacity: 0.6;
}

.text-opacity-65 {
  --bs-text-opacity: 0.65;
}

.bg-opacity-60 {
  --bs-bg-opacity: 0.6;
}

.bg-opacity-65 {
  --bs-bg-opacity: 0.65;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-105 {
  opacity: 1.05 !important;
}

.text-opacity-70 {
  --bs-text-opacity: 0.7;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.bg-opacity-70 {
  --bs-bg-opacity: 0.7;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-120 {
  opacity: 1.2 !important;
}

.text-opacity-80 {
  --bs-text-opacity: 0.8;
}

.text-opacity-85 {
  --bs-text-opacity: 0.85;
}

.bg-opacity-80 {
  --bs-bg-opacity: 0.8;
}

.bg-opacity-85 {
  --bs-bg-opacity: 0.85;
}

.opacity-9 {
  opacity: 0.9 !important;
}

.opacity-135 {
  opacity: 1.35 !important;
}

.text-opacity-90 {
  --bs-text-opacity: 0.9;
}

.text-opacity-95 {
  --bs-text-opacity: 0.95;
}

.bg-opacity-90 {
  --bs-bg-opacity: 0.9;
}

.bg-opacity-95 {
  --bs-bg-opacity: 0.95;
}

.opacity-10 {
  opacity: 1 !important;
}

.opacity-150 {
  opacity: 1.5 !important;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-opacity-105 {
  --bs-text-opacity: 1.05;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-opacity-105 {
  --bs-bg-opacity: 1.05;
}

/* Helper Sticky Top */
@media (min-width: 1200px) {
  .desktop-sticky-top {
    position: sticky;
    top: 4.5rem;
  }
}

/* Helper Outline */
.outline-none {
  outline: none !important;
}

/* Helper Flex */
.flex-1 {
  flex: 1 1 !important;
}

/* Helper Theme */
.list-group-item.active,
.page-item.active .page-link,
.form-check-input:checked,
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: var(--bs-theme);
  border-color: var(--bs-theme);
}

.btn-theme {
  background-color: var(--bs-theme);
  border-color: var(--bs-theme);
  position: relative;
}
.btn-theme:before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border-radius: 4px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn-theme:before {
    transition: none;
  }
}
.btn-theme.disabled, .btn-theme:disabled {
  background-color: var(--bs-theme);
  border-color: var(--bs-theme);
}
.btn-theme:hover, .btn-theme:focus, .btn-theme:active, .btn-theme.active {
  background-color: var(--bs-theme);
  border-color: var(--bs-theme);
}
.btn-theme:hover:before, .btn-theme:focus:before, .btn-theme:active:before, .btn-theme.active:before {
  background: rgba(255, 255, 255, 0.2);
}
.btn-outline-theme {
  color: var(--bs-theme);
  border-color: var(--bs-theme);
}
.btn-outline-theme:hover, .btn-outline-theme.active, .btn-outline-theme:active {
  background-color: var(--bs-theme) !important;
  border-color: var(--bs-theme) !important;
}
.btn-outline-theme.disabled, .btn-outline-theme:disabled {
  color: var(--bs-theme);
}
.nav-link {
  color: var(--bs-theme);
}
.nav-link:hover {
  color: rgba(var(--bs-theme-rgb), 0.5);
}

.app-content {
  padding: 2rem 2rem 0;
  min-height: 100vh;
  position: relative;
  margin-left: 240px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 1199.98px) {
  .app-content {
    padding: 140px 30px 100px;
    margin-left: 0;
  }
}
@media (max-width: 767.98px) {
  .app-content {
    padding: 80px 12px 100px;
    margin-left: 0;
  }
}
.app-content .app-content-inner-padding {
  padding: 2rem 2rem;
}
@media (max-width: 767.98px) {
  .app-content .app-content-inner-padding {
    padding: 1rem 1rem;
  }
}
.app-content .app-content-inner-padding-x {
  padding-left: 2rem;
  padding-right: 2rem;
}
@media (max-width: 767.98px) {
  .app-content .app-content-inner-padding-x {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.app-content .app-content-inner-padding-y {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
@media (max-width: 767.98px) {
  .app-content .app-content-inner-padding-y {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}

.app-footer {
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bs-dark2);
  padding: 12px 2rem;
  font-weight: 600;
  color: var(--bs-heading-color);
  margin-left: 14.375rem;
}
.app-footer-full {
  margin-left: 0;
  text-align: center;
  background: none;
  border: none;
}
@media (max-width: 1199.98px) {
  .app-footer {
    margin: 0;
  }
}
@media (max-width: 767.98px) {
  .app-footer {
    padding: 12px;
  }
}

.live-svg {
  width: 47px;
  margin-right: 8px;
  filter: drop-shadow(0px 0px 3px var(--bs-theme));
  stroke-dasharray: 320;
  stroke-dashoffset: 320;
  animation: liveAni 2s infinite both;
}

@keyframes liveAni {
  0% {
    stroke-dashoffset: 320;
  }
  100% {
    stroke-dashoffset: -320;
  }
}
.app-sidebar-collapsed .app-header {
  width: 3.875rem;
}
.app-sidebar-collapsed .app-header .brand {
  padding-left: 0;
}
.app-sidebar-collapsed .app-header .brand .brand-logo {
  display: none;
}

.app-header {
  height: 3.25rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 14.375rem;
  z-index: 1020;
  background: var(--bs-dark3);
  display: flex;
  transition: all 0.15s ease-in-out;
}
.app-header .menu-toggler {
  border: none;
  background: none;
  height: 100%;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.app-header .menu-toggler .bar {
  width: 1.625rem;
  display: block;
  height: 1px;
  background: rgba(var(--bs-app-header-link-color-rgb), 0.4);
  transition: all 0.2s linear;
}
.app-header .menu-toggler .bar + .bar {
  margin-top: 0.25rem;
}
.app-header .menu-toggler:hover .bar {
  background: rgba(var(--bs-app-header-link-color-rgb), 0.75);
}
.app-header .mobile-toggler {
  height: 100%;
  display: none;
}
@media (max-width: 1199.98px) {
  .app-header .mobile-toggler {
    display: flex;
    align-items: center;
  }
}
.app-header .desktop-toggler {
  height: 100%;
  display: flex;
  align-items: center;
}
@media (max-width: 767.98px) {
  .app-header .desktop-toggler {
    display: none;
  }
}
.app-header .brand {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
}
@media (max-width: 1199.98px) {
  .app-header .brand {
    justify-content: flex-start;
  }
}
.app-header .brand .brand-logo {
  text-decoration: none;
  color: var(--bs-app-header-link-color);
  font-size: 0.91875rem;
  letter-spacing: 2px;
  display: flex;
  align-items: center;
  justify-content: center !important;
}
@media (max-width: 1199.98px) {
  .app-header .brand .brand-logo {
    width: auto !important;
    gap: 10px;
  }
}
.app-header .brand .brand-logo .card {
  padding: 2px 7px;
  margin-left: 2px;
  font-weight: bold;
  font-size: 12px;
}
.app-header .brand .brand-logo .card:not(.border-0):before, .app-header .brand .brand-logo .card:not(.border-0):after {
  border-color: rgba(var(--bs-border-color-rgb), 0.7);
}
.app-header .brand .brand-logo .card .card-arrow-top-left:before,
.app-header .brand .brand-logo .card .card-arrow-top-right:before,
.app-header .brand .brand-logo .card .card-arrow-bottom-left:before,
.app-header .brand .brand-logo .card .card-arrow-bottom-right:before {
  width: 1px;
  height: 6px;
}
.app-header .brand .brand-logo .card .card-arrow-top-left:after,
.app-header .brand .brand-logo .card .card-arrow-top-right:after,
.app-header .brand .brand-logo .card .card-arrow-bottom-left:after,
.app-header .brand .brand-logo .card .card-arrow-bottom-right:after {
  height: 1px;
}
.app-header .brand .brand-logo .brand-text {
  display: flex;
  align-items: center;
}
.app-header .brand .brand-logo img {
  max-width: 100%;
  max-height: 100%;
}
.app-header .brand .brand-logo .brand-img {
  width: 1.625rem;
  height: 1.625rem;
  background: var(--bs-app-header-brand-img);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
}
.app-header .brand .brand-logo .brand-img .brand-img-text {
  display: block;
  letter-spacing: initial;
  font-weight: 600;
  font-size: 1.05rem;
}
.app-header .menu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1;
}
.app-header .menu .menu-item {
  height: 100%;
  display: flex;
  align-items: center;
}
.app-header .menu .menu-item .menu-link {
  text-decoration: none;
  color: var(--bs-app-header-link-color);
  position: relative;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
}
.app-header .menu .menu-item .menu-link .menu-img {
  width: 2rem;
  height: 2rem;
  margin-right: 0.75rem;
}
.app-header .menu .menu-item .menu-link .menu-img img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 30px;
}
.app-header .menu .menu-item .menu-link .menu-icon {
  font-size: 1.25rem;
}
.app-header .menu .menu-item .menu-link .menu-badge {
  position: absolute;
  background: transparent;
  width: 6px;
  height: 6px;
  top: 0.5rem;
  border-radius: 6px;
  right: 1rem;
}
.app-header .menu-search {
  position: absolute;
  top: -3.25rem;
  left: 0;
  right: 0;
  height: 3.25rem;
  background: var(--bs-app-header-bg);
  transition: all 0.2s ease-in-out;
}
.app-header .menu-search .menu-search-container {
  max-width: 60.4375rem;
  margin: 0 auto;
  height: 3.25rem;
  display: flex;
}
.app-header .menu-search .menu-search-container .menu-search-icon {
  padding: 0 1rem;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
}
.app-header .menu-search .menu-search-container .menu-search-icon .bi:before {
  display: block;
}
.app-header .menu-search .menu-search-container .menu-search-icon a {
  color: rgba(var(--bs-app-header-link-color-rgb), 0.5);
  text-decoration: none;
  display: block;
  transition: all 0.2s linear;
}
.app-header .menu-search .menu-search-container .menu-search-icon a:hover {
  color: var(--bs-app-header-link-color);
}
.app-header .menu-search .menu-search-container .menu-search-input {
  flex: 1 1;
}
.app-header .menu-search .menu-search-container .menu-search-input .form-control {
  border: none;
  padding-left: 0;
  height: 100%;
  box-shadow: none;
}
.app-header-menu-search-toggled .app-header .menu-search {
  top: 0;
}
@media (max-width: 1199.98px) {
  .app-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--bs-dark3);
  }
}

#header.app-header {
  height: 110px;
}
#header.app-header .brand .brand-logo {
  height: 100%;
}
#header.app-header .brand .brand-logo img {
  height: 100%;
}

#sidebar.app-sidebar {
  top: 110px;
}

@media screen and (max-width: 1199px) {
  div#sidebar:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--bs-dark4);
    opacity: 0.8;
    pointer-events: none;
  }
}
@media screen and (max-width: 767px) {
  #header.app-header {
    height: 60px;
  }
  #sidebar.app-sidebar {
    top: 60px;
  }
}
.app-sidebar-mobile-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1020;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  margin: 0;
  outline: none;
  display: none;
  background: rgba(0, 0, 0, 0.25);
}

@keyframes appSidebarSubMenuSlideInRight {
  to {
    transform: translate3d(0, 0, 0);
  }
}
.app-sidebar-button {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(90%, 0px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  background: var(--bs-dark3);
  cursor: pointer;
  padding: 5px;
  transition: 0.2s;
}

.app-sidebar {
  width: 14.375rem;
  background: var(--bs-app-header-bg);
  bottom: 0;
  position: fixed;
  top: 3.25rem;
  z-index: 1010;
  transition: all 0.15s ease-in-out;
  left: 0;
}
.app-sidebar:hover .app-sidebar-button {
  transform: translate(100%, 0px);
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
@media (max-width: 1199.98px) {
  .app-sidebar {
    background: var(--bs-dark3);
    transform: translate(-100%, 0px);
  }
}
.app-sidebar .slimScrollDiv {
  width: 100% !important;
}
.app-sidebar .slimScrollDiv .slimScrollBar, .app-sidebar .slimScrollDiv .slimScrollRail {
  display: none !important;
}
.app-sidebar .menu-footer {
  background: var(--bs-dark3);
}
.app-sidebar .app-sidebar-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.app-sidebar .app-sidebar-content .menu {
  position: relative;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 0;
}
.app-sidebar .app-sidebar-content .menu .menu-header {
  padding: 1rem 1rem 0.5rem;
  font-size: 13px;
  font-weight: 500;
  color: var(--bs-body-color);
}
.app-sidebar .app-sidebar-content .menu .menu-item > div {
  position: relative;
}
.app-sidebar .app-sidebar-content .menu .menu-item > div:hover > .menu-item-events {
  opacity: 1;
  visibility: visible;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-item-events {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translate(0px, -50%);
  z-index: 1;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link {
  text-decoration: none;
  position: relative;
  padding: 0.3rem 1rem;
  color: var(--bs-app-sidebar-menu-link-color);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transition: all 0.2s ease-in-out;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-icon {
  width: 1.875rem;
  height: 1.875rem;
  font-size: 1.05rem;
  margin: -0.25rem 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -4px;
  margin-right: 0.75rem;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-caret {
  display: flex;
  align-items: center;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-caret b {
  display: flex;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-text {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link:hover, .app-sidebar .app-sidebar-content .menu .menu-item .menu-link:focus {
  color: var(--bs-app-sidebar-menu-link-hover-color);
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-submenu {
  background: none;
  display: none;
  padding: 0 0 1rem;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-submenu .menu-item {
  position: relative;
  padding-left: 2.625rem;
}
.app-sidebar .app-sidebar-content .menu .menu-item.active:not(.has-sub) > .menu-link {
  color: var(--bs-app-sidebar-menu-link-active-color);
}
.app-sidebar .app-sidebar-content .menu .menu-item.active > .menu-link .menu-icon {
  color: var(--bs-theme);
}
.app-sidebar .app-sidebar-content .menu .menu-item.active.has-sub > .menu-submenu {
  display: block;
}
.app-sidebar .app-sidebar-content .menu .menu-item.expand > .menu-submenu {
  display: block;
}
.app-sidebar .app-sidebar-content .menu .menu-item.expand > .menu-submenu > .menu-item {
  animation: appSidebarSubMenuSlideInRight 0.3s both cubic-bezier(0.7, 0, 0.3, 1);
  transform: translate3d(-100%, 0, 0);
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(2), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(2) {
  animation-delay: 45ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(3), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(3) {
  animation-delay: 60ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(4), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(4) {
  animation-delay: 75ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(5), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(5) {
  animation-delay: 90ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(6), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(6) {
  animation-delay: 105ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(7), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(7) {
  animation-delay: 120ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(8), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(8) {
  animation-delay: 135ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(9), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(9) {
  animation-delay: 150ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(10), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(10) {
  animation-delay: 165ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(11), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(11) {
  animation-delay: 180ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(12), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(12) {
  animation-delay: 195ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(13), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(13) {
  animation-delay: 210ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(14), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(14) {
  animation-delay: 225ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(15), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(15) {
  animation-delay: 240ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(16), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(16) {
  animation-delay: 255ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(17), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(17) {
  animation-delay: 270ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(18), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(18) {
  animation-delay: 285ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(19), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(19) {
  animation-delay: 300ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(20), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(20) {
  animation-delay: 315ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(21), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(21) {
  animation-delay: 330ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(22), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(22) {
  animation-delay: 345ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(23), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(23) {
  animation-delay: 360ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(24), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(24) {
  animation-delay: 375ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(25), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(25) {
  animation-delay: 390ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(26), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(26) {
  animation-delay: 405ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(27), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(27) {
  animation-delay: 420ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(28), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(28) {
  animation-delay: 435ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(29), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(29) {
  animation-delay: 450ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(30), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(30) {
  animation-delay: 465ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(31), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(31) {
  animation-delay: 480ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(32), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(32) {
  animation-delay: 495ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(33), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(33) {
  animation-delay: 510ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(34), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(34) {
  animation-delay: 525ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(35), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(35) {
  animation-delay: 540ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(36), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(36) {
  animation-delay: 555ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(37), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(37) {
  animation-delay: 570ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(38), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(38) {
  animation-delay: 585ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(39), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(39) {
  animation-delay: 600ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(40), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(40) {
  animation-delay: 615ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(41), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(41) {
  animation-delay: 630ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(42), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(42) {
  animation-delay: 645ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(43), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(43) {
  animation-delay: 660ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(44), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(44) {
  animation-delay: 675ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(45), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(45) {
  animation-delay: 690ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(46), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(46) {
  animation-delay: 705ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(47), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(47) {
  animation-delay: 720ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(48), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(48) {
  animation-delay: 735ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(49), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(49) {
  animation-delay: 750ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(50), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(50) {
  animation-delay: 765ms;
}
.app-sidebar .app-sidebar-mobile-backdrop {
  display: none;
}
.app-sidebar.uppercase-mode {
  text-transform: uppercase;
}
.app-sidebar.uppercase-mode .app-sidebar-content .menu .menu-item .menu-link {
  font-size: 0.83125rem;
}

.app-theme-list {
  margin: -0.25rem;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.app-theme-list .app-theme-list-item {
  padding: 0.25rem;
}
.app-theme-list .app-theme-list-item .app-theme-list-link {
  width: 2rem;
  height: 2rem;
  display: block;
  text-decoration: none;
  position: relative;
  transition: all 0.2s linear;
}
.app-theme-list .app-theme-list-item .app-theme-list-link:hover {
  opacity: 0.6;
}
.app-theme-list .app-theme-list-item.active .app-theme-list-link {
  opacity: 1;
}
.app-theme-list .app-theme-list-item.active .app-theme-list-link:before {
  content: "\\f00c";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 0.875rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}

.app-theme-panel {
  position: fixed;
  top: 50%;
  bottom: 0;
  z-index: 1030;
  display: flex;
  align-items: center;
  right: 0;
  transform: translate(100%, -50%);
  transition: 0.2s;
}
.app-theme-panel .app-theme-panel-container {
  width: 190px;
}
.app-theme-panel .app-theme-panel-content {
  background: var(--bs-app-theme-panel-bg);
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  padding: 0.5rem;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link {
  color: #ffffff;
  text-decoration: none;
  text-align: center;
  position: relative;
  display: block;
  transition: all 0.2s linear;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link .img {
  position: relative;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link .img:before {
  content: "\\f00c";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 0.875rem;
  color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link .text {
  font-size: 0.65625rem;
  font-weight: 500;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link:hover {
  opacity: 0.6;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link.active {
  opacity: 1;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link.active .img:before {
  color: #ffffff;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link.active .img:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}
.app-theme-panel .app-theme-panel-content .app-theme-cover {
  margin: -0.25rem;
  display: flex;
  flex-wrap: wrap;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item {
  padding: 0.25rem;
  width: 33.33%;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item .app-theme-cover-link {
  display: block;
  text-decoration: none;
  position: relative;
  padding-top: 46%;
  background-size: cover;
  background-position: center;
  transition: all 0.2s linear;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item .app-theme-cover-link:hover {
  opacity: 0.6;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item .app-theme-cover-link:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #000000;
  opacity: 0.25;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item.active .app-theme-cover-link {
  opacity: 1;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item.active .app-theme-cover-link:after {
  content: "\\f00c";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 0.875rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.app-theme-panel .app-theme-toggle-btn {
  position: absolute;
  top: 50%;
  margin-top: -1rem;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.09375rem;
  color: var(--bs-app-theme-panel-color);
  background: var(--bs-app-theme-panel-bg);
  text-align: center;
  left: 0;
  margin-left: -2rem;
}
.app-theme-panel.active {
  transform: translate(0, -50%);
}

@keyframes topMenuControlSlideInLeft {
  from {
    left: -3.125rem;
  }
  to {
    left: 0;
  }
}
@keyframes topMenuControlSlideInRight {
  from {
    right: -3.125rem;
  }
  to {
    right: 0;
  }
}
.app-top-nav {
  background: var(--bs-app-top-nav-bg);
  left: 0;
  right: 0;
  z-index: 1010;
}
@media (min-width: 768px) {
  .app-top-nav {
    top: 3.25rem;
    position: fixed;
    height: 2.875rem;
  }
}
@media (max-width: 767.98px) {
  .app-top-nav {
    display: none;
  }
}
@media (min-width: 768px) {
  .app-top-nav .menu {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
}
@media (max-width: 767.98px) {
  .app-top-nav .menu {
    display: block;
    margin: 0 !important;
  }
}
.app-top-nav .menu .menu-item {
  position: relative;
}
.app-top-nav .menu .menu-item .menu-link {
  text-decoration: none;
  position: relative;
  padding: 0.75rem 1rem;
  color: var(--bs-app-top-nav-menu-link-color);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
}
@media (max-width: 767.98px) {
  .app-top-nav .menu .menu-item .menu-link {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
.app-top-nav .menu .menu-item .menu-link .menu-icon {
  width: 1.875rem;
  height: 1.875rem;
  font-size: 1.05rem;
  margin: -0.25rem 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
}
.app-top-nav .menu .menu-item .menu-link .menu-caret {
  margin: -0.3125rem 0;
  margin-left: 0.75rem;
}
.app-top-nav .menu .menu-item .menu-link .menu-text {
  flex: 1 1;
}
.app-top-nav .menu .menu-item .menu-link:hover, .app-top-nav .menu .menu-item .menu-link:focus {
  color: var(--bs-app-top-nav-menu-link-hover-color);
}
.app-top-nav .menu .menu-item .menu-submenu {
  background: var(--bs-app-top-nav-menu-submenu-bg);
  display: none;
  padding: 0.5rem 0;
  min-width: 12.5rem;
}
@media (min-width: 768px) {
  .app-top-nav .menu .menu-item .menu-submenu {
    position: absolute;
    max-height: calc(100vh - 6.125rem);
    left: 0;
  }
}
@media (max-width: 767.98px) {
  .app-top-nav .menu .menu-item .menu-submenu {
    padding-top: 0;
    padding-bottom: 1rem;
    padding-left: 2.625rem;
  }
}
.app-top-nav .menu .menu-item .menu-submenu .menu-item {
  position: relative;
}
.app-top-nav .menu .menu-item .menu-submenu .menu-item .menu-link {
  padding: 0.25rem 1rem;
}
.app-top-nav .menu .menu-item.active > .menu-link {
  color: var(--bs-app-top-nav-menu-link-active-color);
}
.app-top-nav .menu .menu-item.active > .menu-link .menu-icon {
  color: var(--bs-theme);
}
.app-top-nav .menu .menu-item.menu-control {
  position: absolute;
  top: 0;
  margin: 0;
  z-index: 10;
}
@media (max-width: 767.98px) {
  .app-top-nav .menu .menu-item.menu-control {
    display: none !important;
  }
}
.app-top-nav .menu .menu-item.menu-control > .menu-link {
  padding: 0;
  text-align: center;
  width: 2.875rem;
  height: 2.875rem;
  background: var(--bs-app-top-nav-bg);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--bs-app-top-nav-menu-link-color);
}
.app-top-nav .menu .menu-item.menu-control > .menu-link i {
  float: none;
  margin: 0;
  font-size: 1.125rem;
  display: block;
  line-height: 2.5rem;
  width: auto;
}
.app-top-nav .menu .menu-item.menu-control > .menu-link:hover, .app-top-nav .menu .menu-item.menu-control > .menu-link:focus {
  color: var(--bs-app-top-nav-menu-link-hover-color);
}
.app-top-nav .menu .menu-item.menu-control.menu-control-start {
  left: -3.25rem;
}
.app-top-nav .menu .menu-item.menu-control.menu-control-start > .menu-link {
  box-shadow: 12px 0 10px -10px rgba(0, 0, 0, 0.5);
}
.app-top-nav .menu .menu-item.menu-control.menu-control-start.show {
  left: 0;
  animation: topMenuControlSlideInLeft 0.2s;
}
.app-top-nav .menu .menu-item.menu-control.menu-control-end {
  right: -3.25rem;
}
.app-top-nav .menu .menu-item.menu-control.menu-control-end > .menu-link {
  box-shadow: -12px 0 10px -10px rgba(0, 0, 0, 0.5);
}
.app-top-nav .menu .menu-item.menu-control.menu-control-end.show {
  right: 0;
  animation: topMenuControlSlideInRight 0.2s;
}
@media (min-width: 768px) {
  .app-top-nav .menu > .menu-item.has-sub:hover > .menu-submenu {
    display: block;
  }
}

.map-fullscreen-hide.active {
  pointer-events: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

.map-zoom-item {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #ffffff;
  z-index: 1;
  border-radius: 4px;
}

.menu-item.has-sub {
  padding-bottom: 5px;
  padding-top: 2px;
}

.map-zoom-item a i {
  color: #000000;
  font-size: 24px;
}

.map-zoom-item a {
  padding: 0 5px;
}

.hide-data tbody tr {
  filter: blur(5px);
  transition: 0.2s;
}

.hide-data tbody tr:hover {
  filter: blur(0px);
}

/* styles.css */
.autocomplete-container {
  position: relative;
}

.autocomplete-input {
  width: 100%;
  padding: 8px;
}

.autocomplete-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #1c242d;
  border: 1px solid #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 150px;
  overflow-y: auto;
}

.autocomplete-item {
  padding: 8px;
  cursor: pointer;
  color: #ffffff;
}

.autocomplete-item:hover {
  background-color: #2a6e59;
}

@media (max-width: 1199.98px) {
  .app {
    overflow: hidden;
  }
}

@media (min-width: 992px) {
  .md-h-100 {
    height: 100%;
  }
  .md-mb-n4 {
    margin-bottom: -1.5rem;
  }
}
.flex-none {
  flex: none;
}

.evenColumn {
  background: rgba(255, 255, 255, 0.06);
}

.ReactVirtualized__Grid {
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.headerCell {
  font-weight: bold;
  text-transform: uppercase;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  padding: 5px 10px;
  display: flex;
  align-items: center;
}

.headerCell {
  border-right: 1px solid rgba(255, 255, 255, 0.25);
}

.evenColumn,
.oddColumn {
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  border-right: 1px solid rgba(255, 255, 255, 0.25);
  padding: 10px;
}

.page-iframe iframe {
  width: 100%;
  height: 100vh;
}

.welcome-container {
  text-align: center;
  min-height: calc(100vh - 280px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.welcome-container h1, .welcome-container .h1 {
  font-size: 2.5em;
  margin-bottom: 10px;
}

.welcome-container p {
  font-size: 1.2em;
  color: #555;
}

.tooltip-title {
  display: inline-block;
  position: absolute;
  top: 100%;
  background: var(--bs-dark3);
  border-radius: 4px;
  text-align: center;
  left: 50%;
  transform: translate(-50%, 4px);
  font-size: 12px;
  padding: 2px 5px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: 0.2s;
}

.tooltip-item {
  position: relative;
}

.tooltip-item:hover .tooltip-title {
  opacity: 1;
  visibility: visible;
}

.graphic-events {
  position: relative;
}

.graphic-events .graphic-events-dropdown {
  position: absolute;
  top: 100%;
  right: 0px;
  background: #1c2e37;
  z-index: 2;
  padding: 10px;
  border-radius: 4px;
}

.gm-style-iw-d .marker-window-container::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.fancybox__content {
  width: 100% !important;
  height: 100% !important;
}

.fancybox-navigation .fancybox-button {
  opacity: 1;
  visibility: visible;
  background: #2ab48a;
  pointer-events: all;
  width: 90px;
  height: 90px;
  padding: 0;
  border-radius: 0px;
  color: #ffffff !important;
}

.fancybox-navigation .fancybox-button:hover {
  background: #1e9a75;
}

.fancybox-navigation .fancybox-button svg {
  width: 60px;
  height: auto;
}

.fancybox-navigation .fancybox-button div {
  height: 100%;
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.todo-sort-arrow:hover {
  color: var(--bs-theme);
}

@media (max-width: 767.98px) {
  .chest-work-page {
    flex-direction: column;
  }
  .chest-work-page > .flex-1 {
    padding: 0 0px 0px 10px !important;
  }
}
@media (max-width: 1199.98px) {
  .neighbourhood-menu {
    max-width: 100% !important;
    width: 100% !important;
  }
  .neighbourhood-menu > div {
    gap: 20px;
    position: relative !important;
    display: flex;
    white-space: nowrap;
    margin-bottom: 30px;
    padding: 20px 20px;
    overflow-x: auto !important;
    overflow-y: hidden !important;
  }
}
.district-menu {
  width: 300px;
  flex: none;
}
@media (max-width: 1199.98px) {
  .district-menu {
    width: 200px;
  }
}
@media (max-width: 767.98px) {
  .district-menu {
    width: 100%;
  }
  .district-menu > ol {
    overflow-x: auto;
    padding: 10px 20px;
    gap: 40px !important;
    margin-bottom: 0;
  }
}

.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th:last-child,
.dataTables_scrollBody > table > tbody tr td:last-child {
  border-right: 1px solid #5d686f;
}

.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th,
.dataTables_scrollBody > table > tbody tr td {
  border-left: 1px solid #5d686f;
}

.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th {
  border-top: 1px solid #5d686f;
  padding-left: 30px;
}

.dataTables_wrapper.dt-bootstrap5 table.dataTable thead > tr > th.sorting:before,
.dataTables_wrapper.dt-bootstrap5 table.dataTable thead > tr > th.sorting:after {
  left: 10px;
  right: auto;
  position: absolute;
  font-size: 11px;
}

.dataTables_wrapper.dt-bootstrap5 table.dataTable thead > tr > th.sorting {
  padding-left: 30px;
  position: relative;
}

.table-datatable.table {
  margin-bottom: 0;
}

.dataTables_scrollBody .table-datatable .sorting:before,
.dataTables_scrollBody .table-datatable .sorting:after {
  display: none !important;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background: rgba(68, 210, 165, 0.1607843137);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--bs-theme);
}

.select-height {
  height: 60px;
}
.select-height > div {
  height: 100%;
}
.select-height .react-select__control {
  height: 100%;
}

.select-h-100 .react-select__control {
  height: 100%;
}

.react-select__control {
  text-transform: uppercase;
}

.react-select__menu {
  text-transform: uppercase;
}

.listen-note > span {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0px);
  white-space: nowrap;
  background: #000000;
  z-index: 1;
  opacity: 0;
  visibility: hidden;
  transition: 0.2s;
  pointer-events: none;
}

.listen-note {
  position: relative;
}
.listen-note .fa-volume-off {
  display: none;
}
.listen-note.active .fa-volume-up {
  display: none;
}
.listen-note.active .fa-volume-off {
  display: block;
}

.listen-note:hover > span {
  opacity: 1;
  visibility: visible;
}

.gm-ui-hover-effect {
  top: 0 !important;
  background: #e00000 !important;
  opacity: 1;
  right: 0 !important;
  border-bottom-left-radius: 6px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 35px !important;
  height: 35px !important;
}
.gm-ui-hover-effect > span {
  width: 24px !important;
  height: 24px !important;
  margin: 0 !important;
  background-color: #ffffff;
}

.carousel-control-prev,
.carousel-control-next {
  opacity: 1;
  background: rgba(0, 0, 0, 0.95);
  top: 50%;
  transform: translate(0px, -50%);
  width: 30px;
  height: 30px;
  border-radius: 100%;
  padding: 3px;
  margin: 0 -7px;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  filter: initial !important;
  position: relative;
}

.carousel-control-prev-icon {
  left: -1px;
}

.carousel-control-next-icon {
  right: -2px;
}

#strategy-map .card:before,
#strategy-map .card:after {
  display: none;
}

#strategy-map .scrum-container > .flex-1 {
  display: none;
}

#strategy-map .scrum-container {
  display: none !important;
  left: 0 !important;
  bottom: 0 !important;
}

.scrum-map-container {
  height: calc(100vh - 150px);
}

@media (max-width: 1199.98px) {
  .scrum-map {
    height: 700px;
  }
  .scrum-map-container {
    height: auto !important;
  }
  .scrum-container {
    height: auto !important;
    width: 100% !important;
    padding: 40px 0 !important;
  }
}
#strategy-map .card .card-body {
  padding: 0;
}

#strategy-map .card .card-arrow {
  display: none;
}

.fancybox__container {
  z-index: 9999;
}

.pointer {
  cursor: pointer;
}

.sandik-analizi-chart-slide .swiper-slide .slide-chest:hover, .sandik-analizi-chart-slide .swiper-slide .slide-chest.active {
  color: var(--bs-theme);
}
.sandik-analizi-chart-slide .swiper-slide .slide-chest:hover strong, .sandik-analizi-chart-slide .swiper-slide .slide-chest.active strong {
  color: var(--bs-theme);
}

.sandik-analizi-chart-slide .swiper-slide .slide-general:hover, .sandik-analizi-chart-slide .swiper-slide .slide-general.active {
  background: rgba(255, 255, 255, 0);
  color: var(--bs-theme);
}

.form-control:disabled {
  opacity: 0.5 !important;
}

.table > thead {
  vertical-align: middle;
}

table.dataTable > tbody > tr:nth-child(even) {
  background: rgba(255, 255, 255, 0.06);
}

.custom-file-button input[type=file] {
  margin-left: -2px !important;
}
.custom-file-button input[type=file]::file-selector-button {
  display: none;
}

.color-item {
  position: relative;
}

.color-item label {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0);
  cursor: pointer;
}

.color-item input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
}

.color-item input:checked ~ label {
  border-color: #ffffff;
}

.live-svg-map {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translate(-50%, 0px);
  z-index: 1;
  margin: 0;
  width: 70px;
  display: none;
}

.app-sidebar-toggled .live-svg-map {
  display: block;
}

.gm-style .gm-style-iw-c {
  color: #000000;
  text-align: center;
  padding: 0;
}

.gm-style-iw-d {
  padding: 5px 10px !important;
  overflow: initial !important;
}

.img-cover {
  object-fit: cover;
  object-position: center;
}

.scroll-up-btn {
  position: fixed;
  bottom: 20px;
  right: 15px;
  cursor: pointer;
  pointer-events: none;
  transform: scale(0);
  transition: 0.2s;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  border-radius: 100%;
  font-size: 30px;
  color: #249d79;
}
.scroll-up-btn.active {
  transform: scale(1);
  pointer-events: all;
}
.scroll-up-btn.near-news {
  bottom: 210px;
}
.scroll-up-btn.near-news.near-footer {
  bottom: 350px !important;
}
.scroll-up-btn:hover {
  color: #ffffff;
}
@media (max-width: 767.98px) {
  .scroll-up-btn.near-news {
    bottom: 30px;
  }
  .scroll-up-btn.near-news.near-footer {
    bottom: 500px !important;
  }
}

.text-overflow {
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
}

.table-for-multiple {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0px;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}

.page-loader .app-header:nth-child(2) {
  width: auto;
  position: relative;
  height: auto;
  background: none;
  transform: scale(0.7);
  flex: 1 1;
}
.page-loader .app-header:nth-child(2) .brand-text {
  font-size: 80px;
}
@media (max-width: 1199.98px) {
  .page-loader .app-header:nth-child(2) {
    transform: scale(0.4);
  }
}
@media (max-width: 767.98px) {
  .page-loader .app-header:nth-child(2) {
    transform: scale(0.25);
  }
}

.page-loader .app-header:nth-child(2) .brand .brand-logo .card {
  font-size: 80px;
  overflow: hidden;
  letter-spacing: 20px;
  margin: 0;
  line-height: 1;
  margin-left: 20px;
  width: 0px;
  padding: 10px 0px;
  box-sizing: content-box;
}
.page-loader .app-header:nth-child(2) .brand .brand-logo .card.loader-text-1 {
  animation: loaderAni1 3s cubic-bezier(0.51, 0.92, 0.24, 1.15) infinite both !important;
}
.page-loader .app-header:nth-child(2) .brand .brand-logo .card.loader-text-2 {
  animation: loaderAni2 3s cubic-bezier(0.51, 0.92, 0.24, 1.15) infinite both !important;
}
.page-loader .app-header:nth-child(2) .brand .brand-logo .card.loader-text-3 {
  animation: loaderAni3 3s cubic-bezier(0.51, 0.92, 0.24, 1.15) infinite both !important;
}

.page-loader .app-header:nth-child(2) .brand {
  width: auto;
  height: auto;
  padding: 0;
}

@keyframes loaderAni1 {
  0%, 100% {
    width: 0px;
    padding: 10px 0px;
    letter-spacing: 20px;
  }
  50% {
    width: 530px;
    padding: 10px 20px;
    letter-spacing: 0px;
  }
}
@keyframes loaderAni2 {
  0%, 100% {
    width: 0px;
    padding: 10px 0px;
    letter-spacing: 20px;
  }
  50% {
    width: 680px;
    padding: 10px 20px;
    letter-spacing: 0px;
  }
}
@keyframes loaderAni3 {
  0%, 100% {
    width: 0px;
    padding: 10px 0px;
    letter-spacing: 20px;
  }
  50% {
    width: 870px;
    padding: 10px 20px;
    letter-spacing: 0px;
  }
}
.details-modal .ck.ck-editor__main > .ck-editor__editable {
  min-height: 100px !important;
}

.weather-item .react-select__menu {
  font-size: 12px;
  width: 120px;
}

.weather-item .react-select__control {
  border: none;
  padding: 0;
  min-height: auto;
  margin: 0;
  font-size: 11px;
}

.select-sm .react-select__control {
  font-size: 11px !important;
}

.breaking-news {
  background-color: var(--bs-dark2);
  padding: 0px 1.5rem;
  position: sticky;
  bottom: 0;
  right: 0;
  margin-left: 14.375rem;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.breaking-news .news-item:hover .news-img:before {
  opacity: 0;
}
.breaking-news .news-img {
  position: relative;
  overflow: hidden;
}
.breaking-news .news-img:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0f1320;
  opacity: 0.7;
  transition: 0.3s;
}
.breaking-news .rate-container {
  border-top: 1px solid 37;
  font-size: 10px;
  margin: 8px 7px 0;
  padding-top: 8px;
}
.breaking-news .weather-container {
  width: auto;
  max-width: 180px;
  border-top: 1px solid 37;
  margin-top: 12px;
  padding-top: 12px;
}
@media (max-width: 767.98px) {
  .breaking-news .weather-container {
    margin-left: 0;
    border-left: none;
    border-top: 1px solid 37;
    margin-top: 5px;
    padding-top: 5px;
  }
}
.breaking-news a {
  text-decoration: none;
  color: #ffffff;
  transition: 0.3s;
}
.breaking-news a p {
  font-size: 20px;
  line-height: 1.1;
  background: rgba(255, 255, 255, 0.02);
  padding: 12px;
}
.breaking-news a p > span:nth-child(1) {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 16px;
}
.breaking-news a p .news-item-desc {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 14px;
  opacity: 0.7;
  font-weight: 300;
  margin-bottom: 12px;
}
.breaking-news a p .text-date {
  font-size: 9px;
}
.breaking-news a:hover {
  color: #249d79;
}
.breaking-news .breaking-news-events {
  position: absolute;
  top: 0;
  z-index: 2;
  left: 16px;
  transform: translate(0px, -100%);
  display: flex;
  gap: 8px;
  width: auto;
  background: var(--bs-dark2);
  padding: 16px;
}
@media (max-width: 767.98px) {
  .breaking-news .breaking-news-events {
    left: 0;
    flex-wrap: wrap;
  }
  .breaking-news .breaking-news-events > * {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 10px);
  }
}
.breaking-news .breaking-news-title {
  background: #e00000;
  color: #ffffff;
  font-weight: bold;
  padding: 5px 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  width: auto;
  cursor: pointer;
  margin-bottom: 0;
}
.breaking-news .breaking-news-title i {
  transform: rotate(180deg);
}
.breaking-news .breaking-news-col {
  display: none;
  padding-bottom: 24px;
}
.breaking-news.active {
  padding: 12px 1.5rem 0;
}
.breaking-news.active .breaking-news-col {
  display: block;
}
.breaking-news.active .breaking-news-title i {
  transform: rotate(0deg);
}
@media (max-width: 1199.98px) {
  .breaking-news {
    margin-left: 0;
  }
}
@media (max-width: 767.98px) {
  .breaking-news {
    margin-left: 0;
  }
}

@media (max-width: 1199.98px) {
  .sandik-analizi-chart {
    height: auto !important;
  }
  .sandik-analizi-chart > .col-12:first-child {
    height: 50vh;
  }
  .sandik-analizi-chart > .col-12:nth-child(2) > .row > div {
    height: auto !important;
  }
  .sandik-analizi-chart .row {
    height: auto !important;
  }
  .sandik-analizi-chart .row > .col-lg-4 {
    height: 500px !important;
  }
}

.tree-chart {
  height: calc(100vh - 200px);
}
.tree-chart > .col:nth-child(1) {
  height: 100%;
}
@media (max-width: 1199.98px) {
  .tree-chart {
    height: auto;
  }
}

#tooltip-item {
  position: absolute;
  top: 0;
  left: 0;
  background: #ffffff;
  z-index: 1;
  color: #000000;
  border-radius: 4px;
  padding: 2px 5px;
  font-size: 12px;
  pointer-events: none;
  display: none;
}
#tooltip-item.active {
  display: block;
}

.app-sidebar .app-theme-panel {
  position: relative;
  right: 0;
  width: 100%;
}

.app-sidebar .app-theme-panel .app-theme-toggle-btn {
  display: none;
}

.app-sidebar .app-theme-panel .app-theme-panel-container {
  position: relative;
  width: 100%;
}

.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content {
  background: none;
  box-shadow: none;
  width: auto;
  display: flex;
  align-items: center;
  padding: 0;
}

.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .small {
  max-width: 60px;
  opacity: 0.8;
}

.app-theme-list {
  flex-direction: row;
}

.app-theme-list .app-theme-list-item {
  flex: 1 1;
}

.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card {
  margin-bottom: 0 !important;
  flex: 1 1;
}

.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card:before,
.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card:after {
  display: none;
}

.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card .card-arrow {
  display: none;
}

.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card .card-body {
  padding: 0 !important;
}

.question-answer-button:hover label {
  opacity: 1;
}
.question-answer-button input:checked ~ label {
  opacity: 1;
}
.question-answer-button label {
  opacity: 0.5;
}

/* Zoom */
.menu-item-events-hover .menu-item-events {
  display: none;
}
.menu-item-events-hover:hover .menu-item-events {
  display: block;
}

.ck-editor-height-full .ck.ck-editor {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ck-editor-height-full .ck.ck-editor .ck.ck-editor__main {
  flex: 1 1;
  overflow: auto;
}

.ck-editor-height-full .ck.ck-editor .ck.ck-editor__main .ck-content {
  height: 100%;
}

.ck-editor-height-full {
  height: 100%;
}

.survey-table,
.survey-table td {
  display: block;
}

.survey-table td {
  flex: 1 0 50%;
}

.survey-table tr {
  display: flex;
  flex-wrap: wrap;
}

.survey-table td:nth-child(1) {
  flex: 0 0 40px;
}

.survey-table td:last-child {
  flex: 0 0 130px;
}

.survey-question-list-item {
  border: 1px solid #4e545b;
  padding: 10px;
  margin-bottom: 15px;
}

.survey-question-list-item .list-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  border-bottom: 1px solid #4e545b;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

.survey-question-list-item .list-item-header > div:first-child {
  flex: 1 1;
}

@media screen and (max-width: 767px) {
  .survey-question-list-item .list-item-header {
    flex-direction: column;
    gap: 0px;
  }
  .survey-question-list-item .row {
    flex-direction: column;
    gap: 10px;
  }
  .survey-question-list-item .list-item-header > div:first-child {
    width: 100%;
  }
  .survey-question-list-item .list-item-header > div:last-child {
    width: 100%;
    border-left: none;
    margin-left: 0;
    padding-left: 0;
    border-top: 1px solid #4e545b;
    padding-top: 10px;
    margin-top: 10px;
  }
}
/* Disaster */
.app {
  transition: 0.5s;
}

.disaster-page {
  background: linear-gradient(180deg, #b70000 -190%, rgb(27, 0, 0) 90%) !important;
  height: auto !important;
}

.modal {
  z-index: 1120;
}

.profil-photo-item-upload {
  opacity: 0;
}
.profil-photo-item:hover .profil-photo-item-upload {
  opacity: 1;
}

.select-map .react-select__menu {
  font-size: 12px !important;
}

.select-map .react-select__control {
  border-color: #000000 !important;
  height: 26px;
  min-height: 26px;
  padding: 0px 10px;
}

.select-map .react-select__control .react-select__value-container .react-select__single-value {
  color: #000000;
}

.select-map .react-select__control .react-select__indicators .react-select__indicator {
  color: #000000;
}

.progress-container {
  display: flex;
  align-items: center;
  border: 1px solid #595d64;
  padding: 10px;
  border-radius: 4px;
  font-size: 18px;
}

.progress-container input {
  flex: 1 1;
  margin-right: 10px;
}

/* Slider genel stili */
.slider { /* Tarayıcı varsayılan stilini kaldırır */
  appearance: none;
  width: 100%;
  height: 8px;
  background: #c0cacf; /* Arka plan rengi */
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.slider:hover {
  opacity: 1; /* Hover'da opaklığı artırır */
}

/* Track (Arka plan) stili */
.slider::-webkit-slider-runnable-track {
  width: 100%;
  height: 8px;
  background: #c0cacf;
  border-radius: 4px;
  cursor: pointer;
}

.slider::-moz-range-track {
  width: 100%;
  height: 8px;
  background: #c0cacf;
  border-radius: 4px;
  cursor: pointer;
}

/* Thumb (Tutma yeri) stili */
.slider::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background: #249d79; /* Thumb rengi */
  margin-top: -6px;
  border-radius: 50%;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #249d79; /* Thumb rengi */
  border-radius: 50%;
  margin-top: -6px;
  cursor: pointer;
}

/* Slider'ın dolu kısmının rengi (Chrome ve Safari için) */
.slider::-webkit-slider-runnable-track {
  background: linear-gradient(to right, #249d79 0%, #249d79 var(--progress), #c0cacf var(--progress), #c0cacf 100%);
}

.slider::-moz-range-progress {
  background: #249d79; /* Firefox'ta dolu kısmın rengi */
  height: 8px;
  border-radius: 4px;
}

.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 94px;
}

.react-datepicker__time-container {
  float: none;
  padding-left: 10px;
  margin-left: 5px;
  border-color: #555e69;
}

.react-datepicker-popper .react-datepicker {
  display: flex;
}

.react-datepicker__header {
  background: #222e3e;
  border-color: #555e6a;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  color: #ffffff;
}

.react-datepicker__time-container .react-datepicker__time {
  background: #222e3e;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  color: #ffffff;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background: #249d79;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  background: rgba(49, 157, 121, 0.1803921569);
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  background: rgba(49, 157, 121, 0.3215686275);
}

.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day:hover {
  background: #249d79;
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range) {
  background: rgba(49, 157, 121, 0.568627451);
}

.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range) {
  background: rgba(49, 157, 121, 0.3215686275);
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  color: #ffffff;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background: #1d2836;
  border-color: #555e69;
  color: #ffffff;
}

.react-datepicker__year-dropdown-container--scroll .react-datepicker__navigation {
  background: none;
  top: 0;
}

.react-datepicker__year-dropdown-container--scroll .react-datepicker__navigation:before {
  content: "\\f105";
  color: rgba(var(--bs-inverse-rgb), 0.5);
  position: absolute;
  font-size: 0.875rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\6 Free, Font Awesome\\6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  transform: rotate(-90deg);
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background: #293748;
}

.react-datepicker__year-option:last-of-type a:before {
  transform: rotate(90deg) !important;
}

.react-datepicker__close-icon::after {
  background: #e00000;
}

.question-block .question-block {
  margin-left: 10px;
  width: calc(100% - 15px);
}

.question-block .row.g-2.align-items-center:before {
  margin-right: 10px;
  margin-left: -10px;
  content: "";
  width: 10px;
  height: 1px;
  background: #ffffff;
  display: block;
}

.question-block:before {
  content: "";
  width: 1px;
  height: calc(100% - 122px);
  background: #ffffff;
  position: absolute;
  top: 31px;
  left: 15px;
}
.question-block.question-string:before {
  height: calc(100% - 77px);
}

.question-block {
  position: relative;
}

.question-block .question-block {
  margin-top: 10px;
  background: rgba(255, 255, 255, 0.05);
}

.question-block {
  background: rgba(255, 255, 255, 0.03);
  padding: 15px 10px 15px 30px;
}

.question-block:after {
  content: "";
  position: absolute;
  top: 30px;
  left: 15px;
  width: 8px;
  height: 1px;
  background: #ffffff;
}

/* styles.css */
.box {
  position: relative;
  box-sizing: border-box;
  resize: both;
  overflow: hidden;
}

.resizer {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #000000;
  cursor: se-resize;
}

.resizer.bottom-right {
  bottom: 0;
  right: 0;
}

.rotate-animation {
  display: block;
  transform: rotate(0deg);
  transform-origin: center;
  animation: rotateAni 5s both infinite;
}

@keyframes rotateAni {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*Now the CSS*/
.tree {
  white-space: nowrap;
  overflow: auto;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.tree ul {
  padding-top: 20px;
  position: relative;
  text-align: center;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li {
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 20px 5px 0 5px;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  /*added for long names*/
  float: none;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  margin: 0 -2px 0 -2px;
}

/*We will use ::before and ::after to draw the connectors*/
.tree li::before,
.tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 1px solid #ccc;
  width: 50%;
  height: 20px;
}

.tree li::after {
  right: auto;
  left: 50%;
  border-left: 1px solid #ccc;
}

/*We need to remove left-right connectors from elements without 
  any siblings*/
.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}

/*Remove space from the top of single children*/
.tree li:only-child {
  padding-top: 0;
}

/*Remove left connector from first child and 
  right connector from last child*/
.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}

/*Adding back the vertical connector to the last nodes*/
.tree li:last-child::before {
  border-right: 1px solid #ccc;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}

.tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

/*Time to add downward connectors from parents*/
.tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1px solid #ccc;
  width: 0;
  height: 20px;
}

.tree li a {
  border: 1px solid #ccc;
  padding: 10px 15px;
  text-decoration: none;
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  display: inline-block;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  transition: all 0.2s;
}

/*Time for some hover effects*/
/*We will apply the hover effect the the lineage of the element also*/
.tree li a:hover,
.tree li a:hover + ul li a {
  background: #249d79;
  color: #000000;
  border: 1px solid #249d79;
}

/*Connector styles on hover*/
.tree li a:hover + ul li::after,
.tree li a:hover + ul li::before,
.tree li a:hover + ul::before,
.tree li a:hover + ul ul::before {
  border-color: #94a0b4;
}

.user-info-hover-item {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: 0.2s;
}
.user-info-hover:hover .user-info-hover-item {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}

.swiper-pagination {
  position: static !important;
  margin-top: 15px !important;
}

.swiper-pagination-bullet {
  width: 10px !important;
  border-radius: 10px !important;
  background: #ffffff !important;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 20px !important;
}

.graphic-note-item .ck-sticky-panel__content {
  display: none;
}

.graphic-note-item .jodit-toolbar__box {
  display: none;
}

figure.table table th,
figure.table table td {
  border: 1px solid;
  font-size: 15px;
}

.file-progress-card {
  position: fixed;
  right: 20px;
  z-index: 99;
  background: #12202c;
  border: 1px solid 59;
  padding: 20px;
  border-radius: 8px;
  color: #ffffff;
  font-weight: 500;
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
}

.pagination .paginate_button.page-item {
  margin: 0;
}

.question-category-scroll {
  height: 400px;
  padding-bottom: 100px;
  mask-image: linear-gradient(180deg, rgba(255, 255, 255, 0) -100%, #ffffff 7.17%, #ffffff 70%, rgba(255, 255, 255, 0) 100%);
}

.menu-first-dropdown .menu-item {
  background: rgba(61, 210, 165, 0.08);
  padding: 8px 0px !important;
}

.has-sub .menu-item.active {
  border-top: 1px dashed 0;
  border-bottom: 1px dashed 0;
}

.menu-first-dropdown > .menu-item.active:not(.has-sub) {
  border-top: 1px dashed 0;
  border-bottom: 1px dashed 0;
}

.app-sidebar .app-sidebar-content .menu .menu-item .menu-link {
  padding: 0 1rem !important;
}

.menu-item.has-sub.ps-0 {
  padding: 1rem 0rem 0.5rem;
}

.menu-first-dropdown .menu-item.has-sub.ps-0 {
  padding: 8px 0;
}

.menu-first-dropdown .menu-submenu {
  padding-bottom: 0 !important;
  margin-top: 12px;
}

.menu-other-dropdown .menu-submenu .menu-item {
  background: rgba(61, 210, 165, 0.08);
  padding: 8px;
}

.menu-other-dropdown .menu-submenu {
  margin-top: 12px;
}

.menu-caret {
  transform: rotate(-90deg);
  transition: 0.3s;
}

.menu-caret.active {
  transform: rotate(0deg);
}

.menu-item.active > div > .menu-link > .menu-caret {
  transform: rotate(0deg);
}

.parent {
  display: grid;
  gap: 10px;
}

.div1,
.div2,
.div3 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 20px;
  color: #ffffff;
}

.menu-settings {
  display: none;
  flex-direction: column;
  justify-content: center;
  margin: 0 10px;
}

.jodit-react-container {
  color: black;
}

.jodit-container:not(.jodit_inline) .jodit-workplace {
  min-height: 500px !important;
}

.jodit_sticky > .jodit-toolbar__box {
  position: static;
}

:root {
  --jd-color-1: #ffffff;
  --jd-color-2: green;
  --jd-color-3: #ffffff00;
  --jd-color-4: #ffffff;
  --jd-color-5: white;
  --jd-color-6: rgb(255 255 255 / 25%);
  --jd-color-7: #ffffff00;
  --jd-color-8: rgb(255 255 255 / 25%);
  --jd-color-9: #ffffff;
}

.jodit_theme_dark .jodit-toolbar__box:not(:empty) {
  background: #141b24;
}

.jodit_theme_dark .jodit-ui-input__input {
  color: black;
}

.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal {
  background-image: repeating-linear-gradient(transparent 0, transparent 37px, var(--jd-color-6) 38px);
}

.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal {
  background-image: repeating-linear-gradient(transparent 0, transparent 37px, var(--jd-color-6) 38px);
}

.jodit-dialog_theme_dark .jodit-toolbar-collection_mode_horizontal:after {
  background-color: var(--jd-color-6);
}

.jodit-dialog_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after {
  background-color: var(--jd-color-6);
}

.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal:after {
  background-color: var(--jd-color-6);
}

.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after {
  background-color: var(--jd-color-6);
}

.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) {
  border-color: var(--jd-color-6);
}

.jodit_theme_dark .jodit-toolbar__box:not(:empty) {
  border-color: var(--jd-color-6);
}

.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after {
  background-color: var(--jd-color-6);
}

.jodit_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after {
  background-color: var(--jd-color-6);
}

.jodit-dialog_theme_dark .jodit-ui-group_separated_true:not(:last-child, .jodit-ui-group_before-spacer_true):after {
  border-right-color: var(--jd-color-6);
}

.jodit_theme_dark .jodit-ui-group_separated_true:not(:last-child, .jodit-ui-group_before-spacer_true):after {
  border-right-color: var(--jd-color-6);
}

.jodit-dialog_theme_dark.jodit-container {
  background-color: var(--jd-color-3);
  border-color: var(--jd-color-8);
}

.jodit_theme_dark.jodit-container {
  background-color: var(--jd-color-3);
  border-color: var(--jd-color-8);
}

.jodit-dialog_theme_dark.jodit-container.jodit_disabled {
  background-color: var(--jd-color-3);
}

.jodit_theme_dark.jodit-container.jodit_disabled {
  background-color: var(--jd-color-3);
}

.jodit-dialog_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace {
  border-color: var(--jd-color-3);
}

.jodit_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace {
  border-color: var(--jd-color-3);
  background: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-popup__content {
  background: var(--jd-color-3);
}

.jodit_theme_dark .jodit-popup__content {
  background: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button__text {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select__text {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button__text {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-ui-button__text:hover:not([disabled]) {
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button__text {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select__text {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button__text {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-ui-button__text:hover:not([disabled]) {
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button svg {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit-dialog_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button__trigger {
  fill: var(--jd-color-9);
  stroke: var(--jd-color-9);
}

.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select svg {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit-dialog_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select__trigger {
  fill: var(--jd-color-9);
  stroke: var(--jd-color-9);
}

.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button svg {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit-dialog_theme_dark .jodit-ui-button svg:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button svg:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button__trigger {
  fill: var(--jd-color-9);
  stroke: var(--jd-color-9);
}

.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button .jodit-icon {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button svg {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button__trigger {
  fill: var(--jd-color-9);
  stroke: var(--jd-color-9);
}

.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select .jodit-icon {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select svg {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select__trigger {
  fill: var(--jd-color-9);
  stroke: var(--jd-color-9);
}

.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button .jodit-icon {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button svg {
  fill: var(--jd-color-4);
  stroke: var(--jd-color-4);
}

.jodit_theme_dark .jodit-ui-button svg:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button svg:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button__trigger {
  fill: var(--jd-color-9);
  stroke: var(--jd-color-9);
}

.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {
  stroke: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {
  fill: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button__button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select__button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button__button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button__text:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button__button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select__button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button__button:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button__text:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {
  background-color: var(--jd-color-4);
  color: var(--jd-color-3);
}

.jodit-dialog_theme_dark .jodit-status-bar {
  background-color: var(--jd-color-7);
  border-color: var(--jd-color-6);
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {
  background-color: var(--jd-color-7);
  border-color: var(--jd-color-6);
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-status-bar {
  background-color: var(--jd-color-7);
  border-color: var(--jd-color-6);
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {
  background-color: var(--jd-color-7);
  border-color: var(--jd-color-6);
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-status-bar {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item a {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item span {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item a {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item span {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-status-bar {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item a {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item span {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item a {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item span {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) {
  background: var(--jd-color-7);
}

.jodit_theme_dark .jodit-toolbar__box:not(:empty) {
  background: var(--jd-color-7);
}

.jodit-dialog_theme_dark .jodit-icon-close {
  stroke: var(--jd-color-4);
}

.jodit_theme_dark .jodit-icon-close {
  stroke: var(--jd-color-4);
}

.jodit-dialog_theme_dark .jodit-wysiwyg {
  background-color: var(--jd-color-3);
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-wysiwyg_iframe {
  background-color: var(--jd-color-3);
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-wysiwyg {
  background-color: var(--jd-color-3);
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-wysiwyg_iframe {
  background-color: var(--jd-color-3);
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-form input[type=text] {
  background-color: rgba(81, 81, 81, 0.41);
  border-color: var(--jd-color-5);
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-form input[type=url] {
  background-color: rgba(81, 81, 81, 0.41);
  border-color: var(--jd-color-5);
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-form textarea {
  background-color: rgba(81, 81, 81, 0.41);
  border-color: var(--jd-color-5);
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-form input[type=text] {
  background-color: rgba(81, 81, 81, 0.41);
  border-color: var(--jd-color-5);
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-form input[type=url] {
  background-color: rgba(81, 81, 81, 0.41);
  border-color: var(--jd-color-5);
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-form textarea {
  background-color: rgba(81, 81, 81, 0.41);
  border-color: var(--jd-color-5);
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-form button {
  background-color: hsla(0, 0%, 41%, 0.75);
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-form button {
  background-color: hsla(0, 0%, 41%, 0.75);
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-placeholder {
  color: hsla(0, 5%, 81%, 0.8);
}

.jodit_theme_dark .jodit-placeholder {
  color: hsla(0, 5%, 81%, 0.8);
}

.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit_uploadfile_button {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-drag-and-drop__file-box {
  color: var(--jd-color-1);
}

.jodit_theme_dark .jodit_uploadfile_button {
  color: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box:hover {
  background-color: hsla(0, 0%, 41%, 0.75);
}

.jodit-dialog_theme_dark .jodit_uploadfile_button:hover {
  background-color: hsla(0, 0%, 41%, 0.75);
}

.jodit_theme_dark .jodit-drag-and-drop__file-box:hover {
  background-color: hsla(0, 0%, 41%, 0.75);
}

.jodit_theme_dark .jodit_uploadfile_button:hover {
  background-color: hsla(0, 0%, 41%, 0.75);
}

.jodit-dialog_theme_dark .jodit-add-new-line:before {
  border-top-color: var(--jd-color-5);
}

.jodit_theme_dark .jodit-add-new-line:before {
  border-top-color: var(--jd-color-5);
}

.jodit-dialog_theme_dark .jodit-add-new-line span {
  background: hsla(0, 0%, 41%, 0.75);
  border-color: var(--jd-color-5);
}

.jodit_theme_dark .jodit-add-new-line span {
  background: hsla(0, 0%, 41%, 0.75);
  border-color: var(--jd-color-5);
}

.jodit-dialog_theme_dark .jodit-add-new-line span svg {
  fill: var(--jd-color-1);
}

.jodit_theme_dark .jodit-add-new-line span svg {
  fill: var(--jd-color-1);
}

.jodit-dialog_theme_dark .jodit-resizer > i {
  background: hsla(0, 0%, 41%, 0.75);
  border-color: var(--jd-color-4);
}

.jodit_theme_dark .jodit-resizer > i {
  background: hsla(0, 0%, 41%, 0.75);
  border-color: var(--jd-color-4);
}

.jodit-dialog_theme_dark .jodit-input {
  background-color: var(--jd-color-4);
  border-color: var(--jd-color-2);
  color: var(--jd-color-2);
}

.jodit-dialog_theme_dark .jodit-select {
  background-color: var(--jd-color-4);
  border-color: var(--jd-color-2);
  color: var(--jd-color-2);
}

.jodit_theme_dark .jodit-input {
  background-color: var(--jd-color-4);
  border-color: var(--jd-color-2);
  color: var(--jd-color-2);
}

.jodit_theme_dark .jodit-select {
  background-color: var(--jd-color-4);
  border-color: var(--jd-color-2);
  color: var(--jd-color-2);
}

.jodit-dialog_theme_dark.jodit-dialog {
  background-color: var(--jd-color-3);
}

.jodit_theme_dark.jodit-dialog {
  background-color: var(--jd-color-3);
}

.jodit-dialog_theme_dark.jodit-dialog .jodit-dialog__header {
  border-color: var(--jd-color-2);
}

.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item {
  border-color: var(--jd-color-2);
}

.jodit_theme_dark.jodit-dialog .jodit-dialog__header {
  border-color: var(--jd-color-2);
}

.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item {
  border-color: var(--jd-color-2);
}

.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info {
  background-color: var(--jd-color-1);
}

.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info {
  background-color: var(--jd-color-1);
}

.jodit_theme_dark .jodit-toolbar-button:hover:not([disabled]) {
  background: transparent;
}

.jodit_theme_dark .jodit-toolbar-button__button:hover:not([disabled]) {
  background: rgba(255, 255, 255, 0.0784313725);
  color: white;
}

.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {
  background: rgba(255, 255, 255, 0.1098039216);
}

.jodit_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {
  fill: white;
}

.jodit_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {
  fill: white;
}

.jodit_theme_dark .jodit-popup__content {
  background: #1d2836;
}

.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {
  background: none;
  color: white;
}

.tema-2[data-bs-theme=dark]:root {
  --bs-theme: #b8c0ff;
  --bs-theme-rgb: 184, 192, 255;
}

.tema-2[data-bs-theme=light]:root {
  --bs-theme: #17248a;
  --bs-theme-rgb: 23, 36, 138;
}

.tema-2 body {
  font-family: Arial, Helvetica, sans-serif;
}

iframe#webpack-dev-server-client-overlay {
  display: none;
}

.tema-2 ::-webkit-scrollbar {
  background: rgba(68, 79, 210, 0.1607843137);
}

.tema-2 .card:not(.border-0):after,
.tema-2 .card:not(.border-0):before {
  display: none;
}

.tema-2 .card .card-arrow {
  display: none;
}

.tema-2 .card {
  border-radius: 18px;
}

.tema-2 .h6 {
  font-size: 12px;
}

.tema-2 #sidebar.app-sidebar {
  top: 20px;
  width: auto;
  right: 20px;
  left: 210px;
  height: 90px;
  border-radius: 0 18px 18px 0;
  position: absolute;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
}

.tema-2 #header.app-header {
  left: 20px;
  top: 20px;
  height: 90px;
  border-radius: 18px 18px 0 0;
  box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.05);
}

.tema-2 .app-content {
  margin-left: 0px;
  padding-top: 150px;
  padding-bottom: 60px;
}

.tema-2 .app-footer {
  margin-left: 0;
  margin-right: 30px;
  padding: 15px 20px;
  border-radius: 15px;
}

.tema-2 .app-footer p {
  margin-bottom: 0 !important;
}

.tema-2 .breaking-news {
  margin-left: 0;
  position: relative;
  border-radius: 20px;
}

.tema-2 .breaking-news .breaking-news-events {
  border-radius: 18px 18px 0 0;
}

@media (min-width: 768px) {
  .tema-2 .app-sidebar-toggled .app-header,
  .tema-2 .app-sidebar-toggled .app-sidebar {
    transform: translate(-110%, 0px);
  }
}
.tema-2 .app-sidebar-button {
  display: none;
  border-radius: 10px;
}

.tema-2 .app-theme-panel .app-theme-toggle-btn {
  border-radius: 100%;
}

.tema-2 .app-theme-panel .app-theme-panel-content > div + div {
  display: none;
}

.tema-2 .app-theme-panel .app-theme-panel-content > div:first-child {
  margin-bottom: 0 !important;
}

.tema-2 .app-theme-panel .app-theme-panel-content {
  border-radius: 10px;
}

.tema-2 .app-theme-panel.active .app-theme-toggle-btn {
  border-radius: 10px 0 0 10px;
}

.tema-2 .app-sidebar .app-sidebar-content .menu {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  overflow: initial;
  align-items: center;
}

.tema-2 .app-sidebar .app-sidebar-content {
  height: 100%;
  flex-direction: row;
  overflow: initial !important;
}

.tema-2 .menu-other-dropdown {
  display: flex;
}

.tema-2 #header.app-header {
  width: 190px;
  border-radius: 18px 0 0 18px;
  position: absolute;
}

.tema-2 .menu-first-dropdown {
  position: absolute;
  top: 95px;
  left: 0;
  right: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.tema-2 .app-sidebar .app-sidebar-content > div.mt-auto {
  display: none;
}

.tema-2 .menu-first-dropdown .menu-item {
  border-radius: 8px;
}

.tema-2 .menu .react-select__placeholder {
  font-size: 11px;
}

.tema-2 .menu .react-select__control {
  padding: 0px 5px;
  min-height: 30px;
}

.tema-2 .menu > div > div.mx-3 {
  margin-right: 0 !important;
}

.tema-2 .menu .react-select__option {
  font-size: 10px;
}

@media (min-width: 1201px) {
  .tema-2 .menu-settings {
    display: flex;
  }
  .tema-2 .app-sidebar .app-sidebar-content .menu .menu-item .menu-submenu {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 0;
    min-width: 170px;
  }
  .tema-2 .app-sidebar .app-sidebar-content .menu .menu-header {
    padding-top: 0;
    padding-bottom: 0;
  }
  .tema-2 .menu-item.has-sub.ps-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .tema-2 .menu-item.has-sub.ps-0 {
    position: relative;
  }
  .tema-2 .menu-other-dropdown .menu-submenu .menu-item {
    background: var(--bs-dark4);
  }
}
@media (max-width: 1200px) {
  .tema-2 #sidebar.app-sidebar {
    top: 90px;
    left: 20px;
    bottom: 10px;
    width: 230px;
    position: fixed;
    height: auto;
    box-shadow: none;
    background: none;
    transform: translate(-110%, 0px);
  }
  .tema-2 .app-sidebar .app-sidebar-content .menu {
    display: block;
  }
  .tema-2 .app-sidebar .app-sidebar-content {
    flex-direction: column;
    width: 100%;
    overflow: auto !important;
    height: 100%;
  }
  .tema-2 .menu-other-dropdown {
    display: block;
  }
  .tema-2 .app-sidebar .app-sidebar-content > div.mt-auto {
    display: block;
  }
  .tema-2 #header.app-header {
    position: fixed;
    width: 230px;
    border-radius: 14px;
    height: 60px;
  }
  .tema-2 div#sidebar:before {
    border-radius: 18px;
    opacity: 1;
  }
  .tema-2 .app-sidebar-mobile-toggled #sidebar.app-sidebar {
    transform: translate(0px, 0px);
  }
  .tema-2 .app-content {
    padding-top: 110px;
  }
  .tema-2 .menu-first-dropdown {
    position: static;
    display: block;
  }
  .tema-2 .menu-first-dropdown .menu-item {
    border-radius: 0;
  }
}
.tema-2[data-bs-theme=dark] .menu-first-dropdown .menu-item {
  background: #222a3b;
}
.tema-2[data-bs-theme=dark] .map-info-container {
  background: #0f1320 !important;
}

.tema-2[data-bs-theme=light] .menu-first-dropdown .menu-item {
  background: #f4f5fd;
}

@media (min-width: 992px) {
  .app-boxed-layout {
    min-height: 100vh;
  }
  .app-boxed-layout, .app-boxed-layout .app-header {
    max-width: 80rem;
    margin-left: auto;
    margin-right: auto;
  }
  .app-boxed-layout .app-top-nav {
    max-width: 80rem;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }
  .app-boxed-layout .app-top-nav .menu .menu-item .menu-submenu {
    position: fixed;
    left: auto;
    right: auto;
    top: auto;
  }
  .app-boxed-layout .app-sidebar {
    left: auto;
  }
}

.app-content-full-height .app-content {
  height: calc(100vh - 3.25rem);
}
.app-content-full-height.app-without-header .app-content {
  height: 100vh;
}

.app-content-full-width .app-content {
  margin: 0;
}
.app-content-full-width .app-footer {
  margin-left: 2rem;
}
@media (max-width: 767.98px) {
  .app-content-full-width .app-footer {
    margin-left: 1rem;
  }
}

.app-footer-fixed {
  position: fixed;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
}

.app-full-height {
  min-height: 100vh;
}

@keyframes appSidebarCollapse {
  from {
    margin-left: 0;
    opacity: 1;
  }
  to {
    margin-left: -14.375rem;
    opacity: 0;
  }
}
@keyframes appContentCollapse {
  from {
    margin-left: 14.375rem;
  }
  to {
    margin-left: 0;
  }
}
@keyframes appFooterCollapse {
  from {
    margin-left: 14.375rem;
  }
  to {
    margin-left: 2rem;
  }
}
@media (min-width: 768px) {
  .app-sidebar-collapsed .app-sidebar {
    margin-left: -10.475rem;
  }
  .app-sidebar-collapsed .app-content {
    margin-left: 3.875rem;
  }
  .app-sidebar-collapsed .app-sidebar .menu {
    opacity: 0;
  }
  .app-sidebar-collapsed .menu-footer {
    transform: translate(8px, 0);
  }
  .app-sidebar-collapsed .menu-footer-title {
    opacity: 0;
  }
}

.app-sidebar-mobile-toggled .app-sidebar {
  transform: translate(0%, 0px);
}

@keyframes appSidebarExpand {
  from {
    margin-left: -14.375rem;
  }
  to {
    margin-left: 0;
  }
}
@keyframes appContentExpand {
  from {
    margin-left: 0;
  }
  to {
    margin-left: 14.375rem;
  }
}
@keyframes appFooterExpand {
  from {
    margin-left: 2rem;
  }
  to {
    margin-left: 16.375rem;
  }
}
@media (min-width: 768px) {
  .app-sidebar-toggled .app-sidebar-button {
    transform: translate(100%, 0px);
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }
  .app-sidebar-toggled .app-sidebar-button i {
    transform: rotate(180deg);
  }
  .app-sidebar-toggled > .app-header {
    transform: translate(-100%, 0px);
  }
  .app-sidebar-toggled .app-sidebar {
    transform: translate(-100%, 0px);
  }
  .app-sidebar-toggled .app-content {
    margin-left: 10px;
  }
  .app-sidebar-toggled .breaking-news {
    margin-left: 10px;
  }
  .app-sidebar-toggled .app-footer {
    margin-left: 10px;
  }
}

@media (min-width: 768px) {
  .app-with-top-nav {
    padding-top: 6.125rem;
  }
  .app-with-top-nav .app-sidebar {
    top: 6.125rem;
  }
}
@media (min-width: 768px) {
  .app-with-top-nav.app-without-header {
    padding-top: 2.875rem;
  }
  .app-with-top-nav.app-without-header .app-sidebar {
    top: 2.875rem;
  }
}

.app-without-header {
  padding-top: 0;
}

.app-without-sidebar .app-content {
  margin: 0;
}

.breadcrumb {
  font-weight: bold;
}
.breadcrumb .breadcrumb-item a {
  text-decoration: none;
}
.breadcrumb .breadcrumb-item a:hover {
  text-decoration: underline;
}
.btn-scroll-top {
  position: fixed;
  bottom: 1.875rem;
  width: 2.5rem;
  height: 2.5rem;
  background: rgba(53, 67, 74, 0.75);
  color: #ffffff;
  text-align: center;
  text-decoration: none;
  z-index: 1020;
  border-radius: 36px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 1.875rem;
}
@media (max-width: 767.98px) {
  .btn-scroll-top {
    bottom: 1.25rem;
    z-index: 1020;
    right: 1.25rem;
  }
}
.btn-scroll-top:hover {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
  text-decoration: none;
}

.card-expand .app-content {
  z-index: 1120;
  position: relative;
  height: calc(100vh - 3.25rem);
  overflow: hidden;
}

[data-bs-theme=light] .card {
  background: rgb(255, 255, 255);
}

[data-bs-theme=dark] .card {
  background: rgba(255, 255, 255, 0.04);
}

.card {
  --bs-border-color-rgb: var(--bs-body-color-rgb);
  position: relative;
  border: none;
}
.card.border-theme {
  --bs-border-color-rgb: var(--bs-theme-rgb);
}
.card.card-expand {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1120;
  border-radius: 0;
  margin: 0 !important;
  padding: 0.3125rem;
  background: var(--bs-dark3);
  height: auto !important;
}
.card.card-expand .card-header, .card.card-expand .card-body {
  border-radius: 0;
}
.card.card-expand .card-body {
  flex: 1 0;
  height: auto !important;
  overflow: scroll;
}
.card.card-expand:not(.border-0):before {
  top: 5px;
  bottom: 5px;
  left: 20px;
  right: 20px;
  pointer-events: none;
}
.card.card-expand:not(.border-0):after {
  top: 20px;
  bottom: 20px;
  left: 5px;
  right: 5px;
  pointer-events: none;
}
.card.card-expand .card-arrow {
  margin: 5px;
  pointer-events: none;
}
.card .card-header .card-header-tabs .nav-item .nav-link.active {
  border-bottom-color: transparent;
}
.card .card-body .nav-tabs .nav-item .nav-link.active {
  background: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}
.card:before, .card:after {
  content: "";
  position: absolute;
  pointer-events: none;
}
.card:not(.border-0):before {
  left: 15px;
  right: 15px;
  top: 0;
  bottom: 0;
  border-top: 1px solid rgba(var(--bs-border-color-rgb), 0.3);
  border-bottom: 1px solid rgba(var(--bs-border-color-rgb), 0.3);
}
.card:not(.border-0):after {
  top: 15px;
  bottom: 15px;
  left: 0;
  right: 0;
  border-left: 1px solid rgba(var(--bs-border-color-rgb), 0.3);
  border-right: 1px solid rgba(var(--bs-border-color-rgb), 0.3);
}
.card > *:not(.card-arrow):not(.card-img-overlay):not(.card-img):not(.hljs-container) {
  position: relative;
  z-index: 10;
}
.card .card-arrow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}
.card .card-arrow-top-left, .card .card-arrow-top-right, .card .card-arrow-bottom-left, .card .card-arrow-bottom-right {
  width: 10px;
  height: 10px;
  position: absolute;
}
.card .card-arrow-top-left:before, .card .card-arrow-top-right:before, .card .card-arrow-bottom-left:before, .card .card-arrow-bottom-right:before {
  content: "";
  position: absolute;
  width: 2px;
  height: 8px;
  background: rgba(var(--bs-border-color-rgb), 0.75);
}
.card .card-arrow-top-left:after, .card .card-arrow-top-right:after, .card .card-arrow-bottom-left:after, .card .card-arrow-bottom-right:after {
  content: "";
  position: absolute;
  width: 10px;
  height: 2px;
  background: rgba(var(--bs-border-color-rgb), 0.75);
}
.card .card-arrow-top-left, .card .card-arrow-top-right {
  top: 0;
}
.card .card-arrow-top-left:before, .card .card-arrow-top-right:before {
  top: 2px;
}
.card .card-arrow-top-left:after, .card .card-arrow-top-right:after {
  top: 0;
}
.card .card-arrow-bottom-left, .card .card-arrow-bottom-right {
  bottom: 0;
}
.card .card-arrow-bottom-left:before, .card .card-arrow-bottom-right:before {
  bottom: 2px;
}
.card .card-arrow-bottom-left:after, .card .card-arrow-bottom-right:after {
  bottom: 0;
}
.card .card-arrow-top-left, .card .card-arrow-bottom-left {
  left: 0;
}
.card .card-arrow-top-left:before, .card .card-arrow-top-left:after, .card .card-arrow-bottom-left:before, .card .card-arrow-bottom-left:after {
  left: 0;
}
.card .card-arrow-top-right, .card .card-arrow-bottom-right {
  right: 0;
}
.card .card-arrow-top-right:before, .card .card-arrow-top-right:after, .card .card-arrow-bottom-right:before, .card .card-arrow-bottom-right:after {
  right: 0;
}

@media (max-width: 991.98px) {
  .card-columns {
    column-count: 2;
  }
}
@media (max-width: 575.98px) {
  .card-columns {
    column-count: 1;
  }
}

.caret:before {
  content: "\\f22c";
  display: inline-block;
  font-family: bootstrap-icons !important;
  font-style: normal;
  font-weight: 400 !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: -0.125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.dropup.caret, .dropup .caret {
  content: "";
  border-top: 0;
  border-bottom: 4px dashed;
  border-bottom: 4px solid\\9 ;
}

.carousel-indicators [data-bs-target] {
  overflow: hidden;
}

@keyframes appDropdownShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.dropdown-menu {
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}
.dropdown-menu.show {
  animation: appDropdownShow 0.25s both cubic-bezier(0.7, 0, 0.3, 1);
}

@media (max-width: 575.98px) {
  .dropdown.dropdown-mobile-full {
    position: initial;
  }
  .dropdown.dropdown-mobile-full .dropdown-menu {
    left: 0.25rem !important;
    right: 0.25rem !important;
    width: auto !important;
  }
}

[data-bs-theme=dark] .form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

[data-bs-theme=dark] .form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.form-select:not([multiple]) option {
  color: #000000;
}

[data-bs-theme=dark] .form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
[data-bs-theme=dark] .form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
[data-bs-theme=dark] .form-switch .form-check-input:checked {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

hr.hr-bg, hr.hr-transparent, hr.hr-inverse, hr.hr-inverse-transparent {
  border: none;
  height: 1px;
}
hr.hr-transparent {
  background-color: rgba(0, 0, 0, 0.3);
}
hr.hr-inverse {
  background-color: #1a1a1a;
}
hr.hr-inverse-transparent {
  background-color: rgba(255, 255, 255, 0.3);
}

a {
  color: var(--bs-theme);
}
a:hover {
  color: rgba(var(--bs-theme-rgb), 0.75);
}

.modal .modal-content > * {
  position: relative;
}
.modal .modal-dialog.modal-full {
  max-width: 100%;
  width: 100%;
}
.modal .modal-dialog.modal-full .modal-content {
  border-radius: 0;
}
.modal.modal-cover .modal-dialog {
  min-height: 100%;
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.modal.modal-cover .modal-content, .modal.modal-cover .modal-header, .modal.modal-cover .modal-footer {
  background: none;
  border: none;
}

[data-bs-theme=dark] .modal-backdrop {
  --bs-backdrop-bg: #1d2835;
}

.nav.nav-pills::-webkit-scrollbar {
  height: 5px;
}
.nav.nav-tabs.nav-tabs-v2::-webkit-scrollbar {
  height: 5px;
}
.nav.nav-tabs.nav-tabs-v2 > .nav-item > .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
  padding: 1rem 0;
  color: var(--bs-inverse);
}
.nav.nav-tabs.nav-tabs-v2 > .nav-item > .nav-link:hover, .nav.nav-tabs.nav-tabs-v2 > .nav-item > .nav-link.active {
  color: var(--bs-inverse);
  border-bottom-color: var(--bs-theme);
}
.nav.nav-tabs.nav-tabs-v2 > .nav-item.show > .nav-link {
  color: var(--bs-inverse);
  border-bottom-color: var(--bs-theme);
}

@media (max-width: 767.98px) {
  .nav-wizards-container {
    overflow: scroll;
  }
  .nav-wizards-container .nav.nav-wizards-1, .nav-wizards-container .nav.nav-wizards-2, .nav-wizards-container .nav.nav-wizards-3 {
    min-width: 37.5rem;
  }
}

.nav.nav-wizards-1 .nav-item {
  padding: 0;
}
.nav.nav-wizards-1 .nav-item .nav-link {
  position: relative;
  color: rgba(var(--bs-inverse-rgb), 0.75);
}
.nav.nav-wizards-1 .nav-item .nav-link .nav-no {
  width: 2.5rem;
  height: 2.5rem;
  margin: 0 auto;
  font-weight: 600;
  background: none;
  border: 2px solid var(--bs-border-color);
  position: relative;
  z-index: 10;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s linear;
}
.nav.nav-wizards-1 .nav-item .nav-link .nav-text {
  text-align: center;
  margin-top: 0.3125rem;
  font-weight: 600;
  font-size: 0.8125rem;
}
.nav.nav-wizards-1 .nav-item .nav-link.active, .nav.nav-wizards-1 .nav-item .nav-link.completed {
  color: var(--bs-theme);
}
.nav.nav-wizards-1 .nav-item .nav-link.active .nav-no, .nav.nav-wizards-1 .nav-item .nav-link.completed .nav-no {
  border-color: var(--bs-theme);
  color: var(--bs-theme);
}
.nav.nav-wizards-1 .nav-item .nav-link.active:before, .nav.nav-wizards-1 .nav-item .nav-link.active:after, .nav.nav-wizards-1 .nav-item .nav-link.completed:before, .nav.nav-wizards-1 .nav-item .nav-link.completed:after {
  background: var(--bs-theme);
}
.nav.nav-wizards-1 .nav-item .nav-link.active .nav-no {
  box-shadow: 0 0 0 5px rgba(var(--bs-theme-rgb), 0.2);
}
.nav.nav-wizards-1 .nav-item .nav-link.disabled {
  color: rgba(var(--bs-inverse-rgb), 0.25);
}
.nav.nav-wizards-1 .nav-item .nav-link:before {
  content: "";
  position: absolute;
  top: 1.625rem;
  height: 0.125rem;
  background: rgba(var(--bs-inverse-rgb), 0.3);
  transition: all 0.2s linear;
}
.nav.nav-wizards-1 .nav-item .nav-link:before {
  left: calc(-50% + 20px);
  right: calc(50% + 20px);
}
.nav.nav-wizards-1 .nav-item:first-child .nav-link:before {
  display: none;
}
.nav.nav-wizards-1 .nav-item:last-child .nav-link:after {
  display: none;
}
.nav.nav-wizards-2 .nav-item {
  padding: 0 1rem;
}
.nav.nav-wizards-2 .nav-item .nav-link {
  position: relative;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  background: rgba(var(--bs-inverse-rgb), 0.15);
  border-radius: 60px;
}
.nav.nav-wizards-2 .nav-item .nav-link .nav-text {
  text-align: center;
  font-weight: 600;
  font-size: 0.8125rem;
}
.nav.nav-wizards-2 .nav-item .nav-link:before {
  content: "";
  position: absolute;
  left: -2rem;
  right: 100%;
  height: 0.125rem;
  top: 50%;
  margin-top: -0.0625rem;
  background-color: rgba(var(--bs-inverse-rgb), 0.3);
  transition: all 0.2s linear;
}
.nav.nav-wizards-2 .nav-item .nav-link.disabled {
  color: rgba(var(--bs-inverse-rgb), 0.35);
}
.nav.nav-wizards-2 .nav-item .nav-link.active, .nav.nav-wizards-2 .nav-item .nav-link.completed {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
}
.nav.nav-wizards-2 .nav-item .nav-link.active:before, .nav.nav-wizards-2 .nav-item .nav-link.completed:before {
  background: var(--bs-theme);
}
.nav.nav-wizards-2 .nav-item .nav-link.active {
  box-shadow: 0 0 0 4px rgba(var(--bs-theme-rgb), 0.2);
}
.nav.nav-wizards-2 .nav-item:first-child .nav-link:before {
  display: none;
}
.nav.nav-wizards-3 .nav-item {
  padding: 0;
}
.nav.nav-wizards-3 .nav-item .nav-link {
  position: relative;
  color: rgba(var(--bs-inverse-rgb), 0.75);
}
.nav.nav-wizards-3 .nav-item .nav-link .nav-dot {
  width: 1rem;
  height: 1rem;
  margin: 0 auto;
  font-weight: 600;
  background: none;
  border: 3px solid var(--bs-border-color);
  position: relative;
  z-index: 10;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s linear;
}
.nav.nav-wizards-3 .nav-item .nav-link .nav-title {
  margin-top: 0.625rem;
  font-weight: 600;
  text-align: center;
}
.nav.nav-wizards-3 .nav-item .nav-link .nav-text {
  text-align: center;
  font-size: 0.8125rem;
}
.nav.nav-wizards-3 .nav-item .nav-link.active, .nav.nav-wizards-3 .nav-item .nav-link.completed {
  color: var(--bs-theme);
}
.nav.nav-wizards-3 .nav-item .nav-link.active .nav-dot, .nav.nav-wizards-3 .nav-item .nav-link.completed .nav-dot {
  border-color: var(--bs-theme);
  color: var(--bs-theme);
}
.nav.nav-wizards-3 .nav-item .nav-link.active:before, .nav.nav-wizards-3 .nav-item .nav-link.completed:before {
  background: var(--bs-theme);
}
.nav.nav-wizards-3 .nav-item .nav-link.active .nav-dot {
  box-shadow: 0 0 0 5px rgba(var(--bs-theme-rgb), 0.2);
}
.nav.nav-wizards-3 .nav-item .nav-link.disabled {
  color: rgba(var(--bs-inverse-rgb), 0.25);
}
.nav.nav-wizards-3 .nav-item .nav-link:before {
  content: "";
  position: absolute;
  left: calc(-50% + 8px);
  top: 0.875rem;
  right: calc(50% + 8px);
  height: 0.1875rem;
  background: rgba(var(--bs-inverse-rgb), 0.3);
}
.nav.nav-wizards-3 .nav-item:first-child .nav-link:before {
  display: none;
}

.navbar.navbar-sticky {
  top: 5.25rem;
  position: sticky;
  padding: 0;
  border-left: 1px solid var(--bs-border-color);
  margin-left: 1rem;
}
.navbar.navbar-sticky .nav {
  width: 100%;
  flex-direction: column;
}
.navbar.navbar-sticky .nav .nav-link {
  color: rgba(var(--bs-inverse-rgb), 0.6);
  padding: 0.25rem 1.5rem;
}
.navbar.navbar-sticky .nav .nav-link:hover {
  color: rgba(var(--bs-inverse-rgb), 1);
}
.navbar.navbar-sticky .nav .nav-link.active {
  color: var(--bs-theme);
  font-weight: 500;
}

.page-header {
  color: var(--bs-heading-color);
  padding: 0;
  border: none;
  margin-bottom: 1rem;
  font-weight: 600;
  font-size: 1.75rem;
}
.page-header small, .page-header .small {
  font-size: 1rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-weight: 300;
}

.pagination .page-item .page-link {
  border-radius: 0.25rem;
}
.pagination .page-item + .page-item {
  margin-left: 0.3125rem;
}

pre {
  display: block;
  padding: 1rem;
  font-size: 0.875rem;
  color: #44555e;
  word-break: break-all;
  word-wrap: break-word;
  background-color: #ffffff;
  border: 1px solid #a8b6bc;
  border-radius: 4px;
}

.row.row-grid > [class*=col-] + [class*=col-] {
  border-left: 1px solid rgba(var(--bs-inverse-rgb), 0.15);
}
.row.row-grid + .row-grid {
  border-top: 1px solid rgba(var(--bs-inverse-rgb), 0.15);
}

.table.table-card thead > tr td:first-child, .table.table-card thead > tr th:first-child, .table.table-card tbody > tr td:first-child, .table.table-card tbody > tr th:first-child {
  padding-left: 1rem;
}
.table.table-card thead > tr td:last-child, .table.table-card thead > tr th:last-child, .table.table-card tbody > tr td:last-child, .table.table-card tbody > tr th:last-child {
  padding-right: 1rem;
}
.table.table-xs {
  font-size: 0.75rem;
}
.table.table-xs thead th, .table.table-xs tbody th, .table.table-xs tfoot th {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
}
.table.table-xs thead td, .table.table-xs tbody td, .table.table-xs tfoot td {
  padding: 0.3125rem 0.5rem;
}

.toasts-container {
  position: fixed;
  top: 5px;
  padding-top: 1rem;
  width: 21.875rem;
  z-index: 9999;
  right: 0;
  padding-right: 1rem;
}
@media (max-width: 767.98px) {
  .toasts-container {
    width: 18.75rem;
  }
}
.toasts-container .toast {
  width: 100%;
}

.apexcharts-canvas .apexcharts-tooltip {
  font-size: 0.8125rem;
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}
.apexcharts-canvas .apexcharts-tooltip * {
  font-family: inherit !important;
}
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light, .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark {
  border: none;
  background: rgba(var(--bs-body-bg-rgb), 0.9);
  color: var(--bs-inverse);
}
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title, .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {
  background: rgba(var(--bs-inverse-rgb), 0.15);
  border-color: transparent;
  color: var(--bs-inverse);
  text-transform: uppercase;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-family: inherit !important;
  font-weight: 600;
  padding: 0.35rem 0.75rem;
  margin: 0;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group {
  padding: 0.35rem 0.75rem;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group .apexcharts-tooltip-marker {
  width: 0.625rem;
  height: 0.625rem;
  margin-right: 0.25rem;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group .apexcharts-tooltip-text .apexcharts-tooltip-y-group {
  padding: 0;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group + .apexcharts-tooltip-series-group {
  padding-top: 0;
}
.apexcharts-canvas .apexcharts-xaxistooltip * {
  font-family: inherit !important;
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark {
  color: #ffffff;
  background: #35434a;
  border-color: #35434a;
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-bottom:before, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-bottom:before {
  border-bottom-color: #35434a;
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-bottom:after, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-bottom:after {
  border-bottom-color: #35434a;
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-top:before, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-top:before {
  border-top-color: #35434a;
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-top:after, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-top:after {
  border-top-color: #35434a;
}
.apexcharts-canvas .apexcharts-yaxistooltip * {
  font-family: inherit !important;
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark {
  color: #ffffff;
  background: #35434a;
  border-color: #35434a;
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-right:before, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-right:before {
  border-right-color: #35434a;
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-right:after, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-right:after {
  border-right-color: #35434a;
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-left:before, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-left:before {
  border-left-color: #35434a;
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-left:after, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-left:after {
  border-left-color: #35434a;
}
.apexcharts-canvas .apexcharts-legend-marker {
  width: 0.625rem !important;
  height: 0.625rem !important;
  margin-right: 0.3125rem;
}
.apexcharts-canvas .apexcharts-menu {
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  border: none;
  padding: 0;
  border-radius: 0;
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}
.apexcharts-canvas .apexcharts-menu .apexcharts-menu-item {
  color: var(--bs-body-color);
}
.apexcharts-canvas .apexcharts-menu .apexcharts-menu-item:hover {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  color: var(--bs-body-color);
}
.apexcharts-canvas.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-reset-icon:hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-menu-icon:hover svg {
  fill: #ffffff;
}

body .daterangepicker {
  z-index: 1030;
  border-color: var(--bs-border-color-translucent);
  font-family: inherit;
  font-size: inherit;
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  border-radius: 0;
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  width: auto;
}
body .daterangepicker:before, body .daterangepicker:after {
  display: none;
}
body .daterangepicker:after {
  border-width: 0.4375rem;
  top: -0.4375rem;
  left: 0.625rem;
}
body .daterangepicker.opensright:after {
  right: 0.625rem;
  left: auto;
}
body .daterangepicker select.monthselect, body .daterangepicker select.yearselect {
  font-size: 0.7875rem;
}
body .daterangepicker .drp-calendar {
  max-width: inherit;
  padding: 0.75rem;
}
body .daterangepicker .drp-calendar .calendar-table {
  background: none;
  border: none;
  border-radius: 0;
}
body .daterangepicker .drp-calendar .calendar-table table thead .week, body .daterangepicker .drp-calendar .calendar-table table tbody .week {
  font-size: 0.74375rem;
  color: #c0cacf;
  font-weight: 600;
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th {
  min-width: auto;
  width: auto;
  height: auto;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  color: var(--bs-inverse);
  font-weight: 600;
  font-size: inherit;
  border: none;
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next span {
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:hover, body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:focus, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:hover, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:focus {
  background: none;
  color: var(--bs-theme);
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:hover span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:focus span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:hover span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:focus span {
  border-color: var(--bs-theme);
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .yearselect, body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .monthselect {
  border-color: var(--bs-border-color);
  background: transparent;
  border-radius: 4px;
  color: var(--bs-inverse);
  transition: all 0.2s linear;
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .yearselect:focus, body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .monthselect:focus {
  outline: none;
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  box-shadow: 0 0 0 0.125rem rgba(var(--bs-inverse-rgb), 0.5);
}
body .daterangepicker .drp-calendar .calendar-table table thead tr:last-child th {
  font-size: 0.74375rem;
  padding-bottom: 0.5rem;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td {
  min-width: auto;
  width: auto;
  height: auto;
  line-height: 1.3;
  padding: 0.625rem 0.375rem;
  font-weight: 400;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  border-color: var(--bs-border-color-translucent);
  font-size: 0.7875rem;
  border-radius: 0 !important;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available:hover, body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available:focus {
  background: var(--bs-theme);
  border-color: var(--bs-theme);
  color: var(--bs-theme-color);
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.in-range {
  background: rgba(var(--bs-theme-rgb), 0.25);
  border-color: rgba(var(--bs-theme-rgb), 0.5);
  color: var(--bs-inverse);
  border-radius: 0;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.active {
  background: var(--bs-theme);
  border-color: var(--bs-theme);
  color: var(--bs-theme-color);
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.start-date {
  border-radius: 0;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.end-date {
  border-radius: 0;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.off {
  background: none;
  color: rgba(var(--bs-inverse-rgb), 0.25);
}
body .daterangepicker .drp-calendar.left {
  padding: 0.75rem !important;
}
body .daterangepicker .drp-calendar.left .calendar-table {
  padding: 0 !important;
}
body .daterangepicker .drp-calendar.right {
  padding: 0.75rem !important;
  border-left: 1px solid var(--bs-border-color);
}
@media (max-width: 575.98px) {
  body .daterangepicker .drp-calendar.right {
    border-top: 1px solid var(--bs-border-color);
    border-left: none;
  }
}
body .daterangepicker .drp-buttons {
  padding: 0.75rem 0.75rem;
  border-color: var(--bs-border-color);
  background: rgba(var(--bs-inverse-rgb), 0.05);
  border: none;
}
body .daterangepicker .drp-buttons .btn.btn-primary {
  background: none;
  border: 1px solid var(--bs-btn-border-color);
  color: var(--bs-btn-color);
  --bs-btn-color: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #249d79;
  --bs-btn-hover-bg: #249d79;
  --bs-btn-hover-border-color: #249d79;
  --bs-btn-focus-shadow-rgb: 36, 157, 121;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #249d79;
  --bs-btn-active-border-color: #249d79;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #249d79;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #249d79;
  --bs-gradient: none;
}
body .daterangepicker .drp-buttons .btn.btn-primary:hover, body .daterangepicker .drp-buttons .btn.btn-primary:active {
  background: var(--bs-btn-hover-bg);
}
body .daterangepicker .drp-buttons .btn.btn-default {
  background: none;
  border: 1px solid var(--bs-btn-border-color);
  color: var(--bs-btn-color);
  --bs-btn-color: #798e98;
  --bs-btn-border-color: #798e98;
  --bs-btn-hover-color: #798e98;
  --bs-btn-hover-bg: #798e98;
  --bs-btn-hover-border-color: #798e98;
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #798e98;
  --bs-btn-active-border-color: #798e98;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #798e98;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #798e98;
  --bs-gradient: none;
}
body .daterangepicker .drp-buttons .btn.btn-default:hover, body .daterangepicker .drp-buttons .btn.btn-default:active {
  color: #000000;
  background: var(--bs-btn-hover-bg);
}
body .daterangepicker .ranges {
  display: none;
}
body .daterangepicker.show-ranges .ranges {
  position: relative;
  display: block;
}
@media (max-width: 767.98px) {
  body .daterangepicker.show-ranges .ranges {
    float: none;
    margin: 0;
    padding: 0.625rem;
    border-bottom: 1px solid var(--bs-border-color);
    overflow: scroll;
    max-width: 35rem;
  }
}
@media (max-width: 767.98px) {
  body .daterangepicker.show-ranges .ranges ul {
    width: auto;
    white-space: nowrap;
    display: flex;
    flex-wrap: nowrap;
    padding-right: 0.625rem;
  }
}
body .daterangepicker.show-ranges .ranges ul li {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-size: 0.8125rem;
  font-weight: 400;
}
@media (max-width: 767.98px) {
  body .daterangepicker.show-ranges .ranges ul li {
    border-radius: 4px;
    margin-right: 0.625rem !important;
  }
}
body .daterangepicker.show-ranges .ranges ul li:hover, body .daterangepicker.show-ranges .ranges ul li:focus {
  background: rgba(var(--bs-inverse-rgb), 0.15);
  color: rgba(var(--bs-inverse-rgb), 0.75);
}
body .daterangepicker.show-ranges .ranges ul li.active {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
  margin-right: -0.0625rem;
}
body .daterangepicker.show-ranges .drp-calendar.left {
  border-left: 1px solid rgba(var(--bs-inverse-rgb), 0.15) !important;
}
@media (max-width: 767.98px) {
  body .daterangepicker.show-ranges .drp-calendar.left {
    border-left: none !important;
  }
}

.dataTables_wrapper.dt-bootstrap5 .dataTables_length .form-select {
  margin: 0 0.5rem;
}
.dataTables_wrapper.dt-bootstrap5 .dataTables_scrollFootInner .table-bordered tr th:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTables_scrollHeadInner .table-bordered tr th:first-child {
  border-left: 1px solid var(--bs-border-color) !important;
}
.dataTables_wrapper.dt-bootstrap5 .dataTables_scrollFoot {
  z-index: 1020;
  margin-top: -0.125rem !important;
  position: inherit;
}
.dataTables_wrapper.dt-bootstrap5 .dataTables_scrollFoot .dataTables_scrollFootInner {
  border-top: 1px solid var(--bs-border-color) !important;
}
.dataTables_wrapper.dt-bootstrap5 .dataTables_scrollBody {
  border-left: none !important;
}
.dataTables_wrapper.dt-bootstrap5 .dt-buttons .btn-outline-default {
  background-color: transparent;
}
.dataTables_wrapper.dt-bootstrap5 .dt-buttons .btn-outline-default:hover, .dataTables_wrapper.dt-bootstrap5 .dt-buttons .btn-outline-default:focus {
  background-color: #798e98;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable.dtr-inline tr td.dtr-control:before {
  border-width: 1px;
  margin-top: -8px;
  border-color: var(--bs-border-color);
  background: none;
  box-shadow: none;
  color: var(--bs-inverse);
  border-radius: 0;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable.dtr-inline tr td.dtr-control:hover:before {
  background: var(--bs-border-color);
}
.dataTables_wrapper.dt-bootstrap5 .dataTable.dtr-inline tr.parent td.dtr-control:before {
  border-color: var(--bs-theme);
  color: var(--bs-theme);
  background: none;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc_disabled, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc_disabled, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc_disabled, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc_disabled {
  padding-right: 1.875rem;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc_disabled::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc_disabled::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc_disabled::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc_disabled::before {
  content: "\\f235";
  top: 20%;
  display: inline-block;
  font-family: bootstrap-icons !important;
  font-style: normal;
  font-weight: 400 !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: -0.125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc_disabled::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc_disabled::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc_disabled::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc_disabled::after {
  content: "\\f229";
  top: 45%;
  display: inline-block;
  font-family: bootstrap-icons !important;
  font-style: normal;
  font-weight: 400 !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: -0.125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc:before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc:after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc:before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc:after {
  color: var(--bs-theme);
  opacity: 1;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable thead .dtfc-fixed-left, .dataTables_wrapper.dt-bootstrap5 .dataTable thead .dtfc-fixed-right, .dataTables_wrapper.dt-bootstrap5 .dataTable tbody .dtfc-fixed-left, .dataTables_wrapper.dt-bootstrap5 .dataTable tbody .dtfc-fixed-right, .dataTables_wrapper.dt-bootstrap5 .dataTable tfoot .dtfc-fixed-left, .dataTables_wrapper.dt-bootstrap5 .dataTable tfoot .dtfc-fixed-right {
  z-index: 1;
  background-color: var(--bs-body-bg);
}
.dataTables_wrapper.dt-bootstrap5 .dataTable thead .dtfc-fixed-left:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable thead .dtfc-fixed-right:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable tbody .dtfc-fixed-left:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable tbody .dtfc-fixed-right:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable tfoot .dtfc-fixed-left:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable tfoot .dtfc-fixed-right:first-child {
  border-left: none;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable.dtfc-has-left tfoot {
  border: none !important;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable.dtfc-has-left tfoot > tr {
  height: 0 !important;
}
.dataTables_wrapper.dt-bootstrap5 .dataTable.dtfc-has-left .dataTables_empty {
  text-align: left !important;
}
.dataTables_wrapper.dt-bootstrap5 .dtfc-right-top-blocker {
  height: auto !important;
  margin-top: 0 !important;
  background: var(--bs-border-color) !important;
}

.fc-event-list .fc-event-item .fc-event-link {
  padding: 0.35rem 0.7rem;
  color: var(--bs-inverse);
  position: relative;
  border: 1px solid var(--bs-border-color);
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.fc-event-list .fc-event-item .fc-event-link:hover {
  background: rgba(var(--bs-inverse-rgb), 0.1);
}
.fc-event-list .fc-event-item .fc-event-link:after {
  content: "\\f0b2";
  color: rgba(var(--bs-inverse-rgb), 0.5);
  line-height: 1;
  margin-left: auto;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.fc-event-list .fc-event-item + .fc-event-item {
  margin-top: 0.5rem;
}

.fc-event-link.fc-dragging, .fc-event-link.fc-event-dragging {
  padding: 0.35rem 0.7rem;
  background: rgba(var(--bs-inverse-rgb), 0.15);
  border: 1px solid var(--bs-border-color);
  color: var(--bs-inverse);
  display: block;
  display: flex;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}

.fc .fc-toolbar, .fc .fc-header-toolbar {
  margin-bottom: 0 !important;
  flex-wrap: wrap;
  align-items: center;
}
.fc .fc-toolbar .fc-left, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1), .fc .fc-header-toolbar .fc-left, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) {
  border-bottom: 1px solid var(--bs-border-color);
  padding: 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 575.98px) {
  .fc .fc-toolbar .fc-left .btn-group, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group, .fc .fc-header-toolbar .fc-left .btn-group, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group {
    width: 100%;
  }
}
.fc .fc-toolbar .fc-left .btn, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn, .fc .fc-header-toolbar .fc-left .btn, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn {
  min-width: 6.25rem;
  background: none;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  color: var(--bs-btn-color);
  --bs-btn-color: #798e98;
  --bs-btn-border-color: #798e98;
  --bs-btn-hover-color: #798e98;
  --bs-btn-hover-bg: #798e98;
  --bs-btn-hover-border-color: #798e98;
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #798e98;
  --bs-btn-active-border-color: #798e98;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #798e98;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #798e98;
  --bs-gradient: none;
}
@media (max-width: 991.98px) {
  .fc .fc-toolbar .fc-left .btn, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn, .fc .fc-header-toolbar .fc-left .btn, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn {
    min-width: 5.625rem;
  }
}
.fc .fc-toolbar .fc-left .btn:hover, .fc .fc-toolbar .fc-left .btn:active, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn:hover, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn:active, .fc .fc-header-toolbar .fc-left .btn:hover, .fc .fc-header-toolbar .fc-left .btn:active, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn:hover, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn:active {
  color: #000000;
  background: var(--bs-btn-hover-bg);
}
.fc .fc-toolbar .fc-center, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(2), .fc .fc-header-toolbar .fc-center, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(2) {
  flex: 1 1;
  padding: 1rem;
}
.fc .fc-toolbar .fc-right, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3), .fc .fc-header-toolbar .fc-right, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) {
  padding: 1rem;
}
.fc .fc-toolbar .fc-right .btn, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn, .fc .fc-header-toolbar .fc-right .btn, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .btn {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  background: none;
  --bs-btn-color: #798e98;
  --bs-btn-border-color: #798e98;
  --bs-btn-hover-color: #798e98;
  --bs-btn-hover-bg: #798e98;
  --bs-btn-hover-border-color: #798e98;
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #798e98;
  --bs-btn-active-border-color: #798e98;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #798e98;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #798e98;
  --bs-gradient: none;
}
.fc .fc-toolbar .fc-right .btn:hover, .fc .fc-toolbar .fc-right .btn:active, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn:hover, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn:active, .fc .fc-header-toolbar .fc-right .btn:hover, .fc .fc-header-toolbar .fc-right .btn:active, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .btn:hover, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .btn:active {
  color: #000000;
}
.fc .fc-view .fc-event, .fc .fc-view .fc-event-dot {
  background-color: rgba(var(--bs-inverse-rgb), 0.15);
  border-color: transparent;
}
.fc .fc-view .fc-event.fc-daygrid-dot-event, .fc .fc-view .fc-event-dot.fc-daygrid-dot-event {
  background-color: rgba(var(--bs-inverse-rgb), 0.15);
  border-color: transparent;
}
.fc .fc-view.fc-dayGrid-view .fc-week-number, .fc .fc-view.fc-dayGrid-view .fc-day-number, .fc .fc-view.fc-dayGrid-view .fc-daygrid-day-number, .fc .fc-view.fc-dayGridMonth-view .fc-week-number, .fc .fc-view.fc-dayGridMonth-view .fc-day-number, .fc .fc-view.fc-dayGridMonth-view .fc-daygrid-day-number {
  padding: 0.125rem 0.25rem;
}
.fc .fc-view.fc-dayGrid-view .fc-day-grid-event, .fc .fc-view.fc-dayGrid-view .fc-daygrid-day-events, .fc .fc-view.fc-dayGridMonth-view .fc-day-grid-event, .fc .fc-view.fc-dayGridMonth-view .fc-daygrid-day-events {
  margin-top: 0.125rem;
}
.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-slats table, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-bg table {
  border: none;
}
.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-slats table tbody tr:first-child td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-slats table thead tr:first-child td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-bg table tbody tr:first-child td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-bg table thead tr:first-child td {
  border-top: none;
}
.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-content-skeleton table {
  border: none !important;
}
.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-content-skeleton table td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-content-skeleton table th {
  border: none !important;
}
.fc .fc-view a {
  text-decoration: none;
}
.fc .fc-view .fc-daygrid-event, .fc .fc-view .fc-timegrid-event-harness-inset .fc-timegrid-event, .fc .fc-view .fc-timegrid-event.fc-event-mirror, .fc .fc-view .fc-timegrid-more-link {
  box-shadow: none;
  border-radius: 0;
}
.fc td, .fc th {
  border-width: 1px;
  border-color: var(--bs-border-color);
}
.fc .fc-view-harness {
  height: auto !important;
}
.fc .fc-scroller-liquid-absolute {
  position: relative !important;
  overflow: initial !important;
}
.fc a:not([href]) {
  color: inherit;
}

.hljs {
  display: block;
  overflow-x: auto;
  color: var(--bs-gray-500);
  font-size: 0.7875rem;
}

.hljs-code,
.hljs-emphasis {
  font-style: italic;
}

.hljs-tag,
.hljs-name {
  color: var(--bs-gray-300);
}

.hljs-string,
.hljs-bullet {
  color: var(--bs-indigo);
}

.hljs-attr {
  color: var(--bs-teal);
}

.hljs a {
  color: inherit;
}
.hljs a:focus, .hljs a:hover {
  color: inherit;
  text-decoration: underline;
}

.hljs-container {
  padding: 1rem 1rem;
  border-top: 1px solid var(--bs-border-color);
  position: relative;
  z-index: 1;
}
.hljs-container pre {
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  border-radius: 0;
}

.ps {
  position: relative;
}
.ps .ps__rail-x, .ps .ps__rail-y {
  z-index: 10;
}
.ps .ps__rail-x.ps--clicking, .ps .ps__rail-x:hover, .ps .ps__rail-x:focus, .ps .ps__rail-y.ps--clicking, .ps .ps__rail-y:hover, .ps .ps__rail-y:focus {
  background: none;
}
.ps .ps__thumb-y {
  border-radius: 0;
  background: none;
}
.ps .ps__thumb-y:before {
  content: "";
  background: #aaa;
  position: absolute;
  top: 0.0625rem;
  bottom: 0.0625rem;
  right: 0;
  left: 0;
}

.app-sidebar .ps__rail-x,
.app-sidebar .ps__rail-y {
  display: none;
}

.rdt .rdtPicker {
  width: auto;
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  border: 1px solid var(--bs-border-color-translucent);
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}
.rdt .rdtPicker table thead tr th.rdtPrev, .rdt .rdtPicker table thead tr th.rdtNext, .rdt .rdtPicker table thead tr th.rdtSwitch {
  line-height: 20px;
  padding: 5px;
  height: auto;
  min-height: 30px;
  border: none;
  border-radius: 4px;
}
.rdt .rdtPicker table thead tr th.rdtPrev:hover, .rdt .rdtPicker table thead tr th.rdtPrev:focus, .rdt .rdtPicker table thead tr th.rdtNext:hover, .rdt .rdtPicker table thead tr th.rdtNext:focus, .rdt .rdtPicker table thead tr th.rdtSwitch:hover, .rdt .rdtPicker table thead tr th.rdtSwitch:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
}
.rdt .rdtPicker table thead tr th.rdtPrev:hover span:before, .rdt .rdtPicker table thead tr th.rdtPrev:focus span:before, .rdt .rdtPicker table thead tr th.rdtNext:hover span:before, .rdt .rdtPicker table thead tr th.rdtNext:focus span:before, .rdt .rdtPicker table thead tr th.rdtSwitch:hover span:before, .rdt .rdtPicker table thead tr th.rdtSwitch:focus span:before {
  color: var(--bs-body-color);
}
.rdt .rdtPicker table thead tr th.rdtPrev, .rdt .rdtPicker table thead tr th.rdtNext {
  color: transparent;
  width: 14.28%;
  position: relative;
}
.rdt .rdtPicker table thead tr th.rdtPrev span, .rdt .rdtPicker table thead tr th.rdtNext span {
  color: transparent;
  position: relative;
  display: block;
  border-radius: 4px;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.rdt .rdtPicker table thead tr th.rdtPrev span:before, .rdt .rdtPicker table thead tr th.rdtNext span:before {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  position: absolute;
  font-size: 14px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rdt .rdtPicker table thead tr th.rdtPrev span i, .rdt .rdtPicker table thead tr th.rdtNext span i {
  display: none;
}
.rdt .rdtPicker table thead tr th.rdtPrev span:before {
  content: "\\f104";
}
.rdt .rdtPicker table thead tr th.rdtNext span:before {
  content: "\\f105";
}
.rdt .rdtPicker table thead tr th.rdtSwitch {
  width: auto;
}
.rdt .rdtPicker table thead tr th.dow {
  padding: 5px 0;
}
.rdt .rdtPicker table tfoot {
  border: none;
}
.rdt .rdtPicker table tfoot tr td.rdtTimeToggle {
  border: none;
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  text-shadow: none;
  border-radius: 4px;
}
.rdt .rdtPicker table tfoot tr td.rdtTimeToggle:hover, .rdt .rdtPicker table tfoot tr td.rdtTimeToggle:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  text-shadow: none;
}
.rdt .rdtPicker .rdtTime {
  min-width: 180px;
}
.rdt .rdtPicker .rdtTime .rdtCounters {
  display: flex;
  align-items: center;
  justify-content: center;
}
.rdt .rdtPicker .rdtTime .rdtCounters > div {
  float: none;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter {
  height: 110px;
  width: 60px;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn {
  height: 35%;
  color: transparent;
  position: relative;
  border-radius: 4px;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn:before {
  content: "\\f106";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn:hover, .rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtCount {
  height: 30%;
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtCount + .rdtBtn:before {
  content: "\\f107";
}
.rdt .rdtPicker .rdtDays {
  min-width: 290px;
}
.rdt .rdtPicker .rdtDays .rdtDay {
  font-weight: 400;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  padding: 5px;
  line-height: 20px;
  border-radius: 8px;
}
.rdt .rdtPicker .rdtDays .rdtDay:hover, .rdt .rdtPicker .rdtDays .rdtDay:focus, .rdt .rdtPicker .rdtDays .rdtDay.rdtSelected, .rdt .rdtPicker .rdtDays .rdtDay.rdtHighlighted, .rdt .rdtPicker .rdtDays .rdtDay.rdtRange {
  background: rgba(var(--bs-body-color-rgb), 0.15) !important;
  text-shadow: none;
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtToday {
  background: var(--bs-theme) !important;
  color: var(--bs-theme-color) !important;
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtToday:before {
  border-bottom-color: var(--bs-inverse);
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtActive {
  background: var(--bs-theme) !important;
  color: var(--bs-theme-color) !important;
  text-shadow: none !important;
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtOld {
  color: rgba(var(--bs-inverse-rgb), 0.25);
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtNew {
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtDisabled {
  color: rgba(var(--bs-inverse-rgb), 0.25);
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtDisabled:hover, .rdt .rdtPicker .rdtDays .rdtDay.rdtDisabled:focus {
  background: none !important;
}
.rdt .rdtPicker .rdtMonths, .rdt .rdtPicker .rdtYears {
  min-width: 290px;
}
.rdt .rdtPicker .rdtMonths .rdtMonth, .rdt .rdtPicker .rdtMonths .rdtYear, .rdt .rdtPicker .rdtYears .rdtMonth, .rdt .rdtPicker .rdtYears .rdtYear {
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  text-shadow: none;
  border-radius: 4px;
}
.rdt .rdtPicker .rdtMonths .rdtMonth:hover, .rdt .rdtPicker .rdtMonths .rdtMonth:focus, .rdt .rdtPicker .rdtMonths .rdtYear:hover, .rdt .rdtPicker .rdtMonths .rdtYear:focus, .rdt .rdtPicker .rdtYears .rdtMonth:hover, .rdt .rdtPicker .rdtYears .rdtMonth:focus, .rdt .rdtPicker .rdtYears .rdtYear:hover, .rdt .rdtPicker .rdtYears .rdtYear:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
}
.rdt .rdtPicker .rdtMonths .rdtMonth.rdtFocused, .rdt .rdtPicker .rdtMonths .rdtYear.rdtFocused, .rdt .rdtPicker .rdtYears .rdtMonth.rdtFocused, .rdt .rdtPicker .rdtYears .rdtYear.rdtFocused {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  color: var(--bs-inverse);
}
.rdt .rdtPicker .rdtMonths .rdtMonth.rdtActive, .rdt .rdtPicker .rdtMonths .rdtYear.rdtActive, .rdt .rdtPicker .rdtYears .rdtMonth.rdtActive, .rdt .rdtPicker .rdtYears .rdtYear.rdtActive {
  background: #249d79 !important;
  color: var(--bs-inverse);
}

.react-datepicker-wrapper {
  width: 100%;
}

.react-datepicker {
  border: none;
  display: block;
  font-family: inherit;
  background: none;
}
.react-datepicker-popper .react-datepicker {
  padding: 0.3125rem;
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  z-index: 10;
  border-radius: 0;
  border: 1px solid var(--bs-border-color-translucent);
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}
.react-datepicker .react-datepicker__triangle {
  display: none;
}
.react-datepicker .react-datepicker__navigation {
  color: transparent;
  padding: 0.3125rem;
  line-height: 1.25rem;
  border: none;
  width: 1.875rem;
  height: 1.875rem;
  top: 0.3125rem;
  text-indent: 0;
  border-radius: 8px;
}
.react-datepicker .react-datepicker__navigation:hover, .react-datepicker .react-datepicker__navigation:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  outline: none;
}
.react-datepicker .react-datepicker__navigation:hover:after, .react-datepicker .react-datepicker__navigation:focus:after {
  color: var(--bs-body-color);
}
.react-datepicker .react-datepicker__navigation:after {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  position: absolute;
  font-size: 0.875rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.react-datepicker .react-datepicker__navigation .react-datepicker__navigation-icon {
  display: none;
}
.react-datepicker .react-datepicker__navigation.react-datepicker__navigation--previous:after {
  content: "\\f104";
}
.react-datepicker .react-datepicker__navigation.react-datepicker__navigation--next:after {
  content: "\\f105";
}
.react-datepicker .react-datepicker__month-container {
  float: none;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__header {
  background: none;
  border: none;
  padding: 0;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__current-month {
  font-size: 0.75rem;
  color: var(--bs-inverse);
  font-weight: 600;
  padding: 0.3125rem;
  line-height: 1.25rem;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__day-names {
  display: flex;
  margin-bottom: -0.1875rem;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__day-names .react-datepicker__day-name {
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  font-size: 0.75rem;
  padding: 0.3125rem;
  line-height: 1.25rem;
  margin: 0;
  flex: 1 1;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month {
  margin: 0;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week {
  display: flex;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day {
  padding: 0.3125rem;
  margin: 0.125rem;
  width: 1.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  flex: 1 1;
  border-radius: 4px;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day:hover, .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day:focus, .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day.react-datepicker__day--today, .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day.react-datepicker__day--keyboard-selected {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  color: var(--bs-inverse);
  outline: none;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day.react-datepicker__day--selected {
  background: #249d79;
  color: #ffffff;
}

body .react-select__control {
  border: 1px solid var(--bs-border-color);
  background: none;
  border-radius: 4px;
  padding: 0.375rem 0.75rem;
  min-height: 2.1875rem;
}
body .react-select__control:hover {
  border-color: var(--bs-border-color);
}
body .react-select__control.react-select__control--is-focused {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
  border-color: var(--bs-border-color);
}
body .react-select__control .react-select__value-container {
  padding: 0;
}
body .react-select__control .react-select__value-container .react-select__placeholder {
  margin: 0;
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
body .react-select__control .react-select__value-container .react-select__single-value {
  color: var(--bs-inverse);
}
body .react-select__control .react-select__value-container .react-select__input-container {
  margin: 0;
  padding: 0;
  color: #fff;
}
body .react-select__control .react-select__value-container .react-select__input-container .react-select__input {
  color: var(--bs-inverse);
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi {
  margin-bottom: -0.3125rem;
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__placeholder, body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__input-container {
  margin-top: -0.3125rem;
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value {
  margin: 0 0.25rem 0.25rem 0;
  background: var(--bs-theme);
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value .react-select__multi-value__label {
  color: var(--bs-theme-color);
  font-size: 0.75rem;
  padding: 0.125rem;
  padding-left: 0.375rem;
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value .react-select__multi-value__remove {
  border-radius: 0;
  padding: 0 3px;
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value .react-select__multi-value__remove:hover {
  background: none;
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
body .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0;
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
body .react-select__control .react-select__indicators .react-select__indicator:hover {
  color: var(--bs-inverse);
}
body .react-select__control .react-select__indicators .react-select__indicator-separator {
  background: none;
  margin: 0;
}
body .react-select__menu {
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  border-radius: 0;
  border: 1px solid var(--bs-border-color-translucent);
  z-index: 99;
}
body .react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-focused {
  background: rgba(var(--bs-body-color-rgb), 0.15);
}
body .react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-selected {
  background: #249d79;
  color: #ffffff;
}

body .rti--container {
  background: transparent;
  border: 1px solid var(--bs-border-color);
  border-radius: 4px;
  padding: 0.25rem 0.75rem;
  line-height: 1;
  gap: 0.25rem;
}
body .rti--container:focus-within {
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
body .rti--container .rti--tag {
  font-size: 0.75rem;
  color: var(--bs-theme-color);
  line-height: 0.9375rem;
  min-height: 1.25rem;
  font-weight: 500;
  border-radius: 1.25rem;
  padding: 0.3125rem 0.75rem;
  background: var(--bs-theme);
}
body .rti--container .rti--tag button {
  margin-top: 0.0625rem;
  margin-bottom: -0.0625rem;
  color: var(--bs-theme-color);
  margin-right: -0.3125rem;
  margin-left: 0.3125rem;
}
body .rti--container .rti--tag button:hover {
  color: var(--bs-theme-color);
  opacity: 0.5;
}
body .rti--container .rti--input {
  background: none;
  color: var(--bs-inverse);
}
body .rti--container .rti--input::placeholder {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-weight: 400;
}

.calendar {
  min-height: calc(100vh - 3.25rem);
  display: flex;
  border-left: 1px solid var(--bs-border-color);
}
@media (max-width: 767.98px) {
  .calendar {
    border: none;
  }
}
.calendar .calendar-body {
  flex: 1 1;
  height: calc(100vh - 3.25rem);
}
.calendar .calendar-body + .calendar-sidebar {
  border-left: 1px solid var(--bs-border-color);
}
.calendar .calendar-body .fc .fc-head-container th {
  border-bottom-width: 0;
}
.calendar .calendar-body .fc table {
  border: none !important;
}
.calendar .calendar-body .fc table thead tr, .calendar .calendar-body .fc table tbody tr {
  border-width: 0;
}
.calendar .calendar-body .fc table thead tr th:first-child, .calendar .calendar-body .fc table thead tr td:first-child, .calendar .calendar-body .fc table tbody tr th:first-child, .calendar .calendar-body .fc table tbody tr td:first-child {
  border-left-width: 0 !important;
}
.calendar .calendar-body .fc table thead tr th:last-child, .calendar .calendar-body .fc table thead tr td:last-child, .calendar .calendar-body .fc table tbody tr th:last-child, .calendar .calendar-body .fc table tbody tr td:last-child {
  border-right-width: 0 !important;
}
.calendar .calendar-body .fc table .fc-head-container {
  border: none;
}
.calendar .calendar-sidebar {
  width: 13.75rem;
  padding: 1rem;
}
@media (min-width: 992px) {
  .calendar .calendar-sidebar {
    height: calc(100vh - 3.25rem);
  }
}
@media (max-width: 991.98px) {
  .calendar .calendar-sidebar {
    display: none;
  }
}
.calendar .calendar-sidebar + .calendar-body {
  border-left: 1px solid var(--bs-border-color);
}
.calendar .calendar-sidebar .calendar-sidebar-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  display: flex;
  align-items: flex-end;
}

.coming-soon {
  min-height: 100vh;
  display: flex;
  align-items: center;
}
.coming-soon .coming-soon-img img {
  max-width: 100%;
}
.coming-soon .coming-soon-timer {
  padding: 2rem;
  min-height: 50vh;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.coming-soon .coming-soon-content {
  min-height: 50vh;
  position: relative;
  text-align: center;
  margin: 0 auto;
  padding: 2rem;
  background: linear-gradient(to bottom, rgba(var(--bs-inverse-rgb), 0.15) 0%, transparent 100%);
  flex: 1 1;
}
.coming-soon .coming-soon-content > * {
  max-width: 32.5rem;
  margin-left: auto;
  margin-right: auto;
}
.coming-soon .is-countdown {
  background: none;
  border: none;
  margin: 0;
  padding: 0;
}
.coming-soon .is-countdown:before, .coming-soon .is-countdown:after {
  content: "";
  display: table;
  clear: both;
}
.coming-soon .is-countdown .countdown-row {
  display: block;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.coming-soon .is-countdown .countdown-row .countdown-section {
  width: 7.5rem;
  padding: 1rem;
  background: rgba(var(--bs-inverse-rgb), 0.15);
  margin: 0.75rem;
  color: var(--bs-inverse);
  border-radius: 12px;
}
@media (max-width: 575.98px) {
  .coming-soon .is-countdown .countdown-row .countdown-section {
    width: 5rem;
    padding: 0.5rem 0;
    margin: 0.25rem;
  }
}
.coming-soon .is-countdown .countdown-amount {
  font-size: 3rem;
  font-weight: 600;
  line-height: 1.25;
}
@media (max-width: 575.98px) {
  .coming-soon .is-countdown .countdown-amount {
    font-size: 1.75rem;
  }
}
.coming-soon .is-countdown .countdown-period {
  font-size: 1.00625rem;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  line-height: 1.5;
}
@media (max-width: 575.98px) {
  .coming-soon .is-countdown .countdown-period {
    font-size: 0.7875rem;
  }
}

.data-management .dataTables_wrapper .dataTable {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  color: var(--bs-body-color);
}
.data-management .dataTables_wrapper .dataTables_filter {
  text-align: left;
  margin-bottom: 1rem;
  font-size: 0.75rem;
}
.data-management .dataTables_wrapper .dataTables_filter label {
  display: flex;
  align-items: center;
}
.data-management .dataTables_wrapper .dataTables_filter input {
  border-radius: 4px;
  font-size: 0.8125rem;
  min-width: 12.5rem;
}
@media (max-width: 991.98px) {
  .data-management .dataTables_wrapper .dataTables_filter input {
    min-width: inherit;
    flex: 1 1;
    width: 100%;
  }
}

.error-page {
  padding: 4rem 0;
  display: flex;
  align-items: center;
}
.error-page .error-page-content {
  margin: 0 auto;
  position: relative;
  padding: 0 1rem;
  text-align: center;
}
.error-page .error-page-content .error-code {
  color: var(--bs-inverse);
  left: 0;
  right: 0;
  font-size: 7.375rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.25;
  letter-spacing: 5px;
  text-shadow: 10px 10px rgba(var(--bs-inverse-rgb), 0.15);
}
@media (max-width: 575.98px) {
  .error-page .error-page-content .error-code {
    font-size: 6.375rem;
  }
}
.error-page .error-page-content .error-page-icon i {
  font-size: 8rem;
  color: #90a2aa;
}
.error-page .error-page-content h1, .error-page .error-page-content .h1 {
  font-size: 3rem;
  font-weight: 600;
}
@media (max-width: 575.98px) {
  .error-page .error-page-content h1, .error-page .error-page-content .h1 {
    font-size: 3.25rem;
  }
}
.error-page .error-page-content h3, .error-page .error-page-content .h3 {
  font-size: 1.125rem;
  font-weight: 400;
}
@media (max-width: 575.98px) {
  .error-page .error-page-content h3, .error-page .error-page-content .h3 {
    font-size: 1rem;
  }
}
.error-page .error-page-content .link-divider {
  width: 0.25rem;
  height: 0.25rem;
  display: inline-block;
  background: rgba(var(--bs-inverse-rgb), 0.3);
  position: relative;
  top: -0.125rem;
  margin: 0 1rem;
  border-radius: 4px;
}

.gallery-menu-container {
  min-width: 12.5rem;
}
@media (min-width: 768px) {
  .gallery-menu-container {
    min-height: calc(100vh - 3.25rem);
    border-right: 1px solid var(--bs-border-color);
  }
}

.gallery-menu {
  padding: 1rem;
  padding: 0;
}
@media (max-width: 767.98px) {
  .gallery-menu {
    overflow: scroll;
    border-bottom: 1px solid var(--bs-border-color);
    position: sticky;
    top: 3.25rem;
    display: flex;
    flex-wrap: nowrap;
  }
}
.gallery-menu .gallery-menu-header {
  padding: 1rem 1rem 0.25rem;
  font-weight: 600;
  font-size: 90%;
}
@media (max-width: 767.98px) {
  .gallery-menu .gallery-menu-header {
    display: none;
  }
}
.gallery-menu .gallery-menu-item .gallery-menu-link {
  padding: 0.35rem 1.25rem;
  display: block;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  text-decoration: none;
}
@media (max-width: 767.98px) {
  .gallery-menu .gallery-menu-item .gallery-menu-link {
    white-space: nowrap;
    padding: 0.9375rem 1.25rem 0.625rem;
  }
}
.gallery-menu .gallery-menu-item .gallery-menu-link .fa {
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
@media (max-width: 767.98px) {
  .gallery-menu .gallery-menu-item .gallery-menu-link .fa {
    display: block;
    margin: 0 0 0.1875rem !important;
    width: auto !important;
    font-size: 1.125rem;
  }
}
.gallery-menu .gallery-menu-item .gallery-menu-link:hover {
  color: rgba(var(--bs-inverse-rgb), 0.75);
}
.gallery-menu .gallery-menu-item .gallery-menu-link.active {
  color: var(--bs-theme);
  font-weight: 600;
}
.gallery-menu .gallery-menu-item .gallery-menu-link.active .fa {
  color: inherit;
}

.gallery-content-container {
  width: 100%;
}
@media (min-width: 768px) {
  .gallery-content-container {
    min-height: calc(100vh - 3.25rem);
  }
}

.gallery {
  padding: 1rem;
}
.gallery + .gallery {
  border-top: 1px solid var(--bs-border-color);
}
.gallery .gallery-title {
  font-size: 1.09375rem;
  color: var(--bs-inverse);
  font-weight: 600;
  margin-bottom: 1rem;
}
.gallery .gallery-title a {
  color: var(--bs-inverse);
  text-decoration: none;
}
.gallery .gallery-title a i {
  font-size: 0.875rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  margin-left: 0.3125rem;
}
.gallery .gallery-title small, .gallery .gallery-title .small {
  display: block;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-size: 0.7875rem;
}
.gallery .gallery-image-list {
  list-style-type: none;
  margin: -0.15rem;
  padding: 0;
}
.gallery .gallery-image-list:before, .gallery .gallery-image-list:after {
  content: "";
  display: table;
  clear: both;
}
.gallery .gallery-image-list > li {
  position: relative;
  padding-top: 12.5%;
  width: 16.6667%;
  float: left;
}
@media (max-width: 991.98px) {
  .gallery .gallery-image-list > li {
    width: 25%;
    padding-top: 18.75%;
  }
}
@media (max-width: 767.98px) {
  .gallery .gallery-image-list > li {
    width: 33.33%;
    padding-top: 33.33%;
  }
}
@media (max-width: 575.98px) {
  .gallery .gallery-image-list > li {
    width: 50%;
    padding-top: 50%;
  }
}
.gallery .gallery-image-list > li:hover {
  z-index: 10;
}
.gallery .gallery-image-list > li a {
  position: absolute;
  left: 0.15rem;
  right: 0.15rem;
  bottom: 0.15rem;
  top: 0.15rem;
  overflow: hidden;
  background: rgba(var(--bs-inverse-rgb), 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}
@media (min-width: 992px) {
  .gallery .gallery-image-list > li a:hover {
    left: -15%;
    right: -15%;
    top: -15%;
    bottom: -15%;
  }
}
.gallery .gallery-image-list > li img, .gallery .gallery-image-list > li .img {
  max-width: 100%;
}
.gallery .gallery-image-list > li .img-portrait {
  height: 100%;
  width: auto;
  max-height: 100%;
  max-width: inherit;
}
@media (max-width: 767.98px) {
  .gallery .gallery-image-list > li .img-portrait-xs {
    height: 100%;
    width: auto;
    max-height: 100%;
    max-width: inherit;
  }
}

.app-content.login-page {
  min-height: initial;
  padding: 0;
  flex: 1 1;
  overflow: auto;
}

.login-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.login-confirm-text p {
  font-size: 18px;
}
@media screen and (max-width: 991px) {
  .login-confirm-text p {
    font-size: 15px;
  }
}

.login-page .app-content {
  flex: 1 1;
  min-height: auto;
  padding: 50px 0;
  overflow: auto;
  margin-bottom: 0 !important;
}

.login-page .app-footer {
  margin: 0;
}

.login {
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  height: 100%;
}
.login .login-bg {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 130vw;
  height: 130vw;
  pointer-events: none;
  opacity: 0.1;
}
.login .login-bg::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bs-theme);
}
.login .login-bg video,
.login .login-bg iframe {
  width: 100%;
  height: 100%;
  mix-blend-mode: color-burn;
}
.login .app-header {
  position: static;
  height: auto;
  width: auto;
  background: no-repeat;
  margin: 0 auto;
}
.login .app-header .brand {
  padding: 0;
}
.login .login-content {
  width: 100%;
  max-width: 25rem;
  margin: 0 auto;
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media (max-width: 1199.98px) {
  .login > video {
    width: 200vw;
  }
}
@media (max-width: 767.98px) {
  .login > video {
    width: 400vw;
  }
}
@media (max-width: 767.98px) {
  .login {
    padding: 1rem;
  }
}

@media screen and (max-width: 767px) {
  .login-page .app-content {
    padding: 15px 0;
  }
  .login-confirm-text p {
    font-size: 12px;
  }
}
.mailbox {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.mailbox .mailbox-toolbar {
  padding: 0.75rem;
  display: flex;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-toolbar {
    overflow: scroll;
    white-space: nowrap;
    padding: 0.5rem;
    flex-wrap: nowrap;
  }
}
.mailbox .mailbox-toolbar .mailbox-toolbar-text {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  padding: 0.5rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-toolbar .mailbox-toolbar-text {
    padding: 0;
  }
}
.mailbox .mailbox-toolbar .mailbox-toolbar-link {
  padding: 0.5rem 1rem;
}
.mailbox .mailbox-toolbar .mailbox-toolbar-item {
  padding: 0.5rem;
}
.mailbox .mailbox-toolbar .mailbox-toolbar-link {
  color: rgba(var(--bs-inverse-rgb), 0.75);
  text-decoration: none;
  border-radius: 4px;
}
.mailbox .mailbox-toolbar .mailbox-toolbar-link:hover {
  background: rgba(var(--bs-inverse-rgb), 0.25);
}
.mailbox .mailbox-toolbar .mailbox-toolbar-link.active {
  background: var(--bs-theme);
  color: #ffffff;
  font-weight: 600;
}
.mailbox .mailbox-body {
  border-top: 1px solid var(--bs-border-color);
  overflow: hidden;
  display: flex;
  flex: 1 1;
}
.mailbox .mailbox-body .mailbox-sidebar {
  max-width: 22.5rem;
  height: 100%;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-body .mailbox-sidebar {
    max-width: 100%;
    height: auto;
  }
}
.mailbox .mailbox-body .mailbox-sidebar + .mailbox-content {
  border-left: 1px solid var(--bs-border-color);
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-body .mailbox-sidebar + .mailbox-content {
    border-left: none;
  }
}
.mailbox .mailbox-body .mailbox-content {
  height: 100%;
  flex: 1 1;
}
.mailbox .mailbox-empty-message {
  min-height: 100%;
  width: 100%;
  padding: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mailbox .mailbox-empty-message .mailbox-empty-message-icon i {
  font-size: 6.125rem;
}
.mailbox .mailbox-empty-message .mailbox-empty-message-img {
  width: 100%;
  text-align: center;
  margin-bottom: 1rem;
}
.mailbox .mailbox-empty-message .mailbox-empty-message-img img {
  width: 100%;
  height: 100%;
  max-width: 30rem;
  max-height: 30rem;
  opacity: 0.5;
}
.mailbox .mailbox-empty-message .mailbox-empty-message-title {
  font-size: 1.3125rem;
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
.mailbox .mailbox-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.mailbox .mailbox-list .mailbox-list-item {
  padding: 1rem;
  display: flex;
}
.mailbox .mailbox-list .mailbox-list-item + .mailbox-list-item {
  border-top: 1px solid var(--bs-border-color);
}
.mailbox .mailbox-list .mailbox-list-item:hover {
  background-color: rgba(var(--bs-inverse-rgb), 0.1);
}
.mailbox .mailbox-list .mailbox-list-item.unread .mailbox-message .mailbox-title {
  font-weight: 600;
  color: var(--bs-inverse);
}
.mailbox .mailbox-list .mailbox-list-item.active {
  background: rgba(var(--bs-inverse-rgb), 0.1);
}
.mailbox .mailbox-list .mailbox-list-item.has-attachment .mailbox-checkbox:after {
  content: "\\f0c1";
  position: absolute;
  top: 1.5625rem;
  text-align: center;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  width: 1.125rem;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  left: 0;
}
.mailbox .mailbox-list .mailbox-checkbox {
  position: relative;
}
.mailbox .mailbox-list .mailbox-checkbox + .mailbox-message {
  padding-left: 0.5rem;
}
.mailbox .mailbox-list .mailbox-message {
  flex: 1 1;
}
.mailbox .mailbox-list .mailbox-message .mailbox-list-item-link {
  display: block;
  color: var(--bs-inverse);
  text-decoration: none;
  position: relative;
}
.mailbox .mailbox-list .mailbox-message .mailbox-sender {
  position: relative;
  display: flex;
  align-items: center;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-list .mailbox-message .mailbox-sender {
    display: block;
  }
}
.mailbox .mailbox-list .mailbox-message .mailbox-sender .mailbox-sender-name {
  font-weight: 600;
  color: var(--bs-theme);
  flex: 1 1;
  margin-right: auto;
}
.mailbox .mailbox-list .mailbox-message .mailbox-sender .mailbox-time {
  font-size: 0.75rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-weight: 400;
  padding-left: 0.5rem;
}
.mailbox .mailbox-list .mailbox-message .mailbox-title {
  color: rgba(var(--bs-inverse-rgb), 0.75);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 18.125rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-list .mailbox-message .mailbox-title {
    max-width: initial;
    white-space: initial;
  }
}
.mailbox .mailbox-list .mailbox-message .mailbox-desc {
  position: relative;
  font-size: 0.8125rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  max-height: 2.625rem;
  overflow: hidden;
}
.mailbox .mailbox-detail {
  padding: 1.5rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-detail {
    padding: 1rem;
  }
}
.mailbox .mailbox-detail .mailbox-detail-header {
  border-bottom: 1px solid var(--bs-border-color);
  padding: 0 0 1.5rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-detail .mailbox-detail-header {
    padding-bottom: 1rem;
  }
}
.mailbox .mailbox-detail .mailbox-detail-content {
  padding: 1.5rem 0;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-detail .mailbox-detail-content {
    padding: 1rem 0;
  }
}
.mailbox .mailbox-detail .mailbox-detail-body {
  font-size: 0.875rem;
}
.mailbox .mailbox-detail .mailbox-detail-attachment {
  display: flex;
  flex-wrap: wrap;
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment {
  background: rgba(var(--bs-inverse-rgb), 0.15);
  width: 7.5rem;
  overflow: hidden;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  margin-right: 0.5rem;
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment a {
  display: block;
  text-decoration: none;
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-file {
  height: 3.75rem;
  overflow: hidden;
  text-align: center;
  background: rgba(var(--bs-inverse-rgb), 0.1);
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-file i {
  display: block;
  line-height: 3.75rem;
  font-size: 2rem;
  color: var(--bs-inverse);
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-file img {
  max-width: 100%;
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-name {
  color: var(--bs-inverse);
  padding: 0.125rem 0.625rem;
  font-size: 0.8125rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mailbox .mailbox-form .mailbox-form-header {
  padding: 1rem 1.5rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-form .mailbox-form-header {
    padding: 0.75rem 1rem;
  }
}
.mailbox .mailbox-form .mailbox-form-header .form-control {
  background: rgba(var(--bs-inverse-rgb), 0.1);
}
.mailbox .mailbox-form .note-editor {
  border: none;
  border-radius: 0;
}
.mailbox .mailbox-form .note-editor .note-toolbar {
  border-top: 1px solid var(--bs-border-color);
  border-bottom: 1px solid var(--bs-border-color);
}
.mailbox .mailbox-form .note-editor .note-editing-area {
  background: rgba(var(--bs-inverse-rgb), 0.1);
}

.messenger {
  height: 100%;
  display: flex;
}
.messenger .messenger-sidebar {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
@media (min-width: 992px) {
  .messenger .messenger-sidebar {
    max-width: 22.5rem;
    border-right: 1px solid var(--bs-border-color);
  }
}
.messenger .messenger-sidebar .messenger-sidebar-header {
  border-bottom: 1px solid var(--bs-border-color);
  padding: 1rem;
}
.messenger .messenger-sidebar .messenger-sidebar-body {
  flex: 1 1;
  overflow: hidden;
}
.messenger .messenger-sidebar .messenger-item {
  border-bottom: 1px solid var(--bs-border-color);
}
.messenger .messenger-sidebar .messenger-item .messenger-link {
  display: flex;
  padding: 0.85rem 1rem;
  text-decoration: none;
  color: var(--bs-inverse);
}
.messenger .messenger-sidebar .messenger-item .messenger-link.active {
  background-color: rgba(var(--bs-inverse-rgb), 0.15);
}
.messenger .messenger-sidebar .messenger-item .messenger-link:hover, .messenger .messenger-sidebar .messenger-item .messenger-link:focus {
  background-color: rgba(var(--bs-inverse-rgb), 0.1);
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-media {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-media img {
  max-width: 100%;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-media + .messenger-info {
  padding-left: 0.85rem;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-info {
  flex: 1 1;
  white-space: nowrap;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-time-badge {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-time {
  font-size: 0.690625rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  margin-bottom: 0.25rem;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-text, .messenger .messenger-sidebar .messenger-item .messenger-link .messenger-name {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 13.75rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-size: 0.8125rem;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-name {
  font-weight: 600;
  color: var(--bs-inverse);
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-badge {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
  display: inline-flex;
  border-radius: 1.875rem;
  padding: 0 0.1875rem;
  min-width: 1.125rem;
  min-height: 1.125rem;
  align-items: center;
  justify-content: center;
  font-size: 0.56875rem;
  font-weight: 600;
  margin-left: auto;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-badge.empty {
  display: none;
}
.messenger .messenger-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
@media (max-width: 991.98px) {
  .messenger .messenger-content {
    display: none;
  }
}
.messenger .messenger-content .messenger-content-header {
  display: flex;
  border-bottom: 1px solid var(--bs-border-color);
  padding: 0.75rem 1rem;
  align-items: center;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-mobile-toggler {
  display: none;
}
@media (max-width: 991.98px) {
  .messenger .messenger-content .messenger-content-header .messenger-content-header-mobile-toggler {
    display: block;
  }
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-mobile-toggler a {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-size: 1.125rem;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-media .media {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-media + .messenger-content-header-info {
  margin-left: 1rem;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-info {
  font-size: 0.875rem;
  color: var(--bs-inverse);
  font-weight: 600;
  font-size: 0.9375rem;
  flex: 1 1;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-info small, .messenger .messenger-content .messenger-content-header .messenger-content-header-info .small {
  display: block;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-weight: normal;
  font-size: 0.6875rem;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-btn {
  display: flex;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-btn .btn {
  font-size: 1rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-btn .btn:hover, .messenger .messenger-content .messenger-content-header .messenger-content-header-btn .btn:focus {
  color: var(--bs-inverse);
}
.messenger .messenger-content .messenger-content-body {
  flex: 1 1;
  overflow: hidden;
}
.messenger .messenger-content .messenger-content-body .widget-chat {
  padding: 1rem;
}
.messenger .messenger-content .messenger-content-footer {
  border-top: 1px solid var(--bs-border-color);
  padding: 1rem;
}
@media (max-width: 991.98px) {
  .messenger.messenger-content-toggled .messenger-sidebar {
    display: none;
  }
  .messenger.messenger-content-toggled .messenger-content {
    display: flex;
  }
}

.pos {
  background: var(--app-pos-bg);
  height: 100%;
}
.pos .pos-container {
  height: 100%;
  padding: 0;
}
@media (min-width: 992px) {
  .pos .pos-container {
    display: flex;
  }
  .pos .pos-container > div + div {
    border-left: 1px solid var(--bs-border-color);
  }
}
.pos .pos-menu {
  display: flex;
}
@media (min-width: 992px) {
  .pos .pos-menu {
    width: 140px;
    flex-direction: column;
  }
}
@media (max-width: 991.98px) {
  .pos .pos-menu {
    overflow: scroll;
    align-items: center;
    border-bottom: 1px solid var(--bs-border-color);
  }
}
.pos .pos-menu .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
@media (max-width: 991.98px) {
  .pos .pos-menu .logo {
    width: 140px;
    height: 5.9375rem;
    flex: 0 0 140px;
  }
}
.pos .pos-menu .logo a {
  display: block;
  text-decoration: none;
  color: inherit;
}
.pos .pos-menu .logo .logo-img {
  text-align: center;
  height: 2.875rem;
}
.pos .pos-menu .logo .logo-text {
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 1px;
  margin-top: 0.25rem;
}
.pos .pos-menu .logo img {
  max-width: 100%;
  max-height: 100%;
}
.pos .pos-menu .nav-container {
  flex: 1 1;
}
@media (min-width: 992px) {
  .pos .pos-menu .nav-container {
    overflow: hidden;
    padding: 0;
  }
}
.pos .pos-menu .nav.nav-tabs {
  margin: 0;
  padding: 0;
  display: block;
  border: 0;
}
@media (max-width: 991.98px) {
  .pos .pos-menu .nav.nav-tabs {
    display: flex;
    flex-wrap: nowrap;
  }
}
@media (max-width: 991.98px) {
  .pos .pos-menu .nav.nav-tabs .nav-item {
    min-width: 5.625rem;
  }
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link {
  position: relative;
  padding: 1rem;
  white-space: nowrap;
  text-align: center;
  color: rgba(var(--bs-inverse), 0.25);
  border: none;
  font-size: 0.65625rem;
  text-transform: uppercase;
  font-weight: 600;
  border-radius: 0;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card {
  margin: -0.75rem -0.25rem;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card .card-body {
  padding: 0.5rem 0.7rem;
  margin: 0.5rem;
  flex: 1 1;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card:before, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card:after, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card .card-arrow {
  visibility: hidden;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .fa {
  display: block;
  margin: 0.225rem auto 0.35rem auto !important;
  font-size: 1.25rem;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link:hover {
  color: rgba(var(--bs-inverse), 0.5);
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active {
  color: var(--bs-inverse);
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active .card:before, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active .card:after, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active .card .card-arrow {
  visibility: visible;
}
.pos .pos-content {
  flex: 1 1;
}
@media (min-width: 992px) {
  .pos .pos-content {
    overflow: scroll;
  }
}
@media (max-width: 991.98px) {
  .pos .pos-content {
    height: calc(100% - 96px);
  }
}
.pos .pos-content .pos-content-container {
  padding: 0 2rem;
}
.pos .pos-sidebar {
  width: 360px;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 0 0 360px;
}
@media (max-width: 991.98px) {
  .pos .pos-sidebar {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto;
    z-index: 1021;
    background: var(--bs-body-bg);
    background: var(--bs-body-bg-gradient);
    display: none;
  }
}
.pos .pos-sidebar .pos-sidebar-header {
  padding: 1rem 1.5rem;
  position: relative;
  display: flex;
  align-items: center;
}
.pos .pos-sidebar .pos-sidebar-header .back-btn {
  border: none;
  display: none;
  margin-right: 1rem;
}
@media (max-width: 991.98px) {
  .pos .pos-sidebar .pos-sidebar-header .back-btn {
    display: block;
  }
}
.pos .pos-sidebar .pos-sidebar-header .back-btn .btn {
  color: var(--bs-inverse);
  padding: 0;
  width: 100%;
  height: 100%;
  font-size: 1.09375rem;
}
.pos .pos-sidebar .pos-sidebar-header .icon img {
  height: 1.875rem;
}
.pos .pos-sidebar .pos-sidebar-header .icon + .title {
  padding-left: 0.625rem;
}
.pos .pos-sidebar .pos-sidebar-header .title {
  font-weight: 600;
  flex: 1 1;
}
.pos .pos-sidebar .pos-sidebar-header .order {
  display: block;
}
.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs {
  padding: 0 1.5rem;
}
.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs .nav-item .nav-link {
  color: rgba(var(--bs-inverse), 0.5);
}
.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs .nav-item .nav-link.active {
  color: var(--bs-inverse);
}
.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs .nav-item + .nav-item {
  margin-left: 0.5rem;
}
.pos .pos-sidebar .pos-sidebar-body {
  padding: 0;
  margin: 0;
  overflow: scroll;
  flex: 1 1;
}
.pos .pos-sidebar .pos-sidebar-footer {
  border-top: 1px solid var(--bs-border-color);
  padding: 1rem 1.5rem;
}
.pos .pos-sidebar .pos-order {
  padding: 1.5rem;
  position: relative;
  display: flex;
}
.pos .pos-sidebar .pos-order .pos-order-product {
  display: flex;
  flex: 1 1;
}
.pos .pos-sidebar .pos-order .pos-order-product .img {
  width: 4.5rem;
  height: 4.5rem;
  background-position: center;
  background-size: cover;
}
.pos .pos-sidebar .pos-order .pos-order-product > * + * {
  margin-left: 1rem;
}
.pos .pos-sidebar .pos-order > * + * {
  margin-left: 1rem;
}
.pos .pos-sidebar .pos-order .pos-order-confirmation {
  position: absolute;
  top: 0;
  left: 0.0625rem;
  right: 0.0625rem;
  bottom: 0;
  z-index: 10;
  background: rgba(235, 235, 235, 0.88);
  padding: 1rem;
  margin: 0;
}
.pos .pos-sidebar .pos-order .pos-order-confirmation > * {
  position: relative;
}
.pos .pos-sidebar .pos-order .pos-order-confirmation .btn {
  min-width: 3.75rem;
}
.pos .pos-sidebar .pos-order + .pos-order {
  border-top: 1px solid var(--bs-border-color);
}
.pos .pos-header {
  padding: 0.66rem 1.75rem;
  height: 3.25rem;
  display: flex;
  align-items: center;
}
.pos .pos-header .logo, .pos .pos-header .time, .pos .pos-header .nav {
  width: 33.33%;
}
@media (max-width: 767.98px) {
  .pos .pos-header .logo, .pos .pos-header .time, .pos .pos-header .nav {
    width: 50%;
  }
}
.pos .pos-header .logo {
  display: flex;
}
.pos .pos-header .logo > div, .pos .pos-header .logo > a {
  text-align: center;
  color: var(--bs-inverse);
  text-decoration: none;
  display: flex;
  align-items: center;
}
.pos .pos-header .logo > div .logo-img img, .pos .pos-header .logo > a .logo-img img {
  height: 2rem;
}
.pos .pos-header .logo > div .logo-text, .pos .pos-header .logo > a .logo-text {
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 0.0625rem;
  margin-left: 1rem;
}
.pos .pos-header .time {
  font-weight: 600;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767.98px) {
  .pos .pos-header .time {
    display: none;
  }
}
.pos .pos-header .nav {
  align-items: center;
  justify-content: flex-end;
}
.pos .pos-header .nav .nav-item .nav-link {
  padding: 0.333rem 1rem;
  color: var(--bs-inverse);
}
@media (max-width: 767.98px) {
  .pos .pos-header .nav .nav-item .nav-link {
    padding: 0.333rem 0.66rem;
  }
}
.pos .pos-header .nav .nav-item .nav-link .nav-icon {
  height: 1.25rem;
  font-size: 1.25rem;
}
.pos .pos-header .nav .nav-item .nav-link:hover {
  color: rgba(var(--bs-inverse), 0.5);
}
.pos .pos-product {
  text-decoration: none;
  color: var(--bs-inverse);
  position: relative;
  transition: all 0.2s linear;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.pos .pos-product .img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 11.25rem;
  transition: all 0.2s linear;
}
.pos .pos-product .info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: rgba(var(--bs-inverse), 0.1);
  padding: 1rem;
}
.pos .pos-product .info .title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--app-component-color);
  margin: 0 0 0.125rem;
}
.pos .pos-product .info .desc {
  color: rgba(var(--bs-inverse), 0.5);
  margin: 0 0 1rem;
  line-height: 1.4;
  flex: 1 1;
}
.pos .pos-product .info .price {
  margin: 0;
  font-weight: 600;
  color: var(--app-component-color);
  font-size: 1rem;
}
.pos .pos-product.not-available {
  cursor: not-allowed;
}
.pos .pos-product.not-available .not-available-text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 11.25rem;
  background: rgba(235, 235, 235, 0.88);
  color: var(--bs-inverse);
  font-size: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pos .pos-table-booking {
  display: block;
  margin-bottom: 1.25rem;
  text-decoration: none;
  color: var(--bs-inverse);
}
.pos .pos-table-booking:hover .pos-table-booking-container {
  background: rgba(var(--bs-inverse), 0.2);
}
.pos .pos-table-booking .pos-table-booking-container {
  padding: 0;
  background: rgba(var(--bs-inverse), 0.1);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-header {
  padding: 1rem;
  border-bottom: 1px solid var(--bs-border-color);
  color: rgba(var(--bs-inverse), 0.5);
  font-weight: 600;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-header .no {
  font-size: 2.5rem;
  color: var(--bs-inverse);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking {
  font-size: 0.8125rem;
  padding: 0.333rem 1rem;
  display: flex;
  align-items: center;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .time {
  width: 4.6875rem;
  font-weight: 600;
  font-size: 0.74375rem;
  color: rgba(var(--bs-inverse), 0.5);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .info {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1 1;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .status {
  font-size: 0.375rem;
  color: #617a86;
  display: flex;
  align-items: center;
  padding-left: 1rem;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .status.upcoming {
  color: #ff9f0c;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .status.in-progress {
  color: #249d79;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking.highlight {
  color: var(--bs-theme);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking.highlight .time {
  color: rgba(var(--bs-theme-rgb), 0.75);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking + .booking {
  border-top: 1px solid var(--bs-border-color);
}
.pos .pos-task {
  border-bottom: 1px solid var(--bs-border-color);
}
@media (min-width: 768px) {
  .pos .pos-task {
    display: flex;
  }
}
.pos .pos-task .pos-task-info {
  width: 30%;
  padding: 1.5rem;
  text-align: right;
}
@media (max-width: 767.98px) {
  .pos .pos-task .pos-task-info {
    width: auto;
    position: relative;
    text-align: left;
  }
}
.pos .pos-task .pos-task-body {
  padding: 1.5rem;
  flex: 1 1;
  border-left: 1px solid var(--bs-border-color);
}
@media (max-width: 767.98px) {
  .pos .pos-task .pos-task-body {
    border-left: none;
    padding-top: 0;
  }
}
.pos .pos-task .pos-task-body .pos-task-completed {
  font-size: 1rem;
  line-height: 2.25rem;
}
@media (max-width: 767.98px) {
  .pos .pos-task .pos-task-body .pos-task-completed {
    border-top: 1px solid var(--bs-border-color);
    margin-top: -0.625rem;
    padding-top: 0.625rem;
  }
}
.pos .pos-task .pos-task-body .pos-task-product {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-img {
  padding-top: 75%;
  position: relative;
  margin-bottom: 1rem;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-img .cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 8px;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-img .caption {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(53, 67, 74, 0.75);
  color: var(--bs-white);
  font-size: 1.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-info {
  display: flex;
  flex: 1 1;
  margin-bottom: 1rem;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-action .btn {
  display: block;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-action .btn + .btn {
  margin-top: 0.75rem;
}
.pos .pos-task .pos-task-body .pos-task-product.completed .pos-task-product-info {
  opacity: 0.33;
}
.pos .pos-checkout-table {
  padding: 0.0625rem;
  margin: 0;
  height: 100%;
}
.pos .pos-checkout-table .pos-checkout-table-container {
  color: var(--bs-inverse);
  display: block;
  padding: 0;
  height: 100%;
  text-decoration: none;
  position: relative;
  transition: all 0.1s linear;
  margin: 0.25rem;
}
.pos .pos-checkout-table .pos-checkout-table-container:before {
  transition: all 0.1s linear;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-header {
  padding: 1rem;
  text-align: center;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-header .status {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  font-size: 0.5rem;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-info > .row {
  border-top: 1px solid var(--bs-border-color);
  margin: 0;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-info > .row > div {
  padding: 0.25rem 0.5rem;
  text-align: center;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-info > .row > div + div {
  border-left: 1px solid var(--bs-border-color);
}
.pos .pos-checkout-table.in-use:hover:not(.disabled) {
  position: relative;
  z-index: 10;
}
.pos .pos-checkout-table.in-use:hover:not(.disabled) .table-container {
  position: relative;
}
.pos .pos-checkout-table.in-use:hover:not(.disabled) .table-container:before {
  content: "";
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(45, 51, 58, 0.75);
}
.pos .pos-checkout-table.in-use:hover:not(.disabled) .table-container:after {
  content: "\\f00c";
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: var(--app-component-color);
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.pos .pos-checkout-table.selected:not(.disabled) .pos-checkout-table-container .table-info-row, .pos .pos-checkout-table.selected:not(.disabled):hover .pos-checkout-table-container .table-info-row {
  color: var(--app-component-color);
}
.pos .pos-checkout-table.selected:not(.disabled) .pos-checkout-table-container:before, .pos .pos-checkout-table.selected:not(.disabled):hover .pos-checkout-table-container:before {
  content: "";
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(var(--bs-theme-rgb), 0.5);
}
.pos .pos-checkout-table.selected:not(.disabled) .pos-checkout-table-container:after, .pos .pos-checkout-table.selected:not(.disabled):hover .pos-checkout-table-container:after {
  content: "\\f00c";
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: var(--bs-inverse);
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.pos .pos-checkout-table.disabled .pos-checkout-table-container {
  cursor: not-allowed;
  background: var(--app-component-bg);
  color: var(--app-component-color);
}
.pos .pos-checkout-table.disabled .pos-checkout-table-container .status {
  color: #e00000;
}
.pos .pos-checkout-table.available .pos-checkout-table-container .status {
  color: #249d79;
}
.pos .pos-checkout-table.available .pos-checkout-table-container .pos-checkout-table-info {
  color: transparent;
}
.pos .pos-checkout-table.available .pos-checkout-table-container .pos-checkout-table-info i {
  color: transparent !important;
}
.pos .pos-checkout-table.in-use .pos-checkout-table-container {
  background: rgba(var(--bs-inverse), 0.15);
  position: relative;
}
.pos .pos-checkout-table.in-use .pos-checkout-table-container .status {
  color: #ff9f0c;
}
.pos.pos-vertical > .pos-container {
  flex-direction: column;
}
.pos.pos-vertical > .pos-container .pos-header + .pos-content {
  height: calc(100% - 52px);
}
.pos.pos-vertical > .pos-container > div + div {
  border: 0;
  border-top: 1px solid var(--bs-border-color);
}
@media (max-width: 991.98px) {
  .pos.pos-mobile-sidebar-toggled {
    z-index: 20;
  }
  .pos.pos-mobile-sidebar-toggled .pos-content, .pos.pos-mobile-sidebar-toggled .pos-menu {
    opacity: 0.25;
  }
  .pos.pos-mobile-sidebar-toggled .pos-sidebar {
    display: flex;
  }
  .pos.pos-mobile-sidebar-toggled.pos-vertical > .pos-container > .pos-content {
    opacity: 1;
  }
}

.modal.modal-pos .close {
  position: absolute;
  top: 1.5625rem;
  z-index: 10;
  right: 1.5625rem;
}
@media (min-width: 992px) {
  .modal.modal-pos .modal-pos-product {
    display: flex;
  }
  .modal.modal-pos .modal-pos-product .modal-pos-product-img, .modal.modal-pos .modal-pos-product .modal-pos-product-info {
    width: 50%;
    max-width: 50%;
    flex: 0 0 50%;
  }
}
.modal.modal-pos .modal-pos-product .modal-pos-product-img {
  padding: 1rem;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-img .img {
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 15.625rem;
}
@media (min-width: 992px) {
  .modal.modal-pos .modal-pos-product .modal-pos-product-img .img {
    min-height: 18.75rem;
  }
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info {
  padding: 1.5rem;
  border-left: 1px solid var(--bs-border-color);
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list {
  margin: -0.333rem;
  padding: 0.333rem 0;
  display: flex;
  flex-wrap: wrap;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option {
  width: 33.33%;
  max-width: 33.33%;
  padding: 0.333rem;
  flex: 0 0 33.33%;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-input {
  display: none;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-input:checked + .option-label {
  color: var(--bs-theme);
  border: 1px solid var(--bs-theme);
  background: rgba(var(--bs-theme-rgb), 0.1);
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-label {
  border: 1px solid rgba(var(--bs-inverse-rgb), 0.25);
  padding: 0.625rem;
  height: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-label .option-text {
  display: block;
  line-height: 1.2;
  opacity: 0.75;
  font-size: 0.8125rem;
  text-align: center;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-label .option-price {
  font-weight: 600;
  margin-top: 0.25rem;
  line-height: 1.2;
}

.pos-mobile-sidebar-toggler {
  position: fixed;
  bottom: 3rem;
  right: 1rem;
  z-index: 1020;
  background: var(--bs-white);
  padding: 0.5rem;
  width: 3.75rem;
  height: 3.75rem;
  text-decoration: none;
  color: var(--bs-black);
  display: none;
  border-radius: 50px;
  box-shadow: 0 1rem 3rem rgba(var(--bs-inverse-rgb), 0.175);
  align-items: center;
  z-index: 10;
}
.pos-mobile-sidebar-toggler:before {
  content: "";
  position: absolute;
  top: -0.25rem;
  left: -0.25rem;
  right: -0.25rem;
  bottom: -0.25rem;
  border: 2px solid var(--bs-white);
  border-radius: 50px;
}
@media (max-width: 991.98px) {
  .pos-mobile-sidebar-toggler {
    display: flex;
  }
}
.pos-mobile-sidebar-toggler:hover {
  color: #526872;
}
.pos-mobile-sidebar-toggler i {
  font-size: 2rem;
  display: block;
  margin: 0 auto;
}
.pos-mobile-sidebar-toggler .badge {
  position: absolute;
  right: -0.3rem;
  top: -0.3rem;
  background-color: var(--bs-theme);
  color: var(--bs-theme-color);
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

[data-bs-theme=dark] .pos .pos-product.not-available .not-available-text,
[data-bs-theme=dark] .pos .pos-sidebar .pos-order .pos-order-confirmation {
  background: rgba(59, 70, 82, 0.88);
}

.profile .profile-img {
  height: 12.5rem;
  overflow: hidden;
  margin-bottom: 1rem;
  z-index: 10;
}
.profile .profile-img img {
  max-width: 100%;
  width: 100%;
}
.profile .profile-tab {
  position: relative;
  padding: 0 1.5rem;
  flex: 1 1;
}
@media (max-width: 991.98px) {
  .profile .profile-tab {
    overflow: scroll;
    padding: 0 1rem;
    display: flex;
    flex-wrap: nowrap;
  }
}
.profile .profile-tab .nav-item .nav-link {
  text-align: center;
}
.profile .profile-tab .nav-item .nav-link .nav-value {
  font-size: 1.3125rem;
  font-weight: 600;
  margin-bottom: -0.35rem;
}
@media (max-width: 767.98px) {
  .profile .profile-tab .nav-item .nav-link .nav-value {
    font-size: 1.00625rem;
  }
}
.profile .profile-tab .nav-item + .nav-item {
  margin-left: 1.5rem;
}
.profile .profile-container {
  display: flex;
}
@media (max-width: 991.98px) {
  .profile .profile-container {
    display: block;
  }
}
.profile .profile-container .profile-sidebar {
  width: 15.625rem;
  padding: 1.5rem;
  border-right: 1px solid var(--bs-border-color);
}
@media (max-width: 991.98px) {
  .profile .profile-container .profile-sidebar {
    display: none;
  }
}
.profile .profile-container .profile-content {
  flex: 1 1;
}
.profile .profile-container .profile-content .profile-content-container {
  padding: 1.5rem;
}
@media (max-width: 991.98px) {
  .profile .profile-container .profile-content .profile-content-container {
    padding: 1rem;
  }
}
.profile .profile-img-list {
  list-style-type: none;
  margin: -0.25rem;
  padding: 0;
}
.profile .profile-img-list:before, .profile .profile-img-list:after {
  content: "";
  display: table;
  clear: both;
}
.profile .profile-img-list .profile-img-list-item {
  width: 25%;
  padding: 0.25rem;
  float: left;
}
.profile .profile-img-list .profile-img-list-item.main {
  width: 50%;
}
.profile .profile-img-list .profile-img-list-item .profile-img-list-link {
  display: block;
  padding-top: 75%;
  overflow: hidden;
  position: relative;
}
.profile .profile-img-list .profile-img-list-item .profile-img-list-link img, .profile .profile-img-list .profile-img-list-item .profile-img-list-link .profile-img-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.profile .profile-img-list .profile-img-list-item .profile-img-list-link img:before, .profile .profile-img-list .profile-img-list-item .profile-img-list-link .profile-img-content:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid rgba(var(--bs-inverse-rgb), 0.15);
}
.profile .profile-img-list .profile-img-list-item.with-number .profile-img-number {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  color: #ffffff;
  font-size: 1.53125rem;
  font-weight: 600;
  line-height: 1.625rem;
  margin-top: -0.765625rem;
  text-align: center;
}

.register {
  min-height: 100vh;
  padding: 3rem 1rem;
  display: flex;
  align-items: center;
}
@media (max-width: 767.98px) {
  .register {
    padding: 1rem;
  }
}
.register .register-content {
  flex: 1 1;
  max-width: 22.5rem;
  margin: 0 auto;
  position: relative;
}

.search-result .search-input {
  position: relative;
  max-width: 45rem;
  margin-bottom: 0.9375rem;
}
.search-result .search-close {
  position: absolute;
  top: 50%;
  margin-top: -0.75rem;
  width: 1.625rem;
  height: 1.625rem;
  text-align: center;
  font-size: 1.25rem;
  padding: 0 0 0.125rem;
  color: var(--bs-inverse);
  background: rgba(var(--bs-inverse-rgb), 0.25);
  text-decoration: none;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0.75rem;
}
.search-result .search-close:hover, .search-result .search-close:focus {
  text-decoration: none;
  background: rgba(var(--bs-inverse-rgb), 0.5);
  color: var(--bs-inverse);
}
.search-result .search-tab {
  list-style-type: none;
  margin: 0 -2rem;
  padding: 0 2rem;
  border-bottom: 1px solid var(--bs-border-color);
  white-space: nowrap;
  display: flex;
}
@media (max-width: 767.98px) {
  .search-result .search-tab {
    margin: 0 -0.9375rem;
    padding: 0 0.9375rem;
    overflow: scroll;
  }
}
.search-result .search-tab .search-tab-item .search-tab-link {
  display: block;
  padding: 0.625rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  text-decoration: none;
  border-bottom: 3px solid transparent;
  font-weight: 500;
  margin-bottom: -1px;
}
.search-result .search-tab .search-tab-item .search-tab-link:hover, .search-result .search-tab .search-tab-item .search-tab-link:focus {
  border-bottom-color: #90a2aa;
}
.search-result .search-tab .search-tab-item .search-tab-link.active {
  font-weight: 600;
  color: var(--bs-theme);
  border-bottom-color: var(--bs-theme);
}
.search-result .search-tab .search-tab-item + .search-tab-item {
  margin-left: 1rem;
}
.search-result .search-result-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.search-result .search-result-list .search-result-item {
  padding: 2rem 0;
  display: flex;
}
.search-result .search-result-list .search-result-item:before, .search-result .search-result-list .search-result-item:after {
  content: "";
  display: table;
  clear: both;
}
.search-result .search-result-list .search-result-item:last-child {
  border-bottom: 1px solid var(--bs-border-color);
}
.search-result .search-result-list .search-result-item + .search-result-item {
  border-top: 1px solid var(--bs-border-color);
}
.search-result .search-result-list .search-result-item .search-result-media {
  width: 10rem;
  height: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767.98px) {
  .search-result .search-result-list .search-result-item .search-result-media {
    width: 5rem;
    height: 3.75rem;
  }
}
.search-result .search-result-list .search-result-item .search-result-media img {
  max-width: 100%;
  max-height: 100%;
}
.search-result .search-result-list .search-result-item .search-result-media + .search-result-content {
  padding-left: 1.875rem;
}
.search-result .search-result-list .search-result-item .search-result-content {
  flex: 1 1;
}
.search-result .search-result-list .search-result-item .search-result-content h3, .search-result .search-result-list .search-result-item .search-result-content .h3 {
  margin: 0 0 0.3125rem;
  font-size: 1.25rem;
}
.search-result .search-result-list .search-result-item .search-result-content h3 a, .search-result .search-result-list .search-result-item .search-result-content .h3 a {
  color: var(--bs-inverse);
  text-decoration: none;
}
.search-result .search-result-list .search-result-item .search-result-content h3 a:hover, .search-result .search-result-list .search-result-item .search-result-content .h3 a:hover {
  text-decoration: underline;
}

.widget-chat {
  margin: 0;
  padding: 0;
}
.widget-chat .widget-chat-item {
  display: flex;
  align-items: flex-end;
}
.widget-chat .widget-chat-item + .widget-chat-item {
  margin-top: 1rem;
}
.widget-chat .widget-chat-item > div + div {
  padding-left: 0.75rem;
}
.widget-chat .widget-chat-date {
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  padding: 0.75rem;
  text-align: center;
}
.widget-chat .widget-chat-content {
  flex: 1 1;
}
.widget-chat .widget-chat-name, .widget-chat .widget-chat-status {
  font-size: 0.6875rem;
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  margin: 0.25rem 0;
  line-height: 1.5;
}
.widget-chat .widget-chat-media {
  width: 1.75rem;
}
.widget-chat .widget-chat-media img {
  max-width: 100%;
  display: block;
  border-radius: 28px;
}
.widget-chat .widget-chat-message {
  background: #ffffff;
  color: #000000;
  padding: 0.5rem 1rem;
  display: inline-block;
  position: relative;
  border-radius: 8px;
}
.widget-chat .widget-chat-message + .widget-chat-message {
  margin-top: 0.3rem;
}
.widget-chat .widget-chat-message.last:before {
  content: "";
  border: 0.3125rem solid transparent;
  border-bottom-color: #ffffff;
  position: absolute;
  bottom: 0.375rem;
  left: -0.25rem;
  border-right-color: #ffffff;
}
.widget-chat .reply .widget-chat-content {
  text-align: right;
}
.widget-chat .reply .widget-chat-message {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
}
.widget-chat .reply .widget-chat-message.last:before {
  border-color: transparent;
  border-bottom-color: var(--bs-theme);
  border-left-color: var(--bs-theme);
  left: auto;
  right: -0.25rem;
}

.widget-img-list {
  margin: -0.0625rem;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.widget-img-list .widget-img-list-item {
  padding: 0.0625rem;
  width: 20%;
}
.widget-img-list .widget-img-list-item a {
  display: block;
  text-decoration: none;
  padding-top: 100%;
  position: relative;
  overflow: hidden;
}
.widget-img-list .widget-img-list-item a img, .widget-img-list .widget-img-list-item a .img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
}
.widget-img-list .widget-img-list-item a .img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.widget-reminder .widget-reminder-item {
  position: relative;
  display: flex;
}
.widget-reminder .widget-reminder-header + .widget-reminder-item, .widget-reminder .widget-reminder-item + .widget-reminder-header, .widget-reminder .widget-reminder-item + .widget-reminder-item {
  border-top: 1px solid var(--bs-border-color);
}
.widget-reminder .widget-reminder-time, .widget-reminder .widget-reminder-content {
  padding: 1rem;
}
.widget-reminder .widget-reminder-content {
  flex: 1 1;
}
.widget-reminder .widget-reminder-time {
  width: 5rem;
  font-size: 0.8125rem;
  text-align: right;
}
.widget-reminder .widget-reminder-divider {
  width: 0.1875rem;
  background: var(--bs-border-color);
}
.widget-reminder + .card-header, .widget-reminder + .card-footer, .widget-reminder + .card-body {
  border-top: 1px solid var(--bs-border-color);
}

.widget-user-list {
  display: flex;
  align-items: center;
}
.widget-user-list .widget-user-list-item .widget-user-list-link {
  border: 2px solid var(--bs-body-bg);
  overflow: hidden;
  width: 2.5rem;
  height: 2.5rem;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
}
.widget-user-list .widget-user-list-item .widget-user-list-link img {
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.widget-user-list .widget-user-list-item + .widget-user-list-item {
  margin-left: -1.25rem;
}`, "",{"version":3,"sources":["webpack://./src/scss/styles.scss","webpack://./src/scss/_variables.scss","webpack://./src/scss/_variables-dark.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/scss/_root.scss","webpack://./src/scss/_reboot.scss","webpack://./src/scss/_helper.scss","webpack://./src/scss/mixins/_helper-spacing.scss","webpack://./src/scss/mixins/_helper-font-size.scss","webpack://./src/scss/mixins/_helper-font-weight.scss","webpack://./src/scss/mixins/_helper-size.scss","webpack://./src/scss/mixins/_helper-color.scss","webpack://./src/scss/mixins/_helper-color-dark.scss","webpack://./src/scss/mixins/_background-gradient.scss","webpack://./src/scss/mixins/_helper-opacity.scss","webpack://./src/scss/app/_app-content.scss","webpack://./src/scss/app/_app-footer.scss","webpack://./src/scss/app/_app-header.scss","webpack://./src/scss/app/_app-sidebar-mobile-backdrop.scss","webpack://./src/scss/app/_app-sidebar.scss","webpack://./src/scss/app/_app-theme-panel.scss","webpack://./src/scss/mixins/_fontawesome.scss","webpack://./src/scss/app/_app-top-nav.scss","webpack://./src/scss/app/_app.scss","webpack://./src/scss/_app.scss","webpack://./src/scss/layout/_app-boxed-layout.scss","webpack://./src/scss/layout/_app-content-full-height.scss","webpack://./src/scss/layout/_app-content-full-width.scss","webpack://./src/scss/layout/_app-footer-fixed.scss","webpack://./src/scss/layout/_app-full-height.scss","webpack://./src/scss/layout/_app-sidebar-collapsed.scss","webpack://./src/scss/layout/_app-sidebar-mobile-toggled.scss","webpack://./src/scss/layout/_app-sidebar-toggled.scss","webpack://./src/scss/layout/_app-with-top-nav.scss","webpack://./src/scss/layout/_app-without-header.scss","webpack://./src/scss/layout/_app-without-sidebar.scss","webpack://./src/scss/ui/_breadcrumb.scss","webpack://./src/scss/ui/_btn_scroll_top.scss","webpack://./src/scss/ui/_card.scss","webpack://./src/scss/ui/_card_columns.scss","webpack://./src/scss/ui/_caret.scss","webpack://./src/scss/ui/_carousel.scss","webpack://./src/scss/ui/_dropdown.scss","webpack://./src/scss/ui/_form-check.scss","webpack://./src/scss/ui/_form-radio.scss","webpack://./src/scss/ui/_form-select.scss","webpack://./src/scss/ui/_form-switch.scss","webpack://./src/scss/ui/_hr.scss","webpack://./src/scss/ui/_link.scss","webpack://./src/scss/ui/_modal.scss","webpack://./src/scss/ui/_nav_tabs.scss","webpack://./src/scss/ui/_nav_wizards.scss","webpack://./src/scss/ui/_navbar_sticky.scss","webpack://./src/scss/ui/_page_header.scss","webpack://./src/scss/ui/_pagination.scss","webpack://./src/scss/ui/_pre.scss","webpack://./src/scss/ui/_row.scss","webpack://./src/scss/ui/_table.scss","webpack://./src/scss/ui/_toasts.scss","webpack://./src/scss/plugins/_apexcharts.scss","webpack://./src/scss/plugins/_bootstrap-daterangepicker.scss","webpack://./src/scss/plugins/_datatables.scss","webpack://./src/scss/mixins/_bootstrap-icons.scss","webpack://./src/scss/plugins/_fullcalendar.scss","webpack://./src/scss/plugins/_hljs.scss","webpack://./src/scss/plugins/_perfect-scrollbar.scss","webpack://./src/scss/plugins/_react-datetime.scss","webpack://./src/scss/plugins/_react-datepicker.scss","webpack://./src/scss/plugins/_react-select.scss","webpack://./src/scss/plugins/_react-tag-input-component.scss","webpack://./src/scss/pages/_calendar.scss","webpack://./src/scss/pages/_coming_soon.scss","webpack://./src/scss/mixins/_clearfix.scss","webpack://./src/scss/pages/_data_management.scss","webpack://./src/scss/pages/_error.scss","webpack://./src/scss/pages/_gallery.scss","webpack://./src/scss/pages/_login.scss","webpack://./src/scss/pages/_mailbox.scss","webpack://./src/scss/pages/_messenger.scss","webpack://./src/scss/pages/_pos.scss","webpack://./src/scss/pages/_profile.scss","webpack://./src/scss/pages/_register.scss","webpack://./src/scss/pages/_search_result.scss","webpack://./src/scss/widget/_widget_chat.scss","webpack://./src/scss/widget/_widget_img_list.scss","webpack://./src/scss/widget/_widget_reminder.scss","webpack://./src/scss/widget/_widget_user_list.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;ACAA;;;;;;;;;;;;;;;;CAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,mBAAA;EAAA,yBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,+BAAA;EAAA,4BAAA;EAAA,mCAAA;EAAA,6BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,0BAAA;EAAA,8BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,uBAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,uBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,iDAAA;EC2OI,6BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,sBAAA;EACA,4BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,gCAAA;EAEA,yCAAA;EACA,iCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,uCAAA;EACA,gCAAA;EACA,oCAAA;EACA,6BAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8CAAA;EACA,uCAAA;EAMA,wBAAA;EACA,2BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,qCAAA;EACA,iDAAA;EAEA,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,iEAAA;EACA,yEAAA;EACA,kEAAA;EACA,yEAAA;EAIA,8BAAA;EACA,6BAAA;EACA,8CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AJ2HF;;AM3OI;EFsHA,kBAAA;EAGA,sBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,4BAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,oCAAA;EACA,6BAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,wBAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,2BAAA;EACA,0BAAA;EAEA,4CAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AJ2HJ;;AOnSA;;;EAGE,sBAAA;APsSF;;AOvRI;EANJ;IAOM,uBAAA;EP2RJ;AACF;;AO9QA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;APiRF;;AOxQA;EACE,cAAA;EACA,cNwRS;EMvRT,SAAA;EACA,wCAAA;EACA,aNwRW;ADbb;;AOjQA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBNmPiB;EMlPjB,gBCwjB4B;EDvjB5B,8BAAA;APkQF;;AO/PA;EFuMQ,qCAAA;AL4DR;AKxNI;EE3CJ;IF8MQ,oBAAA;ELyDN;AACF;;AOnQA;EFkMQ,+BAAA;ALqER;AKjOI;EEtCJ;IFyMQ,kBAAA;ELkEN;AACF;;AOvQA;EF6LQ,uCAAA;AL8ER;AK1OI;EEjCJ;IFoMQ,qBAAA;EL2EN;AACF;;AO3QA;EFwLQ,qCAAA;ALuFR;AKnPI;EE5BJ;IF+LQ,oBAAA;ELoFN;AACF;;AO/QA;EF+KM,qBALI;ALyGV;;AO9QA;EF0KM,mBALI;AL6GV;;AOvQA;EACE,aAAA;EACA,mBNsOwB;ADoC1B;;AOhQA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;APmQF;;AO7PA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;APgQF;;AO1PA;;EAEE,kBAAA;AP6PF;;AO1PA;;;EAGE,aAAA;EACA,mBAAA;AP6PF;;AO1PA;;;;EAIE,gBAAA;AP6PF;;AO1PA;EACE,gBNwJiB;ADqGnB;;AOxPA;EACE,qBAAA;EACA,cAAA;AP2PF;;AOrPA;EACE,gBAAA;APwPF;;AOhPA;;EAEE,mBCsa4B;ARnL9B;;AO3OA;EF6EM,kBALI;ALuKV;;AOxOA;EACE,iBN4Ia;EM3Ib,gCAAA;EACA,wCAAA;AP2OF;;AOlOA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;APqOF;;AOlOA;EAAM,eAAA;APsON;;AOrOA;EAAM,WAAA;APyON;;AOpOA;EACE,gEAAA;EACA,0BNgRgB;ADzClB;AOrOE;EACE,mDAAA;APuOJ;;AO5NE;EAEE,cAAA;EACA,qBAAA;AP8NJ;;AOvNA;;;;EAIE,qCCgV4B;EHlUxB,cALI;ALkNV;;AOnNA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AL0NV;AOlNE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;APoNJ;;AOhNA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;APmNF;AOhNE;EACE,cAAA;APkNJ;;AO9MA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBN89BU;EM79BV,sCN89BO;EQnwCL,kBAAA;ATufJ;AO/ME;EACE,UAAA;EF7BE,cALI;ALoPV;;AOvMA;EACE,gBAAA;AP0MF;;AOpMA;;EAEE,sBAAA;APuMF;;AO/LA;EACE,oBAAA;EACA,yBAAA;APkMF;;AO/LA;EACE,mBNwqBqB;EMvqBrB,sBNuqBqB;EMtqBrB,cN5RS;EM6RT,gBAAA;APkMF;;AO3LA;EAEE,mBAAA;EACA,gCAAA;AP6LF;;AO1LA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AP6LF;;AOrLA;EACE,qBAAA;APwLF;;AOlLA;EAEE,gBAAA;APoLF;;AO5KA;EACE,UAAA;AP+KF;;AO1KA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AP6KF;;AOzKA;;EAEE,oBAAA;AP4KF;;AOvKA;EACE,eAAA;AP0KF;;AOvKA;EAGE,iBAAA;APwKF;AOrKE;EACE,UAAA;APuKJ;;AOhKA;EACE,wBAAA;APmKF;;AO3JA;;;;EAIE,0BAAA;AP8JF;AO3JI;;;;EACE,eAAA;APgKN;;AOzJA;EACE,UAAA;EACA,kBAAA;AP4JF;;AOvJA;EACE,gBAAA;AP0JF;;AOhJA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;APmJF;;AO3IA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBNnJqB;EI9Df,iCAAA;EEoNN,oBAAA;AP6IF;AK7fI;EEyWJ;IFtMQ,iBAAA;EL8VN;AACF;AOhJE;EACE,WAAA;APkJJ;;AO3IA;;;;;;;EAOE,UAAA;AP8IF;;AO3IA;EACE,YAAA;AP8IF;;AOrIA;EACE,6BAAA;EACA,oBAAA;APwIF;;AOhIA;;;;;;;CAAA;AAWA;EACE,wBAAA;APgIF;;AO3HA;EACE,UAAA;AP8HF;;AOvHA;EACE,aAAA;EACA,0BAAA;AP0HF;;AOrHA;EACE,qBAAA;APwHF;;AOnHA;EACE,SAAA;APsHF;;AO/GA;EACE,kBAAA;EACA,eAAA;APkHF;;AO1GA;EACE,wBAAA;AP6GF;;AOrGA;EACE,wBAAA;APwGF;;AU7qBA;ELmQM,qBALI;EK5PR,gBTqTiB;AD2XnB;;AU3qBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ARoE9B;AK7kBI;EKpGF;ILuQM,eAAA;EL8aN;AACF;;AUtrBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AR+E9B;AKxlBI;EKpGF;ILuQM,iBAAA;ELybN;AACF;;AUjsBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AR0F9B;AKnmBI;EKpGF;ILuQM,eAAA;ELocN;AACF;;AU5sBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ARqG9B;AK9mBI;EKpGF;ILuQM,iBAAA;EL+cN;AACF;;AUvtBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ARgH9B;AKznBI;EKpGF;ILuQM,eAAA;EL0dN;AACF;;AUluBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AR2H9B;AKpoBI;EKpGF;ILuQM,iBAAA;ELqeN;AACF;;AUrtBA;ECvDE,eAAA;EACA,gBAAA;AXgxBF;;AUrtBA;EC5DE,eAAA;EACA,gBAAA;AXqxBF;;AUvtBA;EACE,qBAAA;AV0tBF;AUxtBE;EACE,oBT8RkB;AD4btB;;AUhtBA;EL8MM,kBALI;EKvMR,yBAAA;AVmtBF;;AU/sBA;EACE,mBTgOO;EIzBH,qBALI;ALihBV;AUhtBE;EACE,gBAAA;AVktBJ;;AU9sBA;EACE,iBAAA;EACA,mBTsNO;EIzBH,kBALI;EKtLR,cT9BS;AD+uBX;AU/sBE;EACE,aAAA;AVitBJ;;AYjzBA;ECIE,eAAA;EAGA,YAAA;Ab+yBF;;AYhzBA;EACE,gBX6sCkB;EW5sClB,mCX6sCa;EW5sCb,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AbwzBF;;AY1yBA;EAEE,qBAAA;AZ4yBF;;AYzyBA;EACE,qBAAA;EACA,cAAA;AZ4yBF;;AYzyBA;EPyPM,kBALI;EOlPR,gCX6rCqB;ADjZvB;;Ac90BE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Af21BF;;AgBryBI;EF5CE;IACE,gBboWe;EDifrB;AACF;AgB3yBI;EF5CE;IACE,gBboWe;EDsfrB;AACF;AgBhzBI;EF5CE;IACE,gBboWe;ED2frB;AACF;AgBrzBI;EF5CE;IACE,iBboWe;EDggBrB;AACF;AgB1zBI;EF5CE;IACE,iBboWe;EDqgBrB;AACF;AiB13BA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;AjBi4BJ;;AiB53BE;ECNA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AlBq4BF;AiBn4BI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AlB+3BF;;AkBh1BM;EACE,SAAA;AlBm1BR;;AkBh1BM;EApCJ,cAAA;EACA,WAAA;AlBw3BF;;AkB12BE;EACE,cAAA;EACA,WAAA;AlB62BJ;;AkB/2BE;EACE,cAAA;EACA,UAAA;AlBk3BJ;;AkBp3BE;EACE,cAAA;EACA,mBAAA;AlBu3BJ;;AkBz3BE;EACE,cAAA;EACA,UAAA;AlB43BJ;;AkB93BE;EACE,cAAA;EACA,UAAA;AlBi4BJ;;AkBn4BE;EACE,cAAA;EACA,mBAAA;AlBs4BJ;;AkBv2BM;EAhDJ,cAAA;EACA,WAAA;AlB25BF;;AkBt2BU;EAhEN,cAAA;EACA,kBAAA;AlB06BJ;;AkB32BU;EAhEN,cAAA;EACA,mBAAA;AlB+6BJ;;AkBh3BU;EAhEN,cAAA;EACA,UAAA;AlBo7BJ;;AkBr3BU;EAhEN,cAAA;EACA,mBAAA;AlBy7BJ;;AkB13BU;EAhEN,cAAA;EACA,mBAAA;AlB87BJ;;AkB/3BU;EAhEN,cAAA;EACA,UAAA;AlBm8BJ;;AkBp4BU;EAhEN,cAAA;EACA,mBAAA;AlBw8BJ;;AkBz4BU;EAhEN,cAAA;EACA,mBAAA;AlB68BJ;;AkB94BU;EAhEN,cAAA;EACA,UAAA;AlBk9BJ;;AkBn5BU;EAhEN,cAAA;EACA,mBAAA;AlBu9BJ;;AkBx5BU;EAhEN,cAAA;EACA,mBAAA;AlB49BJ;;AkB75BU;EAhEN,cAAA;EACA,WAAA;AlBi+BJ;;AkB15BY;EAxDV,wBAAA;AlBs9BF;;AkB95BY;EAxDV,yBAAA;AlB09BF;;AkBl6BY;EAxDV,gBAAA;AlB89BF;;AkBt6BY;EAxDV,yBAAA;AlBk+BF;;AkB16BY;EAxDV,yBAAA;AlBs+BF;;AkB96BY;EAxDV,gBAAA;AlB0+BF;;AkBl7BY;EAxDV,yBAAA;AlB8+BF;;AkBt7BY;EAxDV,yBAAA;AlBk/BF;;AkB17BY;EAxDV,gBAAA;AlBs/BF;;AkB97BY;EAxDV,yBAAA;AlB0/BF;;AkBl8BY;EAxDV,yBAAA;AlB8/BF;;AkB37BQ;;EAEE,gBAAA;AlB87BV;;AkB37BQ;;EAEE,gBAAA;AlB87BV;;AkBr8BQ;;EAEE,sBAAA;AlBw8BV;;AkBr8BQ;;EAEE,sBAAA;AlBw8BV;;AkB/8BQ;;EAEE,qBAAA;AlBk9BV;;AkB/8BQ;;EAEE,qBAAA;AlBk9BV;;AkBz9BQ;;EAEE,mBAAA;AlB49BV;;AkBz9BQ;;EAEE,mBAAA;AlB49BV;;AkBn+BQ;;EAEE,qBAAA;AlBs+BV;;AkBn+BQ;;EAEE,qBAAA;AlBs+BV;;AkB7+BQ;;EAEE,mBAAA;AlBg/BV;;AkB7+BQ;;EAEE,mBAAA;AlBg/BV;;AgB1iCI;EEUE;IACE,SAAA;ElBoiCN;EkBjiCI;IApCJ,cAAA;IACA,WAAA;ElBwkCA;EkB1jCA;IACE,cAAA;IACA,WAAA;ElB4jCF;EkB9jCA;IACE,cAAA;IACA,UAAA;ElBgkCF;EkBlkCA;IACE,cAAA;IACA,mBAAA;ElBokCF;EkBtkCA;IACE,cAAA;IACA,UAAA;ElBwkCF;EkB1kCA;IACE,cAAA;IACA,UAAA;ElB4kCF;EkB9kCA;IACE,cAAA;IACA,mBAAA;ElBglCF;EkBjjCI;IAhDJ,cAAA;IACA,WAAA;ElBomCA;EkB/iCQ;IAhEN,cAAA;IACA,kBAAA;ElBknCF;EkBnjCQ;IAhEN,cAAA;IACA,mBAAA;ElBsnCF;EkBvjCQ;IAhEN,cAAA;IACA,UAAA;ElB0nCF;EkB3jCQ;IAhEN,cAAA;IACA,mBAAA;ElB8nCF;EkB/jCQ;IAhEN,cAAA;IACA,mBAAA;ElBkoCF;EkBnkCQ;IAhEN,cAAA;IACA,UAAA;ElBsoCF;EkBvkCQ;IAhEN,cAAA;IACA,mBAAA;ElB0oCF;EkB3kCQ;IAhEN,cAAA;IACA,mBAAA;ElB8oCF;EkB/kCQ;IAhEN,cAAA;IACA,UAAA;ElBkpCF;EkBnlCQ;IAhEN,cAAA;IACA,mBAAA;ElBspCF;EkBvlCQ;IAhEN,cAAA;IACA,mBAAA;ElB0pCF;EkB3lCQ;IAhEN,cAAA;IACA,WAAA;ElB8pCF;EkBvlCU;IAxDV,cAAA;ElBkpCA;EkB1lCU;IAxDV,wBAAA;ElBqpCA;EkB7lCU;IAxDV,yBAAA;ElBwpCA;EkBhmCU;IAxDV,gBAAA;ElB2pCA;EkBnmCU;IAxDV,yBAAA;ElB8pCA;EkBtmCU;IAxDV,yBAAA;ElBiqCA;EkBzmCU;IAxDV,gBAAA;ElBoqCA;EkB5mCU;IAxDV,yBAAA;ElBuqCA;EkB/mCU;IAxDV,yBAAA;ElB0qCA;EkBlnCU;IAxDV,gBAAA;ElB6qCA;EkBrnCU;IAxDV,yBAAA;ElBgrCA;EkBxnCU;IAxDV,yBAAA;ElBmrCA;EkBhnCM;;IAEE,gBAAA;ElBknCR;EkB/mCM;;IAEE,gBAAA;ElBinCR;EkBxnCM;;IAEE,sBAAA;ElB0nCR;EkBvnCM;;IAEE,sBAAA;ElBynCR;EkBhoCM;;IAEE,qBAAA;ElBkoCR;EkB/nCM;;IAEE,qBAAA;ElBioCR;EkBxoCM;;IAEE,mBAAA;ElB0oCR;EkBvoCM;;IAEE,mBAAA;ElByoCR;EkBhpCM;;IAEE,qBAAA;ElBkpCR;EkB/oCM;;IAEE,qBAAA;ElBipCR;EkBxpCM;;IAEE,mBAAA;ElB0pCR;EkBvpCM;;IAEE,mBAAA;ElBypCR;AACF;AgBptCI;EEUE;IACE,SAAA;ElB6sCN;EkB1sCI;IApCJ,cAAA;IACA,WAAA;ElBivCA;EkBnuCA;IACE,cAAA;IACA,WAAA;ElBquCF;EkBvuCA;IACE,cAAA;IACA,UAAA;ElByuCF;EkB3uCA;IACE,cAAA;IACA,mBAAA;ElB6uCF;EkB/uCA;IACE,cAAA;IACA,UAAA;ElBivCF;EkBnvCA;IACE,cAAA;IACA,UAAA;ElBqvCF;EkBvvCA;IACE,cAAA;IACA,mBAAA;ElByvCF;EkB1tCI;IAhDJ,cAAA;IACA,WAAA;ElB6wCA;EkBxtCQ;IAhEN,cAAA;IACA,kBAAA;ElB2xCF;EkB5tCQ;IAhEN,cAAA;IACA,mBAAA;ElB+xCF;EkBhuCQ;IAhEN,cAAA;IACA,UAAA;ElBmyCF;EkBpuCQ;IAhEN,cAAA;IACA,mBAAA;ElBuyCF;EkBxuCQ;IAhEN,cAAA;IACA,mBAAA;ElB2yCF;EkB5uCQ;IAhEN,cAAA;IACA,UAAA;ElB+yCF;EkBhvCQ;IAhEN,cAAA;IACA,mBAAA;ElBmzCF;EkBpvCQ;IAhEN,cAAA;IACA,mBAAA;ElBuzCF;EkBxvCQ;IAhEN,cAAA;IACA,UAAA;ElB2zCF;EkB5vCQ;IAhEN,cAAA;IACA,mBAAA;ElB+zCF;EkBhwCQ;IAhEN,cAAA;IACA,mBAAA;ElBm0CF;EkBpwCQ;IAhEN,cAAA;IACA,WAAA;ElBu0CF;EkBhwCU;IAxDV,cAAA;ElB2zCA;EkBnwCU;IAxDV,wBAAA;ElB8zCA;EkBtwCU;IAxDV,yBAAA;ElBi0CA;EkBzwCU;IAxDV,gBAAA;ElBo0CA;EkB5wCU;IAxDV,yBAAA;ElBu0CA;EkB/wCU;IAxDV,yBAAA;ElB00CA;EkBlxCU;IAxDV,gBAAA;ElB60CA;EkBrxCU;IAxDV,yBAAA;ElBg1CA;EkBxxCU;IAxDV,yBAAA;ElBm1CA;EkB3xCU;IAxDV,gBAAA;ElBs1CA;EkB9xCU;IAxDV,yBAAA;ElBy1CA;EkBjyCU;IAxDV,yBAAA;ElB41CA;EkBzxCM;;IAEE,gBAAA;ElB2xCR;EkBxxCM;;IAEE,gBAAA;ElB0xCR;EkBjyCM;;IAEE,sBAAA;ElBmyCR;EkBhyCM;;IAEE,sBAAA;ElBkyCR;EkBzyCM;;IAEE,qBAAA;ElB2yCR;EkBxyCM;;IAEE,qBAAA;ElB0yCR;EkBjzCM;;IAEE,mBAAA;ElBmzCR;EkBhzCM;;IAEE,mBAAA;ElBkzCR;EkBzzCM;;IAEE,qBAAA;ElB2zCR;EkBxzCM;;IAEE,qBAAA;ElB0zCR;EkBj0CM;;IAEE,mBAAA;ElBm0CR;EkBh0CM;;IAEE,mBAAA;ElBk0CR;AACF;AgB73CI;EEUE;IACE,SAAA;ElBs3CN;EkBn3CI;IApCJ,cAAA;IACA,WAAA;ElB05CA;EkB54CA;IACE,cAAA;IACA,WAAA;ElB84CF;EkBh5CA;IACE,cAAA;IACA,UAAA;ElBk5CF;EkBp5CA;IACE,cAAA;IACA,mBAAA;ElBs5CF;EkBx5CA;IACE,cAAA;IACA,UAAA;ElB05CF;EkB55CA;IACE,cAAA;IACA,UAAA;ElB85CF;EkBh6CA;IACE,cAAA;IACA,mBAAA;ElBk6CF;EkBn4CI;IAhDJ,cAAA;IACA,WAAA;ElBs7CA;EkBj4CQ;IAhEN,cAAA;IACA,kBAAA;ElBo8CF;EkBr4CQ;IAhEN,cAAA;IACA,mBAAA;ElBw8CF;EkBz4CQ;IAhEN,cAAA;IACA,UAAA;ElB48CF;EkB74CQ;IAhEN,cAAA;IACA,mBAAA;ElBg9CF;EkBj5CQ;IAhEN,cAAA;IACA,mBAAA;ElBo9CF;EkBr5CQ;IAhEN,cAAA;IACA,UAAA;ElBw9CF;EkBz5CQ;IAhEN,cAAA;IACA,mBAAA;ElB49CF;EkB75CQ;IAhEN,cAAA;IACA,mBAAA;ElBg+CF;EkBj6CQ;IAhEN,cAAA;IACA,UAAA;ElBo+CF;EkBr6CQ;IAhEN,cAAA;IACA,mBAAA;ElBw+CF;EkBz6CQ;IAhEN,cAAA;IACA,mBAAA;ElB4+CF;EkB76CQ;IAhEN,cAAA;IACA,WAAA;ElBg/CF;EkBz6CU;IAxDV,cAAA;ElBo+CA;EkB56CU;IAxDV,wBAAA;ElBu+CA;EkB/6CU;IAxDV,yBAAA;ElB0+CA;EkBl7CU;IAxDV,gBAAA;ElB6+CA;EkBr7CU;IAxDV,yBAAA;ElBg/CA;EkBx7CU;IAxDV,yBAAA;ElBm/CA;EkB37CU;IAxDV,gBAAA;ElBs/CA;EkB97CU;IAxDV,yBAAA;ElBy/CA;EkBj8CU;IAxDV,yBAAA;ElB4/CA;EkBp8CU;IAxDV,gBAAA;ElB+/CA;EkBv8CU;IAxDV,yBAAA;ElBkgDA;EkB18CU;IAxDV,yBAAA;ElBqgDA;EkBl8CM;;IAEE,gBAAA;ElBo8CR;EkBj8CM;;IAEE,gBAAA;ElBm8CR;EkB18CM;;IAEE,sBAAA;ElB48CR;EkBz8CM;;IAEE,sBAAA;ElB28CR;EkBl9CM;;IAEE,qBAAA;ElBo9CR;EkBj9CM;;IAEE,qBAAA;ElBm9CR;EkB19CM;;IAEE,mBAAA;ElB49CR;EkBz9CM;;IAEE,mBAAA;ElB29CR;EkBl+CM;;IAEE,qBAAA;ElBo+CR;EkBj+CM;;IAEE,qBAAA;ElBm+CR;EkB1+CM;;IAEE,mBAAA;ElB4+CR;EkBz+CM;;IAEE,mBAAA;ElB2+CR;AACF;AgBtiDI;EEUE;IACE,SAAA;ElB+hDN;EkB5hDI;IApCJ,cAAA;IACA,WAAA;ElBmkDA;EkBrjDA;IACE,cAAA;IACA,WAAA;ElBujDF;EkBzjDA;IACE,cAAA;IACA,UAAA;ElB2jDF;EkB7jDA;IACE,cAAA;IACA,mBAAA;ElB+jDF;EkBjkDA;IACE,cAAA;IACA,UAAA;ElBmkDF;EkBrkDA;IACE,cAAA;IACA,UAAA;ElBukDF;EkBzkDA;IACE,cAAA;IACA,mBAAA;ElB2kDF;EkB5iDI;IAhDJ,cAAA;IACA,WAAA;ElB+lDA;EkB1iDQ;IAhEN,cAAA;IACA,kBAAA;ElB6mDF;EkB9iDQ;IAhEN,cAAA;IACA,mBAAA;ElBinDF;EkBljDQ;IAhEN,cAAA;IACA,UAAA;ElBqnDF;EkBtjDQ;IAhEN,cAAA;IACA,mBAAA;ElBynDF;EkB1jDQ;IAhEN,cAAA;IACA,mBAAA;ElB6nDF;EkB9jDQ;IAhEN,cAAA;IACA,UAAA;ElBioDF;EkBlkDQ;IAhEN,cAAA;IACA,mBAAA;ElBqoDF;EkBtkDQ;IAhEN,cAAA;IACA,mBAAA;ElByoDF;EkB1kDQ;IAhEN,cAAA;IACA,UAAA;ElB6oDF;EkB9kDQ;IAhEN,cAAA;IACA,mBAAA;ElBipDF;EkBllDQ;IAhEN,cAAA;IACA,mBAAA;ElBqpDF;EkBtlDQ;IAhEN,cAAA;IACA,WAAA;ElBypDF;EkBllDU;IAxDV,cAAA;ElB6oDA;EkBrlDU;IAxDV,wBAAA;ElBgpDA;EkBxlDU;IAxDV,yBAAA;ElBmpDA;EkB3lDU;IAxDV,gBAAA;ElBspDA;EkB9lDU;IAxDV,yBAAA;ElBypDA;EkBjmDU;IAxDV,yBAAA;ElB4pDA;EkBpmDU;IAxDV,gBAAA;ElB+pDA;EkBvmDU;IAxDV,yBAAA;ElBkqDA;EkB1mDU;IAxDV,yBAAA;ElBqqDA;EkB7mDU;IAxDV,gBAAA;ElBwqDA;EkBhnDU;IAxDV,yBAAA;ElB2qDA;EkBnnDU;IAxDV,yBAAA;ElB8qDA;EkB3mDM;;IAEE,gBAAA;ElB6mDR;EkB1mDM;;IAEE,gBAAA;ElB4mDR;EkBnnDM;;IAEE,sBAAA;ElBqnDR;EkBlnDM;;IAEE,sBAAA;ElBonDR;EkB3nDM;;IAEE,qBAAA;ElB6nDR;EkB1nDM;;IAEE,qBAAA;ElB4nDR;EkBnoDM;;IAEE,mBAAA;ElBqoDR;EkBloDM;;IAEE,mBAAA;ElBooDR;EkB3oDM;;IAEE,qBAAA;ElB6oDR;EkB1oDM;;IAEE,qBAAA;ElB4oDR;EkBnpDM;;IAEE,mBAAA;ElBqpDR;EkBlpDM;;IAEE,mBAAA;ElBopDR;AACF;AgB/sDI;EEUE;IACE,SAAA;ElBwsDN;EkBrsDI;IApCJ,cAAA;IACA,WAAA;ElB4uDA;EkB9tDA;IACE,cAAA;IACA,WAAA;ElBguDF;EkBluDA;IACE,cAAA;IACA,UAAA;ElBouDF;EkBtuDA;IACE,cAAA;IACA,mBAAA;ElBwuDF;EkB1uDA;IACE,cAAA;IACA,UAAA;ElB4uDF;EkB9uDA;IACE,cAAA;IACA,UAAA;ElBgvDF;EkBlvDA;IACE,cAAA;IACA,mBAAA;ElBovDF;EkBrtDI;IAhDJ,cAAA;IACA,WAAA;ElBwwDA;EkBntDQ;IAhEN,cAAA;IACA,kBAAA;ElBsxDF;EkBvtDQ;IAhEN,cAAA;IACA,mBAAA;ElB0xDF;EkB3tDQ;IAhEN,cAAA;IACA,UAAA;ElB8xDF;EkB/tDQ;IAhEN,cAAA;IACA,mBAAA;ElBkyDF;EkBnuDQ;IAhEN,cAAA;IACA,mBAAA;ElBsyDF;EkBvuDQ;IAhEN,cAAA;IACA,UAAA;ElB0yDF;EkB3uDQ;IAhEN,cAAA;IACA,mBAAA;ElB8yDF;EkB/uDQ;IAhEN,cAAA;IACA,mBAAA;ElBkzDF;EkBnvDQ;IAhEN,cAAA;IACA,UAAA;ElBszDF;EkBvvDQ;IAhEN,cAAA;IACA,mBAAA;ElB0zDF;EkB3vDQ;IAhEN,cAAA;IACA,mBAAA;ElB8zDF;EkB/vDQ;IAhEN,cAAA;IACA,WAAA;ElBk0DF;EkB3vDU;IAxDV,cAAA;ElBszDA;EkB9vDU;IAxDV,wBAAA;ElByzDA;EkBjwDU;IAxDV,yBAAA;ElB4zDA;EkBpwDU;IAxDV,gBAAA;ElB+zDA;EkBvwDU;IAxDV,yBAAA;ElBk0DA;EkB1wDU;IAxDV,yBAAA;ElBq0DA;EkB7wDU;IAxDV,gBAAA;ElBw0DA;EkBhxDU;IAxDV,yBAAA;ElB20DA;EkBnxDU;IAxDV,yBAAA;ElB80DA;EkBtxDU;IAxDV,gBAAA;ElBi1DA;EkBzxDU;IAxDV,yBAAA;ElBo1DA;EkB5xDU;IAxDV,yBAAA;ElBu1DA;EkBpxDM;;IAEE,gBAAA;ElBsxDR;EkBnxDM;;IAEE,gBAAA;ElBqxDR;EkB5xDM;;IAEE,sBAAA;ElB8xDR;EkB3xDM;;IAEE,sBAAA;ElB6xDR;EkBpyDM;;IAEE,qBAAA;ElBsyDR;EkBnyDM;;IAEE,qBAAA;ElBqyDR;EkB5yDM;;IAEE,mBAAA;ElB8yDR;EkB3yDM;;IAEE,mBAAA;ElB6yDR;EkBpzDM;;IAEE,qBAAA;ElBszDR;EkBnzDM;;IAEE,qBAAA;ElBqzDR;EkB5zDM;;IAEE,mBAAA;ElB8zDR;EkB3zDM;;IAEE,mBAAA;ElB6zDR;AACF;AgBx3DI;EEUE;IACE,SAAA;ElBi3DN;EkB92DI;IApCJ,cAAA;IACA,WAAA;ElBq5DA;EkBv4DA;IACE,cAAA;IACA,WAAA;ElBy4DF;EkB34DA;IACE,cAAA;IACA,UAAA;ElB64DF;EkB/4DA;IACE,cAAA;IACA,mBAAA;ElBi5DF;EkBn5DA;IACE,cAAA;IACA,UAAA;ElBq5DF;EkBv5DA;IACE,cAAA;IACA,UAAA;ElBy5DF;EkB35DA;IACE,cAAA;IACA,mBAAA;ElB65DF;EkB93DI;IAhDJ,cAAA;IACA,WAAA;ElBi7DA;EkB53DQ;IAhEN,cAAA;IACA,kBAAA;ElB+7DF;EkBh4DQ;IAhEN,cAAA;IACA,mBAAA;ElBm8DF;EkBp4DQ;IAhEN,cAAA;IACA,UAAA;ElBu8DF;EkBx4DQ;IAhEN,cAAA;IACA,mBAAA;ElB28DF;EkB54DQ;IAhEN,cAAA;IACA,mBAAA;ElB+8DF;EkBh5DQ;IAhEN,cAAA;IACA,UAAA;ElBm9DF;EkBp5DQ;IAhEN,cAAA;IACA,mBAAA;ElBu9DF;EkBx5DQ;IAhEN,cAAA;IACA,mBAAA;ElB29DF;EkB55DQ;IAhEN,cAAA;IACA,UAAA;ElB+9DF;EkBh6DQ;IAhEN,cAAA;IACA,mBAAA;ElBm+DF;EkBp6DQ;IAhEN,cAAA;IACA,mBAAA;ElBu+DF;EkBx6DQ;IAhEN,cAAA;IACA,WAAA;ElB2+DF;EkBp6DU;IAxDV,cAAA;ElB+9DA;EkBv6DU;IAxDV,wBAAA;ElBk+DA;EkB16DU;IAxDV,yBAAA;ElBq+DA;EkB76DU;IAxDV,gBAAA;ElBw+DA;EkBh7DU;IAxDV,yBAAA;ElB2+DA;EkBn7DU;IAxDV,yBAAA;ElB8+DA;EkBt7DU;IAxDV,gBAAA;ElBi/DA;EkBz7DU;IAxDV,yBAAA;ElBo/DA;EkB57DU;IAxDV,yBAAA;ElBu/DA;EkB/7DU;IAxDV,gBAAA;ElB0/DA;EkBl8DU;IAxDV,yBAAA;ElB6/DA;EkBr8DU;IAxDV,yBAAA;ElBggEA;EkB77DM;;IAEE,gBAAA;ElB+7DR;EkB57DM;;IAEE,gBAAA;ElB87DR;EkBr8DM;;IAEE,sBAAA;ElBu8DR;EkBp8DM;;IAEE,sBAAA;ElBs8DR;EkB78DM;;IAEE,qBAAA;ElB+8DR;EkB58DM;;IAEE,qBAAA;ElB88DR;EkBr9DM;;IAEE,mBAAA;ElBu9DR;EkBp9DM;;IAEE,mBAAA;ElBs9DR;EkB79DM;;IAEE,qBAAA;ElB+9DR;EkB59DM;;IAEE,qBAAA;ElB89DR;EkBr+DM;;IAEE,mBAAA;ElBu+DR;EkBp+DM;;IAEE,mBAAA;ElBs+DR;AACF;AmB5lEA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,uDAAA;EACA,6CAAA;EACA,sDAAA;EACA,4CAAA;EACA,uDAAA;EAEA,WAAA;EACA,mBlBiSO;EkBhSP,mBlBk/B0B;EkBj/B1B,0CAAA;AnB2lEF;AmBplEE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2ClBo/BiB;EkBn/BjB,2GAAA;AnBqlEJ;AmBllEE;EACE,uBAAA;AnBolEJ;AmBjlEE;EACE,sBAAA;AnBmlEJ;;AmB/kEA;EACE,+DAAA;AnBklEF;;AmB3kEA;EACE,iBAAA;AnB8kEF;;AmBpkEE;EACE,wBAAA;AnBukEJ;;AmBxjEE;EACE,sCAAA;AnB2jEJ;AmBxjEI;EACE,sCAAA;AnB0jEN;;AmBnjEE;EACE,sBAAA;AnBsjEJ;AmBnjEE;EACE,mBAAA;AnBqjEJ;;AmB3iEE;EACE,oDAAA;EACA,8CAAA;AnB8iEJ;;AmBxiEE;EACE,oDAAA;EACA,8CAAA;AnB2iEJ;;AmBniEA;EACE,oDAAA;EACA,8CAAA;AnBsiEF;;AmB9hEE;EACE,mDAAA;EACA,6CAAA;AnBiiEJ;;AoB7qEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApByqEJ;;AoB3rEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBurEJ;;AoBzsEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBqsEJ;;AoBvtEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBmtEJ;;AoBruEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBiuEJ;;AoBnvEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB+uEJ;;AoBjwEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB6vEJ;;AoB/wEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB2wEJ;;AmB1nEI;EACE,gBAAA;EACA,iCAAA;AnB6nEN;;AgBxtEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBmoEJ;AACF;AgB/tEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnByoEJ;AACF;AgBruEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnB+oEJ;AACF;AgB3uEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBqpEJ;AACF;AgBjvEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnB2pEJ;AACF;AgBvvEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBiqEJ;AACF;AqBr0EA;EACE,qBpB+nByB;ADwsD3B;;AqB9zEA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBpB0TiB;ADqgEnB;;AqB3zEA;EACE,kDAAA;EACA,qDAAA;EhBoQI,eALI;ALgkEV;;AqB3zEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,oBALI;ALskEV;;AsB51EA;EACE,mBrB0nBqB;EIhWjB,kBALI;EiBjRR,crB2DS;ADkyEX;;AuBl2EA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,mBALI;EkBhRR,gBtBiUiB;EsBhUjB,gBtBoUiB;EsBnUjB,2BtB6oBY;EsB5oBZ,gBAAA;EACA,6BtBuoBS;EsBtoBT,4BAAA;EACA,2DAAA;EdGE,kBAAA;EeHE,wEDMJ;AvBg2EF;AwBl2EM;EDhBN;ICiBQ,gBAAA;ExBq2EN;AACF;AuBn2EE;EACE,gBAAA;AvBq2EJ;AuBn2EI;EACE,eAAA;AvBq2EN;AuBh2EE;EACE,2BtBunBU;EsBtnBV,6BtBknBO;EsBjnBP,8CtB6nBuB;EsB5nBvB,UAAA;EAKE,2DtBghBuB;AD80D7B;AuB11EE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AvB80EJ;AuBz0EE;EACE,cAAA;EACA,UAAA;AvB20EJ;AuBv0EE;EACE,0CtB0lBsB;EsBxlBtB,UAAA;AvBw0EJ;AuBh0EE;EAEE,oDtBgkBgB;EsB7jBhB,UAAA;AvB+zEJ;AuB3zEE;EACE,yBAAA;EACA,0BAAA;EACA,0BtBidkB;EsBhdlB,2BtBujBU;EwBrpBZ,uCxB2yBoB;EsB3sBlB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CtBydqB;EsBxdrB,gBAAA;ECzFE,qID0FF;AvB6zEJ;AwBn5EM;ED0EJ;ICzEM,gBAAA;ExBs5EN;AACF;AuB/zEE;EACE,wCtBksBwB;AD+nD5B;;AuBxzEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBtBmNiB;EsBlNjB,2BtByiBsB;EsBxiBtB,6BAAA;EACA,yBAAA;EACA,sCAAA;AvB2zEF;AuBzzEE;EACE,UAAA;AvB2zEJ;AuBxzEE;EAEE,gBAAA;EACA,eAAA;AvByzEJ;;AuB9yEA;EACE,mEtBuhBgB;EsBthBhB,uBAAA;ElByII,oBALI;EIvQN,kBAAA;ATs7EJ;AuB/yEE;EACE,uBAAA;EACA,wBAAA;EACA,yBtB+ZqB;ADk5DzB;;AuB7yEA;EACE,iEtB2gBgB;EsB1gBhB,oBAAA;ElB4HI,eALI;EIvQN,kBAAA;ATk8EJ;AuB9yEE;EACE,oBAAA;EACA,qBAAA;EACA,uBtBqZqB;AD25DzB;;AuBxyEE;EACE,oEtBwfW;ADmzDf;AuBxyEE;EACE,mEtBqfc;ADqzDlB;AuBvyEE;EACE,iEtBkfc;ADuzDlB;;AuBpyEA;EACE,WtBgfiB;EsB/ejB,gEtByea;EsBxeb,iBtB8WoB;ADy7DtB;AuBryEE;EACE,eAAA;AvBuyEJ;AuBpyEE;EACE,oBAAA;EdvLA,kBAAA;AT89EJ;AuBnyEE;EACE,oBAAA;Ed5LA,kBAAA;ATk+EJ;AuBlyEE;EAAoB,+DtBydJ;AD40DlB;AuBpyEE;EAAoB,6DtBydJ;AD80DlB;;A0Bt/EA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,mBALI;EqB7QR,gBzB8TiB;EyB7TjB,gBzBiUiB;EyBhUjB,2BzB0oBY;EyBzoBZ,gBAAA;EACA,6BzBooBS;EyBnoBT,mFAAA;EACA,4BAAA;EACA,yCzBuuBwB;EyBtuBxB,0BzBuuBoB;EyBtuBpB,2DAAA;EjBHE,kBAAA;EeHE,wEESJ;A1Bs/EF;AwB3/EM;EEfN;IFgBQ,gBAAA;ExB8/EN;AACF;A0Bz/EE;EACE,8CzBqoBuB;EyBpoBvB,UAAA;EAKE,2DzBsuByB;ADixD/B;A0Bn/EE;EAEE,sBzB0gBkB;EyBzgBlB,sBAAA;A1Bo/EJ;A0Bj/EE;EAEE,oDzBymBgB;ADy4DpB;A0B7+EE;EACE,kBAAA;EACA,uCAAA;A1B++EJ;;A0B3+EA;EACE,oBzBigBuB;EyBhgBvB,uBzBggBuB;EyB/fvB,oBzBggBuB;EI7RnB,oBALI;EIvQN,kBAAA;ATyhFJ;;A0B3+EA;EACE,mBzB4fuB;EyB3fvB,sBzB2fuB;EyB1fvB,kBzB2fuB;EIhSnB,eALI;EIvQN,kBAAA;ATiiFJ;;A0Bz+EI;EACE,gEAAA;A1B4+EN;;A2BpjFA;EACE,cAAA;EACA,iB1BqrBsB;E0BprBtB,mB1BqrByB;E0BprBzB,uB1BqrByB;ADk4D3B;A2BrjFE;EACE,WAAA;EACA,mBAAA;A3BujFJ;;A2BnjFA;EACE,oB1B2qByB;E0B1qBzB,eAAA;EACA,iBAAA;A3BsjFF;A2BpjFE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A3BsjFJ;;A2BljFA;EACE,+BAAA;EAEA,cAAA;EACA,Y1B0pBuB;E0BzpBvB,a1BypBuB;E0BxpBvB,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2D1BypBwB;E0BxpBxB,iCAAA;UAAA,yBAAA;A3BojFF;A2BjjFE;ElB3BE,qBAAA;AT+kFJ;A2BhjFE;EAEE,kB1BipB6B;ADg6DjC;A2B9iFE;EACE,uB1ByoB6B;ADu6DjC;A2B7iFE;EACE,8C1BqmBuB;E0BpmBvB,UAAA;EACA,2D1B4fyB;ADmjE7B;A2B5iFE;EACE,yB1BeG;E0BdH,qB1BcG;ADgiFP;A2B5iFI;EAII,iEAAA;A3B2iFR;A2BviFI;EAII,iEAAA;A3BsiFR;A2BjiFE;EACE,yB1BNG;E0BOH,qB1BPG;E0BYD,iEAAA;A3B+hFN;A2B3hFE;EACE,oBAAA;EACA,YAAA;EACA,Y1B6mBgC;ADg7DpC;A2BthFI;EACE,eAAA;EACA,Y1BomB8B;ADo7DpC;;A2B1gFA;EACE,mB1B8lB0B;AD+6D5B;A2B3gFE;EACE,4DAAA;EAEA,Y1BwlBgB;E0BvlBhB,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,oBAAA;EeHE,iDGsHF;A3B4gFJ;AwB9nFM;EG0GJ;IHzGM,gBAAA;ExBioFN;AACF;A2B/gFI;EACE,4DAAA;A3BihFN;A2B9gFI;EACE,iC1BqlB4B;E0BhlB1B,4DAAA;A3B4gFR;A2BvgFE;EACE,oB1BkkBwB;E0BjkBxB,eAAA;A3BygFJ;A2BvgFI;EACE,oBAAA;EACA,cAAA;A3BygFN;;A2BpgFA;EACE,qBAAA;EACA,kB1BgjB6B;ADu9D/B;;A2BpgFA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A3BugFF;A2BngFI;EACE,oBAAA;EACA,YAAA;EACA,a1BuaiB;AD8lEvB;;A2B9/EI;EACE,4DAAA;A3BigFN;;A4BprFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A5BurFF;A4BrrFE;EACE,UAAA;A5BurFJ;A4BnrFI;EAA0B,kF3BgxB5B;ADs6DF;A4BrrFI;EAA0B,kF3B+wB5B;ADy6DF;A4BrrFE;EACE,SAAA;A5BurFJ;A4BprFE;EACE,W3BgwBqB;E2B/vBrB,Y3B+vBqB;E2B9vBrB,oBAAA;EACA,gBAAA;EH1BF,iCxByxBoB;E2B7vBlB,S3B8vBsB;EQ3wBtB,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A5BqrFJ;AwBpsFM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;ExBusFN;AACF;A4BxrFI;EHjCF,iDxBiyB2B;AD27D7B;A4BtrFE;EACE,W3B0uBqB;E2BzuBrB,c3B0uBsB;E2BzuBtB,kBAAA;EACA,e3ByuBsB;E2BxuBtB,kD3ByuBkB;E2BxuBlB,yBAAA;EnB7BA,mBAAA;ATstFJ;A4BprFE;EACE,W3BquBqB;E2BpuBrB,Y3BouBqB;E2BnuBrB,gBAAA;EHpDF,iCxByxBoB;E2BnuBlB,S3BouBsB;EQ3wBtB,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A5BqrFJ;AwB9tFM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;ExBiuFN;AACF;A4BxrFI;EH3DF,iDxBiyB2B;ADq9D7B;A4BtrFE;EACE,W3BgtBqB;E2B/sBrB,c3BgtBsB;E2B/sBtB,kBAAA;EACA,e3B+sBsB;E2B9sBtB,kD3B+sBkB;E2B9sBlB,yBAAA;EnBvDA,mBAAA;ATgvFJ;A4BprFE;EACE,oBAAA;A5BsrFJ;A4BprFI;EACE,2C3BmtByB;ADm+D/B;A4BnrFI;EACE,2C3B+sByB;ADs+D/B;;A6B5wFA;EACE,kBAAA;A7B+wFF;A6B7wFE;;;EAGE,uD5B8yBmB;E4B7yBnB,2D5B6yBmB;E4B5yBnB,iB5B6yBwB;ADk+D5B;A6B5wFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;A7B8wFJ;AwBnxFM;EKTJ;ILUM,gBAAA;ExBsxFN;AACF;A6BhxFE;;EAEE,qBAAA;A7BkxFJ;A6BhxFI;;EACE,kBAAA;A7BmxFN;A6BhxFI;;;EAEE,qB5BkxB0B;E4BjxB1B,wB5BkxB0B;ADigEhC;A6BhxFI;;EACE,qB5B6wB0B;E4B5wB1B,wB5B6wB0B;ADsgEhC;A6B/wFE;EACE,qB5BuwB4B;E4BtwB5B,wB5BuwB4B;AD0gEhC;A6B1wFI;;;;EACE,2CAAA;EACA,8D5BiwB0B;AD8gEhC;A6B7wFM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,e5ByvBqB;E4BxvBrB,WAAA;EACA,6B5BklBG;EQloBP,kBAAA;ATm0FJ;A6B5wFI;EACE,2CAAA;EACA,8D5BgvB0B;AD8hEhC;A6BzwFI;EACE,sCAAA;A7B2wFN;A6BvwFE;;EAEE,c5BlBO;AD2xFX;A6BvwFI;;EACE,oD5B4jBc;AD8sEpB;;A8Bj2FA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9Bo2FF;A8Bl2FE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A9Bo2FJ;A8Bh2FE;;;EAGE,UAAA;A9Bk2FJ;A8B51FE;EACE,kBAAA;EACA,UAAA;A9B81FJ;A8B51FI;EACE,UAAA;A9B81FN;;A8Bn1FA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,mBALI;EyBvOR,gB7BwRiB;E6BvRjB,gB7B2RiB;E6B1RjB,2B7BomBY;E6BnmBZ,kBAAA;EACA,mBAAA;EACA,uC7BkrBqB;E6BjrBrB,2DAAA;ErBtCE,kBAAA;AT63FJ;;A8B70FA;;;;EAIE,oBAAA;EzBwNI,eALI;EIvQN,kBAAA;ATs4FJ;;A8B70FA;;;;EAIE,uBAAA;EzB+MI,oBALI;EIvQN,kBAAA;AT+4FJ;;A8B70FA;;EAEE,mBAAA;A9Bg1FF;;A8Bn0FI;;;;ErBjEA,0BAAA;EACA,6BAAA;AT24FJ;A8Bl0FI;;;;ErB1EA,0BAAA;EACA,6BAAA;ATk5FJ;A8B5zFE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;ATy4FJ;A8B5zFE;;ErB9EE,yBAAA;EACA,4BAAA;AT84FJ;;A+Bt6FE;EACE,aAAA;EACA,WAAA;EACA,mB9BkmBmB;EIhWjB,kBALI;E0B1PN,6B9B6yBqB;AD2nEzB;;A+Br6FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,oBALI;E0B7ON,W9BgyBqB;E8B/xBrB,mC9B+xBqB;EQ1zBrB,sCAAA;ATm8FJ;;A+Bn6FI;;;;EAEE,cAAA;A/Bw6FN;;A+Bv9FI;EAqDE,+B9BkxBmB;E8B/wBjB,oC9B0mBa;E8BzmBb,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A/Bo6FR;A+Bj6FM;EACE,+B9BuwBiB;E8BtwBjB,2D9BswBiB;AD6pEzB;;A+Bp+FI;EA0EI,oC9BwlBa;E8BvlBb,kFAAA;A/B85FR;;A+Bz+FI;EAkFE,+B9BqvBmB;ADsqEzB;A+Bx5FQ;EAEE,iEAAA;EACA,uB9BiqB8B;E8BhqB9B,+DAAA;EACA,2EAAA;A/By5FV;A+Br5FM;EACE,+B9BwuBiB;E8BvuBjB,2D9BuuBiB;ADgrEzB;;A+Bv/FI;EAwGI,yCAAA;A/Bm5FR;;A+B3/FI;EA+GE,+B9BwtBmB;ADwrEzB;A+B94FM;EACE,wC9BqtBiB;AD2rEzB;A+B74FM;EACE,2D9BitBiB;AD8rEzB;A+B54FM;EACE,6B9B6sBiB;ADisEzB;;A+Bz4FI;EACE,kBAAA;A/B44FN;;A+B5gGI;;;;;EA0IM,UAAA;A/B04FV;;A+BhgGE;EACE,aAAA;EACA,WAAA;EACA,mB9BkmBmB;EIhWjB,kBALI;E0B1PN,4B9B6yBqB;ADqtEzB;;A+B//FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,oBALI;E0B7ON,W9BgyBqB;E8B/xBrB,kC9B+xBqB;EQ1zBrB,sCAAA;AT6hGJ;;A+B7/FI;;;;EAEE,cAAA;A/BkgGN;;A+BjjGI;EAqDE,8B9BkxBmB;E8B/wBjB,oC9B0mBa;E8BzmBb,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A/B8/FR;A+B3/FM;EACE,8B9BuwBiB;E8BtwBjB,0D9BswBiB;ADuvEzB;;A+B9jGI;EA0EI,oC9BwlBa;E8BvlBb,kFAAA;A/Bw/FR;;A+BnkGI;EAkFE,8B9BqvBmB;ADgwEzB;A+Bl/FQ;EAEE,kEAAA;EACA,uB9BiqB8B;E8BhqB9B,+DAAA;EACA,2EAAA;A/Bm/FV;A+B/+FM;EACE,8B9BwuBiB;E8BvuBjB,0D9BuuBiB;AD0wEzB;;A+BjlGI;EAwGI,yCAAA;A/B6+FR;;A+BrlGI;EA+GE,8B9BwtBmB;ADkxEzB;A+Bx+FM;EACE,uC9BqtBiB;ADqxEzB;A+Bv+FM;EACE,0D9BitBiB;ADwxEzB;A+Bt+FM;EACE,4B9B6sBiB;AD2xEzB;;A+Bn+FI;EACE,kBAAA;A/Bs+FN;;A+BtmGI;;;;;EA4IM,UAAA;A/Bk+FV;;AgChnGA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,4BALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,2BAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;AhC8mGF;AwBloGM;EQhBN;IRiBQ,gBAAA;ExBqoGN;AACF;AgCjnGE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AhCknGJ;AgC/mGE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AhCgnGJ;AgC7mGE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AhC2mGN;AgCvmGE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AhCqmGN;AgCjmGE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AhC6lGJ;AgC1lGI;EAKI,0CAAA;AhCwlGR;AgCnlGE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AhCklGJ;;AgCtkGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCgrGF;;AgCvlGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCisGF;;AgCxmGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCktGF;;AgCznGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCmuGF;;AgC1oGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCovGF;;AgC3pGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCqwGF;;AgC5qGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCsxGF;;AgC7rGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCuyGF;;AgC9sGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,qCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCwzGF;;AgC/tGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCy0GF;;AgChvGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC01GF;;AgCjwGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,qCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC22GF;;AgClxGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC43GF;;AgCnyGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC64GF;;AgCpzGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC85GF;;AgCr0GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC+6GF;;AgCt1GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCg8GF;;AgCv2GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCi9GF;;AgCx3GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCk+GF;;AgCz4GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCm/GF;;AgC15GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCogHF;;AgC36GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCqhHF;;AgC57GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCsiHF;;AgC78GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCujHF;;AgC99GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCwkHF;;AgC/+GE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCylHF;;AgChgHE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC0mHF;;AgCjhHE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC2nHF;;AgCliHE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC4oHF;;AgCnjHE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC6pHF;;AgCpkHE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC8qHF;;AgCrlHE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC+rHF;;AgC5kHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCurHF;;AgC7lHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCwsHF;;AgC9mHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCytHF;;AgC/nHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC0uHF;;AgChpHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC2vHF;;AgCjqHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC4wHF;;AgClrHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC6xHF;;AgCnsHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC8yHF;;AgCptHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC+zHF;;AgCruHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCg1HF;;AgCtvHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCi2HF;;AgCvwHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCk3HF;;AgCxxHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCm4HF;;AgCzyHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCo5HF;;AgC1zHE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCq6HF;;AgC30HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCs7HF;;AgC51HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCu8HF;;AgC72HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCw9HF;;AgC93HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCy+HF;;AgC/4HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC0/HF;;AgCh6HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC2gIF;;AgCj7HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC4hIF;;AgCl8HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC6iIF;;AgCn9HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC8jIF;;AgCp+HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC+kIF;;AgCr/HE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCgmIF;;AgCtgIE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCinIF;;AgCvhIE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCkoIF;;AgCxiIE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCmpIF;;AgCzjIE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCoqIF;;AgC1kIE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCqrIF;;AgC3lIE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCssIF;;AgChmIA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0B/BuVgB;AD2wHlB;AgCxlIE;EACE,0BAAA;AhC0lIJ;AgCvlIE;EACE,gCAAA;AhCylIJ;;AgC9kIA;ECxIE,0BAAA;EACA,wBAAA;E5B8NI,wBALI;E4BvNR,2BAAA;AjC0tIF;;AgCjlIA;EC5IE,2BAAA;EACA,0BAAA;E5B8NI,6BALI;E4BvNR,2BAAA;AjCiuIF;;AkCpyIA;EVgBM,gCUfJ;AlCuyIF;AwBpxIM;EUpBN;IVqBQ,gBAAA;ExBuxIN;AACF;AkC1yIE;EACE,UAAA;AlC4yIJ;;AkCtyIE;EACE,aAAA;AlCyyIJ;;AkCryIA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AlCwyIF;AwBtyIM;EULN;IVMQ,gBAAA;ExByyIN;AACF;AkC3yIE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AlC6yIJ;AwBhzIM;EUAJ;IVCM,gBAAA;ExBmzIN;AACF;;AmCx0IA;;;;;;EAME,kBAAA;AnC20IF;;AmCx0IA;EACE,mBAAA;AnC20IF;AoCnzII;EACE,qBAAA;EACA,oBnCwYU;EmCvYV,uBnCsYiB;EmCrYjB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ApC21IF;AoCjyII;EACE,cAAA;ApCmyIN;;AmCj1IA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,iCALI;E8BhQR,yCAAA;EACA,mDAAA;EACA,8DAAA;EACA,8BAAA;EACA,kDAAA;EACA,mEAAA;EACA,4DAAA;EACA,sCAAA;EACA,0EAAA;EACA,8CAAA;EACA,oDAAA;EACA,iEAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,kCAAA;EACA,sCAAA;EACA,+DAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AT23IJ;AmC90IE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AnCg1IJ;;AmCxzII;EACE,oBAAA;AnC2zIN;AmCzzIM;EACE,WAAA;EACA,OAAA;AnC2zIR;;AmCvzII;EACE,kBAAA;AnC0zIN;AmCxzIM;EACE,QAAA;EACA,UAAA;AnC0zIR;;AgBp2II;EmB4BA;IACE,oBAAA;EnC40IJ;EmC10II;IACE,WAAA;IACA,OAAA;EnC40IN;EmCx0IE;IACE,kBAAA;EnC00IJ;EmCx0II;IACE,QAAA;IACA,UAAA;EnC00IN;AACF;AgBr3II;EmB4BA;IACE,oBAAA;EnC41IJ;EmC11II;IACE,WAAA;IACA,OAAA;EnC41IN;EmCx1IE;IACE,kBAAA;EnC01IJ;EmCx1II;IACE,QAAA;IACA,UAAA;EnC01IN;AACF;AgBr4II;EmB4BA;IACE,oBAAA;EnC42IJ;EmC12II;IACE,WAAA;IACA,OAAA;EnC42IN;EmCx2IE;IACE,kBAAA;EnC02IJ;EmCx2II;IACE,QAAA;IACA,UAAA;EnC02IN;AACF;AgBr5II;EmB4BA;IACE,oBAAA;EnC43IJ;EmC13II;IACE,WAAA;IACA,OAAA;EnC43IN;EmCx3IE;IACE,kBAAA;EnC03IJ;EmCx3II;IACE,QAAA;IACA,UAAA;EnC03IN;AACF;AgBr6II;EmB4BA;IACE,oBAAA;EnC44IJ;EmC14II;IACE,WAAA;IACA,OAAA;EnC44IN;EmCx4IE;IACE,kBAAA;EnC04IJ;EmCx4II;IACE,QAAA;IACA,UAAA;EnC04IN;AACF;AgBr7II;EmB4BA;IACE,oBAAA;EnC45IJ;EmC15II;IACE,WAAA;IACA,OAAA;EnC45IN;EmCx5IE;IACE,kBAAA;EnC05IJ;EmCx5II;IACE,QAAA;IACA,UAAA;EnC05IN;AACF;AmCj5IE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AnCm5IJ;AoCv+II;EACE,qBAAA;EACA,oBnCwYU;EmCvYV,uBnCsYiB;EmCrYjB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ApCwgJF;AoCr9II;EACE,cAAA;ApCu9IN;;AmCv5IE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AnC05IJ;AoC5/II;EACE,qBAAA;EACA,oBnCwYU;EmCvYV,uBnCsYiB;EmCrYjB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ApCshJF;AoC1+II;EACE,cAAA;ApC4+IN;AmCl6II;EACE,iBAAA;AnCo6IN;;AmC95IE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AnCi6IJ;AoCphJI;EACE,qBAAA;EACA,oBnCwYU;EmCvYV,uBnCsYiB;EmCrYjB,WAAA;ApCshJN;AoC3gJM;EACE,aAAA;ApC6gJR;AoC1gJM;EACE,qBAAA;EACA,qBnCqXQ;EmCpXR,uBnCmXe;EmClXf,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ApCgjJF;AoC1gJI;EACE,cAAA;ApC4gJN;AmCj7II;EACE,iBAAA;AnCm7IN;;AmC56IA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AnC+6IF;;AmCz6IA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gBlCyJmB;EkCxJnB,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;ATmlJJ;AmC16IE;EAEE,0CAAA;EV1LF,kDU4LuB;AnC06IzB;AmCv6IE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AnCw6IzB;AmCr6IE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AnCs6IJ;;AmCh6IA;EACE,cAAA;AnCm6IF;;AmC/5IA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,oBALI;E8B5DR,sCAAA;EACA,mBAAA;AnCk6IF;;AmC95IA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AnCi6IF;;AmC75IA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,uCAAA;EACA,4DAAA;EACA,sDAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AnC+5IF;;AqCrpJA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ArCwpJF;AqCtpJE;;EACE,kBAAA;EACA,cAAA;ArCypJJ;AqCppJE;;;;;;;;;;;;EAME,UAAA;ArC4pJJ;;AqCvpJA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ArC0pJF;AqCxpJE;EACE,WAAA;ArC0pJJ;;AqCtpJA;E5BhBI,kBAAA;AT0qJJ;AqCtpJE;;EAEE,8CAAA;ArCwpJJ;AqCppJE;;;E5BVE,0BAAA;EACA,6BAAA;ATmqJJ;AqChpJE;;;E5BNE,yBAAA;EACA,4BAAA;AT2pJJ;;AqCnoJA;EACE,wBAAA;EACA,uBAAA;ArCsoJF;AqCpoJE;EAGE,cAAA;ArCooJJ;AqCjoJE;EACE,eAAA;ArCmoJJ;;AqC/nJA;EACE,uBAAA;EACA,sBAAA;ArCkoJF;;AqC/nJA;EACE,sBAAA;EACA,qBAAA;ArCkoJF;;AqC9mJA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ArCinJF;AqC/mJE;;EAEE,WAAA;ArCinJJ;AqC9mJE;;EAEE,6CAAA;ArCgnJJ;AqC5mJE;;E5B1FE,6BAAA;EACA,4BAAA;AT0sJJ;AqC5mJE;;E5B7GE,yBAAA;EACA,0BAAA;AT6tJJ;;AsCrvJA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtCovJF;;AsCjvJA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;AtCovJF;AwBhwJM;EcGN;IdFQ,gBAAA;ExBmwJN;AACF;AsCvvJE;EAEE,qCAAA;AtCwvJJ;AsCpvJE;EACE,UAAA;EACA,iD9BkhBoB;ARouIxB;AsClvJE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AtCmvJJ;;AsC3uJA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,kDAAA;EACA,yCAAA;EACA,iGAAA;EAGA,oFAAA;AtC2uJF;AsCzuJE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;ATyxJJ;AsC1uJI;EAGE,kBAAA;EACA,wDAAA;AtC0uJN;AsCtuJE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AtCwuJJ;AsCruJE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;ATwyJJ;;AsC7tJA;EAEE,iCAAA;EACA,yCAAA;EACA,sCAAA;AtC+tJF;AsC5tJE;E7B5FE,gDAAA;AT2zJJ;AsC3tJE;;EAEE,4CAAA;EbjHF,oDakHuB;AtC6tJzB;;AsCptJA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AtCotJF;AsCltJE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AtCotJJ;AsCltJI;EAEE,iCAAA;AtCmtJN;AsC/sJE;;EAEE,gBrCqLe;EqCpLf,gDAAA;EACA,iCAAA;AtCitJJ;;AsCvsJE;;EAEE,cAAA;EACA,kBAAA;AtC0sJJ;;AsCrsJE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AtCwsJJ;;AsClsJE;;EACE,WAAA;AtCssJJ;;AsC5rJE;EACE,aAAA;AtC+rJJ;AsC7rJE;EACE,cAAA;AtC+rJJ;;AuC53JA;EAEE,wBAAA;EACA,6BAAA;EACA,oDAAA;EACA,yDAAA;EACA,4DAAA;EACA,wDAAA;EACA,uCAAA;EACA,kCAAA;EACA,iCAAA;EACA,uDAAA;EACA,6DAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,mCAAA;EACA,qEAAA;EACA,mEAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AvC43JF;AuCt3JE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AvC83JJ;AuC12JA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AvC42JF;AuC12JE;EAEE,yCAAA;AvC22JJ;;AuCj2JA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AvCg2JF;AuC71JI;EAEE,oCAAA;AvC81JN;AuC11JE;EACE,gBAAA;AvC41JJ;;AuCn1JA;EACE,mBtCu+BmB;EsCt+BnB,sBtCs+BmB;EsCr+BnB,6BAAA;AvCs1JF;AuCp1JE;;;EAGE,oCAAA;AvCs1JJ;;AuCz0JA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AvC00JF;;AuCt0JA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;AvCy0JF;AwBl9JM;EeiIN;IfhIQ,gBAAA;ExBq9JN;AACF;AuC50JE;EACE,qBAAA;AvC80JJ;AuC30JE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AvC60JJ;;AuCv0JA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AvC00JF;;AuCv0JA;EACE,yCAAA;EACA,gBAAA;AvC00JF;;AgBp8JI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCi0JN;EuC/zJM;IACE,mBAAA;EvCi0JR;EuC/zJQ;IACE,kBAAA;EvCi0JV;EuC9zJQ;IACE,kDAAA;IACA,iDAAA;EvCg0JV;EuC5zJM;IACE,iBAAA;EvC8zJR;EuC3zJM;IACE,wBAAA;IACA,gBAAA;EvC6zJR;EuC1zJM;IACE,aAAA;EvC4zJR;EuCzzJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCyzJR;EuCtzJQ;IACE,aAAA;EvCwzJV;EuCrzJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCuzJV;AACF;AgBp/JI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCg3JN;EuC92JM;IACE,mBAAA;EvCg3JR;EuC92JQ;IACE,kBAAA;EvCg3JV;EuC72JQ;IACE,kDAAA;IACA,iDAAA;EvC+2JV;EuC32JM;IACE,iBAAA;EvC62JR;EuC12JM;IACE,wBAAA;IACA,gBAAA;EvC42JR;EuCz2JM;IACE,aAAA;EvC22JR;EuCx2JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCw2JR;EuCr2JQ;IACE,aAAA;EvCu2JV;EuCp2JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCs2JV;AACF;AgBniKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvC+5JN;EuC75JM;IACE,mBAAA;EvC+5JR;EuC75JQ;IACE,kBAAA;EvC+5JV;EuC55JQ;IACE,kDAAA;IACA,iDAAA;EvC85JV;EuC15JM;IACE,iBAAA;EvC45JR;EuCz5JM;IACE,wBAAA;IACA,gBAAA;EvC25JR;EuCx5JM;IACE,aAAA;EvC05JR;EuCv5JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCu5JR;EuCp5JQ;IACE,aAAA;EvCs5JV;EuCn5JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCq5JV;AACF;AgBllKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvC88JN;EuC58JM;IACE,mBAAA;EvC88JR;EuC58JQ;IACE,kBAAA;EvC88JV;EuC38JQ;IACE,kDAAA;IACA,iDAAA;EvC68JV;EuCz8JM;IACE,iBAAA;EvC28JR;EuCx8JM;IACE,wBAAA;IACA,gBAAA;EvC08JR;EuCv8JM;IACE,aAAA;EvCy8JR;EuCt8JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCs8JR;EuCn8JQ;IACE,aAAA;EvCq8JV;EuCl8JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCo8JV;AACF;AgBjoKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvC6/JN;EuC3/JM;IACE,mBAAA;EvC6/JR;EuC3/JQ;IACE,kBAAA;EvC6/JV;EuC1/JQ;IACE,kDAAA;IACA,iDAAA;EvC4/JV;EuCx/JM;IACE,iBAAA;EvC0/JR;EuCv/JM;IACE,wBAAA;IACA,gBAAA;EvCy/JR;EuCt/JM;IACE,aAAA;EvCw/JR;EuCr/JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCq/JR;EuCl/JQ;IACE,aAAA;EvCo/JV;EuCj/JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCm/JV;AACF;AgBhrKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvC4iKN;EuC1iKM;IACE,mBAAA;EvC4iKR;EuC1iKQ;IACE,kBAAA;EvC4iKV;EuCziKQ;IACE,kDAAA;IACA,iDAAA;EvC2iKV;EuCviKM;IACE,iBAAA;EvCyiKR;EuCtiKM;IACE,wBAAA;IACA,gBAAA;EvCwiKR;EuCriKM;IACE,aAAA;EvCuiKR;EuCpiKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCoiKR;EuCjiKQ;IACE,aAAA;EvCmiKV;EuChiKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCkiKV;AACF;AuCzlKI;EAEI,iBAAA;EACA,2BAAA;AvC0lKR;AuCxlKQ;EACE,mBAAA;AvC0lKV;AuCxlKU;EACE,kBAAA;AvC0lKZ;AuCvlKU;EACE,kDAAA;EACA,iDAAA;AvCylKZ;AuCrlKQ;EACE,iBAAA;AvCulKV;AuCplKQ;EACE,wBAAA;EACA,gBAAA;AvCslKV;AuCnlKQ;EACE,aAAA;AvCqlKV;AuCllKQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AvCklKV;AuC/kKU;EACE,aAAA;AvCilKZ;AuC9kKU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AvCglKZ;;AuC/jKA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,iCAAA;EACA,gCAAA;EACA,sCAAA;EACA,0DAAA;EACA,qEAAA;AvCikKF;;AuC3jKI;EACE,qEAAA;AvC8jKN;;AwCv1KA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mCAAA;EACA,4BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;ATy2KJ;AwCp1KE;EACE,eAAA;EACA,cAAA;AxCs1KJ;AwCn1KE;EACE,mBAAA;EACA,sBAAA;AxCq1KJ;AwCn1KI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AT42KJ;AwCn1KI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;ATm2KJ;AwCh1KE;;EAEE,aAAA;AxCk1KJ;;AwC90KA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AxC+0KF;;AwC50KA;EACE,4CAAA;EACA,iCAAA;AxC+0KF;;AwC50KA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AxC+0KF;;AwC50KA;EACE,gBAAA;AxC+0KF;;AwCv0KE;EACE,oCAAA;AxC00KJ;;AwCl0KA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AxCq0KF;AwCn0KE;E/B7FE,wFAAA;ATm6KJ;;AwCj0KA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AxCo0KF;AwCl0KE;E/BxGE,wFAAA;AT66KJ;;AwC3zKA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AxC8zKF;AwC5zKE;EACE,mCAAA;EACA,sCAAA;AxC8zKJ;;AwC1zKA;EACE,uDAAA;EACA,sDAAA;AxC6zKF;;AwCzzKA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;ATu8KJ;;AwCzzKA;;;EAGE,WAAA;AxC4zKF;;AwCzzKA;;E/B3II,0DAAA;EACA,2DAAA;ATy8KJ;;AwC1zKA;;E/BlII,8DAAA;EACA,6DAAA;ATi8KJ;;AwCnzKE;EACE,0CAAA;AxCszKJ;AgBj7KI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;ExCszKF;EwCnzKE;IAEE,SAAA;IACA,gBAAA;ExCozKJ;EwClzKI;IACE,cAAA;IACA,cAAA;ExCozKN;EwC/yKM;I/B3KJ,0BAAA;IACA,6BAAA;ET69KF;EwChzKQ;;IAGE,0BAAA;ExCizKV;EwC/yKQ;;IAGE,6BAAA;ExCgzKV;EwC5yKM;I/B5KJ,yBAAA;IACA,4BAAA;ET29KF;EwC7yKQ;;IAGE,yBAAA;ExC8yKV;EwC5yKQ;;IAGE,4BAAA;ExC6yKV;AACF;;AyClhLA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,uEAAA;EACA,oFAAA;EACA,sCAAA;EACA,mCAAA;EACA,8CAAA;EACA,yDAAA;AzCohLF;;AyChhLA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC2PI,mBALI;EoCpPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCtBE,gBAAA;EgCwBF,qBAAA;EjB3BI,0CiB4BJ;AzCmhLF;AwB3iLM;EiBWN;IjBVQ,gBAAA;ExB8iLN;AACF;AyCthLE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AzCwhLJ;AyCthLI;EACE,qDAAA;EACA,iDAAA;AzCwhLN;AyCnhLE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBlDE,mDiBmDF;AzCqhLJ;AwBpkLM;EiBsCJ;IjBrCM,gBAAA;ExBukLN;AACF;AyCvhLE;EACE,UAAA;AzCyhLJ;AyCthLE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AzCwhLJ;;AyCphLA;EACE,gBAAA;AzCuhLF;;AyCphLA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AzCuhLF;AyCrhLE;EhC/DE,yDAAA;EACA,0DAAA;ATulLJ;AyCthLI;EhClEA,+DAAA;EACA,gEAAA;AT2lLJ;AyCrhLE;EACE,aAAA;AzCuhLJ;AyCnhLE;EhC9DE,6DAAA;EACA,4DAAA;ATolLJ;AyCnhLM;EhClEF,mEAAA;EACA,kEAAA;ATwlLJ;AyClhLI;EhCvEA,6DAAA;EACA,4DAAA;AT4lLJ;;AyChhLA;EACE,8EAAA;AzCmhLF;;AyC1gLE;EACE,eAAA;AzC6gLJ;AyC1gLE;EACE,eAAA;EACA,cAAA;EhCpHA,gBAAA;ATioLJ;AyC1gLI;EAAgB,aAAA;AzC6gLpB;AyC5gLI;EAAe,gBAAA;AzC+gLnB;AyC5gLM;EhC3HF,gBAAA;AT0oLJ;;AyCrgLI;EACE,iEAAA;EACA,wEAAA;AzCwgLN;;A0ClqLA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;ErC2RI,8BALI;EqCpRR,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;ATmqLJ;;A0C7pLE;EACE,iDAAA;A1CgqLJ;A0C9pLI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A1CgqLN;A0C5pLE;EACE,6CAAA;A1C8pLJ;;A2CnsLA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,mCALI;EsCrRR,wCAAA;EACA,+BAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,8CAAA;EACA,0DAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,iFAAA;EACA,mDAAA;EACA,0CAAA;EACA,oDAAA;EACA,iEAAA;EACA,6DAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AXwtLF;;A2CjsLA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A3CosLF;AwBrtLM;EmBQN;InBPQ,gBAAA;ExBwtLN;AACF;A2CvsLE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A3CwsLJ;A2CrsLE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,U1C+mCuB;E0C9mCvB,iDAAA;A3CusLJ;A2CpsLE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A3CqsLJ;A2ClsLE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A3CmsLJ;;A2C9rLE;EACE,8C1CilCsB;ADgnJ1B;A2C5rLM;ElC9BF,0DAAA;EACA,6DAAA;AT6tLJ;A2C1rLM;ElClDF,2DAAA;EACA,8DAAA;AT+uLJ;;A2C7qLA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,+BALI;EuCnRR,kCAAA;A5CmxLF;;A2ChrLA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,oCALI;EuCnRR,kCAAA;A5C0xLF;;A6C5xLA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,yBAAA;EACA,6BAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;ATiyLJ;A6CxxLE;EACE,aAAA;A7C0xLJ;;A6CrxLA;EACE,kBAAA;EACA,SAAA;A7CwxLF;;A8CxzLA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,6BAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AT4zLJ;;A8CpzLA;EAEE,cAAA;A9CszLF;;A8ClzLA;EACE,gB7CwSiB;E6CvSjB,iCAAA;A9CqzLF;;A8C7yLA;EACE,mB7Cue4B;ADy0K9B;A8C7yLE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A9C+yLJ;;A8CvyLE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9C0yLJ;;A8C9yLE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9CizLJ;;A8CrzLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A9CwzLJ;;A8C5zLE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9C+zLJ;;A8Cn0LE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A9Cs0LJ;;A8C10LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9C60LJ;;A8Cj1LE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9Co1LJ;;A8Cx1LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9C21LJ;;A8C/1LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Ck2LJ;;A8Ct2LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Cy2LJ;;A8C72LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Cg3LJ;;A8Cp3LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9Cu3LJ;;A8C33LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9C83LJ;;A8Cl4LE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9Cq4LJ;;A8Cz4LE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9C44LJ;;A8Ch5LE;EACE,6CAAA;EACA,sCAAA;EACA,oDAAA;EACA,kDAAA;A9Cm5LJ;;A8Cv5LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9C05LJ;;A8C95LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9Ci6LJ;;A8Cr6LE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9Cw6LJ;;A8C56LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9C+6LJ;;A8Cn7LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9Cs7LJ;;A8C17LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9C67LJ;;A8Cj8LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Co8LJ;;A8Cx8LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9C28LJ;;A8C/8LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9Ck9LJ;;A8Ct9LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9Cy9LJ;;A8C79LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9Cg+LJ;;A8Cp+LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9Cu+LJ;;A8C3+LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9C8+LJ;;A8Cl/LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9Cq/LJ;;A8Cz/LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9C4/LJ;;A8ChgME;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9CmgMJ;;A+C/jME;EACE;IAAK,2B9CgiBS;EDmiLhB;AACF;A+C/jMA;;EAGE,0BAAA;E1CkRI,mCALI;E0C3QR,mDAAA;EACA,oDAAA;EACA,oDAAA;EACA,gCAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;ATukMJ;;A+C1jMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A/C6jMF;AwBllMM;EuBYN;IvBXQ,gBAAA;ExBqlMN;AACF;;A+C/jMA;EtBAE,qMAAA;EsBEA,oEAAA;A/CkkMF;;A+C/jMA;EACE,iBAAA;A/CkkMF;;A+C/jMA;EACE,WAAA;A/CkkMF;;A+C9jME;EACE,kDAAA;A/CikMJ;A+C9jMM;EAJJ;IAKM,eAAA;E/CikMN;AACF;;AgD7nMA;EAEE,2CAAA;EACA,+BAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,qDAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,wCAAA;EACA,qCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;ATuoMJ;;AgDxnMA;EACE,qBAAA;EACA,sBAAA;AhD2nMF;AgDznME;EAEE,oCAAA;EACA,0BAAA;AhD0nMJ;;AgDjnMA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AhDonMF;AgDjnME;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AhDknMJ;AgD/mME;EACE,+CAAA;EACA,uDAAA;AhDinMJ;;AgDzmMA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;AhD4mMF;AgD1mME;EvCvDE,+BAAA;EACA,gCAAA;AToqMJ;AgD1mME;EvC7CE,mCAAA;EACA,kCAAA;AT0pMJ;AgD1mME;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AhD2mMJ;AgDvmME;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AhDymMJ;AgDrmME;EACE,mBAAA;AhDumMJ;AgDrmMI;EACE,wDAAA;EACA,mDAAA;AhDumMN;;AgD1lMI;EACE,mBAAA;AhD6lMN;AgD1lMQ;EvCvDJ,6DAAA;EAZA,0BAAA;ATiqMJ;AgDzlMQ;EvCxEJ,2DAAA;EAYA,4BAAA;ATypMJ;AgDxlMQ;EACE,aAAA;AhD0lMV;AgDvlMQ;EACE,mDAAA;EACA,oBAAA;AhDylMV;AgDvlMU;EACE,yDAAA;EACA,oDAAA;AhDylMZ;;AgB/qMI;EgC8DA;IACE,mBAAA;EhDqnMJ;EgDlnMM;IvCvDJ,6DAAA;IAZA,0BAAA;ETyrMF;EgDjnMM;IvCxEJ,2DAAA;IAYA,4BAAA;ETirMF;EgDhnMM;IACE,aAAA;EhDknMR;EgD/mMM;IACE,mDAAA;IACA,oBAAA;EhDinMR;EgD/mMQ;IACE,yDAAA;IACA,oDAAA;EhDinMV;AACF;AgBxsMI;EgC8DA;IACE,mBAAA;EhD6oMJ;EgD1oMM;IvCvDJ,6DAAA;IAZA,0BAAA;ETitMF;EgDzoMM;IvCxEJ,2DAAA;IAYA,4BAAA;ETysMF;EgDxoMM;IACE,aAAA;EhD0oMR;EgDvoMM;IACE,mDAAA;IACA,oBAAA;EhDyoMR;EgDvoMQ;IACE,yDAAA;IACA,oDAAA;EhDyoMV;AACF;AgBhuMI;EgC8DA;IACE,mBAAA;EhDqqMJ;EgDlqMM;IvCvDJ,6DAAA;IAZA,0BAAA;ETyuMF;EgDjqMM;IvCxEJ,2DAAA;IAYA,4BAAA;ETiuMF;EgDhqMM;IACE,aAAA;EhDkqMR;EgD/pMM;IACE,mDAAA;IACA,oBAAA;EhDiqMR;EgD/pMQ;IACE,yDAAA;IACA,oDAAA;EhDiqMV;AACF;AgBxvMI;EgC8DA;IACE,mBAAA;EhD6rMJ;EgD1rMM;IvCvDJ,6DAAA;IAZA,0BAAA;ETiwMF;EgDzrMM;IvCxEJ,2DAAA;IAYA,4BAAA;ETyvMF;EgDxrMM;IACE,aAAA;EhD0rMR;EgDvrMM;IACE,mDAAA;IACA,oBAAA;EhDyrMR;EgDvrMQ;IACE,yDAAA;IACA,oDAAA;EhDyrMV;AACF;AgBhxMI;EgC8DA;IACE,mBAAA;EhDqtMJ;EgDltMM;IvCvDJ,6DAAA;IAZA,0BAAA;ETyxMF;EgDjtMM;IvCxEJ,2DAAA;IAYA,4BAAA;ETixMF;EgDhtMM;IACE,aAAA;EhDktMR;EgD/sMM;IACE,mDAAA;IACA,oBAAA;EhDitMR;EgD/sMQ;IACE,yDAAA;IACA,oDAAA;EhDitMV;AACF;AgBxyMI;EgC8DA;IACE,mBAAA;EhD6uMJ;EgD1uMM;IvCvDJ,6DAAA;IAZA,0BAAA;ETizMF;EgDzuMM;IvCxEJ,2DAAA;IAYA,4BAAA;ETyyMF;EgDxuMM;IACE,aAAA;EhD0uMR;EgDvuMM;IACE,mDAAA;IACA,oBAAA;EhDyuMR;EgDvuMQ;IACE,yDAAA;IACA,oDAAA;EhDyuMV;AACF;AgD5tMA;EvChJI,gBAAA;AT+2MJ;AgD5tME;EACE,mDAAA;AhD8tMJ;AgD5tMI;EACE,sBAAA;AhD8tMN;;AgDjtME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDotMJ;;AgD9tME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDiuMJ;;AgD3uME;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;AhD8uMJ;;AgDxvME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhD2vMJ;;AgDrwME;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AhDwwMJ;;AgDlxME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDqxMJ;;AgD/xME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhDkyMJ;;AgD5yME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhD+yMJ;;AgDzzME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhD4zMJ;;AgDt0ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDy0MJ;;AgDn1ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDs1MJ;;AgDh2ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDm2MJ;;AgD72ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDg3MJ;;AgD13ME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhD63MJ;;AgDv4ME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhD04MJ;;AgDp5ME;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,4DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,qDAAA;EACA,sDAAA;EACA,gEAAA;AhDu5MJ;;AgDj6ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDo6MJ;;AgD96ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDi7MJ;;AgD37ME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhD87MJ;;AgDx8ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhD28MJ;;AgDr9ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDw9MJ;;AgDl+ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDq+MJ;;AgD/+ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDk/MJ;;AgD5/ME;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhD+/MJ;;AgDzgNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhD4gNJ;;AgDthNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDyhNJ;;AgDniNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDsiNJ;;AgDhjNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDmjNJ;;AgD7jNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDgkNJ;;AgD1kNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhD6kNJ;;AgDvlNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhD0lNJ;;AgDpmNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDumNJ;;AiDnyNA;EAEE,6BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,4EAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UhD8lBgB;EgD7lBhB,WhD6lBgB;EgD5lBhB,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,kBAAA;EwCMF,oCAAA;AjDmyNF;AiDhyNE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AjDkyNJ;AiD/xNE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AjDiyNJ;AiD9xNE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AjD+xNJ;;AiDvxNA;EAHE,wCAAA;AjD8xNF;;AiDrxNI;EATF,wCAAA;AjDkyNF;;AkDn1NA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AT41NJ;AkDj1NE;EACE,UAAA;AlDm1NJ;AkDh1NE;EACE,aAAA;AlDk1NJ;;AkD90NA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AlDg1NF;AkD90NE;EACE,sCAAA;AlDg1NJ;;AkD50NA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;ATg3NJ;AkD90NE;EACE,oDAAA;EACA,sCAAA;AlDg1NJ;;AkD50NA;EACE,kCAAA;EACA,qBAAA;AlD+0NF;;AmD74NA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sCAAA;EACA,2DAAA;EACA,+CAAA;EACA,2BAAA;EACA,4EAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AnD24NF;;AmDp4NA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AnDs4NF;AmDn4NE;E3B5CI,mC2B6CF;EACA,8BlDi4BmB;ADogMvB;AwB/6NM;E2BwCJ;I3BvCM,gBAAA;ExBk7NN;AACF;AmDx4NE;EACE,elD+3BmB;AD2gMvB;AmDt4NE;EACE,sBlD43BoB;AD4gMxB;;AmDp4NA;EACE,+CAAA;AnDu4NF;AmDr4NE;EACE,gBAAA;EACA,gBAAA;AnDu4NJ;AmDp4NE;EACE,gBAAA;AnDs4NJ;;AmDl4NA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AnDq4NF;;AmDj4NA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AnDi4NF;;AmD73NA;EAEE,0BAAA;EACA,yBAAA;EACA,2BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AnDm4N9D;AoD/+NE;EAAS,UAAA;ApDk/NX;AoDj/NE;EAAS,mCD2GiF;AnDy4N5F;;AmDp4NA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E1CtGE,2DAAA;EACA,4DAAA;AT8+NJ;AmDt4NE;EACE,kGAAA;EACA,sJAAA;AnDw4NJ;;AmDn4NA;EACE,gBAAA;EACA,8CAAA;AnDs4NF;;AmDj4NA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AnDk4NF;;AmD93NA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C1HE,+DAAA;EACA,8DAAA;AT4/NJ;AmD73NE;EACE,8CAAA;AnD+3NJ;;AgB3+NI;EmCkHF;IACE,0BAAA;IACA,uEAAA;EnD63NF;EmDz3NA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EnD23NF;EmDx3NA;IACE,uBAAA;EnD03NF;AACF;AgB1/NI;EmCoIF;;IAEE,uBAAA;EnDy3NF;AACF;AgBhgOI;EmC2IF;IACE,wBAAA;EnDw3NF;AACF;AmD/2NI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AnDi3NN;AmD/2NM;EACE,YAAA;EACA,SAAA;E1C1MJ,gBAAA;AT4jOJ;AmD92NM;;E1C9MF,gBAAA;ATgkOJ;AmD72NM;EACE,gBAAA;AnD+2NR;;AgB1gOI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDq4NJ;EmDn4NI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ETglOF;EmDl4NI;;I1C9MF,gBAAA;ETolOF;EmDj4NI;IACE,gBAAA;EnDm4NN;AACF;AgB/hOI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDy5NJ;EmDv5NI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ETomOF;EmDt5NI;;I1C9MF,gBAAA;ETwmOF;EmDr5NI;IACE,gBAAA;EnDu5NN;AACF;AgBnjOI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD66NJ;EmD36NI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ETwnOF;EmD16NI;;I1C9MF,gBAAA;ET4nOF;EmDz6NI;IACE,gBAAA;EnD26NN;AACF;AgBvkOI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDi8NJ;EmD/7NI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ET4oOF;EmD97NI;;I1C9MF,gBAAA;ETgpOF;EmD77NI;IACE,gBAAA;EnD+7NN;AACF;AgB3lOI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDq9NJ;EmDn9NI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ETgqOF;EmDl9NI;;I1C9MF,gBAAA;EToqOF;EmDj9NI;IACE,gBAAA;EnDm9NN;AACF;AgB/mOI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDy+NJ;EmDv+NI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;ETorOF;EmDt+NI;;I1C9MF,gBAAA;ETwrOF;EmDr+NI;IACE,gBAAA;EnDu+NN;AACF;AqD9sOA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,iCALI;EgDjRR,qCAAA;EACA,kCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,uCrDmUiB;EqDjUjB,kBAAA;EACA,gBrDwUmB;EqDvUnB,gBrD0UiB;EqDzUjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;ArDstOF;AqDptOE;EAAS,kCAAA;ArDutOX;AqDrtOE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArDutOJ;AqDrtOI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArDutON;;AqDltOA;EACE,iDAAA;ArDqtOF;AqDntOE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ArDqtOJ;;AqDjtOA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ArDotOF;AqDltOE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ArDotOJ;;AqDhtOA,mBAAA;AAEA;EACE,8CAAA;ArDktOF;AqDhtOE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ArDktOJ;;AqD9sOA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ArDitOF;AqD/sOE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ArDitOJ;;AqD7sOA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;ATiyOJ;;AuDpzOA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,iCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,yEAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,uCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,uCrDmUiB;EqDjUjB,kBAAA;EACA,gBrDwUmB;EqDvUnB,gBrD0UiB;EqDzUjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;AT+0OJ;AuD3zOE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AvD6zOJ;AuD3zOI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AvD4zON;;AuDtzOE;EACE,oFAAA;AvDyzOJ;AuDvzOI;EAEE,wFAAA;AvDwzON;AuDrzOI;EACE,SAAA;EACA,gDAAA;AvDuzON;AuDpzOI;EACE,sCAAA;EACA,sCAAA;AvDszON;;AuDjzOA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AvDmzOJ;AuDjzOI;EAEE,kIAAA;AvDkzON;AuD/yOI;EACE,OAAA;EACA,kDAAA;AvDizON;AuD9yOI;EACE,oCAAA;EACA,wCAAA;AvDgzON;;AuD3yOA,mBAAA;AAGE;EACE,iFAAA;AvD4yOJ;AuD1yOI;EAEE,wFAAA;AvD2yON;AuDxyOI;EACE,MAAA;EACA,mDAAA;AvD0yON;AuDvyOI;EACE,mCAAA;EACA,yCAAA;AvDyyON;AuDpyOE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AvDsyOJ;;AuDlyOA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AvDoyOJ;AuDlyOI;EAEE,kIAAA;AvDmyON;AuDhyOI;EACE,QAAA;EACA,iDAAA;AvDkyON;AuD/xOI;EACE,qCAAA;EACA,uCAAA;AvDiyON;;AuD5xOA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AT26OJ;AuD7wOE;EACE,aAAA;AvD+wOJ;;AuD3wOA;EACE,0EAAA;EACA,mCAAA;AvD8wOF;;AwDn8OA;EACE,kBAAA;AxDs8OF;;AwDn8OA;EACE,mBAAA;AxDs8OF;;AwDn8OA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AxDs8OF;AyD59OE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzD89OJ;;AwDv8OA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AxD08OF;AwBz9OM;EgCQN;IhCPQ,gBAAA;ExB49ON;AACF;;AwD58OA;;;EAGE,cAAA;AxD+8OF;;AwD58OA;;EAEE,2BAAA;AxD+8OF;;AwD58OA;;EAEE,4BAAA;AxD+8OF;;AwDt8OE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AxDy8OJ;AwDt8OE;;;EAGE,UAAA;EACA,UAAA;AxDw8OJ;AwDr8OE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AxDu8OJ;AwBhgPM;EgCqDJ;;IhCpDM,gBAAA;ExBogPN;AACF;;AwDp8OA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UvD0oCuB;EuDzoCvB,UAAA;EACA,cvDnCM;EuDoCN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YvDqoCyB;EuB3tCrB,8BgCuFJ;AxDs8OF;AwBzhPM;EgCkEN;;IhCjEQ,gBAAA;ExB6hPN;AACF;AwDz8OE;;;EAEE,cvD7CI;EuD8CJ,qBAAA;EACA,UAAA;EACA,YvD6nC6B;AD+0MjC;;AwDz8OA;EACE,OAAA;AxD48OF;;AwDz8OA;EACE,QAAA;AxD48OF;;AwDv8OA;;EAEE,qBAAA;EACA,WvD2nC4B;EuD1nC5B,YvD0nC4B;EuDznC5B,4BAAA;EACA,wBAAA;EACA,0BAAA;AxD08OF;;AwDv8OA;;;;;;;GAAA;AAQA;EACE,0DAAA;AxD08OF;;AwDx8OA;EACE,0DAAA;AxD28OF;;AwDn8OA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBvDskCuB;EuDrkCvB,mBAAA;EACA,gBvDokCuB;ADi4MzB;AwDn8OE;EACE,uBAAA;EACA,cAAA;EACA,WvDmkCuB;EuDlkCvB,WvDmkCwB;EuDlkCxB,UAAA;EACA,iBvDmkCwB;EuDlkCxB,gBvDkkCwB;EuDjkCxB,mBAAA;EACA,eAAA;EACA,yBvDnHI;EuDoHJ,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YvD0jCyB;EuBluCvB,6BgCyKF;AxDo8OJ;AwBzmPM;EgCoJJ;IhCnJM,gBAAA;ExB4mPN;AACF;AwDt8OE;EACE,UvDujCgC;ADi5MpC;;AwD/7OA;EACE,kBAAA;EACA,UAAA;EACA,evDgjCwB;EuD/iCxB,SAAA;EACA,oBvD6iC2B;EuD5iC3B,uBvD4iC2B;EuD3iC3B,cvD9IM;EuD+IN,kBAAA;AxDk8OF;;AwD57OE;;EAEE,gCvD2iCgC;ADo5MpC;AwD57OE;EACE,yBvDlII;ADgkPR;AwD37OE;EACE,cvDtII;ADmkPR;;AwDv8OE;;;EAEE,gCvD2iCgC;ADg6MpC;AwDx8OE;EACE,yBvDlII;AD4kPR;AwDv8OE;EACE,cvDtII;AD+kPR;;A0DnqPA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A1DqqPF;;A0DjqPA;EACE;IAAK,0CAAA;E1DqqPL;AACF;A0DlqPA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A1DiqPF;;A0D9pPA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A1DgqPF;;A0DvpPA;EACE;IACE,mBAAA;E1D0pPF;E0DxpPA;IACE,UAAA;IACA,eAAA;E1D0pPF;AACF;A0DtpPA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A1DqpPF;;A0DlpPA;EACE,wBAAA;EACA,yBAAA;A1DqpPF;;A0DjpPE;EACE;;IAEE,kCAAA;E1DopPJ;AACF;A2DpuPA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,gFAAA;EACA,qDAAA;EACA,qCAAA;A3DquPF;;AgBxqPI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3DstPJ;AACF;AwBjvPM;EmCYJ;InCXM,gBAAA;ExBovPN;AACF;AgB9rPI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3D6tPN;E2D1tPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3D4tPN;E2DztPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3D2tPN;E2DxtPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3D0tPN;E2DvtPI;IAEE,eAAA;E3DwtPN;E2DrtPI;IAGE,mBAAA;E3DqtPN;AACF;AgBlvPI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DotPN;E2DltPM;IACE,aAAA;E3DotPR;E2DjtPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DktPR;AACF;;AgBtvPI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3DoyPJ;AACF;AwB/zPM;EmCYJ;InCXM,gBAAA;ExBk0PN;AACF;AgB5wPI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3D2yPN;E2DxyPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3D0yPN;E2DvyPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3DyyPN;E2DtyPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3DwyPN;E2DryPI;IAEE,eAAA;E3DsyPN;E2DnyPI;IAGE,mBAAA;E3DmyPN;AACF;AgBh0PI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DkyPN;E2DhyPM;IACE,aAAA;E3DkyPR;E2D/xPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DgyPR;AACF;;AgBp0PI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3Dk3PJ;AACF;AwB74PM;EmCYJ;InCXM,gBAAA;ExBg5PN;AACF;AgB11PI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3Dy3PN;E2Dt3PI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3Dw3PN;E2Dr3PI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3Du3PN;E2Dp3PI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3Ds3PN;E2Dn3PI;IAEE,eAAA;E3Do3PN;E2Dj3PI;IAGE,mBAAA;E3Di3PN;AACF;AgB94PI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3Dg3PN;E2D92PM;IACE,aAAA;E3Dg3PR;E2D72PM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3D82PR;AACF;;AgBl5PI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3Dg8PJ;AACF;AwB39PM;EmCYJ;InCXM,gBAAA;ExB89PN;AACF;AgBx6PI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3Du8PN;E2Dp8PI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3Ds8PN;E2Dn8PI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3Dq8PN;E2Dl8PI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3Do8PN;E2Dj8PI;IAEE,eAAA;E3Dk8PN;E2D/7PI;IAGE,mBAAA;E3D+7PN;AACF;AgB59PI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3D87PN;E2D57PM;IACE,aAAA;E3D87PR;E2D37PM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3D47PR;AACF;;AgBh+PI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3D8gQJ;AACF;AwBziQM;EmCYJ;InCXM,gBAAA;ExB4iQN;AACF;AgBt/PI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3DqhQN;E2DlhQI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3DohQN;E2DjhQI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3DmhQN;E2DhhQI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3DkhQN;E2D/gQI;IAEE,eAAA;E3DghQN;E2D7gQI;IAGE,mBAAA;E3D6gQN;AACF;AgB1iQI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3D4gQN;E2D1gQM;IACE,aAAA;E3D4gQR;E2DzgQM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3D0gQR;AACF;;AgB9iQI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3D4lQJ;AACF;AwBvnQM;EmCYJ;InCXM,gBAAA;ExB0nQN;AACF;AgBpkQI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3DmmQN;E2DhmQI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3DkmQN;E2D/lQI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3DimQN;E2D9lQI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3DgmQN;E2D7lQI;IAEE,eAAA;E3D8lQN;E2D3lQI;IAGE,mBAAA;E3D2lQN;AACF;AgBxnQI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3D0lQN;E2DxlQM;IACE,aAAA;E3D0lQR;E2DvlQM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DwlQR;AACF;;A2DxqQE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A3DyqQN;AwBnsQM;EmCYJ;InCXM,gBAAA;ExBssQN;AACF;A2D5qQM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A3D8qQR;A2D3qQM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A3D6qQR;A2D1qQM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A3D4qQR;A2DzqQM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A3D2qQR;A2DxqQM;EAEE,eAAA;A3DyqQR;A2DtqQM;EAGE,mBAAA;A3DsqQR;;A2D3oQA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,anDorC0B;EmDnrC1B,YAAA;EACA,aAAA;EACA,yBnDy6BkB;AD01OpB;AoDhwQE;EAAS,UAAA;ApDmwQX;AoDlwQE;EAAS,anDs6Bc;AD+1OzB;;A2DvpQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;A3D0pQF;A2DxpQE;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;A3D0pQJ;;A2DtpQA;EACE,gBAAA;EACA,kDAAA;A3DypQF;;A2DtpQA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A3DypQF;;A4DzyQA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,Y3D+qBwB;AD6nP1B;A4D1yQE;EACE,qBAAA;EACA,WAAA;A5D4yQJ;;A4DvyQA;EACE,iBAAA;A5D0yQF;;A4DvyQA;EACE,iBAAA;A5D0yQF;;A4DvyQA;EACE,iBAAA;A5D0yQF;;A4DryQE;EACE,mDAAA;A5DwyQJ;;A4DpyQA;EACE;IACE,Y3DkpBsB;EDqpPxB;AACF;A4DpyQA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;A5DsyQF;;A4DnyQA;EACE;IACE,uBAAA;E5DsyQF;AACF;AyDr1QE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDu1QJ;;A6D11QE;EACE,yBAAA;EACA,iFAAA;A7D61QJ;;A6D/1QE;EACE,yBAAA;EACA,+EAAA;A7Dk2QJ;;A6Dp2QE;EACE,yBAAA;EACA,qFAAA;A7Du2QJ;;A6Dz2QE;EACE,yBAAA;EACA,iFAAA;A7D42QJ;;A6D92QE;EACE,yBAAA;EACA,mFAAA;A7Di3QJ;;A6Dn3QE;EACE,yBAAA;EACA,iFAAA;A7Ds3QJ;;A6Dx3QE;EACE,yBAAA;EACA,gFAAA;A7D23QJ;;A6D73QE;EACE,yBAAA;EACA,iFAAA;A7Dg4QJ;;A6Dl4QE;EACE,yBAAA;EACA,iFAAA;A7Dq4QJ;;A6Dv4QE;EACE,yBAAA;EACA,8EAAA;A7D04QJ;;A6D54QE;EACE,yBAAA;EACA,8EAAA;A7D+4QJ;;A6Dj5QE;EACE,yBAAA;EACA,+EAAA;A7Do5QJ;;A6Dt5QE;EACE,yBAAA;EACA,+EAAA;A7Dy5QJ;;A6D35QE;EACE,yBAAA;EACA,gFAAA;A7D85QJ;;A6Dh6QE;EACE,yBAAA;EACA,gFAAA;A7Dm6QJ;;A6Dr6QE;EACE,yBAAA;EACA,6EAAA;A7Dw6QJ;;A6D16QE;EACE,yBAAA;EACA,8EAAA;A7D66QJ;;A6D/6QE;EACE,yBAAA;EACA,+EAAA;A7Dk7QJ;;A6Dp7QE;EACE,yBAAA;EACA,gFAAA;A7Du7QJ;;A6Dz7QE;EACE,yBAAA;EACA,8EAAA;A7D47QJ;;A6D97QE;EACE,yBAAA;EACA,+EAAA;A7Di8QJ;;A6Dn8QE;EACE,yBAAA;EACA,+EAAA;A7Ds8QJ;;A6Dx8QE;EACE,yBAAA;EACA,8EAAA;A7D28QJ;;A6D78QE;EACE,yBAAA;EACA,kFAAA;A7Dg9QJ;;A6Dl9QE;EACE,yBAAA;EACA,kFAAA;A7Dq9QJ;;A6Dv9QE;EACE,yBAAA;EACA,kFAAA;A7D09QJ;;A6D59QE;EACE,yBAAA;EACA,kFAAA;A7D+9QJ;;A6Dj+QE;EACE,yBAAA;EACA,kFAAA;A7Do+QJ;;A6Dt+QE;EACE,yBAAA;EACA,kFAAA;A7Dy+QJ;;A6D3+QE;EACE,yBAAA;EACA,kFAAA;A7D8+QJ;;A6Dh/QE;EACE,yBAAA;EACA,kFAAA;A7Dm/QJ;;A6Dr/QE;EACE,yBAAA;EACA,kFAAA;A7Dw/QJ;;A8D1/QE;EACE,wEAAA;EACA,kGAAA;A9D6/QJ;A8D1/QM;EAGE,+DAAA;EACA,yFAAA;A9D0/QR;;A8DngRE;EACE,sEAAA;EACA,gGAAA;A9DsgRJ;A8DngRM;EAGE,8DAAA;EACA,wFAAA;A9DmgRR;;A8D5gRE;EACE,4EAAA;EACA,sGAAA;A9D+gRJ;A8D5gRM;EAGE,gEAAA;EACA,0FAAA;A9D4gRR;;A8DrhRE;EACE,wEAAA;EACA,kGAAA;A9DwhRJ;A8DrhRM;EAGE,6DAAA;EACA,uFAAA;A9DqhRR;;A8D9hRE;EACE,0EAAA;EACA,oGAAA;A9DiiRJ;A8D9hRM;EAGE,+DAAA;EACA,yFAAA;A9D8hRR;;A8DviRE;EACE,wEAAA;EACA,kGAAA;A9D0iRJ;A8DviRM;EAGE,+DAAA;EACA,yFAAA;A9DuiRR;;A8DhjRE;EACE,uEAAA;EACA,iGAAA;A9DmjRJ;A8DhjRM;EAGE,4DAAA;EACA,sFAAA;A9DgjRR;;A8DzjRE;EACE,wEAAA;EACA,kGAAA;A9D4jRJ;A8DzjRM;EAGE,8DAAA;EACA,wFAAA;A9DyjRR;;A8DlkRE;EACE,wEAAA;EACA,kGAAA;A9DqkRJ;A8DlkRM;EAGE,0DAAA;EACA,oFAAA;A9DkkRR;;A8D3kRE;EACE,qEAAA;EACA,+FAAA;A9D8kRJ;A8D3kRM;EAGE,8DAAA;EACA,wFAAA;A9D2kRR;;A8DplRE;EACE,qEAAA;EACA,+FAAA;A9DulRJ;A8DplRM;EAGE,6DAAA;EACA,uFAAA;A9DolRR;;A8D7lRE;EACE,sEAAA;EACA,gGAAA;A9DgmRJ;A8D7lRM;EAGE,0DAAA;EACA,oFAAA;A9D6lRR;;A8DtmRE;EACE,sEAAA;EACA,gGAAA;A9DymRJ;A8DtmRM;EAGE,gEAAA;EACA,0FAAA;A9DsmRR;;A8D/mRE;EACE,uEAAA;EACA,iGAAA;A9DknRJ;A8D/mRM;EAGE,+DAAA;EACA,yFAAA;A9D+mRR;;A8DxnRE;EACE,uEAAA;EACA,iGAAA;A9D2nRJ;A8DxnRM;EAGE,8DAAA;EACA,wFAAA;A9DwnRR;;A8DjoRE;EACE,oEAAA;EACA,8FAAA;A9DooRJ;A8DjoRM;EAGE,4DAAA;EACA,sFAAA;A9DioRR;;A8D1oRE;EACE,qEAAA;EACA,+FAAA;A9D6oRJ;A8D1oRM;EAGE,8DAAA;EACA,wFAAA;A9D0oRR;;A8DnpRE;EACE,sEAAA;EACA,gGAAA;A9DspRJ;A8DnpRM;EAGE,8DAAA;EACA,wFAAA;A9DmpRR;;A8D5pRE;EACE,uEAAA;EACA,iGAAA;A9D+pRJ;A8D5pRM;EAGE,+DAAA;EACA,yFAAA;A9D4pRR;;A8DrqRE;EACE,qEAAA;EACA,+FAAA;A9DwqRJ;A8DrqRM;EAGE,8DAAA;EACA,wFAAA;A9DqqRR;;A8D9qRE;EACE,sEAAA;EACA,gGAAA;A9DirRJ;A8D9qRM;EAGE,8DAAA;EACA,wFAAA;A9D8qRR;;A8DvrRE;EACE,sEAAA;EACA,gGAAA;A9D0rRJ;A8DvrRM;EAGE,gEAAA;EACA,0FAAA;A9DurRR;;A8DhsRE;EACE,qEAAA;EACA,+FAAA;A9DmsRJ;A8DhsRM;EAGE,+DAAA;EACA,yFAAA;A9DgsRR;;A8DzsRE;EACE,yEAAA;EACA,mGAAA;A9D4sRJ;A8DzsRM;EAGE,gEAAA;EACA,0FAAA;A9DysRR;;A8DltRE;EACE,yEAAA;EACA,mGAAA;A9DqtRJ;A8DltRM;EAGE,gEAAA;EACA,0FAAA;A9DktRR;;A8D3tRE;EACE,yEAAA;EACA,mGAAA;A9D8tRJ;A8D3tRM;EAGE,gEAAA;EACA,0FAAA;A9D2tRR;;A8DpuRE;EACE,yEAAA;EACA,mGAAA;A9DuuRJ;A8DpuRM;EAGE,+DAAA;EACA,yFAAA;A9DouRR;;A8D7uRE;EACE,yEAAA;EACA,mGAAA;A9DgvRJ;A8D7uRM;EAGE,8DAAA;EACA,wFAAA;A9D6uRR;;A8DtvRE;EACE,yEAAA;EACA,mGAAA;A9DyvRJ;A8DtvRM;EAGE,6DAAA;EACA,uFAAA;A9DsvRR;;A8D/vRE;EACE,yEAAA;EACA,mGAAA;A9DkwRJ;A8D/vRM;EAGE,6DAAA;EACA,uFAAA;A9D+vRR;;A8DxwRE;EACE,yEAAA;EACA,mGAAA;A9D2wRJ;A8DxwRM;EAGE,6DAAA;EACA,uFAAA;A9DwwRR;;A8DjxRE;EACE,yEAAA;EACA,mGAAA;A9DoxRJ;A8DjxRM;EAGE,6DAAA;EACA,uFAAA;A9DixRR;;A8D1wRA;EACE,+EAAA;EACA,yGAAA;A9D6wRF;A8D1wRI;EAEE,kFAAA;EACA,4GAAA;A9D2wRN;;A+DryRA;EACE,UAAA;EAEA,kJAAA;A/DuyRF;;AgE1yRA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;AhE6yRF;AgE3yRE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;AhE6yRJ;AwBtyRM;EwCZJ;IxCaM,gBAAA;ExByyRN;AACF;;AgE3yRI;EACE,mEAAA;AhE8yRN;;AiEj0RA;EACE,kBAAA;EACA,WAAA;AjEo0RF;AiEl0RE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AjEo0RJ;AiEj0RE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AjEm0RJ;;AiE9zRE;EACE,uBAAA;AjEi0RJ;;AiEl0RE;EACE,sBAAA;AjEq0RJ;;AiEt0RE;EACE,yBAAA;AjEy0RJ;;AiE10RE;EACE,iCAAA;AjE60RJ;;AkEl2RA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,ajEirCa;ADorPf;;AkEl2RA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,ajEyqCa;AD4rPf;;AkE71RI;EACE,gBAAA;EACA,MAAA;EACA,ajE6pCU;ADmsPhB;;AkE71RI;EACE,gBAAA;EACA,SAAA;EACA,ajEupCU;ADysPhB;;AgBj0RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajE6pCU;EDgtPd;EkE12RE;IACE,gBAAA;IACA,SAAA;IACA,ajEupCU;EDqtPd;AACF;AgB90RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajE6pCU;ED4tPd;EkEt3RE;IACE,gBAAA;IACA,SAAA;IACA,ajEupCU;EDiuPd;AACF;AgB11RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajE6pCU;EDwuPd;EkEl4RE;IACE,gBAAA;IACA,SAAA;IACA,ajEupCU;ED6uPd;AACF;AgBt2RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajE6pCU;EDovPd;EkE94RE;IACE,gBAAA;IACA,SAAA;IACA,ajEupCU;EDyvPd;AACF;AgBl3RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajE6pCU;EDgwPd;EkE15RE;IACE,gBAAA;IACA,SAAA;IACA,ajEupCU;EDqwPd;AACF;AgB93RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajE6pCU;ED4wPd;EkEt6RE;IACE,gBAAA;IACA,SAAA;IACA,ajEupCU;EDixPd;AACF;AmEx8RA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AnE08RF;;AmEv8RA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AnE08RF;;AoEl9RA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ArEm9RF;AqEh9RE;;EACE,6BAAA;ArEm9RJ;;AsEj+RE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UrE8fqB;EqE7frB,WAAA;AtEo+RJ;;AuE5+RA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AxEg/RF;;AyEt/RA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,axE0VW;AD+pRb;;A0E77RQ;EAOI,mCAAA;A1E07RZ;;A0Ej8RQ;EAOI,8BAAA;A1E87RZ;;A0Er8RQ;EAOI,iCAAA;A1Ek8RZ;;A0Ez8RQ;EAOI,iCAAA;A1Es8RZ;;A0E78RQ;EAOI,sCAAA;A1E08RZ;;A0Ej9RQ;EAOI,mCAAA;A1E88RZ;;A0Er9RQ;EAOI,sBAAA;A1Ek9RZ;;A0Ez9RQ;EAOI,uBAAA;A1Es9RZ;;A0E79RQ;EAOI,sBAAA;A1E09RZ;;A0Ej+RQ;EAOI,8BAAA;A1E89RZ;;A0Er+RQ;EAOI,4BAAA;A1Ek+RZ;;A0Ez+RQ;EAOI,2BAAA;A1Es+RZ;;A0E7+RQ;EAOI,iCAAA;A1E0+RZ;;A0Ej/RQ;EAOI,2BAAA;A1E8+RZ;;A0Er/RQ;EAOI,qBAAA;A1Ek/RZ;;A0Ez/RQ;EAOI,wBAAA;A1Es/RZ;;A0E7/RQ;EAOI,uBAAA;A1E0/RZ;;A0EjgSQ;EAOI,wBAAA;A1E8/RZ;;A0ErgSQ;EAOI,qBAAA;A1EkgSZ;;A0EzgSQ;EAOI,yBAAA;A1EsgSZ;;A0E7gSQ;EAOI,2BAAA;A1E0gSZ;;A0EjhSQ;EAOI,4BAAA;A1E8gSZ;;A0ErhSQ;EAOI,2BAAA;A1EkhSZ;;A0EzhSQ;EAOI,2BAAA;A1EshSZ;;A0E7hSQ;EAOI,6BAAA;A1E0hSZ;;A0EjiSQ;EAOI,8BAAA;A1E8hSZ;;A0EriSQ;EAOI,6BAAA;A1EkiSZ;;A0EziSQ;EAOI,2BAAA;A1EsiSZ;;A0E7iSQ;EAOI,6BAAA;A1E0iSZ;;A0EjjSQ;EAOI,8BAAA;A1E8iSZ;;A0ErjSQ;EAOI,6BAAA;A1EkjSZ;;A0EzjSQ;EAOI,0BAAA;A1EsjSZ;;A0E7jSQ;EAOI,gCAAA;A1E0jSZ;;A0EjkSQ;EAOI,yBAAA;A1E8jSZ;;A0ErkSQ;EAOI,wBAAA;A1EkkSZ;;A0EzkSQ;EAOI,+BAAA;A1EskSZ;;A0E7kSQ;EAOI,yBAAA;A1E0kSZ;;A0EjlSQ;EAOI,6BAAA;A1E8kSZ;;A0ErlSQ;EAOI,8BAAA;A1EklSZ;;A0EzlSQ;EAOI,wBAAA;A1EslSZ;;A0E7lSQ;EAOI,+BAAA;A1E0lSZ;;A0EjmSQ;EAOI,wBAAA;A1E8lSZ;;A0ErmSQ;EAOI,2CAAA;A1EkmSZ;;A0EzmSQ;EAOI,8CAAA;A1EsmSZ;;A0E7mSQ;EAOI,8CAAA;A1E0mSZ;;A0EjnSQ;EAOI,2BAAA;A1E8mSZ;;A0E/nSQ;EACE,gFAAA;A1EkoSV;;A0EnoSQ;EACE,8EAAA;A1EsoSV;;A0EvoSQ;EACE,oFAAA;A1E0oSV;;A0E3oSQ;EACE,gFAAA;A1E8oSV;;A0E/oSQ;EACE,kFAAA;A1EkpSV;;A0EnpSQ;EACE,gFAAA;A1EspSV;;A0EvpSQ;EACE,+EAAA;A1E0pSV;;A0E3pSQ;EACE,gFAAA;A1E8pSV;;A0E/pSQ;EACE,gFAAA;A1EkqSV;;A0EnqSQ;EACE,6EAAA;A1EsqSV;;A0EvqSQ;EACE,6EAAA;A1E0qSV;;A0E3qSQ;EACE,8EAAA;A1E8qSV;;A0E/qSQ;EACE,8EAAA;A1EkrSV;;A0EnrSQ;EACE,+EAAA;A1EsrSV;;A0EvrSQ;EACE,+EAAA;A1E0rSV;;A0E3rSQ;EACE,4EAAA;A1E8rSV;;A0E/rSQ;EACE,6EAAA;A1EksSV;;A0EnsSQ;EACE,8EAAA;A1EssSV;;A0EvsSQ;EACE,+EAAA;A1E0sSV;;A0E3sSQ;EACE,6EAAA;A1E8sSV;;A0E/sSQ;EACE,8EAAA;A1EktSV;;A0EntSQ;EACE,8EAAA;A1EstSV;;A0EvtSQ;EACE,6EAAA;A1E0tSV;;A0E3tSQ;EACE,iFAAA;A1E8tSV;;A0E/tSQ;EACE,iFAAA;A1EkuSV;;A0EnuSQ;EACE,iFAAA;A1EsuSV;;A0EvuSQ;EACE,iFAAA;A1E0uSV;;A0E3uSQ;EACE,iFAAA;A1E8uSV;;A0E/uSQ;EACE,iFAAA;A1EkvSV;;A0EnvSQ;EACE,iFAAA;A1EsvSV;;A0EvvSQ;EACE,iFAAA;A1E0vSV;;A0E3vSQ;EACE,iFAAA;A1E8vSV;;A0ErvSQ;EAOI,2BAAA;A1EkvSZ;;A0EzvSQ;EAOI,6BAAA;A1EsvSZ;;A0E7vSQ;EAOI,6BAAA;A1E0vSZ;;A0EjwSQ;EAOI,0BAAA;A1E8vSZ;;A0ErwSQ;EAOI,2BAAA;A1EkwSZ;;A0EzwSQ;EAOI,iBAAA;A1EswSZ;;A0E7wSQ;EAOI,mBAAA;A1E0wSZ;;A0EjxSQ;EAOI,oBAAA;A1E8wSZ;;A0ErxSQ;EAOI,oBAAA;A1EkxSZ;;A0EzxSQ;EAOI,sBAAA;A1EsxSZ;;A0E7xSQ;EAOI,uBAAA;A1E0xSZ;;A0EjySQ;EAOI,kBAAA;A1E8xSZ;;A0ErySQ;EAOI,oBAAA;A1EkySZ;;A0EzySQ;EAOI,qBAAA;A1EsySZ;;A0E7ySQ;EAOI,mBAAA;A1E0ySZ;;A0EjzSQ;EAOI,qBAAA;A1E8ySZ;;A0ErzSQ;EAOI,sBAAA;A1EkzSZ;;A0EzzSQ;EAOI,2CAAA;A1EszSZ;;A0E7zSQ;EAOI,sCAAA;A1E0zSZ;;A0Ej0SQ;EAOI,sCAAA;A1E8zSZ;;A0Er0SQ;EAOI,uFAAA;A1Ek0SZ;;A0Ez0SQ;EAOI,oBAAA;A1Es0SZ;;A0E70SQ;EAOI,2FAAA;A1E00SZ;;A0Ej1SQ;EAOI,wBAAA;A1E80SZ;;A0Er1SQ;EAOI,6FAAA;A1Ek1SZ;;A0Ez1SQ;EAOI,0BAAA;A1Es1SZ;;A0E71SQ;EAOI,8FAAA;A1E01SZ;;A0Ej2SQ;EAOI,2BAAA;A1E81SZ;;A0Er2SQ;EAOI,4FAAA;A1Ek2SZ;;A0Ez2SQ;EAOI,yBAAA;A1Es2SZ;;A0E72SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1E22SZ;;A0El3SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1Eg3SZ;;A0Ev3SQ;EAIQ,sBAAA;EAGJ,kFAAA;A1Eq3SZ;;A0E53SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1E03SZ;;A0Ej4SQ;EAIQ,sBAAA;EAGJ,gFAAA;A1E+3SZ;;A0Et4SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1Eo4SZ;;A0E34SQ;EAIQ,sBAAA;EAGJ,6EAAA;A1Ey4SZ;;A0Eh5SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1E84SZ;;A0Er5SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1Em5SZ;;A0E15SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1Ew5SZ;;A0E/5SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1E65SZ;;A0Ep6SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1Ek6SZ;;A0Ez6SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1Eu6SZ;;A0E96SQ;EAIQ,sBAAA;EAGJ,6EAAA;A1E46SZ;;A0En7SQ;EAIQ,sBAAA;EAGJ,6EAAA;A1Ei7SZ;;A0Ex7SQ;EAIQ,sBAAA;EAGJ,0EAAA;A1Es7SZ;;A0E77SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1E27SZ;;A0El8SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1Eg8SZ;;A0Ev8SQ;EAIQ,sBAAA;EAGJ,6EAAA;A1Eq8SZ;;A0E58SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1E08SZ;;A0Ej9SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1E+8SZ;;A0Et9SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1Eo9SZ;;A0E39SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1Ey9SZ;;A0Eh+SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1E89SZ;;A0Er+SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1Em+SZ;;A0E1+SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1Ew+SZ;;A0E/+SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1E6+SZ;;A0Ep/SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1Ek/SZ;;A0Ez/SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1Eu/SZ;;A0E9/SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1E4/SZ;;A0EngTQ;EAIQ,sBAAA;EAGJ,+EAAA;A1EigTZ;;A0ExgTQ;EAIQ,sBAAA;EAGJ,+EAAA;A1EsgTZ;;A0E7gTQ;EAOI,wDAAA;A1E0gTZ;;A0EjhTQ;EAOI,0DAAA;A1E8gTZ;;A0ErhTQ;EAOI,wDAAA;A1EkhTZ;;A0EzhTQ;EAOI,qDAAA;A1EshTZ;;A0E7hTQ;EAOI,wDAAA;A1E0hTZ;;A0EjiTQ;EAOI,uDAAA;A1E8hTZ;;A0EriTQ;EAOI,sDAAA;A1EkiTZ;;A0EziTQ;EAOI,qDAAA;A1EsiTZ;;A0E7iTQ;EAOI,4BAAA;A1E0iTZ;;A0EjjTQ;EAOI,4BAAA;A1E8iTZ;;A0ErjTQ;EAOI,4BAAA;A1EkjTZ;;A0EzjTQ;EAOI,4BAAA;A1EsjTZ;;A0E7jTQ;EAOI,4BAAA;A1E0jTZ;;A0E3kTQ;EACE,wBAAA;A1E8kTV;;A0E/kTQ;EACE,yBAAA;A1EklTV;;A0EnlTQ;EACE,wBAAA;A1EslTV;;A0EvlTQ;EACE,yBAAA;A1E0lTV;;A0E3lTQ;EACE,sBAAA;A1E8lTV;;A0ErlTQ;EAOI,qBAAA;A1EklTZ;;A0EzlTQ;EAOI,qBAAA;A1EslTZ;;A0E7lTQ;EAOI,qBAAA;A1E0lTZ;;A0EjmTQ;EAOI,sBAAA;A1E8lTZ;;A0ErmTQ;EAOI,sBAAA;A1EkmTZ;;A0EzmTQ;EAOI,0BAAA;A1EsmTZ;;A0E7mTQ;EAOI,uBAAA;A1E0mTZ;;A0EjnTQ;EAOI,2BAAA;A1E8mTZ;;A0ErnTQ;EAOI,sBAAA;A1EknTZ;;A0EznTQ;EAOI,sBAAA;A1EsnTZ;;A0E7nTQ;EAOI,sBAAA;A1E0nTZ;;A0EjoTQ;EAOI,uBAAA;A1E8nTZ;;A0EroTQ;EAOI,uBAAA;A1EkoTZ;;A0EzoTQ;EAOI,2BAAA;A1EsoTZ;;A0E7oTQ;EAOI,wBAAA;A1E0oTZ;;A0EjpTQ;EAOI,4BAAA;A1E8oTZ;;A0ErpTQ;EAOI,yBAAA;A1EkpTZ;;A0EzpTQ;EAOI,8BAAA;A1EspTZ;;A0E7pTQ;EAOI,iCAAA;A1E0pTZ;;A0EjqTQ;EAOI,sCAAA;A1E8pTZ;;A0ErqTQ;EAOI,yCAAA;A1EkqTZ;;A0EzqTQ;EAOI,uBAAA;A1EsqTZ;;A0E7qTQ;EAOI,uBAAA;A1E0qTZ;;A0EjrTQ;EAOI,yBAAA;A1E8qTZ;;A0ErrTQ;EAOI,yBAAA;A1EkrTZ;;A0EzrTQ;EAOI,0BAAA;A1EsrTZ;;A0E7rTQ;EAOI,4BAAA;A1E0rTZ;;A0EjsTQ;EAOI,kCAAA;A1E8rTZ;;A0ErsTQ;EAOI,sCAAA;A1EksTZ;;A0EzsTQ;EAOI,oCAAA;A1EssTZ;;A0E7sTQ;EAOI,kCAAA;A1E0sTZ;;A0EjtTQ;EAOI,yCAAA;A1E8sTZ;;A0ErtTQ;EAOI,wCAAA;A1EktTZ;;A0EztTQ;EAOI,wCAAA;A1EstTZ;;A0E7tTQ;EAOI,kCAAA;A1E0tTZ;;A0EjuTQ;EAOI,gCAAA;A1E8tTZ;;A0EruTQ;EAOI,8BAAA;A1EkuTZ;;A0EzuTQ;EAOI,gCAAA;A1EsuTZ;;A0E7uTQ;EAOI,+BAAA;A1E0uTZ;;A0EjvTQ;EAOI,oCAAA;A1E8uTZ;;A0ErvTQ;EAOI,kCAAA;A1EkvTZ;;A0EzvTQ;EAOI,gCAAA;A1EsvTZ;;A0E7vTQ;EAOI,uCAAA;A1E0vTZ;;A0EjwTQ;EAOI,sCAAA;A1E8vTZ;;A0ErwTQ;EAOI,iCAAA;A1EkwTZ;;A0EzwTQ;EAOI,2BAAA;A1EswTZ;;A0E7wTQ;EAOI,iCAAA;A1E0wTZ;;A0EjxTQ;EAOI,+BAAA;A1E8wTZ;;A0ErxTQ;EAOI,6BAAA;A1EkxTZ;;A0EzxTQ;EAOI,+BAAA;A1EsxTZ;;A0E7xTQ;EAOI,8BAAA;A1E0xTZ;;A0EjyTQ;EAOI,oBAAA;A1E8xTZ;;A0EryTQ;EAOI,mBAAA;A1EkyTZ;;A0EzyTQ;EAOI,mBAAA;A1EsyTZ;;A0E7yTQ;EAOI,mBAAA;A1E0yTZ;;A0EjzTQ;EAOI,mBAAA;A1E8yTZ;;A0ErzTQ;EAOI,mBAAA;A1EkzTZ;;A0EzzTQ;EAOI,mBAAA;A1EszTZ;;A0E7zTQ;EAOI,mBAAA;A1E0zTZ;;A0Ej0TQ;EAOI,oBAAA;A1E8zTZ;;A0Er0TQ;EAOI,0BAAA;A1Ek0TZ;;A0Ez0TQ;EAOI,yBAAA;A1Es0TZ;;A0E70TQ;EAOI,uBAAA;A1E00TZ;;A0Ej1TQ;EAOI,yBAAA;A1E80TZ;;A0Er1TQ;EAOI,uBAAA;A1Ek1TZ;;A0Ez1TQ;EAOI,uBAAA;A1Es1TZ;;A0E71TQ;EAOI,0BAAA;EAAA,yBAAA;A1E21TZ;;A0El2TQ;EAOI,gCAAA;EAAA,+BAAA;A1Eg2TZ;;A0Ev2TQ;EAOI,+BAAA;EAAA,8BAAA;A1Eq2TZ;;A0E52TQ;EAOI,6BAAA;EAAA,4BAAA;A1E02TZ;;A0Ej3TQ;EAOI,+BAAA;EAAA,8BAAA;A1E+2TZ;;A0Et3TQ;EAOI,6BAAA;EAAA,4BAAA;A1Eo3TZ;;A0E33TQ;EAOI,6BAAA;EAAA,4BAAA;A1Ey3TZ;;A0Eh4TQ;EAOI,wBAAA;EAAA,2BAAA;A1E83TZ;;A0Er4TQ;EAOI,8BAAA;EAAA,iCAAA;A1Em4TZ;;A0E14TQ;EAOI,6BAAA;EAAA,gCAAA;A1Ew4TZ;;A0E/4TQ;EAOI,2BAAA;EAAA,8BAAA;A1E64TZ;;A0Ep5TQ;EAOI,6BAAA;EAAA,gCAAA;A1Ek5TZ;;A0Ez5TQ;EAOI,2BAAA;EAAA,8BAAA;A1Eu5TZ;;A0E95TQ;EAOI,2BAAA;EAAA,8BAAA;A1E45TZ;;A0En6TQ;EAOI,wBAAA;A1Eg6TZ;;A0Ev6TQ;EAOI,8BAAA;A1Eo6TZ;;A0E36TQ;EAOI,6BAAA;A1Ew6TZ;;A0E/6TQ;EAOI,2BAAA;A1E46TZ;;A0En7TQ;EAOI,6BAAA;A1Eg7TZ;;A0Ev7TQ;EAOI,2BAAA;A1Eo7TZ;;A0E37TQ;EAOI,2BAAA;A1Ew7TZ;;A0E/7TQ;EAOI,0BAAA;A1E47TZ;;A0En8TQ;EAOI,gCAAA;A1Eg8TZ;;A0Ev8TQ;EAOI,+BAAA;A1Eo8TZ;;A0E38TQ;EAOI,6BAAA;A1Ew8TZ;;A0E/8TQ;EAOI,+BAAA;A1E48TZ;;A0En9TQ;EAOI,6BAAA;A1Eg9TZ;;A0Ev9TQ;EAOI,6BAAA;A1Eo9TZ;;A0E39TQ;EAOI,2BAAA;A1Ew9TZ;;A0E/9TQ;EAOI,iCAAA;A1E49TZ;;A0En+TQ;EAOI,gCAAA;A1Eg+TZ;;A0Ev+TQ;EAOI,8BAAA;A1Eo+TZ;;A0E3+TQ;EAOI,gCAAA;A1Ew+TZ;;A0E/+TQ;EAOI,8BAAA;A1E4+TZ;;A0En/TQ;EAOI,8BAAA;A1Eg/TZ;;A0Ev/TQ;EAOI,yBAAA;A1Eo/TZ;;A0E3/TQ;EAOI,+BAAA;A1Ew/TZ;;A0E//TQ;EAOI,8BAAA;A1E4/TZ;;A0EngUQ;EAOI,4BAAA;A1EggUZ;;A0EvgUQ;EAOI,8BAAA;A1EogUZ;;A0E3gUQ;EAOI,4BAAA;A1EwgUZ;;A0E/gUQ;EAOI,4BAAA;A1E4gUZ;;A0EnhUQ;EAOI,2BAAA;A1EghUZ;;A0EvhUQ;EAOI,0BAAA;A1EohUZ;;A0E3hUQ;EAOI,wBAAA;A1EwhUZ;;A0E/hUQ;EAOI,0BAAA;A1E4hUZ;;A0EniUQ;EAOI,wBAAA;A1EgiUZ;;A0EviUQ;EAOI,iCAAA;EAAA,gCAAA;A1EqiUZ;;A0E5iUQ;EAOI,gCAAA;EAAA,+BAAA;A1E0iUZ;;A0EjjUQ;EAOI,8BAAA;EAAA,6BAAA;A1E+iUZ;;A0EtjUQ;EAOI,gCAAA;EAAA,+BAAA;A1EojUZ;;A0E3jUQ;EAOI,8BAAA;EAAA,6BAAA;A1EyjUZ;;A0EhkUQ;EAOI,+BAAA;EAAA,kCAAA;A1E8jUZ;;A0ErkUQ;EAOI,8BAAA;EAAA,iCAAA;A1EmkUZ;;A0E1kUQ;EAOI,4BAAA;EAAA,+BAAA;A1EwkUZ;;A0E/kUQ;EAOI,8BAAA;EAAA,iCAAA;A1E6kUZ;;A0EplUQ;EAOI,4BAAA;EAAA,+BAAA;A1EklUZ;;A0EzlUQ;EAOI,+BAAA;A1EslUZ;;A0E7lUQ;EAOI,8BAAA;A1E0lUZ;;A0EjmUQ;EAOI,4BAAA;A1E8lUZ;;A0ErmUQ;EAOI,8BAAA;A1EkmUZ;;A0EzmUQ;EAOI,4BAAA;A1EsmUZ;;A0E7mUQ;EAOI,iCAAA;A1E0mUZ;;A0EjnUQ;EAOI,gCAAA;A1E8mUZ;;A0ErnUQ;EAOI,8BAAA;A1EknUZ;;A0EznUQ;EAOI,gCAAA;A1EsnUZ;;A0E7nUQ;EAOI,8BAAA;A1E0nUZ;;A0EjoUQ;EAOI,kCAAA;A1E8nUZ;;A0EroUQ;EAOI,iCAAA;A1EkoUZ;;A0EzoUQ;EAOI,+BAAA;A1EsoUZ;;A0E7oUQ;EAOI,iCAAA;A1E0oUZ;;A0EjpUQ;EAOI,+BAAA;A1E8oUZ;;A0ErpUQ;EAOI,gCAAA;A1EkpUZ;;A0EzpUQ;EAOI,+BAAA;A1EspUZ;;A0E7pUQ;EAOI,6BAAA;A1E0pUZ;;A0EjqUQ;EAOI,+BAAA;A1E8pUZ;;A0ErqUQ;EAOI,6BAAA;A1EkqUZ;;A0EzqUQ;EAOI,qBAAA;A1EsqUZ;;A0E7qUQ;EAOI,2BAAA;A1E0qUZ;;A0EjrUQ;EAOI,0BAAA;A1E8qUZ;;A0ErrUQ;EAOI,wBAAA;A1EkrUZ;;A0EzrUQ;EAOI,0BAAA;A1EsrUZ;;A0E7rUQ;EAOI,wBAAA;A1E0rUZ;;A0EjsUQ;EAOI,2BAAA;EAAA,0BAAA;A1E+rUZ;;A0EtsUQ;EAOI,iCAAA;EAAA,gCAAA;A1EosUZ;;A0E3sUQ;EAOI,gCAAA;EAAA,+BAAA;A1EysUZ;;A0EhtUQ;EAOI,8BAAA;EAAA,6BAAA;A1E8sUZ;;A0ErtUQ;EAOI,gCAAA;EAAA,+BAAA;A1EmtUZ;;A0E1tUQ;EAOI,8BAAA;EAAA,6BAAA;A1EwtUZ;;A0E/tUQ;EAOI,yBAAA;EAAA,4BAAA;A1E6tUZ;;A0EpuUQ;EAOI,+BAAA;EAAA,kCAAA;A1EkuUZ;;A0EzuUQ;EAOI,8BAAA;EAAA,iCAAA;A1EuuUZ;;A0E9uUQ;EAOI,4BAAA;EAAA,+BAAA;A1E4uUZ;;A0EnvUQ;EAOI,8BAAA;EAAA,iCAAA;A1EivUZ;;A0ExvUQ;EAOI,4BAAA;EAAA,+BAAA;A1EsvUZ;;A0E7vUQ;EAOI,yBAAA;A1E0vUZ;;A0EjwUQ;EAOI,+BAAA;A1E8vUZ;;A0ErwUQ;EAOI,8BAAA;A1EkwUZ;;A0EzwUQ;EAOI,4BAAA;A1EswUZ;;A0E7wUQ;EAOI,8BAAA;A1E0wUZ;;A0EjxUQ;EAOI,4BAAA;A1E8wUZ;;A0ErxUQ;EAOI,2BAAA;A1EkxUZ;;A0EzxUQ;EAOI,iCAAA;A1EsxUZ;;A0E7xUQ;EAOI,gCAAA;A1E0xUZ;;A0EjyUQ;EAOI,8BAAA;A1E8xUZ;;A0EryUQ;EAOI,gCAAA;A1EkyUZ;;A0EzyUQ;EAOI,8BAAA;A1EsyUZ;;A0E7yUQ;EAOI,4BAAA;A1E0yUZ;;A0EjzUQ;EAOI,kCAAA;A1E8yUZ;;A0ErzUQ;EAOI,iCAAA;A1EkzUZ;;A0EzzUQ;EAOI,+BAAA;A1EszUZ;;A0E7zUQ;EAOI,iCAAA;A1E0zUZ;;A0Ej0UQ;EAOI,+BAAA;A1E8zUZ;;A0Er0UQ;EAOI,0BAAA;A1Ek0UZ;;A0Ez0UQ;EAOI,gCAAA;A1Es0UZ;;A0E70UQ;EAOI,+BAAA;A1E00UZ;;A0Ej1UQ;EAOI,6BAAA;A1E80UZ;;A0Er1UQ;EAOI,+BAAA;A1Ek1UZ;;A0Ez1UQ;EAOI,6BAAA;A1Es1UZ;;A0E71UQ;EAOI,iBAAA;A1E01UZ;;A0Ej2UQ;EAOI,uBAAA;A1E81UZ;;A0Er2UQ;EAOI,sBAAA;A1Ek2UZ;;A0Ez2UQ;EAOI,oBAAA;A1Es2UZ;;A0E72UQ;EAOI,sBAAA;A1E02UZ;;A0Ej3UQ;EAOI,oBAAA;A1E82UZ;;A0Er3UQ;EAOI,qBAAA;A1Ek3UZ;;A0Ez3UQ;EAOI,2BAAA;A1Es3UZ;;A0E73UQ;EAOI,0BAAA;A1E03UZ;;A0Ej4UQ;EAOI,wBAAA;A1E83UZ;;A0Er4UQ;EAOI,0BAAA;A1Ek4UZ;;A0Ez4UQ;EAOI,wBAAA;A1Es4UZ;;A0E74UQ;EAOI,wBAAA;A1E04UZ;;A0Ej5UQ;EAOI,8BAAA;A1E84UZ;;A0Er5UQ;EAOI,6BAAA;A1Ek5UZ;;A0Ez5UQ;EAOI,2BAAA;A1Es5UZ;;A0E75UQ;EAOI,6BAAA;A1E05UZ;;A0Ej6UQ;EAOI,2BAAA;A1E85UZ;;A0Er6UQ;EAOI,gDAAA;A1Ek6UZ;;A0Ez6UQ;EAOI,gDAAA;A1Es6UZ;;A0E76UQ;EAOI,0CAAA;A1E06UZ;;A0Ej7UQ;EAOI,kDAAA;A1E86UZ;;A0Er7UQ;EAOI,gDAAA;A1Ek7UZ;;A0Ez7UQ;EAOI,gCAAA;A1Es7UZ;;A0E77UQ;EAOI,8BAAA;A1E07UZ;;A0Ej8UQ;EAOI,6BAAA;A1E87UZ;;A0Er8UQ;EAOI,6BAAA;A1Ek8UZ;;A0Ez8UQ;EAOI,+BAAA;A1Es8UZ;;A0E78UQ;EAOI,2BAAA;A1E08UZ;;A0Ej9UQ;EAOI,2BAAA;A1E88UZ;;A0Er9UQ;EAOI,2BAAA;A1Ek9UZ;;A0Ez9UQ;EAOI,2BAAA;A1Es9UZ;;A0E79UQ;EAOI,2BAAA;A1E09UZ;;A0Ej+UQ;EAOI,8BAAA;A1E89UZ;;A0Er+UQ;EAOI,yBAAA;A1Ek+UZ;;A0Ez+UQ;EAOI,4BAAA;A1Es+UZ;;A0E7+UQ;EAOI,2BAAA;A1E0+UZ;;A0Ej/UQ;EAOI,yBAAA;A1E8+UZ;;A0Er/UQ;EAOI,2BAAA;A1Ek/UZ;;A0Ez/UQ;EAOI,4BAAA;A1Es/UZ;;A0E7/UQ;EAOI,6BAAA;A1E0/UZ;;A0EjgVQ;EAOI,gCAAA;A1E8/UZ;;A0ErgVQ;EAOI,qCAAA;A1EkgVZ;;A0EzgVQ;EAOI,wCAAA;A1EsgVZ;;A0E7gVQ;EAOI,oCAAA;A1E0gVZ;;A0EjhVQ;EAOI,oCAAA;A1E8gVZ;;A0ErhVQ;EAOI,qCAAA;A1EkhVZ;;A0EzhVQ;EAOI,8BAAA;A1EshVZ;;A0E7hVQ;EAOI,8BAAA;A1E0hVZ;;A0E/iVQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A1EgiVZ;;A0E7gVQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A1EsiVZ;;A0E7iVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1E2iVZ;;A0EljVQ;EAIQ,oBAAA;EAGJ,yEAAA;A1EgjVZ;;A0EvjVQ;EAIQ,oBAAA;EAGJ,qEAAA;A1EqjVZ;;A0E5jVQ;EAIQ,oBAAA;EAGJ,uEAAA;A1E0jVZ;;A0EjkVQ;EAIQ,oBAAA;EAGJ,qEAAA;A1E+jVZ;;A0EtkVQ;EAIQ,oBAAA;EAGJ,oEAAA;A1EokVZ;;A0E3kVQ;EAIQ,oBAAA;EAGJ,qEAAA;A1EykVZ;;A0EhlVQ;EAIQ,oBAAA;EAGJ,qEAAA;A1E8kVZ;;A0ErlVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EmlVZ;;A0E1lVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EwlVZ;;A0E/lVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1E6lVZ;;A0EpmVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1EkmVZ;;A0EzmVQ;EAIQ,oBAAA;EAGJ,oEAAA;A1EumVZ;;A0E9mVQ;EAIQ,oBAAA;EAGJ,oEAAA;A1E4mVZ;;A0EnnVQ;EAIQ,oBAAA;EAGJ,iEAAA;A1EinVZ;;A0ExnVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EsnVZ;;A0E7nVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1E2nVZ;;A0EloVQ;EAIQ,oBAAA;EAGJ,oEAAA;A1EgoVZ;;A0EvoVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EqoVZ;;A0E5oVQ;EAIQ,oBAAA;EAGJ,2CAAA;A1E0oVZ;;A0EjpVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1E+oVZ;;A0EtpVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EopVZ;;A0E3pVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EypVZ;;A0EhqVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1E8pVZ;;A0ErqVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EmqVZ;;A0E1qVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EwqVZ;;A0E/qVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1E6qVZ;;A0EprVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EkrVZ;;A0EzrVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EurVZ;;A0E9rVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1E4rVZ;;A0EnsVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EisVZ;;A0ExsVQ;EAIQ,oBAAA;EAGJ,wEAAA;A1EssVZ;;A0E7sVQ;EAIQ,oBAAA;EAGJ,oCAAA;A1E2sVZ;;A0EltVQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EgtVZ;;A0EvtVQ;EAIQ,oBAAA;EAGJ,2CAAA;A1EqtVZ;;A0E5tVQ;EAIQ,oBAAA;EAGJ,0CAAA;A1E0tVZ;;A0EjuVQ;EAIQ,oBAAA;EAGJ,0CAAA;A1E+tVZ;;A0EtuVQ;EAIQ,oBAAA;EAGJ,yBAAA;A1EouVZ;;A0ErvVQ;EACE,uBAAA;A1EwvVV;;A0EzvVQ;EACE,sBAAA;A1E4vVV;;A0E7vVQ;EACE,uBAAA;A1EgwVV;;A0EjwVQ;EACE,oBAAA;A1EowVV;;A0E3vVQ;EAOI,iDAAA;A1EwvVZ;;A0E/vVQ;EAOI,mDAAA;A1E4vVZ;;A0EnwVQ;EAOI,iDAAA;A1EgwVZ;;A0EvwVQ;EAOI,8CAAA;A1EowVZ;;A0E3wVQ;EAOI,iDAAA;A1EwwVZ;;A0E/wVQ;EAOI,gDAAA;A1E4wVZ;;A0EnxVQ;EAOI,+CAAA;A1EgxVZ;;A0EvxVQ;EAOI,8CAAA;A1EoxVZ;;A0EryVQ;EACE,sBAAA;A1EwyVV;;A0EpyVU;EACE,sBAAA;A1EuyVZ;;A0E7yVQ;EACE,uBAAA;A1EgzVV;;A0E5yVU;EACE,uBAAA;A1E+yVZ;;A0ErzVQ;EACE,sBAAA;A1EwzVV;;A0EpzVU;EACE,sBAAA;A1EuzVZ;;A0E7zVQ;EACE,uBAAA;A1Eg0VV;;A0E5zVU;EACE,uBAAA;A1E+zVZ;;A0Er0VQ;EACE,oBAAA;A1Ew0VV;;A0Ep0VU;EACE,oBAAA;A1Eu0VZ;;A0En0VQ;EAOI,yCAAA;A1Eg0VZ;;A0E3zVU;EAOI,yCAAA;A1EwzVd;;A0E30VQ;EAOI,wCAAA;A1Ew0VZ;;A0En0VU;EAOI,wCAAA;A1Eg0Vd;;A0En1VQ;EAOI,yCAAA;A1Eg1VZ;;A0E30VU;EAOI,yCAAA;A1Ew0Vd;;A0E31VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Ey1VZ;;A0Eh2VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1E81VZ;;A0Er2VQ;EAIQ,8BAAA;EAGJ,mGAAA;A1Em2VZ;;A0E12VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Ew2VZ;;A0E/2VQ;EAIQ,8BAAA;EAGJ,iGAAA;A1E62VZ;;A0Ep3VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Ek3VZ;;A0Ez3VQ;EAIQ,8BAAA;EAGJ,8FAAA;A1Eu3VZ;;A0E93VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1E43VZ;;A0En4VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Ei4VZ;;A0Ex4VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Es4VZ;;A0E74VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1E24VZ;;A0El5VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1Eg5VZ;;A0Ev5VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1Eq5VZ;;A0E55VQ;EAIQ,8BAAA;EAGJ,8FAAA;A1E05VZ;;A0Ej6VQ;EAIQ,8BAAA;EAGJ,8FAAA;A1E+5VZ;;A0Et6VQ;EAIQ,8BAAA;EAGJ,2FAAA;A1Eo6VZ;;A0E36VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Ey6VZ;;A0Eh7VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1E86VZ;;A0Er7VQ;EAIQ,8BAAA;EAGJ,8FAAA;A1Em7VZ;;A0E17VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Ew7VZ;;A0E/7VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1E67VZ;;A0Ep8VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1Ek8VZ;;A0Ez8VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Eu8VZ;;A0E98VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1E48VZ;;A0En9VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Ei9VZ;;A0Ex9VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Es9VZ;;A0E79VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1E29VZ;;A0El+VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Eg+VZ;;A0Ev+VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Eq+VZ;;A0E5+VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1E0+VZ;;A0Ej/VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1E++VZ;;A0Et/VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Eo/VZ;;A0E3/VQ;EAIQ,8BAAA;EAGJ,qGAAA;A1Ey/VZ;;A0E1gWQ;EACE,8BAAA;A1E6gWV;;A0EzgWU;EACE,8BAAA;A1E4gWZ;;A0ElhWQ;EACE,gCAAA;A1EqhWV;;A0EjhWU;EACE,gCAAA;A1EohWZ;;A0E1hWQ;EACE,iCAAA;A1E6hWV;;A0EzhWU;EACE,iCAAA;A1E4hWZ;;A0EliWQ;EACE,gCAAA;A1EqiWV;;A0EjiWU;EACE,gCAAA;A1EoiWZ;;A0E1iWQ;EACE,iCAAA;A1E6iWV;;A0EziWU;EACE,iCAAA;A1E4iWZ;;A0EljWQ;EACE,8BAAA;A1EqjWV;;A0EjjWU;EACE,8BAAA;A1EojWZ;;A0EhjWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E8iWZ;;A0ErjWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1EmjWZ;;A0E1jWQ;EAIQ,kBAAA;EAGJ,kFAAA;A1EwjWZ;;A0E/jWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E6jWZ;;A0EpkWQ;EAIQ,kBAAA;EAGJ,gFAAA;A1EkkWZ;;A0EzkWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1EukWZ;;A0E9kWQ;EAIQ,kBAAA;EAGJ,6EAAA;A1E4kWZ;;A0EnlWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1EilWZ;;A0ExlWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1EslWZ;;A0E7lWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1E2lWZ;;A0ElmWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1EgmWZ;;A0EvmWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1EqmWZ;;A0E5mWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1E0mWZ;;A0EjnWQ;EAIQ,kBAAA;EAGJ,6EAAA;A1E+mWZ;;A0EtnWQ;EAIQ,kBAAA;EAGJ,6EAAA;A1EonWZ;;A0E3nWQ;EAIQ,kBAAA;EAGJ,0EAAA;A1EynWZ;;A0EhoWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1E8nWZ;;A0EroWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1EmoWZ;;A0E1oWQ;EAIQ,kBAAA;EAGJ,6EAAA;A1EwoWZ;;A0E/oWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1E6oWZ;;A0EppWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1EkpWZ;;A0EzpWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1EupWZ;;A0E9pWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1E4pWZ;;A0EnqWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EiqWZ;;A0ExqWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EsqWZ;;A0E7qWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1E2qWZ;;A0ElrWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EgrWZ;;A0EvrWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EqrWZ;;A0E5rWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1E0rWZ;;A0EjsWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1E+rWZ;;A0EtsWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EosWZ;;A0E3sWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EysWZ;;A0EhtWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E8sWZ;;A0ErtWQ;EAIQ,kBAAA;EAGJ,wCAAA;A1EmtWZ;;A0E1tWQ;EAIQ,kBAAA;EAGJ,mFAAA;A1EwtWZ;;A0E/tWQ;EAIQ,kBAAA;EAGJ,kFAAA;A1E6tWZ;;A0E9uWQ;EACE,oBAAA;A1EivWV;;A0ElvWQ;EACE,qBAAA;A1EqvWV;;A0EtvWQ;EACE,oBAAA;A1EyvWV;;A0E1vWQ;EACE,qBAAA;A1E6vWV;;A0E9vWQ;EACE,kBAAA;A1EiwWV;;A0ExvWQ;EAOI,wDAAA;A1EqvWZ;;A0E5vWQ;EAOI,0DAAA;A1EyvWZ;;A0EhwWQ;EAOI,wDAAA;A1E6vWZ;;A0EpwWQ;EAOI,qDAAA;A1EiwWZ;;A0ExwWQ;EAOI,wDAAA;A1EqwWZ;;A0E5wWQ;EAOI,uDAAA;A1EywWZ;;A0EhxWQ;EAOI,sDAAA;A1E6wWZ;;A0EpxWQ;EAOI,qDAAA;A1EixWZ;;A0ExxWQ;EAOI,+CAAA;A1EqxWZ;;A0E5xWQ;EAOI,mCAAA;UAAA,2BAAA;A1EyxWZ;;A0EhyWQ;EAOI,oCAAA;UAAA,4BAAA;A1E6xWZ;;A0EpyWQ;EAOI,oCAAA;UAAA,4BAAA;A1EiyWZ;;A0ExyWQ;EAOI,+BAAA;A1EqyWZ;;A0E5yWQ;EAOI,+BAAA;A1EyyWZ;;A0EhzWQ;EAOI,iDAAA;A1E6yWZ;;A0EpzWQ;EAOI,2BAAA;A1EizWZ;;A0ExzWQ;EAOI,oDAAA;A1EqzWZ;;A0E5zWQ;EAOI,iDAAA;A1EyzWZ;;A0Eh0WQ;EAOI,oDAAA;A1E6zWZ;;A0Ep0WQ;EAOI,oDAAA;A1Ei0WZ;;A0Ex0WQ;EAOI,qDAAA;A1Eq0WZ;;A0E50WQ;EAOI,6BAAA;A1Ey0WZ;;A0Eh1WQ;EAOI,sDAAA;A1E60WZ;;A0Ep1WQ;EAOI,0DAAA;EAAA,2DAAA;A1Ek1WZ;;A0Ez1WQ;EAOI,oCAAA;EAAA,qCAAA;A1Eu1WZ;;A0E91WQ;EAOI,6DAAA;EAAA,8DAAA;A1E41WZ;;A0En2WQ;EAOI,0DAAA;EAAA,2DAAA;A1Ei2WZ;;A0Ex2WQ;EAOI,6DAAA;EAAA,8DAAA;A1Es2WZ;;A0E72WQ;EAOI,6DAAA;EAAA,8DAAA;A1E22WZ;;A0El3WQ;EAOI,8DAAA;EAAA,+DAAA;A1Eg3WZ;;A0Ev3WQ;EAOI,sCAAA;EAAA,uCAAA;A1Eq3WZ;;A0E53WQ;EAOI,+DAAA;EAAA,gEAAA;A1E03WZ;;A0Ej4WQ;EAOI,2DAAA;EAAA,8DAAA;A1E+3WZ;;A0Et4WQ;EAOI,qCAAA;EAAA,wCAAA;A1Eo4WZ;;A0E34WQ;EAOI,8DAAA;EAAA,iEAAA;A1Ey4WZ;;A0Eh5WQ;EAOI,2DAAA;EAAA,8DAAA;A1E84WZ;;A0Er5WQ;EAOI,8DAAA;EAAA,iEAAA;A1Em5WZ;;A0E15WQ;EAOI,8DAAA;EAAA,iEAAA;A1Ew5WZ;;A0E/5WQ;EAOI,+DAAA;EAAA,kEAAA;A1E65WZ;;A0Ep6WQ;EAOI,uCAAA;EAAA,0CAAA;A1Ek6WZ;;A0Ez6WQ;EAOI,gEAAA;EAAA,mEAAA;A1Eu6WZ;;A0E96WQ;EAOI,8DAAA;EAAA,6DAAA;A1E46WZ;;A0En7WQ;EAOI,wCAAA;EAAA,uCAAA;A1Ei7WZ;;A0Ex7WQ;EAOI,iEAAA;EAAA,gEAAA;A1Es7WZ;;A0E77WQ;EAOI,8DAAA;EAAA,6DAAA;A1E27WZ;;A0El8WQ;EAOI,iEAAA;EAAA,gEAAA;A1Eg8WZ;;A0Ev8WQ;EAOI,iEAAA;EAAA,gEAAA;A1Eq8WZ;;A0E58WQ;EAOI,kEAAA;EAAA,iEAAA;A1E08WZ;;A0Ej9WQ;EAOI,0CAAA;EAAA,yCAAA;A1E+8WZ;;A0Et9WQ;EAOI,mEAAA;EAAA,kEAAA;A1Eo9WZ;;A0E39WQ;EAOI,6DAAA;EAAA,0DAAA;A1Ey9WZ;;A0Eh+WQ;EAOI,uCAAA;EAAA,oCAAA;A1E89WZ;;A0Er+WQ;EAOI,gEAAA;EAAA,6DAAA;A1Em+WZ;;A0E1+WQ;EAOI,6DAAA;EAAA,0DAAA;A1Ew+WZ;;A0E/+WQ;EAOI,gEAAA;EAAA,6DAAA;A1E6+WZ;;A0Ep/WQ;EAOI,gEAAA;EAAA,6DAAA;A1Ek/WZ;;A0Ez/WQ;EAOI,iEAAA;EAAA,8DAAA;A1Eu/WZ;;A0E9/WQ;EAOI,yCAAA;EAAA,sCAAA;A1E4/WZ;;A0EngXQ;EAOI,kEAAA;EAAA,+DAAA;A1EigXZ;;A0ExgXQ;EAOI,8BAAA;A1EqgXZ;;A0E5gXQ;EAOI,6BAAA;A1EygXZ;;A0EhhXQ;EAOI,sBAAA;A1E6gXZ;;A0EphXQ;EAOI,qBAAA;A1EihXZ;;A0ExhXQ;EAOI,qBAAA;A1EqhXZ;;A0E5hXQ;EAOI,qBAAA;A1EyhXZ;;A0EhiXQ;EAOI,qBAAA;A1E6hXZ;;AgBviXI;E0DGI;IAOI,sBAAA;E1EkiXV;E0EziXM;IAOI,uBAAA;E1EqiXV;E0E5iXM;IAOI,sBAAA;E1EwiXV;E0E/iXM;IAOI,8BAAA;E1E2iXV;E0EljXM;IAOI,4BAAA;E1E8iXV;E0ErjXM;IAOI,2BAAA;E1EijXV;E0ExjXM;IAOI,iCAAA;E1EojXV;E0E3jXM;IAOI,2BAAA;E1EujXV;E0E9jXM;IAOI,0BAAA;E1E0jXV;E0EjkXM;IAOI,gCAAA;E1E6jXV;E0EpkXM;IAOI,yBAAA;E1EgkXV;E0EvkXM;IAOI,wBAAA;E1EmkXV;E0E1kXM;IAOI,+BAAA;E1EskXV;E0E7kXM;IAOI,yBAAA;E1EykXV;E0EhlXM;IAOI,6BAAA;E1E4kXV;E0EnlXM;IAOI,8BAAA;E1E+kXV;E0EtlXM;IAOI,wBAAA;E1EklXV;E0EzlXM;IAOI,+BAAA;E1EqlXV;E0E5lXM;IAOI,wBAAA;E1EwlXV;E0E/lXM;IAOI,yBAAA;E1E2lXV;E0ElmXM;IAOI,8BAAA;E1E8lXV;E0ErmXM;IAOI,iCAAA;E1EimXV;E0ExmXM;IAOI,sCAAA;E1EomXV;E0E3mXM;IAOI,yCAAA;E1EumXV;E0E9mXM;IAOI,uBAAA;E1E0mXV;E0EjnXM;IAOI,uBAAA;E1E6mXV;E0EpnXM;IAOI,yBAAA;E1EgnXV;E0EvnXM;IAOI,yBAAA;E1EmnXV;E0E1nXM;IAOI,0BAAA;E1EsnXV;E0E7nXM;IAOI,4BAAA;E1EynXV;E0EhoXM;IAOI,kCAAA;E1E4nXV;E0EnoXM;IAOI,sCAAA;E1E+nXV;E0EtoXM;IAOI,oCAAA;E1EkoXV;E0EzoXM;IAOI,kCAAA;E1EqoXV;E0E5oXM;IAOI,yCAAA;E1EwoXV;E0E/oXM;IAOI,wCAAA;E1E2oXV;E0ElpXM;IAOI,wCAAA;E1E8oXV;E0ErpXM;IAOI,kCAAA;E1EipXV;E0ExpXM;IAOI,gCAAA;E1EopXV;E0E3pXM;IAOI,8BAAA;E1EupXV;E0E9pXM;IAOI,gCAAA;E1E0pXV;E0EjqXM;IAOI,+BAAA;E1E6pXV;E0EpqXM;IAOI,oCAAA;E1EgqXV;E0EvqXM;IAOI,kCAAA;E1EmqXV;E0E1qXM;IAOI,gCAAA;E1EsqXV;E0E7qXM;IAOI,uCAAA;E1EyqXV;E0EhrXM;IAOI,sCAAA;E1E4qXV;E0EnrXM;IAOI,iCAAA;E1E+qXV;E0EtrXM;IAOI,2BAAA;E1EkrXV;E0EzrXM;IAOI,iCAAA;E1EqrXV;E0E5rXM;IAOI,+BAAA;E1EwrXV;E0E/rXM;IAOI,6BAAA;E1E2rXV;E0ElsXM;IAOI,+BAAA;E1E8rXV;E0ErsXM;IAOI,8BAAA;E1EisXV;E0ExsXM;IAOI,oBAAA;E1EosXV;E0E3sXM;IAOI,mBAAA;E1EusXV;E0E9sXM;IAOI,mBAAA;E1E0sXV;E0EjtXM;IAOI,mBAAA;E1E6sXV;E0EptXM;IAOI,mBAAA;E1EgtXV;E0EvtXM;IAOI,mBAAA;E1EmtXV;E0E1tXM;IAOI,mBAAA;E1EstXV;E0E7tXM;IAOI,mBAAA;E1EytXV;E0EhuXM;IAOI,oBAAA;E1E4tXV;E0EnuXM;IAOI,0BAAA;E1E+tXV;E0EtuXM;IAOI,yBAAA;E1EkuXV;E0EzuXM;IAOI,uBAAA;E1EquXV;E0E5uXM;IAOI,yBAAA;E1EwuXV;E0E/uXM;IAOI,uBAAA;E1E2uXV;E0ElvXM;IAOI,uBAAA;E1E8uXV;E0ErvXM;IAOI,0BAAA;IAAA,yBAAA;E1EkvXV;E0EzvXM;IAOI,gCAAA;IAAA,+BAAA;E1EsvXV;E0E7vXM;IAOI,+BAAA;IAAA,8BAAA;E1E0vXV;E0EjwXM;IAOI,6BAAA;IAAA,4BAAA;E1E8vXV;E0ErwXM;IAOI,+BAAA;IAAA,8BAAA;E1EkwXV;E0EzwXM;IAOI,6BAAA;IAAA,4BAAA;E1EswXV;E0E7wXM;IAOI,6BAAA;IAAA,4BAAA;E1E0wXV;E0EjxXM;IAOI,wBAAA;IAAA,2BAAA;E1E8wXV;E0ErxXM;IAOI,8BAAA;IAAA,iCAAA;E1EkxXV;E0EzxXM;IAOI,6BAAA;IAAA,gCAAA;E1EsxXV;E0E7xXM;IAOI,2BAAA;IAAA,8BAAA;E1E0xXV;E0EjyXM;IAOI,6BAAA;IAAA,gCAAA;E1E8xXV;E0EryXM;IAOI,2BAAA;IAAA,8BAAA;E1EkyXV;E0EzyXM;IAOI,2BAAA;IAAA,8BAAA;E1EsyXV;E0E7yXM;IAOI,wBAAA;E1EyyXV;E0EhzXM;IAOI,8BAAA;E1E4yXV;E0EnzXM;IAOI,6BAAA;E1E+yXV;E0EtzXM;IAOI,2BAAA;E1EkzXV;E0EzzXM;IAOI,6BAAA;E1EqzXV;E0E5zXM;IAOI,2BAAA;E1EwzXV;E0E/zXM;IAOI,2BAAA;E1E2zXV;E0El0XM;IAOI,0BAAA;E1E8zXV;E0Er0XM;IAOI,gCAAA;E1Ei0XV;E0Ex0XM;IAOI,+BAAA;E1Eo0XV;E0E30XM;IAOI,6BAAA;E1Eu0XV;E0E90XM;IAOI,+BAAA;E1E00XV;E0Ej1XM;IAOI,6BAAA;E1E60XV;E0Ep1XM;IAOI,6BAAA;E1Eg1XV;E0Ev1XM;IAOI,2BAAA;E1Em1XV;E0E11XM;IAOI,iCAAA;E1Es1XV;E0E71XM;IAOI,gCAAA;E1Ey1XV;E0Eh2XM;IAOI,8BAAA;E1E41XV;E0En2XM;IAOI,gCAAA;E1E+1XV;E0Et2XM;IAOI,8BAAA;E1Ek2XV;E0Ez2XM;IAOI,8BAAA;E1Eq2XV;E0E52XM;IAOI,yBAAA;E1Ew2XV;E0E/2XM;IAOI,+BAAA;E1E22XV;E0El3XM;IAOI,8BAAA;E1E82XV;E0Er3XM;IAOI,4BAAA;E1Ei3XV;E0Ex3XM;IAOI,8BAAA;E1Eo3XV;E0E33XM;IAOI,4BAAA;E1Eu3XV;E0E93XM;IAOI,4BAAA;E1E03XV;E0Ej4XM;IAOI,2BAAA;E1E63XV;E0Ep4XM;IAOI,0BAAA;E1Eg4XV;E0Ev4XM;IAOI,wBAAA;E1Em4XV;E0E14XM;IAOI,0BAAA;E1Es4XV;E0E74XM;IAOI,wBAAA;E1Ey4XV;E0Eh5XM;IAOI,iCAAA;IAAA,gCAAA;E1E64XV;E0Ep5XM;IAOI,gCAAA;IAAA,+BAAA;E1Ei5XV;E0Ex5XM;IAOI,8BAAA;IAAA,6BAAA;E1Eq5XV;E0E55XM;IAOI,gCAAA;IAAA,+BAAA;E1Ey5XV;E0Eh6XM;IAOI,8BAAA;IAAA,6BAAA;E1E65XV;E0Ep6XM;IAOI,+BAAA;IAAA,kCAAA;E1Ei6XV;E0Ex6XM;IAOI,8BAAA;IAAA,iCAAA;E1Eq6XV;E0E56XM;IAOI,4BAAA;IAAA,+BAAA;E1Ey6XV;E0Eh7XM;IAOI,8BAAA;IAAA,iCAAA;E1E66XV;E0Ep7XM;IAOI,4BAAA;IAAA,+BAAA;E1Ei7XV;E0Ex7XM;IAOI,+BAAA;E1Eo7XV;E0E37XM;IAOI,8BAAA;E1Eu7XV;E0E97XM;IAOI,4BAAA;E1E07XV;E0Ej8XM;IAOI,8BAAA;E1E67XV;E0Ep8XM;IAOI,4BAAA;E1Eg8XV;E0Ev8XM;IAOI,iCAAA;E1Em8XV;E0E18XM;IAOI,gCAAA;E1Es8XV;E0E78XM;IAOI,8BAAA;E1Ey8XV;E0Eh9XM;IAOI,gCAAA;E1E48XV;E0En9XM;IAOI,8BAAA;E1E+8XV;E0Et9XM;IAOI,kCAAA;E1Ek9XV;E0Ez9XM;IAOI,iCAAA;E1Eq9XV;E0E59XM;IAOI,+BAAA;E1Ew9XV;E0E/9XM;IAOI,iCAAA;E1E29XV;E0El+XM;IAOI,+BAAA;E1E89XV;E0Er+XM;IAOI,gCAAA;E1Ei+XV;E0Ex+XM;IAOI,+BAAA;E1Eo+XV;E0E3+XM;IAOI,6BAAA;E1Eu+XV;E0E9+XM;IAOI,+BAAA;E1E0+XV;E0Ej/XM;IAOI,6BAAA;E1E6+XV;E0Ep/XM;IAOI,qBAAA;E1Eg/XV;E0Ev/XM;IAOI,2BAAA;E1Em/XV;E0E1/XM;IAOI,0BAAA;E1Es/XV;E0E7/XM;IAOI,wBAAA;E1Ey/XV;E0EhgYM;IAOI,0BAAA;E1E4/XV;E0EngYM;IAOI,wBAAA;E1E+/XV;E0EtgYM;IAOI,2BAAA;IAAA,0BAAA;E1EmgYV;E0E1gYM;IAOI,iCAAA;IAAA,gCAAA;E1EugYV;E0E9gYM;IAOI,gCAAA;IAAA,+BAAA;E1E2gYV;E0ElhYM;IAOI,8BAAA;IAAA,6BAAA;E1E+gYV;E0EthYM;IAOI,gCAAA;IAAA,+BAAA;E1EmhYV;E0E1hYM;IAOI,8BAAA;IAAA,6BAAA;E1EuhYV;E0E9hYM;IAOI,yBAAA;IAAA,4BAAA;E1E2hYV;E0EliYM;IAOI,+BAAA;IAAA,kCAAA;E1E+hYV;E0EtiYM;IAOI,8BAAA;IAAA,iCAAA;E1EmiYV;E0E1iYM;IAOI,4BAAA;IAAA,+BAAA;E1EuiYV;E0E9iYM;IAOI,8BAAA;IAAA,iCAAA;E1E2iYV;E0EljYM;IAOI,4BAAA;IAAA,+BAAA;E1E+iYV;E0EtjYM;IAOI,yBAAA;E1EkjYV;E0EzjYM;IAOI,+BAAA;E1EqjYV;E0E5jYM;IAOI,8BAAA;E1EwjYV;E0E/jYM;IAOI,4BAAA;E1E2jYV;E0ElkYM;IAOI,8BAAA;E1E8jYV;E0ErkYM;IAOI,4BAAA;E1EikYV;E0ExkYM;IAOI,2BAAA;E1EokYV;E0E3kYM;IAOI,iCAAA;E1EukYV;E0E9kYM;IAOI,gCAAA;E1E0kYV;E0EjlYM;IAOI,8BAAA;E1E6kYV;E0EplYM;IAOI,gCAAA;E1EglYV;E0EvlYM;IAOI,8BAAA;E1EmlYV;E0E1lYM;IAOI,4BAAA;E1EslYV;E0E7lYM;IAOI,kCAAA;E1EylYV;E0EhmYM;IAOI,iCAAA;E1E4lYV;E0EnmYM;IAOI,+BAAA;E1E+lYV;E0EtmYM;IAOI,iCAAA;E1EkmYV;E0EzmYM;IAOI,+BAAA;E1EqmYV;E0E5mYM;IAOI,0BAAA;E1EwmYV;E0E/mYM;IAOI,gCAAA;E1E2mYV;E0ElnYM;IAOI,+BAAA;E1E8mYV;E0ErnYM;IAOI,6BAAA;E1EinYV;E0ExnYM;IAOI,+BAAA;E1EonYV;E0E3nYM;IAOI,6BAAA;E1EunYV;E0E9nYM;IAOI,iBAAA;E1E0nYV;E0EjoYM;IAOI,uBAAA;E1E6nYV;E0EpoYM;IAOI,sBAAA;E1EgoYV;E0EvoYM;IAOI,oBAAA;E1EmoYV;E0E1oYM;IAOI,sBAAA;E1EsoYV;E0E7oYM;IAOI,oBAAA;E1EyoYV;E0EhpYM;IAOI,qBAAA;E1E4oYV;E0EnpYM;IAOI,2BAAA;E1E+oYV;E0EtpYM;IAOI,0BAAA;E1EkpYV;E0EzpYM;IAOI,wBAAA;E1EqpYV;E0E5pYM;IAOI,0BAAA;E1EwpYV;E0E/pYM;IAOI,wBAAA;E1E2pYV;E0ElqYM;IAOI,wBAAA;E1E8pYV;E0ErqYM;IAOI,8BAAA;E1EiqYV;E0ExqYM;IAOI,6BAAA;E1EoqYV;E0E3qYM;IAOI,2BAAA;E1EuqYV;E0E9qYM;IAOI,6BAAA;E1E0qYV;E0EjrYM;IAOI,2BAAA;E1E6qYV;E0EprYM;IAOI,2BAAA;E1EgrYV;E0EvrYM;IAOI,4BAAA;E1EmrYV;E0E1rYM;IAOI,6BAAA;E1EsrYV;AACF;AgBjsYI;E0DGI;IAOI,sBAAA;E1E2rYV;E0ElsYM;IAOI,uBAAA;E1E8rYV;E0ErsYM;IAOI,sBAAA;E1EisYV;E0ExsYM;IAOI,8BAAA;E1EosYV;E0E3sYM;IAOI,4BAAA;E1EusYV;E0E9sYM;IAOI,2BAAA;E1E0sYV;E0EjtYM;IAOI,iCAAA;E1E6sYV;E0EptYM;IAOI,2BAAA;E1EgtYV;E0EvtYM;IAOI,0BAAA;E1EmtYV;E0E1tYM;IAOI,gCAAA;E1EstYV;E0E7tYM;IAOI,yBAAA;E1EytYV;E0EhuYM;IAOI,wBAAA;E1E4tYV;E0EnuYM;IAOI,+BAAA;E1E+tYV;E0EtuYM;IAOI,yBAAA;E1EkuYV;E0EzuYM;IAOI,6BAAA;E1EquYV;E0E5uYM;IAOI,8BAAA;E1EwuYV;E0E/uYM;IAOI,wBAAA;E1E2uYV;E0ElvYM;IAOI,+BAAA;E1E8uYV;E0ErvYM;IAOI,wBAAA;E1EivYV;E0ExvYM;IAOI,yBAAA;E1EovYV;E0E3vYM;IAOI,8BAAA;E1EuvYV;E0E9vYM;IAOI,iCAAA;E1E0vYV;E0EjwYM;IAOI,sCAAA;E1E6vYV;E0EpwYM;IAOI,yCAAA;E1EgwYV;E0EvwYM;IAOI,uBAAA;E1EmwYV;E0E1wYM;IAOI,uBAAA;E1EswYV;E0E7wYM;IAOI,yBAAA;E1EywYV;E0EhxYM;IAOI,yBAAA;E1E4wYV;E0EnxYM;IAOI,0BAAA;E1E+wYV;E0EtxYM;IAOI,4BAAA;E1EkxYV;E0EzxYM;IAOI,kCAAA;E1EqxYV;E0E5xYM;IAOI,sCAAA;E1EwxYV;E0E/xYM;IAOI,oCAAA;E1E2xYV;E0ElyYM;IAOI,kCAAA;E1E8xYV;E0EryYM;IAOI,yCAAA;E1EiyYV;E0ExyYM;IAOI,wCAAA;E1EoyYV;E0E3yYM;IAOI,wCAAA;E1EuyYV;E0E9yYM;IAOI,kCAAA;E1E0yYV;E0EjzYM;IAOI,gCAAA;E1E6yYV;E0EpzYM;IAOI,8BAAA;E1EgzYV;E0EvzYM;IAOI,gCAAA;E1EmzYV;E0E1zYM;IAOI,+BAAA;E1EszYV;E0E7zYM;IAOI,oCAAA;E1EyzYV;E0Eh0YM;IAOI,kCAAA;E1E4zYV;E0En0YM;IAOI,gCAAA;E1E+zYV;E0Et0YM;IAOI,uCAAA;E1Ek0YV;E0Ez0YM;IAOI,sCAAA;E1Eq0YV;E0E50YM;IAOI,iCAAA;E1Ew0YV;E0E/0YM;IAOI,2BAAA;E1E20YV;E0El1YM;IAOI,iCAAA;E1E80YV;E0Er1YM;IAOI,+BAAA;E1Ei1YV;E0Ex1YM;IAOI,6BAAA;E1Eo1YV;E0E31YM;IAOI,+BAAA;E1Eu1YV;E0E91YM;IAOI,8BAAA;E1E01YV;E0Ej2YM;IAOI,oBAAA;E1E61YV;E0Ep2YM;IAOI,mBAAA;E1Eg2YV;E0Ev2YM;IAOI,mBAAA;E1Em2YV;E0E12YM;IAOI,mBAAA;E1Es2YV;E0E72YM;IAOI,mBAAA;E1Ey2YV;E0Eh3YM;IAOI,mBAAA;E1E42YV;E0En3YM;IAOI,mBAAA;E1E+2YV;E0Et3YM;IAOI,mBAAA;E1Ek3YV;E0Ez3YM;IAOI,oBAAA;E1Eq3YV;E0E53YM;IAOI,0BAAA;E1Ew3YV;E0E/3YM;IAOI,yBAAA;E1E23YV;E0El4YM;IAOI,uBAAA;E1E83YV;E0Er4YM;IAOI,yBAAA;E1Ei4YV;E0Ex4YM;IAOI,uBAAA;E1Eo4YV;E0E34YM;IAOI,uBAAA;E1Eu4YV;E0E94YM;IAOI,0BAAA;IAAA,yBAAA;E1E24YV;E0El5YM;IAOI,gCAAA;IAAA,+BAAA;E1E+4YV;E0Et5YM;IAOI,+BAAA;IAAA,8BAAA;E1Em5YV;E0E15YM;IAOI,6BAAA;IAAA,4BAAA;E1Eu5YV;E0E95YM;IAOI,+BAAA;IAAA,8BAAA;E1E25YV;E0El6YM;IAOI,6BAAA;IAAA,4BAAA;E1E+5YV;E0Et6YM;IAOI,6BAAA;IAAA,4BAAA;E1Em6YV;E0E16YM;IAOI,wBAAA;IAAA,2BAAA;E1Eu6YV;E0E96YM;IAOI,8BAAA;IAAA,iCAAA;E1E26YV;E0El7YM;IAOI,6BAAA;IAAA,gCAAA;E1E+6YV;E0Et7YM;IAOI,2BAAA;IAAA,8BAAA;E1Em7YV;E0E17YM;IAOI,6BAAA;IAAA,gCAAA;E1Eu7YV;E0E97YM;IAOI,2BAAA;IAAA,8BAAA;E1E27YV;E0El8YM;IAOI,2BAAA;IAAA,8BAAA;E1E+7YV;E0Et8YM;IAOI,wBAAA;E1Ek8YV;E0Ez8YM;IAOI,8BAAA;E1Eq8YV;E0E58YM;IAOI,6BAAA;E1Ew8YV;E0E/8YM;IAOI,2BAAA;E1E28YV;E0El9YM;IAOI,6BAAA;E1E88YV;E0Er9YM;IAOI,2BAAA;E1Ei9YV;E0Ex9YM;IAOI,2BAAA;E1Eo9YV;E0E39YM;IAOI,0BAAA;E1Eu9YV;E0E99YM;IAOI,gCAAA;E1E09YV;E0Ej+YM;IAOI,+BAAA;E1E69YV;E0Ep+YM;IAOI,6BAAA;E1Eg+YV;E0Ev+YM;IAOI,+BAAA;E1Em+YV;E0E1+YM;IAOI,6BAAA;E1Es+YV;E0E7+YM;IAOI,6BAAA;E1Ey+YV;E0Eh/YM;IAOI,2BAAA;E1E4+YV;E0En/YM;IAOI,iCAAA;E1E++YV;E0Et/YM;IAOI,gCAAA;E1Ek/YV;E0Ez/YM;IAOI,8BAAA;E1Eq/YV;E0E5/YM;IAOI,gCAAA;E1Ew/YV;E0E//YM;IAOI,8BAAA;E1E2/YV;E0ElgZM;IAOI,8BAAA;E1E8/YV;E0ErgZM;IAOI,yBAAA;E1EigZV;E0ExgZM;IAOI,+BAAA;E1EogZV;E0E3gZM;IAOI,8BAAA;E1EugZV;E0E9gZM;IAOI,4BAAA;E1E0gZV;E0EjhZM;IAOI,8BAAA;E1E6gZV;E0EphZM;IAOI,4BAAA;E1EghZV;E0EvhZM;IAOI,4BAAA;E1EmhZV;E0E1hZM;IAOI,2BAAA;E1EshZV;E0E7hZM;IAOI,0BAAA;E1EyhZV;E0EhiZM;IAOI,wBAAA;E1E4hZV;E0EniZM;IAOI,0BAAA;E1E+hZV;E0EtiZM;IAOI,wBAAA;E1EkiZV;E0EziZM;IAOI,iCAAA;IAAA,gCAAA;E1EsiZV;E0E7iZM;IAOI,gCAAA;IAAA,+BAAA;E1E0iZV;E0EjjZM;IAOI,8BAAA;IAAA,6BAAA;E1E8iZV;E0ErjZM;IAOI,gCAAA;IAAA,+BAAA;E1EkjZV;E0EzjZM;IAOI,8BAAA;IAAA,6BAAA;E1EsjZV;E0E7jZM;IAOI,+BAAA;IAAA,kCAAA;E1E0jZV;E0EjkZM;IAOI,8BAAA;IAAA,iCAAA;E1E8jZV;E0ErkZM;IAOI,4BAAA;IAAA,+BAAA;E1EkkZV;E0EzkZM;IAOI,8BAAA;IAAA,iCAAA;E1EskZV;E0E7kZM;IAOI,4BAAA;IAAA,+BAAA;E1E0kZV;E0EjlZM;IAOI,+BAAA;E1E6kZV;E0EplZM;IAOI,8BAAA;E1EglZV;E0EvlZM;IAOI,4BAAA;E1EmlZV;E0E1lZM;IAOI,8BAAA;E1EslZV;E0E7lZM;IAOI,4BAAA;E1EylZV;E0EhmZM;IAOI,iCAAA;E1E4lZV;E0EnmZM;IAOI,gCAAA;E1E+lZV;E0EtmZM;IAOI,8BAAA;E1EkmZV;E0EzmZM;IAOI,gCAAA;E1EqmZV;E0E5mZM;IAOI,8BAAA;E1EwmZV;E0E/mZM;IAOI,kCAAA;E1E2mZV;E0ElnZM;IAOI,iCAAA;E1E8mZV;E0ErnZM;IAOI,+BAAA;E1EinZV;E0ExnZM;IAOI,iCAAA;E1EonZV;E0E3nZM;IAOI,+BAAA;E1EunZV;E0E9nZM;IAOI,gCAAA;E1E0nZV;E0EjoZM;IAOI,+BAAA;E1E6nZV;E0EpoZM;IAOI,6BAAA;E1EgoZV;E0EvoZM;IAOI,+BAAA;E1EmoZV;E0E1oZM;IAOI,6BAAA;E1EsoZV;E0E7oZM;IAOI,qBAAA;E1EyoZV;E0EhpZM;IAOI,2BAAA;E1E4oZV;E0EnpZM;IAOI,0BAAA;E1E+oZV;E0EtpZM;IAOI,wBAAA;E1EkpZV;E0EzpZM;IAOI,0BAAA;E1EqpZV;E0E5pZM;IAOI,wBAAA;E1EwpZV;E0E/pZM;IAOI,2BAAA;IAAA,0BAAA;E1E4pZV;E0EnqZM;IAOI,iCAAA;IAAA,gCAAA;E1EgqZV;E0EvqZM;IAOI,gCAAA;IAAA,+BAAA;E1EoqZV;E0E3qZM;IAOI,8BAAA;IAAA,6BAAA;E1EwqZV;E0E/qZM;IAOI,gCAAA;IAAA,+BAAA;E1E4qZV;E0EnrZM;IAOI,8BAAA;IAAA,6BAAA;E1EgrZV;E0EvrZM;IAOI,yBAAA;IAAA,4BAAA;E1EorZV;E0E3rZM;IAOI,+BAAA;IAAA,kCAAA;E1EwrZV;E0E/rZM;IAOI,8BAAA;IAAA,iCAAA;E1E4rZV;E0EnsZM;IAOI,4BAAA;IAAA,+BAAA;E1EgsZV;E0EvsZM;IAOI,8BAAA;IAAA,iCAAA;E1EosZV;E0E3sZM;IAOI,4BAAA;IAAA,+BAAA;E1EwsZV;E0E/sZM;IAOI,yBAAA;E1E2sZV;E0EltZM;IAOI,+BAAA;E1E8sZV;E0ErtZM;IAOI,8BAAA;E1EitZV;E0ExtZM;IAOI,4BAAA;E1EotZV;E0E3tZM;IAOI,8BAAA;E1EutZV;E0E9tZM;IAOI,4BAAA;E1E0tZV;E0EjuZM;IAOI,2BAAA;E1E6tZV;E0EpuZM;IAOI,iCAAA;E1EguZV;E0EvuZM;IAOI,gCAAA;E1EmuZV;E0E1uZM;IAOI,8BAAA;E1EsuZV;E0E7uZM;IAOI,gCAAA;E1EyuZV;E0EhvZM;IAOI,8BAAA;E1E4uZV;E0EnvZM;IAOI,4BAAA;E1E+uZV;E0EtvZM;IAOI,kCAAA;E1EkvZV;E0EzvZM;IAOI,iCAAA;E1EqvZV;E0E5vZM;IAOI,+BAAA;E1EwvZV;E0E/vZM;IAOI,iCAAA;E1E2vZV;E0ElwZM;IAOI,+BAAA;E1E8vZV;E0ErwZM;IAOI,0BAAA;E1EiwZV;E0ExwZM;IAOI,gCAAA;E1EowZV;E0E3wZM;IAOI,+BAAA;E1EuwZV;E0E9wZM;IAOI,6BAAA;E1E0wZV;E0EjxZM;IAOI,+BAAA;E1E6wZV;E0EpxZM;IAOI,6BAAA;E1EgxZV;E0EvxZM;IAOI,iBAAA;E1EmxZV;E0E1xZM;IAOI,uBAAA;E1EsxZV;E0E7xZM;IAOI,sBAAA;E1EyxZV;E0EhyZM;IAOI,oBAAA;E1E4xZV;E0EnyZM;IAOI,sBAAA;E1E+xZV;E0EtyZM;IAOI,oBAAA;E1EkyZV;E0EzyZM;IAOI,qBAAA;E1EqyZV;E0E5yZM;IAOI,2BAAA;E1EwyZV;E0E/yZM;IAOI,0BAAA;E1E2yZV;E0ElzZM;IAOI,wBAAA;E1E8yZV;E0ErzZM;IAOI,0BAAA;E1EizZV;E0ExzZM;IAOI,wBAAA;E1EozZV;E0E3zZM;IAOI,wBAAA;E1EuzZV;E0E9zZM;IAOI,8BAAA;E1E0zZV;E0Ej0ZM;IAOI,6BAAA;E1E6zZV;E0Ep0ZM;IAOI,2BAAA;E1Eg0ZV;E0Ev0ZM;IAOI,6BAAA;E1Em0ZV;E0E10ZM;IAOI,2BAAA;E1Es0ZV;E0E70ZM;IAOI,2BAAA;E1Ey0ZV;E0Eh1ZM;IAOI,4BAAA;E1E40ZV;E0En1ZM;IAOI,6BAAA;E1E+0ZV;AACF;AgB11ZI;E0DGI;IAOI,sBAAA;E1Eo1ZV;E0E31ZM;IAOI,uBAAA;E1Eu1ZV;E0E91ZM;IAOI,sBAAA;E1E01ZV;E0Ej2ZM;IAOI,8BAAA;E1E61ZV;E0Ep2ZM;IAOI,4BAAA;E1Eg2ZV;E0Ev2ZM;IAOI,2BAAA;E1Em2ZV;E0E12ZM;IAOI,iCAAA;E1Es2ZV;E0E72ZM;IAOI,2BAAA;E1Ey2ZV;E0Eh3ZM;IAOI,0BAAA;E1E42ZV;E0En3ZM;IAOI,gCAAA;E1E+2ZV;E0Et3ZM;IAOI,yBAAA;E1Ek3ZV;E0Ez3ZM;IAOI,wBAAA;E1Eq3ZV;E0E53ZM;IAOI,+BAAA;E1Ew3ZV;E0E/3ZM;IAOI,yBAAA;E1E23ZV;E0El4ZM;IAOI,6BAAA;E1E83ZV;E0Er4ZM;IAOI,8BAAA;E1Ei4ZV;E0Ex4ZM;IAOI,wBAAA;E1Eo4ZV;E0E34ZM;IAOI,+BAAA;E1Eu4ZV;E0E94ZM;IAOI,wBAAA;E1E04ZV;E0Ej5ZM;IAOI,yBAAA;E1E64ZV;E0Ep5ZM;IAOI,8BAAA;E1Eg5ZV;E0Ev5ZM;IAOI,iCAAA;E1Em5ZV;E0E15ZM;IAOI,sCAAA;E1Es5ZV;E0E75ZM;IAOI,yCAAA;E1Ey5ZV;E0Eh6ZM;IAOI,uBAAA;E1E45ZV;E0En6ZM;IAOI,uBAAA;E1E+5ZV;E0Et6ZM;IAOI,yBAAA;E1Ek6ZV;E0Ez6ZM;IAOI,yBAAA;E1Eq6ZV;E0E56ZM;IAOI,0BAAA;E1Ew6ZV;E0E/6ZM;IAOI,4BAAA;E1E26ZV;E0El7ZM;IAOI,kCAAA;E1E86ZV;E0Er7ZM;IAOI,sCAAA;E1Ei7ZV;E0Ex7ZM;IAOI,oCAAA;E1Eo7ZV;E0E37ZM;IAOI,kCAAA;E1Eu7ZV;E0E97ZM;IAOI,yCAAA;E1E07ZV;E0Ej8ZM;IAOI,wCAAA;E1E67ZV;E0Ep8ZM;IAOI,wCAAA;E1Eg8ZV;E0Ev8ZM;IAOI,kCAAA;E1Em8ZV;E0E18ZM;IAOI,gCAAA;E1Es8ZV;E0E78ZM;IAOI,8BAAA;E1Ey8ZV;E0Eh9ZM;IAOI,gCAAA;E1E48ZV;E0En9ZM;IAOI,+BAAA;E1E+8ZV;E0Et9ZM;IAOI,oCAAA;E1Ek9ZV;E0Ez9ZM;IAOI,kCAAA;E1Eq9ZV;E0E59ZM;IAOI,gCAAA;E1Ew9ZV;E0E/9ZM;IAOI,uCAAA;E1E29ZV;E0El+ZM;IAOI,sCAAA;E1E89ZV;E0Er+ZM;IAOI,iCAAA;E1Ei+ZV;E0Ex+ZM;IAOI,2BAAA;E1Eo+ZV;E0E3+ZM;IAOI,iCAAA;E1Eu+ZV;E0E9+ZM;IAOI,+BAAA;E1E0+ZV;E0Ej/ZM;IAOI,6BAAA;E1E6+ZV;E0Ep/ZM;IAOI,+BAAA;E1Eg/ZV;E0Ev/ZM;IAOI,8BAAA;E1Em/ZV;E0E1/ZM;IAOI,oBAAA;E1Es/ZV;E0E7/ZM;IAOI,mBAAA;E1Ey/ZV;E0EhgaM;IAOI,mBAAA;E1E4/ZV;E0EngaM;IAOI,mBAAA;E1E+/ZV;E0EtgaM;IAOI,mBAAA;E1EkgaV;E0EzgaM;IAOI,mBAAA;E1EqgaV;E0E5gaM;IAOI,mBAAA;E1EwgaV;E0E/gaM;IAOI,mBAAA;E1E2gaV;E0ElhaM;IAOI,oBAAA;E1E8gaV;E0ErhaM;IAOI,0BAAA;E1EihaV;E0ExhaM;IAOI,yBAAA;E1EohaV;E0E3haM;IAOI,uBAAA;E1EuhaV;E0E9haM;IAOI,yBAAA;E1E0haV;E0EjiaM;IAOI,uBAAA;E1E6haV;E0EpiaM;IAOI,uBAAA;E1EgiaV;E0EviaM;IAOI,0BAAA;IAAA,yBAAA;E1EoiaV;E0E3iaM;IAOI,gCAAA;IAAA,+BAAA;E1EwiaV;E0E/iaM;IAOI,+BAAA;IAAA,8BAAA;E1E4iaV;E0EnjaM;IAOI,6BAAA;IAAA,4BAAA;E1EgjaV;E0EvjaM;IAOI,+BAAA;IAAA,8BAAA;E1EojaV;E0E3jaM;IAOI,6BAAA;IAAA,4BAAA;E1EwjaV;E0E/jaM;IAOI,6BAAA;IAAA,4BAAA;E1E4jaV;E0EnkaM;IAOI,wBAAA;IAAA,2BAAA;E1EgkaV;E0EvkaM;IAOI,8BAAA;IAAA,iCAAA;E1EokaV;E0E3kaM;IAOI,6BAAA;IAAA,gCAAA;E1EwkaV;E0E/kaM;IAOI,2BAAA;IAAA,8BAAA;E1E4kaV;E0EnlaM;IAOI,6BAAA;IAAA,gCAAA;E1EglaV;E0EvlaM;IAOI,2BAAA;IAAA,8BAAA;E1EolaV;E0E3laM;IAOI,2BAAA;IAAA,8BAAA;E1EwlaV;E0E/laM;IAOI,wBAAA;E1E2laV;E0ElmaM;IAOI,8BAAA;E1E8laV;E0ErmaM;IAOI,6BAAA;E1EimaV;E0ExmaM;IAOI,2BAAA;E1EomaV;E0E3maM;IAOI,6BAAA;E1EumaV;E0E9maM;IAOI,2BAAA;E1E0maV;E0EjnaM;IAOI,2BAAA;E1E6maV;E0EpnaM;IAOI,0BAAA;E1EgnaV;E0EvnaM;IAOI,gCAAA;E1EmnaV;E0E1naM;IAOI,+BAAA;E1EsnaV;E0E7naM;IAOI,6BAAA;E1EynaV;E0EhoaM;IAOI,+BAAA;E1E4naV;E0EnoaM;IAOI,6BAAA;E1E+naV;E0EtoaM;IAOI,6BAAA;E1EkoaV;E0EzoaM;IAOI,2BAAA;E1EqoaV;E0E5oaM;IAOI,iCAAA;E1EwoaV;E0E/oaM;IAOI,gCAAA;E1E2oaV;E0ElpaM;IAOI,8BAAA;E1E8oaV;E0ErpaM;IAOI,gCAAA;E1EipaV;E0ExpaM;IAOI,8BAAA;E1EopaV;E0E3paM;IAOI,8BAAA;E1EupaV;E0E9paM;IAOI,yBAAA;E1E0paV;E0EjqaM;IAOI,+BAAA;E1E6paV;E0EpqaM;IAOI,8BAAA;E1EgqaV;E0EvqaM;IAOI,4BAAA;E1EmqaV;E0E1qaM;IAOI,8BAAA;E1EsqaV;E0E7qaM;IAOI,4BAAA;E1EyqaV;E0EhraM;IAOI,4BAAA;E1E4qaV;E0EnraM;IAOI,2BAAA;E1E+qaV;E0EtraM;IAOI,0BAAA;E1EkraV;E0EzraM;IAOI,wBAAA;E1EqraV;E0E5raM;IAOI,0BAAA;E1EwraV;E0E/raM;IAOI,wBAAA;E1E2raV;E0ElsaM;IAOI,iCAAA;IAAA,gCAAA;E1E+raV;E0EtsaM;IAOI,gCAAA;IAAA,+BAAA;E1EmsaV;E0E1saM;IAOI,8BAAA;IAAA,6BAAA;E1EusaV;E0E9saM;IAOI,gCAAA;IAAA,+BAAA;E1E2saV;E0EltaM;IAOI,8BAAA;IAAA,6BAAA;E1E+saV;E0EttaM;IAOI,+BAAA;IAAA,kCAAA;E1EmtaV;E0E1taM;IAOI,8BAAA;IAAA,iCAAA;E1EutaV;E0E9taM;IAOI,4BAAA;IAAA,+BAAA;E1E2taV;E0EluaM;IAOI,8BAAA;IAAA,iCAAA;E1E+taV;E0EtuaM;IAOI,4BAAA;IAAA,+BAAA;E1EmuaV;E0E1uaM;IAOI,+BAAA;E1EsuaV;E0E7uaM;IAOI,8BAAA;E1EyuaV;E0EhvaM;IAOI,4BAAA;E1E4uaV;E0EnvaM;IAOI,8BAAA;E1E+uaV;E0EtvaM;IAOI,4BAAA;E1EkvaV;E0EzvaM;IAOI,iCAAA;E1EqvaV;E0E5vaM;IAOI,gCAAA;E1EwvaV;E0E/vaM;IAOI,8BAAA;E1E2vaV;E0ElwaM;IAOI,gCAAA;E1E8vaV;E0ErwaM;IAOI,8BAAA;E1EiwaV;E0ExwaM;IAOI,kCAAA;E1EowaV;E0E3waM;IAOI,iCAAA;E1EuwaV;E0E9waM;IAOI,+BAAA;E1E0waV;E0EjxaM;IAOI,iCAAA;E1E6waV;E0EpxaM;IAOI,+BAAA;E1EgxaV;E0EvxaM;IAOI,gCAAA;E1EmxaV;E0E1xaM;IAOI,+BAAA;E1EsxaV;E0E7xaM;IAOI,6BAAA;E1EyxaV;E0EhyaM;IAOI,+BAAA;E1E4xaV;E0EnyaM;IAOI,6BAAA;E1E+xaV;E0EtyaM;IAOI,qBAAA;E1EkyaV;E0EzyaM;IAOI,2BAAA;E1EqyaV;E0E5yaM;IAOI,0BAAA;E1EwyaV;E0E/yaM;IAOI,wBAAA;E1E2yaV;E0ElzaM;IAOI,0BAAA;E1E8yaV;E0ErzaM;IAOI,wBAAA;E1EizaV;E0ExzaM;IAOI,2BAAA;IAAA,0BAAA;E1EqzaV;E0E5zaM;IAOI,iCAAA;IAAA,gCAAA;E1EyzaV;E0Eh0aM;IAOI,gCAAA;IAAA,+BAAA;E1E6zaV;E0Ep0aM;IAOI,8BAAA;IAAA,6BAAA;E1Ei0aV;E0Ex0aM;IAOI,gCAAA;IAAA,+BAAA;E1Eq0aV;E0E50aM;IAOI,8BAAA;IAAA,6BAAA;E1Ey0aV;E0Eh1aM;IAOI,yBAAA;IAAA,4BAAA;E1E60aV;E0Ep1aM;IAOI,+BAAA;IAAA,kCAAA;E1Ei1aV;E0Ex1aM;IAOI,8BAAA;IAAA,iCAAA;E1Eq1aV;E0E51aM;IAOI,4BAAA;IAAA,+BAAA;E1Ey1aV;E0Eh2aM;IAOI,8BAAA;IAAA,iCAAA;E1E61aV;E0Ep2aM;IAOI,4BAAA;IAAA,+BAAA;E1Ei2aV;E0Ex2aM;IAOI,yBAAA;E1Eo2aV;E0E32aM;IAOI,+BAAA;E1Eu2aV;E0E92aM;IAOI,8BAAA;E1E02aV;E0Ej3aM;IAOI,4BAAA;E1E62aV;E0Ep3aM;IAOI,8BAAA;E1Eg3aV;E0Ev3aM;IAOI,4BAAA;E1Em3aV;E0E13aM;IAOI,2BAAA;E1Es3aV;E0E73aM;IAOI,iCAAA;E1Ey3aV;E0Eh4aM;IAOI,gCAAA;E1E43aV;E0En4aM;IAOI,8BAAA;E1E+3aV;E0Et4aM;IAOI,gCAAA;E1Ek4aV;E0Ez4aM;IAOI,8BAAA;E1Eq4aV;E0E54aM;IAOI,4BAAA;E1Ew4aV;E0E/4aM;IAOI,kCAAA;E1E24aV;E0El5aM;IAOI,iCAAA;E1E84aV;E0Er5aM;IAOI,+BAAA;E1Ei5aV;E0Ex5aM;IAOI,iCAAA;E1Eo5aV;E0E35aM;IAOI,+BAAA;E1Eu5aV;E0E95aM;IAOI,0BAAA;E1E05aV;E0Ej6aM;IAOI,gCAAA;E1E65aV;E0Ep6aM;IAOI,+BAAA;E1Eg6aV;E0Ev6aM;IAOI,6BAAA;E1Em6aV;E0E16aM;IAOI,+BAAA;E1Es6aV;E0E76aM;IAOI,6BAAA;E1Ey6aV;E0Eh7aM;IAOI,iBAAA;E1E46aV;E0En7aM;IAOI,uBAAA;E1E+6aV;E0Et7aM;IAOI,sBAAA;E1Ek7aV;E0Ez7aM;IAOI,oBAAA;E1Eq7aV;E0E57aM;IAOI,sBAAA;E1Ew7aV;E0E/7aM;IAOI,oBAAA;E1E27aV;E0El8aM;IAOI,qBAAA;E1E87aV;E0Er8aM;IAOI,2BAAA;E1Ei8aV;E0Ex8aM;IAOI,0BAAA;E1Eo8aV;E0E38aM;IAOI,wBAAA;E1Eu8aV;E0E98aM;IAOI,0BAAA;E1E08aV;E0Ej9aM;IAOI,wBAAA;E1E68aV;E0Ep9aM;IAOI,wBAAA;E1Eg9aV;E0Ev9aM;IAOI,8BAAA;E1Em9aV;E0E19aM;IAOI,6BAAA;E1Es9aV;E0E79aM;IAOI,2BAAA;E1Ey9aV;E0Eh+aM;IAOI,6BAAA;E1E49aV;E0En+aM;IAOI,2BAAA;E1E+9aV;E0Et+aM;IAOI,2BAAA;E1Ek+aV;E0Ez+aM;IAOI,4BAAA;E1Eq+aV;E0E5+aM;IAOI,6BAAA;E1Ew+aV;AACF;AgBn/aI;E0DGI;IAOI,sBAAA;E1E6+aV;E0Ep/aM;IAOI,uBAAA;E1Eg/aV;E0Ev/aM;IAOI,sBAAA;E1Em/aV;E0E1/aM;IAOI,8BAAA;E1Es/aV;E0E7/aM;IAOI,4BAAA;E1Ey/aV;E0EhgbM;IAOI,2BAAA;E1E4/aV;E0EngbM;IAOI,iCAAA;E1E+/aV;E0EtgbM;IAOI,2BAAA;E1EkgbV;E0EzgbM;IAOI,0BAAA;E1EqgbV;E0E5gbM;IAOI,gCAAA;E1EwgbV;E0E/gbM;IAOI,yBAAA;E1E2gbV;E0ElhbM;IAOI,wBAAA;E1E8gbV;E0ErhbM;IAOI,+BAAA;E1EihbV;E0ExhbM;IAOI,yBAAA;E1EohbV;E0E3hbM;IAOI,6BAAA;E1EuhbV;E0E9hbM;IAOI,8BAAA;E1E0hbV;E0EjibM;IAOI,wBAAA;E1E6hbV;E0EpibM;IAOI,+BAAA;E1EgibV;E0EvibM;IAOI,wBAAA;E1EmibV;E0E1ibM;IAOI,yBAAA;E1EsibV;E0E7ibM;IAOI,8BAAA;E1EyibV;E0EhjbM;IAOI,iCAAA;E1E4ibV;E0EnjbM;IAOI,sCAAA;E1E+ibV;E0EtjbM;IAOI,yCAAA;E1EkjbV;E0EzjbM;IAOI,uBAAA;E1EqjbV;E0E5jbM;IAOI,uBAAA;E1EwjbV;E0E/jbM;IAOI,yBAAA;E1E2jbV;E0ElkbM;IAOI,yBAAA;E1E8jbV;E0ErkbM;IAOI,0BAAA;E1EikbV;E0ExkbM;IAOI,4BAAA;E1EokbV;E0E3kbM;IAOI,kCAAA;E1EukbV;E0E9kbM;IAOI,sCAAA;E1E0kbV;E0EjlbM;IAOI,oCAAA;E1E6kbV;E0EplbM;IAOI,kCAAA;E1EglbV;E0EvlbM;IAOI,yCAAA;E1EmlbV;E0E1lbM;IAOI,wCAAA;E1EslbV;E0E7lbM;IAOI,wCAAA;E1EylbV;E0EhmbM;IAOI,kCAAA;E1E4lbV;E0EnmbM;IAOI,gCAAA;E1E+lbV;E0EtmbM;IAOI,8BAAA;E1EkmbV;E0EzmbM;IAOI,gCAAA;E1EqmbV;E0E5mbM;IAOI,+BAAA;E1EwmbV;E0E/mbM;IAOI,oCAAA;E1E2mbV;E0ElnbM;IAOI,kCAAA;E1E8mbV;E0ErnbM;IAOI,gCAAA;E1EinbV;E0ExnbM;IAOI,uCAAA;E1EonbV;E0E3nbM;IAOI,sCAAA;E1EunbV;E0E9nbM;IAOI,iCAAA;E1E0nbV;E0EjobM;IAOI,2BAAA;E1E6nbV;E0EpobM;IAOI,iCAAA;E1EgobV;E0EvobM;IAOI,+BAAA;E1EmobV;E0E1obM;IAOI,6BAAA;E1EsobV;E0E7obM;IAOI,+BAAA;E1EyobV;E0EhpbM;IAOI,8BAAA;E1E4obV;E0EnpbM;IAOI,oBAAA;E1E+obV;E0EtpbM;IAOI,mBAAA;E1EkpbV;E0EzpbM;IAOI,mBAAA;E1EqpbV;E0E5pbM;IAOI,mBAAA;E1EwpbV;E0E/pbM;IAOI,mBAAA;E1E2pbV;E0ElqbM;IAOI,mBAAA;E1E8pbV;E0ErqbM;IAOI,mBAAA;E1EiqbV;E0ExqbM;IAOI,mBAAA;E1EoqbV;E0E3qbM;IAOI,oBAAA;E1EuqbV;E0E9qbM;IAOI,0BAAA;E1E0qbV;E0EjrbM;IAOI,yBAAA;E1E6qbV;E0EprbM;IAOI,uBAAA;E1EgrbV;E0EvrbM;IAOI,yBAAA;E1EmrbV;E0E1rbM;IAOI,uBAAA;E1EsrbV;E0E7rbM;IAOI,uBAAA;E1EyrbV;E0EhsbM;IAOI,0BAAA;IAAA,yBAAA;E1E6rbV;E0EpsbM;IAOI,gCAAA;IAAA,+BAAA;E1EisbV;E0ExsbM;IAOI,+BAAA;IAAA,8BAAA;E1EqsbV;E0E5sbM;IAOI,6BAAA;IAAA,4BAAA;E1EysbV;E0EhtbM;IAOI,+BAAA;IAAA,8BAAA;E1E6sbV;E0EptbM;IAOI,6BAAA;IAAA,4BAAA;E1EitbV;E0ExtbM;IAOI,6BAAA;IAAA,4BAAA;E1EqtbV;E0E5tbM;IAOI,wBAAA;IAAA,2BAAA;E1EytbV;E0EhubM;IAOI,8BAAA;IAAA,iCAAA;E1E6tbV;E0EpubM;IAOI,6BAAA;IAAA,gCAAA;E1EiubV;E0ExubM;IAOI,2BAAA;IAAA,8BAAA;E1EqubV;E0E5ubM;IAOI,6BAAA;IAAA,gCAAA;E1EyubV;E0EhvbM;IAOI,2BAAA;IAAA,8BAAA;E1E6ubV;E0EpvbM;IAOI,2BAAA;IAAA,8BAAA;E1EivbV;E0ExvbM;IAOI,wBAAA;E1EovbV;E0E3vbM;IAOI,8BAAA;E1EuvbV;E0E9vbM;IAOI,6BAAA;E1E0vbV;E0EjwbM;IAOI,2BAAA;E1E6vbV;E0EpwbM;IAOI,6BAAA;E1EgwbV;E0EvwbM;IAOI,2BAAA;E1EmwbV;E0E1wbM;IAOI,2BAAA;E1EswbV;E0E7wbM;IAOI,0BAAA;E1EywbV;E0EhxbM;IAOI,gCAAA;E1E4wbV;E0EnxbM;IAOI,+BAAA;E1E+wbV;E0EtxbM;IAOI,6BAAA;E1EkxbV;E0EzxbM;IAOI,+BAAA;E1EqxbV;E0E5xbM;IAOI,6BAAA;E1EwxbV;E0E/xbM;IAOI,6BAAA;E1E2xbV;E0ElybM;IAOI,2BAAA;E1E8xbV;E0ErybM;IAOI,iCAAA;E1EiybV;E0ExybM;IAOI,gCAAA;E1EoybV;E0E3ybM;IAOI,8BAAA;E1EuybV;E0E9ybM;IAOI,gCAAA;E1E0ybV;E0EjzbM;IAOI,8BAAA;E1E6ybV;E0EpzbM;IAOI,8BAAA;E1EgzbV;E0EvzbM;IAOI,yBAAA;E1EmzbV;E0E1zbM;IAOI,+BAAA;E1EszbV;E0E7zbM;IAOI,8BAAA;E1EyzbV;E0Eh0bM;IAOI,4BAAA;E1E4zbV;E0En0bM;IAOI,8BAAA;E1E+zbV;E0Et0bM;IAOI,4BAAA;E1Ek0bV;E0Ez0bM;IAOI,4BAAA;E1Eq0bV;E0E50bM;IAOI,2BAAA;E1Ew0bV;E0E/0bM;IAOI,0BAAA;E1E20bV;E0El1bM;IAOI,wBAAA;E1E80bV;E0Er1bM;IAOI,0BAAA;E1Ei1bV;E0Ex1bM;IAOI,wBAAA;E1Eo1bV;E0E31bM;IAOI,iCAAA;IAAA,gCAAA;E1Ew1bV;E0E/1bM;IAOI,gCAAA;IAAA,+BAAA;E1E41bV;E0En2bM;IAOI,8BAAA;IAAA,6BAAA;E1Eg2bV;E0Ev2bM;IAOI,gCAAA;IAAA,+BAAA;E1Eo2bV;E0E32bM;IAOI,8BAAA;IAAA,6BAAA;E1Ew2bV;E0E/2bM;IAOI,+BAAA;IAAA,kCAAA;E1E42bV;E0En3bM;IAOI,8BAAA;IAAA,iCAAA;E1Eg3bV;E0Ev3bM;IAOI,4BAAA;IAAA,+BAAA;E1Eo3bV;E0E33bM;IAOI,8BAAA;IAAA,iCAAA;E1Ew3bV;E0E/3bM;IAOI,4BAAA;IAAA,+BAAA;E1E43bV;E0En4bM;IAOI,+BAAA;E1E+3bV;E0Et4bM;IAOI,8BAAA;E1Ek4bV;E0Ez4bM;IAOI,4BAAA;E1Eq4bV;E0E54bM;IAOI,8BAAA;E1Ew4bV;E0E/4bM;IAOI,4BAAA;E1E24bV;E0El5bM;IAOI,iCAAA;E1E84bV;E0Er5bM;IAOI,gCAAA;E1Ei5bV;E0Ex5bM;IAOI,8BAAA;E1Eo5bV;E0E35bM;IAOI,gCAAA;E1Eu5bV;E0E95bM;IAOI,8BAAA;E1E05bV;E0Ej6bM;IAOI,kCAAA;E1E65bV;E0Ep6bM;IAOI,iCAAA;E1Eg6bV;E0Ev6bM;IAOI,+BAAA;E1Em6bV;E0E16bM;IAOI,iCAAA;E1Es6bV;E0E76bM;IAOI,+BAAA;E1Ey6bV;E0Eh7bM;IAOI,gCAAA;E1E46bV;E0En7bM;IAOI,+BAAA;E1E+6bV;E0Et7bM;IAOI,6BAAA;E1Ek7bV;E0Ez7bM;IAOI,+BAAA;E1Eq7bV;E0E57bM;IAOI,6BAAA;E1Ew7bV;E0E/7bM;IAOI,qBAAA;E1E27bV;E0El8bM;IAOI,2BAAA;E1E87bV;E0Er8bM;IAOI,0BAAA;E1Ei8bV;E0Ex8bM;IAOI,wBAAA;E1Eo8bV;E0E38bM;IAOI,0BAAA;E1Eu8bV;E0E98bM;IAOI,wBAAA;E1E08bV;E0Ej9bM;IAOI,2BAAA;IAAA,0BAAA;E1E88bV;E0Er9bM;IAOI,iCAAA;IAAA,gCAAA;E1Ek9bV;E0Ez9bM;IAOI,gCAAA;IAAA,+BAAA;E1Es9bV;E0E79bM;IAOI,8BAAA;IAAA,6BAAA;E1E09bV;E0Ej+bM;IAOI,gCAAA;IAAA,+BAAA;E1E89bV;E0Er+bM;IAOI,8BAAA;IAAA,6BAAA;E1Ek+bV;E0Ez+bM;IAOI,yBAAA;IAAA,4BAAA;E1Es+bV;E0E7+bM;IAOI,+BAAA;IAAA,kCAAA;E1E0+bV;E0Ej/bM;IAOI,8BAAA;IAAA,iCAAA;E1E8+bV;E0Er/bM;IAOI,4BAAA;IAAA,+BAAA;E1Ek/bV;E0Ez/bM;IAOI,8BAAA;IAAA,iCAAA;E1Es/bV;E0E7/bM;IAOI,4BAAA;IAAA,+BAAA;E1E0/bV;E0EjgcM;IAOI,yBAAA;E1E6/bV;E0EpgcM;IAOI,+BAAA;E1EggcV;E0EvgcM;IAOI,8BAAA;E1EmgcV;E0E1gcM;IAOI,4BAAA;E1EsgcV;E0E7gcM;IAOI,8BAAA;E1EygcV;E0EhhcM;IAOI,4BAAA;E1E4gcV;E0EnhcM;IAOI,2BAAA;E1E+gcV;E0EthcM;IAOI,iCAAA;E1EkhcV;E0EzhcM;IAOI,gCAAA;E1EqhcV;E0E5hcM;IAOI,8BAAA;E1EwhcV;E0E/hcM;IAOI,gCAAA;E1E2hcV;E0ElicM;IAOI,8BAAA;E1E8hcV;E0EricM;IAOI,4BAAA;E1EiicV;E0ExicM;IAOI,kCAAA;E1EoicV;E0E3icM;IAOI,iCAAA;E1EuicV;E0E9icM;IAOI,+BAAA;E1E0icV;E0EjjcM;IAOI,iCAAA;E1E6icV;E0EpjcM;IAOI,+BAAA;E1EgjcV;E0EvjcM;IAOI,0BAAA;E1EmjcV;E0E1jcM;IAOI,gCAAA;E1EsjcV;E0E7jcM;IAOI,+BAAA;E1EyjcV;E0EhkcM;IAOI,6BAAA;E1E4jcV;E0EnkcM;IAOI,+BAAA;E1E+jcV;E0EtkcM;IAOI,6BAAA;E1EkkcV;E0EzkcM;IAOI,iBAAA;E1EqkcV;E0E5kcM;IAOI,uBAAA;E1EwkcV;E0E/kcM;IAOI,sBAAA;E1E2kcV;E0EllcM;IAOI,oBAAA;E1E8kcV;E0ErlcM;IAOI,sBAAA;E1EilcV;E0ExlcM;IAOI,oBAAA;E1EolcV;E0E3lcM;IAOI,qBAAA;E1EulcV;E0E9lcM;IAOI,2BAAA;E1E0lcV;E0EjmcM;IAOI,0BAAA;E1E6lcV;E0EpmcM;IAOI,wBAAA;E1EgmcV;E0EvmcM;IAOI,0BAAA;E1EmmcV;E0E1mcM;IAOI,wBAAA;E1EsmcV;E0E7mcM;IAOI,wBAAA;E1EymcV;E0EhncM;IAOI,8BAAA;E1E4mcV;E0EnncM;IAOI,6BAAA;E1E+mcV;E0EtncM;IAOI,2BAAA;E1EkncV;E0EzncM;IAOI,6BAAA;E1EqncV;E0E5ncM;IAOI,2BAAA;E1EwncV;E0E/ncM;IAOI,2BAAA;E1E2ncV;E0ElocM;IAOI,4BAAA;E1E8ncV;E0ErocM;IAOI,6BAAA;E1EiocV;AACF;AgB5ocI;E0DGI;IAOI,sBAAA;E1EsocV;E0E7ocM;IAOI,uBAAA;E1EyocV;E0EhpcM;IAOI,sBAAA;E1E4ocV;E0EnpcM;IAOI,8BAAA;E1E+ocV;E0EtpcM;IAOI,4BAAA;E1EkpcV;E0EzpcM;IAOI,2BAAA;E1EqpcV;E0E5pcM;IAOI,iCAAA;E1EwpcV;E0E/pcM;IAOI,2BAAA;E1E2pcV;E0ElqcM;IAOI,0BAAA;E1E8pcV;E0ErqcM;IAOI,gCAAA;E1EiqcV;E0ExqcM;IAOI,yBAAA;E1EoqcV;E0E3qcM;IAOI,wBAAA;E1EuqcV;E0E9qcM;IAOI,+BAAA;E1E0qcV;E0EjrcM;IAOI,yBAAA;E1E6qcV;E0EprcM;IAOI,6BAAA;E1EgrcV;E0EvrcM;IAOI,8BAAA;E1EmrcV;E0E1rcM;IAOI,wBAAA;E1EsrcV;E0E7rcM;IAOI,+BAAA;E1EyrcV;E0EhscM;IAOI,wBAAA;E1E4rcV;E0EnscM;IAOI,yBAAA;E1E+rcV;E0EtscM;IAOI,8BAAA;E1EkscV;E0EzscM;IAOI,iCAAA;E1EqscV;E0E5scM;IAOI,sCAAA;E1EwscV;E0E/scM;IAOI,yCAAA;E1E2scV;E0EltcM;IAOI,uBAAA;E1E8scV;E0ErtcM;IAOI,uBAAA;E1EitcV;E0ExtcM;IAOI,yBAAA;E1EotcV;E0E3tcM;IAOI,yBAAA;E1EutcV;E0E9tcM;IAOI,0BAAA;E1E0tcV;E0EjucM;IAOI,4BAAA;E1E6tcV;E0EpucM;IAOI,kCAAA;E1EgucV;E0EvucM;IAOI,sCAAA;E1EmucV;E0E1ucM;IAOI,oCAAA;E1EsucV;E0E7ucM;IAOI,kCAAA;E1EyucV;E0EhvcM;IAOI,yCAAA;E1E4ucV;E0EnvcM;IAOI,wCAAA;E1E+ucV;E0EtvcM;IAOI,wCAAA;E1EkvcV;E0EzvcM;IAOI,kCAAA;E1EqvcV;E0E5vcM;IAOI,gCAAA;E1EwvcV;E0E/vcM;IAOI,8BAAA;E1E2vcV;E0ElwcM;IAOI,gCAAA;E1E8vcV;E0ErwcM;IAOI,+BAAA;E1EiwcV;E0ExwcM;IAOI,oCAAA;E1EowcV;E0E3wcM;IAOI,kCAAA;E1EuwcV;E0E9wcM;IAOI,gCAAA;E1E0wcV;E0EjxcM;IAOI,uCAAA;E1E6wcV;E0EpxcM;IAOI,sCAAA;E1EgxcV;E0EvxcM;IAOI,iCAAA;E1EmxcV;E0E1xcM;IAOI,2BAAA;E1EsxcV;E0E7xcM;IAOI,iCAAA;E1EyxcV;E0EhycM;IAOI,+BAAA;E1E4xcV;E0EnycM;IAOI,6BAAA;E1E+xcV;E0EtycM;IAOI,+BAAA;E1EkycV;E0EzycM;IAOI,8BAAA;E1EqycV;E0E5ycM;IAOI,oBAAA;E1EwycV;E0E/ycM;IAOI,mBAAA;E1E2ycV;E0ElzcM;IAOI,mBAAA;E1E8ycV;E0ErzcM;IAOI,mBAAA;E1EizcV;E0ExzcM;IAOI,mBAAA;E1EozcV;E0E3zcM;IAOI,mBAAA;E1EuzcV;E0E9zcM;IAOI,mBAAA;E1E0zcV;E0Ej0cM;IAOI,mBAAA;E1E6zcV;E0Ep0cM;IAOI,oBAAA;E1Eg0cV;E0Ev0cM;IAOI,0BAAA;E1Em0cV;E0E10cM;IAOI,yBAAA;E1Es0cV;E0E70cM;IAOI,uBAAA;E1Ey0cV;E0Eh1cM;IAOI,yBAAA;E1E40cV;E0En1cM;IAOI,uBAAA;E1E+0cV;E0Et1cM;IAOI,uBAAA;E1Ek1cV;E0Ez1cM;IAOI,0BAAA;IAAA,yBAAA;E1Es1cV;E0E71cM;IAOI,gCAAA;IAAA,+BAAA;E1E01cV;E0Ej2cM;IAOI,+BAAA;IAAA,8BAAA;E1E81cV;E0Er2cM;IAOI,6BAAA;IAAA,4BAAA;E1Ek2cV;E0Ez2cM;IAOI,+BAAA;IAAA,8BAAA;E1Es2cV;E0E72cM;IAOI,6BAAA;IAAA,4BAAA;E1E02cV;E0Ej3cM;IAOI,6BAAA;IAAA,4BAAA;E1E82cV;E0Er3cM;IAOI,wBAAA;IAAA,2BAAA;E1Ek3cV;E0Ez3cM;IAOI,8BAAA;IAAA,iCAAA;E1Es3cV;E0E73cM;IAOI,6BAAA;IAAA,gCAAA;E1E03cV;E0Ej4cM;IAOI,2BAAA;IAAA,8BAAA;E1E83cV;E0Er4cM;IAOI,6BAAA;IAAA,gCAAA;E1Ek4cV;E0Ez4cM;IAOI,2BAAA;IAAA,8BAAA;E1Es4cV;E0E74cM;IAOI,2BAAA;IAAA,8BAAA;E1E04cV;E0Ej5cM;IAOI,wBAAA;E1E64cV;E0Ep5cM;IAOI,8BAAA;E1Eg5cV;E0Ev5cM;IAOI,6BAAA;E1Em5cV;E0E15cM;IAOI,2BAAA;E1Es5cV;E0E75cM;IAOI,6BAAA;E1Ey5cV;E0Eh6cM;IAOI,2BAAA;E1E45cV;E0En6cM;IAOI,2BAAA;E1E+5cV;E0Et6cM;IAOI,0BAAA;E1Ek6cV;E0Ez6cM;IAOI,gCAAA;E1Eq6cV;E0E56cM;IAOI,+BAAA;E1Ew6cV;E0E/6cM;IAOI,6BAAA;E1E26cV;E0El7cM;IAOI,+BAAA;E1E86cV;E0Er7cM;IAOI,6BAAA;E1Ei7cV;E0Ex7cM;IAOI,6BAAA;E1Eo7cV;E0E37cM;IAOI,2BAAA;E1Eu7cV;E0E97cM;IAOI,iCAAA;E1E07cV;E0Ej8cM;IAOI,gCAAA;E1E67cV;E0Ep8cM;IAOI,8BAAA;E1Eg8cV;E0Ev8cM;IAOI,gCAAA;E1Em8cV;E0E18cM;IAOI,8BAAA;E1Es8cV;E0E78cM;IAOI,8BAAA;E1Ey8cV;E0Eh9cM;IAOI,yBAAA;E1E48cV;E0En9cM;IAOI,+BAAA;E1E+8cV;E0Et9cM;IAOI,8BAAA;E1Ek9cV;E0Ez9cM;IAOI,4BAAA;E1Eq9cV;E0E59cM;IAOI,8BAAA;E1Ew9cV;E0E/9cM;IAOI,4BAAA;E1E29cV;E0El+cM;IAOI,4BAAA;E1E89cV;E0Er+cM;IAOI,2BAAA;E1Ei+cV;E0Ex+cM;IAOI,0BAAA;E1Eo+cV;E0E3+cM;IAOI,wBAAA;E1Eu+cV;E0E9+cM;IAOI,0BAAA;E1E0+cV;E0Ej/cM;IAOI,wBAAA;E1E6+cV;E0Ep/cM;IAOI,iCAAA;IAAA,gCAAA;E1Ei/cV;E0Ex/cM;IAOI,gCAAA;IAAA,+BAAA;E1Eq/cV;E0E5/cM;IAOI,8BAAA;IAAA,6BAAA;E1Ey/cV;E0EhgdM;IAOI,gCAAA;IAAA,+BAAA;E1E6/cV;E0EpgdM;IAOI,8BAAA;IAAA,6BAAA;E1EigdV;E0ExgdM;IAOI,+BAAA;IAAA,kCAAA;E1EqgdV;E0E5gdM;IAOI,8BAAA;IAAA,iCAAA;E1EygdV;E0EhhdM;IAOI,4BAAA;IAAA,+BAAA;E1E6gdV;E0EphdM;IAOI,8BAAA;IAAA,iCAAA;E1EihdV;E0ExhdM;IAOI,4BAAA;IAAA,+BAAA;E1EqhdV;E0E5hdM;IAOI,+BAAA;E1EwhdV;E0E/hdM;IAOI,8BAAA;E1E2hdV;E0ElidM;IAOI,4BAAA;E1E8hdV;E0EridM;IAOI,8BAAA;E1EiidV;E0ExidM;IAOI,4BAAA;E1EoidV;E0E3idM;IAOI,iCAAA;E1EuidV;E0E9idM;IAOI,gCAAA;E1E0idV;E0EjjdM;IAOI,8BAAA;E1E6idV;E0EpjdM;IAOI,gCAAA;E1EgjdV;E0EvjdM;IAOI,8BAAA;E1EmjdV;E0E1jdM;IAOI,kCAAA;E1EsjdV;E0E7jdM;IAOI,iCAAA;E1EyjdV;E0EhkdM;IAOI,+BAAA;E1E4jdV;E0EnkdM;IAOI,iCAAA;E1E+jdV;E0EtkdM;IAOI,+BAAA;E1EkkdV;E0EzkdM;IAOI,gCAAA;E1EqkdV;E0E5kdM;IAOI,+BAAA;E1EwkdV;E0E/kdM;IAOI,6BAAA;E1E2kdV;E0ElldM;IAOI,+BAAA;E1E8kdV;E0ErldM;IAOI,6BAAA;E1EildV;E0ExldM;IAOI,qBAAA;E1EoldV;E0E3ldM;IAOI,2BAAA;E1EuldV;E0E9ldM;IAOI,0BAAA;E1E0ldV;E0EjmdM;IAOI,wBAAA;E1E6ldV;E0EpmdM;IAOI,0BAAA;E1EgmdV;E0EvmdM;IAOI,wBAAA;E1EmmdV;E0E1mdM;IAOI,2BAAA;IAAA,0BAAA;E1EumdV;E0E9mdM;IAOI,iCAAA;IAAA,gCAAA;E1E2mdV;E0ElndM;IAOI,gCAAA;IAAA,+BAAA;E1E+mdV;E0EtndM;IAOI,8BAAA;IAAA,6BAAA;E1EmndV;E0E1ndM;IAOI,gCAAA;IAAA,+BAAA;E1EundV;E0E9ndM;IAOI,8BAAA;IAAA,6BAAA;E1E2ndV;E0ElodM;IAOI,yBAAA;IAAA,4BAAA;E1E+ndV;E0EtodM;IAOI,+BAAA;IAAA,kCAAA;E1EmodV;E0E1odM;IAOI,8BAAA;IAAA,iCAAA;E1EuodV;E0E9odM;IAOI,4BAAA;IAAA,+BAAA;E1E2odV;E0ElpdM;IAOI,8BAAA;IAAA,iCAAA;E1E+odV;E0EtpdM;IAOI,4BAAA;IAAA,+BAAA;E1EmpdV;E0E1pdM;IAOI,yBAAA;E1EspdV;E0E7pdM;IAOI,+BAAA;E1EypdV;E0EhqdM;IAOI,8BAAA;E1E4pdV;E0EnqdM;IAOI,4BAAA;E1E+pdV;E0EtqdM;IAOI,8BAAA;E1EkqdV;E0EzqdM;IAOI,4BAAA;E1EqqdV;E0E5qdM;IAOI,2BAAA;E1EwqdV;E0E/qdM;IAOI,iCAAA;E1E2qdV;E0ElrdM;IAOI,gCAAA;E1E8qdV;E0ErrdM;IAOI,8BAAA;E1EirdV;E0ExrdM;IAOI,gCAAA;E1EordV;E0E3rdM;IAOI,8BAAA;E1EurdV;E0E9rdM;IAOI,4BAAA;E1E0rdV;E0EjsdM;IAOI,kCAAA;E1E6rdV;E0EpsdM;IAOI,iCAAA;E1EgsdV;E0EvsdM;IAOI,+BAAA;E1EmsdV;E0E1sdM;IAOI,iCAAA;E1EssdV;E0E7sdM;IAOI,+BAAA;E1EysdV;E0EhtdM;IAOI,0BAAA;E1E4sdV;E0EntdM;IAOI,gCAAA;E1E+sdV;E0EttdM;IAOI,+BAAA;E1EktdV;E0EztdM;IAOI,6BAAA;E1EqtdV;E0E5tdM;IAOI,+BAAA;E1EwtdV;E0E/tdM;IAOI,6BAAA;E1E2tdV;E0EludM;IAOI,iBAAA;E1E8tdV;E0ErudM;IAOI,uBAAA;E1EiudV;E0ExudM;IAOI,sBAAA;E1EoudV;E0E3udM;IAOI,oBAAA;E1EuudV;E0E9udM;IAOI,sBAAA;E1E0udV;E0EjvdM;IAOI,oBAAA;E1E6udV;E0EpvdM;IAOI,qBAAA;E1EgvdV;E0EvvdM;IAOI,2BAAA;E1EmvdV;E0E1vdM;IAOI,0BAAA;E1EsvdV;E0E7vdM;IAOI,wBAAA;E1EyvdV;E0EhwdM;IAOI,0BAAA;E1E4vdV;E0EnwdM;IAOI,wBAAA;E1E+vdV;E0EtwdM;IAOI,wBAAA;E1EkwdV;E0EzwdM;IAOI,8BAAA;E1EqwdV;E0E5wdM;IAOI,6BAAA;E1EwwdV;E0E/wdM;IAOI,2BAAA;E1E2wdV;E0ElxdM;IAOI,6BAAA;E1E8wdV;E0ErxdM;IAOI,2BAAA;E1EixdV;E0ExxdM;IAOI,2BAAA;E1EoxdV;E0E3xdM;IAOI,4BAAA;E1EuxdV;E0E9xdM;IAOI,6BAAA;E1E0xdV;AACF;AgBrydI;E0DGI;IAOI,sBAAA;E1E+xdV;E0EtydM;IAOI,uBAAA;E1EkydV;E0EzydM;IAOI,sBAAA;E1EqydV;E0E5ydM;IAOI,8BAAA;E1EwydV;E0E/ydM;IAOI,4BAAA;E1E2ydV;E0ElzdM;IAOI,2BAAA;E1E8ydV;E0ErzdM;IAOI,iCAAA;E1EizdV;E0ExzdM;IAOI,2BAAA;E1EozdV;E0E3zdM;IAOI,0BAAA;E1EuzdV;E0E9zdM;IAOI,gCAAA;E1E0zdV;E0Ej0dM;IAOI,yBAAA;E1E6zdV;E0Ep0dM;IAOI,wBAAA;E1Eg0dV;E0Ev0dM;IAOI,+BAAA;E1Em0dV;E0E10dM;IAOI,yBAAA;E1Es0dV;E0E70dM;IAOI,6BAAA;E1Ey0dV;E0Eh1dM;IAOI,8BAAA;E1E40dV;E0En1dM;IAOI,wBAAA;E1E+0dV;E0Et1dM;IAOI,+BAAA;E1Ek1dV;E0Ez1dM;IAOI,wBAAA;E1Eq1dV;E0E51dM;IAOI,yBAAA;E1Ew1dV;E0E/1dM;IAOI,8BAAA;E1E21dV;E0El2dM;IAOI,iCAAA;E1E81dV;E0Er2dM;IAOI,sCAAA;E1Ei2dV;E0Ex2dM;IAOI,yCAAA;E1Eo2dV;E0E32dM;IAOI,uBAAA;E1Eu2dV;E0E92dM;IAOI,uBAAA;E1E02dV;E0Ej3dM;IAOI,yBAAA;E1E62dV;E0Ep3dM;IAOI,yBAAA;E1Eg3dV;E0Ev3dM;IAOI,0BAAA;E1Em3dV;E0E13dM;IAOI,4BAAA;E1Es3dV;E0E73dM;IAOI,kCAAA;E1Ey3dV;E0Eh4dM;IAOI,sCAAA;E1E43dV;E0En4dM;IAOI,oCAAA;E1E+3dV;E0Et4dM;IAOI,kCAAA;E1Ek4dV;E0Ez4dM;IAOI,yCAAA;E1Eq4dV;E0E54dM;IAOI,wCAAA;E1Ew4dV;E0E/4dM;IAOI,wCAAA;E1E24dV;E0El5dM;IAOI,kCAAA;E1E84dV;E0Er5dM;IAOI,gCAAA;E1Ei5dV;E0Ex5dM;IAOI,8BAAA;E1Eo5dV;E0E35dM;IAOI,gCAAA;E1Eu5dV;E0E95dM;IAOI,+BAAA;E1E05dV;E0Ej6dM;IAOI,oCAAA;E1E65dV;E0Ep6dM;IAOI,kCAAA;E1Eg6dV;E0Ev6dM;IAOI,gCAAA;E1Em6dV;E0E16dM;IAOI,uCAAA;E1Es6dV;E0E76dM;IAOI,sCAAA;E1Ey6dV;E0Eh7dM;IAOI,iCAAA;E1E46dV;E0En7dM;IAOI,2BAAA;E1E+6dV;E0Et7dM;IAOI,iCAAA;E1Ek7dV;E0Ez7dM;IAOI,+BAAA;E1Eq7dV;E0E57dM;IAOI,6BAAA;E1Ew7dV;E0E/7dM;IAOI,+BAAA;E1E27dV;E0El8dM;IAOI,8BAAA;E1E87dV;E0Er8dM;IAOI,oBAAA;E1Ei8dV;E0Ex8dM;IAOI,mBAAA;E1Eo8dV;E0E38dM;IAOI,mBAAA;E1Eu8dV;E0E98dM;IAOI,mBAAA;E1E08dV;E0Ej9dM;IAOI,mBAAA;E1E68dV;E0Ep9dM;IAOI,mBAAA;E1Eg9dV;E0Ev9dM;IAOI,mBAAA;E1Em9dV;E0E19dM;IAOI,mBAAA;E1Es9dV;E0E79dM;IAOI,oBAAA;E1Ey9dV;E0Eh+dM;IAOI,0BAAA;E1E49dV;E0En+dM;IAOI,yBAAA;E1E+9dV;E0Et+dM;IAOI,uBAAA;E1Ek+dV;E0Ez+dM;IAOI,yBAAA;E1Eq+dV;E0E5+dM;IAOI,uBAAA;E1Ew+dV;E0E/+dM;IAOI,uBAAA;E1E2+dV;E0El/dM;IAOI,0BAAA;IAAA,yBAAA;E1E++dV;E0Et/dM;IAOI,gCAAA;IAAA,+BAAA;E1Em/dV;E0E1/dM;IAOI,+BAAA;IAAA,8BAAA;E1Eu/dV;E0E9/dM;IAOI,6BAAA;IAAA,4BAAA;E1E2/dV;E0ElgeM;IAOI,+BAAA;IAAA,8BAAA;E1E+/dV;E0EtgeM;IAOI,6BAAA;IAAA,4BAAA;E1EmgeV;E0E1geM;IAOI,6BAAA;IAAA,4BAAA;E1EugeV;E0E9geM;IAOI,wBAAA;IAAA,2BAAA;E1E2geV;E0ElheM;IAOI,8BAAA;IAAA,iCAAA;E1E+geV;E0EtheM;IAOI,6BAAA;IAAA,gCAAA;E1EmheV;E0E1heM;IAOI,2BAAA;IAAA,8BAAA;E1EuheV;E0E9heM;IAOI,6BAAA;IAAA,gCAAA;E1E2heV;E0ElieM;IAOI,2BAAA;IAAA,8BAAA;E1E+heV;E0EtieM;IAOI,2BAAA;IAAA,8BAAA;E1EmieV;E0E1ieM;IAOI,wBAAA;E1EsieV;E0E7ieM;IAOI,8BAAA;E1EyieV;E0EhjeM;IAOI,6BAAA;E1E4ieV;E0EnjeM;IAOI,2BAAA;E1E+ieV;E0EtjeM;IAOI,6BAAA;E1EkjeV;E0EzjeM;IAOI,2BAAA;E1EqjeV;E0E5jeM;IAOI,2BAAA;E1EwjeV;E0E/jeM;IAOI,0BAAA;E1E2jeV;E0ElkeM;IAOI,gCAAA;E1E8jeV;E0ErkeM;IAOI,+BAAA;E1EikeV;E0ExkeM;IAOI,6BAAA;E1EokeV;E0E3keM;IAOI,+BAAA;E1EukeV;E0E9keM;IAOI,6BAAA;E1E0keV;E0EjleM;IAOI,6BAAA;E1E6keV;E0EpleM;IAOI,2BAAA;E1EgleV;E0EvleM;IAOI,iCAAA;E1EmleV;E0E1leM;IAOI,gCAAA;E1EsleV;E0E7leM;IAOI,8BAAA;E1EyleV;E0EhmeM;IAOI,gCAAA;E1E4leV;E0EnmeM;IAOI,8BAAA;E1E+leV;E0EtmeM;IAOI,8BAAA;E1EkmeV;E0EzmeM;IAOI,yBAAA;E1EqmeV;E0E5meM;IAOI,+BAAA;E1EwmeV;E0E/meM;IAOI,8BAAA;E1E2meV;E0ElneM;IAOI,4BAAA;E1E8meV;E0ErneM;IAOI,8BAAA;E1EineV;E0ExneM;IAOI,4BAAA;E1EoneV;E0E3neM;IAOI,4BAAA;E1EuneV;E0E9neM;IAOI,2BAAA;E1E0neV;E0EjoeM;IAOI,0BAAA;E1E6neV;E0EpoeM;IAOI,wBAAA;E1EgoeV;E0EvoeM;IAOI,0BAAA;E1EmoeV;E0E1oeM;IAOI,wBAAA;E1EsoeV;E0E7oeM;IAOI,iCAAA;IAAA,gCAAA;E1E0oeV;E0EjpeM;IAOI,gCAAA;IAAA,+BAAA;E1E8oeV;E0ErpeM;IAOI,8BAAA;IAAA,6BAAA;E1EkpeV;E0EzpeM;IAOI,gCAAA;IAAA,+BAAA;E1EspeV;E0E7peM;IAOI,8BAAA;IAAA,6BAAA;E1E0peV;E0EjqeM;IAOI,+BAAA;IAAA,kCAAA;E1E8peV;E0ErqeM;IAOI,8BAAA;IAAA,iCAAA;E1EkqeV;E0EzqeM;IAOI,4BAAA;IAAA,+BAAA;E1EsqeV;E0E7qeM;IAOI,8BAAA;IAAA,iCAAA;E1E0qeV;E0EjreM;IAOI,4BAAA;IAAA,+BAAA;E1E8qeV;E0ErreM;IAOI,+BAAA;E1EireV;E0ExreM;IAOI,8BAAA;E1EoreV;E0E3reM;IAOI,4BAAA;E1EureV;E0E9reM;IAOI,8BAAA;E1E0reV;E0EjseM;IAOI,4BAAA;E1E6reV;E0EpseM;IAOI,iCAAA;E1EgseV;E0EvseM;IAOI,gCAAA;E1EmseV;E0E1seM;IAOI,8BAAA;E1EsseV;E0E7seM;IAOI,gCAAA;E1EyseV;E0EhteM;IAOI,8BAAA;E1E4seV;E0EnteM;IAOI,kCAAA;E1E+seV;E0EtteM;IAOI,iCAAA;E1EkteV;E0EzteM;IAOI,+BAAA;E1EqteV;E0E5teM;IAOI,iCAAA;E1EwteV;E0E/teM;IAOI,+BAAA;E1E2teV;E0ElueM;IAOI,gCAAA;E1E8teV;E0ErueM;IAOI,+BAAA;E1EiueV;E0ExueM;IAOI,6BAAA;E1EoueV;E0E3ueM;IAOI,+BAAA;E1EuueV;E0E9ueM;IAOI,6BAAA;E1E0ueV;E0EjveM;IAOI,qBAAA;E1E6ueV;E0EpveM;IAOI,2BAAA;E1EgveV;E0EvveM;IAOI,0BAAA;E1EmveV;E0E1veM;IAOI,wBAAA;E1EsveV;E0E7veM;IAOI,0BAAA;E1EyveV;E0EhweM;IAOI,wBAAA;E1E4veV;E0EnweM;IAOI,2BAAA;IAAA,0BAAA;E1EgweV;E0EvweM;IAOI,iCAAA;IAAA,gCAAA;E1EoweV;E0E3weM;IAOI,gCAAA;IAAA,+BAAA;E1EwweV;E0E/weM;IAOI,8BAAA;IAAA,6BAAA;E1E4weV;E0EnxeM;IAOI,gCAAA;IAAA,+BAAA;E1EgxeV;E0EvxeM;IAOI,8BAAA;IAAA,6BAAA;E1EoxeV;E0E3xeM;IAOI,yBAAA;IAAA,4BAAA;E1EwxeV;E0E/xeM;IAOI,+BAAA;IAAA,kCAAA;E1E4xeV;E0EnyeM;IAOI,8BAAA;IAAA,iCAAA;E1EgyeV;E0EvyeM;IAOI,4BAAA;IAAA,+BAAA;E1EoyeV;E0E3yeM;IAOI,8BAAA;IAAA,iCAAA;E1EwyeV;E0E/yeM;IAOI,4BAAA;IAAA,+BAAA;E1E4yeV;E0EnzeM;IAOI,yBAAA;E1E+yeV;E0EtzeM;IAOI,+BAAA;E1EkzeV;E0EzzeM;IAOI,8BAAA;E1EqzeV;E0E5zeM;IAOI,4BAAA;E1EwzeV;E0E/zeM;IAOI,8BAAA;E1E2zeV;E0El0eM;IAOI,4BAAA;E1E8zeV;E0Er0eM;IAOI,2BAAA;E1Ei0eV;E0Ex0eM;IAOI,iCAAA;E1Eo0eV;E0E30eM;IAOI,gCAAA;E1Eu0eV;E0E90eM;IAOI,8BAAA;E1E00eV;E0Ej1eM;IAOI,gCAAA;E1E60eV;E0Ep1eM;IAOI,8BAAA;E1Eg1eV;E0Ev1eM;IAOI,4BAAA;E1Em1eV;E0E11eM;IAOI,kCAAA;E1Es1eV;E0E71eM;IAOI,iCAAA;E1Ey1eV;E0Eh2eM;IAOI,+BAAA;E1E41eV;E0En2eM;IAOI,iCAAA;E1E+1eV;E0Et2eM;IAOI,+BAAA;E1Ek2eV;E0Ez2eM;IAOI,0BAAA;E1Eq2eV;E0E52eM;IAOI,gCAAA;E1Ew2eV;E0E/2eM;IAOI,+BAAA;E1E22eV;E0El3eM;IAOI,6BAAA;E1E82eV;E0Er3eM;IAOI,+BAAA;E1Ei3eV;E0Ex3eM;IAOI,6BAAA;E1Eo3eV;E0E33eM;IAOI,iBAAA;E1Eu3eV;E0E93eM;IAOI,uBAAA;E1E03eV;E0Ej4eM;IAOI,sBAAA;E1E63eV;E0Ep4eM;IAOI,oBAAA;E1Eg4eV;E0Ev4eM;IAOI,sBAAA;E1Em4eV;E0E14eM;IAOI,oBAAA;E1Es4eV;E0E74eM;IAOI,qBAAA;E1Ey4eV;E0Eh5eM;IAOI,2BAAA;E1E44eV;E0En5eM;IAOI,0BAAA;E1E+4eV;E0Et5eM;IAOI,wBAAA;E1Ek5eV;E0Ez5eM;IAOI,0BAAA;E1Eq5eV;E0E55eM;IAOI,wBAAA;E1Ew5eV;E0E/5eM;IAOI,wBAAA;E1E25eV;E0El6eM;IAOI,8BAAA;E1E85eV;E0Er6eM;IAOI,6BAAA;E1Ei6eV;E0Ex6eM;IAOI,2BAAA;E1Eo6eV;E0E36eM;IAOI,6BAAA;E1Eu6eV;E0E96eM;IAOI,2BAAA;E1E06eV;E0Ej7eM;IAOI,2BAAA;E1E66eV;E0Ep7eM;IAOI,4BAAA;E1Eg7eV;E0Ev7eM;IAOI,6BAAA;E1Em7eV;AACF;A2E1+eA;ED+CQ;IAOI,+BAAA;E1Ew7eV;E0E/7eM;IAOI,6BAAA;E1E27eV;E0El8eM;IAOI,gCAAA;E1E87eV;E0Er8eM;IAOI,+BAAA;E1Ei8eV;AACF;A2Er+eA;ED4BQ;IAOI,0BAAA;E1Es8eV;E0E78eM;IAOI,gCAAA;E1Ey8eV;E0Eh9eM;IAOI,yBAAA;E1E48eV;E0En9eM;IAOI,wBAAA;E1E+8eV;E0Et9eM;IAOI,+BAAA;E1Ek9eV;E0Ez9eM;IAOI,yBAAA;E1Eq9eV;E0E59eM;IAOI,6BAAA;E1Ew9eV;E0E/9eM;IAOI,8BAAA;E1E29eV;E0El+eM;IAOI,wBAAA;E1E89eV;E0Er+eM;IAOI,+BAAA;E1Ei+eV;E0Ex+eM;IAOI,wBAAA;E1Eo+eV;AACF;A4E7ifC;EACC,6BAAA;A5E+ifF;A4E5ifC;EACC,sBAAA;A5E8ifF;A4E3ifC;EACC,6BAAA;A5E6ifF;A4E1ifC;EACC,sBAAA;A5E4ifF;A4EzifC;;;EAGC,sBAAA;A5E2ifF;A4ExifC;EACC,WAAA;A5E0ifF;A4EvifC;EACC,gBAAA;A5EyifF;A4EtifC;EACC,gCAAA;A5EwifF;A4ErifC;EACC,YAAA;EACA,gCAAA;A5EuifF;A4EpifC;EACC,qFAAA;A5EsifF;A4ElifE;EACC,WAAA;A5EoifH;A4ElifG;EACC,+BAAA;A5EoifJ;A4E/hfC;EACC,+CAAA;A5EiifF;A4E9hfC;EACC,iBAAA;EACA,0CAAA;A5EgifF;A4E7hfC;EACC,iBAAA;A5E+hfF;A4E5hfC;EACC,iBAAA;A5E8hfF;;A4EzhfC;;EAEC,sBAAA;A5E4hfF;;A4ExhfA;;EAEC,2GAAA;EACA,4DAAA;EACA,kCAAA;EAEA,0BAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,iCAAA;EACA,2BAAA;EACA,mEAAA;EACA,mCAAA;EACA,uCAAA;EACA,yCAAA;EACA,mCAAA;EACA,oEAAA;EACA,kEAAA;EACA,+CAAA;EACA,gDAAA;EACA,qDAAA;EACA,4BAAA;EACA,kEAAA;EACA,+CAAA;EACA,gDAAA;EACA,yCAAA;EACA,kDAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;A5E0hfD;;AM3nfI;EsEsGF,2FAAA;EACA,4DAAA;EACA,kCAAA;EAEA,0BAAA;EACA,qCAAA;EACA,0BAAA;EACA,iCAAA;EACA,2BAAA;EACA,uCAAA;EACA,yCAAA;EACA,mEAAA;EACA,mCAAA;EACA,6CAAA;EACA,0DAAA;EACA,mCAAA;EACA,oEAAA;EACA,kEAAA;EACA,+CAAA;EACA,gDAAA;EACA,kDAAA;EACA,2CAAA;EACA,kEAAA;EACA,+CAAA;EACA,gDAAA;EACA,wDAAA;EACA,+CAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;A5EwhfF;;A6E5qfA;EACC,YAAA;A7E+qfD;A6E/ofC;EACC,gBAAA;A7EipfF;;A6E5ofC;EACC,6EAAA;A7E+ofF;;A6E3ofA;EACC,gBAAA;EACA,uCAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;A7E8ofD;A6ExofC;EACC,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,8BAAA;EACA,6BAAA;EAEA,6CAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;A7EyofF;A6EhofA;EACC,iBAAA;A7EkofD;;A6E/nfA;EACC,sCAAA;EACA,kDAAA;A7EkofD;;A6E/nfA;EACC,6CAAA;EACA,4BAAA;A7EkofD;;A6E/nfA;EACC,kDAAA;A7EkofD;;A6E/nfA;EACC,6BAAA;A7EkofD;;A6E/nfA;;EAEC,sBAAA;EACA,sCAAA;A7EkofD;;A6E/nfA;;EAEC,sCAAA;A7EkofD;;A6E/nfA;;EAEC,sCAAA;A7EkofD;;A6E/nfA;;EAEC,sCAAA;A7EkofD;;A6E/nfA;EACC,sCAAA;A7EkofD;;A6E/nfA;EACC,8BAAA;A7EkofD;;A6E/nfA;EACC,sCAAA;A7EkofD;;A8ErwfA,kBAAA;AC8BE;EAcE,sBAAA;A/E8tfJ;;A+E5ufE;EAcE,sBAAA;A/EkufJ;;A+EhvfE;EAcE,sBAAA;A/EsufJ;;A+EpvfE;EAcE,sBAAA;A/E0ufJ;;A+ExvfE;EAcE,sBAAA;A/E8ufJ;;A+E5vfE;EAcE,sBAAA;A/EkvfJ;;A+EhwfE;EAcE,sBAAA;A/EsvfJ;;A+EpwfE;EAcE,sBAAA;A/E0vfJ;;A+ExwfE;EAcE,sBAAA;A/E8vfJ;;A+E5wfE;EAcE,uBAAA;A/EkwfJ;;A+EhxfE;EAcE,sBAAA;A/EswfJ;;A+EpxfE;EAcE,uBAAA;A/E0wfJ;;A+ExxfE;EAcE,uBAAA;A/E8wfJ;;A+E5xfE;EAcE,uBAAA;A/EkxfJ;;A+EhyfE;EAcE,uBAAA;A/EsxfJ;;A+EpyfE;EAcE,uBAAA;A/E0xfJ;;A+ExyfE;EAcE,uBAAA;A/E8xfJ;;A+E5yfE;EAcE,uBAAA;A/EkyfJ;;A+EhzfE;EAcE,uBAAA;A/EsyfJ;;A+EpzfE;EAcE,uBAAA;A/E0yfJ;;A+ExzfE;EAcE,0BAAA;A/E8yfJ;;A+E5zfE;EAcE,0BAAA;A/EkzfJ;;A+Eh0fE;EAcE,0BAAA;A/EszfJ;;A+Ep0fE;EAcE,0BAAA;A/E0zfJ;;A+Ex0fE;EAcE,0BAAA;A/E8zfJ;;A+E50fE;EAcE,0BAAA;A/Ek0fJ;;A+Eh1fE;EAcE,0BAAA;A/Es0fJ;;A+Ep1fE;EAcE,0BAAA;A/E00fJ;;A+Ex1fE;EAcE,0BAAA;A/E80fJ;;A+E51fE;EAcE,2BAAA;A/Ek1fJ;;A+Eh2fE;EAcE,0BAAA;A/Es1fJ;;A+Ep2fE;EAcE,2BAAA;A/E01fJ;;A+Ex2fE;EAcE,2BAAA;A/E81fJ;;A+E52fE;EAcE,2BAAA;A/Ek2fJ;;A+Eh3fE;EAcE,2BAAA;A/Es2fJ;;A+Ep3fE;EAcE,2BAAA;A/E02fJ;;A+Ex3fE;EAcE,2BAAA;A/E82fJ;;A+E53fE;EAcE,2BAAA;A/Ek3fJ;;A+Eh4fE;EAcE,2BAAA;A/Es3fJ;;A+Ep4fE;EAcE,2BAAA;A/E03fJ;;A+Ex4fE;EAcE,4BAAA;A/E83fJ;;A+E54fE;EAcE,4BAAA;A/Ek4fJ;;A+Eh5fE;EAcE,4BAAA;A/Es4fJ;;A+Ep5fE;EAcE,4BAAA;A/E04fJ;;A+Ex5fE;EAcE,4BAAA;A/E84fJ;;A+E55fE;EAcE,4BAAA;A/Ek5fJ;;A+Eh6fE;EAcE,4BAAA;A/Es5fJ;;A+Ep6fE;EAcE,4BAAA;A/E05fJ;;A+Ex6fE;EAcE,4BAAA;A/E85fJ;;A+E56fE;EAcE,6BAAA;A/Ek6fJ;;A+Eh7fE;EAcE,4BAAA;A/Es6fJ;;A+Ep7fE;EAcE,6BAAA;A/E06fJ;;A+Ex7fE;EAcE,6BAAA;A/E86fJ;;A+E57fE;EAcE,6BAAA;A/Ek7fJ;;A+Eh8fE;EAcE,6BAAA;A/Es7fJ;;A+Ep8fE;EAcE,6BAAA;A/E07fJ;;A+Ex8fE;EAcE,6BAAA;A/E87fJ;;A+E58fE;EAcE,6BAAA;A/Ek8fJ;;A+Eh9fE;EAcE,6BAAA;A/Es8fJ;;A+Ep9fE;EAcE,6BAAA;A/E08fJ;;A+Ex9fE;EAcE,6BAAA;A/E88fJ;;A+E59fE;EAcE,6BAAA;A/Ek9fJ;;A+Eh+fE;EAcE,6BAAA;A/Es9fJ;;A+Ep+fE;EAcE,6BAAA;A/E09fJ;;A+Ex+fE;EAcE,6BAAA;A/E89fJ;;A+E5+fE;EAcE,6BAAA;A/Ek+fJ;;A+Eh/fE;EAcE,6BAAA;A/Es+fJ;;A+Ep/fE;EAcE,6BAAA;A/E0+fJ;;A+Ex/fE;EAcE,6BAAA;A/E8+fJ;;A+E5/fE;EAcE,8BAAA;A/Ek/fJ;;A+EhggBE;EAcE,6BAAA;A/Es/fJ;;A+EpggBE;EAcE,8BAAA;A/E0/fJ;;A+ExggBE;EAcE,8BAAA;A/E8/fJ;;A+E5ggBE;EAcE,8BAAA;A/EkggBJ;;A+EhhgBE;EAcE,8BAAA;A/EsggBJ;;A+EphgBE;EAcE,8BAAA;A/E0ggBJ;;A+ExhgBE;EAcE,8BAAA;A/E8ggBJ;;A+E5hgBE;EAcE,8BAAA;A/EkhgBJ;;A+EhigBE;EAcE,8BAAA;A/EshgBJ;;A+EpigBE;EAcE,8BAAA;A/E0hgBJ;;A+ExigBE;EAcE,2BAAA;A/E8hgBJ;;A+E5igBE;EAcE,2BAAA;A/EkigBJ;;A+EhjgBE;EAcE,2BAAA;A/EsigBJ;;A+EpjgBE;EAcE,2BAAA;A/E0igBJ;;A+ExjgBE;EAcE,2BAAA;A/E8igBJ;;A+E5jgBE;EAcE,2BAAA;A/EkjgBJ;;A+EhkgBE;EAcE,2BAAA;A/EsjgBJ;;A+EpkgBE;EAcE,2BAAA;A/E0jgBJ;;A+ExkgBE;EAcE,2BAAA;A/E8jgBJ;;A+E5kgBE;EAcE,4BAAA;A/EkkgBJ;;A+EhlgBE;EAcE,2BAAA;A/EskgBJ;;A+EplgBE;EAcE,4BAAA;A/E0kgBJ;;A+ExlgBE;EAcE,4BAAA;A/E8kgBJ;;A+E5lgBE;EAcE,4BAAA;A/EklgBJ;;A+EhmgBE;EAcE,4BAAA;A/EslgBJ;;A+EpmgBE;EAcE,4BAAA;A/E0lgBJ;;A+ExmgBE;EAcE,4BAAA;A/E8lgBJ;;A+E5mgBE;EAcE,4BAAA;A/EkmgBJ;;A+EhngBE;EAcE,4BAAA;A/EsmgBJ;;A+EpngBE;EAcE,4BAAA;A/E0mgBJ;;A+ExngBE;EAEE,2BAAA;EACA,4BAAA;A/E0ngBJ;;A+E7ngBE;EAEE,2BAAA;EACA,4BAAA;A/E+ngBJ;;A+ElogBE;EAEE,2BAAA;EACA,4BAAA;A/EoogBJ;;A+EvogBE;EAEE,2BAAA;EACA,4BAAA;A/EyogBJ;;A+E5ogBE;EAEE,2BAAA;EACA,4BAAA;A/E8ogBJ;;A+EjpgBE;EAEE,2BAAA;EACA,4BAAA;A/EmpgBJ;;A+EtpgBE;EAEE,2BAAA;EACA,4BAAA;A/EwpgBJ;;A+E3pgBE;EAEE,2BAAA;EACA,4BAAA;A/E6pgBJ;;A+EhqgBE;EAEE,2BAAA;EACA,4BAAA;A/EkqgBJ;;A+ErqgBE;EAEE,4BAAA;EACA,6BAAA;A/EuqgBJ;;A+E1qgBE;EAEE,2BAAA;EACA,4BAAA;A/E4qgBJ;;A+E/qgBE;EAEE,4BAAA;EACA,6BAAA;A/EirgBJ;;A+EprgBE;EAEE,4BAAA;EACA,6BAAA;A/EsrgBJ;;A+EzrgBE;EAEE,4BAAA;EACA,6BAAA;A/E2rgBJ;;A+E9rgBE;EAEE,4BAAA;EACA,6BAAA;A/EgsgBJ;;A+EnsgBE;EAEE,4BAAA;EACA,6BAAA;A/EqsgBJ;;A+ExsgBE;EAEE,4BAAA;EACA,6BAAA;A/E0sgBJ;;A+E7sgBE;EAEE,4BAAA;EACA,6BAAA;A/E+sgBJ;;A+EltgBE;EAEE,4BAAA;EACA,6BAAA;A/EotgBJ;;A+EvtgBE;EAEE,4BAAA;EACA,6BAAA;A/EytgBJ;;A+E5tgBE;EAKE,0BAAA;EACA,6BAAA;A/E2tgBJ;;A+EjugBE;EAKE,0BAAA;EACA,6BAAA;A/EgugBJ;;A+EtugBE;EAKE,0BAAA;EACA,6BAAA;A/EqugBJ;;A+E3ugBE;EAKE,0BAAA;EACA,6BAAA;A/E0ugBJ;;A+EhvgBE;EAKE,0BAAA;EACA,6BAAA;A/E+ugBJ;;A+ErvgBE;EAKE,0BAAA;EACA,6BAAA;A/EovgBJ;;A+E1vgBE;EAKE,0BAAA;EACA,6BAAA;A/EyvgBJ;;A+E/vgBE;EAKE,0BAAA;EACA,6BAAA;A/E8vgBJ;;A+EpwgBE;EAKE,0BAAA;EACA,6BAAA;A/EmwgBJ;;A+EzwgBE;EAKE,2BAAA;EACA,8BAAA;A/EwwgBJ;;A+E9wgBE;EAKE,0BAAA;EACA,6BAAA;A/E6wgBJ;;A+EnxgBE;EAKE,2BAAA;EACA,8BAAA;A/EkxgBJ;;A+ExxgBE;EAKE,2BAAA;EACA,8BAAA;A/EuxgBJ;;A+E7xgBE;EAKE,2BAAA;EACA,8BAAA;A/E4xgBJ;;A+ElygBE;EAKE,2BAAA;EACA,8BAAA;A/EiygBJ;;A+EvygBE;EAKE,2BAAA;EACA,8BAAA;A/EsygBJ;;A+E5ygBE;EAKE,2BAAA;EACA,8BAAA;A/E2ygBJ;;A+EjzgBE;EAKE,2BAAA;EACA,8BAAA;A/EgzgBJ;;A+EtzgBE;EAKE,2BAAA;EACA,8BAAA;A/EqzgBJ;;A+E3zgBE;EAKE,2BAAA;EACA,8BAAA;A/E0zgBJ;;A8Er1gBA,mBAAA;ACqBE;EAcE,uBAAA;A/EuzgBJ;;A+Er0gBE;EAcE,uBAAA;A/E2zgBJ;;A+Ez0gBE;EAcE,uBAAA;A/E+zgBJ;;A+E70gBE;EAcE,uBAAA;A/Em0gBJ;;A+Ej1gBE;EAcE,uBAAA;A/Eu0gBJ;;A+Er1gBE;EAcE,uBAAA;A/E20gBJ;;A+Ez1gBE;EAcE,uBAAA;A/E+0gBJ;;A+E71gBE;EAcE,uBAAA;A/Em1gBJ;;A+Ej2gBE;EAcE,uBAAA;A/Eu1gBJ;;A+Er2gBE;EAcE,wBAAA;A/E21gBJ;;A+Ez2gBE;EAcE,uBAAA;A/E+1gBJ;;A+E72gBE;EAcE,wBAAA;A/Em2gBJ;;A+Ej3gBE;EAcE,wBAAA;A/Eu2gBJ;;A+Er3gBE;EAcE,wBAAA;A/E22gBJ;;A+Ez3gBE;EAcE,wBAAA;A/E+2gBJ;;A+E73gBE;EAcE,wBAAA;A/Em3gBJ;;A+Ej4gBE;EAcE,wBAAA;A/Eu3gBJ;;A+Er4gBE;EAcE,wBAAA;A/E23gBJ;;A+Ez4gBE;EAcE,wBAAA;A/E+3gBJ;;A+E74gBE;EAcE,wBAAA;A/Em4gBJ;;A+Ej5gBE;EAcE,2BAAA;A/Eu4gBJ;;A+Er5gBE;EAcE,2BAAA;A/E24gBJ;;A+Ez5gBE;EAcE,2BAAA;A/E+4gBJ;;A+E75gBE;EAcE,2BAAA;A/Em5gBJ;;A+Ej6gBE;EAcE,2BAAA;A/Eu5gBJ;;A+Er6gBE;EAcE,2BAAA;A/E25gBJ;;A+Ez6gBE;EAcE,2BAAA;A/E+5gBJ;;A+E76gBE;EAcE,2BAAA;A/Em6gBJ;;A+Ej7gBE;EAcE,2BAAA;A/Eu6gBJ;;A+Er7gBE;EAcE,4BAAA;A/E26gBJ;;A+Ez7gBE;EAcE,2BAAA;A/E+6gBJ;;A+E77gBE;EAcE,4BAAA;A/Em7gBJ;;A+Ej8gBE;EAcE,4BAAA;A/Eu7gBJ;;A+Er8gBE;EAcE,4BAAA;A/E27gBJ;;A+Ez8gBE;EAcE,4BAAA;A/E+7gBJ;;A+E78gBE;EAcE,4BAAA;A/Em8gBJ;;A+Ej9gBE;EAcE,4BAAA;A/Eu8gBJ;;A+Er9gBE;EAcE,4BAAA;A/E28gBJ;;A+Ez9gBE;EAcE,4BAAA;A/E+8gBJ;;A+E79gBE;EAcE,4BAAA;A/Em9gBJ;;A+Ej+gBE;EAcE,6BAAA;A/Eu9gBJ;;A+Er+gBE;EAcE,6BAAA;A/E29gBJ;;A+Ez+gBE;EAcE,6BAAA;A/E+9gBJ;;A+E7+gBE;EAcE,6BAAA;A/Em+gBJ;;A+Ej/gBE;EAcE,6BAAA;A/Eu+gBJ;;A+Er/gBE;EAcE,6BAAA;A/E2+gBJ;;A+Ez/gBE;EAcE,6BAAA;A/E++gBJ;;A+E7/gBE;EAcE,6BAAA;A/Em/gBJ;;A+EjghBE;EAcE,6BAAA;A/Eu/gBJ;;A+ErghBE;EAcE,8BAAA;A/E2/gBJ;;A+EzghBE;EAcE,6BAAA;A/E+/gBJ;;A+E7ghBE;EAcE,8BAAA;A/EmghBJ;;A+EjhhBE;EAcE,8BAAA;A/EughBJ;;A+ErhhBE;EAcE,8BAAA;A/E2ghBJ;;A+EzhhBE;EAcE,8BAAA;A/E+ghBJ;;A+E7hhBE;EAcE,8BAAA;A/EmhhBJ;;A+EjihBE;EAcE,8BAAA;A/EuhhBJ;;A+ErihBE;EAcE,8BAAA;A/E2hhBJ;;A+EzihBE;EAcE,8BAAA;A/E+hhBJ;;A+E7ihBE;EAcE,8BAAA;A/EmihBJ;;A+EjjhBE;EAcE,8BAAA;A/EuihBJ;;A+ErjhBE;EAcE,8BAAA;A/E2ihBJ;;A+EzjhBE;EAcE,8BAAA;A/E+ihBJ;;A+E7jhBE;EAcE,8BAAA;A/EmjhBJ;;A+EjkhBE;EAcE,8BAAA;A/EujhBJ;;A+ErkhBE;EAcE,8BAAA;A/E2jhBJ;;A+EzkhBE;EAcE,8BAAA;A/E+jhBJ;;A+E7khBE;EAcE,8BAAA;A/EmkhBJ;;A+EjlhBE;EAcE,8BAAA;A/EukhBJ;;A+ErlhBE;EAcE,+BAAA;A/E2khBJ;;A+EzlhBE;EAcE,8BAAA;A/E+khBJ;;A+E7lhBE;EAcE,+BAAA;A/EmlhBJ;;A+EjmhBE;EAcE,+BAAA;A/EulhBJ;;A+ErmhBE;EAcE,+BAAA;A/E2lhBJ;;A+EzmhBE;EAcE,+BAAA;A/E+lhBJ;;A+E7mhBE;EAcE,+BAAA;A/EmmhBJ;;A+EjnhBE;EAcE,+BAAA;A/EumhBJ;;A+ErnhBE;EAcE,+BAAA;A/E2mhBJ;;A+EznhBE;EAcE,+BAAA;A/E+mhBJ;;A+E7nhBE;EAcE,+BAAA;A/EmnhBJ;;A+EjohBE;EAcE,4BAAA;A/EunhBJ;;A+ErohBE;EAcE,4BAAA;A/E2nhBJ;;A+EzohBE;EAcE,4BAAA;A/E+nhBJ;;A+E7ohBE;EAcE,4BAAA;A/EmohBJ;;A+EjphBE;EAcE,4BAAA;A/EuohBJ;;A+ErphBE;EAcE,4BAAA;A/E2ohBJ;;A+EzphBE;EAcE,4BAAA;A/E+ohBJ;;A+E7phBE;EAcE,4BAAA;A/EmphBJ;;A+EjqhBE;EAcE,4BAAA;A/EuphBJ;;A+ErqhBE;EAcE,6BAAA;A/E2phBJ;;A+EzqhBE;EAcE,4BAAA;A/E+phBJ;;A+E7qhBE;EAcE,6BAAA;A/EmqhBJ;;A+EjrhBE;EAcE,6BAAA;A/EuqhBJ;;A+ErrhBE;EAcE,6BAAA;A/E2qhBJ;;A+EzrhBE;EAcE,6BAAA;A/E+qhBJ;;A+E7rhBE;EAcE,6BAAA;A/EmrhBJ;;A+EjshBE;EAcE,6BAAA;A/EurhBJ;;A+ErshBE;EAcE,6BAAA;A/E2rhBJ;;A+EzshBE;EAcE,6BAAA;A/E+rhBJ;;A+E7shBE;EAcE,6BAAA;A/EmshBJ;;A+EjthBE;EAQE,4BAAA;EACA,6BAAA;A/E6shBJ;;A+EtthBE;EAQE,4BAAA;EACA,6BAAA;A/EkthBJ;;A+E3thBE;EAQE,4BAAA;EACA,6BAAA;A/EuthBJ;;A+EhuhBE;EAQE,4BAAA;EACA,6BAAA;A/E4thBJ;;A+EruhBE;EAQE,4BAAA;EACA,6BAAA;A/EiuhBJ;;A+E1uhBE;EAQE,4BAAA;EACA,6BAAA;A/EsuhBJ;;A+E/uhBE;EAQE,4BAAA;EACA,6BAAA;A/E2uhBJ;;A+EpvhBE;EAQE,4BAAA;EACA,6BAAA;A/EgvhBJ;;A+EzvhBE;EAQE,4BAAA;EACA,6BAAA;A/EqvhBJ;;A+E9vhBE;EAQE,6BAAA;EACA,8BAAA;A/E0vhBJ;;A+EnwhBE;EAQE,4BAAA;EACA,6BAAA;A/E+vhBJ;;A+ExwhBE;EAQE,6BAAA;EACA,8BAAA;A/EowhBJ;;A+E7whBE;EAQE,6BAAA;EACA,8BAAA;A/EywhBJ;;A+ElxhBE;EAQE,6BAAA;EACA,8BAAA;A/E8whBJ;;A+EvxhBE;EAQE,6BAAA;EACA,8BAAA;A/EmxhBJ;;A+E5xhBE;EAQE,6BAAA;EACA,8BAAA;A/EwxhBJ;;A+EjyhBE;EAQE,6BAAA;EACA,8BAAA;A/E6xhBJ;;A+EtyhBE;EAQE,6BAAA;EACA,8BAAA;A/EkyhBJ;;A+E3yhBE;EAQE,6BAAA;EACA,8BAAA;A/EuyhBJ;;A+EhzhBE;EAQE,6BAAA;EACA,8BAAA;A/E4yhBJ;;A+ErzhBE;EAWE,2BAAA;EACA,8BAAA;A/E8yhBJ;;A+E1zhBE;EAWE,2BAAA;EACA,8BAAA;A/EmzhBJ;;A+E/zhBE;EAWE,2BAAA;EACA,8BAAA;A/EwzhBJ;;A+Ep0hBE;EAWE,2BAAA;EACA,8BAAA;A/E6zhBJ;;A+Ez0hBE;EAWE,2BAAA;EACA,8BAAA;A/Ek0hBJ;;A+E90hBE;EAWE,2BAAA;EACA,8BAAA;A/Eu0hBJ;;A+En1hBE;EAWE,2BAAA;EACA,8BAAA;A/E40hBJ;;A+Ex1hBE;EAWE,2BAAA;EACA,8BAAA;A/Ei1hBJ;;A+E71hBE;EAWE,2BAAA;EACA,8BAAA;A/Es1hBJ;;A+El2hBE;EAWE,4BAAA;EACA,+BAAA;A/E21hBJ;;A+Ev2hBE;EAWE,2BAAA;EACA,8BAAA;A/Eg2hBJ;;A+E52hBE;EAWE,4BAAA;EACA,+BAAA;A/Eq2hBJ;;A+Ej3hBE;EAWE,4BAAA;EACA,+BAAA;A/E02hBJ;;A+Et3hBE;EAWE,4BAAA;EACA,+BAAA;A/E+2hBJ;;A+E33hBE;EAWE,4BAAA;EACA,+BAAA;A/Eo3hBJ;;A+Eh4hBE;EAWE,4BAAA;EACA,+BAAA;A/Ey3hBJ;;A+Er4hBE;EAWE,4BAAA;EACA,+BAAA;A/E83hBJ;;A+E14hBE;EAWE,4BAAA;EACA,+BAAA;A/Em4hBJ;;A+E/4hBE;EAWE,4BAAA;EACA,+BAAA;A/Ew4hBJ;;A+Ep5hBE;EAWE,4BAAA;EACA,+BAAA;A/E64hBJ;;A8Er6hBA,gBAAA;AEhBE;EACC,yBAAA;AhFy7hBH;;AgF17hBE;EACC,yBAAA;AhF67hBH;;AgF97hBE;EACC,yBAAA;AhFi8hBH;;AgFl8hBE;EACC,yBAAA;AhFq8hBH;;AgFt8hBE;EACC,yBAAA;AhFy8hBH;;AgF18hBE;EACC,yBAAA;AhF68hBH;;AgF98hBE;EACC,yBAAA;AhFi9hBH;;AgFl9hBE;EACC,yBAAA;AhFq9hBH;;AgFt9hBE;EACC,yBAAA;AhFy9hBH;;AgF19hBE;EACC,yBAAA;AhF69hBH;;AgF99hBE;EACC,0BAAA;AhFi+hBH;;AgFl+hBE;EACC,0BAAA;AhFq+hBH;;AgFt+hBE;EACC,0BAAA;AhFy+hBH;;AgF1+hBE;EACC,0BAAA;AhF6+hBH;;AgF9+hBE;EACC,0BAAA;AhFi/hBH;;AgFl/hBE;EACC,0BAAA;AhFq/hBH;;AgFt/hBE;EACC,0BAAA;AhFy/hBH;;AgF1/hBE;EACC,0BAAA;AhF6/hBH;;AgF9/hBE;EACC,0BAAA;AhFigiBH;;AgFlgiBE;EACC,0BAAA;AhFqgiBH;;AgFtgiBE;EACC,0BAAA;AhFygiBH;;AgF1giBE;EACC,0BAAA;AhF6giBH;;AgF9giBE;EACC,0BAAA;AhFihiBH;;AgFlhiBE;EACC,0BAAA;AhFqhiBH;;AgFthiBE;EACC,0BAAA;AhFyhiBH;;AgF1hiBE;EACC,0BAAA;AhF6hiBH;;AgF9hiBE;EACC,0BAAA;AhFiiiBH;;AgFliiBE;EACC,0BAAA;AhFqiiBH;;AgFtiiBE;EACC,0BAAA;AhFyiiBH;;AgF1iiBE;EACC,0BAAA;AhF6iiBH;;AgF9iiBE;EACC,0BAAA;AhFijiBH;;AgFljiBE;EACC,0BAAA;AhFqjiBH;;AgFtjiBE;EACC,0BAAA;AhFyjiBH;;AgF1jiBE;EACC,0BAAA;AhF6jiBH;;AgF9jiBE;EACC,0BAAA;AhFikiBH;;AgFlkiBE;EACC,0BAAA;AhFqkiBH;;AgFtkiBE;EACC,0BAAA;AhFykiBH;;AgF1kiBE;EACC,0BAAA;AhF6kiBH;;AgF9kiBE;EACC,0BAAA;AhFiliBH;;AgFlliBE;EACC,0BAAA;AhFqliBH;;AgFtliBE;EACC,0BAAA;AhFyliBH;;AgF1liBE;EACC,0BAAA;AhF6liBH;;AgF9liBE;EACC,0BAAA;AhFimiBH;;AgFlmiBE;EACC,0BAAA;AhFqmiBH;;AgFtmiBE;EACC,0BAAA;AhFymiBH;;AgF1miBE;EACC,0BAAA;AhF6miBH;;AgF9miBE;EACC,0BAAA;AhFiniBH;;AgFlniBE;EACC,0BAAA;AhFqniBH;;AgFtniBE;EACC,0BAAA;AhFyniBH;;AgF1niBE;EACC,0BAAA;AhF6niBH;;AgF9niBE;EACC,0BAAA;AhFioiBH;;AgFloiBE;EACC,0BAAA;AhFqoiBH;;AgFtoiBE;EACC,0BAAA;AhFyoiBH;;AgF1oiBE;EACC,0BAAA;AhF6oiBH;;AgF9oiBE;EACC,0BAAA;AhFipiBH;;AgFlpiBE;EACC,0BAAA;AhFqpiBH;;AgFtpiBE;EACC,0BAAA;AhFypiBH;;AgF1piBE;EACC,0BAAA;AhF6piBH;;AgF9piBE;EACC,0BAAA;AhFiqiBH;;AgFlqiBE;EACC,0BAAA;AhFqqiBH;;AgFtqiBE;EACC,0BAAA;AhFyqiBH;;AgF1qiBE;EACC,0BAAA;AhF6qiBH;;AgF9qiBE;EACC,0BAAA;AhFiriBH;;AgFlriBE;EACC,0BAAA;AhFqriBH;;AgFtriBE;EACC,0BAAA;AhFyriBH;;AgF1riBE;EACC,0BAAA;AhF6riBH;;AgF9riBE;EACC,0BAAA;AhFisiBH;;AgFlsiBE;EACC,0BAAA;AhFqsiBH;;AgFtsiBE;EACC,0BAAA;AhFysiBH;;AgF1siBE;EACC,0BAAA;AhF6siBH;;AgF9siBE;EACC,0BAAA;AhFitiBH;;AgFltiBE;EACC,0BAAA;AhFqtiBH;;AgFttiBE;EACC,0BAAA;AhFytiBH;;AgF1tiBE;EACC,0BAAA;AhF6tiBH;;AgF9tiBE;EACC,0BAAA;AhFiuiBH;;AgFluiBE;EACC,0BAAA;AhFquiBH;;AgFtuiBE;EACC,0BAAA;AhFyuiBH;;AgF1uiBE;EACC,0BAAA;AhF6uiBH;;AgF9uiBE;EACC,0BAAA;AhFiviBH;;AgFlviBE;EACC,0BAAA;AhFqviBH;;AgFtviBE;EACC,0BAAA;AhFyviBH;;AiFxviBE;EACC,2BAAA;AjF2viBH;;AiF5viBE;EACC,2BAAA;AjF+viBH;;AiFhwiBE;EACC,2BAAA;AjFmwiBH;;AiFpwiBE;EACC,2BAAA;AjFuwiBH;;AiFxwiBE;EACC,2BAAA;AjF2wiBH;;AiF5wiBE;EACC,2BAAA;AjF+wiBH;;AiFhxiBE;EACC,2BAAA;AjFmxiBH;;AiFpxiBE;EACC,2BAAA;AjFuxiBH;;A8EtwiBA,8BAAA;AACA;EACC,iBAAA;A9EywiBD;;A8EvwiBA;EACC,oBAAA;A9E0wiBD;;A8ExwiBA;EACC,kBAAA;A9E2wiBD;;A8EzwiBA;EACC,mBAAA;A9E4wiBD;;A8E1wiBA;EACC,oBAAA;A9E6wiBD;;A8E3wiBA;EACC,uBAAA;A9E8wiBD;;A8E5wiBA;EACC,qBAAA;A9E+wiBD;;A8E7wiBA;EACC,sBAAA;A9EgxiBD;;A8E7wiBA,gBAAA;AACA;EACC,qCAAA;A9EgxiBD;;A8E9wiBA;EACC,wCAAA;EACA,+CAAA;A9EixiBD;;A8E/wiBA;EACC,yBAAA;A9EkxiBD;;A8E/wiBA,gBAAA;AIxDE;EACC,qBAAA;AlF20iBH;;AkFz0iBE;EACC,qBAAA;AlF40iBH;;AkFh1iBE;EACC,sBAAA;AlFm1iBH;;AkFj1iBE;EACC,qBAAA;AlFo1iBH;;AkFx1iBE;EACC,sBAAA;AlF21iBH;;AkFz1iBE;EACC,qBAAA;AlF41iBH;;AkFh2iBE;EACC,sBAAA;AlFm2iBH;;AkFj2iBE;EACC,qBAAA;AlFo2iBH;;AkFx2iBE;EACC,sBAAA;AlF22iBH;;AkFz2iBE;EACC,qBAAA;AlF42iBH;;AkFh3iBE;EACC,sBAAA;AlFm3iBH;;AkFj3iBE;EACC,qBAAA;AlFo3iBH;;AkFx3iBE;EACC,sBAAA;AlF23iBH;;AkFz3iBE;EACC,qBAAA;AlF43iBH;;AkFh4iBE;EACC,sBAAA;AlFm4iBH;;AkFj4iBE;EACC,qBAAA;AlFo4iBH;;AkFx4iBE;EACC,sBAAA;AlF24iBH;;AkFz4iBE;EACC,qBAAA;AlF44iBH;;AkFh5iBE;EACC,sBAAA;AlFm5iBH;;AkFj5iBE;EACC,sBAAA;AlFo5iBH;;AkFx5iBE;EACC,sBAAA;AlF25iBH;;AkFz5iBE;EACC,sBAAA;AlF45iBH;;AkFh6iBE;EACC,sBAAA;AlFm6iBH;;AkFj6iBE;EACC,sBAAA;AlFo6iBH;;AkFx6iBE;EACC,sBAAA;AlF26iBH;;AkFz6iBE;EACC,sBAAA;AlF46iBH;;AkFh7iBE;EACC,sBAAA;AlFm7iBH;;AkFj7iBE;EACC,sBAAA;AlFo7iBH;;AkFx7iBE;EACC,sBAAA;AlF27iBH;;AkFz7iBE;EACC,sBAAA;AlF47iBH;;AkFh8iBE;EACC,sBAAA;AlFm8iBH;;AkFj8iBE;EACC,sBAAA;AlFo8iBH;;AkFx8iBE;EACC,sBAAA;AlF28iBH;;AkFz8iBE;EACC,sBAAA;AlF48iBH;;AkFh9iBE;EACC,sBAAA;AlFm9iBH;;AkFj9iBE;EACC,sBAAA;AlFo9iBH;;AkFx9iBE;EACC,sBAAA;AlF29iBH;;AkFz9iBE;EACC,sBAAA;AlF49iBH;;AkFh+iBE;EACC,uBAAA;AlFm+iBH;;AkFj+iBE;EACC,sBAAA;AlFo+iBH;;AkFx+iBE;EACC,uBAAA;AlF2+iBH;;AkFz+iBE;EACC,sBAAA;AlF4+iBH;;AkFh/iBE;EACC,uBAAA;AlFm/iBH;;AkFj/iBE;EACC,sBAAA;AlFo/iBH;;AkFx/iBE;EACC,uBAAA;AlF2/iBH;;AkFz/iBE;EACC,sBAAA;AlF4/iBH;;AkFhgjBE;EACC,uBAAA;AlFmgjBH;;AkFjgjBE;EACC,sBAAA;AlFogjBH;;AkFxgjBE;EACC,uBAAA;AlF2gjBH;;AkFzgjBE;EACC,sBAAA;AlF4gjBH;;AkFhhjBE;EACC,uBAAA;AlFmhjBH;;AkFjhjBE;EACC,sBAAA;AlFohjBH;;AkFxhjBE;EACC,uBAAA;AlF2hjBH;;AkFzhjBE;EACC,sBAAA;AlF4hjBH;;AkFhijBE;EACC,uBAAA;AlFmijBH;;AkFjijBE;EACC,sBAAA;AlFoijBH;;AkFxijBE;EACC,uBAAA;AlF2ijBH;;AkFzijBE;EACC,sBAAA;AlF4ijBH;;AkFhjjBE;EACC,uBAAA;AlFmjjBH;;AkFjjjBE;EACC,sBAAA;AlFojjBH;;AkFxjjBE;EACC,uBAAA;AlF2jjBH;;AkFzjjBE;EACC,sBAAA;AlF4jjBH;;AkFhkjBE;EACC,uBAAA;AlFmkjBH;;AkFjkjBE;EACC,sBAAA;AlFokjBH;;AkFxkjBE;EACC,uBAAA;AlF2kjBH;;AkFzkjBE;EACC,sBAAA;AlF4kjBH;;AkFhljBE;EACC,uBAAA;AlFmljBH;;AkFjljBE;EACC,sBAAA;AlFoljBH;;AkFxljBE;EACC,uBAAA;AlF2ljBH;;AkFzljBE;EACC,sBAAA;AlF4ljBH;;AkFhmjBE;EACC,uBAAA;AlFmmjBH;;AkFjmjBE;EACC,sBAAA;AlFomjBH;;AkFxmjBE;EACC,uBAAA;AlF2mjBH;;AkFzmjBE;EACC,sBAAA;AlF4mjBH;;AkFhnjBE;EACC,uBAAA;AlFmnjBH;;AkFjnjBE;EACC,sBAAA;AlFonjBH;;AkFxnjBE;EACC,uBAAA;AlF2njBH;;AkFznjBE;EACC,sBAAA;AlF4njBH;;AkFhojBE;EACC,uBAAA;AlFmojBH;;AkFjojBE;EACC,sBAAA;AlFoojBH;;AkF9njBE;EACC,uBAAA;AlFiojBH;;AkFlojBE;EACC,uBAAA;AlFqojBH;;AkFtojBE;EACC,uBAAA;AlFyojBH;;AkF1ojBE;EACC,uBAAA;AlF6ojBH;;AkF9ojBE;EACC,uBAAA;AlFipjBH;;AkFlpjBE;EACC,uBAAA;AlFqpjBH;;AkFtpjBE;EACC,uBAAA;AlFypjBH;;AkF1pjBE;EACC,uBAAA;AlF6pjBH;;AkFxqjBE;EACC,sBAAA;AlF2qjBH;;AkFzqjBE;EACC,sBAAA;AlF4qjBH;;AkFhrjBE;EACC,uBAAA;AlFmrjBH;;AkFjrjBE;EACC,sBAAA;AlForjBH;;AkFxrjBE;EACC,uBAAA;AlF2rjBH;;AkFzrjBE;EACC,sBAAA;AlF4rjBH;;AkFhsjBE;EACC,uBAAA;AlFmsjBH;;AkFjsjBE;EACC,sBAAA;AlFosjBH;;AkFxsjBE;EACC,uBAAA;AlF2sjBH;;AkFzsjBE;EACC,sBAAA;AlF4sjBH;;AkFhtjBE;EACC,uBAAA;AlFmtjBH;;AkFjtjBE;EACC,sBAAA;AlFotjBH;;AkFxtjBE;EACC,uBAAA;AlF2tjBH;;AkFztjBE;EACC,sBAAA;AlF4tjBH;;AkFhujBE;EACC,uBAAA;AlFmujBH;;AkFjujBE;EACC,sBAAA;AlFoujBH;;AkFxujBE;EACC,uBAAA;AlF2ujBH;;AkFzujBE;EACC,sBAAA;AlF4ujBH;;AkFhvjBE;EACC,uBAAA;AlFmvjBH;;AkFjvjBE;EACC,uBAAA;AlFovjBH;;AkFxvjBE;EACC,uBAAA;AlF2vjBH;;AkFzvjBE;EACC,uBAAA;AlF4vjBH;;AkFhwjBE;EACC,uBAAA;AlFmwjBH;;AkFjwjBE;EACC,uBAAA;AlFowjBH;;AkFxwjBE;EACC,uBAAA;AlF2wjBH;;AkFzwjBE;EACC,uBAAA;AlF4wjBH;;AkFhxjBE;EACC,uBAAA;AlFmxjBH;;AkFjxjBE;EACC,uBAAA;AlFoxjBH;;AkFxxjBE;EACC,uBAAA;AlF2xjBH;;AkFzxjBE;EACC,uBAAA;AlF4xjBH;;AkFhyjBE;EACC,uBAAA;AlFmyjBH;;AkFjyjBE;EACC,uBAAA;AlFoyjBH;;AkFxyjBE;EACC,uBAAA;AlF2yjBH;;AkFzyjBE;EACC,uBAAA;AlF4yjBH;;AkFhzjBE;EACC,uBAAA;AlFmzjBH;;AkFjzjBE;EACC,uBAAA;AlFozjBH;;AkFxzjBE;EACC,uBAAA;AlF2zjBH;;AkFzzjBE;EACC,uBAAA;AlF4zjBH;;AkFh0jBE;EACC,wBAAA;AlFm0jBH;;AkFj0jBE;EACC,uBAAA;AlFo0jBH;;AkFx0jBE;EACC,wBAAA;AlF20jBH;;AkFz0jBE;EACC,uBAAA;AlF40jBH;;AkFh1jBE;EACC,wBAAA;AlFm1jBH;;AkFj1jBE;EACC,uBAAA;AlFo1jBH;;AkFx1jBE;EACC,wBAAA;AlF21jBH;;AkFz1jBE;EACC,uBAAA;AlF41jBH;;AkFh2jBE;EACC,wBAAA;AlFm2jBH;;AkFj2jBE;EACC,uBAAA;AlFo2jBH;;AkFx2jBE;EACC,wBAAA;AlF22jBH;;AkFz2jBE;EACC,uBAAA;AlF42jBH;;AkFh3jBE;EACC,wBAAA;AlFm3jBH;;AkFj3jBE;EACC,uBAAA;AlFo3jBH;;AkFx3jBE;EACC,wBAAA;AlF23jBH;;AkFz3jBE;EACC,uBAAA;AlF43jBH;;AkFh4jBE;EACC,wBAAA;AlFm4jBH;;AkFj4jBE;EACC,uBAAA;AlFo4jBH;;AkFx4jBE;EACC,wBAAA;AlF24jBH;;AkFz4jBE;EACC,uBAAA;AlF44jBH;;AkFh5jBE;EACC,wBAAA;AlFm5jBH;;AkFj5jBE;EACC,uBAAA;AlFo5jBH;;AkFx5jBE;EACC,wBAAA;AlF25jBH;;AkFz5jBE;EACC,uBAAA;AlF45jBH;;AkFh6jBE;EACC,wBAAA;AlFm6jBH;;AkFj6jBE;EACC,uBAAA;AlFo6jBH;;AkFx6jBE;EACC,wBAAA;AlF26jBH;;AkFz6jBE;EACC,uBAAA;AlF46jBH;;AkFh7jBE;EACC,wBAAA;AlFm7jBH;;AkFj7jBE;EACC,uBAAA;AlFo7jBH;;AkFx7jBE;EACC,wBAAA;AlF27jBH;;AkFz7jBE;EACC,uBAAA;AlF47jBH;;AkFh8jBE;EACC,wBAAA;AlFm8jBH;;AkFj8jBE;EACC,uBAAA;AlFo8jBH;;AkFx8jBE;EACC,wBAAA;AlF28jBH;;AkFz8jBE;EACC,uBAAA;AlF48jBH;;AkFh9jBE;EACC,wBAAA;AlFm9jBH;;AkFj9jBE;EACC,uBAAA;AlFo9jBH;;AkFx9jBE;EACC,wBAAA;AlF29jBH;;AkFz9jBE;EACC,uBAAA;AlF49jBH;;AkFh+jBE;EACC,wBAAA;AlFm+jBH;;AkFj+jBE;EACC,uBAAA;AlFo+jBH;;AkF99jBE;EACC,wBAAA;AlFi+jBH;;AkFl+jBE;EACC,wBAAA;AlFq+jBH;;AkFt+jBE;EACC,wBAAA;AlFy+jBH;;AkF1+jBE;EACC,wBAAA;AlF6+jBH;;AkF9+jBE;EACC,wBAAA;AlFi/jBH;;AkFl/jBE;EACC,wBAAA;AlFq/jBH;;AkFt/jBE;EACC,wBAAA;AlFy/jBH;;AkF1/jBE;EACC,wBAAA;AlF6/jBH;;A8E58jBA,iBAAA;AK/DE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF+gkBF;;AmFxgkBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;AnF2gkBF;;AmFxgkBE;EACC,oBAAA;EACA,6DAAA;AnF2gkBH;;AmFzgkBE;EACC,kBAAA;EACA,sEAAA;AnF4gkBH;;AmF1gkBE;EACC,oBAAA;EACA,4DAAA;AnF6gkBH;;AmF3gkBE;EACC,kBAAA;EACA,qEAAA;AnF8gkBH;;AmF5hkBE;EACC,oBAAA;EACA,6DAAA;AnF+hkBH;;AmF7hkBE;EACC,kBAAA;EACA,sEAAA;AnFgikBH;;AmF9hkBE;EACC,oBAAA;EACA,0DAAA;AnFiikBH;;AmF/hkBE;EACC,kBAAA;EACA,mEAAA;AnFkikBH;;AmFhjkBE;EACC,oBAAA;EACA,6DAAA;AnFmjkBH;;AmFjjkBE;EACC,kBAAA;EACA,sEAAA;AnFojkBH;;AmFljkBE;EACC,oBAAA;EACA,0DAAA;AnFqjkBH;;AmFnjkBE;EACC,kBAAA;EACA,mEAAA;AnFsjkBH;;AmFpkkBE;EACC,oBAAA;EACA,6DAAA;AnFukkBH;;AmFrkkBE;EACC,kBAAA;EACA,sEAAA;AnFwkkBH;;AmFtkkBE;EACC,oBAAA;EACA,0DAAA;AnFykkBH;;AmFvkkBE;EACC,kBAAA;EACA,mEAAA;AnF0kkBH;;AmF3mkBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF8mkBF;;AmF5mkBE;EAEC,wCAAA;AnF8mkBH;;AmF3mkBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF8mkBF;;AmF3mkBE;EACC,oBAAA;EACA,6DAAA;AnF8mkBH;;AmF5mkBE;EACC,kBAAA;EACA,sEAAA;AnF+mkBH;;AmF7mkBE;EACC,oBAAA;EACA,2DAAA;AnFgnkBH;;AmF9mkBE;EACC,kBAAA;EACA,oEAAA;AnFinkBH;;AmF/nkBE;EACC,oBAAA;EACA,6DAAA;AnFkokBH;;AmFhokBE;EACC,kBAAA;EACA,sEAAA;AnFmokBH;;AmFjokBE;EACC,oBAAA;EACA,0DAAA;AnFookBH;;AmFlokBE;EACC,kBAAA;EACA,mEAAA;AnFqokBH;;AmFnpkBE;EACC,oBAAA;EACA,6DAAA;AnFspkBH;;AmFppkBE;EACC,kBAAA;EACA,sEAAA;AnFupkBH;;AmFrpkBE;EACC,oBAAA;EACA,0DAAA;AnFwpkBH;;AmFtpkBE;EACC,kBAAA;EACA,mEAAA;AnFypkBH;;AmFvqkBE;EACC,oBAAA;EACA,4DAAA;AnF0qkBH;;AmFxqkBE;EACC,kBAAA;EACA,qEAAA;AnF2qkBH;;AmFzqkBE;EACC,oBAAA;EACA,yDAAA;AnF4qkBH;;AmF1qkBE;EACC,kBAAA;EACA,kEAAA;AnF6qkBH;;AmF9skBE;EACA,oCAAA;EAGA,uEAAA;EACA,sJAAA;AnFitkBF;;AmF1skBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnF6skBF;;AmF1skBE;EACC,oBAAA;EACA,6DAAA;AnF6skBH;;AmF3skBE;EACC,kBAAA;EACA,sEAAA;AnF8skBH;;AmF5skBE;EACC,oBAAA;EACA,6DAAA;AnF+skBH;;AmF7skBE;EACC,kBAAA;EACA,sEAAA;AnFgtkBH;;AmF9tkBE;EACC,oBAAA;EACA,6DAAA;AnFiukBH;;AmF/tkBE;EACC,kBAAA;EACA,sEAAA;AnFkukBH;;AmFhukBE;EACC,oBAAA;EACA,6DAAA;AnFmukBH;;AmFjukBE;EACC,kBAAA;EACA,sEAAA;AnFoukBH;;AmFlvkBE;EACC,oBAAA;EACA,6DAAA;AnFqvkBH;;AmFnvkBE;EACC,kBAAA;EACA,sEAAA;AnFsvkBH;;AmFpvkBE;EACC,oBAAA;EACA,6DAAA;AnFuvkBH;;AmFrvkBE;EACC,kBAAA;EACA,sEAAA;AnFwvkBH;;AmFtwkBE;EACC,oBAAA;EACA,6DAAA;AnFywkBH;;AmFvwkBE;EACC,kBAAA;EACA,sEAAA;AnF0wkBH;;AmFxwkBE;EACC,oBAAA;EACA,0DAAA;AnF2wkBH;;AmFzwkBE;EACC,kBAAA;EACA,mEAAA;AnF4wkBH;;AmF7ykBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFgzkBF;;AmFzykBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnF4ykBF;;AmFzykBE;EACC,oBAAA;EACA,6DAAA;AnF4ykBH;;AmF1ykBE;EACC,kBAAA;EACA,sEAAA;AnF6ykBH;;AmF3ykBE;EACC,oBAAA;EACA,0DAAA;AnF8ykBH;;AmF5ykBE;EACC,kBAAA;EACA,mEAAA;AnF+ykBH;;AmF7zkBE;EACC,oBAAA;EACA,6DAAA;AnFg0kBH;;AmF9zkBE;EACC,kBAAA;EACA,sEAAA;AnFi0kBH;;AmF/zkBE;EACC,oBAAA;EACA,0DAAA;AnFk0kBH;;AmFh0kBE;EACC,kBAAA;EACA,mEAAA;AnFm0kBH;;AmFj1kBE;EACC,oBAAA;EACA,6DAAA;AnFo1kBH;;AmFl1kBE;EACC,kBAAA;EACA,sEAAA;AnFq1kBH;;AmFn1kBE;EACC,oBAAA;EACA,0DAAA;AnFs1kBH;;AmFp1kBE;EACC,kBAAA;EACA,mEAAA;AnFu1kBH;;AmFr2kBE;EACC,oBAAA;EACA,4DAAA;AnFw2kBH;;AmFt2kBE;EACC,kBAAA;EACA,qEAAA;AnFy2kBH;;AmFv2kBE;EACC,oBAAA;EACA,yDAAA;AnF02kBH;;AmFx2kBE;EACC,kBAAA;EACA,kEAAA;AnF22kBH;;AmF54kBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF+4kBF;;AmFx4kBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;AnF24kBF;;AmFx4kBE;EACC,oBAAA;EACA,6DAAA;AnF24kBH;;AmFz4kBE;EACC,kBAAA;EACA,sEAAA;AnF44kBH;;AmF14kBE;EACC,oBAAA;EACA,4DAAA;AnF64kBH;;AmF34kBE;EACC,kBAAA;EACA,qEAAA;AnF84kBH;;AmF55kBE;EACC,oBAAA;EACA,6DAAA;AnF+5kBH;;AmF75kBE;EACC,kBAAA;EACA,sEAAA;AnFg6kBH;;AmF95kBE;EACC,oBAAA;EACA,0DAAA;AnFi6kBH;;AmF/5kBE;EACC,kBAAA;EACA,mEAAA;AnFk6kBH;;AmFh7kBE;EACC,oBAAA;EACA,6DAAA;AnFm7kBH;;AmFj7kBE;EACC,kBAAA;EACA,sEAAA;AnFo7kBH;;AmFl7kBE;EACC,oBAAA;EACA,0DAAA;AnFq7kBH;;AmFn7kBE;EACC,kBAAA;EACA,mEAAA;AnFs7kBH;;AmFp8kBE;EACC,oBAAA;EACA,6DAAA;AnFu8kBH;;AmFr8kBE;EACC,kBAAA;EACA,sEAAA;AnFw8kBH;;AmFt8kBE;EACC,oBAAA;EACA,0DAAA;AnFy8kBH;;AmFv8kBE;EACC,kBAAA;EACA,mEAAA;AnF08kBH;;AmF3+kBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF8+kBF;;AmFv+kBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;AnF0+kBF;;AmFv+kBE;EACC,oBAAA;EACA,6DAAA;AnF0+kBH;;AmFx+kBE;EACC,kBAAA;EACA,sEAAA;AnF2+kBH;;AmFz+kBE;EACC,oBAAA;EACA,4DAAA;AnF4+kBH;;AmF1+kBE;EACC,kBAAA;EACA,qEAAA;AnF6+kBH;;AmF3/kBE;EACC,oBAAA;EACA,6DAAA;AnF8/kBH;;AmF5/kBE;EACC,kBAAA;EACA,sEAAA;AnF+/kBH;;AmF7/kBE;EACC,oBAAA;EACA,0DAAA;AnFgglBH;;AmF9/kBE;EACC,kBAAA;EACA,mEAAA;AnFiglBH;;AmF/glBE;EACC,oBAAA;EACA,6DAAA;AnFkhlBH;;AmFhhlBE;EACC,kBAAA;EACA,sEAAA;AnFmhlBH;;AmFjhlBE;EACC,oBAAA;EACA,0DAAA;AnFohlBH;;AmFlhlBE;EACC,kBAAA;EACA,mEAAA;AnFqhlBH;;AmFnilBE;EACC,oBAAA;EACA,4DAAA;AnFsilBH;;AmFpilBE;EACC,kBAAA;EACA,qEAAA;AnFuilBH;;AmFrilBE;EACC,oBAAA;EACA,yDAAA;AnFwilBH;;AmFtilBE;EACC,kBAAA;EACA,kEAAA;AnFyilBH;;AmF1klBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF6klBF;;AmFtklBE;EACA,8BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8CAAA;AnFyklBF;;AmFtklBE;EACC,oBAAA;EACA,6DAAA;AnFyklBH;;AmFvklBE;EACC,kBAAA;EACA,sEAAA;AnF0klBH;;AmFxklBE;EACC,oBAAA;EACA,yDAAA;AnF2klBH;;AmFzklBE;EACC,kBAAA;EACA,kEAAA;AnF4klBH;;AmF1llBE;EACC,oBAAA;EACA,6DAAA;AnF6llBH;;AmF3llBE;EACC,kBAAA;EACA,sEAAA;AnF8llBH;;AmF5llBE;EACC,oBAAA;EACA,yDAAA;AnF+llBH;;AmF7llBE;EACC,kBAAA;EACA,kEAAA;AnFgmlBH;;AmF9mlBE;EACC,oBAAA;EACA,6DAAA;AnFinlBH;;AmF/mlBE;EACC,kBAAA;EACA,sEAAA;AnFknlBH;;AmFhnlBE;EACC,oBAAA;EACA,wDAAA;AnFmnlBH;;AmFjnlBE;EACC,kBAAA;EACA,iEAAA;AnFonlBH;;AmFlolBE;EACC,oBAAA;EACA,2DAAA;AnFqolBH;;AmFnolBE;EACC,kBAAA;EACA,oEAAA;AnFsolBH;;AmFpolBE;EACC,oBAAA;EACA,wDAAA;AnFuolBH;;AmFrolBE;EACC,kBAAA;EACA,iEAAA;AnFwolBH;;AmFzqlBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF4qlBF;;AmFrqlBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFwqlBF;;AmFrqlBE;EACC,oBAAA;EACA,6DAAA;AnFwqlBH;;AmFtqlBE;EACC,kBAAA;EACA,sEAAA;AnFyqlBH;;AmFvqlBE;EACC,oBAAA;EACA,2DAAA;AnF0qlBH;;AmFxqlBE;EACC,kBAAA;EACA,oEAAA;AnF2qlBH;;AmFzrlBE;EACC,oBAAA;EACA,6DAAA;AnF4rlBH;;AmF1rlBE;EACC,kBAAA;EACA,sEAAA;AnF6rlBH;;AmF3rlBE;EACC,oBAAA;EACA,0DAAA;AnF8rlBH;;AmF5rlBE;EACC,kBAAA;EACA,mEAAA;AnF+rlBH;;AmF7slBE;EACC,oBAAA;EACA,6DAAA;AnFgtlBH;;AmF9slBE;EACC,kBAAA;EACA,sEAAA;AnFitlBH;;AmF/slBE;EACC,oBAAA;EACA,0DAAA;AnFktlBH;;AmFhtlBE;EACC,kBAAA;EACA,mEAAA;AnFmtlBH;;AmFjulBE;EACC,oBAAA;EACA,4DAAA;AnFoulBH;;AmFlulBE;EACC,kBAAA;EACA,qEAAA;AnFqulBH;;AmFnulBE;EACC,oBAAA;EACA,yDAAA;AnFsulBH;;AmFpulBE;EACC,kBAAA;EACA,kEAAA;AnFuulBH;;AmFxwlBE;EACA,oCAAA;EAGA,uEAAA;EACA,sJAAA;AnF2wlBF;;AmFpwlBE;EACA,8BAAA;EACA,kCAAA;EACA,oCAAA;EACA,8CAAA;AnFuwlBF;;AmFpwlBE;EACC,oBAAA;EACA,6DAAA;AnFuwlBH;;AmFrwlBE;EACC,kBAAA;EACA,sEAAA;AnFwwlBH;;AmFtwlBE;EACC,oBAAA;EACA,uDAAA;AnFywlBH;;AmFvwlBE;EACC,kBAAA;EACA,gEAAA;AnF0wlBH;;AmFxxlBE;EACC,oBAAA;EACA,6DAAA;AnF2xlBH;;AmFzxlBE;EACC,kBAAA;EACA,sEAAA;AnF4xlBH;;AmF1xlBE;EACC,oBAAA;EACA,uDAAA;AnF6xlBH;;AmF3xlBE;EACC,kBAAA;EACA,gEAAA;AnF8xlBH;;AmF5ylBE;EACC,oBAAA;EACA,6DAAA;AnF+ylBH;;AmF7ylBE;EACC,kBAAA;EACA,sEAAA;AnFgzlBH;;AmF9ylBE;EACC,oBAAA;EACA,uDAAA;AnFizlBH;;AmF/ylBE;EACC,kBAAA;EACA,gEAAA;AnFkzlBH;;AmFh0lBE;EACC,oBAAA;EACA,0DAAA;AnFm0lBH;;AmFj0lBE;EACC,kBAAA;EACA,mEAAA;AnFo0lBH;;AmFl0lBE;EACC,oBAAA;EACA,uDAAA;AnFq0lBH;;AmFn0lBE;EACC,kBAAA;EACA,gEAAA;AnFs0lBH;;AmFv2lBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF02lBF;;AmFn2lBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnFs2lBF;;AmFn2lBE;EACC,oBAAA;EACA,6DAAA;AnFs2lBH;;AmFp2lBE;EACC,kBAAA;EACA,sEAAA;AnFu2lBH;;AmFr2lBE;EACC,oBAAA;EACA,2DAAA;AnFw2lBH;;AmFt2lBE;EACC,kBAAA;EACA,oEAAA;AnFy2lBH;;AmFv3lBE;EACC,oBAAA;EACA,6DAAA;AnF03lBH;;AmFx3lBE;EACC,kBAAA;EACA,sEAAA;AnF23lBH;;AmFz3lBE;EACC,oBAAA;EACA,0DAAA;AnF43lBH;;AmF13lBE;EACC,kBAAA;EACA,mEAAA;AnF63lBH;;AmF34lBE;EACC,oBAAA;EACA,6DAAA;AnF84lBH;;AmF54lBE;EACC,kBAAA;EACA,sEAAA;AnF+4lBH;;AmF74lBE;EACC,oBAAA;EACA,yDAAA;AnFg5lBH;;AmF94lBE;EACC,kBAAA;EACA,kEAAA;AnFi5lBH;;AmF/5lBE;EACC,oBAAA;EACA,4DAAA;AnFk6lBH;;AmFh6lBE;EACC,kBAAA;EACA,qEAAA;AnFm6lBH;;AmFj6lBE;EACC,oBAAA;EACA,yDAAA;AnFo6lBH;;AmFl6lBE;EACC,kBAAA;EACA,kEAAA;AnFq6lBH;;AmFt8lBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFy8lBF;;AmFl8lBE;EACA,8BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnFq8lBF;;AmFl8lBE;EACC,oBAAA;EACA,6DAAA;AnFq8lBH;;AmFn8lBE;EACC,kBAAA;EACA,sEAAA;AnFs8lBH;;AmFp8lBE;EACC,oBAAA;EACA,0DAAA;AnFu8lBH;;AmFr8lBE;EACC,kBAAA;EACA,mEAAA;AnFw8lBH;;AmFt9lBE;EACC,oBAAA;EACA,6DAAA;AnFy9lBH;;AmFv9lBE;EACC,kBAAA;EACA,sEAAA;AnF09lBH;;AmFx9lBE;EACC,oBAAA;EACA,0DAAA;AnF29lBH;;AmFz9lBE;EACC,kBAAA;EACA,mEAAA;AnF49lBH;;AmF1+lBE;EACC,oBAAA;EACA,6DAAA;AnF6+lBH;;AmF3+lBE;EACC,kBAAA;EACA,sEAAA;AnF8+lBH;;AmF5+lBE;EACC,oBAAA;EACA,0DAAA;AnF++lBH;;AmF7+lBE;EACC,kBAAA;EACA,mEAAA;AnFg/lBH;;AmF9/lBE;EACC,oBAAA;EACA,4DAAA;AnFigmBH;;AmF//lBE;EACC,kBAAA;EACA,qEAAA;AnFkgmBH;;AmFhgmBE;EACC,oBAAA;EACA,0DAAA;AnFmgmBH;;AmFjgmBE;EACC,kBAAA;EACA,mEAAA;AnFogmBH;;AmFrimBE;EACA,oCAAA;EAGA,uEAAA;EACA,sJAAA;AnFwimBF;;AmFjimBE;EACA,8BAAA;EACA,kCAAA;EACA,oCAAA;EACA,8CAAA;AnFoimBF;;AmFjimBE;EACC,oBAAA;EACA,6DAAA;AnFoimBH;;AmFlimBE;EACC,kBAAA;EACA,sEAAA;AnFqimBH;;AmFnimBE;EACC,oBAAA;EACA,uDAAA;AnFsimBH;;AmFpimBE;EACC,kBAAA;EACA,gEAAA;AnFuimBH;;AmFrjmBE;EACC,oBAAA;EACA,6DAAA;AnFwjmBH;;AmFtjmBE;EACC,kBAAA;EACA,sEAAA;AnFyjmBH;;AmFvjmBE;EACC,oBAAA;EACA,uDAAA;AnF0jmBH;;AmFxjmBE;EACC,kBAAA;EACA,gEAAA;AnF2jmBH;;AmFzkmBE;EACC,oBAAA;EACA,6DAAA;AnF4kmBH;;AmF1kmBE;EACC,kBAAA;EACA,sEAAA;AnF6kmBH;;AmF3kmBE;EACC,oBAAA;EACA,uDAAA;AnF8kmBH;;AmF5kmBE;EACC,kBAAA;EACA,gEAAA;AnF+kmBH;;AmF7lmBE;EACC,oBAAA;EACA,0DAAA;AnFgmmBH;;AmF9lmBE;EACC,kBAAA;EACA,mEAAA;AnFimmBH;;AmF/lmBE;EACC,oBAAA;EACA,uDAAA;AnFkmmBH;;AmFhmmBE;EACC,kBAAA;EACA,gEAAA;AnFmmmBH;;AmFpomBE;EACA,oCAAA;EAGA,uEAAA;EACA,sJAAA;AnFuomBF;;AmFhomBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFmomBF;;AmFhomBE;EACC,oBAAA;EACA,6DAAA;AnFmomBH;;AmFjomBE;EACC,kBAAA;EACA,sEAAA;AnFoomBH;;AmFlomBE;EACC,oBAAA;EACA,6DAAA;AnFqomBH;;AmFnomBE;EACC,kBAAA;EACA,sEAAA;AnFsomBH;;AmFppmBE;EACC,oBAAA;EACA,6DAAA;AnFupmBH;;AmFrpmBE;EACC,kBAAA;EACA,sEAAA;AnFwpmBH;;AmFtpmBE;EACC,oBAAA;EACA,6DAAA;AnFypmBH;;AmFvpmBE;EACC,kBAAA;EACA,sEAAA;AnF0pmBH;;AmFxqmBE;EACC,oBAAA;EACA,6DAAA;AnF2qmBH;;AmFzqmBE;EACC,kBAAA;EACA,sEAAA;AnF4qmBH;;AmF1qmBE;EACC,oBAAA;EACA,6DAAA;AnF6qmBH;;AmF3qmBE;EACC,kBAAA;EACA,sEAAA;AnF8qmBH;;AmF5rmBE;EACC,oBAAA;EACA,6DAAA;AnF+rmBH;;AmF7rmBE;EACC,kBAAA;EACA,sEAAA;AnFgsmBH;;AmF9rmBE;EACC,oBAAA;EACA,0DAAA;AnFismBH;;AmF/rmBE;EACC,kBAAA;EACA,mEAAA;AnFksmBH;;AmFnumBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFsumBF;;AmF/tmBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFkumBF;;AmF/tmBE;EACC,oBAAA;EACA,6DAAA;AnFkumBH;;AmFhumBE;EACC,kBAAA;EACA,sEAAA;AnFmumBH;;AmFjumBE;EACC,oBAAA;EACA,4DAAA;AnFoumBH;;AmFlumBE;EACC,kBAAA;EACA,qEAAA;AnFqumBH;;AmFnvmBE;EACC,oBAAA;EACA,6DAAA;AnFsvmBH;;AmFpvmBE;EACC,kBAAA;EACA,sEAAA;AnFuvmBH;;AmFrvmBE;EACC,oBAAA;EACA,2DAAA;AnFwvmBH;;AmFtvmBE;EACC,kBAAA;EACA,oEAAA;AnFyvmBH;;AmFvwmBE;EACC,oBAAA;EACA,6DAAA;AnF0wmBH;;AmFxwmBE;EACC,kBAAA;EACA,sEAAA;AnF2wmBH;;AmFzwmBE;EACC,oBAAA;EACA,0DAAA;AnF4wmBH;;AmF1wmBE;EACC,kBAAA;EACA,mEAAA;AnF6wmBH;;AmF3xmBE;EACC,oBAAA;EACA,4DAAA;AnF8xmBH;;AmF5xmBE;EACC,kBAAA;EACA,qEAAA;AnF+xmBH;;AmF7xmBE;EACC,oBAAA;EACA,yDAAA;AnFgymBH;;AmF9xmBE;EACC,kBAAA;EACA,kEAAA;AnFiymBH;;AmFl0mBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFq0mBF;;AmF9zmBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnFi0mBF;;AmF9zmBE;EACC,oBAAA;EACA,6DAAA;AnFi0mBH;;AmF/zmBE;EACC,kBAAA;EACA,sEAAA;AnFk0mBH;;AmFh0mBE;EACC,oBAAA;EACA,2DAAA;AnFm0mBH;;AmFj0mBE;EACC,kBAAA;EACA,oEAAA;AnFo0mBH;;AmFl1mBE;EACC,oBAAA;EACA,6DAAA;AnFq1mBH;;AmFn1mBE;EACC,kBAAA;EACA,sEAAA;AnFs1mBH;;AmFp1mBE;EACC,oBAAA;EACA,2DAAA;AnFu1mBH;;AmFr1mBE;EACC,kBAAA;EACA,oEAAA;AnFw1mBH;;AmFt2mBE;EACC,oBAAA;EACA,6DAAA;AnFy2mBH;;AmFv2mBE;EACC,kBAAA;EACA,sEAAA;AnF02mBH;;AmFx2mBE;EACC,oBAAA;EACA,2DAAA;AnF22mBH;;AmFz2mBE;EACC,kBAAA;EACA,oEAAA;AnF42mBH;;AmF13mBE;EACC,oBAAA;EACA,4DAAA;AnF63mBH;;AmF33mBE;EACC,kBAAA;EACA,qEAAA;AnF83mBH;;AmF53mBE;EACC,oBAAA;EACA,yDAAA;AnF+3mBH;;AmF73mBE;EACC,kBAAA;EACA,kEAAA;AnFg4mBH;;AmFj6mBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFo6mBF;;AmF75mBE;EACA,8BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8CAAA;AnFg6mBF;;AmF75mBE;EACC,oBAAA;EACA,6DAAA;AnFg6mBH;;AmF95mBE;EACC,kBAAA;EACA,sEAAA;AnFi6mBH;;AmF/5mBE;EACC,oBAAA;EACA,yDAAA;AnFk6mBH;;AmFh6mBE;EACC,kBAAA;EACA,kEAAA;AnFm6mBH;;AmFj7mBE;EACC,oBAAA;EACA,6DAAA;AnFo7mBH;;AmFl7mBE;EACC,kBAAA;EACA,sEAAA;AnFq7mBH;;AmFn7mBE;EACC,oBAAA;EACA,yDAAA;AnFs7mBH;;AmFp7mBE;EACC,kBAAA;EACA,kEAAA;AnFu7mBH;;AmFr8mBE;EACC,oBAAA;EACA,6DAAA;AnFw8mBH;;AmFt8mBE;EACC,kBAAA;EACA,sEAAA;AnFy8mBH;;AmFv8mBE;EACC,oBAAA;EACA,wDAAA;AnF08mBH;;AmFx8mBE;EACC,kBAAA;EACA,iEAAA;AnF28mBH;;AmFz9mBE;EACC,oBAAA;EACA,2DAAA;AnF49mBH;;AmF19mBE;EACC,kBAAA;EACA,oEAAA;AnF69mBH;;AmF39mBE;EACC,oBAAA;EACA,wDAAA;AnF89mBH;;AmF59mBE;EACC,kBAAA;EACA,iEAAA;AnF+9mBH;;AmFhgnBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFmgnBF;;AmF5/mBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF+/mBF;;AmF5/mBE;EACC,oBAAA;EACA,6DAAA;AnF+/mBH;;AmF7/mBE;EACC,kBAAA;EACA,sEAAA;AnFggnBH;;AmF9/mBE;EACC,oBAAA;EACA,2DAAA;AnFignBH;;AmF//mBE;EACC,kBAAA;EACA,oEAAA;AnFkgnBH;;AmFhhnBE;EACC,oBAAA;EACA,6DAAA;AnFmhnBH;;AmFjhnBE;EACC,kBAAA;EACA,sEAAA;AnFohnBH;;AmFlhnBE;EACC,oBAAA;EACA,2DAAA;AnFqhnBH;;AmFnhnBE;EACC,kBAAA;EACA,oEAAA;AnFshnBH;;AmFpinBE;EACC,oBAAA;EACA,6DAAA;AnFuinBH;;AmFrinBE;EACC,kBAAA;EACA,sEAAA;AnFwinBH;;AmFtinBE;EACC,oBAAA;EACA,yDAAA;AnFyinBH;;AmFvinBE;EACC,kBAAA;EACA,kEAAA;AnF0inBH;;AmFxjnBE;EACC,oBAAA;EACA,4DAAA;AnF2jnBH;;AmFzjnBE;EACC,kBAAA;EACA,qEAAA;AnF4jnBH;;AmF1jnBE;EACC,oBAAA;EACA,yDAAA;AnF6jnBH;;AmF3jnBE;EACC,kBAAA;EACA,kEAAA;AnF8jnBH;;AmF/lnBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFkmnBF;;AmF3lnBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnF8lnBF;;AmF3lnBE;EACC,oBAAA;EACA,6DAAA;AnF8lnBH;;AmF5lnBE;EACC,kBAAA;EACA,sEAAA;AnF+lnBH;;AmF7lnBE;EACC,oBAAA;EACA,2DAAA;AnFgmnBH;;AmF9lnBE;EACC,kBAAA;EACA,oEAAA;AnFimnBH;;AmF/mnBE;EACC,oBAAA;EACA,6DAAA;AnFknnBH;;AmFhnnBE;EACC,kBAAA;EACA,sEAAA;AnFmnnBH;;AmFjnnBE;EACC,oBAAA;EACA,0DAAA;AnFonnBH;;AmFlnnBE;EACC,kBAAA;EACA,mEAAA;AnFqnnBH;;AmFnonBE;EACC,oBAAA;EACA,6DAAA;AnFsonBH;;AmFponBE;EACC,kBAAA;EACA,sEAAA;AnFuonBH;;AmFronBE;EACC,oBAAA;EACA,yDAAA;AnFwonBH;;AmFtonBE;EACC,kBAAA;EACA,kEAAA;AnFyonBH;;AmFvpnBE;EACC,oBAAA;EACA,2DAAA;AnF0pnBH;;AmFxpnBE;EACC,kBAAA;EACA,oEAAA;AnF2pnBH;;AmFzpnBE;EACC,oBAAA;EACA,wDAAA;AnF4pnBH;;AmF1pnBE;EACC,kBAAA;EACA,iEAAA;AnF6pnBH;;AmF9rnBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFisnBF;;AmF1rnBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;AnF6rnBF;;AmF1rnBE;EACC,oBAAA;EACA,6DAAA;AnF6rnBH;;AmF3rnBE;EACC,kBAAA;EACA,sEAAA;AnF8rnBH;;AmF5rnBE;EACC,oBAAA;EACA,4DAAA;AnF+rnBH;;AmF7rnBE;EACC,kBAAA;EACA,qEAAA;AnFgsnBH;;AmF9snBE;EACC,oBAAA;EACA,6DAAA;AnFitnBH;;AmF/snBE;EACC,kBAAA;EACA,sEAAA;AnFktnBH;;AmFhtnBE;EACC,oBAAA;EACA,2DAAA;AnFmtnBH;;AmFjtnBE;EACC,kBAAA;EACA,oEAAA;AnFotnBH;;AmFlunBE;EACC,oBAAA;EACA,6DAAA;AnFqunBH;;AmFnunBE;EACC,kBAAA;EACA,sEAAA;AnFsunBH;;AmFpunBE;EACC,oBAAA;EACA,0DAAA;AnFuunBH;;AmFrunBE;EACC,kBAAA;EACA,mEAAA;AnFwunBH;;AmFtvnBE;EACC,oBAAA;EACA,4DAAA;AnFyvnBH;;AmFvvnBE;EACC,kBAAA;EACA,qEAAA;AnF0vnBH;;AmFxvnBE;EACC,oBAAA;EACA,yDAAA;AnF2vnBH;;AmFzvnBE;EACC,kBAAA;EACA,kEAAA;AnF4vnBH;;AmF7xnBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFgynBF;;AmFzxnBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF4xnBF;;AmFzxnBE;EACC,oBAAA;EACA,6DAAA;AnF4xnBH;;AmF1xnBE;EACC,kBAAA;EACA,sEAAA;AnF6xnBH;;AmF3xnBE;EACC,oBAAA;EACA,2DAAA;AnF8xnBH;;AmF5xnBE;EACC,kBAAA;EACA,oEAAA;AnF+xnBH;;AmF7ynBE;EACC,oBAAA;EACA,6DAAA;AnFgznBH;;AmF9ynBE;EACC,kBAAA;EACA,sEAAA;AnFiznBH;;AmF/ynBE;EACC,oBAAA;EACA,0DAAA;AnFkznBH;;AmFhznBE;EACC,kBAAA;EACA,mEAAA;AnFmznBH;;AmFj0nBE;EACC,oBAAA;EACA,6DAAA;AnFo0nBH;;AmFl0nBE;EACC,kBAAA;EACA,sEAAA;AnFq0nBH;;AmFn0nBE;EACC,oBAAA;EACA,0DAAA;AnFs0nBH;;AmFp0nBE;EACC,kBAAA;EACA,mEAAA;AnFu0nBH;;AmFr1nBE;EACC,oBAAA;EACA,4DAAA;AnFw1nBH;;AmFt1nBE;EACC,kBAAA;EACA,qEAAA;AnFy1nBH;;AmFv1nBE;EACC,oBAAA;EACA,yDAAA;AnF01nBH;;AmFx1nBE;EACC,kBAAA;EACA,kEAAA;AnF21nBH;;AmF53nBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF+3nBF;;AmFx3nBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF23nBF;;AmFx3nBE;EACC,oBAAA;EACA,6DAAA;AnF23nBH;;AmFz3nBE;EACC,kBAAA;EACA,sEAAA;AnF43nBH;;AmF13nBE;EACC,oBAAA;EACA,2DAAA;AnF63nBH;;AmF33nBE;EACC,kBAAA;EACA,oEAAA;AnF83nBH;;AmF54nBE;EACC,oBAAA;EACA,6DAAA;AnF+4nBH;;AmF74nBE;EACC,kBAAA;EACA,sEAAA;AnFg5nBH;;AmF94nBE;EACC,oBAAA;EACA,0DAAA;AnFi5nBH;;AmF/4nBE;EACC,kBAAA;EACA,mEAAA;AnFk5nBH;;AmFh6nBE;EACC,oBAAA;EACA,6DAAA;AnFm6nBH;;AmFj6nBE;EACC,kBAAA;EACA,sEAAA;AnFo6nBH;;AmFl6nBE;EACC,oBAAA;EACA,0DAAA;AnFq6nBH;;AmFn6nBE;EACC,kBAAA;EACA,mEAAA;AnFs6nBH;;AmFp7nBE;EACC,oBAAA;EACA,6DAAA;AnFu7nBH;;AmFr7nBE;EACC,kBAAA;EACA,sEAAA;AnFw7nBH;;AmFt7nBE;EACC,oBAAA;EACA,0DAAA;AnFy7nBH;;AmFv7nBE;EACC,kBAAA;EACA,mEAAA;AnF07nBH;;AmF39nBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF89nBF;;AmFv9nBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnF09nBF;;AmFv9nBE;EACC,oBAAA;EACA,6DAAA;AnF09nBH;;AmFx9nBE;EACC,kBAAA;EACA,sEAAA;AnF29nBH;;AmFz9nBE;EACC,oBAAA;EACA,6DAAA;AnF49nBH;;AmF19nBE;EACC,kBAAA;EACA,sEAAA;AnF69nBH;;AmF3+nBE;EACC,oBAAA;EACA,6DAAA;AnF8+nBH;;AmF5+nBE;EACC,kBAAA;EACA,sEAAA;AnF++nBH;;AmF7+nBE;EACC,oBAAA;EACA,6DAAA;AnFg/nBH;;AmF9+nBE;EACC,kBAAA;EACA,sEAAA;AnFi/nBH;;AmF//nBE;EACC,oBAAA;EACA,6DAAA;AnFkgoBH;;AmFhgoBE;EACC,kBAAA;EACA,sEAAA;AnFmgoBH;;AmFjgoBE;EACC,oBAAA;EACA,0DAAA;AnFogoBH;;AmFlgoBE;EACC,kBAAA;EACA,mEAAA;AnFqgoBH;;AmFnhoBE;EACC,oBAAA;EACA,6DAAA;AnFshoBH;;AmFphoBE;EACC,kBAAA;EACA,sEAAA;AnFuhoBH;;AmFrhoBE;EACC,oBAAA;EACA,0DAAA;AnFwhoBH;;AmFthoBE;EACC,kBAAA;EACA,mEAAA;AnFyhoBH;;AmF1joBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF6joBF;;AmFtjoBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;AnFyjoBF;;AmFtjoBE;EACC,oBAAA;EACA,6DAAA;AnFyjoBH;;AmFvjoBE;EACC,kBAAA;EACA,sEAAA;AnF0joBH;;AmFxjoBE;EACC,oBAAA;EACA,0DAAA;AnF2joBH;;AmFzjoBE;EACC,kBAAA;EACA,mEAAA;AnF4joBH;;AmF1koBE;EACC,oBAAA;EACA,6DAAA;AnF6koBH;;AmF3koBE;EACC,kBAAA;EACA,sEAAA;AnF8koBH;;AmF5koBE;EACC,oBAAA;EACA,0DAAA;AnF+koBH;;AmF7koBE;EACC,kBAAA;EACA,mEAAA;AnFgloBH;;AmF9loBE;EACC,oBAAA;EACA,6DAAA;AnFimoBH;;AmF/loBE;EACC,kBAAA;EACA,sEAAA;AnFkmoBH;;AmFhmoBE;EACC,oBAAA;EACA,yDAAA;AnFmmoBH;;AmFjmoBE;EACC,kBAAA;EACA,kEAAA;AnFomoBH;;AmFlnoBE;EACC,oBAAA;EACA,4DAAA;AnFqnoBH;;AmFnnoBE;EACC,kBAAA;EACA,qEAAA;AnFsnoBH;;AmFpnoBE;EACC,oBAAA;EACA,yDAAA;AnFunoBH;;AmFrnoBE;EACC,kBAAA;EACA,kEAAA;AnFwnoBH;;AmFzpoBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF4poBF;;AmFrpoBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFwpoBF;;AmFrpoBE;EACC,oBAAA;EACA,6DAAA;AnFwpoBH;;AmFtpoBE;EACC,kBAAA;EACA,sEAAA;AnFypoBH;;AmFvpoBE;EACC,oBAAA;EACA,6DAAA;AnF0poBH;;AmFxpoBE;EACC,kBAAA;EACA,sEAAA;AnF2poBH;;AmFzqoBE;EACC,oBAAA;EACA,6DAAA;AnF4qoBH;;AmF1qoBE;EACC,kBAAA;EACA,sEAAA;AnF6qoBH;;AmF3qoBE;EACC,oBAAA;EACA,6DAAA;AnF8qoBH;;AmF5qoBE;EACC,kBAAA;EACA,sEAAA;AnF+qoBH;;AmF7roBE;EACC,oBAAA;EACA,6DAAA;AnFgsoBH;;AmF9roBE;EACC,kBAAA;EACA,sEAAA;AnFisoBH;;AmF/roBE;EACC,oBAAA;EACA,0DAAA;AnFksoBH;;AmFhsoBE;EACC,kBAAA;EACA,mEAAA;AnFmsoBH;;AmFjtoBE;EACC,oBAAA;EACA,6DAAA;AnFotoBH;;AmFltoBE;EACC,kBAAA;EACA,sEAAA;AnFqtoBH;;AmFntoBE;EACC,oBAAA;EACA,0DAAA;AnFstoBH;;AmFptoBE;EACC,kBAAA;EACA,mEAAA;AnFutoBH;;AmFxvoBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF2voBF;;AmFpvoBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFuvoBF;;AmFpvoBE;EACC,oBAAA;EACA,6DAAA;AnFuvoBH;;AmFrvoBE;EACC,kBAAA;EACA,sEAAA;AnFwvoBH;;AmFtvoBE;EACC,oBAAA;EACA,6DAAA;AnFyvoBH;;AmFvvoBE;EACC,kBAAA;EACA,sEAAA;AnF0voBH;;AmFxwoBE;EACC,oBAAA;EACA,6DAAA;AnF2woBH;;AmFzwoBE;EACC,kBAAA;EACA,sEAAA;AnF4woBH;;AmF1woBE;EACC,oBAAA;EACA,6DAAA;AnF6woBH;;AmF3woBE;EACC,kBAAA;EACA,sEAAA;AnF8woBH;;AmF5xoBE;EACC,oBAAA;EACA,6DAAA;AnF+xoBH;;AmF7xoBE;EACC,kBAAA;EACA,sEAAA;AnFgyoBH;;AmF9xoBE;EACC,oBAAA;EACA,0DAAA;AnFiyoBH;;AmF/xoBE;EACC,kBAAA;EACA,mEAAA;AnFkyoBH;;AmFhzoBE;EACC,oBAAA;EACA,6DAAA;AnFmzoBH;;AmFjzoBE;EACC,kBAAA;EACA,sEAAA;AnFozoBH;;AmFlzoBE;EACC,oBAAA;EACA,0DAAA;AnFqzoBH;;AmFnzoBE;EACC,kBAAA;EACA,mEAAA;AnFszoBH;;AmFv1oBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF01oBF;;AmFn1oBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFs1oBF;;AmFn1oBE;EACC,oBAAA;EACA,6DAAA;AnFs1oBH;;AmFp1oBE;EACC,kBAAA;EACA,sEAAA;AnFu1oBH;;AmFr1oBE;EACC,oBAAA;EACA,6DAAA;AnFw1oBH;;AmFt1oBE;EACC,kBAAA;EACA,sEAAA;AnFy1oBH;;AmFv2oBE;EACC,oBAAA;EACA,6DAAA;AnF02oBH;;AmFx2oBE;EACC,kBAAA;EACA,sEAAA;AnF22oBH;;AmFz2oBE;EACC,oBAAA;EACA,2DAAA;AnF42oBH;;AmF12oBE;EACC,kBAAA;EACA,oEAAA;AnF62oBH;;AmF33oBE;EACC,oBAAA;EACA,6DAAA;AnF83oBH;;AmF53oBE;EACC,kBAAA;EACA,sEAAA;AnF+3oBH;;AmF73oBE;EACC,oBAAA;EACA,0DAAA;AnFg4oBH;;AmF93oBE;EACC,kBAAA;EACA,mEAAA;AnFi4oBH;;AmF/4oBE;EACC,oBAAA;EACA,6DAAA;AnFk5oBH;;AmFh5oBE;EACC,kBAAA;EACA,sEAAA;AnFm5oBH;;AmFj5oBE;EACC,oBAAA;EACA,0DAAA;AnFo5oBH;;AmFl5oBE;EACC,kBAAA;EACA,mEAAA;AnFq5oBH;;AmFt7oBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFy7oBF;;AmFl7oBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;AnFq7oBF;;AmFl7oBE;EACC,oBAAA;EACA,6DAAA;AnFq7oBH;;AmFn7oBE;EACC,kBAAA;EACA,sEAAA;AnFs7oBH;;AmFp7oBE;EACC,oBAAA;EACA,4DAAA;AnFu7oBH;;AmFr7oBE;EACC,kBAAA;EACA,qEAAA;AnFw7oBH;;AmFt8oBE;EACC,oBAAA;EACA,6DAAA;AnFy8oBH;;AmFv8oBE;EACC,kBAAA;EACA,sEAAA;AnF08oBH;;AmFx8oBE;EACC,oBAAA;EACA,0DAAA;AnF28oBH;;AmFz8oBE;EACC,kBAAA;EACA,mEAAA;AnF48oBH;;AmF19oBE;EACC,oBAAA;EACA,6DAAA;AnF69oBH;;AmF39oBE;EACC,kBAAA;EACA,sEAAA;AnF89oBH;;AmF59oBE;EACC,oBAAA;EACA,0DAAA;AnF+9oBH;;AmF79oBE;EACC,kBAAA;EACA,mEAAA;AnFg+oBH;;AmF9+oBE;EACC,oBAAA;EACA,6DAAA;AnFi/oBH;;AmF/+oBE;EACC,kBAAA;EACA,sEAAA;AnFk/oBH;;AmFh/oBE;EACC,oBAAA;EACA,0DAAA;AnFm/oBH;;AmFj/oBE;EACC,kBAAA;EACA,mEAAA;AnFo/oBH;;AmFrhpBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFwhpBF;;AmFjhpBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFohpBF;;AmFjhpBE;EACC,oBAAA;EACA,6DAAA;AnFohpBH;;AmFlhpBE;EACC,kBAAA;EACA,sEAAA;AnFqhpBH;;AmFnhpBE;EACC,oBAAA;EACA,2DAAA;AnFshpBH;;AmFphpBE;EACC,kBAAA;EACA,oEAAA;AnFuhpBH;;AmFripBE;EACC,oBAAA;EACA,6DAAA;AnFwipBH;;AmFtipBE;EACC,kBAAA;EACA,sEAAA;AnFyipBH;;AmFvipBE;EACC,oBAAA;EACA,0DAAA;AnF0ipBH;;AmFxipBE;EACC,kBAAA;EACA,mEAAA;AnF2ipBH;;AmFzjpBE;EACC,oBAAA;EACA,6DAAA;AnF4jpBH;;AmF1jpBE;EACC,kBAAA;EACA,sEAAA;AnF6jpBH;;AmF3jpBE;EACC,oBAAA;EACA,0DAAA;AnF8jpBH;;AmF5jpBE;EACC,kBAAA;EACA,mEAAA;AnF+jpBH;;AmF7kpBE;EACC,oBAAA;EACA,6DAAA;AnFglpBH;;AmF9kpBE;EACC,kBAAA;EACA,sEAAA;AnFilpBH;;AmF/kpBE;EACC,oBAAA;EACA,0DAAA;AnFklpBH;;AmFhlpBE;EACC,kBAAA;EACA,mEAAA;AnFmlpBH;;AmFpnpBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFunpBF;;AmFhnpBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFmnpBF;;AmFhnpBE;EACC,oBAAA;EACA,6DAAA;AnFmnpBH;;AmFjnpBE;EACC,kBAAA;EACA,sEAAA;AnFonpBH;;AmFlnpBE;EACC,oBAAA;EACA,0DAAA;AnFqnpBH;;AmFnnpBE;EACC,kBAAA;EACA,mEAAA;AnFsnpBH;;AmFpopBE;EACC,oBAAA;EACA,6DAAA;AnFuopBH;;AmFropBE;EACC,kBAAA;EACA,sEAAA;AnFwopBH;;AmFtopBE;EACC,oBAAA;EACA,0DAAA;AnFyopBH;;AmFvopBE;EACC,kBAAA;EACA,mEAAA;AnF0opBH;;AmFxppBE;EACC,oBAAA;EACA,6DAAA;AnF2ppBH;;AmFzppBE;EACC,kBAAA;EACA,sEAAA;AnF4ppBH;;AmF1ppBE;EACC,oBAAA;EACA,0DAAA;AnF6ppBH;;AmF3ppBE;EACC,kBAAA;EACA,mEAAA;AnF8ppBH;;AmF5qpBE;EACC,oBAAA;EACA,6DAAA;AnF+qpBH;;AmF7qpBE;EACC,kBAAA;EACA,sEAAA;AnFgrpBH;;AmF9qpBE;EACC,oBAAA;EACA,0DAAA;AnFirpBH;;AmF/qpBE;EACC,kBAAA;EACA,mEAAA;AnFkrpBH;;AmFntpBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFstpBF;;AmF/spBE;EACA,8BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnFktpBF;;AmF/spBE;EACC,oBAAA;EACA,6DAAA;AnFktpBH;;AmFhtpBE;EACC,kBAAA;EACA,sEAAA;AnFmtpBH;;AmFjtpBE;EACC,oBAAA;EACA,0DAAA;AnFotpBH;;AmFltpBE;EACC,kBAAA;EACA,mEAAA;AnFqtpBH;;AmFnupBE;EACC,oBAAA;EACA,6DAAA;AnFsupBH;;AmFpupBE;EACC,kBAAA;EACA,sEAAA;AnFuupBH;;AmFrupBE;EACC,oBAAA;EACA,0DAAA;AnFwupBH;;AmFtupBE;EACC,kBAAA;EACA,mEAAA;AnFyupBH;;AmFvvpBE;EACC,oBAAA;EACA,6DAAA;AnF0vpBH;;AmFxvpBE;EACC,kBAAA;EACA,sEAAA;AnF2vpBH;;AmFzvpBE;EACC,oBAAA;EACA,0DAAA;AnF4vpBH;;AmF1vpBE;EACC,kBAAA;EACA,mEAAA;AnF6vpBH;;AmF3wpBE;EACC,oBAAA;EACA,6DAAA;AnF8wpBH;;AmF5wpBE;EACC,kBAAA;EACA,sEAAA;AnF+wpBH;;AmF7wpBE;EACC,oBAAA;EACA,0DAAA;AnFgxpBH;;AmF9wpBE;EACC,kBAAA;EACA,mEAAA;AnFixpBH;;AmFlzpBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFqzpBF;;AmF9ypBE;EACA,8BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnFizpBF;;AmF9ypBE;EACC,oBAAA;EACA,6DAAA;AnFizpBH;;AmF/ypBE;EACC,kBAAA;EACA,sEAAA;AnFkzpBH;;AmFhzpBE;EACC,oBAAA;EACA,0DAAA;AnFmzpBH;;AmFjzpBE;EACC,kBAAA;EACA,mEAAA;AnFozpBH;;AmFl0pBE;EACC,oBAAA;EACA,6DAAA;AnFq0pBH;;AmFn0pBE;EACC,kBAAA;EACA,sEAAA;AnFs0pBH;;AmFp0pBE;EACC,oBAAA;EACA,0DAAA;AnFu0pBH;;AmFr0pBE;EACC,kBAAA;EACA,mEAAA;AnFw0pBH;;AmFt1pBE;EACC,oBAAA;EACA,6DAAA;AnFy1pBH;;AmFv1pBE;EACC,kBAAA;EACA,sEAAA;AnF01pBH;;AmFx1pBE;EACC,oBAAA;EACA,0DAAA;AnF21pBH;;AmFz1pBE;EACC,kBAAA;EACA,mEAAA;AnF41pBH;;AmF12pBE;EACC,oBAAA;EACA,4DAAA;AnF62pBH;;AmF32pBE;EACC,kBAAA;EACA,qEAAA;AnF82pBH;;AmF52pBE;EACC,oBAAA;EACA,0DAAA;AnF+2pBH;;AmF72pBE;EACC,kBAAA;EACA,mEAAA;AnFg3pBH;;AmFj5pBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFo5pBF;;AmF74pBE;EACA,8BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnFg5pBF;;AmF74pBE;EACC,oBAAA;EACA,6DAAA;AnFg5pBH;;AmF94pBE;EACC,kBAAA;EACA,sEAAA;AnFi5pBH;;AmF/4pBE;EACC,oBAAA;EACA,0DAAA;AnFk5pBH;;AmFh5pBE;EACC,kBAAA;EACA,mEAAA;AnFm5pBH;;AmFj6pBE;EACC,oBAAA;EACA,6DAAA;AnFo6pBH;;AmFl6pBE;EACC,kBAAA;EACA,sEAAA;AnFq6pBH;;AmFn6pBE;EACC,oBAAA;EACA,0DAAA;AnFs6pBH;;AmFp6pBE;EACC,kBAAA;EACA,mEAAA;AnFu6pBH;;AmFr7pBE;EACC,oBAAA;EACA,6DAAA;AnFw7pBH;;AmFt7pBE;EACC,kBAAA;EACA,sEAAA;AnFy7pBH;;AmFv7pBE;EACC,oBAAA;EACA,0DAAA;AnF07pBH;;AmFx7pBE;EACC,kBAAA;EACA,mEAAA;AnF27pBH;;AmFz8pBE;EACC,oBAAA;EACA,0DAAA;AnF48pBH;;AmF18pBE;EACC,kBAAA;EACA,mEAAA;AnF68pBH;;AmF38pBE;EACC,oBAAA;EACA,yDAAA;AnF88pBH;;AmF58pBE;EACC,kBAAA;EACA,kEAAA;AnF+8pBH;;AmFh/pBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFm/pBF;;AmF5+pBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnF++pBF;;AmF5+pBE;EACC,oBAAA;EACA,6DAAA;AnF++pBH;;AmF7+pBE;EACC,kBAAA;EACA,sEAAA;AnFg/pBH;;AmF9+pBE;EACC,oBAAA;EACA,0DAAA;AnFi/pBH;;AmF/+pBE;EACC,kBAAA;EACA,mEAAA;AnFk/pBH;;AmFhgqBE;EACC,oBAAA;EACA,6DAAA;AnFmgqBH;;AmFjgqBE;EACC,kBAAA;EACA,sEAAA;AnFogqBH;;AmFlgqBE;EACC,oBAAA;EACA,0DAAA;AnFqgqBH;;AmFngqBE;EACC,kBAAA;EACA,mEAAA;AnFsgqBH;;AmFphqBE;EACC,oBAAA;EACA,6DAAA;AnFuhqBH;;AmFrhqBE;EACC,kBAAA;EACA,sEAAA;AnFwhqBH;;AmFthqBE;EACC,oBAAA;EACA,0DAAA;AnFyhqBH;;AmFvhqBE;EACC,kBAAA;EACA,mEAAA;AnF0hqBH;;AmFxiqBE;EACC,oBAAA;EACA,4DAAA;AnF2iqBH;;AmFziqBE;EACC,kBAAA;EACA,qEAAA;AnF4iqBH;;AmF1iqBE;EACC,oBAAA;EACA,yDAAA;AnF6iqBH;;AmF3iqBE;EACC,kBAAA;EACA,kEAAA;AnF8iqBH;;AmF/kqBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFklqBF;;AmF3kqBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnF8kqBF;;AmF3kqBE;EACC,oBAAA;EACA,6DAAA;AnF8kqBH;;AmF5kqBE;EACC,kBAAA;EACA,sEAAA;AnF+kqBH;;AmF7kqBE;EACC,oBAAA;EACA,2DAAA;AnFglqBH;;AmF9kqBE;EACC,kBAAA;EACA,oEAAA;AnFilqBH;;AmF/lqBE;EACC,oBAAA;EACA,6DAAA;AnFkmqBH;;AmFhmqBE;EACC,kBAAA;EACA,sEAAA;AnFmmqBH;;AmFjmqBE;EACC,oBAAA;EACA,2DAAA;AnFomqBH;;AmFlmqBE;EACC,kBAAA;EACA,oEAAA;AnFqmqBH;;AmFnnqBE;EACC,oBAAA;EACA,6DAAA;AnFsnqBH;;AmFpnqBE;EACC,kBAAA;EACA,sEAAA;AnFunqBH;;AmFrnqBE;EACC,oBAAA;EACA,2DAAA;AnFwnqBH;;AmFtnqBE;EACC,kBAAA;EACA,oEAAA;AnFynqBH;;AmFvoqBE;EACC,oBAAA;EACA,4DAAA;AnF0oqBH;;AmFxoqBE;EACC,kBAAA;EACA,qEAAA;AnF2oqBH;;AmFzoqBE;EACC,oBAAA;EACA,yDAAA;AnF4oqBH;;AmF1oqBE;EACC,kBAAA;EACA,kEAAA;AnF6oqBH;;AmF9qqBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFirqBF;;AmF1qqBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF6qqBF;;AmF1qqBE;EACC,oBAAA;EACA,6DAAA;AnF6qqBH;;AmF3qqBE;EACC,kBAAA;EACA,sEAAA;AnF8qqBH;;AmF5qqBE;EACC,oBAAA;EACA,4DAAA;AnF+qqBH;;AmF7qqBE;EACC,kBAAA;EACA,qEAAA;AnFgrqBH;;AmF9rqBE;EACC,oBAAA;EACA,6DAAA;AnFisqBH;;AmF/rqBE;EACC,kBAAA;EACA,sEAAA;AnFksqBH;;AmFhsqBE;EACC,oBAAA;EACA,2DAAA;AnFmsqBH;;AmFjsqBE;EACC,kBAAA;EACA,oEAAA;AnFosqBH;;AmFltqBE;EACC,oBAAA;EACA,6DAAA;AnFqtqBH;;AmFntqBE;EACC,kBAAA;EACA,sEAAA;AnFstqBH;;AmFptqBE;EACC,oBAAA;EACA,0DAAA;AnFutqBH;;AmFrtqBE;EACC,kBAAA;EACA,mEAAA;AnFwtqBH;;AmFtuqBE;EACC,oBAAA;EACA,4DAAA;AnFyuqBH;;AmFvuqBE;EACC,kBAAA;EACA,qEAAA;AnF0uqBH;;AmFxuqBE;EACC,oBAAA;EACA,yDAAA;AnF2uqBH;;AmFzuqBE;EACC,kBAAA;EACA,kEAAA;AnF4uqBH;;AmF7wqBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFgxqBF;;AmFzwqBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF4wqBF;;AmFzwqBE;EACC,oBAAA;EACA,6DAAA;AnF4wqBH;;AmF1wqBE;EACC,kBAAA;EACA,sEAAA;AnF6wqBH;;AmF3wqBE;EACC,oBAAA;EACA,2DAAA;AnF8wqBH;;AmF5wqBE;EACC,kBAAA;EACA,oEAAA;AnF+wqBH;;AmF7xqBE;EACC,oBAAA;EACA,6DAAA;AnFgyqBH;;AmF9xqBE;EACC,kBAAA;EACA,sEAAA;AnFiyqBH;;AmF/xqBE;EACC,oBAAA;EACA,2DAAA;AnFkyqBH;;AmFhyqBE;EACC,kBAAA;EACA,oEAAA;AnFmyqBH;;AmFjzqBE;EACC,oBAAA;EACA,6DAAA;AnFozqBH;;AmFlzqBE;EACC,kBAAA;EACA,sEAAA;AnFqzqBH;;AmFnzqBE;EACC,oBAAA;EACA,yDAAA;AnFszqBH;;AmFpzqBE;EACC,kBAAA;EACA,kEAAA;AnFuzqBH;;AmFr0qBE;EACC,oBAAA;EACA,4DAAA;AnFw0qBH;;AmFt0qBE;EACC,kBAAA;EACA,qEAAA;AnFy0qBH;;AmFv0qBE;EACC,oBAAA;EACA,yDAAA;AnF00qBH;;AmFx0qBE;EACC,kBAAA;EACA,kEAAA;AnF20qBH;;AmF52qBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF+2qBF;;AmFx2qBE;EACA,8BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8CAAA;AnF22qBF;;AmFx2qBE;EACC,oBAAA;EACA,6DAAA;AnF22qBH;;AmFz2qBE;EACC,kBAAA;EACA,sEAAA;AnF42qBH;;AmF12qBE;EACC,oBAAA;EACA,yDAAA;AnF62qBH;;AmF32qBE;EACC,kBAAA;EACA,kEAAA;AnF82qBH;;AmF53qBE;EACC,oBAAA;EACA,6DAAA;AnF+3qBH;;AmF73qBE;EACC,kBAAA;EACA,sEAAA;AnFg4qBH;;AmF93qBE;EACC,oBAAA;EACA,yDAAA;AnFi4qBH;;AmF/3qBE;EACC,kBAAA;EACA,kEAAA;AnFk4qBH;;AmFh5qBE;EACC,oBAAA;EACA,6DAAA;AnFm5qBH;;AmFj5qBE;EACC,kBAAA;EACA,sEAAA;AnFo5qBH;;AmFl5qBE;EACC,oBAAA;EACA,wDAAA;AnFq5qBH;;AmFn5qBE;EACC,kBAAA;EACA,iEAAA;AnFs5qBH;;AmFp6qBE;EACC,oBAAA;EACA,2DAAA;AnFu6qBH;;AmFr6qBE;EACC,kBAAA;EACA,oEAAA;AnFw6qBH;;AmFt6qBE;EACC,oBAAA;EACA,wDAAA;AnFy6qBH;;AmFv6qBE;EACC,kBAAA;EACA,iEAAA;AnF06qBH;;AmF38qBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF88qBF;;AmFv8qBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;AnF08qBF;;AmFv8qBE;EACC,oBAAA;EACA,6DAAA;AnF08qBH;;AmFx8qBE;EACC,kBAAA;EACA,sEAAA;AnF28qBH;;AmFz8qBE;EACC,oBAAA;EACA,4DAAA;AnF48qBH;;AmF18qBE;EACC,kBAAA;EACA,qEAAA;AnF68qBH;;AmF39qBE;EACC,oBAAA;EACA,6DAAA;AnF89qBH;;AmF59qBE;EACC,kBAAA;EACA,sEAAA;AnF+9qBH;;AmF79qBE;EACC,oBAAA;EACA,0DAAA;AnFg+qBH;;AmF99qBE;EACC,kBAAA;EACA,mEAAA;AnFi+qBH;;AmF/+qBE;EACC,oBAAA;EACA,6DAAA;AnFk/qBH;;AmFh/qBE;EACC,kBAAA;EACA,sEAAA;AnFm/qBH;;AmFj/qBE;EACC,oBAAA;EACA,0DAAA;AnFo/qBH;;AmFl/qBE;EACC,kBAAA;EACA,mEAAA;AnFq/qBH;;AmFngrBE;EACC,oBAAA;EACA,4DAAA;AnFsgrBH;;AmFpgrBE;EACC,kBAAA;EACA,qEAAA;AnFugrBH;;AmFrgrBE;EACC,oBAAA;EACA,yDAAA;AnFwgrBH;;AmFtgrBE;EACC,kBAAA;EACA,kEAAA;AnFygrBH;;AmF1irBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF6irBF;;AmFtirBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;AnFyirBF;;AmFtirBE;EACC,oBAAA;EACA,6DAAA;AnFyirBH;;AmFvirBE;EACC,kBAAA;EACA,sEAAA;AnF0irBH;;AmFxirBE;EACC,oBAAA;EACA,4DAAA;AnF2irBH;;AmFzirBE;EACC,kBAAA;EACA,qEAAA;AnF4irBH;;AmF1jrBE;EACC,oBAAA;EACA,6DAAA;AnF6jrBH;;AmF3jrBE;EACC,kBAAA;EACA,sEAAA;AnF8jrBH;;AmF5jrBE;EACC,oBAAA;EACA,2DAAA;AnF+jrBH;;AmF7jrBE;EACC,kBAAA;EACA,oEAAA;AnFgkrBH;;AmF9krBE;EACC,oBAAA;EACA,6DAAA;AnFilrBH;;AmF/krBE;EACC,kBAAA;EACA,sEAAA;AnFklrBH;;AmFhlrBE;EACC,oBAAA;EACA,0DAAA;AnFmlrBH;;AmFjlrBE;EACC,kBAAA;EACA,mEAAA;AnFolrBH;;AmFlmrBE;EACC,oBAAA;EACA,4DAAA;AnFqmrBH;;AmFnmrBE;EACC,kBAAA;EACA,qEAAA;AnFsmrBH;;AmFpmrBE;EACC,oBAAA;EACA,yDAAA;AnFumrBH;;AmFrmrBE;EACC,kBAAA;EACA,kEAAA;AnFwmrBH;;AmFzorBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF4orBF;;AmFrorBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnFworBF;;AmFrorBE;EACC,oBAAA;EACA,6DAAA;AnFworBH;;AmFtorBE;EACC,kBAAA;EACA,sEAAA;AnFyorBH;;AmFvorBE;EACC,oBAAA;EACA,2DAAA;AnF0orBH;;AmFxorBE;EACC,kBAAA;EACA,oEAAA;AnF2orBH;;AmFzprBE;EACC,oBAAA;EACA,6DAAA;AnF4prBH;;AmF1prBE;EACC,kBAAA;EACA,sEAAA;AnF6prBH;;AmF3prBE;EACC,oBAAA;EACA,0DAAA;AnF8prBH;;AmF5prBE;EACC,kBAAA;EACA,mEAAA;AnF+prBH;;AmF7qrBE;EACC,oBAAA;EACA,6DAAA;AnFgrrBH;;AmF9qrBE;EACC,kBAAA;EACA,sEAAA;AnFirrBH;;AmF/qrBE;EACC,oBAAA;EACA,yDAAA;AnFkrrBH;;AmFhrrBE;EACC,kBAAA;EACA,kEAAA;AnFmrrBH;;AmFjsrBE;EACC,oBAAA;EACA,2DAAA;AnFosrBH;;AmFlsrBE;EACC,kBAAA;EACA,oEAAA;AnFqsrBH;;AmFnsrBE;EACC,oBAAA;EACA,wDAAA;AnFssrBH;;AmFpsrBE;EACC,kBAAA;EACA,iEAAA;AnFusrBH;;AmFxurBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF2urBF;;AmFpurBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFuurBF;;AmFpurBE;EACC,oBAAA;EACA,6DAAA;AnFuurBH;;AmFrurBE;EACC,kBAAA;EACA,sEAAA;AnFwurBH;;AmFturBE;EACC,oBAAA;EACA,2DAAA;AnFyurBH;;AmFvurBE;EACC,kBAAA;EACA,oEAAA;AnF0urBH;;AmFxvrBE;EACC,oBAAA;EACA,6DAAA;AnF2vrBH;;AmFzvrBE;EACC,kBAAA;EACA,sEAAA;AnF4vrBH;;AmF1vrBE;EACC,oBAAA;EACA,0DAAA;AnF6vrBH;;AmF3vrBE;EACC,kBAAA;EACA,mEAAA;AnF8vrBH;;AmF5wrBE;EACC,oBAAA;EACA,6DAAA;AnF+wrBH;;AmF7wrBE;EACC,kBAAA;EACA,sEAAA;AnFgxrBH;;AmF9wrBE;EACC,oBAAA;EACA,0DAAA;AnFixrBH;;AmF/wrBE;EACC,kBAAA;EACA,mEAAA;AnFkxrBH;;AmFhyrBE;EACC,oBAAA;EACA,4DAAA;AnFmyrBH;;AmFjyrBE;EACC,kBAAA;EACA,qEAAA;AnFoyrBH;;AmFlyrBE;EACC,oBAAA;EACA,yDAAA;AnFqyrBH;;AmFnyrBE;EACC,kBAAA;EACA,kEAAA;AnFsyrBH;;AmFv0rBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnF00rBF;;AmFn0rBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnFs0rBF;;AmFn0rBE;EACC,oBAAA;EACA,6DAAA;AnFs0rBH;;AmFp0rBE;EACC,kBAAA;EACA,sEAAA;AnFu0rBH;;AmFr0rBE;EACC,oBAAA;EACA,2DAAA;AnFw0rBH;;AmFt0rBE;EACC,kBAAA;EACA,oEAAA;AnFy0rBH;;AmFv1rBE;EACC,oBAAA;EACA,6DAAA;AnF01rBH;;AmFx1rBE;EACC,kBAAA;EACA,sEAAA;AnF21rBH;;AmFz1rBE;EACC,oBAAA;EACA,0DAAA;AnF41rBH;;AmF11rBE;EACC,kBAAA;EACA,mEAAA;AnF61rBH;;AmF32rBE;EACC,oBAAA;EACA,6DAAA;AnF82rBH;;AmF52rBE;EACC,kBAAA;EACA,sEAAA;AnF+2rBH;;AmF72rBE;EACC,oBAAA;EACA,yDAAA;AnFg3rBH;;AmF92rBE;EACC,kBAAA;EACA,kEAAA;AnFi3rBH;;AmF/3rBE;EACC,oBAAA;EACA,4DAAA;AnFk4rBH;;AmFh4rBE;EACC,kBAAA;EACA,qEAAA;AnFm4rBH;;AmFj4rBE;EACC,oBAAA;EACA,yDAAA;AnFo4rBH;;AmFl4rBE;EACC,kBAAA;EACA,kEAAA;AnFq4rBH;;AmFt6rBE;EACA,oCAAA;EAGA,uEAAA;EACA,sJAAA;AnFy6rBF;;AmFl6rBE;EACA,8BAAA;EACA,kCAAA;EACA,oCAAA;EACA,8CAAA;AnFq6rBF;;AmFl6rBE;EACC,oBAAA;EACA,6DAAA;AnFq6rBH;;AmFn6rBE;EACC,kBAAA;EACA,sEAAA;AnFs6rBH;;AmFp6rBE;EACC,oBAAA;EACA,uDAAA;AnFu6rBH;;AmFr6rBE;EACC,kBAAA;EACA,gEAAA;AnFw6rBH;;AmFt7rBE;EACC,oBAAA;EACA,6DAAA;AnFy7rBH;;AmFv7rBE;EACC,kBAAA;EACA,sEAAA;AnF07rBH;;AmFx7rBE;EACC,oBAAA;EACA,uDAAA;AnF27rBH;;AmFz7rBE;EACC,kBAAA;EACA,gEAAA;AnF47rBH;;AmF18rBE;EACC,oBAAA;EACA,6DAAA;AnF68rBH;;AmF38rBE;EACC,kBAAA;EACA,sEAAA;AnF88rBH;;AmF58rBE;EACC,oBAAA;EACA,uDAAA;AnF+8rBH;;AmF78rBE;EACC,kBAAA;EACA,gEAAA;AnFg9rBH;;AmF99rBE;EACC,oBAAA;EACA,0DAAA;AnFi+rBH;;AmF/9rBE;EACC,kBAAA;EACA,mEAAA;AnFk+rBH;;AmFh+rBE;EACC,oBAAA;EACA,uDAAA;AnFm+rBH;;AmFj+rBE;EACC,kBAAA;EACA,gEAAA;AnFo+rBH;;AmFrgsBE;EACA,oCAAA;EAGA,uEAAA;EACA,sJAAA;AnFwgsBF;;AmFjgsBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFogsBF;;AmFjgsBE;EACC,oBAAA;EACA,6DAAA;AnFogsBH;;AmFlgsBE;EACC,kBAAA;EACA,sEAAA;AnFqgsBH;;AmFngsBE;EACC,oBAAA;EACA,6DAAA;AnFsgsBH;;AmFpgsBE;EACC,kBAAA;EACA,sEAAA;AnFugsBH;;AmFrhsBE;EACC,oBAAA;EACA,6DAAA;AnFwhsBH;;AmFthsBE;EACC,kBAAA;EACA,sEAAA;AnFyhsBH;;AmFvhsBE;EACC,oBAAA;EACA,6DAAA;AnF0hsBH;;AmFxhsBE;EACC,kBAAA;EACA,sEAAA;AnF2hsBH;;AmFzisBE;EACC,oBAAA;EACA,6DAAA;AnF4isBH;;AmF1isBE;EACC,kBAAA;EACA,sEAAA;AnF6isBH;;AmF3isBE;EACC,oBAAA;EACA,6DAAA;AnF8isBH;;AmF5isBE;EACC,kBAAA;EACA,sEAAA;AnF+isBH;;AmF7jsBE;EACC,oBAAA;EACA,6DAAA;AnFgksBH;;AmF9jsBE;EACC,kBAAA;EACA,sEAAA;AnFiksBH;;AmF/jsBE;EACC,oBAAA;EACA,0DAAA;AnFkksBH;;AmFhksBE;EACC,kBAAA;EACA,mEAAA;AnFmksBH;;AmFpmsBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFumsBF;;AmFhmsBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFmmsBF;;AmFhmsBE;EACC,oBAAA;EACA,6DAAA;AnFmmsBH;;AmFjmsBE;EACC,kBAAA;EACA,sEAAA;AnFomsBH;;AmFlmsBE;EACC,oBAAA;EACA,0DAAA;AnFqmsBH;;AmFnmsBE;EACC,kBAAA;EACA,mEAAA;AnFsmsBH;;AmFpnsBE;EACC,oBAAA;EACA,6DAAA;AnFunsBH;;AmFrnsBE;EACC,kBAAA;EACA,sEAAA;AnFwnsBH;;AmFtnsBE;EACC,oBAAA;EACA,0DAAA;AnFynsBH;;AmFvnsBE;EACC,kBAAA;EACA,mEAAA;AnF0nsBH;;AmFxosBE;EACC,oBAAA;EACA,6DAAA;AnF2osBH;;AmFzosBE;EACC,kBAAA;EACA,sEAAA;AnF4osBH;;AmF1osBE;EACC,oBAAA;EACA,0DAAA;AnF6osBH;;AmF3osBE;EACC,kBAAA;EACA,mEAAA;AnF8osBH;;AmF5psBE;EACC,oBAAA;EACA,6DAAA;AnF+psBH;;AmF7psBE;EACC,kBAAA;EACA,sEAAA;AnFgqsBH;;AmF9psBE;EACC,oBAAA;EACA,0DAAA;AnFiqsBH;;AmF/psBE;EACC,kBAAA;EACA,mEAAA;AnFkqsBH;;AmFnssBE;EACA,oCAAA;EAGA,yEAAA;EACA,sJAAA;AnFsssBF;;AmF/rsBE;EACA,8BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnFkssBF;;AmF/rsBE;EACC,oBAAA;EACA,6DAAA;AnFkssBH;;AmFhssBE;EACC,kBAAA;EACA,sEAAA;AnFmssBH;;AmFjssBE;EACC,oBAAA;EACA,0DAAA;AnFossBH;;AmFlssBE;EACC,kBAAA;EACA,mEAAA;AnFqssBH;;AmFntsBE;EACC,oBAAA;EACA,6DAAA;AnFstsBH;;AmFptsBE;EACC,kBAAA;EACA,sEAAA;AnFutsBH;;AmFrtsBE;EACC,oBAAA;EACA,0DAAA;AnFwtsBH;;AmFttsBE;EACC,kBAAA;EACA,mEAAA;AnFytsBH;;AmFvusBE;EACC,oBAAA;EACA,6DAAA;AnF0usBH;;AmFxusBE;EACC,kBAAA;EACA,sEAAA;AnF2usBH;;AmFzusBE;EACC,oBAAA;EACA,0DAAA;AnF4usBH;;AmF1usBE;EACC,kBAAA;EACA,mEAAA;AnF6usBH;;AmF3vsBE;EACC,oBAAA;EACA,4DAAA;AnF8vsBH;;AmF5vsBE;EACC,kBAAA;EACA,qEAAA;AnF+vsBH;;AmF7vsBE;EACC,oBAAA;EACA,0DAAA;AnFgwsBH;;AmF9vsBE;EACC,kBAAA;EACA,mEAAA;AnFiwsBH;;AMpxsBI;EwE4DD,qBAAA;EACA,+BAAA;EADA,mBAAA;EACA,4BAAA;EADA,qBAAA;EACA,8BAAA;EADA,uBAAA;EACA,iCAAA;EADA,qBAAA;EACA,8BAAA;EADA,oBAAA;EACA,4BAAA;EADA,qBAAA;EACA,8BAAA;EADA,qBAAA;EACA,+BAAA;EADA,kBAAA;EACA,2BAAA;EADA,kBAAA;EACA,yBAAA;EADA,mBAAA;EACA,uBAAA;EADA,mBAAA;EACA,6BAAA;EADA,oBAAA;EACA,8BAAA;EADA,oBAAA;EACA,8BAAA;EADA,iBAAA;EACA,yBAAA;EADA,kBAAA;EACA,2BAAA;EADA,mBAAA;EACA,2BAAA;EADA,oBAAA;EACA,6BAAA;EADA,kBAAA;EACA,2BAAA;EADA,mBAAA;EACA,4BAAA;EADA,mBAAA;EACA,6BAAA;EADA,kBAAA;EACA,2BAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,+BAAA;EADA,sBAAA;EACA,+BAAA;EADA,sBAAA;EACA,6BAAA;EADA,sBAAA;EACA,6BAAA;EADA,sBAAA;EACA,6BAAA;EADA,2BAAA;EACA,mCAAA;EADA,2BAAA;EACA,mCAAA;EADA,2BAAA;EACA,oCAAA;EADA,2BAAA;EACA,oCAAA;EADA,2BAAA;EACA,oCAAA;EADA,2BAAA;EACA,oCAAA;EADA,2BAAA;EACA,oCAAA;EADA,2BAAA;EACA,oCAAA;EADA,2BAAA;EACA,oCAAA;EADA,4BAAA;EACA,qCAAA;A9E4ysBH;AoFv3sBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFy3sBF;AoFl3sBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFo3sBF;AoFj3sBE;EACC,oBAAA;EACA,6DAAA;ApFm3sBH;AoFj3sBE;EACC,kBAAA;EACA,sEAAA;ApFm3sBH;AoFj3sBE;EACC,oBAAA;EACA,6DAAA;ApFm3sBH;AoFj3sBE;EACC,kBAAA;EACA,sEAAA;ApFm3sBH;AoFj4sBE;EACC,oBAAA;EACA,6DAAA;ApFm4sBH;AoFj4sBE;EACC,kBAAA;EACA,sEAAA;ApFm4sBH;AoFj4sBE;EACC,oBAAA;EACA,6DAAA;ApFm4sBH;AoFj4sBE;EACC,kBAAA;EACA,sEAAA;ApFm4sBH;AoFj5sBE;EACC,oBAAA;EACA,6DAAA;ApFm5sBH;AoFj5sBE;EACC,kBAAA;EACA,sEAAA;ApFm5sBH;AoFj5sBE;EACC,oBAAA;EACA,0DAAA;ApFm5sBH;AoFj5sBE;EACC,kBAAA;EACA,mEAAA;ApFm5sBH;AoFj6sBE;EACC,oBAAA;EACA,6DAAA;ApFm6sBH;AoFj6sBE;EACC,kBAAA;EACA,sEAAA;ApFm6sBH;AoFj6sBE;EACC,oBAAA;EACA,0DAAA;ApFm6sBH;AoFj6sBE;EACC,kBAAA;EACA,mEAAA;ApFm6sBH;AoFp8sBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFs8sBF;AoFp8sBC;EAEE,wCAAA;ApFq8sBH;AoFl8sBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFo8sBF;AoFj8sBE;EACC,oBAAA;EACA,6DAAA;ApFm8sBH;AoFj8sBE;EACC,kBAAA;EACA,sEAAA;ApFm8sBH;AoFj8sBE;EACC,oBAAA;EACA,4DAAA;ApFm8sBH;AoFj8sBE;EACC,kBAAA;EACA,qEAAA;ApFm8sBH;AoFj9sBE;EACC,oBAAA;EACA,6DAAA;ApFm9sBH;AoFj9sBE;EACC,kBAAA;EACA,sEAAA;ApFm9sBH;AoFj9sBE;EACC,oBAAA;EACA,2DAAA;ApFm9sBH;AoFj9sBE;EACC,kBAAA;EACA,oEAAA;ApFm9sBH;AoFj+sBE;EACC,oBAAA;EACA,6DAAA;ApFm+sBH;AoFj+sBE;EACC,kBAAA;EACA,sEAAA;ApFm+sBH;AoFj+sBE;EACC,oBAAA;EACA,0DAAA;ApFm+sBH;AoFj+sBE;EACC,kBAAA;EACA,mEAAA;ApFm+sBH;AoFj/sBE;EACC,oBAAA;EACA,4DAAA;ApFm/sBH;AoFj/sBE;EACC,kBAAA;EACA,qEAAA;ApFm/sBH;AoFj/sBE;EACC,oBAAA;EACA,0DAAA;ApFm/sBH;AoFj/sBE;EACC,kBAAA;EACA,mEAAA;ApFm/sBH;AoFphtBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFshtBF;AoF/gtBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFihtBF;AoF9gtBE;EACC,oBAAA;EACA,6DAAA;ApFghtBH;AoF9gtBE;EACC,kBAAA;EACA,sEAAA;ApFghtBH;AoF9gtBE;EACC,oBAAA;EACA,4DAAA;ApFghtBH;AoF9gtBE;EACC,kBAAA;EACA,qEAAA;ApFghtBH;AoF9htBE;EACC,oBAAA;EACA,6DAAA;ApFgitBH;AoF9htBE;EACC,kBAAA;EACA,sEAAA;ApFgitBH;AoF9htBE;EACC,oBAAA;EACA,2DAAA;ApFgitBH;AoF9htBE;EACC,kBAAA;EACA,oEAAA;ApFgitBH;AoF9itBE;EACC,oBAAA;EACA,6DAAA;ApFgjtBH;AoF9itBE;EACC,kBAAA;EACA,sEAAA;ApFgjtBH;AoF9itBE;EACC,oBAAA;EACA,2DAAA;ApFgjtBH;AoF9itBE;EACC,kBAAA;EACA,oEAAA;ApFgjtBH;AoF9jtBE;EACC,oBAAA;EACA,6DAAA;ApFgktBH;AoF9jtBE;EACC,kBAAA;EACA,sEAAA;ApFgktBH;AoF9jtBE;EACC,oBAAA;EACA,0DAAA;ApFgktBH;AoF9jtBE;EACC,kBAAA;EACA,mEAAA;ApFgktBH;AoFjmtBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFmmtBF;AoF5ltBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;ApF8ltBF;AoF3ltBE;EACC,oBAAA;EACA,6DAAA;ApF6ltBH;AoF3ltBE;EACC,kBAAA;EACA,sEAAA;ApF6ltBH;AoF3ltBE;EACC,oBAAA;EACA,4DAAA;ApF6ltBH;AoF3ltBE;EACC,kBAAA;EACA,qEAAA;ApF6ltBH;AoF3mtBE;EACC,oBAAA;EACA,6DAAA;ApF6mtBH;AoF3mtBE;EACC,kBAAA;EACA,sEAAA;ApF6mtBH;AoF3mtBE;EACC,oBAAA;EACA,0DAAA;ApF6mtBH;AoF3mtBE;EACC,kBAAA;EACA,mEAAA;ApF6mtBH;AoF3ntBE;EACC,oBAAA;EACA,6DAAA;ApF6ntBH;AoF3ntBE;EACC,kBAAA;EACA,sEAAA;ApF6ntBH;AoF3ntBE;EACC,oBAAA;EACA,0DAAA;ApF6ntBH;AoF3ntBE;EACC,kBAAA;EACA,mEAAA;ApF6ntBH;AoF3otBE;EACC,oBAAA;EACA,6DAAA;ApF6otBH;AoF3otBE;EACC,kBAAA;EACA,sEAAA;ApF6otBH;AoF3otBE;EACC,oBAAA;EACA,0DAAA;ApF6otBH;AoF3otBE;EACC,kBAAA;EACA,mEAAA;ApF6otBH;AoF9qtBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFgrtBF;AoFzqtBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApF2qtBF;AoFxqtBE;EACC,oBAAA;EACA,6DAAA;ApF0qtBH;AoFxqtBE;EACC,kBAAA;EACA,sEAAA;ApF0qtBH;AoFxqtBE;EACC,oBAAA;EACA,4DAAA;ApF0qtBH;AoFxqtBE;EACC,kBAAA;EACA,qEAAA;ApF0qtBH;AoFxrtBE;EACC,oBAAA;EACA,6DAAA;ApF0rtBH;AoFxrtBE;EACC,kBAAA;EACA,sEAAA;ApF0rtBH;AoFxrtBE;EACC,oBAAA;EACA,0DAAA;ApF0rtBH;AoFxrtBE;EACC,kBAAA;EACA,mEAAA;ApF0rtBH;AoFxstBE;EACC,oBAAA;EACA,6DAAA;ApF0stBH;AoFxstBE;EACC,kBAAA;EACA,sEAAA;ApF0stBH;AoFxstBE;EACC,oBAAA;EACA,0DAAA;ApF0stBH;AoFxstBE;EACC,kBAAA;EACA,mEAAA;ApF0stBH;AoFxttBE;EACC,oBAAA;EACA,4DAAA;ApF0ttBH;AoFxttBE;EACC,kBAAA;EACA,qEAAA;ApF0ttBH;AoFxttBE;EACC,oBAAA;EACA,yDAAA;ApF0ttBH;AoFxttBE;EACC,kBAAA;EACA,kEAAA;ApF0ttBH;AoF3vtBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF6vtBF;AoFtvtBC;EACC,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;ApFwvtBF;AoFrvtBE;EACC,oBAAA;EACA,6DAAA;ApFuvtBH;AoFrvtBE;EACC,kBAAA;EACA,sEAAA;ApFuvtBH;AoFrvtBE;EACC,oBAAA;EACA,2DAAA;ApFuvtBH;AoFrvtBE;EACC,kBAAA;EACA,oEAAA;ApFuvtBH;AoFrwtBE;EACC,oBAAA;EACA,6DAAA;ApFuwtBH;AoFrwtBE;EACC,kBAAA;EACA,sEAAA;ApFuwtBH;AoFrwtBE;EACC,oBAAA;EACA,2DAAA;ApFuwtBH;AoFrwtBE;EACC,kBAAA;EACA,oEAAA;ApFuwtBH;AoFrxtBE;EACC,oBAAA;EACA,6DAAA;ApFuxtBH;AoFrxtBE;EACC,kBAAA;EACA,sEAAA;ApFuxtBH;AoFrxtBE;EACC,oBAAA;EACA,2DAAA;ApFuxtBH;AoFrxtBE;EACC,kBAAA;EACA,oEAAA;ApFuxtBH;AoFrytBE;EACC,oBAAA;EACA,6DAAA;ApFuytBH;AoFrytBE;EACC,kBAAA;EACA,sEAAA;ApFuytBH;AoFrytBE;EACC,oBAAA;EACA,0DAAA;ApFuytBH;AoFrytBE;EACC,kBAAA;EACA,mEAAA;ApFuytBH;AoFx0tBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF00tBF;AoFn0tBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFq0tBF;AoFl0tBE;EACC,oBAAA;EACA,6DAAA;ApFo0tBH;AoFl0tBE;EACC,kBAAA;EACA,sEAAA;ApFo0tBH;AoFl0tBE;EACC,oBAAA;EACA,4DAAA;ApFo0tBH;AoFl0tBE;EACC,kBAAA;EACA,qEAAA;ApFo0tBH;AoFl1tBE;EACC,oBAAA;EACA,6DAAA;ApFo1tBH;AoFl1tBE;EACC,kBAAA;EACA,sEAAA;ApFo1tBH;AoFl1tBE;EACC,oBAAA;EACA,2DAAA;ApFo1tBH;AoFl1tBE;EACC,kBAAA;EACA,oEAAA;ApFo1tBH;AoFl2tBE;EACC,oBAAA;EACA,6DAAA;ApFo2tBH;AoFl2tBE;EACC,kBAAA;EACA,sEAAA;ApFo2tBH;AoFl2tBE;EACC,oBAAA;EACA,0DAAA;ApFo2tBH;AoFl2tBE;EACC,kBAAA;EACA,mEAAA;ApFo2tBH;AoFl3tBE;EACC,oBAAA;EACA,4DAAA;ApFo3tBH;AoFl3tBE;EACC,kBAAA;EACA,qEAAA;ApFo3tBH;AoFl3tBE;EACC,oBAAA;EACA,0DAAA;ApFo3tBH;AoFl3tBE;EACC,kBAAA;EACA,mEAAA;ApFo3tBH;AoFr5tBC;EACC,oCAAA;EAGA,uEAAA;EACA,sJAAA;ApFu5tBF;AoFh5tBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFk5tBF;AoF/4tBE;EACC,oBAAA;EACA,6DAAA;ApFi5tBH;AoF/4tBE;EACC,kBAAA;EACA,sEAAA;ApFi5tBH;AoF/4tBE;EACC,oBAAA;EACA,6DAAA;ApFi5tBH;AoF/4tBE;EACC,kBAAA;EACA,sEAAA;ApFi5tBH;AoF/5tBE;EACC,oBAAA;EACA,6DAAA;ApFi6tBH;AoF/5tBE;EACC,kBAAA;EACA,sEAAA;ApFi6tBH;AoF/5tBE;EACC,oBAAA;EACA,6DAAA;ApFi6tBH;AoF/5tBE;EACC,kBAAA;EACA,sEAAA;ApFi6tBH;AoF/6tBE;EACC,oBAAA;EACA,6DAAA;ApFi7tBH;AoF/6tBE;EACC,kBAAA;EACA,sEAAA;ApFi7tBH;AoF/6tBE;EACC,oBAAA;EACA,6DAAA;ApFi7tBH;AoF/6tBE;EACC,kBAAA;EACA,sEAAA;ApFi7tBH;AoF/7tBE;EACC,oBAAA;EACA,6DAAA;ApFi8tBH;AoF/7tBE;EACC,kBAAA;EACA,sEAAA;ApFi8tBH;AoF/7tBE;EACC,oBAAA;EACA,0DAAA;ApFi8tBH;AoF/7tBE;EACC,kBAAA;EACA,mEAAA;ApFi8tBH;AoFl+tBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFo+tBF;AoF79tBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApF+9tBF;AoF59tBE;EACC,oBAAA;EACA,6DAAA;ApF89tBH;AoF59tBE;EACC,kBAAA;EACA,sEAAA;ApF89tBH;AoF59tBE;EACC,oBAAA;EACA,4DAAA;ApF89tBH;AoF59tBE;EACC,kBAAA;EACA,qEAAA;ApF89tBH;AoF5+tBE;EACC,oBAAA;EACA,6DAAA;ApF8+tBH;AoF5+tBE;EACC,kBAAA;EACA,sEAAA;ApF8+tBH;AoF5+tBE;EACC,oBAAA;EACA,4DAAA;ApF8+tBH;AoF5+tBE;EACC,kBAAA;EACA,qEAAA;ApF8+tBH;AoF5/tBE;EACC,oBAAA;EACA,6DAAA;ApF8/tBH;AoF5/tBE;EACC,kBAAA;EACA,sEAAA;ApF8/tBH;AoF5/tBE;EACC,oBAAA;EACA,2DAAA;ApF8/tBH;AoF5/tBE;EACC,kBAAA;EACA,oEAAA;ApF8/tBH;AoF5guBE;EACC,oBAAA;EACA,4DAAA;ApF8guBH;AoF5guBE;EACC,kBAAA;EACA,qEAAA;ApF8guBH;AoF5guBE;EACC,oBAAA;EACA,0DAAA;ApF8guBH;AoF5guBE;EACC,kBAAA;EACA,mEAAA;ApF8guBH;AoF/iuBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFijuBF;AoF1iuBC;EACC,8BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;ApF4iuBF;AoFziuBE;EACC,oBAAA;EACA,6DAAA;ApF2iuBH;AoFziuBE;EACC,kBAAA;EACA,sEAAA;ApF2iuBH;AoFziuBE;EACC,oBAAA;EACA,0DAAA;ApF2iuBH;AoFziuBE;EACC,kBAAA;EACA,mEAAA;ApF2iuBH;AoFzjuBE;EACC,oBAAA;EACA,6DAAA;ApF2juBH;AoFzjuBE;EACC,kBAAA;EACA,sEAAA;ApF2juBH;AoFzjuBE;EACC,oBAAA;EACA,0DAAA;ApF2juBH;AoFzjuBE;EACC,kBAAA;EACA,mEAAA;ApF2juBH;AoFzkuBE;EACC,oBAAA;EACA,6DAAA;ApF2kuBH;AoFzkuBE;EACC,kBAAA;EACA,sEAAA;ApF2kuBH;AoFzkuBE;EACC,oBAAA;EACA,0DAAA;ApF2kuBH;AoFzkuBE;EACC,kBAAA;EACA,mEAAA;ApF2kuBH;AoFzluBE;EACC,oBAAA;EACA,4DAAA;ApF2luBH;AoFzluBE;EACC,kBAAA;EACA,qEAAA;ApF2luBH;AoFzluBE;EACC,oBAAA;EACA,0DAAA;ApF2luBH;AoFzluBE;EACC,kBAAA;EACA,mEAAA;ApF2luBH;AoF5nuBC;EACC,oCAAA;EAGA,uEAAA;EACA,sJAAA;ApF8nuBF;AoFvnuBC;EACC,8BAAA;EACA,kCAAA;EACA,oCAAA;EACA,8CAAA;ApFynuBF;AoFtnuBE;EACC,oBAAA;EACA,6DAAA;ApFwnuBH;AoFtnuBE;EACC,kBAAA;EACA,sEAAA;ApFwnuBH;AoFtnuBE;EACC,oBAAA;EACA,uDAAA;ApFwnuBH;AoFtnuBE;EACC,kBAAA;EACA,gEAAA;ApFwnuBH;AoFtouBE;EACC,oBAAA;EACA,6DAAA;ApFwouBH;AoFtouBE;EACC,kBAAA;EACA,sEAAA;ApFwouBH;AoFtouBE;EACC,oBAAA;EACA,uDAAA;ApFwouBH;AoFtouBE;EACC,kBAAA;EACA,gEAAA;ApFwouBH;AoFtpuBE;EACC,oBAAA;EACA,6DAAA;ApFwpuBH;AoFtpuBE;EACC,kBAAA;EACA,sEAAA;ApFwpuBH;AoFtpuBE;EACC,oBAAA;EACA,uDAAA;ApFwpuBH;AoFtpuBE;EACC,kBAAA;EACA,gEAAA;ApFwpuBH;AoFtquBE;EACC,oBAAA;EACA,0DAAA;ApFwquBH;AoFtquBE;EACC,kBAAA;EACA,mEAAA;ApFwquBH;AoFtquBE;EACC,oBAAA;EACA,uDAAA;ApFwquBH;AoFtquBE;EACC,kBAAA;EACA,gEAAA;ApFwquBH;AoFzsuBC;EACC,oCAAA;EAGA,uEAAA;EACA,sJAAA;ApF2suBF;AoFpsuBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFssuBF;AoFnsuBE;EACC,oBAAA;EACA,6DAAA;ApFqsuBH;AoFnsuBE;EACC,kBAAA;EACA,sEAAA;ApFqsuBH;AoFnsuBE;EACC,oBAAA;EACA,6DAAA;ApFqsuBH;AoFnsuBE;EACC,kBAAA;EACA,sEAAA;ApFqsuBH;AoFntuBE;EACC,oBAAA;EACA,6DAAA;ApFqtuBH;AoFntuBE;EACC,kBAAA;EACA,sEAAA;ApFqtuBH;AoFntuBE;EACC,oBAAA;EACA,6DAAA;ApFqtuBH;AoFntuBE;EACC,kBAAA;EACA,sEAAA;ApFqtuBH;AoFnuuBE;EACC,oBAAA;EACA,6DAAA;ApFquuBH;AoFnuuBE;EACC,kBAAA;EACA,sEAAA;ApFquuBH;AoFnuuBE;EACC,oBAAA;EACA,6DAAA;ApFquuBH;AoFnuuBE;EACC,kBAAA;EACA,sEAAA;ApFquuBH;AoFnvuBE;EACC,oBAAA;EACA,6DAAA;ApFqvuBH;AoFnvuBE;EACC,kBAAA;EACA,sEAAA;ApFqvuBH;AoFnvuBE;EACC,oBAAA;EACA,0DAAA;ApFqvuBH;AoFnvuBE;EACC,kBAAA;EACA,mEAAA;ApFqvuBH;AoFtxuBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFwxuBF;AoFjxuBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFmxuBF;AoFhxuBE;EACC,oBAAA;EACA,6DAAA;ApFkxuBH;AoFhxuBE;EACC,kBAAA;EACA,sEAAA;ApFkxuBH;AoFhxuBE;EACC,oBAAA;EACA,6DAAA;ApFkxuBH;AoFhxuBE;EACC,kBAAA;EACA,sEAAA;ApFkxuBH;AoFhyuBE;EACC,oBAAA;EACA,6DAAA;ApFkyuBH;AoFhyuBE;EACC,kBAAA;EACA,sEAAA;ApFkyuBH;AoFhyuBE;EACC,oBAAA;EACA,4DAAA;ApFkyuBH;AoFhyuBE;EACC,kBAAA;EACA,qEAAA;ApFkyuBH;AoFhzuBE;EACC,oBAAA;EACA,6DAAA;ApFkzuBH;AoFhzuBE;EACC,kBAAA;EACA,sEAAA;ApFkzuBH;AoFhzuBE;EACC,oBAAA;EACA,2DAAA;ApFkzuBH;AoFhzuBE;EACC,kBAAA;EACA,oEAAA;ApFkzuBH;AoFh0uBE;EACC,oBAAA;EACA,6DAAA;ApFk0uBH;AoFh0uBE;EACC,kBAAA;EACA,sEAAA;ApFk0uBH;AoFh0uBE;EACC,oBAAA;EACA,0DAAA;ApFk0uBH;AoFh0uBE;EACC,kBAAA;EACA,mEAAA;ApFk0uBH;AoFn2uBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFq2uBF;AoF91uBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFg2uBF;AoF71uBE;EACC,oBAAA;EACA,6DAAA;ApF+1uBH;AoF71uBE;EACC,kBAAA;EACA,sEAAA;ApF+1uBH;AoF71uBE;EACC,oBAAA;EACA,6DAAA;ApF+1uBH;AoF71uBE;EACC,kBAAA;EACA,sEAAA;ApF+1uBH;AoF72uBE;EACC,oBAAA;EACA,6DAAA;ApF+2uBH;AoF72uBE;EACC,kBAAA;EACA,sEAAA;ApF+2uBH;AoF72uBE;EACC,oBAAA;EACA,4DAAA;ApF+2uBH;AoF72uBE;EACC,kBAAA;EACA,qEAAA;ApF+2uBH;AoF73uBE;EACC,oBAAA;EACA,6DAAA;ApF+3uBH;AoF73uBE;EACC,kBAAA;EACA,sEAAA;ApF+3uBH;AoF73uBE;EACC,oBAAA;EACA,2DAAA;ApF+3uBH;AoF73uBE;EACC,kBAAA;EACA,oEAAA;ApF+3uBH;AoF74uBE;EACC,oBAAA;EACA,6DAAA;ApF+4uBH;AoF74uBE;EACC,kBAAA;EACA,sEAAA;ApF+4uBH;AoF74uBE;EACC,oBAAA;EACA,0DAAA;ApF+4uBH;AoF74uBE;EACC,kBAAA;EACA,mEAAA;ApF+4uBH;AoFh7uBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFk7uBF;AoF36uBC;EACC,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;ApF66uBF;AoF16uBE;EACC,oBAAA;EACA,6DAAA;ApF46uBH;AoF16uBE;EACC,kBAAA;EACA,sEAAA;ApF46uBH;AoF16uBE;EACC,oBAAA;EACA,2DAAA;ApF46uBH;AoF16uBE;EACC,kBAAA;EACA,oEAAA;ApF46uBH;AoF17uBE;EACC,oBAAA;EACA,6DAAA;ApF47uBH;AoF17uBE;EACC,kBAAA;EACA,sEAAA;ApF47uBH;AoF17uBE;EACC,oBAAA;EACA,2DAAA;ApF47uBH;AoF17uBE;EACC,kBAAA;EACA,oEAAA;ApF47uBH;AoF18uBE;EACC,oBAAA;EACA,6DAAA;ApF48uBH;AoF18uBE;EACC,kBAAA;EACA,sEAAA;ApF48uBH;AoF18uBE;EACC,oBAAA;EACA,2DAAA;ApF48uBH;AoF18uBE;EACC,kBAAA;EACA,oEAAA;ApF48uBH;AoF19uBE;EACC,oBAAA;EACA,6DAAA;ApF49uBH;AoF19uBE;EACC,kBAAA;EACA,sEAAA;ApF49uBH;AoF19uBE;EACC,oBAAA;EACA,0DAAA;ApF49uBH;AoF19uBE;EACC,kBAAA;EACA,mEAAA;ApF49uBH;AoF7/uBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF+/uBF;AoFx/uBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;ApF0/uBF;AoFv/uBE;EACC,oBAAA;EACA,6DAAA;ApFy/uBH;AoFv/uBE;EACC,kBAAA;EACA,sEAAA;ApFy/uBH;AoFv/uBE;EACC,oBAAA;EACA,4DAAA;ApFy/uBH;AoFv/uBE;EACC,kBAAA;EACA,qEAAA;ApFy/uBH;AoFvgvBE;EACC,oBAAA;EACA,6DAAA;ApFygvBH;AoFvgvBE;EACC,kBAAA;EACA,sEAAA;ApFygvBH;AoFvgvBE;EACC,oBAAA;EACA,2DAAA;ApFygvBH;AoFvgvBE;EACC,kBAAA;EACA,oEAAA;ApFygvBH;AoFvhvBE;EACC,oBAAA;EACA,6DAAA;ApFyhvBH;AoFvhvBE;EACC,kBAAA;EACA,sEAAA;ApFyhvBH;AoFvhvBE;EACC,oBAAA;EACA,0DAAA;ApFyhvBH;AoFvhvBE;EACC,kBAAA;EACA,mEAAA;ApFyhvBH;AoFvivBE;EACC,oBAAA;EACA,6DAAA;ApFyivBH;AoFvivBE;EACC,kBAAA;EACA,sEAAA;ApFyivBH;AoFvivBE;EACC,oBAAA;EACA,0DAAA;ApFyivBH;AoFvivBE;EACC,kBAAA;EACA,mEAAA;ApFyivBH;AoF1kvBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF4kvBF;AoFrkvBC;EACC,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;ApFukvBF;AoFpkvBE;EACC,oBAAA;EACA,6DAAA;ApFskvBH;AoFpkvBE;EACC,kBAAA;EACA,sEAAA;ApFskvBH;AoFpkvBE;EACC,oBAAA;EACA,2DAAA;ApFskvBH;AoFpkvBE;EACC,kBAAA;EACA,oEAAA;ApFskvBH;AoFplvBE;EACC,oBAAA;EACA,6DAAA;ApFslvBH;AoFplvBE;EACC,kBAAA;EACA,sEAAA;ApFslvBH;AoFplvBE;EACC,oBAAA;EACA,2DAAA;ApFslvBH;AoFplvBE;EACC,kBAAA;EACA,oEAAA;ApFslvBH;AoFpmvBE;EACC,oBAAA;EACA,6DAAA;ApFsmvBH;AoFpmvBE;EACC,kBAAA;EACA,sEAAA;ApFsmvBH;AoFpmvBE;EACC,oBAAA;EACA,0DAAA;ApFsmvBH;AoFpmvBE;EACC,kBAAA;EACA,mEAAA;ApFsmvBH;AoFpnvBE;EACC,oBAAA;EACA,2DAAA;ApFsnvBH;AoFpnvBE;EACC,kBAAA;EACA,oEAAA;ApFsnvBH;AoFpnvBE;EACC,oBAAA;EACA,yDAAA;ApFsnvBH;AoFpnvBE;EACC,kBAAA;EACA,kEAAA;ApFsnvBH;AoFvpvBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFypvBF;AoFlpvBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFopvBF;AoFjpvBE;EACC,oBAAA;EACA,6DAAA;ApFmpvBH;AoFjpvBE;EACC,kBAAA;EACA,sEAAA;ApFmpvBH;AoFjpvBE;EACC,oBAAA;EACA,4DAAA;ApFmpvBH;AoFjpvBE;EACC,kBAAA;EACA,qEAAA;ApFmpvBH;AoFjqvBE;EACC,oBAAA;EACA,6DAAA;ApFmqvBH;AoFjqvBE;EACC,kBAAA;EACA,sEAAA;ApFmqvBH;AoFjqvBE;EACC,oBAAA;EACA,2DAAA;ApFmqvBH;AoFjqvBE;EACC,kBAAA;EACA,oEAAA;ApFmqvBH;AoFjrvBE;EACC,oBAAA;EACA,6DAAA;ApFmrvBH;AoFjrvBE;EACC,kBAAA;EACA,sEAAA;ApFmrvBH;AoFjrvBE;EACC,oBAAA;EACA,0DAAA;ApFmrvBH;AoFjrvBE;EACC,kBAAA;EACA,mEAAA;ApFmrvBH;AoFjsvBE;EACC,oBAAA;EACA,4DAAA;ApFmsvBH;AoFjsvBE;EACC,kBAAA;EACA,qEAAA;ApFmsvBH;AoFjsvBE;EACC,oBAAA;EACA,yDAAA;ApFmsvBH;AoFjsvBE;EACC,kBAAA;EACA,kEAAA;ApFmsvBH;AoFpuvBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFsuvBF;AoF/tvBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFiuvBF;AoF9tvBE;EACC,oBAAA;EACA,6DAAA;ApFguvBH;AoF9tvBE;EACC,kBAAA;EACA,sEAAA;ApFguvBH;AoF9tvBE;EACC,oBAAA;EACA,4DAAA;ApFguvBH;AoF9tvBE;EACC,kBAAA;EACA,qEAAA;ApFguvBH;AoF9uvBE;EACC,oBAAA;EACA,6DAAA;ApFgvvBH;AoF9uvBE;EACC,kBAAA;EACA,sEAAA;ApFgvvBH;AoF9uvBE;EACC,oBAAA;EACA,2DAAA;ApFgvvBH;AoF9uvBE;EACC,kBAAA;EACA,oEAAA;ApFgvvBH;AoF9vvBE;EACC,oBAAA;EACA,6DAAA;ApFgwvBH;AoF9vvBE;EACC,kBAAA;EACA,sEAAA;ApFgwvBH;AoF9vvBE;EACC,oBAAA;EACA,0DAAA;ApFgwvBH;AoF9vvBE;EACC,kBAAA;EACA,mEAAA;ApFgwvBH;AoF9wvBE;EACC,oBAAA;EACA,4DAAA;ApFgxvBH;AoF9wvBE;EACC,kBAAA;EACA,qEAAA;ApFgxvBH;AoF9wvBE;EACC,oBAAA;EACA,0DAAA;ApFgxvBH;AoF9wvBE;EACC,kBAAA;EACA,mEAAA;ApFgxvBH;AoFjzvBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFmzvBF;AoF5yvBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;ApF8yvBF;AoF3yvBE;EACC,oBAAA;EACA,6DAAA;ApF6yvBH;AoF3yvBE;EACC,kBAAA;EACA,sEAAA;ApF6yvBH;AoF3yvBE;EACC,oBAAA;EACA,2DAAA;ApF6yvBH;AoF3yvBE;EACC,kBAAA;EACA,oEAAA;ApF6yvBH;AoF3zvBE;EACC,oBAAA;EACA,6DAAA;ApF6zvBH;AoF3zvBE;EACC,kBAAA;EACA,sEAAA;ApF6zvBH;AoF3zvBE;EACC,oBAAA;EACA,0DAAA;ApF6zvBH;AoF3zvBE;EACC,kBAAA;EACA,mEAAA;ApF6zvBH;AoF30vBE;EACC,oBAAA;EACA,6DAAA;ApF60vBH;AoF30vBE;EACC,kBAAA;EACA,sEAAA;ApF60vBH;AoF30vBE;EACC,oBAAA;EACA,0DAAA;ApF60vBH;AoF30vBE;EACC,kBAAA;EACA,mEAAA;ApF60vBH;AoF31vBE;EACC,oBAAA;EACA,6DAAA;ApF61vBH;AoF31vBE;EACC,kBAAA;EACA,sEAAA;ApF61vBH;AoF31vBE;EACC,oBAAA;EACA,0DAAA;ApF61vBH;AoF31vBE;EACC,kBAAA;EACA,mEAAA;ApF61vBH;AoF93vBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFg4vBF;AoFz3vBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApF23vBF;AoFx3vBE;EACC,oBAAA;EACA,6DAAA;ApF03vBH;AoFx3vBE;EACC,kBAAA;EACA,sEAAA;ApF03vBH;AoFx3vBE;EACC,oBAAA;EACA,6DAAA;ApF03vBH;AoFx3vBE;EACC,kBAAA;EACA,sEAAA;ApF03vBH;AoFx4vBE;EACC,oBAAA;EACA,6DAAA;ApF04vBH;AoFx4vBE;EACC,kBAAA;EACA,sEAAA;ApF04vBH;AoFx4vBE;EACC,oBAAA;EACA,6DAAA;ApF04vBH;AoFx4vBE;EACC,kBAAA;EACA,sEAAA;ApF04vBH;AoFx5vBE;EACC,oBAAA;EACA,6DAAA;ApF05vBH;AoFx5vBE;EACC,kBAAA;EACA,sEAAA;ApF05vBH;AoFx5vBE;EACC,oBAAA;EACA,0DAAA;ApF05vBH;AoFx5vBE;EACC,kBAAA;EACA,mEAAA;ApF05vBH;AoFx6vBE;EACC,oBAAA;EACA,6DAAA;ApF06vBH;AoFx6vBE;EACC,kBAAA;EACA,sEAAA;ApF06vBH;AoFx6vBE;EACC,oBAAA;EACA,0DAAA;ApF06vBH;AoFx6vBE;EACC,kBAAA;EACA,mEAAA;ApF06vBH;AoF38vBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF68vBF;AoFt8vBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFw8vBF;AoFr8vBE;EACC,oBAAA;EACA,6DAAA;ApFu8vBH;AoFr8vBE;EACC,kBAAA;EACA,sEAAA;ApFu8vBH;AoFr8vBE;EACC,oBAAA;EACA,4DAAA;ApFu8vBH;AoFr8vBE;EACC,kBAAA;EACA,qEAAA;ApFu8vBH;AoFr9vBE;EACC,oBAAA;EACA,6DAAA;ApFu9vBH;AoFr9vBE;EACC,kBAAA;EACA,sEAAA;ApFu9vBH;AoFr9vBE;EACC,oBAAA;EACA,2DAAA;ApFu9vBH;AoFr9vBE;EACC,kBAAA;EACA,oEAAA;ApFu9vBH;AoFr+vBE;EACC,oBAAA;EACA,6DAAA;ApFu+vBH;AoFr+vBE;EACC,kBAAA;EACA,sEAAA;ApFu+vBH;AoFr+vBE;EACC,oBAAA;EACA,0DAAA;ApFu+vBH;AoFr+vBE;EACC,kBAAA;EACA,mEAAA;ApFu+vBH;AoFr/vBE;EACC,oBAAA;EACA,4DAAA;ApFu/vBH;AoFr/vBE;EACC,kBAAA;EACA,qEAAA;ApFu/vBH;AoFr/vBE;EACC,oBAAA;EACA,yDAAA;ApFu/vBH;AoFr/vBE;EACC,kBAAA;EACA,kEAAA;ApFu/vBH;AoFxhwBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF0hwBF;AoFnhwBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFqhwBF;AoFlhwBE;EACC,oBAAA;EACA,6DAAA;ApFohwBH;AoFlhwBE;EACC,kBAAA;EACA,sEAAA;ApFohwBH;AoFlhwBE;EACC,oBAAA;EACA,6DAAA;ApFohwBH;AoFlhwBE;EACC,kBAAA;EACA,sEAAA;ApFohwBH;AoFliwBE;EACC,oBAAA;EACA,6DAAA;ApFoiwBH;AoFliwBE;EACC,kBAAA;EACA,sEAAA;ApFoiwBH;AoFliwBE;EACC,oBAAA;EACA,6DAAA;ApFoiwBH;AoFliwBE;EACC,kBAAA;EACA,sEAAA;ApFoiwBH;AoFljwBE;EACC,oBAAA;EACA,6DAAA;ApFojwBH;AoFljwBE;EACC,kBAAA;EACA,sEAAA;ApFojwBH;AoFljwBE;EACC,oBAAA;EACA,0DAAA;ApFojwBH;AoFljwBE;EACC,kBAAA;EACA,mEAAA;ApFojwBH;AoFlkwBE;EACC,oBAAA;EACA,6DAAA;ApFokwBH;AoFlkwBE;EACC,kBAAA;EACA,sEAAA;ApFokwBH;AoFlkwBE;EACC,oBAAA;EACA,0DAAA;ApFokwBH;AoFlkwBE;EACC,kBAAA;EACA,mEAAA;ApFokwBH;AoFrmwBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFumwBF;AoFhmwBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFkmwBF;AoF/lwBE;EACC,oBAAA;EACA,6DAAA;ApFimwBH;AoF/lwBE;EACC,kBAAA;EACA,sEAAA;ApFimwBH;AoF/lwBE;EACC,oBAAA;EACA,6DAAA;ApFimwBH;AoF/lwBE;EACC,kBAAA;EACA,sEAAA;ApFimwBH;AoF/mwBE;EACC,oBAAA;EACA,6DAAA;ApFinwBH;AoF/mwBE;EACC,kBAAA;EACA,sEAAA;ApFinwBH;AoF/mwBE;EACC,oBAAA;EACA,6DAAA;ApFinwBH;AoF/mwBE;EACC,kBAAA;EACA,sEAAA;ApFinwBH;AoF/nwBE;EACC,oBAAA;EACA,6DAAA;ApFiowBH;AoF/nwBE;EACC,kBAAA;EACA,sEAAA;ApFiowBH;AoF/nwBE;EACC,oBAAA;EACA,0DAAA;ApFiowBH;AoF/nwBE;EACC,kBAAA;EACA,mEAAA;ApFiowBH;AoF/owBE;EACC,oBAAA;EACA,6DAAA;ApFipwBH;AoF/owBE;EACC,kBAAA;EACA,sEAAA;ApFipwBH;AoF/owBE;EACC,oBAAA;EACA,0DAAA;ApFipwBH;AoF/owBE;EACC,kBAAA;EACA,mEAAA;ApFipwBH;AoFlrwBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApForwBF;AoF7qwBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApF+qwBF;AoF5qwBE;EACC,oBAAA;EACA,6DAAA;ApF8qwBH;AoF5qwBE;EACC,kBAAA;EACA,sEAAA;ApF8qwBH;AoF5qwBE;EACC,oBAAA;EACA,6DAAA;ApF8qwBH;AoF5qwBE;EACC,kBAAA;EACA,sEAAA;ApF8qwBH;AoF5rwBE;EACC,oBAAA;EACA,6DAAA;ApF8rwBH;AoF5rwBE;EACC,kBAAA;EACA,sEAAA;ApF8rwBH;AoF5rwBE;EACC,oBAAA;EACA,2DAAA;ApF8rwBH;AoF5rwBE;EACC,kBAAA;EACA,oEAAA;ApF8rwBH;AoF5swBE;EACC,oBAAA;EACA,6DAAA;ApF8swBH;AoF5swBE;EACC,kBAAA;EACA,sEAAA;ApF8swBH;AoF5swBE;EACC,oBAAA;EACA,0DAAA;ApF8swBH;AoF5swBE;EACC,kBAAA;EACA,mEAAA;ApF8swBH;AoF5twBE;EACC,oBAAA;EACA,6DAAA;ApF8twBH;AoF5twBE;EACC,kBAAA;EACA,sEAAA;ApF8twBH;AoF5twBE;EACC,oBAAA;EACA,0DAAA;ApF8twBH;AoF5twBE;EACC,kBAAA;EACA,mEAAA;ApF8twBH;AoF/vwBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFiwwBF;AoF1vwBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;ApF4vwBF;AoFzvwBE;EACC,oBAAA;EACA,6DAAA;ApF2vwBH;AoFzvwBE;EACC,kBAAA;EACA,sEAAA;ApF2vwBH;AoFzvwBE;EACC,oBAAA;EACA,4DAAA;ApF2vwBH;AoFzvwBE;EACC,kBAAA;EACA,qEAAA;ApF2vwBH;AoFzwwBE;EACC,oBAAA;EACA,6DAAA;ApF2wwBH;AoFzwwBE;EACC,kBAAA;EACA,sEAAA;ApF2wwBH;AoFzwwBE;EACC,oBAAA;EACA,0DAAA;ApF2wwBH;AoFzwwBE;EACC,kBAAA;EACA,mEAAA;ApF2wwBH;AoFzxwBE;EACC,oBAAA;EACA,6DAAA;ApF2xwBH;AoFzxwBE;EACC,kBAAA;EACA,sEAAA;ApF2xwBH;AoFzxwBE;EACC,oBAAA;EACA,0DAAA;ApF2xwBH;AoFzxwBE;EACC,kBAAA;EACA,mEAAA;ApF2xwBH;AoFzywBE;EACC,oBAAA;EACA,6DAAA;ApF2ywBH;AoFzywBE;EACC,kBAAA;EACA,sEAAA;ApF2ywBH;AoFzywBE;EACC,oBAAA;EACA,0DAAA;ApF2ywBH;AoFzywBE;EACC,kBAAA;EACA,mEAAA;ApF2ywBH;AoF50wBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF80wBF;AoFv0wBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;ApFy0wBF;AoFt0wBE;EACC,oBAAA;EACA,6DAAA;ApFw0wBH;AoFt0wBE;EACC,kBAAA;EACA,sEAAA;ApFw0wBH;AoFt0wBE;EACC,oBAAA;EACA,2DAAA;ApFw0wBH;AoFt0wBE;EACC,kBAAA;EACA,oEAAA;ApFw0wBH;AoFt1wBE;EACC,oBAAA;EACA,6DAAA;ApFw1wBH;AoFt1wBE;EACC,kBAAA;EACA,sEAAA;ApFw1wBH;AoFt1wBE;EACC,oBAAA;EACA,0DAAA;ApFw1wBH;AoFt1wBE;EACC,kBAAA;EACA,mEAAA;ApFw1wBH;AoFt2wBE;EACC,oBAAA;EACA,6DAAA;ApFw2wBH;AoFt2wBE;EACC,kBAAA;EACA,sEAAA;ApFw2wBH;AoFt2wBE;EACC,oBAAA;EACA,0DAAA;ApFw2wBH;AoFt2wBE;EACC,kBAAA;EACA,mEAAA;ApFw2wBH;AoFt3wBE;EACC,oBAAA;EACA,6DAAA;ApFw3wBH;AoFt3wBE;EACC,kBAAA;EACA,sEAAA;ApFw3wBH;AoFt3wBE;EACC,oBAAA;EACA,0DAAA;ApFw3wBH;AoFt3wBE;EACC,kBAAA;EACA,mEAAA;ApFw3wBH;AoFz5wBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF25wBF;AoFp5wBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;ApFs5wBF;AoFn5wBE;EACC,oBAAA;EACA,6DAAA;ApFq5wBH;AoFn5wBE;EACC,kBAAA;EACA,sEAAA;ApFq5wBH;AoFn5wBE;EACC,oBAAA;EACA,0DAAA;ApFq5wBH;AoFn5wBE;EACC,kBAAA;EACA,mEAAA;ApFq5wBH;AoFn6wBE;EACC,oBAAA;EACA,6DAAA;ApFq6wBH;AoFn6wBE;EACC,kBAAA;EACA,sEAAA;ApFq6wBH;AoFn6wBE;EACC,oBAAA;EACA,0DAAA;ApFq6wBH;AoFn6wBE;EACC,kBAAA;EACA,mEAAA;ApFq6wBH;AoFn7wBE;EACC,oBAAA;EACA,6DAAA;ApFq7wBH;AoFn7wBE;EACC,kBAAA;EACA,sEAAA;ApFq7wBH;AoFn7wBE;EACC,oBAAA;EACA,0DAAA;ApFq7wBH;AoFn7wBE;EACC,kBAAA;EACA,mEAAA;ApFq7wBH;AoFn8wBE;EACC,oBAAA;EACA,6DAAA;ApFq8wBH;AoFn8wBE;EACC,kBAAA;EACA,sEAAA;ApFq8wBH;AoFn8wBE;EACC,oBAAA;EACA,0DAAA;ApFq8wBH;AoFn8wBE;EACC,kBAAA;EACA,mEAAA;ApFq8wBH;AoFt+wBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFw+wBF;AoFj+wBC;EACC,8BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;ApFm+wBF;AoFh+wBE;EACC,oBAAA;EACA,6DAAA;ApFk+wBH;AoFh+wBE;EACC,kBAAA;EACA,sEAAA;ApFk+wBH;AoFh+wBE;EACC,oBAAA;EACA,0DAAA;ApFk+wBH;AoFh+wBE;EACC,kBAAA;EACA,mEAAA;ApFk+wBH;AoFh/wBE;EACC,oBAAA;EACA,6DAAA;ApFk/wBH;AoFh/wBE;EACC,kBAAA;EACA,sEAAA;ApFk/wBH;AoFh/wBE;EACC,oBAAA;EACA,0DAAA;ApFk/wBH;AoFh/wBE;EACC,kBAAA;EACA,mEAAA;ApFk/wBH;AoFhgxBE;EACC,oBAAA;EACA,6DAAA;ApFkgxBH;AoFhgxBE;EACC,kBAAA;EACA,sEAAA;ApFkgxBH;AoFhgxBE;EACC,oBAAA;EACA,0DAAA;ApFkgxBH;AoFhgxBE;EACC,kBAAA;EACA,mEAAA;ApFkgxBH;AoFhhxBE;EACC,oBAAA;EACA,6DAAA;ApFkhxBH;AoFhhxBE;EACC,kBAAA;EACA,sEAAA;ApFkhxBH;AoFhhxBE;EACC,oBAAA;EACA,0DAAA;ApFkhxBH;AoFhhxBE;EACC,kBAAA;EACA,mEAAA;ApFkhxBH;AoFnjxBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFqjxBF;AoF9ixBC;EACC,8BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;ApFgjxBF;AoF7ixBE;EACC,oBAAA;EACA,6DAAA;ApF+ixBH;AoF7ixBE;EACC,kBAAA;EACA,sEAAA;ApF+ixBH;AoF7ixBE;EACC,oBAAA;EACA,0DAAA;ApF+ixBH;AoF7ixBE;EACC,kBAAA;EACA,mEAAA;ApF+ixBH;AoF7jxBE;EACC,oBAAA;EACA,6DAAA;ApF+jxBH;AoF7jxBE;EACC,kBAAA;EACA,sEAAA;ApF+jxBH;AoF7jxBE;EACC,oBAAA;EACA,0DAAA;ApF+jxBH;AoF7jxBE;EACC,kBAAA;EACA,mEAAA;ApF+jxBH;AoF7kxBE;EACC,oBAAA;EACA,6DAAA;ApF+kxBH;AoF7kxBE;EACC,kBAAA;EACA,sEAAA;ApF+kxBH;AoF7kxBE;EACC,oBAAA;EACA,0DAAA;ApF+kxBH;AoF7kxBE;EACC,kBAAA;EACA,mEAAA;ApF+kxBH;AoF7lxBE;EACC,oBAAA;EACA,4DAAA;ApF+lxBH;AoF7lxBE;EACC,kBAAA;EACA,qEAAA;ApF+lxBH;AoF7lxBE;EACC,oBAAA;EACA,0DAAA;ApF+lxBH;AoF7lxBE;EACC,kBAAA;EACA,mEAAA;ApF+lxBH;AoFhoxBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFkoxBF;AoF3nxBC;EACC,8BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;ApF6nxBF;AoF1nxBE;EACC,oBAAA;EACA,6DAAA;ApF4nxBH;AoF1nxBE;EACC,kBAAA;EACA,sEAAA;ApF4nxBH;AoF1nxBE;EACC,oBAAA;EACA,0DAAA;ApF4nxBH;AoF1nxBE;EACC,kBAAA;EACA,mEAAA;ApF4nxBH;AoF1oxBE;EACC,oBAAA;EACA,6DAAA;ApF4oxBH;AoF1oxBE;EACC,kBAAA;EACA,sEAAA;ApF4oxBH;AoF1oxBE;EACC,oBAAA;EACA,0DAAA;ApF4oxBH;AoF1oxBE;EACC,kBAAA;EACA,mEAAA;ApF4oxBH;AoF1pxBE;EACC,oBAAA;EACA,6DAAA;ApF4pxBH;AoF1pxBE;EACC,kBAAA;EACA,sEAAA;ApF4pxBH;AoF1pxBE;EACC,oBAAA;EACA,0DAAA;ApF4pxBH;AoF1pxBE;EACC,kBAAA;EACA,mEAAA;ApF4pxBH;AoF1qxBE;EACC,oBAAA;EACA,0DAAA;ApF4qxBH;AoF1qxBE;EACC,kBAAA;EACA,mEAAA;ApF4qxBH;AoF1qxBE;EACC,oBAAA;EACA,yDAAA;ApF4qxBH;AoF1qxBE;EACC,kBAAA;EACA,kEAAA;ApF4qxBH;AoF7sxBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF+sxBF;AoFxsxBC;EACC,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;ApF0sxBF;AoFvsxBE;EACC,oBAAA;EACA,6DAAA;ApFysxBH;AoFvsxBE;EACC,kBAAA;EACA,sEAAA;ApFysxBH;AoFvsxBE;EACC,oBAAA;EACA,2DAAA;ApFysxBH;AoFvsxBE;EACC,kBAAA;EACA,oEAAA;ApFysxBH;AoFvtxBE;EACC,oBAAA;EACA,6DAAA;ApFytxBH;AoFvtxBE;EACC,kBAAA;EACA,sEAAA;ApFytxBH;AoFvtxBE;EACC,oBAAA;EACA,2DAAA;ApFytxBH;AoFvtxBE;EACC,kBAAA;EACA,oEAAA;ApFytxBH;AoFvuxBE;EACC,oBAAA;EACA,6DAAA;ApFyuxBH;AoFvuxBE;EACC,kBAAA;EACA,sEAAA;ApFyuxBH;AoFvuxBE;EACC,oBAAA;EACA,0DAAA;ApFyuxBH;AoFvuxBE;EACC,kBAAA;EACA,mEAAA;ApFyuxBH;AoFvvxBE;EACC,oBAAA;EACA,2DAAA;ApFyvxBH;AoFvvxBE;EACC,kBAAA;EACA,oEAAA;ApFyvxBH;AoFvvxBE;EACC,oBAAA;EACA,0DAAA;ApFyvxBH;AoFvvxBE;EACC,kBAAA;EACA,mEAAA;ApFyvxBH;AoF1xxBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF4xxBF;AoFrxxBC;EACC,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;ApFuxxBF;AoFpxxBE;EACC,oBAAA;EACA,6DAAA;ApFsxxBH;AoFpxxBE;EACC,kBAAA;EACA,sEAAA;ApFsxxBH;AoFpxxBE;EACC,oBAAA;EACA,2DAAA;ApFsxxBH;AoFpxxBE;EACC,kBAAA;EACA,oEAAA;ApFsxxBH;AoFpyxBE;EACC,oBAAA;EACA,6DAAA;ApFsyxBH;AoFpyxBE;EACC,kBAAA;EACA,sEAAA;ApFsyxBH;AoFpyxBE;EACC,oBAAA;EACA,2DAAA;ApFsyxBH;AoFpyxBE;EACC,kBAAA;EACA,oEAAA;ApFsyxBH;AoFpzxBE;EACC,oBAAA;EACA,6DAAA;ApFszxBH;AoFpzxBE;EACC,kBAAA;EACA,sEAAA;ApFszxBH;AoFpzxBE;EACC,oBAAA;EACA,0DAAA;ApFszxBH;AoFpzxBE;EACC,kBAAA;EACA,mEAAA;ApFszxBH;AoFp0xBE;EACC,oBAAA;EACA,4DAAA;ApFs0xBH;AoFp0xBE;EACC,kBAAA;EACA,qEAAA;ApFs0xBH;AoFp0xBE;EACC,oBAAA;EACA,0DAAA;ApFs0xBH;AoFp0xBE;EACC,kBAAA;EACA,mEAAA;ApFs0xBH;AoFv2xBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFy2xBF;AoFl2xBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFo2xBF;AoFj2xBE;EACC,oBAAA;EACA,6DAAA;ApFm2xBH;AoFj2xBE;EACC,kBAAA;EACA,sEAAA;ApFm2xBH;AoFj2xBE;EACC,oBAAA;EACA,4DAAA;ApFm2xBH;AoFj2xBE;EACC,kBAAA;EACA,qEAAA;ApFm2xBH;AoFj3xBE;EACC,oBAAA;EACA,6DAAA;ApFm3xBH;AoFj3xBE;EACC,kBAAA;EACA,sEAAA;ApFm3xBH;AoFj3xBE;EACC,oBAAA;EACA,4DAAA;ApFm3xBH;AoFj3xBE;EACC,kBAAA;EACA,qEAAA;ApFm3xBH;AoFj4xBE;EACC,oBAAA;EACA,6DAAA;ApFm4xBH;AoFj4xBE;EACC,kBAAA;EACA,sEAAA;ApFm4xBH;AoFj4xBE;EACC,oBAAA;EACA,0DAAA;ApFm4xBH;AoFj4xBE;EACC,kBAAA;EACA,mEAAA;ApFm4xBH;AoFj5xBE;EACC,oBAAA;EACA,4DAAA;ApFm5xBH;AoFj5xBE;EACC,kBAAA;EACA,qEAAA;ApFm5xBH;AoFj5xBE;EACC,oBAAA;EACA,0DAAA;ApFm5xBH;AoFj5xBE;EACC,kBAAA;EACA,mEAAA;ApFm5xBH;AoFp7xBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFs7xBF;AoF/6xBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFi7xBF;AoF96xBE;EACC,oBAAA;EACA,6DAAA;ApFg7xBH;AoF96xBE;EACC,kBAAA;EACA,sEAAA;ApFg7xBH;AoF96xBE;EACC,oBAAA;EACA,4DAAA;ApFg7xBH;AoF96xBE;EACC,kBAAA;EACA,qEAAA;ApFg7xBH;AoF97xBE;EACC,oBAAA;EACA,6DAAA;ApFg8xBH;AoF97xBE;EACC,kBAAA;EACA,sEAAA;ApFg8xBH;AoF97xBE;EACC,oBAAA;EACA,4DAAA;ApFg8xBH;AoF97xBE;EACC,kBAAA;EACA,qEAAA;ApFg8xBH;AoF98xBE;EACC,oBAAA;EACA,6DAAA;ApFg9xBH;AoF98xBE;EACC,kBAAA;EACA,sEAAA;ApFg9xBH;AoF98xBE;EACC,oBAAA;EACA,0DAAA;ApFg9xBH;AoF98xBE;EACC,kBAAA;EACA,mEAAA;ApFg9xBH;AoF99xBE;EACC,oBAAA;EACA,4DAAA;ApFg+xBH;AoF99xBE;EACC,kBAAA;EACA,qEAAA;ApFg+xBH;AoF99xBE;EACC,oBAAA;EACA,0DAAA;ApFg+xBH;AoF99xBE;EACC,kBAAA;EACA,mEAAA;ApFg+xBH;AoFjgyBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFmgyBF;AoF5/xBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApF8/xBF;AoF3/xBE;EACC,oBAAA;EACA,6DAAA;ApF6/xBH;AoF3/xBE;EACC,kBAAA;EACA,sEAAA;ApF6/xBH;AoF3/xBE;EACC,oBAAA;EACA,4DAAA;ApF6/xBH;AoF3/xBE;EACC,kBAAA;EACA,qEAAA;ApF6/xBH;AoF3gyBE;EACC,oBAAA;EACA,6DAAA;ApF6gyBH;AoF3gyBE;EACC,kBAAA;EACA,sEAAA;ApF6gyBH;AoF3gyBE;EACC,oBAAA;EACA,2DAAA;ApF6gyBH;AoF3gyBE;EACC,kBAAA;EACA,oEAAA;ApF6gyBH;AoF3hyBE;EACC,oBAAA;EACA,6DAAA;ApF6hyBH;AoF3hyBE;EACC,kBAAA;EACA,sEAAA;ApF6hyBH;AoF3hyBE;EACC,oBAAA;EACA,0DAAA;ApF6hyBH;AoF3hyBE;EACC,kBAAA;EACA,mEAAA;ApF6hyBH;AoF3iyBE;EACC,oBAAA;EACA,4DAAA;ApF6iyBH;AoF3iyBE;EACC,kBAAA;EACA,qEAAA;ApF6iyBH;AoF3iyBE;EACC,oBAAA;EACA,0DAAA;ApF6iyBH;AoF3iyBE;EACC,kBAAA;EACA,mEAAA;ApF6iyBH;AoF9kyBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFglyBF;AoFzkyBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApF2kyBF;AoFxkyBE;EACC,oBAAA;EACA,6DAAA;ApF0kyBH;AoFxkyBE;EACC,kBAAA;EACA,sEAAA;ApF0kyBH;AoFxkyBE;EACC,oBAAA;EACA,2DAAA;ApF0kyBH;AoFxkyBE;EACC,kBAAA;EACA,oEAAA;ApF0kyBH;AoFxlyBE;EACC,oBAAA;EACA,6DAAA;ApF0lyBH;AoFxlyBE;EACC,kBAAA;EACA,sEAAA;ApF0lyBH;AoFxlyBE;EACC,oBAAA;EACA,2DAAA;ApF0lyBH;AoFxlyBE;EACC,kBAAA;EACA,oEAAA;ApF0lyBH;AoFxmyBE;EACC,oBAAA;EACA,6DAAA;ApF0myBH;AoFxmyBE;EACC,kBAAA;EACA,sEAAA;ApF0myBH;AoFxmyBE;EACC,oBAAA;EACA,0DAAA;ApF0myBH;AoFxmyBE;EACC,kBAAA;EACA,mEAAA;ApF0myBH;AoFxnyBE;EACC,oBAAA;EACA,4DAAA;ApF0nyBH;AoFxnyBE;EACC,kBAAA;EACA,qEAAA;ApF0nyBH;AoFxnyBE;EACC,oBAAA;EACA,0DAAA;ApF0nyBH;AoFxnyBE;EACC,kBAAA;EACA,mEAAA;ApF0nyBH;AoF3pyBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF6pyBF;AoFtpyBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFwpyBF;AoFrpyBE;EACC,oBAAA;EACA,6DAAA;ApFupyBH;AoFrpyBE;EACC,kBAAA;EACA,sEAAA;ApFupyBH;AoFrpyBE;EACC,oBAAA;EACA,4DAAA;ApFupyBH;AoFrpyBE;EACC,kBAAA;EACA,qEAAA;ApFupyBH;AoFrqyBE;EACC,oBAAA;EACA,6DAAA;ApFuqyBH;AoFrqyBE;EACC,kBAAA;EACA,sEAAA;ApFuqyBH;AoFrqyBE;EACC,oBAAA;EACA,2DAAA;ApFuqyBH;AoFrqyBE;EACC,kBAAA;EACA,oEAAA;ApFuqyBH;AoFrryBE;EACC,oBAAA;EACA,6DAAA;ApFuryBH;AoFrryBE;EACC,kBAAA;EACA,sEAAA;ApFuryBH;AoFrryBE;EACC,oBAAA;EACA,0DAAA;ApFuryBH;AoFrryBE;EACC,kBAAA;EACA,mEAAA;ApFuryBH;AoFrsyBE;EACC,oBAAA;EACA,4DAAA;ApFusyBH;AoFrsyBE;EACC,kBAAA;EACA,qEAAA;ApFusyBH;AoFrsyBE;EACC,oBAAA;EACA,0DAAA;ApFusyBH;AoFrsyBE;EACC,kBAAA;EACA,mEAAA;ApFusyBH;AoFxuyBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApF0uyBF;AoFnuyBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFquyBF;AoFluyBE;EACC,oBAAA;EACA,6DAAA;ApFouyBH;AoFluyBE;EACC,kBAAA;EACA,sEAAA;ApFouyBH;AoFluyBE;EACC,oBAAA;EACA,4DAAA;ApFouyBH;AoFluyBE;EACC,kBAAA;EACA,qEAAA;ApFouyBH;AoFlvyBE;EACC,oBAAA;EACA,6DAAA;ApFovyBH;AoFlvyBE;EACC,kBAAA;EACA,sEAAA;ApFovyBH;AoFlvyBE;EACC,oBAAA;EACA,4DAAA;ApFovyBH;AoFlvyBE;EACC,kBAAA;EACA,qEAAA;ApFovyBH;AoFlwyBE;EACC,oBAAA;EACA,6DAAA;ApFowyBH;AoFlwyBE;EACC,kBAAA;EACA,sEAAA;ApFowyBH;AoFlwyBE;EACC,oBAAA;EACA,0DAAA;ApFowyBH;AoFlwyBE;EACC,kBAAA;EACA,mEAAA;ApFowyBH;AoFlxyBE;EACC,oBAAA;EACA,4DAAA;ApFoxyBH;AoFlxyBE;EACC,kBAAA;EACA,qEAAA;ApFoxyBH;AoFlxyBE;EACC,oBAAA;EACA,0DAAA;ApFoxyBH;AoFlxyBE;EACC,kBAAA;EACA,mEAAA;ApFoxyBH;AoFrzyBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFuzyBF;AoFhzyBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFkzyBF;AoF/yyBE;EACC,oBAAA;EACA,6DAAA;ApFizyBH;AoF/yyBE;EACC,kBAAA;EACA,sEAAA;ApFizyBH;AoF/yyBE;EACC,oBAAA;EACA,4DAAA;ApFizyBH;AoF/yyBE;EACC,kBAAA;EACA,qEAAA;ApFizyBH;AoF/zyBE;EACC,oBAAA;EACA,6DAAA;ApFi0yBH;AoF/zyBE;EACC,kBAAA;EACA,sEAAA;ApFi0yBH;AoF/zyBE;EACC,oBAAA;EACA,4DAAA;ApFi0yBH;AoF/zyBE;EACC,kBAAA;EACA,qEAAA;ApFi0yBH;AoF/0yBE;EACC,oBAAA;EACA,6DAAA;ApFi1yBH;AoF/0yBE;EACC,kBAAA;EACA,sEAAA;ApFi1yBH;AoF/0yBE;EACC,oBAAA;EACA,0DAAA;ApFi1yBH;AoF/0yBE;EACC,kBAAA;EACA,mEAAA;ApFi1yBH;AoF/1yBE;EACC,oBAAA;EACA,4DAAA;ApFi2yBH;AoF/1yBE;EACC,kBAAA;EACA,qEAAA;ApFi2yBH;AoF/1yBE;EACC,oBAAA;EACA,0DAAA;ApFi2yBH;AoF/1yBE;EACC,kBAAA;EACA,mEAAA;ApFi2yBH;AoFl4yBC;EACC,oCAAA;EAGA,yEAAA;EACA,sJAAA;ApFo4yBF;AoF73yBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;ApF+3yBF;AoF53yBE;EACC,oBAAA;EACA,6DAAA;ApF83yBH;AoF53yBE;EACC,kBAAA;EACA,sEAAA;ApF83yBH;AoF53yBE;EACC,oBAAA;EACA,2DAAA;ApF83yBH;AoF53yBE;EACC,kBAAA;EACA,oEAAA;ApF83yBH;AoF54yBE;EACC,oBAAA;EACA,6DAAA;ApF84yBH;AoF54yBE;EACC,kBAAA;EACA,sEAAA;ApF84yBH;AoF54yBE;EACC,oBAAA;EACA,2DAAA;ApF84yBH;AoF54yBE;EACC,kBAAA;EACA,oEAAA;ApF84yBH;AoF55yBE;EACC,oBAAA;EACA,6DAAA;ApF85yBH;AoF55yBE;EACC,kBAAA;EACA,sEAAA;ApF85yBH;AoF55yBE;EACC,oBAAA;EACA,0DAAA;ApF85yBH;AoF55yBE;EACC,kBAAA;EACA,mEAAA;ApF85yBH;AoF56yBE;EACC,oBAAA;EACA,4DAAA;ApF86yBH;AoF56yBE;EACC,kBAAA;EACA,qEAAA;ApF86yBH;AoF56yBE;EACC,oBAAA;EACA,0DAAA;ApF86yBH;AoF56yBE;EACC,kBAAA;EACA,mEAAA;ApF86yBH;;A8E93yBA;EACC,2BAAA;A9Ei4yBD;;A8E/3yBA;EACC,sCAAA;A9Ek4yBD;;A8Eh4yBA;EACC,iCAAA;A9Em4yBD;;A8Ej4yBA;EACC,uCAAA;A9Eo4yBD;;AqF/9yBC;EACC,mBP4FqD;A9Es4yBvD;;AqFh+yBC;EAIK,gEAAA;EAQJ,wHAAA;ArF29yBF;;AqF1+yBC;EACC,mBP6FqD;A9Eg5yBvD;;AqF3+yBC;EAIK,gEAAA;EAQJ,wHAAA;ArFs+yBF;;AqFr/yBC;EACC,mBP8FmD;A9E05yBrD;;AqFt/yBC;EAIK,gEAAA;EAQJ,wHAAA;ArFi/yBF;;AqFhgzBC;EACC,mBP+FwD;A9Eo6yB1D;;AqFjgzBC;EAIK,gEAAA;EAQJ,wHAAA;ArF4/yBF;;AqF3gzBC;EACC,mBPgGqD;A9E86yBvD;;AqF5gzBC;EAIK,gEAAA;EAQJ,wHAAA;ArFugzBF;;AqFthzBC;EACC,mBPiGuD;A9Ew7yBzD;;AqFvhzBC;EAIK,gEAAA;EAQJ,wHAAA;ArFkhzBF;;AqFjizBC;EACC,mBpF2EK;ADy9yBP;;AqFlizBC;EAIK,gEAAA;EAQJ,wHAAA;ArF6hzBF;;AqF5izBC;EACC,mBpF2EK;ADo+yBP;;AqF7izBC;EAIK,gEAAA;EAQJ,wHAAA;ArFwizBF;;AqFvjzBC;EACC,mBpFmFK;ADu+yBP;;AqFxjzBC;EAIK,gEAAA;EAQJ,wHAAA;ArFmjzBF;;AqFlkzBC;EACC,mBpFmFK;ADk/yBP;;AqFnkzBC;EAIK,gEAAA;EAQJ,wHAAA;ArF8jzBF;;AqF7kzBC;EACC,mBpF4EO;ADogzBT;;AqF9kzBC;EAIK,gEAAA;EAQJ,wHAAA;ArFykzBF;;AqFxlzBC;EACC,mBPyGD;A9Ek/yBD;;AqFzlzBC;EAMK,iEAAA;EAMJ,wHAAA;ArFolzBF;;AqFnmzBC;EACC,mBP+GD;A9Eu/yBD;;AqFpmzBC;EAMK,iEAAA;EAMJ,wHAAA;ArF+lzBF;;AqF9mzBC;EACC,mBPmHsD;A9E8/yBxD;;AqF/mzBC;EAMK,iEAAA;EAMJ,wHAAA;ArF0mzBF;;AqFznzBC;EACC,mBPsHD;A9EsgzBD;;AqF1nzBC;EAMK,iEAAA;EAMJ,wHAAA;ArFqnzBF;;AqFpozBC;EACC,mBpF2EK;AD4jzBP;;AqFrozBC;EAMK,iEAAA;EAMJ,wHAAA;ArFgozBF;;A8EnhzBA;EACC,gFAAA;A9EshzBD;;A8ElhzBE;EACC,iBAAA;A9EqhzBH;;A8EhhzBA,mBAAA;AQtIE;EACC,qBAAA;AtF0pzBH;;AsFxpzBE;EACC,qBAAA;AtF2pzBH;;AsFzpzBE;EACC,oBAAA;AtF4pzBH;;AsF1pzBE;EACC,uBAAA;AtF6pzBH;;AsF3pzBE;EACC,kBAAA;AtF8pzBH;;AsF5pzBE;EACC,qBAAA;AtF+pzBH;;AsF/qzBE;EACC,uBAAA;AtFkrzBH;;AsFhrzBE;EACC,wBAAA;AtFmrzBH;;AsFjrzBE;EACC,sBAAA;AtForzBH;;AsFlrzBE;EACC,uBAAA;AtFqrzBH;;AsFnrzBE;EACC,oBAAA;AtFsrzBH;;AsFprzBE;EACC,qBAAA;AtFurzBH;;AsFvszBE;EACC,uBAAA;AtF0szBH;;AsFxszBE;EACC,uBAAA;AtF2szBH;;AsFzszBE;EACC,sBAAA;AtF4szBH;;AsF1szBE;EACC,uBAAA;AtF6szBH;;AsF3szBE;EACC,oBAAA;AtF8szBH;;AsF5szBE;EACC,qBAAA;AtF+szBH;;AsF/tzBE;EACC,uBAAA;AtFkuzBH;;AsFhuzBE;EACC,wBAAA;AtFmuzBH;;AsFjuzBE;EACC,sBAAA;AtFouzBH;;AsFluzBE;EACC,uBAAA;AtFquzBH;;AsFnuzBE;EACC,oBAAA;AtFsuzBH;;AsFpuzBE;EACC,qBAAA;AtFuuzBH;;AsFvvzBE;EACC,uBAAA;AtF0vzBH;;AsFxvzBE;EACC,uBAAA;AtF2vzBH;;AsFzvzBE;EACC,sBAAA;AtF4vzBH;;AsF1vzBE;EACC,uBAAA;AtF6vzBH;;AsF3vzBE;EACC,oBAAA;AtF8vzBH;;AsF5vzBE;EACC,qBAAA;AtF+vzBH;;AsF/wzBE;EACC,uBAAA;AtFkxzBH;;AsFhxzBE;EACC,wBAAA;AtFmxzBH;;AsFjxzBE;EACC,sBAAA;AtFoxzBH;;AsFlxzBE;EACC,uBAAA;AtFqxzBH;;AsFnxzBE;EACC,oBAAA;AtFsxzBH;;AsFpxzBE;EACC,qBAAA;AtFuxzBH;;AsFvyzBE;EACC,uBAAA;AtF0yzBH;;AsFxyzBE;EACC,uBAAA;AtF2yzBH;;AsFzyzBE;EACC,sBAAA;AtF4yzBH;;AsF1yzBE;EACC,uBAAA;AtF6yzBH;;AsF3yzBE;EACC,oBAAA;AtF8yzBH;;AsF5yzBE;EACC,qBAAA;AtF+yzBH;;AsF/zzBE;EACC,uBAAA;AtFk0zBH;;AsFh0zBE;EACC,wBAAA;AtFm0zBH;;AsFj0zBE;EACC,sBAAA;AtFo0zBH;;AsFl0zBE;EACC,uBAAA;AtFq0zBH;;AsFn0zBE;EACC,oBAAA;AtFs0zBH;;AsFp0zBE;EACC,qBAAA;AtFu0zBH;;AsFv1zBE;EACC,uBAAA;AtF01zBH;;AsFx1zBE;EACC,uBAAA;AtF21zBH;;AsFz1zBE;EACC,sBAAA;AtF41zBH;;AsF11zBE;EACC,uBAAA;AtF61zBH;;AsF31zBE;EACC,oBAAA;AtF81zBH;;AsF51zBE;EACC,qBAAA;AtF+1zBH;;AsF/2zBE;EACC,uBAAA;AtFk3zBH;;AsFh3zBE;EACC,wBAAA;AtFm3zBH;;AsFj3zBE;EACC,sBAAA;AtFo3zBH;;AsFl3zBE;EACC,uBAAA;AtFq3zBH;;AsFn3zBE;EACC,oBAAA;AtFs3zBH;;AsFp3zBE;EACC,qBAAA;AtFu3zBH;;AsFv4zBE;EACC,qBAAA;AtF04zBH;;AsFx4zBE;EACC,uBAAA;AtF24zBH;;AsFz4zBE;EACC,oBAAA;AtF44zBH;;AsF14zBE;EACC,uBAAA;AtF64zBH;;AsF34zBE;EACC,kBAAA;AtF84zBH;;AsF54zBE;EACC,qBAAA;AtF+4zBH;;A8EtxzBA,sBAAA;A9D5EI;E8D6EJ;IAEE,gBAAA;IACA,WAAA;E9EyxzBA;AACF;;A8EtxzBA,mBAAA;AACA;EACC,wBAAA;A9EyxzBD;;A8EtwzBA,gBAAA;AACA;EACC,oBAAA;A9EywzBD;;A8EtwzBA,iBAAA;AACA;;;;;EAKC,iCAAA;EACA,6BAAA;A9EywzBD;;A8EvwzBA;EACC,iCAAA;EACA,6BAAA;EACA,kBAAA;A9E0wzBD;A8ExwzBC;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAEA,kB7EiNc;EuBpYV,qIsDoLJ;A9EywzBF;AwBz7zBM;EsDuKL;ItDtKO,gBAAA;ExB47zBN;AACF;A8E5wzBC;EAEC,iCAAA;EACA,6BAAA;A9E6wzBF;A8E3wzBC;EAIC,iCAAA;EACA,6BAAA;A9E0wzBF;A8ExwzBE;EACC,oCAAA;A9E0wzBH;A8EhwzBA;EACC,sBAAA;EACA,6BAAA;A9EkwzBD;A8EhwzBC;EAGC,4CAAA;EACA,wCAAA;A9EgwzBF;A8E9vzBC;EAEC,sBAAA;A9E+vzBF;A8EtvzBA;EACC,sBAAA;A9EwvzBD;A8EtvzBC;EACC,qCAAA;A9EwvzBF;;AuF9+zBA;EACC,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EAGA,aAAA;EACA,sBAAA;EACA,8BAAA;AvF++zBD;AgB56zBI;EuE5EJ;IAYE,yBAAA;IACA,cAAA;EvFg/zBA;AACF;AgBl7zBI;EuE5EJ;IAiBE,wBAAA;IACA,cAAA;EvFi/zBA;AACF;AuF/+zBC;EACC,kBAAA;AvFi/zBF;AgB37zBI;EuEvDH;IAIE,kBAAA;EvFk/zBD;AACF;AuFh/zBC;EACC,kBtFgdsB;EsF/ctB,mBtF+csB;ADmizBxB;AgBp8zBI;EuEhDH;IAKE,kBtFuRM;IsFtRN,mBtFsRM;ED6tzBP;AACF;AuFj/zBC;EACC,iBtFscsB;EsFrctB,oBtFqcsB;AD8izBxB;AgB98zBI;EuEvCH;IAKE,iBtF8QM;IsF7QN,oBtF6QM;EDuuzBP;AACF;;AwFhi0BA;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBvFmUkB;EuFlUlB,8BAAA;EACA,sBAAA;AxFmi0BD;AwFhi0BC;EACC,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AxFki0BF;AgBt+zBI;EwE5EJ;IAoBE,SAAA;ExFki0BA;AACF;AgB3+zBI;EwE5EJ;IAwBE,aAAA;ExFmi0BA;AACF;;AyF5j0BA;EACC,WAAA;EACA,iBAAA;EACA,gDAAA;EACA,qBAAA;EACA,sBAAA;EACA,mCAAA;AzF+j0BD;;AyF5j0BA;EACC;IACC,sBAAA;EzF+j0BA;EyF5j0BD;IACC,uBAAA;EzF8j0BA;AACF;AyF1j0BC;EACC,eAAA;AzF4j0BF;AyF1j0BE;EACC,eAAA;AzF4j0BH;AyF1j0BG;EACC,aAAA;AzF4j0BJ;;AyFtj0BA;EACC,exFmamB;EwFlanB,eAAA;EACA,MAAA;EACA,OAAA;EACA,gBxF4amB;EwF3anB,axFgamB;EwF/ZnB,2BAAA;EACA,aAAA;EACA,iCAAA;AzFyj0BD;AyFvj0BC;EACC,YAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AzFyj0BF;AyFvj0BE;EACC,eAAA;EACA,cAAA;EACA,WAAA;EACA,0DAAA;EACA,2BAAA;AzFyj0BH;AyFvj0BG;EACC,mBAAA;AzFyj0BJ;AyFpj0BG;EACC,2DAAA;AzFsj0BJ;AyFlj0BC;EACC,YAAA;EACA,aAAA;AzFoj0BF;AgBlj0BI;EyEJH;IAKE,aAAA;IACA,mBAAA;EzFqj0BD;AACF;AyFnj0BC;EACC,YAAA;EACA,aAAA;EACA,mBAAA;AzFqj0BF;AgB7j0BI;EyEKH;IAME,aAAA;EzFsj0BD;AACF;AyFnj0BC;EACC,YAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AzFoj0BF;AgB1k0BI;EyEeH;IAUE,2BAAA;EzFqj0BD;AACF;AyFnj0BE;EACC,qBAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;AzFqj0BH;AgBxl0BI;EyE4BF;IAUE,sBAAA;IACA,SAAA;EzFsj0BF;AACF;AyFpj0BG;EACC,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AzFsj0BJ;AyFpj0BI;EAEC,mDAAA;AzFqj0BL;AyFjj0BG;;;;EAIC,UAAA;EACA,WAAA;AzFmj0BJ;AyFhj0BG;;;;EAIC,WAAA;AzFkj0BJ;AyF/i0BG;EACC,aAAA;EACA,mBAAA;AzFij0BJ;AyF9i0BG;EACC,eAAA;EACA,gBAAA;AzFgj0BJ;AyFxi0BG;EACC,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,kBxF0II;AD45zBT;AyFni0BI;EACC,cAAA;EACA,uBAAA;EACA,gBxFsJc;EwFrJd,kBAAA;AzFqi0BL;AyFhi0BC;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AzFki0BF;AyFhi0BE;EACC,YAAA;EACA,aAAA;EACA,mBAAA;AzFki0BH;AyFhi0BG;EACC,qBAAA;EACA,sCAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AzFki0BJ;AyFhi0BI;EACC,WAAA;EACA,YAAA;EAKC,qBAAA;AzF8h0BN;AyF3h0BK;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AzF6h0BN;AyF1h0BI;EACC,kBAAA;AzF4h0BL;AyF1h0BI;EACC,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EAKC,WxF6EG;AD28zBT;AyFlh0BC;EACC,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,exF+MkB;EwF9MlB,mCAAA;EACA,gCAAA;AzFoh0BF;AyFlh0BE;EACC,qBxF6M2B;EwF5M3B,cAAA;EACA,exFwMiB;EwFvMjB,aAAA;AzFoh0BH;AyFlh0BG;EACC,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AzFoh0BJ;AyFjh0BK;EACC,cAAA;AzFmh0BN;AyFhh0BI;EACC,qDAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;AzFkh0BL;AyFhh0BK;EACC,sCAAA;AzFkh0BN;AyF9g0BG;EACC,SAAA;AzFgh0BJ;AyF9g0BI;EACC,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AzFgh0BL;AyF5g0BE;EACC,MAAA;AzF8g0BH;AgBpu0BI;EyE3CJ;IAsQE,WAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,2BAAA;EzF6g0BA;AACF;;AyF1g0BA;EACC,aAAA;AzF6g0BD;AyF3g0BC;EACC,YAAA;AzF6g0BF;AyF3g0BE;EACC,YAAA;AzF6g0BH;;AyFxg0BA;EACC,UAAA;AzF2g0BD;;AyFxg0BA;EACC;IACC,WAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,2BAAA;IACA,YAAA;IACA,oBAAA;EzF2g0BA;AACF;AyFxg0BA;EACC;IACC,YAAA;EzF0g0BA;EyFvg0BD;IACC,SAAA;EzFyg0BA;AACF;A0F710BA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,azFqdoC;EyFpdpC,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,+BzF8cgC;ADi5zBjC;;A2F720BA;EACC;IACC,+BAAA;E3Fg30BA;AACF;A2F720BA;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,8BAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;A3F+20BD;;A2F520BA;EACC,gB1F6bmB;E0F5bnB,mCAAA;EACA,SAAA;EACA,eAAA;EACA,Y1F4amB;E0F3anB,a1F8boB;E0F7bpB,iCAAA;EAcC,OAAA;A3Fk20BF;A2F720BE;EACC,+BAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;A3F+20BH;AgBr00BI;E2ExDJ;IAyBE,2BAAA;IACA,gCAAA;E3Fw20BA;AACF;A2Ft20BC;EACC,sBAAA;A3Fw20BF;A2Ft20BE;EAEC,wBAAA;A3Fu20BH;A2Fn20BC;EACC,2BAAA;A3Fq20BF;A2Fl20BC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;A3Fo20BF;A2Fl20BE;EACC,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;A3Fo20BH;A2Fl20BG;EACC,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;A3Fo20BJ;A2Fj20BI;EACC,kBAAA;A3Fm20BL;A2Fh20BM;EACC,UAAA;EACA,mBAAA;A3Fk20BP;A2F710BI;EACC,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,UAAA;A3F+10BL;A2F510BI;EACC,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;A3F810BL;A2F510BK;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EAKC,qBAAA;A3F010BP;A2Fv10BK;EACC,aAAA;EACA,mBAAA;A3Fy10BN;A2Fv10BM;EACC,aAAA;A3Fy10BP;A2Ft10BK;EACC,SAAA;EACA,gBAAA;EACA,uBAAA;A3Fw10BN;A2Ft10BK;EAEC,kDAAA;A3Fu10BN;A2Fp10BI;EACC,gBAAA;EACA,aAAA;EACA,iBAAA;A3Fs10BL;A2Fp10BK;EACC,kBAAA;EAKC,sBAAA;A3Fk10BP;A2F700BK;EACC,mDAAA;A3F+00BN;A2F500BM;EACC,sB1F+SmC;AD+h0B1C;A2F100BM;EACC,cAAA;A3F400BP;A2Fv00BK;EACC,cAAA;A3Fy00BN;A2Fv00BM;EACC,+EAAA;EAKC,mCAAA;A3Fq00BR;A2Fxz0BK;EACC,qBALM;A3F+z0BZ;A2F3z0BK;EACC,qBALM;A3Fk00BZ;A2F9z0BK;EACC,qBALM;A3Fq00BZ;A2Fj00BK;EACC,qBALM;A3Fw00BZ;A2Fp00BK;EACC,sBALM;A3F200BZ;A2Fv00BK;EACC,sBALM;A3F800BZ;A2F100BK;EACC,sBALM;A3Fi10BZ;A2F700BK;EACC,sBALM;A3Fo10BZ;A2Fh10BK;EACC,sBALM;A3Fu10BZ;A2Fn10BK;EACC,sBALM;A3F010BZ;A2Ft10BK;EACC,sBALM;A3F610BZ;A2Fz10BK;EACC,sBALM;A3Fg20BZ;A2F510BK;EACC,sBALM;A3Fm20BZ;A2F/10BK;EACC,sBALM;A3Fs20BZ;A2Fl20BK;EACC,sBALM;A3Fy20BZ;A2Fr20BK;EACC,sBALM;A3F420BZ;A2Fx20BK;EACC,sBALM;A3F+20BZ;A2F320BK;EACC,sBALM;A3Fk30BZ;A2F920BK;EACC,sBALM;A3Fq30BZ;A2Fj30BK;EACC,sBALM;A3Fw30BZ;A2Fp30BK;EACC,sBALM;A3F230BZ;A2Fv30BK;EACC,sBALM;A3F830BZ;A2F130BK;EACC,sBALM;A3Fi40BZ;A2F730BK;EACC,sBALM;A3Fo40BZ;A2Fh40BK;EACC,sBALM;A3Fu40BZ;A2Fn40BK;EACC,sBALM;A3F040BZ;A2Ft40BK;EACC,sBALM;A3F640BZ;A2Fz40BK;EACC,sBALM;A3Fg50BZ;A2F540BK;EACC,sBALM;A3Fm50BZ;A2F/40BK;EACC,sBALM;A3Fs50BZ;A2Fl50BK;EACC,sBALM;A3Fy50BZ;A2Fr50BK;EACC,sBALM;A3F450BZ;A2Fx50BK;EACC,sBALM;A3F+50BZ;A2F350BK;EACC,sBALM;A3Fk60BZ;A2F950BK;EACC,sBALM;A3Fq60BZ;A2Fj60BK;EACC,sBALM;A3Fw60BZ;A2Fp60BK;EACC,sBALM;A3F260BZ;A2Fv60BK;EACC,sBALM;A3F860BZ;A2F160BK;EACC,sBALM;A3Fi70BZ;A2F760BK;EACC,sBALM;A3Fo70BZ;A2Fh70BK;EACC,sBALM;A3Fu70BZ;A2Fn70BK;EACC,sBALM;A3F070BZ;A2Ft70BK;EACC,sBALM;A3F670BZ;A2Fz70BK;EACC,sBALM;A3Fg80BZ;A2F570BK;EACC,sBALM;A3Fm80BZ;A2F/70BK;EACC,sBALM;A3Fs80BZ;A2Fl80BK;EACC,sBALM;A3Fy80BZ;A2Fr80BK;EACC,sBALM;A3F480BZ;A2Fx80BK;EACC,sBALM;A3F+80BZ;A2Fp80BC;EACC,aAAA;A3Fs80BF;A2Fp80BC;EACC,yBAAA;A3Fs80BF;A2Fj80BK;EACC,qBAAA;A3Fm80BN;;A4F3p1BA;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;A5F8p1BD;A4F5p1BC;EACC,gBAAA;A5F8p1BF;A4F5p1BE;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,2BAAA;A5F8p1BH;A4F5p1BG;EACC,YAAA;A5F8p1BJ;A4F1p1BG;EACC,UAAA;A5F4p1BJ;A4F1p1BI;EACC,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,c3F6BG;E2F5BH,aAAA;EACA,mBAAA;EACA,uBAAA;ECpCJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7Fis1BD;;A4Fxp1BA;EACC,eAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;A5F2p1BD;A4Fzp1BC;EACC,YAAA;A5F2p1BF;A4Fzp1BC;EACC,wCAAA;EACA,4D3F+VW;E2F9VX,eAAA;A5F2p1BF;A4Fzp1BE;EACC,c3FHK;E2FIL,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;A5F2p1BH;A4Fzp1BG;EACC,kBAAA;A5F2p1BJ;A4Fzp1BI;EACC,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;ECvFJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7Fmv1BD;A4F3p1BG;EACC,qBAAA;EACA,gB3F0OmB;E2FzOnB,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;A5F6p1BJ;A4F3p1BG;EACC,YAAA;A5F6p1BJ;A4F3p1BG;EACC,UAAA;A5F6p1BJ;A4F1p1BK;EACC,c3FlDE;AD8s1BR;A4F1p1BK;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,8BAAA;A5F4p1BN;A4Fpp1BE;EACC,gBAAA;EACA,aAAA;EACA,eAAA;A5Fsp1BH;A4Fpp1BG;EACC,gBAAA;EACA,aAAA;A5Fsp1BJ;A4Fpp1BI;EACC,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;EACA,2BAAA;A5Fsp1BL;A4Fpp1BK;EACC,YAAA;A5Fsp1BN;A4Fpp1BK;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mB3FtEE;E2FuEF,aAAA;A5Fsp1BN;A4Flp1BK;EACC,UAAA;A5Fop1BN;A4Flp1BM;EACC,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,c3F/GC;E2FgHD,aAAA;EACA,mBAAA;EACA,uBAAA;EChLN,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7Fq01BD;A4Fhp1BC;EACC,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,sCAAA;EACA,wCAAA;EACA,kBAAA;EAMC,OAAA;EACA,kBAAA;A5F6o1BH;A4F1o1BC;EACC,6BAAA;A5F4o1BF;;A8F311BA;EACC;IAAO,eAAA;E9F+11BN;E8F911BD;IAAK,OAAA;E9Fi21BJ;AACF;A8Fh21BA;EACC;IAAO,gBAAA;E9Fm21BN;E8Fl21BD;IAAK,QAAA;E9Fq21BJ;AACF;A8Fp21BA;EACC,oCAAA;EACA,OAAA;EACA,QAAA;EACA,a7FodoB;ADk50BrB;AgBnz1BI;E8EvDJ;IAOE,Y7FsbkB;I6FrblB,eAAA;IACA,gB7FgdmB;EDu50BnB;AACF;AgB7y1BI;E8EpEJ;IAYE,aAAA;E9Fy21BA;AACF;AgB/z1BI;E8ExCH;IAEE,aAAA;IACA,iBAAA;IACA,mBAAA;E9Fy21BD;AACF;AgBzz1BI;E8ErDH;IAOE,cAAA;IACA,oBAAA;E9F221BD;AACF;A8Fz21BE;EACC,kBAAA;A9F221BH;A8Fz21BG;EACC,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;A9F221BJ;AgB701BI;E8EvCD;IAYE,mBAAA;IACA,sBAAA;E9F421BH;AACF;A8F121BI;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,qBAAA;A9Fw21BN;A8Fr21BI;EACC,oBAAA;EAKC,oBAAA;A9Fm21BN;A8Fh21BI;EACC,SAAA;A9Fk21BL;A8Fh21BI;EAEC,kDAAA;A9Fi21BL;A8F911BG;EACC,iDAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;A9Fg21BJ;AgB331BI;E8EuBD;IAOE,kBAAA;IACA,kCAAA;IAKC,OAAA;E9F611BJ;AACF;AgBr31BI;E8EUD;IAiBE,cAAA;IACA,oB7FgNI;I6F3MH,sBAAA;E9F011BJ;AACF;A8Fv11BI;EACC,kBAAA;A9Fy11BL;A8Fv11BK;EACC,qBAAA;A9Fy11BN;A8Fp11BI;EACC,mDAAA;A9Fs11BL;A8Fn11BK;EACC,sB7FwWoC;AD6+0B1C;A8Fj11BG;EACC,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;A9Fm11BJ;AgB941BI;E8EuDD;IAOE,wBAAA;E9Fo11BH;AACF;A8Fl11BI;EACC,UAAA;EACA,kBAAA;EACA,e7FiVgB;E6FhVhB,gB7FgVgB;E6F/UhB,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;A9Fo11BL;A8Fl11BK;EACC,WAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;A9Fo11BN;A8Fl11BK;EAEC,kDAAA;A9Fm11BN;A8Fh11BI;EAIE,cAAA;A9F+01BN;A8F501BK;EAIE,gDAAA;A9F201BP;A8Fx01BK;EAKE,OAAA;EACA,yCAAA;A9Fs01BP;A8Fl01BI;EAIE,eAAA;A9Fi01BN;A8F9z1BK;EAIE,iDAAA;A9F6z1BP;A8F1z1BK;EAKE,QAAA;EACA,0CAAA;A9Fwz1BP;AgB181BI;E8E2JC;IAEE,cAAA;E9Fiz1BL;AACF;;A+F9g2BA;EACC,+BAAA;EACA,qBAAA;EACA,6BAAA;A/Fih2BD;;A+F/g2BA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mB9FsDO;E8FrDP,UAAA;EACA,kBAAA;A/Fkh2BD;;A+F/g2BA;EACC,mBAAA;EACA,gBAAA;A/Fkh2BD;;A+F/g2BA;EACC,c9FoEO;E8FnEP,eAAA;A/Fkh2BD;;A+F/g2BA;EACC,cAAA;A/Fkh2BD;;A+F/g2BA;EACC,iBAAA;EACA,gBAAA;A/Fkh2BD;;A+F/g2BA;EACC,iBAAA;A/Fkh2BD;;A+F/g2BA,eAAA;AACA;EACC,kBAAA;A/Fkh2BD;;A+F/g2BA;EACC,WAAA;EACA,YAAA;A/Fkh2BD;;A+F/g2BA;EACC,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;A/Fkh2BD;;A+F/g2BA;EACC,YAAA;EACA,eAAA;EACA,cAAA;A/Fkh2BD;;A+F/g2BA;EACC,yBAAA;A/Fkh2BD;;AgBzg2BI;E+ENJ;IAGE,gBAAA;E/Fih2BA;AACF;;A+F/g2BA;EACC;IACC,YAAA;E/Fkh2BA;E+F/g2BD;IACC,sBAAA;E/Fih2BA;AACF;A+F9g2BA;EACC,UAAA;A/Fgh2BD;;A+F7g2BA;EACC,qCAAA;A/Fgh2BD;;A+F7g2BA;EACC,2CAAA;A/Fgh2BD;;A+F7g2BA;EACC,iBAAA;EACA,yBAAA;EACA,kDAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;A/Fgh2BD;;A+F7g2BA;EACC,iDAAA;A/Fgh2BD;;A+F7g2BA;;EAEC,kDAAA;EACA,iDAAA;EACA,aAAA;A/Fgh2BD;;A+F7g2BA;EACC,WAAA;EACA,aAAA;A/Fgh2BD;;A+F7g2BA;EACC,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;A/Fgh2BD;;A+F9g2BA;EACC,gBAAA;EACA,mBAAA;A/Fih2BD;;A+F/g2BA;EACC,gBAAA;EACA,WAAA;A/Fkh2BD;;A+F/g2BA;EACC,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;A/Fkh2BD;;A+F/g2BA;EACC,kBAAA;A/Fkh2BD;;A+F/g2BA;EACC,UAAA;EACA,mBAAA;A/Fkh2BD;;A+F/g2BA;EACC,kBAAA;A/Fkh2BD;;A+F/g2BA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;A/Fkh2BD;;A+F/g2BA;EACC,UAAA;EACA,WAAA;A/Fkh2BD;;A+F/g2BA;EACC,sBAAA;EACA,uBAAA;A/Fkh2BD;;A+F/g2BA;EACC,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;A/Fkh2BD;;A+F/g2BA;EACC,mBAAA;A/Fkh2BD;;A+F/g2BA;EACC,WAAA;EACA,YAAA;A/Fkh2BD;;A+F/g2BA;EACC,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A/Fkh2BD;;A+F9g2BC;EACC,sBAAA;A/Fih2BF;;AgBnq2BI;E+EuJH;IACC,sBAAA;E/Fgh2BA;E+F9g2BA;IACC,kCAAA;E/Fgh2BD;AACF;AgB5q2BI;E+EiKH;IACC,0BAAA;IACA,sBAAA;E/F8g2BA;E+F5g2BA;IACC,SAAA;IACA,6BAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;IACA,2BAAA;IACA,6BAAA;E/F8g2BD;AACF;A+F1g2BA;EACC,YAAA;EACA,UAAA;A/F4g2BD;AgBhs2BI;E+EkLJ;IAKE,YAAA;E/F6g2BA;AACF;AgBrs2BI;E+EkLJ;IASE,WAAA;E/F8g2BA;E+F5g2BA;IACC,gBAAA;IACA,kBAAA;IACA,oBAAA;IACA,gBAAA;E/F8g2BD;AACF;;A+F1g2BA;;EAEC,+BAAA;A/F6g2BD;;A+F1g2BA;;EAEC,8BAAA;A/F6g2BD;;A+F1g2BA;EACC,6BAAA;EACA,kBAAA;A/F6g2BD;;A+F1g2BA;;EAEC,UAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;A/F6g2BD;;A+F1g2BA;EACC,kBAAA;EACA,kBAAA;A/F6g2BD;;A+F1g2BA;EACC,gBAAA;A/F6g2BD;;A+F1g2BA;;EAEC,wBAAA;A/F6g2BD;;A+F1g2BA,UAAA;AACA;EACC,WAAA;EACA,YAAA;EACA,4CAAA;A/F6g2BD;;A+F1g2BA,WAAA;AACA;EACC,2BAAA;A/F6g2BD;;A+F1g2BA;EACC,YAAA;A/F6g2BD;A+F3g2BC;EACC,YAAA;A/F6g2BF;A+F1g2BC;EACC,YAAA;A/F4g2BF;;A+Fxg2BA;EACC,YAAA;A/F2g2BD;;A+Fxg2BA;EACC,yBAAA;A/F2g2BD;;A+Fxg2BA;EACC,yBAAA;A/F2g2BD;;A+Fxg2BA;EACC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,+BAAA;EACA,mBAAA;EACA,mB9FzQO;E8F0QP,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;A/F2g2BD;;A+Fxg2BA;EACC,kBAAA;A/F2g2BD;A+Fzg2BC;EACC,aAAA;A/F2g2BF;A+Fvg2BE;EACC,aAAA;A/Fyg2BH;A+Fvg2BE;EACC,cAAA;A/Fyg2BH;;A+Fpg2BA;EACC,UAAA;EACA,mBAAA;A/Fug2BD;;A+Fpg2BA;EACC,iBAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;A/Fug2BD;A+Frg2BC;EACC,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yB9FhVM;ADu12BR;;A+Fng2BA;;EAEC,UAAA;EACA,+BAAA;EACA,QAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;A/Fsg2BD;;A+Fng2BA;;EAEC,0BAAA;EACA,kBAAA;A/Fsg2BD;;A+Fng2BA;EACC,UAAA;A/Fsg2BD;;A+Fng2BA;EACC,WAAA;A/Fsg2BD;;A+Fng2BA;;EAEC,aAAA;A/Fsg2BD;;A+Fng2BA;EACC,aAAA;A/Fsg2BD;;A+Fng2BA;EACC,wBAAA;EACA,kBAAA;EACA,oBAAA;A/Fsg2BD;;A+Fng2BA;EACC,2BAAA;A/Fsg2BD;;AgBx32BI;E+EsXH;IACC,aAAA;E/Fsg2BA;E+Fng2BD;IACC,uBAAA;E/Fqg2BA;E+Flg2BD;IACC,uBAAA;IACA,sBAAA;IACA,0BAAA;E/Fog2BA;AACF;A+Fjg2BA;EACC,UAAA;A/Fmg2BD;;A+Fhg2BA;EACC,aAAA;A/Fmg2BD;;A+Fjg2BA;EACC,aAAA;A/Fog2BD;;A+Fjg2BA;EACC,eAAA;A/Fog2BD;;A+F3/1BC;EAEC,sBAAA;A/F6/1BF;A+F3/1BE;EACC,sBAAA;A/F6/1BH;;A+Fv/1BC;EAEC,kCAAA;EACA,sBAAA;A/Fy/1BF;;A+Fr/1BA;EACC,uBAAA;A/Fw/1BD;;A+Fr/1BA;EACC,sBAAA;A/Fw/1BD;;A+Fr/1BA;EACC,qCAAA;A/Fw/1BD;;A+Fp/1BC;EACC,4BAAA;A/Fu/1BF;A+Fl/1BE;EACC,aAAA;A/Fu/1BH;;A+Fl/1BA;EACC,kBAAA;A/Fq/1BD;;A+Fl/1BA;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;A/Fq/1BD;;A+Fl/1BA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,kBAAA;A/Fq/1BD;;A+Fl/1BA;EACC,qB9FxeO;AD692BR;;A+Fl/1BA;EACC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,+BAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;A/Fq/1BD;;A+Fj/1BC;EACC,cAAA;A/Fo/1BF;;A+Fh/1BA;EACC,c9FpeO;E8FqeP,kBAAA;EACA,UAAA;A/Fm/1BD;;A+Fh/1BA;EACC,4BAAA;EACA,4BAAA;A/Fm/1BD;;A+Fh/1BA;EACC,iBAAA;EACA,uBAAA;A/Fm/1BD;;A+Fh/1BA;EACC,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,c9F1gBM;AD6/2BP;A+Fj/1BC;EACC,mBAAA;EACA,mBAAA;A/Fm/1BF;A+Fh/1BC;EACC,aAAA;A/Fk/1BF;A+F/+1BC;EACC,wBAAA;A/Fi/1BF;A+F9+1BC;EACC,c9F5iBM;AD4h3BR;AgB/g3BI;E+EmiBF;IACC,YAAA;E/F++1BD;E+F5+1BA;IACC,wBAAA;E/F8+1BD;AACF;;A+F1+1BA;EACC,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;A/F6+1BD;;A+F1+1BA;EACC,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A/F6+1BD;;A+F1+1BA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;A/F6+1BD;;A+F1+1BA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;A/F6+1BD;A+F3+1BC;EACC,eAAA;A/F6+1BF;AgB9j3BI;E+EwkBJ;IAaE,qBAAA;E/F6+1BA;AACF;AgBnk3BI;E+EwkBJ;IAiBE,sBAAA;E/F8+1BA;AACF;;A+F3+1BA;EACC,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,uBAAA;A/F8+1BD;A+F5+1BC;EACC,sFAAA;A/F8+1BF;A+F3+1BC;EACC,sFAAA;A/F6+1BF;A+F1+1BC;EACC,sFAAA;A/F4+1BF;;A+Fx+1BA;EACC,WAAA;EACA,YAAA;EACA,UAAA;A/F2+1BD;;A+Fx+1BA;EACC;IAEC,UAAA;IACA,iBAAA;IACA,oBAAA;E/F0+1BA;E+Fv+1BD;IACC,YAAA;IACA,kBAAA;IACA,mBAAA;E/Fy+1BA;AACF;A+Ft+1BA;EACC;IAEC,UAAA;IACA,iBAAA;IACA,oBAAA;E/Fu+1BA;E+Fp+1BD;IACC,YAAA;IACA,kBAAA;IACA,mBAAA;E/Fs+1BA;AACF;A+Fn+1BA;EACC;IAEC,UAAA;IACA,iBAAA;IACA,oBAAA;E/Fo+1BA;E+Fj+1BD;IACC,YAAA;IACA,kBAAA;IACA,mBAAA;E/Fm+1BA;AACF;A+Fh+1BA;EACC,4BAAA;A/Fk+1BD;;A+F/91BA;EACC,eAAA;EACA,YAAA;A/Fk+1BD;;A+F/91BA;EACC,YAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;A/Fk+1BD;;A+F/91BA;EACC,0BAAA;A/Fk+1BD;;A+F/91BA;EACC,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;A/Fk+1BD;A+F791BI;EACC,UAAA;A/F+91BL;A+Fz91BC;EACC,kBAAA;EACA,gBAAA;A/F291BF;A+Fz91BE;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;A/F291BH;A+Fv91BC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A/Fy91BF;A+Ft91BC;EACC,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;A/Fw91BF;AgBxs3BI;E+E2uBH;IAQE,cAAA;IACA,iBAAA;IACA,wBAAA;IACA,eAAA;IACA,gBAAA;E/Fy91BD;AACF;A+Ft91BC;EACC,qBAAA;EACA,c9F1wBM;E8F2wBN,gBAAA;A/Fw91BF;A+Ft91BE;EACC,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,aAAA;A/Fw91BH;A+Fr91BI;EACC,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A/Fu91BL;A+Fn91BG;EACC,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;A/Fq91BJ;A+Fl91BG;EACC,cAAA;A/Fo91BJ;A+Fh91BE;EACC,c9F7xBI;AD+u3BP;A+F981BC;EACC,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;A/Fg91BF;AgBhw3BI;E+EsyBH;IAaE,OAAA;IACA,eAAA;E/Fi91BD;E+F/81BC;IACC,YAAA;IAAA,cAAA;IAAA,4BAAA;E/Fi91BF;AACF;A+F781BC;EACC,mB9FzzBI;E8F0zBJ,c9F30BM;E8F40BN,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;A/F+81BF;A+F781BE;EACC,yBAAA;A/F+81BH;A+F381BC;EACC,aAAA;EACA,oBAAA;A/F681BF;A+F181BC;EACC,sBAAA;A/F481BF;A+F181BE;EACC,cAAA;A/F481BH;A+Fx81BG;EACC,uBAAA;A/F081BJ;AgBty3BI;E+E6rBJ;IAqKE,cAAA;E/Fw81BA;AACF;AgB3y3BI;E+E6rBJ;IAyKE,cAAA;E/Fy81BA;AACF;;AgBhz3BI;E+E02BJ;IAEE,uBAAA;E/Fy81BA;E+Fv81BA;IACC,YAAA;E/Fy81BD;E+Ft81BA;IACC,uBAAA;E/Fw81BD;E+Fr81BA;IACC,uBAAA;E/Fu81BD;E+Ft81BC;IACC,wBAAA;E/Fw81BF;AACF;;A+Fn81BA;EACC,2BAAA;A/Fs81BD;A+Fp81BC;EACC,YAAA;A/Fs81BF;AgBz03BI;E+E+3BJ;IAQE,YAAA;E/Fs81BA;AACF;;A+Fn81BA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,mB9F55BO;E8F65BP,UAAA;EACA,c9Fr4BO;E8Fs4BP,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;A/Fs81BD;A+Fp81BC;EACC,cAAA;A/Fs81BF;;A+Fl81BA;EACC,kBAAA;EACA,QAAA;EACA,WAAA;A/Fq81BD;;A+Fl81BA;EACC,aAAA;A/Fq81BD;;A+Fl81BA;EACC,kBAAA;EACA,WAAA;A/Fq81BD;;A+Fl81BA;EACC,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;A/Fq81BD;;A+Fl81BA;EACC,eAAA;EACA,YAAA;A/Fq81BD;;A+Fl81BA;EACC,mBAAA;A/Fq81BD;;A+Fl81BA;EACC,SAAA;A/Fq81BD;;A+Fl81BA;EACC,2BAAA;EACA,SAAA;A/Fq81BD;;A+Fl81BA;;EAEC,aAAA;A/Fq81BD;;A+Fl81BA;EACC,aAAA;A/Fq81BD;;A+Fl81BA;EACC,qBAAA;A/Fq81BD;;A+Fh81BC;EACC,UAAA;A/Fm81BF;A+Fh81BC;EACC,UAAA;A/Fk81BF;A+F/71BC;EACC,YAAA;A/Fi81BF;;A+F771BA,SAAA;AAeC;EACC,aAAA;A/Fk71BF;A+F961BE;EACC,cAAA;A/Fg71BH;;A+F361BA;EACC,aAAA;EACA,sBAAA;EACA,YAAA;A/F861BD;;A+F361BA;EACC,SAAA;EACA,cAAA;A/F861BD;;A+F361BA;EACC,YAAA;A/F861BD;;A+F361BA;EACC,YAAA;A/F861BD;;A+Fz61BA;;EAEC,cAAA;A/F461BD;;A+Fz61BA;EACC,aAAA;A/F461BD;;A+Fz61BA;EACC,aAAA;EACA,eAAA;A/F461BD;;A+Fz61BA;EACC,cAAA;A/F461BD;;A+Fz61BA;EACC,eAAA;A/F461BD;;A+Fz61BA;EACC,yBAAA;EACA,aAAA;EACA,mBAAA;A/F461BD;;A+Fz61BA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gCAAA;EACA,oBAAA;EACA,mBAAA;A/F461BD;;A+Fl61BA;EACC,SAAA;A/Fq61BD;;A+Fl61BA;EACC;IACC,sBAAA;IACA,QAAA;E/Fq61BA;E+Fl61BD;IACC,sBAAA;IACA,SAAA;E/Fo61BA;E+Fj61BD;IACC,WAAA;E/Fm61BA;E+Fh61BD;IACC,WAAA;IACA,iBAAA;IACA,cAAA;IACA,eAAA;IACA,6BAAA;IACA,iBAAA;IACA,gBAAA;E/Fk61BA;AACF;A+F/51BA,aAAA;AACA;EACC,gBAAA;A/Fi61BD;;A+F951BA;EACC,gFAAA;EACA,uBAAA;A/Fi61BD;;A+F/31BA;EACC,aAAA;A/Fk41BD;;A+F931BC;EACC,UAAA;A/Fi41BF;A+F731BE;EACC,UAAA;A/F+31BH;;A+F131BA;EACC,0BAAA;A/F631BD;;A+F131BA;EACC,gCAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;A/F631BD;;A+F131BA;EACC,c9FtpCO;ADmh4BR;;A+F131BA;EACC,c9F1pCO;ADuh4BR;;A+F131BA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;A/F631BD;;A+F131BA;EACC,SAAA;EACA,kBAAA;A/F631BD;;A+F131BA,uBAAA;AACA,UACC,yCAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,mB9FxsCU,E8FwsCa,oBAAA;EACvB,aAAA;EACA,YAAA;EACA,wBAAA;A/F631BD;;A+F131BA;EACC,UAAA,EAAA,8BAAA;A/F631BD;;A+F131BA,4BAAA;AACA;EACC,WAAA;EACA,WAAA;EACA,mB9FttCU;E8FutCV,kBAAA;EACA,eAAA;A/F631BD;;A+F131BA;EACC,WAAA;EACA,WAAA;EACA,mB9F9tCU;E8F+tCV,kBAAA;EACA,eAAA;A/F631BD;;A+F131BA,6BAAA;AACA;EAEC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mB9FztCM,E8FytCc,gBAAA;EACpB,gBAAA;EACA,kBAAA;EACA,eAAA;A/F631BD;;A+F131BA;EACC,WAAA;EACA,YAAA;EACA,mB9FluCM,E8FkuCc,gBAAA;EACpB,kBAAA;EACA,gBAAA;EACA,eAAA;A/F631BD;;A+F131BA,0DAAA;AACA;EACC,iHAAA;A/F631BD;;A+F131BA;EACC,mB9F9uCM,E8F8uCc,iCAAA;EACpB,WAAA;EACA,kBAAA;A/F631BD;;A+F131BA;EACC,WAAA;A/F631BD;;A+F131BA;EACC,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;A/F631BD;;A+F131BA;EACC,aAAA;A/F631BD;;A+F131BA;EACC,mBAAA;EACA,qBAAA;A/F631BD;;A+F131BA;;;EAGC,c9F5xCO;ADyp4BR;;A+F131BA;EACC,mBAAA;A/F631BD;;A+F131BA;EAKC,c9FxyCO;ADiq4BR;;A+Ft31BA;EAKC,mB9F9xCM;ADmp4BP;;A+Fl31BA;EAKC,4CAAA;A/Fi31BD;;A+F921BA;;;;;;;;;;;;EAYC,4CAAA;A/Fi31BD;;A+F921BA;EAKC,mB9F7zCM;AD0q4BP;;A+F121BA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwDC,2CAAA;A/Fq11BD;;A+Fl11BA;;;;;;;;;;;;;;;;EAwBC,4CAAA;A/F601BD;;A+F101BA;;;EAGC,c9F36CO;ADwv4BR;;A+F101BA;;;EAGC,mBAAA;EACA,qBAAA;EACA,c9Fn7CO;ADgw4BR;;A+F101BA;EACC,gBAAA;EACA,MAAA;A/F601BD;;A+F101BA;EACC,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4EACC;EAGD,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,yBAAA;A/F001BD;;A+Fv01BA;;;EAGC,mBAAA;A/F001BD;;A+Fv01BA;EACC,mCAAA;A/F001BD;;A+Fv01BA;EACC,mB9F58CK;ADsx4BN;;A+Fv01BA;EACC,iBAAA;EACA,wBAAA;A/F001BD;;A+Fv01BA;EACC,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mB9F3+CO;E8F4+CP,cAAA;A/F001BD;;A+Ft01BC;EACC,WAAA;EACA,UAAA;EACA,0BAAA;EACA,mB9Fp/CM;E8Fq/CN,kBAAA;EACA,SAAA;EACA,UAAA;A/Fy01BF;A+Ft01BC;EACC,yBAAA;A/Fw01BF;;A+Fp01BA;EACC,kBAAA;A/Fu01BD;;A+Fp01BA;EACC,gBAAA;EACA,qCAAA;A/Fu01BD;;A+Fp01BA;EACC,qCAAA;EACA,4BAAA;A/Fu01BD;;A+Fp01BA;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,mB9FphDO;AD214BR;;A+Fp01BA,eAAA;AAEA;EACC,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;A/Fs01BD;;A+Fn01BA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mB9F3gDO;E8F4gDP,iBAAA;A/Fs01BD;;A+Fn01BA;EACC,SAAA;EACA,QAAA;A/Fs01BD;;A+Fn01BA;EACC,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qCAAA;A/Fs01BD;;A+Fn01BA;EACC;IACC,uBAAA;E/Fs01BA;E+Fp01BD;IACC,yBAAA;E/Fs01BA;AACF;A+Fl01BA,cAAA;AAEA;EACC,mBAAA;EACA,cAAA;EACA,0CAAA;A/Fm01BD;;A+Fh01BA;EACC,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;A/Fm01BD;;A+Fh01BA;EACC,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;EACA,uBAAA;EAEA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;A/Fk01BD;;A+Fh01BA,0DAAA;AAEA;;EAEC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,0BAAA;EACA,UAAA;EACA,YAAA;A/Fk01BD;;A+F/z1BA;EACC,WAAA;EACA,SAAA;EACA,2BAAA;A/Fk01BD;;A+Fh01BA;eAAA;AAGA;;EAEC,aAAA;A/Fk01BD;;A+Fh01BA,+CAAA;AAEA;EACC,cAAA;A/Fk01BD;;A+Fh01BA;kCAAA;AAGA;;EAEC,cAAA;A/Fk01BD;;A+Fh01BA,uDAAA;AAEA;EACC,4BAAA;EACA,wBAAA;EACA,gCAAA;EACA,6BAAA;A/Fk01BD;;A+F/z1BA;EACC,wBAAA;EACA,gCAAA;EACA,6BAAA;A/Fk01BD;;A+Fh01BA,+CAAA;AAEA;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,YAAA;A/Fk01BD;;A+F/z1BA;EACC,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,c9FlqDO;E8FmqDP,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,oBAAA;A/Fk01BD;;A+Fh01BA,8BAAA;AACA,qEAAA;AAEA;;EAEC,mB9F9pDM;E8F+pDN,c9FxpDO;E8FypDP,yBAAA;A/Fk01BD;;A+Fh01BA,4BAAA;AAEA;;;;EAIC,qBAAA;A/Fk01BD;;A+F7z1BC;EACC,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;A/Fg01BF;A+F5z1BE;EACC,UAAA;EACA,mBAAA;EACA,mBAAA;A/F8z1BH;;A+Fzz1BA;EACC,2BAAA;EACA,2BAAA;A/F4z1BD;;A+Fzz1BA;EACC,sBAAA;EACA,8BAAA;EACA,8BAAA;A/F4z1BD;;A+Fzz1BA;EACC,sBAAA;A/F4z1BD;;A+Fzz1BA;EACC,aAAA;A/F4z1BD;;A+Fzz1BA;EACC,aAAA;A/F4z1BD;;A+Fzz1BA;;EAEC,iBAAA;EACA,eAAA;A/F4z1BD;;A+Fvz1BA;EACC,eAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,c9FtvDO;E8FuvDP,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;A/F0z1BD;;A+Fvz1BA;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,QAAA;A/F0z1BD;;A+Fvz1BA;EACC,SAAA;A/F0z1BD;;A+Fvz1BA;EACC,aAAA;EACA,qBAAA;EAQA,0HAAA;A/Foz1BD;;A+F3y1BA;EACC,oCAAA;EACA,2BAAA;A/F8y1BD;;A+F3y1BA;EACC,wBAAA;EACA,2BAAA;A/F8y1BD;;A+F3y1BA;EACC,wBAAA;EACA,2BAAA;A/F8y1BD;;A+F3y1BA;EACC,0BAAA;A/F8y1BD;;A+F3y1BA;EACC,yBAAA;A/F8y1BD;;A+F3y1BA;EACC,cAAA;A/F8y1BD;;A+F3y1BA;EACC,4BAAA;EACA,gBAAA;A/F8y1BD;;A+F3y1BA;EACC,oCAAA;EACA,YAAA;A/F8y1BD;;A+F3y1BA;EACC,gBAAA;A/F8y1BD;;A+F3y1BA;EACC,yBAAA;EACA,gBAAA;A/F8y1BD;;A+F3y1BA;EACC,uBAAA;A/F8y1BD;;A+F3y1BA;EACC,uBAAA;A/F8y1BD;;A+F3y1BA;EACC,aAAA;EACA,SAAA;A/F8y1BD;;A+F3y1BA;;;EAGC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,c9F/1DO;AD6o5BR;;A+F3y1BA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;A/F8y1BD;;A+F1y1BA;EACC,YAAA;A/F6y1BD;;A+F1y1BA;EACC,4BAAA;A/F6y1BD;;A+F1y1BA;EACC,gBAAA;A/F6y1BD;;A+F1y1BA;EACC,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oCAAA;EACA,uBAAA;EACA,oCAAA;EACA,qBAAA;A/F6y1BD;;A+F1y1BA;EACC,mBAAA;A/F6y1BD;;A+F1y1BA;EACC,YAAA;A/F6y1BD;;A+F1y1BA;EACC,oGAAA;A/F6y1BD;;A+Fvy1BA;EACC,oGAAA;A/F0y1BD;;A+Fpy1BA;EACC,mCAAA;A/Fuy1BD;;A+Fry1BA;EACC,mCAAA;A/Fwy1BD;;A+Fty1BA;EACC,mCAAA;A/Fyy1BD;;A+Fvy1BA;EACC,mCAAA;A/F0y1BD;;A+Fxy1BA;EACC,+BAAA;A/F2y1BD;;A+Fzy1BA;EACC,+BAAA;A/F4y1BD;;A+F1y1BA;EACC,mCAAA;A/F6y1BD;;A+F3y1BA;EACC,mCAAA;A/F8y1BD;;A+F5y1BA;EACC,qCAAA;A/F+y1BD;;A+F7y1BA;EACC,qCAAA;A/Fgz1BD;;A+F9y1BA;EACC,mCAAA;EACA,+BAAA;A/Fiz1BD;;A+F/y1BA;EACC,mCAAA;EACA,+BAAA;A/Fkz1BD;;A+Fhz1BA;EACC,mCAAA;A/Fmz1BD;;A+Fjz1BA;EACC,mCAAA;A/Foz1BD;;A+Flz1BA;EACC,+BAAA;A/Fqz1BD;;A+Fnz1BA;EACC,+BAAA;EACA,6BAAA;A/Fsz1BD;;A+Fpz1BA;EACC,6BAAA;A/Fuz1BD;;A+Frz1BA;EACC,6BAAA;A/Fwz1BD;;A+Ftz1BA;EACC,wBAAA;A/Fyz1BD;;A+Fvz1BA;EACC,wBAAA;A/F0z1BD;;A+Fxz1BA;EACC,wBAAA;A/F2z1BD;;A+Fzz1BA;EACC,wBAAA;A/F4z1BD;;A+F1z1BA;EACC,wBAAA;A/F6z1BD;;A+F3z1BA;EACC,wBAAA;A/F8z1BD;;A+F5z1BA;EACC,wBAAA;A/F+z1BD;;A+F7z1BA;EACC,wBAAA;A/Fg01BD;;A+F9z1BA;EACC,wBAAA;A/Fi01BD;;A+F/z1BA;EACC,wBAAA;A/Fk01BD;;A+Fh01BA;EACC,wBAAA;A/Fm01BD;;A+Fj01BA;EACC,wBAAA;A/Fo01BD;;A+Fl01BA;EACC,uBAAA;EACA,yBAAA;A/Fq01BD;;A+Fn01BA;EACC,yBAAA;A/Fs01BD;;A+Fp01BA;EACC,uBAAA;A/Fu01BD;;A+Fr01BA;EACC,uBAAA;EACA,yBAAA;A/Fw01BD;;A+Ft01BA;EACC,yBAAA;A/Fy01BD;;A+Fv01BA;EACC,uBAAA;A/F001BD;;A+Fx01BA;EACC,uBAAA;EACA,yBAAA;A/F201BD;;A+Fz01BA;EACC,yBAAA;A/F401BD;;A+F101BA;EACC,uBAAA;A/F601BD;;A+F301BA;EACC,uBAAA;EACA,yBAAA;A/F801BD;;A+F501BA;EACC,yBAAA;A/F+01BD;;A+F701BA;EACC,uBAAA;A/Fg11BD;;A+F901BA;EACC,uBAAA;EACA,yBAAA;A/Fi11BD;;A+F/01BA;EACC,yBAAA;A/Fk11BD;;A+Fh11BA;EACC,uBAAA;A/Fm11BD;;A+Fj11BA;EACC,uBAAA;EACA,yBAAA;A/Fo11BD;;A+Fl11BA;EACC,yBAAA;A/Fq11BD;;A+Fn11BA;EACC,uBAAA;A/Fs11BD;;A+Fp11BA;EACC,uBAAA;EACA,yBAAA;A/Fu11BD;;A+Fr11BA;EACC,yBAAA;A/Fw11BD;;A+Ft11BA;EACC,uBAAA;A/Fy11BD;;A+Fv11BA;EACC,uBAAA;EACA,yBAAA;A/F011BD;;A+Fx11BA;EACC,yBAAA;A/F211BD;;A+Fz11BA;EACC,uBAAA;A/F411BD;;A+F111BA;EACC,uBAAA;EACA,yBAAA;A/F611BD;;A+F311BA;EACC,yBAAA;A/F811BD;;A+F511BA;EACC,uBAAA;A/F+11BD;;A+F711BA;EACC,uBAAA;EACA,yBAAA;A/Fg21BD;;A+F911BA;EACC,yBAAA;A/Fi21BD;;A+F/11BA;EACC,uBAAA;A/Fk21BD;;A+Fh21BA;EACC,uBAAA;EACA,yBAAA;A/Fm21BD;;A+Fj21BA;EACC,yBAAA;A/Fo21BD;;A+Fl21BA;EACC,uBAAA;A/Fq21BD;;A+Fn21BA;EACC,uBAAA;EACA,yBAAA;A/Fs21BD;;A+Fp21BA;EACC,yBAAA;A/Fu21BD;;A+Fr21BA;EACC,uBAAA;A/Fw21BD;;A+Ft21BA;EACC,uBAAA;EACA,yBAAA;A/Fy21BD;;A+Fv21BA;EACC,yBAAA;A/F021BD;;A+Fx21BA;EACC,uBAAA;A/F221BD;;A+Fz21BA;EACC,uBAAA;EACA,yBAAA;A/F421BD;;A+F121BA;EACC,yBAAA;A/F621BD;;A+F321BA;EACC,uBAAA;A/F821BD;;A+F521BA;EACC,uBAAA;EACA,yBAAA;A/F+21BD;;A+F721BA;EACC,yBAAA;A/Fg31BD;;A+F921BA;EACC,uBAAA;A/Fi31BD;;A+F/21BA;EACC,uBAAA;EACA,yBAAA;A/Fk31BD;;A+Fh31BA;EACC,yBAAA;A/Fm31BD;;A+Fj31BA;EACC,uBAAA;A/Fo31BD;;A+Fl31BA;EACC,uBAAA;EACA,yBAAA;A/Fq31BD;;A+Fn31BA;EACC,yBAAA;A/Fs31BD;;A+Fp31BA;EACC,uBAAA;A/Fu31BD;;A+Fr31BA;EACC,uBAAA;EACA,yBAAA;A/Fw31BD;;A+Ft31BA;EACC,yBAAA;A/Fy31BD;;A+Fv31BA;EACC,uBAAA;A/F031BD;;A+Fx31BA;EACC,mCAAA;EACA,wBAAA;A/F231BD;;A+Fz31BA;EACC,mCAAA;EACA,wBAAA;A/F431BD;;A+F131BA;EACC,mCAAA;EACA,wBAAA;A/F631BD;;A+F331BA;EACC,mCAAA;EACA,wBAAA;A/F831BD;;A+F531BA;EACC,mCAAA;EACA,wBAAA;A/F+31BD;;A+F731BA;EACC,mCAAA;EACA,wBAAA;A/Fg41BD;;A+F931BA;EACC,mCAAA;EACA,wBAAA;A/Fi41BD;;A+F/31BA;EACC,mCAAA;EACA,wBAAA;A/Fk41BD;;A+Fh41BA;EACC,mCAAA;EACA,wBAAA;A/Fm41BD;;A+Fj41BA;EACC,mCAAA;EACA,wBAAA;A/Fo41BD;;A+Fl41BA;EACC,mCAAA;EACA,wBAAA;A/Fq41BD;;A+Fn41BA;EACC,mCAAA;EACA,wBAAA;A/Fs41BD;;A+Fp41BA;EACC,mCAAA;EACA,wBAAA;A/Fu41BD;;A+Fr41BA;EACC,mCAAA;EACA,wBAAA;A/Fw41BD;;A+Ft41BA;EACC,mCAAA;EACA,wBAAA;A/Fy41BD;;A+Fv41BA;EACC,mCAAA;EACA,wBAAA;A/F041BD;;A+Fx41BA;EACC,mCAAA;EACA,wBAAA;A/F241BD;;A+Fz41BA;EACC,mCAAA;EACA,wBAAA;A/F441BD;;A+F141BA;EACC,mCAAA;EACA,wBAAA;A/F641BD;;A+F341BA;EACC,mCAAA;EACA,wBAAA;A/F841BD;;A+F541BA;EACC,mCAAA;EACA,wBAAA;A/F+41BD;;A+F741BA;EACC,mCAAA;EACA,wBAAA;A/Fg51BD;;A+F941BA;EACC,mCAAA;EACA,wBAAA;A/Fi51BD;;A+F/41BA;EACC,mCAAA;EACA,wBAAA;A/Fk51BD;;A+Fh51BA;EACC,mCAAA;EACA,+BAAA;EACA,wBAAA;A/Fm51BD;;A+Fj51BA;EACC,mCAAA;EACA,+BAAA;EACA,wBAAA;A/Fo51BD;;A+Fl51BA;EACC,mCAAA;EACA,+BAAA;EACA,wBAAA;A/Fq51BD;;A+Fn51BA;EACC,mCAAA;EACA,+BAAA;EACA,wBAAA;A/Fs51BD;;A+Fp51BA;EACC,wBAAA;A/Fu51BD;;A+Fr51BA;EACC,wBAAA;A/Fw51BD;;A+Ft51BA;EACC,wBAAA;A/Fy51BD;;A+Fv51BA;EACC,wBAAA;A/F051BD;;A+Fx51BA;EACC,wBAAA;A/F251BD;;A+Fz51BA;EACC,wBAAA;A/F451BD;;A+F151BA;EACC,wBAAA;A/F651BD;;A+F351BA;EACC,wBAAA;A/F851BD;;A+F551BA;EACC,wBAAA;A/F+51BD;;A+F751BA;EACC,wBAAA;A/Fg61BD;;A+F951BA;EACC,wBAAA;A/Fi61BD;;A+F/51BA;EACC,wBAAA;A/Fk61BD;;A+Fh61BA;EACC,wBAAA;A/Fm61BD;;A+Fj61BA;EACC,wBAAA;A/Fo61BD;;A+Fl61BA;EACC,wBAAA;A/Fq61BD;;A+Fn61BA;EACC,wBAAA;A/Fs61BD;;A+Fp61BA;EACC,wBAAA;A/Fu61BD;;A+Fr61BA;EACC,wBAAA;A/Fw61BD;;A+Ft61BA;EACC,wBAAA;A/Fy61BD;;A+Fv61BA;EACC,wBAAA;A/F061BD;;A+Fx61BA;EACC,wBAAA;A/F261BD;;A+Fz61BA;EACC,wBAAA;A/F461BD;;A+F161BA;EACC,wBAAA;A/F661BD;;A+F361BA;EACC,wBAAA;A/F861BD;;A+F561BA;EACC,6BAAA;A/F+61BD;;A+F761BA;EACC,6BAAA;A/Fg71BD;;A+F961BA;EACC,yBAAA;A/Fi71BD;;A+F/61BA;EACC,yBAAA;A/Fk71BD;;A+Fh71BA;EACC,mCAAA;EACA,wBAAA;A/Fm71BD;;A+Fj71BA;EACC,mCAAA;EACA,wBAAA;A/Fo71BD;;A+Fl71BA;EACC,mCAAA;EACA,wBAAA;A/Fq71BD;;A+Fn71BA;EACC,mCAAA;EACA,wBAAA;A/Fs71BD;;A+Fp71BA;EACC,wCAAA;EACA,+BAAA;EACA,wBAAA;A/Fu71BD;;A+Fr71BA;EACC,wCAAA;EACA,+BAAA;EACA,wBAAA;A/Fw71BD;;A+Ft71BA;EACC,wCAAA;EACA,+BAAA;EACA,wBAAA;A/Fy71BD;;A+Fv71BA;EACC,wCAAA;EACA,+BAAA;EACA,wBAAA;A/F071BD;;A+Fx71BA;EACC,wCAAA;EACA,+BAAA;EACA,wBAAA;A/F271BD;;A+Fz71BA;EACC,wCAAA;EACA,+BAAA;EACA,wBAAA;A/F471BD;;A+F171BA;EACC,wCAAA;EACA,wBAAA;A/F671BD;;A+F371BA;EACC,wCAAA;EACA,wBAAA;A/F871BD;;A+F571BA;EACC,4BAAA;A/F+71BD;;A+F771BA;EACC,4BAAA;A/Fg81BD;;A+F971BA;EACC,wBAAA;A/Fi81BD;;A+F/71BA;EACC,wBAAA;A/Fk81BD;;A+Fh81BA;EACC,wBAAA;A/Fm81BD;;A+Fj81BA;EACC,wBAAA;A/Fo81BD;;A+Fl81BA;EACC,wCAAA;A/Fq81BD;;A+Fn81BA;EACC,wCAAA;A/Fs81BD;;A+Fp81BA;EACC,wCAAA;A/Fu81BD;;A+Fr81BA;EACC,wCAAA;A/Fw81BD;;A+Ft81BA;EACC,mCAAA;A/Fy81BD;;A+Fv81BA;EACC,mCAAA;A/F081BD;;A+Fx81BA;EACC,kCAAA;EACA,+BAAA;A/F281BD;;A+Fz81BA;EACC,kCAAA;EACA,+BAAA;A/F481BD;;A+F181BA;EACC,uBAAA;A/F681BD;;A+F381BA;EACC,uBAAA;A/F881BD;;A+F581BA;EACC,kCAAA;EACA,+BAAA;A/F+81BD;;A+F781BA;EACC,kCAAA;EACA,+BAAA;A/Fg91BD;;A+F981BA;EACC,mCAAA;EACA,+BAAA;EACA,wBAAA;A/Fi91BD;;A+F/81BA;EACC,mCAAA;EACA,+BAAA;EACA,wBAAA;A/Fk91BD;;A+Fh91BA;EACC,mCAAA;EACA,+BAAA;EACA,wBAAA;A/Fm91BD;;A+Fj91BA;EACC,mCAAA;EACA,+BAAA;EACA,wBAAA;A/Fo91BD;;A+Fl91BA;EACC,mCAAA;A/Fq91BD;;A+Fn91BA;EACC,mCAAA;A/Fs91BD;;A+Fp91BA;EACC,+BAAA;A/Fu91BD;;A+Fr91BA;EACC,+BAAA;A/Fw91BD;;A+Ft91BA;EACC,+BAAA;A/Fy91BD;;A+Fv91BA;EACC,+BAAA;A/F091BD;;A+Fx91BA;EACC,mCAAA;A/F291BD;;A+Fz91BA;EACC,mCAAA;A/F491BD;;A+Ft91BA;EACC,uBAAA;A/Fy91BD;;A+Ft91BA;EACC,6CAAA;EACA,YAAA;A/Fy91BD;;A+Ft91BA;EACC,6CAAA;A/Fy91BD;;A+Ft91BA;EACC,WAAA;A/Fy91BD;;A+Ft91BA;EACC,WAAA;A/Fy91BD;;A+Ft91BA;EACC,mBAAA;A/Fy91BD;;A+Ft91BA;EACC,gBAAA;EACA,YAAA;A/Fy91BD;;AgG1j7BA;EACI,mBAAA;EACA,6BAAA;AhG6j7BJ;;AgG1j7BA;EACI,mBAAA;EACA,2BAAA;AhG6j7BJ;;AgG1j7BA;EACI,yCAAA;AhG6j7BJ;;AgG1j7BA;EACI,aAAA;AhG6j7BJ;;AgG1j7BA;EACI,2CAAA;AhG6j7BJ;;AgG1j7BA;;EAEI,aAAA;AhG6j7BJ;;AgG1j7BA;EACI,aAAA;AhG6j7BJ;;AgG1j7BA;EACI,mBAAA;AhG6j7BJ;;AgG1j7BA;EACI,eAAA;AhG6j7BJ;;AgG1j7BA;EACI,SAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,uCAAA;AhG6j7BJ;;AgG1j7BA;EACI,UAAA;EACA,SAAA;EACA,YAAA;EACA,4BAAA;EACA,6CAAA;AhG6j7BJ;;AgG1j7BA;EACI,gBAAA;EACA,kBAAA;EACA,oBAAA;AhG6j7BJ;;AgG1j7BA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AhG6j7BJ;;AgG1j7BA;EACI,2BAAA;AhG6j7BJ;;AgG1j7BA;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;AhG6j7BJ;;AgG1j7BA;EACI,4BAAA;AhG6j7BJ;;AgG1j7BA;EACI;;IAEI,gCAAA;EhG6j7BN;AACF;AgG1j7BA;EACI,aAAA;EACA,mBAAA;AhG4j7BJ;;AgGzj7BA;EACI,mBAAA;AhG4j7BJ;;AgGzj7BA;EACI,aAAA;AhG4j7BJ;;AgGzj7BA;EACI,2BAAA;AhG4j7BJ;;AgGzj7BA;EACI,mBAAA;AhG4j7BJ;;AgGzj7BA;EACI,4BAAA;AhG4j7BJ;;AgGzj7BA;EACI,aAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;AhG4j7BJ;;AgGzj7BA;EACI,YAAA;EACA,mBAAA;EACA,4BAAA;AhG4j7BJ;;AgGzj7BA;EACI,aAAA;AhG4j7BJ;;AgGzj7BA;EACI,YAAA;EACA,4BAAA;EACA,kBAAA;AhG4j7BJ;;AgGzj7BA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AhG4j7BJ;;AgGzj7BA;EACI,aAAA;AhG4j7BJ;;AgGzj7BA;EACI,kBAAA;AhG4j7BJ;;AgGzj7BA;EACI,eAAA;AhG4j7BJ;;AgGzj7BA;EACI,gBAAA;EACA,gBAAA;AhG4j7BJ;;AgGzj7BA;EACI,0BAAA;AhG4j7BJ;;AgGzj7BA;EACI,eAAA;AhG4j7BJ;;AgGzj7BA;EACI;IACI,aAAA;EhG4j7BN;EgGzj7BE;IACI,kBAAA;IACA,SAAA;IACA,OAAA;IACA,aAAA;IACA,gBAAA;EhG2j7BN;EgGxj7BE;IACI,cAAA;IACA,iBAAA;EhG0j7BN;EgGvj7BE;IACI,cAAA;IACA,iBAAA;EhGyj7BN;EgGtj7BE;IACI,kBAAA;EhGwj7BN;EgGrj7BE;IACI,2BAAA;EhGuj7BN;AACF;AgGpj7BA;EACI;IACI,SAAA;IACA,UAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,gCAAA;EhGsj7BN;EgGnj7BE;IACI,cAAA;EhGqj7BN;EgGlj7BE;IACI,sBAAA;IACA,WAAA;IACA,yBAAA;IACA,YAAA;EhGoj7BN;EgGjj7BE;IACI,cAAA;EhGmj7BN;EgGhj7BE;IACI,cAAA;EhGkj7BN;EgG/i7BE;IACI,eAAA;IACA,YAAA;IACA,mBAAA;IACA,YAAA;EhGij7BN;EgG9i7BE;IACI,mBAAA;IACA,UAAA;EhGgj7BN;EgG7i7BE;IACI,8BAAA;EhG+i7BN;EgG5i7BE;IACI,kBAAA;EhG8i7BN;EgG3i7BE;IACI,gBAAA;IACA,cAAA;EhG6i7BN;EgG1i7BE;IACI,gBAAA;EhG4i7BN;AACF;AgGxi7BI;EACI,mBAAA;AhG0i7BR;AgGvi7BI;EACI,8BAAA;AhGyi7BR;;AgGpi7BI;EACI,mBAAA;AhGui7BR;;AgB5w7BI;EiF/DJ;IAEE,iBAAA;EjG807BA;EiG507BA;IAEC,gBAAA;IACA,iBAAA;IACA,kBAAA;EjG607BD;EiG307BA;IACC,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;EjG607BD;EiG307BC;IACC,eAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;EjG607BF;EiG107BA;IAIE,UAAA;EjGy07BF;AACF;;AkGp27BC;EACC,6BAAA;AlGu27BF;AkGp27BE;EACC,aAAA;AlGs27BH;;AmG327BC;EACC,SAAA;AnG827BF;AmG527BC;EAIE,iBlGqeqB;ADs46BxB;AgBvy7BI;EmFxEH;IAWG,iBlGySK;ED+j7BP;AACF;;AoGx37BA;EACC,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;ApG237BD;;AqGh47BA;EACC,iBAAA;ArGm47BD;;AsGp47BA;EAWE;IACC,cAAA;IACA,UAAA;EtG637BD;EsG337BA;IACC,uBAAA;IACA,UAAA;EtG637BD;AACF;AsG137BA;EASE;IACC,sBrGmbiB;EDi86BlB;EsGl37BA;IACC,cAAA;EtGo37BD;AACF;AsGj37BA;EASE;IACC,sBrGkaiB;EDy86BlB;EsGz27BA;IACC,iBrG0bqB;EDi76BtB;AACF;AgBh27BI;EsFLF;IACC,uBAAA;EtGw27BD;EsGr27BA;IACC,qBAAA;EtGu27BD;EsGn27BC;IACC,UAAA;EtGq27BF;EsGj27BA;IACC,4BAAA;EtGm27BD;EsGj27BC;IACC,UAAA;EtGm27BF;AACF;;AuG/67BC;EACC,6BAAA;AvGk77BF;;AwGp77BA;EASE;IACC,uBAAA;ExG+67BD;EwG767BA;IACC,cAAA;ExG+67BD;AACF;AwG567BA;EASE;IACC,cAAA;ExGs67BD;EwGp67BA;IACC,sBvGobiB;EDk/6BlB;AACF;AwGn67BA;EASE;IACC,iBvGicqB;ED496BtB;EwG357BA;IACC,sBAAA;ExG657BD;AACF;AgB947BI;EwFTF;IACC,+BAAA;IACA,UAAA;IACA,mBAAA;IACA,mBAAA;ExG057BD;EwGx57BC;IACC,yBAAA;ExG057BF;EwGv57BA;IACC,gCAAA;ExGy57BD;EwGv57BA;IACC,gCAAA;ExGy57BD;EwGv57BA;IACC,iBAAA;ExGy57BD;EwGv57BA;IACC,iBAAA;ExGy57BD;EwGv57BA;IACC,iBAAA;ExGy57BD;AACF;;AgBx67BI;EyF/DJ;IAEE,qBAAA;EzG0+7BA;EyGx+7BA;IACC,aAAA;EzG0+7BD;AACF;AgBj77BI;EyFtDH;IAEE,qBxGsdkB;EDmh7BnB;EyGv+7BC;IACC,axGmdiB;EDsh7BnB;AACF;;A0Gx/7BA;EACC,cAAA;A1G2/7BD;;A2G3/7BC;EACC,SAAA;A3G8/7BF;;A4Ghg8BA;EACC,iBAAA;A5Gmg8BD;A4Ghg8BE;EACC,qBAAA;A5Gkg8BH;A4Ghg8BG;EACC,0BAAA;A5Gkg8BJ;A6G1g8BA;EACC,eAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,kCAAA;EACA,c5GyDO;E4GxDP,kBAAA;EACA,qBAAA;EACA,a5G8bmB;E4G7bnB,mBAAA;EACA,qI5GslBC;E4GrlBD,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,eAAA;A7Gwg8BF;AgB/87BI;E6F5EJ;IAsBE,eAAA;IACA,a5GgbkB;I4G3ajB,cAAA;E7Gqg8BD;AACF;A6Glg8BC;EACC,2BAAA;EACA,4BAAA;EACA,qBAAA;A7Gog8BF;;A8Gti8BC;EACC,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;A9Gyi8BF;;A8Gpi8BC;EACC,8BAAA;A9Gui8BF;;A8Gli8BC;EACC,qCAAA;A9Gqi8BF;;A8Gji8BA;EACC,+CAAA;EACA,kBAAA;EACA,YAAA;A9Goi8BD;A8Gli8BC;EACC,0CAAA;A9Goi8BF;A8Gli8BC;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,2BAAA;EACA,uBAAA;A9Goi8BF;A8Gli8BE;EAEC,gBAAA;A9Gmi8BH;A8Gji8BE;EACC,SAAA;EACA,uBAAA;EACA,gBAAA;A9Gmi8BH;A8Ghi8BE;EACC,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;A9Gki8BH;A8Ghi8BE;EACC,SAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;A9Gki8BH;A8Ghi8BE;EACC,WAAA;EACA,oBAAA;A9Gki8BH;A8G3h8BK;EACC,gCAAA;A9G6h8BN;A8Gnh8BK;EACC,6BAAA;EACA,sCAAA;A9Gqh8BN;A8G9g8BC;EAEC,WAAA;EACA,kBAAA;EACA,oBAAA;A9G+g8BF;A8G7g8BC;EACC,UAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,2DAAA;EACA,8DAAA;A9G+g8BF;A8G7g8BC;EACC,SAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,4DAAA;EACA,6DAAA;A9G+g8BF;A8G5g8BC;EACC,kBAAA;EACA,WAAA;A9G8g8BF;A8G5g8BC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;A9G8g8BF;A8G5g8BC;EAIC,WAAA;EACA,YAAA;EACA,kBAAA;A9G2g8BF;A8Gzg8BE;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kDAAA;A9G2g8BH;A8Gzg8BE;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kDAAA;A9G2g8BH;A8Gxg8BC;EAEC,MAAA;A9Gyg8BF;A8Gvg8BE;EACC,QAAA;A9Gyg8BH;A8Gvg8BE;EACC,MAAA;A9Gyg8BH;A8Gtg8BC;EAEC,SAAA;A9Gug8BF;A8Grg8BE;EACC,WAAA;A9Gug8BH;A8Grg8BE;EACC,SAAA;A9Gug8BH;A8Gpg8BC;EAEC,OAAA;A9Gqg8BF;A8Gng8BE;EAEC,OAAA;A9Gog8BH;A8Gjg8BC;EAEC,QAAA;A9Gkg8BF;A8Ghg8BE;EAEC,QAAA;A9Gig8BH;;AgBnn8BI;E+F5EJ;IAEI,eAAA;E/Gks8BF;AACF;AgBzn8BI;E+F5EJ;IAKI,eAAA;E/Gos8BF;AACF;;AgHzs8BC;EACC,gBAAA;EACA,qBAAA;EACE,uCAAA;EACA,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;AhH4s8BJ;;AgHxs8BC;EAEC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,2BAAA;AhH0s8BF;;AiH/t8BA;EACC,gBAAA;AjHku8BD;;AkHnu8BA;EACC;IAAO,UAAA;ElHuu8BN;EkHtu8BD;IAAK,UAAA;ElHyu8BJ;AACF;AkHvu8BA;EACC,4DjHuZY;ADk17Bb;AkHvu8BC;EACC,kEAAA;AlHyu8BF;;AgBtq8BI;EkG/DH;IAEE,iBAAA;ElHwu8BD;EkHtu8BC;IACC,wBAAA;IACA,yBAAA;IACA,sBAAA;ElHwu8BF;AACF;;AmH3v8BE;EACC,kEAAA;AnH8v8BH;;AoH/v8BE;EACC,kEAAA;ApHkw8BH;;AqHpw8BC;EACC,cpHsFM;ADir8BR;;AsHtw8BG;EACC,4DAAA;AtHyw8BJ;AsHvw8BI;EACC,4DAAA;AtHyw8BL;AsHtw8BI;EAIE,6DAAA;AtHqw8BN;;AuHlx8BC;EAIC,YAAA;EACA,WAAA;AvHkx8BF;AuHhx8BC;EACC,oCAAA;AvHkx8BF;AuHhx8BC;EACC,yBAAA;AvHkx8BF;AuHhx8BC;EACC,0CAAA;AvHkx8BF;;AwHjy8BA;EACC,sBAAA;AxHoy8BD;AwHly8BC;EACC,sCAAA;AxHoy8BF;;AyHty8BE;EACC,kBAAA;AzHyy8BH;AyHry8BE;EACC,eAAA;EACA,WAAA;AzHuy8BH;AyHry8BG;EACC,gBAAA;AzHuy8BJ;AyHly8BE;EACC,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AzHoy8BH;AyHly8BE;EAGC,gBAAA;EACA,YAAA;AzHky8BH;;AyH3x8BG;EACC,yBAAA;AzH8x8BJ;;A0Hh08BE;EACC,WAAA;A1Hm08BH;A0H7z8BG;EACC,WAAA;A1H+z8BJ;A0H3z8BI;EACC,YAAA;EACA,oCAAA;EACA,eAAA;EACA,wBAAA;A1H6z8BL;A0H3z8BK;EAEC,wBzHwlCuB;EyHvlCvB,oCAAA;A1H4z8BN;A0Hxz8BK;EACC,wBzHklCuB;EyHjlCvB,oCAAA;A1H0z8BN;;AgB3w8BI;E2G5EJ;IAEE,gBAAA;E3H018BA;E2Hx18BA;IAGC,kBAAA;E3Hw18BD;AACF;;A2Hl18BE;EACC,UAAA;A3Hq18BH;A2Hn18BG;EACC,kBAAA;EACA,wCAAA;A3Hq18BJ;A2Hn18BI;EACC,aAAA;EACA,cAAA;EACA,cAAA;EACA,gB1HiTc;E0HhTd,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;A3Hq18BL;A2Hn18BI;EACC,kBAAA;EACA,qBAAA;EACA,gB1HmSc;E0HlSd,oBAAA;A3Hq18BL;A2Hn18BI;EAEC,sBAAA;A3Ho18BL;A2Hl18BK;EACC,6BAAA;EACA,sBAAA;A3Ho18BN;A2Hl18BK;EAEC,2BAAA;A3Hm18BN;A2H/08BK;EACC,oDAAA;A3Hi18BN;A2H908BI;EACC,wCAAA;A3Hg18BL;A2H908BI;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,4CAAA;EACA,2BAAA;A3Hg18BL;A2H908BI;EACC,uBAAA;EACA,uBAAA;A3Hg18BL;A2H308BK;EACC,aAAA;A3H608BN;A2Hv08BK;EACC,aAAA;A3Hy08BN;A2Hl08BE;EACC,eAAA;A3Ho08BH;A2Hl08BG;EACC,kBAAA;EACA,wCAAA;EACA,6CAAA;EACA,mBAAA;A3Ho08BJ;A2Hl08BI;EACC,kBAAA;EACA,gB1HkOc;E0HjOd,oBAAA;A3Ho08BL;A2Hl08BI;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;EACA,kDAAA;EACA,2BAAA;A3Ho08BL;A2Hl08BI;EACC,wCAAA;A3Ho08BL;A2Hl08BI;EAEC,2BAAA;EACA,4BAAA;A3Hm08BL;A2Hj08BK;EACC,2BAAA;A3Hm08BN;A2Hh08BI;EACC,oDAAA;A3Hk08BL;A2H7z8BK;EACC,aAAA;A3H+z8BN;A2Hxz8BE;EACC,UAAA;A3H0z8BH;A2Hxz8BG;EACC,kBAAA;EACA,wCAAA;A3H0z8BJ;A2Hxz8BI;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,gB1H+Kc;E0H9Kd,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;A3H0z8BL;A2Hxz8BI;EACC,oBAAA;EACA,gB1HkKc;E0HjKd,kBAAA;A3H0z8BL;A2Hxz8BI;EACC,kBAAA;EACA,oBAAA;A3H0z8BL;A2Hxz8BI;EAEC,sBAAA;A3Hyz8BL;A2Hvz8BK;EACC,6BAAA;EACA,sBAAA;A3Hyz8BN;A2Hvz8BK;EACC,2BAAA;A3Hyz8BN;A2Hrz8BK;EACC,oDAAA;A3Huz8BN;A2Hpz8BI;EACC,wCAAA;A3Hsz8BL;A2Hpz8BI;EACC,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,4CAAA;A3Hsz8BL;A2Hjz8BK;EACC,aAAA;A3Hmz8BN;;A4Hlg9BC;EACC,YAAA;EACA,gBAAA;EACA,UAAA;EAMC,6CAAA;EACA,iB3H6SM;ADmt8BT;A4H7/8BE;EACC,WAAA;EACA,sBAAA;A5H+/8BH;A4H7/8BG;EACC,uCAAA;EACA,uBAAA;A5H+/8BJ;A4H7/8BI;EACC,qCAAA;A5H+/8BL;A4H7/8BI;EACC,sBAAA;EACA,gB3H8SkB;ADit8BvB;;A6H1h9BA;EACC,8BAAA;EACA,UAAA;EACA,YAAA;EACA,mB5HoTQ;E4HnTR,gB5HqUkB;E4HpUlB,kBAAA;A7H6h9BD;A6H3h9BC;EACC,eAAA;EACA,uCAAA;EACA,gB5H6TkB;ADgu8BpB;;A8Hti9BE;EACC,sBAAA;A9Hyi9BH;A8Hvi9BE;EAIE,sBAAA;A9Hsi9BJ;;A+H/i9BA;EACC,cAAA;EACA,aAAA;EACA,mB9HkUgB;E8HjUhB,c9HmEU;E8HlEV,qBAAA;EACA,qBAAA;EACA,yB9HwDO;E8HvDP,yBAAA;EACA,kB9H2Ye;ADuq8BhB;;AgIzj9BE;EACC,wDAAA;AhI4j9BH;AgIzj9BC;EACC,uDAAA;AhI2j9BF;;AiI3j9BK;EAIE,kBhI6SE;AD8w8BT;AiIxj9BK;EAIE,mBhIsSE;ADix8BT;AiIhj9BC;EACC,kBAAA;AjIkj9BF;AiI7i9BG;EACC,oBAAA;EACA,uBAAA;EACA,oBAAA;AjI+i9BJ;AiI7i9BG;EACC,yBAAA;AjI+i9BJ;;AkIpl9BA;EACC,eAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAMC,QAAA;EACA,mBAAA;AlIkl9BF;AgBlh9BI;EkH5EJ;IAgBE,eAAA;ElIkl9BA;AACF;AkIhl9BC;EACC,WAAA;AlIkl9BF;;AmIrm9BC;EACC,oBAAA;EACA,4DlI0ZW;AD8s8Bb;AmItm9BE;EACC,+BAAA;AnIwm9BH;AmItm9BE;EAEC,YAAA;EACA,4CAAA;EACA,wBAAA;AnIum9BH;AmIrm9BG;EACC,6CAAA;EACA,yBAAA;EACA,wBAAA;EACA,yBAAA;AnIum9BJ;AmIpm9BE;EACC,+BAAA;EACA,gBlImTgB;EkIlThB,wBAAA;EACA,SAAA;AnIsm9BH;AmIpm9BE;EACC,wBAAA;AnIsm9BH;AmIpm9BG;EACC,eAAA;EACA,gBAAA;EACA,qBAAA;AnIsm9BJ;AmInm9BI;EACC,UAAA;AnIqm9BL;AmIlm9BG;EACC,cAAA;AnIom9BJ;AmI/l9BE;EACC,+BAAA;AnIim9BH;AmI/l9BE;EAEC,clIYK;EkIXL,mBlIoBQ;EkInBR,qBlImBQ;AD6k9BX;AmI7l9BI;EACC,4BlIeM;ADgl9BX;AmI7l9BI;EACC,4BlIYM;ADml9BX;AmI3l9BI;EACC,yBlIOM;ADsl9BX;AmI3l9BI;EACC,yBlIIM;ADyl9BX;AmIvl9BE;EACC,+BAAA;AnIyl9BH;AmIvl9BE;EAEC,clIhBK;EkIiBL,mBlIRQ;EkISR,qBlITQ;ADim9BX;AmIrl9BI;EACC,2BlIbM;ADom9BX;AmIrl9BI;EACC,2BlIhBM;ADum9BX;AmInl9BI;EACC,0BlIrBM;AD0m9BX;AmInl9BI;EACC,0BlIxBM;AD6m9BX;AmIhl9BC;EACC,0BAAA;EACA,2BAAA;EAKC,uBAAA;AnI8k9BH;AmI3k9BC;EACC,6ClIm8BY;EkIl8BZ,YAAA;EACA,UAAA;EACA,gBlIk8BuB;EkIj8BvB,4DlIySW;ADoy8Bb;AmI3k9BE;EACC,2BlIs8BmB;ADuo7BtB;AmI3k9BG;EACC,gDlIq8BqB;EkIp8BrB,2BlIk8BkB;AD2o7BtB;AmIjk9BI;EACC,alIzEG;AD4o9BR;;AoI1s9BC;EACC,aAAA;EACA,gDnIijCsB;EmIhjCtB,oBAAA;EACA,kBAAA;EACA,6CnI6iCY;EmI5iCZ,gBAAA;EACA,4DnIqZW;EmIpZX,WAAA;ApI6s9BF;AoI3s9BE;EAEC,aAAA;ApI4s9BH;AoI1s9BE;EACC,uBAAA;EACA,eAAA;EAMC,cAAA;ApIus9BJ;AoIns9BG;EAKE,eAAA;EACA,UAAA;ApIis9BL;AoI7r9BE;EAEC,oBAAA;ApI8r9BH;AoI5r9BE;EACC,kBAAA;EACA,gBAAA;ApI8r9BH;AoI5r9BG;EACC,gBAAA;EACA,YAAA;EACA,gBAAA;ApI8r9BJ;AoIzr9BM;EACC,qBAAA;EACA,cnIUI;EmITJ,gBnIkRY;ADy68BnB;AoItr9BO;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,wBAAA;EACA,gBnIsQW;EmIrQX,kBAAA;EACA,YAAA;ApIwr9BR;AoIpr9BS;EACC,8CAAA;ApIsr9BV;AoIpr9BS;EAEC,gBAAA;EACA,sBAAA;ApIqr9BV;AoInr9BU;EACC,6BAAA;ApIqr9BX;AoIhr9BS;EAEC,oCAAA;EACA,uBAAA;EACA,kBnIwTM;EmIvTN,wBAAA;EACA,2BAAA;ApIir9BV;AoI/q9BU;EACC,aAAA;EACA,8CnI+jBgB;EmI9jBhB,2DAAA;ApIir9BX;AoI3q9BQ;EACC,qBAAA;EACA,sBAAA;ApI6q9BT;AoItq9BO;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBnIoNa;EmInNb,wCAAA;EACA,gDnI07BgB;EmIz7BhB,oBAAA;EACA,2BAAA;ApIwq9BR;AoIrq9BS;EAEC,2BAAA;EACA,6BAAA;EACA,4BAAA;ApIsq9BV;AoIpq9BS;EACC,2CAAA;EACA,4CAAA;EACA,wBAAA;EACA,gBAAA;ApIsq9BV;AoIpq9BS;EACC,2BAAA;EACA,6BAAA;EACA,4BAAA;ApIsq9BV;AoIpq9BS;EACC,gBAAA;ApIsq9BV;AoIpq9BS;EACC,gBAAA;ApIsq9BV;AoInq9BQ;EACC,gBAAA;EACA,wCAAA;ApIqq9BT;AoI9p9BG;EACC,2BAAA;ApIgq9BJ;AoI9p9BI;EACC,qBAAA;ApIgq9BL;AoI7p9BG;EACC,2BAAA;EAKC,6CAAA;ApI2p9BL;AgB5v9BI;EoH2FD;IAUE,4CAAA;IAKC,iBAAA;EpIup9BJ;AACF;AoInp9BE;EACC,wBAAA;EACA,oCAAA;EACA,6CAAA;EACA,YAAA;ApIqp9BH;AoIlp9BI;EACC,gBAAA;EACA,4CAAA;EACA,0BAAA;EnGxJH,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC6y9BF;AoI9p9BK;EAEC,kCAAA;ApI+p9BN;AoI5p9BI;EACC,gBAAA;EACA,4CAAA;EACA,0BAAA;EnGpKH,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCm09BF;AoIxq9BK;EAEC,cnI/HE;EmIgIF,kCAAA;ApIyq9BN;AoIpq9BE;EACC,aAAA;ApIsq9BH;AoInq9BG;EACC,kBAAA;EACA,cAAA;ApIqq9BJ;AgB5z9BI;EoHqJD;IAKE,WAAA;IACA,SAAA;IACA,iBAAA;IACA,+CAAA;IACA,gBAAA;IACA,gBAAA;EpIsq9BH;AACF;AgBt09BI;EoHkKA;IAEE,WAAA;IACA,mBAAA;IACA,aAAA;IACA,iBAAA;IAKC,uBAAA;EpIkq9BL;AACF;AoI/p9BK;EACC,uCAAA;EACA,oBAAA;EACA,gBnI4Ea;ADql9BnB;AgBp19BI;EoHgLC;IAME,kBnIkJS;ImI7IR,iCAAA;EpI8p9BN;AACF;AoI3p9BM;EAEC,6CAAA;EACA,wCAAA;ApI4p9BP;AoI1p9BM;EACC,2BAAA;EACA,4BAAA;EAKC,wBAAA;ApIwp9BR;AoIjp9BI;EAIE,mEAAA;ApIgp9BN;AgBt29BI;EoHkNA;IAWG,4BAAA;EpI6o9BL;AACF;;AqIp79BG;EACC,gBAAA;ArIu79BJ;AqIl79BG;EAIE,wDAAA;ArIi79BL;AqI769BE;EACC,aAAA;EACA,gCAAA;EACA,iBAAA;ArI+69BH;AqI769BG;EACC,uDAAA;ArI+69BJ;AqI569BE;EACC,4BAAA;ArI869BH;AqI759BG;EACC,6BAAA;ArI+59BJ;AqI759BI;EAEC,yBpImBM;AD249BX;AqIr59BO;EACC,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;ArIu59BR;AqIr59BO;EACC,kCAAA;ArIu59BR;AqIh59BQ;EACC,6BAAA;EACA,sBAAA;EACA,gBAAA;ArIk59BT;AqIv49BM;EAKC,uBAAA;ArIq49BP;AqIn49BO;EACC,gBAAA;EACA,QAAA;ECjGP,qBAAA;EACA,uCAAA;EACA,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;AtIu+9BD;AqI349BO;EACC,gBAAA;EACA,QAAA;ECvGP,qBAAA;EACA,uCAAA;EACA,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;AtIq/9BD;AqIl59BM;EAEC,sBAAA;EACA,UAAA;ArIm59BP;AqI349BI;EAEC,UAAA;EACA,mCAAA;ArI449BL;AqI149BK;EACC,iBAAA;ArI449BN;AqIv49BI;EACC,uBAAA;ArIy49BL;AqIv49BK;EACC,oBAAA;ArIy49BN;AqIt49BI;EACC,2BAAA;ArIw49BL;AqIp49BE;EACC,uBAAA;EACA,wBAAA;EACA,6CAAA;ArIs49BH;;AuIth+BE;EACC,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBtI2Ya;AD8o9BhB;AuIvh+BG;EACC,4CAAA;AvIyh+BJ;AuIvh+BG;EACC,gBAAA;EACA,uCAAA;EACA,cAAA;EACA,iBAAA;E1CjBH,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7F2i+BD;AuIzh+BE;EACC,kBAAA;AvI2h+BH;;AuIth+BC;EAEC,uBAAA;EACA,6CAAA;EACA,wCAAA;EACA,wBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBtI8Wc;EsI7Wd,4DtIsXW;ADkq9Bb;;AuIph+BC;EAEC,2BAAA;EACA,eAAA;EACA,mBAAA;AvIsh+BF;AuIph+BE;EAEC,+CAAA;EACA,atIoQM;EsInQN,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AvIqh+BH;AgBjg+BI;EuHlBD;IAEG,WAAA;EvIqh+BJ;AACF;AuInh+BG;EACC,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EtGvBF,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC6i+BF;AgB3h+BI;EuHbD;IASE,mBAAA;EvImi+BH;AACF;AuIji+BI;EAEC,ctIWG;EsIVH,kCAAA;AvIki+BL;AuIxg+BE;EAEC,SAAA;EACA,atI6MM;AD4z9BT;AuIvg+BE;EAEC,atIyMM;AD+z9BT;AuItg+BG;EACC,mBAAA;EACA,sBAAA;EACA,gBAAA;EtGvEF,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCgl+BF;AuIlh+BI;EAEC,ctIlCG;ADqj+BR;AuI7g+BE;EAEC,mDAAA;EACA,yBAAA;AvI8g+BH;AuI5g+BG;EACC,mDAAA;EACA,yBAAA;AvI8g+BJ;AuIzg+BG;EAGC,yBAAA;AvIyg+BJ;AuIvg+BG;EAEC,oBAAA;AvIwg+BJ;AuIjg+BK;EACC,YAAA;AvImg+BN;AuI7/9BS;EACC,gBAAA;AvI+/9BV;AuIv/9BK;EACC,uBAAA;AvIy/9BN;AuIv/9BM;EAEC,uBAAA;AvIw/9BP;AuIl/9BE;EACC,qBAAA;AvIo/9BH;AuIl/9BE;EAIC,gBAAA;EACA,gBAAA;AvIi/9BH;AuI9+9BC;EAEC,iBAAA;EACA,oCtIu1BmB;ADwp8BrB;AuI7+9BC;EACC,uBAAA;AvI++9BF;AuI7+9BC;EACC,6BAAA;EACA,4BAAA;AvI++9BF;AuI7+9BC;EACC,cAAA;AvI++9BF;;AwI5r+BA;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;AxI+r+BF;;AwI7r+BA;;EAEE,kBAAA;AxIgs+BF;;AwI9r+BA;;EAEC,yBAAA;AxIis+BD;;AwI/r+BA;;EAEE,uBAAA;AxIks+BF;;AwIhs+BA;EACC,qBAAA;AxIms+BD;;AwIjs+BA;EACE,cAAA;AxIos+BF;AwIls+BC;EAEC,cAAA;EACA,0BAAA;AxIms+BF;;AwIhs+BA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;EACA,UAAA;AxIms+BF;AwIjs+BC;EACC,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AxIms+BF;;AyI5u+BA;EACC,kBAAA;AzI+u+BD;AyI7u+BC;EAEC,WAAA;AzI8u+BF;AyI5u+BE;EAGC,gBAAA;AzI4u+BH;AyIzu+BC;EACC,gBAAA;EACA,gBAAA;AzI2u+BF;AyIzu+BE;EACC,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,QAAA;EACA,OAAA;AzI2u+BH;;AyIvu+BA;;EAEC,aAAA;AzI0u+BD;;A0Ivw+BC;EACC,WAAA;EACA,6CzIgjCY;EyI/iCZ,oDAAA;EACA,4DzIwZW;ADk39Bb;A0Ipw+BM;EAGC,iBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBzIiYS;ADm49BhB;A0Ilw+BO;EAEC,gDzIwiCiB;AD2t8BzB;A0Ijw+BQ;EACC,2BzImiCa;ADgu8BtB;A0I/v+BM;EAEC,kBAAA;EACA,aAAA;EACA,kBAAA;A1Igw+BP;A0I9v+BO;EACC,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBzI4WQ;E4FnZf,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7Fwy+BD;A0Ijw+BQ;EACC,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1Imw+BT;A0Ijw+BQ;EACC,aAAA;A1Imw+BT;A0I9v+BO;EACC,gBAAA;A1Igw+BR;A0I5v+BO;EACC,gBAAA;A1I8v+BR;A0I3v+BM;EACC,WAAA;A1I6v+BP;A0I3v+BM;EACC,cAAA;A1I6v+BP;A0Ixv+BG;EACC,YAAA;A1I0v+BJ;A0Itv+BM;EACC,YAAA;EACA,gBzIkPY;EyIjPZ,uCAAA;EACA,iBAAA;EACA,kBzIyTS;AD+79BhB;A0Itv+BO;EAEC,gDzIg+BiB;EyI/9BjB,iBAAA;A1Iuv+BR;A0Ihv+BE;EACC,gBAAA;A1Ikv+BH;A0Ihv+BG;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;A1Ikv+BJ;A0Ihv+BI;EACC,WAAA;A1Ikv+BL;A0Ihv+BI;EACC,aAAA;EACA,WAAA;A1Ikv+BL;A0Ihv+BK;EACC,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBzI0RU;E4FnZf,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7F42+BD;A0Inv+BM;EACC,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1Iqv+BP;A0Inv+BM;EAEC,gDzIk7BkB;ADk08BzB;A0Ijv+BK;EACC,WAAA;EACA,gBzIwLa;EyIvLb,wCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1Imv+BN;A0Ihv+BO;EACC,gBAAA;A1Ikv+BR;A0I3u+BE;EACC,gBAAA;A1I6u+BH;A0I3u+BG;EACC,gBzIqKe;EyIpKf,wCAAA;EACA,YAAA;EACA,iBAAA;EACA,kBzI2Oe;ADkg+BnB;A0I3u+BI;EAKC,2DAAA;EACA,iBAAA;A1Iyu+BL;A0Ivu+BI;EACC,sCAAA;EACA,uCAAA;A1Iyu+BL;A0Ivu+BK;EACC,sCAAA;A1Iyu+BN;A0Itu+BI;EACC,sCAAA;EACA,uCAAA;EACA,4BAAA;A1Iwu+BL;A0Itu+BI;EACC,wCAAA;A1Iwu+BL;A0Itu+BI;EACC,uCAAA;A1Iwu+BL;A0Itu+BI;EACC,wCAAA;A1Iwu+BL;A0Itu+BK;EAEC,2BAAA;A1Iuu+BN;A0Ilu+BE;EAEC,gBAAA;A1Imu+BH;A0Iju+BG;EAEC,gBzImHe;EyIlHf,uCAAA;EACA,iBAAA;EACA,kBzI0LY;ADwi+BhB;A0Ihu+BI;EAEC,gDzIi2BoB;ADg48BzB;A0I/t+BI;EACC,gDzI81BoB;EyI71BpB,wBAAA;A1Iiu+BL;A0I/t+BI;EACC,8BAAA;EACA,wBAAA;A1Iiu+BL;;A2Iv8+BA;EACC,WAAA;A3I08+BD;;A2Iv8+BA;EACC,YAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;A3I08+BD;A2Ix8+BC;EACC,kBAAA;EACA,6C1IuiCY;E0ItiCZ,WAAA;EACA,gBAAA;EACA,oDAAA;EACA,4D1I6YW;AD6j+Bb;A2Ix8+BC;EACC,aAAA;A3I08+BF;A2Ix8+BC;EACC,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kB1IuXiB;ADml+BnB;A2Ix8+BE;EAEC,gD1I6hCsB;E0I5hCtB,aAAA;A3Iy8+BH;A2Iv8+BG;EACC,2B1IuhCkB;ADk78BtB;A2It8+BE;EACC,uCAAA;EACA,kBAAA;EACA,mB1IyRc;E0IxRd,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;E9ClDF,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7F2/+BD;A2Iz8+BE;EACC,aAAA;A3I28+BH;A2Ix8+BG;EACC,gBAAA;A3I08+BJ;A2It8+BG;EACC,gBAAA;A3Iw8+BJ;A2Ip8+BC;EACC,WAAA;A3Is8+BF;A2Ip8+BE;EACC,gBAAA;EACA,YAAA;EACA,UAAA;A3Is8+BH;A2Ip8+BG;EACC,kBAAA;EACA,wBAAA;EACA,gB1I0Pe;E0IzPf,kBAAA;EACA,oBAAA;A3Is8+BJ;A2Ip8+BG;EACC,aAAA;EACA,yBAAA;A3Is8+BJ;A2Ip8+BI;EACC,gB1IiPc;E0IhPd,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,SAAA;A3Is8+BL;A2Ij8+BE;EACC,SAAA;A3Im8+BH;A2Ij8+BG;EACC,aAAA;A3Im8+BJ;A2Ij8+BI;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gB1I6NgB;E0I5NhB,uCAAA;EACA,SAAA;EACA,kB1IkSW;ADiq+BhB;A2Ij8+BK;EAIC,gD1Iu8BmB;E0It8BnB,wBAAA;EACA,aAAA;A3Ig8+BN;A2I97+BK;EACC,mB1I5CC;E0I6CD,c1I/DE;AD+/+BR;;A4I7j/BC;EACC,wCAAA;EACA,gBAAA;EACA,kB3IgZc;E2I/Yd,yBAAA;EACA,qBAAA;A5Igk/BF;A4I9j/BE;EACC,oCAAA;A5Igk/BH;A4I9j/BE;EACC,2D3I8iB0B;E2I7iB1B,oCAAA;A5Igk/BH;A4I9j/BE;EACC,UAAA;A5Igk/BH;A4I9j/BG;EACC,SAAA;EACA,uCAAA;A5Igk/BJ;A4I9j/BG;EACC,wBAAA;A5Igk/BJ;A4I9j/BG;EACC,SAAA;EACA,UAAA;EACA,WAAA;A5Igk/BJ;A4I9j/BI;EACC,wBAAA;A5Igk/BL;A4I7j/BG;EACC,yBAAA;A5I+j/BJ;A4I7j/BI;EAEC,sBAAA;A5I8j/BL;A4I3j/BI;EACC,2BAAA;EACA,2BAAA;A5I6j/BL;A4I3j/BK;EACC,4BAAA;EACA,kBAAA;EACA,iBAAA;EAKC,sBAAA;A5Iyj/BP;A4Itj/BK;EACC,gBAAA;EACA,cAAA;A5Iwj/BN;A4Itj/BM;EACC,gBAAA;EACA,uCAAA;A5Iwj/BP;A4Ijj/BG;EACC,UAAA;EACA,uCAAA;A5Imj/BJ;A4Ijj/BI;EACC,wBAAA;A5Imj/BL;A4Ihj/BG;EACC,gBAAA;EACA,SAAA;A5Ikj/BJ;A4I9i/BC;EACC,6C3I89BY;E2I79BZ,gBAAA;EACA,oDAAA;EACA,WAAA;A5Igj/BF;A4I5i/BI;EACC,gD3Ik+BoB;AD4k9BzB;A4I5i/BI;EACC,mB3IfE;E2IgBF,c3IlCG;ADgl/BR;;A6I/o/BA;EACC,uBAAA;EACA,wCAAA;EACA,kB5IiZe;E4IhZf,wBAAA;EACA,cAAA;EACA,YAAA;A7Ikp/BD;A6Ihp/BC;EACC,8C5IwpByB;E4IvpBzB,2D5IgjB2B;ADkm+B7B;A6Ihp/BC;EACC,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;A7Ikp/BF;A6Ihp/BE;EACC,qBAAA;EACA,yBAAA;EACA,4BAAA;EAMC,wBAAA;EACA,sBAAA;A7I6o/BJ;A6I3o/BG;EACC,4BAAA;EACA,YAAA;A7I6o/BJ;A6Izo/BC;EACC,gBAAA;EACA,wBAAA;A7I2o/BF;A6Izo/BE;EACC,uCAAA;EACA,gB5I6RgB;AD82+BnB;;A8Izr/BA;EACC,iCAAA;EACA,aAAA;EAKC,6CAAA;A9Iwr/BF;AgBnn/BI;E8H5EJ;IAUE,YAAA;E9Iyr/BA;AACF;A8Ivr/BC;EACC,SAAA;EACA,6BAAA;A9Iyr/BF;A8Ivr/BE;EAIE,6CAAA;A9Isr/BJ;A8Ihr/BI;EACC,sBAAA;A9Ikr/BL;A8I/q/BG;EACC,uBAAA;A9Iir/BJ;A8I7q/BK;EACC,eAAA;A9I+q/BN;A8I3q/BO;EAIE,+BAAA;A9I0q/BT;A8Ivq/BO;EAIE,gCAAA;A9Isq/BT;A8Ihq/BI;EACC,YAAA;A9Ikq/BL;A8I7p/BC;EACC,eAAA;EACA,a7IsPO;ADy6+BT;AgBlq/BI;E8HCH;IAKE,6BAAA;E9Igq/BD;AACF;AgB1p/BI;E8HZH;IAQE,aAAA;E9Ikq/BD;AACF;A8Ihq/BE;EAIE,6CAAA;A9I+p/BJ;A8I5p/BE;EACC,gB7IuPgB;E6ItPhB,qBAAA;EACA,mB7IgPc;E6I/Od,aAAA;EACA,qBAAA;A9I8p/BH;;A+Irv/BA;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;A/Iwv/BD;A+Irv/BE;EACC,eAAA;A/Iuv/BH;A+Ipv/BC;EACC,aAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;A/Isv/BF;A+Ipv/BC;EACC,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,8FAAA;EACA,SAAA;A/Isv/BF;A+Ipv/BE;EACC,kBAAA;EACA,iBAAA;EACA,kBAAA;A/Isv/BH;A+Inv/BC;EACC,gBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;A/Iqv/BF;AgJxx/BC;EAEC,WAAA;EACA,cAAA;EACA,WAAA;AhJyx/BF;A+Itv/BE;EACC,cAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A/Iwv/BH;A+Itv/BG;EACC,aAAA;EACA,a9IuQK;E8ItQL,6CAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;A/Iwv/BJ;AgBju/BI;E+H7BD;IASE,WAAA;IACA,iBAAA;IACA,eAAA;E/Iyv/BH;AACF;A+Itv/BE;EACC,eAAA;EACA,gB9I0QgB;E8IzQhB,iBAAA;A/Iwv/BH;AgB7u/BI;E+HdF;IAME,kBAAA;E/Iyv/BF;AACF;A+Ivv/BE;EACC,qBAAA;EACA,wCAAA;EACA,gBAAA;A/Iyv/BH;AgBvv/BI;E+HLF;IAME,oBAAA;E/I0v/BF;AACF;;AiJt0/BE;EACC,wBAAA;EACA,2BAAA;EACA,2BAAA;AjJy0/BH;AiJv0/BE;EACC,gBAAA;EACA,mBhJ+SM;EgJ9SN,kBAAA;AjJy0/BH;AiJv0/BG;EACC,aAAA;EACA,mBAAA;AjJy0/BJ;AiJv0/BG;EACC,kBhJmYY;EgJlYZ,oBAAA;EACA,kBAAA;AjJy0/BJ;AgBhx/BI;EiI5DD;IAME,kBAAA;IACA,SAAA;IACA,WAAA;EjJ00/BH;AACF;;AkJn2/BA;EAEC,eAAA;EACA,aAAA;EACA,mBAAA;AlJq2/BD;AkJn2/BC;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AlJq2/BF;AkJn2/BE;EACC,wBAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,gBjJyTgB;EiJxThB,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wDAAA;AlJq2/BH;AgB9y/BI;EkIhEF;IAYE,mBAAA;ElJs2/BF;AACF;AkJp2/BE;EACC,eAAA;EACA,cjJsCQ;ADg0/BX;AkJp2/BE;EACC,eAAA;EACA,gBjJySgB;AD6j/BnB;AgB3z/BI;EkI7CF;IAKE,kBAAA;ElJu2/BF;AACF;AkJr2/BE;EACC,mBAAA;EACA,gBAAA;AlJu2/BH;AgBp0/BI;EkIrCF;IAKE,eAAA;ElJw2/BF;AACF;AkJt2/BE;EACC,cAAA;EACA,eAAA;EACA,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,kBjJ6Va;AD2g/BhB;;AmJ/5/BA;EACC,kBAAA;AnJk6/BD;AgBp2/BI;EmI/DJ;IAIE,iCAAA;IACA,8CAAA;EnJm6/BA;AACF;;AmJj6/BA;EACC,alJ+SQ;EkJ9SR,UAAA;AnJo6/BD;AgBl2/BI;EmIpEJ;IAKE,gBAAA;IACA,+CAAA;IACA,gBAAA;IACA,YlJqbkB;IkJpblB,aAAA;IACA,iBAAA;EnJq6/BA;AACF;AmJp6/BC;EACC,0BAAA;EACA,gBlJoTiB;EkJnTjB,cAAA;AnJs6/BF;AgBj3/BI;EmIxDH;IAME,aAAA;EnJu6/BD;AACF;AmJp6/BE;EACC,wBAAA;EACA,cAAA;EACA,uCAAA;EACA,qBAAA;AnJs6/BH;AgB53/BI;EmI9CF;IAOE,mBAAA;IACA,mCAAA;EnJu6/BF;AACF;AmJr6/BG;EACC,uCAAA;AnJu6/BJ;AgBr4/BI;EmInCD;IAIE,cAAA;IACA,gCAAA;IACA,sBAAA;IACA,mBAAA;EnJw6/BH;AACF;AmJt6/BG;EACC,wCAAA;AnJw6/BJ;AmJt6/BG;EACC,sBAAA;EACA,gBlJkRe;ADsp/BnB;AmJt6/BI;EACC,cAAA;AnJw6/BL;;AmJj6/BA;EACC,WAAA;AnJo6/BD;AgBx6/BI;EmIGJ;IAIE,iCAAA;EnJq6/BA;AACF;;AmJn6/BA;EACC,alJ8OQ;ADwr/BT;AmJp6/BC;EACC,4CAAA;AnJs6/BF;AmJp6/BC;EACC,qBAAA;EACA,wBAAA;EACA,gBlJwPiB;EkJvPjB,mBlJqOO;ADis/BT;AmJp6/BE;EACC,wBAAA;EACA,qBAAA;AnJs6/BH;AmJp6/BG;EACC,mBlJ2Oa;EkJ1Ob,uCAAA;EAKC,sBAAA;AnJk6/BL;AmJ95/BE;EACC,cAAA;EACA,uCAAA;EACA,oBAAA;AnJg6/BH;AmJ75/BC;EACC,qBAAA;EACA,gBAAA;EACA,UAAA;AnJ+5/BF;AgJ3ggCC;EAEC,WAAA;EACA,cAAA;EACA,WAAA;AhJ4ggCF;AmJh6/BE;EACC,kBAAA;EACA,kBAAA;EACA,eAAA;EAKC,WAAA;AnJ85/BJ;AgB38/BI;EmIqCF;IAYE,UAAA;IACA,mBAAA;EnJ85/BF;AACF;AgBj9/BI;EmIqCF;IAgBE,aAAA;IACA,mBAAA;EnJg6/BF;AACF;AgBv9/BI;EmIqCF;IAoBE,UAAA;IACA,gBAAA;EnJk6/BF;AACF;AmJj6/BG;EACC,WAAA;AnJm6/BJ;AmJj6/BG;EACC,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AnJm6/BJ;AgB1//BI;EmI0FC;IACC,UAAA;IACA,WAAA;IACA,SAAA;IACA,YAAA;EnJm6/BJ;AACF;AmJh6/BG;EAEC,eAAA;AnJi6/BJ;AmJ/5/BG;EACC,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AnJi6/BJ;AgB9//BI;EmI+FD;IAEE,YAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;EnJi6/BH;AACF;;AoJllgCA;EACC,mBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;ApJqlgCD;;AoJllgCA;EACC,aAAA;EACA,sBAAA;EACA,aAAA;ApJqlgCD;;AoJllgCA;EACC,eAAA;ApJqlgCD;AoJnlgCC;EAHD;IAIE,eAAA;EpJslgCA;AACF;;AoJnlgCA;EACC,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;ApJslgCD;;AoJnlgCA;EACC,SAAA;ApJslgCD;;AoJnlgCA;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;ApJslgCD;AoJplgCC;EACC,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;ApJslgCF;AoJplgCE;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;ApJslgCH;AoJnlgCE;;EAEC,WAAA;EACA,YAAA;EACA,0BAAA;ApJqlgCH;AoJjlgCC;EACC,gBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;ApJmlgCF;AoJjlgCE;EACC,UAAA;ApJmlgCH;AoJ/kgCC;EACC,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;ApJilgCF;AgB/lgCI;EoIkBF;IACC,YAAA;EpJglgCD;AACF;AgBpmgCI;EoIwBF;IACC,YAAA;EpJ+kgCD;AACF;AgBzmgCI;EoI3CJ;IAyEE,anJ8MO;EDi4/BP;AACF;;AoJ5kgCA;EACC;IACC,eAAA;EpJ+kgCA;EoJ5kgCD;IACC,eAAA;EpJ8kgCA;AACF;AqJnsgCA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;ArJqsgCD;AqJnsgCC;EACC,gBAAA;EACA,aAAA;ArJqsgCF;AgBhogCI;EqIvEH;IAKE,gBAAA;IACA,mBAAA;IACA,eAAA;IACA,iBAAA;ErJssgCD;AACF;AqJrsgCE;EACC,uCAAA;EACA,eAAA;ArJusgCH;AgB5ogCI;EqI7DF;IAKE,UAAA;ErJwsgCF;AACF;AqJtsgCE;EACC,oBAAA;ArJwsgCH;AqJtsgCE;EACC,eAAA;ArJwsgCH;AqJtsgCE;EACC,wCAAA;EACA,qBAAA;EACA,kBpJoXa;ADo1/BhB;AqJtsgCG;EACC,6CAAA;ArJwsgCJ;AqJtsgCG;EACC,2BAAA;EACA,cpJwBI;EoJvBJ,gBpJkSe;ADs6/BnB;AqJpsgCC;EACC,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;ArJssgCF;AqJpsgCE;EACC,kBAAA;EACA,YAAA;ArJssgCH;AgB9qgCI;EqI1BF;IAKE,eAAA;IACA,YAAA;ErJusgCF;AACF;AqJrsgCG;EAIE,6CAAA;ArJosgCL;AgBvrgCI;EqIjBD;IAWG,iBAAA;ErJisgCJ;AACF;AqJ7rgCE;EACC,YAAA;EACA,SAAA;ArJ+rgCH;AqJ5rgCC;EACC,gBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ArJ8rgCF;AqJ3rgCG;EACC,mBAAA;ArJ6rgCJ;AqJ1rgCE;EACC,WAAA;EACA,kBAAA;EACA,mBpJsNM;ADs+/BT;AqJ1rgCG;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;ArJ4rgCJ;AqJzrgCE;EACC,oBAAA;EACA,gBpJ4NgB;EoJ3NhB,uCAAA;ArJ2rgCH;AqJxrgCC;EACC,qBAAA;EACA,SAAA;EACA,UAAA;ArJ0rgCF;AqJxrgCE;EACC,apJgMM;EoJ/LN,aAAA;ArJ0rgCH;AqJxrgCG;EACC,4CAAA;ArJ0rgCJ;AqJxrgCG;EACC,kDAAA;ArJ0rgCJ;AqJtrgCK;EACC,gBpJsMa;EoJrMb,wBAAA;ArJwrgCN;AqJprgCG;EACC,4CAAA;ArJsrgCJ;AqJnrgCI;EACC,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;ExDlJJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EwDoJK,OAAA;ArJqrgCN;AqJhrgCE;EACC,kBAAA;ArJkrgCH;AqJhrgCG;EAIE,oBAAA;ArJ+qgCL;AqJ3qgCE;EACC,SAAA;ArJ6qgCH;AqJ3qgCG;EACC,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;ArJ6qgCJ;AqJ3qgCG;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;ArJ6qgCJ;AgBtxgCI;EqIsGD;IAME,cAAA;ErJ8qgCH;AACF;AqJ5qgCI;EACC,gBpJ8Ic;EoJ7Id,sBAAA;EACA,SAAA;EAKC,kBAAA;ArJ0qgCN;AqJvqgCI;EACC,kBAAA;EACA,uCAAA;EACA,gBpJkIc;EoJ7Hb,oBAAA;ArJqqgCN;AqJjqgCG;EACC,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;ArJmqgCJ;AgB9ygCI;EqIsID;IAQE,kBAAA;IACA,oBAAA;ErJoqgCH;AACF;AqJlqgCG;EACC,kBAAA;EACA,oBAAA;EACA,uCAAA;EACA,oBAAA;EACA,gBAAA;ArJoqgCJ;AqJhqgCC;EACC,eAAA;ArJkqgCF;AgB9zgCI;EqI2JH;IAIE,apJ6EM;EDslgCP;AACF;AqJjqgCE;EACC,+CAAA;EACA,mBAAA;ArJmqgCH;AgBv0gCI;EqIkKF;IAKE,oBpJqEK;ED+lgCP;AACF;AqJlqgCE;EACC,iBAAA;ArJoqgCH;AgB/0gCI;EqI0KF;IAIE,eAAA;ErJqqgCF;AACF;AqJnqgCE;EACC,mBpJuEc;AD8lgCjB;AqJnqgCE;EACC,aAAA;EACA,eAAA;ArJqqgCH;AqJnqgCG;EACC,6CAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBpJ2IY;EoJtIX,oBAAA;ArJiqgCL;AqJ9pgCI;EACC,cAAA;EACA,qBAAA;ArJgqgCL;AqJ9pgCI;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;ArJgqgCL;AqJ9pgCK;EACC,cAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ArJgqgCN;AqJ9pgCK;EACC,eAAA;ArJgqgCN;AqJ7pgCI;EACC,wBAAA;EACA,0BAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ArJ+pgCL;AqJzpgCE;EACC,oBAAA;ArJ2pgCH;AgBp4gCI;EqIwOF;IAIE,qBAAA;ErJ4pgCF;AACF;AqJ1pgCG;EACC,4CAAA;ArJ4pgCJ;AqJzpgCE;EACC,YAAA;EACA,gBAAA;ArJ2pgCH;AqJzpgCG;EACC,4CAAA;EACA,+CAAA;ArJ2pgCJ;AqJzpgCG;EACC,4CAAA;ArJ2pgCJ;;AsJn+gCA;EACC,YAAA;EACA,aAAA;AtJs+gCD;AsJp+gCC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AtJs+gCF;AgB96gCI;EsI3DH;IAME,kBAAA;IACA,8CAAA;EtJu+gCD;AACF;AsJt+gCE;EACC,+CAAA;EACA,arJySM;AD+rgCT;AsJt+gCE;EACC,SAAA;EACA,gBAAA;AtJw+gCH;AsJt+gCE;EACC,+CAAA;AtJw+gCH;AsJt+gCG;EACC,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,wBAAA;AtJw+gCJ;AsJt+gCI;EACC,mDAAA;AtJw+gCL;AsJt+gCI;EAEC,kDAAA;AtJu+gCL;AsJp+gCI;EACC,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AtJs+gCL;AsJp+gCK;EACC,eAAA;AtJs+gCN;AsJn+gCK;EACC,qBAAA;AtJq+gCN;AsJl+gCI;EACC,SAAA;EACA,mBAAA;AtJo+gCL;AsJl+gCI;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AtJo+gCL;AsJl+gCI;EACC,sBAAA;EACA,uCAAA;EACA,sBAAA;AtJo+gCL;AsJl+gCI;EAEC,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,oBrJ6PU;ADsugCf;AsJj+gCI;EACC,gBrJ8Pc;EqJ7Pd,wBAAA;AtJm+gCL;AsJj+gCI;EACC,2BAAA;EACA,4BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBrJgPc;EqJvOb,iBAAA;AtJ29gCN;AsJl+gCK;EACC,aAAA;AtJo+gCN;AsJx9gCC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AtJ09gCF;AgB1/gCI;EsI6BH;IAME,aAAA;EtJ29gCD;AACF;AsJz9gCE;EACC,aAAA;EACA,+CAAA;EACA,qBAAA;EACA,mBAAA;AtJ29gCH;AsJz9gCG;EACC,aAAA;AtJ29gCJ;AgBxghCI;EsI4CD;IAIE,cAAA;EtJ49gCH;AACF;AsJ19gCI;EACC,uCAAA;EACA,mBAAA;AtJ49gCL;AsJx9gCI;EACC,aAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AtJ09gCL;AsJx9gCI;EAIE,iBrJuKG;ADgzgCT;AsJn9gCG;EACC,mBrJ+Ka;EqJ9Kb,wBAAA;EACA,gBrJkLe;EqJjLf,oBAAA;EACA,SAAA;AtJq9gCJ;AsJn9gCI;EACC,cAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;AtJq9gCL;AsJl9gCG;EACC,aAAA;AtJo9gCJ;AsJl9gCI;EACC,eAAA;EACA,uCAAA;AtJo9gCL;AsJl9gCK;EAEC,wBAAA;AtJm9gCN;AsJ98gCE;EACC,SAAA;EACA,gBAAA;AtJg9gCH;AsJ98gCG;EACC,arJkIK;AD80gCT;AsJ78gCE;EACC,4CAAA;EACA,arJ6HM;ADk1gCT;AgB9jhCI;EsIoHD;IACC,aAAA;EtJ68gCF;EsJ38gCC;IACC,aAAA;EtJ68gCF;AACF;;AuJlphCA;EACC,6BAAA;EACA,YAAA;AvJqphCD;AuJnphCC;EACC,YAAA;EACA,UAAA;AvJqphCF;AgB5lhCI;EuI3DH;IAKE,aAAA;EvJsphCD;EuJpphCC;IAIE,6CAAA;EvJmphCH;AACF;AuJ/ohCC;EACC,aAAA;AvJiphCF;AgBvmhCI;EuI3CH;IAIE,YtJoesB;IsJnetB,sBAAA;EvJkphCD;AACF;AgBhmhCI;EuIxDH;IAQE,gBAAA;IACA,mBAAA;IACA,+CAAA;EvJophCD;AACF;AuJlphCE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,atJmRM;ADi4gCT;AgB7mhCI;EuI3CF;IAOE,YtJodqB;IsJndrB,iBAAA;IACA,eAAA;EvJqphCF;AACF;AuJpphCG;EACC,cAAA;EACA,qBAAA;EACA,cAAA;AvJsphCJ;AuJpphCG;EACC,kBAAA;EACA,gBAAA;AvJsphCJ;AuJpphCG;EACC,mBtJ+Qa;EsJ9Qb,gBtJmRe;EsJlRf,mBAAA;EACA,mBAAA;AvJsphCJ;AuJpphCG;EACC,eAAA;EACA,gBAAA;AvJsphCJ;AuJnphCE;EACC,SAAA;AvJqphCH;AgBvphCI;EuICF;IAIE,gBAAA;IACA,UAAA;EvJsphCF;AACF;AuJpphCE;EACC,SAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;AvJsphCH;AgBtphCI;EuIJF;IAOE,aAAA;IACA,iBAAA;EvJuphCF;AACF;AgB5phCI;EuIOD;IAEE,mBAAA;EvJuphCH;AACF;AuJtphCI;EACC,kBAAA;EACA,atJ+NI;EsJ9NJ,mBAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBtJ0Oc;EsJzOd,gBAAA;AvJwphCL;AuJtphCK;EACC,yBAAA;AvJwphCN;AuJtphCM;EACC,sBAAA;EACA,cAAA;EACA,SAAA;AvJwphCP;AuJtphCM;EAGC,kBAAA;AvJsphCP;AuJnphCK;EACC,cAAA;EACA,6CAAA;EACA,kBAAA;AvJqphCN;AuJnphCK;EACC,mCAAA;AvJqphCN;AuJnphCK;EACC,wBAAA;AvJqphCN;AuJlphCO;EAGC,mBAAA;AvJkphCR;AuJ1ohCC;EACC,SAAA;AvJ4ohCF;AgBtthCI;EuIyEH;IAIE,gBAAA;EvJ6ohCD;AACF;AgB9shCI;EuI4DH;IAOE,yBAAA;EvJ+ohCD;AACF;AuJ7ohCE;EACC,eAAA;AvJ+ohCH;AuJ5ohCC;EACC,YtJsW0B;EsJrW1B,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AvJ8ohCF;AgB7thCI;EuI0EH;IAQE,eAAA;IACA,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,aAAA;IACA,6BAAA;IACA,sCAAA;IACA,aAAA;EvJ+ohCD;AACF;AuJ7ohCE;EACC,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AvJ+ohCH;AuJ7ohCG;EACC,YAAA;EACA,aAAA;EAKC,kBtJiII;AD0ghCT;AgBtvhCI;EuIoGD;IAUE,cAAA;EvJ4ohCH;AACF;AuJ1ohCI;EACC,wBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AvJ4ohCL;AuJxohCI;EACC,gBAAA;AvJ0ohCL;AuJxohCI;EAIE,sBAAA;AvJuohCN;AuJnohCG;EACC,gBtJwHe;EsJvHf,SAAA;AvJqohCJ;AuJnohCG;EACC,cAAA;AvJqohCJ;AuJjohCG;EACC,iBAAA;AvJmohCJ;AuJhohCK;EACC,mCAAA;AvJkohCN;AuJhohCM;EACC,wBAAA;AvJkohCP;AuJ/nhCK;EACC,mBAAA;AvJiohCN;AuJ5nhCE;EACC,UAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;AvJ8nhCH;AuJ5nhCE;EACC,4CAAA;EACA,oBAAA;AvJ8nhCH;AuJ5nhCE;EACC,eAAA;EACA,kBAAA;EACA,aAAA;AvJ8nhCH;AuJ5nhCG;EACC,aAAA;EACA,SAAA;AvJ8nhCJ;AuJ5nhCI;EACC,aAAA;EACA,cAAA;EACA,2BAAA;EACA,sBAAA;AvJ8nhCL;AuJ5nhCI;EAIE,iBtJgDG;AD2khCT;AuJvnhCG;EAIE,iBtJwCI;AD8khCT;AuJlnhCG;EACC,kBAAA;EACA,MAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,qCAAA;EACA,atJ4BK;EsJ3BL,SAAA;AvJonhCJ;AuJlnhCI;EACC,kBAAA;AvJonhCL;AuJlnhCI;EACC,kBAAA;AvJonhCL;AuJhnhCG;EACC,4CAAA;AvJknhCJ;AuJ9mhCC;EACC,wBAAA;EACA,etJ2M0B;EsJ1M1B,aAAA;EACA,mBAAA;AvJgnhCF;AuJ9mhCE;EAGC,aAAA;AvJ8mhCH;AgBv1hCI;EuIsOF;IAME,UAAA;EvJ+mhCF;AACF;AuJ7mhCE;EACC,aAAA;AvJ+mhCH;AuJ7mhCG;EAEC,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AvJ8mhCJ;AuJ3mhCK;EACC,YAAA;AvJ6mhCN;AuJ1mhCI;EACC,gBtJFc;EsJGd,eAAA;EACA,yBAAA;EAKC,iBtJ3BG;ADmohCT;AuJnmhCE;EACC,gBtJfgB;EsJgBhB,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AvJqmhCH;AgBt3hCI;EuI4QF;IAQE,aAAA;EvJsmhCF;AACF;AuJpmhCE;EACC,mBAAA;EACA,yBAAA;AvJsmhCH;AuJnmhCI;EACC,sBAAA;EACA,wBAAA;AvJqmhCL;AgBn4hCI;EuI4RA;IAKE,yBAAA;EvJsmhCJ;AACF;AuJrmhCK;EACC,eAAA;EACA,kBAAA;AvJumhCN;AuJrmhCK;EACC,mCAAA;AvJumhCN;AuJjmhCC;EACC,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AvJmmhCF;AuJjmhCE;EACC,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;AvJmmhCH;AuJjmhCE;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,wCAAA;EACA,atJvFM;AD0rhCT;AuJjmhCG;EACC,etJ3EW;EsJ4EX,gBtJzEe;EsJ0Ef,iCAAA;EACA,oBAAA;AvJmmhCJ;AuJjmhCG;EACC,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AvJmmhCJ;AuJjmhCG;EACC,SAAA;EACA,gBtJrFe;EsJsFf,iCAAA;EACA,etJ1FW;AD6rhCf;AuJhmhCE;EACC,mBAAA;AvJkmhCH;AuJhmhCG;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACC,qCAAA;EACD,wBAAA;EACA,kB/IyM0B;E+IxM1B,aAAA;EACA,mBAAA;EACA,uBAAA;AvJkmhCJ;AuJ9lhCC;EACC,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;AvJgmhCF;AuJ7lhCG;EACC,wCAAA;AvJ+lhCJ;AuJ3lhCE;EACC,UAAA;EACA,wCAAA;AvJ6lhCH;AuJ3lhCG;EACC,atJhJK;EsJiJL,+CAAA;EACA,mCAAA;EACA,gBtJjIe;AD8thCnB;AuJ3lhCI;EACC,iBAAA;EACA,wBAAA;AvJ6lhCL;AuJzlhCI;EACC,oBtJ9IU;EsJ+IV,sBAAA;EACA,aAAA;EACA,mBAAA;AvJ2lhCL;AuJzlhCK;EACC,gBAAA;EACA,gBtJjJa;EsJkJb,qBAAA;EACA,mCAAA;AvJ2lhCN;AuJzlhCK;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AvJ2lhCN;AuJzlhCK;EACC,mBAAA;EACA,ctJvaK;EsJwaL,aAAA;EACA,mBAAA;EAKC,kBtJtLE;AD6whCT;AuJplhCM;EACC,ctJvaE;AD6/hCT;AuJplhCM;EACC,ctJpaA;AD0/hCP;AuJnlhCK;EACC,sBAAA;AvJqlhCN;AuJnlhCM;EACC,sCAAA;AvJqlhCP;AuJllhCK;EACC,4CAAA;AvJolhCN;AuJ9khCC;EACC,+CAAA;AvJglhCF;AgBxhiCI;EuIucH;IAIE,aAAA;EvJilhCD;AACF;AuJhlhCE;EACC,UAAA;EACA,eAAA;EAKC,iBAAA;AvJ8khCJ;AgBrhiCI;EuIgcF;IAUE,WAAA;IACA,kBAAA;IAKC,gBAAA;EvJ2khCH;AACF;AuJxkhCE;EACC,eAAA;EACA,SAAA;EAKC,6CAAA;AvJskhCJ;AgBjiiCI;EuIodF;IAUE,iBAAA;IACA,cAAA;EvJukhCF;AACF;AuJrkhCG;EACC,eAAA;EACA,oBAAA;AvJukhCJ;AgB3iiCI;EuIkeD;IAKE,4CAAA;IACA,qBAAA;IACA,qBAAA;EvJwkhCH;AACF;AuJtkhCG;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AvJwkhCJ;AuJtkhCI;EACC,gBAAA;EACA,kBAAA;EACA,mBtJxQI;ADg1hCT;AuJtkhCK;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBtJtLa;AD8vhCnB;AuJtkhCK;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBtJjMa;EsJkMb,aAAA;EACA,mBAAA;EACA,uBAAA;AvJwkhCN;AuJrkhCI;EACC,aAAA;EACA,SAAA;EACA,mBtJvSI;AD82hCT;AuJpkhCK;EACC,cAAA;AvJskhCN;AuJpkhCM;EACC,mBAAA;AvJskhCP;AuJjkhCK;EACC,aAAA;AvJmkhCN;AuJ7jhCC;EACC,kBAAA;EACA,SAAA;EACA,YAAA;AvJ+jhCF;AuJ7jhCE;EACC,wBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;AvJ+jhCH;AuJ7jhCG;EACC,2BAAA;AvJ+jhCJ;AuJ7jhCG;EACC,atJ7UK;EsJ8UL,kBAAA;AvJ+jhCJ;AuJ7jhCI;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;AvJ+jhCL;AuJ3jhCI;EACC,4CAAA;EACA,SAAA;AvJ6jhCL;AuJ3jhCK;EACC,uBAAA;EACA,kBAAA;AvJ6jhCN;AuJ3jhCM;EAIE,6CAAA;AvJ0jhCR;AuJnjhCE;EACC,kBAAA;EACA,WAAA;AvJqjhCH;AuJnjhCG;EACC,kBAAA;AvJqjhCJ;AuJnjhCI;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;AvJqjhCL;AuJnjhCI;EACC,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;E1D/rBJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7FqviCD;AuJjjhCI;EACC,iCAAA;AvJmjhCL;AuJjjhCI;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;AvJmjhCL;AuJjjhCI;EACC,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;E1DjuBJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7FqxiCD;AuJjjhCG;EACC,mBAAA;EACA,mCAAA;EACA,iCAAA;AvJmjhCJ;AuJjjhCI;EACC,ctJ/pBC;ADktiCN;AuJ7ihCI;EACC,ctJrqBE;ADotiCP;AuJ7ihCI;EACC,kBAAA;AvJ+ihCL;AuJ7ihCK;EACC,6BAAA;AvJ+ihCN;AuJzihCG;EACC,yCAAA;EACA,kBAAA;AvJ2ihCJ;AuJzihCI;EACC,ctJ5rBI;ADuuiCT;AuJrihCE;EACC,sBAAA;AvJuihCH;AuJpihCI;EACC,yBAAA;AvJsihCL;AuJnihCG;EACC,SAAA;EACA,4CAAA;AvJqihCJ;AgBhviCI;EuI+sBH;IAEE,WAAA;EvJmihCD;EuJjihCC;IAEC,aAAA;EvJkihCF;EuJhihCC;IACC,aAAA;EvJkihCF;EuJ/hhCE;IACC,UAAA;EvJiihCH;AACF;;AuJzhhCC;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EAKC,gBAAA;AvJwhhCH;AgBlxiCI;EuI6vBH;IAEE,aAAA;EvJuhhCD;EuJrhhCC;IAEC,UAAA;IACA,cAAA;IACA,aAAA;EvJshhCF;AACF;AuJphhCE;EACC,atJhhBM;ADsiiCT;AuJphhCG;EACC,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,qBAAA;AvJshhCJ;AgBtyiCI;EuI2wBD;IAQE,oBAAA;EvJuhhCH;AACF;AuJphhCE;EACC,eAAA;EACA,6CAAA;AvJshhCH;AuJphhCG;EACC,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AvJshhCJ;AuJphhCI;EACC,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AvJshhCL;AuJphhCK;EACC,aAAA;AvJshhCN;AuJnhhCO;EACC,sBAAA;EACA,iCAAA;EACA,0CAAA;AvJqhhCR;AuJjhhCK;EACC,mDAAA;EACA,iBAAA;EACA,YAAA;EACA,kBtJjeU;EsJkeV,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AvJmhhCN;AuJjhhCM;EACC,cAAA;EACA,gB/I7OuB;E+I8OvB,aAAA;EACA,oBtJzjBQ;EsJ0jBR,kBAAA;AvJmhhCP;AuJjhhCM;EACC,gBtJzjBY;EsJ0jBZ,mBAAA;EACA,gB/IrPuB;ARwwhC9B;;AuJ1ghCA;EACC,eAAA;EACA,YAAA;EACA,WtJzlBQ;EsJ0lBR,aAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,0DtJ5fe;EsJ6ff,mBAAA;EACA,WAAA;AvJ6ghCD;AuJ3ghCC;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;AvJ6ghCF;AgBx2iCI;EuIk0BJ;IA6BE,aAAA;EvJ6ghCA;AACF;AuJ3ghCC;EACC,ctJz2BS;ADs3iCX;AuJ3ghCC;EACC,eAAA;EACA,cAAA;EACA,cAAA;AvJ6ghCF;AuJ3ghCC;EACC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iCAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;EACA,mBtJznBe;EsJ0nBf,gBtJrnBiB;EsJsnBjB,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AvJ6ghCF;;AuJvghCE;;EAEC,kCAAA;AvJ0ghCH;;AwJr9iCC;EACC,eAAA;EACA,gBAAA;EACA,mBvJoTO;EuJnTP,WAAA;AxJw9iCF;AwJt9iCE;EACC,eAAA;EACA,WAAA;AxJw9iCH;AwJr9iCC;EACC,kBAAA;EACA,iBAAA;EACA,SAAA;AxJu9iCF;AgB15iCI;EwIhEH;IAME,gBAAA;IACA,eAAA;IACA,aAAA;IACA,iBAAA;ExJw9iCD;AACF;AwJr9iCG;EACC,kBAAA;AxJu9iCJ;AwJr9iCI;EACC,oBAAA;EACA,gBvJ4Sc;EuJ3Sd,uBAAA;AxJu9iCL;AgB16iCI;EwIhDA;IAME,qBAAA;ExJw9iCJ;AACF;AwJr9iCG;EAIE,mBAAA;AxJo9iCL;AwJ/8iCC;EACC,aAAA;AxJi9iCF;AgBr7iCI;EwI7BH;IAIE,cAAA;ExJk9iCD;AACF;AwJh9iCE;EACC,gBAAA;EACA,eAAA;EAKC,8CAAA;AxJ88iCJ;AgB/7iCI;EwItBF;IAWE,aAAA;ExJ88iCF;AACF;AwJ58iCE;EACC,SAAA;AxJ88iCH;AwJ58iCG;EACC,eAAA;AxJ88iCJ;AgB18iCI;EwILD;IAIE,avJ6OI;EDkuiCP;AACF;AwJ38iCC;EACC,qBAAA;EACA,gBAAA;EACA,UAAA;AxJ68iCF;AgJ/hjCC;EAEC,WAAA;EACA,cAAA;EACA,WAAA;AhJgijCF;AwJ98iCE;EACC,UAAA;EACA,gBAAA;EAKC,WAAA;AxJ48iCJ;AwJz8iCG;EACC,UAAA;AxJ28iCJ;AwJz8iCG;EACC,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AxJ28iCJ;AwJz8iCI;EAEC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AxJ08iCL;AwJx8iCK;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mDAAA;AxJ08iCN;AwJr8iCI;EACC,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,cvJxEG;EuJyEH,qBAAA;EACA,gBvJiMc;EuJhMd,qBAAA;EACA,wBAAA;EACA,kBAAA;AxJu8iCL;;AyJnljCA;EACC,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AzJsljCD;AgB9gjCI;EyI5EJ;IAOE,axJiTO;EDsyiCP;AACF;AyJrljCC;EACC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AzJuljCF;;A0JpmjCC;EACC,kBAAA;EACA,gBAAA;EACA,wBAAA;A1JumjCF;A0JrmjCC;EACC,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6CAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,cAAA;A1JmmjCH;A0JhmjCE;EAEC,qBAAA;EACA,4CAAA;EACA,wBAAA;A1JimjCH;A0J9ljCC;EACC,qBAAA;EACA,eAAA;EACA,eAAA;EACA,+CAAA;EACA,mBAAA;EACA,aAAA;A1JgmjCF;AgB9jjCI;E0IxCH;IASE,oBAAA;IACA,oBAAA;IACA,gBAAA;E1JimjCD;AACF;A0J9ljCG;EACC,cAAA;EACA,iBAAA;EACA,uCAAA;EACA,qBAAA;EACA,oCAAA;EACA,gBAAA;EACA,mBAAA;A1JgmjCJ;A0J9ljCI;EAEC,4BzJKM;AD0ljCX;A0J7ljCI;EACC,gBzJyQc;EyJxQd,sBAAA;EACA,oCAAA;A1J+ljCL;A0J5ljCG;EAIE,iBzJ8OI;AD62iCT;A0JtljCC;EACC,qBAAA;EACA,SAAA;EACA,UAAA;A1JwljCF;A0JtljCE;EACC,eAAA;EACA,aAAA;A1JwljCH;AgJ7qjCC;EAEC,WAAA;EACA,cAAA;EACA,WAAA;AhJ8qjCF;A0JzljCG;EACC,+CAAA;A1J2ljCJ;A0JzljCG;EACC,4CAAA;A1J2ljCJ;A0JzljCG;EACC,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1J2ljCJ;AgBpnjCI;E0IoBD;IAQE,WAAA;IACA,eAAA;E1J4ljCH;AACF;A0J1ljCI;EACC,eAAA;EACA,gBAAA;A1J4ljCL;A0J1ljCI;EAIE,sBAAA;A1JyljCN;A0JrljCG;EACC,SAAA;A1JuljCJ;A0JrljCI;EACC,qBAAA;EACA,kBAAA;A1JuljCL;A0JrljCK;EACC,wBAAA;EACA,qBAAA;A1JuljCN;A0JrljCM;EACC,0BAAA;A1JuljCP;;A2J3tjCA;EACC,SAAA;EACA,UAAA;A3J8tjCD;A2J5tjCC;EACC,aAAA;EACA,qBAAA;A3J8tjCF;A2J5tjCE;EACC,gB1J+SM;AD+6iCT;A2J5tjCE;EACC,qBAAA;A3J8tjCH;A2J3tjCC;EACC,kBAAA;EACA,gB1JyTiB;E0JxTjB,uCAAA;EACA,gBAAA;EACA,kBAAA;A3J6tjCF;A2J3tjCC;EACC,SAAA;A3J6tjCF;A2J3tjCC;EAEC,oBAAA;EACA,gB1J8SiB;E0J7SjB,wCAAA;EACA,iBAAA;EACA,gBAAA;A3J4tjCF;A2J1tjCC;EACC,cAAA;A3J4tjCF;A2J1tjCE;EACC,eAAA;EACA,cAAA;ElJnBC,mBAAA;ATgvjCJ;A2JztjCC;EACC,mB1JoBM;E0JnBN,c1J4CM;E0J3CN,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kB1JqWiB;ADs3iCnB;A2JztjCE;EACC,kBAAA;A3J2tjCH;A2JxtjCG;EACC,WAAA;EACA,mCAAA;EACA,4B1JMI;E0JLJ,kBAAA;EACA,gBAAA;EAMC,cAAA;EACA,2B1JHG;ADwtjCR;A2J/sjCE;EACC,iBAAA;A3JitjCH;A2J/sjCE;EACC,2BAAA;EACA,4BAAA;A3JitjCH;A2J/sjCG;EACC,yBAAA;EACA,oCAAA;EAOC,kCAAA;EACA,UAAA;EACA,eAAA;A3J2sjCL;;A4JryjCA;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;A5JwyjCD;A4JtyjCC;EACC,kBAAA;EACA,UAAA;A5JwyjCF;A4JtyjCE;EACC,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;A5JwyjCH;A4JtyjCG;EAEC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;A5JuyjCJ;A4JryjCG;EACC,sBAAA;EACA,2BAAA;EACA,4BAAA;A5JuyjCJ;;A6Jn0jCC;EACC,kBAAA;EACA,aAAA;A7Js0jCF;A6Jp0jCC;EAGC,4CAAA;A7Jo0jCF;A6Jl0jCC;EAEC,a5J4SO;ADuhjCT;A6Jj0jCC;EACC,SAAA;A7Jm0jCF;A6Jj0jCC;EACC,WAAA;EACA,oBAAA;EAKC,iBAAA;A7J+zjCH;A6J5zjCC;EACC,gBAAA;EACA,kCAAA;A7J8zjCF;A6J5zjCC;EAGC,4CAAA;A7J4zjCF;;A8J91jCA;EACC,aAAA;EACA,mBAAA;A9Ji2jCD;A8J91jCE;EACC,mCAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;A9Jg2jCH;A8J91jCG;EACC,cAAA;EACA,eAAA;EACA,gBAAA;A9Jg2jCJ;A8J51jCE;EAIE,qBAAA;A9J21jCJ","sourcesContent":["@charset \"UTF-8\";\n/*\n   01. Color system \n   02. Options toggle setting (rtl, shadow, caret, negative margin, color mode)\n   03. Variable prefix setting\n   04. Body setting\n   05. Spacer setting\n   06. Font & headings settings\n   07. Grid settings\n   08. Container padding\n   09. Component border settings\n   10. Component border-radius settings\n   11. Component box-shadow settings \n   12. Component color settings \n   13. Component caret settings \n   14. Component transition settings \n   15. Component ratio settings \n   16. Container padding settings\n   17. App - Header settings\n   18. App - Sidebar settings\n   19. App - Content settings\n   20. App - Pos system settings\n   21. Link settings\n   22. Alerts settings\n   23. Breadcrumbs settings\n   24. Progress bars settings\n   25. Buttons + Forms settings\n   26. Buttons settings\n   27. Button close settings\n   28. Forms settings\n   29. Form placeholders settings\n   30. Form check settings\n   31. Form switch settings\n   32. Form input group settings\n   33. Form select settings\n   34. Form range settings\n   35. Form file settings\n   36. Form Floating settings\n   37. Form validation settings\n   38. Cards settings\n   39. Tooltips settings\n   40. Popovers\n   41. Modals settings\n   42. Offcanvas\n   43. Toasts settings\n   44. Accordion settings\n   45. Tables settings\n   46. Dropdown settings\n   47. List group settings\n   48. Nav settings\n   49. Navbar settings\n   50. Pagination settings\n   51. Z-index settings\n   52. Badges settings\n   53. Position settings\n   54. Image thumbnails settings\n   55. Figures settings\n   56. Carousel settings\n   57. Spinners settings\n   58. Code settings\n*/\n/*\n   Dark color mode variables\n\n   01. Color system \n   02. Body setting\n   03. Font & headings settings\n   04. Border settings\n   05. Component settings\n   06. App - Header settings\n   07. App - Sidebar settings\n   08. App - Theme panel settings\n   09. Form switch settings\n   10. Form select settings\n   11. Form check settings\n   12. Accordion settings\n   13. Modal settings\n*/\n/*!\n * Bootstrap  v5.3.2 (https://getbootstrap.com/)\n * Copyright 2011-2023 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #0271ff;\n  --bs-indigo: #5c25ff;\n  --bs-purple: #b90dff;\n  --bs-pink: #e61079;\n  --bs-red: #e00000;\n  --bs-orange: #ff9f0c;\n  --bs-yellow: #f9e80d;\n  --bs-green: #148922;\n  --bs-teal: #249d79;\n  --bs-cyan: #009be3;\n  --bs-black: #000000;\n  --bs-white: #ffffff;\n  --bs-gray: #526872;\n  --bs-gray-dark: #35434a;\n  --bs-gray-100: #c0cacf;\n  --bs-gray-200: #a8b6bc;\n  --bs-gray-300: #90a2aa;\n  --bs-gray-400: #798e98;\n  --bs-gray-500: #617a86;\n  --bs-gray-600: #526872;\n  --bs-gray-700: #44555e;\n  --bs-gray-800: #35434a;\n  --bs-gray-900: #273136;\n  --bs-default: #798e98;\n  --bs-theme: #249d79;\n  --bs-theme-color: #ffffff;\n  --bs-primary: #0271ff;\n  --bs-secondary: #798e98;\n  --bs-warning: #ff9f0c;\n  --bs-danger: #e00000;\n  --bs-success: #249d79;\n  --bs-inverse: #000000;\n  --bs-info: #009be3;\n  --bs-dark: #35434a;\n  --bs-black: #000000;\n  --bs-white: #ffffff;\n  --bs-purple: #b90dff;\n  --bs-indigo: #5c25ff;\n  --bs-red: #e00000;\n  --bs-pink: #e61079;\n  --bs-green: #148922;\n  --bs-yellow: #f9e80d;\n  --bs-teal: #249d79;\n  --bs-muted: #617a86;\n  --bs-light: #c0cacf;\n  --bs-lime: #50b00a;\n  --bs-gray-100: #c0cacf;\n  --bs-gray-200: #a8b6bc;\n  --bs-gray-300: #90a2aa;\n  --bs-gray-400: #798e98;\n  --bs-gray-500: #617a86;\n  --bs-gray-600: #526872;\n  --bs-gray-700: #44555e;\n  --bs-gray-800: #35434a;\n  --bs-gray-900: #273136;\n  --bs-default-rgb: 121, 142, 152;\n  --bs-theme-rgb: 36, 157, 121;\n  --bs-theme-color-rgb: 255, 255, 255;\n  --bs-primary-rgb: 2, 113, 255;\n  --bs-secondary-rgb: 121, 142, 152;\n  --bs-warning-rgb: 255, 159, 12;\n  --bs-danger-rgb: 224, 0, 0;\n  --bs-success-rgb: 36, 157, 121;\n  --bs-inverse-rgb: 0, 0, 0;\n  --bs-info-rgb: 0, 155, 227;\n  --bs-dark-rgb: 53, 67, 74;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-purple-rgb: 185, 13, 255;\n  --bs-indigo-rgb: 92, 37, 255;\n  --bs-red-rgb: 224, 0, 0;\n  --bs-pink-rgb: 230, 16, 121;\n  --bs-green-rgb: 20, 137, 34;\n  --bs-yellow-rgb: 249, 232, 13;\n  --bs-teal-rgb: 36, 157, 121;\n  --bs-muted-rgb: 97, 122, 134;\n  --bs-light-rgb: 192, 202, 207;\n  --bs-lime-rgb: 80, 176, 10;\n  --bs-gray-100-rgb: 192, 202, 207;\n  --bs-gray-200-rgb: 168, 182, 188;\n  --bs-gray-300-rgb: 144, 162, 170;\n  --bs-gray-400-rgb: 121, 142, 152;\n  --bs-gray-500-rgb: 97, 122, 134;\n  --bs-gray-600-rgb: 82, 104, 114;\n  --bs-gray-700-rgb: 68, 85, 94;\n  --bs-gray-800-rgb: 53, 67, 74;\n  --bs-gray-900-rgb: 39, 49, 54;\n  --bs-primary-text-emphasis: #012d66;\n  --bs-secondary-text-emphasis: #30393d;\n  --bs-success-text-emphasis: #0e3f30;\n  --bs-info-text-emphasis: #003e5b;\n  --bs-warning-text-emphasis: #664005;\n  --bs-danger-text-emphasis: #5a0000;\n  --bs-light-text-emphasis: #44555e;\n  --bs-dark-text-emphasis: #44555e;\n  --bs-primary-bg-subtle: #cce3ff;\n  --bs-secondary-bg-subtle: #c0cacf;\n  --bs-success-bg-subtle: #d0e7d3;\n  --bs-info-bg-subtle: #ccebf9;\n  --bs-warning-bg-subtle: #fefacf;\n  --bs-danger-bg-subtle: #f9cccc;\n  --bs-light-bg-subtle: #e0e5e7;\n  --bs-dark-bg-subtle: #798e98;\n  --bs-primary-border-subtle: #9ac6ff;\n  --bs-secondary-border-subtle: #a8b6bc;\n  --bs-success-border-subtle: #a1d0a7;\n  --bs-info-border-subtle: #99d7f4;\n  --bs-warning-border-subtle: #fdf69e;\n  --bs-danger-border-subtle: #f39999;\n  --bs-light-border-subtle: #a8b6bc;\n  --bs-dark-border-subtle: #617a86;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: \"Chakra Petch\", sans-serif;\n  --bs-body-font-size: 0.875rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: black;\n  --bs-body-color-rgb: 0, 0, 0;\n  --bs-body-bg: #ffffff;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-emphasis-color: #000000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(0, 0, 0, 0.75);\n  --bs-secondary-color-rgb: 0, 0, 0;\n  --bs-secondary-bg: #c0cacf;\n  --bs-secondary-bg-rgb: 192, 202, 207;\n  --bs-tertiary-color: rgba(0, 0, 0, 0.5);\n  --bs-tertiary-color-rgb: 0, 0, 0;\n  --bs-tertiary-bg: rgba(0, 0, 0, 0.1);\n  --bs-tertiary-bg-rgb: 0, 0, 0;\n  --bs-heading-color: #000000;\n  --bs-link-color: #249d79;\n  --bs-link-color-rgb: 36, 157, 121;\n  --bs-link-decoration: underline;\n  --bs-link-hover-color: rgba(36, 157, 121, 0.5);\n  --bs-link-hover-color-rgb: 36, 157, 121;\n  --bs-code-color: #e61079;\n  --bs-highlight-color: black;\n  --bs-highlight-bg: #fefacf;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: rgba(0, 0, 0, 0.2);\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.1);\n  --bs-border-radius: 4px;\n  --bs-border-radius-sm: 2px;\n  --bs-border-radius-lg: 8px;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(var(--bs-inverse-rgb), 0.035);\n  --bs-box-shadow-lg: 0 1rem 3rem rgba(var(--bs-inverse-rgb), 0.175);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(var(--bs-inverse-rgb), 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(2, 113, 255, 0.25);\n  --bs-form-valid-color: #249d79;\n  --bs-form-valid-border-color: #249d79;\n  --bs-form-invalid-color: #e00000;\n  --bs-form-invalid-border-color: #e00000;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: white;\n  --bs-body-color-rgb: 255, 255, 255;\n  --bs-body-bg: #1d2835;\n  --bs-body-bg-rgb: 29, 40, 53;\n  --bs-emphasis-color: #c0cacf;\n  --bs-emphasis-color-rgb: 192, 202, 207;\n  --bs-secondary-color: rgba(255, 255, 255, 0.75);\n  --bs-secondary-color-rgb: 255, 255, 255;\n  --bs-secondary-bg: #35434a;\n  --bs-secondary-bg-rgb: 53, 67, 74;\n  --bs-tertiary-color: rgba(255, 255, 255, 0.5);\n  --bs-tertiary-color-rgb: 255, 255, 255;\n  --bs-tertiary-bg: rgba(0, 0, 0, 0.1);\n  --bs-tertiary-bg-rgb: 0, 0, 0;\n  --bs-primary-text-emphasis: #67aaff;\n  --bs-secondary-text-emphasis: #afbbc1;\n  --bs-success-text-emphasis: #7cc4af;\n  --bs-info-text-emphasis: #66c3ee;\n  --bs-warning-text-emphasis: #ffc56d;\n  --bs-danger-text-emphasis: #ec6666;\n  --bs-light-text-emphasis: #c0cacf;\n  --bs-dark-text-emphasis: #90a2aa;\n  --bs-primary-bg-subtle: #001733;\n  --bs-secondary-bg-subtle: #273136;\n  --bs-success-bg-subtle: #041b07;\n  --bs-info-bg-subtle: #001f2d;\n  --bs-warning-bg-subtle: #322e03;\n  --bs-danger-bg-subtle: #2d0000;\n  --bs-light-bg-subtle: #35434a;\n  --bs-dark-bg-subtle: #1b2225;\n  --bs-primary-border-subtle: #014499;\n  --bs-secondary-border-subtle: #44555e;\n  --bs-success-border-subtle: #0c5214;\n  --bs-info-border-subtle: #003e5b;\n  --bs-warning-border-subtle: #645d05;\n  --bs-danger-border-subtle: #860000;\n  --bs-light-border-subtle: #44555e;\n  --bs-dark-border-subtle: #35434a;\n  --bs-heading-color: #fff;\n  --bs-link-color: #67aaff;\n  --bs-link-hover-color: #9ac6ff;\n  --bs-link-color-rgb: 103, 170, 255;\n  --bs-link-hover-color-rgb: 154, 198, 255;\n  --bs-code-color: #f070af;\n  --bs-highlight-color: white;\n  --bs-highlight-bg: #645d05;\n  --bs-border-color: rgba(255, 255, 255, 0.25);\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.25);\n  --bs-form-valid-color: #72b87a;\n  --bs-form-valid-border-color: #72b87a;\n  --bs-form-invalid-color: #ec6666;\n  --bs-form-invalid-border-color: #ec6666;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.34375rem + 1.125vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.1875rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.3rem + 0.6vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.75rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.278125rem + 0.3375vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.53125rem;\n  }\n}\n\nh4, .h4 {\n  font-size: calc(1.25625rem + 0.075vw);\n}\n@media (min-width: 1200px) {\n  h4, .h4 {\n    font-size: 1.3125rem;\n  }\n}\n\nh5, .h5 {\n  font-size: 1.09375rem;\n}\n\nh6, .h6 {\n  font-size: 0.875rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 600;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: underline;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 2px;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: #798e98;\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.09375rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.09375rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #526872;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 20px;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1660px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1660px;\n  --bs-breakpoint-xxxl: 1921px;\n}\n\n.row {\n  --bs-gutter-x: 20px;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1660px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1921px) {\n  .col-xxxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxxl-0,\n  .gx-xxxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxxl-0,\n  .gy-xxxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxxl-1,\n  .gx-xxxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxxl-1,\n  .gy-xxxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxxl-2,\n  .gx-xxxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxxl-2,\n  .gy-xxxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxxl-3,\n  .gx-xxxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxxl-3,\n  .gy-xxxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxxl-4,\n  .gx-xxxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxxl-4,\n  .gy-xxxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxxl-5,\n  .gx-xxxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxxl-5,\n  .gy-xxxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--bs-body-color);\n  --bs-table-bg: transparent;\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-body-color);\n  --bs-table-striped-bg: rgba(var(--bs-inverse-rgb), 0.1);\n  --bs-table-active-color: var(--bs-body-color);\n  --bs-table-active-bg: rgba(var(--bs-inverse-rgb), 0.1);\n  --bs-table-hover-color: var(--bs-body-color);\n  --bs-table-hover-bg: rgba(var(--bs-inverse-rgb), 0.075);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: var(--bs-border-width) 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 var(--bs-border-width);\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #cce3ff;\n  --bs-table-border-color: #b8cce6;\n  --bs-table-striped-bg: #b8cce6;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #b8cce6;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #bdd2ec;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #e4e8ea;\n  --bs-table-border-color: #cdd1d3;\n  --bs-table-striped-bg: #cdd1d3;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #cdd1d3;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #d3d7d8;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000000;\n  --bs-table-bg: #d3ebe4;\n  --bs-table-border-color: #bed4cd;\n  --bs-table-striped-bg: #bed4cd;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #bed4cd;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #c3d9d3;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000000;\n  --bs-table-bg: #ccebf9;\n  --bs-table-border-color: #b8d4e0;\n  --bs-table-striped-bg: #b8d4e0;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #b8d4e0;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #bdd9e6;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000000;\n  --bs-table-bg: #ffecce;\n  --bs-table-border-color: #e6d4b9;\n  --bs-table-striped-bg: #e6d4b9;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e6d4b9;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #ecdabf;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000000;\n  --bs-table-bg: #f9cccc;\n  --bs-table-border-color: #e0b8b8;\n  --bs-table-striped-bg: #e0b8b8;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e0b8b8;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e6bdbd;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000000;\n  --bs-table-bg: #c0cacf;\n  --bs-table-border-color: #adb6ba;\n  --bs-table-striped-bg: #adb6ba;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #adb6ba;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #b2bbbf;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #ffffff;\n  --bs-table-bg: #35434a;\n  --bs-table-border-color: #49565c;\n  --bs-table-striped-bg: #49565c;\n  --bs-table-striped-color: #ffffff;\n  --bs-table-active-bg: #49565c;\n  --bs-table-active-color: #ffffff;\n  --bs-table-hover-bg: #445158;\n  --bs-table-hover-color: #ffffff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1659.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1920.98px) {\n  .table-responsive-xxxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + var(--bs-border-width));\n  padding-bottom: calc(0.375rem + var(--bs-border-width));\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + var(--bs-border-width));\n  padding-bottom: calc(0.5rem + var(--bs-border-width));\n  font-size: 1rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + var(--bs-border-width));\n  padding-bottom: calc(0.25rem + var(--bs-border-width));\n  font-size: 0.8125rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #798e98;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: transparent;\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: 4px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border-color: rgba(var(--bs-inverse-rgb), 0.5);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: rgba(var(--bs-body-color-rgb), 0.5);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: var(--bs-form-control-disabled-bg);\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: var(--bs-border-width);\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-border-color);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: var(--bs-border-width) 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n  padding: 0.25rem 0.5rem;\n  font-size: 0.8125rem;\n  border-radius: 2px;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  border-radius: 8px;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n  padding: 0.375rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 4px;\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: 4px;\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2335434a' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: transparent;\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: 4px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: rgba(var(--bs-inverse-rgb), 0.5);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: var(--bs-form-control-disabled-bg);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-body-color);\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.8125rem;\n  border-radius: 2px;\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1rem;\n  border-radius: 8px;\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.3em;\n  padding-left: 1.8em;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.8em;\n}\n\n.form-check-reverse {\n  padding-right: 1.8em;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.8em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: transparent;\n  flex-shrink: 0;\n  width: 1.3em;\n  height: 1.3em;\n  margin-top: 0.1em;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: rgba(var(--bs-inverse-rgb), 0.5);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n}\n.form-check-input:checked {\n  background-color: #249d79;\n  border-color: #249d79;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #249d79;\n  border-color: #249d79;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.8em;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 2.3em;\n  margin-left: -2.8em;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2.3em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='gray'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 2.8em;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.8em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px transparent, 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px transparent, 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: var(--bs-theme);\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: rgba(var(--bs-theme-rgb), 0.75);\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: rgba(var(--bs-inverse-rgb), 0.1);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: var(--bs-theme);\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: rgba(var(--bs-theme-rgb), 0.75);\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: rgba(var(--bs-inverse-rgb), 0.1);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-secondary-color);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: var(--bs-border-width) solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.75rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.875em;\n  content: \"\";\n  background-color: transparent;\n  border-radius: 4px;\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: var(--bs-border-width) 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #526872;\n}\n.form-floating > :disabled ~ label::after,\n.form-floating > .form-control:disabled ~ label::after {\n  background-color: var(--bs-form-control-disabled-bg);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-tertiary-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: 4px;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  border-radius: 8px;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.8125rem;\n  border-radius: 2px;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(var(--bs-border-width) * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-success-text);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.8125rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-success);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23249d79' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-success);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-success);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23249d79' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-success);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-success);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-success-text);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-success-text);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-danger-text);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.8125rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-danger);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23e00000'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23e00000' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-danger);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-danger);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23e00000'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23e00000' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-danger);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-danger);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-danger-text);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-danger-text);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 0.75rem;\n  --bs-btn-padding-y: 0.375rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 0.875rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: var(--bs-border-width);\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 4px;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-default {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #798e98;\n  --bs-btn-border-color: #798e98;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #677981;\n  --bs-btn-hover-border-color: #61727a;\n  --bs-btn-focus-shadow-rgb: 141, 159, 167;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #61727a;\n  --bs-btn-active-border-color: #5b6b72;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #798e98;\n  --bs-btn-disabled-border-color: #798e98;\n}\n\n.btn-theme {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #249d79;\n  --bs-btn-border-color: #249d79;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #1f8567;\n  --bs-btn-hover-border-color: #1d7e61;\n  --bs-btn-focus-shadow-rgb: 69, 172, 141;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #1d7e61;\n  --bs-btn-active-border-color: #1b765b;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #249d79;\n  --bs-btn-disabled-border-color: #249d79;\n}\n\n.btn-theme-color {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #ffffff;\n  --bs-btn-border-color: #ffffff;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: white;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 217, 217, 217;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: white;\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #ffffff;\n  --bs-btn-disabled-border-color: #ffffff;\n}\n\n.btn-primary {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #0271ff;\n  --bs-btn-border-color: #0271ff;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #0260d9;\n  --bs-btn-hover-border-color: #025acc;\n  --bs-btn-focus-shadow-rgb: 40, 134, 255;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #025acc;\n  --bs-btn-active-border-color: #0255bf;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #0271ff;\n  --bs-btn-disabled-border-color: #0271ff;\n}\n\n.btn-secondary {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #798e98;\n  --bs-btn-border-color: #798e98;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #677981;\n  --bs-btn-hover-border-color: #61727a;\n  --bs-btn-focus-shadow-rgb: 141, 159, 167;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #61727a;\n  --bs-btn-active-border-color: #5b6b72;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #798e98;\n  --bs-btn-disabled-border-color: #798e98;\n}\n\n.btn-warning {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #ff9f0c;\n  --bs-btn-border-color: #ff9f0c;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffad30;\n  --bs-btn-hover-border-color: #ffa924;\n  --bs-btn-focus-shadow-rgb: 217, 135, 10;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffb23d;\n  --bs-btn-active-border-color: #ffa924;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #ff9f0c;\n  --bs-btn-disabled-border-color: #ff9f0c;\n}\n\n.btn-danger {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #e00000;\n  --bs-btn-border-color: #e00000;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #be0000;\n  --bs-btn-hover-border-color: #b30000;\n  --bs-btn-focus-shadow-rgb: 229, 38, 38;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #b30000;\n  --bs-btn-active-border-color: #a80000;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #e00000;\n  --bs-btn-disabled-border-color: #e00000;\n}\n\n.btn-success {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #249d79;\n  --bs-btn-border-color: #249d79;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #1f8567;\n  --bs-btn-hover-border-color: #1d7e61;\n  --bs-btn-focus-shadow-rgb: 69, 172, 141;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #1d7e61;\n  --bs-btn-active-border-color: #1b765b;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #249d79;\n  --bs-btn-disabled-border-color: #249d79;\n}\n\n.btn-inverse {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #000000;\n  --bs-btn-border-color: #000000;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: black;\n  --bs-btn-hover-border-color: black;\n  --bs-btn-focus-shadow-rgb: 38, 38, 38;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: black;\n  --bs-btn-active-border-color: black;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #000000;\n  --bs-btn-disabled-border-color: #000000;\n}\n\n.btn-info {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #009be3;\n  --bs-btn-border-color: #009be3;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #0084c1;\n  --bs-btn-hover-border-color: #007cb6;\n  --bs-btn-focus-shadow-rgb: 38, 170, 231;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #007cb6;\n  --bs-btn-active-border-color: #0074aa;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #009be3;\n  --bs-btn-disabled-border-color: #009be3;\n}\n\n.btn-dark {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #35434a;\n  --bs-btn-border-color: #35434a;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #535f65;\n  --bs-btn-hover-border-color: #49565c;\n  --bs-btn-focus-shadow-rgb: 83, 95, 101;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #5d696e;\n  --bs-btn-active-border-color: #49565c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #35434a;\n  --bs-btn-disabled-border-color: #35434a;\n}\n\n.btn-black {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #000000;\n  --bs-btn-border-color: #000000;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: black;\n  --bs-btn-hover-border-color: black;\n  --bs-btn-focus-shadow-rgb: 38, 38, 38;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: black;\n  --bs-btn-active-border-color: black;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #000000;\n  --bs-btn-disabled-border-color: #000000;\n}\n\n.btn-white {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #ffffff;\n  --bs-btn-border-color: #ffffff;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: white;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 217, 217, 217;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: white;\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #ffffff;\n  --bs-btn-disabled-border-color: #ffffff;\n}\n\n.btn-purple {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #b90dff;\n  --bs-btn-border-color: #b90dff;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #9d0bd9;\n  --bs-btn-hover-border-color: #940acc;\n  --bs-btn-focus-shadow-rgb: 196, 49, 255;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #940acc;\n  --bs-btn-active-border-color: #8b0abf;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #b90dff;\n  --bs-btn-disabled-border-color: #b90dff;\n}\n\n.btn-indigo {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #5c25ff;\n  --bs-btn-border-color: #5c25ff;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #4e1fd9;\n  --bs-btn-hover-border-color: #4a1ecc;\n  --bs-btn-focus-shadow-rgb: 116, 70, 255;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #4a1ecc;\n  --bs-btn-active-border-color: #451cbf;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #5c25ff;\n  --bs-btn-disabled-border-color: #5c25ff;\n}\n\n.btn-red {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #e00000;\n  --bs-btn-border-color: #e00000;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #be0000;\n  --bs-btn-hover-border-color: #b30000;\n  --bs-btn-focus-shadow-rgb: 229, 38, 38;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #b30000;\n  --bs-btn-active-border-color: #a80000;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #e00000;\n  --bs-btn-disabled-border-color: #e00000;\n}\n\n.btn-pink {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #e61079;\n  --bs-btn-border-color: #e61079;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #c40e67;\n  --bs-btn-hover-border-color: #b80d61;\n  --bs-btn-focus-shadow-rgb: 234, 52, 141;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #b80d61;\n  --bs-btn-active-border-color: #ad0c5b;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #e61079;\n  --bs-btn-disabled-border-color: #e61079;\n}\n\n.btn-green {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #148922;\n  --bs-btn-border-color: #148922;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #11741d;\n  --bs-btn-hover-border-color: #106e1b;\n  --bs-btn-focus-shadow-rgb: 55, 155, 67;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #106e1b;\n  --bs-btn-active-border-color: #0f671a;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #148922;\n  --bs-btn-disabled-border-color: #148922;\n}\n\n.btn-yellow {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #f9e80d;\n  --bs-btn-border-color: #f9e80d;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #faeb31;\n  --bs-btn-hover-border-color: #faea25;\n  --bs-btn-focus-shadow-rgb: 212, 197, 11;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #faed3d;\n  --bs-btn-active-border-color: #faea25;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #f9e80d;\n  --bs-btn-disabled-border-color: #f9e80d;\n}\n\n.btn-teal {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #249d79;\n  --bs-btn-border-color: #249d79;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #1f8567;\n  --bs-btn-hover-border-color: #1d7e61;\n  --bs-btn-focus-shadow-rgb: 69, 172, 141;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #1d7e61;\n  --bs-btn-active-border-color: #1b765b;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #249d79;\n  --bs-btn-disabled-border-color: #249d79;\n}\n\n.btn-muted {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #617a86;\n  --bs-btn-border-color: #617a86;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #526872;\n  --bs-btn-hover-border-color: #4e626b;\n  --bs-btn-focus-shadow-rgb: 121, 142, 152;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #4e626b;\n  --bs-btn-active-border-color: #495c65;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #617a86;\n  --bs-btn-disabled-border-color: #617a86;\n}\n\n.btn-light {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #c0cacf;\n  --bs-btn-border-color: #c0cacf;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #a3acb0;\n  --bs-btn-hover-border-color: #9aa2a6;\n  --bs-btn-focus-shadow-rgb: 163, 172, 176;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #9aa2a6;\n  --bs-btn-active-border-color: #90989b;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #c0cacf;\n  --bs-btn-disabled-border-color: #c0cacf;\n}\n\n.btn-lime {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #50b00a;\n  --bs-btn-border-color: #50b00a;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #6abc2f;\n  --bs-btn-hover-border-color: #62b823;\n  --bs-btn-focus-shadow-rgb: 68, 150, 9;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #73c03b;\n  --bs-btn-active-border-color: #62b823;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #50b00a;\n  --bs-btn-disabled-border-color: #50b00a;\n}\n\n.btn-gray-100 {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #c0cacf;\n  --bs-btn-border-color: #c0cacf;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #c9d2d6;\n  --bs-btn-hover-border-color: #c6cfd4;\n  --bs-btn-focus-shadow-rgb: 163, 172, 176;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #cdd5d9;\n  --bs-btn-active-border-color: #c6cfd4;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #c0cacf;\n  --bs-btn-disabled-border-color: #c0cacf;\n}\n\n.btn-gray-200 {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #a8b6bc;\n  --bs-btn-border-color: #a8b6bc;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #b5c1c6;\n  --bs-btn-hover-border-color: #b1bdc3;\n  --bs-btn-focus-shadow-rgb: 143, 155, 160;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #b9c5c9;\n  --bs-btn-active-border-color: #b1bdc3;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #a8b6bc;\n  --bs-btn-disabled-border-color: #a8b6bc;\n}\n\n.btn-gray-300 {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #90a2aa;\n  --bs-btn-border-color: #90a2aa;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #a1b0b7;\n  --bs-btn-hover-border-color: #9babb3;\n  --bs-btn-focus-shadow-rgb: 122, 138, 145;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #a6b5bb;\n  --bs-btn-active-border-color: #9babb3;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #90a2aa;\n  --bs-btn-disabled-border-color: #90a2aa;\n}\n\n.btn-gray-400 {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #798e98;\n  --bs-btn-border-color: #798e98;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #677981;\n  --bs-btn-hover-border-color: #61727a;\n  --bs-btn-focus-shadow-rgb: 141, 159, 167;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #61727a;\n  --bs-btn-active-border-color: #5b6b72;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #798e98;\n  --bs-btn-disabled-border-color: #798e98;\n}\n\n.btn-gray-500 {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #617a86;\n  --bs-btn-border-color: #617a86;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #526872;\n  --bs-btn-hover-border-color: #4e626b;\n  --bs-btn-focus-shadow-rgb: 121, 142, 152;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #4e626b;\n  --bs-btn-active-border-color: #495c65;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #617a86;\n  --bs-btn-disabled-border-color: #617a86;\n}\n\n.btn-gray-600 {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #526872;\n  --bs-btn-border-color: #526872;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #465861;\n  --bs-btn-hover-border-color: #42535b;\n  --bs-btn-focus-shadow-rgb: 108, 127, 135;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #42535b;\n  --bs-btn-active-border-color: #3e4e56;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #526872;\n  --bs-btn-disabled-border-color: #526872;\n}\n\n.btn-gray-700 {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #44555e;\n  --bs-btn-border-color: #44555e;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #3a4850;\n  --bs-btn-hover-border-color: #36444b;\n  --bs-btn-focus-shadow-rgb: 96, 111, 118;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #36444b;\n  --bs-btn-active-border-color: #334047;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #44555e;\n  --bs-btn-disabled-border-color: #44555e;\n}\n\n.btn-gray-800 {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #35434a;\n  --bs-btn-border-color: #35434a;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #2d393f;\n  --bs-btn-hover-border-color: #2a363b;\n  --bs-btn-focus-shadow-rgb: 83, 95, 101;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #2a363b;\n  --bs-btn-active-border-color: #283238;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #35434a;\n  --bs-btn-disabled-border-color: #35434a;\n}\n\n.btn-gray-900 {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #273136;\n  --bs-btn-border-color: #273136;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #212a2e;\n  --bs-btn-hover-border-color: #1f272b;\n  --bs-btn-focus-shadow-rgb: 71, 80, 84;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #1f272b;\n  --bs-btn-active-border-color: #1d2529;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #273136;\n  --bs-btn-disabled-border-color: #273136;\n}\n\n.btn-outline-default {\n  --bs-btn-color: #798e98;\n  --bs-btn-border-color: #798e98;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #798e98;\n  --bs-btn-hover-border-color: #798e98;\n  --bs-btn-focus-shadow-rgb: 121, 142, 152;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #798e98;\n  --bs-btn-active-border-color: #798e98;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #798e98;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #798e98;\n  --bs-gradient: none;\n}\n\n.btn-outline-theme {\n  --bs-btn-color: #249d79;\n  --bs-btn-border-color: #249d79;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #249d79;\n  --bs-btn-hover-border-color: #249d79;\n  --bs-btn-focus-shadow-rgb: 36, 157, 121;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #249d79;\n  --bs-btn-active-border-color: #249d79;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #249d79;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #249d79;\n  --bs-gradient: none;\n}\n\n.btn-outline-theme-color {\n  --bs-btn-color: #ffffff;\n  --bs-btn-border-color: #ffffff;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffffff;\n  --bs-btn-hover-border-color: #ffffff;\n  --bs-btn-focus-shadow-rgb: 255, 255, 255;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffffff;\n  --bs-btn-active-border-color: #ffffff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffffff;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #0271ff;\n  --bs-btn-border-color: #0271ff;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #0271ff;\n  --bs-btn-hover-border-color: #0271ff;\n  --bs-btn-focus-shadow-rgb: 2, 113, 255;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #0271ff;\n  --bs-btn-active-border-color: #0271ff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0271ff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0271ff;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #798e98;\n  --bs-btn-border-color: #798e98;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #798e98;\n  --bs-btn-hover-border-color: #798e98;\n  --bs-btn-focus-shadow-rgb: 121, 142, 152;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #798e98;\n  --bs-btn-active-border-color: #798e98;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #798e98;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #798e98;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ff9f0c;\n  --bs-btn-border-color: #ff9f0c;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ff9f0c;\n  --bs-btn-hover-border-color: #ff9f0c;\n  --bs-btn-focus-shadow-rgb: 255, 159, 12;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ff9f0c;\n  --bs-btn-active-border-color: #ff9f0c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ff9f0c;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ff9f0c;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #e00000;\n  --bs-btn-border-color: #e00000;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #e00000;\n  --bs-btn-hover-border-color: #e00000;\n  --bs-btn-focus-shadow-rgb: 224, 0, 0;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #e00000;\n  --bs-btn-active-border-color: #e00000;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #e00000;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #e00000;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #249d79;\n  --bs-btn-border-color: #249d79;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #249d79;\n  --bs-btn-hover-border-color: #249d79;\n  --bs-btn-focus-shadow-rgb: 36, 157, 121;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #249d79;\n  --bs-btn-active-border-color: #249d79;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #249d79;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #249d79;\n  --bs-gradient: none;\n}\n\n.btn-outline-inverse {\n  --bs-btn-color: #000000;\n  --bs-btn-border-color: #000000;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #000000;\n  --bs-btn-hover-border-color: #000000;\n  --bs-btn-focus-shadow-rgb: 0, 0, 0;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #000000;\n  --bs-btn-active-border-color: #000000;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #000000;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #009be3;\n  --bs-btn-border-color: #009be3;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #009be3;\n  --bs-btn-hover-border-color: #009be3;\n  --bs-btn-focus-shadow-rgb: 0, 155, 227;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #009be3;\n  --bs-btn-active-border-color: #009be3;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #009be3;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #009be3;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #35434a;\n  --bs-btn-border-color: #35434a;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #35434a;\n  --bs-btn-hover-border-color: #35434a;\n  --bs-btn-focus-shadow-rgb: 53, 67, 74;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #35434a;\n  --bs-btn-active-border-color: #35434a;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #35434a;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #35434a;\n  --bs-gradient: none;\n}\n\n.btn-outline-black {\n  --bs-btn-color: #000000;\n  --bs-btn-border-color: #000000;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #000000;\n  --bs-btn-hover-border-color: #000000;\n  --bs-btn-focus-shadow-rgb: 0, 0, 0;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #000000;\n  --bs-btn-active-border-color: #000000;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #000000;\n  --bs-gradient: none;\n}\n\n.btn-outline-white {\n  --bs-btn-color: #ffffff;\n  --bs-btn-border-color: #ffffff;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffffff;\n  --bs-btn-hover-border-color: #ffffff;\n  --bs-btn-focus-shadow-rgb: 255, 255, 255;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffffff;\n  --bs-btn-active-border-color: #ffffff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffffff;\n  --bs-gradient: none;\n}\n\n.btn-outline-purple {\n  --bs-btn-color: #b90dff;\n  --bs-btn-border-color: #b90dff;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #b90dff;\n  --bs-btn-hover-border-color: #b90dff;\n  --bs-btn-focus-shadow-rgb: 185, 13, 255;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #b90dff;\n  --bs-btn-active-border-color: #b90dff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #b90dff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #b90dff;\n  --bs-gradient: none;\n}\n\n.btn-outline-indigo {\n  --bs-btn-color: #5c25ff;\n  --bs-btn-border-color: #5c25ff;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #5c25ff;\n  --bs-btn-hover-border-color: #5c25ff;\n  --bs-btn-focus-shadow-rgb: 92, 37, 255;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #5c25ff;\n  --bs-btn-active-border-color: #5c25ff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #5c25ff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #5c25ff;\n  --bs-gradient: none;\n}\n\n.btn-outline-red {\n  --bs-btn-color: #e00000;\n  --bs-btn-border-color: #e00000;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #e00000;\n  --bs-btn-hover-border-color: #e00000;\n  --bs-btn-focus-shadow-rgb: 224, 0, 0;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #e00000;\n  --bs-btn-active-border-color: #e00000;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #e00000;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #e00000;\n  --bs-gradient: none;\n}\n\n.btn-outline-pink {\n  --bs-btn-color: #e61079;\n  --bs-btn-border-color: #e61079;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #e61079;\n  --bs-btn-hover-border-color: #e61079;\n  --bs-btn-focus-shadow-rgb: 230, 16, 121;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #e61079;\n  --bs-btn-active-border-color: #e61079;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #e61079;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #e61079;\n  --bs-gradient: none;\n}\n\n.btn-outline-green {\n  --bs-btn-color: #148922;\n  --bs-btn-border-color: #148922;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #148922;\n  --bs-btn-hover-border-color: #148922;\n  --bs-btn-focus-shadow-rgb: 20, 137, 34;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #148922;\n  --bs-btn-active-border-color: #148922;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #148922;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #148922;\n  --bs-gradient: none;\n}\n\n.btn-outline-yellow {\n  --bs-btn-color: #f9e80d;\n  --bs-btn-border-color: #f9e80d;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #f9e80d;\n  --bs-btn-hover-border-color: #f9e80d;\n  --bs-btn-focus-shadow-rgb: 249, 232, 13;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #f9e80d;\n  --bs-btn-active-border-color: #f9e80d;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f9e80d;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f9e80d;\n  --bs-gradient: none;\n}\n\n.btn-outline-teal {\n  --bs-btn-color: #249d79;\n  --bs-btn-border-color: #249d79;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #249d79;\n  --bs-btn-hover-border-color: #249d79;\n  --bs-btn-focus-shadow-rgb: 36, 157, 121;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #249d79;\n  --bs-btn-active-border-color: #249d79;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #249d79;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #249d79;\n  --bs-gradient: none;\n}\n\n.btn-outline-muted {\n  --bs-btn-color: #617a86;\n  --bs-btn-border-color: #617a86;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #617a86;\n  --bs-btn-hover-border-color: #617a86;\n  --bs-btn-focus-shadow-rgb: 97, 122, 134;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #617a86;\n  --bs-btn-active-border-color: #617a86;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #617a86;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #617a86;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #c0cacf;\n  --bs-btn-border-color: #c0cacf;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #c0cacf;\n  --bs-btn-hover-border-color: #c0cacf;\n  --bs-btn-focus-shadow-rgb: 192, 202, 207;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #c0cacf;\n  --bs-btn-active-border-color: #c0cacf;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #c0cacf;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #c0cacf;\n  --bs-gradient: none;\n}\n\n.btn-outline-lime {\n  --bs-btn-color: #50b00a;\n  --bs-btn-border-color: #50b00a;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #50b00a;\n  --bs-btn-hover-border-color: #50b00a;\n  --bs-btn-focus-shadow-rgb: 80, 176, 10;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #50b00a;\n  --bs-btn-active-border-color: #50b00a;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #50b00a;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #50b00a;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-100 {\n  --bs-btn-color: #c0cacf;\n  --bs-btn-border-color: #c0cacf;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #c0cacf;\n  --bs-btn-hover-border-color: #c0cacf;\n  --bs-btn-focus-shadow-rgb: 192, 202, 207;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #c0cacf;\n  --bs-btn-active-border-color: #c0cacf;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #c0cacf;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #c0cacf;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-200 {\n  --bs-btn-color: #a8b6bc;\n  --bs-btn-border-color: #a8b6bc;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #a8b6bc;\n  --bs-btn-hover-border-color: #a8b6bc;\n  --bs-btn-focus-shadow-rgb: 168, 182, 188;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #a8b6bc;\n  --bs-btn-active-border-color: #a8b6bc;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #a8b6bc;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #a8b6bc;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-300 {\n  --bs-btn-color: #90a2aa;\n  --bs-btn-border-color: #90a2aa;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #90a2aa;\n  --bs-btn-hover-border-color: #90a2aa;\n  --bs-btn-focus-shadow-rgb: 144, 162, 170;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #90a2aa;\n  --bs-btn-active-border-color: #90a2aa;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #90a2aa;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #90a2aa;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-400 {\n  --bs-btn-color: #798e98;\n  --bs-btn-border-color: #798e98;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #798e98;\n  --bs-btn-hover-border-color: #798e98;\n  --bs-btn-focus-shadow-rgb: 121, 142, 152;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #798e98;\n  --bs-btn-active-border-color: #798e98;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #798e98;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #798e98;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-500 {\n  --bs-btn-color: #617a86;\n  --bs-btn-border-color: #617a86;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #617a86;\n  --bs-btn-hover-border-color: #617a86;\n  --bs-btn-focus-shadow-rgb: 97, 122, 134;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #617a86;\n  --bs-btn-active-border-color: #617a86;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #617a86;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #617a86;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-600 {\n  --bs-btn-color: #526872;\n  --bs-btn-border-color: #526872;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #526872;\n  --bs-btn-hover-border-color: #526872;\n  --bs-btn-focus-shadow-rgb: 82, 104, 114;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #526872;\n  --bs-btn-active-border-color: #526872;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #526872;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #526872;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-700 {\n  --bs-btn-color: #44555e;\n  --bs-btn-border-color: #44555e;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #44555e;\n  --bs-btn-hover-border-color: #44555e;\n  --bs-btn-focus-shadow-rgb: 68, 85, 94;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #44555e;\n  --bs-btn-active-border-color: #44555e;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #44555e;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #44555e;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-800 {\n  --bs-btn-color: #35434a;\n  --bs-btn-border-color: #35434a;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #35434a;\n  --bs-btn-hover-border-color: #35434a;\n  --bs-btn-focus-shadow-rgb: 53, 67, 74;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #35434a;\n  --bs-btn-active-border-color: #35434a;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #35434a;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #35434a;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-900 {\n  --bs-btn-color: #273136;\n  --bs-btn-border-color: #273136;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #273136;\n  --bs-btn-hover-border-color: #273136;\n  --bs-btn-focus-shadow-rgb: 39, 49, 54;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #273136;\n  --bs-btn-active-border-color: #273136;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #273136;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #273136;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #526872;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 69, 172, 141;\n  text-decoration: underline;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-border-radius: 8px;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.25rem;\n  --bs-btn-padding-x: 0.5rem;\n  --bs-btn-font-size: 0.8125rem;\n  --bs-btn-border-radius: 2px;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 0.875rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: rgba(var(--bs-body-bg-rgb), 0.98);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: 0;\n  --bs-dropdown-border-width: var(--bs-border-width);\n  --bs-dropdown-inner-border-radius: calc(0 - var(--bs-border-width));\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n  --bs-dropdown-link-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-bg: rgba(var(--bs-body-color-rgb), 0.15);\n  --bs-dropdown-link-active-color: #ffffff;\n  --bs-dropdown-link-active-bg: #249d79;\n  --bs-dropdown-link-disabled-color: #617a86;\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.375rem;\n  --bs-dropdown-header-color: rgba(var(--bs-body-color-rgb), 0.5);\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1660px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1921px) {\n  .dropdown-menu-xxxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.8125rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #90a2aa;\n  --bs-dropdown-bg: #35434a;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #90a2aa;\n  --bs-dropdown-link-hover-color: #ffffff;\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #ffffff;\n  --bs-dropdown-link-active-bg: #249d79;\n  --bs-dropdown-link-disabled-color: #617a86;\n  --bs-dropdown-header-color: #617a86;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: 4px;\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(var(--bs-border-width) * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  text-decoration: none;\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(2, 113, 255, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: var(--bs-border-color);\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-inverse);\n  --bs-nav-tabs-link-active-bg: transparent;\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) transparent;\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: 4px;\n  --bs-nav-pills-link-active-color: #ffffff;\n  --bs-nav-pills-link-active-bg: #249d79;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 600;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-inverse-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-inverse-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-inverse-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-inverse-rgb), 1);\n  --bs-navbar-brand-padding-y: 0.40625rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1rem;\n  --bs-navbar-brand-color: rgba(var(--bs-inverse-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-inverse-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-inverse-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: 4px;\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  text-decoration: none;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1660px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1921px) {\n  .navbar-expand-xxxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #ffffff;\n  --bs-navbar-brand-color: #ffffff;\n  --bs-navbar-brand-hover-color: #ffffff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: var(--bs-border-width);\n  --bs-card-border-color: var(--bs-border-color-translucent);\n  --bs-card-border-radius: var(--bs-border-radius);\n  --bs-card-box-shadow: ;\n  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: transparent;\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 10px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--bs-body-color);\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: var(--bs-border-radius);\n  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-border-color: rgba(var(--bs-inverse-rgb), 0.5);\n  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: var(--bs-inverse);\n  --bs-accordion-active-bg: rgba(var(--bs-theme-rgb), 0.15);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 0.875rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: var(--bs-accordion-btn-focus-border-color);\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-font-size: 85%;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 0.875rem;\n  --bs-pagination-color: var(--bs-inverse);\n  --bs-pagination-bg: transparent;\n  --bs-pagination-border-width: var(--bs-border-width);\n  --bs-pagination-border-color: var(--bs-border-color);\n  --bs-pagination-border-radius: var(--bs-border-radius);\n  --bs-pagination-hover-color: var(--bs-inverse);\n  --bs-pagination-hover-bg: rgba(var(--bs-inverse-rgb), 0.1);\n  --bs-pagination-hover-border-color: var(--bs-border-color);\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: var(--bs-secondary-bg);\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n  --bs-pagination-active-color: var(--bs-theme-color);\n  --bs-pagination-active-bg: var(--bs-theme);\n  --bs-pagination-active-border-color: var(--bs-theme);\n  --bs-pagination-disabled-color: rgba(var(--bs-inverse-rgb), 0.35);\n  --bs-pagination-disabled-bg: rgba(var(--bs-inverse-rgb), 0.1);\n  --bs-pagination-disabled-border-color: var(--bs-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-border-radius: 8px;\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.8125rem;\n  --bs-pagination-border-radius: 2px;\n}\n\n.badge {\n  --bs-badge-padding-x: 0.65em;\n  --bs-badge-padding-y: 0.35em;\n  --bs-badge-font-size: 0.75em;\n  --bs-badge-font-weight: 600;\n  --bs-badge-color: #ffffff;\n  --bs-badge-border-radius: 4px;\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: 4px;\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 600;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-default {\n  --bs-alert-color: var(--bs-default-text-emphasis);\n  --bs-alert-bg: var(--bs-default-bg-subtle);\n  --bs-alert-border-color: var(--bs-default-border-subtle);\n  --bs-alert-link-color: var(--bs-default-text-emphasis);\n}\n\n.alert-theme {\n  --bs-alert-color: var(--bs-theme-text-emphasis);\n  --bs-alert-bg: var(--bs-theme-bg-subtle);\n  --bs-alert-border-color: var(--bs-theme-border-subtle);\n  --bs-alert-link-color: var(--bs-theme-text-emphasis);\n}\n\n.alert-theme-color {\n  --bs-alert-color: var(--bs-theme-color-text-emphasis);\n  --bs-alert-bg: var(--bs-theme-color-bg-subtle);\n  --bs-alert-border-color: var(--bs-theme-color-border-subtle);\n  --bs-alert-link-color: var(--bs-theme-color-text-emphasis);\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-inverse {\n  --bs-alert-color: var(--bs-inverse-text-emphasis);\n  --bs-alert-bg: var(--bs-inverse-bg-subtle);\n  --bs-alert-border-color: var(--bs-inverse-border-subtle);\n  --bs-alert-link-color: var(--bs-inverse-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n.alert-black {\n  --bs-alert-color: var(--bs-black-text-emphasis);\n  --bs-alert-bg: var(--bs-black-bg-subtle);\n  --bs-alert-border-color: var(--bs-black-border-subtle);\n  --bs-alert-link-color: var(--bs-black-text-emphasis);\n}\n\n.alert-white {\n  --bs-alert-color: var(--bs-white-text-emphasis);\n  --bs-alert-bg: var(--bs-white-bg-subtle);\n  --bs-alert-border-color: var(--bs-white-border-subtle);\n  --bs-alert-link-color: var(--bs-white-text-emphasis);\n}\n\n.alert-purple {\n  --bs-alert-color: var(--bs-purple-text-emphasis);\n  --bs-alert-bg: var(--bs-purple-bg-subtle);\n  --bs-alert-border-color: var(--bs-purple-border-subtle);\n  --bs-alert-link-color: var(--bs-purple-text-emphasis);\n}\n\n.alert-indigo {\n  --bs-alert-color: var(--bs-indigo-text-emphasis);\n  --bs-alert-bg: var(--bs-indigo-bg-subtle);\n  --bs-alert-border-color: var(--bs-indigo-border-subtle);\n  --bs-alert-link-color: var(--bs-indigo-text-emphasis);\n}\n\n.alert-red {\n  --bs-alert-color: var(--bs-red-text-emphasis);\n  --bs-alert-bg: var(--bs-red-bg-subtle);\n  --bs-alert-border-color: var(--bs-red-border-subtle);\n  --bs-alert-link-color: var(--bs-red-text-emphasis);\n}\n\n.alert-pink {\n  --bs-alert-color: var(--bs-pink-text-emphasis);\n  --bs-alert-bg: var(--bs-pink-bg-subtle);\n  --bs-alert-border-color: var(--bs-pink-border-subtle);\n  --bs-alert-link-color: var(--bs-pink-text-emphasis);\n}\n\n.alert-green {\n  --bs-alert-color: var(--bs-green-text-emphasis);\n  --bs-alert-bg: var(--bs-green-bg-subtle);\n  --bs-alert-border-color: var(--bs-green-border-subtle);\n  --bs-alert-link-color: var(--bs-green-text-emphasis);\n}\n\n.alert-yellow {\n  --bs-alert-color: var(--bs-yellow-text-emphasis);\n  --bs-alert-bg: var(--bs-yellow-bg-subtle);\n  --bs-alert-border-color: var(--bs-yellow-border-subtle);\n  --bs-alert-link-color: var(--bs-yellow-text-emphasis);\n}\n\n.alert-teal {\n  --bs-alert-color: var(--bs-teal-text-emphasis);\n  --bs-alert-bg: var(--bs-teal-bg-subtle);\n  --bs-alert-border-color: var(--bs-teal-border-subtle);\n  --bs-alert-link-color: var(--bs-teal-text-emphasis);\n}\n\n.alert-muted {\n  --bs-alert-color: var(--bs-muted-text-emphasis);\n  --bs-alert-bg: var(--bs-muted-bg-subtle);\n  --bs-alert-border-color: var(--bs-muted-border-subtle);\n  --bs-alert-link-color: var(--bs-muted-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-lime {\n  --bs-alert-color: var(--bs-lime-text-emphasis);\n  --bs-alert-bg: var(--bs-lime-bg-subtle);\n  --bs-alert-border-color: var(--bs-lime-border-subtle);\n  --bs-alert-link-color: var(--bs-lime-text-emphasis);\n}\n\n.alert-gray-100 {\n  --bs-alert-color: var(--bs-gray-100-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-100-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-100-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-100-text-emphasis);\n}\n\n.alert-gray-200 {\n  --bs-alert-color: var(--bs-gray-200-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-200-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-200-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-200-text-emphasis);\n}\n\n.alert-gray-300 {\n  --bs-alert-color: var(--bs-gray-300-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-300-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-300-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-300-text-emphasis);\n}\n\n.alert-gray-400 {\n  --bs-alert-color: var(--bs-gray-400-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-400-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-400-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-400-text-emphasis);\n}\n\n.alert-gray-500 {\n  --bs-alert-color: var(--bs-gray-500-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-500-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-500-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-500-text-emphasis);\n}\n\n.alert-gray-600 {\n  --bs-alert-color: var(--bs-gray-600-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-600-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-600-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-600-text-emphasis);\n}\n\n.alert-gray-700 {\n  --bs-alert-color: var(--bs-gray-700-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-700-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-700-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-700-text-emphasis);\n}\n\n.alert-gray-800 {\n  --bs-alert-color: var(--bs-gray-800-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-800-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-800-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-800-text-emphasis);\n}\n\n.alert-gray-900 {\n  --bs-alert-color: var(--bs-gray-900-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-900-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-900-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-900-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.65625rem;\n  --bs-progress-bg: rgba(var(--bs-inverse-rgb), 0.15);\n  --bs-progress-border-radius: var(--bs-border-radius);\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #ffffff;\n  --bs-progress-bar-bg: #0271ff;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-body-color);\n  --bs-list-group-bg: transparent;\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-inverse);\n  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: transparent;\n  --bs-list-group-active-color: #ffffff;\n  --bs-list-group-active-bg: #249d79;\n  --bs-list-group-active-border-color: #249d79;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1660px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1921px) {\n  .list-group-horizontal-xxxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-default {\n  --bs-list-group-color: var(--bs-default-text-emphasis);\n  --bs-list-group-bg: var(--bs-default-bg-subtle);\n  --bs-list-group-border-color: var(--bs-default-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-default-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-default-border-subtle);\n  --bs-list-group-active-color: var(--bs-default-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-default-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-default-text-emphasis);\n}\n\n.list-group-item-theme {\n  --bs-list-group-color: var(--bs-theme-text-emphasis);\n  --bs-list-group-bg: var(--bs-theme-bg-subtle);\n  --bs-list-group-border-color: var(--bs-theme-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-theme-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-theme-border-subtle);\n  --bs-list-group-active-color: var(--bs-theme-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-theme-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-theme-text-emphasis);\n}\n\n.list-group-item-theme-color {\n  --bs-list-group-color: var(--bs-theme-color-text-emphasis);\n  --bs-list-group-bg: var(--bs-theme-color-bg-subtle);\n  --bs-list-group-border-color: var(--bs-theme-color-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-theme-color-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-theme-color-border-subtle);\n  --bs-list-group-active-color: var(--bs-theme-color-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-theme-color-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-theme-color-text-emphasis);\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-inverse {\n  --bs-list-group-color: var(--bs-inverse-text-emphasis);\n  --bs-list-group-bg: var(--bs-inverse-bg-subtle);\n  --bs-list-group-border-color: var(--bs-inverse-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-inverse-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-inverse-border-subtle);\n  --bs-list-group-active-color: var(--bs-inverse-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-inverse-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-inverse-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.list-group-item-black {\n  --bs-list-group-color: var(--bs-black-text-emphasis);\n  --bs-list-group-bg: var(--bs-black-bg-subtle);\n  --bs-list-group-border-color: var(--bs-black-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-black-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-black-border-subtle);\n  --bs-list-group-active-color: var(--bs-black-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-black-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-black-text-emphasis);\n}\n\n.list-group-item-white {\n  --bs-list-group-color: var(--bs-white-text-emphasis);\n  --bs-list-group-bg: var(--bs-white-bg-subtle);\n  --bs-list-group-border-color: var(--bs-white-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-white-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-white-border-subtle);\n  --bs-list-group-active-color: var(--bs-white-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-white-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-white-text-emphasis);\n}\n\n.list-group-item-purple {\n  --bs-list-group-color: var(--bs-purple-text-emphasis);\n  --bs-list-group-bg: var(--bs-purple-bg-subtle);\n  --bs-list-group-border-color: var(--bs-purple-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-purple-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-purple-border-subtle);\n  --bs-list-group-active-color: var(--bs-purple-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-purple-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-purple-text-emphasis);\n}\n\n.list-group-item-indigo {\n  --bs-list-group-color: var(--bs-indigo-text-emphasis);\n  --bs-list-group-bg: var(--bs-indigo-bg-subtle);\n  --bs-list-group-border-color: var(--bs-indigo-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-indigo-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-indigo-border-subtle);\n  --bs-list-group-active-color: var(--bs-indigo-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-indigo-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-indigo-text-emphasis);\n}\n\n.list-group-item-red {\n  --bs-list-group-color: var(--bs-red-text-emphasis);\n  --bs-list-group-bg: var(--bs-red-bg-subtle);\n  --bs-list-group-border-color: var(--bs-red-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-red-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-red-border-subtle);\n  --bs-list-group-active-color: var(--bs-red-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-red-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-red-text-emphasis);\n}\n\n.list-group-item-pink {\n  --bs-list-group-color: var(--bs-pink-text-emphasis);\n  --bs-list-group-bg: var(--bs-pink-bg-subtle);\n  --bs-list-group-border-color: var(--bs-pink-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-pink-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-pink-border-subtle);\n  --bs-list-group-active-color: var(--bs-pink-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-pink-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-pink-text-emphasis);\n}\n\n.list-group-item-green {\n  --bs-list-group-color: var(--bs-green-text-emphasis);\n  --bs-list-group-bg: var(--bs-green-bg-subtle);\n  --bs-list-group-border-color: var(--bs-green-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-green-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-green-border-subtle);\n  --bs-list-group-active-color: var(--bs-green-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-green-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-green-text-emphasis);\n}\n\n.list-group-item-yellow {\n  --bs-list-group-color: var(--bs-yellow-text-emphasis);\n  --bs-list-group-bg: var(--bs-yellow-bg-subtle);\n  --bs-list-group-border-color: var(--bs-yellow-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-yellow-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-yellow-border-subtle);\n  --bs-list-group-active-color: var(--bs-yellow-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-yellow-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-yellow-text-emphasis);\n}\n\n.list-group-item-teal {\n  --bs-list-group-color: var(--bs-teal-text-emphasis);\n  --bs-list-group-bg: var(--bs-teal-bg-subtle);\n  --bs-list-group-border-color: var(--bs-teal-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-teal-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-teal-border-subtle);\n  --bs-list-group-active-color: var(--bs-teal-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-teal-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-teal-text-emphasis);\n}\n\n.list-group-item-muted {\n  --bs-list-group-color: var(--bs-muted-text-emphasis);\n  --bs-list-group-bg: var(--bs-muted-bg-subtle);\n  --bs-list-group-border-color: var(--bs-muted-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-muted-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-muted-border-subtle);\n  --bs-list-group-active-color: var(--bs-muted-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-muted-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-muted-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-lime {\n  --bs-list-group-color: var(--bs-lime-text-emphasis);\n  --bs-list-group-bg: var(--bs-lime-bg-subtle);\n  --bs-list-group-border-color: var(--bs-lime-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-lime-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-lime-border-subtle);\n  --bs-list-group-active-color: var(--bs-lime-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-lime-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-lime-text-emphasis);\n}\n\n.list-group-item-gray-100 {\n  --bs-list-group-color: var(--bs-gray-100-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-100-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-100-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-100-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-100-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-100-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-100-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-100-text-emphasis);\n}\n\n.list-group-item-gray-200 {\n  --bs-list-group-color: var(--bs-gray-200-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-200-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-200-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-200-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-200-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-200-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-200-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-200-text-emphasis);\n}\n\n.list-group-item-gray-300 {\n  --bs-list-group-color: var(--bs-gray-300-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-300-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-300-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-300-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-300-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-300-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-300-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-300-text-emphasis);\n}\n\n.list-group-item-gray-400 {\n  --bs-list-group-color: var(--bs-gray-400-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-400-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-400-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-400-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-400-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-400-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-400-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-400-text-emphasis);\n}\n\n.list-group-item-gray-500 {\n  --bs-list-group-color: var(--bs-gray-500-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-500-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-500-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-500-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-500-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-500-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-500-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-500-text-emphasis);\n}\n\n.list-group-item-gray-600 {\n  --bs-list-group-color: var(--bs-gray-600-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-600-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-600-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-600-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-600-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-600-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-600-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-600-text-emphasis);\n}\n\n.list-group-item-gray-700 {\n  --bs-list-group-color: var(--bs-gray-700-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-700-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-700-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-700-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-700-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-700-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-700-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-700-text-emphasis);\n}\n\n.list-group-item-gray-800 {\n  --bs-list-group-color: var(--bs-gray-800-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-800-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-800-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-800-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-800-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-800-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-800-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-800-text-emphasis);\n}\n\n.list-group-item-gray-900 {\n  --bs-list-group-color: var(--bs-gray-900-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-900-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-900-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-900-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-900-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-900-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-900-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-900-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 4px;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 20px;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-secondary-color);\n  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-header-border-color: var(--bs-border-color-translucent);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: var(--bs-app-header-bg);\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: var(--bs-border-width);\n  --bs-modal-border-radius: 0;\n  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(var(--bs-inverse-rgb), 0.035);\n  --bs-modal-inner-border-radius: 0;\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: var(--bs-border-width);\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: var(--bs-border-width);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #e6e6e6;\n  --bs-backdrop-opacity: 0.95;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1659.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1920.98px) {\n  .modal-fullscreen-xxxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxxl-down .modal-header,\n  .modal-fullscreen-xxxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1130;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 0.5rem;\n  --bs-tooltip-padding-y: 0.25rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.8125rem;\n  --bs-tooltip-color: var(--bs-body-bg);\n  --bs-tooltip-bg: var(--bs-inverse);\n  --bs-tooltip-border-radius: var(--bs-border-radius);\n  --bs-tooltip-opacity: 0.9;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: \"Chakra Petch\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.8125rem;\n  --bs-popover-bg: var(--bs-body-bg);\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: var(--bs-border-radius-lg);\n  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));\n  --bs-popover-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 0.875rem;\n  --bs-popover-header-color: #000000;\n  --bs-popover-header-bg: var(--bs-secondary-bg);\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: var(--bs-body-color);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: \"Chakra Petch\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #ffffff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #ffffff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #ffffff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000000;\n}\n.carousel-dark .carousel-caption {\n  color: #000000;\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,\n[data-bs-theme=dark].carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {\n  background-color: #000000;\n}\n[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {\n  color: #000000;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxxl, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: var(--bs-border-width);\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(var(--bs-inverse-rgb), 0.035);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1659.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1659.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1659.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1660px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1920.98px) {\n  .offcanvas-xxxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1920.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxxl {\n    transition: none;\n  }\n}\n@media (max-width: 1920.98px) {\n  .offcanvas-xxxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxxl.showing, .offcanvas-xxxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxxl.showing, .offcanvas-xxxl.hiding, .offcanvas-xxxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1921px) {\n  .offcanvas-xxxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #e6e6e6;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.95;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-default {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-default-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-theme {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-theme-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-theme-color {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-theme-color-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-inverse {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-inverse-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-black {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-black-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-white {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-white-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-purple {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-purple-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-indigo {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-indigo-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-red {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-red-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-pink {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-pink-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-green {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-green-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-yellow {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-yellow-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-teal {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-teal-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-muted {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-muted-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-lime {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-lime-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-100 {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-gray-100-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-200 {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-gray-200-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-300 {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-gray-300-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-400 {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-gray-400-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-500 {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-gray-500-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-600 {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-gray-600-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-700 {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-gray-700-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-800 {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-gray-800-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-900 {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-gray-900-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-default {\n  color: RGBA(var(--bs-default-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-default-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-default:hover, .link-default:focus {\n  color: RGBA(97, 114, 122, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(97, 114, 122, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-theme {\n  color: RGBA(var(--bs-theme-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-theme-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-theme:hover, .link-theme:focus {\n  color: RGBA(29, 126, 97, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(29, 126, 97, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-theme-color {\n  color: RGBA(var(--bs-theme-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-theme-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-theme-color:hover, .link-theme-color:focus {\n  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(2, 90, 204, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(2, 90, 204, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(97, 114, 122, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(97, 114, 122, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 178, 61, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 178, 61, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(179, 0, 0, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(179, 0, 0, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(29, 126, 97, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(29, 126, 97, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-inverse {\n  color: RGBA(var(--bs-inverse-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-inverse-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-inverse:hover, .link-inverse:focus {\n  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(0, 124, 182, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(0, 124, 182, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(42, 54, 59, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(42, 54, 59, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-black {\n  color: RGBA(var(--bs-black-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-black-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-black:hover, .link-black:focus {\n  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-white {\n  color: RGBA(var(--bs-white-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-white-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-white:hover, .link-white:focus {\n  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-purple {\n  color: RGBA(var(--bs-purple-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-purple-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-purple:hover, .link-purple:focus {\n  color: RGBA(148, 10, 204, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(148, 10, 204, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-indigo {\n  color: RGBA(var(--bs-indigo-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-indigo-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-indigo:hover, .link-indigo:focus {\n  color: RGBA(74, 30, 204, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(74, 30, 204, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-red {\n  color: RGBA(var(--bs-red-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-red-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-red:hover, .link-red:focus {\n  color: RGBA(179, 0, 0, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(179, 0, 0, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-pink {\n  color: RGBA(var(--bs-pink-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-pink-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-pink:hover, .link-pink:focus {\n  color: RGBA(184, 13, 97, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(184, 13, 97, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-green {\n  color: RGBA(var(--bs-green-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-green-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-green:hover, .link-green:focus {\n  color: RGBA(16, 110, 27, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(16, 110, 27, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-yellow {\n  color: RGBA(var(--bs-yellow-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-yellow-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-yellow:hover, .link-yellow:focus {\n  color: RGBA(250, 237, 61, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(250, 237, 61, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-teal {\n  color: RGBA(var(--bs-teal-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-teal-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-teal:hover, .link-teal:focus {\n  color: RGBA(29, 126, 97, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(29, 126, 97, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-muted {\n  color: RGBA(var(--bs-muted-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-muted-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-muted:hover, .link-muted:focus {\n  color: RGBA(78, 98, 107, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(78, 98, 107, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(205, 213, 217, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(205, 213, 217, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-lime {\n  color: RGBA(var(--bs-lime-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-lime-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-lime:hover, .link-lime:focus {\n  color: RGBA(115, 192, 59, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(115, 192, 59, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-100 {\n  color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-gray-100:hover, .link-gray-100:focus {\n  color: RGBA(205, 213, 217, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(205, 213, 217, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-200 {\n  color: RGBA(var(--bs-gray-200-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-200-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-gray-200:hover, .link-gray-200:focus {\n  color: RGBA(185, 197, 201, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(185, 197, 201, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-300 {\n  color: RGBA(var(--bs-gray-300-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-300-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-gray-300:hover, .link-gray-300:focus {\n  color: RGBA(166, 181, 187, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(166, 181, 187, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-400 {\n  color: RGBA(var(--bs-gray-400-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-400-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-gray-400:hover, .link-gray-400:focus {\n  color: RGBA(97, 114, 122, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(97, 114, 122, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-500 {\n  color: RGBA(var(--bs-gray-500-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-500-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-gray-500:hover, .link-gray-500:focus {\n  color: RGBA(78, 98, 107, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(78, 98, 107, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-600 {\n  color: RGBA(var(--bs-gray-600-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-600-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-gray-600:hover, .link-gray-600:focus {\n  color: RGBA(66, 83, 91, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(66, 83, 91, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-700 {\n  color: RGBA(var(--bs-gray-700-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-700-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-gray-700:hover, .link-gray-700:focus {\n  color: RGBA(54, 68, 75, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(54, 68, 75, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-800 {\n  color: RGBA(var(--bs-gray-800-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-800-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-gray-800:hover, .link-gray-800:focus {\n  color: RGBA(42, 54, 59, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(42, 54, 59, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-900 {\n  color: RGBA(var(--bs-gray-900-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-900-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-gray-900:hover, .link-gray-900:focus {\n  color: RGBA(31, 39, 43, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(31, 39, 43, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1660px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1921px) {\n  .sticky-xxxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-default {\n  --bs-focus-ring-color: rgba(var(--bs-default-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-theme {\n  --bs-focus-ring-color: rgba(var(--bs-theme-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-theme-color {\n  --bs-focus-ring-color: rgba(var(--bs-theme-color-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-inverse {\n  --bs-focus-ring-color: rgba(var(--bs-inverse-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-black {\n  --bs-focus-ring-color: rgba(var(--bs-black-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-white {\n  --bs-focus-ring-color: rgba(var(--bs-white-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-purple {\n  --bs-focus-ring-color: rgba(var(--bs-purple-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-indigo {\n  --bs-focus-ring-color: rgba(var(--bs-indigo-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-red {\n  --bs-focus-ring-color: rgba(var(--bs-red-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-pink {\n  --bs-focus-ring-color: rgba(var(--bs-pink-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-green {\n  --bs-focus-ring-color: rgba(var(--bs-green-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-yellow {\n  --bs-focus-ring-color: rgba(var(--bs-yellow-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-teal {\n  --bs-focus-ring-color: rgba(var(--bs-teal-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-muted {\n  --bs-focus-ring-color: rgba(var(--bs-muted-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-lime {\n  --bs-focus-ring-color: rgba(var(--bs-lime-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-100 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-100-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-200 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-200-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-300 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-300-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-400 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-400-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-500 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-500-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-600 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-600-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-700 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-700-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-800 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-800-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-900 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-900-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-default {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-default-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-theme {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-theme-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-theme-color {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-theme-color-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-inverse {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-inverse-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-purple {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-purple-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-indigo {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-indigo-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-red {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-red-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-pink {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-pink-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-green {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-green-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-yellow {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-yellow-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-teal {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-teal-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-muted {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-muted-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-lime {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-lime-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-100 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-100-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-200 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-200-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-300 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-300-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-400 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-400-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-500 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-500-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-600 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-600-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-700 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-700-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-800 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-800-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-900 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-900-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -1rem !important;\n}\n\n.m-n4 {\n  margin: -1.5rem !important;\n}\n\n.m-n5 {\n  margin: -3rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.25rem !important;\n  margin-left: -0.25rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.5rem !important;\n  margin-left: -0.5rem !important;\n}\n\n.mx-n3 {\n  margin-right: -1rem !important;\n  margin-left: -1rem !important;\n}\n\n.mx-n4 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n5 {\n  margin-right: -3rem !important;\n  margin-left: -3rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.25rem !important;\n  margin-bottom: -0.25rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.5rem !important;\n  margin-bottom: -0.5rem !important;\n}\n\n.my-n3 {\n  margin-top: -1rem !important;\n  margin-bottom: -1rem !important;\n}\n\n.my-n4 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n5 {\n  margin-top: -3rem !important;\n  margin-bottom: -3rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mt-n3 {\n  margin-top: -1rem !important;\n}\n\n.mt-n4 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n5 {\n  margin-top: -3rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.me-n3 {\n  margin-right: -1rem !important;\n}\n\n.me-n4 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n5 {\n  margin-right: -3rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -1rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -3rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.ms-n3 {\n  margin-left: -1rem !important;\n}\n\n.ms-n4 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n5 {\n  margin-left: -3rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 3rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.34375rem + 1.125vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.278125rem + 0.3375vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.25625rem + 0.075vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.09375rem !important;\n}\n\n.fs-6 {\n  font-size: 0.875rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 500 !important;\n}\n\n.fw-bold {\n  font-weight: 600 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-default {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-default-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-theme {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-theme-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-theme-color {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-theme-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-inverse {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-inverse-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-purple {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-purple-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-indigo {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-indigo-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-red {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-red-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-pink {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-pink-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-green {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-green-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-yellow {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-yellow-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-teal {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-teal-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-lime {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-lime-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-100 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-100-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-200 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-200-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-300 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-300-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-400 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-400-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-500 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-500-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-600 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-600-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-700 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-700-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-800 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-800-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-900 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-900-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-default {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-default-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-theme {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-theme-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-theme-color {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-theme-color-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-inverse {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-inverse-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-black {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-black-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-white {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-white-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-purple {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-purple-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-indigo {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-indigo-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-red {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-red-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-pink {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-pink-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-green {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-green-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-yellow {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-yellow-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-teal {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-teal-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-muted {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-muted-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-lime {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-lime-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-100 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-200 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-200-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-300 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-300-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-400 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-400-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-500 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-500-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-600 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-600-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-700 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-700-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-800 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-800-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-900 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-900-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-default {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-default-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-theme {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-theme-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-theme-color {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-theme-color-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-inverse {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-inverse-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-purple-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-indigo {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-indigo-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-red {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-red-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-pink {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-pink-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-green {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-green-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-yellow {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-yellow-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-teal {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-teal-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-muted {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-muted-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-lime {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-lime-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-100-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-200-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-300-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-400-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-500 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-500-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-600-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-700-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-800-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-900-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-sm-n5 {\n    margin: -3rem !important;\n  }\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-sm-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-sm-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-sm-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-sm-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-sm-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-sm-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-sm-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-sm-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-sm-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-sm-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-sm-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-sm-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-sm-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-sm-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-sm-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-sm-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-sm-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 3rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-md-n3 {\n    margin: -1rem !important;\n  }\n  .m-md-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-md-n5 {\n    margin: -3rem !important;\n  }\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-md-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-md-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-md-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-md-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-md-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-md-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-md-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-md-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-md-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-md-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-md-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-md-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-md-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-md-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-md-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-md-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-md-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-md-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 3rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-lg-n5 {\n    margin: -3rem !important;\n  }\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-lg-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-lg-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-lg-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-lg-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-lg-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-lg-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-lg-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-lg-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-lg-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-lg-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-lg-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-lg-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-lg-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-lg-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-lg-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-lg-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-lg-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 3rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-xl-n5 {\n    margin: -3rem !important;\n  }\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xl-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xl-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xl-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xl-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xl-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-xl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xl-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xl-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-xl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xl-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xl-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xl-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-xl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xl-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1660px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .m-xxl-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-xxl-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-xxl-n3 {\n    margin: -1rem !important;\n  }\n  .m-xxl-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-xxl-n5 {\n    margin: -3rem !important;\n  }\n  .mx-xxl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xxl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xxl-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xxl-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xxl-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-xxl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xxl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xxl-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xxl-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xxl-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-xxl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xxl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xxl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-xxl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xxl-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-xxl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xxl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xxl-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-xxl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xxl-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xxl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xxl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xxl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xxl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xxl-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-xxl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xxl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xxl-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-xxl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xxl-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1921px) {\n  .float-xxxl-start {\n    float: left !important;\n  }\n  .float-xxxl-end {\n    float: right !important;\n  }\n  .float-xxxl-none {\n    float: none !important;\n  }\n  .object-fit-xxxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxxl-none {\n    object-fit: none !important;\n  }\n  .d-xxxl-inline {\n    display: inline !important;\n  }\n  .d-xxxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxxl-block {\n    display: block !important;\n  }\n  .d-xxxl-grid {\n    display: grid !important;\n  }\n  .d-xxxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxxl-table {\n    display: table !important;\n  }\n  .d-xxxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxxl-flex {\n    display: flex !important;\n  }\n  .d-xxxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxxl-none {\n    display: none !important;\n  }\n  .flex-xxxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxxl-first {\n    order: -1 !important;\n  }\n  .order-xxxl-0 {\n    order: 0 !important;\n  }\n  .order-xxxl-1 {\n    order: 1 !important;\n  }\n  .order-xxxl-2 {\n    order: 2 !important;\n  }\n  .order-xxxl-3 {\n    order: 3 !important;\n  }\n  .order-xxxl-4 {\n    order: 4 !important;\n  }\n  .order-xxxl-5 {\n    order: 5 !important;\n  }\n  .order-xxxl-last {\n    order: 6 !important;\n  }\n  .m-xxxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxxl-auto {\n    margin-left: auto !important;\n  }\n  .m-xxxl-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-xxxl-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-xxxl-n3 {\n    margin: -1rem !important;\n  }\n  .m-xxxl-n4 {\n    margin: -1.5rem !important;\n  }\n  .m-xxxl-n5 {\n    margin: -3rem !important;\n  }\n  .mx-xxxl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xxxl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xxxl-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xxxl-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xxxl-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .my-xxxl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xxxl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xxxl-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xxxl-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xxxl-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .mt-xxxl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xxxl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xxxl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mt-xxxl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xxxl-n5 {\n    margin-top: -3rem !important;\n  }\n  .me-xxxl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xxxl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xxxl-n3 {\n    margin-right: -1rem !important;\n  }\n  .me-xxxl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xxxl-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xxxl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xxxl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xxxl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xxxl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xxxl-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ms-xxxl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xxxl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xxxl-n3 {\n    margin-left: -1rem !important;\n  }\n  .ms-xxxl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xxxl-n5 {\n    margin-left: -3rem !important;\n  }\n  .p-xxxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxxl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xxxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxxl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xxxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxxl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxxl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxxl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xxxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxxl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxxl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxxl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxxl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxxl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xxxl-start {\n    text-align: left !important;\n  }\n  .text-xxxl-end {\n    text-align: right !important;\n  }\n  .text-xxxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.1875rem !important;\n  }\n  .fs-2 {\n    font-size: 1.75rem !important;\n  }\n  .fs-3 {\n    font-size: 1.53125rem !important;\n  }\n  .fs-4 {\n    font-size: 1.3125rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n[data-bs-theme=light] .border-white {\n  border-color: #000 !important;\n}\n[data-bs-theme=light] .text-white {\n  color: #000 !important;\n}\n[data-bs-theme=light] .border-black {\n  border-color: #fff !important;\n}\n[data-bs-theme=light] .text-black {\n  color: #fff !important;\n}\n[data-bs-theme=light] body .react-select__control,\n[data-bs-theme=light] .form-control,\n[data-bs-theme=light] .form-select {\n  background-color: #fff;\n}\n[data-bs-theme=light] body .react-select__control .react-select__value-container .react-select__input-container {\n  color: #000;\n}\n[data-bs-theme=light] .table {\n  background: #fff;\n}\n[data-bs-theme=light] .tree {\n  border-color: rgba(0, 0, 0, 0.3);\n}\n[data-bs-theme=light] .tree li a {\n  color: black;\n  border-color: rgba(0, 0, 0, 0.3);\n}\n[data-bs-theme=light] .disaster-page {\n  background: linear-gradient(180deg, #ff8d8d -190%, rgb(255, 255, 255) 90%) !important;\n}\n[data-bs-theme=light] .breaking-news a {\n  color: #000;\n}\n[data-bs-theme=light] .breaking-news a p {\n  background: rgba(0, 0, 0, 0.02);\n}\n[data-bs-theme=light] .map-info-container {\n  background: rgba(255, 255, 255, 0.9) !important;\n}\n[data-bs-theme=light] .graphic-events .graphic-events-dropdown {\n  background: white;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);\n}\n[data-bs-theme=light] .file-progress-card {\n  background: white;\n}\n[data-bs-theme=light] .popover-content {\n  background: white;\n}\n\n[data-bs-theme=dark] .ck-reset_all :not(.ck-reset_all-excluded *),\n[data-bs-theme=dark] .ck.ck-reset_all {\n  color: #fff !important;\n}\n\n:root,\n[data-bs-theme=light] {\n  --bs-body-bg-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.99) 100%);\n  --bs-body-bg-image: url(\"images/pattern.png\");\n  --bs-body-bg-image-size: 4.6875rem;\n  --bs-body-font-weight: 400;\n  --bs-body-letter-spacing: 0.046875rem;\n  --bs-component-bg: #ffffff;\n  --bs-component-bg-rgb: 255, 255, 255;\n  --bs-component-color: black;\n  --bs-component-color-rgb: 0, 0, 0;\n  --bs-app-header-bg: #ffffff;\n  --bs-app-header-brand-img: url(\"images/logo.png\");\n  --bs-app-header-link-color: #000000;\n  --bs-app-header-link-color-rgb: 0, 0, 0;\n  --bs-app-header-link-hover-color: #000000;\n  --bs-app-header-scroll-box-shadow: ;\n  --bs-app-sidebar-menu-header-color: rgba(var(--bs-inverse-rgb), 0.3);\n  --bs-app-sidebar-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);\n  --bs-app-sidebar-menu-link-hover-color: #000000;\n  --bs-app-sidebar-menu-link-active-color: #000000;\n  --bs-app-sidebar-mobile-bg: rgba(255, 255, 255, 0.98);\n  --bs-app-top-nav-bg: #ffffff;\n  --bs-app-top-nav-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);\n  --bs-app-top-nav-menu-link-hover-color: #000000;\n  --bs-app-top-nav-menu-link-active-color: #000000;\n  --bs-app-top-nav-menu-submenu-bg: #ffffff;\n  --bs-app-theme-panel-bg: rgba(255, 255, 255, 0.95);\n  --bs-theme-bg-subtle: #d3ebe4;\n  --bs-dark2: #dadada;\n  --bs-dark3: #f2f2f2;\n  --bs-dark4: #fefefe;\n  --bs-dark5: #65656596;\n}\n\n[data-bs-theme=dark] {\n  --bs-body-bg-gradient: linear-gradient(180deg, rgba(9, 56, 45, 0.9) 0%, rgb(0, 7, 23) 100%);\n  --bs-body-bg-image: url(\"images/pattern-dark.png\");\n  --bs-body-bg-image-size: 4.6875rem;\n  --bs-body-font-weight: 300;\n  --bs-body-letter-spacing: 0.046875rem;\n  --bs-component-bg: #28292b;\n  --bs-component-bg-rgb: 40, 41, 43;\n  --bs-component-color: white;\n  --bs-component-color-rgb: 255, 255, 255;\n  --bs-app-header-bg: rgba(29, 40, 53, 0.5);\n  --bs-app-header-brand-img: url(\"images/logo-dark.png\");\n  --bs-app-header-link-color: #ffffff;\n  --bs-app-header-link-color-rgb: 255, 255, 255;\n  --bs-app-header-link-hover-color: rgba(255, 255, 255, 0.5);\n  --bs-app-header-scroll-box-shadow: ;\n  --bs-app-sidebar-menu-header-color: rgba(var(--bs-inverse-rgb), 0.5);\n  --bs-app-sidebar-menu-link-color: rgba(var(--bs-inverse-rgb), 0.8);\n  --bs-app-sidebar-menu-link-hover-color: #ffffff;\n  --bs-app-sidebar-menu-link-active-color: #ffffff;\n  --bs-app-sidebar-mobile-bg: rgba(44, 56, 70, 0.98);\n  --bs-app-top-nav-bg: rgba(29, 40, 53, 0.95);\n  --bs-app-top-nav-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);\n  --bs-app-top-nav-menu-link-hover-color: #ffffff;\n  --bs-app-top-nav-menu-link-active-color: #ffffff;\n  --bs-app-top-nav-menu-submenu-bg: rgba(29, 40, 53, 0.95);\n  --bs-app-theme-panel-bg: rgba(68, 85, 94, 0.95);\n  --bs-theme-bg-subtle: #071f18;\n  --bs-dark2: #0f131f;\n  --bs-dark3: #1d2835;\n  --bs-dark4: #141b24;\n  --bs-dark5: #141b2496;\n}\n\nhtml {\n  height: 100%;\n}\n[data-bs-theme=light] .app {\n  background: #eee;\n}\n\n[data-bs-theme=dark] .app {\n  background: linear-gradient(180deg, var(--bs-theme) -190%, rgb(0, 7, 23) 90%);\n}\n\nbody {\n  background: none;\n  font-weight: var(--bs-body-font-weight);\n  letter-spacing: var(--bs-body-letter-spacing);\n  position: relative;\n  min-height: 100vh;\n  z-index: 9999;\n  overflow-x: hidden;\n}\nbody:before {\n  content: \"\";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  background-attachment: initial;\n  background-color: transparent;\n  background-size: var(--bs-body-bg-image-size);\n  background-repeat: repeat;\n  background-attachment: initial;\n  z-index: -5;\n}\nstrong {\n  font-weight: bold;\n}\n\n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar {\n  background: var(--bs-dark4) !important;\n  border-color: rgba(255, 255, 255, 0.25) !important;\n}\n\n.ck.ck-editor__main > .ck-editor__editable {\n  background: rgba(255, 255, 255, 0) !important;\n  min-height: 200px !important;\n}\n\n.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {\n  border-color: rgba(255, 255, 255, 0.25) !important;\n}\n\n.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {\n  border-color: #fff !important;\n}\n\n.ck.ck-button.ck-on,\na.ck.ck-button.ck-on {\n  color: #fff !important;\n  background: var(--bs-theme) !important;\n}\n\n.ck.ck-button.ck-on:not(.ck-disabled):hover,\na.ck.ck-button.ck-on:not(.ck-disabled):hover {\n  background: var(--bs-theme) !important;\n}\n\n.ck.ck-button:not(.ck-disabled):hover,\na.ck.ck-button:not(.ck-disabled):hover {\n  background: var(--bs-theme) !important;\n}\n\n.ck.ck-dropdown__panel,\n.ck.ck-list {\n  background: var(--bs-dark4) !important;\n}\n\n.ck.ck-list__item .ck-button:hover:not(.ck-disabled) {\n  background: var(--bs-theme) !important;\n}\n\n.ck.ck-list__item .ck-button.ck-on {\n  background: #1f9b76 !important;\n}\n\n.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled) {\n  background: var(--bs-theme) !important;\n}\n\n/* Helper Margin */\n.m-1px {\n  margin: 1px !important;\n}\n\n.m-2px {\n  margin: 2px !important;\n}\n\n.m-3px {\n  margin: 3px !important;\n}\n\n.m-4px {\n  margin: 4px !important;\n}\n\n.m-5px {\n  margin: 5px !important;\n}\n\n.m-6px {\n  margin: 6px !important;\n}\n\n.m-7px {\n  margin: 7px !important;\n}\n\n.m-8px {\n  margin: 8px !important;\n}\n\n.m-9px {\n  margin: 9px !important;\n}\n\n.m-10px {\n  margin: 10px !important;\n}\n\n.m-5px {\n  margin: 5px !important;\n}\n\n.m-10px {\n  margin: 10px !important;\n}\n\n.m-15px {\n  margin: 15px !important;\n}\n\n.m-20px {\n  margin: 20px !important;\n}\n\n.m-25px {\n  margin: 25px !important;\n}\n\n.m-30px {\n  margin: 30px !important;\n}\n\n.m-35px {\n  margin: 35px !important;\n}\n\n.m-40px {\n  margin: 40px !important;\n}\n\n.m-45px {\n  margin: 45px !important;\n}\n\n.m-50px {\n  margin: 50px !important;\n}\n\n.mt-1px {\n  margin-top: 1px !important;\n}\n\n.mt-2px {\n  margin-top: 2px !important;\n}\n\n.mt-3px {\n  margin-top: 3px !important;\n}\n\n.mt-4px {\n  margin-top: 4px !important;\n}\n\n.mt-5px {\n  margin-top: 5px !important;\n}\n\n.mt-6px {\n  margin-top: 6px !important;\n}\n\n.mt-7px {\n  margin-top: 7px !important;\n}\n\n.mt-8px {\n  margin-top: 8px !important;\n}\n\n.mt-9px {\n  margin-top: 9px !important;\n}\n\n.mt-10px {\n  margin-top: 10px !important;\n}\n\n.mt-5px {\n  margin-top: 5px !important;\n}\n\n.mt-10px {\n  margin-top: 10px !important;\n}\n\n.mt-15px {\n  margin-top: 15px !important;\n}\n\n.mt-20px {\n  margin-top: 20px !important;\n}\n\n.mt-25px {\n  margin-top: 25px !important;\n}\n\n.mt-30px {\n  margin-top: 30px !important;\n}\n\n.mt-35px {\n  margin-top: 35px !important;\n}\n\n.mt-40px {\n  margin-top: 40px !important;\n}\n\n.mt-45px {\n  margin-top: 45px !important;\n}\n\n.mt-50px {\n  margin-top: 50px !important;\n}\n\n.me-1px {\n  margin-right: 1px !important;\n}\n\n.me-2px {\n  margin-right: 2px !important;\n}\n\n.me-3px {\n  margin-right: 3px !important;\n}\n\n.me-4px {\n  margin-right: 4px !important;\n}\n\n.me-5px {\n  margin-right: 5px !important;\n}\n\n.me-6px {\n  margin-right: 6px !important;\n}\n\n.me-7px {\n  margin-right: 7px !important;\n}\n\n.me-8px {\n  margin-right: 8px !important;\n}\n\n.me-9px {\n  margin-right: 9px !important;\n}\n\n.me-10px {\n  margin-right: 10px !important;\n}\n\n.me-5px {\n  margin-right: 5px !important;\n}\n\n.me-10px {\n  margin-right: 10px !important;\n}\n\n.me-15px {\n  margin-right: 15px !important;\n}\n\n.me-20px {\n  margin-right: 20px !important;\n}\n\n.me-25px {\n  margin-right: 25px !important;\n}\n\n.me-30px {\n  margin-right: 30px !important;\n}\n\n.me-35px {\n  margin-right: 35px !important;\n}\n\n.me-40px {\n  margin-right: 40px !important;\n}\n\n.me-45px {\n  margin-right: 45px !important;\n}\n\n.me-50px {\n  margin-right: 50px !important;\n}\n\n.mb-1px {\n  margin-bottom: 1px !important;\n}\n\n.mb-2px {\n  margin-bottom: 2px !important;\n}\n\n.mb-3px {\n  margin-bottom: 3px !important;\n}\n\n.mb-4px {\n  margin-bottom: 4px !important;\n}\n\n.mb-5px {\n  margin-bottom: 5px !important;\n}\n\n.mb-6px {\n  margin-bottom: 6px !important;\n}\n\n.mb-7px {\n  margin-bottom: 7px !important;\n}\n\n.mb-8px {\n  margin-bottom: 8px !important;\n}\n\n.mb-9px {\n  margin-bottom: 9px !important;\n}\n\n.mb-10px {\n  margin-bottom: 10px !important;\n}\n\n.mb-5px {\n  margin-bottom: 5px !important;\n}\n\n.mb-10px {\n  margin-bottom: 10px !important;\n}\n\n.mb-15px {\n  margin-bottom: 15px !important;\n}\n\n.mb-20px {\n  margin-bottom: 20px !important;\n}\n\n.mb-25px {\n  margin-bottom: 25px !important;\n}\n\n.mb-30px {\n  margin-bottom: 30px !important;\n}\n\n.mb-35px {\n  margin-bottom: 35px !important;\n}\n\n.mb-40px {\n  margin-bottom: 40px !important;\n}\n\n.mb-45px {\n  margin-bottom: 45px !important;\n}\n\n.mb-50px {\n  margin-bottom: 50px !important;\n}\n\n.ms-1px {\n  margin-left: 1px !important;\n}\n\n.ms-2px {\n  margin-left: 2px !important;\n}\n\n.ms-3px {\n  margin-left: 3px !important;\n}\n\n.ms-4px {\n  margin-left: 4px !important;\n}\n\n.ms-5px {\n  margin-left: 5px !important;\n}\n\n.ms-6px {\n  margin-left: 6px !important;\n}\n\n.ms-7px {\n  margin-left: 7px !important;\n}\n\n.ms-8px {\n  margin-left: 8px !important;\n}\n\n.ms-9px {\n  margin-left: 9px !important;\n}\n\n.ms-10px {\n  margin-left: 10px !important;\n}\n\n.ms-5px {\n  margin-left: 5px !important;\n}\n\n.ms-10px {\n  margin-left: 10px !important;\n}\n\n.ms-15px {\n  margin-left: 15px !important;\n}\n\n.ms-20px {\n  margin-left: 20px !important;\n}\n\n.ms-25px {\n  margin-left: 25px !important;\n}\n\n.ms-30px {\n  margin-left: 30px !important;\n}\n\n.ms-35px {\n  margin-left: 35px !important;\n}\n\n.ms-40px {\n  margin-left: 40px !important;\n}\n\n.ms-45px {\n  margin-left: 45px !important;\n}\n\n.ms-50px {\n  margin-left: 50px !important;\n}\n\n.mx-1px {\n  margin-left: 1px !important;\n  margin-right: 1px !important;\n}\n\n.mx-2px {\n  margin-left: 2px !important;\n  margin-right: 2px !important;\n}\n\n.mx-3px {\n  margin-left: 3px !important;\n  margin-right: 3px !important;\n}\n\n.mx-4px {\n  margin-left: 4px !important;\n  margin-right: 4px !important;\n}\n\n.mx-5px {\n  margin-left: 5px !important;\n  margin-right: 5px !important;\n}\n\n.mx-6px {\n  margin-left: 6px !important;\n  margin-right: 6px !important;\n}\n\n.mx-7px {\n  margin-left: 7px !important;\n  margin-right: 7px !important;\n}\n\n.mx-8px {\n  margin-left: 8px !important;\n  margin-right: 8px !important;\n}\n\n.mx-9px {\n  margin-left: 9px !important;\n  margin-right: 9px !important;\n}\n\n.mx-10px {\n  margin-left: 10px !important;\n  margin-right: 10px !important;\n}\n\n.mx-5px {\n  margin-left: 5px !important;\n  margin-right: 5px !important;\n}\n\n.mx-10px {\n  margin-left: 10px !important;\n  margin-right: 10px !important;\n}\n\n.mx-15px {\n  margin-left: 15px !important;\n  margin-right: 15px !important;\n}\n\n.mx-20px {\n  margin-left: 20px !important;\n  margin-right: 20px !important;\n}\n\n.mx-25px {\n  margin-left: 25px !important;\n  margin-right: 25px !important;\n}\n\n.mx-30px {\n  margin-left: 30px !important;\n  margin-right: 30px !important;\n}\n\n.mx-35px {\n  margin-left: 35px !important;\n  margin-right: 35px !important;\n}\n\n.mx-40px {\n  margin-left: 40px !important;\n  margin-right: 40px !important;\n}\n\n.mx-45px {\n  margin-left: 45px !important;\n  margin-right: 45px !important;\n}\n\n.mx-50px {\n  margin-left: 50px !important;\n  margin-right: 50px !important;\n}\n\n.my-1px {\n  margin-top: 1px !important;\n  margin-bottom: 1px !important;\n}\n\n.my-2px {\n  margin-top: 2px !important;\n  margin-bottom: 2px !important;\n}\n\n.my-3px {\n  margin-top: 3px !important;\n  margin-bottom: 3px !important;\n}\n\n.my-4px {\n  margin-top: 4px !important;\n  margin-bottom: 4px !important;\n}\n\n.my-5px {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n}\n\n.my-6px {\n  margin-top: 6px !important;\n  margin-bottom: 6px !important;\n}\n\n.my-7px {\n  margin-top: 7px !important;\n  margin-bottom: 7px !important;\n}\n\n.my-8px {\n  margin-top: 8px !important;\n  margin-bottom: 8px !important;\n}\n\n.my-9px {\n  margin-top: 9px !important;\n  margin-bottom: 9px !important;\n}\n\n.my-10px {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n}\n\n.my-5px {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n}\n\n.my-10px {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n}\n\n.my-15px {\n  margin-top: 15px !important;\n  margin-bottom: 15px !important;\n}\n\n.my-20px {\n  margin-top: 20px !important;\n  margin-bottom: 20px !important;\n}\n\n.my-25px {\n  margin-top: 25px !important;\n  margin-bottom: 25px !important;\n}\n\n.my-30px {\n  margin-top: 30px !important;\n  margin-bottom: 30px !important;\n}\n\n.my-35px {\n  margin-top: 35px !important;\n  margin-bottom: 35px !important;\n}\n\n.my-40px {\n  margin-top: 40px !important;\n  margin-bottom: 40px !important;\n}\n\n.my-45px {\n  margin-top: 45px !important;\n  margin-bottom: 45px !important;\n}\n\n.my-50px {\n  margin-top: 50px !important;\n  margin-bottom: 50px !important;\n}\n\n/* Helper Padding */\n.p-1px {\n  padding: 1px !important;\n}\n\n.p-2px {\n  padding: 2px !important;\n}\n\n.p-3px {\n  padding: 3px !important;\n}\n\n.p-4px {\n  padding: 4px !important;\n}\n\n.p-5px {\n  padding: 5px !important;\n}\n\n.p-6px {\n  padding: 6px !important;\n}\n\n.p-7px {\n  padding: 7px !important;\n}\n\n.p-8px {\n  padding: 8px !important;\n}\n\n.p-9px {\n  padding: 9px !important;\n}\n\n.p-10px {\n  padding: 10px !important;\n}\n\n.p-5px {\n  padding: 5px !important;\n}\n\n.p-10px {\n  padding: 10px !important;\n}\n\n.p-15px {\n  padding: 15px !important;\n}\n\n.p-20px {\n  padding: 20px !important;\n}\n\n.p-25px {\n  padding: 25px !important;\n}\n\n.p-30px {\n  padding: 30px !important;\n}\n\n.p-35px {\n  padding: 35px !important;\n}\n\n.p-40px {\n  padding: 40px !important;\n}\n\n.p-45px {\n  padding: 45px !important;\n}\n\n.p-50px {\n  padding: 50px !important;\n}\n\n.pt-1px {\n  padding-top: 1px !important;\n}\n\n.pt-2px {\n  padding-top: 2px !important;\n}\n\n.pt-3px {\n  padding-top: 3px !important;\n}\n\n.pt-4px {\n  padding-top: 4px !important;\n}\n\n.pt-5px {\n  padding-top: 5px !important;\n}\n\n.pt-6px {\n  padding-top: 6px !important;\n}\n\n.pt-7px {\n  padding-top: 7px !important;\n}\n\n.pt-8px {\n  padding-top: 8px !important;\n}\n\n.pt-9px {\n  padding-top: 9px !important;\n}\n\n.pt-10px {\n  padding-top: 10px !important;\n}\n\n.pt-5px {\n  padding-top: 5px !important;\n}\n\n.pt-10px {\n  padding-top: 10px !important;\n}\n\n.pt-15px {\n  padding-top: 15px !important;\n}\n\n.pt-20px {\n  padding-top: 20px !important;\n}\n\n.pt-25px {\n  padding-top: 25px !important;\n}\n\n.pt-30px {\n  padding-top: 30px !important;\n}\n\n.pt-35px {\n  padding-top: 35px !important;\n}\n\n.pt-40px {\n  padding-top: 40px !important;\n}\n\n.pt-45px {\n  padding-top: 45px !important;\n}\n\n.pt-50px {\n  padding-top: 50px !important;\n}\n\n.pe-1px {\n  padding-right: 1px !important;\n}\n\n.pe-2px {\n  padding-right: 2px !important;\n}\n\n.pe-3px {\n  padding-right: 3px !important;\n}\n\n.pe-4px {\n  padding-right: 4px !important;\n}\n\n.pe-5px {\n  padding-right: 5px !important;\n}\n\n.pe-6px {\n  padding-right: 6px !important;\n}\n\n.pe-7px {\n  padding-right: 7px !important;\n}\n\n.pe-8px {\n  padding-right: 8px !important;\n}\n\n.pe-9px {\n  padding-right: 9px !important;\n}\n\n.pe-10px {\n  padding-right: 10px !important;\n}\n\n.pe-5px {\n  padding-right: 5px !important;\n}\n\n.pe-10px {\n  padding-right: 10px !important;\n}\n\n.pe-15px {\n  padding-right: 15px !important;\n}\n\n.pe-20px {\n  padding-right: 20px !important;\n}\n\n.pe-25px {\n  padding-right: 25px !important;\n}\n\n.pe-30px {\n  padding-right: 30px !important;\n}\n\n.pe-35px {\n  padding-right: 35px !important;\n}\n\n.pe-40px {\n  padding-right: 40px !important;\n}\n\n.pe-45px {\n  padding-right: 45px !important;\n}\n\n.pe-50px {\n  padding-right: 50px !important;\n}\n\n.pb-1px {\n  padding-bottom: 1px !important;\n}\n\n.pb-2px {\n  padding-bottom: 2px !important;\n}\n\n.pb-3px {\n  padding-bottom: 3px !important;\n}\n\n.pb-4px {\n  padding-bottom: 4px !important;\n}\n\n.pb-5px {\n  padding-bottom: 5px !important;\n}\n\n.pb-6px {\n  padding-bottom: 6px !important;\n}\n\n.pb-7px {\n  padding-bottom: 7px !important;\n}\n\n.pb-8px {\n  padding-bottom: 8px !important;\n}\n\n.pb-9px {\n  padding-bottom: 9px !important;\n}\n\n.pb-10px {\n  padding-bottom: 10px !important;\n}\n\n.pb-5px {\n  padding-bottom: 5px !important;\n}\n\n.pb-10px {\n  padding-bottom: 10px !important;\n}\n\n.pb-15px {\n  padding-bottom: 15px !important;\n}\n\n.pb-20px {\n  padding-bottom: 20px !important;\n}\n\n.pb-25px {\n  padding-bottom: 25px !important;\n}\n\n.pb-30px {\n  padding-bottom: 30px !important;\n}\n\n.pb-35px {\n  padding-bottom: 35px !important;\n}\n\n.pb-40px {\n  padding-bottom: 40px !important;\n}\n\n.pb-45px {\n  padding-bottom: 45px !important;\n}\n\n.pb-50px {\n  padding-bottom: 50px !important;\n}\n\n.ps-1px {\n  padding-left: 1px !important;\n}\n\n.ps-2px {\n  padding-left: 2px !important;\n}\n\n.ps-3px {\n  padding-left: 3px !important;\n}\n\n.ps-4px {\n  padding-left: 4px !important;\n}\n\n.ps-5px {\n  padding-left: 5px !important;\n}\n\n.ps-6px {\n  padding-left: 6px !important;\n}\n\n.ps-7px {\n  padding-left: 7px !important;\n}\n\n.ps-8px {\n  padding-left: 8px !important;\n}\n\n.ps-9px {\n  padding-left: 9px !important;\n}\n\n.ps-10px {\n  padding-left: 10px !important;\n}\n\n.ps-5px {\n  padding-left: 5px !important;\n}\n\n.ps-10px {\n  padding-left: 10px !important;\n}\n\n.ps-15px {\n  padding-left: 15px !important;\n}\n\n.ps-20px {\n  padding-left: 20px !important;\n}\n\n.ps-25px {\n  padding-left: 25px !important;\n}\n\n.ps-30px {\n  padding-left: 30px !important;\n}\n\n.ps-35px {\n  padding-left: 35px !important;\n}\n\n.ps-40px {\n  padding-left: 40px !important;\n}\n\n.ps-45px {\n  padding-left: 45px !important;\n}\n\n.ps-50px {\n  padding-left: 50px !important;\n}\n\n.px-1px {\n  padding-left: 1px !important;\n  padding-right: 1px !important;\n}\n\n.px-2px {\n  padding-left: 2px !important;\n  padding-right: 2px !important;\n}\n\n.px-3px {\n  padding-left: 3px !important;\n  padding-right: 3px !important;\n}\n\n.px-4px {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n\n.px-5px {\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n\n.px-6px {\n  padding-left: 6px !important;\n  padding-right: 6px !important;\n}\n\n.px-7px {\n  padding-left: 7px !important;\n  padding-right: 7px !important;\n}\n\n.px-8px {\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n\n.px-9px {\n  padding-left: 9px !important;\n  padding-right: 9px !important;\n}\n\n.px-10px {\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n\n.px-5px {\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n\n.px-10px {\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n\n.px-15px {\n  padding-left: 15px !important;\n  padding-right: 15px !important;\n}\n\n.px-20px {\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n}\n\n.px-25px {\n  padding-left: 25px !important;\n  padding-right: 25px !important;\n}\n\n.px-30px {\n  padding-left: 30px !important;\n  padding-right: 30px !important;\n}\n\n.px-35px {\n  padding-left: 35px !important;\n  padding-right: 35px !important;\n}\n\n.px-40px {\n  padding-left: 40px !important;\n  padding-right: 40px !important;\n}\n\n.px-45px {\n  padding-left: 45px !important;\n  padding-right: 45px !important;\n}\n\n.px-50px {\n  padding-left: 50px !important;\n  padding-right: 50px !important;\n}\n\n.py-1px {\n  padding-top: 1px !important;\n  padding-bottom: 1px !important;\n}\n\n.py-2px {\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n}\n\n.py-3px {\n  padding-top: 3px !important;\n  padding-bottom: 3px !important;\n}\n\n.py-4px {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n\n.py-5px {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n}\n\n.py-6px {\n  padding-top: 6px !important;\n  padding-bottom: 6px !important;\n}\n\n.py-7px {\n  padding-top: 7px !important;\n  padding-bottom: 7px !important;\n}\n\n.py-8px {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n\n.py-9px {\n  padding-top: 9px !important;\n  padding-bottom: 9px !important;\n}\n\n.py-10px {\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n\n.py-5px {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n}\n\n.py-10px {\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n\n.py-15px {\n  padding-top: 15px !important;\n  padding-bottom: 15px !important;\n}\n\n.py-20px {\n  padding-top: 20px !important;\n  padding-bottom: 20px !important;\n}\n\n.py-25px {\n  padding-top: 25px !important;\n  padding-bottom: 25px !important;\n}\n\n.py-30px {\n  padding-top: 30px !important;\n  padding-bottom: 30px !important;\n}\n\n.py-35px {\n  padding-top: 35px !important;\n  padding-bottom: 35px !important;\n}\n\n.py-40px {\n  padding-top: 40px !important;\n  padding-bottom: 40px !important;\n}\n\n.py-45px {\n  padding-top: 45px !important;\n  padding-bottom: 45px !important;\n}\n\n.py-50px {\n  padding-top: 50px !important;\n  padding-bottom: 50px !important;\n}\n\n/* Helper Font */\n.fs-0px {\n  font-size: 0px !important;\n}\n\n.fs-1px {\n  font-size: 1px !important;\n}\n\n.fs-2px {\n  font-size: 2px !important;\n}\n\n.fs-3px {\n  font-size: 3px !important;\n}\n\n.fs-4px {\n  font-size: 4px !important;\n}\n\n.fs-5px {\n  font-size: 5px !important;\n}\n\n.fs-6px {\n  font-size: 6px !important;\n}\n\n.fs-7px {\n  font-size: 7px !important;\n}\n\n.fs-8px {\n  font-size: 8px !important;\n}\n\n.fs-9px {\n  font-size: 9px !important;\n}\n\n.fs-10px {\n  font-size: 10px !important;\n}\n\n.fs-11px {\n  font-size: 11px !important;\n}\n\n.fs-12px {\n  font-size: 12px !important;\n}\n\n.fs-13px {\n  font-size: 13px !important;\n}\n\n.fs-14px {\n  font-size: 14px !important;\n}\n\n.fs-15px {\n  font-size: 15px !important;\n}\n\n.fs-16px {\n  font-size: 16px !important;\n}\n\n.fs-17px {\n  font-size: 17px !important;\n}\n\n.fs-18px {\n  font-size: 18px !important;\n}\n\n.fs-19px {\n  font-size: 19px !important;\n}\n\n.fs-20px {\n  font-size: 20px !important;\n}\n\n.fs-21px {\n  font-size: 21px !important;\n}\n\n.fs-22px {\n  font-size: 22px !important;\n}\n\n.fs-23px {\n  font-size: 23px !important;\n}\n\n.fs-24px {\n  font-size: 24px !important;\n}\n\n.fs-25px {\n  font-size: 25px !important;\n}\n\n.fs-26px {\n  font-size: 26px !important;\n}\n\n.fs-27px {\n  font-size: 27px !important;\n}\n\n.fs-28px {\n  font-size: 28px !important;\n}\n\n.fs-29px {\n  font-size: 29px !important;\n}\n\n.fs-30px {\n  font-size: 30px !important;\n}\n\n.fs-31px {\n  font-size: 31px !important;\n}\n\n.fs-32px {\n  font-size: 32px !important;\n}\n\n.fs-33px {\n  font-size: 33px !important;\n}\n\n.fs-34px {\n  font-size: 34px !important;\n}\n\n.fs-35px {\n  font-size: 35px !important;\n}\n\n.fs-36px {\n  font-size: 36px !important;\n}\n\n.fs-37px {\n  font-size: 37px !important;\n}\n\n.fs-38px {\n  font-size: 38px !important;\n}\n\n.fs-39px {\n  font-size: 39px !important;\n}\n\n.fs-40px {\n  font-size: 40px !important;\n}\n\n.fs-41px {\n  font-size: 41px !important;\n}\n\n.fs-42px {\n  font-size: 42px !important;\n}\n\n.fs-43px {\n  font-size: 43px !important;\n}\n\n.fs-44px {\n  font-size: 44px !important;\n}\n\n.fs-45px {\n  font-size: 45px !important;\n}\n\n.fs-46px {\n  font-size: 46px !important;\n}\n\n.fs-47px {\n  font-size: 47px !important;\n}\n\n.fs-48px {\n  font-size: 48px !important;\n}\n\n.fs-49px {\n  font-size: 49px !important;\n}\n\n.fs-50px {\n  font-size: 50px !important;\n}\n\n.fs-51px {\n  font-size: 51px !important;\n}\n\n.fs-52px {\n  font-size: 52px !important;\n}\n\n.fs-53px {\n  font-size: 53px !important;\n}\n\n.fs-54px {\n  font-size: 54px !important;\n}\n\n.fs-55px {\n  font-size: 55px !important;\n}\n\n.fs-56px {\n  font-size: 56px !important;\n}\n\n.fs-57px {\n  font-size: 57px !important;\n}\n\n.fs-58px {\n  font-size: 58px !important;\n}\n\n.fs-59px {\n  font-size: 59px !important;\n}\n\n.fs-60px {\n  font-size: 60px !important;\n}\n\n.fs-61px {\n  font-size: 61px !important;\n}\n\n.fs-62px {\n  font-size: 62px !important;\n}\n\n.fs-63px {\n  font-size: 63px !important;\n}\n\n.fs-64px {\n  font-size: 64px !important;\n}\n\n.fs-65px {\n  font-size: 65px !important;\n}\n\n.fs-66px {\n  font-size: 66px !important;\n}\n\n.fs-67px {\n  font-size: 67px !important;\n}\n\n.fs-68px {\n  font-size: 68px !important;\n}\n\n.fs-69px {\n  font-size: 69px !important;\n}\n\n.fs-70px {\n  font-size: 70px !important;\n}\n\n.fs-71px {\n  font-size: 71px !important;\n}\n\n.fs-72px {\n  font-size: 72px !important;\n}\n\n.fs-73px {\n  font-size: 73px !important;\n}\n\n.fs-74px {\n  font-size: 74px !important;\n}\n\n.fs-75px {\n  font-size: 75px !important;\n}\n\n.fs-76px {\n  font-size: 76px !important;\n}\n\n.fs-77px {\n  font-size: 77px !important;\n}\n\n.fs-78px {\n  font-size: 78px !important;\n}\n\n.fs-79px {\n  font-size: 79px !important;\n}\n\n.fs-80px {\n  font-size: 80px !important;\n}\n\n.fw-100 {\n  font-weight: 100 !important;\n}\n\n.fw-200 {\n  font-weight: 200 !important;\n}\n\n.fw-300 {\n  font-weight: 300 !important;\n}\n\n.fw-400 {\n  font-weight: 400 !important;\n}\n\n.fw-500 {\n  font-weight: 500 !important;\n}\n\n.fw-600 {\n  font-weight: 600 !important;\n}\n\n.fw-700 {\n  font-weight: 700 !important;\n}\n\n.fw-800 {\n  font-weight: 800 !important;\n}\n\n/* Helper Position Direction */\n.top-0 {\n  top: 0 !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.top-auto {\n  top: auto !important;\n}\n\n.bottom-auto {\n  bottom: auto !important;\n}\n\n.start-auto {\n  left: auto !important;\n}\n\n.end-auto {\n  right: auto !important;\n}\n\n/* Helper Text */\n.text-underline {\n  text-decoration: underline !important;\n}\n\n.text-gradient {\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n}\n\n.line-height-1 {\n  line-height: 1 !important;\n}\n\n/* Helper Size */\n.w-5px {\n  width: 5px !important;\n}\n\n.w-1px {\n  width: 1px !important;\n}\n\n.w-10px {\n  width: 10px !important;\n}\n\n.w-2px {\n  width: 2px !important;\n}\n\n.w-15px {\n  width: 15px !important;\n}\n\n.w-3px {\n  width: 3px !important;\n}\n\n.w-20px {\n  width: 20px !important;\n}\n\n.w-4px {\n  width: 4px !important;\n}\n\n.w-25px {\n  width: 25px !important;\n}\n\n.w-5px {\n  width: 5px !important;\n}\n\n.w-30px {\n  width: 30px !important;\n}\n\n.w-6px {\n  width: 6px !important;\n}\n\n.w-35px {\n  width: 35px !important;\n}\n\n.w-7px {\n  width: 7px !important;\n}\n\n.w-40px {\n  width: 40px !important;\n}\n\n.w-8px {\n  width: 8px !important;\n}\n\n.w-45px {\n  width: 45px !important;\n}\n\n.w-9px {\n  width: 9px !important;\n}\n\n.w-50px {\n  width: 50px !important;\n}\n\n.w-10px {\n  width: 10px !important;\n}\n\n.w-55px {\n  width: 55px !important;\n}\n\n.w-11px {\n  width: 11px !important;\n}\n\n.w-60px {\n  width: 60px !important;\n}\n\n.w-12px {\n  width: 12px !important;\n}\n\n.w-65px {\n  width: 65px !important;\n}\n\n.w-13px {\n  width: 13px !important;\n}\n\n.w-70px {\n  width: 70px !important;\n}\n\n.w-14px {\n  width: 14px !important;\n}\n\n.w-75px {\n  width: 75px !important;\n}\n\n.w-15px {\n  width: 15px !important;\n}\n\n.w-80px {\n  width: 80px !important;\n}\n\n.w-16px {\n  width: 16px !important;\n}\n\n.w-85px {\n  width: 85px !important;\n}\n\n.w-17px {\n  width: 17px !important;\n}\n\n.w-90px {\n  width: 90px !important;\n}\n\n.w-18px {\n  width: 18px !important;\n}\n\n.w-95px {\n  width: 95px !important;\n}\n\n.w-19px {\n  width: 19px !important;\n}\n\n.w-100px {\n  width: 100px !important;\n}\n\n.w-20px {\n  width: 20px !important;\n}\n\n.w-105px {\n  width: 105px !important;\n}\n\n.w-21px {\n  width: 21px !important;\n}\n\n.w-110px {\n  width: 110px !important;\n}\n\n.w-22px {\n  width: 22px !important;\n}\n\n.w-115px {\n  width: 115px !important;\n}\n\n.w-23px {\n  width: 23px !important;\n}\n\n.w-120px {\n  width: 120px !important;\n}\n\n.w-24px {\n  width: 24px !important;\n}\n\n.w-125px {\n  width: 125px !important;\n}\n\n.w-25px {\n  width: 25px !important;\n}\n\n.w-130px {\n  width: 130px !important;\n}\n\n.w-26px {\n  width: 26px !important;\n}\n\n.w-135px {\n  width: 135px !important;\n}\n\n.w-27px {\n  width: 27px !important;\n}\n\n.w-140px {\n  width: 140px !important;\n}\n\n.w-28px {\n  width: 28px !important;\n}\n\n.w-145px {\n  width: 145px !important;\n}\n\n.w-29px {\n  width: 29px !important;\n}\n\n.w-150px {\n  width: 150px !important;\n}\n\n.w-30px {\n  width: 30px !important;\n}\n\n.w-155px {\n  width: 155px !important;\n}\n\n.w-31px {\n  width: 31px !important;\n}\n\n.w-160px {\n  width: 160px !important;\n}\n\n.w-32px {\n  width: 32px !important;\n}\n\n.w-165px {\n  width: 165px !important;\n}\n\n.w-33px {\n  width: 33px !important;\n}\n\n.w-170px {\n  width: 170px !important;\n}\n\n.w-34px {\n  width: 34px !important;\n}\n\n.w-175px {\n  width: 175px !important;\n}\n\n.w-35px {\n  width: 35px !important;\n}\n\n.w-180px {\n  width: 180px !important;\n}\n\n.w-36px {\n  width: 36px !important;\n}\n\n.w-185px {\n  width: 185px !important;\n}\n\n.w-37px {\n  width: 37px !important;\n}\n\n.w-190px {\n  width: 190px !important;\n}\n\n.w-38px {\n  width: 38px !important;\n}\n\n.w-195px {\n  width: 195px !important;\n}\n\n.w-39px {\n  width: 39px !important;\n}\n\n.w-200px {\n  width: 200px !important;\n}\n\n.w-40px {\n  width: 40px !important;\n}\n\n.w-250px {\n  width: 250px !important;\n}\n\n.w-300px {\n  width: 300px !important;\n}\n\n.w-350px {\n  width: 350px !important;\n}\n\n.w-400px {\n  width: 400px !important;\n}\n\n.w-450px {\n  width: 450px !important;\n}\n\n.w-500px {\n  width: 500px !important;\n}\n\n.w-550px {\n  width: 550px !important;\n}\n\n.w-600px {\n  width: 600px !important;\n}\n\n.h-5px {\n  height: 5px !important;\n}\n\n.h-1px {\n  height: 1px !important;\n}\n\n.h-10px {\n  height: 10px !important;\n}\n\n.h-2px {\n  height: 2px !important;\n}\n\n.h-15px {\n  height: 15px !important;\n}\n\n.h-3px {\n  height: 3px !important;\n}\n\n.h-20px {\n  height: 20px !important;\n}\n\n.h-4px {\n  height: 4px !important;\n}\n\n.h-25px {\n  height: 25px !important;\n}\n\n.h-5px {\n  height: 5px !important;\n}\n\n.h-30px {\n  height: 30px !important;\n}\n\n.h-6px {\n  height: 6px !important;\n}\n\n.h-35px {\n  height: 35px !important;\n}\n\n.h-7px {\n  height: 7px !important;\n}\n\n.h-40px {\n  height: 40px !important;\n}\n\n.h-8px {\n  height: 8px !important;\n}\n\n.h-45px {\n  height: 45px !important;\n}\n\n.h-9px {\n  height: 9px !important;\n}\n\n.h-50px {\n  height: 50px !important;\n}\n\n.h-10px {\n  height: 10px !important;\n}\n\n.h-55px {\n  height: 55px !important;\n}\n\n.h-11px {\n  height: 11px !important;\n}\n\n.h-60px {\n  height: 60px !important;\n}\n\n.h-12px {\n  height: 12px !important;\n}\n\n.h-65px {\n  height: 65px !important;\n}\n\n.h-13px {\n  height: 13px !important;\n}\n\n.h-70px {\n  height: 70px !important;\n}\n\n.h-14px {\n  height: 14px !important;\n}\n\n.h-75px {\n  height: 75px !important;\n}\n\n.h-15px {\n  height: 15px !important;\n}\n\n.h-80px {\n  height: 80px !important;\n}\n\n.h-16px {\n  height: 16px !important;\n}\n\n.h-85px {\n  height: 85px !important;\n}\n\n.h-17px {\n  height: 17px !important;\n}\n\n.h-90px {\n  height: 90px !important;\n}\n\n.h-18px {\n  height: 18px !important;\n}\n\n.h-95px {\n  height: 95px !important;\n}\n\n.h-19px {\n  height: 19px !important;\n}\n\n.h-100px {\n  height: 100px !important;\n}\n\n.h-20px {\n  height: 20px !important;\n}\n\n.h-105px {\n  height: 105px !important;\n}\n\n.h-21px {\n  height: 21px !important;\n}\n\n.h-110px {\n  height: 110px !important;\n}\n\n.h-22px {\n  height: 22px !important;\n}\n\n.h-115px {\n  height: 115px !important;\n}\n\n.h-23px {\n  height: 23px !important;\n}\n\n.h-120px {\n  height: 120px !important;\n}\n\n.h-24px {\n  height: 24px !important;\n}\n\n.h-125px {\n  height: 125px !important;\n}\n\n.h-25px {\n  height: 25px !important;\n}\n\n.h-130px {\n  height: 130px !important;\n}\n\n.h-26px {\n  height: 26px !important;\n}\n\n.h-135px {\n  height: 135px !important;\n}\n\n.h-27px {\n  height: 27px !important;\n}\n\n.h-140px {\n  height: 140px !important;\n}\n\n.h-28px {\n  height: 28px !important;\n}\n\n.h-145px {\n  height: 145px !important;\n}\n\n.h-29px {\n  height: 29px !important;\n}\n\n.h-150px {\n  height: 150px !important;\n}\n\n.h-30px {\n  height: 30px !important;\n}\n\n.h-155px {\n  height: 155px !important;\n}\n\n.h-31px {\n  height: 31px !important;\n}\n\n.h-160px {\n  height: 160px !important;\n}\n\n.h-32px {\n  height: 32px !important;\n}\n\n.h-165px {\n  height: 165px !important;\n}\n\n.h-33px {\n  height: 33px !important;\n}\n\n.h-170px {\n  height: 170px !important;\n}\n\n.h-34px {\n  height: 34px !important;\n}\n\n.h-175px {\n  height: 175px !important;\n}\n\n.h-35px {\n  height: 35px !important;\n}\n\n.h-180px {\n  height: 180px !important;\n}\n\n.h-36px {\n  height: 36px !important;\n}\n\n.h-185px {\n  height: 185px !important;\n}\n\n.h-37px {\n  height: 37px !important;\n}\n\n.h-190px {\n  height: 190px !important;\n}\n\n.h-38px {\n  height: 38px !important;\n}\n\n.h-195px {\n  height: 195px !important;\n}\n\n.h-39px {\n  height: 39px !important;\n}\n\n.h-200px {\n  height: 200px !important;\n}\n\n.h-40px {\n  height: 40px !important;\n}\n\n.h-250px {\n  height: 250px !important;\n}\n\n.h-300px {\n  height: 300px !important;\n}\n\n.h-350px {\n  height: 350px !important;\n}\n\n.h-400px {\n  height: 400px !important;\n}\n\n.h-450px {\n  height: 450px !important;\n}\n\n.h-500px {\n  height: 500px !important;\n}\n\n.h-550px {\n  height: 550px !important;\n}\n\n.h-600px {\n  height: 600px !important;\n}\n\n/* Helper Color */\n.bg-gradient-default {\n  background-color: #798e98 !important;\n  background-image: -moz-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: -webkit-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-default {\n  --bs-theme: #798e98 !important;\n  --bs-theme-rgb: 121, 142, 152 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-default-100 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;\n}\n\n.bg-default-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;\n}\n\n.text-default-600 {\n  --bs-text-opacity: 1;\n  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;\n}\n\n.bg-default-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;\n}\n\n.text-default-200 {\n  --bs-text-opacity: 1;\n  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;\n}\n\n.bg-default-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;\n}\n\n.text-default-700 {\n  --bs-text-opacity: 1;\n  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;\n}\n\n.bg-default-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;\n}\n\n.text-default-300 {\n  --bs-text-opacity: 1;\n  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;\n}\n\n.bg-default-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;\n}\n\n.text-default-800 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;\n}\n\n.bg-default-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;\n}\n\n.text-default-400 {\n  --bs-text-opacity: 1;\n  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;\n}\n\n.bg-default-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;\n}\n\n.text-default-900 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;\n}\n\n.bg-default-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-theme {\n  background-color: #249d79 !important;\n  background-image: -moz-linear-gradient(top, #2ec699, #1f8869) !important;\n  background-image: -webkit-linear-gradient(top, #2ec699, #1f8869) !important;\n  background-image: linear-gradient(to bottom, #2ec699, #1f8869) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n.border-theme {\n  border-color: var(--bs-theme) !important;\n}\n\n:root .theme-theme {\n  --bs-theme: #249d79 !important;\n  --bs-theme-rgb: 36, 157, 121 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-theme-100 {\n  --bs-text-opacity: 1;\n  color: rgba(211, 235, 228, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(211, 235, 228, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-600 {\n  --bs-text-opacity: 1;\n  color: rgba(29, 126, 97, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(29, 126, 97, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-200 {\n  --bs-text-opacity: 1;\n  color: rgba(167, 216, 201, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(167, 216, 201, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-700 {\n  --bs-text-opacity: 1;\n  color: rgba(22, 94, 73, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(22, 94, 73, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-300 {\n  --bs-text-opacity: 1;\n  color: rgba(124, 196, 175, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(124, 196, 175, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-800 {\n  --bs-text-opacity: 1;\n  color: rgba(14, 63, 48, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(14, 63, 48, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-400 {\n  --bs-text-opacity: 1;\n  color: rgba(80, 177, 148, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(80, 177, 148, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-900 {\n  --bs-text-opacity: 1;\n  color: rgba(7, 31, 24, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(7, 31, 24, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-theme-color {\n  background-color: #ffffff !important;\n  background-image: -moz-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: -webkit-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-theme-color {\n  --bs-theme: #ffffff !important;\n  --bs-theme-rgb: 255, 255, 255 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-theme-color-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-color-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-color-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-color-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-color-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-color-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-color-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-color-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-color-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-color-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-color-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-color-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-color-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-color-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-theme-color-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-theme-color-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-primary {\n  background-color: #0271ff !important;\n  background-image: -moz-linear-gradient(top, #358eff, #0066e8) !important;\n  background-image: -webkit-linear-gradient(top, #358eff, #0066e8) !important;\n  background-image: linear-gradient(to bottom, #358eff, #0066e8) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-primary {\n  --bs-theme: #0271ff !important;\n  --bs-theme-rgb: 2, 113, 255 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-primary-100 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 227, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-primary-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 227, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-primary-600 {\n  --bs-text-opacity: 1;\n  color: rgba(2, 90, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-primary-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(2, 90, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-primary-200 {\n  --bs-text-opacity: 1;\n  color: rgba(154, 198, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-primary-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(154, 198, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-primary-700 {\n  --bs-text-opacity: 1;\n  color: rgba(1, 68, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-primary-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(1, 68, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-primary-300 {\n  --bs-text-opacity: 1;\n  color: rgba(103, 170, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-primary-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(103, 170, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-primary-800 {\n  --bs-text-opacity: 1;\n  color: rgba(1, 45, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-primary-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(1, 45, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-primary-400 {\n  --bs-text-opacity: 1;\n  color: rgba(53, 141, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-primary-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(53, 141, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-primary-900 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 23, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-primary-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 23, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-secondary {\n  background-color: #798e98 !important;\n  background-image: -moz-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: -webkit-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-secondary {\n  --bs-theme: #798e98 !important;\n  --bs-theme-rgb: 121, 142, 152 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-secondary-100 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;\n}\n\n.bg-secondary-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;\n}\n\n.text-secondary-600 {\n  --bs-text-opacity: 1;\n  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;\n}\n\n.bg-secondary-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;\n}\n\n.text-secondary-200 {\n  --bs-text-opacity: 1;\n  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;\n}\n\n.bg-secondary-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;\n}\n\n.text-secondary-700 {\n  --bs-text-opacity: 1;\n  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;\n}\n\n.bg-secondary-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;\n}\n\n.text-secondary-300 {\n  --bs-text-opacity: 1;\n  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;\n}\n\n.bg-secondary-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;\n}\n\n.text-secondary-800 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;\n}\n\n.bg-secondary-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;\n}\n\n.text-secondary-400 {\n  --bs-text-opacity: 1;\n  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;\n}\n\n.bg-secondary-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;\n}\n\n.text-secondary-900 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;\n}\n\n.bg-secondary-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-warning {\n  background-color: #ff9f0c !important;\n  background-image: -moz-linear-gradient(top, #ffb33f, #f29200) !important;\n  background-image: -webkit-linear-gradient(top, #ffb33f, #f29200) !important;\n  background-image: linear-gradient(to bottom, #ffb33f, #f29200) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-warning {\n  --bs-theme: #ff9f0c !important;\n  --bs-theme-rgb: 255, 159, 12 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-warning-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 236, 206, var(--bs-text-opacity)) !important;\n}\n\n.bg-warning-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 236, 206, var(--bs-bg-opacity)) !important;\n}\n\n.text-warning-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 127, 10, var(--bs-text-opacity)) !important;\n}\n\n.bg-warning-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 127, 10, var(--bs-bg-opacity)) !important;\n}\n\n.text-warning-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 217, 158, var(--bs-text-opacity)) !important;\n}\n\n.bg-warning-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 217, 158, var(--bs-bg-opacity)) !important;\n}\n\n.text-warning-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 95, 7, var(--bs-text-opacity)) !important;\n}\n\n.bg-warning-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 95, 7, var(--bs-bg-opacity)) !important;\n}\n\n.text-warning-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 197, 109, var(--bs-text-opacity)) !important;\n}\n\n.bg-warning-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 197, 109, var(--bs-bg-opacity)) !important;\n}\n\n.text-warning-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 64, 5, var(--bs-text-opacity)) !important;\n}\n\n.bg-warning-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 64, 5, var(--bs-bg-opacity)) !important;\n}\n\n.text-warning-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 178, 61, var(--bs-text-opacity)) !important;\n}\n\n.bg-warning-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 178, 61, var(--bs-bg-opacity)) !important;\n}\n\n.text-warning-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 32, 2, var(--bs-text-opacity)) !important;\n}\n\n.bg-warning-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 32, 2, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-danger {\n  background-color: #e00000 !important;\n  background-image: -moz-linear-gradient(top, #ff1414, #c70000) !important;\n  background-image: -webkit-linear-gradient(top, #ff1414, #c70000) !important;\n  background-image: linear-gradient(to bottom, #ff1414, #c70000) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-danger {\n  --bs-theme: #e00000 !important;\n  --bs-theme-rgb: 224, 0, 0 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-danger-100 {\n  --bs-text-opacity: 1;\n  color: rgba(249, 204, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-danger-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(249, 204, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-danger-600 {\n  --bs-text-opacity: 1;\n  color: rgba(179, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-danger-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-danger-200 {\n  --bs-text-opacity: 1;\n  color: rgba(243, 153, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-danger-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(243, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-danger-700 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-danger-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-danger-300 {\n  --bs-text-opacity: 1;\n  color: rgba(236, 102, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-danger-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(236, 102, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-danger-800 {\n  --bs-text-opacity: 1;\n  color: rgba(90, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-danger-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(90, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-danger-400 {\n  --bs-text-opacity: 1;\n  color: rgba(230, 51, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-danger-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(230, 51, 51, var(--bs-bg-opacity)) !important;\n}\n\n.text-danger-900 {\n  --bs-text-opacity: 1;\n  color: rgba(45, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-danger-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(45, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-success {\n  background-color: #249d79 !important;\n  background-image: -moz-linear-gradient(top, #2ec699, #1f8869) !important;\n  background-image: -webkit-linear-gradient(top, #2ec699, #1f8869) !important;\n  background-image: linear-gradient(to bottom, #2ec699, #1f8869) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-success {\n  --bs-theme: #249d79 !important;\n  --bs-theme-rgb: 36, 157, 121 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-success-100 {\n  --bs-text-opacity: 1;\n  color: rgba(211, 235, 228, var(--bs-text-opacity)) !important;\n}\n\n.bg-success-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(211, 235, 228, var(--bs-bg-opacity)) !important;\n}\n\n.text-success-600 {\n  --bs-text-opacity: 1;\n  color: rgba(29, 126, 97, var(--bs-text-opacity)) !important;\n}\n\n.bg-success-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(29, 126, 97, var(--bs-bg-opacity)) !important;\n}\n\n.text-success-200 {\n  --bs-text-opacity: 1;\n  color: rgba(167, 216, 201, var(--bs-text-opacity)) !important;\n}\n\n.bg-success-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(167, 216, 201, var(--bs-bg-opacity)) !important;\n}\n\n.text-success-700 {\n  --bs-text-opacity: 1;\n  color: rgba(22, 94, 73, var(--bs-text-opacity)) !important;\n}\n\n.bg-success-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(22, 94, 73, var(--bs-bg-opacity)) !important;\n}\n\n.text-success-300 {\n  --bs-text-opacity: 1;\n  color: rgba(124, 196, 175, var(--bs-text-opacity)) !important;\n}\n\n.bg-success-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(124, 196, 175, var(--bs-bg-opacity)) !important;\n}\n\n.text-success-800 {\n  --bs-text-opacity: 1;\n  color: rgba(14, 63, 48, var(--bs-text-opacity)) !important;\n}\n\n.bg-success-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(14, 63, 48, var(--bs-bg-opacity)) !important;\n}\n\n.text-success-400 {\n  --bs-text-opacity: 1;\n  color: rgba(80, 177, 148, var(--bs-text-opacity)) !important;\n}\n\n.bg-success-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(80, 177, 148, var(--bs-bg-opacity)) !important;\n}\n\n.text-success-900 {\n  --bs-text-opacity: 1;\n  color: rgba(7, 31, 24, var(--bs-text-opacity)) !important;\n}\n\n.bg-success-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(7, 31, 24, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-inverse {\n  background-color: #000000 !important;\n  background-image: -moz-linear-gradient(top, #1a1a1a, black) !important;\n  background-image: -webkit-linear-gradient(top, #1a1a1a, black) !important;\n  background-image: linear-gradient(to bottom, #1a1a1a, black) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-inverse {\n  --bs-theme: #000000 !important;\n  --bs-theme-rgb: 0, 0, 0 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-inverse-100 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-inverse-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-inverse-600 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-inverse-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-inverse-200 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-inverse-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-inverse-700 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-inverse-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-inverse-300 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-inverse-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-inverse-800 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-inverse-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-inverse-400 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-inverse-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;\n}\n\n.text-inverse-900 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-inverse-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-info {\n  background-color: #009be3 !important;\n  background-image: -moz-linear-gradient(top, #17b5ff, #008aca) !important;\n  background-image: -webkit-linear-gradient(top, #17b5ff, #008aca) !important;\n  background-image: linear-gradient(to bottom, #17b5ff, #008aca) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-info {\n  --bs-theme: #009be3 !important;\n  --bs-theme-rgb: 0, 155, 227 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-info-100 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 235, 249, var(--bs-text-opacity)) !important;\n}\n\n.bg-info-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 235, 249, var(--bs-bg-opacity)) !important;\n}\n\n.text-info-600 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 124, 182, var(--bs-text-opacity)) !important;\n}\n\n.bg-info-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 124, 182, var(--bs-bg-opacity)) !important;\n}\n\n.text-info-200 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 215, 244, var(--bs-text-opacity)) !important;\n}\n\n.bg-info-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 215, 244, var(--bs-bg-opacity)) !important;\n}\n\n.text-info-700 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 93, 136, var(--bs-text-opacity)) !important;\n}\n\n.bg-info-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 93, 136, var(--bs-bg-opacity)) !important;\n}\n\n.text-info-300 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 195, 238, var(--bs-text-opacity)) !important;\n}\n\n.bg-info-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 195, 238, var(--bs-bg-opacity)) !important;\n}\n\n.text-info-800 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 62, 91, var(--bs-text-opacity)) !important;\n}\n\n.bg-info-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 62, 91, var(--bs-bg-opacity)) !important;\n}\n\n.text-info-400 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 175, 233, var(--bs-text-opacity)) !important;\n}\n\n.bg-info-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 175, 233, var(--bs-bg-opacity)) !important;\n}\n\n.text-info-900 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 31, 45, var(--bs-text-opacity)) !important;\n}\n\n.bg-info-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 31, 45, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-dark {\n  background-color: #35434a !important;\n  background-image: -moz-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: -webkit-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-dark {\n  --bs-theme: #35434a !important;\n  --bs-theme-rgb: 53, 67, 74 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-dark-100 {\n  --bs-text-opacity: 1;\n  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;\n}\n\n.bg-dark-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;\n}\n\n.text-dark-600 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;\n}\n\n.bg-dark-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;\n}\n\n.text-dark-200 {\n  --bs-text-opacity: 1;\n  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;\n}\n\n.bg-dark-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;\n}\n\n.text-dark-700 {\n  --bs-text-opacity: 1;\n  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;\n}\n\n.bg-dark-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;\n}\n\n.text-dark-300 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;\n}\n\n.bg-dark-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;\n}\n\n.text-dark-800 {\n  --bs-text-opacity: 1;\n  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;\n}\n\n.bg-dark-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;\n}\n\n.text-dark-400 {\n  --bs-text-opacity: 1;\n  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;\n}\n\n.bg-dark-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;\n}\n\n.text-dark-900 {\n  --bs-text-opacity: 1;\n  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;\n}\n\n.bg-dark-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-black {\n  background-color: #000000 !important;\n  background-image: -moz-linear-gradient(top, #1a1a1a, black) !important;\n  background-image: -webkit-linear-gradient(top, #1a1a1a, black) !important;\n  background-image: linear-gradient(to bottom, #1a1a1a, black) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-black {\n  --bs-theme: #000000 !important;\n  --bs-theme-rgb: 0, 0, 0 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-black-100 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-600 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-200 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-700 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-300 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-800 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-400 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-900 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-white {\n  background-color: #ffffff !important;\n  background-image: -moz-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: -webkit-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-white {\n  --bs-theme: #ffffff !important;\n  --bs-theme-rgb: 255, 255, 255 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-white-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-purple {\n  background-color: #b90dff !important;\n  background-image: -moz-linear-gradient(top, #c840ff, #ac00f3) !important;\n  background-image: -webkit-linear-gradient(top, #c840ff, #ac00f3) !important;\n  background-image: linear-gradient(to bottom, #c840ff, #ac00f3) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-purple {\n  --bs-theme: #b90dff !important;\n  --bs-theme-rgb: 185, 13, 255 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-purple-100 {\n  --bs-text-opacity: 1;\n  color: rgba(241, 207, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(241, 207, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-600 {\n  --bs-text-opacity: 1;\n  color: rgba(148, 10, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(148, 10, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-200 {\n  --bs-text-opacity: 1;\n  color: rgba(227, 158, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(227, 158, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-700 {\n  --bs-text-opacity: 1;\n  color: rgba(111, 8, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(111, 8, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-300 {\n  --bs-text-opacity: 1;\n  color: rgba(213, 110, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(213, 110, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-800 {\n  --bs-text-opacity: 1;\n  color: rgba(74, 5, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(74, 5, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-400 {\n  --bs-text-opacity: 1;\n  color: rgba(199, 61, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(199, 61, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-900 {\n  --bs-text-opacity: 1;\n  color: rgba(37, 3, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(37, 3, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-indigo {\n  background-color: #5c25ff !important;\n  background-image: -moz-linear-gradient(top, #8258ff, #490cff) !important;\n  background-image: -webkit-linear-gradient(top, #8258ff, #490cff) !important;\n  background-image: linear-gradient(to bottom, #8258ff, #490cff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-indigo {\n  --bs-theme: #5c25ff !important;\n  --bs-theme-rgb: 92, 37, 255 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-indigo-100 {\n  --bs-text-opacity: 1;\n  color: rgba(222, 211, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(222, 211, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-600 {\n  --bs-text-opacity: 1;\n  color: rgba(74, 30, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(74, 30, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-200 {\n  --bs-text-opacity: 1;\n  color: rgba(190, 168, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(190, 168, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-700 {\n  --bs-text-opacity: 1;\n  color: rgba(55, 22, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(55, 22, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-300 {\n  --bs-text-opacity: 1;\n  color: rgba(157, 124, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(157, 124, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-800 {\n  --bs-text-opacity: 1;\n  color: rgba(37, 15, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(37, 15, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-400 {\n  --bs-text-opacity: 1;\n  color: rgba(125, 81, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(125, 81, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-900 {\n  --bs-text-opacity: 1;\n  color: rgba(18, 7, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(18, 7, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-red {\n  background-color: #e00000 !important;\n  background-image: -moz-linear-gradient(top, #ff1414, #c70000) !important;\n  background-image: -webkit-linear-gradient(top, #ff1414, #c70000) !important;\n  background-image: linear-gradient(to bottom, #ff1414, #c70000) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-red {\n  --bs-theme: #e00000 !important;\n  --bs-theme-rgb: 224, 0, 0 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-red-100 {\n  --bs-text-opacity: 1;\n  color: rgba(249, 204, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(249, 204, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-600 {\n  --bs-text-opacity: 1;\n  color: rgba(179, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-200 {\n  --bs-text-opacity: 1;\n  color: rgba(243, 153, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(243, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-700 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-300 {\n  --bs-text-opacity: 1;\n  color: rgba(236, 102, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(236, 102, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-800 {\n  --bs-text-opacity: 1;\n  color: rgba(90, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(90, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-400 {\n  --bs-text-opacity: 1;\n  color: rgba(230, 51, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(230, 51, 51, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-900 {\n  --bs-text-opacity: 1;\n  color: rgba(45, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(45, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-pink {\n  background-color: #e61079 !important;\n  background-image: -moz-linear-gradient(top, #f13893, #ce0e6c) !important;\n  background-image: -webkit-linear-gradient(top, #f13893, #ce0e6c) !important;\n  background-image: linear-gradient(to bottom, #f13893, #ce0e6c) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-pink {\n  --bs-theme: #e61079 !important;\n  --bs-theme-rgb: 230, 16, 121 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-pink-100 {\n  --bs-text-opacity: 1;\n  color: rgba(250, 207, 228, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(250, 207, 228, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-600 {\n  --bs-text-opacity: 1;\n  color: rgba(184, 13, 97, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(184, 13, 97, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-200 {\n  --bs-text-opacity: 1;\n  color: rgba(245, 159, 201, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(245, 159, 201, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-700 {\n  --bs-text-opacity: 1;\n  color: rgba(138, 10, 73, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(138, 10, 73, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-300 {\n  --bs-text-opacity: 1;\n  color: rgba(240, 112, 175, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(240, 112, 175, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-800 {\n  --bs-text-opacity: 1;\n  color: rgba(92, 6, 48, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(92, 6, 48, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-400 {\n  --bs-text-opacity: 1;\n  color: rgba(235, 64, 148, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(235, 64, 148, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-900 {\n  --bs-text-opacity: 1;\n  color: rgba(46, 3, 24, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(46, 3, 24, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-green {\n  background-color: #148922 !important;\n  background-image: -moz-linear-gradient(top, #1ab62d, #11731c) !important;\n  background-image: -webkit-linear-gradient(top, #1ab62d, #11731c) !important;\n  background-image: linear-gradient(to bottom, #1ab62d, #11731c) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-green {\n  --bs-theme: #148922 !important;\n  --bs-theme-rgb: 20, 137, 34 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-green-100 {\n  --bs-text-opacity: 1;\n  color: rgba(208, 231, 211, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(208, 231, 211, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-600 {\n  --bs-text-opacity: 1;\n  color: rgba(16, 110, 27, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(16, 110, 27, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-200 {\n  --bs-text-opacity: 1;\n  color: rgba(161, 208, 167, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(161, 208, 167, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-700 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 82, 20, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 82, 20, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-300 {\n  --bs-text-opacity: 1;\n  color: rgba(114, 184, 122, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(114, 184, 122, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-800 {\n  --bs-text-opacity: 1;\n  color: rgba(8, 55, 14, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(8, 55, 14, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-400 {\n  --bs-text-opacity: 1;\n  color: rgba(67, 161, 78, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(67, 161, 78, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-900 {\n  --bs-text-opacity: 1;\n  color: rgba(4, 27, 7, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(4, 27, 7, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-yellow {\n  background-color: #f9e80d !important;\n  background-image: -moz-linear-gradient(top, #faed3f, #e7d706) !important;\n  background-image: -webkit-linear-gradient(top, #faed3f, #e7d706) !important;\n  background-image: linear-gradient(to bottom, #faed3f, #e7d706) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-yellow {\n  --bs-theme: #f9e80d !important;\n  --bs-theme-rgb: 249, 232, 13 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-yellow-100 {\n  --bs-text-opacity: 1;\n  color: rgba(254, 250, 207, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(254, 250, 207, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-600 {\n  --bs-text-opacity: 1;\n  color: rgba(199, 186, 10, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(199, 186, 10, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-200 {\n  --bs-text-opacity: 1;\n  color: rgba(253, 246, 158, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(253, 246, 158, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-700 {\n  --bs-text-opacity: 1;\n  color: rgba(149, 139, 8, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(149, 139, 8, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-300 {\n  --bs-text-opacity: 1;\n  color: rgba(251, 241, 110, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(251, 241, 110, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-800 {\n  --bs-text-opacity: 1;\n  color: rgba(100, 93, 5, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(100, 93, 5, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-400 {\n  --bs-text-opacity: 1;\n  color: rgba(250, 237, 61, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(250, 237, 61, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-900 {\n  --bs-text-opacity: 1;\n  color: rgba(50, 46, 3, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(50, 46, 3, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-teal {\n  background-color: #249d79 !important;\n  background-image: -moz-linear-gradient(top, #2ec699, #1f8869) !important;\n  background-image: -webkit-linear-gradient(top, #2ec699, #1f8869) !important;\n  background-image: linear-gradient(to bottom, #2ec699, #1f8869) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-teal {\n  --bs-theme: #249d79 !important;\n  --bs-theme-rgb: 36, 157, 121 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-teal-100 {\n  --bs-text-opacity: 1;\n  color: rgba(211, 235, 228, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(211, 235, 228, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-600 {\n  --bs-text-opacity: 1;\n  color: rgba(29, 126, 97, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(29, 126, 97, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-200 {\n  --bs-text-opacity: 1;\n  color: rgba(167, 216, 201, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(167, 216, 201, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-700 {\n  --bs-text-opacity: 1;\n  color: rgba(22, 94, 73, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(22, 94, 73, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-300 {\n  --bs-text-opacity: 1;\n  color: rgba(124, 196, 175, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(124, 196, 175, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-800 {\n  --bs-text-opacity: 1;\n  color: rgba(14, 63, 48, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(14, 63, 48, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-400 {\n  --bs-text-opacity: 1;\n  color: rgba(80, 177, 148, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(80, 177, 148, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-900 {\n  --bs-text-opacity: 1;\n  color: rgba(7, 31, 24, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(7, 31, 24, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-muted {\n  background-color: #617a86 !important;\n  background-image: -moz-linear-gradient(top, #7b939f, #566d77) !important;\n  background-image: -webkit-linear-gradient(top, #7b939f, #566d77) !important;\n  background-image: linear-gradient(to bottom, #7b939f, #566d77) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-muted {\n  --bs-theme: #617a86 !important;\n  --bs-theme-rgb: 97, 122, 134 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-muted-100 {\n  --bs-text-opacity: 1;\n  color: rgba(223, 228, 231, var(--bs-text-opacity)) !important;\n}\n\n.bg-muted-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(223, 228, 231, var(--bs-bg-opacity)) !important;\n}\n\n.text-muted-600 {\n  --bs-text-opacity: 1;\n  color: rgba(78, 98, 107, var(--bs-text-opacity)) !important;\n}\n\n.bg-muted-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(78, 98, 107, var(--bs-bg-opacity)) !important;\n}\n\n.text-muted-200 {\n  --bs-text-opacity: 1;\n  color: rgba(192, 202, 207, var(--bs-text-opacity)) !important;\n}\n\n.bg-muted-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(192, 202, 207, var(--bs-bg-opacity)) !important;\n}\n\n.text-muted-700 {\n  --bs-text-opacity: 1;\n  color: rgba(58, 73, 80, var(--bs-text-opacity)) !important;\n}\n\n.bg-muted-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(58, 73, 80, var(--bs-bg-opacity)) !important;\n}\n\n.text-muted-300 {\n  --bs-text-opacity: 1;\n  color: rgba(160, 175, 182, var(--bs-text-opacity)) !important;\n}\n\n.bg-muted-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(160, 175, 182, var(--bs-bg-opacity)) !important;\n}\n\n.text-muted-800 {\n  --bs-text-opacity: 1;\n  color: rgba(39, 49, 54, var(--bs-text-opacity)) !important;\n}\n\n.bg-muted-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(39, 49, 54, var(--bs-bg-opacity)) !important;\n}\n\n.text-muted-400 {\n  --bs-text-opacity: 1;\n  color: rgba(129, 149, 158, var(--bs-text-opacity)) !important;\n}\n\n.bg-muted-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(129, 149, 158, var(--bs-bg-opacity)) !important;\n}\n\n.text-muted-900 {\n  --bs-text-opacity: 1;\n  color: rgba(19, 24, 27, var(--bs-text-opacity)) !important;\n}\n\n.bg-muted-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(19, 24, 27, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-light {\n  background-color: #c0cacf !important;\n  background-image: -moz-linear-gradient(top, #dde2e5, #b2bec4) !important;\n  background-image: -webkit-linear-gradient(top, #dde2e5, #b2bec4) !important;\n  background-image: linear-gradient(to bottom, #dde2e5, #b2bec4) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-light {\n  --bs-theme: #c0cacf !important;\n  --bs-theme-rgb: 192, 202, 207 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-light-100 {\n  --bs-text-opacity: 1;\n  color: rgba(242, 244, 245, var(--bs-text-opacity)) !important;\n}\n\n.bg-light-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(242, 244, 245, var(--bs-bg-opacity)) !important;\n}\n\n.text-light-600 {\n  --bs-text-opacity: 1;\n  color: rgba(154, 162, 166, var(--bs-text-opacity)) !important;\n}\n\n.bg-light-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(154, 162, 166, var(--bs-bg-opacity)) !important;\n}\n\n.text-light-200 {\n  --bs-text-opacity: 1;\n  color: rgba(230, 234, 236, var(--bs-text-opacity)) !important;\n}\n\n.bg-light-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(230, 234, 236, var(--bs-bg-opacity)) !important;\n}\n\n.text-light-700 {\n  --bs-text-opacity: 1;\n  color: rgba(115, 121, 124, var(--bs-text-opacity)) !important;\n}\n\n.bg-light-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(115, 121, 124, var(--bs-bg-opacity)) !important;\n}\n\n.text-light-300 {\n  --bs-text-opacity: 1;\n  color: rgba(217, 223, 226, var(--bs-text-opacity)) !important;\n}\n\n.bg-light-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(217, 223, 226, var(--bs-bg-opacity)) !important;\n}\n\n.text-light-800 {\n  --bs-text-opacity: 1;\n  color: rgba(77, 81, 83, var(--bs-text-opacity)) !important;\n}\n\n.bg-light-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(77, 81, 83, var(--bs-bg-opacity)) !important;\n}\n\n.text-light-400 {\n  --bs-text-opacity: 1;\n  color: rgba(205, 213, 217, var(--bs-text-opacity)) !important;\n}\n\n.bg-light-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(205, 213, 217, var(--bs-bg-opacity)) !important;\n}\n\n.text-light-900 {\n  --bs-text-opacity: 1;\n  color: rgba(38, 40, 41, var(--bs-text-opacity)) !important;\n}\n\n.bg-light-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(38, 40, 41, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-lime {\n  background-color: #50b00a !important;\n  background-image: -moz-linear-gradient(top, #66e00d, #459809) !important;\n  background-image: -webkit-linear-gradient(top, #66e00d, #459809) !important;\n  background-image: linear-gradient(to bottom, #66e00d, #459809) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-lime {\n  --bs-theme: #50b00a !important;\n  --bs-theme-rgb: 80, 176, 10 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-lime-100 {\n  --bs-text-opacity: 1;\n  color: rgba(220, 239, 206, var(--bs-text-opacity)) !important;\n}\n\n.bg-lime-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(220, 239, 206, var(--bs-bg-opacity)) !important;\n}\n\n.text-lime-600 {\n  --bs-text-opacity: 1;\n  color: rgba(64, 141, 8, var(--bs-text-opacity)) !important;\n}\n\n.bg-lime-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(64, 141, 8, var(--bs-bg-opacity)) !important;\n}\n\n.text-lime-200 {\n  --bs-text-opacity: 1;\n  color: rgba(185, 223, 157, var(--bs-text-opacity)) !important;\n}\n\n.bg-lime-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(185, 223, 157, var(--bs-bg-opacity)) !important;\n}\n\n.text-lime-700 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 106, 6, var(--bs-text-opacity)) !important;\n}\n\n.bg-lime-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 106, 6, var(--bs-bg-opacity)) !important;\n}\n\n.text-lime-300 {\n  --bs-text-opacity: 1;\n  color: rgba(150, 208, 108, var(--bs-text-opacity)) !important;\n}\n\n.bg-lime-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(150, 208, 108, var(--bs-bg-opacity)) !important;\n}\n\n.text-lime-800 {\n  --bs-text-opacity: 1;\n  color: rgba(32, 70, 4, var(--bs-text-opacity)) !important;\n}\n\n.bg-lime-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(32, 70, 4, var(--bs-bg-opacity)) !important;\n}\n\n.text-lime-400 {\n  --bs-text-opacity: 1;\n  color: rgba(115, 192, 59, var(--bs-text-opacity)) !important;\n}\n\n.bg-lime-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(115, 192, 59, var(--bs-bg-opacity)) !important;\n}\n\n.text-lime-900 {\n  --bs-text-opacity: 1;\n  color: rgba(16, 35, 2, var(--bs-text-opacity)) !important;\n}\n\n.bg-lime-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(16, 35, 2, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-100 {\n  background-color: #c0cacf !important;\n  background-image: -moz-linear-gradient(top, #dde2e5, #b2bec4) !important;\n  background-image: -webkit-linear-gradient(top, #dde2e5, #b2bec4) !important;\n  background-image: linear-gradient(to bottom, #dde2e5, #b2bec4) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-100 {\n  --bs-theme: #c0cacf !important;\n  --bs-theme-rgb: 192, 202, 207 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-gray-100-100 {\n  --bs-text-opacity: 1;\n  color: rgba(242, 244, 245, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-100-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(242, 244, 245, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-100-600 {\n  --bs-text-opacity: 1;\n  color: rgba(154, 162, 166, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-100-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(154, 162, 166, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-100-200 {\n  --bs-text-opacity: 1;\n  color: rgba(230, 234, 236, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-100-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(230, 234, 236, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-100-700 {\n  --bs-text-opacity: 1;\n  color: rgba(115, 121, 124, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-100-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(115, 121, 124, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-100-300 {\n  --bs-text-opacity: 1;\n  color: rgba(217, 223, 226, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-100-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(217, 223, 226, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-100-800 {\n  --bs-text-opacity: 1;\n  color: rgba(77, 81, 83, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-100-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(77, 81, 83, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-100-400 {\n  --bs-text-opacity: 1;\n  color: rgba(205, 213, 217, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-100-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(205, 213, 217, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-100-900 {\n  --bs-text-opacity: 1;\n  color: rgba(38, 40, 41, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-100-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(38, 40, 41, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-200 {\n  background-color: #a8b6bc !important;\n  background-image: -moz-linear-gradient(top, #c5ced2, #9aaab1) !important;\n  background-image: -webkit-linear-gradient(top, #c5ced2, #9aaab1) !important;\n  background-image: linear-gradient(to bottom, #c5ced2, #9aaab1) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-200 {\n  --bs-theme: #a8b6bc !important;\n  --bs-theme-rgb: 168, 182, 188 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-gray-200-100 {\n  --bs-text-opacity: 1;\n  color: rgba(238, 240, 242, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-200-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(238, 240, 242, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-200-600 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 146, 150, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-200-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 146, 150, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-200-200 {\n  --bs-text-opacity: 1;\n  color: rgba(220, 226, 228, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-200-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(220, 226, 228, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-200-700 {\n  --bs-text-opacity: 1;\n  color: rgba(101, 109, 113, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-200-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(101, 109, 113, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-200-300 {\n  --bs-text-opacity: 1;\n  color: rgba(203, 211, 215, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-200-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(203, 211, 215, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-200-800 {\n  --bs-text-opacity: 1;\n  color: rgba(67, 73, 75, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-200-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(67, 73, 75, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-200-400 {\n  --bs-text-opacity: 1;\n  color: rgba(185, 197, 201, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-200-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(185, 197, 201, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-200-900 {\n  --bs-text-opacity: 1;\n  color: rgba(34, 36, 38, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-200-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(34, 36, 38, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-300 {\n  background-color: #90a2aa !important;\n  background-image: -moz-linear-gradient(top, #adbac0, #82969f) !important;\n  background-image: -webkit-linear-gradient(top, #adbac0, #82969f) !important;\n  background-image: linear-gradient(to bottom, #adbac0, #82969f) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-300 {\n  --bs-theme: #90a2aa !important;\n  --bs-theme-rgb: 144, 162, 170 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-gray-300-100 {\n  --bs-text-opacity: 1;\n  color: rgba(233, 236, 238, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-300-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(233, 236, 238, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-300-600 {\n  --bs-text-opacity: 1;\n  color: rgba(115, 130, 136, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-300-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(115, 130, 136, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-300-200 {\n  --bs-text-opacity: 1;\n  color: rgba(211, 218, 221, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-300-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(211, 218, 221, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-300-700 {\n  --bs-text-opacity: 1;\n  color: rgba(86, 97, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-300-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(86, 97, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-300-300 {\n  --bs-text-opacity: 1;\n  color: rgba(188, 199, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-300-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(188, 199, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-300-800 {\n  --bs-text-opacity: 1;\n  color: rgba(58, 65, 68, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-300-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(58, 65, 68, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-300-400 {\n  --bs-text-opacity: 1;\n  color: rgba(166, 181, 187, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-300-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(166, 181, 187, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-300-900 {\n  --bs-text-opacity: 1;\n  color: rgba(29, 32, 34, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-300-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(29, 32, 34, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-400 {\n  background-color: #798e98 !important;\n  background-image: -moz-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: -webkit-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-400 {\n  --bs-theme: #798e98 !important;\n  --bs-theme-rgb: 121, 142, 152 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-gray-400-100 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-400-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-400-600 {\n  --bs-text-opacity: 1;\n  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-400-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-400-200 {\n  --bs-text-opacity: 1;\n  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-400-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-400-700 {\n  --bs-text-opacity: 1;\n  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-400-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-400-300 {\n  --bs-text-opacity: 1;\n  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-400-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-400-800 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-400-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-400-400 {\n  --bs-text-opacity: 1;\n  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-400-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-400-900 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-400-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-500 {\n  background-color: #617a86 !important;\n  background-image: -moz-linear-gradient(top, #7b939f, #566d77) !important;\n  background-image: -webkit-linear-gradient(top, #7b939f, #566d77) !important;\n  background-image: linear-gradient(to bottom, #7b939f, #566d77) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-500 {\n  --bs-theme: #617a86 !important;\n  --bs-theme-rgb: 97, 122, 134 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-gray-500-100 {\n  --bs-text-opacity: 1;\n  color: rgba(223, 228, 231, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-500-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(223, 228, 231, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-500-600 {\n  --bs-text-opacity: 1;\n  color: rgba(78, 98, 107, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-500-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(78, 98, 107, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-500-200 {\n  --bs-text-opacity: 1;\n  color: rgba(192, 202, 207, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-500-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(192, 202, 207, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-500-700 {\n  --bs-text-opacity: 1;\n  color: rgba(58, 73, 80, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-500-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(58, 73, 80, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-500-300 {\n  --bs-text-opacity: 1;\n  color: rgba(160, 175, 182, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-500-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(160, 175, 182, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-500-800 {\n  --bs-text-opacity: 1;\n  color: rgba(39, 49, 54, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-500-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(39, 49, 54, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-500-400 {\n  --bs-text-opacity: 1;\n  color: rgba(129, 149, 158, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-500-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(129, 149, 158, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-500-900 {\n  --bs-text-opacity: 1;\n  color: rgba(19, 24, 27, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-500-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(19, 24, 27, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-600 {\n  background-color: #526872 !important;\n  background-image: -moz-linear-gradient(top, #678390, #475a63) !important;\n  background-image: -webkit-linear-gradient(top, #678390, #475a63) !important;\n  background-image: linear-gradient(to bottom, #678390, #475a63) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-600 {\n  --bs-theme: #526872 !important;\n  --bs-theme-rgb: 82, 104, 114 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-gray-600-100 {\n  --bs-text-opacity: 1;\n  color: rgba(220, 225, 227, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-600-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(220, 225, 227, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-600-600 {\n  --bs-text-opacity: 1;\n  color: rgba(66, 83, 91, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-600-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(66, 83, 91, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-600-200 {\n  --bs-text-opacity: 1;\n  color: rgba(186, 195, 199, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-600-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(186, 195, 199, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-600-700 {\n  --bs-text-opacity: 1;\n  color: rgba(49, 62, 68, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-600-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(49, 62, 68, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-600-300 {\n  --bs-text-opacity: 1;\n  color: rgba(151, 164, 170, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-600-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(151, 164, 170, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-600-800 {\n  --bs-text-opacity: 1;\n  color: rgba(33, 42, 46, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-600-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(33, 42, 46, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-600-400 {\n  --bs-text-opacity: 1;\n  color: rgba(117, 134, 142, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-600-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(117, 134, 142, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-600-900 {\n  --bs-text-opacity: 1;\n  color: rgba(16, 21, 23, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-600-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(16, 21, 23, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-700 {\n  background-color: #44555e !important;\n  background-image: -moz-linear-gradient(top, #59707c, #39484f) !important;\n  background-image: -webkit-linear-gradient(top, #59707c, #39484f) !important;\n  background-image: linear-gradient(to bottom, #59707c, #39484f) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-700 {\n  --bs-theme: #44555e !important;\n  --bs-theme-rgb: 68, 85, 94 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-gray-700-100 {\n  --bs-text-opacity: 1;\n  color: rgba(218, 221, 223, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-700-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(218, 221, 223, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-700-600 {\n  --bs-text-opacity: 1;\n  color: rgba(54, 68, 75, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-700-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(54, 68, 75, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-700-200 {\n  --bs-text-opacity: 1;\n  color: rgba(180, 187, 191, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-700-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(180, 187, 191, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-700-700 {\n  --bs-text-opacity: 1;\n  color: rgba(41, 51, 56, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-700-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(41, 51, 56, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-700-300 {\n  --bs-text-opacity: 1;\n  color: rgba(143, 153, 158, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-700-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(143, 153, 158, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-700-800 {\n  --bs-text-opacity: 1;\n  color: rgba(27, 34, 38, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-700-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(27, 34, 38, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-700-400 {\n  --bs-text-opacity: 1;\n  color: rgba(105, 119, 126, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-700-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(105, 119, 126, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-700-900 {\n  --bs-text-opacity: 1;\n  color: rgba(14, 17, 19, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-700-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(14, 17, 19, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-800 {\n  background-color: #35434a !important;\n  background-image: -moz-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: -webkit-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-800 {\n  --bs-theme: #35434a !important;\n  --bs-theme-rgb: 53, 67, 74 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-gray-800-100 {\n  --bs-text-opacity: 1;\n  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-800-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-800-600 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-800-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-800-200 {\n  --bs-text-opacity: 1;\n  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-800-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-800-700 {\n  --bs-text-opacity: 1;\n  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-800-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-800-300 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-800-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-800-800 {\n  --bs-text-opacity: 1;\n  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-800-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-800-400 {\n  --bs-text-opacity: 1;\n  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-800-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-800-900 {\n  --bs-text-opacity: 1;\n  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-800-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-900 {\n  background-color: #273136 !important;\n  background-image: -moz-linear-gradient(top, #3c4c54, #1c2427) !important;\n  background-image: -webkit-linear-gradient(top, #3c4c54, #1c2427) !important;\n  background-image: linear-gradient(to bottom, #3c4c54, #1c2427) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-900 {\n  --bs-theme: #273136 !important;\n  --bs-theme-rgb: 39, 49, 54 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-gray-900-100 {\n  --bs-text-opacity: 1;\n  color: rgba(212, 214, 215, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-900-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(212, 214, 215, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-900-600 {\n  --bs-text-opacity: 1;\n  color: rgba(31, 39, 43, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-900-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(31, 39, 43, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-900-200 {\n  --bs-text-opacity: 1;\n  color: rgba(169, 173, 175, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-900-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(169, 173, 175, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-900-700 {\n  --bs-text-opacity: 1;\n  color: rgba(23, 29, 32, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-900-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(23, 29, 32, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-900-300 {\n  --bs-text-opacity: 1;\n  color: rgba(125, 131, 134, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-900-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(125, 131, 134, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-900-800 {\n  --bs-text-opacity: 1;\n  color: rgba(16, 20, 22, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-900-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(16, 20, 22, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-900-400 {\n  --bs-text-opacity: 1;\n  color: rgba(82, 90, 94, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-900-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(82, 90, 94, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-900-900 {\n  --bs-text-opacity: 1;\n  color: rgba(8, 10, 11, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-900-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(8, 10, 11, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-blue {\n  background-color: #0271ff !important;\n  background-image: -moz-linear-gradient(top, #358eff, #0066e8) !important;\n  background-image: -webkit-linear-gradient(top, #358eff, #0066e8) !important;\n  background-image: linear-gradient(to bottom, #358eff, #0066e8) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-blue {\n  --bs-theme: #0271ff !important;\n  --bs-theme-rgb: 2, 113, 255 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-blue-100 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 227, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-blue-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 227, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-blue-600 {\n  --bs-text-opacity: 1;\n  color: rgba(2, 90, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-blue-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(2, 90, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-blue-200 {\n  --bs-text-opacity: 1;\n  color: rgba(154, 198, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-blue-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(154, 198, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-blue-700 {\n  --bs-text-opacity: 1;\n  color: rgba(1, 68, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-blue-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(1, 68, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-blue-300 {\n  --bs-text-opacity: 1;\n  color: rgba(103, 170, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-blue-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(103, 170, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-blue-800 {\n  --bs-text-opacity: 1;\n  color: rgba(1, 45, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-blue-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(1, 45, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-blue-400 {\n  --bs-text-opacity: 1;\n  color: rgba(53, 141, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-blue-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(53, 141, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-blue-900 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 23, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-blue-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 23, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-indigo {\n  background-color: #5c25ff !important;\n  background-image: -moz-linear-gradient(top, #8258ff, #490cff) !important;\n  background-image: -webkit-linear-gradient(top, #8258ff, #490cff) !important;\n  background-image: linear-gradient(to bottom, #8258ff, #490cff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-indigo {\n  --bs-theme: #5c25ff !important;\n  --bs-theme-rgb: 92, 37, 255 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-indigo-100 {\n  --bs-text-opacity: 1;\n  color: rgba(222, 211, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(222, 211, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-600 {\n  --bs-text-opacity: 1;\n  color: rgba(74, 30, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(74, 30, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-200 {\n  --bs-text-opacity: 1;\n  color: rgba(190, 168, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(190, 168, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-700 {\n  --bs-text-opacity: 1;\n  color: rgba(55, 22, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(55, 22, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-300 {\n  --bs-text-opacity: 1;\n  color: rgba(157, 124, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(157, 124, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-800 {\n  --bs-text-opacity: 1;\n  color: rgba(37, 15, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(37, 15, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-400 {\n  --bs-text-opacity: 1;\n  color: rgba(125, 81, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(125, 81, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-indigo-900 {\n  --bs-text-opacity: 1;\n  color: rgba(18, 7, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-indigo-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(18, 7, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-purple {\n  background-color: #b90dff !important;\n  background-image: -moz-linear-gradient(top, #c840ff, #ac00f3) !important;\n  background-image: -webkit-linear-gradient(top, #c840ff, #ac00f3) !important;\n  background-image: linear-gradient(to bottom, #c840ff, #ac00f3) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-purple {\n  --bs-theme: #b90dff !important;\n  --bs-theme-rgb: 185, 13, 255 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-purple-100 {\n  --bs-text-opacity: 1;\n  color: rgba(241, 207, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(241, 207, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-600 {\n  --bs-text-opacity: 1;\n  color: rgba(148, 10, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(148, 10, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-200 {\n  --bs-text-opacity: 1;\n  color: rgba(227, 158, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(227, 158, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-700 {\n  --bs-text-opacity: 1;\n  color: rgba(111, 8, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(111, 8, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-300 {\n  --bs-text-opacity: 1;\n  color: rgba(213, 110, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(213, 110, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-800 {\n  --bs-text-opacity: 1;\n  color: rgba(74, 5, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(74, 5, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-400 {\n  --bs-text-opacity: 1;\n  color: rgba(199, 61, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(199, 61, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-purple-900 {\n  --bs-text-opacity: 1;\n  color: rgba(37, 3, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-purple-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(37, 3, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-pink {\n  background-color: #e61079 !important;\n  background-image: -moz-linear-gradient(top, #f13893, #ce0e6c) !important;\n  background-image: -webkit-linear-gradient(top, #f13893, #ce0e6c) !important;\n  background-image: linear-gradient(to bottom, #f13893, #ce0e6c) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-pink {\n  --bs-theme: #e61079 !important;\n  --bs-theme-rgb: 230, 16, 121 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-pink-100 {\n  --bs-text-opacity: 1;\n  color: rgba(250, 207, 228, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(250, 207, 228, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-600 {\n  --bs-text-opacity: 1;\n  color: rgba(184, 13, 97, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(184, 13, 97, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-200 {\n  --bs-text-opacity: 1;\n  color: rgba(245, 159, 201, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(245, 159, 201, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-700 {\n  --bs-text-opacity: 1;\n  color: rgba(138, 10, 73, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(138, 10, 73, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-300 {\n  --bs-text-opacity: 1;\n  color: rgba(240, 112, 175, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(240, 112, 175, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-800 {\n  --bs-text-opacity: 1;\n  color: rgba(92, 6, 48, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(92, 6, 48, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-400 {\n  --bs-text-opacity: 1;\n  color: rgba(235, 64, 148, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(235, 64, 148, var(--bs-bg-opacity)) !important;\n}\n\n.text-pink-900 {\n  --bs-text-opacity: 1;\n  color: rgba(46, 3, 24, var(--bs-text-opacity)) !important;\n}\n\n.bg-pink-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(46, 3, 24, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-red {\n  background-color: #e00000 !important;\n  background-image: -moz-linear-gradient(top, #ff1414, #c70000) !important;\n  background-image: -webkit-linear-gradient(top, #ff1414, #c70000) !important;\n  background-image: linear-gradient(to bottom, #ff1414, #c70000) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-red {\n  --bs-theme: #e00000 !important;\n  --bs-theme-rgb: 224, 0, 0 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-red-100 {\n  --bs-text-opacity: 1;\n  color: rgba(249, 204, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(249, 204, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-600 {\n  --bs-text-opacity: 1;\n  color: rgba(179, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(179, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-200 {\n  --bs-text-opacity: 1;\n  color: rgba(243, 153, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(243, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-700 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-300 {\n  --bs-text-opacity: 1;\n  color: rgba(236, 102, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(236, 102, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-800 {\n  --bs-text-opacity: 1;\n  color: rgba(90, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(90, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-400 {\n  --bs-text-opacity: 1;\n  color: rgba(230, 51, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(230, 51, 51, var(--bs-bg-opacity)) !important;\n}\n\n.text-red-900 {\n  --bs-text-opacity: 1;\n  color: rgba(45, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-red-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(45, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-orange {\n  background-color: #ff9f0c !important;\n  background-image: -moz-linear-gradient(top, #ffb33f, #f29200) !important;\n  background-image: -webkit-linear-gradient(top, #ffb33f, #f29200) !important;\n  background-image: linear-gradient(to bottom, #ffb33f, #f29200) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-orange {\n  --bs-theme: #ff9f0c !important;\n  --bs-theme-rgb: 255, 159, 12 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-orange-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 236, 206, var(--bs-text-opacity)) !important;\n}\n\n.bg-orange-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 236, 206, var(--bs-bg-opacity)) !important;\n}\n\n.text-orange-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 127, 10, var(--bs-text-opacity)) !important;\n}\n\n.bg-orange-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 127, 10, var(--bs-bg-opacity)) !important;\n}\n\n.text-orange-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 217, 158, var(--bs-text-opacity)) !important;\n}\n\n.bg-orange-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 217, 158, var(--bs-bg-opacity)) !important;\n}\n\n.text-orange-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 95, 7, var(--bs-text-opacity)) !important;\n}\n\n.bg-orange-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 95, 7, var(--bs-bg-opacity)) !important;\n}\n\n.text-orange-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 197, 109, var(--bs-text-opacity)) !important;\n}\n\n.bg-orange-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 197, 109, var(--bs-bg-opacity)) !important;\n}\n\n.text-orange-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 64, 5, var(--bs-text-opacity)) !important;\n}\n\n.bg-orange-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 64, 5, var(--bs-bg-opacity)) !important;\n}\n\n.text-orange-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 178, 61, var(--bs-text-opacity)) !important;\n}\n\n.bg-orange-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 178, 61, var(--bs-bg-opacity)) !important;\n}\n\n.text-orange-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 32, 2, var(--bs-text-opacity)) !important;\n}\n\n.bg-orange-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 32, 2, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-yellow {\n  background-color: #f9e80d !important;\n  background-image: -moz-linear-gradient(top, #faed3f, #e7d706) !important;\n  background-image: -webkit-linear-gradient(top, #faed3f, #e7d706) !important;\n  background-image: linear-gradient(to bottom, #faed3f, #e7d706) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-yellow {\n  --bs-theme: #f9e80d !important;\n  --bs-theme-rgb: 249, 232, 13 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-yellow-100 {\n  --bs-text-opacity: 1;\n  color: rgba(254, 250, 207, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(254, 250, 207, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-600 {\n  --bs-text-opacity: 1;\n  color: rgba(199, 186, 10, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(199, 186, 10, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-200 {\n  --bs-text-opacity: 1;\n  color: rgba(253, 246, 158, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(253, 246, 158, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-700 {\n  --bs-text-opacity: 1;\n  color: rgba(149, 139, 8, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(149, 139, 8, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-300 {\n  --bs-text-opacity: 1;\n  color: rgba(251, 241, 110, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(251, 241, 110, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-800 {\n  --bs-text-opacity: 1;\n  color: rgba(100, 93, 5, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(100, 93, 5, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-400 {\n  --bs-text-opacity: 1;\n  color: rgba(250, 237, 61, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(250, 237, 61, var(--bs-bg-opacity)) !important;\n}\n\n.text-yellow-900 {\n  --bs-text-opacity: 1;\n  color: rgba(50, 46, 3, var(--bs-text-opacity)) !important;\n}\n\n.bg-yellow-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(50, 46, 3, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-green {\n  background-color: #148922 !important;\n  background-image: -moz-linear-gradient(top, #1ab62d, #11731c) !important;\n  background-image: -webkit-linear-gradient(top, #1ab62d, #11731c) !important;\n  background-image: linear-gradient(to bottom, #1ab62d, #11731c) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-green {\n  --bs-theme: #148922 !important;\n  --bs-theme-rgb: 20, 137, 34 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-green-100 {\n  --bs-text-opacity: 1;\n  color: rgba(208, 231, 211, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(208, 231, 211, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-600 {\n  --bs-text-opacity: 1;\n  color: rgba(16, 110, 27, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(16, 110, 27, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-200 {\n  --bs-text-opacity: 1;\n  color: rgba(161, 208, 167, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(161, 208, 167, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-700 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 82, 20, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 82, 20, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-300 {\n  --bs-text-opacity: 1;\n  color: rgba(114, 184, 122, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(114, 184, 122, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-800 {\n  --bs-text-opacity: 1;\n  color: rgba(8, 55, 14, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(8, 55, 14, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-400 {\n  --bs-text-opacity: 1;\n  color: rgba(67, 161, 78, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(67, 161, 78, var(--bs-bg-opacity)) !important;\n}\n\n.text-green-900 {\n  --bs-text-opacity: 1;\n  color: rgba(4, 27, 7, var(--bs-text-opacity)) !important;\n}\n\n.bg-green-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(4, 27, 7, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-teal {\n  background-color: #249d79 !important;\n  background-image: -moz-linear-gradient(top, #2ec699, #1f8869) !important;\n  background-image: -webkit-linear-gradient(top, #2ec699, #1f8869) !important;\n  background-image: linear-gradient(to bottom, #2ec699, #1f8869) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-teal {\n  --bs-theme: #249d79 !important;\n  --bs-theme-rgb: 36, 157, 121 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-teal-100 {\n  --bs-text-opacity: 1;\n  color: rgba(211, 235, 228, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(211, 235, 228, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-600 {\n  --bs-text-opacity: 1;\n  color: rgba(29, 126, 97, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(29, 126, 97, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-200 {\n  --bs-text-opacity: 1;\n  color: rgba(167, 216, 201, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(167, 216, 201, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-700 {\n  --bs-text-opacity: 1;\n  color: rgba(22, 94, 73, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(22, 94, 73, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-300 {\n  --bs-text-opacity: 1;\n  color: rgba(124, 196, 175, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(124, 196, 175, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-800 {\n  --bs-text-opacity: 1;\n  color: rgba(14, 63, 48, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(14, 63, 48, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-400 {\n  --bs-text-opacity: 1;\n  color: rgba(80, 177, 148, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(80, 177, 148, var(--bs-bg-opacity)) !important;\n}\n\n.text-teal-900 {\n  --bs-text-opacity: 1;\n  color: rgba(7, 31, 24, var(--bs-text-opacity)) !important;\n}\n\n.bg-teal-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(7, 31, 24, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-cyan {\n  background-color: #009be3 !important;\n  background-image: -moz-linear-gradient(top, #17b5ff, #008aca) !important;\n  background-image: -webkit-linear-gradient(top, #17b5ff, #008aca) !important;\n  background-image: linear-gradient(to bottom, #17b5ff, #008aca) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-cyan {\n  --bs-theme: #009be3 !important;\n  --bs-theme-rgb: 0, 155, 227 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-cyan-100 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 235, 249, var(--bs-text-opacity)) !important;\n}\n\n.bg-cyan-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 235, 249, var(--bs-bg-opacity)) !important;\n}\n\n.text-cyan-600 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 124, 182, var(--bs-text-opacity)) !important;\n}\n\n.bg-cyan-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 124, 182, var(--bs-bg-opacity)) !important;\n}\n\n.text-cyan-200 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 215, 244, var(--bs-text-opacity)) !important;\n}\n\n.bg-cyan-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 215, 244, var(--bs-bg-opacity)) !important;\n}\n\n.text-cyan-700 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 93, 136, var(--bs-text-opacity)) !important;\n}\n\n.bg-cyan-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 93, 136, var(--bs-bg-opacity)) !important;\n}\n\n.text-cyan-300 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 195, 238, var(--bs-text-opacity)) !important;\n}\n\n.bg-cyan-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 195, 238, var(--bs-bg-opacity)) !important;\n}\n\n.text-cyan-800 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 62, 91, var(--bs-text-opacity)) !important;\n}\n\n.bg-cyan-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 62, 91, var(--bs-bg-opacity)) !important;\n}\n\n.text-cyan-400 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 175, 233, var(--bs-text-opacity)) !important;\n}\n\n.bg-cyan-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 175, 233, var(--bs-bg-opacity)) !important;\n}\n\n.text-cyan-900 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 31, 45, var(--bs-text-opacity)) !important;\n}\n\n.bg-cyan-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 31, 45, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-black {\n  background-color: #000000 !important;\n  background-image: -moz-linear-gradient(top, #1a1a1a, black) !important;\n  background-image: -webkit-linear-gradient(top, #1a1a1a, black) !important;\n  background-image: linear-gradient(to bottom, #1a1a1a, black) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-black {\n  --bs-theme: #000000 !important;\n  --bs-theme-rgb: 0, 0, 0 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-black-100 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-600 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-200 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-700 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-300 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-800 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-400 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;\n}\n\n.text-black-900 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n\n.bg-black-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-white {\n  background-color: #ffffff !important;\n  background-image: -moz-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: -webkit-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-white {\n  --bs-theme: #ffffff !important;\n  --bs-theme-rgb: 255, 255, 255 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n\n.text-white-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n\n.text-white-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;\n}\n\n.bg-white-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray {\n  background-color: #526872 !important;\n  background-image: -moz-linear-gradient(top, #678390, #475a63) !important;\n  background-image: -webkit-linear-gradient(top, #678390, #475a63) !important;\n  background-image: linear-gradient(to bottom, #678390, #475a63) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray {\n  --bs-theme: #526872 !important;\n  --bs-theme-rgb: 82, 104, 114 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-gray-100 {\n  --bs-text-opacity: 1;\n  color: rgba(220, 225, 227, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(220, 225, 227, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-600 {\n  --bs-text-opacity: 1;\n  color: rgba(66, 83, 91, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(66, 83, 91, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-200 {\n  --bs-text-opacity: 1;\n  color: rgba(186, 195, 199, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(186, 195, 199, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-700 {\n  --bs-text-opacity: 1;\n  color: rgba(49, 62, 68, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(49, 62, 68, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-300 {\n  --bs-text-opacity: 1;\n  color: rgba(151, 164, 170, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(151, 164, 170, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-800 {\n  --bs-text-opacity: 1;\n  color: rgba(33, 42, 46, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(33, 42, 46, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-400 {\n  --bs-text-opacity: 1;\n  color: rgba(117, 134, 142, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(117, 134, 142, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-900 {\n  --bs-text-opacity: 1;\n  color: rgba(16, 21, 23, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(16, 21, 23, var(--bs-bg-opacity)) !important;\n}\n\n.bg-gradient-gray-dark {\n  background-color: #35434a !important;\n  background-image: -moz-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: -webkit-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n\n:root .theme-gray-dark {\n  --bs-theme: #35434a !important;\n  --bs-theme-rgb: 53, 67, 74 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n\n.text-gray-dark-100 {\n  --bs-text-opacity: 1;\n  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-dark-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-dark-600 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-dark-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-dark-200 {\n  --bs-text-opacity: 1;\n  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-dark-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-dark-700 {\n  --bs-text-opacity: 1;\n  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-dark-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-dark-300 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-dark-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-dark-800 {\n  --bs-text-opacity: 1;\n  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-dark-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-dark-400 {\n  --bs-text-opacity: 1;\n  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-dark-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;\n}\n\n.text-gray-dark-900 {\n  --bs-text-opacity: 1;\n  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;\n}\n\n.bg-gray-dark-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;\n}\n\n[data-bs-theme=dark] {\n  --bs-default: #a8b6bc;\n  --bs-default-rgb: 168, 182, 188;\n  --bs-theme: #3cd2a5;\n  --bs-theme-rgb: 60, 210, 165;\n  --bs-primary: #4e9cff;\n  --bs-primary-rgb: 78, 156, 255;\n  --bs-secondary: #798e98;\n  --bs-secondary-rgb: 121, 142, 152;\n  --bs-warning: #ff9f0c;\n  --bs-warning-rgb: 255, 159, 12;\n  --bs-danger: #ff6060;\n  --bs-danger-rgb: 255, 96, 96;\n  --bs-success: #3cd2a5;\n  --bs-success-rgb: 60, 210, 165;\n  --bs-inverse: #ffffff;\n  --bs-inverse-rgb: 255, 255, 255;\n  --bs-info: #30beff;\n  --bs-info-rgb: 48, 190, 255;\n  --bs-dark: #35434a;\n  --bs-dark-rgb: 53, 67, 74;\n  --bs-black: #000000;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-white: #ffffff;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-purple: #de8cff;\n  --bs-purple-rgb: 222, 140, 255;\n  --bs-indigo: #bba4ff;\n  --bs-indigo-rgb: 187, 164, 255;\n  --bs-red: #ff6060;\n  --bs-red-rgb: 255, 96, 96;\n  --bs-pink: #f34fa0;\n  --bs-pink-rgb: 243, 79, 160;\n  --bs-green: #1ecc33;\n  --bs-green-rgb: 30, 204, 51;\n  --bs-yellow: #f9e80d;\n  --bs-yellow-rgb: 249, 232, 13;\n  --bs-teal: #3cd2a5;\n  --bs-teal-rgb: 60, 210, 165;\n  --bs-muted: #617a86;\n  --bs-muted-rgb: 97, 122, 134;\n  --bs-light: #c0cacf;\n  --bs-light-rgb: 192, 202, 207;\n  --bs-lime: #81f32d;\n  --bs-lime-rgb: 129, 243, 45;\n  --bs-gray-100: #c0cacf;\n  --bs-gray-100-rgb: 192, 202, 207;\n  --bs-gray-200: #a8b6bc;\n  --bs-gray-200-rgb: 168, 182, 188;\n  --bs-gray-300: #90a2aa;\n  --bs-gray-300-rgb: 144, 162, 170;\n  --bs-gray-400: #798e98;\n  --bs-gray-400-rgb: 121, 142, 152;\n  --bs-gray-500: #617a86;\n  --bs-gray-500-rgb: 97, 122, 134;\n  --bs-gray-600: #526872;\n  --bs-gray-600-rgb: 82, 104, 114;\n  --bs-gray-700: #44555e;\n  --bs-gray-700-rgb: 68, 85, 94;\n  --bs-gray-800: #35434a;\n  --bs-gray-800-rgb: 53, 67, 74;\n  --bs-gray-900: #273136;\n  --bs-gray-900-rgb: 39, 49, 54;\n  --bs-theme-color-1: #d23c3c;\n  --bs-theme-color-1-rgb: 210, 60, 60;\n  --bs-theme-color-2: #d23c5b;\n  --bs-theme-color-2-rgb: 210, 60, 91;\n  --bs-theme-color-3: #3ca7d2;\n  --bs-theme-color-3-rgb: 60, 167, 210;\n  --bs-theme-color-4: #3ccbd2;\n  --bs-theme-color-4-rgb: 60, 203, 210;\n  --bs-theme-color-5: #3cd2a5;\n  --bs-theme-color-5-rgb: 60, 210, 165;\n  --bs-theme-color-6: #3cd26a;\n  --bs-theme-color-6-rgb: 60, 210, 106;\n  --bs-theme-color-7: #a2d23c;\n  --bs-theme-color-7-rgb: 162, 210, 60;\n  --bs-theme-color-8: #d2bc3c;\n  --bs-theme-color-8-rgb: 210, 188, 60;\n  --bs-theme-color-9: #d2a83c;\n  --bs-theme-color-9-rgb: 210, 168, 60;\n  --bs-theme-color-10: #d26e3c;\n  --bs-theme-color-10-rgb: 210, 110, 60;\n}\n[data-bs-theme=dark] .bg-gradient-default {\n  background-color: #a8b6bc !important;\n  background-image: -moz-linear-gradient(top, #c5ced2, #9aaab1) !important;\n  background-image: -webkit-linear-gradient(top, #c5ced2, #9aaab1) !important;\n  background-image: linear-gradient(to bottom, #c5ced2, #9aaab1) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-default {\n  --bs-theme: #a8b6bc !important;\n  --bs-theme-rgb: 168, 182, 188 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-default-100 {\n  --bs-text-opacity: 1;\n  color: rgba(238, 240, 242, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-default-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(238, 240, 242, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-default-600 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 146, 150, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-default-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 146, 150, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-default-200 {\n  --bs-text-opacity: 1;\n  color: rgba(220, 226, 228, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-default-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(220, 226, 228, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-default-700 {\n  --bs-text-opacity: 1;\n  color: rgba(101, 109, 113, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-default-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(101, 109, 113, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-default-300 {\n  --bs-text-opacity: 1;\n  color: rgba(203, 211, 215, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-default-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(203, 211, 215, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-default-800 {\n  --bs-text-opacity: 1;\n  color: rgba(67, 73, 75, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-default-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(67, 73, 75, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-default-400 {\n  --bs-text-opacity: 1;\n  color: rgba(185, 197, 201, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-default-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(185, 197, 201, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-default-900 {\n  --bs-text-opacity: 1;\n  color: rgba(34, 36, 38, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-default-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(34, 36, 38, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme {\n  background-color: #3cd2a5 !important;\n  background-image: -moz-linear-gradient(top, #65dcb8, #2ec799) !important;\n  background-image: -webkit-linear-gradient(top, #65dcb8, #2ec799) !important;\n  background-image: linear-gradient(to bottom, #65dcb8, #2ec799) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .border-theme {\n  border-color: var(--bs-theme) !important;\n}\n[data-bs-theme=dark] .theme-theme {\n  --bs-theme: #3cd2a5 !important;\n  --bs-theme-rgb: 60, 210, 165 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-theme-100 {\n  --bs-text-opacity: 1;\n  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-600 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-200 {\n  --bs-text-opacity: 1;\n  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-700 {\n  --bs-text-opacity: 1;\n  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-300 {\n  --bs-text-opacity: 1;\n  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-800 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-400 {\n  --bs-text-opacity: 1;\n  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-900 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-primary {\n  background-color: #4e9cff !important;\n  background-image: -moz-linear-gradient(top, #81b9ff, #358eff) !important;\n  background-image: -webkit-linear-gradient(top, #81b9ff, #358eff) !important;\n  background-image: linear-gradient(to bottom, #81b9ff, #358eff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-primary {\n  --bs-theme: #4e9cff !important;\n  --bs-theme-rgb: 78, 156, 255 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-primary-100 {\n  --bs-text-opacity: 1;\n  color: rgba(220, 235, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-primary-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(220, 235, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-primary-600 {\n  --bs-text-opacity: 1;\n  color: rgba(62, 125, 204, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-primary-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(62, 125, 204, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-primary-200 {\n  --bs-text-opacity: 1;\n  color: rgba(184, 215, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-primary-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(184, 215, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-primary-700 {\n  --bs-text-opacity: 1;\n  color: rgba(47, 94, 153, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-primary-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(47, 94, 153, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-primary-300 {\n  --bs-text-opacity: 1;\n  color: rgba(149, 196, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-primary-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(149, 196, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-primary-800 {\n  --bs-text-opacity: 1;\n  color: rgba(31, 62, 102, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-primary-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(31, 62, 102, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-primary-400 {\n  --bs-text-opacity: 1;\n  color: rgba(113, 176, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-primary-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(113, 176, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-primary-900 {\n  --bs-text-opacity: 1;\n  color: rgba(16, 31, 51, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-primary-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(16, 31, 51, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-secondary {\n  background-color: #798e98 !important;\n  background-image: -moz-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: -webkit-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-secondary {\n  --bs-theme: #798e98 !important;\n  --bs-theme-rgb: 121, 142, 152 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-secondary-100 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-secondary-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-secondary-600 {\n  --bs-text-opacity: 1;\n  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-secondary-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-secondary-200 {\n  --bs-text-opacity: 1;\n  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-secondary-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-secondary-700 {\n  --bs-text-opacity: 1;\n  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-secondary-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-secondary-300 {\n  --bs-text-opacity: 1;\n  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-secondary-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-secondary-800 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-secondary-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-secondary-400 {\n  --bs-text-opacity: 1;\n  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-secondary-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-secondary-900 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-secondary-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-warning {\n  background-color: #ff9f0c !important;\n  background-image: -moz-linear-gradient(top, #ffb33f, #f29200) !important;\n  background-image: -webkit-linear-gradient(top, #ffb33f, #f29200) !important;\n  background-image: linear-gradient(to bottom, #ffb33f, #f29200) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-warning {\n  --bs-theme: #ff9f0c !important;\n  --bs-theme-rgb: 255, 159, 12 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-warning-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 236, 206, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-warning-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 236, 206, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-warning-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 127, 10, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-warning-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 127, 10, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-warning-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 217, 158, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-warning-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 217, 158, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-warning-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 95, 7, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-warning-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 95, 7, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-warning-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 197, 109, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-warning-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 197, 109, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-warning-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 64, 5, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-warning-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 64, 5, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-warning-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 178, 61, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-warning-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 178, 61, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-warning-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 32, 2, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-warning-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 32, 2, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-danger {\n  background-color: #ff6060 !important;\n  background-image: -moz-linear-gradient(top, #ff9393, #ff4747) !important;\n  background-image: -webkit-linear-gradient(top, #ff9393, #ff4747) !important;\n  background-image: linear-gradient(to bottom, #ff9393, #ff4747) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-danger {\n  --bs-theme: #ff6060 !important;\n  --bs-theme-rgb: 255, 96, 96 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-danger-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 223, 223, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-danger-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 223, 223, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-danger-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 77, 77, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-danger-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 77, 77, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-danger-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 191, 191, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-danger-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 191, 191, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-danger-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 58, 58, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-danger-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 58, 58, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-danger-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 160, 160, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-danger-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 160, 160, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-danger-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 38, 38, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-danger-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 38, 38, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-danger-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 128, 128, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-danger-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 128, 128, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-danger-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 19, 19, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-danger-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 19, 19, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-success {\n  background-color: #3cd2a5 !important;\n  background-image: -moz-linear-gradient(top, #65dcb8, #2ec799) !important;\n  background-image: -webkit-linear-gradient(top, #65dcb8, #2ec799) !important;\n  background-image: linear-gradient(to bottom, #65dcb8, #2ec799) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-success {\n  --bs-theme: #3cd2a5 !important;\n  --bs-theme-rgb: 60, 210, 165 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-success-100 {\n  --bs-text-opacity: 1;\n  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-success-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-success-600 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-success-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-success-200 {\n  --bs-text-opacity: 1;\n  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-success-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-success-700 {\n  --bs-text-opacity: 1;\n  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-success-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-success-300 {\n  --bs-text-opacity: 1;\n  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-success-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-success-800 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-success-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-success-400 {\n  --bs-text-opacity: 1;\n  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-success-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-success-900 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-success-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-inverse {\n  background-color: #ffffff !important;\n  background-image: -moz-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: -webkit-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-inverse {\n  --bs-theme: #ffffff !important;\n  --bs-theme-rgb: 255, 255, 255 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-inverse-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-inverse-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-inverse-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-inverse-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-inverse-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-inverse-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-inverse-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-inverse-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-inverse-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-inverse-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-inverse-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-inverse-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-inverse-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-inverse-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-inverse-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-inverse-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-info {\n  background-color: #30beff !important;\n  background-image: -moz-linear-gradient(top, #63ceff, #17b6ff) !important;\n  background-image: -webkit-linear-gradient(top, #63ceff, #17b6ff) !important;\n  background-image: linear-gradient(to bottom, #63ceff, #17b6ff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-info {\n  --bs-theme: #30beff !important;\n  --bs-theme-rgb: 48, 190, 255 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-info-100 {\n  --bs-text-opacity: 1;\n  color: rgba(214, 242, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-info-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(214, 242, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-info-600 {\n  --bs-text-opacity: 1;\n  color: rgba(38, 152, 204, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-info-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(38, 152, 204, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-info-200 {\n  --bs-text-opacity: 1;\n  color: rgba(172, 229, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-info-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(172, 229, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-info-700 {\n  --bs-text-opacity: 1;\n  color: rgba(29, 114, 153, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-info-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(29, 114, 153, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-info-300 {\n  --bs-text-opacity: 1;\n  color: rgba(131, 216, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-info-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(131, 216, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-info-800 {\n  --bs-text-opacity: 1;\n  color: rgba(19, 76, 102, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-info-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(19, 76, 102, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-info-400 {\n  --bs-text-opacity: 1;\n  color: rgba(89, 203, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-info-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(89, 203, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-info-900 {\n  --bs-text-opacity: 1;\n  color: rgba(10, 38, 51, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-info-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(10, 38, 51, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-dark {\n  background-color: #35434a !important;\n  background-image: -moz-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: -webkit-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-dark {\n  --bs-theme: #35434a !important;\n  --bs-theme-rgb: 53, 67, 74 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-dark-100 {\n  --bs-text-opacity: 1;\n  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-dark-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-dark-600 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-dark-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-dark-200 {\n  --bs-text-opacity: 1;\n  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-dark-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-dark-700 {\n  --bs-text-opacity: 1;\n  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-dark-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-dark-300 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-dark-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-dark-800 {\n  --bs-text-opacity: 1;\n  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-dark-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-dark-400 {\n  --bs-text-opacity: 1;\n  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-dark-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-dark-900 {\n  --bs-text-opacity: 1;\n  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-dark-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-black {\n  background-color: #000000 !important;\n  background-image: -moz-linear-gradient(top, #1a1a1a, black) !important;\n  background-image: -webkit-linear-gradient(top, #1a1a1a, black) !important;\n  background-image: linear-gradient(to bottom, #1a1a1a, black) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-black {\n  --bs-theme: #000000 !important;\n  --bs-theme-rgb: 0, 0, 0 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-black-100 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-black-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-black-600 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-black-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-black-200 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-black-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-black-700 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-black-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-black-300 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-black-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-black-800 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-black-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-black-400 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-black-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-black-900 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-black-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-white {\n  background-color: #ffffff !important;\n  background-image: -moz-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: -webkit-linear-gradient(top, white, #f2f2f2) !important;\n  background-image: linear-gradient(to bottom, white, #f2f2f2) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-white {\n  --bs-theme: #ffffff !important;\n  --bs-theme-rgb: 255, 255, 255 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-white-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-white-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-white-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-white-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-white-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-white-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-white-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-white-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-white-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-white-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-white-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-white-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-white-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-white-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-white-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-white-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-purple {\n  background-color: #de8cff !important;\n  background-image: -moz-linear-gradient(top, #edbfff, #d773ff) !important;\n  background-image: -webkit-linear-gradient(top, #edbfff, #d773ff) !important;\n  background-image: linear-gradient(to bottom, #edbfff, #d773ff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-purple {\n  --bs-theme: #de8cff !important;\n  --bs-theme-rgb: 222, 140, 255 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-purple-100 {\n  --bs-text-opacity: 1;\n  color: rgba(248, 232, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-purple-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(248, 232, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-purple-600 {\n  --bs-text-opacity: 1;\n  color: rgba(178, 112, 204, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-purple-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(178, 112, 204, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-purple-200 {\n  --bs-text-opacity: 1;\n  color: rgba(242, 209, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-purple-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(242, 209, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-purple-700 {\n  --bs-text-opacity: 1;\n  color: rgba(133, 84, 153, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-purple-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(133, 84, 153, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-purple-300 {\n  --bs-text-opacity: 1;\n  color: rgba(235, 186, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-purple-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(235, 186, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-purple-800 {\n  --bs-text-opacity: 1;\n  color: rgba(89, 56, 102, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-purple-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(89, 56, 102, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-purple-400 {\n  --bs-text-opacity: 1;\n  color: rgba(229, 163, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-purple-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(229, 163, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-purple-900 {\n  --bs-text-opacity: 1;\n  color: rgba(44, 28, 51, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-purple-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(44, 28, 51, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-indigo {\n  background-color: #bba4ff !important;\n  background-image: -moz-linear-gradient(top, #e1d7ff, #a88bff) !important;\n  background-image: -webkit-linear-gradient(top, #e1d7ff, #a88bff) !important;\n  background-image: linear-gradient(to bottom, #e1d7ff, #a88bff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-indigo {\n  --bs-theme: #bba4ff !important;\n  --bs-theme-rgb: 187, 164, 255 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-indigo-100 {\n  --bs-text-opacity: 1;\n  color: rgba(241, 237, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-indigo-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(241, 237, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-indigo-600 {\n  --bs-text-opacity: 1;\n  color: rgba(150, 131, 204, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-indigo-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(150, 131, 204, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-indigo-200 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 219, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-indigo-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 219, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-indigo-700 {\n  --bs-text-opacity: 1;\n  color: rgba(112, 98, 153, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-indigo-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(112, 98, 153, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-indigo-300 {\n  --bs-text-opacity: 1;\n  color: rgba(214, 200, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-indigo-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(214, 200, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-indigo-800 {\n  --bs-text-opacity: 1;\n  color: rgba(75, 66, 102, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-indigo-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(75, 66, 102, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-indigo-400 {\n  --bs-text-opacity: 1;\n  color: rgba(201, 182, 255, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-indigo-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(201, 182, 255, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-indigo-900 {\n  --bs-text-opacity: 1;\n  color: rgba(37, 33, 51, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-indigo-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(37, 33, 51, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-red {\n  background-color: #ff6060 !important;\n  background-image: -moz-linear-gradient(top, #ff9393, #ff4747) !important;\n  background-image: -webkit-linear-gradient(top, #ff9393, #ff4747) !important;\n  background-image: linear-gradient(to bottom, #ff9393, #ff4747) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-red {\n  --bs-theme: #ff6060 !important;\n  --bs-theme-rgb: 255, 96, 96 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-red-100 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 223, 223, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-red-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 223, 223, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-red-600 {\n  --bs-text-opacity: 1;\n  color: rgba(204, 77, 77, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-red-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(204, 77, 77, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-red-200 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 191, 191, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-red-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 191, 191, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-red-700 {\n  --bs-text-opacity: 1;\n  color: rgba(153, 58, 58, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-red-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(153, 58, 58, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-red-300 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 160, 160, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-red-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 160, 160, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-red-800 {\n  --bs-text-opacity: 1;\n  color: rgba(102, 38, 38, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-red-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(102, 38, 38, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-red-400 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 128, 128, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-red-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(255, 128, 128, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-red-900 {\n  --bs-text-opacity: 1;\n  color: rgba(51, 19, 19, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-red-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(51, 19, 19, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-pink {\n  background-color: #f34fa0 !important;\n  background-image: -moz-linear-gradient(top, #f67fba, #f13793) !important;\n  background-image: -webkit-linear-gradient(top, #f67fba, #f13793) !important;\n  background-image: linear-gradient(to bottom, #f67fba, #f13793) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-pink {\n  --bs-theme: #f34fa0 !important;\n  --bs-theme-rgb: 243, 79, 160 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-pink-100 {\n  --bs-text-opacity: 1;\n  color: rgba(253, 220, 236, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-pink-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(253, 220, 236, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-pink-600 {\n  --bs-text-opacity: 1;\n  color: rgba(194, 63, 128, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-pink-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(194, 63, 128, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-pink-200 {\n  --bs-text-opacity: 1;\n  color: rgba(250, 185, 217, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-pink-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(250, 185, 217, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-pink-700 {\n  --bs-text-opacity: 1;\n  color: rgba(146, 47, 96, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-pink-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(146, 47, 96, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-pink-300 {\n  --bs-text-opacity: 1;\n  color: rgba(248, 149, 198, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-pink-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(248, 149, 198, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-pink-800 {\n  --bs-text-opacity: 1;\n  color: rgba(97, 32, 64, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-pink-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(97, 32, 64, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-pink-400 {\n  --bs-text-opacity: 1;\n  color: rgba(245, 114, 179, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-pink-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(245, 114, 179, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-pink-900 {\n  --bs-text-opacity: 1;\n  color: rgba(49, 16, 32, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-pink-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(49, 16, 32, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-green {\n  background-color: #1ecc33 !important;\n  background-image: -moz-linear-gradient(top, #3be24f, #1bb62d) !important;\n  background-image: -webkit-linear-gradient(top, #3be24f, #1bb62d) !important;\n  background-image: linear-gradient(to bottom, #3be24f, #1bb62d) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-green {\n  --bs-theme: #1ecc33 !important;\n  --bs-theme-rgb: 30, 204, 51 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-green-100 {\n  --bs-text-opacity: 1;\n  color: rgba(210, 245, 214, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-green-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(210, 245, 214, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-green-600 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 163, 41, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-green-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 163, 41, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-green-200 {\n  --bs-text-opacity: 1;\n  color: rgba(165, 235, 173, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-green-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(165, 235, 173, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-green-700 {\n  --bs-text-opacity: 1;\n  color: rgba(18, 122, 31, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-green-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(18, 122, 31, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-green-300 {\n  --bs-text-opacity: 1;\n  color: rgba(120, 224, 133, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-green-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(120, 224, 133, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-green-800 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 82, 20, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-green-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 82, 20, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-green-400 {\n  --bs-text-opacity: 1;\n  color: rgba(75, 214, 92, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-green-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(75, 214, 92, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-green-900 {\n  --bs-text-opacity: 1;\n  color: rgba(6, 41, 10, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-green-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(6, 41, 10, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-yellow {\n  background-color: #f9e80d !important;\n  background-image: -moz-linear-gradient(top, #faed3f, #e7d706) !important;\n  background-image: -webkit-linear-gradient(top, #faed3f, #e7d706) !important;\n  background-image: linear-gradient(to bottom, #faed3f, #e7d706) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-yellow {\n  --bs-theme: #f9e80d !important;\n  --bs-theme-rgb: 249, 232, 13 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-yellow-100 {\n  --bs-text-opacity: 1;\n  color: rgba(254, 250, 207, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-yellow-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(254, 250, 207, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-yellow-600 {\n  --bs-text-opacity: 1;\n  color: rgba(199, 186, 10, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-yellow-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(199, 186, 10, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-yellow-200 {\n  --bs-text-opacity: 1;\n  color: rgba(253, 246, 158, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-yellow-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(253, 246, 158, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-yellow-700 {\n  --bs-text-opacity: 1;\n  color: rgba(149, 139, 8, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-yellow-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(149, 139, 8, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-yellow-300 {\n  --bs-text-opacity: 1;\n  color: rgba(251, 241, 110, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-yellow-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(251, 241, 110, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-yellow-800 {\n  --bs-text-opacity: 1;\n  color: rgba(100, 93, 5, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-yellow-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(100, 93, 5, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-yellow-400 {\n  --bs-text-opacity: 1;\n  color: rgba(250, 237, 61, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-yellow-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(250, 237, 61, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-yellow-900 {\n  --bs-text-opacity: 1;\n  color: rgba(50, 46, 3, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-yellow-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(50, 46, 3, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-teal {\n  background-color: #3cd2a5 !important;\n  background-image: -moz-linear-gradient(top, #65dcb8, #2ec799) !important;\n  background-image: -webkit-linear-gradient(top, #65dcb8, #2ec799) !important;\n  background-image: linear-gradient(to bottom, #65dcb8, #2ec799) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-teal {\n  --bs-theme: #3cd2a5 !important;\n  --bs-theme-rgb: 60, 210, 165 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-teal-100 {\n  --bs-text-opacity: 1;\n  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-teal-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-teal-600 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-teal-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-teal-200 {\n  --bs-text-opacity: 1;\n  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-teal-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-teal-700 {\n  --bs-text-opacity: 1;\n  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-teal-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-teal-300 {\n  --bs-text-opacity: 1;\n  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-teal-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-teal-800 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-teal-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-teal-400 {\n  --bs-text-opacity: 1;\n  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-teal-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-teal-900 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-teal-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-muted {\n  background-color: #617a86 !important;\n  background-image: -moz-linear-gradient(top, #7b939f, #566d77) !important;\n  background-image: -webkit-linear-gradient(top, #7b939f, #566d77) !important;\n  background-image: linear-gradient(to bottom, #7b939f, #566d77) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-muted {\n  --bs-theme: #617a86 !important;\n  --bs-theme-rgb: 97, 122, 134 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-muted-100 {\n  --bs-text-opacity: 1;\n  color: rgba(223, 228, 231, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-muted-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(223, 228, 231, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-muted-600 {\n  --bs-text-opacity: 1;\n  color: rgba(78, 98, 107, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-muted-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(78, 98, 107, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-muted-200 {\n  --bs-text-opacity: 1;\n  color: rgba(192, 202, 207, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-muted-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(192, 202, 207, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-muted-700 {\n  --bs-text-opacity: 1;\n  color: rgba(58, 73, 80, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-muted-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(58, 73, 80, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-muted-300 {\n  --bs-text-opacity: 1;\n  color: rgba(160, 175, 182, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-muted-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(160, 175, 182, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-muted-800 {\n  --bs-text-opacity: 1;\n  color: rgba(39, 49, 54, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-muted-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(39, 49, 54, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-muted-400 {\n  --bs-text-opacity: 1;\n  color: rgba(129, 149, 158, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-muted-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(129, 149, 158, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-muted-900 {\n  --bs-text-opacity: 1;\n  color: rgba(19, 24, 27, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-muted-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(19, 24, 27, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-light {\n  background-color: #c0cacf !important;\n  background-image: -moz-linear-gradient(top, #dde2e5, #b2bec4) !important;\n  background-image: -webkit-linear-gradient(top, #dde2e5, #b2bec4) !important;\n  background-image: linear-gradient(to bottom, #dde2e5, #b2bec4) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-light {\n  --bs-theme: #c0cacf !important;\n  --bs-theme-rgb: 192, 202, 207 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-light-100 {\n  --bs-text-opacity: 1;\n  color: rgba(242, 244, 245, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-light-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(242, 244, 245, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-light-600 {\n  --bs-text-opacity: 1;\n  color: rgba(154, 162, 166, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-light-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(154, 162, 166, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-light-200 {\n  --bs-text-opacity: 1;\n  color: rgba(230, 234, 236, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-light-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(230, 234, 236, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-light-700 {\n  --bs-text-opacity: 1;\n  color: rgba(115, 121, 124, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-light-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(115, 121, 124, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-light-300 {\n  --bs-text-opacity: 1;\n  color: rgba(217, 223, 226, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-light-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(217, 223, 226, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-light-800 {\n  --bs-text-opacity: 1;\n  color: rgba(77, 81, 83, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-light-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(77, 81, 83, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-light-400 {\n  --bs-text-opacity: 1;\n  color: rgba(205, 213, 217, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-light-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(205, 213, 217, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-light-900 {\n  --bs-text-opacity: 1;\n  color: rgba(38, 40, 41, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-light-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(38, 40, 41, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-lime {\n  background-color: #81f32d !important;\n  background-image: -moz-linear-gradient(top, #9ef65d, #73f215) !important;\n  background-image: -webkit-linear-gradient(top, #9ef65d, #73f215) !important;\n  background-image: linear-gradient(to bottom, #9ef65d, #73f215) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-lime {\n  --bs-theme: #81f32d !important;\n  --bs-theme-rgb: 129, 243, 45 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-lime-100 {\n  --bs-text-opacity: 1;\n  color: rgba(230, 253, 213, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-lime-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(230, 253, 213, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-lime-600 {\n  --bs-text-opacity: 1;\n  color: rgba(103, 194, 36, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-lime-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(103, 194, 36, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-lime-200 {\n  --bs-text-opacity: 1;\n  color: rgba(205, 250, 171, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-lime-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(205, 250, 171, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-lime-700 {\n  --bs-text-opacity: 1;\n  color: rgba(77, 146, 27, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-lime-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(77, 146, 27, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-lime-300 {\n  --bs-text-opacity: 1;\n  color: rgba(179, 248, 129, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-lime-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(179, 248, 129, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-lime-800 {\n  --bs-text-opacity: 1;\n  color: rgba(52, 97, 18, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-lime-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(52, 97, 18, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-lime-400 {\n  --bs-text-opacity: 1;\n  color: rgba(154, 245, 87, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-lime-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(154, 245, 87, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-lime-900 {\n  --bs-text-opacity: 1;\n  color: rgba(26, 49, 9, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-lime-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(26, 49, 9, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-gray-100 {\n  background-color: #c0cacf !important;\n  background-image: -moz-linear-gradient(top, #dde2e5, #b2bec4) !important;\n  background-image: -webkit-linear-gradient(top, #dde2e5, #b2bec4) !important;\n  background-image: linear-gradient(to bottom, #dde2e5, #b2bec4) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-gray-100 {\n  --bs-theme: #c0cacf !important;\n  --bs-theme-rgb: 192, 202, 207 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-gray-100-100 {\n  --bs-text-opacity: 1;\n  color: rgba(242, 244, 245, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-100-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(242, 244, 245, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-100-600 {\n  --bs-text-opacity: 1;\n  color: rgba(154, 162, 166, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-100-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(154, 162, 166, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-100-200 {\n  --bs-text-opacity: 1;\n  color: rgba(230, 234, 236, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-100-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(230, 234, 236, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-100-700 {\n  --bs-text-opacity: 1;\n  color: rgba(115, 121, 124, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-100-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(115, 121, 124, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-100-300 {\n  --bs-text-opacity: 1;\n  color: rgba(217, 223, 226, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-100-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(217, 223, 226, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-100-800 {\n  --bs-text-opacity: 1;\n  color: rgba(77, 81, 83, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-100-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(77, 81, 83, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-100-400 {\n  --bs-text-opacity: 1;\n  color: rgba(205, 213, 217, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-100-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(205, 213, 217, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-100-900 {\n  --bs-text-opacity: 1;\n  color: rgba(38, 40, 41, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-100-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(38, 40, 41, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-gray-200 {\n  background-color: #a8b6bc !important;\n  background-image: -moz-linear-gradient(top, #c5ced2, #9aaab1) !important;\n  background-image: -webkit-linear-gradient(top, #c5ced2, #9aaab1) !important;\n  background-image: linear-gradient(to bottom, #c5ced2, #9aaab1) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-gray-200 {\n  --bs-theme: #a8b6bc !important;\n  --bs-theme-rgb: 168, 182, 188 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-gray-200-100 {\n  --bs-text-opacity: 1;\n  color: rgba(238, 240, 242, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-200-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(238, 240, 242, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-200-600 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 146, 150, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-200-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 146, 150, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-200-200 {\n  --bs-text-opacity: 1;\n  color: rgba(220, 226, 228, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-200-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(220, 226, 228, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-200-700 {\n  --bs-text-opacity: 1;\n  color: rgba(101, 109, 113, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-200-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(101, 109, 113, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-200-300 {\n  --bs-text-opacity: 1;\n  color: rgba(203, 211, 215, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-200-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(203, 211, 215, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-200-800 {\n  --bs-text-opacity: 1;\n  color: rgba(67, 73, 75, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-200-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(67, 73, 75, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-200-400 {\n  --bs-text-opacity: 1;\n  color: rgba(185, 197, 201, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-200-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(185, 197, 201, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-200-900 {\n  --bs-text-opacity: 1;\n  color: rgba(34, 36, 38, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-200-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(34, 36, 38, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-gray-300 {\n  background-color: #90a2aa !important;\n  background-image: -moz-linear-gradient(top, #adbac0, #82969f) !important;\n  background-image: -webkit-linear-gradient(top, #adbac0, #82969f) !important;\n  background-image: linear-gradient(to bottom, #adbac0, #82969f) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-gray-300 {\n  --bs-theme: #90a2aa !important;\n  --bs-theme-rgb: 144, 162, 170 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-gray-300-100 {\n  --bs-text-opacity: 1;\n  color: rgba(233, 236, 238, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-300-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(233, 236, 238, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-300-600 {\n  --bs-text-opacity: 1;\n  color: rgba(115, 130, 136, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-300-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(115, 130, 136, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-300-200 {\n  --bs-text-opacity: 1;\n  color: rgba(211, 218, 221, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-300-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(211, 218, 221, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-300-700 {\n  --bs-text-opacity: 1;\n  color: rgba(86, 97, 102, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-300-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(86, 97, 102, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-300-300 {\n  --bs-text-opacity: 1;\n  color: rgba(188, 199, 204, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-300-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(188, 199, 204, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-300-800 {\n  --bs-text-opacity: 1;\n  color: rgba(58, 65, 68, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-300-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(58, 65, 68, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-300-400 {\n  --bs-text-opacity: 1;\n  color: rgba(166, 181, 187, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-300-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(166, 181, 187, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-300-900 {\n  --bs-text-opacity: 1;\n  color: rgba(29, 32, 34, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-300-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(29, 32, 34, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-gray-400 {\n  background-color: #798e98 !important;\n  background-image: -moz-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: -webkit-linear-gradient(top, #96a6ae, #6c818c) !important;\n  background-image: linear-gradient(to bottom, #96a6ae, #6c818c) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-gray-400 {\n  --bs-theme: #798e98 !important;\n  --bs-theme-rgb: 121, 142, 152 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-gray-400-100 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 232, 234, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-400-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 232, 234, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-400-600 {\n  --bs-text-opacity: 1;\n  color: rgba(97, 114, 122, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-400-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(97, 114, 122, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-400-200 {\n  --bs-text-opacity: 1;\n  color: rgba(201, 210, 214, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-400-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(201, 210, 214, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-400-700 {\n  --bs-text-opacity: 1;\n  color: rgba(73, 85, 91, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-400-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(73, 85, 91, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-400-300 {\n  --bs-text-opacity: 1;\n  color: rgba(175, 187, 193, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-400-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(175, 187, 193, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-400-800 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 57, 61, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-400-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 57, 61, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-400-400 {\n  --bs-text-opacity: 1;\n  color: rgba(148, 165, 173, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-400-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(148, 165, 173, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-400-900 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 28, 30, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-400-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 28, 30, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-gray-500 {\n  background-color: #617a86 !important;\n  background-image: -moz-linear-gradient(top, #7b939f, #566d77) !important;\n  background-image: -webkit-linear-gradient(top, #7b939f, #566d77) !important;\n  background-image: linear-gradient(to bottom, #7b939f, #566d77) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-gray-500 {\n  --bs-theme: #617a86 !important;\n  --bs-theme-rgb: 97, 122, 134 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-gray-500-100 {\n  --bs-text-opacity: 1;\n  color: rgba(223, 228, 231, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-500-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(223, 228, 231, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-500-600 {\n  --bs-text-opacity: 1;\n  color: rgba(78, 98, 107, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-500-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(78, 98, 107, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-500-200 {\n  --bs-text-opacity: 1;\n  color: rgba(192, 202, 207, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-500-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(192, 202, 207, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-500-700 {\n  --bs-text-opacity: 1;\n  color: rgba(58, 73, 80, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-500-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(58, 73, 80, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-500-300 {\n  --bs-text-opacity: 1;\n  color: rgba(160, 175, 182, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-500-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(160, 175, 182, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-500-800 {\n  --bs-text-opacity: 1;\n  color: rgba(39, 49, 54, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-500-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(39, 49, 54, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-500-400 {\n  --bs-text-opacity: 1;\n  color: rgba(129, 149, 158, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-500-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(129, 149, 158, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-500-900 {\n  --bs-text-opacity: 1;\n  color: rgba(19, 24, 27, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-500-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(19, 24, 27, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-gray-600 {\n  background-color: #526872 !important;\n  background-image: -moz-linear-gradient(top, #678390, #475a63) !important;\n  background-image: -webkit-linear-gradient(top, #678390, #475a63) !important;\n  background-image: linear-gradient(to bottom, #678390, #475a63) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-gray-600 {\n  --bs-theme: #526872 !important;\n  --bs-theme-rgb: 82, 104, 114 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-gray-600-100 {\n  --bs-text-opacity: 1;\n  color: rgba(220, 225, 227, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-600-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(220, 225, 227, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-600-600 {\n  --bs-text-opacity: 1;\n  color: rgba(66, 83, 91, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-600-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(66, 83, 91, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-600-200 {\n  --bs-text-opacity: 1;\n  color: rgba(186, 195, 199, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-600-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(186, 195, 199, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-600-700 {\n  --bs-text-opacity: 1;\n  color: rgba(49, 62, 68, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-600-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(49, 62, 68, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-600-300 {\n  --bs-text-opacity: 1;\n  color: rgba(151, 164, 170, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-600-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(151, 164, 170, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-600-800 {\n  --bs-text-opacity: 1;\n  color: rgba(33, 42, 46, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-600-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(33, 42, 46, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-600-400 {\n  --bs-text-opacity: 1;\n  color: rgba(117, 134, 142, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-600-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(117, 134, 142, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-600-900 {\n  --bs-text-opacity: 1;\n  color: rgba(16, 21, 23, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-600-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(16, 21, 23, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-gray-700 {\n  background-color: #44555e !important;\n  background-image: -moz-linear-gradient(top, #59707c, #39484f) !important;\n  background-image: -webkit-linear-gradient(top, #59707c, #39484f) !important;\n  background-image: linear-gradient(to bottom, #59707c, #39484f) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-gray-700 {\n  --bs-theme: #44555e !important;\n  --bs-theme-rgb: 68, 85, 94 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-gray-700-100 {\n  --bs-text-opacity: 1;\n  color: rgba(218, 221, 223, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-700-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(218, 221, 223, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-700-600 {\n  --bs-text-opacity: 1;\n  color: rgba(54, 68, 75, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-700-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(54, 68, 75, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-700-200 {\n  --bs-text-opacity: 1;\n  color: rgba(180, 187, 191, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-700-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(180, 187, 191, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-700-700 {\n  --bs-text-opacity: 1;\n  color: rgba(41, 51, 56, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-700-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(41, 51, 56, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-700-300 {\n  --bs-text-opacity: 1;\n  color: rgba(143, 153, 158, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-700-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(143, 153, 158, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-700-800 {\n  --bs-text-opacity: 1;\n  color: rgba(27, 34, 38, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-700-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(27, 34, 38, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-700-400 {\n  --bs-text-opacity: 1;\n  color: rgba(105, 119, 126, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-700-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(105, 119, 126, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-700-900 {\n  --bs-text-opacity: 1;\n  color: rgba(14, 17, 19, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-700-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(14, 17, 19, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-gray-800 {\n  background-color: #35434a !important;\n  background-image: -moz-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: -webkit-linear-gradient(top, #4a5e68, #2a363b) !important;\n  background-image: linear-gradient(to bottom, #4a5e68, #2a363b) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-gray-800 {\n  --bs-theme: #35434a !important;\n  --bs-theme-rgb: 53, 67, 74 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-gray-800-100 {\n  --bs-text-opacity: 1;\n  color: rgba(215, 217, 219, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-800-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(215, 217, 219, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-800-600 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 54, 59, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-800-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 54, 59, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-800-200 {\n  --bs-text-opacity: 1;\n  color: rgba(174, 180, 183, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-800-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(174, 180, 183, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-800-700 {\n  --bs-text-opacity: 1;\n  color: rgba(32, 40, 44, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-800-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(32, 40, 44, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-800-300 {\n  --bs-text-opacity: 1;\n  color: rgba(134, 142, 146, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-800-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(134, 142, 146, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-800-800 {\n  --bs-text-opacity: 1;\n  color: rgba(21, 27, 30, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-800-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(21, 27, 30, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-800-400 {\n  --bs-text-opacity: 1;\n  color: rgba(93, 105, 110, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-800-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(93, 105, 110, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-800-900 {\n  --bs-text-opacity: 1;\n  color: rgba(11, 13, 15, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-800-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(11, 13, 15, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-gray-900 {\n  background-color: #273136 !important;\n  background-image: -moz-linear-gradient(top, #3c4c54, #1c2427) !important;\n  background-image: -webkit-linear-gradient(top, #3c4c54, #1c2427) !important;\n  background-image: linear-gradient(to bottom, #3c4c54, #1c2427) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-gray-900 {\n  --bs-theme: #273136 !important;\n  --bs-theme-rgb: 39, 49, 54 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-gray-900-100 {\n  --bs-text-opacity: 1;\n  color: rgba(212, 214, 215, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-900-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(212, 214, 215, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-900-600 {\n  --bs-text-opacity: 1;\n  color: rgba(31, 39, 43, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-900-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(31, 39, 43, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-900-200 {\n  --bs-text-opacity: 1;\n  color: rgba(169, 173, 175, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-900-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(169, 173, 175, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-900-700 {\n  --bs-text-opacity: 1;\n  color: rgba(23, 29, 32, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-900-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(23, 29, 32, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-900-300 {\n  --bs-text-opacity: 1;\n  color: rgba(125, 131, 134, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-900-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(125, 131, 134, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-900-800 {\n  --bs-text-opacity: 1;\n  color: rgba(16, 20, 22, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-900-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(16, 20, 22, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-900-400 {\n  --bs-text-opacity: 1;\n  color: rgba(82, 90, 94, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-900-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(82, 90, 94, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-gray-900-900 {\n  --bs-text-opacity: 1;\n  color: rgba(8, 10, 11, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gray-900-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(8, 10, 11, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-1 {\n  background-color: #d23c3c !important;\n  background-image: -moz-linear-gradient(top, #dc6565, #c72e2e) !important;\n  background-image: -webkit-linear-gradient(top, #dc6565, #c72e2e) !important;\n  background-image: linear-gradient(to bottom, #dc6565, #c72e2e) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-1 {\n  --bs-theme: #d23c3c !important;\n  --bs-theme-rgb: 210, 60, 60 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-theme-color-1-100 {\n  --bs-text-opacity: 1;\n  color: rgba(246, 216, 216, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-1-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(246, 216, 216, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-1-600 {\n  --bs-text-opacity: 1;\n  color: rgba(168, 48, 48, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-1-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(168, 48, 48, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-1-200 {\n  --bs-text-opacity: 1;\n  color: rgba(237, 177, 177, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-1-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(237, 177, 177, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-1-700 {\n  --bs-text-opacity: 1;\n  color: rgba(126, 36, 36, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-1-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(126, 36, 36, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-1-300 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 138, 138, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-1-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 138, 138, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-1-800 {\n  --bs-text-opacity: 1;\n  color: rgba(84, 24, 24, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-1-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(84, 24, 24, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-1-400 {\n  --bs-text-opacity: 1;\n  color: rgba(219, 99, 99, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-1-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(219, 99, 99, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-1-900 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 12, 12, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-1-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 12, 12, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-2 {\n  background-color: #d23c5b !important;\n  background-image: -moz-linear-gradient(top, #dc657e, #c72e4d) !important;\n  background-image: -webkit-linear-gradient(top, #dc657e, #c72e4d) !important;\n  background-image: linear-gradient(to bottom, #dc657e, #c72e4d) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-2 {\n  --bs-theme: #d23c5b !important;\n  --bs-theme-rgb: 210, 60, 91 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-theme-color-2-100 {\n  --bs-text-opacity: 1;\n  color: rgba(246, 216, 222, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-2-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(246, 216, 222, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-2-600 {\n  --bs-text-opacity: 1;\n  color: rgba(168, 48, 73, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-2-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(168, 48, 73, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-2-200 {\n  --bs-text-opacity: 1;\n  color: rgba(237, 177, 189, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-2-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(237, 177, 189, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-2-700 {\n  --bs-text-opacity: 1;\n  color: rgba(126, 36, 55, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-2-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(126, 36, 55, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-2-300 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 138, 157, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-2-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 138, 157, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-2-800 {\n  --bs-text-opacity: 1;\n  color: rgba(84, 24, 36, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-2-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(84, 24, 36, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-2-400 {\n  --bs-text-opacity: 1;\n  color: rgba(219, 99, 124, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-2-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(219, 99, 124, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-2-900 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 12, 18, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-2-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 12, 18, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-3 {\n  background-color: #3ca7d2 !important;\n  background-image: -moz-linear-gradient(top, #65badc, #2e9bc7) !important;\n  background-image: -webkit-linear-gradient(top, #65badc, #2e9bc7) !important;\n  background-image: linear-gradient(to bottom, #65badc, #2e9bc7) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-3 {\n  --bs-theme: #3ca7d2 !important;\n  --bs-theme-rgb: 60, 167, 210 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-theme-color-3-100 {\n  --bs-text-opacity: 1;\n  color: rgba(216, 237, 246, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-3-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(216, 237, 246, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-3-600 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 134, 168, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-3-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 134, 168, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-3-200 {\n  --bs-text-opacity: 1;\n  color: rgba(177, 220, 237, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-3-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(177, 220, 237, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-3-700 {\n  --bs-text-opacity: 1;\n  color: rgba(36, 100, 126, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-3-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(36, 100, 126, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-3-300 {\n  --bs-text-opacity: 1;\n  color: rgba(138, 202, 228, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-3-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(138, 202, 228, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-3-800 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 67, 84, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-3-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 67, 84, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-3-400 {\n  --bs-text-opacity: 1;\n  color: rgba(99, 185, 219, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-3-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(99, 185, 219, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-3-900 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 33, 42, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-3-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 33, 42, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-4 {\n  background-color: #3ccbd2 !important;\n  background-image: -moz-linear-gradient(top, #65d6dc, #2ec0c7) !important;\n  background-image: -webkit-linear-gradient(top, #65d6dc, #2ec0c7) !important;\n  background-image: linear-gradient(to bottom, #65d6dc, #2ec0c7) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-4 {\n  --bs-theme: #3ccbd2 !important;\n  --bs-theme-rgb: 60, 203, 210 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-theme-color-4-100 {\n  --bs-text-opacity: 1;\n  color: rgba(216, 245, 246, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-4-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(216, 245, 246, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-4-600 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 162, 168, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-4-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 162, 168, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-4-200 {\n  --bs-text-opacity: 1;\n  color: rgba(177, 234, 237, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-4-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(177, 234, 237, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-4-700 {\n  --bs-text-opacity: 1;\n  color: rgba(36, 122, 126, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-4-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(36, 122, 126, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-4-300 {\n  --bs-text-opacity: 1;\n  color: rgba(138, 224, 228, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-4-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(138, 224, 228, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-4-800 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 81, 84, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-4-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 81, 84, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-4-400 {\n  --bs-text-opacity: 1;\n  color: rgba(99, 213, 219, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-4-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(99, 213, 219, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-4-900 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 41, 42, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-4-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 41, 42, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-5 {\n  background-color: #3cd2a5 !important;\n  background-image: -moz-linear-gradient(top, #65dcb8, #2ec799) !important;\n  background-image: -webkit-linear-gradient(top, #65dcb8, #2ec799) !important;\n  background-image: linear-gradient(to bottom, #65dcb8, #2ec799) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-5 {\n  --bs-theme: #3cd2a5 !important;\n  --bs-theme-rgb: 60, 210, 165 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-theme-color-5-100 {\n  --bs-text-opacity: 1;\n  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-5-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-5-600 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-5-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-5-200 {\n  --bs-text-opacity: 1;\n  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-5-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-5-700 {\n  --bs-text-opacity: 1;\n  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-5-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-5-300 {\n  --bs-text-opacity: 1;\n  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-5-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-5-800 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-5-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-5-400 {\n  --bs-text-opacity: 1;\n  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-5-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-5-900 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-5-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-6 {\n  background-color: #3cd26a !important;\n  background-image: -moz-linear-gradient(top, #65dc8a, #2ec75d) !important;\n  background-image: -webkit-linear-gradient(top, #65dc8a, #2ec75d) !important;\n  background-image: linear-gradient(to bottom, #65dc8a, #2ec75d) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-6 {\n  --bs-theme: #3cd26a !important;\n  --bs-theme-rgb: 60, 210, 106 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-theme-color-6-100 {\n  --bs-text-opacity: 1;\n  color: rgba(216, 246, 225, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-6-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(216, 246, 225, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-6-600 {\n  --bs-text-opacity: 1;\n  color: rgba(48, 168, 85, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-6-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(48, 168, 85, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-6-200 {\n  --bs-text-opacity: 1;\n  color: rgba(177, 237, 195, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-6-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(177, 237, 195, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-6-700 {\n  --bs-text-opacity: 1;\n  color: rgba(36, 126, 64, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-6-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(36, 126, 64, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-6-300 {\n  --bs-text-opacity: 1;\n  color: rgba(138, 228, 166, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-6-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(138, 228, 166, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-6-800 {\n  --bs-text-opacity: 1;\n  color: rgba(24, 84, 42, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-6-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(24, 84, 42, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-6-400 {\n  --bs-text-opacity: 1;\n  color: rgba(99, 219, 136, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-6-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(99, 219, 136, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-6-900 {\n  --bs-text-opacity: 1;\n  color: rgba(12, 42, 21, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-6-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(12, 42, 21, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-7 {\n  background-color: #a2d23c !important;\n  background-image: -moz-linear-gradient(top, #b6dc65, #96c72e) !important;\n  background-image: -webkit-linear-gradient(top, #b6dc65, #96c72e) !important;\n  background-image: linear-gradient(to bottom, #b6dc65, #96c72e) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-7 {\n  --bs-theme: #a2d23c !important;\n  --bs-theme-rgb: 162, 210, 60 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-theme-color-7-100 {\n  --bs-text-opacity: 1;\n  color: rgba(236, 246, 216, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-7-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(236, 246, 216, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-7-600 {\n  --bs-text-opacity: 1;\n  color: rgba(130, 168, 48, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-7-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(130, 168, 48, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-7-200 {\n  --bs-text-opacity: 1;\n  color: rgba(218, 237, 177, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-7-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(218, 237, 177, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-7-700 {\n  --bs-text-opacity: 1;\n  color: rgba(97, 126, 36, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-7-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(97, 126, 36, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-7-300 {\n  --bs-text-opacity: 1;\n  color: rgba(199, 228, 138, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-7-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(199, 228, 138, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-7-800 {\n  --bs-text-opacity: 1;\n  color: rgba(65, 84, 24, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-7-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(65, 84, 24, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-7-400 {\n  --bs-text-opacity: 1;\n  color: rgba(181, 219, 99, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-7-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(181, 219, 99, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-7-900 {\n  --bs-text-opacity: 1;\n  color: rgba(32, 42, 12, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-7-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(32, 42, 12, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-8 {\n  background-color: #d2bc3c !important;\n  background-image: -moz-linear-gradient(top, #dcca65, #c7b02e) !important;\n  background-image: -webkit-linear-gradient(top, #dcca65, #c7b02e) !important;\n  background-image: linear-gradient(to bottom, #dcca65, #c7b02e) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-8 {\n  --bs-theme: #d2bc3c !important;\n  --bs-theme-rgb: 210, 188, 60 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-theme-color-8-100 {\n  --bs-text-opacity: 1;\n  color: rgba(246, 242, 216, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-8-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(246, 242, 216, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-8-600 {\n  --bs-text-opacity: 1;\n  color: rgba(168, 150, 48, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-8-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(168, 150, 48, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-8-200 {\n  --bs-text-opacity: 1;\n  color: rgba(237, 228, 177, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-8-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(237, 228, 177, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-8-700 {\n  --bs-text-opacity: 1;\n  color: rgba(126, 113, 36, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-8-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(126, 113, 36, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-8-300 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 215, 138, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-8-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 215, 138, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-8-800 {\n  --bs-text-opacity: 1;\n  color: rgba(84, 75, 24, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-8-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(84, 75, 24, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-8-400 {\n  --bs-text-opacity: 1;\n  color: rgba(219, 201, 99, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-8-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(219, 201, 99, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-8-900 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 38, 12, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-8-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 38, 12, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-9 {\n  background-color: #d2a83c !important;\n  background-image: -moz-linear-gradient(top, #dcba65, #c79c2e) !important;\n  background-image: -webkit-linear-gradient(top, #dcba65, #c79c2e) !important;\n  background-image: linear-gradient(to bottom, #dcba65, #c79c2e) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-9 {\n  --bs-theme: #d2a83c !important;\n  --bs-theme-rgb: 210, 168, 60 !important;\n  --bs-theme-color: #000000 !important;\n  --bs-theme-color-rgb: 0, 0, 0 !important;\n}\n[data-bs-theme=dark] .text-theme-color-9-100 {\n  --bs-text-opacity: 1;\n  color: rgba(246, 238, 216, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-9-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(246, 238, 216, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-9-600 {\n  --bs-text-opacity: 1;\n  color: rgba(168, 134, 48, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-9-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(168, 134, 48, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-9-200 {\n  --bs-text-opacity: 1;\n  color: rgba(237, 220, 177, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-9-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(237, 220, 177, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-9-700 {\n  --bs-text-opacity: 1;\n  color: rgba(126, 101, 36, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-9-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(126, 101, 36, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-9-300 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 203, 138, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-9-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 203, 138, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-9-800 {\n  --bs-text-opacity: 1;\n  color: rgba(84, 67, 24, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-9-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(84, 67, 24, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-9-400 {\n  --bs-text-opacity: 1;\n  color: rgba(219, 185, 99, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-9-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(219, 185, 99, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-9-900 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 34, 12, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-9-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 34, 12, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-gradient-theme-color-10 {\n  background-color: #d26e3c !important;\n  background-image: -moz-linear-gradient(top, #dc8d65, #c7612e) !important;\n  background-image: -webkit-linear-gradient(top, #dc8d65, #c7612e) !important;\n  background-image: linear-gradient(to bottom, #dc8d65, #c7612e) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"lighten($value, 10%)\", endColorstr=\"darken($value, 5%)\",GradientType=0 ) !important;\n}\n[data-bs-theme=dark] .theme-theme-color-10 {\n  --bs-theme: #d26e3c !important;\n  --bs-theme-rgb: 210, 110, 60 !important;\n  --bs-theme-color: #ffffff !important;\n  --bs-theme-color-rgb: 255, 255, 255 !important;\n}\n[data-bs-theme=dark] .text-theme-color-10-100 {\n  --bs-text-opacity: 1;\n  color: rgba(246, 226, 216, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-10-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(246, 226, 216, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-10-600 {\n  --bs-text-opacity: 1;\n  color: rgba(168, 88, 48, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-10-600 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(168, 88, 48, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-10-200 {\n  --bs-text-opacity: 1;\n  color: rgba(237, 197, 177, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-10-200 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(237, 197, 177, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-10-700 {\n  --bs-text-opacity: 1;\n  color: rgba(126, 66, 36, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-10-700 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(126, 66, 36, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-10-300 {\n  --bs-text-opacity: 1;\n  color: rgba(228, 168, 138, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-10-300 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(228, 168, 138, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-10-800 {\n  --bs-text-opacity: 1;\n  color: rgba(84, 44, 24, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-10-800 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(84, 44, 24, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-10-400 {\n  --bs-text-opacity: 1;\n  color: rgba(219, 139, 99, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-10-400 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(219, 139, 99, var(--bs-bg-opacity)) !important;\n}\n[data-bs-theme=dark] .text-theme-color-10-900 {\n  --bs-text-opacity: 1;\n  color: rgba(42, 22, 12, var(--bs-text-opacity)) !important;\n}\n[data-bs-theme=dark] .bg-theme-color-10-900 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(42, 22, 12, var(--bs-bg-opacity)) !important;\n}\n\n.bg-none {\n  background: none !important;\n}\n\n.bg-position-center {\n  background-position: center !important;\n}\n\n.bg-size-cover {\n  background-size: cover !important;\n}\n\n.bg-repeat-no-repeat {\n  background-repeat: no-repeat !important;\n}\n\n.bg-gradient-orange-red {\n  background: #ffb33f;\n}\n\n.bg-gradient-orange-red {\n  background: -moz-linear-gradient(top, #ffb33f, #ff1414) !important;\n  background: -webkit-linear-gradient(top, #ffb33f, #ff1414) !important;\n  background: linear-gradient(to top, #ffb33f, #ff1414) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-red-orange {\n  background: #ff1414;\n}\n\n.bg-gradient-red-orange {\n  background: -moz-linear-gradient(top, #ff1414, #ffb33f) !important;\n  background: -webkit-linear-gradient(top, #ff1414, #ffb33f) !important;\n  background: linear-gradient(to top, #ff1414, #ffb33f) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-red-pink {\n  background: #ff1414;\n}\n\n.bg-gradient-red-pink {\n  background: -moz-linear-gradient(top, #ff1414, #f13893) !important;\n  background: -webkit-linear-gradient(top, #ff1414, #f13893) !important;\n  background: linear-gradient(to top, #ff1414, #f13893) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-yellow-orange {\n  background: #faed3f;\n}\n\n.bg-gradient-yellow-orange {\n  background: -moz-linear-gradient(top, #faed3f, #ffb33f) !important;\n  background: -webkit-linear-gradient(top, #faed3f, #ffb33f) !important;\n  background: linear-gradient(to top, #faed3f, #ffb33f) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-yellow-red {\n  background: #faed3f;\n}\n\n.bg-gradient-yellow-red {\n  background: -moz-linear-gradient(top, #faed3f, #ff1414) !important;\n  background: -webkit-linear-gradient(top, #faed3f, #ff1414) !important;\n  background: linear-gradient(to top, #faed3f, #ff1414) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-yellow-green {\n  background: #faed3f;\n}\n\n.bg-gradient-yellow-green {\n  background: -moz-linear-gradient(top, #faed3f, #1ab62d) !important;\n  background: -webkit-linear-gradient(top, #faed3f, #1ab62d) !important;\n  background: linear-gradient(to top, #faed3f, #1ab62d) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-blue-indigo {\n  background: #0271ff;\n}\n\n.bg-gradient-blue-indigo {\n  background: -moz-linear-gradient(top, #0271ff, #5c25ff) !important;\n  background: -webkit-linear-gradient(top, #0271ff, #5c25ff) !important;\n  background: linear-gradient(to top, #0271ff, #5c25ff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-blue-cyan {\n  background: #0271ff;\n}\n\n.bg-gradient-blue-cyan {\n  background: -moz-linear-gradient(top, #0271ff, #009be3) !important;\n  background: -webkit-linear-gradient(top, #0271ff, #009be3) !important;\n  background: linear-gradient(to top, #0271ff, #009be3) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-cyan-blue {\n  background: #009be3;\n}\n\n.bg-gradient-cyan-blue {\n  background: -moz-linear-gradient(top, #009be3, #0271ff) !important;\n  background: -webkit-linear-gradient(top, #009be3, #0271ff) !important;\n  background: linear-gradient(to top, #009be3, #0271ff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-cyan-indigo {\n  background: #009be3;\n}\n\n.bg-gradient-cyan-indigo {\n  background: -moz-linear-gradient(top, #009be3, #5c25ff) !important;\n  background: -webkit-linear-gradient(top, #009be3, #5c25ff) !important;\n  background: linear-gradient(to top, #009be3, #5c25ff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-indigo-blue {\n  background: #5c25ff;\n}\n\n.bg-gradient-indigo-blue {\n  background: -moz-linear-gradient(top, #5c25ff, #0271ff) !important;\n  background: -webkit-linear-gradient(top, #5c25ff, #0271ff) !important;\n  background: linear-gradient(to top, #5c25ff, #0271ff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-custom-orange {\n  background: #f57260;\n}\n\n.bg-gradient-custom-orange {\n  background: -moz-linear-gradient(right, #f57260, #f78f81) !important;\n  background: -webkit-linear-gradient(right, #f57260, #f78f81) !important;\n  background: linear-gradient(to left, #f57260, #f78f81) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-custom-pink {\n  background: #ef1d84;\n}\n\n.bg-gradient-custom-pink {\n  background: -moz-linear-gradient(right, #ef1d84, #f13f96) !important;\n  background: -webkit-linear-gradient(right, #ef1d84, #f13f96) !important;\n  background: linear-gradient(to left, #ef1d84, #f13f96) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-custom-teal {\n  background: #1e8163;\n}\n\n.bg-gradient-custom-teal {\n  background: -moz-linear-gradient(right, #1e8163, #249d79) !important;\n  background: -webkit-linear-gradient(right, #1e8163, #249d79) !important;\n  background: linear-gradient(to left, #1e8163, #249d79) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-custom-indigo {\n  background: #8a66f6;\n}\n\n.bg-gradient-custom-indigo {\n  background: -moz-linear-gradient(right, #8a66f6, #b39bf9) !important;\n  background: -webkit-linear-gradient(right, #8a66f6, #b39bf9) !important;\n  background: linear-gradient(to left, #8a66f6, #b39bf9) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-custom-blue {\n  background: #0271ff;\n}\n\n.bg-gradient-custom-blue {\n  background: -moz-linear-gradient(right, #0271ff, #358eff) !important;\n  background: -webkit-linear-gradient(right, #0271ff, #358eff) !important;\n  background: linear-gradient(to left, #0271ff, #358eff) !important;\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"$from\", endColorstr=\"$to\",GradientType=0 ) !important;\n}\n\n.bg-gradient-indigo-teal {\n  background-image: linear-gradient(to left, #5c25ff, #0271ff, #249d79) !important;\n}\n\n[data-bs-theme=dark] .invert-dark {\n  filter: invert(1);\n}\n\n/* Helper Opacity */\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.text-opacity-0 {\n  --bs-text-opacity: 0;\n}\n\n.text-opacity-5 {\n  --bs-text-opacity: 0.05;\n}\n\n.bg-opacity-0 {\n  --bs-bg-opacity: 0;\n}\n\n.bg-opacity-5 {\n  --bs-bg-opacity: 0.05;\n}\n\n.opacity-1 {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.text-opacity-10 {\n  --bs-text-opacity: 0.1;\n}\n\n.text-opacity-15 {\n  --bs-text-opacity: 0.15;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-15 {\n  --bs-bg-opacity: 0.15;\n}\n\n.opacity-2 {\n  opacity: 0.2 !important;\n}\n\n.opacity-30 {\n  opacity: 0.3 !important;\n}\n\n.text-opacity-20 {\n  --bs-text-opacity: 0.2;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.bg-opacity-20 {\n  --bs-bg-opacity: 0.2;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.opacity-3 {\n  opacity: 0.3 !important;\n}\n\n.opacity-45 {\n  opacity: 0.45 !important;\n}\n\n.text-opacity-30 {\n  --bs-text-opacity: 0.3;\n}\n\n.text-opacity-35 {\n  --bs-text-opacity: 0.35;\n}\n\n.bg-opacity-30 {\n  --bs-bg-opacity: 0.3;\n}\n\n.bg-opacity-35 {\n  --bs-bg-opacity: 0.35;\n}\n\n.opacity-4 {\n  opacity: 0.4 !important;\n}\n\n.opacity-60 {\n  opacity: 0.6 !important;\n}\n\n.text-opacity-40 {\n  --bs-text-opacity: 0.4;\n}\n\n.text-opacity-45 {\n  --bs-text-opacity: 0.45;\n}\n\n.bg-opacity-40 {\n  --bs-bg-opacity: 0.4;\n}\n\n.bg-opacity-45 {\n  --bs-bg-opacity: 0.45;\n}\n\n.opacity-5 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-55 {\n  --bs-text-opacity: 0.55;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-55 {\n  --bs-bg-opacity: 0.55;\n}\n\n.opacity-6 {\n  opacity: 0.6 !important;\n}\n\n.opacity-90 {\n  opacity: 0.9 !important;\n}\n\n.text-opacity-60 {\n  --bs-text-opacity: 0.6;\n}\n\n.text-opacity-65 {\n  --bs-text-opacity: 0.65;\n}\n\n.bg-opacity-60 {\n  --bs-bg-opacity: 0.6;\n}\n\n.bg-opacity-65 {\n  --bs-bg-opacity: 0.65;\n}\n\n.opacity-7 {\n  opacity: 0.7 !important;\n}\n\n.opacity-105 {\n  opacity: 1.05 !important;\n}\n\n.text-opacity-70 {\n  --bs-text-opacity: 0.7;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.bg-opacity-70 {\n  --bs-bg-opacity: 0.7;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.opacity-8 {\n  opacity: 0.8 !important;\n}\n\n.opacity-120 {\n  opacity: 1.2 !important;\n}\n\n.text-opacity-80 {\n  --bs-text-opacity: 0.8;\n}\n\n.text-opacity-85 {\n  --bs-text-opacity: 0.85;\n}\n\n.bg-opacity-80 {\n  --bs-bg-opacity: 0.8;\n}\n\n.bg-opacity-85 {\n  --bs-bg-opacity: 0.85;\n}\n\n.opacity-9 {\n  opacity: 0.9 !important;\n}\n\n.opacity-135 {\n  opacity: 1.35 !important;\n}\n\n.text-opacity-90 {\n  --bs-text-opacity: 0.9;\n}\n\n.text-opacity-95 {\n  --bs-text-opacity: 0.95;\n}\n\n.bg-opacity-90 {\n  --bs-bg-opacity: 0.9;\n}\n\n.bg-opacity-95 {\n  --bs-bg-opacity: 0.95;\n}\n\n.opacity-10 {\n  opacity: 1 !important;\n}\n\n.opacity-150 {\n  opacity: 1.5 !important;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-opacity-105 {\n  --bs-text-opacity: 1.05;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-opacity-105 {\n  --bs-bg-opacity: 1.05;\n}\n\n/* Helper Sticky Top */\n@media (min-width: 1200px) {\n  .desktop-sticky-top {\n    position: sticky;\n    top: 4.5rem;\n  }\n}\n\n/* Helper Outline */\n.outline-none {\n  outline: none !important;\n}\n\n/* Helper Flex */\n.flex-1 {\n  flex: 1 !important;\n}\n\n/* Helper Theme */\n.list-group-item.active,\n.page-item.active .page-link,\n.form-check-input:checked,\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  background-color: var(--bs-theme);\n  border-color: var(--bs-theme);\n}\n\n.btn-theme {\n  background-color: var(--bs-theme);\n  border-color: var(--bs-theme);\n  position: relative;\n}\n.btn-theme:before {\n  content: \"\";\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  right: -1px;\n  bottom: -1px;\n  border-radius: 4px;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn-theme:before {\n    transition: none;\n  }\n}\n.btn-theme.disabled, .btn-theme:disabled {\n  background-color: var(--bs-theme);\n  border-color: var(--bs-theme);\n}\n.btn-theme:hover, .btn-theme:focus, .btn-theme:active, .btn-theme.active {\n  background-color: var(--bs-theme);\n  border-color: var(--bs-theme);\n}\n.btn-theme:hover:before, .btn-theme:focus:before, .btn-theme:active:before, .btn-theme.active:before {\n  background: rgba(255, 255, 255, 0.2);\n}\n.btn-outline-theme {\n  color: var(--bs-theme);\n  border-color: var(--bs-theme);\n}\n.btn-outline-theme:hover, .btn-outline-theme.active, .btn-outline-theme:active {\n  background-color: var(--bs-theme) !important;\n  border-color: var(--bs-theme) !important;\n}\n.btn-outline-theme.disabled, .btn-outline-theme:disabled {\n  color: var(--bs-theme);\n}\n.nav-link {\n  color: var(--bs-theme);\n}\n.nav-link:hover {\n  color: rgba(var(--bs-theme-rgb), 0.5);\n}\n\n.app-content {\n  padding: 2rem 2rem 0;\n  min-height: 100vh;\n  position: relative;\n  margin-left: 240px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n@media (max-width: 1199.98px) {\n  .app-content {\n    padding: 140px 30px 100px;\n    margin-left: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-content {\n    padding: 80px 12px 100px;\n    margin-left: 0;\n  }\n}\n.app-content .app-content-inner-padding {\n  padding: 2rem 2rem;\n}\n@media (max-width: 767.98px) {\n  .app-content .app-content-inner-padding {\n    padding: 1rem 1rem;\n  }\n}\n.app-content .app-content-inner-padding-x {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n@media (max-width: 767.98px) {\n  .app-content .app-content-inner-padding-x {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n.app-content .app-content-inner-padding-y {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n@media (max-width: 767.98px) {\n  .app-content .app-content-inner-padding-y {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n}\n\n.app-footer {\n  position: relative;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--bs-dark2);\n  padding: 12px 2rem;\n  font-weight: 600;\n  color: var(--bs-heading-color);\n  margin-left: 14.375rem;\n}\n.app-footer-full {\n  margin-left: 0;\n  text-align: center;\n  background: none;\n  border: none;\n}\n@media (max-width: 1199.98px) {\n  .app-footer {\n    margin: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-footer {\n    padding: 12px;\n  }\n}\n\n.live-svg {\n  width: 47px;\n  margin-right: 8px;\n  filter: drop-shadow(0px 0px 3px var(--bs-theme));\n  stroke-dasharray: 320;\n  stroke-dashoffset: 320;\n  animation: liveAni 2s infinite both;\n}\n\n@keyframes liveAni {\n  0% {\n    stroke-dashoffset: 320;\n  }\n  100% {\n    stroke-dashoffset: -320;\n  }\n}\n.app-sidebar-collapsed .app-header {\n  width: 3.875rem;\n}\n.app-sidebar-collapsed .app-header .brand {\n  padding-left: 0;\n}\n.app-sidebar-collapsed .app-header .brand .brand-logo {\n  display: none;\n}\n\n.app-header {\n  height: 3.25rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 14.375rem;\n  z-index: 1020;\n  background: var(--bs-dark3);\n  display: flex;\n  transition: all 0.15s ease-in-out;\n}\n.app-header .menu-toggler {\n  border: none;\n  background: none;\n  height: 100%;\n  padding: 0.5rem 1rem;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.app-header .menu-toggler .bar {\n  width: 1.625rem;\n  display: block;\n  height: 1px;\n  background: rgba(var(--bs-app-header-link-color-rgb), 0.4);\n  transition: all 0.2s linear;\n}\n.app-header .menu-toggler .bar + .bar {\n  margin-top: 0.25rem;\n}\n.app-header .menu-toggler:hover .bar {\n  background: rgba(var(--bs-app-header-link-color-rgb), 0.75);\n}\n.app-header .mobile-toggler {\n  height: 100%;\n  display: none;\n}\n@media (max-width: 1199.98px) {\n  .app-header .mobile-toggler {\n    display: flex;\n    align-items: center;\n  }\n}\n.app-header .desktop-toggler {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 767.98px) {\n  .app-header .desktop-toggler {\n    display: none;\n  }\n}\n.app-header .brand {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  white-space: nowrap;\n}\n@media (max-width: 1199.98px) {\n  .app-header .brand {\n    justify-content: flex-start;\n  }\n}\n.app-header .brand .brand-logo {\n  text-decoration: none;\n  color: var(--bs-app-header-link-color);\n  font-size: 0.91875rem;\n  letter-spacing: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center !important;\n}\n@media (max-width: 1199.98px) {\n  .app-header .brand .brand-logo {\n    width: auto !important;\n    gap: 10px;\n  }\n}\n.app-header .brand .brand-logo .card {\n  padding: 2px 7px;\n  margin-left: 2px;\n  font-weight: bold;\n  font-size: 12px;\n}\n.app-header .brand .brand-logo .card:not(.border-0):before, .app-header .brand .brand-logo .card:not(.border-0):after {\n  border-color: rgba(var(--bs-border-color-rgb), 0.7);\n}\n.app-header .brand .brand-logo .card .card-arrow-top-left:before,\n.app-header .brand .brand-logo .card .card-arrow-top-right:before,\n.app-header .brand .brand-logo .card .card-arrow-bottom-left:before,\n.app-header .brand .brand-logo .card .card-arrow-bottom-right:before {\n  width: 1px;\n  height: 6px;\n}\n.app-header .brand .brand-logo .card .card-arrow-top-left:after,\n.app-header .brand .brand-logo .card .card-arrow-top-right:after,\n.app-header .brand .brand-logo .card .card-arrow-bottom-left:after,\n.app-header .brand .brand-logo .card .card-arrow-bottom-right:after {\n  height: 1px;\n}\n.app-header .brand .brand-logo .brand-text {\n  display: flex;\n  align-items: center;\n}\n.app-header .brand .brand-logo img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.app-header .brand .brand-logo .brand-img {\n  width: 1.625rem;\n  height: 1.625rem;\n  background: var(--bs-app-header-brand-img);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 1rem;\n}\n.app-header .brand .brand-logo .brand-img .brand-img-text {\n  display: block;\n  letter-spacing: initial;\n  font-weight: 600;\n  font-size: 1.05rem;\n}\n.app-header .menu {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 1;\n}\n.app-header .menu .menu-item {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.app-header .menu .menu-item .menu-link {\n  text-decoration: none;\n  color: var(--bs-app-header-link-color);\n  position: relative;\n  padding: 0.5rem 1rem;\n  display: flex;\n  align-items: center;\n}\n.app-header .menu .menu-item .menu-link .menu-img {\n  width: 2rem;\n  height: 2rem;\n  margin-right: 0.75rem;\n}\n.app-header .menu .menu-item .menu-link .menu-img img {\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 30px;\n}\n.app-header .menu .menu-item .menu-link .menu-icon {\n  font-size: 1.25rem;\n}\n.app-header .menu .menu-item .menu-link .menu-badge {\n  position: absolute;\n  background: transparent;\n  width: 6px;\n  height: 6px;\n  top: 0.5rem;\n  border-radius: 6px;\n  right: 1rem;\n}\n.app-header .menu-search {\n  position: absolute;\n  top: -3.25rem;\n  left: 0;\n  right: 0;\n  height: 3.25rem;\n  background: var(--bs-app-header-bg);\n  transition: all 0.2s ease-in-out;\n}\n.app-header .menu-search .menu-search-container {\n  max-width: 60.4375rem;\n  margin: 0 auto;\n  height: 3.25rem;\n  display: flex;\n}\n.app-header .menu-search .menu-search-container .menu-search-icon {\n  padding: 0 1rem;\n  font-size: 1.05rem;\n  display: flex;\n  align-items: center;\n}\n.app-header .menu-search .menu-search-container .menu-search-icon .bi:before {\n  display: block;\n}\n.app-header .menu-search .menu-search-container .menu-search-icon a {\n  color: rgba(var(--bs-app-header-link-color-rgb), 0.5);\n  text-decoration: none;\n  display: block;\n  transition: all 0.2s linear;\n}\n.app-header .menu-search .menu-search-container .menu-search-icon a:hover {\n  color: var(--bs-app-header-link-color);\n}\n.app-header .menu-search .menu-search-container .menu-search-input {\n  flex: 1;\n}\n.app-header .menu-search .menu-search-container .menu-search-input .form-control {\n  border: none;\n  padding-left: 0;\n  height: 100%;\n  box-shadow: none;\n}\n.app-header-menu-search-toggled .app-header .menu-search {\n  top: 0;\n}\n@media (max-width: 1199.98px) {\n  .app-header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: var(--bs-dark3);\n  }\n}\n\n#header.app-header {\n  height: 110px;\n}\n#header.app-header .brand .brand-logo {\n  height: 100%;\n}\n#header.app-header .brand .brand-logo img {\n  height: 100%;\n}\n\n#sidebar.app-sidebar {\n  top: 110px;\n}\n\n@media screen and (max-width: 1199px) {\n  div#sidebar:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: var(--bs-dark4);\n    opacity: 0.8;\n    pointer-events: none;\n  }\n}\n@media screen and (max-width: 767px) {\n  #header.app-header {\n    height: 60px;\n  }\n  #sidebar.app-sidebar {\n    top: 60px;\n  }\n}\n.app-sidebar-mobile-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1020;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  margin: 0;\n  outline: none;\n  display: none;\n  background: rgba(0, 0, 0, 0.25);\n}\n\n@keyframes appSidebarSubMenuSlideInRight {\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.app-sidebar-button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(90%, 0px);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  background: var(--bs-dark3);\n  cursor: pointer;\n  padding: 5px;\n  transition: 0.2s;\n}\n\n.app-sidebar {\n  width: 14.375rem;\n  background: var(--bs-app-header-bg);\n  bottom: 0;\n  position: fixed;\n  top: 3.25rem;\n  z-index: 1010;\n  transition: all 0.15s ease-in-out;\n  left: 0;\n}\n.app-sidebar:hover .app-sidebar-button {\n  transform: translate(100%, 0px);\n  opacity: 1;\n  visibility: visible;\n  pointer-events: all;\n}\n@media (max-width: 1199.98px) {\n  .app-sidebar {\n    background: var(--bs-dark3);\n    transform: translate(-100%, 0px);\n  }\n}\n.app-sidebar .slimScrollDiv {\n  width: 100% !important;\n}\n.app-sidebar .slimScrollDiv .slimScrollBar, .app-sidebar .slimScrollDiv .slimScrollRail {\n  display: none !important;\n}\n.app-sidebar .menu-footer {\n  background: var(--bs-dark3);\n}\n.app-sidebar .app-sidebar-content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.app-sidebar .app-sidebar-content .menu {\n  position: relative;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 10px 0;\n}\n.app-sidebar .app-sidebar-content .menu .menu-header {\n  padding: 1rem 1rem 0.5rem;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--bs-body-color);\n}\n.app-sidebar .app-sidebar-content .menu .menu-item > div {\n  position: relative;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item > div:hover > .menu-item-events {\n  opacity: 1;\n  visibility: visible;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-item-events {\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n  top: 50%;\n  left: 0px;\n  transform: translate(0px, -50%);\n  z-index: 1;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-link {\n  text-decoration: none;\n  position: relative;\n  padding: 0.3rem 1rem;\n  color: var(--bs-app-sidebar-menu-link-color);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  transition: all 0.2s ease-in-out;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-icon {\n  width: 1.875rem;\n  height: 1.875rem;\n  font-size: 1.05rem;\n  margin: -0.25rem 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: -4px;\n  margin-right: 0.75rem;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-caret {\n  display: flex;\n  align-items: center;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-caret b {\n  display: flex;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-text {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-link:hover, .app-sidebar .app-sidebar-content .menu .menu-item .menu-link:focus {\n  color: var(--bs-app-sidebar-menu-link-hover-color);\n}\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-submenu {\n  background: none;\n  display: none;\n  padding: 0 0 1rem;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-submenu .menu-item {\n  position: relative;\n  padding-left: 2.625rem;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item.active:not(.has-sub) > .menu-link {\n  color: var(--bs-app-sidebar-menu-link-active-color);\n}\n.app-sidebar .app-sidebar-content .menu .menu-item.active > .menu-link .menu-icon {\n  color: var(--bs-theme);\n}\n.app-sidebar .app-sidebar-content .menu .menu-item.active.has-sub > .menu-submenu {\n  display: block;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item.expand > .menu-submenu {\n  display: block;\n}\n.app-sidebar .app-sidebar-content .menu .menu-item.expand > .menu-submenu > .menu-item {\n  animation: appSidebarSubMenuSlideInRight 0.3s both cubic-bezier(0.7, 0, 0.3, 1);\n  transform: translate3d(-100%, 0, 0);\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(2), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(2) {\n  animation-delay: 45ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(3), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(3) {\n  animation-delay: 60ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(4), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(4) {\n  animation-delay: 75ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(5), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(5) {\n  animation-delay: 90ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(6), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(6) {\n  animation-delay: 105ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(7), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(7) {\n  animation-delay: 120ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(8), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(8) {\n  animation-delay: 135ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(9), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(9) {\n  animation-delay: 150ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(10), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(10) {\n  animation-delay: 165ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(11), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(11) {\n  animation-delay: 180ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(12), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(12) {\n  animation-delay: 195ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(13), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(13) {\n  animation-delay: 210ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(14), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(14) {\n  animation-delay: 225ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(15), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(15) {\n  animation-delay: 240ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(16), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(16) {\n  animation-delay: 255ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(17), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(17) {\n  animation-delay: 270ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(18), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(18) {\n  animation-delay: 285ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(19), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(19) {\n  animation-delay: 300ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(20), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(20) {\n  animation-delay: 315ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(21), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(21) {\n  animation-delay: 330ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(22), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(22) {\n  animation-delay: 345ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(23), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(23) {\n  animation-delay: 360ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(24), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(24) {\n  animation-delay: 375ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(25), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(25) {\n  animation-delay: 390ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(26), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(26) {\n  animation-delay: 405ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(27), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(27) {\n  animation-delay: 420ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(28), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(28) {\n  animation-delay: 435ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(29), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(29) {\n  animation-delay: 450ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(30), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(30) {\n  animation-delay: 465ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(31), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(31) {\n  animation-delay: 480ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(32), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(32) {\n  animation-delay: 495ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(33), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(33) {\n  animation-delay: 510ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(34), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(34) {\n  animation-delay: 525ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(35), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(35) {\n  animation-delay: 540ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(36), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(36) {\n  animation-delay: 555ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(37), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(37) {\n  animation-delay: 570ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(38), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(38) {\n  animation-delay: 585ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(39), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(39) {\n  animation-delay: 600ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(40), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(40) {\n  animation-delay: 615ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(41), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(41) {\n  animation-delay: 630ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(42), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(42) {\n  animation-delay: 645ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(43), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(43) {\n  animation-delay: 660ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(44), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(44) {\n  animation-delay: 675ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(45), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(45) {\n  animation-delay: 690ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(46), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(46) {\n  animation-delay: 705ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(47), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(47) {\n  animation-delay: 720ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(48), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(48) {\n  animation-delay: 735ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(49), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(49) {\n  animation-delay: 750ms;\n}\n.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(50), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(50) {\n  animation-delay: 765ms;\n}\n.app-sidebar .app-sidebar-mobile-backdrop {\n  display: none;\n}\n.app-sidebar.uppercase-mode {\n  text-transform: uppercase;\n}\n.app-sidebar.uppercase-mode .app-sidebar-content .menu .menu-item .menu-link {\n  font-size: 0.83125rem;\n}\n\n.app-theme-list {\n  margin: -0.25rem;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n}\n.app-theme-list .app-theme-list-item {\n  padding: 0.25rem;\n}\n.app-theme-list .app-theme-list-item .app-theme-list-link {\n  width: 2rem;\n  height: 2rem;\n  display: block;\n  text-decoration: none;\n  position: relative;\n  transition: all 0.2s linear;\n}\n.app-theme-list .app-theme-list-item .app-theme-list-link:hover {\n  opacity: 0.6;\n}\n.app-theme-list .app-theme-list-item.active .app-theme-list-link {\n  opacity: 1;\n}\n.app-theme-list .app-theme-list-item.active .app-theme-list-link:before {\n  content: \"\\f00c\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  font-size: 0.875rem;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n\n.app-theme-panel {\n  position: fixed;\n  top: 50%;\n  bottom: 0;\n  z-index: 1030;\n  display: flex;\n  align-items: center;\n  right: 0;\n  transform: translate(100%, -50%);\n  transition: 0.2s;\n}\n.app-theme-panel .app-theme-panel-container {\n  width: 190px;\n}\n.app-theme-panel .app-theme-panel-content {\n  background: var(--bs-app-theme-panel-bg);\n  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n  padding: 0.5rem;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-mode-link {\n  color: #ffffff;\n  text-decoration: none;\n  text-align: center;\n  position: relative;\n  display: block;\n  transition: all 0.2s linear;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-mode-link .img {\n  position: relative;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-mode-link .img:before {\n  content: \"\\f00c\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  font-size: 0.875rem;\n  color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-mode-link .text {\n  font-size: 0.65625rem;\n  font-weight: 500;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-mode-link:hover {\n  opacity: 0.6;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-mode-link.active {\n  opacity: 1;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-mode-link.active .img:before {\n  color: #ffffff;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-mode-link.active .img:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n}\n.app-theme-panel .app-theme-panel-content .app-theme-cover {\n  margin: -0.25rem;\n  display: flex;\n  flex-wrap: wrap;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item {\n  padding: 0.25rem;\n  width: 33.33%;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item .app-theme-cover-link {\n  display: block;\n  text-decoration: none;\n  position: relative;\n  padding-top: 46%;\n  background-size: cover;\n  background-position: center;\n  transition: all 0.2s linear;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item .app-theme-cover-link:hover {\n  opacity: 0.6;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item .app-theme-cover-link:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: #000000;\n  opacity: 0.25;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item.active .app-theme-cover-link {\n  opacity: 1;\n}\n.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item.active .app-theme-cover-link:after {\n  content: \"\\f00c\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  font-size: 0.875rem;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n.app-theme-panel .app-theme-toggle-btn {\n  position: absolute;\n  top: 50%;\n  margin-top: -1rem;\n  width: 2rem;\n  height: 2rem;\n  line-height: 2rem;\n  font-size: 1.09375rem;\n  color: var(--bs-app-theme-panel-color);\n  background: var(--bs-app-theme-panel-bg);\n  text-align: center;\n  left: 0;\n  margin-left: -2rem;\n}\n.app-theme-panel.active {\n  transform: translate(0, -50%);\n}\n\n@keyframes topMenuControlSlideInLeft {\n  from {\n    left: -3.125rem;\n  }\n  to {\n    left: 0;\n  }\n}\n@keyframes topMenuControlSlideInRight {\n  from {\n    right: -3.125rem;\n  }\n  to {\n    right: 0;\n  }\n}\n.app-top-nav {\n  background: var(--bs-app-top-nav-bg);\n  left: 0;\n  right: 0;\n  z-index: 1010;\n}\n@media (min-width: 768px) {\n  .app-top-nav {\n    top: 3.25rem;\n    position: fixed;\n    height: 2.875rem;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-top-nav {\n    display: none;\n  }\n}\n@media (min-width: 768px) {\n  .app-top-nav .menu {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-top-nav .menu {\n    display: block;\n    margin: 0 !important;\n  }\n}\n.app-top-nav .menu .menu-item {\n  position: relative;\n}\n.app-top-nav .menu .menu-item .menu-link {\n  text-decoration: none;\n  position: relative;\n  padding: 0.75rem 1rem;\n  color: var(--bs-app-top-nav-menu-link-color);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  transition: all 0.2s ease-in-out;\n  white-space: nowrap;\n}\n@media (max-width: 767.98px) {\n  .app-top-nav .menu .menu-item .menu-link {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n}\n.app-top-nav .menu .menu-item .menu-link .menu-icon {\n  width: 1.875rem;\n  height: 1.875rem;\n  font-size: 1.05rem;\n  margin: -0.25rem 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 0.75rem;\n}\n.app-top-nav .menu .menu-item .menu-link .menu-caret {\n  margin: -0.3125rem 0;\n  margin-left: 0.75rem;\n}\n.app-top-nav .menu .menu-item .menu-link .menu-text {\n  flex: 1;\n}\n.app-top-nav .menu .menu-item .menu-link:hover, .app-top-nav .menu .menu-item .menu-link:focus {\n  color: var(--bs-app-top-nav-menu-link-hover-color);\n}\n.app-top-nav .menu .menu-item .menu-submenu {\n  background: var(--bs-app-top-nav-menu-submenu-bg);\n  display: none;\n  padding: 0.5rem 0;\n  min-width: 12.5rem;\n}\n@media (min-width: 768px) {\n  .app-top-nav .menu .menu-item .menu-submenu {\n    position: absolute;\n    max-height: calc(100vh - 6.125rem);\n    left: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-top-nav .menu .menu-item .menu-submenu {\n    padding-top: 0;\n    padding-bottom: 1rem;\n    padding-left: 2.625rem;\n  }\n}\n.app-top-nav .menu .menu-item .menu-submenu .menu-item {\n  position: relative;\n}\n.app-top-nav .menu .menu-item .menu-submenu .menu-item .menu-link {\n  padding: 0.25rem 1rem;\n}\n.app-top-nav .menu .menu-item.active > .menu-link {\n  color: var(--bs-app-top-nav-menu-link-active-color);\n}\n.app-top-nav .menu .menu-item.active > .menu-link .menu-icon {\n  color: var(--bs-theme);\n}\n.app-top-nav .menu .menu-item.menu-control {\n  position: absolute;\n  top: 0;\n  margin: 0;\n  z-index: 10;\n}\n@media (max-width: 767.98px) {\n  .app-top-nav .menu .menu-item.menu-control {\n    display: none !important;\n  }\n}\n.app-top-nav .menu .menu-item.menu-control > .menu-link {\n  padding: 0;\n  text-align: center;\n  width: 2.875rem;\n  height: 2.875rem;\n  background: var(--bs-app-top-nav-bg);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--bs-app-top-nav-menu-link-color);\n}\n.app-top-nav .menu .menu-item.menu-control > .menu-link i {\n  float: none;\n  margin: 0;\n  font-size: 1.125rem;\n  display: block;\n  line-height: 2.5rem;\n  width: auto;\n}\n.app-top-nav .menu .menu-item.menu-control > .menu-link:hover, .app-top-nav .menu .menu-item.menu-control > .menu-link:focus {\n  color: var(--bs-app-top-nav-menu-link-hover-color);\n}\n.app-top-nav .menu .menu-item.menu-control.menu-control-start {\n  left: -3.25rem;\n}\n.app-top-nav .menu .menu-item.menu-control.menu-control-start > .menu-link {\n  box-shadow: 12px 0 10px -10px rgba(0, 0, 0, 0.5);\n}\n.app-top-nav .menu .menu-item.menu-control.menu-control-start.show {\n  left: 0;\n  animation: topMenuControlSlideInLeft 0.2s;\n}\n.app-top-nav .menu .menu-item.menu-control.menu-control-end {\n  right: -3.25rem;\n}\n.app-top-nav .menu .menu-item.menu-control.menu-control-end > .menu-link {\n  box-shadow: -12px 0 10px -10px rgba(0, 0, 0, 0.5);\n}\n.app-top-nav .menu .menu-item.menu-control.menu-control-end.show {\n  right: 0;\n  animation: topMenuControlSlideInRight 0.2s;\n}\n@media (min-width: 768px) {\n  .app-top-nav .menu > .menu-item.has-sub:hover > .menu-submenu {\n    display: block;\n  }\n}\n\n.map-fullscreen-hide.active {\n  pointer-events: none !important;\n  opacity: 0 !important;\n  visibility: hidden !important;\n}\n\n.map-zoom-item {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: #ffffff;\n  z-index: 1;\n  border-radius: 4px;\n}\n\n.menu-item.has-sub {\n  padding-bottom: 5px;\n  padding-top: 2px;\n}\n\n.map-zoom-item a i {\n  color: #000000;\n  font-size: 24px;\n}\n\n.map-zoom-item a {\n  padding: 0 5px;\n}\n\n.hide-data tbody tr {\n  filter: blur(5px);\n  transition: 0.2s;\n}\n\n.hide-data tbody tr:hover {\n  filter: blur(0px);\n}\n\n/* styles.css */\n.autocomplete-container {\n  position: relative;\n}\n\n.autocomplete-input {\n  width: 100%;\n  padding: 8px;\n}\n\n.autocomplete-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  z-index: 1000;\n  background-color: #1c242d;\n  border: 1px solid #ffffff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.autocomplete-item {\n  padding: 8px;\n  cursor: pointer;\n  color: #ffffff;\n}\n\n.autocomplete-item:hover {\n  background-color: #2a6e59;\n}\n\n@media (max-width: 1199.98px) {\n  .app {\n    overflow: hidden;\n  }\n}\n\n@media (min-width: 992px) {\n  .md-h-100 {\n    height: 100%;\n  }\n  .md-mb-n4 {\n    margin-bottom: -1.5rem;\n  }\n}\n.flex-none {\n  flex: none;\n}\n\n.evenColumn {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.ReactVirtualized__Grid {\n  border: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.headerCell {\n  font-weight: bold;\n  text-transform: uppercase;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n}\n\n.headerCell {\n  border-right: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.evenColumn,\n.oddColumn {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n  border-right: 1px solid rgba(255, 255, 255, 0.25);\n  padding: 10px;\n}\n\n.page-iframe iframe {\n  width: 100%;\n  height: 100vh;\n}\n\n.welcome-container {\n  text-align: center;\n  min-height: calc(100vh - 280px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.welcome-container h1, .welcome-container .h1 {\n  font-size: 2.5em;\n  margin-bottom: 10px;\n}\n\n.welcome-container p {\n  font-size: 1.2em;\n  color: #555;\n}\n\n.tooltip-title {\n  display: inline-block;\n  position: absolute;\n  top: 100%;\n  background: var(--bs-dark3);\n  border-radius: 4px;\n  text-align: center;\n  left: 50%;\n  transform: translate(-50%, 4px);\n  font-size: 12px;\n  padding: 2px 5px;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: 0.2s;\n}\n\n.tooltip-item {\n  position: relative;\n}\n\n.tooltip-item:hover .tooltip-title {\n  opacity: 1;\n  visibility: visible;\n}\n\n.graphic-events {\n  position: relative;\n}\n\n.graphic-events .graphic-events-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0px;\n  background: #1c2e37;\n  z-index: 2;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.gm-style-iw-d .marker-window-container::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n}\n\n.fancybox__content {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.fancybox-navigation .fancybox-button {\n  opacity: 1;\n  visibility: visible;\n  background: #2ab48a;\n  pointer-events: all;\n  width: 90px;\n  height: 90px;\n  padding: 0;\n  border-radius: 0px;\n  color: #ffffff !important;\n}\n\n.fancybox-navigation .fancybox-button:hover {\n  background: #1e9a75;\n}\n\n.fancybox-navigation .fancybox-button svg {\n  width: 60px;\n  height: auto;\n}\n\n.fancybox-navigation .fancybox-button div {\n  height: 100%;\n  width: 100%;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.todo-sort-arrow:hover {\n  color: var(--bs-theme);\n}\n\n@media (max-width: 767.98px) {\n  .chest-work-page {\n    flex-direction: column;\n  }\n  .chest-work-page > .flex-1 {\n    padding: 0 0px 0px 10px !important;\n  }\n}\n@media (max-width: 1199.98px) {\n  .neighbourhood-menu {\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .neighbourhood-menu > div {\n    gap: 20px;\n    position: relative !important;\n    display: flex;\n    white-space: nowrap;\n    margin-bottom: 30px;\n    padding: 20px 20px;\n    overflow-x: auto !important;\n    overflow-y: hidden !important;\n  }\n}\n.district-menu {\n  width: 300px;\n  flex: none;\n}\n@media (max-width: 1199.98px) {\n  .district-menu {\n    width: 200px;\n  }\n}\n@media (max-width: 767.98px) {\n  .district-menu {\n    width: 100%;\n  }\n  .district-menu > ol {\n    overflow-x: auto;\n    padding: 10px 20px;\n    gap: 40px !important;\n    margin-bottom: 0;\n  }\n}\n\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th:last-child,\n.dataTables_scrollBody > table > tbody tr td:last-child {\n  border-right: 1px solid #5d686f;\n}\n\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th,\n.dataTables_scrollBody > table > tbody tr td {\n  border-left: 1px solid #5d686f;\n}\n\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th {\n  border-top: 1px solid #5d686f;\n  padding-left: 30px;\n}\n\n.dataTables_wrapper.dt-bootstrap5 table.dataTable thead > tr > th.sorting:before,\n.dataTables_wrapper.dt-bootstrap5 table.dataTable thead > tr > th.sorting:after {\n  left: 10px;\n  right: auto;\n  position: absolute;\n  font-size: 11px;\n}\n\n.dataTables_wrapper.dt-bootstrap5 table.dataTable thead > tr > th.sorting {\n  padding-left: 30px;\n  position: relative;\n}\n\n.table-datatable.table {\n  margin-bottom: 0;\n}\n\n.dataTables_scrollBody .table-datatable .sorting:before,\n.dataTables_scrollBody .table-datatable .sorting:after {\n  display: none !important;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n  background: rgba(68, 210, 165, 0.1607843137);\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: var(--bs-theme);\n}\n\n.select-height {\n  height: 60px;\n}\n.select-height > div {\n  height: 100%;\n}\n.select-height .react-select__control {\n  height: 100%;\n}\n\n.select-h-100 .react-select__control {\n  height: 100%;\n}\n\n.react-select__control {\n  text-transform: uppercase;\n}\n\n.react-select__menu {\n  text-transform: uppercase;\n}\n\n.listen-note > span {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translate(-50%, 0px);\n  white-space: nowrap;\n  background: #000000;\n  z-index: 1;\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.2s;\n  pointer-events: none;\n}\n\n.listen-note {\n  position: relative;\n}\n.listen-note .fa-volume-off {\n  display: none;\n}\n.listen-note.active .fa-volume-up {\n  display: none;\n}\n.listen-note.active .fa-volume-off {\n  display: block;\n}\n\n.listen-note:hover > span {\n  opacity: 1;\n  visibility: visible;\n}\n\n.gm-ui-hover-effect {\n  top: 0 !important;\n  background: #e00000 !important;\n  opacity: 1;\n  right: 0 !important;\n  border-bottom-left-radius: 6px;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 35px !important;\n  height: 35px !important;\n}\n.gm-ui-hover-effect > span {\n  width: 24px !important;\n  height: 24px !important;\n  margin: 0 !important;\n  background-color: #ffffff;\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  opacity: 1;\n  background: rgba(0, 0, 0, 0.95);\n  top: 50%;\n  transform: translate(0px, -50%);\n  width: 30px;\n  height: 30px;\n  border-radius: 100%;\n  padding: 3px;\n  margin: 0 -7px;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  filter: initial !important;\n  position: relative;\n}\n\n.carousel-control-prev-icon {\n  left: -1px;\n}\n\n.carousel-control-next-icon {\n  right: -2px;\n}\n\n#strategy-map .card:before,\n#strategy-map .card:after {\n  display: none;\n}\n\n#strategy-map .scrum-container > .flex-1 {\n  display: none;\n}\n\n#strategy-map .scrum-container {\n  display: none !important;\n  left: 0 !important;\n  bottom: 0 !important;\n}\n\n.scrum-map-container {\n  height: calc(100vh - 150px);\n}\n\n@media (max-width: 1199.98px) {\n  .scrum-map {\n    height: 700px;\n  }\n  .scrum-map-container {\n    height: auto !important;\n  }\n  .scrum-container {\n    height: auto !important;\n    width: 100% !important;\n    padding: 40px 0 !important;\n  }\n}\n#strategy-map .card .card-body {\n  padding: 0;\n}\n\n#strategy-map .card .card-arrow {\n  display: none;\n}\n\n.fancybox__container {\n  z-index: 9999;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.sandik-analizi-chart-slide .swiper-slide .slide-chest:hover, .sandik-analizi-chart-slide .swiper-slide .slide-chest.active {\n  color: var(--bs-theme);\n}\n.sandik-analizi-chart-slide .swiper-slide .slide-chest:hover strong, .sandik-analizi-chart-slide .swiper-slide .slide-chest.active strong {\n  color: var(--bs-theme);\n}\n\n.sandik-analizi-chart-slide .swiper-slide .slide-general:hover, .sandik-analizi-chart-slide .swiper-slide .slide-general.active {\n  background: rgba(255, 255, 255, 0);\n  color: var(--bs-theme);\n}\n\n.form-control:disabled {\n  opacity: 0.5 !important;\n}\n\n.table > thead {\n  vertical-align: middle;\n}\n\ntable.dataTable > tbody > tr:nth-child(even) {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.custom-file-button input[type=file] {\n  margin-left: -2px !important;\n}\n.custom-file-button input[type=file]::-webkit-file-upload-button {\n  display: none;\n}\n.custom-file-button input[type=file]::file-selector-button {\n  display: none;\n}\n\n.color-item {\n  position: relative;\n}\n\n.color-item label {\n  display: block;\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  border: 2px solid rgba(255, 255, 255, 0);\n  cursor: pointer;\n}\n\n.color-item input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.color-item input:checked ~ label {\n  border-color: #ffffff;\n}\n\n.live-svg-map {\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  transform: translate(-50%, 0px);\n  z-index: 1;\n  margin: 0;\n  width: 70px;\n  display: none;\n}\n\n.app-sidebar-toggled .live-svg-map {\n  display: block;\n}\n\n.gm-style .gm-style-iw-c {\n  color: #000000;\n  text-align: center;\n  padding: 0;\n}\n\n.gm-style-iw-d {\n  padding: 5px 10px !important;\n  overflow: initial !important;\n}\n\n.img-cover {\n  object-fit: cover;\n  object-position: center;\n}\n\n.scroll-up-btn {\n  position: fixed;\n  bottom: 20px;\n  right: 15px;\n  cursor: pointer;\n  pointer-events: none;\n  transform: scale(0);\n  transition: 0.2s;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 99;\n  border-radius: 100%;\n  font-size: 30px;\n  color: #249d79;\n}\n.scroll-up-btn.active {\n  transform: scale(1);\n  pointer-events: all;\n}\n.scroll-up-btn.near-news {\n  bottom: 210px;\n}\n.scroll-up-btn.near-news.near-footer {\n  bottom: 350px !important;\n}\n.scroll-up-btn:hover {\n  color: #ffffff;\n}\n@media (max-width: 767.98px) {\n  .scroll-up-btn.near-news {\n    bottom: 30px;\n  }\n  .scroll-up-btn.near-news.near-footer {\n    bottom: 500px !important;\n  }\n}\n\n.text-overflow {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 100%;\n  overflow: hidden;\n}\n\n.table-for-multiple {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.page-loader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0px;\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n}\n\n.page-loader .app-header:nth-child(2) {\n  width: auto;\n  position: relative;\n  height: auto;\n  background: none;\n  transform: scale(0.7);\n  flex: 1;\n}\n.page-loader .app-header:nth-child(2) .brand-text {\n  font-size: 80px;\n}\n@media (max-width: 1199.98px) {\n  .page-loader .app-header:nth-child(2) {\n    transform: scale(0.4);\n  }\n}\n@media (max-width: 767.98px) {\n  .page-loader .app-header:nth-child(2) {\n    transform: scale(0.25);\n  }\n}\n\n.page-loader .app-header:nth-child(2) .brand .brand-logo .card {\n  font-size: 80px;\n  overflow: hidden;\n  letter-spacing: 20px;\n  margin: 0;\n  line-height: 1;\n  margin-left: 20px;\n  width: 0px;\n  padding: 10px 0px;\n  box-sizing: content-box;\n}\n.page-loader .app-header:nth-child(2) .brand .brand-logo .card.loader-text-1 {\n  animation: loaderAni1 3s cubic-bezier(0.51, 0.92, 0.24, 1.15) infinite both !important;\n}\n.page-loader .app-header:nth-child(2) .brand .brand-logo .card.loader-text-2 {\n  animation: loaderAni2 3s cubic-bezier(0.51, 0.92, 0.24, 1.15) infinite both !important;\n}\n.page-loader .app-header:nth-child(2) .brand .brand-logo .card.loader-text-3 {\n  animation: loaderAni3 3s cubic-bezier(0.51, 0.92, 0.24, 1.15) infinite both !important;\n}\n\n.page-loader .app-header:nth-child(2) .brand {\n  width: auto;\n  height: auto;\n  padding: 0;\n}\n\n@keyframes loaderAni1 {\n  0%, 100% {\n    width: 0px;\n    padding: 10px 0px;\n    letter-spacing: 20px;\n  }\n  50% {\n    width: 530px;\n    padding: 10px 20px;\n    letter-spacing: 0px;\n  }\n}\n@keyframes loaderAni2 {\n  0%, 100% {\n    width: 0px;\n    padding: 10px 0px;\n    letter-spacing: 20px;\n  }\n  50% {\n    width: 680px;\n    padding: 10px 20px;\n    letter-spacing: 0px;\n  }\n}\n@keyframes loaderAni3 {\n  0%, 100% {\n    width: 0px;\n    padding: 10px 0px;\n    letter-spacing: 20px;\n  }\n  50% {\n    width: 870px;\n    padding: 10px 20px;\n    letter-spacing: 0px;\n  }\n}\n.details-modal .ck.ck-editor__main > .ck-editor__editable {\n  min-height: 100px !important;\n}\n\n.weather-item .react-select__menu {\n  font-size: 12px;\n  width: 120px;\n}\n\n.weather-item .react-select__control {\n  border: none;\n  padding: 0;\n  min-height: auto;\n  margin: 0;\n  font-size: 11px;\n}\n\n.select-sm .react-select__control {\n  font-size: 11px !important;\n}\n\n.breaking-news {\n  background-color: var(--bs-dark2);\n  padding: 0px 1.5rem;\n  position: sticky;\n  bottom: 0;\n  right: 0;\n  margin-left: 14.375rem;\n  z-index: 99;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.breaking-news .news-item:hover .news-img:before {\n  opacity: 0;\n}\n.breaking-news .news-img {\n  position: relative;\n  overflow: hidden;\n}\n.breaking-news .news-img:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #0f1320;\n  opacity: 0.7;\n  transition: 0.3s;\n}\n.breaking-news .rate-container {\n  border-top: 1px solid 37;\n  font-size: 10px;\n  margin: 8px 7px 0;\n  padding-top: 8px;\n}\n.breaking-news .weather-container {\n  width: auto;\n  max-width: 180px;\n  border-top: 1px solid 37;\n  margin-top: 12px;\n  padding-top: 12px;\n}\n@media (max-width: 767.98px) {\n  .breaking-news .weather-container {\n    margin-left: 0;\n    border-left: none;\n    border-top: 1px solid 37;\n    margin-top: 5px;\n    padding-top: 5px;\n  }\n}\n.breaking-news a {\n  text-decoration: none;\n  color: #ffffff;\n  transition: 0.3s;\n}\n.breaking-news a p {\n  font-size: 20px;\n  line-height: 1.1;\n  background: rgba(255, 255, 255, 0.02);\n  padding: 12px;\n}\n.breaking-news a p > span:nth-child(1) {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 16px;\n}\n.breaking-news a p .news-item-desc {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  font-size: 14px;\n  opacity: 0.7;\n  font-weight: 300;\n  margin-bottom: 12px;\n}\n.breaking-news a p .text-date {\n  font-size: 9px;\n}\n.breaking-news a:hover {\n  color: #249d79;\n}\n.breaking-news .breaking-news-events {\n  position: absolute;\n  top: 0;\n  z-index: 2;\n  left: 16px;\n  transform: translate(0px, -100%);\n  display: flex;\n  gap: 8px;\n  width: auto;\n  background: var(--bs-dark2);\n  padding: 16px;\n}\n@media (max-width: 767.98px) {\n  .breaking-news .breaking-news-events {\n    left: 0;\n    flex-wrap: wrap;\n  }\n  .breaking-news .breaking-news-events > * {\n    flex: 0 0 calc(50% - 10px);\n  }\n}\n.breaking-news .breaking-news-title {\n  background: #e00000;\n  color: #ffffff;\n  font-weight: bold;\n  padding: 5px 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border-radius: 4px;\n  width: auto;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n.breaking-news .breaking-news-title i {\n  transform: rotate(180deg);\n}\n.breaking-news .breaking-news-col {\n  display: none;\n  padding-bottom: 24px;\n}\n.breaking-news.active {\n  padding: 12px 1.5rem 0;\n}\n.breaking-news.active .breaking-news-col {\n  display: block;\n}\n.breaking-news.active .breaking-news-title i {\n  transform: rotate(0deg);\n}\n@media (max-width: 1199.98px) {\n  .breaking-news {\n    margin-left: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .breaking-news {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .sandik-analizi-chart {\n    height: auto !important;\n  }\n  .sandik-analizi-chart > .col-12:first-child {\n    height: 50vh;\n  }\n  .sandik-analizi-chart > .col-12:nth-child(2) > .row > div {\n    height: auto !important;\n  }\n  .sandik-analizi-chart .row {\n    height: auto !important;\n  }\n  .sandik-analizi-chart .row > .col-lg-4 {\n    height: 500px !important;\n  }\n}\n\n.tree-chart {\n  height: calc(100vh - 200px);\n}\n.tree-chart > .col:nth-child(1) {\n  height: 100%;\n}\n@media (max-width: 1199.98px) {\n  .tree-chart {\n    height: auto;\n  }\n}\n\n#tooltip-item {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: #ffffff;\n  z-index: 1;\n  color: #000000;\n  border-radius: 4px;\n  padding: 2px 5px;\n  font-size: 12px;\n  pointer-events: none;\n  display: none;\n}\n#tooltip-item.active {\n  display: block;\n}\n\n.app-sidebar .app-theme-panel {\n  position: relative;\n  right: 0;\n  width: 100%;\n}\n\n.app-sidebar .app-theme-panel .app-theme-toggle-btn {\n  display: none;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container {\n  position: relative;\n  width: 100%;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content {\n  background: none;\n  box-shadow: none;\n  width: auto;\n  display: flex;\n  align-items: center;\n  padding: 0;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .small {\n  max-width: 60px;\n  opacity: 0.8;\n}\n\n.app-theme-list {\n  flex-direction: row;\n}\n\n.app-theme-list .app-theme-list-item {\n  flex: 1;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card {\n  margin-bottom: 0 !important;\n  flex: 1;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card:before,\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card:after {\n  display: none;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card .card-arrow {\n  display: none;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card .card-body {\n  padding: 0 !important;\n}\n\n.question-answer-button:hover label {\n  opacity: 1;\n}\n.question-answer-button input:checked ~ label {\n  opacity: 1;\n}\n.question-answer-button label {\n  opacity: 0.5;\n}\n\n/* Zoom */\n.menu-item-events-hover .menu-item-events {\n  display: none;\n}\n.menu-item-events-hover:hover .menu-item-events {\n  display: block;\n}\n\n.ck-editor-height-full .ck.ck-editor {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.ck-editor-height-full .ck.ck-editor .ck.ck-editor__main {\n  flex: 1;\n  overflow: auto;\n}\n\n.ck-editor-height-full .ck.ck-editor .ck.ck-editor__main .ck-content {\n  height: 100%;\n}\n\n.ck-editor-height-full {\n  height: 100%;\n}\n\n.survey-table,\n.survey-table td {\n  display: block;\n}\n\n.survey-table td {\n  flex: 1 0 50%;\n}\n\n.survey-table tr {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.survey-table td:nth-child(1) {\n  flex: 0 0 40px;\n}\n\n.survey-table td:last-child {\n  flex: 0 0 130px;\n}\n\n.survey-question-list-item {\n  border: 1px solid #4e545b;\n  padding: 10px;\n  margin-bottom: 15px;\n}\n\n.survey-question-list-item .list-item-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  border-bottom: 1px solid #4e545b;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n}\n\n.survey-question-list-item .list-item-header > div:first-child {\n  flex: 1;\n}\n\n@media screen and (max-width: 767px) {\n  .survey-question-list-item .list-item-header {\n    flex-direction: column;\n    gap: 0px;\n  }\n  .survey-question-list-item .row {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .survey-question-list-item .list-item-header > div:first-child {\n    width: 100%;\n  }\n  .survey-question-list-item .list-item-header > div:last-child {\n    width: 100%;\n    border-left: none;\n    margin-left: 0;\n    padding-left: 0;\n    border-top: 1px solid #4e545b;\n    padding-top: 10px;\n    margin-top: 10px;\n  }\n}\n/* Disaster */\n.app {\n  transition: 0.5s;\n}\n\n.disaster-page {\n  background: linear-gradient(180deg, #b70000 -190%, rgb(27, 0, 0) 90%) !important;\n  height: auto !important;\n}\n\n.modal {\n  z-index: 1120;\n}\n\n.profil-photo-item-upload {\n  opacity: 0;\n}\n.profil-photo-item:hover .profil-photo-item-upload {\n  opacity: 1;\n}\n\n.select-map .react-select__menu {\n  font-size: 12px !important;\n}\n\n.select-map .react-select__control {\n  border-color: #000000 !important;\n  height: 26px;\n  min-height: 26px;\n  padding: 0px 10px;\n}\n\n.select-map .react-select__control .react-select__value-container .react-select__single-value {\n  color: #000000;\n}\n\n.select-map .react-select__control .react-select__indicators .react-select__indicator {\n  color: #000000;\n}\n\n.progress-container {\n  display: flex;\n  align-items: center;\n  border: 1px solid #595d64;\n  padding: 10px;\n  border-radius: 4px;\n  font-size: 18px;\n}\n\n.progress-container input {\n  flex: 1;\n  margin-right: 10px;\n}\n\n/* Slider genel stili */\n.slider {\n  -webkit-appearance: none; /* Tarayıcı varsayılan stilini kaldırır */\n  appearance: none;\n  width: 100%;\n  height: 8px;\n  background: #c0cacf; /* Arka plan rengi */\n  outline: none;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.slider:hover {\n  opacity: 1; /* Hover'da opaklığı artırır */\n}\n\n/* Track (Arka plan) stili */\n.slider::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 8px;\n  background: #c0cacf;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.slider::-moz-range-track {\n  width: 100%;\n  height: 8px;\n  background: #c0cacf;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* Thumb (Tutma yeri) stili */\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #249d79; /* Thumb rengi */\n  margin-top: -6px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  background: #249d79; /* Thumb rengi */\n  border-radius: 50%;\n  margin-top: -6px;\n  cursor: pointer;\n}\n\n/* Slider'ın dolu kısmının rengi (Chrome ve Safari için) */\n.slider::-webkit-slider-runnable-track {\n  background: linear-gradient(to right, #249d79 0%, #249d79 var(--progress), #c0cacf var(--progress), #c0cacf 100%);\n}\n\n.slider::-moz-range-progress {\n  background: #249d79; /* Firefox'ta dolu kısmın rengi */\n  height: 8px;\n  border-radius: 4px;\n}\n\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 94px;\n}\n\n.react-datepicker__time-container {\n  float: none;\n  padding-left: 10px;\n  margin-left: 5px;\n  border-color: #555e69;\n}\n\n.react-datepicker-popper .react-datepicker {\n  display: flex;\n}\n\n.react-datepicker__header {\n  background: #222e3e;\n  border-color: #555e6a;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  color: #ffffff;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n  background: #222e3e;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  color: #ffffff;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background: #249d79;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  background: rgba(49, 157, 121, 0.1803921569);\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  background: rgba(49, 157, 121, 0.3215686275);\n}\n\n.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day:hover {\n  background: #249d79;\n}\n\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range) {\n  background: rgba(49, 157, 121, 0.568627451);\n}\n\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range) {\n  background: rgba(49, 157, 121, 0.3215686275);\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  color: #ffffff;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background: #1d2836;\n  border-color: #555e69;\n  color: #ffffff;\n}\n\n.react-datepicker__year-dropdown-container--scroll .react-datepicker__navigation {\n  background: none;\n  top: 0;\n}\n\n.react-datepicker__year-dropdown-container--scroll .react-datepicker__navigation:before {\n  content: \"\\f105\";\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  position: absolute;\n  font-size: 0.875rem;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: Font Awesome\\6 Free, Font Awesome\\6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  transform: rotate(-90deg);\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background: #293748;\n}\n\n.react-datepicker__year-option:last-of-type a:before {\n  transform: rotate(90deg) !important;\n}\n\n.react-datepicker__close-icon::after {\n  background: #e00000;\n}\n\n.question-block .question-block {\n  margin-left: 10px;\n  width: calc(100% - 15px);\n}\n\n.question-block .row.g-2.align-items-center:before {\n  margin-right: 10px;\n  margin-left: -10px;\n  content: \"\";\n  width: 10px;\n  height: 1px;\n  background: #ffffff;\n  display: block;\n}\n\n.question-block:before {\n  content: \"\";\n  width: 1px;\n  height: calc(100% - 122px);\n  background: #ffffff;\n  position: absolute;\n  top: 31px;\n  left: 15px;\n}\n.question-block.question-string:before {\n  height: calc(100% - 77px);\n}\n\n.question-block {\n  position: relative;\n}\n\n.question-block .question-block {\n  margin-top: 10px;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.question-block {\n  background: rgba(255, 255, 255, 0.03);\n  padding: 15px 10px 15px 30px;\n}\n\n.question-block:after {\n  content: \"\";\n  position: absolute;\n  top: 30px;\n  left: 15px;\n  width: 8px;\n  height: 1px;\n  background: #ffffff;\n}\n\n/* styles.css */\n.box {\n  position: relative;\n  box-sizing: border-box;\n  resize: both;\n  overflow: hidden;\n}\n\n.resizer {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background: #000000;\n  cursor: se-resize;\n}\n\n.resizer.bottom-right {\n  bottom: 0;\n  right: 0;\n}\n\n.rotate-animation {\n  display: block;\n  transform: rotate(0deg);\n  transform-origin: center;\n  animation: rotateAni 5s both infinite;\n}\n\n@keyframes rotateAni {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/*Now the CSS*/\n.tree {\n  white-space: nowrap;\n  overflow: auto;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.tree ul {\n  padding-top: 20px;\n  position: relative;\n  text-align: center;\n  transition: all 0.5s;\n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n}\n\n.tree li {\n  text-align: center;\n  list-style-type: none;\n  position: relative;\n  padding: 20px 5px 0 5px;\n  transition: all 0.5s;\n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n  /*added for long names*/\n  float: none;\n  display: inline-block;\n  vertical-align: top;\n  white-space: nowrap;\n  margin: 0 -2px 0 -2px;\n}\n\n/*We will use ::before and ::after to draw the connectors*/\n.tree li::before,\n.tree li::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 50%;\n  border-top: 1px solid #ccc;\n  width: 50%;\n  height: 20px;\n}\n\n.tree li::after {\n  right: auto;\n  left: 50%;\n  border-left: 1px solid #ccc;\n}\n\n/*We need to remove left-right connectors from elements without \n  any siblings*/\n.tree li:only-child::after,\n.tree li:only-child::before {\n  display: none;\n}\n\n/*Remove space from the top of single children*/\n.tree li:only-child {\n  padding-top: 0;\n}\n\n/*Remove left connector from first child and \n  right connector from last child*/\n.tree li:first-child::before,\n.tree li:last-child::after {\n  border: 0 none;\n}\n\n/*Adding back the vertical connector to the last nodes*/\n.tree li:last-child::before {\n  border-right: 1px solid #ccc;\n  border-radius: 0 5px 0 0;\n  -webkit-border-radius: 0 5px 0 0;\n  -moz-border-radius: 0 5px 0 0;\n}\n\n.tree li:first-child::after {\n  border-radius: 5px 0 0 0;\n  -webkit-border-radius: 5px 0 0 0;\n  -moz-border-radius: 5px 0 0 0;\n}\n\n/*Time to add downward connectors from parents*/\n.tree ul ul::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  border-left: 1px solid #ccc;\n  width: 0;\n  height: 20px;\n}\n\n.tree li a {\n  border: 1px solid #ccc;\n  padding: 10px 15px;\n  text-decoration: none;\n  color: #ffffff;\n  font-weight: 500;\n  font-size: 14px;\n  display: inline-block;\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  transition: all 0.2s;\n}\n\n/*Time for some hover effects*/\n/*We will apply the hover effect the the lineage of the element also*/\n.tree li a:hover,\n.tree li a:hover + ul li a {\n  background: #249d79;\n  color: #000000;\n  border: 1px solid #249d79;\n}\n\n/*Connector styles on hover*/\n.tree li a:hover + ul li::after,\n.tree li a:hover + ul li::before,\n.tree li a:hover + ul::before,\n.tree li a:hover + ul ul::before {\n  border-color: #94a0b4;\n}\n\n.user-info-hover-item {\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: 0.2s;\n}\n.user-info-hover:hover .user-info-hover-item {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: all;\n}\n\n.swiper-pagination {\n  position: static !important;\n  margin-top: 15px !important;\n}\n\n.swiper-pagination-bullet {\n  width: 10px !important;\n  border-radius: 10px !important;\n  background: #ffffff !important;\n}\n\n.swiper-pagination-bullet.swiper-pagination-bullet-active {\n  width: 20px !important;\n}\n\n.graphic-note-item .ck-sticky-panel__content {\n  display: none;\n}\n\n.graphic-note-item .jodit-toolbar__box {\n  display: none;\n}\n\nfigure.table table th,\nfigure.table table td {\n  border: 1px solid;\n  font-size: 15px;\n}\n\n.file-progress-card {\n  position: fixed;\n  right: 20px;\n  z-index: 99;\n  background: #12202c;\n  border: 1px solid 59;\n  padding: 20px;\n  border-radius: 8px;\n  color: #ffffff;\n  font-weight: 500;\n  width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.pagination {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 5px;\n}\n\n.pagination .paginate_button.page-item {\n  margin: 0;\n}\n\n.question-category-scroll {\n  height: 400px;\n  padding-bottom: 100px;\n  -webkit-mask-image: linear-gradient(180deg, rgba(255, 255, 255, 0) -100%, #ffffff 7.17%, #ffffff 70%, rgba(255, 255, 255, 0) 100%);\n  mask-image: linear-gradient(180deg, rgba(255, 255, 255, 0) -100%, #ffffff 7.17%, #ffffff 70%, rgba(255, 255, 255, 0) 100%);\n}\n\n.menu-first-dropdown .menu-item {\n  background: rgba(61, 210, 165, 0.08);\n  padding: 8px 0px !important;\n}\n\n.has-sub .menu-item.active {\n  border-top: 1px dashed 0;\n  border-bottom: 1px dashed 0;\n}\n\n.menu-first-dropdown > .menu-item.active:not(.has-sub) {\n  border-top: 1px dashed 0;\n  border-bottom: 1px dashed 0;\n}\n\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-link {\n  padding: 0 1rem !important;\n}\n\n.menu-item.has-sub.ps-0 {\n  padding: 1rem 0rem 0.5rem;\n}\n\n.menu-first-dropdown .menu-item.has-sub.ps-0 {\n  padding: 8px 0;\n}\n\n.menu-first-dropdown .menu-submenu {\n  padding-bottom: 0 !important;\n  margin-top: 12px;\n}\n\n.menu-other-dropdown .menu-submenu .menu-item {\n  background: rgba(61, 210, 165, 0.08);\n  padding: 8px;\n}\n\n.menu-other-dropdown .menu-submenu {\n  margin-top: 12px;\n}\n\n.menu-caret {\n  transform: rotate(-90deg);\n  transition: 0.3s;\n}\n\n.menu-caret.active {\n  transform: rotate(0deg);\n}\n\n.menu-item.active > div > .menu-link > .menu-caret {\n  transform: rotate(0deg);\n}\n\n.parent {\n  display: grid;\n  gap: 10px;\n}\n\n.div1,\n.div2,\n.div3 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  font-size: 20px;\n  color: #ffffff;\n}\n\n.menu-settings {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  margin: 0 10px;\n}\n\n.jodit-react-container {\n  color: black;\n}\n\n.jodit-container:not(.jodit_inline) .jodit-workplace {\n  min-height: 500px !important;\n}\n\n.jodit_sticky > .jodit-toolbar__box {\n  position: static;\n}\n\n:root {\n  --jd-color-1: #ffffff;\n  --jd-color-2: green;\n  --jd-color-3: #ffffff00;\n  --jd-color-4: #ffffff;\n  --jd-color-5: white;\n  --jd-color-6: rgb(255 255 255 / 25%);\n  --jd-color-7: #ffffff00;\n  --jd-color-8: rgb(255 255 255 / 25%);\n  --jd-color-9: #ffffff;\n}\n\n.jodit_theme_dark .jodit-toolbar__box:not(:empty) {\n  background: #141b24;\n}\n\n.jodit_theme_dark .jodit-ui-input__input {\n  color: black;\n}\n\n.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal {\n  background-image: repeating-linear-gradient(transparent 0, transparent 37px, var(--jd-color-6) 38px);\n}\n\n.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal {\n  background-image: repeating-linear-gradient(transparent 0, transparent 37px, var(--jd-color-6) 38px);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-collection_mode_horizontal:after {\n  background-color: var(--jd-color-6);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after {\n  background-color: var(--jd-color-6);\n}\n\n.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal:after {\n  background-color: var(--jd-color-6);\n}\n\n.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after {\n  background-color: var(--jd-color-6);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) {\n  border-color: var(--jd-color-6);\n}\n\n.jodit_theme_dark .jodit-toolbar__box:not(:empty) {\n  border-color: var(--jd-color-6);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after {\n  background-color: var(--jd-color-6);\n}\n\n.jodit_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after {\n  background-color: var(--jd-color-6);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-group_separated_true:not(:last-child, .jodit-ui-group_before-spacer_true):after {\n  border-right-color: var(--jd-color-6);\n}\n\n.jodit_theme_dark .jodit-ui-group_separated_true:not(:last-child, .jodit-ui-group_before-spacer_true):after {\n  border-right-color: var(--jd-color-6);\n}\n\n.jodit-dialog_theme_dark.jodit-container {\n  background-color: var(--jd-color-3);\n  border-color: var(--jd-color-8);\n}\n\n.jodit_theme_dark.jodit-container {\n  background-color: var(--jd-color-3);\n  border-color: var(--jd-color-8);\n}\n\n.jodit-dialog_theme_dark.jodit-container.jodit_disabled {\n  background-color: var(--jd-color-3);\n}\n\n.jodit_theme_dark.jodit-container.jodit_disabled {\n  background-color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace {\n  border-color: var(--jd-color-3);\n}\n\n.jodit_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace {\n  border-color: var(--jd-color-3);\n  background: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-popup__content {\n  background: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-popup__content {\n  background: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button__text {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select__text {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button__text {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button__text:hover:not([disabled]) {\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button__text {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select__text {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button__text {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-ui-button__text:hover:not([disabled]) {\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button svg {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button__trigger {\n  fill: var(--jd-color-9);\n  stroke: var(--jd-color-9);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select svg {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select__trigger {\n  fill: var(--jd-color-9);\n  stroke: var(--jd-color-9);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button svg {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button svg:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button svg:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button__trigger {\n  fill: var(--jd-color-9);\n  stroke: var(--jd-color-9);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button .jodit-icon {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button svg {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button__trigger {\n  fill: var(--jd-color-9);\n  stroke: var(--jd-color-9);\n}\n\n.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select .jodit-icon {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select svg {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select__trigger {\n  fill: var(--jd-color-9);\n  stroke: var(--jd-color-9);\n}\n\n.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button .jodit-icon {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button svg {\n  fill: var(--jd-color-4);\n  stroke: var(--jd-color-4);\n}\n\n.jodit_theme_dark .jodit-ui-button svg:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button svg:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button__trigger {\n  fill: var(--jd-color-9);\n  stroke: var(--jd-color-9);\n}\n\n.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n  stroke: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n  fill: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button__button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select__button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button__button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button__text:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button__button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select__button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button__button:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button__text:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n  background-color: var(--jd-color-4);\n  color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark .jodit-status-bar {\n  background-color: var(--jd-color-7);\n  border-color: var(--jd-color-6);\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {\n  background-color: var(--jd-color-7);\n  border-color: var(--jd-color-6);\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-status-bar {\n  background-color: var(--jd-color-7);\n  border-color: var(--jd-color-6);\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {\n  background-color: var(--jd-color-7);\n  border-color: var(--jd-color-6);\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-status-bar {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item a {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item span {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item a {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item span {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-status-bar {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item a {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item span {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item a {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item span {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) {\n  background: var(--jd-color-7);\n}\n\n.jodit_theme_dark .jodit-toolbar__box:not(:empty) {\n  background: var(--jd-color-7);\n}\n\n.jodit-dialog_theme_dark .jodit-icon-close {\n  stroke: var(--jd-color-4);\n}\n\n.jodit_theme_dark .jodit-icon-close {\n  stroke: var(--jd-color-4);\n}\n\n.jodit-dialog_theme_dark .jodit-wysiwyg {\n  background-color: var(--jd-color-3);\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-wysiwyg_iframe {\n  background-color: var(--jd-color-3);\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-wysiwyg {\n  background-color: var(--jd-color-3);\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-wysiwyg_iframe {\n  background-color: var(--jd-color-3);\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-form input[type=text] {\n  background-color: rgba(81, 81, 81, 0.41);\n  border-color: var(--jd-color-5);\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-form input[type=url] {\n  background-color: rgba(81, 81, 81, 0.41);\n  border-color: var(--jd-color-5);\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-form textarea {\n  background-color: rgba(81, 81, 81, 0.41);\n  border-color: var(--jd-color-5);\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-form input[type=text] {\n  background-color: rgba(81, 81, 81, 0.41);\n  border-color: var(--jd-color-5);\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-form input[type=url] {\n  background-color: rgba(81, 81, 81, 0.41);\n  border-color: var(--jd-color-5);\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-form textarea {\n  background-color: rgba(81, 81, 81, 0.41);\n  border-color: var(--jd-color-5);\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-form button {\n  background-color: hsla(0, 0%, 41%, 0.75);\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-form button {\n  background-color: hsla(0, 0%, 41%, 0.75);\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-placeholder {\n  color: hsla(0, 5%, 81%, 0.8);\n}\n\n.jodit_theme_dark .jodit-placeholder {\n  color: hsla(0, 5%, 81%, 0.8);\n}\n\n.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit_uploadfile_button {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-drag-and-drop__file-box {\n  color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit_uploadfile_button {\n  color: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box:hover {\n  background-color: hsla(0, 0%, 41%, 0.75);\n}\n\n.jodit-dialog_theme_dark .jodit_uploadfile_button:hover {\n  background-color: hsla(0, 0%, 41%, 0.75);\n}\n\n.jodit_theme_dark .jodit-drag-and-drop__file-box:hover {\n  background-color: hsla(0, 0%, 41%, 0.75);\n}\n\n.jodit_theme_dark .jodit_uploadfile_button:hover {\n  background-color: hsla(0, 0%, 41%, 0.75);\n}\n\n.jodit-dialog_theme_dark .jodit-add-new-line:before {\n  border-top-color: var(--jd-color-5);\n}\n\n.jodit_theme_dark .jodit-add-new-line:before {\n  border-top-color: var(--jd-color-5);\n}\n\n.jodit-dialog_theme_dark .jodit-add-new-line span {\n  background: hsla(0, 0%, 41%, 0.75);\n  border-color: var(--jd-color-5);\n}\n\n.jodit_theme_dark .jodit-add-new-line span {\n  background: hsla(0, 0%, 41%, 0.75);\n  border-color: var(--jd-color-5);\n}\n\n.jodit-dialog_theme_dark .jodit-add-new-line span svg {\n  fill: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-add-new-line span svg {\n  fill: var(--jd-color-1);\n}\n\n.jodit-dialog_theme_dark .jodit-resizer > i {\n  background: hsla(0, 0%, 41%, 0.75);\n  border-color: var(--jd-color-4);\n}\n\n.jodit_theme_dark .jodit-resizer > i {\n  background: hsla(0, 0%, 41%, 0.75);\n  border-color: var(--jd-color-4);\n}\n\n.jodit-dialog_theme_dark .jodit-input {\n  background-color: var(--jd-color-4);\n  border-color: var(--jd-color-2);\n  color: var(--jd-color-2);\n}\n\n.jodit-dialog_theme_dark .jodit-select {\n  background-color: var(--jd-color-4);\n  border-color: var(--jd-color-2);\n  color: var(--jd-color-2);\n}\n\n.jodit_theme_dark .jodit-input {\n  background-color: var(--jd-color-4);\n  border-color: var(--jd-color-2);\n  color: var(--jd-color-2);\n}\n\n.jodit_theme_dark .jodit-select {\n  background-color: var(--jd-color-4);\n  border-color: var(--jd-color-2);\n  color: var(--jd-color-2);\n}\n\n.jodit-dialog_theme_dark.jodit-dialog {\n  background-color: var(--jd-color-3);\n}\n\n.jodit_theme_dark.jodit-dialog {\n  background-color: var(--jd-color-3);\n}\n\n.jodit-dialog_theme_dark.jodit-dialog .jodit-dialog__header {\n  border-color: var(--jd-color-2);\n}\n\n.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item {\n  border-color: var(--jd-color-2);\n}\n\n.jodit_theme_dark.jodit-dialog .jodit-dialog__header {\n  border-color: var(--jd-color-2);\n}\n\n.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item {\n  border-color: var(--jd-color-2);\n}\n\n.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info {\n  background-color: var(--jd-color-1);\n}\n\n.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info {\n  background-color: var(--jd-color-1);\n}\n\n.jodit_theme_dark .jodit-toolbar-button:hover:not([disabled]) {\n  background: transparent;\n}\n\n.jodit_theme_dark .jodit-toolbar-button__button:hover:not([disabled]) {\n  background: rgba(255, 255, 255, 0.0784313725);\n  color: white;\n}\n\n.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n  background: rgba(255, 255, 255, 0.1098039216);\n}\n\n.jodit_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n  fill: white;\n}\n\n.jodit_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n  fill: white;\n}\n\n.jodit_theme_dark .jodit-popup__content {\n  background: #1d2836;\n}\n\n.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n  background: none;\n  color: white;\n}\n\n.tema-2[data-bs-theme=dark]:root {\n  --bs-theme: #b8c0ff;\n  --bs-theme-rgb: 184, 192, 255;\n}\n\n.tema-2[data-bs-theme=light]:root {\n  --bs-theme: #17248a;\n  --bs-theme-rgb: 23, 36, 138;\n}\n\n.tema-2 body {\n  font-family: Arial, Helvetica, sans-serif;\n}\n\niframe#webpack-dev-server-client-overlay {\n  display: none;\n}\n\n.tema-2 ::-webkit-scrollbar {\n  background: rgba(68, 79, 210, 0.1607843137);\n}\n\n.tema-2 .card:not(.border-0):after,\n.tema-2 .card:not(.border-0):before {\n  display: none;\n}\n\n.tema-2 .card .card-arrow {\n  display: none;\n}\n\n.tema-2 .card {\n  border-radius: 18px;\n}\n\n.tema-2 .h6 {\n  font-size: 12px;\n}\n\n.tema-2 #sidebar.app-sidebar {\n  top: 20px;\n  width: auto;\n  right: 20px;\n  left: 210px;\n  height: 90px;\n  border-radius: 0 18px 18px 0;\n  position: absolute;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);\n}\n\n.tema-2 #header.app-header {\n  left: 20px;\n  top: 20px;\n  height: 90px;\n  border-radius: 18px 18px 0 0;\n  box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.05);\n}\n\n.tema-2 .app-content {\n  margin-left: 0px;\n  padding-top: 150px;\n  padding-bottom: 60px;\n}\n\n.tema-2 .app-footer {\n  margin-left: 0;\n  margin-right: 30px;\n  padding: 15px 20px;\n  border-radius: 15px;\n}\n\n.tema-2 .app-footer p {\n  margin-bottom: 0 !important;\n}\n\n.tema-2 .breaking-news {\n  margin-left: 0;\n  position: relative;\n  border-radius: 20px;\n}\n\n.tema-2 .breaking-news .breaking-news-events {\n  border-radius: 18px 18px 0 0;\n}\n\n@media (min-width: 768px) {\n  .tema-2 .app-sidebar-toggled .app-header,\n  .tema-2 .app-sidebar-toggled .app-sidebar {\n    transform: translate(-110%, 0px);\n  }\n}\n.tema-2 .app-sidebar-button {\n  display: none;\n  border-radius: 10px;\n}\n\n.tema-2 .app-theme-panel .app-theme-toggle-btn {\n  border-radius: 100%;\n}\n\n.tema-2 .app-theme-panel .app-theme-panel-content > div + div {\n  display: none;\n}\n\n.tema-2 .app-theme-panel .app-theme-panel-content > div:first-child {\n  margin-bottom: 0 !important;\n}\n\n.tema-2 .app-theme-panel .app-theme-panel-content {\n  border-radius: 10px;\n}\n\n.tema-2 .app-theme-panel.active .app-theme-toggle-btn {\n  border-radius: 10px 0 0 10px;\n}\n\n.tema-2 .app-sidebar .app-sidebar-content .menu {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0;\n  overflow: initial;\n  align-items: center;\n}\n\n.tema-2 .app-sidebar .app-sidebar-content {\n  height: 100%;\n  flex-direction: row;\n  overflow: initial !important;\n}\n\n.tema-2 .menu-other-dropdown {\n  display: flex;\n}\n\n.tema-2 #header.app-header {\n  width: 190px;\n  border-radius: 18px 0 0 18px;\n  position: absolute;\n}\n\n.tema-2 .menu-first-dropdown {\n  position: absolute;\n  top: 95px;\n  left: 0;\n  right: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n}\n\n.tema-2 .app-sidebar .app-sidebar-content > div.mt-auto {\n  display: none;\n}\n\n.tema-2 .menu-first-dropdown .menu-item {\n  border-radius: 8px;\n}\n\n.tema-2 .menu .react-select__placeholder {\n  font-size: 11px;\n}\n\n.tema-2 .menu .react-select__control {\n  padding: 0px 5px;\n  min-height: 30px;\n}\n\n.tema-2 .menu > div > div.mx-3 {\n  margin-right: 0 !important;\n}\n\n.tema-2 .menu .react-select__option {\n  font-size: 10px;\n}\n\n@media (min-width: 1201px) {\n  .tema-2 .menu-settings {\n    display: flex;\n  }\n  .tema-2 .app-sidebar .app-sidebar-content .menu .menu-item .menu-submenu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin-top: 0;\n    min-width: 170px;\n  }\n  .tema-2 .app-sidebar .app-sidebar-content .menu .menu-header {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .tema-2 .menu-item.has-sub.ps-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .tema-2 .menu-item.has-sub.ps-0 {\n    position: relative;\n  }\n  .tema-2 .menu-other-dropdown .menu-submenu .menu-item {\n    background: var(--bs-dark4);\n  }\n}\n@media (max-width: 1200px) {\n  .tema-2 #sidebar.app-sidebar {\n    top: 90px;\n    left: 20px;\n    bottom: 10px;\n    width: 230px;\n    position: fixed;\n    height: auto;\n    box-shadow: none;\n    background: none;\n    transform: translate(-110%, 0px);\n  }\n  .tema-2 .app-sidebar .app-sidebar-content .menu {\n    display: block;\n  }\n  .tema-2 .app-sidebar .app-sidebar-content {\n    flex-direction: column;\n    width: 100%;\n    overflow: auto !important;\n    height: 100%;\n  }\n  .tema-2 .menu-other-dropdown {\n    display: block;\n  }\n  .tema-2 .app-sidebar .app-sidebar-content > div.mt-auto {\n    display: block;\n  }\n  .tema-2 #header.app-header {\n    position: fixed;\n    width: 230px;\n    border-radius: 14px;\n    height: 60px;\n  }\n  .tema-2 div#sidebar:before {\n    border-radius: 18px;\n    opacity: 1;\n  }\n  .tema-2 .app-sidebar-mobile-toggled #sidebar.app-sidebar {\n    transform: translate(0px, 0px);\n  }\n  .tema-2 .app-content {\n    padding-top: 110px;\n  }\n  .tema-2 .menu-first-dropdown {\n    position: static;\n    display: block;\n  }\n  .tema-2 .menu-first-dropdown .menu-item {\n    border-radius: 0;\n  }\n}\n.tema-2[data-bs-theme=dark] .menu-first-dropdown .menu-item {\n  background: #222a3b;\n}\n.tema-2[data-bs-theme=dark] .map-info-container {\n  background: #0f1320 !important;\n}\n\n.tema-2[data-bs-theme=light] .menu-first-dropdown .menu-item {\n  background: #f4f5fd;\n}\n\n@media (min-width: 992px) {\n  .app-boxed-layout {\n    min-height: 100vh;\n  }\n  .app-boxed-layout, .app-boxed-layout .app-header {\n    max-width: 80rem;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .app-boxed-layout .app-top-nav {\n    max-width: 80rem;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: hidden;\n  }\n  .app-boxed-layout .app-top-nav .menu .menu-item .menu-submenu {\n    position: fixed;\n    left: auto;\n    right: auto;\n    top: auto;\n  }\n  .app-boxed-layout .app-sidebar {\n    left: auto;\n  }\n}\n\n.app-content-full-height .app-content {\n  height: calc(100vh - 3.25rem);\n}\n.app-content-full-height.app-without-header .app-content {\n  height: 100vh;\n}\n\n.app-content-full-width .app-content {\n  margin: 0;\n}\n.app-content-full-width .app-footer {\n  margin-left: 2rem;\n}\n@media (max-width: 767.98px) {\n  .app-content-full-width .app-footer {\n    margin-left: 1rem;\n  }\n}\n\n.app-footer-fixed {\n  position: fixed;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 80px;\n}\n\n.app-full-height {\n  min-height: 100vh;\n}\n\n@keyframes appSidebarCollapse {\n  from {\n    margin-left: 0;\n    opacity: 1;\n  }\n  to {\n    margin-left: -14.375rem;\n    opacity: 0;\n  }\n}\n@keyframes appContentCollapse {\n  from {\n    margin-left: 14.375rem;\n  }\n  to {\n    margin-left: 0;\n  }\n}\n@keyframes appFooterCollapse {\n  from {\n    margin-left: 14.375rem;\n  }\n  to {\n    margin-left: 2rem;\n  }\n}\n@media (min-width: 768px) {\n  .app-sidebar-collapsed .app-sidebar {\n    margin-left: -10.475rem;\n  }\n  .app-sidebar-collapsed .app-content {\n    margin-left: 3.875rem;\n  }\n  .app-sidebar-collapsed .app-sidebar .menu {\n    opacity: 0;\n  }\n  .app-sidebar-collapsed .menu-footer {\n    transform: translate(8px, 0);\n  }\n  .app-sidebar-collapsed .menu-footer-title {\n    opacity: 0;\n  }\n}\n\n.app-sidebar-mobile-toggled .app-sidebar {\n  transform: translate(0%, 0px);\n}\n\n@keyframes appSidebarExpand {\n  from {\n    margin-left: -14.375rem;\n  }\n  to {\n    margin-left: 0;\n  }\n}\n@keyframes appContentExpand {\n  from {\n    margin-left: 0;\n  }\n  to {\n    margin-left: 14.375rem;\n  }\n}\n@keyframes appFooterExpand {\n  from {\n    margin-left: 2rem;\n  }\n  to {\n    margin-left: 16.375rem;\n  }\n}\n@media (min-width: 768px) {\n  .app-sidebar-toggled .app-sidebar-button {\n    transform: translate(100%, 0px);\n    opacity: 1;\n    visibility: visible;\n    pointer-events: all;\n  }\n  .app-sidebar-toggled .app-sidebar-button i {\n    transform: rotate(180deg);\n  }\n  .app-sidebar-toggled > .app-header {\n    transform: translate(-100%, 0px);\n  }\n  .app-sidebar-toggled .app-sidebar {\n    transform: translate(-100%, 0px);\n  }\n  .app-sidebar-toggled .app-content {\n    margin-left: 10px;\n  }\n  .app-sidebar-toggled .breaking-news {\n    margin-left: 10px;\n  }\n  .app-sidebar-toggled .app-footer {\n    margin-left: 10px;\n  }\n}\n\n@media (min-width: 768px) {\n  .app-with-top-nav {\n    padding-top: 6.125rem;\n  }\n  .app-with-top-nav .app-sidebar {\n    top: 6.125rem;\n  }\n}\n@media (min-width: 768px) {\n  .app-with-top-nav.app-without-header {\n    padding-top: 2.875rem;\n  }\n  .app-with-top-nav.app-without-header .app-sidebar {\n    top: 2.875rem;\n  }\n}\n\n.app-without-header {\n  padding-top: 0;\n}\n\n.app-without-sidebar .app-content {\n  margin: 0;\n}\n\n.breadcrumb {\n  font-weight: bold;\n}\n.breadcrumb .breadcrumb-item a {\n  text-decoration: none;\n}\n.breadcrumb .breadcrumb-item a:hover {\n  text-decoration: underline;\n}\n.btn-scroll-top {\n  position: fixed;\n  bottom: 1.875rem;\n  width: 2.5rem;\n  height: 2.5rem;\n  background: rgba(53, 67, 74, 0.75);\n  color: #ffffff;\n  text-align: center;\n  text-decoration: none;\n  z-index: 1020;\n  border-radius: 36px;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 1.875rem;\n}\n@media (max-width: 767.98px) {\n  .btn-scroll-top {\n    bottom: 1.25rem;\n    z-index: 1020;\n    right: 1.25rem;\n  }\n}\n.btn-scroll-top:hover {\n  background: var(--bs-theme);\n  color: var(--bs-theme-color);\n  text-decoration: none;\n}\n\n.card-expand .app-content {\n  z-index: 1120;\n  position: relative;\n  height: calc(100vh - 3.25rem);\n  overflow: hidden;\n}\n\n[data-bs-theme=light] .card {\n  background: rgb(255, 255, 255);\n}\n\n[data-bs-theme=dark] .card {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.card {\n  --bs-border-color-rgb: var(--bs-body-color-rgb);\n  position: relative;\n  border: none;\n}\n.card.border-theme {\n  --bs-border-color-rgb: var(--bs-theme-rgb);\n}\n.card.card-expand {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1120;\n  border-radius: 0;\n  margin: 0 !important;\n  padding: 0.3125rem;\n  background: var(--bs-dark3);\n  height: auto !important;\n}\n.card.card-expand .card-header, .card.card-expand .card-body {\n  border-radius: 0;\n}\n.card.card-expand .card-body {\n  flex: 1 0 0;\n  height: auto !important;\n  overflow: scroll;\n}\n.card.card-expand:not(.border-0):before {\n  top: 5px;\n  bottom: 5px;\n  left: 20px;\n  right: 20px;\n  pointer-events: none;\n}\n.card.card-expand:not(.border-0):after {\n  top: 20px;\n  bottom: 20px;\n  left: 5px;\n  right: 5px;\n  pointer-events: none;\n}\n.card.card-expand .card-arrow {\n  margin: 5px;\n  pointer-events: none;\n}\n.card .card-header .card-header-tabs .nav-item .nav-link.active {\n  border-bottom-color: transparent;\n}\n.card .card-body .nav-tabs .nav-item .nav-link.active {\n  background: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n.card:before, .card:after {\n  content: \"\";\n  position: absolute;\n  pointer-events: none;\n}\n.card:not(.border-0):before {\n  left: 15px;\n  right: 15px;\n  top: 0;\n  bottom: 0;\n  border-top: 1px solid rgba(var(--bs-border-color-rgb), 0.3);\n  border-bottom: 1px solid rgba(var(--bs-border-color-rgb), 0.3);\n}\n.card:not(.border-0):after {\n  top: 15px;\n  bottom: 15px;\n  left: 0;\n  right: 0;\n  border-left: 1px solid rgba(var(--bs-border-color-rgb), 0.3);\n  border-right: 1px solid rgba(var(--bs-border-color-rgb), 0.3);\n}\n.card > *:not(.card-arrow):not(.card-img-overlay):not(.card-img):not(.hljs-container) {\n  position: relative;\n  z-index: 10;\n}\n.card .card-arrow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n}\n.card .card-arrow-top-left, .card .card-arrow-top-right, .card .card-arrow-bottom-left, .card .card-arrow-bottom-right {\n  width: 10px;\n  height: 10px;\n  position: absolute;\n}\n.card .card-arrow-top-left:before, .card .card-arrow-top-right:before, .card .card-arrow-bottom-left:before, .card .card-arrow-bottom-right:before {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  height: 8px;\n  background: rgba(var(--bs-border-color-rgb), 0.75);\n}\n.card .card-arrow-top-left:after, .card .card-arrow-top-right:after, .card .card-arrow-bottom-left:after, .card .card-arrow-bottom-right:after {\n  content: \"\";\n  position: absolute;\n  width: 10px;\n  height: 2px;\n  background: rgba(var(--bs-border-color-rgb), 0.75);\n}\n.card .card-arrow-top-left, .card .card-arrow-top-right {\n  top: 0;\n}\n.card .card-arrow-top-left:before, .card .card-arrow-top-right:before {\n  top: 2px;\n}\n.card .card-arrow-top-left:after, .card .card-arrow-top-right:after {\n  top: 0;\n}\n.card .card-arrow-bottom-left, .card .card-arrow-bottom-right {\n  bottom: 0;\n}\n.card .card-arrow-bottom-left:before, .card .card-arrow-bottom-right:before {\n  bottom: 2px;\n}\n.card .card-arrow-bottom-left:after, .card .card-arrow-bottom-right:after {\n  bottom: 0;\n}\n.card .card-arrow-top-left, .card .card-arrow-bottom-left {\n  left: 0;\n}\n.card .card-arrow-top-left:before, .card .card-arrow-top-left:after, .card .card-arrow-bottom-left:before, .card .card-arrow-bottom-left:after {\n  left: 0;\n}\n.card .card-arrow-top-right, .card .card-arrow-bottom-right {\n  right: 0;\n}\n.card .card-arrow-top-right:before, .card .card-arrow-top-right:after, .card .card-arrow-bottom-right:before, .card .card-arrow-bottom-right:after {\n  right: 0;\n}\n\n@media (max-width: 991.98px) {\n  .card-columns {\n    column-count: 2;\n  }\n}\n@media (max-width: 575.98px) {\n  .card-columns {\n    column-count: 1;\n  }\n}\n\n.caret:before {\n  content: \"\\f22c\";\n  display: inline-block;\n  font-family: bootstrap-icons !important;\n  font-style: normal;\n  font-weight: 400 !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: -0.125em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.dropup.caret, .dropup .caret {\n  content: \"\";\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid\\9 ;\n}\n\n.carousel-indicators [data-bs-target] {\n  overflow: hidden;\n}\n\n@keyframes appDropdownShow {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.dropdown-menu {\n  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n}\n.dropdown-menu.show {\n  animation: appDropdownShow 0.25s both cubic-bezier(0.7, 0, 0.3, 1);\n}\n\n@media (max-width: 575.98px) {\n  .dropdown.dropdown-mobile-full {\n    position: initial;\n  }\n  .dropdown.dropdown-mobile-full .dropdown-menu {\n    left: 0.25rem !important;\n    right: 0.25rem !important;\n    width: auto !important;\n  }\n}\n\n[data-bs-theme=dark] .form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23000000' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23000000'/%3e%3c/svg%3e\");\n}\n\n.form-select:not([multiple]) option {\n  color: #000000;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n[data-bs-theme=dark] .form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n[data-bs-theme=dark] .form-switch .form-check-input:checked {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23000000'/%3e%3c/svg%3e\");\n}\n\nhr.hr-bg, hr.hr-transparent, hr.hr-inverse, hr.hr-inverse-transparent {\n  border: none;\n  height: 1px;\n}\nhr.hr-transparent {\n  background-color: rgba(0, 0, 0, 0.3);\n}\nhr.hr-inverse {\n  background-color: #1a1a1a;\n}\nhr.hr-inverse-transparent {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\na {\n  color: var(--bs-theme);\n}\na:hover {\n  color: rgba(var(--bs-theme-rgb), 0.75);\n}\n\n.modal .modal-content > * {\n  position: relative;\n}\n.modal .modal-dialog.modal-full {\n  max-width: 100%;\n  width: 100%;\n}\n.modal .modal-dialog.modal-full .modal-content {\n  border-radius: 0;\n}\n.modal.modal-cover .modal-dialog {\n  min-height: 100%;\n  margin-top: 0;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n}\n.modal.modal-cover .modal-content, .modal.modal-cover .modal-header, .modal.modal-cover .modal-footer {\n  background: none;\n  border: none;\n}\n\n[data-bs-theme=dark] .modal-backdrop {\n  --bs-backdrop-bg: #1d2835;\n}\n\n.nav.nav-pills::-webkit-scrollbar {\n  height: 5px;\n}\n.nav.nav-tabs.nav-tabs-v2::-webkit-scrollbar {\n  height: 5px;\n}\n.nav.nav-tabs.nav-tabs-v2 > .nav-item > .nav-link {\n  border: none;\n  border-bottom: 3px solid transparent;\n  padding: 1rem 0;\n  color: var(--bs-inverse);\n}\n.nav.nav-tabs.nav-tabs-v2 > .nav-item > .nav-link:hover, .nav.nav-tabs.nav-tabs-v2 > .nav-item > .nav-link.active {\n  color: var(--bs-inverse);\n  border-bottom-color: var(--bs-theme);\n}\n.nav.nav-tabs.nav-tabs-v2 > .nav-item.show > .nav-link {\n  color: var(--bs-inverse);\n  border-bottom-color: var(--bs-theme);\n}\n\n@media (max-width: 767.98px) {\n  .nav-wizards-container {\n    overflow: scroll;\n  }\n  .nav-wizards-container .nav.nav-wizards-1, .nav-wizards-container .nav.nav-wizards-2, .nav-wizards-container .nav.nav-wizards-3 {\n    min-width: 37.5rem;\n  }\n}\n\n.nav.nav-wizards-1 .nav-item {\n  padding: 0;\n}\n.nav.nav-wizards-1 .nav-item .nav-link {\n  position: relative;\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n}\n.nav.nav-wizards-1 .nav-item .nav-link .nav-no {\n  width: 2.5rem;\n  height: 2.5rem;\n  margin: 0 auto;\n  font-weight: 600;\n  background: none;\n  border: 2px solid var(--bs-border-color);\n  position: relative;\n  z-index: 10;\n  border-radius: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s linear;\n}\n.nav.nav-wizards-1 .nav-item .nav-link .nav-text {\n  text-align: center;\n  margin-top: 0.3125rem;\n  font-weight: 600;\n  font-size: 0.8125rem;\n}\n.nav.nav-wizards-1 .nav-item .nav-link.active, .nav.nav-wizards-1 .nav-item .nav-link.completed {\n  color: var(--bs-theme);\n}\n.nav.nav-wizards-1 .nav-item .nav-link.active .nav-no, .nav.nav-wizards-1 .nav-item .nav-link.completed .nav-no {\n  border-color: var(--bs-theme);\n  color: var(--bs-theme);\n}\n.nav.nav-wizards-1 .nav-item .nav-link.active:before, .nav.nav-wizards-1 .nav-item .nav-link.active:after, .nav.nav-wizards-1 .nav-item .nav-link.completed:before, .nav.nav-wizards-1 .nav-item .nav-link.completed:after {\n  background: var(--bs-theme);\n}\n.nav.nav-wizards-1 .nav-item .nav-link.active .nav-no {\n  box-shadow: 0 0 0 5px rgba(var(--bs-theme-rgb), 0.2);\n}\n.nav.nav-wizards-1 .nav-item .nav-link.disabled {\n  color: rgba(var(--bs-inverse-rgb), 0.25);\n}\n.nav.nav-wizards-1 .nav-item .nav-link:before {\n  content: \"\";\n  position: absolute;\n  top: 1.625rem;\n  height: 0.125rem;\n  background: rgba(var(--bs-inverse-rgb), 0.3);\n  transition: all 0.2s linear;\n}\n.nav.nav-wizards-1 .nav-item .nav-link:before {\n  left: calc(-50% + 20px);\n  right: calc(50% + 20px);\n}\n.nav.nav-wizards-1 .nav-item:first-child .nav-link:before {\n  display: none;\n}\n.nav.nav-wizards-1 .nav-item:last-child .nav-link:after {\n  display: none;\n}\n.nav.nav-wizards-2 .nav-item {\n  padding: 0 1rem;\n}\n.nav.nav-wizards-2 .nav-item .nav-link {\n  position: relative;\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n  background: rgba(var(--bs-inverse-rgb), 0.15);\n  border-radius: 60px;\n}\n.nav.nav-wizards-2 .nav-item .nav-link .nav-text {\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.8125rem;\n}\n.nav.nav-wizards-2 .nav-item .nav-link:before {\n  content: \"\";\n  position: absolute;\n  left: -2rem;\n  right: 100%;\n  height: 0.125rem;\n  top: 50%;\n  margin-top: -0.0625rem;\n  background-color: rgba(var(--bs-inverse-rgb), 0.3);\n  transition: all 0.2s linear;\n}\n.nav.nav-wizards-2 .nav-item .nav-link.disabled {\n  color: rgba(var(--bs-inverse-rgb), 0.35);\n}\n.nav.nav-wizards-2 .nav-item .nav-link.active, .nav.nav-wizards-2 .nav-item .nav-link.completed {\n  background: var(--bs-theme);\n  color: var(--bs-theme-color);\n}\n.nav.nav-wizards-2 .nav-item .nav-link.active:before, .nav.nav-wizards-2 .nav-item .nav-link.completed:before {\n  background: var(--bs-theme);\n}\n.nav.nav-wizards-2 .nav-item .nav-link.active {\n  box-shadow: 0 0 0 4px rgba(var(--bs-theme-rgb), 0.2);\n}\n.nav.nav-wizards-2 .nav-item:first-child .nav-link:before {\n  display: none;\n}\n.nav.nav-wizards-3 .nav-item {\n  padding: 0;\n}\n.nav.nav-wizards-3 .nav-item .nav-link {\n  position: relative;\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n}\n.nav.nav-wizards-3 .nav-item .nav-link .nav-dot {\n  width: 1rem;\n  height: 1rem;\n  margin: 0 auto;\n  font-weight: 600;\n  background: none;\n  border: 3px solid var(--bs-border-color);\n  position: relative;\n  z-index: 10;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s linear;\n}\n.nav.nav-wizards-3 .nav-item .nav-link .nav-title {\n  margin-top: 0.625rem;\n  font-weight: 600;\n  text-align: center;\n}\n.nav.nav-wizards-3 .nav-item .nav-link .nav-text {\n  text-align: center;\n  font-size: 0.8125rem;\n}\n.nav.nav-wizards-3 .nav-item .nav-link.active, .nav.nav-wizards-3 .nav-item .nav-link.completed {\n  color: var(--bs-theme);\n}\n.nav.nav-wizards-3 .nav-item .nav-link.active .nav-dot, .nav.nav-wizards-3 .nav-item .nav-link.completed .nav-dot {\n  border-color: var(--bs-theme);\n  color: var(--bs-theme);\n}\n.nav.nav-wizards-3 .nav-item .nav-link.active:before, .nav.nav-wizards-3 .nav-item .nav-link.completed:before {\n  background: var(--bs-theme);\n}\n.nav.nav-wizards-3 .nav-item .nav-link.active .nav-dot {\n  box-shadow: 0 0 0 5px rgba(var(--bs-theme-rgb), 0.2);\n}\n.nav.nav-wizards-3 .nav-item .nav-link.disabled {\n  color: rgba(var(--bs-inverse-rgb), 0.25);\n}\n.nav.nav-wizards-3 .nav-item .nav-link:before {\n  content: \"\";\n  position: absolute;\n  left: calc(-50% + 8px);\n  top: 0.875rem;\n  right: calc(50% + 8px);\n  height: 0.1875rem;\n  background: rgba(var(--bs-inverse-rgb), 0.3);\n}\n.nav.nav-wizards-3 .nav-item:first-child .nav-link:before {\n  display: none;\n}\n\n.navbar.navbar-sticky {\n  top: 5.25rem;\n  position: sticky;\n  padding: 0;\n  border-left: 1px solid var(--bs-border-color);\n  margin-left: 1rem;\n}\n.navbar.navbar-sticky .nav {\n  width: 100%;\n  flex-direction: column;\n}\n.navbar.navbar-sticky .nav .nav-link {\n  color: rgba(var(--bs-inverse-rgb), 0.6);\n  padding: 0.25rem 1.5rem;\n}\n.navbar.navbar-sticky .nav .nav-link:hover {\n  color: rgba(var(--bs-inverse-rgb), 1);\n}\n.navbar.navbar-sticky .nav .nav-link.active {\n  color: var(--bs-theme);\n  font-weight: 500;\n}\n\n.page-header {\n  color: var(--bs-heading-color);\n  padding: 0;\n  border: none;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  font-size: 1.75rem;\n}\n.page-header small, .page-header .small {\n  font-size: 1rem;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  font-weight: 300;\n}\n\n.pagination .page-item .page-link {\n  border-radius: 0.25rem;\n}\n.pagination .page-item + .page-item {\n  margin-left: 0.3125rem;\n}\n\npre {\n  display: block;\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: #44555e;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: #ffffff;\n  border: 1px solid #a8b6bc;\n  border-radius: 4px;\n}\n\n.row.row-grid > [class*=col-] + [class*=col-] {\n  border-left: 1px solid rgba(var(--bs-inverse-rgb), 0.15);\n}\n.row.row-grid + .row-grid {\n  border-top: 1px solid rgba(var(--bs-inverse-rgb), 0.15);\n}\n\n.table.table-card thead > tr td:first-child, .table.table-card thead > tr th:first-child, .table.table-card tbody > tr td:first-child, .table.table-card tbody > tr th:first-child {\n  padding-left: 1rem;\n}\n.table.table-card thead > tr td:last-child, .table.table-card thead > tr th:last-child, .table.table-card tbody > tr td:last-child, .table.table-card tbody > tr th:last-child {\n  padding-right: 1rem;\n}\n.table.table-xs {\n  font-size: 0.75rem;\n}\n.table.table-xs thead th, .table.table-xs tbody th, .table.table-xs tfoot th {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n}\n.table.table-xs thead td, .table.table-xs tbody td, .table.table-xs tfoot td {\n  padding: 0.3125rem 0.5rem;\n}\n\n.toasts-container {\n  position: fixed;\n  top: 5px;\n  padding-top: 1rem;\n  width: 21.875rem;\n  z-index: 9999;\n  right: 0;\n  padding-right: 1rem;\n}\n@media (max-width: 767.98px) {\n  .toasts-container {\n    width: 18.75rem;\n  }\n}\n.toasts-container .toast {\n  width: 100%;\n}\n\n.apexcharts-canvas .apexcharts-tooltip {\n  font-size: 0.8125rem;\n  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n}\n.apexcharts-canvas .apexcharts-tooltip * {\n  font-family: inherit !important;\n}\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light, .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark {\n  border: none;\n  background: rgba(var(--bs-body-bg-rgb), 0.9);\n  color: var(--bs-inverse);\n}\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title, .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(var(--bs-inverse-rgb), 0.15);\n  border-color: transparent;\n  color: var(--bs-inverse);\n  text-transform: uppercase;\n}\n.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {\n  font-family: inherit !important;\n  font-weight: 600;\n  padding: 0.35rem 0.75rem;\n  margin: 0;\n}\n.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group {\n  padding: 0.35rem 0.75rem;\n}\n.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group .apexcharts-tooltip-marker {\n  width: 0.625rem;\n  height: 0.625rem;\n  margin-right: 0.25rem;\n}\n.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group .apexcharts-tooltip-text .apexcharts-tooltip-y-group {\n  padding: 0;\n}\n.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group + .apexcharts-tooltip-series-group {\n  padding-top: 0;\n}\n.apexcharts-canvas .apexcharts-xaxistooltip * {\n  font-family: inherit !important;\n}\n.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark {\n  color: #ffffff;\n  background: #35434a;\n  border-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-bottom:before, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-bottom:after, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-top:before, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-top:before {\n  border-top-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-top:after, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-top:after {\n  border-top-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-yaxistooltip * {\n  font-family: inherit !important;\n}\n.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark {\n  color: #ffffff;\n  background: #35434a;\n  border-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-right:before, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-right:before {\n  border-right-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-right:after, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-right:after {\n  border-right-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-left:before, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-left:before {\n  border-left-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-left:after, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-left:after {\n  border-left-color: #35434a;\n}\n.apexcharts-canvas .apexcharts-legend-marker {\n  width: 0.625rem !important;\n  height: 0.625rem !important;\n  margin-right: 0.3125rem;\n}\n.apexcharts-canvas .apexcharts-menu {\n  background: rgba(var(--bs-body-bg-rgb), 0.98);\n  border: none;\n  padding: 0;\n  border-radius: 0;\n  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n}\n.apexcharts-canvas .apexcharts-menu .apexcharts-menu-item {\n  color: var(--bs-body-color);\n}\n.apexcharts-canvas .apexcharts-menu .apexcharts-menu-item:hover {\n  background: rgba(var(--bs-body-color-rgb), 0.15);\n  color: var(--bs-body-color);\n}\n.apexcharts-canvas.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-reset-icon:hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-menu-icon:hover svg {\n  fill: #ffffff;\n}\n\nbody .daterangepicker {\n  z-index: 1030;\n  border-color: var(--bs-border-color-translucent);\n  font-family: inherit;\n  font-size: inherit;\n  background: rgba(var(--bs-body-bg-rgb), 0.98);\n  border-radius: 0;\n  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n  width: auto;\n}\nbody .daterangepicker:before, body .daterangepicker:after {\n  display: none;\n}\nbody .daterangepicker:after {\n  border-width: 0.4375rem;\n  top: -0.4375rem;\n  left: 0.625rem;\n}\nbody .daterangepicker.opensright:after {\n  right: 0.625rem;\n  left: auto;\n}\nbody .daterangepicker select.monthselect, body .daterangepicker select.yearselect {\n  font-size: 0.7875rem;\n}\nbody .daterangepicker .drp-calendar {\n  max-width: inherit;\n  padding: 0.75rem;\n}\nbody .daterangepicker .drp-calendar .calendar-table {\n  background: none;\n  border: none;\n  border-radius: 0;\n}\nbody .daterangepicker .drp-calendar .calendar-table table thead .week, body .daterangepicker .drp-calendar .calendar-table table tbody .week {\n  font-size: 0.74375rem;\n  color: #c0cacf;\n  font-weight: 600;\n}\nbody .daterangepicker .drp-calendar .calendar-table table thead tr th {\n  min-width: auto;\n  width: auto;\n  height: auto;\n  line-height: 1;\n  padding: 0.375rem 0.75rem;\n  color: var(--bs-inverse);\n  font-weight: 600;\n  font-size: inherit;\n  border: none;\n}\nbody .daterangepicker .drp-calendar .calendar-table table thead tr th.prev span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next span {\n  border-color: rgba(var(--bs-inverse-rgb), 0.5);\n}\nbody .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:hover, body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:focus, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:hover, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:focus {\n  background: none;\n  color: var(--bs-theme);\n}\nbody .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:hover span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:focus span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:hover span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:focus span {\n  border-color: var(--bs-theme);\n}\nbody .daterangepicker .drp-calendar .calendar-table table thead tr th.month .yearselect, body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .monthselect {\n  border-color: var(--bs-border-color);\n  background: transparent;\n  border-radius: 4px;\n  color: var(--bs-inverse);\n  transition: all 0.2s linear;\n}\nbody .daterangepicker .drp-calendar .calendar-table table thead tr th.month .yearselect:focus, body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .monthselect:focus {\n  outline: none;\n  border-color: rgba(var(--bs-inverse-rgb), 0.5);\n  box-shadow: 0 0 0 0.125rem rgba(var(--bs-inverse-rgb), 0.5);\n}\nbody .daterangepicker .drp-calendar .calendar-table table thead tr:last-child th {\n  font-size: 0.74375rem;\n  padding-bottom: 0.5rem;\n}\nbody .daterangepicker .drp-calendar .calendar-table table tbody tr td {\n  min-width: auto;\n  width: auto;\n  height: auto;\n  line-height: 1.3;\n  padding: 0.625rem 0.375rem;\n  font-weight: 400;\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n  border-color: var(--bs-border-color-translucent);\n  font-size: 0.7875rem;\n  border-radius: 0 !important;\n}\nbody .daterangepicker .drp-calendar .calendar-table table tbody tr td.available:hover, body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available:focus {\n  background: var(--bs-theme);\n  border-color: var(--bs-theme);\n  color: var(--bs-theme-color);\n}\nbody .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.in-range {\n  background: rgba(var(--bs-theme-rgb), 0.25);\n  border-color: rgba(var(--bs-theme-rgb), 0.5);\n  color: var(--bs-inverse);\n  border-radius: 0;\n}\nbody .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.active {\n  background: var(--bs-theme);\n  border-color: var(--bs-theme);\n  color: var(--bs-theme-color);\n}\nbody .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.start-date {\n  border-radius: 0;\n}\nbody .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.end-date {\n  border-radius: 0;\n}\nbody .daterangepicker .drp-calendar .calendar-table table tbody tr td.off {\n  background: none;\n  color: rgba(var(--bs-inverse-rgb), 0.25);\n}\nbody .daterangepicker .drp-calendar.left {\n  padding: 0.75rem !important;\n}\nbody .daterangepicker .drp-calendar.left .calendar-table {\n  padding: 0 !important;\n}\nbody .daterangepicker .drp-calendar.right {\n  padding: 0.75rem !important;\n  border-left: 1px solid var(--bs-border-color);\n}\n@media (max-width: 575.98px) {\n  body .daterangepicker .drp-calendar.right {\n    border-top: 1px solid var(--bs-border-color);\n    border-left: none;\n  }\n}\nbody .daterangepicker .drp-buttons {\n  padding: 0.75rem 0.75rem;\n  border-color: var(--bs-border-color);\n  background: rgba(var(--bs-inverse-rgb), 0.05);\n  border: none;\n}\nbody .daterangepicker .drp-buttons .btn.btn-primary {\n  background: none;\n  border: 1px solid var(--bs-btn-border-color);\n  color: var(--bs-btn-color);\n  --bs-btn-color: #249d79;\n  --bs-btn-border-color: #249d79;\n  --bs-btn-hover-color: #249d79;\n  --bs-btn-hover-bg: #249d79;\n  --bs-btn-hover-border-color: #249d79;\n  --bs-btn-focus-shadow-rgb: 36, 157, 121;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #249d79;\n  --bs-btn-active-border-color: #249d79;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #249d79;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #249d79;\n  --bs-gradient: none;\n}\nbody .daterangepicker .drp-buttons .btn.btn-primary:hover, body .daterangepicker .drp-buttons .btn.btn-primary:active {\n  background: var(--bs-btn-hover-bg);\n}\nbody .daterangepicker .drp-buttons .btn.btn-default {\n  background: none;\n  border: 1px solid var(--bs-btn-border-color);\n  color: var(--bs-btn-color);\n  --bs-btn-color: #798e98;\n  --bs-btn-border-color: #798e98;\n  --bs-btn-hover-color: #798e98;\n  --bs-btn-hover-bg: #798e98;\n  --bs-btn-hover-border-color: #798e98;\n  --bs-btn-focus-shadow-rgb: 121, 142, 152;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #798e98;\n  --bs-btn-active-border-color: #798e98;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #798e98;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #798e98;\n  --bs-gradient: none;\n}\nbody .daterangepicker .drp-buttons .btn.btn-default:hover, body .daterangepicker .drp-buttons .btn.btn-default:active {\n  color: #000000;\n  background: var(--bs-btn-hover-bg);\n}\nbody .daterangepicker .ranges {\n  display: none;\n}\nbody .daterangepicker.show-ranges .ranges {\n  position: relative;\n  display: block;\n}\n@media (max-width: 767.98px) {\n  body .daterangepicker.show-ranges .ranges {\n    float: none;\n    margin: 0;\n    padding: 0.625rem;\n    border-bottom: 1px solid var(--bs-border-color);\n    overflow: scroll;\n    max-width: 35rem;\n  }\n}\n@media (max-width: 767.98px) {\n  body .daterangepicker.show-ranges .ranges ul {\n    width: auto;\n    white-space: nowrap;\n    display: flex;\n    flex-wrap: nowrap;\n    padding-right: 0.625rem;\n  }\n}\nbody .daterangepicker.show-ranges .ranges ul li {\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  font-size: 0.8125rem;\n  font-weight: 400;\n}\n@media (max-width: 767.98px) {\n  body .daterangepicker.show-ranges .ranges ul li {\n    border-radius: 4px;\n    margin-right: 0.625rem !important;\n  }\n}\nbody .daterangepicker.show-ranges .ranges ul li:hover, body .daterangepicker.show-ranges .ranges ul li:focus {\n  background: rgba(var(--bs-inverse-rgb), 0.15);\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n}\nbody .daterangepicker.show-ranges .ranges ul li.active {\n  background: var(--bs-theme);\n  color: var(--bs-theme-color);\n  margin-right: -0.0625rem;\n}\nbody .daterangepicker.show-ranges .drp-calendar.left {\n  border-left: 1px solid rgba(var(--bs-inverse-rgb), 0.15) !important;\n}\n@media (max-width: 767.98px) {\n  body .daterangepicker.show-ranges .drp-calendar.left {\n    border-left: none !important;\n  }\n}\n\n.dataTables_wrapper.dt-bootstrap5 .dataTables_length .form-select {\n  margin: 0 0.5rem;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTables_scrollFootInner .table-bordered tr th:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTables_scrollHeadInner .table-bordered tr th:first-child {\n  border-left: 1px solid var(--bs-border-color) !important;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTables_scrollFoot {\n  z-index: 1020;\n  margin-top: -0.125rem !important;\n  position: inherit;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTables_scrollFoot .dataTables_scrollFootInner {\n  border-top: 1px solid var(--bs-border-color) !important;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTables_scrollBody {\n  border-left: none !important;\n}\n.dataTables_wrapper.dt-bootstrap5 .dt-buttons .btn-outline-default {\n  background-color: transparent;\n}\n.dataTables_wrapper.dt-bootstrap5 .dt-buttons .btn-outline-default:hover, .dataTables_wrapper.dt-bootstrap5 .dt-buttons .btn-outline-default:focus {\n  background-color: #798e98;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable.dtr-inline tr td.dtr-control:before {\n  border-width: 1px;\n  margin-top: -8px;\n  border-color: var(--bs-border-color);\n  background: none;\n  box-shadow: none;\n  color: var(--bs-inverse);\n  border-radius: 0;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable.dtr-inline tr td.dtr-control:hover:before {\n  background: var(--bs-border-color);\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable.dtr-inline tr.parent td.dtr-control:before {\n  border-color: var(--bs-theme);\n  color: var(--bs-theme);\n  background: none;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc_disabled, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc_disabled, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc_disabled, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc_disabled {\n  padding-right: 1.875rem;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc_disabled::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc_disabled::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc_disabled::before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc_disabled::before {\n  content: \"\\f235\";\n  top: 20%;\n  display: inline-block;\n  font-family: bootstrap-icons !important;\n  font-style: normal;\n  font-weight: 400 !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: -0.125em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc_disabled::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc_disabled::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc_disabled::after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc_disabled::after {\n  content: \"\\f229\";\n  top: 45%;\n  display: inline-block;\n  font-family: bootstrap-icons !important;\n  font-style: normal;\n  font-weight: 400 !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: -0.125em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_asc:before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th.sorting_desc:after, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_asc:before, .dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > td.sorting_desc:after {\n  color: var(--bs-theme);\n  opacity: 1;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead .dtfc-fixed-left, .dataTables_wrapper.dt-bootstrap5 .dataTable thead .dtfc-fixed-right, .dataTables_wrapper.dt-bootstrap5 .dataTable tbody .dtfc-fixed-left, .dataTables_wrapper.dt-bootstrap5 .dataTable tbody .dtfc-fixed-right, .dataTables_wrapper.dt-bootstrap5 .dataTable tfoot .dtfc-fixed-left, .dataTables_wrapper.dt-bootstrap5 .dataTable tfoot .dtfc-fixed-right {\n  z-index: 1;\n  background-color: var(--bs-body-bg);\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead .dtfc-fixed-left:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable thead .dtfc-fixed-right:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable tbody .dtfc-fixed-left:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable tbody .dtfc-fixed-right:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable tfoot .dtfc-fixed-left:first-child, .dataTables_wrapper.dt-bootstrap5 .dataTable tfoot .dtfc-fixed-right:first-child {\n  border-left: none;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable.dtfc-has-left tfoot {\n  border: none !important;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable.dtfc-has-left tfoot > tr {\n  height: 0 !important;\n}\n.dataTables_wrapper.dt-bootstrap5 .dataTable.dtfc-has-left .dataTables_empty {\n  text-align: left !important;\n}\n.dataTables_wrapper.dt-bootstrap5 .dtfc-right-top-blocker {\n  height: auto !important;\n  margin-top: 0 !important;\n  background: var(--bs-border-color) !important;\n}\n\n.fc-event-list .fc-event-item .fc-event-link {\n  padding: 0.35rem 0.7rem;\n  color: var(--bs-inverse);\n  position: relative;\n  border: 1px solid var(--bs-border-color);\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n}\n.fc-event-list .fc-event-item .fc-event-link:hover {\n  background: rgba(var(--bs-inverse-rgb), 0.1);\n}\n.fc-event-list .fc-event-item .fc-event-link:after {\n  content: \"\\f0b2\";\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  line-height: 1;\n  margin-left: auto;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n.fc-event-list .fc-event-item + .fc-event-item {\n  margin-top: 0.5rem;\n}\n\n.fc-event-link.fc-dragging, .fc-event-link.fc-event-dragging {\n  padding: 0.35rem 0.7rem;\n  background: rgba(var(--bs-inverse-rgb), 0.15);\n  border: 1px solid var(--bs-border-color);\n  color: var(--bs-inverse);\n  display: block;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n}\n\n.fc .fc-toolbar, .fc .fc-header-toolbar {\n  margin-bottom: 0 !important;\n  flex-wrap: wrap;\n  align-items: center;\n}\n.fc .fc-toolbar .fc-left, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1), .fc .fc-header-toolbar .fc-left, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) {\n  border-bottom: 1px solid var(--bs-border-color);\n  padding: 1rem;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 575.98px) {\n  .fc .fc-toolbar .fc-left .btn-group, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group, .fc .fc-header-toolbar .fc-left .btn-group, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group {\n    width: 100%;\n  }\n}\n.fc .fc-toolbar .fc-left .btn, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn, .fc .fc-header-toolbar .fc-left .btn, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn {\n  min-width: 6.25rem;\n  background: none;\n  padding-top: 0.2rem;\n  padding-bottom: 0.2rem;\n  color: var(--bs-btn-color);\n  --bs-btn-color: #798e98;\n  --bs-btn-border-color: #798e98;\n  --bs-btn-hover-color: #798e98;\n  --bs-btn-hover-bg: #798e98;\n  --bs-btn-hover-border-color: #798e98;\n  --bs-btn-focus-shadow-rgb: 121, 142, 152;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #798e98;\n  --bs-btn-active-border-color: #798e98;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #798e98;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #798e98;\n  --bs-gradient: none;\n}\n@media (max-width: 991.98px) {\n  .fc .fc-toolbar .fc-left .btn, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn, .fc .fc-header-toolbar .fc-left .btn, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn {\n    min-width: 5.625rem;\n  }\n}\n.fc .fc-toolbar .fc-left .btn:hover, .fc .fc-toolbar .fc-left .btn:active, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn:hover, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn:active, .fc .fc-header-toolbar .fc-left .btn:hover, .fc .fc-header-toolbar .fc-left .btn:active, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn:hover, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn:active {\n  color: #000000;\n  background: var(--bs-btn-hover-bg);\n}\n.fc .fc-toolbar .fc-center, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(2), .fc .fc-header-toolbar .fc-center, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(2) {\n  flex: 1;\n  padding: 1rem;\n}\n.fc .fc-toolbar .fc-right, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3), .fc .fc-header-toolbar .fc-right, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) {\n  padding: 1rem;\n}\n.fc .fc-toolbar .fc-right .btn, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn, .fc .fc-header-toolbar .fc-right .btn, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .btn {\n  padding-top: 0.2rem;\n  padding-bottom: 0.2rem;\n  background: none;\n  --bs-btn-color: #798e98;\n  --bs-btn-border-color: #798e98;\n  --bs-btn-hover-color: #798e98;\n  --bs-btn-hover-bg: #798e98;\n  --bs-btn-hover-border-color: #798e98;\n  --bs-btn-focus-shadow-rgb: 121, 142, 152;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #798e98;\n  --bs-btn-active-border-color: #798e98;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #798e98;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #798e98;\n  --bs-gradient: none;\n}\n.fc .fc-toolbar .fc-right .btn:hover, .fc .fc-toolbar .fc-right .btn:active, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn:hover, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn:active, .fc .fc-header-toolbar .fc-right .btn:hover, .fc .fc-header-toolbar .fc-right .btn:active, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .btn:hover, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .btn:active {\n  color: #000000;\n}\n.fc .fc-view .fc-event, .fc .fc-view .fc-event-dot {\n  background-color: rgba(var(--bs-inverse-rgb), 0.15);\n  border-color: transparent;\n}\n.fc .fc-view .fc-event.fc-daygrid-dot-event, .fc .fc-view .fc-event-dot.fc-daygrid-dot-event {\n  background-color: rgba(var(--bs-inverse-rgb), 0.15);\n  border-color: transparent;\n}\n.fc .fc-view.fc-dayGrid-view .fc-week-number, .fc .fc-view.fc-dayGrid-view .fc-day-number, .fc .fc-view.fc-dayGrid-view .fc-daygrid-day-number, .fc .fc-view.fc-dayGridMonth-view .fc-week-number, .fc .fc-view.fc-dayGridMonth-view .fc-day-number, .fc .fc-view.fc-dayGridMonth-view .fc-daygrid-day-number {\n  padding: 0.125rem 0.25rem;\n}\n.fc .fc-view.fc-dayGrid-view .fc-day-grid-event, .fc .fc-view.fc-dayGrid-view .fc-daygrid-day-events, .fc .fc-view.fc-dayGridMonth-view .fc-day-grid-event, .fc .fc-view.fc-dayGridMonth-view .fc-daygrid-day-events {\n  margin-top: 0.125rem;\n}\n.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-slats table, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-bg table {\n  border: none;\n}\n.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-slats table tbody tr:first-child td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-slats table thead tr:first-child td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-bg table tbody tr:first-child td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-bg table thead tr:first-child td {\n  border-top: none;\n}\n.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-content-skeleton table {\n  border: none !important;\n}\n.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-content-skeleton table td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-content-skeleton table th {\n  border: none !important;\n}\n.fc .fc-view a {\n  text-decoration: none;\n}\n.fc .fc-view .fc-daygrid-event, .fc .fc-view .fc-timegrid-event-harness-inset .fc-timegrid-event, .fc .fc-view .fc-timegrid-event.fc-event-mirror, .fc .fc-view .fc-timegrid-more-link {\n  box-shadow: none;\n  border-radius: 0;\n}\n.fc td, .fc th {\n  border-width: 1px;\n  border-color: var(--bs-border-color);\n}\n.fc .fc-view-harness {\n  height: auto !important;\n}\n.fc .fc-scroller-liquid-absolute {\n  position: relative !important;\n  overflow: initial !important;\n}\n.fc a:not([href]) {\n  color: inherit;\n}\n\n.hljs {\n  display: block;\n  overflow-x: auto;\n  color: var(--bs-gray-500);\n  font-size: 0.7875rem;\n}\n\n.hljs-code,\n.hljs-emphasis {\n  font-style: italic;\n}\n\n.hljs-tag,\n.hljs-name {\n  color: var(--bs-gray-300);\n}\n\n.hljs-string,\n.hljs-bullet {\n  color: var(--bs-indigo);\n}\n\n.hljs-attr {\n  color: var(--bs-teal);\n}\n\n.hljs a {\n  color: inherit;\n}\n.hljs a:focus, .hljs a:hover {\n  color: inherit;\n  text-decoration: underline;\n}\n\n.hljs-container {\n  padding: 1rem 1rem;\n  border-top: 1px solid var(--bs-border-color);\n  position: relative;\n  z-index: 1;\n}\n.hljs-container pre {\n  border: none;\n  padding: 0;\n  margin: 0;\n  background: none;\n  border-radius: 0;\n}\n\n.ps {\n  position: relative;\n}\n.ps .ps__rail-x, .ps .ps__rail-y {\n  z-index: 10;\n}\n.ps .ps__rail-x.ps--clicking, .ps .ps__rail-x:hover, .ps .ps__rail-x:focus, .ps .ps__rail-y.ps--clicking, .ps .ps__rail-y:hover, .ps .ps__rail-y:focus {\n  background: none;\n}\n.ps .ps__thumb-y {\n  border-radius: 0;\n  background: none;\n}\n.ps .ps__thumb-y:before {\n  content: \"\";\n  background: #aaa;\n  position: absolute;\n  top: 0.0625rem;\n  bottom: 0.0625rem;\n  right: 0;\n  left: 0;\n}\n\n.app-sidebar .ps__rail-x,\n.app-sidebar .ps__rail-y {\n  display: none;\n}\n\n.rdt .rdtPicker {\n  width: auto;\n  background: rgba(var(--bs-body-bg-rgb), 0.98);\n  border: 1px solid var(--bs-border-color-translucent);\n  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n}\n.rdt .rdtPicker table thead tr th.rdtPrev, .rdt .rdtPicker table thead tr th.rdtNext, .rdt .rdtPicker table thead tr th.rdtSwitch {\n  line-height: 20px;\n  padding: 5px;\n  height: auto;\n  min-height: 30px;\n  border: none;\n  border-radius: 4px;\n}\n.rdt .rdtPicker table thead tr th.rdtPrev:hover, .rdt .rdtPicker table thead tr th.rdtPrev:focus, .rdt .rdtPicker table thead tr th.rdtNext:hover, .rdt .rdtPicker table thead tr th.rdtNext:focus, .rdt .rdtPicker table thead tr th.rdtSwitch:hover, .rdt .rdtPicker table thead tr th.rdtSwitch:focus {\n  background: rgba(var(--bs-body-color-rgb), 0.15);\n}\n.rdt .rdtPicker table thead tr th.rdtPrev:hover span:before, .rdt .rdtPicker table thead tr th.rdtPrev:focus span:before, .rdt .rdtPicker table thead tr th.rdtNext:hover span:before, .rdt .rdtPicker table thead tr th.rdtNext:focus span:before, .rdt .rdtPicker table thead tr th.rdtSwitch:hover span:before, .rdt .rdtPicker table thead tr th.rdtSwitch:focus span:before {\n  color: var(--bs-body-color);\n}\n.rdt .rdtPicker table thead tr th.rdtPrev, .rdt .rdtPicker table thead tr th.rdtNext {\n  color: transparent;\n  width: 14.28%;\n  position: relative;\n}\n.rdt .rdtPicker table thead tr th.rdtPrev span, .rdt .rdtPicker table thead tr th.rdtNext span {\n  color: transparent;\n  position: relative;\n  display: block;\n  border-radius: 4px;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n.rdt .rdtPicker table thead tr th.rdtPrev span:before, .rdt .rdtPicker table thead tr th.rdtNext span:before {\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  position: absolute;\n  font-size: 14px;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.rdt .rdtPicker table thead tr th.rdtPrev span i, .rdt .rdtPicker table thead tr th.rdtNext span i {\n  display: none;\n}\n.rdt .rdtPicker table thead tr th.rdtPrev span:before {\n  content: \"\\f104\";\n}\n.rdt .rdtPicker table thead tr th.rdtNext span:before {\n  content: \"\\f105\";\n}\n.rdt .rdtPicker table thead tr th.rdtSwitch {\n  width: auto;\n}\n.rdt .rdtPicker table thead tr th.dow {\n  padding: 5px 0;\n}\n.rdt .rdtPicker table tfoot {\n  border: none;\n}\n.rdt .rdtPicker table tfoot tr td.rdtTimeToggle {\n  border: none;\n  font-weight: 600;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  text-shadow: none;\n  border-radius: 4px;\n}\n.rdt .rdtPicker table tfoot tr td.rdtTimeToggle:hover, .rdt .rdtPicker table tfoot tr td.rdtTimeToggle:focus {\n  background: rgba(var(--bs-body-color-rgb), 0.15);\n  text-shadow: none;\n}\n.rdt .rdtPicker .rdtTime {\n  min-width: 180px;\n}\n.rdt .rdtPicker .rdtTime .rdtCounters {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.rdt .rdtPicker .rdtTime .rdtCounters > div {\n  float: none;\n}\n.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter {\n  height: 110px;\n  width: 60px;\n}\n.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn {\n  height: 35%;\n  color: transparent;\n  position: relative;\n  border-radius: 4px;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn:before {\n  content: \"\\f106\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn:hover, .rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn:focus {\n  background: rgba(var(--bs-body-color-rgb), 0.15);\n}\n.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtCount {\n  height: 30%;\n  font-weight: 600;\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtCount + .rdtBtn:before {\n  content: \"\\f107\";\n}\n.rdt .rdtPicker .rdtDays {\n  min-width: 290px;\n}\n.rdt .rdtPicker .rdtDays .rdtDay {\n  font-weight: 400;\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n  padding: 5px;\n  line-height: 20px;\n  border-radius: 8px;\n}\n.rdt .rdtPicker .rdtDays .rdtDay:hover, .rdt .rdtPicker .rdtDays .rdtDay:focus, .rdt .rdtPicker .rdtDays .rdtDay.rdtSelected, .rdt .rdtPicker .rdtDays .rdtDay.rdtHighlighted, .rdt .rdtPicker .rdtDays .rdtDay.rdtRange {\n  background: rgba(var(--bs-body-color-rgb), 0.15) !important;\n  text-shadow: none;\n}\n.rdt .rdtPicker .rdtDays .rdtDay.rdtToday {\n  background: var(--bs-theme) !important;\n  color: var(--bs-theme-color) !important;\n}\n.rdt .rdtPicker .rdtDays .rdtDay.rdtToday:before {\n  border-bottom-color: var(--bs-inverse);\n}\n.rdt .rdtPicker .rdtDays .rdtDay.rdtActive {\n  background: var(--bs-theme) !important;\n  color: var(--bs-theme-color) !important;\n  text-shadow: none !important;\n}\n.rdt .rdtPicker .rdtDays .rdtDay.rdtOld {\n  color: rgba(var(--bs-inverse-rgb), 0.25);\n}\n.rdt .rdtPicker .rdtDays .rdtDay.rdtNew {\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n}\n.rdt .rdtPicker .rdtDays .rdtDay.rdtDisabled {\n  color: rgba(var(--bs-inverse-rgb), 0.25);\n}\n.rdt .rdtPicker .rdtDays .rdtDay.rdtDisabled:hover, .rdt .rdtPicker .rdtDays .rdtDay.rdtDisabled:focus {\n  background: none !important;\n}\n.rdt .rdtPicker .rdtMonths, .rdt .rdtPicker .rdtYears {\n  min-width: 290px;\n}\n.rdt .rdtPicker .rdtMonths .rdtMonth, .rdt .rdtPicker .rdtMonths .rdtYear, .rdt .rdtPicker .rdtYears .rdtMonth, .rdt .rdtPicker .rdtYears .rdtYear {\n  font-weight: 600;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  text-shadow: none;\n  border-radius: 4px;\n}\n.rdt .rdtPicker .rdtMonths .rdtMonth:hover, .rdt .rdtPicker .rdtMonths .rdtMonth:focus, .rdt .rdtPicker .rdtMonths .rdtYear:hover, .rdt .rdtPicker .rdtMonths .rdtYear:focus, .rdt .rdtPicker .rdtYears .rdtMonth:hover, .rdt .rdtPicker .rdtYears .rdtMonth:focus, .rdt .rdtPicker .rdtYears .rdtYear:hover, .rdt .rdtPicker .rdtYears .rdtYear:focus {\n  background: rgba(var(--bs-body-color-rgb), 0.15);\n}\n.rdt .rdtPicker .rdtMonths .rdtMonth.rdtFocused, .rdt .rdtPicker .rdtMonths .rdtYear.rdtFocused, .rdt .rdtPicker .rdtYears .rdtMonth.rdtFocused, .rdt .rdtPicker .rdtYears .rdtYear.rdtFocused {\n  background: rgba(var(--bs-body-color-rgb), 0.15);\n  color: var(--bs-inverse);\n}\n.rdt .rdtPicker .rdtMonths .rdtMonth.rdtActive, .rdt .rdtPicker .rdtMonths .rdtYear.rdtActive, .rdt .rdtPicker .rdtYears .rdtMonth.rdtActive, .rdt .rdtPicker .rdtYears .rdtYear.rdtActive {\n  background: #249d79 !important;\n  color: var(--bs-inverse);\n}\n\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.react-datepicker {\n  border: none;\n  display: block;\n  font-family: inherit;\n  background: none;\n}\n.react-datepicker-popper .react-datepicker {\n  padding: 0.3125rem;\n  background: rgba(var(--bs-body-bg-rgb), 0.98);\n  z-index: 10;\n  border-radius: 0;\n  border: 1px solid var(--bs-border-color-translucent);\n  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);\n}\n.react-datepicker .react-datepicker__triangle {\n  display: none;\n}\n.react-datepicker .react-datepicker__navigation {\n  color: transparent;\n  padding: 0.3125rem;\n  line-height: 1.25rem;\n  border: none;\n  width: 1.875rem;\n  height: 1.875rem;\n  top: 0.3125rem;\n  text-indent: 0;\n  border-radius: 8px;\n}\n.react-datepicker .react-datepicker__navigation:hover, .react-datepicker .react-datepicker__navigation:focus {\n  background: rgba(var(--bs-body-color-rgb), 0.15);\n  outline: none;\n}\n.react-datepicker .react-datepicker__navigation:hover:after, .react-datepicker .react-datepicker__navigation:focus:after {\n  color: var(--bs-body-color);\n}\n.react-datepicker .react-datepicker__navigation:after {\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  position: absolute;\n  font-size: 0.875rem;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n.react-datepicker .react-datepicker__navigation .react-datepicker__navigation-icon {\n  display: none;\n}\n.react-datepicker .react-datepicker__navigation.react-datepicker__navigation--previous:after {\n  content: \"\\f104\";\n}\n.react-datepicker .react-datepicker__navigation.react-datepicker__navigation--next:after {\n  content: \"\\f105\";\n}\n.react-datepicker .react-datepicker__month-container {\n  float: none;\n}\n.react-datepicker .react-datepicker__month-container .react-datepicker__header {\n  background: none;\n  border: none;\n  padding: 0;\n}\n.react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__current-month {\n  font-size: 0.75rem;\n  color: var(--bs-inverse);\n  font-weight: 600;\n  padding: 0.3125rem;\n  line-height: 1.25rem;\n}\n.react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__day-names {\n  display: flex;\n  margin-bottom: -0.1875rem;\n}\n.react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__day-names .react-datepicker__day-name {\n  font-weight: 600;\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n  font-size: 0.75rem;\n  padding: 0.3125rem;\n  line-height: 1.25rem;\n  margin: 0;\n  flex: 1;\n}\n.react-datepicker .react-datepicker__month-container .react-datepicker__month {\n  margin: 0;\n}\n.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week {\n  display: flex;\n}\n.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day {\n  padding: 0.3125rem;\n  margin: 0.125rem;\n  width: 1.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  flex: 1;\n  border-radius: 4px;\n}\n.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day:hover, .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day:focus, .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day.react-datepicker__day--today, .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day.react-datepicker__day--keyboard-selected {\n  background: rgba(var(--bs-body-color-rgb), 0.15);\n  color: var(--bs-inverse);\n  outline: none;\n}\n.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day.react-datepicker__day--selected {\n  background: #249d79;\n  color: #ffffff;\n}\n\nbody .react-select__control {\n  border: 1px solid var(--bs-border-color);\n  background: none;\n  border-radius: 4px;\n  padding: 0.375rem 0.75rem;\n  min-height: 2.1875rem;\n}\nbody .react-select__control:hover {\n  border-color: var(--bs-border-color);\n}\nbody .react-select__control.react-select__control--is-focused {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n  border-color: var(--bs-border-color);\n}\nbody .react-select__control .react-select__value-container {\n  padding: 0;\n}\nbody .react-select__control .react-select__value-container .react-select__placeholder {\n  margin: 0;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n}\nbody .react-select__control .react-select__value-container .react-select__single-value {\n  color: var(--bs-inverse);\n}\nbody .react-select__control .react-select__value-container .react-select__input-container {\n  margin: 0;\n  padding: 0;\n  color: #fff;\n}\nbody .react-select__control .react-select__value-container .react-select__input-container .react-select__input {\n  color: var(--bs-inverse);\n}\nbody .react-select__control .react-select__value-container.react-select__value-container--is-multi {\n  margin-bottom: -0.3125rem;\n}\nbody .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__placeholder, body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__input-container {\n  margin-top: -0.3125rem;\n}\nbody .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value {\n  margin: 0 0.25rem 0.25rem 0;\n  background: var(--bs-theme);\n}\nbody .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value .react-select__multi-value__label {\n  color: var(--bs-theme-color);\n  font-size: 0.75rem;\n  padding: 0.125rem;\n  padding-left: 0.375rem;\n}\nbody .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value .react-select__multi-value__remove {\n  border-radius: 0;\n  padding: 0 3px;\n}\nbody .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value .react-select__multi-value__remove:hover {\n  background: none;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n}\nbody .react-select__control .react-select__indicators .react-select__indicator {\n  padding: 0;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n}\nbody .react-select__control .react-select__indicators .react-select__indicator:hover {\n  color: var(--bs-inverse);\n}\nbody .react-select__control .react-select__indicators .react-select__indicator-separator {\n  background: none;\n  margin: 0;\n}\nbody .react-select__menu {\n  background: rgba(var(--bs-body-bg-rgb), 0.98);\n  border-radius: 0;\n  border: 1px solid var(--bs-border-color-translucent);\n  z-index: 99;\n}\nbody .react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-focused {\n  background: rgba(var(--bs-body-color-rgb), 0.15);\n}\nbody .react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-selected {\n  background: #249d79;\n  color: #ffffff;\n}\n\nbody .rti--container {\n  background: transparent;\n  border: 1px solid var(--bs-border-color);\n  border-radius: 4px;\n  padding: 0.25rem 0.75rem;\n  line-height: 1;\n  gap: 0.25rem;\n}\nbody .rti--container:focus-within {\n  border-color: rgba(var(--bs-inverse-rgb), 0.5);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);\n}\nbody .rti--container .rti--tag {\n  font-size: 0.75rem;\n  color: var(--bs-theme-color);\n  line-height: 0.9375rem;\n  min-height: 1.25rem;\n  font-weight: 500;\n  border-radius: 1.25rem;\n  padding: 0.3125rem 0.75rem;\n  background: var(--bs-theme);\n}\nbody .rti--container .rti--tag button {\n  margin-top: 0.0625rem;\n  margin-bottom: -0.0625rem;\n  color: var(--bs-theme-color);\n  margin-right: -0.3125rem;\n  margin-left: 0.3125rem;\n}\nbody .rti--container .rti--tag button:hover {\n  color: var(--bs-theme-color);\n  opacity: 0.5;\n}\nbody .rti--container .rti--input {\n  background: none;\n  color: var(--bs-inverse);\n}\nbody .rti--container .rti--input::placeholder {\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  font-weight: 400;\n}\n\n.calendar {\n  min-height: calc(100vh - 3.25rem);\n  display: flex;\n  border-left: 1px solid var(--bs-border-color);\n}\n@media (max-width: 767.98px) {\n  .calendar {\n    border: none;\n  }\n}\n.calendar .calendar-body {\n  flex: 1;\n  height: calc(100vh - 3.25rem);\n}\n.calendar .calendar-body + .calendar-sidebar {\n  border-left: 1px solid var(--bs-border-color);\n}\n.calendar .calendar-body .fc .fc-head-container th {\n  border-bottom-width: 0;\n}\n.calendar .calendar-body .fc table {\n  border: none !important;\n}\n.calendar .calendar-body .fc table thead tr, .calendar .calendar-body .fc table tbody tr {\n  border-width: 0;\n}\n.calendar .calendar-body .fc table thead tr th:first-child, .calendar .calendar-body .fc table thead tr td:first-child, .calendar .calendar-body .fc table tbody tr th:first-child, .calendar .calendar-body .fc table tbody tr td:first-child {\n  border-left-width: 0 !important;\n}\n.calendar .calendar-body .fc table thead tr th:last-child, .calendar .calendar-body .fc table thead tr td:last-child, .calendar .calendar-body .fc table tbody tr th:last-child, .calendar .calendar-body .fc table tbody tr td:last-child {\n  border-right-width: 0 !important;\n}\n.calendar .calendar-body .fc table .fc-head-container {\n  border: none;\n}\n.calendar .calendar-sidebar {\n  width: 13.75rem;\n  padding: 1rem;\n}\n@media (min-width: 992px) {\n  .calendar .calendar-sidebar {\n    height: calc(100vh - 3.25rem);\n  }\n}\n@media (max-width: 991.98px) {\n  .calendar .calendar-sidebar {\n    display: none;\n  }\n}\n.calendar .calendar-sidebar + .calendar-body {\n  border-left: 1px solid var(--bs-border-color);\n}\n.calendar .calendar-sidebar .calendar-sidebar-title {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: flex-end;\n}\n\n.coming-soon {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n}\n.coming-soon .coming-soon-img img {\n  max-width: 100%;\n}\n.coming-soon .coming-soon-timer {\n  padding: 2rem;\n  min-height: 50vh;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n.coming-soon .coming-soon-content {\n  min-height: 50vh;\n  position: relative;\n  text-align: center;\n  margin: 0 auto;\n  padding: 2rem;\n  background: linear-gradient(to bottom, rgba(var(--bs-inverse-rgb), 0.15) 0%, transparent 100%);\n  flex: 1;\n}\n.coming-soon .coming-soon-content > * {\n  max-width: 32.5rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n.coming-soon .is-countdown {\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n.coming-soon .is-countdown:before, .coming-soon .is-countdown:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.coming-soon .is-countdown .countdown-row {\n  display: block;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.coming-soon .is-countdown .countdown-row .countdown-section {\n  width: 7.5rem;\n  padding: 1rem;\n  background: rgba(var(--bs-inverse-rgb), 0.15);\n  margin: 0.75rem;\n  color: var(--bs-inverse);\n  border-radius: 12px;\n}\n@media (max-width: 575.98px) {\n  .coming-soon .is-countdown .countdown-row .countdown-section {\n    width: 5rem;\n    padding: 0.5rem 0;\n    margin: 0.25rem;\n  }\n}\n.coming-soon .is-countdown .countdown-amount {\n  font-size: 3rem;\n  font-weight: 600;\n  line-height: 1.25;\n}\n@media (max-width: 575.98px) {\n  .coming-soon .is-countdown .countdown-amount {\n    font-size: 1.75rem;\n  }\n}\n.coming-soon .is-countdown .countdown-period {\n  font-size: 1.00625rem;\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n  line-height: 1.5;\n}\n@media (max-width: 575.98px) {\n  .coming-soon .is-countdown .countdown-period {\n    font-size: 0.7875rem;\n  }\n}\n\n.data-management .dataTables_wrapper .dataTable {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  color: var(--bs-body-color);\n}\n.data-management .dataTables_wrapper .dataTables_filter {\n  text-align: left;\n  margin-bottom: 1rem;\n  font-size: 0.75rem;\n}\n.data-management .dataTables_wrapper .dataTables_filter label {\n  display: flex;\n  align-items: center;\n}\n.data-management .dataTables_wrapper .dataTables_filter input {\n  border-radius: 4px;\n  font-size: 0.8125rem;\n  min-width: 12.5rem;\n}\n@media (max-width: 991.98px) {\n  .data-management .dataTables_wrapper .dataTables_filter input {\n    min-width: inherit;\n    flex: 1;\n    width: 100%;\n  }\n}\n\n.error-page {\n  padding: 4rem 0;\n  display: flex;\n  align-items: center;\n}\n.error-page .error-page-content {\n  margin: 0 auto;\n  position: relative;\n  padding: 0 1rem;\n  text-align: center;\n}\n.error-page .error-page-content .error-code {\n  color: var(--bs-inverse);\n  left: 0;\n  right: 0;\n  font-size: 7.375rem;\n  font-weight: 600;\n  text-align: center;\n  line-height: 1.25;\n  letter-spacing: 5px;\n  text-shadow: 10px 10px rgba(var(--bs-inverse-rgb), 0.15);\n}\n@media (max-width: 575.98px) {\n  .error-page .error-page-content .error-code {\n    font-size: 6.375rem;\n  }\n}\n.error-page .error-page-content .error-page-icon i {\n  font-size: 8rem;\n  color: #90a2aa;\n}\n.error-page .error-page-content h1, .error-page .error-page-content .h1 {\n  font-size: 3rem;\n  font-weight: 600;\n}\n@media (max-width: 575.98px) {\n  .error-page .error-page-content h1, .error-page .error-page-content .h1 {\n    font-size: 3.25rem;\n  }\n}\n.error-page .error-page-content h3, .error-page .error-page-content .h3 {\n  font-size: 1.125rem;\n  font-weight: 400;\n}\n@media (max-width: 575.98px) {\n  .error-page .error-page-content h3, .error-page .error-page-content .h3 {\n    font-size: 1rem;\n  }\n}\n.error-page .error-page-content .link-divider {\n  width: 0.25rem;\n  height: 0.25rem;\n  display: inline-block;\n  background: rgba(var(--bs-inverse-rgb), 0.3);\n  position: relative;\n  top: -0.125rem;\n  margin: 0 1rem;\n  border-radius: 4px;\n}\n\n.gallery-menu-container {\n  min-width: 12.5rem;\n}\n@media (min-width: 768px) {\n  .gallery-menu-container {\n    min-height: calc(100vh - 3.25rem);\n    border-right: 1px solid var(--bs-border-color);\n  }\n}\n\n.gallery-menu {\n  padding: 1rem;\n  padding: 0;\n}\n@media (max-width: 767.98px) {\n  .gallery-menu {\n    overflow: scroll;\n    border-bottom: 1px solid var(--bs-border-color);\n    position: sticky;\n    top: 3.25rem;\n    display: flex;\n    flex-wrap: nowrap;\n  }\n}\n.gallery-menu .gallery-menu-header {\n  padding: 1rem 1rem 0.25rem;\n  font-weight: 600;\n  font-size: 90%;\n}\n@media (max-width: 767.98px) {\n  .gallery-menu .gallery-menu-header {\n    display: none;\n  }\n}\n.gallery-menu .gallery-menu-item .gallery-menu-link {\n  padding: 0.35rem 1.25rem;\n  display: block;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  text-decoration: none;\n}\n@media (max-width: 767.98px) {\n  .gallery-menu .gallery-menu-item .gallery-menu-link {\n    white-space: nowrap;\n    padding: 0.9375rem 1.25rem 0.625rem;\n  }\n}\n.gallery-menu .gallery-menu-item .gallery-menu-link .fa {\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n}\n@media (max-width: 767.98px) {\n  .gallery-menu .gallery-menu-item .gallery-menu-link .fa {\n    display: block;\n    margin: 0 0 0.1875rem !important;\n    width: auto !important;\n    font-size: 1.125rem;\n  }\n}\n.gallery-menu .gallery-menu-item .gallery-menu-link:hover {\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n}\n.gallery-menu .gallery-menu-item .gallery-menu-link.active {\n  color: var(--bs-theme);\n  font-weight: 600;\n}\n.gallery-menu .gallery-menu-item .gallery-menu-link.active .fa {\n  color: inherit;\n}\n\n.gallery-content-container {\n  width: 100%;\n}\n@media (min-width: 768px) {\n  .gallery-content-container {\n    min-height: calc(100vh - 3.25rem);\n  }\n}\n\n.gallery {\n  padding: 1rem;\n}\n.gallery + .gallery {\n  border-top: 1px solid var(--bs-border-color);\n}\n.gallery .gallery-title {\n  font-size: 1.09375rem;\n  color: var(--bs-inverse);\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n.gallery .gallery-title a {\n  color: var(--bs-inverse);\n  text-decoration: none;\n}\n.gallery .gallery-title a i {\n  font-size: 0.875rem;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  margin-left: 0.3125rem;\n}\n.gallery .gallery-title small, .gallery .gallery-title .small {\n  display: block;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  font-size: 0.7875rem;\n}\n.gallery .gallery-image-list {\n  list-style-type: none;\n  margin: -0.15rem;\n  padding: 0;\n}\n.gallery .gallery-image-list:before, .gallery .gallery-image-list:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.gallery .gallery-image-list > li {\n  position: relative;\n  padding-top: 12.5%;\n  width: 16.6667%;\n  float: left;\n}\n@media (max-width: 991.98px) {\n  .gallery .gallery-image-list > li {\n    width: 25%;\n    padding-top: 18.75%;\n  }\n}\n@media (max-width: 767.98px) {\n  .gallery .gallery-image-list > li {\n    width: 33.33%;\n    padding-top: 33.33%;\n  }\n}\n@media (max-width: 575.98px) {\n  .gallery .gallery-image-list > li {\n    width: 50%;\n    padding-top: 50%;\n  }\n}\n.gallery .gallery-image-list > li:hover {\n  z-index: 10;\n}\n.gallery .gallery-image-list > li a {\n  position: absolute;\n  left: 0.15rem;\n  right: 0.15rem;\n  bottom: 0.15rem;\n  top: 0.15rem;\n  overflow: hidden;\n  background: rgba(var(--bs-inverse-rgb), 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease-in-out;\n}\n@media (min-width: 992px) {\n  .gallery .gallery-image-list > li a:hover {\n    left: -15%;\n    right: -15%;\n    top: -15%;\n    bottom: -15%;\n  }\n}\n.gallery .gallery-image-list > li img, .gallery .gallery-image-list > li .img {\n  max-width: 100%;\n}\n.gallery .gallery-image-list > li .img-portrait {\n  height: 100%;\n  width: auto;\n  max-height: 100%;\n  max-width: inherit;\n}\n@media (max-width: 767.98px) {\n  .gallery .gallery-image-list > li .img-portrait-xs {\n    height: 100%;\n    width: auto;\n    max-height: 100%;\n    max-width: inherit;\n  }\n}\n\n.app-content.login-page {\n  min-height: initial;\n  padding: 0;\n  flex: 1;\n  overflow: auto;\n}\n\n.login-page {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.login-confirm-text p {\n  font-size: 18px;\n}\n@media screen and (max-width: 991px) {\n  .login-confirm-text p {\n    font-size: 15px;\n  }\n}\n\n.login-page .app-content {\n  flex: 1;\n  min-height: auto;\n  padding: 50px 0;\n  overflow: auto;\n  margin-bottom: 0 !important;\n}\n\n.login-page .app-footer {\n  margin: 0;\n}\n\n.login {\n  display: flex;\n  align-items: center;\n  position: relative;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  height: 100%;\n}\n.login .login-bg {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 130vw;\n  height: 130vw;\n  pointer-events: none;\n  opacity: 0.1;\n}\n.login .login-bg::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--bs-theme);\n}\n.login .login-bg video,\n.login .login-bg iframe {\n  width: 100%;\n  height: 100%;\n  mix-blend-mode: color-burn;\n}\n.login .app-header {\n  position: static;\n  height: auto;\n  width: auto;\n  background: no-repeat;\n  margin: 0 auto;\n}\n.login .app-header .brand {\n  padding: 0;\n}\n.login .login-content {\n  width: 100%;\n  max-width: 25rem;\n  margin: 0 auto;\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n@media (max-width: 1199.98px) {\n  .login > video {\n    width: 200vw;\n  }\n}\n@media (max-width: 767.98px) {\n  .login > video {\n    width: 400vw;\n  }\n}\n@media (max-width: 767.98px) {\n  .login {\n    padding: 1rem;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .login-page .app-content {\n    padding: 15px 0;\n  }\n  .login-confirm-text p {\n    font-size: 12px;\n  }\n}\n.mailbox {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.mailbox .mailbox-toolbar {\n  padding: 0.75rem;\n  display: flex;\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-toolbar {\n    overflow: scroll;\n    white-space: nowrap;\n    padding: 0.5rem;\n    flex-wrap: nowrap;\n  }\n}\n.mailbox .mailbox-toolbar .mailbox-toolbar-text {\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  padding: 0.5rem;\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-toolbar .mailbox-toolbar-text {\n    padding: 0;\n  }\n}\n.mailbox .mailbox-toolbar .mailbox-toolbar-link {\n  padding: 0.5rem 1rem;\n}\n.mailbox .mailbox-toolbar .mailbox-toolbar-item {\n  padding: 0.5rem;\n}\n.mailbox .mailbox-toolbar .mailbox-toolbar-link {\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n  text-decoration: none;\n  border-radius: 4px;\n}\n.mailbox .mailbox-toolbar .mailbox-toolbar-link:hover {\n  background: rgba(var(--bs-inverse-rgb), 0.25);\n}\n.mailbox .mailbox-toolbar .mailbox-toolbar-link.active {\n  background: var(--bs-theme);\n  color: #ffffff;\n  font-weight: 600;\n}\n.mailbox .mailbox-body {\n  border-top: 1px solid var(--bs-border-color);\n  overflow: hidden;\n  display: flex;\n  flex: 1;\n}\n.mailbox .mailbox-body .mailbox-sidebar {\n  max-width: 22.5rem;\n  height: 100%;\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-body .mailbox-sidebar {\n    max-width: 100%;\n    height: auto;\n  }\n}\n.mailbox .mailbox-body .mailbox-sidebar + .mailbox-content {\n  border-left: 1px solid var(--bs-border-color);\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-body .mailbox-sidebar + .mailbox-content {\n    border-left: none;\n  }\n}\n.mailbox .mailbox-body .mailbox-content {\n  height: 100%;\n  flex: 1;\n}\n.mailbox .mailbox-empty-message {\n  min-height: 100%;\n  width: 100%;\n  padding: 2rem;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.mailbox .mailbox-empty-message .mailbox-empty-message-icon i {\n  font-size: 6.125rem;\n}\n.mailbox .mailbox-empty-message .mailbox-empty-message-img {\n  width: 100%;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n.mailbox .mailbox-empty-message .mailbox-empty-message-img img {\n  width: 100%;\n  height: 100%;\n  max-width: 30rem;\n  max-height: 30rem;\n  opacity: 0.5;\n}\n.mailbox .mailbox-empty-message .mailbox-empty-message-title {\n  font-size: 1.3125rem;\n  font-weight: 600;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n}\n.mailbox .mailbox-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n.mailbox .mailbox-list .mailbox-list-item {\n  padding: 1rem;\n  display: flex;\n}\n.mailbox .mailbox-list .mailbox-list-item + .mailbox-list-item {\n  border-top: 1px solid var(--bs-border-color);\n}\n.mailbox .mailbox-list .mailbox-list-item:hover {\n  background-color: rgba(var(--bs-inverse-rgb), 0.1);\n}\n.mailbox .mailbox-list .mailbox-list-item.unread .mailbox-message .mailbox-title {\n  font-weight: 600;\n  color: var(--bs-inverse);\n}\n.mailbox .mailbox-list .mailbox-list-item.active {\n  background: rgba(var(--bs-inverse-rgb), 0.1);\n}\n.mailbox .mailbox-list .mailbox-list-item.has-attachment .mailbox-checkbox:after {\n  content: \"\\f0c1\";\n  position: absolute;\n  top: 1.5625rem;\n  text-align: center;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  width: 1.125rem;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  left: 0;\n}\n.mailbox .mailbox-list .mailbox-checkbox {\n  position: relative;\n}\n.mailbox .mailbox-list .mailbox-checkbox + .mailbox-message {\n  padding-left: 0.5rem;\n}\n.mailbox .mailbox-list .mailbox-message {\n  flex: 1;\n}\n.mailbox .mailbox-list .mailbox-message .mailbox-list-item-link {\n  display: block;\n  color: var(--bs-inverse);\n  text-decoration: none;\n  position: relative;\n}\n.mailbox .mailbox-list .mailbox-message .mailbox-sender {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-list .mailbox-message .mailbox-sender {\n    display: block;\n  }\n}\n.mailbox .mailbox-list .mailbox-message .mailbox-sender .mailbox-sender-name {\n  font-weight: 600;\n  color: var(--bs-theme);\n  flex: 1;\n  margin-right: auto;\n}\n.mailbox .mailbox-list .mailbox-message .mailbox-sender .mailbox-time {\n  font-size: 0.75rem;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  font-weight: 400;\n  padding-left: 0.5rem;\n}\n.mailbox .mailbox-list .mailbox-message .mailbox-title {\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 18.125rem;\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-list .mailbox-message .mailbox-title {\n    max-width: initial;\n    white-space: initial;\n  }\n}\n.mailbox .mailbox-list .mailbox-message .mailbox-desc {\n  position: relative;\n  font-size: 0.8125rem;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  max-height: 2.625rem;\n  overflow: hidden;\n}\n.mailbox .mailbox-detail {\n  padding: 1.5rem;\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-detail {\n    padding: 1rem;\n  }\n}\n.mailbox .mailbox-detail .mailbox-detail-header {\n  border-bottom: 1px solid var(--bs-border-color);\n  padding: 0 0 1.5rem;\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-detail .mailbox-detail-header {\n    padding-bottom: 1rem;\n  }\n}\n.mailbox .mailbox-detail .mailbox-detail-content {\n  padding: 1.5rem 0;\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-detail .mailbox-detail-content {\n    padding: 1rem 0;\n  }\n}\n.mailbox .mailbox-detail .mailbox-detail-body {\n  font-size: 0.875rem;\n}\n.mailbox .mailbox-detail .mailbox-detail-attachment {\n  display: flex;\n  flex-wrap: wrap;\n}\n.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment {\n  background: rgba(var(--bs-inverse-rgb), 0.15);\n  width: 7.5rem;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n  border-radius: 4px;\n  margin-right: 0.5rem;\n}\n.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment a {\n  display: block;\n  text-decoration: none;\n}\n.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-file {\n  height: 3.75rem;\n  overflow: hidden;\n  text-align: center;\n  background: rgba(var(--bs-inverse-rgb), 0.1);\n}\n.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-file i {\n  display: block;\n  line-height: 3.75rem;\n  font-size: 2rem;\n  color: var(--bs-inverse);\n}\n.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-file img {\n  max-width: 100%;\n}\n.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-name {\n  color: var(--bs-inverse);\n  padding: 0.125rem 0.625rem;\n  font-size: 0.8125rem;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.mailbox .mailbox-form .mailbox-form-header {\n  padding: 1rem 1.5rem;\n}\n@media (max-width: 991.98px) {\n  .mailbox .mailbox-form .mailbox-form-header {\n    padding: 0.75rem 1rem;\n  }\n}\n.mailbox .mailbox-form .mailbox-form-header .form-control {\n  background: rgba(var(--bs-inverse-rgb), 0.1);\n}\n.mailbox .mailbox-form .note-editor {\n  border: none;\n  border-radius: 0;\n}\n.mailbox .mailbox-form .note-editor .note-toolbar {\n  border-top: 1px solid var(--bs-border-color);\n  border-bottom: 1px solid var(--bs-border-color);\n}\n.mailbox .mailbox-form .note-editor .note-editing-area {\n  background: rgba(var(--bs-inverse-rgb), 0.1);\n}\n\n.messenger {\n  height: 100%;\n  display: flex;\n}\n.messenger .messenger-sidebar {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n@media (min-width: 992px) {\n  .messenger .messenger-sidebar {\n    max-width: 22.5rem;\n    border-right: 1px solid var(--bs-border-color);\n  }\n}\n.messenger .messenger-sidebar .messenger-sidebar-header {\n  border-bottom: 1px solid var(--bs-border-color);\n  padding: 1rem;\n}\n.messenger .messenger-sidebar .messenger-sidebar-body {\n  flex: 1;\n  overflow: hidden;\n}\n.messenger .messenger-sidebar .messenger-item {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link {\n  display: flex;\n  padding: 0.85rem 1rem;\n  text-decoration: none;\n  color: var(--bs-inverse);\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link.active {\n  background-color: rgba(var(--bs-inverse-rgb), 0.15);\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link:hover, .messenger .messenger-sidebar .messenger-item .messenger-link:focus {\n  background-color: rgba(var(--bs-inverse-rgb), 0.1);\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-media {\n  width: 2.5rem;\n  height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-media img {\n  max-width: 100%;\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-media + .messenger-info {\n  padding-left: 0.85rem;\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-info {\n  flex: 1;\n  white-space: nowrap;\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-time-badge {\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-time {\n  font-size: 0.690625rem;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  margin-bottom: 0.25rem;\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-text, .messenger .messenger-sidebar .messenger-item .messenger-link .messenger-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 13.75rem;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  font-size: 0.8125rem;\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-name {\n  font-weight: 600;\n  color: var(--bs-inverse);\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-badge {\n  background: var(--bs-theme);\n  color: var(--bs-theme-color);\n  display: inline-flex;\n  border-radius: 1.875rem;\n  padding: 0 0.1875rem;\n  min-width: 1.125rem;\n  min-height: 1.125rem;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.56875rem;\n  font-weight: 600;\n  margin-left: auto;\n}\n.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-badge.empty {\n  display: none;\n}\n.messenger .messenger-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n@media (max-width: 991.98px) {\n  .messenger .messenger-content {\n    display: none;\n  }\n}\n.messenger .messenger-content .messenger-content-header {\n  display: flex;\n  border-bottom: 1px solid var(--bs-border-color);\n  padding: 0.75rem 1rem;\n  align-items: center;\n}\n.messenger .messenger-content .messenger-content-header .messenger-content-header-mobile-toggler {\n  display: none;\n}\n@media (max-width: 991.98px) {\n  .messenger .messenger-content .messenger-content-header .messenger-content-header-mobile-toggler {\n    display: block;\n  }\n}\n.messenger .messenger-content .messenger-content-header .messenger-content-header-mobile-toggler a {\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  font-size: 1.125rem;\n}\n.messenger .messenger-content .messenger-content-header .messenger-content-header-media .media {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.messenger .messenger-content .messenger-content-header .messenger-content-header-media + .messenger-content-header-info {\n  margin-left: 1rem;\n}\n.messenger .messenger-content .messenger-content-header .messenger-content-header-info {\n  font-size: 0.875rem;\n  color: var(--bs-inverse);\n  font-weight: 600;\n  font-size: 0.9375rem;\n  flex: 1;\n}\n.messenger .messenger-content .messenger-content-header .messenger-content-header-info small, .messenger .messenger-content .messenger-content-header .messenger-content-header-info .small {\n  display: block;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  font-weight: normal;\n  font-size: 0.6875rem;\n}\n.messenger .messenger-content .messenger-content-header .messenger-content-header-btn {\n  display: flex;\n}\n.messenger .messenger-content .messenger-content-header .messenger-content-header-btn .btn {\n  font-size: 1rem;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n}\n.messenger .messenger-content .messenger-content-header .messenger-content-header-btn .btn:hover, .messenger .messenger-content .messenger-content-header .messenger-content-header-btn .btn:focus {\n  color: var(--bs-inverse);\n}\n.messenger .messenger-content .messenger-content-body {\n  flex: 1;\n  overflow: hidden;\n}\n.messenger .messenger-content .messenger-content-body .widget-chat {\n  padding: 1rem;\n}\n.messenger .messenger-content .messenger-content-footer {\n  border-top: 1px solid var(--bs-border-color);\n  padding: 1rem;\n}\n@media (max-width: 991.98px) {\n  .messenger.messenger-content-toggled .messenger-sidebar {\n    display: none;\n  }\n  .messenger.messenger-content-toggled .messenger-content {\n    display: flex;\n  }\n}\n\n.pos {\n  background: var(--app-pos-bg);\n  height: 100%;\n}\n.pos .pos-container {\n  height: 100%;\n  padding: 0;\n}\n@media (min-width: 992px) {\n  .pos .pos-container {\n    display: flex;\n  }\n  .pos .pos-container > div + div {\n    border-left: 1px solid var(--bs-border-color);\n  }\n}\n.pos .pos-menu {\n  display: flex;\n}\n@media (min-width: 992px) {\n  .pos .pos-menu {\n    width: 140px;\n    flex-direction: column;\n  }\n}\n@media (max-width: 991.98px) {\n  .pos .pos-menu {\n    overflow: scroll;\n    align-items: center;\n    border-bottom: 1px solid var(--bs-border-color);\n  }\n}\n.pos .pos-menu .logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n@media (max-width: 991.98px) {\n  .pos .pos-menu .logo {\n    width: 140px;\n    height: 5.9375rem;\n    flex: 0 0 140px;\n  }\n}\n.pos .pos-menu .logo a {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n}\n.pos .pos-menu .logo .logo-img {\n  text-align: center;\n  height: 2.875rem;\n}\n.pos .pos-menu .logo .logo-text {\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: 1px;\n  margin-top: 0.25rem;\n}\n.pos .pos-menu .logo img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.pos .pos-menu .nav-container {\n  flex: 1;\n}\n@media (min-width: 992px) {\n  .pos .pos-menu .nav-container {\n    overflow: hidden;\n    padding: 0;\n  }\n}\n.pos .pos-menu .nav.nav-tabs {\n  margin: 0;\n  padding: 0;\n  display: block;\n  border: 0;\n}\n@media (max-width: 991.98px) {\n  .pos .pos-menu .nav.nav-tabs {\n    display: flex;\n    flex-wrap: nowrap;\n  }\n}\n@media (max-width: 991.98px) {\n  .pos .pos-menu .nav.nav-tabs .nav-item {\n    min-width: 5.625rem;\n  }\n}\n.pos .pos-menu .nav.nav-tabs .nav-item .nav-link {\n  position: relative;\n  padding: 1rem;\n  white-space: nowrap;\n  text-align: center;\n  color: rgba(var(--bs-inverse), 0.25);\n  border: none;\n  font-size: 0.65625rem;\n  text-transform: uppercase;\n  font-weight: 600;\n  border-radius: 0;\n}\n.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card {\n  margin: -0.75rem -0.25rem;\n}\n.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card .card-body {\n  padding: 0.5rem 0.7rem;\n  margin: 0.5rem;\n  flex: 1;\n}\n.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card:before, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card:after, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card .card-arrow {\n  visibility: hidden;\n}\n.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .fa {\n  display: block;\n  margin: 0.225rem auto 0.35rem auto !important;\n  font-size: 1.25rem;\n}\n.pos .pos-menu .nav.nav-tabs .nav-item .nav-link:hover {\n  color: rgba(var(--bs-inverse), 0.5);\n}\n.pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active {\n  color: var(--bs-inverse);\n}\n.pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active .card:before, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active .card:after, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active .card .card-arrow {\n  visibility: visible;\n}\n.pos .pos-content {\n  flex: 1;\n}\n@media (min-width: 992px) {\n  .pos .pos-content {\n    overflow: scroll;\n  }\n}\n@media (max-width: 991.98px) {\n  .pos .pos-content {\n    height: calc(100% - 96px);\n  }\n}\n.pos .pos-content .pos-content-container {\n  padding: 0 2rem;\n}\n.pos .pos-sidebar {\n  width: 360px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 360px;\n}\n@media (max-width: 991.98px) {\n  .pos .pos-sidebar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: auto;\n    z-index: 1021;\n    background: var(--bs-body-bg);\n    background: var(--bs-body-bg-gradient);\n    display: none;\n  }\n}\n.pos .pos-sidebar .pos-sidebar-header {\n  padding: 1rem 1.5rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.pos .pos-sidebar .pos-sidebar-header .back-btn {\n  border: none;\n  display: none;\n  margin-right: 1rem;\n}\n@media (max-width: 991.98px) {\n  .pos .pos-sidebar .pos-sidebar-header .back-btn {\n    display: block;\n  }\n}\n.pos .pos-sidebar .pos-sidebar-header .back-btn .btn {\n  color: var(--bs-inverse);\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  font-size: 1.09375rem;\n}\n.pos .pos-sidebar .pos-sidebar-header .icon img {\n  height: 1.875rem;\n}\n.pos .pos-sidebar .pos-sidebar-header .icon + .title {\n  padding-left: 0.625rem;\n}\n.pos .pos-sidebar .pos-sidebar-header .title {\n  font-weight: 600;\n  flex: 1;\n}\n.pos .pos-sidebar .pos-sidebar-header .order {\n  display: block;\n}\n.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs {\n  padding: 0 1.5rem;\n}\n.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs .nav-item .nav-link {\n  color: rgba(var(--bs-inverse), 0.5);\n}\n.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs .nav-item .nav-link.active {\n  color: var(--bs-inverse);\n}\n.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs .nav-item + .nav-item {\n  margin-left: 0.5rem;\n}\n.pos .pos-sidebar .pos-sidebar-body {\n  padding: 0;\n  margin: 0;\n  overflow: scroll;\n  flex: 1;\n}\n.pos .pos-sidebar .pos-sidebar-footer {\n  border-top: 1px solid var(--bs-border-color);\n  padding: 1rem 1.5rem;\n}\n.pos .pos-sidebar .pos-order {\n  padding: 1.5rem;\n  position: relative;\n  display: flex;\n}\n.pos .pos-sidebar .pos-order .pos-order-product {\n  display: flex;\n  flex: 1;\n}\n.pos .pos-sidebar .pos-order .pos-order-product .img {\n  width: 4.5rem;\n  height: 4.5rem;\n  background-position: center;\n  background-size: cover;\n}\n.pos .pos-sidebar .pos-order .pos-order-product > * + * {\n  margin-left: 1rem;\n}\n.pos .pos-sidebar .pos-order > * + * {\n  margin-left: 1rem;\n}\n.pos .pos-sidebar .pos-order .pos-order-confirmation {\n  position: absolute;\n  top: 0;\n  left: 0.0625rem;\n  right: 0.0625rem;\n  bottom: 0;\n  z-index: 10;\n  background: rgba(235, 235, 235, 0.88);\n  padding: 1rem;\n  margin: 0;\n}\n.pos .pos-sidebar .pos-order .pos-order-confirmation > * {\n  position: relative;\n}\n.pos .pos-sidebar .pos-order .pos-order-confirmation .btn {\n  min-width: 3.75rem;\n}\n.pos .pos-sidebar .pos-order + .pos-order {\n  border-top: 1px solid var(--bs-border-color);\n}\n.pos .pos-header {\n  padding: 0.66rem 1.75rem;\n  height: 3.25rem;\n  display: flex;\n  align-items: center;\n}\n.pos .pos-header .logo, .pos .pos-header .time, .pos .pos-header .nav {\n  width: 33.33%;\n}\n@media (max-width: 767.98px) {\n  .pos .pos-header .logo, .pos .pos-header .time, .pos .pos-header .nav {\n    width: 50%;\n  }\n}\n.pos .pos-header .logo {\n  display: flex;\n}\n.pos .pos-header .logo > div, .pos .pos-header .logo > a {\n  text-align: center;\n  color: var(--bs-inverse);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n}\n.pos .pos-header .logo > div .logo-img img, .pos .pos-header .logo > a .logo-img img {\n  height: 2rem;\n}\n.pos .pos-header .logo > div .logo-text, .pos .pos-header .logo > a .logo-text {\n  font-weight: 600;\n  font-size: 1rem;\n  letter-spacing: 0.0625rem;\n  margin-left: 1rem;\n}\n.pos .pos-header .time {\n  font-weight: 600;\n  font-size: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 767.98px) {\n  .pos .pos-header .time {\n    display: none;\n  }\n}\n.pos .pos-header .nav {\n  align-items: center;\n  justify-content: flex-end;\n}\n.pos .pos-header .nav .nav-item .nav-link {\n  padding: 0.333rem 1rem;\n  color: var(--bs-inverse);\n}\n@media (max-width: 767.98px) {\n  .pos .pos-header .nav .nav-item .nav-link {\n    padding: 0.333rem 0.66rem;\n  }\n}\n.pos .pos-header .nav .nav-item .nav-link .nav-icon {\n  height: 1.25rem;\n  font-size: 1.25rem;\n}\n.pos .pos-header .nav .nav-item .nav-link:hover {\n  color: rgba(var(--bs-inverse), 0.5);\n}\n.pos .pos-product {\n  text-decoration: none;\n  color: var(--bs-inverse);\n  position: relative;\n  transition: all 0.2s linear;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.pos .pos-product .img {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  min-height: 11.25rem;\n  transition: all 0.2s linear;\n}\n.pos .pos-product .info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: rgba(var(--bs-inverse), 0.1);\n  padding: 1rem;\n}\n.pos .pos-product .info .title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--app-component-color);\n  margin: 0 0 0.125rem;\n}\n.pos .pos-product .info .desc {\n  color: rgba(var(--bs-inverse), 0.5);\n  margin: 0 0 1rem;\n  line-height: 1.4;\n  flex: 1;\n}\n.pos .pos-product .info .price {\n  margin: 0;\n  font-weight: 600;\n  color: var(--app-component-color);\n  font-size: 1rem;\n}\n.pos .pos-product.not-available {\n  cursor: not-allowed;\n}\n.pos .pos-product.not-available .not-available-text {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  min-height: 11.25rem;\n  background: rgba(235, 235, 235, 0.88);\n  color: var(--bs-inverse);\n  font-size: 1.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.pos .pos-table-booking {\n  display: block;\n  margin-bottom: 1.25rem;\n  text-decoration: none;\n  color: var(--bs-inverse);\n}\n.pos .pos-table-booking:hover .pos-table-booking-container {\n  background: rgba(var(--bs-inverse), 0.2);\n}\n.pos .pos-table-booking .pos-table-booking-container {\n  padding: 0;\n  background: rgba(var(--bs-inverse), 0.1);\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-header {\n  padding: 1rem;\n  border-bottom: 1px solid var(--bs-border-color);\n  color: rgba(var(--bs-inverse), 0.5);\n  font-weight: 600;\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-header .no {\n  font-size: 2.5rem;\n  color: var(--bs-inverse);\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking {\n  font-size: 0.8125rem;\n  padding: 0.333rem 1rem;\n  display: flex;\n  align-items: center;\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .time {\n  width: 4.6875rem;\n  font-weight: 600;\n  font-size: 0.74375rem;\n  color: rgba(var(--bs-inverse), 0.5);\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .info {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  flex: 1;\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .status {\n  font-size: 0.375rem;\n  color: #617a86;\n  display: flex;\n  align-items: center;\n  padding-left: 1rem;\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .status.upcoming {\n  color: #ff9f0c;\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .status.in-progress {\n  color: #249d79;\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking.highlight {\n  color: var(--bs-theme);\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking.highlight .time {\n  color: rgba(var(--bs-theme-rgb), 0.75);\n}\n.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking + .booking {\n  border-top: 1px solid var(--bs-border-color);\n}\n.pos .pos-task {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n@media (min-width: 768px) {\n  .pos .pos-task {\n    display: flex;\n  }\n}\n.pos .pos-task .pos-task-info {\n  width: 30%;\n  padding: 1.5rem;\n  text-align: right;\n}\n@media (max-width: 767.98px) {\n  .pos .pos-task .pos-task-info {\n    width: auto;\n    position: relative;\n    text-align: left;\n  }\n}\n.pos .pos-task .pos-task-body {\n  padding: 1.5rem;\n  flex: 1;\n  border-left: 1px solid var(--bs-border-color);\n}\n@media (max-width: 767.98px) {\n  .pos .pos-task .pos-task-body {\n    border-left: none;\n    padding-top: 0;\n  }\n}\n.pos .pos-task .pos-task-body .pos-task-completed {\n  font-size: 1rem;\n  line-height: 2.25rem;\n}\n@media (max-width: 767.98px) {\n  .pos .pos-task .pos-task-body .pos-task-completed {\n    border-top: 1px solid var(--bs-border-color);\n    margin-top: -0.625rem;\n    padding-top: 0.625rem;\n  }\n}\n.pos .pos-task .pos-task-body .pos-task-product {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-img {\n  padding-top: 75%;\n  position: relative;\n  margin-bottom: 1rem;\n}\n.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-img .cover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  border-radius: 8px;\n}\n.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-img .caption {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(53, 67, 74, 0.75);\n  color: var(--bs-white);\n  font-size: 1.5rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-info {\n  display: flex;\n  flex: 1;\n  margin-bottom: 1rem;\n}\n.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-action .btn {\n  display: block;\n}\n.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-action .btn + .btn {\n  margin-top: 0.75rem;\n}\n.pos .pos-task .pos-task-body .pos-task-product.completed .pos-task-product-info {\n  opacity: 0.33;\n}\n.pos .pos-checkout-table {\n  padding: 0.0625rem;\n  margin: 0;\n  height: 100%;\n}\n.pos .pos-checkout-table .pos-checkout-table-container {\n  color: var(--bs-inverse);\n  display: block;\n  padding: 0;\n  height: 100%;\n  text-decoration: none;\n  position: relative;\n  transition: all 0.1s linear;\n  margin: 0.25rem;\n}\n.pos .pos-checkout-table .pos-checkout-table-container:before {\n  transition: all 0.1s linear;\n}\n.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-header {\n  padding: 1rem;\n  text-align: center;\n}\n.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-header .status {\n  position: absolute;\n  right: 0.5rem;\n  top: 0.5rem;\n  font-size: 0.5rem;\n}\n.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-info > .row {\n  border-top: 1px solid var(--bs-border-color);\n  margin: 0;\n}\n.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-info > .row > div {\n  padding: 0.25rem 0.5rem;\n  text-align: center;\n}\n.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-info > .row > div + div {\n  border-left: 1px solid var(--bs-border-color);\n}\n.pos .pos-checkout-table.in-use:hover:not(.disabled) {\n  position: relative;\n  z-index: 10;\n}\n.pos .pos-checkout-table.in-use:hover:not(.disabled) .table-container {\n  position: relative;\n}\n.pos .pos-checkout-table.in-use:hover:not(.disabled) .table-container:before {\n  content: \"\";\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(45, 51, 58, 0.75);\n}\n.pos .pos-checkout-table.in-use:hover:not(.disabled) .table-container:after {\n  content: \"\\f00c\";\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: var(--app-component-color);\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n.pos .pos-checkout-table.selected:not(.disabled) .pos-checkout-table-container .table-info-row, .pos .pos-checkout-table.selected:not(.disabled):hover .pos-checkout-table-container .table-info-row {\n  color: var(--app-component-color);\n}\n.pos .pos-checkout-table.selected:not(.disabled) .pos-checkout-table-container:before, .pos .pos-checkout-table.selected:not(.disabled):hover .pos-checkout-table-container:before {\n  content: \"\";\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(var(--bs-theme-rgb), 0.5);\n}\n.pos .pos-checkout-table.selected:not(.disabled) .pos-checkout-table-container:after, .pos .pos-checkout-table.selected:not(.disabled):hover .pos-checkout-table-container:after {\n  content: \"\\f00c\";\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: var(--bs-inverse);\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n  font-weight: 900;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n}\n.pos .pos-checkout-table.disabled .pos-checkout-table-container {\n  cursor: not-allowed;\n  background: var(--app-component-bg);\n  color: var(--app-component-color);\n}\n.pos .pos-checkout-table.disabled .pos-checkout-table-container .status {\n  color: #e00000;\n}\n.pos .pos-checkout-table.available .pos-checkout-table-container .status {\n  color: #249d79;\n}\n.pos .pos-checkout-table.available .pos-checkout-table-container .pos-checkout-table-info {\n  color: transparent;\n}\n.pos .pos-checkout-table.available .pos-checkout-table-container .pos-checkout-table-info i {\n  color: transparent !important;\n}\n.pos .pos-checkout-table.in-use .pos-checkout-table-container {\n  background: rgba(var(--bs-inverse), 0.15);\n  position: relative;\n}\n.pos .pos-checkout-table.in-use .pos-checkout-table-container .status {\n  color: #ff9f0c;\n}\n.pos.pos-vertical > .pos-container {\n  flex-direction: column;\n}\n.pos.pos-vertical > .pos-container .pos-header + .pos-content {\n  height: calc(100% - 52px);\n}\n.pos.pos-vertical > .pos-container > div + div {\n  border: 0;\n  border-top: 1px solid var(--bs-border-color);\n}\n@media (max-width: 991.98px) {\n  .pos.pos-mobile-sidebar-toggled {\n    z-index: 20;\n  }\n  .pos.pos-mobile-sidebar-toggled .pos-content, .pos.pos-mobile-sidebar-toggled .pos-menu {\n    opacity: 0.25;\n  }\n  .pos.pos-mobile-sidebar-toggled .pos-sidebar {\n    display: flex;\n  }\n  .pos.pos-mobile-sidebar-toggled.pos-vertical > .pos-container > .pos-content {\n    opacity: 1;\n  }\n}\n\n.modal.modal-pos .close {\n  position: absolute;\n  top: 1.5625rem;\n  z-index: 10;\n  right: 1.5625rem;\n}\n@media (min-width: 992px) {\n  .modal.modal-pos .modal-pos-product {\n    display: flex;\n  }\n  .modal.modal-pos .modal-pos-product .modal-pos-product-img, .modal.modal-pos .modal-pos-product .modal-pos-product-info {\n    width: 50%;\n    max-width: 50%;\n    flex: 0 0 50%;\n  }\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-img {\n  padding: 1rem;\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-img .img {\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: 15.625rem;\n}\n@media (min-width: 992px) {\n  .modal.modal-pos .modal-pos-product .modal-pos-product-img .img {\n    min-height: 18.75rem;\n  }\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-info {\n  padding: 1.5rem;\n  border-left: 1px solid var(--bs-border-color);\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list {\n  margin: -0.333rem;\n  padding: 0.333rem 0;\n  display: flex;\n  flex-wrap: wrap;\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option {\n  width: 33.33%;\n  max-width: 33.33%;\n  padding: 0.333rem;\n  flex: 0 0 33.33%;\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-input {\n  display: none;\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-input:checked + .option-label {\n  color: var(--bs-theme);\n  border: 1px solid var(--bs-theme);\n  background: rgba(var(--bs-theme-rgb), 0.1);\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-label {\n  border: 1px solid rgba(var(--bs-inverse-rgb), 0.25);\n  padding: 0.625rem;\n  height: 100%;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-label .option-text {\n  display: block;\n  line-height: 1.2;\n  opacity: 0.75;\n  font-size: 0.8125rem;\n  text-align: center;\n}\n.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-label .option-price {\n  font-weight: 600;\n  margin-top: 0.25rem;\n  line-height: 1.2;\n}\n\n.pos-mobile-sidebar-toggler {\n  position: fixed;\n  bottom: 3rem;\n  right: 1rem;\n  z-index: 1020;\n  background: var(--bs-white);\n  padding: 0.5rem;\n  width: 3.75rem;\n  height: 3.75rem;\n  text-decoration: none;\n  color: var(--bs-black);\n  display: none;\n  border-radius: 50px;\n  box-shadow: 0 1rem 3rem rgba(var(--bs-inverse-rgb), 0.175);\n  align-items: center;\n  z-index: 10;\n}\n.pos-mobile-sidebar-toggler:before {\n  content: \"\";\n  position: absolute;\n  top: -0.25rem;\n  left: -0.25rem;\n  right: -0.25rem;\n  bottom: -0.25rem;\n  border: 2px solid var(--bs-white);\n  border-radius: 50px;\n}\n@media (max-width: 991.98px) {\n  .pos-mobile-sidebar-toggler {\n    display: flex;\n  }\n}\n.pos-mobile-sidebar-toggler:hover {\n  color: #526872;\n}\n.pos-mobile-sidebar-toggler i {\n  font-size: 2rem;\n  display: block;\n  margin: 0 auto;\n}\n.pos-mobile-sidebar-toggler .badge {\n  position: absolute;\n  right: -0.3rem;\n  top: -0.3rem;\n  background-color: var(--bs-theme);\n  color: var(--bs-theme-color);\n  width: 1.5rem;\n  height: 1.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n}\n\n[data-bs-theme=dark] .pos .pos-product.not-available .not-available-text,\n[data-bs-theme=dark] .pos .pos-sidebar .pos-order .pos-order-confirmation {\n  background: rgba(59, 70, 82, 0.88);\n}\n\n.profile .profile-img {\n  height: 12.5rem;\n  overflow: hidden;\n  margin-bottom: 1rem;\n  z-index: 10;\n}\n.profile .profile-img img {\n  max-width: 100%;\n  width: 100%;\n}\n.profile .profile-tab {\n  position: relative;\n  padding: 0 1.5rem;\n  flex: 1;\n}\n@media (max-width: 991.98px) {\n  .profile .profile-tab {\n    overflow: scroll;\n    padding: 0 1rem;\n    display: flex;\n    flex-wrap: nowrap;\n  }\n}\n.profile .profile-tab .nav-item .nav-link {\n  text-align: center;\n}\n.profile .profile-tab .nav-item .nav-link .nav-value {\n  font-size: 1.3125rem;\n  font-weight: 600;\n  margin-bottom: -0.35rem;\n}\n@media (max-width: 767.98px) {\n  .profile .profile-tab .nav-item .nav-link .nav-value {\n    font-size: 1.00625rem;\n  }\n}\n.profile .profile-tab .nav-item + .nav-item {\n  margin-left: 1.5rem;\n}\n.profile .profile-container {\n  display: flex;\n}\n@media (max-width: 991.98px) {\n  .profile .profile-container {\n    display: block;\n  }\n}\n.profile .profile-container .profile-sidebar {\n  width: 15.625rem;\n  padding: 1.5rem;\n  border-right: 1px solid var(--bs-border-color);\n}\n@media (max-width: 991.98px) {\n  .profile .profile-container .profile-sidebar {\n    display: none;\n  }\n}\n.profile .profile-container .profile-content {\n  flex: 1;\n}\n.profile .profile-container .profile-content .profile-content-container {\n  padding: 1.5rem;\n}\n@media (max-width: 991.98px) {\n  .profile .profile-container .profile-content .profile-content-container {\n    padding: 1rem;\n  }\n}\n.profile .profile-img-list {\n  list-style-type: none;\n  margin: -0.25rem;\n  padding: 0;\n}\n.profile .profile-img-list:before, .profile .profile-img-list:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.profile .profile-img-list .profile-img-list-item {\n  width: 25%;\n  padding: 0.25rem;\n  float: left;\n}\n.profile .profile-img-list .profile-img-list-item.main {\n  width: 50%;\n}\n.profile .profile-img-list .profile-img-list-item .profile-img-list-link {\n  display: block;\n  padding-top: 75%;\n  overflow: hidden;\n  position: relative;\n}\n.profile .profile-img-list .profile-img-list-item .profile-img-list-link img, .profile .profile-img-list .profile-img-list-item .profile-img-list-link .profile-img-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-width: 100%;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.profile .profile-img-list .profile-img-list-item .profile-img-list-link img:before, .profile .profile-img-list .profile-img-list-item .profile-img-list-link .profile-img-content:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 1px solid rgba(var(--bs-inverse-rgb), 0.15);\n}\n.profile .profile-img-list .profile-img-list-item.with-number .profile-img-number {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  color: #ffffff;\n  font-size: 1.53125rem;\n  font-weight: 600;\n  line-height: 1.625rem;\n  margin-top: -0.765625rem;\n  text-align: center;\n}\n\n.register {\n  min-height: 100vh;\n  padding: 3rem 1rem;\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 767.98px) {\n  .register {\n    padding: 1rem;\n  }\n}\n.register .register-content {\n  flex: 1;\n  max-width: 22.5rem;\n  margin: 0 auto;\n  position: relative;\n}\n\n.search-result .search-input {\n  position: relative;\n  max-width: 45rem;\n  margin-bottom: 0.9375rem;\n}\n.search-result .search-close {\n  position: absolute;\n  top: 50%;\n  margin-top: -0.75rem;\n  width: 1.625rem;\n  height: 1.625rem;\n  text-align: center;\n  font-size: 1.25rem;\n  padding: 0 0 0.125rem;\n  color: var(--bs-inverse);\n  background: rgba(var(--bs-inverse-rgb), 0.25);\n  text-decoration: none;\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 0.75rem;\n}\n.search-result .search-close:hover, .search-result .search-close:focus {\n  text-decoration: none;\n  background: rgba(var(--bs-inverse-rgb), 0.5);\n  color: var(--bs-inverse);\n}\n.search-result .search-tab {\n  list-style-type: none;\n  margin: 0 -2rem;\n  padding: 0 2rem;\n  border-bottom: 1px solid var(--bs-border-color);\n  white-space: nowrap;\n  display: flex;\n}\n@media (max-width: 767.98px) {\n  .search-result .search-tab {\n    margin: 0 -0.9375rem;\n    padding: 0 0.9375rem;\n    overflow: scroll;\n  }\n}\n.search-result .search-tab .search-tab-item .search-tab-link {\n  display: block;\n  padding: 0.625rem;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  text-decoration: none;\n  border-bottom: 3px solid transparent;\n  font-weight: 500;\n  margin-bottom: -1px;\n}\n.search-result .search-tab .search-tab-item .search-tab-link:hover, .search-result .search-tab .search-tab-item .search-tab-link:focus {\n  border-bottom-color: #90a2aa;\n}\n.search-result .search-tab .search-tab-item .search-tab-link.active {\n  font-weight: 600;\n  color: var(--bs-theme);\n  border-bottom-color: var(--bs-theme);\n}\n.search-result .search-tab .search-tab-item + .search-tab-item {\n  margin-left: 1rem;\n}\n.search-result .search-result-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n.search-result .search-result-list .search-result-item {\n  padding: 2rem 0;\n  display: flex;\n}\n.search-result .search-result-list .search-result-item:before, .search-result .search-result-list .search-result-item:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.search-result .search-result-list .search-result-item:last-child {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n.search-result .search-result-list .search-result-item + .search-result-item {\n  border-top: 1px solid var(--bs-border-color);\n}\n.search-result .search-result-list .search-result-item .search-result-media {\n  width: 10rem;\n  height: 10rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 767.98px) {\n  .search-result .search-result-list .search-result-item .search-result-media {\n    width: 5rem;\n    height: 3.75rem;\n  }\n}\n.search-result .search-result-list .search-result-item .search-result-media img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.search-result .search-result-list .search-result-item .search-result-media + .search-result-content {\n  padding-left: 1.875rem;\n}\n.search-result .search-result-list .search-result-item .search-result-content {\n  flex: 1;\n}\n.search-result .search-result-list .search-result-item .search-result-content h3, .search-result .search-result-list .search-result-item .search-result-content .h3 {\n  margin: 0 0 0.3125rem;\n  font-size: 1.25rem;\n}\n.search-result .search-result-list .search-result-item .search-result-content h3 a, .search-result .search-result-list .search-result-item .search-result-content .h3 a {\n  color: var(--bs-inverse);\n  text-decoration: none;\n}\n.search-result .search-result-list .search-result-item .search-result-content h3 a:hover, .search-result .search-result-list .search-result-item .search-result-content .h3 a:hover {\n  text-decoration: underline;\n}\n\n.widget-chat {\n  margin: 0;\n  padding: 0;\n}\n.widget-chat .widget-chat-item {\n  display: flex;\n  align-items: flex-end;\n}\n.widget-chat .widget-chat-item + .widget-chat-item {\n  margin-top: 1rem;\n}\n.widget-chat .widget-chat-item > div + div {\n  padding-left: 0.75rem;\n}\n.widget-chat .widget-chat-date {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: rgba(var(--bs-inverse-rgb), 0.5);\n  padding: 0.75rem;\n  text-align: center;\n}\n.widget-chat .widget-chat-content {\n  flex: 1;\n}\n.widget-chat .widget-chat-name, .widget-chat .widget-chat-status {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: rgba(var(--bs-inverse-rgb), 0.75);\n  margin: 0.25rem 0;\n  line-height: 1.5;\n}\n.widget-chat .widget-chat-media {\n  width: 1.75rem;\n}\n.widget-chat .widget-chat-media img {\n  max-width: 100%;\n  display: block;\n  border-radius: 28px;\n}\n.widget-chat .widget-chat-message {\n  background: #ffffff;\n  color: #000000;\n  padding: 0.5rem 1rem;\n  display: inline-block;\n  position: relative;\n  border-radius: 8px;\n}\n.widget-chat .widget-chat-message + .widget-chat-message {\n  margin-top: 0.3rem;\n}\n.widget-chat .widget-chat-message.last:before {\n  content: \"\";\n  border: 0.3125rem solid transparent;\n  border-bottom-color: #ffffff;\n  position: absolute;\n  bottom: 0.375rem;\n  left: -0.25rem;\n  border-right-color: #ffffff;\n}\n.widget-chat .reply .widget-chat-content {\n  text-align: right;\n}\n.widget-chat .reply .widget-chat-message {\n  background: var(--bs-theme);\n  color: var(--bs-theme-color);\n}\n.widget-chat .reply .widget-chat-message.last:before {\n  border-color: transparent;\n  border-bottom-color: var(--bs-theme);\n  border-left-color: var(--bs-theme);\n  left: auto;\n  right: -0.25rem;\n}\n\n.widget-img-list {\n  margin: -0.0625rem;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n}\n.widget-img-list .widget-img-list-item {\n  padding: 0.0625rem;\n  width: 20%;\n}\n.widget-img-list .widget-img-list-item a {\n  display: block;\n  text-decoration: none;\n  padding-top: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.widget-img-list .widget-img-list-item a img, .widget-img-list .widget-img-list-item a .img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-width: 100%;\n}\n.widget-img-list .widget-img-list-item a .img {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.widget-reminder .widget-reminder-item {\n  position: relative;\n  display: flex;\n}\n.widget-reminder .widget-reminder-header + .widget-reminder-item, .widget-reminder .widget-reminder-item + .widget-reminder-header, .widget-reminder .widget-reminder-item + .widget-reminder-item {\n  border-top: 1px solid var(--bs-border-color);\n}\n.widget-reminder .widget-reminder-time, .widget-reminder .widget-reminder-content {\n  padding: 1rem;\n}\n.widget-reminder .widget-reminder-content {\n  flex: 1;\n}\n.widget-reminder .widget-reminder-time {\n  width: 5rem;\n  font-size: 0.8125rem;\n  text-align: right;\n}\n.widget-reminder .widget-reminder-divider {\n  width: 0.1875rem;\n  background: var(--bs-border-color);\n}\n.widget-reminder + .card-header, .widget-reminder + .card-footer, .widget-reminder + .card-body {\n  border-top: 1px solid var(--bs-border-color);\n}\n\n.widget-user-list {\n  display: flex;\n  align-items: center;\n}\n.widget-user-list .widget-user-list-item .widget-user-list-link {\n  border: 2px solid var(--bs-body-bg);\n  overflow: hidden;\n  width: 2.5rem;\n  height: 2.5rem;\n  text-align: center;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 40px;\n}\n.widget-user-list .widget-user-list-item .widget-user-list-link img {\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n}\n.widget-user-list .widget-user-list-item + .widget-user-list-item {\n  margin-left: -1.25rem;\n}","/*\n   01. Color system \n   02. Options toggle setting (rtl, shadow, caret, negative margin, color mode)\n   03. Variable prefix setting\n   04. Body setting\n   05. Spacer setting\n   06. Font & headings settings\n   07. Grid settings\n   08. Container padding\n   09. Component border settings\n   10. Component border-radius settings\n   11. Component box-shadow settings \n   12. Component color settings \n   13. Component caret settings \n   14. Component transition settings \n   15. Component ratio settings \n   16. Container padding settings\n   17. App - Header settings\n   18. App - Sidebar settings\n   19. App - Content settings\n   20. App - Pos system settings\n   21. Link settings\n   22. Alerts settings\n   23. Breadcrumbs settings\n   24. Progress bars settings\n   25. Buttons + Forms settings\n   26. Buttons settings\n   27. Button close settings\n   28. Forms settings\n   29. Form placeholders settings\n   30. Form check settings\n   31. Form switch settings\n   32. Form input group settings\n   33. Form select settings\n   34. Form range settings\n   35. Form file settings\n   36. Form Floating settings\n   37. Form validation settings\n   38. Cards settings\n   39. Tooltips settings\n   40. Popovers\n   41. Modals settings\n   42. Offcanvas\n   43. Toasts settings\n   44. Accordion settings\n   45. Tables settings\n   46. Dropdown settings\n   47. List group settings\n   48. Nav settings\n   49. Navbar settings\n   50. Pagination settings\n   51. Z-index settings\n   52. Badges settings\n   53. Position settings\n   54. Image thumbnails settings\n   55. Figures settings\n   56. Carousel settings\n   57. Spinners settings\n   58. Code settings\n*/\n\n// 01. Color system\n\n$white: #ffffff !default;\n$gray-500: #617a86 !default;\n$gray-100: mix(#fff, $gray-500, 60%) !default;\n$gray-200: mix(#fff, $gray-500, 45%) !default;\n$gray-300: mix(#fff, $gray-500, 30%) !default;\n$gray-400: mix(#fff, $gray-500, 15%) !default;\n$gray-500: #617a86 !default;\n$gray-600: mix(#000, $gray-500, 15%) !default;\n$gray-700: mix(#000, $gray-500, 30%) !default;\n$gray-800: mix(#000, $gray-500, 45%) !default;\n$gray-900: mix(#000, $gray-500, 60%) !default;\n$yellow: #f9e80d !default;\n$orange: #ff9f0c !default;\n$aqua: #0cfff5 !default;\n$blue: #0271ff !default;\n$indigo: #5c25ff !default;\n$purple: #b90dff !default;\n$red: #e00000 !default;\n$teal: #249d79 !default;\n$green: #148922 !default;\n$lime: #50b00a !default;\n$pink: #e61079 !default;\n$cyan: #009be3 !default;\n$default: $gray-400 !default;\n$dark: $gray-800 !default;\n$black: #000000 !default;\n$light: $gray-100 !default;\n$primary: $blue !default;\n$warning: $orange !default;\n$danger: $red !default;\n$success: $teal !default;\n$info: $cyan !default;\n$secondary: $gray-400 !default;\n$text-muted: $gray-400 !default;\n$inverse: $black !default;\n$theme: $teal !default;\n$theme-color: $white !default;\n$theme-colors: (\n  \"default\": $default,\n  \"theme\": $theme,\n  \"theme-color\": $theme-color,\n  \"primary\": $primary,\n  \"secondary\": $secondary,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"success\": $success,\n  \"inverse\": $inverse,\n  \"info\": $info,\n  \"dark\": $dark,\n  \"black\": $black,\n  \"white\": $white,\n  \"purple\": $purple,\n  \"indigo\": $indigo,\n  \"red\": $red,\n  \"pink\": $pink,\n  \"green\": $green,\n  \"yellow\": $yellow,\n  \"teal\": $teal,\n  \"muted\": $gray-500,\n  \"light\": $light,\n  \"lime\": $lime,\n  \"gray-100\": $gray-100,\n  \"gray-200\": $gray-200,\n  \"gray-300\": $gray-300,\n  \"gray-400\": $gray-400,\n  \"gray-500\": $gray-500,\n  \"gray-600\": $gray-600,\n  \"gray-700\": $gray-700,\n  \"gray-800\": $gray-800,\n  \"gray-900\": $gray-900\n);\n\n$min-contrast-ratio: 3 !default;\n$color-contrast-dark: $black !default;\n$color-contrast-light: $white !default;\n\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$primary-text: $blue-600 !default;\n$secondary-text: $gray-600 !default;\n$success-text: $green-600 !default;\n$info-text: $cyan-700 !default;\n$warning-text: $yellow-700 !default;\n$danger-text: $red-600 !default;\n$light-text: $gray-600 !default;\n$dark-text: $gray-700 !default;\n\n$primary-bg-subtle: $blue-100 !default;\n$secondary-bg-subtle: $gray-100 !default;\n$success-bg-subtle: $green-100 !default;\n$info-bg-subtle: $cyan-100 !default;\n$warning-bg-subtle: $yellow-100 !default;\n$danger-bg-subtle: $red-100 !default;\n$light-bg-subtle: mix($gray-100, $white) !default;\n$dark-bg-subtle: $gray-400 !default;\n\n$primary-border-subtle: $blue-200 !default;\n$secondary-border-subtle: $gray-200 !default;\n$success-border-subtle: $green-200 !default;\n$info-border-subtle: $cyan-200 !default;\n$warning-border-subtle: $yellow-200 !default;\n$danger-border-subtle: $red-200 !default;\n$light-border-subtle: $gray-200 !default;\n$dark-border-subtle: $gray-500 !default;\n\n// 02. Options toggle setting (rtl, shadow, caret, negative margin, color mode)\n\n$enable-rtl: false !default;\n$enable-caret: true !default;\n$enable-rounded: true !default;\n$enable-shadows: false !default;\n$enable-gradients: false !default;\n$enable-transitions: true !default;\n$enable-reduced-motion: true !default;\n$enable-smooth-scroll: true !default;\n$enable-grid-classes: true !default;\n$enable-container-classes: true !default;\n$enable-cssgrid: false !default;\n$enable-button-pointers: true !default;\n$enable-rfs: true !default;\n$enable-validation-icons: true !default;\n$enable-negative-margins: true !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities: true !default;\n$enable-dark-mode: true !default;\n$color-mode-type: data !default; // `data` or `media-query`\n$gradient: linear-gradient(180deg, rgba($white, 0.15), rgba($white, 0)) !default;\n\n// 03. Variable prefix setting\n\n$prefix: bs- !default;\n\n// 04. Body setting\n\n$body-bg: $white !default;\n$body-bg-gradient: linear-gradient(180deg, rgba($white, 0.9) 0%, rgba($white, 0.99) 100%) !default;\n// $body-bg-cover:                                 url('images/cover.jpg') !default;\n$body-bg-image: url(\"images/pattern.png\") !default;\n$body-bg-image-size: rem(75px) !default;\n$body-letter-spacing: rem(0.75px) !default;\n$body-color: rgba($black, 1) !default;\n$body-font-weight: 400 !default;\n$body-emphasis-color: $black !default;\n$body-secondary-color: rgba($body-color, 0.75) !default;\n$body-secondary-bg: $gray-100 !default;\n$body-tertiary-color: rgba($body-color, 0.5) !default;\n$body-tertiary-bg: rgba($body-color, 0.1) !default;\n$emphasis-color: $black !default;\n\n// 05. Spacer setting\n\n$spacer: rem-default(16px) !default;\n$spacers: (\n  0: 0,\n  1: $spacer * 0.25,\n  2: $spacer * 0.5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3\n) !default;\n\n// 06. Font & headings settings\n\n$font-family-base: \"Chakra Petch\", sans-serif !default;\n$font-size-base: 0.875rem !default;\n$font-size-sm: 0.8125rem !default;\n$font-size-lg: 1rem !default;\n$font-weight-light: 300 !default;\n$font-weight-semibold: 500 !default;\n$font-weight-bold: 600 !default;\n$font-weight-base: 400 !default;\n$font-weight-normal: 400 !default;\n$headings-font-weight: $font-weight-bold !default;\n$headings-color: $black !default;\n$line-height-base: 1.5 !default;\n$line-height-sm: 1.25 !default;\n$line-height-lg: 2 !default;\n$lead-font-size: $font-size-base * 1.25 !default;\n$lead-font-weight: 300 !default;\n$small-font-size: 0.875em !default;\n$sub-sup-font-size: 0.75em !default;\n$text-muted: var(--#{$prefix}secondary-color) !default;\n$initialism-font-size: $small-font-size !default;\n$blockquote-margin-y: $spacer !default;\n$blockquote-font-size: $font-size-base * 1.25 !default;\n$blockquote-footer-color: $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n$hr-margin-y: $spacer !default;\n$hr-color: inherit !default;\n$hr-border-color: null !default;\n$hr-border-width: var(--#{$prefix}border-width) !default;\n$hr-opacity: 0.25 !default;\n$legend-margin-bottom: 0.5rem !default;\n$legend-font-size: 1.5rem !default;\n$legend-font-weight: null !default;\n$dt-font-weight: $font-weight-bold !default;\n$list-inline-padding: 0.5rem !default;\n$mark-padding: 0.1875em !default;\n$mark-bg: $yellow-100 !default;\n$paragraph-margin-bottom: 1rem !default;\n\n// 07. Grid settings\n\n$grid-gutter-width: 20px !default;\n$grid-columns: 12 !default;\n$grid-row-columns: 6 !default;\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1660px,\n  xxxl: 1921px\n) !default;\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n\n// 08. Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n// 09. Component border settings\n\n$border-width: 1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style: solid !default;\n$border-color: rgba($black, 0.2) !default;\n$border-color-translucent: rgba($black, 0.1) !default;\n\n// 10. Component border-radius settings\n\n$border-radius: 4px !default;\n$border-radius-lg: 8px !default;\n$border-radius-sm: 2px !default;\n$border-radius-xl: 1rem !default;\n$border-radius-2xl: 2rem !default;\n$border-radius-pill: 50rem !default;\n\n// 11. Component box-shadow settings\n\n$box-shadow: 0 0.5rem 1rem rgba(var(--#{$prefix}inverse-rgb), 0.075) !default;\n$box-shadow-sm: 0 0.125rem 0.25rem rgba(var(--#{$prefix}inverse-rgb), 0.035) !default;\n$box-shadow-lg: 0 1rem 3rem rgba(var(--#{$prefix}inverse-rgb), 0.175) !default;\n$box-shadow-inset: inset 0 1px 2px rgba(var(--#{$prefix}inverse-rgb), 0.075) !default;\n\n// 12. Component color settings\n\n$component-bg: $white !default;\n$component-color: $body-color !default;\n$component-active-color: $theme-color !default;\n$component-active-bg: $theme !default;\n\n// 13. Component caret settings\n\n$caret-width: 0.3em !default;\n$caret-vertical-align: $caret-width * 0.85 !default;\n$caret-spacing: $caret-width * 0.85 !default;\n\n// 14. Component transition settings\n\n$transition-base: all 0.2s ease-in-out !default;\n$transition-fade: opacity 0.15s linear !default;\n$transition-collapse: height 0.35s ease !default;\n$transition-collapse-width: width 0.35s ease !default;\n\n// 15. Component ratio settings\n\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n\n// 16. Container padding settings\n\n$container-padding-x: $grid-gutter-width !default;\n\n// 17. App - Header settings\n\n$app-header-height: rem(52px) !default;\n$app-header-bg: $white !default;\n$app-header-zindex: 1020 !default;\n$app-header-search-max-width: rem(967px) !default;\n$app-header-padding-x: $spacer * 0.25 !default;\n$app-header-padding-y: $spacer * 0.25 !default;\n$app-header-brand-img: url(\"images/logo.png\") !default;\n$app-header-link-color: $black !default;\n$app-header-link-hover-color: $black !default;\n$app-header-scroll-box-shadow: null !default;\n\n// 18. App - Sidebar settings\n\n$app-sidebar-width: rem(230px) !default;\n$app-sidebar-menu-header-color: rgba(var(--#{$prefix}inverse-rgb), 0.3) !default;\n$app-sidebar-menu-link-color: rgba(var(--#{$prefix}inverse-rgb), 0.5) !default;\n$app-sidebar-menu-link-hover-color: $black !default;\n$app-sidebar-menu-link-active-color: $black !default;\n$app-sidebar-menu-link-icon-active-color: var(--#{$prefix}theme) !default;\n$app-sidebar-zindex: $app-header-zindex - 10 !default;\n$app-sidebar-mobile-zindex: $app-header-zindex + 10 !default;\n$app-sidebar-mobile-bg: rgba(255, 255, 255, 0.98) !default;\n$app-sidebar-mobile-backdrop-zindex: $app-sidebar-mobile-zindex - 10 !default;\n$app-sidebar-mobile-backdrop-bg: rgba($black, 0.25) !default;\n\n// 19. App - Top Nav settings\n$app-top-nav-bg: $white !default;\n$app-top-nav-zindex: $app-header-zindex - 10 !default;\n$app-top-nav-height: rem(46px) !default;\n$app-top-nav-menu-link-padding-x: rem(20px) !default;\n$app-top-nav-menu-link-padding-y: rem(10px) !default;\n$app-top-nav-menu-link-color: rgba(var(--#{$prefix}inverse-rgb), 0.5) !default;\n$app-top-nav-menu-link-hover-color: $black !default;\n$app-top-nav-menu-link-active-color: $black !default;\n$app-top-nav-menu-link-icon-active-color: var(--#{$prefix}theme) !default;\n$app-top-nav-menu-submenu-bg: $white !default;\n\n// 19. App - Content settings\n\n$app-content-padding-y: $spacer * 2;\n$app-content-padding-x: $spacer * 2;\n$app-content-sm-padding-y: $spacer;\n$app-content-sm-padding-x: $spacer;\n\n// 20. App - Theme panel settings\n\n$app-theme-panel-bg: rgba($white, 0.95) !default;\n$app-theme-panel-color: $black !default;\n\n// 20. App - Pos system settings\n\n$pos-booking-header-height: rem(52px) !default;\n$pos-counter-header-height: rem(52px) !default;\n$pos-kitchen-header-height: rem(52px) !default;\n$pos-stock-header-height: rem(52px) !default;\n$pos-sidebar-menu-width: 140px !default;\n$pos-sidebar-desktop-width: 360px !default;\n$pos-bg: $gray-200 !default;\n$pos-bg-dark-mode: shade-color($gray-900, 30%) !default;\n\n// 21. Link settings\n\n$link-color: $theme !default;\n$link-hover-color: rgba($theme, 0.5) !default;\n$link-decoration: underline !default;\n$link-shade-percentage: 20% !default;\n$link-hover-decoration: null !default;\n$stretched-link-pseudo-element: after !default;\n$stretched-link-z-index: 1 !default;\n\n// 22. Alerts settings\n\n$alert-padding-y: $spacer !default;\n$alert-padding-x: $spacer !default;\n$alert-margin-bottom: 1rem !default;\n$alert-border-radius: $border-radius !default;\n$alert-link-font-weight: $font-weight-bold !default;\n$alert-border-width: var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r: $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n\n// 23. Breadcrumbs settings\n\n$breadcrumb-font-size: 85% !default;\n$breadcrumb-padding-y: 0 !default;\n$breadcrumb-padding-x: 0 !default;\n$breadcrumb-item-padding-x: 0.5rem !default;\n$breadcrumb-margin-bottom: 1rem !default;\n$breadcrumb-bg: null !default;\n$breadcrumb-divider-color: var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color: var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider: quote(\"/\") !default;\n$breadcrumb-divider-flipped: $breadcrumb-divider !default;\n$breadcrumb-border-radius: null !default;\n\n// 24. Progress bars settings\n\n$progress-height: 1rem !default;\n$progress-font-size: $font-size-base * 0.75 !default;\n$progress-bg: rgba(var(--#{$prefix}inverse-rgb), 0.15) !default;\n$progress-border-radius: var(--#{$prefix}border-radius) !default;\n$progress-box-shadow: var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color: $white !default;\n$progress-bar-bg: $primary !default;\n$progress-bar-animation-timing: 1s linear infinite !default;\n$progress-bar-transition: width 0.6s ease !default;\n\n// 25. Buttons + Forms settings\n\n$input-btn-padding-y: 0.375rem !default;\n$input-btn-padding-x: 0.75rem !default;\n$input-btn-font-family: null !default;\n$input-btn-font-size: $font-size-base !default;\n$input-btn-line-height: $line-height-base !default;\n$input-btn-focus-width: 0.25rem !default;\n$input-btn-focus-color-opacity: 0.25 !default;\n$input-btn-focus-color: rgba(var(--#{$prefix}inverse-rgb), $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur: 0 !default;\n$input-btn-focus-box-shadow: 0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n$input-btn-padding-y-sm: 0.25rem !default;\n$input-btn-padding-x-sm: 0.5rem !default;\n$input-btn-font-size-sm: $font-size-sm !default;\n$input-btn-padding-y-lg: 0.5rem !default;\n$input-btn-padding-x-lg: 1rem !default;\n$input-btn-font-size-lg: $font-size-lg !default;\n$input-btn-border-width: var(--#{$prefix}border-width) !default;\n\n// 26. Buttons settings\n\n$btn-padding-y: $input-btn-padding-y !default;\n$btn-padding-x: $input-btn-padding-x !default;\n$btn-font-family: $input-btn-font-family !default;\n$btn-font-size: $input-btn-font-size !default;\n$btn-line-height: $input-btn-line-height !default;\n$btn-white-space: null !default; // Set to `nowrap` to prevent text wrapping\n$btn-padding-y-sm: $input-btn-padding-y-sm !default;\n$btn-padding-x-sm: $input-btn-padding-x-sm !default;\n$btn-font-size-sm: $input-btn-font-size-sm !default;\n$btn-padding-y-lg: $input-btn-padding-y-lg !default;\n$btn-padding-x-lg: $input-btn-padding-x-lg !default;\n$btn-font-size-lg: $input-btn-font-size-lg !default;\n$btn-border-width: $input-btn-border-width !default;\n$btn-font-weight: $font-weight-normal !default;\n$btn-box-shadow:\n  inset 0 1px 0 rgba($white, 0.15),\n  0 1px 1px rgba($black, 0.075) !default;\n$btn-focus-width: $input-btn-focus-width !default;\n$btn-focus-box-shadow: $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity: 0.65 !default;\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, 0.125) !default;\n$btn-link-color: var(--#{$prefix}link-color) !default;\n$btn-link-hover-color: var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color: $gray-600 !default;\n$btn-border-radius: $border-radius !default;\n$btn-border-radius-sm: $border-radius-sm !default;\n$btn-border-radius-lg: $border-radius-lg !default;\n$btn-transition:\n  color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out !default;\n$btn-hover-bg-shade-amount: 15% !default;\n$btn-hover-bg-tint-amount: 15% !default;\n$btn-hover-border-shade-amount: 20% !default;\n$btn-hover-border-tint-amount: 10% !default;\n$btn-active-bg-shade-amount: 20% !default;\n$btn-active-bg-tint-amount: 20% !default;\n$btn-active-border-shade-amount: 25% !default;\n$btn-active-border-tint-amount: 10% !default;\n\n// 27. Button close settings\n\n$btn-close-width: 1em !default;\n$btn-close-height: $btn-close-width !default;\n$btn-close-padding-x: 0.25em !default;\n$btn-close-padding-y: $btn-close-padding-x !default;\n$btn-close-color: $black !default;\n$btn-close-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow: $input-btn-focus-box-shadow !default;\n$btn-close-opacity: 0.5 !default;\n$btn-close-hover-opacity: 0.75 !default;\n$btn-close-focus-opacity: 1 !default;\n$btn-close-disabled-opacity: 0.25 !default;\n$btn-close-white-filter: invert(1) grayscale(100%) brightness(200%) !default;\n\n// 28. Forms settings\n\n$form-text-margin-top: 0.25rem !default;\n$form-text-font-size: $small-font-size !default;\n$form-text-font-style: null !default;\n$form-text-font-weight: null !default;\n$form-text-color: $text-muted !default;\n$form-label-margin-bottom: 0.5rem !default;\n$form-label-font-size: null !default;\n$form-label-font-style: null !default;\n$form-label-font-weight: null !default;\n$form-label-color: null !default;\n$input-padding-y: $input-btn-padding-y !default;\n$input-padding-x: $input-btn-padding-x !default;\n$input-font-family: $input-btn-font-family !default;\n$input-font-size: $input-btn-font-size !default;\n$input-font-weight: $font-weight-base !default;\n$input-line-height: $input-btn-line-height !default;\n$input-padding-y-sm: $input-btn-padding-y-sm !default;\n$input-padding-x-sm: $input-btn-padding-x-sm !default;\n$input-font-size-sm: $input-btn-font-size-sm !default;\n$input-padding-y-lg: $input-btn-padding-y-lg !default;\n$input-padding-x-lg: $input-btn-padding-x-lg !default;\n$input-font-size-lg: $input-btn-font-size-lg !default;\n$input-bg: transparent !default;\n$input-disabled-color: null !default;\n$input-disabled-bg: var(--#{$prefix}form-control-disabled-bg) !default;\n$input-disabled-border-color: null !default;\n$input-color: var(--#{$prefix}body-color) !default;\n$input-border-color: var(--#{$prefix}border-color) !default; //$gray-400\n$input-border-width: $input-btn-border-width !default;\n$input-box-shadow: $box-shadow-inset !default;\n$input-border-radius: $border-radius !default;\n$input-border-radius-sm: $border-radius-sm !default;\n$input-border-radius-lg: $border-radius-lg !default;\n$input-focus-bg: $input-bg !default;\n$input-focus-border-color: rgba(var(--#{$prefix}inverse-rgb), 0.5) !default;\n$input-focus-color: $input-color !default;\n$input-focus-width: $input-btn-focus-width !default;\n$input-focus-box-shadow: $input-btn-focus-box-shadow !default;\n$input-placeholder-color: rgba(var(--#{$prefix}body-color-rgb), 0.5) !default;\n$input-plaintext-color: var(--#{$prefix}body-color) !default;\n$input-height-border: calc($input-border-width * 2) !default; // stylelint-disable-line function-disallowed-list\n$input-height-inner: add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half: add($input-line-height * 0.5em, $input-padding-y) !default;\n$input-height-inner-quarter: add($input-line-height * 0.25em, $input-padding-y * 0.5) !default;\n$input-height: add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm: add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg: add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n$input-transition:\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out !default;\n$form-color-width: 3rem !default;\n\n// 29. Form placeholders settings\n\n$placeholder-opacity-max: 0.5 !default;\n$placeholder-opacity-min: 0.2 !default;\n\n// 30. Form check settings\n\n$form-check-input-width: 1.3em !default;\n$form-check-min-height: 1.3em !default;\n$form-check-padding-start: $form-check-input-width + 0.5em !default;\n$form-check-margin-bottom: 0.125rem !default;\n$form-check-label-color: null !default;\n$form-check-label-cursor: null !default;\n$form-check-transition: null !default;\n$form-check-input-active-filter: brightness(90%) !default;\n$form-check-input-bg: $input-bg !default;\n$form-check-input-border: var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius: 0.25em !default;\n$form-check-radio-border-radius: 50% !default;\n$form-check-input-focus-border: $input-focus-border-color !default;\n$form-check-input-focus-box-shadow: $input-btn-focus-box-shadow !default;\n$form-check-input-checked-color: $component-active-color !default;\n$form-check-input-checked-bg-color: $component-active-bg !default;\n$form-check-input-checked-border-color: $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n$form-check-input-indeterminate-color: $component-active-color !default;\n$form-check-input-indeterminate-bg-color: $component-active-bg !default;\n$form-check-input-indeterminate-border-color: $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n$form-check-input-disabled-opacity: 0.5 !default;\n$form-check-label-disabled-opacity: $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity: $btn-disabled-opacity !default;\n$form-check-inline-margin-end: 1rem !default;\n\n// 31. Form switch settings\n\n$form-switch-color: rgba($black, 0.25) !default;\n$form-switch-width: 2.3em !default;\n$form-switch-padding-start: $form-switch-width + 0.5em !default;\n$form-switch-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius: $form-switch-width !default;\n$form-switch-transition: background-position 0.15s ease-in-out !default;\n$form-switch-focus-color: tint-color($black, 50%) !default;\n$form-switch-focus-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n$form-switch-checked-color: $component-active-color !default;\n$form-switch-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n\n// 32. Form input group settings\n\n$input-group-addon-padding-y: $input-padding-y !default;\n$input-group-addon-padding-x: $input-padding-x !default;\n$input-group-addon-font-weight: $input-font-weight !default;\n$input-group-addon-color: $input-color !default;\n$input-group-addon-bg: var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color: $input-border-color !default;\n\n// 33. Form select settings\n\n$form-select-padding-y: $input-padding-y !default;\n$form-select-padding-x: $input-padding-x !default;\n$form-select-font-family: $input-font-family !default;\n$form-select-font-size: $input-font-size !default;\n$form-select-indicator-padding: $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight: $input-font-weight !default;\n$form-select-line-height: $input-line-height !default;\n$form-select-color: $input-color !default;\n$form-select-bg: $input-bg !default;\n$form-select-disabled-color: null !default;\n$form-select-disabled-bg: $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position: right $form-select-padding-x center !default;\n$form-select-bg-size: 16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color: $gray-800 !default;\n$form-select-indicator: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position: center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size: $input-height-inner-half $input-height-inner-half !default;\n$form-select-border-width: $input-border-width !default;\n$form-select-border-color: $input-border-color !default;\n$form-select-border-radius: $input-border-radius !default;\n$form-select-box-shadow: $box-shadow-inset !default;\n$form-select-focus-border-color: $input-focus-border-color !default;\n$form-select-focus-width: $input-focus-width !default;\n$form-select-focus-box-shadow: 0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n$form-select-padding-y-sm: $input-padding-y-sm !default;\n$form-select-padding-x-sm: $input-padding-x-sm !default;\n$form-select-font-size-sm: $input-font-size-sm !default;\n$form-select-border-radius-sm: $input-border-radius-sm !default;\n$form-select-padding-y-lg: $input-padding-y-lg !default;\n$form-select-padding-x-lg: $input-padding-x-lg !default;\n$form-select-font-size-lg: $input-font-size-lg !default;\n$form-select-border-radius-lg: $input-border-radius-lg !default;\n$form-select-transition: $input-transition !default;\n\n// 34. Form range settings\n\n$form-range-track-width: 100% !default;\n$form-range-track-height: 0.5rem !default;\n$form-range-track-cursor: pointer !default;\n$form-range-track-bg: rgba(var(--#{$prefix}inverse-rgb), 0.1) !default;\n$form-range-track-border-radius: 1rem !default;\n$form-range-track-box-shadow: $box-shadow-inset !default;\n$form-range-thumb-width: 1rem !default;\n$form-range-thumb-height: $form-range-thumb-width !default;\n$form-range-thumb-bg: var(--#{$prefix}theme) !default;\n$form-range-thumb-border: 0 !default;\n$form-range-thumb-border-radius: 1rem !default;\n$form-range-thumb-box-shadow: 0 0.1rem 0.25rem rgba($black, 0.1) !default;\n$form-range-thumb-focus-box-shadow:\n  0 0 0 1px transparent,\n  $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width: $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg: rgba(var(--#{$prefix}theme-rgb), 0.75) !default;\n$form-range-thumb-disabled-bg: var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out !default;\n\n// 35. Form file settings\n\n$form-file-button-color: $input-color !default;\n$form-file-button-bg: var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg: var(--#{$prefix}border-color) !default;\n\n// 36. Form Floating settings\n\n$form-floating-height: add(3.5rem, $input-height-border) !default;\n$form-floating-line-height: 1.25 !default;\n$form-floating-padding-x: $input-padding-x !default;\n$form-floating-padding-y: 1rem !default;\n$form-floating-input-padding-t: 1.625rem !default;\n$form-floating-input-padding-b: 0.625rem !default;\n$form-floating-label-height: 1.875em !default;\n$form-floating-label-opacity: 0.65 !default;\n$form-floating-label-transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem) !default;\n$form-floating-label-disabled-color: $gray-600 !default;\n$form-floating-transition:\n  opacity 0.1s ease-in-out,\n  transform 0.1s ease-in-out !default;\n\n// 37. Form validation settings\n\n$form-feedback-margin-top: $form-text-margin-top !default;\n$form-feedback-font-size: $form-text-font-size !default;\n$form-feedback-font-style: $form-text-font-style !default;\n$form-feedback-valid-color: $success !default;\n$form-feedback-invalid-color: $danger !default;\n$form-feedback-icon-valid-color: $form-feedback-valid-color !default;\n$form-feedback-icon-valid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color: $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}success-text),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width\n      rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}success)\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}danger-text),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width\n      rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}danger)\n  )\n) !default;\n\n// 38. Cards settings\n\n$card-spacer-y: $spacer !default;\n$card-spacer-x: $spacer !default;\n$card-title-spacer-y: $spacer * 0.5 !default;\n$card-title-color: null !default;\n$card-subtitle-color: null !default;\n$card-border-width: var(--#{$prefix}border-width) !default;\n$card-border-color: var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius: var(--#{$prefix}border-radius) !default;\n$card-box-shadow: null !default;\n$card-inner-border-radius: subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y: $card-spacer-y * 0.5 !default;\n$card-cap-padding-x: $card-spacer-x !default;\n$card-cap-bg: rgba(var(--#{$prefix}body-color-rgb), 0.03) !default;\n$card-cap-color: null !default;\n$card-height: null !default;\n$card-color: null !default;\n$card-bg: transparent !default;\n$card-img-overlay-padding: $spacer !default;\n$card-group-margin: $grid-gutter-width * 0.5 !default;\n\n// 39. Tooltips settings\n\n$tooltip-font-size: $font-size-sm !default;\n$tooltip-max-width: 200px !default;\n$tooltip-color: var(--#{$prefix}body-bg) !default;\n$tooltip-bg: var(--#{$prefix}inverse) !default;\n$tooltip-border-radius: var(--#{$prefix}border-radius) !default;\n$tooltip-opacity: 0.9 !default;\n$tooltip-padding-y: $spacer * 0.25 !default;\n$tooltip-padding-x: $spacer * 0.5 !default;\n$tooltip-arrow-width: 0.8rem !default;\n$tooltip-arrow-height: 0.4rem !default;\n$form-feedback-tooltip-padding-y: $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x: $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size: $tooltip-font-size !default;\n$form-feedback-tooltip-line-height: null !default;\n$form-feedback-tooltip-opacity: $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n// 40. Popovers\n\n$popover-font-size: $font-size-sm !default;\n$popover-bg: var(--#{$prefix}body-bg) !default;\n$popover-max-width: 276px !default;\n$popover-border-width: var(--#{$prefix}border-width) !default;\n$popover-border-color: var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius: var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius: calc(\n  $popover-border-radius - $popover-border-width\n) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow: $box-shadow !default;\n$popover-header-font-size: $font-size-base !default;\n$popover-header-bg: var(--#{$prefix}secondary-bg) !default;\n$popover-header-color: $headings-color !default;\n$popover-header-padding-y: 0.5rem !default;\n$popover-header-padding-x: $spacer !default;\n$popover-body-color: var(--#{$prefix}body-color) !default;\n$popover-body-padding-y: $spacer !default;\n$popover-body-padding-x: $spacer !default;\n$popover-arrow-width: 1rem !default;\n$popover-arrow-height: 0.5rem !default;\n\n// 41. Modals settings\n\n$modal-inner-padding: $spacer !default;\n$modal-footer-margin-between: 0.5rem !default;\n$modal-dialog-margin: 0.5rem !default;\n$modal-dialog-margin-y-sm-up: 1.75rem !default;\n$modal-title-line-height: $line-height-base !default;\n$modal-content-color: null !default;\n$modal-content-bg: var(--#{$prefix}app-header-bg) !default;\n$modal-content-border-color: var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width: var(--#{$prefix}border-width) !default;\n$modal-content-border-radius: 0 !default;\n$modal-content-inner-border-radius: 0 !default;\n$modal-content-box-shadow-xs: $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up: $box-shadow !default;\n$modal-backdrop-bg: #e6e6e6 !default;\n$modal-backdrop-opacity: 0.95 !default;\n$modal-header-border-color: var(--#{$prefix}border-color) !default;\n$modal-header-border-width: $modal-content-border-width !default;\n$modal-header-padding-y: $modal-inner-padding !default;\n$modal-header-padding-x: $modal-inner-padding !default;\n$modal-header-padding: $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n$modal-footer-bg: null !default;\n$modal-footer-border-color: $modal-header-border-color !default;\n$modal-footer-border-width: $modal-header-border-width !default;\n$modal-sm: 300px !default;\n$modal-md: 500px !default;\n$modal-lg: 800px !default;\n$modal-xl: 1140px !default;\n$modal-fade-transform: translate(0, -50px) !default;\n$modal-show-transform: none !default;\n$modal-transition: transform 0.3s ease-out !default;\n$modal-scale-transform: scale(1.02) !default;\n\n// 42. Offcanvas\n\n$offcanvas-padding-y: $modal-inner-padding !default;\n$offcanvas-padding-x: $modal-inner-padding !default;\n$offcanvas-horizontal-width: 400px !default;\n$offcanvas-vertical-height: 30vh !default;\n$offcanvas-transition-duration: 0.3s !default;\n$offcanvas-border-color: $modal-content-border-color !default;\n$offcanvas-border-width: $modal-content-border-width !default;\n$offcanvas-title-line-height: $modal-title-line-height !default;\n$offcanvas-bg-color: var(--#{$prefix}body-bg) !default;\n$offcanvas-color: var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow: $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg: $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity: $modal-backdrop-opacity !default;\n\n// 43. Toasts settings\n\n$toast-max-width: 350px !default;\n$toast-padding-x: 0.75rem !default;\n$toast-padding-y: 0.5rem !default;\n$toast-font-size: 0.875rem !default;\n$toast-color: null !default;\n$toast-background-color: rgba(var(--#{$prefix}body-bg-rgb), 0.85) !default;\n$toast-border-width: var(--#{$prefix}border-width) !default;\n$toast-border-color: var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius: var(--#{$prefix}border-radius) !default;\n$toast-box-shadow: var(--#{$prefix}box-shadow) !default;\n$toast-spacing: $container-padding-x !default;\n$toast-header-color: var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color: rgba(var(--#{$prefix}body-bg-rgb), 0.85) !default;\n$toast-header-border-color: $toast-border-color !default;\n\n// 44. Accordion settings\n\n$accordion-padding-y: 1rem !default;\n$accordion-padding-x: 1.25rem !default;\n$accordion-color: var(--#{$prefix}body-color) !default; // Sass variable because of $accordion-button-icon\n$accordion-bg: var(--#{$prefix}body-bg) !default;\n$accordion-border-width: var(--#{$prefix}border-width) !default;\n$accordion-border-color: var(--#{$prefix}border-color) !default;\n$accordion-border-radius: var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius: subtract($accordion-border-radius, $accordion-border-width) !default;\n$accordion-body-padding-y: $accordion-padding-y !default;\n$accordion-body-padding-x: $accordion-padding-x !default;\n$accordion-button-padding-y: $accordion-padding-y !default;\n$accordion-button-padding-x: $accordion-padding-x !default;\n$accordion-button-color: var(--#{$prefix}body-color) !default;\n$accordion-button-bg: var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:\n  $btn-transition,\n  border-radius 0.15s ease !default;\n$accordion-button-active-bg: rgba(var(--#{$prefix}theme-rgb), 0.15) !default;\n$accordion-button-active-color: var(--#{$prefix}inverse) !default;\n$accordion-button-focus-border-color: $input-focus-border-color !default;\n$accordion-button-focus-box-shadow: $btn-focus-box-shadow !default;\n$accordion-icon-width: 1.25rem !default;\n$accordion-icon-color: $body-color !default;\n$accordion-icon-active-color: $body-color !default;\n$accordion-icon-transition: transform 0.2s ease-in-out !default;\n$accordion-icon-transform: rotate(-180deg) !default;\n$accordion-button-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n// 45. Tables settings\n\n$table-cell-padding-y: 0.5rem !default;\n$table-cell-padding-x: 0.5rem !default;\n$table-cell-padding-y-sm: 0.25rem !default;\n$table-cell-padding-x-sm: 0.25rem !default;\n$table-cell-vertical-align: top !default;\n$table-color: var(--#{$prefix}body-color) !default;\n$table-bg: transparent !default;\n$table-accent-bg: transparent !default;\n$table-th-font-weight: null !default;\n$table-striped-color: $table-color !default;\n$table-striped-bg-factor: 0.1 !default;\n$table-striped-bg: rgba(var(--#{$prefix}inverse-rgb), $table-striped-bg-factor) !default;\n$table-active-color: $table-color !default;\n$table-active-bg-factor: 0.1 !default;\n$table-active-bg: rgba(var(--#{$prefix}inverse-rgb), $table-active-bg-factor) !default;\n$table-hover-color: $table-color !default;\n$table-hover-bg-factor: 0.075 !default;\n$table-hover-bg: rgba(var(--#{$prefix}inverse-rgb), $table-hover-bg-factor) !default;\n$table-border-factor: 0.1 !default;\n$table-border-width: var(--#{$prefix}border-width) !default;\n$table-border-color: var(--#{$prefix}border-color) !default;\n$table-striped-order: odd !default;\n$table-striped-columns-order: even !default;\n$table-group-separator-color: currentcolor !default;\n$table-caption-color: $text-muted !default;\n$table-bg-scale: -80% !default;\n$table-variants: (\n  \"primary\": shift-color($primary, $table-bg-scale),\n  \"secondary\": shift-color($secondary, $table-bg-scale),\n  \"success\": shift-color($success, $table-bg-scale),\n  \"info\": shift-color($info, $table-bg-scale),\n  \"warning\": shift-color($warning, $table-bg-scale),\n  \"danger\": shift-color($danger, $table-bg-scale),\n  \"light\": $light,\n  \"dark\": $dark\n) !default;\n\n// 46. Dropdown settings\n\n$dropdown-min-width: 10rem !default;\n$dropdown-padding-x: 0 !default;\n$dropdown-padding-y: 0.5rem !default;\n$dropdown-spacer: 0.125rem !default;\n$dropdown-font-size: $font-size-base !default;\n$dropdown-color: var(--#{$prefix}body-color) !default;\n$dropdown-bg: rgba(var(--#{$prefix}body-bg-rgb), 0.98) !default;\n$dropdown-border-color: var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius: 0 !default;\n$dropdown-border-width: var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius: calc(\n  $dropdown-border-radius - $dropdown-border-width\n) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg: $dropdown-border-color !default;\n$dropdown-divider-margin-y: $spacer * 0.5 !default;\n$dropdown-box-shadow: $box-shadow !default;\n$dropdown-link-color: var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color: $dropdown-link-color !default;\n$dropdown-link-hover-bg: rgba(var(--#{$prefix}body-color-rgb), 0.15) !default;\n$dropdown-link-active-color: $component-active-color !default;\n$dropdown-link-active-bg: $component-active-bg !default;\n$dropdown-link-disabled-color: $gray-500 !default;\n$dropdown-item-padding-y: rem(6px) !default;\n$dropdown-item-padding-x: $spacer !default;\n$dropdown-header-color: rgba(var(--#{$prefix}body-color-rgb), 0.5) !default;\n$dropdown-header-padding-x: $dropdown-item-padding-x !default;\n$dropdown-header-padding-y: $dropdown-padding-y !default;\n\n// 47. List group settings\n\n$list-group-color: var(--#{$prefix}body-color) !default;\n$list-group-bg: transparent !default;\n$list-group-border-color: var(--#{$prefix}border-color) !default;\n$list-group-border-width: var(--#{$prefix}border-width) !default;\n$list-group-border-radius: var(--#{$prefix}border-radius) !default;\n$list-group-item-padding-y: $spacer * 0.5 !default;\n$list-group-item-padding-x: $spacer !default;\n$list-group-hover-bg: var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color: $component-active-color !default;\n$list-group-active-bg: $component-active-bg !default;\n$list-group-active-border-color: $list-group-active-bg !default;\n$list-group-disabled-color: var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg: $list-group-bg !default;\n$list-group-action-color: var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color: var(--#{$prefix}inverse) !default;\n$list-group-action-active-color: var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg: var(--#{$prefix}secondary-bg) !default;\n\n// 48. Nav settings\n\n$nav-link-padding-y: 0.5rem !default;\n$nav-link-padding-x: 1rem !default;\n$nav-link-font-size: null !default;\n$nav-link-font-weight: null !default;\n$nav-link-color: var(--#{$prefix}link-color) !default;\n$nav-link-hover-color: var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:\n  color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out !default;\n$nav-link-disabled-color: var(--#{$prefix}secondary-color) !default;\n$nav-tabs-border-color: var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width: var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius: var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color: var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color: var(--#{$prefix}inverse) !default;\n$nav-tabs-link-active-bg: transparent !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n$nav-pills-border-radius: $border-radius !default;\n$nav-pills-link-active-color: $component-active-color !default;\n$nav-pills-link-active-bg: $component-active-bg !default;\n\n// 49. Navbar settings\n\n$navbar-padding-y: $spacer * 0.5 !default;\n$navbar-padding-x: null !default;\n$navbar-nav-link-padding-x: 0.5rem !default;\n$navbar-brand-font-size: $font-size-lg !default;\n$nav-link-height: $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) * 0.5 !default;\n$navbar-brand-margin-end: 1rem !default;\n$navbar-toggler-padding-y: 0.25rem !default;\n$navbar-toggler-padding-x: 0.75rem !default;\n$navbar-toggler-font-size: $font-size-lg !default;\n$navbar-toggler-border-radius: $btn-border-radius !default;\n$navbar-toggler-focus-width: $btn-focus-width !default;\n$navbar-toggler-transition: box-shadow 0.15s ease-in-out !default;\n$navbar-light-color: rgba(var(--#{$prefix}inverse-rgb), 0.65) !default;\n$navbar-light-hover-color: rgba(var(--#{$prefix}inverse-rgb), 0.8) !default;\n$navbar-light-active-color: rgba(var(--#{$prefix}inverse-rgb), 1) !default;\n$navbar-light-disabled-color: rgba(var(--#{$prefix}inverse-rgb), 0.3) !default;\n$navbar-light-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{rgba($body-color, .75)}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}inverse-rgb), 0.15) !default;\n$navbar-light-brand-color: $navbar-light-active-color !default;\n$navbar-light-brand-hover-color: $navbar-light-active-color !default;\n\n// 50. Pagination settings\n\n$pagination-padding-y: 0.375rem !default;\n$pagination-padding-x: 0.75rem !default;\n$pagination-padding-y-sm: 0.25rem !default;\n$pagination-padding-x-sm: 0.5rem !default;\n$pagination-padding-y-lg: 0.75rem !default;\n$pagination-padding-x-lg: 1.5rem !default;\n$pagination-font-size: $font-size-base !default;\n$pagination-color: var(--#{$prefix}inverse) !default;\n$pagination-bg: transparent !default;\n$pagination-border-radius: var(--#{$prefix}border-radius) !default;\n$pagination-border-width: var(--#{$prefix}border-width) !default;\n$pagination-margin-start: calc(\n  $pagination-border-width * -1\n) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color: var(--#{$prefix}border-color) !default;\n$pagination-focus-color: var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg: var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow: $input-btn-focus-box-shadow !default;\n$pagination-focus-outline: 0 !default;\n$pagination-hover-color: var(--#{$prefix}inverse) !default;\n$pagination-hover-bg: rgba(var(--#{$prefix}inverse-rgb), 0.1) !default;\n$pagination-hover-border-color: var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n$pagination-active-color: var(--#{$prefix}theme-color) !default;\n$pagination-active-bg: var(--#{$prefix}theme) !default;\n$pagination-active-border-color: var(--#{$prefix}theme) !default;\n$pagination-disabled-color: rgba(var(--#{$prefix}inverse-rgb), 0.35) !default;\n$pagination-disabled-bg: rgba(var(--#{$prefix}inverse-rgb), 0.1) !default;\n$pagination-disabled-border-color: var(--#{$prefix}border-color) !default;\n$pagination-transition:\n  color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out !default;\n$pagination-border-radius-sm: $border-radius-sm !default;\n$pagination-border-radius-lg: $border-radius-lg !default;\n\n// 51. Z-index settings\n\n$zindex-dropdown: 1000 !default;\n$zindex-sticky: 1020 !default;\n$zindex-fixed: 1030 !default;\n$zindex-offcanvas-backdrop: 1040 !default;\n$zindex-offcanvas: 1045 !default;\n$zindex-modal-backdrop: 1050 !default;\n$zindex-modal: 1055 !default;\n$zindex-popover: 1070 !default;\n$zindex-tooltip: 1130 !default;\n$zindex-toast: 1090 !default;\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n\n// 52. Badges settings\n\n$badge-font-size: 0.75em !default;\n$badge-font-weight: $font-weight-bold !default;\n$badge-color: $white !default;\n$badge-padding-y: 0.35em !default;\n$badge-padding-x: 0.65em !default;\n$badge-border-radius: $border-radius !default;\n\n// 53. Position settings\n\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n\n// 54. Image thumbnails settings\n\n$thumbnail-padding: 0.25rem !default;\n$thumbnail-bg: var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width: var(--#{$prefix}border-width) !default;\n$thumbnail-border-color: var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius: var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow: var(--#{$prefix}box-shadow-sm) !default;\n\n// 55. Figures settings\n\n$figure-caption-font-size: $small-font-size !default;\n$figure-caption-color: var(--#{$prefix}secondary-color) !default;\n\n// 56. Carousel settings\n\n$carousel-control-color: $white !default;\n$carousel-control-width: 15% !default;\n$carousel-control-opacity: 0.5 !default;\n$carousel-control-hover-opacity: 0.9 !default;\n$carousel-control-transition: opacity 0.15s ease !default;\n$carousel-indicator-width: 30px !default;\n$carousel-indicator-height: 3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer: 3px !default;\n$carousel-indicator-opacity: 0.5 !default;\n$carousel-indicator-active-bg: $white !default;\n$carousel-indicator-active-opacity: 1 !default;\n$carousel-indicator-transition: opacity 0.6s ease !default;\n$carousel-caption-width: 70% !default;\n$carousel-caption-color: $white !default;\n$carousel-caption-padding-y: 1.25rem !default;\n$carousel-caption-spacer: 1.25rem !default;\n$carousel-control-icon-width: 2rem !default;\n$carousel-control-prev-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$carousel-transition-duration: 0.6s !default;\n$carousel-transition: transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n$carousel-dark-indicator-active-bg: $black !default;\n$carousel-dark-caption-color: $black !default;\n$carousel-dark-control-icon-filter: invert(1) grayscale(100) !default;\n\n// 57. Spinners settings\n\n$spinner-width: 2rem !default;\n$spinner-height: $spinner-width !default;\n$spinner-vertical-align: -0.125em !default;\n$spinner-border-width: 0.25em !default;\n$spinner-animation-speed: 0.75s !default;\n$spinner-width-sm: 1rem !default;\n$spinner-height-sm: $spinner-width-sm !default;\n$spinner-border-width-sm: 0.2em !default;\n\n// 58. Code settings\n\n$code-font-size: $small-font-size !default;\n$code-color: $pink !default;\n$kbd-padding-y: 0.1875rem !default;\n$kbd-padding-x: 0.375rem !default;\n$kbd-font-size: $code-font-size !default;\n$kbd-color: var(--#{$prefix}body-bg) !default;\n$kbd-bg: var(--#{$prefix}body-color) !default;\n$pre-color: null !default;\n","/*\n   Dark color mode variables\n\t\n   01. Color system \n   02. Body setting\n   03. Font & headings settings\n   04. Border settings\n   05. Component settings\n   06. App - Header settings\n   07. App - Sidebar settings\n   08. App - Theme panel settings\n   09. Form switch settings\n   10. Form select settings\n   11. Form check settings\n   12. Accordion settings\n   13. Modal settings\n*/\n\n// 01. Color system\n\n$white: #ffffff !default;\n$gray-500: #617a86 !default;\n$gray-100: mix(#fff, $gray-500, 60%) !default;\n$gray-200: mix(#fff, $gray-500, 45%) !default;\n$gray-300: mix(#fff, $gray-500, 30%) !default;\n$gray-400: mix(#fff, $gray-500, 15%) !default;\n$gray-500: #617a86 !default;\n$gray-600: mix(#000, $gray-500, 15%) !default;\n$gray-700: mix(#000, $gray-500, 30%) !default;\n$gray-800: mix(#000, $gray-500, 45%) !default;\n$gray-900: mix(#000, $gray-500, 60%) !default;\n$yellow-dark: #f9e80d !default;\n$orange-dark: #ff9f0c !default;\n$aqua-dark: #0cfff5 !default;\n$blue-dark: #4e9cff !default;\n$indigo-dark: #bba4ff !default;\n$purple-dark: #de8cff !default;\n$red-dark: #ff6060 !default;\n$teal-dark: #3cd2a5 !default;\n$green-dark: #1ecc33 !default;\n$lime-dark: #81f32d !default;\n$pink-dark: #f34fa0 !default;\n$cyan-dark: #30beff !default;\n\n$default-dark: $gray-200 !default;\n$dark-dark: $gray-800 !default;\n$black-dark: #000000 !default;\n$light-dark: $gray-100 !default;\n$primary-dark: $blue-dark !default;\n$warning-dark: $orange-dark !default;\n$danger-dark: $red-dark !default;\n$success-dark: $teal-dark !default;\n$info-dark: $cyan-dark !default;\n$secondary-dark: $gray-400 !default;\n$text-muted-dark: $gray-400 !default;\n$inverse-dark: $white !default;\n$theme-dark: $teal-dark !default;\n$theme-colors-dark: (\n\t\"default\": $default-dark,\n\t\"theme\": $theme-dark,\n\t\"primary\": $primary-dark,\n\t\"secondary\": $secondary-dark,\n\t\"warning\": $warning-dark,\n\t\"danger\": $danger-dark,\n\t\"success\": $success-dark,\n\t\"inverse\": $inverse-dark,\n\t\"info\": $info-dark,\n\t\"dark\": $dark-dark,\n\t\"black\": $black-dark,\n\t\"white\": $white,\n\t\"purple\": $purple-dark,\n\t\"indigo\": $indigo-dark,\n\t\"red\": $red-dark,\n\t\"pink\": $pink-dark,\n\t\"green\": $green-dark,\n\t\"yellow\": $yellow-dark,\n\t\"teal\": $teal-dark,\n\t\"muted\": $gray-500,\n\t\"light\": $light-dark,\n\t\"lime\": $lime-dark,\n\t\"gray-100\": $gray-100,\n\t\"gray-200\": $gray-200,\n\t\"gray-300\": $gray-300,\n\t\"gray-400\": $gray-400,\n\t\"gray-500\": $gray-500,\n\t\"gray-600\": $gray-600,\n\t\"gray-700\": $gray-700,\n\t\"gray-800\": $gray-800,\n\t\"gray-900\": $gray-900,\n\t\"theme-color-1\": #d23c3c,\n\t\"theme-color-2\": #d23c5b,\n\t\"theme-color-3\": #3ca7d2,\n\t\"theme-color-4\": #3ccbd2,\n\t\"theme-color-5\": #3cd2a5,\n\t\"theme-color-6\": #3cd26a,\n\t\"theme-color-7\": #a2d23c,\n\t\"theme-color-8\": #d2bc3c,\n\t\"theme-color-9\": #d2a83c,\n\t\"theme-color-10\": #d26e3c\n);\n\n$primary-text-dark: $blue-300 !default;\n$secondary-text-dark: $gray-300 !default;\n$success-text-dark: $green-300 !default;\n$info-text-dark: $cyan-300 !default;\n$warning-text-dark: $yellow-300 !default;\n$danger-text-dark: $red-300 !default;\n$light-text-dark: $gray-100 !default;\n$dark-text-dark: $gray-300 !default;\n\n$primary-bg-subtle-dark: $blue-900 !default;\n$secondary-bg-subtle-dark: $gray-900 !default;\n$success-bg-subtle-dark: $green-900 !default;\n$info-bg-subtle-dark: $cyan-900 !default;\n$warning-bg-subtle-dark: $yellow-900 !default;\n$danger-bg-subtle-dark: $red-900 !default;\n$light-bg-subtle-dark: $gray-800 !default;\n$dark-bg-subtle-dark: mix($gray-800, $black) !default;\n\n$primary-border-subtle-dark: $blue-700 !default;\n$secondary-border-subtle-dark: $gray-700 !default;\n$success-border-subtle-dark: $green-700 !default;\n$info-border-subtle-dark: $cyan-800 !default;\n$warning-border-subtle-dark: $yellow-800 !default;\n$danger-border-subtle-dark: $red-700 !default;\n$light-border-subtle-dark: $gray-700 !default;\n$dark-border-subtle-dark: $gray-800 !default;\n\n// 02. Body setting\n\n$body-font-weight-dark: 300 !default;\n$body-letter-spacing-dark: rem(0.75px) !default;\n$body-bg-dark: #1d2835 !default;\n$body-bg-gradient-dark: linear-gradient(180deg, rgba(9, 56, 45, 0.9) 0%, rgba(0, 7, 23, 1) 100%) !default;\n// $body-bg-cover-dark:                            url('images/cover-dark.jpg') !default;\n$body-bg-image-dark: url(\"images/pattern-dark.png\") !default;\n$body-bg-image-size-dark: rem(75px) !default;\n$body-color-dark: rgba($white, 1) !default;\n$body-emphasis-color-dark: $gray-100 !default;\n$body-secondary-color-dark: rgba($body-color-dark, 0.75) !default;\n$body-secondary-bg-dark: $gray-800 !default;\n$body-tertiary-color-dark: rgba($body-color-dark, 0.5) !default;\n$body-tertiary-bg-dark: rgba($body-color, 0.1) !default;\n$emphasis-color-dark: $white !default;\n\n// 03. Font & headings settings\n\n$headings-color-dark: #fff !default;\n$link-color-dark: $blue-300 !default;\n$link-hover-color-dark: $blue-200 !default;\n$code-color-dark: $pink-300 !default;\n\n// 04. Border settings\n\n$border-color-dark: rgba($white, 0.25) !default;\n$border-color-translucent-dark: rgba($white, 0.25) !default;\n\n// 05. Component settings\n\n$component-bg-dark: #28292b !default;\n$component-color-dark: $body-color-dark !default;\n\n// 06. App - Header settings\n\n$app-header-bg-dark: rgba(29, 40, 53, 0.5) !default;\n$app-header-brand-img-dark: url(\"images/logo-dark.png\") !default;\n$app-header-link-color-dark: $white !default;\n$app-header-link-hover-color-dark: rgba($white, 0.5) !default;\n$app-header-scroll-box-shadow-dark: null !default;\n\n// 07. App - Sidebar settings\n\n$app-sidebar-menu-header-color-dark: rgba(var(--#{$prefix}inverse-rgb), 0.5) !default;\n$app-sidebar-menu-link-color-dark: rgba(var(--#{$prefix}inverse-rgb), 0.8) !default;\n$app-sidebar-menu-link-hover-color-dark: $white !default;\n$app-sidebar-menu-link-active-color-dark: $white !default;\n$app-sidebar-mobile-bg-dark: rgba(44, 56, 70, 0.98) !default;\n\n// 08. App - Top Nav settings\n\n$app-top-nav-bg-dark: rgba(29, 40, 53, 0.95) !default;\n$app-top-nav-menu-link-color-dark: rgba(var(--#{$prefix}inverse-rgb), 0.5) !default;\n$app-top-nav-menu-link-hover-color-dark: $white !default;\n$app-top-nav-menu-link-active-color-dark: $white !default;\n$app-top-nav-menu-submenu-bg-dark: rgba(29, 40, 53, 0.95) !default;\n\n// 08. App - Theme panel settings\n\n$app-theme-panel-bg-dark: rgba($gray-700, 0.95) !default;\n$app-theme-panel-color-dark: $white !default;\n\n// 09. Form switch settings\n\n$form-switch-color-dark: rgba($white, 0.25) !default;\n$form-switch-bg-image-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-dark}'/></svg>\") !default;\n$form-switch-focus-color-dark: rgba($white, 0.25) !default;\n$form-switch-focus-bg-image-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color-dark}'/></svg>\") !default;\n$form-switch-checked-color-dark: $black !default;\n$form-switch-checked-bg-image-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color-dark}'/></svg>\") !default;\n\n// 10. Form select settings\n\n$form-select-indicator-color-dark: $body-color-dark !default;\n$form-select-indicator-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n// 11. Form check settings\n\n$form-check-input-checked-color-dark: $black !default;\n$form-check-input-checked-bg-image-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color-dark}'/></svg>\") !default;\n\n// 12. Accordion settings\n\n$accordion-button-icon-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$body-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$body-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n// 13. Modal settings\n\n$modal-backdrop-bg-dark: #1d2835 !default;\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.2 (https://getbootstrap.com/)\n   * Copyright 2011-2023 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","[data-bs-theme=\"light\"] {\n\t.border-white {\n\t\tborder-color: #000 !important;\n\t}\n\n\t.text-white {\n\t\tcolor: #000 !important;\n\t}\n\n\t.border-black {\n\t\tborder-color: #fff !important;\n\t}\n\n\t.text-black {\n\t\tcolor: #fff !important;\n\t}\n\n\tbody .react-select__control,\n\t.form-control,\n\t.form-select {\n\t\tbackground-color: #fff;\n\t}\n\n\tbody .react-select__control .react-select__value-container .react-select__input-container {\n\t\tcolor: #000;\n\t}\n\n\t.table {\n\t\tbackground: #fff;\n\t}\n\n\t.tree {\n\t\tborder-color: rgb(0 0 0 / 30%);\n\t}\n\n\t.tree li a {\n\t\tcolor: black;\n\t\tborder-color: rgb(0 0 0 / 30%);\n\t}\n\n\t.disaster-page {\n\t\tbackground: linear-gradient(180deg, #ff8d8d -190%, rgb(255 255 255) 90%) !important;\n\t}\n\n\t.breaking-news {\n\t\ta {\n\t\t\tcolor: #000;\n\n\t\t\tp {\n\t\t\t\tbackground: rgba(0, 0, 0, 0.02);\n\t\t\t}\n\t\t}\n\t}\n\n\t.map-info-container {\n\t\tbackground: rgb(255 255 255 / 90%) !important;\n\t}\n\n\t.graphic-events .graphic-events-dropdown {\n\t\tbackground: white;\n\t\tbox-shadow: 0px 3px 5px rgb(0 0 0 / 10%);\n\t}\n\n\t.file-progress-card {\n\t\tbackground: white;\n\t}\n\n\t.popover-content {\n\t\tbackground: white;\n\t}\n}\n\n[data-bs-theme=\"dark\"] {\n\t.ck-reset_all :not(.ck-reset_all-excluded *),\n\t.ck.ck-reset_all {\n\t\tcolor: #fff !important;\n\t}\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n\t--#{$prefix}body-bg-gradient: #{$body-bg-gradient};\n\t--#{$prefix}body-bg-image: #{$body-bg-image};\n\t--#{$prefix}body-bg-image-size: #{$body-bg-image-size};\n\t// --#{$prefix}body-bg-cover: #{$body-bg-cover};\n\t--#{$prefix}body-font-weight: #{$body-font-weight};\n\t--#{$prefix}body-letter-spacing: #{$body-letter-spacing};\n\t--#{$prefix}component-bg: #{$component-bg};\n\t--#{$prefix}component-bg-rgb: #{to-rgb($component-bg)};\n\t--#{$prefix}component-color: #{$component-color};\n\t--#{$prefix}component-color-rgb: #{to-rgb($component-color)};\n\t--#{$prefix}app-header-bg: #{$app-header-bg};\n\t--#{$prefix}app-header-brand-img: #{$app-header-brand-img};\n\t--#{$prefix}app-header-link-color: #{$app-header-link-color};\n\t--#{$prefix}app-header-link-color-rgb: #{to-rgb($app-header-link-color)};\n\t--#{$prefix}app-header-link-hover-color: #{$app-header-link-hover-color};\n\t--#{$prefix}app-header-scroll-box-shadow: #{$app-header-scroll-box-shadow};\n\t--#{$prefix}app-sidebar-menu-header-color: #{$app-sidebar-menu-header-color};\n\t--#{$prefix}app-sidebar-menu-link-color: #{$app-sidebar-menu-link-color};\n\t--#{$prefix}app-sidebar-menu-link-hover-color: #{$app-sidebar-menu-link-hover-color};\n\t--#{$prefix}app-sidebar-menu-link-active-color: #{$app-sidebar-menu-link-active-color};\n\t--#{$prefix}app-sidebar-mobile-bg: #{$app-sidebar-mobile-bg};\n\t--#{$prefix}app-top-nav-bg: #{$app-top-nav-bg};\n\t--#{$prefix}app-top-nav-menu-link-color: #{$app-top-nav-menu-link-color};\n\t--#{$prefix}app-top-nav-menu-link-hover-color: #{$app-top-nav-menu-link-hover-color};\n\t--#{$prefix}app-top-nav-menu-link-active-color: #{$app-top-nav-menu-link-active-color};\n\t--#{$prefix}app-top-nav-menu-submenu-bg: #{$app-top-nav-menu-submenu-bg};\n\t--#{$prefix}app-theme-panel-bg: #{$app-theme-panel-bg};\n\t--#{$prefix}theme-bg-subtle: #{tint-color($theme, 80%)};\n\t--#{$prefix}dark2: #dadada;\n\t--#{$prefix}dark3: #f2f2f2;\n\t--#{$prefix}dark4: #fefefe;\n\t--#{$prefix}dark5: #65656596;\n}\n\n@if $enable-dark-mode {\n\t@include color-mode(dark, true) {\n\t\t--#{$prefix}body-bg-gradient: #{$body-bg-gradient-dark};\n\t\t--#{$prefix}body-bg-image: #{$body-bg-image-dark};\n\t\t--#{$prefix}body-bg-image-size: #{$body-bg-image-size-dark};\n\t\t// --#{$prefix}body-bg-cover: #{$body-bg-cover-dark};\n\t\t--#{$prefix}body-font-weight: #{$body-font-weight-dark};\n\t\t--#{$prefix}body-letter-spacing: #{$body-letter-spacing-dark};\n\t\t--#{$prefix}component-bg: #{$component-bg-dark};\n\t\t--#{$prefix}component-bg-rgb: #{to-rgb($component-bg-dark)};\n\t\t--#{$prefix}component-color: #{$component-color-dark};\n\t\t--#{$prefix}component-color-rgb: #{to-rgb($component-color-dark)};\n\t\t--#{$prefix}app-header-bg: #{$app-header-bg-dark};\n\t\t--#{$prefix}app-header-brand-img: #{$app-header-brand-img-dark};\n\t\t--#{$prefix}app-header-link-color: #{$app-header-link-color-dark};\n\t\t--#{$prefix}app-header-link-color-rgb: #{to-rgb($app-header-link-color-dark)};\n\t\t--#{$prefix}app-header-link-hover-color: #{$app-header-link-hover-color-dark};\n\t\t--#{$prefix}app-header-scroll-box-shadow: #{$app-header-scroll-box-shadow-dark};\n\t\t--#{$prefix}app-sidebar-menu-header-color: #{$app-sidebar-menu-header-color-dark};\n\t\t--#{$prefix}app-sidebar-menu-link-color: #{$app-sidebar-menu-link-color-dark};\n\t\t--#{$prefix}app-sidebar-menu-link-hover-color: #{$app-sidebar-menu-link-hover-color-dark};\n\t\t--#{$prefix}app-sidebar-menu-link-active-color: #{$app-sidebar-menu-link-active-color-dark};\n\t\t--#{$prefix}app-sidebar-mobile-bg: #{$app-sidebar-mobile-bg-dark};\n\t\t--#{$prefix}app-top-nav-bg: #{$app-top-nav-bg-dark};\n\t\t--#{$prefix}app-top-nav-menu-link-color: #{$app-top-nav-menu-link-color-dark};\n\t\t--#{$prefix}app-top-nav-menu-link-hover-color: #{$app-top-nav-menu-link-hover-color-dark};\n\t\t--#{$prefix}app-top-nav-menu-link-active-color: #{$app-top-nav-menu-link-active-color-dark};\n\t\t--#{$prefix}app-top-nav-menu-submenu-bg: #{$app-top-nav-menu-submenu-bg-dark};\n\t\t--#{$prefix}app-theme-panel-bg: #{$app-theme-panel-bg-dark};\n\t\t--#{$prefix}theme-bg-subtle: #{shade-color($theme, 80%)};\n\t\t--#{$prefix}dark2: #0f131f;\n\t\t--#{$prefix}dark3: #1d2835;\n\t\t--#{$prefix}dark4: #141b24;\n\t\t--#{$prefix}dark5: #141b2496;\n\t}\n}\n","html {\n\theight: 100%;\n\t// &:before {\n\t// \tcontent: \"\";\n\t// \tposition: fixed;\n\t// \ttop: 0;\n\t// \tleft: 0;\n\t// \tright: 0;\n\t// \theight: 100%;\n\t// \tz-index: -5;\n\t// \tbackground: var(--#{$prefix}body-bg-gradient);\n\t// }\n\t&:after {\n\t\t// content: '';\n\t\t// position:fixed;\n\t\t// top:0;\n\t\t// height:100%;\n\t\t// left:0;\n\t\t// right:0;\n\t\t// z-index:-10;\n\t\t// background-color: var(--#{$prefix}body-bg);\n\t\t// background-image: var(--#{$prefix}body-bg-gradient);\n\t\t// background-image: var(--#{$prefix}body-bg-cover);\n\t\t// background-repeat: no-repeat;\n\t\t// background-position: center;\n\t\t// background-attachment: initial;\n\t\t// height: 100%;\n\t\t// transition: background .2s linear;\n\t\t// background-size: cover;\n\t}\n}\n\n[data-bs-theme=\"light\"] {\n\t.app {\n\t\tbackground: #eee;\n\t}\n}\n\n[data-bs-theme=\"dark\"] {\n\t.app {\n\t\tbackground: linear-gradient(180deg, var(--#{$prefix}theme) -190%, rgba(0, 7, 23, 1) 90%);\n\t}\n}\n\nbody {\n\tbackground: none;\n\tfont-weight: var(--#{$prefix}body-font-weight);\n\tletter-spacing: var(--#{$prefix}body-letter-spacing);\n\tposition: relative;\n\tmin-height: 100vh;\n\tz-index: 9999;\n\toverflow-x: hidden;\n\n\t@if ($enable-rtl) {\n\t\tdirection: rtl;\n\t}\n\n\t&:before {\n\t\tcontent: \"\";\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\theight: 100%;\n\t\tbackground-attachment: initial;\n\t\tbackground-color: transparent;\n\t\t// background-image: var(--#{$prefix}body-bg-image);\n\t\tbackground-size: var(--#{$prefix}body-bg-image-size);\n\t\tbackground-repeat: repeat;\n\t\tbackground-attachment: initial;\n\t\tz-index: -5;\n\t}\n\n\t&:not(.app-init) * {\n\t\t// transition: none !important;\n\t\t// animation: none !important;\n\t}\n}\n\nstrong {\n\tfont-weight: bold;\n}\n\n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar {\n\tbackground: var(--bs-dark4) !important;\n\tborder-color: rgba(255, 255, 255, 0.25) !important;\n}\n\n.ck.ck-editor__main > .ck-editor__editable {\n\tbackground: #fff0 !important;\n\tmin-height: 200px !important;\n}\n\n.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {\n\tborder-color: rgba(255, 255, 255, 0.25) !important;\n}\n\n.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {\n\tborder-color: #fff !important;\n}\n\n.ck.ck-button.ck-on,\na.ck.ck-button.ck-on {\n\tcolor: #fff !important;\n\tbackground: var(--#{$prefix}theme) !important;\n}\n\n.ck.ck-button.ck-on:not(.ck-disabled):hover,\na.ck.ck-button.ck-on:not(.ck-disabled):hover {\n\tbackground: var(--#{$prefix}theme) !important;\n}\n\n.ck.ck-button:not(.ck-disabled):hover,\na.ck.ck-button:not(.ck-disabled):hover {\n\tbackground: var(--#{$prefix}theme) !important;\n}\n\n.ck.ck-dropdown__panel,\n.ck.ck-list {\n\tbackground: var(--#{$prefix}dark4) !important;\n}\n\n.ck.ck-list__item .ck-button:hover:not(.ck-disabled) {\n\tbackground: var(--#{$prefix}theme) !important;\n}\n\n.ck.ck-list__item .ck-button.ck-on {\n\tbackground: #1f9b76 !important;\n}\n\n.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled) {\n\tbackground: var(--#{$prefix}theme) !important;\n}\n","/* Helper Margin */\n@include helper-spacing(\"\", \"margin\", \"m\");\n@include helper-spacing(\"top\", \"margin\", \"mt\");\n@include helper-spacing(\"right\", \"margin\", \"me\");\n@include helper-spacing(\"bottom\", \"margin\", \"mb\");\n@include helper-spacing(\"left\", \"margin\", \"ms\");\n@include helper-spacing(\"mx\", \"margin\", \"mx\");\n@include helper-spacing(\"my\", \"margin\", \"my\");\n\n/* Helper Padding */\n@include helper-spacing(\"\", \"padding\", \"p\");\n@include helper-spacing(\"top\", \"padding\", \"pt\");\n@include helper-spacing(\"right\", \"padding\", \"pe\");\n@include helper-spacing(\"bottom\", \"padding\", \"pb\");\n@include helper-spacing(\"left\", \"padding\", \"ps\");\n@include helper-spacing(\"px\", \"padding\", \"px\");\n@include helper-spacing(\"py\", \"padding\", \"py\");\n\n/* Helper Font */\n@include helper-font-size(0, 80);\n@include helper-font-weight(1, 8);\n\n/* Helper Position Direction */\n.top-0 {\n\ttop: 0 !important;\n}\n.bottom-0 {\n\tbottom: 0 !important;\n}\n.start-0 {\n\tleft: 0 !important;\n}\n.end-0 {\n\tright: 0 !important;\n}\n.top-auto {\n\ttop: auto !important;\n}\n.bottom-auto {\n\tbottom: auto !important;\n}\n.start-auto {\n\tleft: auto !important;\n}\n.end-auto {\n\tright: auto !important;\n}\n\n/* Helper Text */\n.text-underline {\n\ttext-decoration: underline !important;\n}\n.text-gradient {\n\t-webkit-background-clip: text !important;\n\t-webkit-text-fill-color: transparent !important;\n}\n.line-height-1 {\n\tline-height: 1 !important;\n}\n\n/* Helper Size */\n@include helper-size(\"w\", \"width\");\n@include helper-size(\"h\", \"height\");\n\n/* Helper Color */\n@each $color, $value in $theme-colors {\n\t@include helper-color($color, $value);\n}\n@each $color, $value in $colors {\n\t@include helper-color($color, $value);\n}\n\n@if $enable-dark-mode {\n\t@include color-mode(dark, true) {\n\t\t@each $color, $value in $theme-colors-dark {\n\t\t\t--#{$prefix}#{$color}: #{$value};\n\t\t\t--#{$prefix}#{$color}-rgb: #{to-rgb($value)};\n\n\t\t\t@include helper-color-dark($color, $value);\n\t\t}\n\t}\n}\n.bg-none {\n\tbackground: none !important;\n}\n.bg-position-center {\n\tbackground-position: center !important;\n}\n.bg-size-cover {\n\tbackground-size: cover !important;\n}\n.bg-repeat-no-repeat {\n\tbackground-repeat: no-repeat !important;\n}\n@include background-gradient(\"bg-gradient-orange-red\", lighten($orange, 10%), lighten($red, 10%));\n@include background-gradient(\"bg-gradient-red-orange\", lighten($red, 10%), lighten($orange, 10%));\n@include background-gradient(\"bg-gradient-red-pink\", lighten($red, 10%), lighten($pink, 10));\n@include background-gradient(\"bg-gradient-yellow-orange\", lighten($yellow, 10%), lighten($orange, 10%));\n@include background-gradient(\"bg-gradient-yellow-red\", lighten($yellow, 10%), lighten($red, 10%));\n@include background-gradient(\"bg-gradient-yellow-green\", lighten($yellow, 10%), lighten($green, 10%));\n@include background-gradient(\"bg-gradient-blue-indigo\", $blue, $indigo);\n@include background-gradient(\"bg-gradient-blue-cyan\", $blue, $cyan);\n@include background-gradient(\"bg-gradient-cyan-blue\", $cyan, $blue);\n@include background-gradient(\"bg-gradient-cyan-indigo\", $cyan, $indigo);\n@include background-gradient(\"bg-gradient-indigo-blue\", $indigo, $blue);\n@include background-gradient(\n\t\"bg-gradient-custom-orange\",\n\tlighten(mix($pink, $orange, 50%), 6%),\n\tlighten(mix($pink, $orange, 50%), 13%),\n\tright\n);\n@include background-gradient(\n\t\"bg-gradient-custom-pink\",\n\tlighten(mix($black, $pink, 20%), 14%),\n\tlighten(mix($black, $pink, 20%), 21%),\n\tright\n);\n@include background-gradient(\"bg-gradient-custom-teal\", mix($black, $teal, 18%), $teal, right);\n@include background-gradient(\n\t\"bg-gradient-custom-indigo\",\n\tlighten(mix($black, $indigo, 5%), 14%),\n\tlighten(mix($black, $indigo, 5%), 25%),\n\tright\n);\n@include background-gradient(\"bg-gradient-custom-blue\", $blue, lighten($blue, 10%), right);\n.bg-gradient-indigo-teal {\n\tbackground-image: linear-gradient(to left, $indigo, $blue, $teal) !important;\n}\n@if $enable-dark-mode {\n\t@include color-mode(dark, true) {\n\t\t.invert-dark {\n\t\t\tfilter: invert(1);\n\t\t}\n\t}\n}\n\n/* Helper Opacity */\n@include helper-opacity(0, 10);\n\n/* Helper Sticky Top */\n.desktop-sticky-top {\n\t@include media-breakpoint-up(xl) {\n\t\tposition: sticky;\n\t\ttop: $app-header-height + rem(20px);\n\t}\n}\n\n/* Helper Outline */\n.outline-none {\n\toutline: none !important;\n}\n\n// @for $i from 2 through 9 {\n// \t.bg-cover-#{$i}:after {\n// \t\tbackground-image: url(\"images/cover-#{$i}.jpg\");\n// \t}\n// \t.bg-cover-none:after {\n// \t\tbackground-color: var(--#{$prefix}body-bg);\n// \t}\n// \t@if $enable-dark-mode {\n// \t\t@include color-mode(dark, true) {\n// \t\t\t&.bg-cover-#{$i}:after {\n// \t\t\t\tbackground-image: url(\"images/cover-#{$i}-dark.jpg\");\n// \t\t\t}\n// \t\t}\n// \t}\n// }\n\n/* Helper Flex */\n.flex-1 {\n\tflex: 1 !important;\n}\n\n/* Helper Theme */\n.list-group-item.active,\n.page-item.active .page-link,\n.form-check-input:checked,\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n\tbackground-color: var(--#{$prefix}theme);\n\tborder-color: var(--#{$prefix}theme);\n}\n.btn-theme {\n\tbackground-color: var(--#{$prefix}theme);\n\tborder-color: var(--#{$prefix}theme);\n\tposition: relative;\n\n\t&:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: -1px;\n\t\tleft: -1px;\n\t\tright: -1px;\n\t\tbottom: -1px;\n\n\t\tborder-radius: $border-radius;\n\t\t@include transition($btn-transition);\n\t}\n\t&.disabled,\n\t&:disabled {\n\t\tbackground-color: var(--#{$prefix}theme);\n\t\tborder-color: var(--#{$prefix}theme);\n\t}\n\t&:hover,\n\t&:focus,\n\t&:active,\n\t&.active {\n\t\tbackground-color: var(--#{$prefix}theme);\n\t\tborder-color: var(--#{$prefix}theme);\n\n\t\t&:before {\n\t\t\tbackground: rgba($white, 0.2);\n\t\t}\n\t}\n\t&:focus,\n\t&:active,\n\t&.active:focus,\n\t&:active:focus {\n\t\t@include box-shadow(0 0 0 0.25rem rgba(#{var(--#{$prefix}theme-rgb)}, 0.5));\n\t}\n}\n.btn-outline-theme {\n\tcolor: var(--#{$prefix}theme);\n\tborder-color: var(--#{$prefix}theme);\n\n\t&:hover,\n\t&.active,\n\t&:active {\n\t\tbackground-color: var(--#{$prefix}theme) !important;\n\t\tborder-color: var(--#{$prefix}theme) !important;\n\t}\n\t&.disabled,\n\t&:disabled {\n\t\tcolor: var(--#{$prefix}theme);\n\t}\n\t&:focus,\n\t&:active,\n\t&.active:focus,\n\t&:active:focus {\n\t\t@include box-shadow(0 0 0 0.25rem rgba(#{var(--#{$prefix}theme-rgb)}, 0.5));\n\t}\n}\n.nav-link {\n\tcolor: var(--#{$prefix}theme);\n\n\t&:hover {\n\t\tcolor: rgba(#{var(--#{$prefix}theme-rgb)}, 0.5);\n\t}\n}\n","@mixin helper-spacing($direction, $classProperty, $className) {\n\t@for $i from 1 through 20 {\n\t\t$classInt: $i;\n\t\t$cssValue: rem($i);\n\t\t$cssProperty: $classProperty;\n\t\t\n\t\t@if ($direction == 'top') {\n\t\t\t$cssProperty: $classProperty + '-top';\n\t\t} @else if ($direction == 'right') {\n\t\t\t@if $enable-rtl {\n\t\t\t\t$cssProperty: $classProperty + '-left';\n\t\t\t} @else {\n\t\t\t\t$cssProperty: $classProperty + '-right';\n\t\t\t}\n\t\t} @else if ($direction == 'bottom') {\n\t\t\t$cssProperty: $classProperty + '-bottom';\n\t\t} @else if ($direction == 'left') {\n\t\t\t@if $enable-rtl {\n\t\t\t\t$cssProperty: $classProperty + '-right';\n\t\t\t} @else {\n\t\t\t\t$cssProperty: $classProperty + '-left';\n\t\t\t}\n\t\t}\n\t\t@if ($i <= 10) {\n\t\t\t$classInt: ($i) + px;\n\t\t\t$cssValue: $i + px;\n\t\t} @else if ($i > 10) {\n\t\t\t$classInt: (($i - 10) * 5) + px;\n\t\t\t$cssValue: (($i - 10) * 5) + px;\n\t\t}\n\t\t.#{$className}-#{$classInt} {\n\t\t\t@if ($direction == 'mx') {\n\t\t\t\tmargin-left: $cssValue !important;\n\t\t\t\tmargin-right: $cssValue !important;\n\t\t\t} @else if ($direction == 'my') {\n\t\t\t\tmargin-top: $cssValue !important;\n\t\t\t\tmargin-bottom: $cssValue !important;\n\t\t\t} @else if ($direction == 'px') {\n\t\t\t\tpadding-left: $cssValue !important;\n\t\t\t\tpadding-right: $cssValue !important;\n\t\t\t} @else if ($direction == 'py') {\n\t\t\t\tpadding-top: $cssValue !important;\n\t\t\t\tpadding-bottom: $cssValue !important;\n\t\t\t} @else {\n\t\t\t\t#{$cssProperty}: $cssValue !important;\n\t\t\t}\n\t\t}\n\t}\n}","@mixin helper-font-size($from, $to) {\n\t@for $i from $from through $to {\n\t\t.fs-#{$i}px {\n\t\t\tfont-size: $i + px !important;\n\t\t}\n\t}\n}","@mixin helper-font-weight($from, $to) {\n\t@for $i from $from through $to {\n\t\t$classValue: $i * 100;\n\t\t\n\t\t.fw-#{$classValue} {\n\t\t\tfont-weight: $classValue !important;\n\t\t}\n\t}\n}","@mixin helper-size($className, $classProperty) {\n\t@for $i from 1 through 40 {\n\t\t$classInt: $i * 5;\n\t\t\n\t\t.#{$className}-#{$classInt}px {\n\t\t\t#{$classProperty}: $classInt + px !important;\n\t\t}\n\t\t.#{$className}-#{$i}px {\n\t\t\t#{$classProperty}: $i + px !important;\n\t\t}\n\t}\n\t@for $i from 5 through 12 {\n\t\t$classInt: $i * 50;\n\t\t\n\t\t.#{$className}-#{$classInt}px {\n\t\t\t#{$classProperty}: $classInt + px !important;\n\t\t}\n\t}\n}","@mixin helper-color($color, $value) {\n  .bg-gradient-#{$color} {\n\t\tbackground-color: $value !important;\n\t\tbackground-image: -moz-linear-gradient(top, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tbackground-image: -webkit-linear-gradient(top, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tbackground-image: linear-gradient(to bottom, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)',GradientType=0 ) !important;\n  }\n  .border-#{$color} {\n  \t@if ($color == 'theme') {\n\t\t\tborder-color: var(--#{$prefix}theme) !important;\n  \t}\n  }\n  :root .theme-#{$color} {\n\t\t--#{$prefix}theme: #{$value} !important;\n\t\t--#{$prefix}theme-rgb: #{to-rgb($value)} !important;\n\t\t--#{$prefix}theme-color: #{color-contrast($value)} !important;\n\t\t--#{$prefix}theme-color-rgb: #{to-rgb(color-contrast($value))} !important;\n\t}\n\t@for $i from 1 through 4 {\n\t\t.text-#{$color}-#{$i * 100} {\n\t\t\t--#{$prefix}text-opacity: 1;\n\t\t\tcolor: rgba(tint-color($value, (100 - ($i * 20)) * 1%), var(--#{$prefix}text-opacity)) !important;\n\t\t}\n\t\t.bg-#{$color}-#{$i * 100} {\n\t\t\t--#{$prefix}bg-opacity: 1;\n\t\t\tbackground-color: rgba(tint-color($value, (100 - ($i * 20)) * 1%), var(--#{$prefix}bg-opacity)) !important;\n\t\t}\n\t\t.text-#{$color}-#{($i + 5) * 100} {\n\t\t\t--#{$prefix}text-opacity: 1;\n\t\t\tcolor: rgba(shade-color($value, ($i * 20) * 1%), var(--#{$prefix}text-opacity))  !important;\n\t\t}\n\t\t.bg-#{$color}-#{($i + 5) * 100} {\n\t\t\t--#{$prefix}bg-opacity: 1;\n\t\t\tbackground-color: rgba(shade-color($value, ($i * 20) * 1%), var(--#{$prefix}bg-opacity)) !important;\n\t\t}\n  }\n}","@mixin helper-color-dark($color, $value) {\n\t& .bg-gradient-#{$color} {\n\t\tbackground-color: $value !important;\n\t\tbackground-image: -moz-linear-gradient(top, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tbackground-image: -webkit-linear-gradient(top, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tbackground-image: linear-gradient(to bottom, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)',GradientType=0 ) !important;\n\t}\n\t& .border-#{$color} {\n\t\t@if ($color == 'theme') {\n\t\t\tborder-color: var(--#{$prefix}theme) !important;\n\t\t}\n\t}\n\t& .theme-#{$color} {\n\t\t--#{$prefix}theme: #{$value} !important;\n\t\t--#{$prefix}theme-rgb: #{to-rgb($value)} !important;\n\t\t--#{$prefix}theme-color: #{color-contrast($value)} !important;\n\t\t--#{$prefix}theme-color-rgb: #{to-rgb(color-contrast($value))} !important;\n\t}\n\t@for $i from 1 through 4 {\n\t\t& .text-#{$color}-#{$i * 100} {\n\t\t\t--#{$prefix}text-opacity: 1;\n\t\t\tcolor: rgba(tint-color($value, (100 - ($i * 20)) * 1%), var(--#{$prefix}text-opacity)) !important;\n\t\t}\n\t\t.bg-#{$color}-#{$i * 100} {\n\t\t\t--#{$prefix}bg-opacity: 1;\n\t\t\tbackground-color: rgba(tint-color($value, (100 - ($i * 20)) * 1%), var(--#{$prefix}bg-opacity)) !important;\n\t\t}\n\t\t.text-#{$color}-#{($i + 5) * 100} {\n\t\t\t--#{$prefix}text-opacity: 1;\n\t\t\tcolor: rgba(shade-color($value, ($i * 20) * 1%), var(--#{$prefix}text-opacity))  !important;\n\t\t}\n\t\t.bg-#{$color}-#{($i + 5) * 100} {\n\t\t\t--#{$prefix}bg-opacity: 1;\n\t\t\tbackground-color: rgba(shade-color($value, ($i * 20) * 1%), var(--#{$prefix}bg-opacity)) !important;\n\t\t}\n\t}\n}","@mixin background-gradient($className, $from, $to, $direction: top) {\n\t.#{$className} {\n\t\tbackground: $from;\n\t}\n\t.#{$className} {\n\t\tbackground: -moz-linear-gradient($direction, $from, $to) !important;\n\t\tbackground: -webkit-linear-gradient($direction, $from, $to) !important;\n\t    @if $direction == top {\n\t\t    background: linear-gradient(to top, $from, $to) !important;\n\t    } @else if $direction == right {\n\t\t    background: linear-gradient(to left, $from, $to) !important;\n\t    } @else if $direction == left {\n\t\t    background: linear-gradient(to right, $from, $to) !important;\n\t    } @else if $direction == bottom {\n\t\t    background: linear-gradient(to bottom, $from, $to) !important;\n\t    }\n\t\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$from', endColorstr='$to',GradientType=0 ) !important;\n\t}\n}\n","@mixin helper-opacity($from, $to) {\n\t@for $i from $from through $to {\n\t\t.opacity-#{$i} {\n\t\t\topacity: #{$i * 0.1} !important;\n\t\t}\n\t\t.opacity-#{$i * 15} {\n\t\t\topacity: #{$i * 0.15} !important;\n\t\t}\n\t\t.text-opacity-#{$i * 10} {\n\t\t\t--#{$prefix}text-opacity: #{$i * 0.1};\n\t\t}\n\t\t.text-opacity-#{($i * 10) + 5} {\n\t\t\t--#{$prefix}text-opacity: #{($i * 0.1) + 0.05};\n\t\t}\n\t\t.bg-opacity-#{$i * 10} {\n\t\t\t--#{$prefix}bg-opacity: #{$i * 0.1};\n\t\t}\n\t\t.bg-opacity-#{($i * 10) + 5} {\n\t\t\t--#{$prefix}bg-opacity: #{($i * 0.1) + 0.05};\n\t\t}\n\t}\n}",".app-content {\n\tpadding: $app-content-padding-y $app-content-padding-x 0;\n\tmin-height: 100vh;\n\tposition: relative;\n\tmargin-left: 240px;\n\t// margin-left: 190px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t@include media-breakpoint-down(xl) {\n\t\tpadding: 140px 30px 100px;\n\t\tmargin-left: 0;\n\t}\n\n\t@include media-breakpoint-down(md) {\n\t\tpadding: 80px 12px 100px;\n\t\tmargin-left: 0;\n\t}\n\n\t& .app-content-inner-padding {\n\t\tpadding: $app-content-padding-y $app-content-padding-x;\n\n\t\t@include media-breakpoint-down(md) {\n\t\t\tpadding: $app-content-sm-padding-y $app-content-sm-padding-x;\n\t\t}\n\t}\n\t& .app-content-inner-padding-x {\n\t\tpadding-left: $app-content-padding-x;\n\t\tpadding-right: $app-content-padding-x;\n\n\t\t@include media-breakpoint-down(md) {\n\t\t\tpadding-left: $app-content-sm-padding-x;\n\t\t\tpadding-right: $app-content-sm-padding-x;\n\t\t}\n\t}\n\t& .app-content-inner-padding-y {\n\t\tpadding-top: $app-content-padding-y;\n\t\tpadding-bottom: $app-content-padding-y;\n\n\t\t@include media-breakpoint-down(md) {\n\t\t\tpadding-top: $app-content-sm-padding-y;\n\t\t\tpadding-bottom: $app-content-sm-padding-y;\n\t\t}\n\t}\n}\n",".app-footer {\n\tposition: relative;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: var(--bs-dark2);\n\tpadding: 12px 2rem;\n\tfont-weight: $font-weight-bold;\n\tcolor: var(--bs-heading-color);\n\tmargin-left: ($app-sidebar-width + $app-content-padding-x) - 2;\n    // margin: 0 -42px;\n\n\t&-full {\n\t\tmargin-left: 0;\n\t\ttext-align: center;\n\t\tbackground: none;\n\t\tborder: none;\n\t}\n\n\t@include media-breakpoint-down(xl) {\n\t\tmargin: 0;\n\t}\n\n\t@include media-breakpoint-down(md) {\n\t\tpadding: 12px;\n\t}\n}\n",".live-svg {\n\twidth: 47px;\n\tmargin-right: 8px;\n\tfilter: drop-shadow(0px 0px 3px var(--#{$prefix}theme));\n\tstroke-dasharray: 320;\n\tstroke-dashoffset: 320;\n\tanimation: liveAni 2s infinite both;\n}\n\n@keyframes liveAni {\n\t0% {\n\t\tstroke-dashoffset: 320;\n\t}\n\n\t100% {\n\t\tstroke-dashoffset: -320;\n\t}\n}\n\n.app-sidebar-collapsed {\n\t.app-header {\n\t\twidth: 3.875rem;\n\n\t\t.brand {\n\t\t\tpadding-left: 0;\n\n\t\t\t.brand-logo {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.app-header {\n\theight: $app-header-height;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: $app-sidebar-width;\n\tz-index: $app-header-zindex;\n\tbackground: var(--bs-dark3);\n\tdisplay: flex;\n\ttransition: all 0.15s ease-in-out;\n\n\t& .menu-toggler {\n\t\tborder: none;\n\t\tbackground: none;\n\t\theight: 100%;\n\t\tpadding: $spacer * 0.5 $spacer;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\n\t\t& .bar {\n\t\t\twidth: rem(26px);\n\t\t\tdisplay: block;\n\t\t\theight: 1px;\n\t\t\tbackground: rgba(var(--#{$prefix}app-header-link-color-rgb), 0.4);\n\t\t\ttransition: all 0.2s linear;\n\n\t\t\t& + .bar {\n\t\t\t\tmargin-top: rem(4px);\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t& .bar {\n\t\t\t\tbackground: rgba(var(--#{$prefix}app-header-link-color-rgb), 0.75);\n\t\t\t}\n\t\t}\n\t}\n\t& .mobile-toggler {\n\t\theight: 100%;\n\t\tdisplay: none;\n\n\t\t@include media-breakpoint-down(xl) {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\t& .desktop-toggler {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t@include media-breakpoint-down(md) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .brand {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\t// padding-left: $spacer;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\twhite-space: nowrap;\n\n\t\t@include media-breakpoint-down(xl) {\n\t\t\tjustify-content: flex-start;\n\t\t}\n\n\t\t& .brand-logo {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--#{$prefix}app-header-link-color);\n\t\t\tfont-size: $font-size-base * 1.05;\n\t\t\tletter-spacing: 2px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center !important;\n\n\t\t\t@include media-breakpoint-down(xl) {\n\t\t\t\twidth: auto !important;\n\t\t\t\tgap: 10px;\n\t\t\t}\n\n\t\t\t.card {\n\t\t\t\tpadding: 2px 7px;\n\t\t\t\tmargin-left: 2px;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tfont-size: 12px;\n\n\t\t\t\t&:not(.border-0):before,\n\t\t\t\t&:not(.border-0):after {\n\t\t\t\t\tborder-color: rgba(var(--bs-border-color-rgb), 0.7);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.card .card-arrow-top-left:before,\n\t\t\t.card .card-arrow-top-right:before,\n\t\t\t.card .card-arrow-bottom-left:before,\n\t\t\t.card .card-arrow-bottom-right:before {\n\t\t\t\twidth: 1px;\n\t\t\t\theight: 6px;\n\t\t\t}\n\n\t\t\t.card .card-arrow-top-left:after,\n\t\t\t.card .card-arrow-top-right:after,\n\t\t\t.card .card-arrow-bottom-left:after,\n\t\t\t.card .card-arrow-bottom-right:after {\n\t\t\t\theight: 1px;\n\t\t\t}\n\n\t\t\t.brand-text {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t}\n\n\t\t\t& img {\n\t\t\t\tmax-width: 100%;\n\t\t\t\tmax-height: 100%;\n\n\t\t\t\t// @if $enable-rtl {\n\t\t\t\t// \tmargin-left: $spacer;\n\t\t\t\t// } @else {\n\t\t\t\t// \tmargin-right: $spacer;\n\t\t\t\t// }\n\t\t\t}\n\t\t\t& .brand-img {\n\t\t\t\twidth: rem(26px);\n\t\t\t\theight: rem(26px);\n\t\t\t\tbackground: var(--#{$prefix}app-header-brand-img);\n\t\t\t\tbackground-size: cover;\n\t\t\t\tbackground-position: center;\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t}\n\n\t\t\t\t& .brand-img-text {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tletter-spacing: initial;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tfont-size: $font-size-base * 1.2;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .menu {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t\tflex: 1;\n\n\t\t& .menu-item {\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t& .menu-link {\n\t\t\t\ttext-decoration: none;\n\t\t\t\tcolor: var(--#{$prefix}app-header-link-color);\n\t\t\t\tposition: relative;\n\t\t\t\tpadding: $spacer * 0.5 $spacer;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t& .menu-img {\n\t\t\t\t\twidth: rem(32px);\n\t\t\t\t\theight: rem(32px);\n\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-left: $spacer * 0.75;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-right: $spacer * 0.75;\n\t\t\t\t\t}\n\n\t\t\t\t\t& img {\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t\tmax-height: 100%;\n\t\t\t\t\t\tborder-radius: 30px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .menu-icon {\n\t\t\t\t\tfont-size: rem(20px);\n\t\t\t\t}\n\t\t\t\t& .menu-badge {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\twidth: 6px;\n\t\t\t\t\theight: 6px;\n\t\t\t\t\ttop: rem(8px);\n\t\t\t\t\tborder-radius: 6px;\n\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tleft: $spacer;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tright: $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .menu-search {\n\t\tposition: absolute;\n\t\ttop: $app-header-height * -1;\n\t\tleft: 0;\n\t\tright: 0;\n\t\theight: $app-header-height;\n\t\tbackground: var(--#{$prefix}app-header-bg);\n\t\ttransition: all 0.2s ease-in-out;\n\n\t\t& .menu-search-container {\n\t\t\tmax-width: $app-header-search-max-width;\n\t\t\tmargin: 0 auto;\n\t\t\theight: $app-header-height;\n\t\t\tdisplay: flex;\n\n\t\t\t& .menu-search-icon {\n\t\t\t\tpadding: 0 $spacer;\n\t\t\t\tfont-size: $font-size-base * 1.2;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t& .bi {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& a {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}app-header-link-color-rgb), 0.5);\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\ttransition: all 0.2s linear;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--#{$prefix}app-header-link-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .menu-search-input {\n\t\t\t\tflex: 1;\n\n\t\t\t\t& .form-control {\n\t\t\t\t\tborder: none;\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tbox-shadow: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.app-header-menu-search-toggled & {\n\t\t\ttop: 0;\n\t\t}\n\t}\n\n\t@include media-breakpoint-down(xl) {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tbackground: var(--bs-dark3);\n\t}\n}\n\n#header.app-header {\n\theight: 110px;\n\n\t.brand .brand-logo {\n\t\theight: 100%;\n\n\t\timg {\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n\n#sidebar.app-sidebar {\n\ttop: 110px;\n}\n\n@media screen and (max-width: 1199px) {\n\tdiv#sidebar:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tbackground: var(--bs-dark4);\n\t\topacity: 0.8;\n\t\tpointer-events: none;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t#header.app-header {\n\t\theight: 60px;\n\t}\n\t\n\t#sidebar.app-sidebar {\n\t\ttop: 60px;\n\t}\n}",".app-sidebar-mobile-backdrop {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: $app-sidebar-mobile-backdrop-zindex;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 0;\n\tborder: 0;\n\tmargin: 0;\n\toutline: none;\n\tdisplay: none;\n\tbackground: $app-sidebar-mobile-backdrop-bg;\n}","@keyframes appSidebarSubMenuSlideInRight {\n\tto {\n\t\ttransform: translate3d(0, 0, 0);\n\t}\n}\n\n.app-sidebar-button {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\ttransform: translate(90%, 0px);\n\topacity: 0;\n\tvisibility: hidden;\n\tpointer-events: none;\n\tbackground: var(--bs-dark3);\n\tcursor: pointer;\n\tpadding: 5px;\n\ttransition: 0.2s;\n}\n\n.app-sidebar {\n\twidth: $app-sidebar-width;\n\tbackground: var(--#{$prefix}app-header-bg);\n\tbottom: 0;\n\tposition: fixed;\n\ttop: $app-header-height;\n\tz-index: $app-sidebar-zindex;\n\ttransition: all 0.15s ease-in-out;\n\n\t&:hover {\n\t\t.app-sidebar-button {\n\t\t\ttransform: translate(100%, 0px);\n\t\t\topacity: 1;\n\t\t\tvisibility: visible;\n\t\t\tpointer-events: all;\n\t\t}\n\t}\n\n\t@if $enable-rtl {\n\t\tright: 0;\n\t} @else {\n\t\tleft: 0;\n\t}\n\n\t@include media-breakpoint-down(xl) {\n\t\tbackground: var(--bs-dark3);\n\t\ttransform: translate(-100%, 0px);\n\t}\n\n\t& .slimScrollDiv {\n\t\twidth: 100% !important;\n\n\t\t& .slimScrollBar,\n\t\t& .slimScrollRail {\n\t\t\tdisplay: none !important;\n\t\t}\n\t}\n\n\t.menu-footer {\n\t\tbackground: var(--bs-dark3);\n\t}\n\n\t& .app-sidebar-content {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t& .menu {\n\t\t\tposition: relative;\n\t\t\tflex: 1;\n\t\t\toverflow-y: auto;\n\t\t\toverflow-x: hidden;\n\t\t\tpadding: 10px 0;\n\n\t\t\t& .menu-header {\n\t\t\t\tpadding: $spacer $spacer $spacer * 0.5;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tcolor: var(--bs-body-color);\n\t\t\t}\n\t\t\t& .menu-item {\n\t\t\t\t> div {\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\t> .menu-item-events {\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\tvisibility: visible;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.menu-item-events {\n\t\t\t\t\topacity: 0;\n\t\t\t\t\tvisibility: hidden;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 0px;\n\t\t\t\t\ttransform: translate(0px, -50%);\n\t\t\t\t\tz-index: 1;\n\t\t\t\t}\n\n\t\t\t\t& .menu-link {\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding: $spacer * 0.3 $spacer;\n\t\t\t\t\tcolor: var(--#{$prefix}app-sidebar-menu-link-color);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\ttransition: all 0.2s ease-in-out;\n\n\t\t\t\t\t& .menu-icon {\n\t\t\t\t\t\twidth: rem(30px);\n\t\t\t\t\t\theight: rem(30px);\n\t\t\t\t\t\tfont-size: $font-size-base * 1.2;\n\t\t\t\t\t\tmargin: rem(-4px) 0;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\tmargin-left: -4px;\n\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tmargin-left: $spacer * 0.75;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tmargin-right: $spacer * 0.75;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .menu-caret {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t\tb {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .menu-text {\n\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tcolor: var(--#{$prefix}app-sidebar-menu-link-hover-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .menu-submenu {\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tdisplay: none;\n\t\t\t\t\tpadding: 0 0 $spacer;\n\n\t\t\t\t\t& .menu-item {\n\t\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-right: rem(42px);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-left: rem(42px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t&:not(.has-sub) > .menu-link {\n\t\t\t\t\t\tcolor: var(--#{$prefix}app-sidebar-menu-link-active-color);\n\t\t\t\t\t}\n\t\t\t\t\t& > .menu-link {\n\t\t\t\t\t\t& .menu-icon {\n\t\t\t\t\t\t\tcolor: $app-sidebar-menu-link-icon-active-color;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.has-sub {\n\t\t\t\t\t\t& > .menu-submenu {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.expand {\n\t\t\t\t\t& > .menu-submenu {\n\t\t\t\t\t\tdisplay: block;\n\n\t\t\t\t\t\t& > .menu-item {\n\t\t\t\t\t\t\tanimation: appSidebarSubMenuSlideInRight 0.3s both cubic-bezier(0.7, 0, 0.3, 1);\n\n\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\ttransform: translate3d(100%, 0, 0);\n\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\ttransform: translate3d(-100%, 0, 0);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t@for $i from 2 through 50 {\n\t\t\t\t$time: 15 + (15 * $i);\n\t\t\t\t$delay: $time * 1ms;\n\n\t\t\t\t& .collapse.expand > .menu-item,\n\t\t\t\t& .menu-item > .menu-submenu > .menu-item {\n\t\t\t\t\t&:nth-child(#{$i}) {\n\t\t\t\t\t\tanimation-delay: $delay;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .app-sidebar-mobile-backdrop {\n\t\tdisplay: none;\n\t}\n\t&.uppercase-mode {\n\t\ttext-transform: uppercase;\n\n\t\t& .app-sidebar-content {\n\t\t\t& .menu {\n\t\t\t\t& .menu-item {\n\t\t\t\t\t& .menu-link {\n\t\t\t\t\t\tfont-size: $font-size-base * 0.95;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n","$theme-panel-width: $spacer * 4;\n.app-theme-list {\n\tmargin: $spacer * -0.25;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex-wrap: wrap;\n\n\t& .app-theme-list-item {\n\t\tpadding: $spacer * 0.25;\n\n\t\t& .app-theme-list-link {\n\t\t\twidth: rem(32px);\n\t\t\theight: rem(32px);\n\t\t\tdisplay: block;\n\t\t\ttext-decoration: none;\n\t\t\tposition: relative;\n\t\t\ttransition: all 0.2s linear;\n\n\t\t\t&:hover {\n\t\t\t\topacity: 0.6;\n\t\t\t}\n\t\t}\n\t\t&.active {\n\t\t\t& .app-theme-list-link {\n\t\t\t\topacity: 1;\n\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: \"\\f00c\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tfont-size: rem(14px);\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.app-theme-panel {\n\tposition: fixed;\n\ttop: 50%;\n\tbottom: 0;\n\tz-index: $app-header-zindex + 10;\n\tdisplay: flex;\n\talign-items: center;\n\tright: 0;\n\ttransform: translate(100%, -50%);\n\ttransition: 0.2s;\n\n\t& .app-theme-panel-container {\n\t\twidth: 190px;\n\t}\n\t& .app-theme-panel-content {\n\t\tbackground: var(--#{$prefix}app-theme-panel-bg);\n\t\tbox-shadow: $dropdown-box-shadow;\n\t\tpadding: $spacer * 0.5;\n\n\t\t& .app-theme-mode-link {\n\t\t\tcolor: $white;\n\t\t\ttext-decoration: none;\n\t\t\ttext-align: center;\n\t\t\tposition: relative;\n\t\t\tdisplay: block;\n\t\t\ttransition: all 0.2s linear;\n\n\t\t\t& .img {\n\t\t\t\tposition: relative;\n\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: \"\\f00c\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tfont-size: rem(14px);\n\t\t\t\t\tcolor: transparent;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tz-index: 10;\n\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .text {\n\t\t\t\tfont-size: $font-size-base * 0.75;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tbackground: rgba($black, 0.85);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: flex-end;\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\topacity: 0.6;\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\topacity: 1;\n\n\t\t\t\t& .img {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tbackground: rgba($black, 0.3);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .text {\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& .app-theme-cover {\n\t\t\tmargin: $spacer * -0.25;\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\n\t\t\t& .app-theme-cover-item {\n\t\t\t\tpadding: $spacer * 0.25;\n\t\t\t\twidth: 33.33%;\n\n\t\t\t\t& .app-theme-cover-link {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding-top: 46%;\n\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\tbackground-position: center;\n\t\t\t\t\ttransition: all 0.2s linear;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: 0.6;\n\t\t\t\t\t}\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tbackground: $black;\n\t\t\t\t\t\topacity: 0.25;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t& .app-theme-cover-link {\n\t\t\t\t\t\topacity: 1;\n\n\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\tcontent: \"\\f00c\";\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\tfont-size: rem(14px);\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\n\t\t\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .app-theme-toggle-btn {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tmargin-top: $spacer * -1;\n\t\twidth: $spacer * 2;\n\t\theight: $spacer * 2;\n\t\tline-height: $spacer * 2;\n\t\tfont-size: $font-size-base * 1.25;\n\t\tcolor: var(--#{$prefix}app-theme-panel-color);\n\t\tbackground: var(--#{$prefix}app-theme-panel-bg);\n\t\ttext-align: center;\n\n\t\t@if $enable-rtl {\n\t\t\tright: 0;\n\t\t\tmargin-right: $spacer * -2;\n\t\t} @else {\n\t\t\tleft: 0;\n\t\t\tmargin-left: $spacer * -2;\n\t\t}\n\t}\n\t&.active {\n\t\ttransform: translate(0, -50%);\n\t}\n}\n","@mixin fontawesome() {\n\tfont-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n\tfont-weight: 900;\n\tfont-style: normal;\n\tfont-variant: normal;\n\ttext-rendering: auto;\n}","@keyframes topMenuControlSlideInLeft {\n\tfrom { left: rem(-50px); }\n\tto { left: 0; }\n}\n@keyframes topMenuControlSlideInRight {\n\tfrom { right: rem(-50px); }\n\tto { right: 0; }\n}\n.app-top-nav {\n\tbackground: var(--#{$prefix}app-top-nav-bg);\n\tleft: 0;\n\tright: 0;\n\tz-index: $app-top-nav-zindex;\n\t\n\t@include media-breakpoint-up(md) {\n\t\ttop: $app-header-height;\n\t\tposition: fixed;\n\t\theight: $app-top-nav-height;\n\t}\n\t@include media-breakpoint-down(md) {\n\t\tdisplay: none;\n\t}\n\t\n\t& .menu {\n\t\t@include media-breakpoint-up(md) {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: nowrap;\n\t\t\talign-items: center;\n\t\t}\n\t\t@include media-breakpoint-down(md) {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0 !important;\n\t\t}\n\t\t\n\t\t& .menu-item {\n\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t& .menu-link {\n\t\t\t\ttext-decoration: none;\n\t\t\t\tposition: relative;\n\t\t\t\tpadding: ($app-top-nav-height - ($font-size-base * $line-height-base) - rem(1px)) / 2 $spacer;\n\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-color);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t\ttransition: all .2s ease-in-out;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tpadding-top: $spacer * .5;\n\t\t\t\t\tpadding-bottom: $spacer * .5;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .menu-icon {\n\t\t\t\t\twidth: rem(30px);\n\t\t\t\t\theight: rem(30px);\n\t\t\t\t\tfont-size: $font-size-base * 1.2;\n\t\t\t\t\tmargin: rem(-4px) 0;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-left: $spacer* .75;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-right: $spacer * .75;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .menu-caret {\n\t\t\t\t\tmargin: rem(-5px) 0;\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-right: $spacer* .75;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: $spacer * .75;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .menu-text {\n\t\t\t\t\tflex: 1;\n\t\t\t\t}\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-hover-color);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .menu-submenu {\n\t\t\t\tbackground: var(--#{$prefix}app-top-nav-menu-submenu-bg);\n\t\t\t\tdisplay: none;\n\t\t\t\tpadding: $spacer * .5 0;\n\t\t\t\tmin-width: rem(200px);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-up(md) {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tmax-height: calc(100vh - #{$app-top-nav-height + $app-header-height});\n\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tpadding-top: 0;\n\t\t\t\t\tpadding-bottom: $spacer;\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tpadding-right: rem(42px);\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tpadding-left: rem(42px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .menu-item {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\t\n\t\t\t\t\t& .menu-link {\n\t\t\t\t\t\tpadding: $spacer * .25 $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t& > .menu-link {\n\t\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-active-color);\n\t\t\t\t}\n\t\t\t\t& > .menu-link {\n\t\t\t\t\t& .menu-icon {\n\t\t\t\t\t\tcolor: $app-top-nav-menu-link-icon-active-color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.menu-control {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tmargin: 0;\n\t\t\t\tz-index: 10;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tdisplay: none !important;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& > .menu-link {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\twidth: $app-top-nav-height;\n\t\t\t\t\theight: $app-top-nav-height;\n\t\t\t\t\tbackground: var(--#{$prefix}app-top-nav-bg);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-color);\n\t\t\t\t\t\n\t\t\t\t\t& i {\n\t\t\t\t\t\tfloat: none;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tfont-size: rem(18px);\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tline-height: rem(40px);\n\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-hover-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.menu-control-start {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tright: -$app-header-height;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tleft: -$app-header-height;\n\t\t\t\t\t}\n\t\t\t\t\n\t\t\t\t\t& > .menu-link {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tbox-shadow: -12px 0 10px -10px rgba($black,.5);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tbox-shadow: 12px 0 10px -10px rgba($black,.5);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.show {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\tanimation: topMenuControlSlideInRight .2s;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tanimation: topMenuControlSlideInLeft .2s;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.menu-control-end {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tleft: -$app-header-height;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tright: -$app-header-height;\n\t\t\t\t\t}\n\t\t\t\t\n\t\t\t\t\t& > .menu-link {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tbox-shadow: 12px 0 10px -10px rgba($black,.5);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tbox-shadow: -12px 0 10px -10px rgba($black,.5);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.show {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tanimation: topMenuControlSlideInLeft .2s;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\tanimation: topMenuControlSlideInRight .2s;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& > .menu-item {\n\t\t\t&.has-sub {\n\t\t\t\t&:hover {\n\t\t\t\t\t& > .menu-submenu {\n\t\t\t\t\t\t@include media-breakpoint-up(md) {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".map-fullscreen-hide.active {\n\tpointer-events: none !important;\n\topacity: 0 !important;\n\tvisibility: hidden !important;\n}\n.map-zoom-item {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n\tbackground: $white;\n\tz-index: 1;\n\tborder-radius: 4px;\n}\n\n.menu-item.has-sub {\n\tpadding-bottom: 5px;\n\tpadding-top: 2px;\n}\n\n.map-zoom-item a i {\n\tcolor: $black;\n\tfont-size: 24px;\n}\n\n.map-zoom-item a {\n\tpadding: 0 5px;\n}\n\n.hide-data tbody tr {\n\tfilter: blur(5px);\n\ttransition: 0.2s;\n}\n\n.hide-data tbody tr:hover {\n\tfilter: blur(0px);\n}\n\n/* styles.css */\n.autocomplete-container {\n\tposition: relative;\n}\n\n.autocomplete-input {\n\twidth: 100%;\n\tpadding: 8px;\n}\n\n.autocomplete-dropdown {\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 0;\n\twidth: 100%;\n\tz-index: 1000;\n\tbackground-color: #1c242d;\n\tborder: 1px solid $white;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\tmax-height: 150px;\n\toverflow-y: auto;\n}\n\n.autocomplete-item {\n\tpadding: 8px;\n\tcursor: pointer;\n\tcolor: $white;\n}\n\n.autocomplete-item:hover {\n\tbackground-color: #2a6e59;\n}\n\n.app {\n\t// padding-top: $app-header-height;\n\t@include media-breakpoint-down(xl) {\n\t\toverflow: hidden;\n\t}\n}\n@media (min-width: 992px) {\n\t.md-h-100 {\n\t\theight: 100%;\n\t}\n\n\t.md-mb-n4 {\n\t\tmargin-bottom: -1.5rem;\n\t}\n}\n\n.flex-none {\n\tflex: none;\n}\n\n.evenColumn {\n\tbackground: rgba(255, 255, 255, 0.06);\n}\n\n.ReactVirtualized__Grid {\n\tborder: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.headerCell {\n\tfont-weight: bold;\n\ttext-transform: uppercase;\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.25);\n\tpadding: 5px 10px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.headerCell {\n\tborder-right: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.evenColumn,\n.oddColumn {\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.25);\n\tborder-right: 1px solid rgba(255, 255, 255, 0.25);\n\tpadding: 10px;\n}\n\n.page-iframe iframe {\n\twidth: 100%;\n\theight: 100vh;\n}\n\n.welcome-container {\n\ttext-align: center;\n\tmin-height: calc(100vh - 280px);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-direction: column;\n}\n.welcome-container h1 {\n\tfont-size: 2.5em;\n\tmargin-bottom: 10px;\n}\n.welcome-container p {\n\tfont-size: 1.2em;\n\tcolor: #555;\n}\n\n.tooltip-title {\n\tdisplay: inline-block;\n\tposition: absolute;\n\ttop: 100%;\n\tbackground: var(--bs-dark3);\n\tborder-radius: 4px;\n\ttext-align: center;\n\tleft: 50%;\n\ttransform: translate(-50%, 4px);\n\tfont-size: 12px;\n\tpadding: 2px 5px;\n\topacity: 0;\n\tvisibility: hidden;\n\tpointer-events: none;\n\ttransition: 0.2s;\n}\n\n.tooltip-item {\n\tposition: relative;\n}\n\n.tooltip-item:hover .tooltip-title {\n\topacity: 1;\n\tvisibility: visible;\n}\n\n.graphic-events {\n\tposition: relative;\n}\n\n.graphic-events .graphic-events-dropdown {\n\tposition: absolute;\n\ttop: 100%;\n\tright: 0px;\n\tbackground: #1c2e37;\n\tz-index: 2;\n\tpadding: 10px;\n\tborder-radius: 4px;\n}\n\n.gm-style-iw-d .marker-window-container::-webkit-scrollbar {\n\twidth: 0px;\n\theight: 0px;\n}\n\n.fancybox__content {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\n.fancybox-navigation .fancybox-button {\n\topacity: 1;\n\tvisibility: visible;\n\tbackground: #2ab48a;\n\tpointer-events: all;\n\twidth: 90px;\n\theight: 90px;\n\tpadding: 0;\n\tborder-radius: 0px;\n\tcolor: $white !important;\n}\n\n.fancybox-navigation .fancybox-button:hover {\n\tbackground: #1e9a75;\n}\n\n.fancybox-navigation .fancybox-button svg {\n\twidth: 60px;\n\theight: auto;\n}\n\n.fancybox-navigation .fancybox-button div {\n\theight: 100%;\n\twidth: 100%;\n\tpadding: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.todo-sort-arrow {\n\t&:hover {\n\t\tcolor: var(--#{$prefix}theme);\n\t}\n}\n\n@include media-breakpoint-down(md) {\n\t.chest-work-page {\n\t\tflex-direction: column;\n\n\t\t> .flex-1 {\n\t\t\tpadding: 0 0px 0px 10px !important;\n\t\t}\n\t}\n}\n\n@include media-breakpoint-down(xl) {\n\t.neighbourhood-menu {\n\t\tmax-width: 100% !important;\n\t\twidth: 100% !important;\n\n\t\t> div {\n\t\t\tgap: 20px;\n\t\t\tposition: relative !important;\n\t\t\tdisplay: flex;\n\t\t\twhite-space: nowrap;\n\t\t\tmargin-bottom: 30px;\n\t\t\tpadding: 20px 20px;\n\t\t\toverflow-x: auto !important;\n\t\t\toverflow-y: hidden !important;\n\t\t}\n\t}\n}\n\n.district-menu {\n\twidth: 300px;\n\tflex: none;\n\n\t@include media-breakpoint-down(xl) {\n\t\twidth: 200px;\n\t}\n\n\t@include media-breakpoint-down(md) {\n\t\twidth: 100%;\n\n\t\t> ol {\n\t\t\toverflow-x: auto;\n\t\t\tpadding: 10px 20px;\n\t\t\tgap: 40px !important;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n}\n\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th:last-child,\n.dataTables_scrollBody > table > tbody tr td:last-child {\n\tborder-right: 1px solid #5d686f;\n}\n\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th,\n.dataTables_scrollBody > table > tbody tr td {\n\tborder-left: 1px solid #5d686f;\n}\n\n.dataTables_wrapper.dt-bootstrap5 .dataTable thead > tr > th {\n\tborder-top: 1px solid #5d686f;\n\tpadding-left: 30px;\n}\n\n.dataTables_wrapper.dt-bootstrap5 table.dataTable thead > tr > th.sorting:before,\n.dataTables_wrapper.dt-bootstrap5 table.dataTable thead > tr > th.sorting:after {\n\tleft: 10px;\n\tright: auto;\n\tposition: absolute;\n\tfont-size: 11px;\n}\n\n.dataTables_wrapper.dt-bootstrap5 table.dataTable thead > tr > th.sorting {\n\tpadding-left: 30px;\n\tposition: relative;\n}\n\n.table-datatable.table {\n\tmargin-bottom: 0;\n}\n\n.dataTables_scrollBody .table-datatable .sorting:before,\n.dataTables_scrollBody .table-datatable .sorting:after {\n\tdisplay: none !important;\n}\n\n/* width */\n::-webkit-scrollbar {\n\twidth: 10px;\n\theight: 10px;\n\tbackground: #44d2a529;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n\tbackground: var(--#{$prefix}theme);\n}\n\n.select-height {\n\theight: 60px;\n\n\t> div {\n\t\theight: 100%;\n\t}\n\n\t.react-select__control {\n\t\theight: 100%;\n\t}\n}\n\n.select-h-100 .react-select__control {\n\theight: 100%;\n}\n\n.react-select__control {\n\ttext-transform: uppercase;\n}\n\n.react-select__menu {\n\ttext-transform: uppercase;\n}\n\n.listen-note > span {\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 50%;\n\ttransform: translate(-50%, 0px);\n\twhite-space: nowrap;\n\tbackground: $black;\n\tz-index: 1;\n\topacity: 0;\n\tvisibility: hidden;\n\ttransition: 0.2s;\n\tpointer-events: none;\n}\n\n.listen-note {\n\tposition: relative;\n\n\t.fa-volume-off {\n\t\tdisplay: none;\n\t}\n\n\t&.active {\n\t\t.fa-volume-up {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.fa-volume-off {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n.listen-note:hover > span {\n\topacity: 1;\n\tvisibility: visible;\n}\n\n.gm-ui-hover-effect {\n\ttop: 0 !important;\n\tbackground: $red !important;\n\topacity: 1;\n\tright: 0 !important;\n\tborder-bottom-left-radius: 6px;\n\tdisplay: flex !important;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 35px !important;\n\theight: 35px !important;\n\n\t> span {\n\t\twidth: 24px !important;\n\t\theight: 24px !important;\n\t\tmargin: 0 !important;\n\t\tbackground-color: $white;\n\t}\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n\topacity: 1;\n\tbackground: rgba(0, 0, 0, 0.95);\n\ttop: 50%;\n\ttransform: translate(0px, -50%);\n\twidth: 30px;\n\theight: 30px;\n\tborder-radius: 100%;\n\tpadding: 3px;\n\tmargin: 0 -7px;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n\tfilter: initial !important;\n\tposition: relative;\n}\n\n.carousel-control-prev-icon {\n\tleft: -1px;\n}\n\n.carousel-control-next-icon {\n\tright: -2px;\n}\n\n#strategy-map .card:before,\n#strategy-map .card:after {\n\tdisplay: none;\n}\n\n#strategy-map .scrum-container > .flex-1 {\n\tdisplay: none;\n}\n\n#strategy-map .scrum-container {\n\tdisplay: none !important;\n\tleft: 0 !important;\n\tbottom: 0 !important;\n}\n\n.scrum-map-container {\n\theight: calc(100vh - 150px);\n}\n\n@include media-breakpoint-down(xl) {\n\t.scrum-map {\n\t\theight: 700px;\n\t}\n\n\t.scrum-map-container {\n\t\theight: auto !important;\n\t}\n\n\t.scrum-container {\n\t\theight: auto !important;\n\t\twidth: 100% !important;\n\t\tpadding: 40px 0 !important;\n\t}\n}\n\n#strategy-map .card .card-body {\n\tpadding: 0;\n}\n\n#strategy-map .card .card-arrow {\n\tdisplay: none;\n}\n.fancybox__container {\n\tz-index: 9999;\n}\n\n.pointer {\n\tcursor: pointer;\n}\n\n// table.dataTable td,\n// table.dataTable th {\n// \ttext-transform: uppercase;\n// }\n\n.sandik-analizi-chart-slide .swiper-slide .slide-chest {\n\t&:hover,\n\t&.active {\n\t\tcolor: var(--#{$prefix}theme);\n\n\t\tstrong {\n\t\t\tcolor: var(--#{$prefix}theme);\n\t\t}\n\t}\n}\n\n.sandik-analizi-chart-slide .swiper-slide .slide-general {\n\t&:hover,\n\t&.active {\n\t\tbackground: #fff0;\n\t\tcolor: var(--#{$prefix}theme);\n\t}\n}\n\n.form-control:disabled {\n\topacity: 0.5 !important;\n}\n\n.table > thead {\n\tvertical-align: middle;\n}\n\ntable.dataTable > tbody > tr:nth-child(even) {\n\tbackground: rgba(255, 255, 255, 0.06);\n}\n\n.custom-file-button {\n\tinput[type=\"file\"] {\n\t\tmargin-left: -2px !important;\n\n\t\t&::-webkit-file-upload-button {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&::file-selector-button {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n.color-item {\n\tposition: relative;\n}\n\n.color-item label {\n\tdisplay: block;\n\twidth: 24px;\n\theight: 24px;\n\tborder-radius: 4px;\n\tborder: 2px solid #fff0;\n\tcursor: pointer;\n}\n\n.color-item input {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\topacity: 0;\n\tvisibility: hidden;\n}\n\n.color-item input:checked ~ label {\n\tborder-color: $white;\n}\n\n.live-svg-map {\n\tposition: absolute;\n\ttop: 20px;\n\tleft: 50%;\n\ttransform: translate(-50%, 0px);\n\tz-index: 1;\n\tmargin: 0;\n\twidth: 70px;\n\tdisplay: none;\n}\n\n.app-sidebar-toggled {\n\t.live-svg-map {\n\t\tdisplay: block;\n\t}\n}\n\n.gm-style .gm-style-iw-c {\n\tcolor: $black;\n\ttext-align: center;\n\tpadding: 0;\n}\n\n.gm-style-iw-d {\n\tpadding: 5px 10px !important;\n\toverflow: initial !important;\n}\n\n.img-cover {\n\tobject-fit: cover;\n\tobject-position: center;\n}\n\n.scroll-up-btn {\n\tposition: fixed;\n\tbottom: 20px;\n\tright: 15px;\n\tcursor: pointer;\n\tpointer-events: none;\n\ttransform: scale(0);\n\ttransition: 0.2s;\n\twidth: 40px;\n\theight: 40px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 99;\n\tborder-radius: 100%;\n\tfont-size: 30px;\n\tcolor: $theme;\n\n\t&.active {\n\t\ttransform: scale(1);\n\t\tpointer-events: all;\n\t}\n\n\t&.near-news {\n\t\tbottom: 210px;\n\t}\n\n\t&.near-news.near-footer {\n\t\tbottom: 350px !important;\n\t}\n\n\t&:hover {\n\t\tcolor: $white;\n\t}\n\n\t@include media-breakpoint-down(md) {\n\t\t&.near-news {\n\t\t\tbottom: 30px;\n\t\t}\n\n\t\t&.near-news.near-footer {\n\t\t\tbottom: 500px !important;\n\t\t}\n\t}\n}\n\n.text-overflow {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\twidth: 100%;\n\toverflow: hidden;\n}\n\n.table-for-multiple {\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 2;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n}\n\n.page-loader {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0px;\n\tz-index: 999;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tflex-direction: column;\n}\n\n.page-loader .app-header:nth-child(2) {\n\twidth: auto;\n\tposition: relative;\n\theight: auto;\n\tbackground: none;\n\ttransform: scale(0.7);\n\tflex: 1;\n\n\t.brand-text {\n\t\tfont-size: 80px;\n\t}\n\n\t@include media-breakpoint-down(xl) {\n\t\ttransform: scale(0.4);\n\t}\n\n\t@include media-breakpoint-down(md) {\n\t\ttransform: scale(0.25);\n\t}\n}\n\n.page-loader .app-header:nth-child(2) .brand .brand-logo .card {\n\tfont-size: 80px;\n\toverflow: hidden;\n\tletter-spacing: 20px;\n\tmargin: 0;\n\tline-height: 1;\n\tmargin-left: 20px;\n\twidth: 0px;\n\tpadding: 10px 0px;\n\tbox-sizing: content-box;\n\n\t&.loader-text-1 {\n\t\tanimation: loaderAni1 3s cubic-bezier(0.51, 0.92, 0.24, 1.15) infinite both !important;\n\t}\n\n\t&.loader-text-2 {\n\t\tanimation: loaderAni2 3s cubic-bezier(0.51, 0.92, 0.24, 1.15) infinite both !important;\n\t}\n\n\t&.loader-text-3 {\n\t\tanimation: loaderAni3 3s cubic-bezier(0.51, 0.92, 0.24, 1.15) infinite both !important;\n\t}\n}\n\n.page-loader .app-header:nth-child(2) .brand {\n\twidth: auto;\n\theight: auto;\n\tpadding: 0;\n}\n\n@keyframes loaderAni1 {\n\t0%,\n\t100% {\n\t\twidth: 0px;\n\t\tpadding: 10px 0px;\n\t\tletter-spacing: 20px;\n\t}\n\n\t50% {\n\t\twidth: 530px;\n\t\tpadding: 10px 20px;\n\t\tletter-spacing: 0px;\n\t}\n}\n\n@keyframes loaderAni2 {\n\t0%,\n\t100% {\n\t\twidth: 0px;\n\t\tpadding: 10px 0px;\n\t\tletter-spacing: 20px;\n\t}\n\n\t50% {\n\t\twidth: 680px;\n\t\tpadding: 10px 20px;\n\t\tletter-spacing: 0px;\n\t}\n}\n\n@keyframes loaderAni3 {\n\t0%,\n\t100% {\n\t\twidth: 0px;\n\t\tpadding: 10px 0px;\n\t\tletter-spacing: 20px;\n\t}\n\n\t50% {\n\t\twidth: 870px;\n\t\tpadding: 10px 20px;\n\t\tletter-spacing: 0px;\n\t}\n}\n\n.details-modal .ck.ck-editor__main > .ck-editor__editable {\n\tmin-height: 100px !important;\n}\n\n.weather-item .react-select__menu {\n\tfont-size: 12px;\n\twidth: 120px;\n}\n\n.weather-item .react-select__control {\n\tborder: none;\n\tpadding: 0;\n\tmin-height: auto;\n\tmargin: 0;\n\tfont-size: 11px;\n}\n\n.select-sm .react-select__control {\n\tfont-size: 11px !important;\n}\n\n.breaking-news {\n\tbackground-color: var(--bs-dark2);\n\tpadding: 0px 1.5rem;\n\tposition: sticky;\n\tbottom: 0;\n\tright: 0;\n\tmargin-left: ($app-sidebar-width + $app-content-padding-x) - 2;\n\tz-index: 99;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\t.news-item {\n\t\t&:hover {\n\t\t\t.news-img {\n\t\t\t\t&:before {\n\t\t\t\t\topacity: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.news-img {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tbackground: #0f1320;\n\t\t\topacity: 0.7;\n\t\t\ttransition: 0.3s;\n\t\t}\n\t}\n\n\t.rate-container {\n\t\tborder-top: 1px solid 0037;\n\t\tfont-size: 10px;\n\t\tmargin: 8px 7px 0;\n\t\tpadding-top: 8px;\n\t}\n\n\t.weather-container {\n\t\twidth: auto;\n\t\tmax-width: 180px;\n\t\tborder-top: 1px solid 0037;\n\t\tmargin-top: 12px;\n\t\tpadding-top: 12px;\n\n\t\t@include media-breakpoint-down(md) {\n\t\t\tmargin-left: 0;\n\t\t\tborder-left: none;\n\t\t\tborder-top: 1px solid 0037;\n\t\t\tmargin-top: 5px;\n\t\t\tpadding-top: 5px;\n\t\t}\n\t}\n\n\ta {\n\t\ttext-decoration: none;\n\t\tcolor: $white;\n\t\ttransition: 0.3s;\n\n\t\tp {\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 1.1;\n\t\t\tbackground: rgba(255, 255, 255, 0.02);\n\t\t\tpadding: 12px;\n\n\t\t\t> span {\n\t\t\t\t&:nth-child(1) {\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\tmargin-bottom: 16px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.news-item-desc {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t-webkit-line-clamp: 3;\n\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\toverflow: hidden;\n\t\t\t\tfont-size: 14px;\n\t\t\t\topacity: 0.7;\n\t\t\t\tfont-weight: 300;\n\t\t\t\tmargin-bottom: 12px;\n\t\t\t}\n\n\t\t\t.text-date {\n\t\t\t\tfont-size: 9px;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\tcolor: $theme;\n\t\t}\n\t}\n\n\t.breaking-news-events {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tz-index: 2;\n\t\tleft: 16px;\n\t\ttransform: translate(0px, -100%);\n\t\tdisplay: flex;\n\t\tgap: 8px;\n\t\twidth: auto;\n\t\tbackground: var(--bs-dark2);\n\t\tpadding: 16px;\n\n\t\t@include media-breakpoint-down(md) {\n\t\t\tleft: 0;\n\t\t\tflex-wrap: wrap;\n\n\t\t\t> * {\n\t\t\t\tflex: 0 0 calc(50% - 10px);\n\t\t\t}\n\t\t}\n\t}\n\n\t.breaking-news-title {\n\t\tbackground: $red;\n\t\tcolor: $white;\n\t\tfont-weight: bold;\n\t\tpadding: 5px 10px;\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t\tborder-radius: 4px;\n\t\twidth: auto;\n\t\tcursor: pointer;\n\t\tmargin-bottom: 0;\n\n\t\ti {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\t}\n\n\t.breaking-news-col {\n\t\tdisplay: none;\n\t\tpadding-bottom: 24px;\n\t}\n\n\t&.active {\n\t\tpadding: 12px 1.5rem 0;\n\n\t\t.breaking-news-col {\n\t\t\tdisplay: block;\n\t\t}\n\n\t\t.breaking-news-title {\n\t\t\ti {\n\t\t\t\ttransform: rotate(0deg);\n\t\t\t}\n\t\t}\n\t}\n\n\t@include media-breakpoint-down(xl) {\n\t\tmargin-left: 0;\n\t}\n\n\t@include media-breakpoint-down(md) {\n\t\tmargin-left: 0;\n\t}\n}\n\n.sandik-analizi-chart {\n\t@include media-breakpoint-down(xl) {\n\t\theight: auto !important;\n\n\t\t> .col-12:first-child {\n\t\t\theight: 50vh;\n\t\t}\n\n\t\t> .col-12:nth-child(2) > .row > div {\n\t\t\theight: auto !important;\n\t\t}\n\n\t\t.row {\n\t\t\theight: auto !important;\n\t\t\t> .col-lg-4 {\n\t\t\t\theight: 500px !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.tree-chart {\n\theight: calc(100vh - 200px);\n\n\t> .col:nth-child(1) {\n\t\theight: 100%;\n\t}\n\n\t@include media-breakpoint-down(xl) {\n\t\theight: auto;\n\t}\n}\n\n#tooltip-item {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbackground: $white;\n\tz-index: 1;\n\tcolor: $black;\n\tborder-radius: 4px;\n\tpadding: 2px 5px;\n\tfont-size: 12px;\n\tpointer-events: none;\n\tdisplay: none;\n\n\t&.active {\n\t\tdisplay: block;\n\t}\n}\n\n.app-sidebar .app-theme-panel {\n\tposition: relative;\n\tright: 0;\n\twidth: 100%;\n}\n\n.app-sidebar .app-theme-panel .app-theme-toggle-btn {\n\tdisplay: none;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container {\n\tposition: relative;\n\twidth: 100%;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content {\n\tbackground: none;\n\tbox-shadow: none;\n\twidth: auto;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .small {\n\tmax-width: 60px;\n\topacity: 0.8;\n}\n\n.app-theme-list {\n\tflex-direction: row;\n}\n\n.app-theme-list .app-theme-list-item {\n\tflex: 1;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card {\n\tmargin-bottom: 0 !important;\n\tflex: 1;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card:before,\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card:after {\n\tdisplay: none;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card .card-arrow {\n\tdisplay: none;\n}\n\n.app-sidebar .app-theme-panel .app-theme-panel-container .app-theme-panel-content .card .card-body {\n\tpadding: 0 !important;\n}\n\n// Questions\n.question-answer-button {\n\t&:hover label {\n\t\topacity: 1;\n\t}\n\n\tinput:checked ~ label {\n\t\topacity: 1;\n\t}\n\n\tlabel {\n\t\topacity: 0.5;\n\t}\n}\n\n/* Zoom */\n// .app-header,\n// .app-sidebar {\n// \tzoom: 0.8;\n// }\n\n// .modal-content {\n// \tzoom: 0.8;\n// }\n\n// .zoom-item {\n// \tzoom: 0.7;\n// }\n\n.menu-item-events-hover {\n\t.menu-item-events {\n\t\tdisplay: none;\n\t}\n\n\t&:hover {\n\t\t.menu-item-events {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n.ck-editor-height-full .ck.ck-editor {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n}\n\n.ck-editor-height-full .ck.ck-editor .ck.ck-editor__main {\n\tflex: 1;\n\toverflow: auto;\n}\n\n.ck-editor-height-full .ck.ck-editor .ck.ck-editor__main .ck-content {\n\theight: 100%;\n}\n\n.ck-editor-height-full {\n\theight: 100%;\n}\n\n//--\n\n.survey-table,\n.survey-table td {\n\tdisplay: block;\n}\n\n.survey-table td {\n\tflex: 1 0 50%;\n}\n\n.survey-table tr {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n\n.survey-table td:nth-child(1) {\n\tflex: 0 0 40px;\n}\n\n.survey-table td:last-child {\n\tflex: 0 0 130px;\n}\n\n.survey-question-list-item {\n\tborder: 1px solid #4e545b;\n\tpadding: 10px;\n\tmargin-bottom: 15px;\n}\n\n.survey-question-list-item .list-item-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 15px;\n\tborder-bottom: 1px solid #4e545b;\n\tpadding-bottom: 15px;\n\tmargin-bottom: 15px;\n}\n\n// .survey-question-list-item .list-item-header > div:last-child {\n// \twidth: 160px;\n// \tborder-left: 1px solid #4e545b;\n// \tpadding-left: 20px;\n// \tmargin-left: 20px;\n// }\n\n.survey-question-list-item .list-item-header > div:first-child {\n\tflex: 1;\n}\n\n@media screen and (max-width: 767px) {\n\t.survey-question-list-item .list-item-header {\n\t\tflex-direction: column;\n\t\tgap: 0px;\n\t}\n\n\t.survey-question-list-item .row {\n\t\tflex-direction: column;\n\t\tgap: 10px;\n\t}\n\n\t.survey-question-list-item .list-item-header > div:first-child {\n\t\twidth: 100%;\n\t}\n\n\t.survey-question-list-item .list-item-header > div:last-child {\n\t\twidth: 100%;\n\t\tborder-left: none;\n\t\tmargin-left: 0;\n\t\tpadding-left: 0;\n\t\tborder-top: 1px solid #4e545b;\n\t\tpadding-top: 10px;\n\t\tmargin-top: 10px;\n\t}\n}\n\n/* Disaster */\n.app {\n\ttransition: 0.5s;\n}\n\n.disaster-page {\n\tbackground: linear-gradient(180deg, #b70000 -190%, rgb(27 0 0) 90%) !important;\n\theight: auto !important;\n}\n\n// .disaster-container {\n// \tposition: fixed;\n// \ttop: 0;\n// \tleft: 0%;\n// \ttransform: scale(1.1);\n// \topacity: 0;\n// \tvisibility: hidden;\n// \tbottom: 0;\n// \twidth: 100%;\n// \tbackground: rgb(69 0 0 / 80%);\n// \tz-index: 999999;\n// \tpointer-events: none;\n// \ttransition: 0.5s 0.2s;\n// \tpadding: 32px 24px;\n// }\n\n// .disaster-active {\n// \toverflow: hidden;\n\n// \t.app {\n// \t\tfilter: blur(5px);\n// \t}\n\n// \t.disaster-container {\n// \t\ttransform: scale(1);\n// \t\topacity: 1;\n// \t\tvisibility: visible;\n// \t\tpointer-events: all;\n// \t}\n// }\n\n.modal {\n\tz-index: 1120;\n}\n\n.profil-photo-item {\n\t&-upload {\n\t\topacity: 0;\n\t}\n\n\t&:hover {\n\t\t.profil-photo-item-upload {\n\t\t\topacity: 1;\n\t\t}\n\t}\n}\n\n.select-map .react-select__menu {\n\tfont-size: 12px !important;\n}\n\n.select-map .react-select__control {\n\tborder-color: $black !important;\n\theight: 26px;\n\tmin-height: 26px;\n\tpadding: 0px 10px;\n}\n\n.select-map .react-select__control .react-select__value-container .react-select__single-value {\n\tcolor: $black;\n}\n\n.select-map .react-select__control .react-select__indicators .react-select__indicator {\n\tcolor: $black;\n}\n\n.progress-container {\n\tdisplay: flex;\n\talign-items: center;\n\tborder: 1px solid #595d64;\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tfont-size: 18px;\n}\n\n.progress-container input {\n\tflex: 1;\n\tmargin-right: 10px;\n}\n\n/* Slider genel stili */\n.slider {\n\t-webkit-appearance: none; /* Tarayıcı varsayılan stilini kaldırır */\n\tappearance: none;\n\twidth: 100%;\n\theight: 8px;\n\tbackground: $gray-100; /* Arka plan rengi */\n\toutline: none;\n\topacity: 0.7;\n\ttransition: opacity 0.2s;\n}\n\n.slider:hover {\n\topacity: 1; /* Hover'da opaklığı artırır */\n}\n\n/* Track (Arka plan) stili */\n.slider::-webkit-slider-runnable-track {\n\twidth: 100%;\n\theight: 8px;\n\tbackground: $gray-100;\n\tborder-radius: 4px;\n\tcursor: pointer;\n}\n\n.slider::-moz-range-track {\n\twidth: 100%;\n\theight: 8px;\n\tbackground: $gray-100;\n\tborder-radius: 4px;\n\tcursor: pointer;\n}\n\n/* Thumb (Tutma yeri) stili */\n.slider::-webkit-slider-thumb {\n\t-webkit-appearance: none;\n\tappearance: none;\n\twidth: 20px;\n\theight: 20px;\n\tbackground: $theme; /* Thumb rengi */\n\tmargin-top: -6px;\n\tborder-radius: 50%;\n\tcursor: pointer;\n}\n\n.slider::-moz-range-thumb {\n\twidth: 20px;\n\theight: 20px;\n\tbackground: $theme; /* Thumb rengi */\n\tborder-radius: 50%;\n\tmargin-top: -6px;\n\tcursor: pointer;\n}\n\n/* Slider'ın dolu kısmının rengi (Chrome ve Safari için) */\n.slider::-webkit-slider-runnable-track {\n\tbackground: linear-gradient(to right, $theme 0%, $theme var(--progress), $gray-100 var(--progress), $gray-100 100%);\n}\n\n.slider::-moz-range-progress {\n\tbackground: $theme; /* Firefox'ta dolu kısmın rengi */\n\theight: 8px;\n\tborder-radius: 4px;\n}\n\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n\tright: 94px;\n}\n\n.react-datepicker__time-container {\n\tfloat: none;\n\tpadding-left: 10px;\n\tmargin-left: 5px;\n\tborder-color: #555e69;\n}\n\n.react-datepicker-popper .react-datepicker {\n\tdisplay: flex;\n}\n\n.react-datepicker__header {\n\tbackground: #222e3e;\n\tborder-color: #555e6a;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n\tcolor: $white;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n\tbackground: #222e3e;\n}\n\n.react-datepicker__time-container\n\t.react-datepicker__time\n\t.react-datepicker__time-box\n\tul.react-datepicker__time-list\n\tli.react-datepicker__time-list-item {\n\tcolor: $white;\n}\n\n.react-datepicker__time-container\n\t.react-datepicker__time\n\t.react-datepicker__time-box\n\tul.react-datepicker__time-list\n\tli.react-datepicker__time-list-item--selected {\n\tbackground: $theme;\n}\n\n.react-datepicker__time-container\n\t.react-datepicker__time\n\t.react-datepicker__time-box\n\tul.react-datepicker__time-list\n\tli.react-datepicker__time-list-item:hover {\n\tbackground: #319d792e;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n\tbackground: #319d7952;\n}\n\n.react-datepicker\n\t.react-datepicker__month-container\n\t.react-datepicker__month\n\t.react-datepicker__week\n\t.react-datepicker__day:hover {\n\tbackground: $theme;\n}\n\n.react-datepicker__month--selecting-range\n\t.react-datepicker__day--in-range:not(\n\t\t.react-datepicker__day--in-selecting-range,\n\t\t.react-datepicker__month-text--in-selecting-range,\n\t\t.react-datepicker__quarter-text--in-selecting-range,\n\t\t.react-datepicker__year-text--in-selecting-range\n\t),\n.react-datepicker__year--selecting-range\n\t.react-datepicker__day--in-range:not(\n\t\t.react-datepicker__day--in-selecting-range,\n\t\t.react-datepicker__month-text--in-selecting-range,\n\t\t.react-datepicker__quarter-text--in-selecting-range,\n\t\t.react-datepicker__year-text--in-selecting-range\n\t),\n.react-datepicker__month--selecting-range\n\t.react-datepicker__month-text--in-range:not(\n\t\t.react-datepicker__day--in-selecting-range,\n\t\t.react-datepicker__month-text--in-selecting-range,\n\t\t.react-datepicker__quarter-text--in-selecting-range,\n\t\t.react-datepicker__year-text--in-selecting-range\n\t),\n.react-datepicker__year--selecting-range\n\t.react-datepicker__month-text--in-range:not(\n\t\t.react-datepicker__day--in-selecting-range,\n\t\t.react-datepicker__month-text--in-selecting-range,\n\t\t.react-datepicker__quarter-text--in-selecting-range,\n\t\t.react-datepicker__year-text--in-selecting-range\n\t),\n.react-datepicker__month--selecting-range\n\t.react-datepicker__quarter-text--in-range:not(\n\t\t.react-datepicker__day--in-selecting-range,\n\t\t.react-datepicker__month-text--in-selecting-range,\n\t\t.react-datepicker__quarter-text--in-selecting-range,\n\t\t.react-datepicker__year-text--in-selecting-range\n\t),\n.react-datepicker__year--selecting-range\n\t.react-datepicker__quarter-text--in-range:not(\n\t\t.react-datepicker__day--in-selecting-range,\n\t\t.react-datepicker__month-text--in-selecting-range,\n\t\t.react-datepicker__quarter-text--in-selecting-range,\n\t\t.react-datepicker__year-text--in-selecting-range\n\t),\n.react-datepicker__month--selecting-range\n\t.react-datepicker__year-text--in-range:not(\n\t\t.react-datepicker__day--in-selecting-range,\n\t\t.react-datepicker__month-text--in-selecting-range,\n\t\t.react-datepicker__quarter-text--in-selecting-range,\n\t\t.react-datepicker__year-text--in-selecting-range\n\t),\n.react-datepicker__year--selecting-range\n\t.react-datepicker__year-text--in-range:not(\n\t\t.react-datepicker__day--in-selecting-range,\n\t\t.react-datepicker__month-text--in-selecting-range,\n\t\t.react-datepicker__quarter-text--in-selecting-range,\n\t\t.react-datepicker__year-text--in-selecting-range\n\t) {\n\tbackground: #319d7991;\n}\n\n.react-datepicker__day--in-selecting-range:not(\n\t\t.react-datepicker__day--in-range,\n\t\t.react-datepicker__month-text--in-range,\n\t\t.react-datepicker__quarter-text--in-range,\n\t\t.react-datepicker__year-text--in-range\n\t),\n.react-datepicker__month-text--in-selecting-range:not(\n\t\t.react-datepicker__day--in-range,\n\t\t.react-datepicker__month-text--in-range,\n\t\t.react-datepicker__quarter-text--in-range,\n\t\t.react-datepicker__year-text--in-range\n\t),\n.react-datepicker__quarter-text--in-selecting-range:not(\n\t\t.react-datepicker__day--in-range,\n\t\t.react-datepicker__month-text--in-range,\n\t\t.react-datepicker__quarter-text--in-range,\n\t\t.react-datepicker__year-text--in-range\n\t),\n.react-datepicker__year-text--in-selecting-range:not(\n\t\t.react-datepicker__day--in-range,\n\t\t.react-datepicker__month-text--in-range,\n\t\t.react-datepicker__quarter-text--in-range,\n\t\t.react-datepicker__year-text--in-range\n\t) {\n\tbackground: #319d7952;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n\tcolor: $white;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n\tbackground: #1d2836;\n\tborder-color: #555e69;\n\tcolor: $white;\n}\n\n.react-datepicker__year-dropdown-container--scroll .react-datepicker__navigation {\n\tbackground: none;\n\ttop: 0;\n}\n\n.react-datepicker__year-dropdown-container--scroll .react-datepicker__navigation:before {\n\tcontent: \"\\f105\";\n\tcolor: rgba(var(--bs-inverse-rgb), 0.5);\n\tposition: absolute;\n\tfont-size: 0.875rem;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-family:\n\t\tFont Awesome\\6 Free,\n\t\tFont Awesome\\6 Pro,\n\t\tFontAwesome !important;\n\tfont-weight: 900;\n\tfont-style: normal;\n\tfont-variant: normal;\n\ttext-rendering: auto;\n\ttransform: rotate(-90deg);\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n\tbackground: #293748;\n}\n\n.react-datepicker__year-option:last-of-type a:before {\n\ttransform: rotate(90deg) !important;\n}\n\n.react-datepicker__close-icon::after {\n\tbackground: $red;\n}\n\n.question-block .question-block {\n\tmargin-left: 10px;\n\twidth: calc(100% - 15px);\n}\n\n.question-block .row.g-2.align-items-center:before {\n\tmargin-right: 10px;\n\tmargin-left: -10px;\n\tcontent: \"\";\n\twidth: 10px;\n\theight: 1px;\n\tbackground: $white;\n\tdisplay: block;\n}\n\n.question-block {\n\t&:before {\n\t\tcontent: \"\";\n\t\twidth: 1px;\n\t\theight: calc(100% - 122px);\n\t\tbackground: $white;\n\t\tposition: absolute;\n\t\ttop: 31px;\n\t\tleft: 15px;\n\t}\n\n\t&.question-string:before {\n\t\theight: calc(100% - 77px);\n\t}\n}\n\n.question-block {\n\tposition: relative;\n}\n\n.question-block .question-block {\n\tmargin-top: 10px;\n\tbackground: rgb(255 255 255 / 5%);\n}\n\n.question-block {\n\tbackground: rgb(255 255 255 / 3%);\n\tpadding: 15px 10px 15px 30px;\n}\n\n.question-block:after {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 30px;\n\tleft: 15px;\n\twidth: 8px;\n\theight: 1px;\n\tbackground: $white;\n}\n\n/* styles.css */\n\n.box {\n\tposition: relative;\n\tbox-sizing: border-box;\n\tresize: both;\n\toverflow: hidden;\n}\n\n.resizer {\n\tposition: absolute;\n\twidth: 10px;\n\theight: 10px;\n\tbackground: $black;\n\tcursor: se-resize;\n}\n\n.resizer.bottom-right {\n\tbottom: 0;\n\tright: 0;\n}\n\n.rotate-animation {\n\tdisplay: block;\n\ttransform: rotate(0deg);\n\ttransform-origin: center;\n\tanimation: rotateAni 5s both infinite;\n}\n\n@keyframes rotateAni {\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n// TREE\n/*Now the CSS*/\n\n.tree {\n\twhite-space: nowrap;\n\toverflow: auto;\n\tborder: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.tree ul {\n\tpadding-top: 20px;\n\tposition: relative;\n\ttext-align: center;\n\ttransition: all 0.5s;\n\t-webkit-transition: all 0.5s;\n\t-moz-transition: all 0.5s;\n}\n\n.tree li {\n\ttext-align: center;\n\tlist-style-type: none;\n\tposition: relative;\n\tpadding: 20px 5px 0 5px;\n\ttransition: all 0.5s;\n\t-webkit-transition: all 0.5s;\n\t-moz-transition: all 0.5s;\n\t/*added for long names*/\n\n\tfloat: none;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: nowrap;\n\tmargin: 0 -2px 0 -2px;\n}\n/*We will use ::before and ::after to draw the connectors*/\n\n.tree li::before,\n.tree li::after {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0;\n\tright: 50%;\n\tborder-top: 1px solid #ccc;\n\twidth: 50%;\n\theight: 20px;\n}\n\n.tree li::after {\n\tright: auto;\n\tleft: 50%;\n\tborder-left: 1px solid #ccc;\n}\n/*We need to remove left-right connectors from elements without \n  any siblings*/\n\n.tree li:only-child::after,\n.tree li:only-child::before {\n\tdisplay: none;\n}\n/*Remove space from the top of single children*/\n\n.tree li:only-child {\n\tpadding-top: 0;\n}\n/*Remove left connector from first child and \n  right connector from last child*/\n\n.tree li:first-child::before,\n.tree li:last-child::after {\n\tborder: 0 none;\n}\n/*Adding back the vertical connector to the last nodes*/\n\n.tree li:last-child::before {\n\tborder-right: 1px solid #ccc;\n\tborder-radius: 0 5px 0 0;\n\t-webkit-border-radius: 0 5px 0 0;\n\t-moz-border-radius: 0 5px 0 0;\n}\n\n.tree li:first-child::after {\n\tborder-radius: 5px 0 0 0;\n\t-webkit-border-radius: 5px 0 0 0;\n\t-moz-border-radius: 5px 0 0 0;\n}\n/*Time to add downward connectors from parents*/\n\n.tree ul ul::before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0;\n\tleft: 50%;\n\tborder-left: 1px solid #ccc;\n\twidth: 0;\n\theight: 20px;\n}\n\n.tree li a {\n\tborder: 1px solid #ccc;\n\tpadding: 10px 15px;\n\ttext-decoration: none;\n\tcolor: $white;\n\tfont-weight: 500;\n\tfont-size: 14px;\n\tdisplay: inline-block;\n\tborder-radius: 5px;\n\t-webkit-border-radius: 5px;\n\t-moz-border-radius: 5px;\n\ttransition: all 0.2s;\n}\n/*Time for some hover effects*/\n/*We will apply the hover effect the the lineage of the element also*/\n\n.tree li a:hover,\n.tree li a:hover + ul li a {\n\tbackground: $theme;\n\tcolor: $black;\n\tborder: 1px solid $theme;\n}\n/*Connector styles on hover*/\n\n.tree li a:hover + ul li::after,\n.tree li a:hover + ul li::before,\n.tree li a:hover + ul::before,\n.tree li a:hover + ul ul::before {\n\tborder-color: #94a0b4;\n}\n\n//--\n.user-info-hover {\n\t&-item {\n\t\topacity: 0;\n\t\tvisibility: hidden;\n\t\tpointer-events: none;\n\t\ttransition: 0.2s;\n\t}\n\n\t&:hover {\n\t\t.user-info-hover-item {\n\t\t\topacity: 1;\n\t\t\tvisibility: visible;\n\t\t\tpointer-events: all;\n\t\t}\n\t}\n}\n\n.swiper-pagination {\n\tposition: static !important;\n\tmargin-top: 15px !important;\n}\n\n.swiper-pagination-bullet {\n\twidth: 10px !important;\n\tborder-radius: 10px !important;\n\tbackground: $white !important;\n}\n\n.swiper-pagination-bullet.swiper-pagination-bullet-active {\n\twidth: 20px !important;\n}\n\n.graphic-note-item .ck-sticky-panel__content {\n\tdisplay: none;\n}\n\n.graphic-note-item .jodit-toolbar__box {\n\tdisplay: none;\n}\n\nfigure.table table th,\nfigure.table table td {\n\tborder: 1px solid;\n\tfont-size: 15px;\n}\n\n//--\n\n.file-progress-card {\n\tposition: fixed;\n\tright: 20px;\n\tz-index: 99;\n\tbackground: #12202c;\n\tborder: 1px solid 0059;\n\tpadding: 20px;\n\tborder-radius: 8px;\n\tcolor: $white;\n\tfont-weight: 500;\n\twidth: 400px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 20px;\n}\n\n.pagination {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: center;\n\tgap: 5px;\n}\n\n.pagination .paginate_button.page-item {\n\tmargin: 0;\n}\n\n.question-category-scroll {\n\theight: 400px;\n\tpadding-bottom: 100px;\n\t-webkit-mask-image: linear-gradient(\n\t\t180deg,\n\t\trgba(255, 255, 255, 0) -100%,\n\t\t$white 7.17%,\n\t\t$white 70%,\n\t\trgba(255, 255, 255, 0) 100%\n\t);\n\tmask-image: linear-gradient(\n\t\t180deg,\n\t\trgba(255, 255, 255, 0) -100%,\n\t\t$white 7.17%,\n\t\t$white 70%,\n\t\trgba(255, 255, 255, 0) 100%\n\t);\n}\n\n.menu-first-dropdown .menu-item {\n\tbackground: rgb(61 210 165 / 8%);\n\tpadding: 8px 0px !important;\n}\n\n.has-sub .menu-item.active {\n\tborder-top: 1px dashed 00;\n\tborder-bottom: 1px dashed 00;\n}\n\n.menu-first-dropdown > .menu-item.active:not(.has-sub) {\n\tborder-top: 1px dashed 00;\n\tborder-bottom: 1px dashed 00;\n}\n\n.app-sidebar .app-sidebar-content .menu .menu-item .menu-link {\n\tpadding: 0 1rem !important;\n}\n\n.menu-item.has-sub.ps-0 {\n\tpadding: 1rem 0rem 0.5rem;\n}\n\n.menu-first-dropdown .menu-item.has-sub.ps-0 {\n\tpadding: 8px 0;\n}\n\n.menu-first-dropdown .menu-submenu {\n\tpadding-bottom: 0 !important;\n\tmargin-top: 12px;\n}\n\n.menu-other-dropdown .menu-submenu .menu-item {\n\tbackground: rgba(61, 210, 165, 0.08);\n\tpadding: 8px;\n}\n\n.menu-other-dropdown .menu-submenu {\n\tmargin-top: 12px;\n}\n\n.menu-caret {\n\ttransform: rotate(-90deg);\n\ttransition: 0.3s;\n}\n\n.menu-caret.active {\n\ttransform: rotate(0deg);\n}\n\n.menu-item.active > div > .menu-link > .menu-caret {\n\ttransform: rotate(0deg);\n}\n\n.parent {\n\tdisplay: grid;\n\tgap: 10px;\n}\n\n.div1,\n.div2,\n.div3 {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 100%;\n\tfont-size: 20px;\n\tcolor: $white;\n}\n\n.menu-settings {\n\tdisplay: none;\n\tflex-direction: column;\n\tjustify-content: center;\n\tmargin: 0 10px;\n}\n\n// Jodit Editor\n.jodit-react-container {\n\tcolor: black;\n}\n\n.jodit-container:not(.jodit_inline) .jodit-workplace {\n\tmin-height: 500px !important;\n}\n\n.jodit_sticky > .jodit-toolbar__box {\n\tposition: static;\n}\n\n:root {\n\t--jd-color-1: #ffffff;\n\t--jd-color-2: green;\n\t--jd-color-3: #ffffff00;\n\t--jd-color-4: #ffffff;\n\t--jd-color-5: white;\n\t--jd-color-6: rgb(255 255 255 / 25%);\n\t--jd-color-7: #ffffff00;\n\t--jd-color-8: rgb(255 255 255 / 25%);\n\t--jd-color-9: #ffffff;\n}\n\n.jodit_theme_dark .jodit-toolbar__box:not(:empty) {\n\tbackground: #141b24;\n}\n\n.jodit_theme_dark .jodit-ui-input__input {\n\tcolor: black;\n}\n\n.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal {\n\tbackground-image: repeating-linear-gradient(\n\t\ttransparent 0,\n\t\ttransparent calc(calc(14px + calc((14px - 4px) * 2) + 2px * 2) - 1px),\n\t\tvar(--jd-color-6) calc(14px + calc((14px - 4px) * 2) + 2px * 2)\n\t);\n}\n.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal {\n\tbackground-image: repeating-linear-gradient(\n\t\ttransparent 0,\n\t\ttransparent calc(calc(14px + calc((14px - 4px) * 2) + 2px * 2) - 1px),\n\t\tvar(--jd-color-6) calc(14px + calc((14px - 4px) * 2) + 2px * 2)\n\t);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-collection_mode_horizontal:after {\n\tbackground-color: var(--jd-color-6);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after {\n\tbackground-color: var(--jd-color-6);\n}\n.jodit_theme_dark .jodit-toolbar-collection_mode_horizontal:after {\n\tbackground-color: var(--jd-color-6);\n}\n.jodit_theme_dark .jodit-toolbar-editor-collection_mode_horizontal:after {\n\tbackground-color: var(--jd-color-6);\n}\n.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) {\n\tborder-color: var(--jd-color-6);\n}\n.jodit_theme_dark .jodit-toolbar__box:not(:empty) {\n\tborder-color: var(--jd-color-6);\n}\n.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after {\n\tbackground-color: var(--jd-color-6);\n}\n.jodit_theme_dark .jodit-toolbar__box:not(:empty) .jodit-toolbar-editor-collection:after {\n\tbackground-color: var(--jd-color-6);\n}\n.jodit-dialog_theme_dark .jodit-ui-group_separated_true:not(:last-child, .jodit-ui-group_before-spacer_true):after {\n\tborder-right-color: var(--jd-color-6);\n}\n.jodit_theme_dark .jodit-ui-group_separated_true:not(:last-child, .jodit-ui-group_before-spacer_true):after {\n\tborder-right-color: var(--jd-color-6);\n}\n.jodit-dialog_theme_dark.jodit-container {\n\tbackground-color: var(--jd-color-3);\n\tborder-color: var(--jd-color-8);\n}\n.jodit_theme_dark.jodit-container {\n\tbackground-color: var(--jd-color-3);\n\tborder-color: var(--jd-color-8);\n}\n.jodit-dialog_theme_dark.jodit-container.jodit_disabled {\n\tbackground-color: var(--jd-color-3);\n}\n.jodit_theme_dark.jodit-container.jodit_disabled {\n\tbackground-color: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace {\n\tborder-color: var(--jd-color-3);\n}\n.jodit_theme_dark.jodit-container:not(.jodit_inline) .jodit-workplace {\n\tborder-color: var(--jd-color-3);\n\tbackground: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-popup__content {\n\tbackground: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-popup__content {\n\tbackground: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button__text {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select__text {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button__text {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-ui-button__text:hover:not([disabled]) {\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button__text {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select__text {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button__text {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-ui-button__text:hover:not([disabled]) {\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button svg {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button__trigger {\n\tfill: var(--jd-color-9);\n\tstroke: var(--jd-color-9);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select svg {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select__trigger {\n\tfill: var(--jd-color-9);\n\tstroke: var(--jd-color-9);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button svg {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit-dialog_theme_dark .jodit-ui-button svg:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button svg:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button__trigger {\n\tfill: var(--jd-color-9);\n\tstroke: var(--jd-color-9);\n}\n.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button .jodit-icon {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button svg {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button__trigger {\n\tfill: var(--jd-color-9);\n\tstroke: var(--jd-color-9);\n}\n.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select .jodit-icon {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select .jodit-icon:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select svg {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select svg:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select__trigger {\n\tfill: var(--jd-color-9);\n\tstroke: var(--jd-color-9);\n}\n.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button .jodit-icon {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button .jodit-icon:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button svg {\n\tfill: var(--jd-color-4);\n\tstroke: var(--jd-color-4);\n}\n.jodit_theme_dark .jodit-ui-button svg:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button svg:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button__trigger {\n\tfill: var(--jd-color-9);\n\tstroke: var(--jd-color-9);\n}\n.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n\tstroke: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n\tfill: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button__button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select__button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button__button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button__text:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button__button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select__button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select__text:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-toolbar-select__trigger:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button__button:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button__text:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit_theme_dark .jodit-ui-button__trigger:hover:not([disabled]) {\n\tbackground-color: var(--jd-color-4);\n\tcolor: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark .jodit-status-bar {\n\tbackground-color: var(--jd-color-7);\n\tborder-color: var(--jd-color-6);\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {\n\tbackground-color: var(--jd-color-7);\n\tborder-color: var(--jd-color-6);\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-status-bar {\n\tbackground-color: var(--jd-color-7);\n\tborder-color: var(--jd-color-6);\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {\n\tbackground-color: var(--jd-color-7);\n\tborder-color: var(--jd-color-6);\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-status-bar {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item a {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-status-bar .jodit-status-bar__item span {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item a {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item span {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-status-bar {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item a {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-status-bar .jodit-status-bar__item span {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:hover {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-status-bar a.jodit-status-bar-link:visited {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item a {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) .jodit-status-bar__item span {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:hover {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-workplace + .jodit-status-bar:not(:empty) a.jodit-status-bar-link:visited {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-toolbar__box:not(:empty) {\n\tbackground: var(--jd-color-7);\n}\n.jodit_theme_dark .jodit-toolbar__box:not(:empty) {\n\tbackground: var(--jd-color-7);\n}\n.jodit-dialog_theme_dark .jodit-icon-close {\n\tstroke: var(--jd-color-4);\n}\n.jodit_theme_dark .jodit-icon-close {\n\tstroke: var(--jd-color-4);\n}\n.jodit-dialog_theme_dark .jodit-wysiwyg {\n\tbackground-color: var(--jd-color-3);\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-wysiwyg_iframe {\n\tbackground-color: var(--jd-color-3);\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-wysiwyg {\n\tbackground-color: var(--jd-color-3);\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-wysiwyg_iframe {\n\tbackground-color: var(--jd-color-3);\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-form input[type=\"text\"] {\n\tbackground-color: rgba(81, 81, 81, 0.41);\n\tborder-color: var(--jd-color-5);\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-form input[type=\"url\"] {\n\tbackground-color: rgba(81, 81, 81, 0.41);\n\tborder-color: var(--jd-color-5);\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-form textarea {\n\tbackground-color: rgba(81, 81, 81, 0.41);\n\tborder-color: var(--jd-color-5);\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-form input[type=\"text\"] {\n\tbackground-color: rgba(81, 81, 81, 0.41);\n\tborder-color: var(--jd-color-5);\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-form input[type=\"url\"] {\n\tbackground-color: rgba(81, 81, 81, 0.41);\n\tborder-color: var(--jd-color-5);\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-form textarea {\n\tbackground-color: rgba(81, 81, 81, 0.41);\n\tborder-color: var(--jd-color-5);\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-form button {\n\tbackground-color: hsla(0, 0%, 41%, 0.75);\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-form button {\n\tbackground-color: hsla(0, 0%, 41%, 0.75);\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-placeholder {\n\tcolor: hsla(0, 5%, 81%, 0.8);\n}\n.jodit_theme_dark .jodit-placeholder {\n\tcolor: hsla(0, 5%, 81%, 0.8);\n}\n.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit_uploadfile_button {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-drag-and-drop__file-box {\n\tcolor: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit_uploadfile_button {\n\tcolor: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-drag-and-drop__file-box:hover {\n\tbackground-color: hsla(0, 0%, 41%, 0.75);\n}\n.jodit-dialog_theme_dark .jodit_uploadfile_button:hover {\n\tbackground-color: hsla(0, 0%, 41%, 0.75);\n}\n.jodit_theme_dark .jodit-drag-and-drop__file-box:hover {\n\tbackground-color: hsla(0, 0%, 41%, 0.75);\n}\n.jodit_theme_dark .jodit_uploadfile_button:hover {\n\tbackground-color: hsla(0, 0%, 41%, 0.75);\n}\n.jodit-dialog_theme_dark .jodit-add-new-line:before {\n\tborder-top-color: var(--jd-color-5);\n}\n.jodit_theme_dark .jodit-add-new-line:before {\n\tborder-top-color: var(--jd-color-5);\n}\n.jodit-dialog_theme_dark .jodit-add-new-line span {\n\tbackground: hsla(0, 0%, 41%, 0.75);\n\tborder-color: var(--jd-color-5);\n}\n.jodit_theme_dark .jodit-add-new-line span {\n\tbackground: hsla(0, 0%, 41%, 0.75);\n\tborder-color: var(--jd-color-5);\n}\n.jodit-dialog_theme_dark .jodit-add-new-line span svg {\n\tfill: var(--jd-color-1);\n}\n.jodit_theme_dark .jodit-add-new-line span svg {\n\tfill: var(--jd-color-1);\n}\n.jodit-dialog_theme_dark .jodit-resizer > i {\n\tbackground: hsla(0, 0%, 41%, 0.75);\n\tborder-color: var(--jd-color-4);\n}\n.jodit_theme_dark .jodit-resizer > i {\n\tbackground: hsla(0, 0%, 41%, 0.75);\n\tborder-color: var(--jd-color-4);\n}\n.jodit-dialog_theme_dark .jodit-input {\n\tbackground-color: var(--jd-color-4);\n\tborder-color: var(--jd-color-2);\n\tcolor: var(--jd-color-2);\n}\n.jodit-dialog_theme_dark .jodit-select {\n\tbackground-color: var(--jd-color-4);\n\tborder-color: var(--jd-color-2);\n\tcolor: var(--jd-color-2);\n}\n.jodit_theme_dark .jodit-input {\n\tbackground-color: var(--jd-color-4);\n\tborder-color: var(--jd-color-2);\n\tcolor: var(--jd-color-2);\n}\n.jodit_theme_dark .jodit-select {\n\tbackground-color: var(--jd-color-4);\n\tborder-color: var(--jd-color-2);\n\tcolor: var(--jd-color-2);\n}\n.jodit-dialog_theme_dark.jodit-dialog {\n\tbackground-color: var(--jd-color-3);\n}\n.jodit_theme_dark.jodit-dialog {\n\tbackground-color: var(--jd-color-3);\n}\n.jodit-dialog_theme_dark.jodit-dialog .jodit-dialog__header {\n\tborder-color: var(--jd-color-2);\n}\n.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item {\n\tborder-color: var(--jd-color-2);\n}\n.jodit_theme_dark.jodit-dialog .jodit-dialog__header {\n\tborder-color: var(--jd-color-2);\n}\n.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item {\n\tborder-color: var(--jd-color-2);\n}\n.jodit-dialog_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info {\n\tbackground-color: var(--jd-color-1);\n}\n.jodit_theme_dark.jodit-dialog .jodit-filebrowser__files.active .jodit-filebrowser__files-item-info {\n\tbackground-color: var(--jd-color-1);\n}\n\nbutton.jodit-toolbar-button__button {\n}\n\n.jodit_theme_dark .jodit-toolbar-button:hover:not([disabled]) {\n\tbackground: transparent;\n}\n\n.jodit_theme_dark .jodit-toolbar-button__button:hover:not([disabled]) {\n\tbackground: #ffffff14;\n\tcolor: white;\n}\n\n.jodit_theme_dark .jodit-toolbar-button__trigger:hover:not([disabled]) {\n\tbackground: #ffffff1c;\n}\n\n.jodit_theme_dark .jodit-toolbar-button .jodit-icon:hover:not([disabled]) {\n\tfill: white;\n}\n\n.jodit_theme_dark .jodit-toolbar-button svg:hover:not([disabled]) {\n\tfill: white;\n}\n\n.jodit_theme_dark .jodit-popup__content {\n\tbackground: #1d2836;\n}\n\n.jodit_theme_dark .jodit-toolbar-button__text:hover:not([disabled]) {\n\tbackground: none;\n\tcolor: white;\n}\n","@import \"app/_app-content.scss\";\n@import \"app/_app-footer.scss\";\n@import \"app/_app-header.scss\";\n@import \"app/_app-sidebar-mobile-backdrop.scss\";\n@import \"app/_app-sidebar.scss\";\n@import \"app/_app-theme-panel.scss\";\n@import \"app/_app-top-nav.scss\";\n@import \"app/_app.scss\";\n\n// Datakokpit\n.tema-2[data-bs-theme=\"dark\"]:root {\n    --bs-theme: #b8c0ff;\n    --bs-theme-rgb: 184, 192, 255;\n}\n\n.tema-2[data-bs-theme=\"light\"]:root {\n    --bs-theme: #17248a;\n    --bs-theme-rgb: 23, 36, 138;\n}\n\n.tema-2 body {\n    font-family: Arial, Helvetica, sans-serif;\n}\n\niframe#webpack-dev-server-client-overlay {\n    display: none;\n}\n\n.tema-2 ::-webkit-scrollbar {\n    background: #444fd229;\n}\n\n.tema-2 .card:not(.border-0):after,\n.tema-2 .card:not(.border-0):before {\n    display: none;\n}\n\n.tema-2 .card .card-arrow {\n    display: none;\n}\n\n.tema-2 .card {\n    border-radius: 18px;\n}\n\n.tema-2 .h6 {\n    font-size: 12px;\n}\n\n.tema-2 #sidebar.app-sidebar {\n    top: 20px;\n    width: auto;\n    right: 20px;\n    left: 210px;\n    height: 90px;\n    border-radius: 0 18px 18px 0;\n    position: absolute;\n    box-shadow: 0 0 8px rgb(0 0 0 / 5%);\n}\n\n.tema-2 #header.app-header {\n    left: 20px;\n    top: 20px;\n    height: 90px;\n    border-radius: 18px 18px 0 0;\n    box-shadow: 0px -6px 12px rgb(0 0 0 / 5%);\n}\n\n.tema-2 .app-content {\n    margin-left: 0px;\n    padding-top: 150px;\n    padding-bottom: 60px;\n}\n\n.tema-2 .app-footer {\n    margin-left: 0;\n    margin-right: 30px;\n    padding: 15px 20px;\n    border-radius: 15px;\n}\n\n.tema-2 .app-footer p {\n    margin-bottom: 0 !important;\n}\n\n.tema-2 .breaking-news {\n    margin-left: 0;\n    position: relative;\n    border-radius: 20px;\n}\n\n.tema-2 .breaking-news .breaking-news-events {\n    border-radius: 18px 18px 0 0;\n}\n\n@media (min-width: 768px) {\n    .tema-2 .app-sidebar-toggled .app-header,\n    .tema-2 .app-sidebar-toggled .app-sidebar {\n        transform: translate(-110%, 0px);\n    }\n}\n\n.tema-2 .app-sidebar-button {\n    display: none;\n    border-radius: 10px;\n}\n\n.tema-2 .app-theme-panel .app-theme-toggle-btn {\n    border-radius: 100%;\n}\n\n.tema-2 .app-theme-panel .app-theme-panel-content > div + div {\n    display: none;\n}\n\n.tema-2 .app-theme-panel .app-theme-panel-content > div:first-child {\n    margin-bottom: 0 !important;\n}\n\n.tema-2 .app-theme-panel .app-theme-panel-content {\n    border-radius: 10px;\n}\n\n.tema-2 .app-theme-panel.active .app-theme-toggle-btn {\n    border-radius: 10px 0 0 10px;\n}\n\n.tema-2 .app-sidebar .app-sidebar-content .menu {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0;\n    overflow: initial;\n    align-items: center;\n}\n\n.tema-2 .app-sidebar .app-sidebar-content {\n    height: 100%;\n    flex-direction: row;\n    overflow: initial !important;\n}\n\n.tema-2 .menu-other-dropdown {\n    display: flex;\n}\n\n.tema-2 #header.app-header {\n    width: 190px;\n    border-radius: 18px 0 0 18px;\n    position: absolute;\n}\n\n.tema-2 .menu-first-dropdown {\n    position: absolute;\n    top: 95px;\n    left: 0;\n    right: 20px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2px;\n}\n\n.tema-2 .app-sidebar .app-sidebar-content > div.mt-auto {\n    display: none;\n}\n\n.tema-2 .menu-first-dropdown .menu-item {\n    border-radius: 8px;\n}\n\n.tema-2 .menu .react-select__placeholder {\n    font-size: 11px;\n}\n\n.tema-2 .menu .react-select__control {\n    padding: 0px 5px;\n    min-height: 30px;\n}\n\n.tema-2 .menu > div > div.mx-3 {\n    margin-right: 0 !important;\n}\n\n.tema-2 .menu .react-select__option {\n    font-size: 10px;\n}\n\n@media (min-width: 1201px) {\n    .tema-2 .menu-settings {\n        display: flex;\n    }\n\n    .tema-2 .app-sidebar .app-sidebar-content .menu .menu-item .menu-submenu {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        margin-top: 0;\n        min-width: 170px;\n    }\n\n    .tema-2 .app-sidebar .app-sidebar-content .menu .menu-header {\n        padding-top: 0;\n        padding-bottom: 0;\n    }\n\n    .tema-2 .menu-item.has-sub.ps-0 {\n        padding-top: 0;\n        padding-bottom: 0;\n    }\n\n    .tema-2 .menu-item.has-sub.ps-0 {\n        position: relative;\n    }\n\n    .tema-2 .menu-other-dropdown .menu-submenu .menu-item {\n        background: var(--bs-dark4);\n    }\n}\n\n@media (max-width: 1200px) {\n    .tema-2 #sidebar.app-sidebar {\n        top: 90px;\n        left: 20px;\n        bottom: 10px;\n        width: 230px;\n        position: fixed;\n        height: auto;\n        box-shadow: none;\n        background: none;\n        transform: translate(-110%, 0px);\n    }\n\n    .tema-2 .app-sidebar .app-sidebar-content .menu {\n        display: block;\n    }\n\n    .tema-2 .app-sidebar .app-sidebar-content {\n        flex-direction: column;\n        width: 100%;\n        overflow: auto !important;\n        height: 100%;\n    }\n\n    .tema-2 .menu-other-dropdown {\n        display: block;\n    }\n\n    .tema-2 .app-sidebar .app-sidebar-content > div.mt-auto {\n        display: block;\n    }\n\n    .tema-2 #header.app-header {\n        position: fixed;\n        width: 230px;\n        border-radius: 14px;\n        height: 60px;\n    }\n\n    .tema-2 div#sidebar:before {\n        border-radius: 18px;\n        opacity: 1;\n    }\n\n    .tema-2 .app-sidebar-mobile-toggled #sidebar.app-sidebar {\n        transform: translate(0px, 0px);\n    }\n\n    .tema-2 .app-content {\n        padding-top: 110px;\n    }\n\n    .tema-2 .menu-first-dropdown {\n        position: static;\n        display: block;\n    }\n\n    .tema-2 .menu-first-dropdown .menu-item {\n        border-radius: 0;\n    }\n}\n\n.tema-2[data-bs-theme=\"dark\"] {\n    .menu-first-dropdown .menu-item {\n        background: #222a3b;\n    }\n\n    .map-info-container {\n        background: #0f1320 !important;\n    }\n}\n\n.tema-2[data-bs-theme=\"light\"] {\n    .menu-first-dropdown .menu-item {\n        background: #f4f5fd;\n    }\n}\n",".app-boxed-layout {\n\t@include media-breakpoint-up(lg) {\n\t\tmin-height: 100vh;\n\t\n\t\t&,\n\t\t& .app-header {\n\t\t\tmax-width: rem(1280px);\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t\t& .app-top-nav {\n\t\t\tmax-width: rem(1280px);\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t\toverflow: hidden;\n\t\t\t\n\t\t\t& .menu .menu-item .menu-submenu {\n\t\t\t\tposition: fixed;\n\t\t\t\tleft: auto;\n\t\t\t\tright: auto;\n\t\t\t\ttop: auto;\n\t\t\t}\n\t\t}\n\t\t& .app-sidebar {\n\t\t\t@if $enable-rtl {\n\t\t\t\tright: auto;\n\t\t\t} @else {\n\t\t\t\tleft: auto;\n\t\t\t}\n\t\t}\n\t}\n}",".app-content-full-height {\n\t& .app-content {\n\t\theight: calc(100vh - #{$app-header-height});\n\t}\n\t&.app-without-header {\n\t\t& .app-content {\n\t\t\theight: 100vh;\n\t\t}\n\t}\n}",".app-content-full-width {\n\t& .app-content {\n\t\tmargin: 0;\n\t}\n\t& .app-footer {\n\t\t@if ($enable-rtl) {\n\t\t\tmargin-right: $app-content-padding-x;\n\t\t} @else {\n\t\t\tmargin-left: $app-content-padding-x;\n\t\t}\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tmargin-right: $app-content-sm-padding-x;\n\t\t\t} @else {\n\t\t\t\tmargin-left: $app-content-sm-padding-x;\n\t\t\t}\n\t\t}\n\t}\n}",".app-footer-fixed {\n\tposition: fixed;\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-bottom: 80px;\n}\t",".app-full-height {\n\tmin-height: 100vh;\n}","@keyframes appSidebarCollapse {\n\t@if ($enable-rtl) {\n\t\tfrom {\n\t\t\tmargin-right: 0;\n\t\t\topacity: 1;\n\t\t}\n\t\tto {\n\t\t\tmargin-right: -$app-sidebar-width;\n\t\t\topacity: 0;\n\t\t}\n\t} @else {\n\t\tfrom {\n\t\t\tmargin-left: 0;\n\t\t\topacity: 1;\n\t\t}\n\t\tto {\n\t\t\tmargin-left: -$app-sidebar-width;\n\t\t\topacity: 0;\n\t\t}\n\t}\n}\n@keyframes appContentCollapse {\n\t@if ($enable-rtl) {\n\t\tfrom {\n\t\t\tmargin-right: $app-sidebar-width;\n\t\t}\n\t\tto {\n\t\t\tmargin-right: 0;\n\t\t}\n\t} @else {\n\t\tfrom {\n\t\t\tmargin-left: $app-sidebar-width;\n\t\t}\n\t\tto {\n\t\t\tmargin-left: 0;\n\t\t}\n\t}\n}\n@keyframes appFooterCollapse {\n\t@if ($enable-rtl) {\n\t\tfrom {\n\t\t\tmargin-right: $app-sidebar-width;\n\t\t}\n\t\tto {\n\t\t\tmargin-right: $app-content-padding-x;\n\t\t}\n\t} @else {\n\t\tfrom {\n\t\t\tmargin-left: $app-sidebar-width;\n\t\t}\n\t\tto {\n\t\t\tmargin-left: $app-content-padding-x;\n\t\t}\n\t}\n}\n\n.app-sidebar-collapsed {\n\t@include media-breakpoint-up(md) {\n\t\t& .app-sidebar {\n\t\t\tmargin-left: -$app-sidebar-width + 3.9;\n\t\t}\n\n\t\t.app-content {\n\t\t\tmargin-left: 3.875rem;\n\t\t}\n\n\t\t.app-sidebar {\n\t\t\t.menu {\n\t\t\t\topacity: 0;\n\t\t\t}\n\t\t}\n\n\t\t.menu-footer {\n\t\t\ttransform: translate(8px, 0);\n\n\t\t\t&-title {\n\t\t\t\topacity: 0;\n\t\t\t}\n\t\t}\n\n\t\t// & .app-sidebar {\n\t\t// \topacity: 0;\n\n\t\t// \t.app-init & {\n\t\t// \t\tanimation: appSidebarCollapse 0.15s both cubic-bezier(0.7, 0, 0.3, 1);\n\t\t// \t}\n\n\t\t// \t@if ($enable-rtl) {\n\t\t// \t\tmargin-right: -$app-sidebar-width;\n\t\t// \t} @else {\n\t\t// \t\tmargin-left: -$app-sidebar-width;\n\t\t// \t}\n\t\t// }\n\t\t// & .app-content {\n\t\t// \tanimation: appContentCollapse 0.15s both cubic-bezier(0.7, 0, 0.3, 1);\n\n\t\t// \t@if ($enable-rtl) {\n\t\t// \t\tmargin-right: 0;\n\t\t// \t} @else {\n\t\t// \t\tmargin-left: 0;\n\t\t// \t}\n\t\t// }\n\t\t// & .app-footer {\n\t\t// \tanimation: appFooterCollapse 0.15s both cubic-bezier(0.7, 0, 0.3, 1);\n\n\t\t// \t@if ($enable-rtl) {\n\t\t// \t\tmargin-right: $app-content-padding-x;\n\t\t// \t} @else {\n\t\t// \t\tmargin-left: $app-content-padding-x;\n\t\t// \t}\n\t\t// }\n\t}\n}\n",".app-sidebar-mobile-toggled {\n\t.app-sidebar {\n\t\ttransform: translate(0%, 0px);\n\t}\n}\n","@keyframes appSidebarExpand {\n\t@if ($enable-rtl) {\n\t\tfrom {\n\t\t\tmargin-right: -$app-sidebar-width;\n\t\t}\n\t\tto {\n\t\t\tmargin-right: 0;\n\t\t}\n\t} @else {\n\t\tfrom {\n\t\t\tmargin-left: -$app-sidebar-width;\n\t\t}\n\t\tto {\n\t\t\tmargin-left: 0;\n\t\t}\n\t}\n}\n@keyframes appContentExpand {\n\t@if ($enable-rtl) {\n\t\tfrom {\n\t\t\tmargin-right: 0;\n\t\t}\n\t\tto {\n\t\t\tmargin-right: $app-sidebar-width;\n\t\t}\n\t} @else {\n\t\tfrom {\n\t\t\tmargin-left: 0;\n\t\t}\n\t\tto {\n\t\t\tmargin-left: $app-sidebar-width;\n\t\t}\n\t}\n}\n@keyframes appFooterExpand {\n\t@if ($enable-rtl) {\n\t\tfrom {\n\t\t\tmargin-right: $app-content-padding-x;\n\t\t}\n\t\tto {\n\t\t\tmargin-right: $app-sidebar-width + $app-content-padding-x;\n\t\t}\n\t} @else {\n\t\tfrom {\n\t\t\tmargin-left: $app-content-padding-x;\n\t\t}\n\t\tto {\n\t\t\tmargin-left: $app-sidebar-width + $app-content-padding-x;\n\t\t}\n\t}\n}\n\n.app-sidebar-toggled {\n\t@include media-breakpoint-up(md) {\n\t\t& .app-sidebar-button {\n\t\t\ttransform: translate(100%, 0px);\n\t\t\topacity: 1;\n\t\t\tvisibility: visible;\n\t\t\tpointer-events: all;\n\n\t\t\ti {\n\t\t\t\ttransform: rotate(180deg);\n\t\t\t}\n\t\t}\n\t\t& > .app-header {\n\t\t\ttransform: translate(-100%, 0px);\n\t\t}\n\t\t& .app-sidebar {\n\t\t\ttransform: translate(-100%, 0px);\n\t\t}\n\t\t& .app-content {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\t& .breaking-news {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\t& .app-footer {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n}\n",".app-with-top-nav {\n\t@include media-breakpoint-up(md) {\n\t\tpadding-top: $app-top-nav-height + $app-header-height;\n\t\t\n\t\t& .app-sidebar {\n\t\t\ttop: $app-top-nav-height + $app-header-height;\n\t\t}\n\t}\n\t\n\t&.app-without-header {\n\t\t@include media-breakpoint-up(md) {\n\t\t\tpadding-top: $app-top-nav-height;\n\t\t\n\t\t\t& .app-sidebar {\n\t\t\t\ttop: $app-top-nav-height;\n\t\t\t}\n\t\t}\n\t}\n}",".app-without-header {\n\tpadding-top: 0;\n}",".app-without-sidebar {\n\t& .app-content {\n\t\tmargin: 0;\n\t}\n}",".breadcrumb {\n\tfont-weight: bold;\n\t\n\t& .breadcrumb-item {\n\t\t& a {\n\t\t\ttext-decoration: none;\n\t\t\t\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t\t& + .breadcrumb-item {\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tpadding-left: 0;\n\t\t\t\tpadding-right: $spacer * .5;\n\t\t\t\t\n\t\t\t\t&:before {\n\t\t\t\t\tfloat: right;\n\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\tpadding-left: $spacer * .5;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".btn-scroll-top {\n\tposition: fixed;\n\tbottom: rem(30px);\n\twidth: rem(40px);\n\theight: rem(40px);\n\tbackground: rgba($gray-800, .75);\n\tcolor: $white;\n\ttext-align: center;\n\ttext-decoration: none;\n\tz-index: $app-header-zindex;\n\tborder-radius: 36px;\n\ttransition: $btn-transition;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\t\n\t@if $enable-rtl {\n\t\tleft: rem(30px);\n\t} @else {\n\t\tright: rem(30px);\n\t}\n\t@include media-breakpoint-down(md) {\n\t\tbottom: rem(20px);\n\t\tz-index: $app-header-zindex;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tleft: rem(20px);\n\t\t} @else {\n\t\t\tright: rem(20px);\n\t\t}\n\t}\n\t\n\t&:hover {\n\t\tbackground: var(--#{$prefix}theme);\n\t\tcolor: var(--#{$prefix}theme-color);\n\t\ttext-decoration: none;\n\t}\n}",".card-expand {\n\t& .app-content {\n\t\tz-index: $app-header-zindex + 100;\n\t\tposition: relative;\n\t\theight: calc(100vh - #{$app-header-height});\n\t\toverflow: hidden;\n\t}\n}\n\n[data-bs-theme=\"light\"] {\n\t.card {\n\t\tbackground: rgba(255, 255, 255, 1);\n\t}\n}\n\n[data-bs-theme=\"dark\"] {\n\t.card {\n\t\tbackground: rgba(255, 255, 255, 0.04);\n\t}\n}\n\n.card {\n\t--#{$prefix}border-color-rgb: var(--#{$prefix}body-color-rgb);\n\tposition: relative;\n\tborder: none;\n\n\t&.border-theme {\n\t\t--#{$prefix}border-color-rgb: var(--#{$prefix}theme-rgb);\n\t}\n\t&.card-expand {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tz-index: $app-header-zindex + 100;\n\t\tborder-radius: 0;\n\t\tmargin: 0 !important;\n\t\tpadding: rem(5px);\n\t\tbackground: var(--bs-dark3);\n\t\theight: auto !important;\n\n\t\t& .card-header,\n\t\t& .card-body {\n\t\t\tborder-radius: 0;\n\t\t}\n\t\t& .card-body {\n\t\t\tflex: 1 0 0;\n\t\t\theight: auto !important;\n\t\t\toverflow: scroll;\n\t\t}\n\n\t\t&:not(.border-0):before {\n\t\t\ttop: 5px;\n\t\t\tbottom: 5px;\n\t\t\tleft: 20px;\n\t\t\tright: 20px;\n\t\t\tpointer-events: none;\n\t\t}\n\t\t&:not(.border-0):after {\n\t\t\ttop: 20px;\n\t\t\tbottom: 20px;\n\t\t\tleft: 5px;\n\t\t\tright: 5px;\n\t\t\tpointer-events: none;\n\t\t}\n\t\t& .card-arrow {\n\t\t\tmargin: 5px;\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\t& .card-header {\n\t\t& .card-header-tabs {\n\t\t\t& .nav-item {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tborder-bottom-color: transparent;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .card-body {\n\t\t& .nav-tabs {\n\t\t\t& .nav-item {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tbackground: var(--#{$prefix}card-bg);\n\t\t\t\t\t\tborder-bottom-color: var(--#{$prefix}card-bg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&:before,\n\t&:after {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tpointer-events: none;\n\t}\n\t&:not(.border-0):before {\n\t\tleft: 15px;\n\t\tright: 15px;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tborder-top: $border-width solid rgba(var(--#{$prefix}border-color-rgb), 0.3);\n\t\tborder-bottom: $border-width solid rgba(var(--#{$prefix}border-color-rgb), 0.3);\n\t}\n\t&:not(.border-0):after {\n\t\ttop: 15px;\n\t\tbottom: 15px;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tborder-left: $border-width solid rgba(var(--#{$prefix}border-color-rgb), 0.3);\n\t\tborder-right: $border-width solid rgba(var(--#{$prefix}border-color-rgb), 0.3);\n\t}\n\n\t& > *:not(.card-arrow):not(.card-img-overlay):not(.card-img):not(.hljs-container) {\n\t\tposition: relative;\n\t\tz-index: 10;\n\t}\n\t& .card-arrow {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tpointer-events: none;\n\t}\n\t& .card-arrow-top-left,\n\t& .card-arrow-top-right,\n\t& .card-arrow-bottom-left,\n\t& .card-arrow-bottom-right {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\tposition: absolute;\n\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\twidth: 2px;\n\t\t\theight: 8px;\n\t\t\tbackground: rgba(var(--#{$prefix}border-color-rgb), 0.75);\n\t\t}\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\twidth: 10px;\n\t\t\theight: 2px;\n\t\t\tbackground: rgba(var(--#{$prefix}border-color-rgb), 0.75);\n\t\t}\n\t}\n\t& .card-arrow-top-left,\n\t& .card-arrow-top-right {\n\t\ttop: 0;\n\n\t\t&:before {\n\t\t\ttop: 2px;\n\t\t}\n\t\t&:after {\n\t\t\ttop: 0;\n\t\t}\n\t}\n\t& .card-arrow-bottom-left,\n\t& .card-arrow-bottom-right {\n\t\tbottom: 0;\n\n\t\t&:before {\n\t\t\tbottom: 2px;\n\t\t}\n\t\t&:after {\n\t\t\tbottom: 0;\n\t\t}\n\t}\n\t& .card-arrow-top-left,\n\t& .card-arrow-bottom-left {\n\t\tleft: 0;\n\n\t\t&:before,\n\t\t&:after {\n\t\t\tleft: 0;\n\t\t}\n\t}\n\t& .card-arrow-top-right,\n\t& .card-arrow-bottom-right {\n\t\tright: 0;\n\n\t\t&:before,\n\t\t&:after {\n\t\t\tright: 0;\n\t\t}\n\t}\n}\n",".card-columns {\n  @include media-breakpoint-down(lg) {\n    column-count: 2;\n  }\n  @include media-breakpoint-down(sm) {\n    column-count: 1;\n  }\n}",".caret {\n\t&:before {\n\t\tcontent: \"\\f22c\";\n\t\tdisplay: inline-block;\n    font-family: bootstrap-icons!important;\n    font-style: normal;\n    font-weight: 400!important;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    vertical-align: -.125em;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\t}\n}\n.dropup {\n\t&.caret,\n\t& .caret {\n\t\tcontent: '';\n\t\tborder-top: 0;\n\t\tborder-bottom: 4px dashed;\n\t\tborder-bottom: 4px solid\\9;\n  }\n}",".carousel-indicators [data-bs-target] {\n\toverflow: hidden;\n}","@keyframes appDropdownShow {\n\tfrom { opacity: 0; }\n\tto { opacity: 1; }\n}\n\n.dropdown-menu {\n\tbox-shadow: $dropdown-box-shadow;\n\t\n\t&.show {\n\t\tanimation: appDropdownShow 0.25s both cubic-bezier(0.7, 0, 0.3, 1);\n\t}\n}\n.dropdown {\n\t&.dropdown-mobile-full {\n\t\t@include media-breakpoint-down(sm) {\n\t\t\tposition: initial;\n\t\t\n\t\t\t& .dropdown-menu {\n\t\t\t\tleft: $spacer * .25 !important;\n\t\t\t\tright: $spacer * .25 !important;\n\t\t\t\twidth: auto !important;\n\t\t\t}\n\t\t}\n\t}\n}","@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n\t\t.form-check-input:checked[type=checkbox] {\n\t\t\t--#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image-dark)};\n\t\t}\n\t}\n}","@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n\t\t.form-check-input:checked[type=radio] {\n\t\t\t--#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image-dark)};\n\t\t}\n\t}\n}",".form-select:not([multiple]) {\n\t& option {\n\t\tcolor: $black;\n\t}\n}","@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n\t\t& .form-switch {\n\t\t\t& .form-check-input {\n\t\t\t\t--#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n\n\t\t\t\t&:focus {\n\t\t\t\t\t--#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image-dark)};\n\t\t\t\t}\n\n\t\t\t\t&:checked {\n\t\t\t\t\t@if $enable-gradients {\n\t\t\t\t\t\t--#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image-dark)}, var(--#{$prefix}gradient);\n\t\t\t\t\t} @else {\n\t\t\t\t\t\t--#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image-dark)};\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","hr {\n\t&.hr-bg,\n\t&.hr-transparent,\n\t&.hr-inverse,\n\t&.hr-inverse-transparent {\n\t\tborder: none;\n\t\theight: 1px;\n\t}\n\t&.hr-transparent {\n\t\tbackground-color: rgba($black, .3);\n\t}\n\t&.hr-inverse {\n\t\tbackground-color: lighten($black, 10%);\n\t}\n\t&.hr-inverse-transparent {\n\t\tbackground-color: rgba($white, .3);\n\t}\n}","a {\n\tcolor: var(--#{$prefix}theme);\n\t\n\t&:hover {\n\t\tcolor: rgba(#{var(--#{$prefix}theme-rgb)}, .75);\n\t}\n}",".modal {\n\t& .modal-content {\n\t\t& > * {\n\t\t\tposition: relative;\n\t\t}\n\t}\n\t& .modal-dialog{\n\t\t&.modal-full {\n\t\t\tmax-width: 100%;\n\t\t\twidth: 100%;\n\t\t\t\n\t\t\t& .modal-content {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\t&.modal-cover {\n\t\t& .modal-dialog {\n\t\t\tmin-height: 100%;\n\t\t\tmargin-top: 0;\n\t\t\tmargin-bottom: 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t\t& .modal-content,\n\t\t& .modal-header,\n\t\t& .modal-footer {\n\t\t\tbackground: none;\n\t\t\tborder: none;\n\t\t}\n\t}\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n  \t.modal-backdrop {\n  \t\t--#{$prefix}backdrop-bg: #{$modal-backdrop-bg-dark};\n  \t}\n  }\n}\n\n",".nav {\n\t&.nav-pills {\n\t\t&::-webkit-scrollbar {\n\t\t\theight: 5px;\n\t\t}\n\t}\n\n\t&.nav-tabs {\n\t\t&.nav-tabs-v2 {\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\theight: 5px;\n\t\t\t}\n\n\t\t\t& > .nav-item {\n\t\t\t\t& > .nav-link {\n\t\t\t\t\tborder: none;\n\t\t\t\t\tborder-bottom: 3px solid transparent;\n\t\t\t\t\tpadding: $nav-link-padding-x 0;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tcolor: $nav-tabs-link-active-color;\n\t\t\t\t\t\tborder-bottom-color: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.show {\n\t\t\t\t\t& > .nav-link {\n\t\t\t\t\t\tcolor: $nav-tabs-link-active-color;\n\t\t\t\t\t\tborder-bottom-color: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".nav-wizards-container {\n\t@include media-breakpoint-down(md) {\n\t\toverflow: scroll;\n\t\t\n\t\t& .nav.nav-wizards-1,\n\t\t& .nav.nav-wizards-2,\n\t\t& .nav.nav-wizards-3 {\n\t\t\tmin-width: rem(600px);\n\t\t}\n\t}\n}\n\n.nav {\n\t&.nav-wizards-1 {\n\t\t& .nav-item {\n\t\t\tpadding: 0;\n\t\t\t\n\t\t\t& .nav-link {\n\t\t\t\tposition: relative;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\t\n\t\t\t\t& .nav-no {\n\t\t\t\t\twidth: rem(40px);\n\t\t\t\t\theight: rem(40px);\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tborder: 2px solid var(--#{$prefix}border-color);\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\tborder-radius: 40px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t}\n\t\t\t\t& .nav-text {\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tmargin-top: rem(5px);\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t}\n\t\t\t\t&.active,\n\t\t\t\t&.completed {\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\n\t\t\t\t\t& .nav-no {\n\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t\t&:before,\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t& .nav-no {\n\t\t\t\t\t\tbox-shadow: 0 0 0 5px rgba(var(--#{$prefix}theme-rgb), .2);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: $nav-link-padding-x + rem(10px);\n\t\t\t\t\theight: rem(2px);\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .3);\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tleft: calc(-50% + 20px);\n\t\t\t\t\tright: calc(50% + 20px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:first-child {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.nav-wizards-2 {\n\t\t& .nav-item {\n\t\t\tpadding: 0 $nav-link-padding-x;\n\t\t\t\n\t\t\t& .nav-link {\n\t\t\t\tposition: relative;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tborder-radius: 60px;\n\t\t\t\t\n\t\t\t\t& .nav-text {\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: $nav-link-padding-x * -2;\n\t\t\t\t\tright: 100%;\n\t\t\t\t\theight: rem(2px);\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tmargin-top: rem(-1px);\n\t\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .3);\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t}\n\t\t\t\t&.disabled {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .35);\n\t\t\t\t}\n\t\t\t\t&.active,\n\t\t\t\t&.completed {\n\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tbox-shadow: 0 0 0 4px rgba(var(--#{$prefix}theme-rgb), .2);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:first-child {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.nav-wizards-3 {\n\t\t& .nav-item {\n\t\t\tpadding: 0;\n\t\t\t\n\t\t\t& .nav-link {\n\t\t\t\tposition: relative;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\t\n\t\t\t\t& .nav-dot {\n\t\t\t\t\twidth: rem(16px);\n\t\t\t\t\theight: rem(16px);\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tborder: 3px solid var(--#{$prefix}border-color);\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t}\n\t\t\t\t& .nav-title {\n\t\t\t\t\tmargin-top: rem(10px);\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t\t& .nav-text {\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t}\n\t\t\t\t&.active,\n\t\t\t\t&.completed {\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\n\t\t\t\t\t& .nav-dot {\n\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t& .nav-dot {\n\t\t\t\t\t\tbox-shadow: 0 0 0 5px rgba(var(--#{$prefix}theme-rgb), .2);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: calc(-50% + 8px);\n\t\t\t\t\ttop: $nav-link-padding-y + rem(6px);\n\t\t\t\t\tright: calc(50% + 8px);\n\t\t\t\t\theight: rem(3px);\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .3);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:first-child {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".navbar {\n\t&.navbar-sticky {\n\t\ttop: $app-header-height + $app-content-padding-y;\n\t\tposition: sticky;\n\t\tpadding: 0;\n\n\t\t@if $enable-rtl {\n\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\tmargin-right: $spacer;\n\t\t} @else {\n\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\tmargin-left: $spacer;\n\t\t}\n\t\t\n\t\t& .nav {\n\t\t\twidth: 100%;\n\t\t\tflex-direction: column;\n\t\t\t\n\t\t\t& .nav-link {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .6);\n\t\t\t\tpadding: $spacer * .25 $spacer * 1.5;\n\t\t\t\t\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), 1);\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".page-header {\n\tcolor: var(--#{$prefix}heading-color);\n\tpadding: 0;\n\tborder: none;\n\tmargin-bottom: $spacer;\n\tfont-weight: $font-weight-bold;\n\tfont-size: rem(28px);\n\t\n\t& small {\n\t\tfont-size: rem(16px);\n\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\tfont-weight: $font-weight-light;\n\t}\n}",".pagination {\n\t& .page-item {\n\t\t& .page-link {\n\t\t\tborder-radius: rem($border-radius);\n\t\t}\n\t\t& + .page-item {\n\t\t\t@if $enable-rtl {\n\t\t\t\tmargin-right: rem(5px);\n\t\t\t} @else {\n\t\t\t\tmargin-left: rem(5px);\n\t\t\t}\n\t\t}\n\t}\n}","pre {\n\tdisplay: block;\n\tpadding: rem(16px);\n\tfont-size: $font-size-base;\n\tcolor: $gray-700;\n\tword-break: break-all;\n\tword-wrap: break-word;\n\tbackground-color: $white;\n\tborder: 1px solid $gray-200;\n\tborder-radius: $border-radius;\n}",".row.row-grid {\n\t& > [class*=\"col-\"] {\n\t\t& + [class*=\"col-\"] {\n\t\t\tborder-left: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t}\n\t}\n\t& + .row-grid {\n\t\tborder-top: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15);\n\t}\n}",".table {\n\t&.table-card {\n\t\t& thead,\n\t\t& tbody {\n\t\t\t& > tr {\n\t\t\t\t& td,\n\t\t\t\t& th {\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-right: $card-spacer-x;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-left: $card-spacer-x;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-left: $card-spacer-x;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-right: $card-spacer-x;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.table-xs {\n\t\tfont-size: rem(12px);\n\t\t\n\t\t& thead,\n\t\t& tbody,\n\t\t& tfoot {\n\t\t\t& th {\n\t\t\t\tpadding-top: rem(4px);\n\t\t\t\tpadding-bottom: rem(4px);\n\t\t\t\tpadding-left: rem(8px);\n\t\t\t}\n\t\t\t& td {\n\t\t\t\tpadding: rem(5px) rem(8px);\n\t\t\t}\n\t\t}\n\t}\n}",".toasts-container {\n\tposition: fixed;\n\ttop: 5px;\n\tpadding-top: $app-content-padding-y * 0.5;\n\twidth: rem(350px);\n\tz-index: 9999;\n\n\t@if $enable-rtl {\n\t\tleft: 0;\n\t\tpadding-left: $app-content-padding-y * 0.5;\n\t} @else {\n\t\tright: 0;\n\t\tpadding-right: $app-content-padding-y * 0.5;\n\t}\n\n\t@include media-breakpoint-down(md) {\n\t\twidth: rem(300px);\n\t}\n\n\t& .toast {\n\t\twidth: 100%;\n\t}\n}\n",".apexcharts-canvas {\n\t& .apexcharts-tooltip {\n\t\tfont-size: rem(13px);\n\t\tbox-shadow: $dropdown-box-shadow;\n\t\t\n\t\t& * {\n\t\t\tfont-family: inherit !important;\n\t\t}\n\t\t&.apexcharts-theme-light,\n\t\t&.apexcharts-theme-dark {\n\t\t\tborder: none;\n\t\t\tbackground: rgba(var(--#{$prefix}body-bg-rgb), .9);\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\n\t\t\t& .apexcharts-tooltip-title {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tborder-color: transparent;\n\t\t\t\tcolor: var(--#{$prefix}inverse);;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\t\t& .apexcharts-tooltip-title {\n\t\t\tfont-family: inherit !important;\n\t\t\tfont-weight: $headings-font-weight;\n\t\t\tpadding: $spacer * .35 $spacer * .75;\n\t\t\tmargin: 0;\n\t\t}\n\t\t& .apexcharts-tooltip-series-group {\n\t\t\tpadding: $spacer * .35 $spacer * .75;\n\t\t\t\n\t\t\t& .apexcharts-tooltip-marker {\n\t\t\t\twidth: rem(10px);\n\t\t\t\theight: rem(10px);\n\t\t\t\tmargin-right: $spacer * .25;\n\t\t\t}\n\t\t\t& .apexcharts-tooltip-text {\n\t\t\t\t& .apexcharts-tooltip-y-group {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& + .apexcharts-tooltip-series-group {\n\t\t\t\tpadding-top: 0;\n\t\t\t}\n\t\t}\n\t}\n\t& .apexcharts-xaxistooltip {\n\t\t& * {\n\t\t\tfont-family: inherit !important;\n\t\t}\n\t\t&.apexcharts-theme-light,\n\t\t&.apexcharts-theme-dark {\n\t\t\tcolor: $white;\n\t\t\tbackground: $gray-800;\n\t\t\tborder-color: $gray-800;\n\t\t\t\n\t\t\t&.apexcharts-xaxistooltip-bottom {\n\t\t\t\t&:before {\n\t\t\t\t\tborder-bottom-color: $gray-800;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tborder-bottom-color: $gray-800;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.apexcharts-xaxistooltip-top {\n\t\t\t\t&:before {\n\t\t\t\t\tborder-top-color: $gray-800;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tborder-top-color: $gray-800;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .apexcharts-yaxistooltip {\n\t\t& * {\n\t\t\tfont-family: inherit !important;\n\t\t}\n\t\t&.apexcharts-theme-light,\n\t\t&.apexcharts-theme-dark {\n\t\t\tcolor: $white;\n\t\t\tbackground: $gray-800;\n\t\t\tborder-color: $gray-800;\n\t\t\t\n\t\t\t&.apexcharts-yaxistooltip-right {\n\t\t\t\t&:before {\n\t\t\t\t\tborder-right-color: $gray-800;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tborder-right-color: $gray-800;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.apexcharts-yaxistooltip-left {\n\t\t\t\t&:before {\n\t\t\t\t\tborder-left-color: $gray-800;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tborder-left-color: $gray-800;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .apexcharts-legend-marker {\n\t\twidth: rem(10px) !important;\n\t\theight: rem(10px) !important;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tmargin-left: rem(5px);\n\t\t} @else {\n\t\t\tmargin-right: rem(5px);\n\t\t}\n\t}\n\t& .apexcharts-menu {\n\t\tbackground: $dropdown-bg;\n\t\tborder: none;\n\t\tpadding: 0;\n\t\tborder-radius: $dropdown-border-radius;\n\t\tbox-shadow: $dropdown-box-shadow;\n\t\t\n\t\t& .apexcharts-menu-item {\n\t\t\tcolor: $dropdown-link-color;\n\t\t\t\n\t\t\t&:hover {\n\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\tcolor: $dropdown-link-hover-color;\n\t\t\t}\n\t\t}\n\t}\n\t&.apexcharts-theme-light {\n\t\t& .apexcharts-selection-icon:not(.apexcharts-selected),\n\t\t& .apexcharts-zoom-icon:not(.apexcharts-selected),\n\t\t& .apexcharts-zoomin-icon,\n\t\t& .apexcharts-zoomout-icon,\n\t\t& .apexcharts-reset-icon,\n\t\t& .apexcharts-menu-icon {\n\t\t\t&:hover {\n\t\t\t\t& svg {\n\t\t\t\t\tfill: $white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".daterangepicker {\n\tbody & {\n\t\tz-index: $app-header-zindex + 10;\n\t\tborder-color: $dropdown-border-color;\n\t\tfont-family: inherit;\n\t\tfont-size: inherit;\n\t\tbackground: $dropdown-bg;\n\t\tborder-radius: 0;\n\t\tbox-shadow: $dropdown-box-shadow;\n\t\twidth: auto;\n\t\t\n\t\t&:before,\n\t\t&:after {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&:after {\n\t\t\tborder-width: rem(7px);\n\t\t\ttop: rem(-7px);\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\tright: rem(10px);\n\t\t\t\tleft: auto;\n\t\t\t} @else {\n\t\t\t\tleft: rem(10px);\n\t\t\t}\n\t\t}\n\t\t&.opensright {\n\t\t\t&:after {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tleft: rem(10px);\n\t\t\t\t\tright: auto;\n\t\t\t\t} @else {\n\t\t\t\t\tright: rem(10px);\n\t\t\t\t\tleft: auto;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& select.monthselect,\n\t\t& select.yearselect {\n\t\t\tfont-size: $font-size-base * .9;\n\t\t}\n\t\t& .drp-calendar {\n\t\t\tmax-width: inherit;\n\t\t\tpadding: rem(12px);\n\t\t\t\n\t\t\t& .calendar-table {\n\t\t\t\tbackground: none;\n\t\t\t\tborder: none;\n\t\t\t\tborder-radius: 0;\n\t\t\t\t\n\t\t\t\t& table {\n\t\t\t\t\t& thead,\n\t\t\t\t\t& tbody {\n\t\t\t\t\t\t& .week {\n\t\t\t\t\t\t\tfont-size: $font-size-base * .85;\n\t\t\t\t\t\t\tcolor: $gray-100;\n\t\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& thead {\n\t\t\t\t\t\t& tr {\n\t\t\t\t\t\t\t& th {\n\t\t\t\t\t\t\t\tmin-width: auto;\n\t\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\t\t\tpadding: rem(6px) rem(12px);\n\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\t\t\tfont-size: inherit;\n\t\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t&.prev,\n\t\t\t\t\t\t\t\t&.next {\n\t\t\t\t\t\t\t\t\t& span {\n\t\t\t\t\t\t\t\t\t\tborder-color: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t& span {\n\t\t\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.month {\n\t\t\t\t\t\t\t\t\t& .yearselect,\n\t\t\t\t\t\t\t\t\t& .monthselect {\n\t\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}border-color);\n\t\t\t\t\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\t\t\t\toutline: none;\n\t\t\t\t\t\t\t\t\t\t\tborder-color: $input-focus-border-color;\n\t\t\t\t\t\t\t\t\t\t\tbox-shadow: 0 0 0 0.125rem $input-focus-border-color;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t& th {\n\t\t\t\t\t\t\t\t\tfont-size: $font-size-base * .85;\n\t\t\t\t\t\t\t\t\tpadding-bottom: rem(8px);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& tbody {\n\t\t\t\t\t\t& tr {\n\t\t\t\t\t\t\t& td {\n\t\t\t\t\t\t\t\tmin-width: auto;\n\t\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\t\tline-height: 1.3;\n\t\t\t\t\t\t\t\tpadding: rem(10px) rem(6px);\n\t\t\t\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\t\t\t\t\tborder-color: $dropdown-border-color;\n\t\t\t\t\t\t\t\tfont-size: $font-size-base * .9;\n\t\t\t\t\t\t\t\tborder-radius: 0 !important;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t&.available {\n\t\t\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.in-range {\n\t\t\t\t\t\t\t\t\t\tbackground: rgba(var(--#{$prefix}theme-rgb), .25);\n\t\t\t\t\t\t\t\t\t\tborder-color: rgba(var(--#{$prefix}theme-rgb), .5);\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.start-date {\n\t\t\t\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.end-date {\n\t\t\t\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.off {\n\t\t\t\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.left {\n\t\t\t\tpadding: rem(12px) !important;\n\t\t\t\t\n\t\t\t\t& .calendar-table {\n\t\t\t\t\tpadding: 0 !important;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.right {\n\t\t\t\tpadding: rem(12px) !important;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tborder-right: none;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tborder-left: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .drp-buttons {\n\t\t\tpadding: rem(12px) rem(12px);\n\t\t\tborder-color: var(--#{$prefix}border-color);\n\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .05);\n\t\t\tborder: none;\n\t\t\t\n\t\t\t& .btn {\n\t\t\t\t&.btn-primary {\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tborder: 1px solid var(--#{$prefix}btn-border-color);\n\t\t\t\t\tcolor: var(--#{$prefix}btn-color);\n\t\t\t\t\t\n\t\t\t\t\t@include button-outline-variant($theme, $theme);\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:active {\n\t\t\t\t\t\tbackground: var(--#{$prefix}btn-hover-bg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.btn-default {\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tborder: 1px solid var(--#{$prefix}btn-border-color);\n\t\t\t\t\tcolor: var(--#{$prefix}btn-color);\n\t\t\t\t\t\n\t\t\t\t\t@include button-outline-variant($default, $default);\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:active {\n\t\t\t\t\t\tcolor: $black;\n\t\t\t\t\t\tbackground: var(--#{$prefix}btn-hover-bg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .ranges {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&.show-ranges {\n\t\t\t& .ranges {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: block;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tfloat: none;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tpadding: rem(10px);\n\t\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\toverflow: scroll;\n\t\t\t\t\tmax-width: rem(560px);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& ul {\n\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-wrap: nowrap;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-left: rem(10px);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-right: rem(10px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t& li {\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t\t\tfont-weight: $font-weight-base;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\tmargin-left: rem(10px) !important;\n\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\tmargin-right: rem(10px) !important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\tmargin-left: rem(-1px);\n\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\tmargin-right: rem(-1px);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .drp-calendar {\n\t\t\t\t&.left { \n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tborder-right: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15) !important;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tborder-left: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15) !important;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tborder-right: none !important;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tborder-left: none !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".dataTables_wrapper {\n\t&.dt-bootstrap5 {\n\t\t& .dataTables_length {\n\t\t\t& .form-select {\n\t\t\t\tmargin: 0 $spacer * .5;\n\t\t\t}\n\t\t}\n\t\t& .dataTables_scrollFootInner,\n\t\t& .dataTables_scrollHeadInner {\n\t\t\t& .table-bordered tr th:first-child {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color) !important;\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .dataTables_scrollFoot {\n\t\t\tz-index: 1020;\n\t\t\tmargin-top: rem(-2px) !important;\n\t\t\tposition: inherit;\n\t\t\t\n\t\t\t& .dataTables_scrollFootInner {\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color) !important;\n\t\t\t}\n\t\t}\n\t\t& .dataTables_scrollBody {\n\t\t\tborder-left: none !important;\n\t\t\t\n\t\t\t& thead {\n\t\t\t\t& > tr {\n\t\t\t\t\t& > th,\n\t\t\t\t\t& > td {\n\t\t\t\t\t\t&.sorting {\n\t\t\t\t\t\t\t&:before,\n\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t// display: none !important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .dt-buttons {\n\t\t\t& .btn-outline-default {\n\t\t\t\tbackground-color: transparent;\n\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tbackground-color: $default;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .dataTable {\n\t\t\t&.dtr-inline {\n\t\t\t\t& tr {\n\t\t\t\t\t& td {\n\t\t\t\t\t\t&.dtr-control {\n\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\tborder-width: 1px;\n\t\t\t\t\t\t\t\tmargin-top: -8px;\n\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}border-color);\n\t\t\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover:before {\n\t\t\t\t\t\t\t\tbackground: var(--#{$prefix}border-color);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.parent {\n\t\t\t\t\t\t& td {\n\t\t\t\t\t\t\t&.dtr-control {\n\t\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& thead {\n\t\t\t\t& > tr {\n\t\t\t\t\t& > th,\n\t\t\t\t\t& > td {\n\t\t\t\t\t\t&.sorting,\n\t\t\t\t\t\t&.sorting_asc,\n\t\t\t\t\t\t&.sorting_desc,\n\t\t\t\t\t\t&.sorting_asc_disabled,\n\t\t\t\t\t\t&.sorting_desc_disabled {\n\t\t\t\t\t\t\tpadding-right: rem(30px);\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\tcontent: '\\F235';\n\t\t\t\t\t\t\t\ttop: 20%;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t@include bootstrap-icons();\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\t\tcontent: '\\F229';\n\t\t\t\t\t\t\t\ttop: 45%;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t@include bootstrap-icons();\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.sorting_asc:before, \n\t\t\t\t\t\t&.sorting_desc:after {\n\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& thead,\n\t\t\t& tbody,\n\t\t\t& tfoot {\n\t\t\t\t& .dtfc-fixed-left,\n\t\t\t\t& .dtfc-fixed-right {\n\t\t\t\t\tz-index: 1;\n\t\t\t\t\tbackground-color: var(--#{$prefix}body-bg);\n\t\t\t\t\t\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tborder-left: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.dtfc-has-left {\n\t\t\t\t& tfoot {\n\t\t\t\t\tborder: none !important;\n\t\t\t\t\t\n\t\t\t\t\t& > tr {\n\t\t\t\t\t\theight: 0 !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .dataTables_empty {\n\t\t\t\t\ttext-align: left !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .dtfc-right-top-blocker {\n\t\t\theight: auto !important;\n\t\t\tmargin-top: 0 !important;\n\t\t\tbackground: var(--#{$prefix}border-color) !important;\n\t\t}\n\t}\n}","@mixin bootstrap-icons() {\n\tdisplay: inline-block;\n\tfont-family: bootstrap-icons!important;\n\tfont-style: normal;\n\tfont-weight: 400!important;\n\tfont-variant: normal;\n\ttext-transform: none;\n\tline-height: 1;\n\tvertical-align: -0.125em;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}",".fc-event-list {\n\t& .fc-event-item {\n\t\t& .fc-event-link {\n\t\t\tpadding: $spacer * .35 $spacer * .7;\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\tposition: relative;\n\t\t\tborder: 1px solid var(--#{$prefix}border-color);\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tborder-radius: $border-radius;\n\t\t\t\n\t\t\t&:hover {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tcontent: '\\f0b2';\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\tline-height: 1;\n\t\t\t\tmargin-left: auto;\n\t\t\t\t\n\t\t\t\t@include fontawesome();\n\t\t\t}\n\t\t}\n\t\t& + .fc-event-item {\n\t\t\tmargin-top: $spacer * .5;\n\t\t}\n\t}\n}\n.fc-event-link {\n\t&.fc-dragging,\n\t&.fc-event-dragging {\n\t\tpadding: $spacer * .35 $spacer * .7;\n\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\tborder: 1px solid var(--#{$prefix}border-color);\n\t\tcolor: var(--#{$prefix}inverse);\n\t\tdisplay: block;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tborder-radius: $border-radius;\n\t\tbox-shadow: $dropdown-box-shadow;\n\t}\n}\n.fc {\n\t& .fc-toolbar,\n\t& .fc-header-toolbar {\n\t\tmargin-bottom: 0 !important;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t\t\n\t\t& .fc-left,\n\t\t& .fc-toolbar-chunk:nth-child(1) {\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer;\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t\n\t\t\t& .btn-group {\n\t\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t \t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .btn {\n\t\t\t\tmin-width: rem(100px);\n\t\t\t\tbackground: none;\n\t\t\t\tpadding-top: $spacer * .2;\n\t\t\t\tpadding-bottom: $spacer * .2;\n\t\t\t\tcolor: var(--#{$prefix}btn-color);\n\t\t\t\t\n\t\t\t\t@include button-outline-variant($default, $default);\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tmin-width: rem(90px);\n\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:active {\n\t\t\t\t\tcolor: $black;\n\t\t\t\t\tbackground: var(--#{$prefix}btn-hover-bg);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t@if $enable-rtl {\n\t\t\t& .fc-toolbar-chunk {\n\t\t\t\t& .btn-group {\n\t\t\t\t\t& > .btn {\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\n\t\t\t\t\t\t& + .btn {\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t\tmargin-left: -1px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tborder-top-left-radius: $border-radius;\n\t\t\t\t\t\t\tborder-bottom-left-radius: $border-radius;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tborder-top-right-radius: $border-radius;\n\t\t\t\t\t\t\tborder-bottom-right-radius: $border-radius;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .fc-center,\n\t\t& .fc-toolbar-chunk:nth-child(2) {\n\t\t\tflex: 1;\n\t\t\tpadding: $spacer;\n\t\t}\n\t\t& .fc-right,\n\t\t& .fc-toolbar-chunk:nth-child(3) {\n\t\t\tpadding: $spacer;\n\t\t\t\n\t\t\t& .btn {\n\t\t\t\tpadding-top: $spacer * .2;\n\t\t\t\tpadding-bottom: $spacer * .2;\n\t\t\t\tbackground: none;\n\t\t\t\t\n\t\t\t\t@include button-outline-variant($default, $default);\n\t\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:active {\n\t\t\t\t\tcolor: $black;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .fc-view {\n\t\t& .fc-event,\n\t\t& .fc-event-dot {\n\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\tborder-color: transparent;\n\t\t\t\n\t\t\t&.fc-daygrid-dot-event {\n\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n\t\t&.fc-dayGrid-view,\n\t\t&.fc-dayGridMonth-view {\n\t\t\t& .fc-week-number,\n\t\t\t& .fc-day-number,\n\t\t\t& .fc-daygrid-day-number {\n\t\t\t\tpadding: rem(2px) rem(4px);\n\t\t\t}\n\t\t\t& .fc-day-grid-event,\n\t\t\t& .fc-daygrid-day-events {\n\t\t\t\tmargin-top: rem(2px);\n\t\t\t}\n\t\t}\n\t\t&.fc-timeGrid-view {\n\t\t\t& .fc-time-grid {\n\t\t\t\t& .fc-slats,\n\t\t\t\t& .fc-bg {\n\t\t\t\t\t& table {\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& tbody,\n\t\t\t\t\t\t& thead {\n\t\t\t\t\t\t\t& tr {\n\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t& td {\n\t\t\t\t\t\t\t\t\t\tborder-top: none;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .fc-content-skeleton {\n\t\t\t\t\t& table {\n\t\t\t\t\t\tborder: none !important;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& td,\n\t\t\t\t\t\t& th {\n\t\t\t\t\t\t\tborder: none !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& a {\n\t\t\ttext-decoration: none;\n\t\t}\n\t\t& .fc-daygrid-event,\n\t\t& .fc-timegrid-event-harness-inset .fc-timegrid-event, \n\t\t& .fc-timegrid-event.fc-event-mirror, \n\t\t& .fc-timegrid-more-link {\n\t\t\tbox-shadow: none;\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\t& td,\n\t& th {\n\t\tborder-width: 1px;\n\t\tborder-color: $table-border-color;\n\t}\n\t& .fc-view-harness {\n\t\theight: auto !important;\n\t}\n\t& .fc-scroller-liquid-absolute {\n\t\tposition: relative !important;\n\t\toverflow: initial !important;\n\t}\n\t& a:not([href]) {\n\t\tcolor: inherit;\n\t}\n}",".hljs {\n  display: block;\n  overflow-x: auto;\n  color: var(--#{$prefix}gray-500);\n  font-size: $font-size-base * .9;\n}\n.hljs-code,\n.hljs-emphasis {\n  font-style: italic;\n}\n.hljs-tag,\n.hljs-name {\n\tcolor: var(--#{$prefix}gray-300);\n}\n.hljs-string,\n.hljs-bullet {\n  color: var(--#{$prefix}indigo);\n}\n.hljs-attr {\n\tcolor: var(--#{$prefix}teal);\n}\n.hljs a {\n  color: inherit;\n  \n\t&:focus,\n\t&:hover {\n\t\tcolor: inherit;\n\t\ttext-decoration: underline;\n\t}\n}\n.hljs-container {\n  padding: $card-spacer-y $card-spacer-x;\n  border-top: 1px solid var(--#{$prefix}border-color);\n  position: relative;\n  z-index: 1;\n\t\n\t& pre {\n\t\tborder: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tbackground: none;\n\t\tborder-radius: 0;\n\t}\n}",".ps {\n\tposition: relative;\n\t\n\t& .ps__rail-x,\n\t& .ps__rail-y {\n\t\tz-index: 10;\n\t\t\n\t\t&.ps--clicking,\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tbackground: none;\n\t\t}\n\t}\n\t& .ps__thumb-y {\n\t\tborder-radius: 0;\n\t\tbackground: none;\n\t\t\n\t\t&:before {\n\t\t\tcontent: '';\n\t\t\tbackground: #aaa;\n\t\t\tposition: absolute;\n\t\t\ttop: rem(1px);\n\t\t\tbottom: rem(1px);\n\t\t\tright: 0;\n\t\t\tleft: 0;\n\t\t}\n\t}\n}\n.app-sidebar .ps__rail-x,\n.app-sidebar .ps__rail-y {\n\tdisplay: none;\n}",".rdt {\n\t& .rdtPicker {\n\t\twidth: auto;\n\t\tbackground: $dropdown-bg;\n\t\tborder: 1px solid $dropdown-border-color;\n\t\tbox-shadow: $box-shadow;\n\t\t\n\t\t& table {\n\t\t\t& thead {\n\t\t\t\t& tr {\n\t\t\t\t\t& th {\n\t\t\t\t\t\t&.rdtPrev,\n\t\t\t\t\t\t&.rdtNext,\n\t\t\t\t\t\t&.rdtSwitch {\n\t\t\t\t\t\t\tline-height: 20px;\n\t\t\t\t\t\t\tpadding: 5px;\n\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\tmin-height: 30px;\n\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t& span:before {\n\t\t\t\t\t\t\t\t\tcolor: $dropdown-link-hover-color;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.rdtPrev,\n\t\t\t\t\t\t&.rdtNext {\n\t\t\t\t\t\t\tcolor: transparent;\n\t\t\t\t\t\t\twidth: 14.28%;\n\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t& span {\n\t\t\t\t\t\t\t\tcolor: transparent;\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t& i {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.rdtPrev {\n\t\t\t\t\t\t\t& span:before {\n\t\t\t\t\t\t\t\tcontent: '\\f104';\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.rdtNext {\n\t\t\t\t\t\t\t& span:before {\n\t\t\t\t\t\t\t\tcontent: '\\f105';\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.rdtSwitch {\n\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.dow {\n\t\t\t\t\t\t\tpadding: 5px 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& tfoot {\n\t\t\t\tborder: none;\n\t\t\t\t\n\t\t\t\t& tr {\n\t\t\t\t\t& td {\n\t\t\t\t\t\t&.rdtTimeToggle {\n\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\t\ttext-shadow: none;\n\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\n\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\t\t\t\ttext-shadow: none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .rdtTime {\n\t\t\tmin-width: 180px;\n\t\t\t\n\t\t\t& .rdtCounters {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t\n\t\t\t\t& > div {\n\t\t\t\t\tfloat: none;\n\t\t\t\t}\n\t\t\t\t& .rdtCounter {\n\t\t\t\t\theight: 110px;\n\t\t\t\t\twidth: 60px;\n\t\t\t\t\t\n\t\t\t\t\t& .rdtBtn {\n\t\t\t\t\t\theight: 35%;\n\t\t\t\t\t\tcolor: transparent;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t\t\n\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\tcontent: '\\f106';\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .rdtCount {\n\t\t\t\t\t\theight: 30%;\n\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& + .rdtBtn {\n\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\tcontent: '\\f107';\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .rdtDays {\n\t\t\tmin-width: 290px;\n\t\t\t\n\t\t\t& .rdtDay {\n\t\t\t\tfont-weight: $font-weight-base;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\tpadding: 5px;\n\t\t\t\tline-height: 20px;\n\t\t\t\tborder-radius: $border-radius-lg;\n\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:focus,\n\t\t\t\t&.rdtSelected,\n\t\t\t\t&.rdtHighlighted,\n\t\t\t\t&.rdtRange {\n\t\t\t\t\tbackground: $dropdown-link-hover-bg !important;\n\t\t\t\t\ttext-shadow: none;\n\t\t\t\t}\n\t\t\t\t&.rdtToday {\n\t\t\t\t\tbackground: var(--#{$prefix}theme) !important;\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color) !important;\n\t\t\t\t\t\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tborder-bottom-color: var(--#{$prefix}inverse);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.rdtActive {\n\t\t\t\t\tbackground: var(--#{$prefix}theme) !important;\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color) !important;\n\t\t\t\t\ttext-shadow: none !important;\n\t\t\t\t}\n\t\t\t\t&.rdtOld {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t}\n\t\t\t\t&.rdtNew {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t}\n\t\t\t\t&.rdtDisabled {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tbackground: none !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t\t& .rdtMonths,\n\t\t& .rdtYears {\n\t\t\tmin-width: 290px;\n\t\t\t\n\t\t\t& .rdtMonth,\n\t\t\t& .rdtYear {\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\ttext-shadow: none;\n\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t}\n\t\t\t\t&.rdtFocused {\n\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t}\n\t\t\t\t&.rdtActive {\n\t\t\t\t\tbackground: $dropdown-link-active-bg !important;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".react-datepicker-wrapper {\n\twidth: 100%;\n}\n\n.react-datepicker {\n\tborder: none;\n\tdisplay: block;\n\tfont-family: inherit;\n\tbackground: none;\n\n\t.react-datepicker-popper & {\n\t\tpadding: rem(5px);\n\t\tbackground: $dropdown-bg;\n\t\tz-index: 10;\n\t\tborder-radius: 0;\n\t\tborder: 1px solid $dropdown-border-color;\n\t\tbox-shadow: $box-shadow;\n\t}\n\t& .react-datepicker__triangle {\n\t\tdisplay: none;\n\t}\n\t& .react-datepicker__navigation {\n\t\tcolor: transparent;\n\t\tpadding: rem(5px);\n\t\tline-height: rem(20px);\n\t\tborder: none;\n\t\twidth: rem(30px);\n\t\theight: rem(30px);\n\t\ttop: rem(5px);\n\t\ttext-indent: 0;\n\t\tborder-radius: $border-radius-lg;\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\toutline: none;\n\n\t\t\t&:after {\n\t\t\t\tcolor: $dropdown-link-hover-color;\n\t\t\t}\n\t\t}\n\t\t&:after {\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), 0.5);\n\t\t\tposition: absolute;\n\t\t\tfont-size: $font-size-base;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\t@include fontawesome();\n\t\t}\n\t\t& .react-datepicker__navigation-icon {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&.react-datepicker__navigation--previous {\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\f104\";\n\t\t\t}\n\t\t}\n\t\t&.react-datepicker__navigation--next {\n\t\t\t&:after {\n\t\t\t\tcontent: \"\\f105\";\n\t\t\t}\n\t\t}\n\t}\n\t& .react-datepicker__month-container {\n\t\tfloat: none;\n\n\t\t& .react-datepicker__header {\n\t\t\tbackground: none;\n\t\t\tborder: none;\n\t\t\tpadding: 0;\n\n\t\t\t& .react-datepicker__current-month {\n\t\t\t\tfont-size: rem(12px);\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tpadding: rem(5px);\n\t\t\t\tline-height: rem(20px);\n\t\t\t}\n\t\t\t& .react-datepicker__day-names {\n\t\t\t\tdisplay: flex;\n\t\t\t\tmargin-bottom: rem(-3px);\n\n\t\t\t\t& .react-datepicker__day-name {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), 0.75);\n\t\t\t\t\tfont-size: rem(12px);\n\t\t\t\t\tpadding: rem(5px);\n\t\t\t\t\tline-height: rem(20px);\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tflex: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& .react-datepicker__month {\n\t\t\tmargin: 0;\n\n\t\t\t& .react-datepicker__week {\n\t\t\t\tdisplay: flex;\n\n\t\t\t\t& .react-datepicker__day {\n\t\t\t\t\tpadding: rem(5px);\n\t\t\t\t\tmargin: rem(2px);\n\t\t\t\t\twidth: rem(30px);\n\t\t\t\t\tline-height: rem(20px);\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), 0.5);\n\t\t\t\t\tflex: 1;\n\t\t\t\t\tborder-radius: $border-radius;\n\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus,\n\t\t\t\t\t&.react-datepicker__day--today,\n\t\t\t\t\t&.react-datepicker__day--keyboard-selected {\n\t\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\toutline: none;\n\t\t\t\t\t}\n\t\t\t\t\t&.react-datepicker__day--selected {\n\t\t\t\t\t\tbackground: $dropdown-link-active-bg;\n\t\t\t\t\t\tcolor: $dropdown-link-active-color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n","body {\n\t& .react-select__control {\n\t\tborder: 1px solid var(--#{$prefix}border-color);\n\t\tbackground: none;\n\t\tborder-radius: $border-radius;\n\t\tpadding: 0.375rem 0.75rem;\n\t\tmin-height: rem(35px);\n\t\t\n\t\t&:hover {\n\t\t\tborder-color: var(--#{$prefix}border-color);\n\t\t}\n\t\t&.react-select__control--is-focused {\n\t\t\tbox-shadow: $input-btn-focus-box-shadow;\n\t\t\tborder-color: var(--#{$prefix}border-color);\n\t\t}\n\t\t& .react-select__value-container {\n\t\t\tpadding: 0;\n\t\t\t\n\t\t\t& .react-select__placeholder {\n\t\t\t\tmargin: 0;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t}\n\t\t\t& .react-select__single-value {\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t}\n\t\t\t& .react-select__input-container {\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\tcolor: #fff;\n\t\t\t\t\n\t\t\t\t& .react-select__input {\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.react-select__value-container--is-multi {\n\t\t\t\tmargin-bottom: rem(-5px);\n\t\t\t\t\n\t\t\t\t& .react-select__placeholder,\n\t\t\t\t& .react-select__input-container {\n\t\t\t\t\tmargin-top: rem(-5px);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .react-select__multi-value {\n\t\t\t\t\tmargin: 0 rem(4px) rem(4px) 0;\n\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t\n\t\t\t\t\t& .react-select__multi-value__label {\n\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\tfont-size: rem(12px);\n\t\t\t\t\t\tpadding: rem(2px);\n\t\t\t\t\t\t\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-right: rem(6px);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-left: rem(6px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .react-select__multi-value__remove {\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\tpadding: 0 3px;\n\t\t\t\t\t\t\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .react-select__indicators {\n\t\t\t& .react-select__indicator {\n\t\t\t\tpadding: 0;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .react-select__indicator-separator {\n\t\t\t\tbackground: none;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t}\n\t& .react-select__menu {\n\t\tbackground: $dropdown-bg;\n\t\tborder-radius: 0;\n\t\tborder: 1px solid $dropdown-border-color;\n\t\tz-index: 99;\n\t\t\n\t\t& .react-select__menu-list {\n\t\t\t& .react-select__option {\n\t\t\t\t&.react-select__option--is-focused {\n\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t}\n\t\t\t\t&.react-select__option--is-selected {\n\t\t\t\t\tbackground: $dropdown-link-active-bg;\n\t\t\t\t\tcolor: $dropdown-link-active-color;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","body .rti--container {\n\tbackground: transparent;\n\tborder: 1px solid $input-border-color;\n\tborder-radius: $border-radius;\n\tpadding: $input-padding-y - rem(2px) $input-padding-x;\n\tline-height: 1;\n\tgap: rem(4px);\n\t\n\t&:focus-within {\n\t\tborder-color: $input-focus-border-color;\n\t\tbox-shadow: $input-focus-box-shadow;\n\t}\n\t& .rti--tag {\n\t\tfont-size: rem(12px);\n\t\tcolor: var(--#{$prefix}theme-color);\n\t\tline-height: rem(15px);\n\t\tmin-height: rem(20px);\n\t\tfont-weight: 500;\n\t\tborder-radius: rem(20px);\n\t\tpadding: rem(5px) rem(12px);\n\t\tbackground: var(--#{$prefix}theme);\n\t\t\n\t\t& button {\n\t\t\tmargin-top: rem(1px);\n\t\t\tmargin-bottom: rem(-1px);\n\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\tmargin-left: rem(-5px);\n\t\t\t\tmargin-right: rem(5px);\n\t\t\t} @else {\n\t\t\t\tmargin-right: rem(-5px);\n\t\t\t\tmargin-left: rem(5px);\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\topacity: .5;\n\t\t\t}\n\t\t}\n\t}\n\t& .rti--input {\n\t\tbackground: none;\n\t\tcolor: var(--#{$prefix}inverse);\n\t\t\n\t\t&::placeholder {\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\tfont-weight: $input-font-weight;\n\t\t}\n\t}\n}",".calendar {\n\tmin-height: calc(100vh - #{$app-header-height});\n\tdisplay: flex;\n\t\n\t@if ($enable-rtl) {\n\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t} @else {\n\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t}\n\t@include media-breakpoint-down(md) {\n\t\tborder: none;\n\t}\n\t\n\t& .calendar-body {\n\t\tflex: 1;\n\t\theight: calc(100vh - #{$app-header-height});\n\t\t\n\t\t& + .calendar-sidebar {\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t} @else {\n\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t}\n\t\t\n\t\t& .fc {\n\t\t\t& .fc-head-container  {\n\t\t\t\t& th {\n\t\t\t\t\tborder-bottom-width: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& table {\n\t\t\t\tborder: none !important;\n\t\t\t\n\t\t\t\t& thead,\n\t\t\t\t& tbody {\n\t\t\t\t\t& tr {\n\t\t\t\t\t\tborder-width: 0;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& th,\n\t\t\t\t\t\t& td {\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\t\t\t\tborder-right-width: 0 !important;\n\t\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\t\tborder-left-width: 0 !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\t\t\t\tborder-left-width: 0 !important;\n\t\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\t\tborder-right-width: 0 !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .fc-head-container  {\n\t\t\t\t\tborder: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .calendar-sidebar {\n\t\twidth: rem(220px);\n\t\tpadding: $spacer;\n\t\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\theight: calc(100vh - #{$app-header-height});\n\t\t}\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tdisplay: none;\n\t\t}\n\t\t\n\t\t& + .calendar-body {\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t} @else {\n\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t}\n\t\t& .calendar-sidebar-title {\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\tmargin-bottom: $spacer * .5;\n\t\t\tfont-size: $font-size-base;\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-end;\n\t\t}\n\t}\n}",".coming-soon {\n\tmin-height: 100vh;\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t& .coming-soon-img {\n\t\t& img {\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n\t& .coming-soon-timer {\n\t\tpadding: $spacer * 2;\n\t\tmin-height: 50vh;\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\tjustify-content: center;\n\t}\n\t& .coming-soon-content {\n\t\tmin-height: 50vh;\n\t\tposition: relative;\n\t\ttext-align: center;\n\t\tmargin: 0 auto;\n\t\tpadding: $spacer * 2;\n\t\tbackground: linear-gradient(to bottom, rgba(var(--#{$prefix}inverse-rgb), .15) 0%, transparent 100%);\n\t\tflex: 1;\n\t\t\n\t\t& > * {\n\t\t\tmax-width: rem(520px);\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n\t& .is-countdown {\n\t\tbackground: none;\n\t\tborder: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\t\n\t\t@include clearfix();\n\t\t\n\t\t& .countdown-row {\n\t\t\tdisplay: block;\n\t\t\tpadding: 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t\n\t\t\t& .countdown-section {\n\t\t\t\twidth: rem(120px);\n\t\t\t\tpadding: $spacer;\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tmargin: $spacer * .75;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\tborder-radius: $border-radius-lg * 1.5;\n\t\t\t\n\t\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\t\twidth: rem(80px);\n\t\t\t\t\tpadding: $spacer * .5 0;\n\t\t\t\t\tmargin: $spacer * .25;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .countdown-amount {\n\t\t\tfont-size: rem(48px);\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\tline-height: 1.25;\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: rem(28px);\n\t\t\t}\n\t\t}\n\t\t& .countdown-period {\n\t\t\tfont-size: $font-size-base * 1.15;\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\tline-height: 1.5;\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: $font-size-base * .9;\n\t\t\t}\n\t\t}\n\t}\n}","@mixin clearfix() {\n\t&:before,\n\t&:after {\n\t\tcontent: '';\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n}",".data-management {\n\t& .dataTables_wrapper {\n\t\t& .dataTable {\n\t\t\tmargin-top: 0 !important;\n\t\t\tmargin-bottom: 0 !important;\n\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t}\n\t\t& .dataTables_filter {\n\t\t\ttext-align: left;\n\t\t\tmargin-bottom: $spacer;\n\t\t\tfont-size: rem(12px);\n\t\t\t\n\t\t\t& label {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t\t& input {\n\t\t\t\tborder-radius: $border-radius;\n\t\t\t\tfont-size: rem(13px);\n\t\t\t\tmin-width: rem(200px);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tmin-width: inherit;\n\t\t\t\t\tflex: 1;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".error-page {\n\t// min-height: 100vh;\n\tpadding: $spacer * 4 0;\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t& .error-page-content {\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t\tpadding: 0 $spacer;\n\t\ttext-align: center;\n\t\t\n\t\t& .error-code {\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tfont-size: rem(118px);\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\ttext-align: center;\n\t\t\tline-height: 1.25;\n\t\t\tletter-spacing: 5px;\n\t\t\ttext-shadow: 10px 10px rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: rem(102px);\n\t\t\t}\n\t\t}\n\t\t& .error-page-icon i {\n\t\t\tfont-size: rem(128px);\n\t\t\tcolor: $gray-300;\n\t\t}\n\t\t& h1 {\n\t\t\tfont-size: rem(48px);\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: rem(52px);\n\t\t\t}\n\t\t}\n\t\t& h3 {\n\t\t\tfont-size: rem(18px);\n\t\t\tfont-weight: 400;\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: rem(16px);\n\t\t\t}\n\t\t}\n\t\t& .link-divider {\n\t\t\twidth: rem(4px);\n\t\t\theight: rem(4px);\n\t\t\tdisplay: inline-block;\n\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .3);\n\t\t\tposition: relative;\n\t\t\ttop: rem(-2px);\n\t\t\tmargin: 0 $spacer;\n\t\t\tborder-radius: $border-radius;\n\t\t}\n\t}\n}",".gallery-menu-container {\n\tmin-width: rem(200px);\n\t\n\t@include media-breakpoint-up(md) {\n\t\tmin-height: calc(100vh - #{$app-header-height});\n\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t}\n}\n.gallery-menu {\n\tpadding: $spacer;\n\tpadding: 0;\n\t\n\t@include media-breakpoint-down(md) {\n\t\toverflow: scroll;\n\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\tposition: sticky;\n\t\ttop: $app-header-height;\n\t\tdisplay: flex;\n\t\tflex-wrap: nowrap;\n\t}\n\t& .gallery-menu-header {\n\t\tpadding: $spacer $spacer $spacer * .25;\n\t\tfont-weight: $font-weight-bold;\n\t\tfont-size: 90%;\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t& .gallery-menu-item {\n\t\t& .gallery-menu-link {\n\t\t\tpadding: $spacer * .35 $spacer * 1.25;\n\t\t\tdisplay: block;\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\ttext-decoration: none;\n\t\t\t\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\twhite-space: nowrap;\n\t\t\t\tpadding: rem(15px) rem(20px) rem(10px);\n\t\t\t}\n\t\t\t\n\t\t\t& .fa {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tmargin: 0 0 rem(3px) !important;\n\t\t\t\t\twidth: auto !important;\n\t\t\t\t\tfont-size: rem(18px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\n\t\t\t\t& .fa {\n\t\t\t\t\tcolor: inherit;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.gallery-content-container {\n\twidth: 100%;\n\t\n\t@include media-breakpoint-up(md) {\n\t\tmin-height: calc(100vh - #{$app-header-height});\n\t}\n}\n.gallery {\n\tpadding: $spacer;\n\t\n\t& + .gallery {\n\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t}\n\t& .gallery-title {\n\t\tfont-size: $font-size-base * 1.25;\n\t\tcolor: var(--#{$prefix}inverse);\n\t\tfont-weight: $font-weight-bold;\n\t\tmargin-bottom: $spacer;\n\t\t\n\t\t& a {\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\ttext-decoration: none;\n\t\t\t\n\t\t\t& i {\n\t\t\t\tfont-size: $font-size-base;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-right: rem(5px);\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-left: rem(5px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& small {\n\t\t\tdisplay: block;\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\tfont-size: $font-size-base * .9;\n\t\t}\n\t}\n\t& .gallery-image-list {\n\t\tlist-style-type: none;\n\t\tmargin: $spacer * -.15;\n\t\tpadding: 0;\n\t\n\t\t@include clearfix();\n\t\n\t\t& > li {\n\t\t\tposition: relative;\n\t\t\tpadding-top: 12.5%;\n\t\t\twidth: 16.6667%;\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\tfloat: right;\n\t\t\t} @else {\n\t\t\t\tfloat: left;\n\t\t\t}\n\t\t\n\t\t\t@include media-breakpoint-down(lg) { \n\t\t\t\twidth: 25%;\n\t\t\t\tpadding-top: 18.75%;\n\t\t\t}\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\twidth: 33.33%;\n\t\t\t\tpadding-top: 33.33%;\n\t\t\t}\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\twidth: 50%;\n\t\t\t\tpadding-top: 50%;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tz-index: 10;\n\t\t\t}\n\t\t\t& a {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: $spacer * .15;\n\t\t\t\tright: $spacer * .15;\n\t\t\t\tbottom: $spacer * .15;\n\t\t\t\ttop: $spacer * .15;\n\t\t\t\toverflow: hidden;\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\ttransition: all .2s ease-in-out;\n\t\t\t\n\t\t\t\t@include media-breakpoint-up(lg) {\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tleft: -15%;\n\t\t\t\t\t\tright: -15%;\n\t\t\t\t\t\ttop: -15%;\n\t\t\t\t\t\tbottom: -15%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& img,\n\t\t\t& .img {\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t\t& .img-portrait {\n\t\t\t\theight: 100%;\n\t\t\t\twidth: auto;\n\t\t\t\tmax-height: 100%;\n\t\t\t\tmax-width: inherit;\n\t\t\t}\n\t\t\t& .img-portrait-xs {\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\theight: 100%;\n\t\t\t\t\twidth: auto;\n\t\t\t\t\tmax-height: 100%;\n\t\t\t\t\tmax-width: inherit;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".app-content.login-page {\n\tmin-height: initial;\n\tpadding: 0;\n\tflex: 1;\n\toverflow: auto;\n}\n\n.login-page {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100vh;\n}\n\n.login-confirm-text p {\n\tfont-size: 18px;\n\n\t@media screen and (max-width: 991px) {\n\t\tfont-size: 15px;\n\t}\n}\n\n.login-page .app-content {\n\tflex: 1;\n\tmin-height: auto;\n\tpadding: 50px 0;\n\toverflow: auto;\n\tmargin-bottom: 0 !important;\n}\n\n.login-page .app-footer {\n\tmargin: 0;\n}\n\n.login {\n\tdisplay: flex;\n\talign-items: center;\n\tposition: relative;\n\tflex-direction: column;\n\tjustify-content: center;\n\toverflow: hidden;\n\theight: 100%;\n\n\t.login-bg {\n\t\tposition: fixed;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\twidth: 130vw;\n\t\theight: 130vw;\n\t\tpointer-events: none;\n\t\topacity: 0.1;\n\n\t\t&::before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tbackground-color: var(--#{$prefix}theme);\n\t\t}\n\n\t\tvideo,\n\t\tiframe {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmix-blend-mode: color-burn;\n\t\t}\n\t}\n\n\t.app-header {\n\t\tposition: static;\n\t\theight: auto;\n\t\twidth: auto;\n\t\tbackground: no-repeat;\n\t\tmargin: 0 auto;\n\n\t\t.brand {\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t& .login-content {\n\t\twidth: 100%;\n\t\tmax-width: rem(400px);\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t}\n\n\t@include media-breakpoint-down(xl) {\n\t\t> video {\n\t\t\twidth: 200vw;\n\t\t}\n\t}\n\n\t@include media-breakpoint-down(md) {\n\t\t> video {\n\t\t\twidth: 400vw;\n\t\t}\n\t}\n\n\t@include media-breakpoint-down(md) {\n\t\tpadding: $spacer;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.login-page .app-content {\n\t\tpadding: 15px 0;\n\t}\n\n\t.login-confirm-text p {\n\t\tfont-size: 12px;\n\t}\n}\n",".mailbox {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\t\n\t& .mailbox-toolbar {\n\t\tpadding: $spacer * .75;\n\t\tdisplay: flex;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\toverflow: scroll;\n\t\t\twhite-space: nowrap;\n\t\t\tpadding: $spacer * .5;\n\t\t\tflex-wrap: nowrap;\n\t\t}\n\t\t& .mailbox-toolbar-text {\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\tpadding: $spacer * .5;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t\t& .mailbox-toolbar-link {\n\t\t\tpadding: $spacer * .5 $spacer;\n\t\t}\n\t\t& .mailbox-toolbar-item {\n\t\t\tpadding: $spacer * .5;\n\t\t}\n\t\t& .mailbox-toolbar-link {\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\ttext-decoration: none;\n\t\t\tborder-radius: $border-radius;\n\t\t\t\n\t\t\t&:hover {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\tcolor: $component-active-color;\t\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t}\n\t\t}\n\t}\n\t& .mailbox-body {\n\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\toverflow: hidden;\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\t\n\t\t& .mailbox-sidebar {\n\t\t\tmax-width: rem(360px);\n\t\t\theight: 100%;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tmax-width: 100%;\n\t\t\t\theight: auto;\n\t\t\t}\n\t\t\t\n\t\t\t& + .mailbox-content {\n\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tborder-right: none;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tborder-left: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .mailbox-content {\n\t\t\theight: 100%;\n\t\t\tflex: 1;\n\t\t}\n\t}\n\t& .mailbox-empty-message {\n\t\tmin-height: 100%;\n\t\twidth: 100%;\n\t\tpadding: $spacer * 2;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\t\n\t\t& .mailbox-empty-message-icon {\n\t\t\t& i {\n\t\t\t\tfont-size: $font-size-base * 7;\n\t\t\t}\n\t\t}\n\t\t& .mailbox-empty-message-img {\n\t\t\twidth: 100%;\n\t\t\ttext-align: center;\n\t\t\tmargin-bottom: $spacer;\n\t\t\t\n\t\t\t& img {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tmax-width: rem(480px);\n\t\t\t\tmax-height: rem(480px);\n\t\t\t\topacity: 0.5\n\t\t\t}\n\t\t}\n\t\t& .mailbox-empty-message-title {\n\t\t\tfont-size: $font-size-base * 1.5;\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t}\n\t}\n\t& .mailbox-list {\n\t\tlist-style-type: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\n\t\t& .mailbox-list-item {\n\t\t\tpadding: $spacer;\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t& + .mailbox-list-item {\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t\t&.unread {\n\t\t\t\t& .mailbox-message {\n\t\t\t\t\t& .mailbox-title {\n\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t\t&.has-attachment {\n\t\t\t\t& .mailbox-checkbox:after {\n\t\t\t\t\tcontent: '\\f0c1';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: rem(25px);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\twidth: rem(18px);\n\t\t\t\t\t\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .mailbox-checkbox {\n\t\t\tposition: relative;\n\t\t\t\n\t\t\t& + .mailbox-message {\n\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\tpadding-right: $spacer * .5;\n\t\t\t\t} @else {\n\t\t\t\t\tpadding-left: $spacer * .5;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .mailbox-message {\n\t\t\tflex: 1;\n\t\t\n\t\t\t& .mailbox-list-item-link {\n\t\t\t\tdisplay: block;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\ttext-decoration: none;\n\t\t\t\tposition: relative;\n\t\t\t}\n\t\t\t& .mailbox-sender {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .mailbox-sender-name {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\tflex: 1;\n\t\t\t\t\t\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-right: auto;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .mailbox-time {\n\t\t\t\t\tfont-size: $font-size-base - rem(2px);\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tfont-weight: $font-weight-base;\n\t\t\t\t\t\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tpadding-right: $spacer * .5;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tpadding-left: $spacer * .5;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .mailbox-title {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\twhite-space: nowrap;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\tmax-width: rem(290px);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tmax-width: initial;\n\t\t\t\t\twhite-space: initial;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .mailbox-desc {\n\t\t\t\tposition: relative;\n\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\tmax-height: rem(42px);\n\t\t\t\toverflow: hidden;\n\t\t\t}\n\t\t}\n\t}\n\t& .mailbox-detail {\n\t\tpadding: $spacer * 1.5;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tpadding: $spacer;\n\t\t}\n\t\t\n\t\t& .mailbox-detail-header {\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: 0 0 $spacer * 1.5;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tpadding-bottom: $spacer;\n\t\t\t}\n\t\t}\n\t\t& .mailbox-detail-content {\n\t\t\tpadding: $spacer * 1.5 0;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tpadding: $spacer 0;\n\t\t\t}\n\t\t}\n\t\t& .mailbox-detail-body {\n\t\t\tfont-size: $font-size-base;\n\t\t}\n\t\t& .mailbox-detail-attachment {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\t\n\t\t\t& .mailbox-attachment {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\twidth: rem(120px);\n\t\t\t\toverflow: hidden;\n\t\t\t\tmargin-bottom: $spacer * .5;\n\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\n\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\tmargin-left: $spacer * .5;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-right: $spacer * .5;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& a {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t}\n\t\t\t\t& .document-file {\n\t\t\t\t\theight: rem(60px);\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t\t\t\n\t\t\t\t\t& i {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tline-height: rem(60px);\n\t\t\t\t\t\tfont-size: rem(32px);\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t}\n\t\t\t\t\t& img {\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .document-name {\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\tpadding: rem(2px) rem(10px);\n\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .mailbox-form {\n\t\t& .mailbox-form-header {\n\t\t\tpadding: $spacer $spacer * 1.5;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tpadding: $spacer * .75 $spacer;\n\t\t\t}\n\t\t\t\n\t\t\t& .form-control {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t}\n\t\t& .note-editor {\n\t\t\tborder: none;\n\t\t\tborder-radius: 0;\n\t\t\t\n\t\t\t& .note-toolbar {\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t& .note-editing-area {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t}\n\t}\n}",".messenger {\n\theight: 100%;\n\tdisplay: flex;\n\t\n\t& .messenger-sidebar {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex: 1;\n\t\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\tmax-width: rem(360px);\n\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t}\n\t\t& .messenger-sidebar-header {\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer;\n\t\t}\n\t\t& .messenger-sidebar-body {\n\t\t\tflex: 1;\n\t\t\toverflow: hidden;\n\t\t}\n\t\t& .messenger-item {\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t\n\t\t\t& .messenger-link {\n\t\t\t\tdisplay: flex;\n\t\t\t\tpadding: $spacer * .85 $spacer;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\n\t\t\t\t&.active {\n\t\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\t}\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .messenger-media {\n\t\t\t\t\twidth: rem(40px);\n\t\t\t\t\theight: rem(40px);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t& img {\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t& + .messenger-info {\n\t\t\t\t\t\tpadding-left: $spacer * .85;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .messenger-info {\n\t\t\t\t\tflex: 1;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t}\n\t\t\t\t& .messenger-time-badge {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t}\n\t\t\t\t& .messenger-time {\n\t\t\t\t\tfont-size: $font-size-sm * .85;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tmargin-bottom: $spacer * .25;\n\t\t\t\t}\n\t\t\t\t& .messenger-text,\n\t\t\t\t& .messenger-name {\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\tmax-width: rem(220px);\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tfont-size: $font-size-sm;\n\t\t\t\t}\n\t\t\t\t& .messenger-name {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t}\n\t\t\t\t& .messenger-badge {\n\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tborder-radius: rem(30px);\n\t\t\t\t\tpadding: 0 rem(3px);\n\t\t\t\t\tmin-width: rem(18px);\n\t\t\t\t\tmin-height: rem(18px);\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tfont-size: $font-size-base * .65;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\n\t\t\t\t\t&.empty {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tmargin-right: auto;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .messenger-content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex: 1;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tdisplay: none;\n\t\t}\n\t\t\n\t\t& .messenger-content-header {\n\t\t\tdisplay: flex;\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer * .75 $spacer;\n\t\t\talign-items: center;\n\t\t\t\n\t\t\t& .messenger-content-header-mobile-toggler {\n\t\t\t\tdisplay: none;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& a {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tfont-size: rem(18px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .messenger-content-header-media {\n\t\t\t\t& .media {\n\t\t\t\t\twidth: rem(40px);\n\t\t\t\t\theight: rem(40px);\n\t\t\t\t\tborder-radius: 40px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t\t& + .messenger-content-header-info {\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .messenger-content-header-info {\n\t\t\t\tfont-size: $font-size-base;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tfont-size: rem(15px);\n\t\t\t\tflex: 1;\n\t\t\t\t\n\t\t\t\t& small {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tfont-weight: normal;\n\t\t\t\t\tfont-size: rem(11px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .messenger-content-header-btn {\n\t\t\t\tdisplay: flex;\n\t\t\t\t\n\t\t\t\t& .btn {\n\t\t\t\t\tfont-size: rem(16px);\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .messenger-content-body {\n\t\t\tflex: 1;\n\t\t\toverflow: hidden;\n\t\t\t\n\t\t\t& .widget-chat {\n\t\t\t\tpadding: $spacer;\n\t\t\t}\n\t\t}\n\t\t& .messenger-content-footer {\n\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer;\n\t\t}\n\t}\n\t&.messenger-content-toggled {\n\t\t@include media-breakpoint-down(lg) {\n\t\t\t& .messenger-sidebar {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t& .messenger-content {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t}\n\t}\n}",".pos {\n\tbackground: var(--app-pos-bg);\n\theight: 100%;\n\t\t\n\t& .pos-container {\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\tdisplay: flex;\n\t\t\n\t\t\t& > div + div {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-menu {\n\t\tdisplay: flex;\n\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\twidth: $pos-sidebar-menu-width;\n\t\t\tflex-direction: column;\n\t\t}\n\t\t@include media-breakpoint-down(lg) {\n\t\t\toverflow: scroll;\n\t\t\talign-items: center;\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t}\n\t\n\t\t& .logo {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tpadding: $spacer;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\twidth: $pos-sidebar-menu-width;\n\t\t\t\theight: rem(95px);\n\t\t\t\tflex: 0 0 $pos-sidebar-menu-width;\n\t\t\t}\n\t\t\t& a {\n\t\t\t\tdisplay: block;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t\t& .logo-img {\n\t\t\t\ttext-align: center;\n\t\t\t\theight: rem(46px);\n\t\t\t}\n\t\t\t& .logo-text {\n\t\t\t\tfont-size: $font-size-base;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tletter-spacing: 1px;\n\t\t\t\tmargin-top: $spacer * .25;\n\t\t\t}\n\t\t\t& img {\n\t\t\t\tmax-width: 100%;\n\t\t\t\tmax-height: 100%;\n\t\t\t}\n\t\t}\n\t\t& .nav-container {\n\t\t\tflex: 1;\n\t\t\n\t\t\t@include media-breakpoint-up(lg) {\n\t\t\t\toverflow: hidden;\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t\t& .nav.nav-tabs {\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\tdisplay: block;\n\t\t\tborder: 0;\n\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\n\t\t\t& .nav-item {\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tmin-width: rem(90px);\n\t\t\t\t}\n\t\t\t\t& .nav-link {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding: $spacer;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .25);\n\t\t\t\t\tborder: none;\n\t\t\t\t\tfont-size: $font-size-base * .75;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\n\t\t\t\t\t& .card {\n\t\t\t\t\t\tmargin: $spacer * -.75 $spacer * -.25;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& .card-body {\n\t\t\t\t\t\t\tpadding: $spacer * .5 $spacer * .7;\n\t\t\t\t\t\t\tmargin: $spacer * .5;\n\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:before,\n\t\t\t\t\t\t&:after,\n\t\t\t\t\t\t& .card-arrow {\n\t\t\t\t\t\t\tvisibility: hidden;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .fa {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tmargin: $spacer * .225 auto $spacer * .35 auto !important;\n\t\t\t\t\t\tfont-size: rem(20px);\n\t\t\t\t\t}\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\t\t}\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\n\t\t\t\t\t\t& .card {\n\t\t\t\t\t\t\t&:before,\n\t\t\t\t\t\t\t&:after,\n\t\t\t\t\t\t\t& .card-arrow {\n\t\t\t\t\t\t\t\tvisibility: visible;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-content {\n\t\tflex: 1;\n\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\toverflow: scroll;\n\t\t}\n\t\t@include media-breakpoint-down(lg) {\n\t\t\theight: calc(100% - 96px);\n\t\t}\n\t\t\n\t\t& .pos-content-container {\n\t\t\tpadding: 0 $spacer * 2;\n\t\t}\n\t}\n\t& .pos-sidebar {\n\t\twidth: $pos-sidebar-desktop-width;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex: 0 0 $pos-sidebar-desktop-width;\n\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\twidth: auto;\n\t\t\tz-index: $app-header-zindex + 1;\n\t\t\tbackground: var(--#{$prefix}body-bg);\n\t\t\tbackground: var(--#{$prefix}body-bg-gradient);\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& .pos-sidebar-header {\n\t\t\tpadding: $spacer $spacer * 1.5;\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\n\t\t\t& .back-btn {\n\t\t\t\tborder: none;\n\t\t\t\tdisplay: none;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t}\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\n\t\t\t\t& .btn {\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tfont-size: $font-size-base * 1.25;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .icon {\n\t\t\t\t& img {\n\t\t\t\t\theight: rem(30px);\n\t\t\t\t}\n\t\t\t\t& + .title {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tpadding-right: rem(10px);\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tpadding-left: rem(10px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .title {\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tflex: 1;\n\t\t\t}\n\t\t\t& .order {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t\t& .pos-sidebar-nav {\n\t\t\t& .nav.nav-tabs {\n\t\t\t\tpadding: 0 $spacer * 1.5;\n\t\t\t\t\n\t\t\t\t& .nav-item {\n\t\t\t\t\t& .nav-link {\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\t\t\t\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& + .nav-item {\n\t\t\t\t\t\tmargin-left: $spacer * .5;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .pos-sidebar-body {\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\toverflow: scroll;\n\t\t\tflex: 1;\n\t\t}\n\t\t& .pos-sidebar-footer {\n\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer $spacer * 1.5;\n\t\t}\n\t\t& .pos-order {\n\t\t\tpadding: $spacer * 1.5;\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t& .pos-order-product {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex: 1;\n\t\t\t\t\n\t\t\t\t& .img {\n\t\t\t\t\twidth: rem(72px);\n\t\t\t\t\theight: rem(72px);\n\t\t\t\t\tbackground-position: center;\n\t\t\t\t\tbackground-size: cover;\n\t\t\t\t}\n\t\t\t\t& > * + * {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& > * + * {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t}\n\t\t\t}\n\t\n\t\t\t& .pos-order-confirmation {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: rem(1px);\n\t\t\t\tright: rem(1px);\n\t\t\t\tbottom: 0;\n\t\t\t\tz-index: 10;\n\t\t\t\tbackground: rgba(235, 235, 235, .88);\n\t\t\t\tpadding: $spacer;\n\t\t\t\tmargin: 0;\n\t\t\t\n\t\t\t\t& > * {\n\t\t\t\t\tposition: relative;\n\t\t\t\t}\n\t\t\t\t& .btn {\n\t\t\t\t\tmin-width: rem(60px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t& + .pos-order {\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-header {\n\t\tpadding: $spacer * 0.66 $spacer * 1.75;\n\t\theight: $pos-counter-header-height;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t\n\t\t& .logo,\n\t\t& .time,\n\t\t& .nav {\n\t\t\twidth: 33.33%;\n\t\t\t\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\twidth: 50%;\n\t\t\t}\n\t\t}\n\t\t& .logo {\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t& > div,\n\t\t\t& > a {\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\ttext-decoration: none;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\t\n\t\t\t\t& .logo-img {\n\t\t\t\t\t& img {\n\t\t\t\t\t\theight: rem(32px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .logo-text {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tfont-size: rem(16px);\n\t\t\t\t\tletter-spacing: rem(1px);\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .time {\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\tfont-size: rem(20px);\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t& .nav {\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-end;\n\t\t\t\n\t\t\t& .nav-item {\n\t\t\t\t& .nav-link {\n\t\t\t\t\tpadding: $spacer * .333 $spacer;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\n\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\tpadding: $spacer * .333 $spacer * 0.66;\n\t\t\t\t\t}\n\t\t\t\t\t& .nav-icon {\n\t\t\t\t\t\theight: rem(20px);\n\t\t\t\t\t\tfont-size: rem(20px);\n\t\t\t\t\t}\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-product {\n\t\ttext-decoration: none;\n\t\tcolor: var(--#{$prefix}inverse);\n\t\tposition: relative;\n\t\ttransition: all .2s linear;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: 100%;\n\n\t\t& .img {\n\t\t\tbackground-size: cover;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: center;\n\t\t\tmin-height: rem(180px);\n\t\t\ttransition: all .2s linear;\n\t\t}\n\t\t& .info {\n\t\t\tflex: 1;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tbackground: rgba(var(--#{$prefix}inverse), .1);\n\t\t\tpadding: $spacer;\n\t\n\t\t\t& .title {\n\t\t\t\tfont-size: $font-size-lg;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\tmargin: 0 0 rem(2px);\n\t\t\t}\n\t\t\t& .desc {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\tmargin: 0 0 $spacer;\n\t\t\t\tline-height: 1.4;\n\t\t\t\tflex: 1;\n\t\t\t}\n\t\t\t& .price {\n\t\t\t\tmargin: 0;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\tfont-size: $font-size-lg;\n\t\t\t}\n\t\t}\n\t\t&.not-available {\n\t\t\tcursor: not-allowed;\n\t\n\t\t\t& .not-available-text {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tmin-height: rem(180px);\n  \t\t\tbackground: rgba(235, 235, 235, .88);\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\tfont-size: $h2-font-size;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-table-booking {\n\t\tdisplay: block;\n\t\tmargin-bottom: $spacer * 1.25;\n\t\ttext-decoration: none;\n\t\tcolor: var(--#{$prefix}inverse);\n\t\n\t\t&:hover {\n\t\t\t& .pos-table-booking-container {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse), .2);\n\t\t\t}\n\t\t}\n\t\t\n\t\t& .pos-table-booking-container {\n\t\t\tpadding: 0;\n\t\t\tbackground: rgba(var(--#{$prefix}inverse), .1);\n\t\t\t\n\t\t\t& .pos-table-booking-header {\n\t\t\t\tpadding: $spacer;\n\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\n\t\t\t\t& .no {\n\t\t\t\t\tfont-size: $font-size-lg * 2.5;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .pos-table-booking-body {\n\t\t\t\t& .booking {\n\t\t\t\t\tfont-size: $font-size-sm;\n\t\t\t\t\tpadding: $spacer * .333 $spacer;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t\n\t\t\t\t\t& .time {\n\t\t\t\t\t\twidth: rem(75px);\n\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\tfont-size: $font-size-base * .85;\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\t\t}\n\t\t\t\t\t& .info {\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t}\n\t\t\t\t\t& .status {\n\t\t\t\t\t\tfont-size: rem(6px);\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-right: $spacer;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-left: $spacer;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t&.upcoming {\n\t\t\t\t\t\t\tcolor: $warning;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.in-progress {\n\t\t\t\t\t\t\tcolor: $success;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.highlight {\n\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\n\t\t\t\t\t\t& .time {\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}theme-rgb), .75);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& + .booking {\n\t\t\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-task {\n\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\n\t\t@include media-breakpoint-up(md) {\n\t\t\tdisplay: flex;\n\t\t}\t\t\t\t\t\n\t\t& .pos-task-info {\n\t\t\twidth: 30%;\n\t\t\tpadding: $spacer * 1.5;\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\ttext-align: left;\n\t\t\t} @else {\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\twidth: auto;\n\t\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\ttext-align: right;\n\t\t\t\t} @else {\n\t\t\t\t\ttext-align: left;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .pos-task-body {\n\t\t\tpadding: $spacer * 1.5;\n\t\t\tflex: 1;\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t} @else {\n\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\tborder-left: none;\n\t\t\t\tpadding-top: 0;\n\t\t\t}\n\t\t\t\n\t\t\t& .pos-task-completed {\n\t\t\t\tfont-size: rem(16px);\n\t\t\t\tline-height: rem(36px);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\tmargin-top: rem(-10px);\n\t\t\t\t\tpadding-top: rem(10px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .pos-task-product {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\theight: 100%;\n\t\t\t\t\n\t\t\t\t& .pos-task-product-img {\n\t\t\t\t\tpadding-top: 75%;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tmargin-bottom: $spacer;\n\t\t\t\t\n\t\t\t\t\t& .cover {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\t\t\tbackground-position: center;\n\t\t\t\t\t\tborder-radius: $border-radius-lg;\n\t\t\t\t\t}\n\t\t\t\t\t& .caption {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tbackground: rgba($gray-800, .75);\n\t\t\t\t\t\tcolor: var(--#{$prefix}white);\n\t\t\t\t\t\tfont-size: rem(24px);\n\t\t\t\t\t\tborder-radius: $border-radius-lg;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .pos-task-product-info {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex: 1;\n\t\t\t\t\tmargin-bottom: $spacer;\n\t\t\t\t}\n\t\t\t\t& .pos-task-product-action {\n\t\t\t\t\t& .btn {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& + .btn {\n\t\t\t\t\t\t\tmargin-top: $spacer * .75;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.completed {\n\t\t\t\t\t& .pos-task-product-info {\n\t\t\t\t\t\topacity: .33;\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-checkout-table {\n\t\tpadding: rem(1px);\n\t\tmargin: 0;\n\t\theight: 100%;\n\t\t\n\t\t& .pos-checkout-table-container {\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\tdisplay: block;\n\t\t\tpadding: 0;\n\t\t\theight: 100%;\n\t\t\ttext-decoration: none;\n\t\t\tposition: relative;\n\t\t\ttransition: all .1s linear;\n\t\t\tmargin: $spacer * .25;\n\t\t\t\n\t\t\t&:before {\n\t\t\t\ttransition: all .1s linear;\n\t\t\t}\n\t\t\t& .pos-checkout-table-header {\n\t\t\t\tpadding: $spacer;\n\t\t\t\ttext-align: center;\n\t\t\t\t\n\t\t\t\t& .status {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: $spacer * .5;\n\t\t\t\t\ttop: $spacer * .5;\n\t\t\t\t\tfont-size: rem(8px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .pos-checkout-table-info {\n\t\t\t\t& > .row {\n\t\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\n\t\t\t\t\t& > div {\n\t\t\t\t\t\tpadding: $spacer * .25 $spacer * .5;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& + div {\n\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.in-use:hover:not(.disabled) {\n\t\t\tposition: relative;\n\t\t\tz-index: 10;\n\t\t\t\n\t\t\t& .table-container {\n\t\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tbackground: rgba(#2d333a, .75);\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: '\\f00c';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\t\tfont-size: rem(32px);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.selected:not(.disabled),\n\t\t&.selected:not(.disabled):hover {\n\t\t\t& .pos-checkout-table-container {\n\t\t\t\t& .table-info-row {\n\t\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}theme-rgb), .5);\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: '\\f00c';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\tfont-size: rem(32px);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.disabled {\n\t\t\t& .pos-checkout-table-container {\n\t\t\t\tcursor: not-allowed;\n\t\t\t\tbackground: var(--app-component-bg);\n\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\n\t\t\t\t& .status {\n\t\t\t\t\tcolor: $danger;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.available {\n\t\t\t& .pos-checkout-table-container {\n\t\t\t\t& .status {\n\t\t\t\t\tcolor: $success;\n\t\t\t\t}\n\t\t\t\t& .pos-checkout-table-info {\n\t\t\t\t\tcolor: transparent;\n\t\t\t\t\t\n\t\t\t\t\t& i {\n\t\t\t\t\t\tcolor: transparent !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.in-use {\n\t\t\t& .pos-checkout-table-container {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse), .15);\n\t\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t\t& .status {\n\t\t\t\t\tcolor: $warning;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.pos-vertical {\n\t\t& > .pos-container {\n\t\t\tflex-direction: column;\n\t\t\t\n\t\t\t& .pos-header {\n\t\t\t\t& + .pos-content {\n\t\t\t\t\theight: calc(100% - 52px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& > div + div {\n\t\t\t\tborder: 0;\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t}\n\t}\n\t&.pos-mobile-sidebar-toggled {\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tz-index: 20;\n\t\t\t\n\t\t\t& .pos-content,\n\t\t\t& .pos-menu {\n\t\t\t\topacity: .25;\n\t\t\t}\n\t\t\t& .pos-sidebar {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t\t&.pos-vertical {\n\t\t\t\t& > .pos-container > .pos-content {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n.modal.modal-pos {\n\t& .close {\n\t\tposition: absolute;\n\t\ttop: rem(25px);\n\t\tz-index: 10;\n\t\n\t\t@if $enable-rtl {\n\t\t\tleft: rem(25px);\n\t\t} @else {\n\t\t\tright: rem(25px);\n\t\t}\n\t}\n\t& .modal-pos-product {\n\t\t@include media-breakpoint-up(lg) {\n\t\t\tdisplay: flex;\n\t\n\t\t\t& .modal-pos-product-img,\n\t\t\t& .modal-pos-product-info {\n\t\t\t\twidth: 50%;\n\t\t\t\tmax-width: 50%;\n\t\t\t\tflex: 0 0 50%;\n\t\t\t}\n\t\t}\n\t\t& .modal-pos-product-img {\n\t\t\tpadding: $spacer;\n\t\t\t\n\t\t\t& .img {\n\t\t\t\theight: 100%;\n\t\t\t\tbackground-size: cover;\n\t\t\t\tbackground-position: center;\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tmin-height: rem(250px);\n\t\t\t\n\t\t\t\t@include media-breakpoint-up(lg) {\n\t\t\t\t\tmin-height: rem(300px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .modal-pos-product-info {\n\t\t\tpadding: $spacer * 1.5;\n\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\n\t\t\t& .option-list {\n\t\t\t\tmargin: $spacer * -.333;\n\t\t\t\tpadding: $spacer * .333 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: wrap;\n\n\t\t\t\t& .option {\n\t\t\t\t\twidth: 33.33%;\n\t\t\t\t\tmax-width: 33.33%;\n\t\t\t\t\tpadding: $spacer * .333;\n\t\t\t\t\tflex: 0 0 33.33%;\n\t\n\t\t\t\t\t& .option-input {\n\t\t\t\t\t\tdisplay: none;\n\t\t\n\t\t\t\t\t\t&:checked {\n\t\t\t\t\t\t\t& + .option-label {\n\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\tborder: 1px solid var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\tbackground: rgba(var(--#{$prefix}theme-rgb), .1);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .option-label {\n\t\t\t\t\t\tborder: 1px solid rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t\t\tpadding: rem(10px);\n\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\n\t\t\t\t\t\t& .option-text {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tline-height: $headings-line-height;\n\t\t\t\t\t\t\topacity: .75;\n\t\t\t\t\t\t\tfont-size: $font-size-sm;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t& .option-price {\n\t\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\t\tmargin-top: $spacer * .25;\n\t\t\t\t\t\t\tline-height: $headings-line-height;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.pos-mobile-sidebar-toggler {\n\tposition: fixed;\n\tbottom: $spacer * 3;\n\tright: $spacer;\n\tz-index: 1020;\n\tbackground: var(--#{$prefix}white);\n\tpadding: $spacer * .5;\n\twidth: rem(60px);\n\theight: rem(60px);\n\ttext-decoration: none;\n\tcolor: var(--#{$prefix}black);\n\tdisplay: none;\n\tborder-radius: 50px;\n\tbox-shadow: $box-shadow-lg;\n\talign-items: center;\n\tz-index: 10;\n\t\n\t&:before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: $spacer * -.25;\n\t\tleft: $spacer * -.25;\n\t\tright: $spacer * -.25;\n\t\tbottom: $spacer * -.25;\n\t\tborder: 2px solid var(--#{$prefix}white);\n\t\tborder-radius: 50px;\n\t}\n\t\n\t@include media-breakpoint-down(lg) {\n\t\tdisplay: flex;\n\t}\n\t\n\t&:hover {\n\t\tcolor: $gray-600;\n\t}\n\t& i {\n\t\tfont-size: rem(32px);\n\t\tdisplay: block;\n\t\tmargin: 0 auto;\n\t}\n\t& .badge {\n\t\tposition: absolute;\n\t\tright: $spacer * -.3;\n\t\ttop: $spacer * -.3;\n\t\tbackground-color: var(--#{$prefix}theme);\n\t\tcolor: var(--#{$prefix}theme-color);\n\t\twidth: rem(24px);\n\t\theight: rem(24px);\n\t\tfont-size: $font-size-base;\n\t\tfont-weight: $font-weight-bold;\n\t\tpadding: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 20px;\n\t}\n}\n\t\t\n@if $enable-dark-mode {\n\t@include color-mode(dark, true) {\n\t\t.pos .pos-product.not-available .not-available-text,\n\t\t.pos .pos-sidebar .pos-order .pos-order-confirmation {\n\t\t\tbackground: rgba(59, 70, 82, .88);\n\t\t}\n\t}\n}",".profile {\n\t& .profile-img {\n\t\theight: rem(200px);\n\t\toverflow: hidden;\n\t\tmargin-bottom: $spacer;\n\t\tz-index: 10;\n\t\t\n\t\t& img {\n\t\t\tmax-width: 100%;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t& .profile-tab {\n\t\tposition: relative;\n\t\tpadding: 0 $spacer * 1.5;\n\t\tflex: 1;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\toverflow: scroll;\n\t\t\tpadding: 0 $spacer;\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: nowrap;\n\t\t}\n\n\t\t& .nav-item {\n\t\t\t& .nav-link {\n\t\t\t\ttext-align: center;\n\t\t\t\t\n\t\t\t\t& .nav-value {\n\t\t\t\t\tfont-size: $font-size-base * 1.5;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tmargin-bottom: $spacer * -.35;\n\t\t\t\t\t\n\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\tfont-size: $font-size-base * 1.15;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& + .nav-item {\n\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\tmargin-right: $spacer * 1.5;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-left: $spacer * 1.5;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .profile-container {\n\t\tdisplay: flex;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tdisplay: block;\n\t\t}\n\t\t\n\t\t& .profile-sidebar {\n\t\t\twidth: rem(250px);\n\t\t\tpadding: $spacer * 1.5;\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t} @else {\n\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t& .profile-content {\n\t\t\tflex: 1;\n\t\t\t\n\t\t\t& .profile-content-container {\n\t\t\t\tpadding: $spacer * 1.5;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tpadding: $spacer;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .profile-img-list {\n\t\tlist-style-type: none;\n\t\tmargin: $spacer * -.25;\n\t\tpadding: 0;\n\t\t\n\t\t@include clearfix();\n\t\t\n\t\t& .profile-img-list-item {\n\t\t\twidth: 25%;\n\t\t\tpadding: $spacer * .25;\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tfloat: right;\n\t\t\t} @else {\n\t\t\t\tfloat: left;\n\t\t\t}\n\t\t\t\n\t\t\t&.main {\n\t\t\t\twidth: 50%;\n\t\t\t}\n\t\t\t& .profile-img-list-link {\n\t\t\t\tdisplay: block;\n\t\t\t\tpadding-top: 75%;\n\t\t\t\toverflow: hidden;\n\t\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t\t& img,\n\t\t\t\t& .profile-img-content {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\tbackground-position: center;\n\t\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\t\t\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tborder: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.with-number {\n\t\t\t\t& .profile-img-number {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tfont-size: $font-size-base * 1.75;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tline-height: rem(26px);\n\t\t\t\t\tmargin-top: $font-size-base * -1.75 * .5;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".register {\n\tmin-height: 100vh;\n\tpadding: $spacer * 3 $spacer;\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t@include media-breakpoint-down(md) {\n\t\tpadding: $spacer;\n\t}\n\t\n\t& .register-content {\n\t\tflex: 1;\n\t\tmax-width: rem(360px);\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t}\n}",".search-result {\n\t& .search-input {\n\t\tposition: relative;\n\t\tmax-width: rem(720px);\n\t\tmargin-bottom: rem(15px);\n\t}\n\t& .search-close {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tmargin-top: rem(-12px);\n\t\twidth: rem(26px);\n\t\theight: rem(26px);\n\t\ttext-align: center;\n\t\tfont-size: rem(20px);\n\t\tpadding: 0 0 rem(2px);\n\t\tcolor: var(--#{$prefix}inverse);\n\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\ttext-decoration: none;\n\t\tborder-radius: 30px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tleft: rem(12px);\n\t\t} @else {\n\t\t\tright: rem(12px);\n\t\t}\n\t\t\n\t\t&:hover,\n\t\t&:focus{ \n\t\t\ttext-decoration: none;\n\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t}\t\n\t}\n\t& .search-tab {\n\t\tlist-style-type: none;\n\t\tmargin: 0 ($app-content-padding-x * -1);\n\t\tpadding: 0 $app-content-padding-x;\n\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\twhite-space: nowrap;\n\t\tdisplay: flex;\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tmargin: 0 rem(-15px);\n\t\t\tpadding: 0 rem(15px);\n\t\t\toverflow: scroll;\n\t\t}\n\t\t\n\t\t& .search-tab-item {\n\t\t\t& .search-tab-link {\n\t\t\t\tdisplay: block;\n\t\t\t\tpadding: rem(10px);\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\ttext-decoration: none;\n\t\t\t\tborder-bottom: 3px solid transparent;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tmargin-bottom: -1px;\n\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tborder-bottom-color: $gray-300;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\tborder-bottom-color: var(--#{$prefix}theme);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& + .search-tab-item {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .search-result-list {\n\t\tlist-style-type: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\t\n\t\t& .search-result-item {\n\t\t\tpadding: $spacer * 2 0;\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t@include clearfix();\n\t\t\t\n\t\t\t&:last-child {\n\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t& + .search-result-item {\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t& .search-result-media {\n\t\t\t\twidth: rem(160px);\n\t\t\t\theight: rem(160px);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\twidth: rem(80px);\n\t\t\t\t\theight: rem(60px);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& img {\n\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\tmax-height: 100%;\n\t\t\t\t}\n\t\t\t\t& + .search-result-content {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tpadding-right: rem(30px);\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tpadding-left: rem(30px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .search-result-content {\n\t\t\t\tflex: 1;\n\t\t\t\t\n\t\t\t\t& h3 {\n\t\t\t\t\tmargin: 0 0 rem(5px);\n\t\t\t\t\tfont-size: rem(20px);\n\t\t\t\t\t\n\t\t\t\t\t& a {\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".widget-chat {\n\tmargin: 0;\n\tpadding: 0;\n\t\n\t& .widget-chat-item {\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\t\n\t\t& + .widget-chat-item {\n\t\t\tmargin-top: $spacer;\n\t\t}\n\t\t& > div + div {\n\t\t\tpadding-left: $spacer * .75;\n\t\t}\n\t}\n\t& .widget-chat-date {\n\t\tfont-size: $font-size-base - rem(2px);\n\t\tfont-weight: $font-weight-bold;\n\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\tpadding: $spacer * .75;\n\t\ttext-align: center;\n\t}\n\t& .widget-chat-content {\n\t\tflex: 1;\n\t}\n\t& .widget-chat-name,\n\t& .widget-chat-status {\n\t\tfont-size: $font-size-base - rem(3px);\n\t\tfont-weight: $font-weight-bold;\n\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\tmargin: $spacer * .25 0;\n\t\tline-height: 1.5;\n\t}\n\t& .widget-chat-media {\n\t\twidth: rem(28px);\n\t\t\n\t\t& img {\n\t\t\tmax-width: 100%;\n\t\t\tdisplay: block;\n\t\t\t@include border-radius(28px);\n\t\t}\n\t}\n\t& .widget-chat-message {\n\t\tbackground: $white;\n\t\tcolor: $black;\n\t\tpadding: $spacer * .5 $spacer;\n\t\tdisplay: inline-block;\n\t\tposition: relative;\n\t\tborder-radius: $border-radius-lg;\n\t\t\n\t\t& + .widget-chat-message {\n\t\t\tmargin-top: $spacer * .3;\n\t\t}\n\t\t&.last {\n\t\t\t&:before {\n\t\t\t\tcontent: '';\n\t\t\t\tborder: rem(5px) solid transparent;\n\t\t\t\tborder-bottom-color: $white;\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: rem(6px);\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tright: rem(-4px);\n\t\t\t\t\tborder-left-color: $white;\n\t\t\t\t} @else {\n\t\t\t\t\tleft: rem(-4px);\n\t\t\t\t\tborder-right-color: $white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .reply {\n\t\t& .widget-chat-content {\n\t\t\ttext-align: right;\n\t\t}\n\t\t& .widget-chat-message {\n\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\n\t\t\t&.last:before {\n\t\t\t\tborder-color: transparent;\n\t\t\t\tborder-bottom-color: var(--#{$prefix}theme);\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tborder-right-color: var(--#{$prefix}theme);\n\t\t\t\t\tright: auto;\n\t\t\t\t\tleft: rem(-4px);\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left-color: var(--#{$prefix}theme);\n\t\t\t\t\tleft: auto;\n\t\t\t\t\tright: rem(-4px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".widget-img-list {\n\tmargin: rem(-1px);\n\tpadding: 0;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\t\n\t& .widget-img-list-item {\n\t\tpadding: rem(1px);\n\t\twidth: 20%;\n\t\t\n\t\t& a {\n\t\t\tdisplay: block;\n\t\t\ttext-decoration: none;\n\t\t\tpadding-top: 100%;\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\t\t\t\n\t\t\t& img,\n\t\t\t& .img {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t\t& .img {\n\t\t\t\tbackground-size: cover;\n\t\t\t\tbackground-position: center;\n\t\t\t\tbackground-repeat: no-repeat;\t\n\t\t\t}\n\t\t}\n\t}\n}",".widget-reminder {\n\t& .widget-reminder-item {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t}\n\t& .widget-reminder-header + .widget-reminder-item,\n\t& .widget-reminder-item + .widget-reminder-header,\n\t& .widget-reminder-item + .widget-reminder-item {\n\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t}\n\t& .widget-reminder-time,\n\t& .widget-reminder-content {\n\t\tpadding: $spacer;\n\t}\n\t& .widget-reminder-content {\n\t\tflex: 1;\n\t}\n\t& .widget-reminder-time {\n\t\twidth: rem(80px);\n\t\tfont-size: $font-size-base - rem(1px);\n\t\t\n\t\t@if $enable-rtl {\n\t\t\ttext-align: left;\n\t\t} @else {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\t& .widget-reminder-divider {\n\t\twidth: rem(3px);\n\t\tbackground: var(--#{$prefix}border-color);\n\t}\n\t& + .card-header,\n\t& + .card-footer,\n\t& + .card-body {\n\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t}\n}",".widget-user-list {\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t& .widget-user-list-item {\n\t\t& .widget-user-list-link {\n\t\t\tborder: 2px solid var(--#{$prefix}body-bg);\n\t\t\toverflow: hidden;\n\t\t\twidth: rem(40px);\n\t\t\theight: rem(40px);\n\t\t\ttext-align: center;\n\t\t\ttext-decoration: none;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tborder-radius: 40px;\n\t\t\t\n\t\t\t& img {\n\t\t\t\tdisplay: block;\n\t\t\t\tmax-width: 100%;\n\t\t\t\tmax-height: 100%;\n\t\t\t}\n\t\t}\n\t\t\n\t\t& + .widget-user-list-item {\n\t\t\t@if $enable-rtl {\n\t\t\t\tmargin-right: rem(-20px);\n\t\t\t} @else {\n\t\t\t\tmargin-left: rem(-20px);\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
